export default {
  "123": "ARM 调试信息 3",
  "632": "这是另外一个标签",
  "666": "666",
  "678": "ARM 调试信息 3",
  "12313": "3333",
  "123123": "备电模式下的电池最低 SOC",
  "77777777": "77777777777777777",
  "language.name": "中文",
  "system.dataScreen": "数据大屏",
  "product.PleaseEnter": "请输入产品名称",
  "product.PleaseEnterTheProductSerialNumber": "请输入产品序列号",
  "product.PleaseEnterSubmodelNumber": "请输入子型号",
  "product.PleaseenterTheSubmodelSerialNumber": "请输入子型号序列号",
  "product.PleaseSelectTheDeviceType": "请选择设备类型",
  "product.PleaseSelectDevelopmentType": "请选择研发类型",
  "product.management": "产品管理",
  "product.name": "产品系列",
  "product.reset": "重置",
  "product.search": "搜索",
  "product.ApplicationList": "产品列表",
  "product.newProduct": "新建产品",
  "product.editName": "编辑产品",
  "product.DetailSetting": "详情设置",
  "product.delete": "删除",
  "product.deleteConfirm": "确定删除产品 {productName} 吗？",
  "product.serialNumber": "产品序列号",
  "product.deviceType": "设备类型",
  "product.RandDtype": "研发类型",
  "product.subType": "子型号",
  "product.subTypeNumber": "子序列号",
  "product.updateTime": "更新时间",
  "product.operation": "操作",
  "product.shippingMarket": "出货市场",
  "product.deviceList": "设备清单(出货日志)",
  "product.parameterManagement": "参数管理",
  "product.updataManagement": "升级管理",
  "product.ParentDevice": "父设备",
  "product.AssociatedPowerStationState": "关联电站状态",
  "product.ImportDeviceList": "导入设备清单",
  "product.PlantDetails": "电站详情",
  "product.OwningPowerStation": "所属电站",
  "product.parameterName": "参数名称",
  "product.ParameterClass": "参数类别",
  "product.ParameterSettingType": "参数设置类型",
  "product.ParameterOperationType": "参数操作类型",
  "product.ImportParameter": "导入参数",
  "product.OwningUpperLevelParameterCategory": "所属上级参数分类",
  "product.WhetherYoSupportBatchRead": "是否支持批量读",
  "product.value": "值",
  "product.scope": "范围",
  "product.unit": "单位",
  "product.explain": "说明",
  "product.remark": "备注",
  "product.fileName": "填写名字",
  "product.fileAddress": "文件地址",
  "product.versionNumber": "版本号",
  "product.ProductOfOwnership": "所属产品",
  "product.ProductDetailsSettings": "阳台1.0 - 产品详情设置",
  "product.QueryResultList": "查询结果列表",
  "product.AddFirmware": "添加固件",
  "product.NewParameter": "新增参数",
  "product.datalog": "采集器",
  "product.Inverter": "逆变器",
  "product.storage": "储能",
  "product.battery": "电池",
  "product.socket": "插座",
  "product.DownloadTemplate": "下载模板",
  "product.nation": "国家",
  "product.agent": "代理商",
  "product.expirationDate": "保质期",
  "product.UpdateTime": "更新时间",
  "product.LastWeek": "最近一周",
  "product.LastMonth": "最近一个月",
  "product.LastThreeMonths": "最近三个月",
  "product.parameterType": "参数类型",
  "product.ProtocolAddress": "参数协议中的地址",
  "product.stepSize": "步长",
  "product.PleaseEnterAParameterName": "请输入参数名称",
  "product.parameterCoding": "参数编码",
  "product.PleaseEnterTheParameterCode": "请输入参数编码",
  "product.ParameterDataType": "参数数据类型",
  "product.PleaseEnterTheAddressInTheParameterProtocol": "请输入参数协议中的地址",
  "product.blockEncoding": "分组编码",
  "product.PleaseEnterABlockCode": "请输入分组编码",
  "product.GroupName": "分组名称",
  "product.PleaseEnterAGroupName": "请输入分组名称",
  "product.PleaseEnterTheUnit": "请输入最小值",
  "product.decimalPoint": "小数点",
  "product.PleaseEnterTheDecimalPoint": "请输入小数点",
  "product.leastValue": "最小值",
  "product.maximumValue": "最大值",
  "product.PleaseEnterTheMaximumValue": "请输入最大值",
  "product.PleaseEnterTheStepSize": "请输入步长",
  "product.addEquipment": "新增设备",
  "product.equipment": "设备",
  "product.remove": "移除",
  "product.sort": "排序",
  "product.PleaseEnterTheOrder": "请输入排序",
  "product.PleaseEnterTheParameterSettingType": "请输入参数设置类型",
  "product.PleaseSelectAFolderPath": "请选择文件夹路径",
  "product.ReturnToSuperior": "返回上级",
  "product.PleaseEnterTheVersionNumber": "请输入版本号",
  "product.firmwareSpecification": "固件说明",
  "product.PleaseEnterFirmwareDescription": "请输入固件说明",
  "product.FileName": "文件名",
  "product.DeviceType": "设备类型",
  "product.FileAddress": "文件地址",
  "product.time": "服务时间",
  "sidebar.default": "导航页",
  "sidebar.home": "数据概览",
  "sidebar.endbenutzer": "用户管理",
  "sidebar.plant": "场景管理",
  "sidebar.plant_plant": "电站管理",
  "sidebar.device": "设备管理",
  "sidebar.datalog": "采集器列表",
  "sidebar.inverter": "逆变器列表",
  "sidebar.sotrage": "储能列表",
  "sidebar.socket": "插座列表",
  "sidebar.battery": "电池列表",
  "sidebar.agent": "代理商管理",
  "sidebar.systematicSupply": "出货日志",
  "sidebar.firmware": "远程升级",
  "sidebar.firmware_up": "固件上传",
  "sidebar.firmware_log": "升级记录",
  "sidebar.system": "系统管理",
  "sidebar.system_datalog_log": "采集器日志",
  "sidebar.system_log": "操作日志",
  "sidebar.system_tongxun": "通讯日志",
  "sidebar.system_app": "App 版本",
  "sidebar.personal": "用户信息",
  "sidebar.logout": "退出账户",
  "sidebar.organizationalManagement": "组织管理",
  "sidebar.auth_manage": "权限管理",
  "sidebar.workorder": "工单管理",
  "login.email": "邮箱",
  "login.password": "密码",
  "login.remember": "记住邮箱和密码",
  "login.rememberAccount": "记住账号和密码",
  "login.enteremail": "请输入邮箱",
  "login.enterpassword": "请输入密码",
  "login.enterAccount": "请输入邮箱或手机号",
  "login.correctAccount": "请输入正确的邮箱或手机号",
  "login.accountPlaceholder": "请输入邮箱或手机号",
  "login.accountNumber": "账号",
  "login.system": "Haier Energy Cloud",
  "login.read": "阅读并同意",
  "login.userAgreement": "《用户协议》",
  "login.privacyPolicy": "《隐私政策》",
  "login.temporarilyDisagree": "暂不同意",
  "login.agreeAndAccept": "同意并接受",
  "login.retrievePassword": "找回密码",
  "login.verCode": "验证码",
  "login.newPassword": "新密码",
  "login.sendverCode": "发送验证码",
  "login.greenLife": "创新清洁能源 共建绿色生活",
  "login.welcome": "欢迎来到Haier Energy Cloud",
  "login.downloadApp": "下载APP",
  "login.sure": "确定",
  "home.echarts1.title": "注册用户",
  "home.echarts1.subhead": "今日新增/用户总数",
  "home.echarts2.title": "登录用户",
  "home.echarts2.subhead": "今日登录/用户总数",
  "home.echarts3.title": "添加代理商",
  "home.echarts3.subhead": "今日登录/代理商总数",
  "home.echarts4.title": "添加场景",
  "home.echarts4.subhead": "新增场景/场景总数",
  "home.echarts4.title_plant": "添加电站",
  "home.echarts4.subhead_plant": "新增电站/电站总数",
  "home.echarts5.title": "添加采集器",
  "home.echarts5.subhead": "新增采集器/采集器总数",
  "home.echarts6.title": "添加设备",
  "home.echarts6.subhead": "新增设备/设备总数",
  "End_user.input_email": "请输入用户邮箱",
  "End_user.btn_search": "搜索",
  "End_user.btn_add": "添加",
  "End_user.btn_delete": "删除",
  "End_user.btn_binding": "绑定",
  "End_user.add_station": "添加场景",
  "End_user.lable_StationName": "场景名字",
  "End_user.lable_StationType": "场景类型",
  "End_user.lable_PVCapacity": "太阳电池容量",
  "End_user.lable_InstalltionDate": "安装日期",
  "End_user.lable_Country": "国家",
  "End_user.lable_City": "城市",
  "End_user.lable_Address": "地址",
  "End_user.lable_TimeZone": "时区",
  "End_user.lable_Energyprice": "能源单价",
  "End_user.lable_IncomeUnit": "收入单位",
  "End_user.input_StationName": "请输入场景名字",
  "End_user.input_StationType": "请选择类型",
  "End_user.input_PVCapacity": "请输入电池容量",
  "End_user.input_InstalltionDate": "请选择安装日期",
  "End_user.input_Country": "请选择国家",
  "End_user.input_City": "请选择城市",
  "End_user.input_Address": "请输入地址",
  "End_user.input_TimeZone": "请选择时区",
  "End_user.input_Energyprice": "请输入单价",
  "End_user.input_IncomeUnit": "选择收入单位",
  "End_user.max_20": "字符最大不能超过20个",
  "End_user.max_5": "字符最大不能超过5个",
  "End_user.max_8": "字符最大不能超过8个",
  "End_user.format": "请输入正确的格式",
  "End_user.close": "关闭",
  "End_user.submit": "提交",
  "End_user.title_delete": "删除？",
  "End_user.no": "否",
  "End_user.yes": "是",
  "End_user.Bingding_Agent": "绑定代理商",
  "End_user.Agent_Code": "代理商:",
  "End_user.please_select": "请选择",
  "plant.input_email": "请输入用户邮箱",
  "plant.search": "搜索",
  "plant.edit": "编辑",
  "plant.delete": "删除",
  "plant.edit_plant": "编辑场景",
  "plant.input_station": "请输入场景名字",
  "plant.lable_StationName": "场景名字",
  "plant.lable_StationType": "场景类型",
  "plant.lable_PVCapacity": "光伏装机量",
  "plant.lable_InstalltionDate": "安装日期",
  "plant.lable_Country": "国家",
  "plant.lable_City": "城市",
  "plant.lable_Address": "地址",
  "plant.lable_TimeZone": "时区",
  "plant.lable_Energyprice": "能源单价",
  "plant.lable_IncomeUnit": "收入单位",
  "plant.input_StationName": "请输入场景名字",
  "plant.input_StationType": "请选择类型",
  "plant.input_PVCapacity": "请输入电池容量",
  "plant.input_InstalltionDate": "请选择安装日期",
  "plant.input_Country": "请选择国家",
  "plant.input_City": "请选择城市",
  "plant.input_Address": "请输入地址",
  "plant.input_TimeZone": "请选择时区",
  "plant.input_Energyprice": "请输入单价",
  "plant.input_IncomeUnit": "选择收入单位",
  "plant.max_20": "字符最大不能超过20个",
  "plant.max_5": "字符最大不能超过5个",
  "plant.max_8": "字符最大不能超过8个",
  "plant.format": "请输入正确的格式",
  "plant.close": "关闭",
  "plant.submit": "提交",
  "plant.title_delete": "删除？",
  "plant.no": "否",
  "plant.yes": "是",
  "plant.plantName": "电站名称",
  "plant.country": "国家/地区",
  "plant.installer": "安装商",
  "plant.installPerson": "安装工",
  "plant.InstallationPlan": "安装方案",
  "plant.owner": "业主",
  "plant.photovoltaicCapacity": "光伏容量(kWh)",
  "plant.batteryCapacity": "电池容量(kWh)",
  "plant.electricityConsumptionToday": "今日电量",
  "plant.electricityConsumptionMonth": "当月电量",
  "plant.electricityConsumptionTotal": "累计用电量",
  "plant.runningState": "运行状态",
  "plant.buildState": "建设状态",
  "plant.plantNum": "电站数",
  "plant.totalPlantNum": "总数",
  "plant.building": "建设中",
  "plant.delivered": "已交付",
  "plant.electricEnergy": "发电量",
  "plant.today": "今日",
  "plant.month": "当月",
  "plant.year": "当年",
  "plant.total": "累计",
  "plant.deleteSuccess": "电站删除成功",
  "plant.powerGeneration": "发电量",
  "plant.powerConsumption": "用电量",
  "plant.spontaneousSelfUse": "自发自用",
  "plant.selfSufficient": "自给自足",
  "plant.photovoltaicPowerGeneration": "光伏发电功率",
  "plant.electricPowerConsumption": "用电功率",
  "plant.spontaneousSelfUsePower": "自发自用功率",
  "plant.buyPowers": "买电功率",
  "plant.sellPowers": "卖电功率",
  "plant.selfSufficientPower": "自给自足功率",
  "plant.batterySOC": "储能电池SOC",
  "plant.storageChargingPower": "储能充电功率",
  "plant.storageDischargePower": "储能放电功率",
  "plant.life": "生命期",
  "plant.operatingData": "运行数据",
  "plant.dataReportingTime": "数据上报时间",
  "plant.plantOverview": "电站概览",
  "plant.deviceList": "设备列表",
  "plant.energyBalance": "能源平衡(kWh)",
  "plant.onGridEnergy": "上网电量",
  "plant.purchaseElectricity": "买电量",
  "plant.statisticalAnalysis": "统计分析",
  "plant.energyAnalysis": "能量分析",
  "plant.powerAnalysis": "功率分析",
  "plant.updateTime": "气象数据更新时间",
  "plant.stationInfo": "电站信息",
  "plant.userInfo": "用户信息",
  "plant.socialContribution": "社会贡献",
  "plant.equivalentIncome": "等效收益",
  "plant.priceSet": "电价设置",
  "plant.co2emissionReduction": "CO2减排量",
  "plant.plantPowerGeneration": "电站累计发电量",
  "plant.equivalentTreePlanting": "等效植树量",
  "plant.saveStandardCoal": "节约标准煤",
  "plant.photovoltaicPowerGenerations": "光伏发电量",
  "plant.weather": "天气",
  "plant.sunriseSunset": "日出日落",
  "plant.temperature": "温度(℃)",
  "plant.humidity": "湿度",
  "plant.windSpeed": "风速",
  "plant.windDirection": "风向",
  "plant.primaryUser": "主用户",
  "plant.receiveMode": "接收方式",
  "plant.dateOfReceipt": "接收日期",
  "plant.familyName": "家庭名称",
  "plant.familyMembers": "家庭成员数",
  "plant.currency": "币种",
  "plant.purchasePrice": "买电价格",
  "plant.sellingPrice": "卖电电价",
  "plant.noUserInfo": "尚未交付用户",
  "plant.noIncomeTip": "为了更好的计算您的等效收益，请输入买电与卖电单价",
  "plant.pleaseSelectDate": "请选择日期",
  "plant.saveTimezoneTip": "修改时区会导致：\n设备数据图表出现断层或重叠（持续数小时）\n设备本地任务错乱，可能短暂离线",
  "plant.createType": "创建方",
  "datalog.email": "请输入邮箱",
  "datalog.datalogSn": "请输入采集器序列号",
  "datalog.search": "搜索",
  "datalog.Version": "版本号",
  "datalog.setting": "设置",
  "datalog.upgrade": "升级",
  "datalog.delete": "删除",
  "datalog.title_datalog": "采集器设置",
  "datalog.span_info": "信息",
  "datalog.span_datalog": "采集器序列号:",
  "datalog.span_name": "别名:",
  "datalog.span_time": "更新时间:",
  "datalog.span_firmware": "信号/固件版本:",
  "datalog.span_order": "命令",
  "datalog.span_settingdns": "设置域名",
  "datalog.span_inputsetting": "请输入域名",
  "datalog.span_upgrade": "升级采集器",
  "datalog.span_reset": "重启采集器",
  "datalog.span_setup": "高级设置",
  "datalog.span_param": "参数",
  "datalog.span_value": "值",
  "datalog.btn_setup": "高级设置",
  "datalog.btn_setting": "设置",
  "datalog.btn_settingdns": "设置域名",
  "datalog.btn_upgrade": "升级",
  "datalog.btn_reset": "重启",
  "datalog.btn_read": "读取",
  "datalog.btn_close": "取消",
  "datalog.methods_version": "检测版本更新?",
  "datalog.no": "否",
  "datalog.yes": "是",
  "datalog.methods_delete": "删除?",
  "datalog.methods_rereset": "重启?",
  "datalog.methodes_inputDns": "请输入域名",
  "datalog.methodes_DNS": "是否设置此域名",
  "sotrage.select": "请选择",
  "sotrage.email": "请输入邮箱",
  "sotrage.datalogSn": "请输入采集器序列号",
  "sotrage.deviceSn": "请输入设备序列号",
  "sotrage.search": "搜索",
  "sotrage.sotrage": "储能设置",
  "device.select": "请选择",
  "device.email": "请输入邮箱",
  "device.datalogSn": "请输入采集器序列号",
  "device.deviceSn": "请输入设备序列号",
  "device.search": "搜索",
  "device.title": "逆变器设置",
  "device.setting": "设置",
  "device.setting_inverte": "设置逆变器参数",
  "device.input_start_address": "起始寄存器地址",
  "device.input_ent_address": "终止寄存器地址",
  "device.input_setting_value": "请输入设置值",
  "device.read_data": "读取寄存器数据:",
  "device.input_start_read": "起始寄存器地址",
  "device.input_end_read": "终止寄存器地址",
  "device.btn_address": "设置地址",
  "device.btn_value": "设置参数",
  "device.btn_read": "读取",
  "device.btn_close": "返回",
  "device.selet_data": "选择日期",
  "device.workMode": "工作模式",
  "device.alarmInfo": "报警数量",
  "device.countryStandard": "国家标准",
  "device.runningStatus": "运行状态",
  "device.inverterTemp": "逆变器温度(℃)",
  "device.dcdcTemp": "电池温度(℃)",
  "device.mpptTemp": "MPPT温度(℃)",
  "device.drmStatus": "DRM状态",
  "device.version": "版本",
  "device.communicationEquipment": "通讯设备",
  "device.basicInfo": "基本信息",
  "device.productName": "产品名称",
  "device.productType": "产品类型",
  "device.productModel": "产品型号",
  "device.softVersion": "软件版本",
  "device.softUpdateTime": "软件更新时间",
  "device.plant": "电站",
  "device.installer": "安装商",
  "device.installPerson": "安装工",
  "device.deviceRegisterDate": "设备注册日期",
  "device.ownerEmail": "业主邮箱",
  "device.ownerReceiveTime": "业主接收时间",
  "device.ownerFamily": "业主家庭",
  "device.versionInfo": "版本信息",
  "device.searchSn": "请输入SN搜索",
  "device.user": "用户",
  "device.userReceiveDate": "用户接收日期",
  "device.yuan": "源：光伏",
  "device.totalPower": "总功率",
  "device.todayPowerGeneration": "今日发电量",
  "device.dataGateway": "数据网关",
  "device.optimizer": "优化器",
  "device.chu": "储：储能电池",
  "device.power": "功率",
  "device.todayChargingCapacity": "今日充电量",
  "device.todayDischargingCapacity": "电池今日放电量",
  "device.he": "荷：用电负荷",
  "device.todayElectricityConsumption": "当日用电量",
  "device.totalElectricityConsumption": "累计用电量",
  "device.wang": "网：电网侧",
  "device.totalFrequency": "总频率",
  "device.buyPowers": "买电",
  "device.sellPowers": "卖电",
  "device.more": "更多",
  "device.readWrite": "直接读写工具",
  "device.chargeAndDisChargeSetting": "充放电设置",
  "device.mutipleSave": "批量下发",
  "device.mutipleRead": "批量读取",
  "device.deviceSnisExist": "请确认设备sn是否存在",
  "device.saveSuccess": "参数指令已下发，请刷新页面或点击【读取】按钮确认参数是否生效",
  "device.saveFail": "参数下发失败",
  "device.getParamsSuccess": "获取参数成功",
  "device.getParamsFail": "获取参数失败",
  "device.operationalDataAnalysis": "运行数据分析",
  "device.pleaseSelect": "请选择左侧数据项",
  "device.maxFour": "单位不能超过4种",
  "device.maxFourOrTwenty": "最多只能有4种单位或20种选项",
  "device.protocolDirectives": "协议指令",
  "device.dateRangeError": "日期范围应在3天内",
  "device.noDeviceDetail": "暂无设备详情",
  "device.address": "寄存器地址",
  "device.faultClearing": "故障清除",
  "device.operationMonitoring": "运行监控",
  "device.parameterControl": "参数控制",
  "device.Fault&Alarm": "故障&告警",
  "device.dynamicPriceTip": "家庭业主已开启AI模式，该参数不支持手动修改。",
  "device.importTemplateDownload": "导入模版下载",
  "device.snNumber": "SN号",
  "device.enterSnCode": "请输入SN码",
  "device.enterSupplierSN": "请输入供应商SN",
  "device.deviceModelLabel": "设备型号",
  "device.importTip": "请导入相应的电站编码、设备名称、sn号、MDM编码",
  "device.importTip2": "请导入相应的设备名称、sn号、MDM编码",
  "device.keepAtLeastOneRow": "至少保留一行",
  "device.importSuccessWithCount": "成功导入 {count} 条设备数据",
  "device.importTemplateEmpty": "导入模板为空",
  "device.fillAllRequiredFields": "请填写完整的必填项",
  "device.enterPlantCode": "请输入电站编码",
  "device.plantCodeLabel": "电站编码",
  "device.supplierSNLabel": "供应商SN",
  "device.chargeSetting": "充电设置",
  "device.dischargeSetting": "放电设置",
  "battery.select": "请选择",
  "battery.email": "请输入邮箱",
  "battery.datalogSn": "请输入采集器序列号",
  "battery.deviceSn": "请输入设备序列号",
  "battery.search": "搜索",
  "socket.title": "插座设置",
  "socket.setting": "设置",
  "socket.span": "设置了多个寄存器地址，值也要设置多个。 设置值中间要用 , 隔开，示例（1，2，3）",
  "socket.setting_device": "设置逆变器参数：",
  "socket.startaddress": "起始寄存器地址",
  "socket.stopaddress": "终止寄存器地址",
  "socket.value": "请输入设置值",
  "socket.readdata": "读取寄存器数据：",
  "socket.setting_address": "设置地址",
  "socket.setting_value": "设置参数",
  "socket.read": "读取",
  "socket.return": "返回",
  "agent.close": "取消",
  "agent.submit": "提交",
  "agent.input_email": "请输入邮箱",
  "agent.search": "搜索",
  "agent.add_agent": "添加代理商",
  "agent.import_device": "导入设备",
  "agent.edit": "编辑",
  "agent.title": "添加代理商",
  "agent.email": "邮箱",
  "agent.password": "密码",
  "agent.phone": "手机号码",
  "agent.company": "公司",
  "agent.language": "语言",
  "agent.address": "地址",
  "agent.input_password": "请输入密码",
  "agent.input_phone": "请输入手机号",
  "agent.input_company": "请选择公司",
  "agent.input_language": "请输入语言",
  "agent.input_address": "请输入地址",
  "agent.relus_email": "请输入有效的电子邮件地址",
  "agent.title_edit": "编辑代理商",
  "agent.title_device": "上传",
  "agent.span": "示例: Excle 表格",
  "agent.btn_upload": "上传",
  "agent.delete": "删除",
  "agent.agent_delete": "删除代理商?",
  "ship.starttime": "开始时间",
  "ship.endtime": "结束时间",
  "ship.deviceSn": "请输入设备序列号",
  "ship.select": "请选择公司",
  "ship.search": "搜索",
  "Firmware.file_name": "请输入文件名字",
  "Firmware.search": "搜索",
  "Firmware.add": "添加",
  "Firmware.delete": "删除",
  "Firmware.title": "固件上传",
  "Firmware.select_folder": "选择文件夹:",
  "Firmware.select_folder_type": "请选择文件夹类型",
  "Firmware.craete_folder": "创建一个新的文件夹",
  "Firmware.folder_path": "文件夹路径：",
  "Firmware.folder_name": "文件名:",
  "Firmware.input_folder_name": "输入文件名称",
  "Firmware.create": "创建文件夹",
  "Firmware.listed_files": "文件列表：",
  "Firmware.import_folder": "导入文件",
  "Firmware.uplad_folder": "上传文件",
  "Firmware.close": "返回",
  "Upgrade.starttime": "开始时间",
  "Upgrade.endtime": "结束时间",
  "Upgrade.deviceSn": "请输入设备序列号",
  "Upgrade.type": "请选择类型",
  "Upgrade.search": "搜索",
  "Upgrade.datalog": "采集器",
  "Upgrade.Inverter": "逆变器",
  "Upgrade.Control": "控制器",
  "datalogs_logs.starttime": "开始时间",
  "datalogs_logs.endtime": "结束时间",
  "datalogs_logs.deviceSn": "请输入设备序列号",
  "datalogs_logs.Version": "请输入版本",
  "datalogs_logs.search": "搜索",
  "Logs.starttime": "开始时间",
  "Logs.endtime": "结束时间",
  "Logs.deviceSn": "请输入设备序列号",
  "Logs.type": "请选择类型",
  "Logs.search": "搜索",
  "Special.starttime": "开始时间",
  "Special.endtime": "结束时间",
  "Special.deviceSn": "请输入设备序列号",
  "Special.datalogSn": "请输入采集器序列号",
  "Special.type": "请选择类型",
  "Special.search": "搜索",
  "Special.save": "保存",
  "Special.Examples": "示例：(2305210230,2305210139)",
  "App.System_Config": "系统配置",
  "App.APP_Version": "App版本发布",
  "App.Android_Version": "安卓版本:",
  "App.IOS_Version": "IOS版本:",
  "App.APP_Type": "App类型:",
  "App.New_Version": "新版本",
  "App.update_content": "更新内容描述:(用“/n”来划分)",
  "App.Whether_update": "是否强制更新：",
  "App.no": "否",
  "App.yes": "是",
  "App.submit": "提交",
  "Tips.app_submit": "确定修改信息?",
  "Tips.firmware_delete": "确认删除?",
  "Tips.firmware_deleteCDN": "删除CDN中的文件?",
  "Tips.yes": "是",
  "Tips.no": "否",
  "global.DataDetails": "数据详情",
  "global.device": "逆变器设置",
  "global.device_data": "设置逆变器参数:",
  "global.storage": "储能设置",
  "global.storage_data": "设置储能参数",
  "global.battery": "电池设置",
  "global.battery_data": "设置电池参数",
  "global.socket": "插座设置",
  "global.socket_data": "设置插座参数",
  "btn.setting_address": "设置地址",
  "btn.close": "返回",
  "btn.submit": "提交",
  "btn.Setting_parameters": "设置参数",
  "btn.Reading": "读取",
  "btn.search": "搜索",
  "btn.add": "添加",
  "btn.import": "导入",
  "btn.download": "下载示例",
  "btn.edit": "编辑",
  "btn.login": "登录",
  "btn.export": "导出",
  "form.addShip": "添加出货设备",
  "form.editShip": "编辑出货设备",
  "form.import": "导入设备信息",
  "form.shipSN": "出货序列号",
  "form.agent": "代理商",
  "form.networkCall": "是否执行配网回调",
  "form.warrantyPeriod": "质保时间",
  "form.shiptime": "出货时间",
  "form.shiptype": "出货类型",
  "form.classify": "分类",
  "form.file": "将文件拖到此处或者点击上传",
  "form.edit_plant": "编辑场景",
  "form.input_station": "请输入场景名字",
  "form.lable_StationName": "场景名字",
  "form.lable_StationType": "场景类型",
  "form.input_StationName": "请输入场景名字",
  "form.edit_plant_plant": "编辑电站",
  "form.input_station_plant": "请输入电站名字",
  "form.lable_StationName_plant": "电站名字",
  "form.lable_StationType_plant": "电站类型",
  "form.input_StationName_plant": "请输入电站名字",
  "placeholder.select": "请选择",
  "placeholder.choiceCountry": "请选择国家",
  "placeholder.choiceTimezone": "请选择时区",
  "placeholder.enterEmail": "请输入邮箱",
  "placeholder.enterPhone": "请输入手机号",
  "placeholder.verificationCode": "请输入验证码",
  "placeholder.enterPassword": "请输入6-20位密码",
  "placeholder.confirmPassword": "请确认密码",
  "placeholder.readAndAgree": "我已经阅读并同意",
  "placeholder.search": "搜索",
  "placeholder.searchPlantName": "搜索电站名字",
  "placeholder.searchDeviceName": "搜索设备名字",
  "placeholder.searchDataloggerName": "搜索采集器名字",
  "placeholder.enterPlantName": "请输入电站名字",
  "placeholder.enterPlantType": "请输入电站类型",
  "placeholder.enterPVCapacity": "请输入PV容量",
  "placeholder.choiceInstallationDate": "请选择安装日期",
  "placeholder.enterPlantAddress": "请输入电站地址",
  "placeholder.enterOldPassword": "请输入旧密码",
  "placeholder.enterNewPassword": "请输入新密码",
  "placeholder.enterConfirmPassword": "请确认新密码",
  "placeholder.enter": "请输入{scope}",
  "placeholder.input": "请输入",
  "placeholder.country": "国家",
  "placeholder.city": "城市",
  "placeholder.scanCodeAddPlant": "请扫码添加电站!",
  "placeholder.currentNoPlant": "当前没有电站，请点击添加!",
  "placeholder.selectRepeatTime": "请选择重复时间",
  "placeholder.enterDatalogger": "请输入采集器序列号",
  "placeholder.enterDeviceSN": "请输入设备序列号",
  "placeholder.startTime": "开始时间",
  "placeholder.endTime": "结束时间",
  "placeholder.startDate": "开始日期",
  "placeholder.endDate": "结束日期",
  "setting.general.needGreat": "需要大于",
  "setting.general.needSmall": "需要小于",
  "setting.general.gapScope": "输入参数的间隔是",
  "setting.general.valScope": "输入参数的范围是",
  "setting.socket.switchStatus": "插座开关",
  "setting.socket.repetition": "重复时间",
  "setting.socket.enableOrNot": "是否启用",
  "setting.socket.monday": "周一",
  "setting.socket.tuesday": "周二",
  "setting.socket.wednesday": "周三",
  "setting.socket.thursday": "周四",
  "setting.socket.friday": "周五",
  "setting.socket.saturday": "周六",
  "setting.socket.sunday": "周日",
  "setting.type3.dischargeScheduleMode": "定时放电模式",
  "setting.type3.timeDischarge": "定时放电",
  "setting.type3.workingDay": "工作日",
  "setting.type3.weekend": "周末",
  "setting.type3.pureLightControlMode": "纯光控模式",
  "setting.type3.stopDischarge": "SOC低端停止放电设定值",
  "setting.type3.chargeTransferDischarge": "SOC充满转放电设定值",
  "setting.type3.batterySOCSetting": "电池SOC设置",
  "setting.type3.lowBatteryAlam": "电池 SOC 低端告警设定值",
  "setting.type3.lowBatteryShutdown": "电池 SOC 低端停止放电设定值",
  "setting.type3.systemSetting": "系统设置",
  "setting.type3.systemWorkMode": "系统工作模式",
  "setting.type3.restoreFactory": "恢复出厂设置",
  "setting.type3.loadMode": "负载模式",
  "setting.type3.timingDischarge": "定时放电模式",
  "setting.type3.DCOutputNormallyClosed": "直流输出常闭模式",
  "setting.type3.DCOutputNormallyOpen": "直流输出常开模式",
  "setting.type3.ForcedPowerProtection": "强制保电模式",
  "setting.type3.mode": "模式",
  "setting.type3.startTime": "开始时间",
  "setting.type3.stopTime": "结束时间",
  "setting.type3.onlyAddThree": "最多添加21个定时器",
  "setting.type3.startCompareEnd": "定时器的开始时间只能小于结束时间",
  "setting.type3.confirmClose": "你确定要关机吗？",
  "setting.type6.countryCode": "国家编号",
  "setting.type6.poweradjppm": "逆变器功率调节速率",
  "setting.type6.enaINVTR": "远程开关机",
  "setting.type6.enaSysProtIF_selfCheck": "系统保护接口自检",
  "setting.type6.enaRestoretodefault": "恢复默认值",
  "setting.type6.UV_resopnseTime": "{num}级欠压响应时间",
  "setting.type6.UF_resopnseTime": "{num}级欠频响应时间",
  "setting.type6.OV_resopnseTime": "{num}级过压响应时间",
  "setting.type6.OF_resopnseTime": "{num}级过频响应时间",
  "setting.type6.open": "开启",
  "setting.type6.recover": "恢复",
  "setting.type6.noHave": "无",
  "setting.type6.activePowerSwitch": "有功功率开关",
  "setting.type6.activePowerPermillage": "有功功率千分比",
  "setting.type7.paramterSetting": "参数设置",
  "setting.type7.batteryVoltage": "蓄电池电压",
  "setting.type7.batteryCapacity": "蓄电池容量",
  "setting.type7.PVChargingCurrent": "光伏充电电流",
  "setting.type7.overVoltage": "超压电压",
  "setting.type7.chargingLimitVoltage": "充电限制电压",
  "setting.type7.increaseChargeReturnVoltage": "提升充电返回电压",
  "setting.type7.overDischargeVoltage": "过放电压",
  "setting.type7.stopchangeCurrent": "停止充电电流",
  "setting.type7.inverter485Address": "485地址",
  "setting.type7.passwordValue": "用户密码",
  "setting.type7.inputPassword": "密码输入",
  "setting.type7.recordFaultCodes": "记录故障码",
  "setting.type7.isOpen": "开关机控制",
  "setting.type7.equalizingChargeCmd": "立即充电均衡",
  "setting.type7.reset": "复位控制",
  "setting.type7.factory": "恢复出厂设置",
  "setting.type7.clearAlarm": "清除当前告警",
  "setting.type7.clearHistory": "清除历史记录",
  "setting.type7.generatorSwitchCmd": "发电机切换",
  "setting.type7.nowTimeStr": "当前时间",
  "setting.type7.setVal.reset": "复位",
  "setting.type7.setVal.recover": "恢复",
  "setting.type7.setVal.clearAlarm": "清除警告",
  "setting.type7.setVal.clearHistory": "清除历史",
  "setting.type7.setVal.toggle": "切换",
  "setting.type8.systemSwitch": "系统开关",
  "setting.type10.modeSelect": "模式",
  "setting.type10.standbyMode": "备电模式",
  "setting.type10.PureOffGrid": "纯离网启动模式",
  "setting.type10.energyNet": "并网输出设置",
  "setting.type10.inverter0": "逆变补能量到本地负载",
  "setting.type10.inverter1": "逆变给电网发电",
  "setting.type10.inverter2": "逆变给本地负载带CT",
  "setting.type10.inverter3": "逆变给本地负载或者智能插座及智能电表",
  "setting.type10.chargePriority": "充电优先级",
  "setting.type10.PVPriority": "光伏优先",
  "setting.type10.utilityPriority": "市电优先",
  "setting.type10.hybridModel": "混合充",
  "setting.type10.PVOnly": "仅光伏充",
  "setting.type10.batteryLowAlarm": "电池电量低告警点",
  "setting.type10.batteryLowShutdown": "电池电量低关机点",
  "setting.type10.batteryFull": "电池充满关机点",
  "setting.type10.ACCharging": "充电时间",
  "setting.type10.startTime": "起始时间",
  "setting.type10.endTime": "结束时间",
  "setting.type10.forcedDischarge": "放电时间",
  "setting.type10.phaseGridSide": "电网侧",
  "setting.type10.power": "相有功功率",
  "setting.type10.current": "相电流",
  "setting.type10.gridConnectionStandard": "并网标准",
  "setting.type10.baudRate": "485波特率",
  "setting.type10.disable": "不使能",
  "setting.type10.enable": "使能",
  "setting.type10.ApprovalStandards": "认证标准",
  "setting.type10.antiRefluxPower": "防逆流功率",
  "setting.type10.antiRefluxSet": "防逆流使能",
  "setting.type10.batFullSocSet": "电池冲饱和判断值（%）",
  "setting.type10.auxSourceSet": "辅源开关",
  "setting.type10.timeSharingGridConnectedDischarge": "分时并网放电",
  "setting.type10.timeSharingGridConnection": "分时并网设置",
  "setting.type10.outputPower": "输出功率",
  "setting.type10.onlyAddThree": "最多添加{num}个定时器",
  "setting.type10.productModelNumber": "产品型号",
  "setting.type10.PleaseTurnOnThe_PCS_switchFirst": "请先打开开关",
  "setting.type10.ThereIs_a_conflictInTheChargingAndDischargingTime": "充放电时间有冲突",
  "setting.type10.ChargeDischargeTimeSetting": "充电&放电 时间设置",
  "setting.type11.switchPCS": "开关机控制",
  "setting.type11.functionSwitch": "功能开关",
  "setting.type11.maxChargeVol": "最高充电电压（V）",
  "setting.type11.onGridMinDischargeVol": "并网最低放电电压（V）",
  "setting.type11.offGridOutputVol": "离网输出电压（V）",
  "setting.type11.maxChargeCur": "最大充电功率",
  "setting.type11.onGridMaxDischargeCur": "并网最高放电电流(A)",
  "setting.type11.offGridMaxDisChargeCur": "离网最高放电电流(A)",
  "setting.type11.minSocBMS": "BMS最小SOC（%）",
  "setting.type11.minSocDischarge": "智能放电最小SOC（%）",
  "setting.type11.maxSocDischarge": "智能放电最大SOC（%）",
  "setting.type11.timeStr": "设备时间",
  "setting.type11.timerSetting": "定时器设置{num}",
  "setting.type11.chargeStartTime1": "起始充电时间1",
  "setting.type11.chargeLongTime1": "充电时长1",
  "setting.type11.chargeTimeMaxSOC1": "充电时段 1 最大SOC（%）",
  "setting.type11.chargeTimeCurrent1": "充电时段 1 充电电流(A)",
  "setting.type11.dischargeStartTime1": "起始放电时间1",
  "setting.type11.dischargeLongTime1": "放电时长1",
  "setting.type11.dischargeTimeMaxSOC1": "放电时段 1 最小SOC（%）",
  "setting.type11.dischargeTimeCurrent1": "放电时段 1 放电电流(A)",
  "setting.type11.chargeStartTime2": "起始充电时间2",
  "setting.type11.chargeLongTime2": "充电时长2",
  "setting.type11.chargeTimeMaxSOC2": "充电时段 2 最大SOC（%）",
  "setting.type11.chargeTimeCurrent2": "充电时段 2 充电电流(A)",
  "setting.type11.dischargeStartTime2": "起始放电时间2",
  "setting.type11.dischargeLongTime2": "放电时长2",
  "setting.type11.dischargeTimeMaxSOC2": "放电时段 2 最小SOC（%）",
  "setting.type11.dischargeTimeCurrent2": "放电时段 2 放电电流(A)",
  "setting.type11.chargeStartTime3": "起始充电时间3",
  "setting.type11.chargeLongTime3": "充电时长3",
  "setting.type11.chargeTimeMaxSOC3": "充电时段 3 最大SOC（%）",
  "setting.type11.chargeTimeCurrent3": "充电时段 3 充电电流(A)",
  "setting.type11.dischargeStartTime3": "起始放电时间3",
  "setting.type11.dischargeLongTime3": "放电时长3",
  "setting.type11.dischargeTimeMaxSOC3": "放电时段 3 最小SOC（%）",
  "setting.type11.dischargeTimeCurrent3": "放电时段 3 放电电流(A)",
  "setting.type11.chargeStartTime4": "起始充电时间4",
  "setting.type11.chargeLongTime4": "充电时长4",
  "setting.type11.chargeTimeMaxSOC4": "充电时段 4 最大SOC（%）",
  "setting.type11.chargeTimeCurrent4": "充电时段 4 充电电流(A)",
  "setting.type11.dischargeStartTime4": "起始放电时间4",
  "setting.type11.dischargeLongTime4": "放电时长4",
  "setting.type11.dischargeTimeMaxSOC4": "放电时段 4 最小SOC（%）",
  "setting.type11.dischargeTimeCurrent4": "放电时段 4 放电电流(A)",
  "setting.type11.functionSwitchObj.val1": "智能模式",
  "setting.type11.functionSwitchObj.val2": "定时模式",
  "setting.type11.functionSwitchObj.val3": "自发自用模式",
  "setting.type12.LEDSwitch": "LED开关",
  "setting.type12.LEDSpeed": "LED速度",
  "setting.type12.LEDEffect": "LED效果",
  "setting.type12.LEDBrightness": "LED亮度",
  "setting.type12.dataColor": "数据颜色表示",
  "setting.type12.LED1Color": "LED1 颜色",
  "setting.type12.LED2Color": "LED2 颜色",
  "setting.type12.LED3Color": "LED3 颜色",
  "setting.type12.buzzerAlarm": "蜂鸣器告警",
  "setting.type12.overLoadToBypass": "过载转旁路",
  "setting.type12.lcdRestartPage": "LCD无操作恢复主界面",
  "setting.type12.overloadReset": "过载重启",
  "setting.type12.overloadTemperature": "过温重启",
  "setting.type12.backLightOn": "LCD无操作背光",
  "setting.type12.inputSourceChangeAlarm": "输入源变化告警",
  "setting.type12.faultCodeRecord": "通讯软件故障记录",
  "setting.type12.solarFeedToGird": "太阳能空闲并网",
  "setting.type12.switchOptions": "开关选项",
  "setting.type12.batteryParam": "电池参数",
  "setting.type12.outputParam": "输出参数",
  "setting.type12.ratedOutputVol": "额定输出电压",
  "setting.type12.ratedOutputFreq": "额定输出频率",
  "setting.type12.inputVolRange": "输入电压范围",
  "setting.type12.outPutSourcePriority": "输出源优先",
  "setting.type12.batType": "电池类型",
  "setting.type12.batUnderVol": "电池截止电压",
  "setting.type12.batBulkVol": "电池恒充电压",
  "setting.type12.batFloatVol": "电池浮充电压",
  "setting.type12.maxChargingCur": "最大充电电流",
  "setting.type12.maxAcChargingCur": "最大交流充电电流",
  "setting.type12.chargeSourcePriority": "充电器源优先级",
  "setting.type12.batReChargeVol": "恢复充电电压",
  "setting.type12.batFullRestoreDischargeVol": "恢复放电电压",
  "setting.type12.solarSupplyPriority": "太阳能供电优先",
  "setting.type12.resetPvStorage": "重置PV统计数据",
  "setting.type12.countryRegulations": "国家法规",
  "setting.type12.acChargeStartTime": "交流充电器工作启动时间",
  "setting.type12.acChargeEndTime": "交流充电器工作停止时间",
  "setting.type12.acSupplyStartTime": "交流电源的启动时间",
  "setting.type12.acSupplyEndTime": "交流电源的停止时间",
  "setting.type12.restoreFactorySet": "恢复出厂设置",
  "setting.type12.parallelMode": "并机模式",
  "setting.type12.bulkChargeVol": "CV充电电压",
  "setting.type12.batEquSet": "电池均充功能",
  "setting.type12.batEquTime": "电池均充时间（min）",
  "setting.type12.batEquDay": "电池均充间隔天数（d）",
  "setting.type12.batEquChargeVol": "电池均充电压 (V)",
  "setting.type12.batEquTimeout": "电池均充超时时间(min)",
  "setting.type12.equInfoSet": "均衡信息设置",
  "setting.type12.val.slow": "慢",
  "setting.type12.val.medium": "中",
  "setting.type12.val.fast": "快",
  "setting.type12.val.low": "低",
  "setting.type12.val.high": "高",
  "setting.type12.val.powerCycle": "动力循环",
  "setting.type12.val.powerRotation": "动力轮替",
  "setting.type12.val.additionalPower": "动力追加",
  "setting.type12.val.powerUnchanged": "动力不变",
  "setting.type12.val.solarPowerInput": "太阳能输入功率",
  "setting.type12.val.batteryCapacity": "电池容量百分比",
  "setting.type12.val.percentageLoad": "负载百分比",
  "setting.type12.val.energySource": "能量源",
  "setting.type12.val.batteryStatus": "电池充放电状态",
  "setting.type12.val.blue": "蓝色",
  "setting.type12.val.cyan": "青色",
  "setting.type12.val.green": "绿色",
  "setting.type12.val.pink": "粉色",
  "setting.type12.val.purple": "紫色",
  "setting.type12.val.orange": "橙色",
  "setting.type12.val.yellow": "黄色",
  "setting.type12.val.white": "白色",
  "setting.type12.val.inputOvlRange1": "APL 模式（90-280V）",
  "setting.type12.val.inputOvlRange2": "UPS 模式（170-280V）",
  "setting.type12.val.outputSource1": "太阳能->公用->电池",
  "setting.type12.val.outputSource2": "太阳能->电池->公用",
  "setting.type12.val.chargeSourcePriority1": "光伏优先",
  "setting.type12.val.chargeSourcePriority2": "光伏和市电",
  "setting.type12.val.chargeSourcePriority3": "仅光伏",
  "setting.type12.val.solarSupplyPriority1": "电池-负载-公用",
  "setting.type12.val.solarSupplyPriority2": "负载-电池-公用",
  "setting.type12.val.countryRegulations1": "印度",
  "setting.type12.val.countryRegulations2": "德国",
  "setting.type12.val.countryRegulations3": "南美洲",
  "setting.type12.val.parallelMode1": "无并机",
  "setting.type12.val.parallelMode2": "单相并机",
  "setting.type12.val.outPutSourcePriority1": "市电优先",
  "setting.type12.val.outPutSourcePriority2": "太阳能优先",
  "setting.type12.val.outPutSourcePriority3": "太阳能->电池->市电",
  "setting.ops15.invSwitch": "逆变器开关",
  "setting.ops15.workMode": "工作模式",
  "setting.ops15.workMode1": "馈网优先",
  "setting.ops15.workMode2": "离网模式",
  "setting.ops15.workMode3": "自发自用",
  "setting.ops15.invTime": "逆变器时间",
  "setting.ops15.batType": "电池类型",
  "setting.ops15.batType1": "无电池",
  "setting.ops15.batType2": "通用锂电池",
  "setting.ops15.batType3": "铅酸电池",
  "setting.ops15.batType4": "锂电池",
  "setting.ops15.timingTime": "定时时间",
  "setting.ops15.offGirdSoc": "过放SOC（%）",
  "setting.ops15.optimizeRevenue": "优化收益",
  "setting.type19.totalActivePower": "有功功率",
  "setting.type19.offgridSettings": "并离网设置",
  "setting.type19.gridConnectedControlMode": "并网控制",
  "setting.type19.offGridControlMode": "离网控制",
  "setting.type19.offgrid.gridNet": "并网",
  "setting.type19.offgrid.offNet": "离网",
  "setting.type22.parameterScope": "参数范围",
  "setting.type22.ACStartVoltage": "启动电压/频率设置",
  "setting.type22.highVoltage": "AC启动高压",
  "setting.type22.lowVoltage": "AC启动低压",
  "setting.type22.pvStartLowVol": "PV启动低压",
  "setting.type22.acUnderVol1": "AC欠压一阶(V)",
  "setting.type22.acOverVol1": "AC过压一阶(V)",
  "setting.type22.acUnderVolTime1": "AC欠压一阶时间(s)",
  "setting.type22.acOverVolTime1": "AC过压一阶时间(s)",
  "setting.type22.acUnderVol2": "AC欠压二阶(V)",
  "setting.type22.acOverVol2": "AC过压二阶(V)",
  "setting.type22.acUnderVolTime2": "AC欠压二阶时间(s)",
  "setting.type22.acOverVolTime2": "AC过压二阶时间(s)",
  "setting.type22.startDelayTime": "启动延时时间",
  "setting.type22.restartDelayTime": "重启延时时间",
  "setting.type22.ACStartFrequency": "过欠压/频设置",
  "setting.type22.highFrequency": "AC启动高频",
  "setting.type22.lowFrequency": "AC启动低频",
  "setting.type22.acUnderFrequency1": "AC欠频一阶(Hz)",
  "setting.type22.acOverFrequency1": "AC过频一阶(Hz)",
  "setting.type22.acUnderFrequencyTime1": "AC欠频一阶时间(s)",
  "setting.type22.acOverFrequencyTime1": "AC过频一阶时间(s)",
  "setting.type22.acUnderFrequency2": "AC欠频二阶(Hz)",
  "setting.type22.acOverFrequency2": "AC过频二阶(Hz)",
  "setting.type22.acUnderFrequencyTime2": "AC欠频二阶时间(s)",
  "setting.type22.acOverFrequencyTime2": "AC过频二阶时间(s)",
  "setting.type22.systemSetting": "设备信息设置",
  "setting.type22.SNset": "序列号设置",
  "setting.type22.reactiveControlMode": "无功控制方式",
  "setting.type22.inputMode": "输入模式",
  "setting.type22.startSolpe": "启动斜率",
  "setting.type22.restartSolpe": "重启斜率",
  "setting.type22.reactivePercentage": "无功百分比",
  "setting.type22.activePercentage": "有功百分比",
  "setting.type22.shutdown": "远程开关",
  "setting.type22.functionSelect": "功能选择",
  "setting.type22.manufacturer": "厂商",
  "setting.type22.setFunctionSelect.val1": "禁止",
  "setting.type22.setFunctionSelect.val2": "使能防逆流",
  "setting.type22.setManufacturer.val1": "英威腾",
  "setting.type22.setManufacturer.val2": "创维",
  "setting.type22.reactiveControlModeChoice.val1": "功率因数控制",
  "setting.type22.reactiveControlModeChoice.val2": "无功功率百分比控制",
  "setting.type22.reactiveControlModeChoice.val3": "QV曲线控制",
  "setting.type22.inputModeChoice.val1": "输入独立模式",
  "setting.type22.inputModeChoice.val2": "输入并联模式",
  "setting.type22.inputModeChoice.val3": "DC Source 模式",
  "title.login": "登录",
  "title.vistorLogin": "游客登录",
  "title.createAccount": "创建账户",
  "title.retrievePassword": "找回密码",
  "title.userAgreement": "用户协议",
  "title.privacyPolicy": "隐私协议",
  "title.phone": "电话",
  "title.addPlant": "添加电站",
  "title.editPlant": "编辑电站",
  "title.accountInfo": "账户信息",
  "title.changePassword": "修改密码",
  "title.message": "消息",
  "title.systemMessage": "系统消息",
  "title.faultMessage": "故障消息",
  "title.deviceMessage": "设备消息",
  "title.aboutUs": "关于",
  "title.device": "设备",
  "title.datalogger": "采集器",
  "title.setting": "设置",
  "title.socketSetting": "插座设置",
  "title.addSchedule": "添加定时器",
  "title.editSchedule": "编辑定时器",
  "title.repetitionTime": "重复时间",
  "title.addDatalogger": "添加设备",
  "title.connectWifi": "连接路由",
  "title.distributionNetworkStatus": "配网状态",
  "title.language": "语言",
  "title.selectCountry": "选择国家",
  "title.selectCity": "选择城市",
  "bar.home": "首页",
  "bar.energy": "分析",
  "bar.plant": "电站",
  "bar.user": "用户",
  "bar.endpoint": "终端",
  "bar.mine": "我的",
  "bar.my": "我的",
  "button.logOut": "退出",
  "button.rememberMe": "记住账号密码",
  "button.forgetPassword": "忘记密码",
  "button.register": "注册",
  "button.ok": "确定",
  "button.send": "发送",
  "button.auto": "自动",
  "button.cancle": "取消",
  "button.yes": "是",
  "button.close": "关闭",
  "button.refresh": "刷新",
  "button.next": "下一步",
  "button.redistributionNetwork": "重新配网",
  "button.upload": "上传",
  "button.confirm": "确定",
  "button.edit": "编辑",
  "button.delete": "删除",
  "button.save": "保存",
  "button.allReady": "全部已读",
  "button.selectAll": "全选",
  "button.deselectAll": "取消全选",
  "button.unsubscribe": "注销账户",
  "button.later": "稍后",
  "button.upgrade": "更新",
  "button.unfollow": "取消关注",
  "button.add": "添加",
  "subtitle.NeedMoreHelp": "更多帮助",
  "subtitle.VisitSupportCenter": "浏览官网获得更多帮助",
  "subtitle.energyFlowDiagram": "能流图",
  "subtitle.selectTimezone": "选择时区",
  "subtitle.selectPlantType": "选择电站类型",
  "subtitle.selectInstallationDate": "选择安装日期",
  "subtitle.selectCurrency": "选择货币",
  "subtitle.selectDateType": "选择日期类型",
  "subtitle.selectDeviceType": "选择设备类型",
  "subtitle.socketBluetooth": "插座蓝牙",
  "subtitle.log": "日志",
  "subtitle.all": "全部",
  "subtitle.online": "在线",
  "subtitle.offline": "离线",
  "subtitle.normal": "正常",
  "subtitle.abnormal": "故障",
  "subtitle.on": "开",
  "subtitle.off": "关",
  "subtitle.todayEnergy": "今日电量",
  "subtitle.totalEnergy": "总电量",
  "subtitle.totalRevenue": "总收入",
  "subtitle.plantImage": "电站图片",
  "subtitle.plantName": "电站名字",
  "subtitle.plantType": "电站类型",
  "subtitle.PVCapacity": "PV容量",
  "subtitle.installationDate": "安装日期",
  "subtitle.plantAddress": "电站地址",
  "subtitle.revenue": "收入",
  "subtitle.timeZone": "时区",
  "subtitle.updatePhone": "更新电话",
  "subtitle.solar": "光伏",
  "subtitle.grid": "电网",
  "subtitle.battery": "电池",
  "subtitle.home": "负载",
  "subtitle.load": "负载",
  "subtitle.socket": "插座",
  "subtitle.today": "日",
  "subtitle.day": "日",
  "subttile.week": "周",
  "subtitle.month": "月",
  "subtitle.year": "年",
  "subtitle.total": "总",
  "subtitle.time": "时间",
  "subtitle.Co2": "二氧化碳",
  "subtitle.coal": "煤",
  "subtitle.deforestation": "保护森林",
  "subtitle.parameter": "参数",
  "subtitle.schedule": "定时器",
  "subtitle.countdown": "倒计时",
  "subtitle.socketSwitch": "插座开关",
  "subtitle.currency": "货币",
  "subtitle.energyPrice": "电价",
  "subtitle.storagePlant": "储能电站",
  "subtitle.on-GridPlant": "并网电站",
  "subtitle.photo": "头像",
  "subtitle.email": "邮箱",
  "subtitle.account": "账户",
  "subtitle.version": "版本",
  "subtitle.officalWebsite": "官网",
  "subtitle.SN": "序列号",
  "subtitle.wifiSignal": "WiFi 信号",
  "subtitle.lastSync": "最后同步",
  "subtitle.switch": "开关",
  "subtitle.happening": "发生中",
  "subtitle.restored": "已恢复",
  "subtitle.details": "详情",
  "subtitle.warn": "告警",
  "subtitle.fault": "故障",
  "subtitle.status": "状态",
  "subtitle.level": "等级",
  "subtitle.deviceType": "设备类型",
  "subtitle.alarmStartTime": "告警开始时间",
  "subtitle.alarmEndTime": "告警结束时间",
  "subtitle.solution": "解决方法",
  "subtitle.noSolution": "请参考用户手册或直接与售后部门取得联系。",
  "subtitle.loginIn": "登录中……",
  "subtitle.checkVersion": "检查更新",
  "subtitle.versionUpgrade": "版本更新",
  "subtitle.alarmName": "告警名称",
  "subtitle.messageDetail": "消息详情",
  "subtitle.todayConsumption": "今日用电量",
  "subtitle.totalConsumption": "累计用电量",
  "subtitle.dataloggerSN": "采集器序列号",
  "subtitle.configurationGuidance": "配置指导",
  "subtitle.guideVideo": "指导视频",
  "subtitle.manualInstuction": "指导手册",
  "subtitle.manualInstuction4G": "4G指导手册",
  "subtitle.manualInstuctionMasterControl": "主控指导手册",
  "subtitle.masterControlConfiguration": "主控配网",
  "subtitle.defaultConfiguration": "默认配网",
  "subtitle.findEmail": "邮箱找回",
  "subtitle.findPhone": "手机找回",
  "subtitle.family": "家庭",
  "subtitle.agent": "代理商",
  "subtitle.endUsers": "终端用户",
  "subtitle.deviceManagement": "设备管理",
  "subtitle.deviceSN": "设备序列号",
  "subtitle.firmwareVersion": "固件版本",
  "subtitle.alias": "别名",
  "subtitle.information": "信息",
  "subtitle.domainName": "域名",
  "subtitle.restartdatalogger": "重启采集器",
  "subtitle.value": "值",
  "subtitle.customizable": "自定义",
  "subtitle.ready": "读取",
  "subtitle.deviceDetails": "设备详情",
  "subtitle.startAddress": "起始寄存器地址",
  "subtitle.endAddress": "终止寄存器地址",
  "subtitle.settingParam": "设置参数",
  "subtitle.tariffType": "电价类型",
  "subtitle.fixed": "固定",
  "subtitle.timeshare": "分时",
  "subtitle.addTime": "添加时间",
  "subtitle.notAllDay": "不是一整天",
  "subtitle.dealer": "经销商",
  "subtitle.dealerNumber": "经销商编号",
  "subtitle.toggle": "切换",
  "subtitle.environmentalBenefit": "环境效益",
  "subtitle.basicParam": "基本参数",
  "subtitle.realTimeParam": "实时参数",
  "subtitle.export": "导出",
  "subtitle.localDebug": "近端调试",
  "subtitle.mode": "方式",
  "subtitle.manuallyAdd": "手动添加",
  "subtitle.AttachTheDevice": "下挂设备",
  "subtitle.ammeter": "电表",
  "subtitle.FeederPowerOnTheSameDay": "当日馈网电量",
  "subtitle.BatterySOC": "电池SOC",
  "subtitle.DailyChargingCapacityOfTheBattery": "今日充电量",
  "subtitle.DailyPowerConsumption": "日用电量",
  "subtitle.CumulativePowerGeneration": "累计发电量",
  "subtitle.total2": "总计",
  "subtitle.run": "运行",
  "subtitle.StopIt": "停止",
  "subtitle.Optimizer": "优化器",
  "subtitle.DataGateways": "数据网关",
  "subtitle.dataType": "数据类型",
  "subtitle.Model": "型号",
  "subtitle.TheAmountOfElectricityGeneratedToday": "今日发电量",
  "subtitle.CurrentPower": "当前功率",
  "subtitle.AllOptimizerWorkingStatus": "所有优化器工作状态",
  "subtitle.WhenClosedAllOptimizersStopWorking": "关闭后，所有优化器当停止工作",
  "subtitle.TheDataGatewayRestarts": "数据网关重启",
  "subtitle.Reboot": "重启",
  "subtitle.Restarting": "重启中",
  "subtitle.HardwareVersionNumber": "硬件版本号",
  "subtitle.SoftwareVersionNumber": "软件版本号",
  "subtitle.OutputPower": "输出功率",
  "subtitle.OutputVoltage": "输出电压",
  "subtitle.OutputCurrent": "输出电流",
  "subtitle.InputPower": "输入功率",
  "subtitle.InputVoltage": "输入电压",
  "subtitle.InputCurrent": "输入电流",
  "subtitle.OperationalStatus": "运行状态",
  "subtitle.temperature": "温度(℃)",
  "subtitle.DeviceAddress": "设备地址",
  "subtitle.FeederMode": "馈网模式",
  "subtitle.StandbyMode": "备电模式",
  "subtitle.Off-gridMode": "离网模式",
  "subtitle.TimedChargingAndDischarging": "定时充放电",
  "subtitle.WorkingModeSettings": "工作模式设置",
  "subtitle.DeviceInformation": "设备信息",
  "subtitle.HMISoftwareVersion": "HMI软件版本",
  "subtitle.DSPSoftwareVersion": "DSP软件版本",
  "subtitle.ChargeAndDischargeTimePeriodSetting": "充放电时间段设置",
  "subtitle.ChargingPeriod": "充电时间段",
  "subtitle.DischargeTimePeriod": "放电时间段",
  "subtitle.BatteryMinimumSOC(%)": "电池最小SOC(%)",
  "subtitle.BatteryOvervoltageMethod(V)": "电池过压法值(V)",
  "subtitle.BatteryUndervoltageThreshold(A)": "电池欠压阀值(A)",
  "subtitle.ChargingCurrentLimit(A)": "充电限流(A)",
  "subtitle.DischargeCurrentLimit(A)": "放电限流(A)",
  "subtitle.Off-GridDischargeMinimumSOC(%)": "离网放电最小SOC(%)",
  "subtitle.Off-Grid-2-DischargeMinmumSOC(%)": "离网2放电最小SOC(%)",
  "subtitle.Off-grid-2-DischargeMinimumBatteryVoltage(V)": "离网2放电最小电池电压(V)",
  "subtitle.Auto-replenishment": "自动补电",
  "subtitle.BatteryBMSActivationCommand": "电池BMS激活命令",
  "subtitle.ForcedFullCharge": "强制满充",
  "subtitle.ForceCharge2": "强制充电2",
  "subtitle.ForceCharge1": "强制充电1",
  "subtitle.DischargeEnabled": "放电使能",
  "subtitle.ChargingEnabled": "充电使能",
  "subtitle.NumberOfOptimizers": "优化器数量",
  "subtitle.TheNameOfTheDevice": "设备名称",
  "subtitle.GeneralSettings": "通用设置",
  "subtitle.Anti-backflowSwitch": "防逆流开关",
  "subtitle.ReflowPowerLimit(W)": "回流功率限值(W)",
  "subtitle.OptimizerNumber": "优化器编号",
  "subtitle.reset": "重置",
  "subtitle.areYouSure": "确定要重置吗",
  "subtitle.PhysicalView": "物理视图",
  "subtitle.LogicalView": "逻辑视图",
  "subtitle.LayoutDrawing": "布局图",
  "tip.noData": "暂无数据",
  "tip.base.maxDistance": "最远",
  "tip.base.minDistance": "最近",
  "tip.base.maxSize": "最大",
  "tip.base.minSize": "最小",
  "tip.request.loading": "加载中",
  "tip.request.netWork": "网络连接失败，请检查网络",
  "tip.request.connectServerFail": "无法连接到服务器",
  "tip.request.requestTimeout": "请求超时",
  "tip.validate.choiceCountry": "请先选择一个国家",
  "tip.validate.country": "国家不能为空，请选择国家",
  "tip.validate.timeZone": "时区不能为空，请选择时区",
  "tip.validate.email": "邮箱格式错，请输入一个正确的邮箱",
  "tip.validate.verification": "请先发送验证码",
  "tip.validate.verificationError": "验证码错误，请输入一个有效的验证码",
  "tip.validate.passwordFormTip": "请输入一个6-20位由数字和字母组成的密码",
  "tip.validate.passwordError": "密码格式错误，请输入一个6-20位由数字和字母组成的密码",
  "tip.validate.passwordError2": "请输入一个有效的密码(密码不应该包括任何特殊字符、符号和空格)",
  "tip.validate.validatePassword": "您输入的两个密码不一致，请检查后重新输入",
  "tip.validate.confirmAgreement": "请您先阅读并同意隐私协议",
  "tip.validate.plantName": "电站名字不能为空，请输入电站名字",
  "tip.validate.plantType": "电站类型不能为空，请选择电站类型",
  "tip.validate.pvCapacity": "太阳能电池容量不能为空，请输入电池容量",
  "tip.validate.installationDate": "安装日期不能为空，请选择安装日期",
  "tip.validate.city": "城市不能为空，请选择城市",
  "tip.validate.incomeunit": "货币不能为空，请选择货币",
  "tip.validate.energyPrice": "电价不能为空，请输入电价",
  "tip.validate.firstChoiceCountry": "请先选择一个国家",
  "tip.validate.oldPassword": "旧密码不能为空，请输入旧密码",
  "tip.validate.newPassword": "新密码不能为空，请输入新密码",
  "tip.validate.confirmPassword": "确认密码不能为空，请确认密码",
  "tip.validate.passwordNotMatch": "两次密码输入不一致，请检查确认后提交",
  "tip.validate.SN1": "序列号不能为空",
  "tip.validate.SN2": "序列号必须是10位",
  "tip.validate.noSocketTimer": "当前没有插座定时器，请点击添加",
  "tip.validate.cameraPermission": "App需要相机权限，以便用于扫码添加采集器",
  "tip.validate.searchingState": "正在搜索蓝牙中，请勿重复点击",
  "tip.validate.notInTheScope": "输入参数不在规定范围内",
  "tip.validate.enterDecimal": "必须输入{num}位小数或整数",
  "tip.validate.integer": "必须是整数",
  "tip.validate.phone": "手机号仅支持中国大陆，其它请使用邮箱找回",
  "tip.validate.can`tEmpty": "{param}不能为空",
  "tip.validate.dealerSope": "经销商编号范围是6~8位数字",
  "tip.validate.firstChoicePlant": "请先选择电站",
  "tip.log.permissionOpen": "确保定位和蓝牙权限已开启",
  "tip.log.openBluetoothSystem": "打开蓝牙设置",
  "tip.log.openIosBtSystem": "请重启蓝牙开关",
  "tip.log.openLocationSystem": "打开定位设置",
  "tip.log.bluetoothAuthorization": "APP蓝牙授权未开启",
  "tip.log.locationAuthorization": "APP定位授权未开启",
  "tip.log.searchSurroundingDevicesPermission": "搜索附近设备未授权",
  "tip.log.bluetoothNotPermission": "蓝牙未开启",
  "tip.log.locationNotPermission": "定位未开启",
  "tip.log.bluetoothPermission": "蓝牙已开启",
  "tip.log.locationPermission": "定位已开启",
  "tip.log.bluetoothException": "蓝牙异常断开，请确认设备蓝牙已开启，然后重新连接",
  "tip.log.listeningFailure": "监听特征值变化失败，请重新连接蓝牙",
  "tip.log.communicationException": "蓝牙通讯异常，请重新连接蓝牙",
  "tip.log.reconnect": "蓝牙重新连接",
  "tip.log.connectFail": "蓝牙连接失败",
  "tip.log.connect": "连接蓝牙",
  "tip.log.bluetoothService": "请开启蓝牙服务",
  "tip.log.locationService": "请开启定位服务",
  "tip.log.notsupport": "当前平台支持调用蓝牙功能",
  "tip.log.locationNotTurnOn": "定位未开启，无法搜索蓝牙",
  "tip.log.init": "蓝牙初始化",
  "tip.log.searching": "正在搜索周围蓝牙",
  "tip.log.searchFail": "周围没有查询到设备，请确保设备蓝牙已开启，然后点击刷新",
  "tip.log.stopSearch": "停止搜索周围蓝牙",
  "tip.log.stopSearchFail": "停止搜索周围蓝牙失败",
  "tip.log.connectSuccess": "蓝牙连接成功",
  "tip.log.setMTUsSuccess": "设置最大传输单元成功",
  "tip.log.setMTUsFail": "设置最大传输单元失败",
  "tip.log.closeSuccess": "已断开蓝牙连接",
  "tip.log.closeFail": "断开蓝牙连接失败",
  "tip.log.wifiLoadFail": "WiFi列表加载失败，请手动输入",
  "tip.log.bluetoothAbnormal": "蓝牙连接异常，正在尝试重新连接",
  "tip.log.getBluetoothServiceSuccess": "获取蓝牙设备服务成功",
  "tip.log.getBluetoothServiceFail": "获取蓝牙设备服务失败",
  "tip.log.getFeatureValuesSucess": "已成功获取蓝牙设备指定服务中的所有特征值",
  "tip.log.getFeatureValuesFail": "获取蓝牙设备指定服务中的所有特征值失败",
  "tip.log.subscriptionEigenvalueSuccess": "已启用低功耗蓝牙设备特征值变化时的notify功能，订阅特征值",
  "tip.log.subscriptionEigenvalueFail": "启用低功耗蓝牙设备特征值变化时的notify功能，订阅特征值失败",
  "tip.log.monitoringSuccess": "已成功监听低功耗蓝牙设备的特征值变化事件",
  "tip.log.monitoringFail": "监听低功耗蓝牙设备的特征值变化事件失败",
  "tip.log.CRC": "CRC校验失败",
  "tip.log.queryWiFi": "已成功查询WiFi列表",
  "tip.log.queryWiFiState": "已成功下发WiFi列表查询指令",
  "tip.log.wifiConenct": "正在查询路由连接状态",
  "tip.log.wifiFail": "请检查路由器账号和密码并尝试重新连接",
  "tip.log.connectWiFiSuccess": "路由器连接成功",
  "tip.log.connectWiFiFail": "路由器连接失败",
  "tip.log.routerAccount": "路由器账号错误",
  "tip.log.routerPassword": "路由器密码错误",
  "tip.log.gettingIP": "正在获取路由器IP",
  "tip.log.getIPFail": "获取路由器IP失败",
  "tip.log.queryServerState": "已成功下发查询设备与服务器交互状态指令",
  "tip.log.server03": "有03数据交互",
  "tip.log.server04": "有04数据交互",
  "tip.log.heartbeat": "有心跳数据交互",
  "tip.log.noInteraction": "没有数据交互",
  "tip.log.bluetoothCommunication": "已打通蓝牙通讯",
  "tip.log.connectWiFi": "连接WiFi",
  "tip.log.getWiFiList": "正在查询WiFi列表",
  "tip.log.wifiName": "WiFi名字不能为空，请选择或输入2.4WiFi",
  "tip.log.wifiPasword": "WiFi不能为空，请输入密码",
  "tip.log.wifiPasswordError": "WiFi密码不能包含特殊字符(ǎǐò•♢∝⌒℃℉ etc.)",
  "tip.log.masterControlId": "主控ID不能为空，请输入ID",
  "tip.addDatalogger.noSearchDevice": "无法查询到设备，请确保设备蓝牙已开启",
  "tip.addDatalogger.searchAroundBluetooth": "周围可配网蓝牙",
  "tip.addDatalogger.scan": "扫描二维码或在二维码下方手动输入采集器序列号。",
  "tip.addDatalogger.connectBluetoothFail": "蓝牙连接失败，请扫描二维码或在二维码下方手动输入采集器序列号后再次连接。",
  "tip.connectWifi.tip1": "配置设备加入网络",
  "tip.connectWifi.tip": "请选择2.4G WiFi",
  "tip.connectWifi.devicePower": "设备功率",
  "tip.connectWifi.enterSSID": "请输入路由器账号",
  "tip.connectWifi.enterPassword": "请输入路由器密码",
  "tip.connectWifi.masterId": "请输入主控Id",
  "tip.connectWifi.commandSetFail": "命令设置失败，请重新连接采集器",
  "tip.configurationState.connecting": "连接中",
  "tip.configurationState.connectFail": "连接失败",
  "tip.configurationState.connectSuccess": "连接成功",
  "tip.configurationState.wait": "请稍等",
  "tip.configurationState.addDeviceSuccess": "添加设备成功",
  "tip.home.today": "日发电量",
  "tip.home.month": "月发电量",
  "tip.home.year": "年发电量",
  "tip.home.total": "累计发电量",
  "tip.home.homePower": "家庭总负载",
  "tip.home.socketPower": "插座负载",
  "tip.home.off-gridPower": "离网负载",
  "tip.home.acPower": "市电功率",
  "tip.home.on-gridPower": "AC最大输出功率",
  "tip.home.others": "其它",
  "tip.home.latestVersion": "已是最新版本",
  "tip.home.frontEndLoad": "前端负载",
  "tip.home.backEndLoad": "离网负载",
  "tip.energy.choiceDate": "当前的数据只到",
  "tip.energy.explain": "说明",
  "tip.energy.tip1.load": "负载所消耗的能源",
  "tip.energy.tip1.solar": "将太阳能转换为电能，用于电池充电或负载供电的能源",
  "tip.energy.tip1.grid": "累计给电网出售的能源",
  "tip.energy.tip1.battery": "累计给电池充电的电能能源",
  "tip.energy.tip2": "0",
  "tip.energy.tip3.title": "社会贡献计算标准",
  "tip.energy.tip3.title2": "1kWh等于:",
  "tip.energy.tip3.Co2": "减少二氧化碳排放量：",
  "tip.energy.tip3.coal": "节约使用标准煤：",
  "tip.energy.tip3.deforestation": "保护树木：",
  "tip.plant.comprehensive": "综合排序",
  "tip.plant.totalEnergyMax": "总电量最高",
  "tip.plant.totalEnergyMin": "总电量最低",
  "tip.plant.realTimePower": "实时功率",
  "tip.plant.pvcapacityMax": "pv容量最高",
  "tip.plant.pvcapacityMin": "pv容量最低",
  "tip.plant.installationDateMax": "装机日期最远",
  "tip.plant.installationDateMin": "装机日期最近",
  "tip.plant.paramChoice": "参数选择",
  "tip.plant.filter": "筛选",
  "tip.plant.addVisitor": "添加访客",
  "tip.plant.tip": "提示",
  "tip.plant.visitorTip": "只能分享给已注册的用户",
  "tip.plant.name": "名字",
  "tip.plant.permission": "权限",
  "tip.plant.read-write": "读写",
  "tip.plant.onlyread": "只读",
  "tip.plant.visitor": "访客",
  "tip.plant.unfollow": "你确定要取消对此电站的关注？",
  "tip.device.power": "功率",
  "tip.device.type": "类型",
  "tip.device.updateTime": "更新时间",
  "tip.device.powerOnTime": "上电时间",
  "tip.device.todayEnergy": "今日用电量",
  "tip.device.signal": "信号强度",
  "tip.device.deliveryWarning": "抱歉，本设备已经交付C端用户使用，无法删除。您可以先去电站管理，撤回交付，然后再来删除设备。",
  "common.ok": "好的",
  "tip.delDevice": "你确定要删除这个{device}吗?",
  "tip.currentNoDevice": "当前没有设备",
  "tip.currentNoDatalog": "当前没有采集器",
  "tip.messageInfo.storage": "储能",
  "tip.messageInfo.inverter": "逆变器",
  "tip.messageInfo.microInverter": "微逆",
  "tip.ops.setDomainName": "你确定要设置这个域名吗？",
  "tip.ops.restartDatalogger": "你确定要重启采集器吗？",
  "tip.opsLog.addUser": "添加终端用户",
  "tip.opsLog.bindSuccess": "绑定成功",
  "tip.opsLog.selectDate": "选择日期",
  "tip.opsLog.start": "开始",
  "tip.opsLog.end": "结束",
  "tip.opsLog.upgrade": "升级",
  "tip.opsLog.operation": "操作",
  "tip.opsLog.communication": "通讯",
  "tip.opsLog.type": "类型",
  "tip.opsLog.content": "内容",
  "tip.opsLog.control": "控制器",
  "tip.opsLog.command": "命令类型",
  "tip.opsLog.reset": "重置",
  "tip.opsLog.serverTime": "服务器时间",
  "tip.opsLog.inverter": "间隔",
  "tip.opsLog.bindAgent": "绑定经销商",
  "tip.opsLog.deleteDeviceSN": "请确认是否删除？",
  "tip.opsLog.recordLog": "需要记录日志的设备",
  "tip.userLocation": "用户所在地",
  "tip.setting.productModelNumberRelevancyOn-gridPower": "并网有功功率不能大于所选产品型号最大功率",
  "productEquipment.productModelNumber": "产品型号",
  "productEquipment.warnMessage": "告警信息",
  "productEquipment.customInstruction": "自定义指令",
  "productEquipment.firmwareUpdate": "固件升级",
  "productEquipment.historicalData": "历史数据",
  "productEquipment.linkageInformation": "连接信息",
  "systemAuthority.systemSettings": "系统设置",
  "systemAuthority.authorityManagement": "权限管理",
  "systemAuthority.accountManagement": "角色管理",
  "systemAuthority.Disabled": "禁用",
  "systemAuthority.enable": "启用",
  "org.ChangeSupplier": "更改安装商",
  "upload.imageDetail": "图片详情",
  "upload.seeOrigin": "点击查看源文件",
  "upload.needOpen": "该文件可能需下载后查看",
  "upload.knowandSure": "知晓并确认",
  "upload.fail": "上传失败",
  "upload.uploadError": "文件上传失败，请联系管理员",
  "upload.fielExceed": "文件超出个数",
  "upload.fileSizeExceed": "上传图片大小不能超过",
  "upload.fileTypeError": "请选择正确的文件格式",
  "upload.image": "图片",
  "common.reset": "重置",
  "common.confirm": "确定",
  "common.cancel": "取消",
  "common.save": "保存",
  "common.delete": "删除",
  "common.add": "新增",
  "common.edit": "编辑",
  "common.update": "更新",
  "common.submit": "提交",
  "common.tip": "提醒",
  "common.success": "成功",
  "common.fail": "失败",
  "common.password": "密码",
  "common.handleFail": "操作失败",
  "common.required": "必填项",
  "common.environmentChange": "账号环境变更，确认将刷新账号或重新登录",
  "common.noPermissions": "还没有内容，快联系管理员配置上吧～",
  "common.personalCenter": "个人中心",
  "common.deviceSet": "设备设置",
  "common.productDetail": "产品详情",
  "validator.bank": "请输入正确银行卡号",
  "validator.phone": "请输入正确的手机或固话号码",
  "validator.email": "请输入正确的邮箱",
  "validator.password": "密码长度 8-20 位，至少包含以下三种字符类型（数字、大写字母、小写字母、英文符号）",
  "validator.max": "最多只能输入{num}个字符",
  "validator.min": "最少输入{num}个字符",
  "validator.greater": "请输入大于零的数字",
  "org.user": "用户",
  "org.role": "角色",
  "org.email": "邮箱",
  "org.editorginfo": "编辑组织信息",
  "org.passwordResetTo": "的密码将重置为",
  "org.pleaseChooseOrg": "请先选择组织",
  "org.addDept": "新增部门",
  "org.editDept": "编辑部门",
  "org.passwordResetSuccess": "重置密码成功",
  "org.passwordResetFail": "重置密码失败",
  "org.deleteTip": "此操作将删除该部门, 是否继续?",
  "org.deleteSuccess": "删除成功",
  "org.parent": "上级组织",
  "org.orgName": "组织名称",
  "org.area": "国家/地区",
  "org.leader": "负责人",
  "org.leaderPhone": "负责人联系方式",
  "org.logo": "组织logo",
  "org.namenick": "姓名/昵称",
  "org.createTime": "创建时间",
  "org.status": "状态",
  "org.action": "操作",
  "shipment.shippingManagement": "出货管理",
  "shipment.haierSn": "海尔SN",
  "shipment.category": "品类",
  "shipment.supplier": "供应商",
  "shipment.supplierSN": "生产SN",
  "shipment.PleaseSelectStatus": "请选择状态",
  "shipment.MaterialCode": "MDM物料编码",
  "shipment.PleaseEnterMaterialCode": "请输入MDM物料编码",
  "shipment.MdmCode": "MDM编码",
  "shipment.devType": "研发方式",
  "shipment.spread": "展开",
  "shipment.packUp": "收起",
  "shipment.shippingManagementTemplage": "出货管理导入模板",
  "product.createProduct": "创建产品",
  "product.deviceSubclass": "设备子类",
  "product.networkingMode": "联网方式",
  "product.productImage": "产品图片",
  "product.bluetoothIcon": "蓝牙图标",
  "product.uploadOneBluetoothIcon": "蓝牙图标最多上传1张",
  "product.UploadUpTo9Photos": "最多上传9张",
  "product.PleaseEnterSupplier": "请输入供应商",
  "product.PleaseUploadNoBackground": "请上传没有背景的设备图片",
  "person.changePassword": "修改密码",
  "person.userName": "用户名",
  "person.company": "公司",
  "person.newPassword": "新密码",
  "person.confirmPassword": "确认密码",
  "person.userInformation": "用户信息",
  "person.basicInformation": "基本信息",
  "person.address": "地址",
  "person.phone": "电话",
  "person.confirmChange": "确认修改",
  "weather.clearSky": "晴天",
  "weather.fewClouds": "少云",
  "weather.scatteredClouds": "散布云",
  "weather.brokenClouds": "碎云",
  "weather.overcastClouds": "阴天",
  "weather.lightRain": "小雨",
  "weather.moderateRain": "中雨",
  "weather.heavyRain": "大雨",
  "weather.thunderstormWithLightRain": "小雨伴雷暴",
  "weather.thunderstormWithRain": "降雨伴雷暴",
  "weather.thunderstormWithHeavyRain": "大雨伴雷暴",
  "weather.lightSnow": "小雪",
  "weather.snow": "下雪",
  "weather.heavySnow": "大雪",
  "weather.sleet": "雨夹雪",
  "weather.showerRain": "阵雨",
  "weather.lightShowerRain": "轻微阵雨",
  "weather.heavyShowerRain": "强烈阵雨",
  "weather.mist": "薄雾",
  "weather.smoke": "烟雾",
  "weather.haze": "霾",
  "weather.dust": "尘土飞扬",
  "weather.fog": "雾",
  "weather.sand": "沙尘",
  "weather.ash": "火山灰",
  "weather.squall": "突风",
  "weather.tornado": "龙卷风",
  "zh-CN": "中文",
  "en-US": "英语",
  "de-DE": "德语",
  "fr-FR": "法语",
  "it-IT": "意大利语",
  "uk-UA": "乌克兰语",
  "th-TH": "泰语",
  "nl-NL": "荷兰语",
  "device.to": "至",
  "device.range": "范围",
  "device.noParamsChange": "未修改任何参数，无需下发",
  "device.timeCopy": "存在重复时间段，请修改",
  "product.havePublished": "已发布",
  "product.inDevelopment": "开发中",
  "language.management": "多语言管理",
  "language.syncIot": "同步IoT告警",
  "language.syncSuccess": "同步青络IoT告警配置成功",
  "sidebar.roleManagement": "角色管理",
  "user.userEmail": "用户邮箱",
  "user.agentCode": "代理代码",
  "user.phoneModel": "手机型号",
  "user.phoneOs": "手机操作系统",
  "user.appVersion": "应用版本",
  "user.country": "国家",
  "user.createTime": "创建时间",
  "user.loginTime": "登录时间",
  "bTerminal.correlationDeleteTheDevice": "若删除本设备，与其相关联的设备也将同步删除，确定删除吗",
  "log.operationEmail": "操作邮箱",
  "log.deviceSn": "设备SN",
  "log.opType": "操作类型",
  "log.opTime": "操作时间",
  "log.operator": "操作人",
  "log.operationDescription": "操作说明",
  "log.content": "操作内容",
  "log.params": "参数",
  "role.action": "操作",
  "role.add.select.menu": "请选择菜单资源",
  "role.addRole": "新增角色",
  "role.addTip": "支持对Web端、B端APP用户进行权限配置不支持对C端APP用户进行权限配置。",
  "role.applySuccess": "提交成功",
  "role.appPermissions": "APP菜单权限",
  "role.base": "基本信息",
  "role.edit": "编辑",
  "role.exist": "角色已经存在",
  "role.info": "详情",
  "role.name": "角色名称",
  "role.no": "角色编号",
  "role.not.empty": "角色信息不能为空",
  "role.per.user": "每个用户只能分配一个角色",
  "role.permissions": "数据权限",
  "role.status": "角色状态",
  "role.submit": "提交",
  "role.type": "角色类型",
  "role.typeTip": "安装商管理员：默认给安装商组织负责人的角色，整个平台有且仅有一个。安装商角色：安装商组织负责人可以给员工分配的角色，可以有多个。平台角色：除安装商外都可以使用的角色。",
  "role.updateTime": "更新时间",
  "role.webPermissions": "web菜单权限",
  "device.paramRangeErrorDefault": "数据范围有误, 输入范围应为 ",
  "device.paramRangeError": "数据范围有误",
  "plant.dataUpdate": "数据更新",
  "validate.requiredFormat": "请按示例格式输入",
  "plant.addStation": "新增电站",
  "product.ProtocolCode": "IoT产品ID",
  "product.IoIDandPlatformSource": "IoT 产品 ID 及平台来源",
  "product.productIdCannotRepeat": "产品id不能重复",
  "product.deviceTypeAccess.maxAddRows": "最多只能添加2条",
  "product.accessPlatformCannotRepeat": "平台来源不能重复",
  "product.productId": "产品ID",
  "product.powerType": "电源形式",
  "product.power": "额定功率kW",
  "system.taskCenter": "任务中心",
  "task.name": "任务名称",
  "task.type": "任务类型",
  "task.status": "状态",
  "task.createDate": "创建时间",
  "task.progress": "进度",
  "task.view": "查看",
  "task.stop": "中止",
  "task.stopConfirm": "是否确认中止任务？",
  "task.stopSuccess": "中止任务成功",
  "task.stopFail": "中止任务失败",
  "task.confirm": "确定",
  "task.cancel": "取消",
  "task.mutipleSearch": "批量查询",
  "task.mutipleSend": "批量下发",
  "task.taskDetail": "任务详情",
  "task.equipmentList": "设备清单",
  "task.fileLimit": "只能上传xls/xlsx文件",
  "task.reChoose": "清空列表后重新选择",
  "task.tip": "将文件拖到此处，或",
  "task.upload": "点击上传",
  "task.templateDownload": "模板下载",
  "task.mutipleHandleParams": "批量处理的参数",
  "common.previousStep": "上一步",
  "task.requiredProductModel": "请选择产品型号",
  "task.requiredEquipmentList": "请上传设备清单",
  "task.equipmentListTip": "表格数据为空或上传失败，请检查",
  "task.requiredParameter": "请选择参数",
  "task.writeValue": "写入值",
  "task.progressRate": "完成度",
  "task.readTime": "读取时间",
  "task.sendTime": "下发时间",
  "task.mutipleSearchTemplate": "批量查询模板",
  "task.mutipleSendTemplate": "批量下发模板",
  "task.uploadSuccess": "上传成功",
  "task.sendSuccess": "任务创建成功",
  "task.inProgress": "进行中",
  "task.completed": "已完成",
  "task.failed": "失败",
  "task.success": "成功",
  "system.configureImport": "配置导入",
  "product.DeviceHlepInstructions": "设备帮助说明",
  "product.addDeviceHlepInstructions": "添加设备帮助说明",
  "product.deviceInstallationGuideFirst": "请上传设备安装指引图片，引导安装商一步步完成安装与APP操作。",
  "product.deviceInstallationGuideSecond": "建议包括进入设备配网模式、SN二维码位置、建站、添加设备、蓝牙操作、快速配置等说明。",
  "product.mdnTip": "海尔SN前9位",
  "product.basicProperties": "基本属性",
  "product.specialProperties": "特殊属性",
  "product.platformRelated": "平台相关",
  "product.specialParam1": "特殊参数1",
  "product.platformParam1": "平台参数1",
  "Firmware.secretType": "加密方式",
  "common.copySuccess": "复制成功",
  "bTerminal.ModifyTheNameOfTheDevice": "更改设备名称",
  "bTerminal.changeFailed": "修改失败",
  "bTerminal.OnlyWithin100Characters": "仅限于100字以内的中英文、数字",
  "bTerminal.OnlyWithin30Characters": "仅限于30字以内的中英文、数字",
  "bTerminal.rename": "更名",
  "sidebar.prefill": "评价与反馈",
  "paramters.basicInformation": "基础信息",
  "paramters.DCSide": "直流侧",
  "paramters.ACSide": "交流侧",
  "paramters.stringCurrent": "组串电流",
  "paramters.moreParamters": "更多信息",
  "paramters.debugInformation": "调试信息",
  "paramters.current": "电流",
  "paramters.voltage": "电压",
  "paramters.power": "功率",
  "paramters.init": "初始化",
  "paramters.wait": "等待",
  "paramters.normal": "正常",
  "paramters.abnormal": "故障",
  "paramters.burn": "烧录",
  "system.reportCenter": "报表中心",
  "system.reportMonth": "月报表",
  "system.reportYear": "年报表",
  "system.selfServiceReport": "自助报表",
  "system.selfServiceReport.hour": "小时",
  "system.selfServiceReport.selectPlant": "请选择电站",
  "system.selfServiceReport.selectYear": "选择年份",
  "system.selfServiceReport.metricSelection": "指标选择",
  "system.selfServiceReport.required": "必选",
  "system.selfServiceReport.startTimeCannotBeLater": "开始时间不能大于结束时间",
  "system.selfServiceReport.fieldIsRequired": "{field} 为必选项",
  "system.selfServiceReport.hourTimeTooltipLine1": "小时代表该整点开始的1小时",
  "system.selfServiceReport.hourTimeTooltipLine2": "(例如 15:00 = 15:00–15:59)",
  "report.exportAll": "全部导出",
  "report.installedCapacity": "装机容量",
  "report.capacityErrorTip": "装机容量筛选范围有误",
  "report.exportFailed": "导出失败, 请稍后再试",
  "report.firstChoiceTime": "请先选择日期，再导出",
  "placeholder.selectScope": "请选择{scope}",
  "register.accountVerification": "账号验证",
  "register.companyRegistration": "公司注册",
  "register.staffRegistration": "员工注册",
  "register.companyInfo": "在下面提供公司信息",
  "register.companyFullName": "企业全称",
  "register.installationCountryNotice": "请仔细选择安装程序注册的国家，您无法在注册区域之外安装系统。",
  "register.detailAddress": "详细地址",
  "register.postalCode": "邮政编码",
  "register.contactName": "联系人姓名",
  "register.contactInfo": "联系人手机号或邮箱",
  "register.applyJoinCompany": "申请加入公司",
  "register.companyCodeInfo": "请填写公司编码及个人信息，加入已注册企业",
  "register.registrationCode": "公司注册编码",
  "register.codeHint": "编码可联系企业管理员获取",
  "register.realName": "姓名",
  "register.accountVerificationInfo": "选择以下方式完成账号注册",
  "register.emailRegistration": "邮箱注册",
  "register.sixDigitCode": "6位验证码",
  "register.getVerificationCode": "获取验证码",
  "register.resendAfterSeconds": "{seconds}s后重新获取",
  "register.resendAfterMinutes": "{minutes}min 后重新获取",
  "register.resendAfterMinutesSeconds": "{minutes}min{seconds}s后重新获取",
  "register.password6to20": "6-20位密码",
  "register.password8to20": "8-20位密码",
  "register.phoneNumber": "手机号",
  "register.phoneRegistration": "手机号注册",
  "register.optionalEmail": "可选：邮箱地址",
  "register.previousPage": "上一页",
  "register.goToLogin": "去登录",
  "register.completeRegistration": "完成注册",
  "register.accountAlreadyRegistered": "该邮箱或手机号已注册，请登录或更换其他账号。",
  "register.emailAlreadyRegistered": "邮箱已注册，请直接登录或更换其他账号",
  "register.phoneAlreadyRegistered": "手机号已注册，请直接登录或更换其他账号",
  "register.companyAlreadyRegistered": "「{companyName}」公司已注册",
  "register.companyExistOptions": "您可以返回修改公司名称，或申请加入该公司",
  "register.returnToModify": "返回修改",
  "register.companyRegisteredApplyJoin": "申请加入",
  "register.companyRegisteredApplyJoinFull": "公司已注册，申请加入公司",
  "register.validation.selectCountry": "请选择国家/地区",
  "register.validation.selectCity": "请选择城市",
  "register.validation.enterDetailAddress": "请输入详细地址",
  "register.validation.enterCorrectPostalCode": "请输入正确的邮编格式",
  "register.validation.enterContactName": "请输入联系人姓名",
  "register.validation.enterRegistrationCode": "请输入公司注册编码",
  "register.validation.enterYourName": "请输入您的姓名",
  "register.validation.enterPassword": "请输入密码",
  "register.validation.passwordLength": "密码长度需为6-20位",
  "register.validation.passwordLength8to20": "密码长度需为8-20位",
  "register.validation.passwordComplexity": "密码必须包含至少三种不同的字符类型（数字、大写字母、小写字母、特殊字符）",
  "register.validation.enterPasswordAgain": "请再次输入密码",
  "register.validation.passwordMismatch": "两次密码输入不一致",
  "register.validation.correctPhoneFormat": "请输入正确的手机号格式",
  "register.validation.correctPhoneOrEmailFormat": "请输入正确的手机号或邮箱格式",
  "register.validation.correctEmailFormat": "请输入正确的邮箱格式",
  "register.validation.enterVerificationCode": "请输入验证码",
  "register.validation.sixDigitNumber": "验证码需为6位数字",
  "register.validation.enterCompanyName": "请输入公司名称",
  "register.validation.companyRegisteredChooseAction": "公司已注册，请选择操作",
  "register.message.searchCompanyFailed": "搜索公司失败",
  "register.message.checkCompanyStatusFailed": "检查公司状态失败",
  "register.message.getCityListFailed": "获取城市列表失败",
  "register.message.companyRegisteredChooseAction": "公司已注册，请选择操作",
  "register.message.completeCompanyInfo": "请完善企业信息",
  "register.message.completeStaffInfo": "请完善员工信息",
  "register.message.enterEmailFirst": "请先输入邮箱地址",
  "register.message.correctEmailFormat": "请输入正确的邮箱格式",
  "register.message.verificationCodeSent": "验证码已发送至：{contact}",
  "register.message.sendVerificationCodeFailed": "发送验证码失败",
  "register.message.enterPhoneFirst": "请先输入手机号",
  "register.message.correctPhoneFormat": "请输入正确的手机号格式",
  "register.message.completeAccountInfoAndFixErrors": "请完善账号信息并修正错误项",
  "register.message.companyRegistrationSuccess": "公司注册成功！",
  "register.message.companyRegistrationFailed": "公司注册失败",
  "register.message.staffRegistrationSuccess": "员工注册成功！",
  "register.message.staffRegistrationFailed": "员工注册失败",
  "register.message.phoneRegistrationNotAvailable": "通过手机号码进行注册的功能目前尚未开通，请持续关注。",
  "register.tooltip.title": "如何查看公司注册码？",
  "register.tooltip.appPathTitle": "1. APP 查看路径",
  "register.tooltip.appPathDesc": "在APP-用户-点击头像-账号信息中，查看公司注册码。",
  "register.tooltip.webPathTitle": "2. 后台系统查看路径",
  "register.tooltip.webPathDesc": "在Web-组织管理-组织信息中，查看公司注册码。",
  "registerAccomplish.applicationComplete": "申请完成",
  "registerAccomplish.congratulations": "恭喜你，已完成注册。",
  "registerAccomplish.companyRegisterCodeIs": "你的公司注册码为",
  "registerAccomplish.certificationRequired": "你需要继续前往认证中心进行认证，否则无法激活设备。",
  "registerAccomplish.greenChannelInfo": "对于部门特殊紧急情况，为了不耽误现场安装，您可选择绿色通道，获得 2 个月的激活设备的临时权限。",
  "registerAccomplish.certificationCenter": "认证中心",
  "registerAccomplish.greenChannel": "绿色通道",
  "registerAccomplish.returnToLogin": "返回登录页",
  "registerAccomplish.useHaierEnergyApp": "可使用Haier Energy APP 添加设备。",
  "registerAccomplish.applyingGreenChannel": "您正在申请绿色通道",
  "registerAccomplish.greenChannelDescription1": "该通道仅针对部分特殊紧急情况，为了不耽误现场安装，用于激活设备。",
  "registerAccomplish.greenChannelDescription2": "通过该通道获得的账号权限为临时权限，激活设备的有效期为 2 个月。",
  "registerAccomplish.greenChannelDescription3": "您需要在 2 个月内前往认证中心完成认证，获得永久激活设备的权限。",
  "registerAccomplish.confirmSubmit": "确认提交",
  "registerAccomplish.returnToPrevious": "返回上一页",
  "registerAccomplish.applicationSubmittedSuccessfully": "您的申请已成功提交！",
  "registerAccomplish.missingAgentIdParameter": "缺少agentId参数，无法申请绿色通道",
  "registerAccomplish.greenChannelApplicationSuccess": "绿色通道申请成功！",
  "registerAccomplish.greenChannelApplicationFailed": "绿色通道申请失败",
  "registerAccomplish.enterSystem": "进入系统",
  "registerAccomplish.pleaseLoginFirst": "请先完成登录",
  "org.phoneNumber": "手机号",
  "org.certificationStatus": "认证状态",
  "org.permission": "权限",
  "org.accountSource": "账号来源",
  "org.certificationStatusTip": "目前仅针对在Haier Energy app 添加设备的权限",
  "org.unauthenticated": "未认证",
  "org.authenticated": "已认证",
  "org.noNeedToAuthenticate": "无需认证",
  "org.unauthorized": "未授权",
  "org.authorized": "已授权",
  "org.temporaryAuthorization": "临时授权",
  "org.remainingDays": "剩余天数: {scope}天",
  "org.allocated": "分配",
  "org.registered": "注册",
  "org.authorization": "授权",
  "org.addressDetail": "详细地址",
  "org.postalCode": "邮政编码",
  "org.accountSwitch": "账号切换",
  "org.viewAccountInfo": "查看账号信息",
  "org.baseInfo": "基础信息",
  "org.certificationInfo": "认证信息",
  "org.restDays": "剩余天数",
  "org.applyTime": "申请时间",
  "org.certificationTime": "认证时间",
  "org.registerCode": "注册编码",
  "org.registrationTip": "注册时可输入公司注册编码申请加入该公司。",
  "org.authenticationTip": "该账号已禁用，无法授权",
  "org.authenticationTip2": "该账号已授权或临时授权未到期,无法再次授权",
  "org.temporaryAuthorizationTip": "授权为临时权限，默认为3个月",
  "org.temporaryAuthorizationSuccess": "授权成功",
  "report.allSelect": "全部选择",
  "report.compare": "对比",
  "report.energy": "有功功率",
  "report.ipv": "直流电流",
  "report.vpv": "直流电压",
  "report.fac": "交流侧频率",
  "report.vac": "交流电压",
  "report.iac": "交流电流",
  "report.temperature": "内部温度",
  "report.str_cur": "组串电流",
  "report.inverterCompare": "逆变器对比",
  "report.inverterCompareTip": "已经添加到列表中，请勿重复添加",
  "report.pleaseChooseInverter": "请选择逆变器",
  "report.pleaseChooseCompare": "请选择对比项",
  "report.compareItem": "对比项",
  "system.inverterCompare": "逆变器参数对比",
  "shipment.deviceSource": "出货来源",
  "shipment.shippingCustomer": "出货客户",
  "shipment.customerContact": "客户联系人",
  "shipment.tag": "标签",
  "shipment.addTag": "新增标签",
  "shipment.editTag": "编辑标签",
  "shipment.tagContent": "标签内容",
  "shipment.tagColor": "标签颜色",
  "placeholder.selectShippingCustomer": "请选择出货客户",
  "placeholder.enterCustomerContact": "请输入客户联系人",
  "placeholder.selectTag": "请选择标签",
  "placeholder.enterTagContent": "请输入标签内容",
  "placeholder.noResult": "暂无匹配的标签",
  "validation.enterTagContent": "请输入标签内容",
  "validation.selectTagColor": "请选择标签颜色",
  "shipment.operationRecordTitle": "操作记录",
  "shipment.boundUserWarning": "抱歉，本设备已绑定用户，无法更新出货客户了。",
  "shipment.batchBoundUserWarning": "抱歉，所选设备中包含已绑定用户的设备，无法批量更新出货客户。",
  "shipment.uploadEquipmentListRequired": "请上传设备清单文件",
  "shipment.errorDataTipTitle": "异常数据提醒",
  "shipment.downloadImportResult": "下载导入结果",
  "shipment.downloading": "下载中...",
  "shipment.noFailedDataToDownload": "暂无失败数据可下载",
  "shipment.deleteTagConfirm": "确定删除标签\"{tagName}\"吗？",
  "common.addSuccess": "新增成功",
  "common.editSuccess": "修改成功",
  "system.intelligentDiagnosis": "智能诊断",
  "system.ivline": "IV曲线",
  "subtitle.ivlineCreate": "扫描任务",
  "diagnosis.diagnosisTime": "诊断时间",
  "diagnosis.faultQuantity": "故障数量",
  "diagnosis.scanCompleteTime": "扫描完成时间",
  "diagnosis.scanProgress": "扫描进度",
  "diagnosis.newTask": "新建任务",
  "diagnosis.deleteTask": "删除任务",
  "diagnosis.deleteTaskSuccess": "任务删除成功",
  "diagnosis.closeAll": "全部清除",
  "diagnosis.startScan": "开始扫描",
  "diagnosis.pleaseChooseInverter": "请选择逆变器",
  "diagnosis.stringSetting": "组串设置",
  "diagnosis.taskSetting": "设置任务",
  "diagnosis.batchComponentSetting": "批量组件设置",
  "diagnosis.componentType": "组件类型",
  "diagnosis.maxPower": "最大功率（Pmax）",
  "diagnosis.bestWorkingVoltage": "最佳工作电压（Vmpp）",
  "diagnosis.bestWorkingCurrent": "最佳工作电流（lmpp）",
  "diagnosis.openCircuitVoltage": "开路电压（Voc）",
  "diagnosis.shortCircuitCurrent": "短路电流（Isc）",
  "diagnosis.maxPowerTemperatureCoefficient": "最大功率的温度系数",
  "diagnosis.openCircuitVoltageTemperatureCoefficient": "开路电压的温度系数",
  "diagnosis.shortCircuitCurrentTemperatureCoefficient": "短路电流的温度系数",
  "diagnosis.nominalComponentConversionEfficiency": "标称组件转换效率",
  "diagnosis.firstYearDecayRate": "组件首年衰减率",
  "diagnosis.yearlyDecayRate": "组件逐年衰减率",
  "diagnosis.fillFactor": "填充因子",
  "product.maxPvChannels": "最大支持的PV路数",
  "product.componentManufacturer": "组件厂商",
  "product.componentType": "组件类型",
  "product.ratedPower": "额定功率",
  "product.mppVoltage": "MPP电压",
  "product.mppCurrent": "MPP电流",
  "product.openCircuitVoltage": "开路电压",
  "product.shortCircuitCurrent": "短路电流",
  "product.maxPowerTempCoeff": "最大功率的温度系数",
  "product.openVoltageTempCoeff": "开路电压温度系数",
  "product.shortCurrentTempCoeff": "短路电流温度系数",
  "product.componentEfficiency": "标称组件转换效率",
  "product.firstYearDegradation": "组件首年衰减率",
  "product.annualDegradation": "组件逐年衰减率",
  "product.fillFactor": "填充因子",
  "product.ratedPowerOnTheACSide": "交流侧额定功率（kW）",
  "product.ratedPowerOnTheDCSide": "直流侧额定功率（kW）",
  "product.energyStoragePower": "储能功率（kW）",
  "product.energyStorageCapacity": "储能容量（kWh）",
  "product.placeholder.range_0_9999_2dp": "0-9999，小数点后两位",
  "product.placeholder.range_0_99_2dp": "0-99，小数点后两位",
  "product.placeholder.range_0_999_2dp": "0-999，小数点后两位",
  "product.placeholder.range_neg1_1_2dp": "-1-1，小数点后两位",
  "product.rule.range_0_9999_2dp": "请输入0-9999之间的数字，最多两位小数",
  "product.rule.range_0_99_2dp": "请输入0-99之间的数字，最多两位小数",
  "product.rule.range_0_999_2dp": "请输入0-999之间的数字，最多两位小数",
  "product.rule.range_neg1_1_2dp": "请输入-1-1之间的数字，最多两位小数",
  "product.ivScanSupport": "是否支持IV曲线扫描",
  "diagnosis.componentManufacturer": "组件厂商",
  "diagnosis.componentAmount": "组件数量",
  "diagnosis.capacity": "组串容量",
  "diagnosis.stringAmount": "组串数量(片)",
  "diagnosis.inverterSerialNumber": "逆变器序列号",
  "diagnosis.totalCapacity": "组串总容量",
  "diagnosis.pleaseFillInAllItems": "存在未填项，请检查",
  "diagnosis.moreParamters": "更多参数",
  "diagnosis.envParam": "环境参数",
  "diagnosis.startTask": "开启任务",
  "diagnosis.startTaskSuccess": "任务启动成功",
  "diagnosis.start": "启动",
  "diagnosis.noDevice": "未找到设备",
  "register.contactAdminForCode": "请联系公司管理员获取公司注册码",
  "register.provideCompanyInfoBelow": "在下面公司提供公司信息",
  "login.success": "登录成功",
  "flowData.existingInvTip": "注意：\n外部逆变器>0, 代表太阳能正在发电;\n外部逆变器<0, 代表外部逆变器正在消耗电量。",
  "flowData.alert": "当前外部逆变器<0, 代表外部逆变器正在消耗电量。",
  "dialog.confirm": "我知道了",
  "paramters.deviceTotalInformation": "设备总信息",
  "paramters.innerInverter": "内部逆变器",
  "paramters.outerInverter": "外部逆变器",
  "paramters.outerInverterFromPvSide": "来自光伏侧电表",
  "paramters.activePower": "有功功率",
  "paramters.apparentPower": "视在功率",
  "paramters.reactivePower": "无功功率",
  "paramters.powerFactor": "功率因数",
  "paramters.phaseA": "A相",
  "paramters.phaseB": "B相",
  "paramters.phaseC": "C相",
  "paramters.charge": "充电",
  "paramters.discharge": "放电",
  "paramters.sell": "卖电",
  "paramters.buy": "买电",
  "bw_param_ctrl_group_WorkMode": "工作模式",
  "bw_param_ctrl_name_GRID_Meter_negate": "电网电表反接标志",
  "bw_param_ctrl_name_GridBreake": "电网端用电限值",
  "bw_param_ctrl_name_BBSOC_lx1": "L1断电SOC值",
  "bw_param_ctrl_name_BBSOC_lx2": "L2断电SOC值",
  "bw_param_ctrl_name_BBSOC_lx3": "L3断电SOC值",
  "bw_param_ctrl_option_ON": "开启",
  "bw_param_ctrl_name_Systemmode": "系统模式",
  "bw_param_ctrl_name_UPSReserveSoc": "UPS保留SOC",
  "bw_param_ctrl_option_OFF": "关闭",
  "bw_param_ctrl_option_B5": "单相5KW机型",
  "bw_param_ctrl_name_InvSub": "机型类型",
  "bw_param_ctrl_name_MAXFeedintogridpercent": "最大馈入电网百分比",
  "bw_param_ctrl_option_T4": "三相4KW机型",
  "bw_param_ctrl_option_T5": "三相5KW机型",
  "bw_param_ctrl_option_T6": "三相6KW机型",
  "bw_param_ctrl_option_T8": "三相8KW机型",
  "bw_param_ctrl_option_S3": "单相储能3KW机型",
  "bw_param_ctrl_option_S5": "单相储能5KW机型",
  "bw_param_ctrl_option_S6": "单相储能6KW机型",
  "bw_param_ctrl_option_S8": "单相储能8KW机型",
  "bw_param_ctrl_option_Grid&PV useCT": "电网和光伏使用CT",
  "bw_param_ctrl_note_MAXFeedintogridpercent": "最大馈网功率与光伏装机容量（包含光伏逆变器和储能逆变器接入的所有光伏容量）的比例",
  "bw_param_ctrl_option_Grid&PVUseMeter": "电网和光伏用电表",
  "bw_param_ctrl_note_PVCapacityofGridInverter": "接在储能逆变器上的PV总安装容量",
  "bw_param_ctrl_option_T10": "三相10KW机型",
  "bw_param_ctrl_name_DispatchReactivepower": "调度无功功率",
  "bw_param_ctrl_name_Grid_Regulation": "电网规范",
  "bw_param_ctrl_option_Enablecharge&dischargeTimePeriodControl": "启用充、放电时间段控制",
  "bw_param_ctrl_name_Timeperiodcontrolflag": "工作模式",
  "bw_param_ctrl_note_BatteryReady": "Battery Ready功能，默认“接入电池”，当没有电池接入系统或者不使用电池时请选择“未接入电池”",
  "bw_param_ctrl_option_withBattery": "接入电池",
  "bw_param_ctrl_name_PV_Meter_negate": "光伏电表反接标志",
  "bw_param_ctrl_option_OnlyEnableDischargeTimePeriodControl": "只启用放电时间段控制",
  "bw_param_ctrl_name_EMSReset": "重启EMS",
  "bw_param_ctrl_name_FactoryReset": "\n初始化系统",
  "bw_param_ctrl_name_DSPReset": "重启DSP",
  "bw_param_ctrl_group_RemoteReset": "远程重启",
  "bw_param_ctrl_option_FactoryReset": "重启",
  "bw_param_ctrl_option_DSPReset": "重启",
  "bw_param_ctrl_option_EMSReset": "重启",
  "bw_param_ctrl_group_BackupBox": "Backup Box",
  "bw_param_ctrl_name_BBPrio_lx1": "L1策略优先级",
  "bw_param_ctrl_name_BBPrio_lx2": "L2策略优先级",
  "bw_param_ctrl_name_BBPrio_lx3": "L3策略优先级",
  "bw_param_ctrl_note_BBSOC_lx3": "优先级3的SOC需高于优先级1的soc和优先级2的SOC",
  "bw_param_ctrl_note_BBSOC_lx1": "优先级1的SO需为L1、L2、L3最小SOC",
  "bw_param_ctrl_note_BBSOC_lx2": "优先级2的SOC需高于优先级1的soc",
  "bw_param_ctrl_option_1": "1",
  "bw_param_ctrl_option_3": "3",
  "bw_param_ctrl_option_2": "2",
  "bw_param_ctrl_name_BBLoadEnable": "启用Backup-Box",
  "bw_param_ctrl_name_MeterCTSelect": "电表/CT安装选项",
  "bw_param_ctrl_option_GridUse CT&PVUseMeter": "电网使用CT、光伏使用电表",
  "bw_param_ctrl_name_ChargeCutSoc": "充电截止SOC",
  "bw_param_ctrl_option_HybridMode": "混合模式",
  "bw_param_ctrl_name_PVCapacityStorage": "光伏逆变器PV装机容量",
  "bw_param_ctrl_name_DispatchTime": "调度时间",
  "bw_param_ctrl_name_DispatchStart": "调度（强制充放电）开关",
  "bw_param_ctrl_name_UPSreserveenable": "UPS保留使能",
  "bw_param_ctrl_option_selfuse": "自发自用",
  "bw_param_ctrl_option_DCMode": "DC模式",
  "bw_param_ctrl_name_PVCapacityofGridInverter": "储能系统PV装机容量",
  "bw_param_ctrl_name_RTC": "时钟设置",
  "bw_param_ctrl_option_Normal": "正常",
  "bw_param_ctrl_group_SystemInfo": "系统信息",
  "bw_param_ctrl_note_Systemmode": "DC:对于装混合逆变器的现场，指新装光伏系统，光伏组件直接接在逆变器上；对于装电池逆变器的现场，现场没有光伏逆变器，电池逆变器只并入电网，只有电网可以对电池进行充电。\n\nAC:指光伏改造系统，现场还有光伏逆变器并在电网上，光伏组件接在光伏逆变器上，不直接接在储能逆变器上\n\nHybrid:指现场有光伏逆变器并在电网上，也有光伏组件直接接在混合逆变器上。",
  "bw_param_ctrl_group_GridMeterSettings": "电表设置",
  "bw_param_ctrl_option_Forced charging and discharging": "强制充放电",
  "bw_param_ctrl_note_ChargeCutSoc": "电池SOC充电上限值",
  "bw_param_ctrl_option_OnlyEnableChargeTimeperiod control": "只启用充电时间段控制",
  "bw_param_ctrl_option_Disable": "不使能",
  "bw_param_ctrl_group_BatterySettings": "电池设置",
  "bw_param_ctrl_name_BatteryReady": "电池使能位",
  "bw_param_ctrl_option_GridUse Meter&PVUseCT": "电网使用电表、光伏使用CT",
  "bw_param_ctrl_name_DispatchSOC": "调度SOC",
  "bw_param_ctrl_option_Disable TimePeriodControl": "禁用时间段控制",
  "bw_param_ctrl_option_Enable": "使能",
  "bw_param_ctrl_option_TOU": "TOU",
  "bw_param_ctrl_name_ChargeTimeSlot1": "强充时间1",
  "bw_param_ctrl_name_ChargeTimeSlot2": "强充时间2",
  "bw_param_ctrl_note_Timeperiodcontrolflag": "选择“TOU”模式时，充放电设置才生效。",
  "bw_param_ctrl_group_GridSafetyConfig": "电网安规配置",
  "bw_param_ctrl_group_SystemConfig": "系统配置",
  "bw_param_ctrl_option_ACMode": "AC模式",
  "bw_param_ctrl_option_Reverse": "取反",
  "bw_param_ctrl_option_NotEnabledChargeSetting": "未启用充放电功能",
  "bw_param_ctrl_group_Charge&DischargeSettings": "充放电设置",
  "bw_param_ctrl_name_DispatchMode": "调度模式",
  "bw_param_ctrl_note_GridBreake": "请根据逆变器电网侧的实际空开规格选择，若填写规格有误可能会引起空开跳闸的问题",
  "bw_param_ctrl_note_PVCapacityStorage": "接在光伏逆变器上的PV总安装容量。",
  "bw_param_ctrl_name_DischargeTimeSlot2": "强放时间2",
  "bw_param_ctrl_name_DischargeTimeSlot1": "强放时间1",
  "bw_param_ctrl_group_GridDispatch": "电网调度",
  "bw_param_ctrl_name_DispatchActivepower": "调度有功功率",
  "jl_param_ctrl_group_OnOff": "逆变器开关",
  "jl_param_ctrl_name_OnOff": "逆变器开关",
  "jl_param_ctrl_option_PowerOFF": "关机",
  "jl_param_ctrl_option_PowerON": "开机",
  "product.multipleLanguage": "物模型多语言设置",
  "product.multipleLanguageNote": "物模型多语言词条库",
  "product.entryCode": "词条Code",
  "product.entryValue": "词条值",
  "product.endpoint": "端",
  "product.module": "模块",
  "product.tag": "标签",
  "product.editLanguage": "编辑多语言",
  "product.addLanguage": "新增多语言",
  "product.maintainInfo": "维护信息",
  "product.statusChangeSuccess": "状态调整成功",
  "product.statusChangeFail": "状态调整失败",
  "product.syncIotI18n": "同步青络物模型词条",
  "product.confirmSyncIotI18n": "确定要同步青络物模型词条吗？",
  "button.sync": "同步多语言包",
  "plant.withdrawDelivery": "撤回交付",
  "plant.deliverUser": "交付用户",
  "plant.withdrawDeliveryTip": "撤回交付后，C端用户将无法继续管理本电站。请谨慎操作。",
  "plant.undelivered": "未交付",
  "plant.deliverManage": "交付管理",
  "plant.email_format_error": "邮箱格式错误",
  "plant.deliverUserTip": "说明：用户使用邮箱登录Haier Energy时，即可通过APP监控、控制您安装的设备。",
  "plant.enterUserAccount": "请输入用户账号",
  "plant.deliverUserTipUnified": "说明：用户使用手机号或邮箱登录 Haier Energy 时，即可通过 APP 监控、控制您安装的设备。",
  "plant.placeholderPhoneOrEmail": "请输入手机号或邮箱",
  "plant.phoneOrEmailFormatError": "请输入正确的手机号或邮箱格式",
  "plant.deliverSuccess": "交付成功",
  "plant.known": "知道了",
  "plant.notRegistered": "未注册",
  "plant.noPermission": "抱歉，您没有权限撤回交付。仅平台超级管理员、安装商管理员可以撤回交付。",
  "plant.scanQRCode": "请让业主扫描下方二维码",
  "plant.qrCodeExpireTip": "接收成功后，本授权码将失效",
  "plant.transferMethod": "移交方式",
  "plant.transferRecord": "移交记录",
  "plant.operationTime": "操作时间",
  "plant.operator": "操作人",
  "plant.transferType": "移交类型",
  "plant.userIdentifier": "用户标识",
  "plant.transferResult": "移交结果",
  "plant.totalRecordCount": "共计{count}条记录",
  "device.Yield": "混合逆变器",
  "device.ExistingINV": "外部逆变器",
  "sidebar.dictManage": "字典管理",
  "subtitle.dictData": "字典数据",
  "dict.dictname": "字典标签",
  "dict.dictnameen": "字典键值",
  "dict.dictdataname": "数据标签",
  "dict.dictdatavalue": "数据键值",
  "dict.i18nCode": "语言code",
  "dict.dictsort": "排序",
  "dict.addDict": "新增字典",
  "dict.addDictData": "新增字典数据",
  "dict.editDict": "编辑字典",
  "dict.editDictData": "编辑字典数据",
  "device.otaTabTip": "提示：升级完成后，设备会短暂离线，请重启设备。",
  "product.accessPlatform": "平台来源",
  "product.valueFilter": "词条空值",
  "product.multipleEdit": "批量编辑",
  "product.mutipleDelete": "批量删除",
  "setting.type22.restrictCounterCurrent.val1": "限制三相总功率",
  "setting.type22.restrictCounterCurrent.val2": "限制单相功率",
  "setting.type22.disable": "禁止",
  "setting.type22.enable": "使能",
  "setting.type22.meterSelect.str": "斯通瑞电表",
  "setting.type22.meterSelect.df": "东帆电表",
  "setting.type22.meterSelect.dh": "东鸿电表",
  "setting.type22.meterSelect.zt": "正泰电表",
  "setting.type22.meterSelect.yb": "益邦",
  "setting.type22.meterSelect.yz": "英臻",
  "setting.type22.meterSelect.nky": "能控云智能电表",
  "bw_RTparam_name_AFCI_Version": "AFCI版本号",
  "bw_RTparam_name_allowCharged": "允充允放",
  "bw_RTparam_name_ApparentPOAP_Grid": "电表A视在功率",
  "bw_RTparam_name_ApparentPOBP_Grid": "电表B视在功率",
  "bw_RTparam_name_ApparentPOCP_Grid": "电表C视在功率",
  "bw_RTparam_name_BackupCurrentR": "Backup R相电流",
  "bw_RTparam_name_BackupCurrentS": "Backup S相电流",
  "bw_RTparam_name_BackupCurrentT": "Backup T相电流",
  "bw_RTparam_name_BackupFrequency": "Backup频率",
  "bw_RTparam_name_BackupPower": "Backup有功功率",
  "bw_RTparam_name_BackupVoltageR": "Backup R相电压",
  "bw_RTparam_name_BackupVoltageS": "Backup S相电压",
  "bw_RTparam_name_BackupVoltageT": "Backup T相电压",
  "bw_RTparam_name_batDcdcVersion": "电池DCDC版本号",
  "bw_RTparam_name_BatteryChargeCut-offVoltage": "系统充电截止电压",
  "bw_RTparam_name_BatteryChargeFromGrid_Every": "电池来自于电网的电量",
  "bw_RTparam_name_BatteryChargingCurrentLimit": "电池充电限流",
  "bw_RTparam_name_BatteryCurrent": "电池电流",
  "bw_RTparam_name_BatteryDischargeCurrentLimit": "电池放电限流",
  "bw_RTparam_name_BatteryDischargeCut-offVoltage": "系统放电截止电压",
  "bw_RTparam_name_BatteryMaxChargePower": "逆变器允许的最大充电功率",
  "bw_RTparam_name_BatteryMaxDischargePower": "逆变器允许的最大放电功率",
  "bw_RTparam_name_BatteryMode": "BMS模式",
  "bw_RTparam_name_BatteryModel": "电池型号",
  "bw_RTparam_name_BatteryNum": "系统电池包数量",
  "bw_RTparam_name_BatteryPower": "电池功率",
  "bw_RTparam_name_BatteryRelayStatus": "BMS继电器状态",
  "bw_RTparam_name_BatteryRunningTime": "总运行时间",
  "bw_RTparam_name_BatterySN": "电池SN（控制箱）",
  "bw_RTparam_name_BatterySN1": "电池包1 SN",
  "bw_RTparam_name_BatterySN2": "电池包2 SN",
  "bw_RTparam_name_BatterySN3": "电池包3 SN",
  "bw_RTparam_name_BatterySN4": "电池包4 SN",
  "bw_RTparam_name_BatterySN5": "电池包5 SN",
  "bw_RTparam_name_BatterySN6": "电池包6 SN",
  "bw_RTparam_name_BatterySOC": "电池SOC",
  "bw_RTparam_name_BatterySOH": "电池SOH",
  "bw_RTparam_name_BatteryStatus": "BMS状态",
  "bw_RTparam_name_BatteryVersion": "电池版本号",
  "bw_RTparam_name_BatteryVoltage": "电池电压",
  "bw_RTparam_name_BatWarnningPack": "电池具体报错位置",
  "bw_RTparam_name_BB_Version": "Backup Box版本号",
  "bw_RTparam_name_buy": "买电",
  "bw_RTparam_name_charge": "未启用充放电功能",
  "bw_RTparam_name_ChargeCutSoc": "SOC上限值",
  "bw_RTparam_name_charging": "允充禁放",
  "bw_RTparam_name_CurrentOfAPhase_PV": "电表A相电流",
  "bw_RTparam_name_CurrentOfBPhase_PV": "电表B相电流",
  "bw_RTparam_name_CurrentOfCPhase_PV": "电表C相电流",
  "bw_RTparam_name_DailyDeviceEnergy": "今日总发电量",
  "bw_RTparam_name_DailyEnergyfromGrid": "今日买电量",
  "bw_RTparam_name_DailyEnergytoGrid": "当日卖电量",
  "bw_RTparam_name_DataloggerSN": "序列号",
  "bw_RTparam_name_DataloggerVersion": "采集器版本",
  "bw_RTparam_name_DataUploadCycle": "数据上传间隔",
  "bw_RTparam_name_deviceRunningState": "设备运行状态",
  "bw_RTparam_name_DongleRssi": "信号强度",
  "bw_RTparam_name_dontBuy": "不买不卖",
  "bw_RTparam_name_electricity": "电网使用电表、光伏使用CT",
  "bw_RTparam_name_forbidden": "禁充允放",
  "bw_RTparam_name_ForceChargingSOC": "强充SOC",
  "bw_RTparam_name_forced": "强制充放电",
  "bw_RTparam_name_forcedCharge": "强充允放",
  "bw_RTparam_name_forcedCharging": "强充禁放",
  "bw_RTparam_name_Frequent_PV": "电表频率",
  "bw_RTparam_name_Fullchargecapacityofbattery": "满充容量",
  "bw_RTparam_name_grid": "电网和光伏用电表",
  "bw_RTparam_name_gridCT": "电网使用CT、光伏使用电表",
  "bw_RTparam_name_GridCurrentL1": "电网电流L1",
  "bw_RTparam_name_GridCurrentL2": "电网电流L2",
  "bw_RTparam_name_GridCurrentL3": "电网电流L3",
  "bw_RTparam_name_GridFrequency": "电网频率",
  "bw_RTparam_name_GridFrequencyINV": "逆变并网频率（并网）",
  "bw_RTparam_name_GridLoadPower": "电网负载功率",
  "bw_RTparam_name_GridPowerL1": "电网有功功率L1",
  "bw_RTparam_name_GridPowerL2": "电网有功功率L2",
  "bw_RTparam_name_GridPowerL3": "电网有功功率L3",
  "bw_RTparam_name_GridStatus": "电网状态",
  "bw_RTparam_name_GridTotalActivePower": "电网总功率（有功功率）",
  "bw_RTparam_name_GridVoltageL1": "电网电压L1",
  "bw_RTparam_name_GridVoltageL2": "电网电压L2",
  "bw_RTparam_name_GridVoltageL3": "电网电压L3",
  "bw_RTparam_name_InvActivePower": "逆变有功功率",
  "bw_RTparam_name_InvApparentPower": "逆变视在功率",
  "bw_RTparam_name_InvCurrentR": "逆变器L1相电流",
  "bw_RTparam_name_InvCurrentS": "逆变器L2相电流",
  "bw_RTparam_name_InvCurrentT": "逆变器L3相电流",
  "bw_RTparam_name_InverterInternalOperatingAmbientTemperature": "逆变器运行内部环温",
  "bw_RTparam_name_InverterMasterSoftwareVersion": "Master软件版本",
  "bw_RTparam_name_InvModuleTemperature": "INV模块温度",
  "bw_RTparam_name_InvPowerFactor": "逆变功率因数",
  "bw_RTparam_name_InvReactivePower": "逆变无功功率",
  "bw_RTparam_name_LANIP": "局域网IP",
  "bw_RTparam_name_Locationofthehighesttemperaturebatterycellinthesystem": "系统最高温度电芯位置",
  "bw_RTparam_name_Locationofthelowesttemperaturebatterycellinthesystem": "系统最低温度电芯位置",
  "bw_RTparam_name_Mac": "MAC地址",
  "bw_RTparam_name_Maximumcellvoltage": "最高电芯电压",
  "bw_RTparam_name_Maximumtemperatureofbattery": "电池最高温度",
  "bw_RTparam_name_Meter.CTSetting": "电表/CT",
  "bw_RTparam_name_MeterInstallationLocation": "电表安装位置",
  "bw_RTparam_name_MeterTypeandInstallationLocation": "电表类型及安装位置",
  "bw_RTparam_name_Minimumcellvoltage": "最低电芯电压",
  "bw_RTparam_name_Minimumtemperatureofbattery": "电池最低温度",
  "bw_RTparam_name_noCharging": "禁充禁放",
  "bw_RTparam_name_offline": "离线",
  "bw_RTparam_name_online": "在线",
  "bw_RTparam_name_OverDischargeSOC": "过放SOC",
  "bw_RTparam_name_PackIDofMaxCellTemperature": "系统最高电池模块温度编号",
  "bw_RTparam_name_PackIDofMaxCellVoltage": "系统最高电池模块电压编号",
  "bw_RTparam_name_PackIDofMinCellTemperature": "系统最低电池模块温度编号",
  "bw_RTparam_name_PackIDofMinCellVoltage": "系统最低电池模块电压编号",
  "bw_RTparam_name_PFOA_Grid": "电表A功率因数",
  "bw_RTparam_name_PFOB_Grid": "电表B功率因数",
  "bw_RTparam_name_PFOC_Grid": "电表C功率因数",
  "bw_RTparam_name_photovoltaics": "电网和光伏使用CT",
  "bw_RTparam_name_Positionofthehighestvoltagecellinthesystem": "系统最高电压电芯位置",
  "bw_RTparam_name_Positionofthelowestvoltagebatterycellinthesystem": "系统最低电压电芯位置",
  "bw_RTparam_name_Power-onTime": "本次上电工作",
  "bw_RTparam_name_PowerBoardTemperature": "功率板温度(散热片温度)",
  "bw_RTparam_name_PSSILevel": "信号强度等级",
  "bw_RTparam_name_PV1Current": "PV1实时电流",
  "bw_RTparam_name_PV1Power": "PV1实时功率",
  "bw_RTparam_name_PV1Voltage": "PV1实时电压",
  "bw_RTparam_name_PV2Current": "PV2实时电流",
  "bw_RTparam_name_PV2Power": "PV2实时功率",
  "bw_RTparam_name_PV2Voltage": "PV2实时电压",
  "bw_RTparam_name_PV3Current": "PV3实时电流",
  "bw_RTparam_name_PV3Power": "PV3实时功率",
  "bw_RTparam_name_PV3Voltage": "PV3实时电压",
  "bw_RTparam_name_PvBoostTemperature": "Boost模块温度",
  "bw_RTparam_name_PVConnectState": "设备运行状态",
  "bw_RTparam_name_PVMeterNegate": "光伏电表反接标志",
  "bw_RTparam_name_PV_ActivePowerOfAPhase": "电表A有功功率",
  "bw_RTparam_name_PV_ActivePowerOfBPhase": "电表B有功功率",
  "bw_RTparam_name_PV_ActivePowerOfCPhase": "电表C有功功率",
  "bw_RTparam_name_PV_ApparentPowerOfAPhase": "电表A视在功率",
  "bw_RTparam_name_PV_ApparentPowerOfBPhase": "电表B视在功率",
  "bw_RTparam_name_PV_ApparentPowerOfCPhase": "电表C视在功率",
  "bw_RTparam_name_PV_PowerFactorOfAPhase": "电表A功率因数",
  "bw_RTparam_name_PV_PowerFactorOfBPhase": "电表B功率因数",
  "bw_RTparam_name_PV_PowerFactorOfCPhase": "电表C功率因数",
  "bw_RTparam_name_PV_ReactivePowerOfAPhase": "电表A无功功率",
  "bw_RTparam_name_PV_ReactivePowerOfBPhase": "电表B无功功率",
  "bw_RTparam_name_PV_ReactivePowerOfCPhase": "电表C无功功率",
  "bw_RTparam_name_ReactivePOAP_Grid": "电表A无功功率",
  "bw_RTparam_name_ReactivePOBP_Grid": "电表B无功功率",
  "bw_RTparam_name_ReactivePOCP_Grid": "电表C无功功率",
  "bw_RTparam_name_RSSI": "信号强度",
  "bw_RTparam_name_sell": "卖电",
  "bw_RTparam_name_SSID": "SSID/Wifi 名称",
  "bw_RTparam_name_State": "通讯棒状态",
  "bw_RTparam_name_Systemmaximumtemperaturecellserialnumber": "系统最高温度电芯串号",
  "bw_RTparam_name_Systemmaximumvoltagecellserialnumber": "系统最高电压电芯串号",
  "bw_RTparam_name_Systemminimumtemperaturecellserialnumber": "系统最低温度电芯串号",
  "bw_RTparam_name_Systemminimumvoltagecellserialnumber": "系统最低电压电芯串号",
  "bw_RTparam_name_TheSystemTotalPVEnergy": "设备总发电量(含光伏电表数据)",
  "bw_RTparam_name_TodayConsumption": "当日用电量",
  "bw_RTparam_name_TodayGridLoadConsumption": "当日电网负载用电量",
  "bw_RTparam_name_TodayYield": "今日发电量",
  "bw_RTparam_name_TotalActivePower_PV": "电表有功功率（总）",
  "bw_RTparam_name_TotalApparent Power_Grid": "电表视在功率（总）",
  "bw_RTparam_name_TotalApparentPower_PV": "电表视在功率（总）",
  "bw_RTparam_name_TotalConsumption": "累计充电量",
  "bw_RTparam_name_TotalConsumptionEnergy": "累计用电量",
  "bw_RTparam_name_TotalConsumptionPower": "用电总功率",
  "bw_RTparam_name_TotalDevicePower": "总功率",
  "bw_RTparam_name_TotalEnergyConsumeFormGrid_PV": "取电能量",
  "bw_RTparam_name_TotalEnergyFeedToGrid_PV": "馈网能量",
  "bw_RTparam_name_TotalEnergyfromBattery": "累计放电量",
  "bw_RTparam_name_TotalEnergyfromGrid": "累计买电量",
  "bw_RTparam_name_TotalEnergyInvInput": "逆变器总输入电量",
  "bw_RTparam_name_TotalEnergyInvOutput": "逆变器总输出电量",
  "bw_RTparam_name_TotalEnergytoGrid": "累计卖电量",
  "bw_RTparam_name_TotalGridLoadConsumption": "累计电网负载用电量",
  "bw_RTparam_name_TotalOperationTime": "累计工作时间",
  "bw_RTparam_name_TotalPower": "总功率",
  "bw_RTparam_name_TotalPowerFactor_Grid": "电表功率因数（总）",
  "bw_RTparam_name_TotalPowerFactor_PV": "电表功率因数（总）",
  "bw_RTparam_name_TotalPowerFactor_PV1": "电表功率因数（总）1",
  "bw_RTparam_name_TotalPVEnergy_includePVMeter": "累计总发电量（内部+外部）",
  "bw_RTparam_name_TotalReactivePower_Grid": "电表无功功率（总）",
  "bw_RTparam_name_TotalReactivePower_PV": "电表无功功率（总）",
  "bw_RTparam_name_TotalRuntime": "PV的总时长",
  "bw_RTparam_name_TotalYield": "累计发电量",
  "bw_RTparam_name_UPSReserveSoc": "SOC下限值（并网情况）",
  "bw_RTparam_name_vatBmsVersion": "电池包版本号",
  "bw_RTparam_name_VoltageOfAPhase_PV": "电表A相电压",
  "bw_RTparam_name_VoltageOfBPhase_PV": "电表B相电压",
  "bw_RTparam_name_VoltageOfCPhase_PV": "电表C相电压",
  "bw_RTparam_name_WiFiType": "联网类型",
  "org.keyFilter": "输入关键字过滤",
  "language.zoneTip": "本时间为东八区时间",
  "shipment.confirmDownload": "清单下载",
  "shipment.updateCustomer": "更新出货客户",
  "shipment.invalidEquipmentList": "是否下载校验不通过的设备清单(10分钟内有效)? 校验不通过的设备数量:",
  "shipment.fileExpired": "文件已过期",
  "common.maintain": "请先维护",
  "workorder.searchCreateTime": "发起时间",
  "workorder.statusAll": "全部工单",
  "workorder.statusPending": "待处理",
  "workorder.statusCompleted": "已完成",
  "workorder.statusClosed": "已关闭",
  "workorder.no": "工单号",
  "workorder.tableDescription": "工单描述",
  "workorder.plant": "电站",
  "workorder.device": "设备",
  "workorder.tableStatus": "状态",
  "workorder.owner": "负责人",
  "workorder.handler": "处理人",
  "workorder.handledTime": "处理时间",
  "workorder.creator": "创建人",
  "workorder.createTime": "创建时间",
  "workorder.timeTooltip": "电站所在时区的时间",
  "workorder.tableAction": "操作",
  "workorder.actionDetails": "详情",
  "workorder.actionHandle": "处理",
  "workorder.actionCancel": "关闭",
  "workorder.createTitle": "创建工单",
  "workorder.description": "故障描述",
  "workorder.images": "故障图片",
  "workorder.handleTitle": "处理工单",
  "workorder.group": "处理信息",
  "workorder.feedback": "处理反馈",
  "workorder.handleimages": "处理图片",
  "workorder.detailsTitle": "工单详情",
  "workorder.detailsGroup": "工单信息",
  "workorder.uploadSuccess": "上传成功",
  "workorder.uploadNums": "最多只能上传3张图片",
  "workorder.uploadFormatTip": "文件格式不正确，请上传JPG、JPEG或PNG格式的文件",
  "workorder.uploadFormat": "请上传大小不超过5MB格式为 png/jpg/jpeg 的文件",
  "workorder.uploadImage": "上传图片",
  "workorder.cancelTip": "工单取消后，该工单将自动关闭，是否继续?",
  "workorder.basicInformation": "基本信息",
  "common.cropper": "图片裁剪",
  "common.confirmCropper": "确认裁剪",
  "common.networkUnstable": "网络连接已断开，请检查您的网络设置",
  "common.networkFull": "网络又和阳光一样满格了",
  "common.networkSlow": "当前网络较慢，请耐心等待或检查网络设置",
  "common.requestTimeout": "请求超时，请检查网络或稍后重试",
  "screen.platform": "能源管理平台",
  "plantScreen.title": "电站管理",
  "plantScreen.DailyElectricityGenerated": "当日发电量",
  "plantScreen.DailyElectricityUsed": "当日用电量",
  "plantScreen.DailyElectricityPurchased": "当日买电量",
  "plantScreen.DailyElectricitySold": "当日卖电量",
  "plantScreen.ChargingStatus": "充电状态",
  "plantScreen.BatteryLevel": "电池电量",
  "plantScreen.PhotovoltaicStatus": "光伏状态",
  "plantScreen.GridStatus": "电网状态",
  "plantScreen.Charging": "充电中",
  "plantScreen.Discharging": "放电中",
  "plantScreen.Generating": "发电中",
  "plantScreen.Idle": "不充不放",
  "plantScreen.pvIDLE": "不发电",
  "plantScreen.BuyingElectricity": "买电",
  "plantScreen.SellingElectricity": "卖电",
  "plantScreen.netdead": "离网",
  "plantScreen.day": "日",
  "plantScreen.month": "月",
  "plantScreen.year": "年",
  "plantScreen.life": "累计",
  "plantScreen.BatterySOC": "储能电池SOC",
  "plantScreen.PowerAnalysis": "功率分析",
  "plantScreen.EquivalentRevenue": "等效收益",
  "plantScreen.EnergyAnalysis": "能量分析",
  "plantScreen.SocialContribution": "社会贡献",
  "plantScreen.Photovoltaic": "光伏",
  "plantScreen.Grid": "电网",
  "plantScreen.Battery": "电池",
  "plantScreen.Load": "负载",
  "plantScreen.Daily": "当日",
  "plantScreen.Monthly": "当月",
  "plantScreen.Yearly": "当年",
  "plantScreen.Cumulative": "累计",
  "plantScreen.Unit": "单位",
  "plantScreen.ElectricityGeneration": "发电量",
  "plantScreen.ElectricityConsumption": "用电量",
  "plantScreen.ChartSet.explain": "说明：功率大于 0，表示电池放电；功率小于0，表示电池充电",
  "plantScreen.ChartSet.Self-consumption": "自发自用",
  "plantScreen.ChartSet.GridElectricity": "上网电量",
  "plantScreen.ChartSet.Self-Sufficiency": "自给自足",
  "plantScreen.ChartSet.PurchasedElectricity": "购买电量",
  "plantScreen.ChartSet.PVPower": "光伏发电功率",
  "plantScreen.ChartSet.ConsumptionPower": "用电功率",
  "plantScreen.ChartSet.BatterySOC": "储能电池SOC",
  "plantScreen.ChartSet.BatteryChargingPower": "储能充电功率",
  "plantScreen.ChartSet.BatteryDischargingPower": "储能放电功率",
  "plantScreen.ProtectedForest": "保护森林",
  "plantScreen.CO2Emission": "二氧化碳",
  "plantScreen.Media": "媒",
  "plantScreen.coal": "煤",
  "plant.EquivalentBenefit.GridView": "等效收益 = 自发自用 * 买电价 + 电网卖电 * 卖电价",
  "plant.MonitoringScreen": "监控大屏",
  "plantScreen.ChartSet.explainPower": "说明：电网功率大于 0，表示卖电；功率小于0，表示卖电",
  "device.operationgDataInfoTip": "说明：若此项为空，请联系IOT平台管理员配置",
  "alarmInfo.time": "告警时间",
  "alarmInfo.duration": "告警持续时长",
  "alarmInfo.level": "告警级别",
  "alarmInfo.triggerCondition": "触发条件",
  "alarmInfo.reason": "告警原因",
  "alarmInfo.exceptionDesc": "异常描述",
  "alarmInfo.suggestion": "处理建议",
  "alarmInfo.handleTime": "处理时间",
  "alarmInfo.handleType": "处理类型",
  "device.realTimeMonitoring": "实时监控",
  "device.propertyName": "属性名称",
  "device.issueCommand": "下发",
  "device.history": "历史",
  "device.properName": "名称",
  "device.daterange": "自定义",
  "device.near24h": "近24时",
  "device.date": "今日",
  "device.near3d": "近3天",
  "device.chartModule": "图表模块",
  "device.lineChart": "曲线图",
  "device.barChart": "柱状图",
  "device.dateRangeDayError": "日期范围应在{scope}天内",
  "device.SOCHistoryData": "历史数据",
  "device.paramSave": "参数下发",
  "common.deleteTip": "确认删除{scope}?",
  "plant.plantCategory": "电站类型",
  "plant.plantCode": "电站编码",
  "plant.energyStorageCapacity": "储能容量",
  "plant.energyStoragePower": "储能功率",
  "plant.gridConnectionMode": "上网方式",
  "plant.img": "电站图片",
  "upgrade.upgradeSN": "升级SN",
  "upgrade.devicesSN": "设备SN",
  "upgrade.datalogSN": "数据日志SN",
  "upgrade.upgradeType": "升级类型",
  "upgrade.fileAddress": "文件地址",
  "upgrade.plantTime": "电站时间",
  "upgrade.timeUTC8": "时间(UTC+8)",
  "upgrade.timeServer": "时间(server)",
  "upgrade.content": "内容",
  "upgrade.account": "账号",
  "firmware.secretType": "秘钥类型",
  "plant.statisticalCycle": "统计周期",
  "priceConfig.currentEffectivePrice": "当前生效电价",
  "priceConfig.currencyUnitLabel": "货币单位:",
  "priceConfig.addPrice": "新增电价",
  "priceConfig.effectiveTimeLabel": "生效时间",
  "priceConfig.powerPrice": "电量电价",
  "priceConfig.additionalFees": "额外费用",
  "priceConfig.lastUpdateTime": "最后修改时间",
  "priceConfig.lastUpdateTimeLabel": "最后修改时间",
  "priceConfig.emptyCurrent": "当前无生效电价，请点击按钮进行配置",
  "priceConfig.emptyUpcoming": "暂无即将生效电价",
  "priceConfig.upcomingTitle": "即将生效电价",
  "priceConfig.copyPriceTitle": "复制电价",
  "priceConfig.deletePriceTitle": "删除电价",
  "priceConfig.deleteConfirmText": "请确认删除以下电价",
  "priceConfig.otherPrice": "其他电价",
  "priceConfig.deleteWarning": "若当前电价正在生效则影响收益计算以及 AI 策略执行",
  "priceConfig.priceTypeLabel": "电价类型",
  "priceConfig.timeOfUse": "分时",
  "priceConfig.dynamic": "动态",
  "priceConfig.timeOfUsePrice": "分时电价",
  "priceConfig.dynamicPrice": "动态电价",
  "priceConfig.effectiveDatePlaceholder": "请选择生效日期",
  "priceConfig.copyEffectiveDatePlaceholder": "请选择生效日期",
  "priceConfig.nextStep": "下一步",
  "priceConfig.buyPriceTitle": "购买电价",
  "priceConfig.feedInPriceTitle": "上网电价",
  "priceConfig.addTimePeriod": "添加时段",
  "priceConfig.electricitySurchargeTitle": "电量附加费",
  "priceConfig.electricitySurchargeTooltip": "每购买一度电，需要额外支付的其他费用",
  "priceConfig.fixedFeeTitle": "固定费",
  "priceConfig.fixedFeeTooltip": "合同里约定账单期的基本电费是固定金额，不随用电容量或需量变化。",
  "priceConfig.hasFeeYes": "有",
  "priceConfig.countryLabel": "国家",
  "priceConfig.secondaryRegionLabel": "二级区域",
  "priceConfig.secondaryRegionPlaceholder": "请选择二级区域",
  "priceConfig.currencyUnitPlaceholder": "请选择货币单位",
  "priceConfig.powerMarketLabel": "电力市场",
  "priceConfig.powerMarketPlaceholder": "请选择电力市场",
  "priceConfig.electricitySurchargePlaceholder": "最多 7 位整数，8 位小数，且 ≥ 0",
  "priceConfig.fixedFeePlaceholder": "最多 7 位整数，8 位小数，且 ≥ 0",
  "priceConfig.priceInputPlaceholder": "请输入电价（最多 7 位整数，8 位小数，且 ≥ 0）",
  "priceConfig.timePlaceholder": "选择时间",
  "priceConfig.selectEffectiveTimeTip": "请选择生效时间",
  "priceConfig.selectPriceTypeTip": "请选择电价类型",
  "priceConfig.selectCountryTip": "请选择国家",
  "priceConfig.selectSecondaryRegionTip": "请选择二级区域",
  "priceConfig.selectCurrencyUnitTip": "请选择货币单位",
  "priceConfig.selectPowerMarketTip": "请选择电力市场",
  "priceConfig.electricitySurchargeInputTip": "请填写电量附加费（最多 7 位整数，8 位小数，且 ≥ 0）",
  "priceConfig.electricitySurchargeRangeTip": "电量附加费须为最多 7 位整数、8 位小数且 ≥ 0",
  "priceConfig.fixedFeeInputTip": "请填写固定费（最多 7 位整数，8 位小数，且 ≥ 0）",
  "priceConfig.fixedFeeRangeTip": "固定费须为最多 7 位整数、8 位小数且 ≥ 0",
  "priceConfig.buyTimeFullDayTip": "购买电价时间段必须填满 24 小时",
  "priceConfig.feedInTimeFullDayTip": "上网电价时间段必须填满 24 小时",
  "priceConfig.buyTimeNoOverlapTip": "购买电价时间段不能重叠",
  "priceConfig.feedInTimeNoOverlapTip": "上网电价时间段不能重叠",
  "priceConfig.loadFail": "获取电价数据失败",
  "priceConfig.copySelectPriceTip": "未选择电价信息，无法复制",
  "priceConfig.copyMissingPlantTip": "缺少电站信息，无法复制电价",
  "priceConfig.copySuccess": "复制成功",
  "priceConfig.copyFail": "复制失败",
  "priceConfig.networkTimeout": "网络超时，请在网络恢复后重试",
  "priceConfig.copyUnsupportedTip": "暂不支持复制该类型电价",
  "priceConfig.deleteSelectPriceTip": "未选择电价",
  "priceConfig.deleteIdMissingTip": "无法获取电价 id，删除失败",
  "priceConfig.deleteSuccess": "删除成功",
  "priceConfig.deleteFail": "删除失败",
  "priceConfig.missingPlantInfoTip": "缺少电站信息",
  "priceConfig.confirmGiveUpCreateTip": "确定放弃本次电价新增吗？",
  "priceConfig.confirmGiveUpEditTip": "确定放弃本次电价编辑吗？",
  "priceConfig.pageTitleAdd": "新增电价",
  "priceConfig.pageTitleEdit": "编辑电价",
  "priceConfig.pageTitleView": "查看电价",
  "priceConfig.createSuccess": "创建成功",
  "priceConfig.editSuccess": "编辑成功",
  "priceConfig.saveFail": "保存失败",
  "priceConfig.dateRangePermanent": "{start} 至永久",
  "priceConfig.dateRange": "{start} 至 {end}",
  "priceConfig.routeTitle": "电价配置",
  "priceConfig.priceLabel": "电价",
  "priceConfig.surchargeLabel": "附加费",
  "priceConfig.fixedFeeLabel": "固定费",
  "button.copy": "复制",
  "common.view": "查看",
  "plant.electrovalence": "电价配置",
  "plant.energy_management": "能量管理",
  "plant.energy_todayStrategy": "今日策略",
  "plant.energy_PeakShavingAndValleyFilling": "削峰填谷",
  "plant.energy_ValidTime": "有效时间",
  "plant.energy_Charging": "充电",
  "plant.energy_Discharging": "放电",
  "plant.energy_SelectStartTime": "选择开始时间",
  "plant.energy_StrategyName": "策略名称",
  "plant.energy_StrategyType": "策略类型",
  "plant.energy_Status": "状态",
  "plant.energy_No": "序号",
  "plant.energy_StartDate": "开始日期",
  "plant.energy_EndDate": "结束日期",
  "plant.energy_AddStrategy": "新增策略",
  "plant.energy_EffectiveTime": "生效时间",
  "plant.energy_SelectStrategy": "选择策略",
  "plant.energy_SelectCorrespondingStrategy": "选择相应策略",
  "plant.energy_ConfirmAndDeploy": "确认并下发",
  "plant.energy_PleaseConfirmSaveAndDeployTheStrategy": "请确认策略，保存并下发",
  "plant.energy_Cancel": "取消",
  "plant.energy_PleaseConfirmStrategyDeletion": "请确认策略删除",
  "plant.energy_IfNoOtherStrategyExistsExecuteManualStrategy": "若无其他策略，则执行手动策略",
  "plant.energy_PriorityChargingTime": "优先充电时间",
  "plant.energy_PriorityDischargingTime": "优先放电时间",
  "plant.energy_PVConsumptionPeriod": "光伏消纳时间",
  "plant.energy_StartTime": "开始时间",
  "plant.energy_EndTime": "结束时间",
  "plant.energy_ChargingPower": "充电功率",
  "plant.energy_DischargingPower": "放电功率",
  "plant.energy_SOCUpperLimit": "SOC上限",
  "plant.energy_SOCLowerLimit": "SOC下限",
  "plant.energy_Action": "操作",
  "plant.energy_AddTimePeriod": "添加时段",
  "plant.energy_ChargingStatus": "充电状态",
  "plant.energy_DischargingPower_kW": "放电功率（kW）",
  "plant.energy_copyStrategy": "复制策略",
  "plant.energy_examine": "查看",
  "plant.energy_delete": "删除",
  "plant.energy_edit": "编辑",
  "plant.energy_basicInfo": "基本信息",
  "common.ConfirmDeploy": "确认下发",
  "plant.energy_PriorityChargingDischargingTime": "优先充放电时间",
  "plant.energy_PeakShavingAtLeastOne": "至少保留一条数据",
  "common.formInvalid": "缺少必填项",
  "plant.energy_overlapTime": "请勿交叉时间段",
  "plant.energy_cover24hour": "时间段必须包含24小时",
  "plant.energy_PleaseConfirmStrategyModification": "请确认策略修改",
  "plant.energy_Strategy": "策略",
  "plant.energy_cutOff_SOC": "截止SOC",
  "plant.energy_CopyStrategy": "复制策略",
  "plant.energy_EditStrategy": "编辑策略",
  "plant.energy_ExamineStrategy": "查看策略",
  "plant.energy_photovoltaic_storage_peak_valley_explain1": "1）优先充电时段：利用光伏余电和（谷时）市电对储能进行充电，保障充电达到设置的SOC值；储能不放电。",
  "plant.energy_photovoltaic_storage_peak_valley_explain2": "2）优先放电时段：光伏余电对储能充电；光伏不足时，储能优先放电，最低放电至设置的SOC值；其次电网供电。",
  "plant.energy_photovoltaic_storage_peak_valley_explain3": "3）光伏消纳时段：光伏绿电优先供负荷使用，其次储能消纳（至SOC最高限值），再次余电限制或上网；光伏不足时，优先储能放电（至SOC最低限值），其次电网供电。",
  "plant.energy_photovoltaic_storage_peak_valley_explain4": "4）其他时段：光伏绿电优先供负荷使用，其次储能消纳（至SOC最高限值），再次余电限制或上网；储能不放电",
  "plant.energy_peak_shaving_valley_filling_explain": "分时操作储能充放降低高峰期负荷、填补低谷期需求，以实现资源平稳利用的策略。",
  "plant.energy_photovoltaic_consumption_self_consumption_explain": "光伏绿电优先供负荷使用，其次储能消纳，再次限制光伏，保障不逆流；光伏不足时，优先储能放电，其次电网供电；",
  "plant.energy_photovoltaic_consumptionsurplus_power_grid_feed_in_explain": "光伏绿电优先供负荷使用，其次储能消纳，再次余电上网；光伏不足时，优先储能放电，其次电网供电；",
  "plant.energy_smart_strategy_station_profit_priority_explain": "提综合分时电价、光伏消纳、峰谷套利、光伏和负荷预测、需量管理等多维目标，在保证微电网稳定运行前提下，由AI机器人智能计算求解对储能及可调负荷进行调度管理，从而实现整个场站收益最大化。",
  "plant.energy_manual_mode_explain": "当前光伏、储能无调度策略，请去设备页面手动操作",
  "plant.energy_SOCUpperLowerLimits": "SOC上下限",
  "plant.energy_ChargeDischargePower": "充放电功率",
  "plant.energy_ChargeDischargeStatus": "充放电状态",
  "plant.stationTopology": "电站拓扑",
  "plant.topologyConfig": "拓扑配置",
  "plant.projectName": "项目名称",
  "plant.topologyUrl": "拓扑地址",
  "plant.topologyMap": "拓扑图",
  "plant.topologyPlaceholder": "请输入拓扑地址",
  "plant.addScopeSuccess": "新增{scope}成功",
  "plant.updateScopeSuccess": "编辑{scope}成功",
  "plant.topologyUrlFormatError": "拓扑地址格式错误",
  "cookie.necessary": "严格必要Cookie",
  "cookie.performance": "性能Cookie",
  "cookie.functional": "功能型Cookie",
  "cookie.targeting": "定向Cookie",
  "cookie.necessaryExplain": "此类Cookie是网站正常运行所必需的，无法在我们的系统中关闭。它们通常仅在用户执行特定服务请求操作时设置，例如设置隐私偏好、登录或填写表单。用户可通过浏览器设置阻止或提醒此类Cookie，但网站部分功能可能因此无法正常使用。此类Cookie不存储任何可识别个人身份的信息。",
  "cookie.performanceExplain": "此类Cookie用于统计访问量及流量来源，帮助我们评估并优化网站性能。它们能帮助我们了解哪些页面最受欢迎、哪些页面访问量最低，以及访客在网站内的浏览路径。此类 Cookie 收集的所有信息均经过聚合处理，因此具有匿名性。若用户拒绝此类 Cookie，我们将无法知晓用户的访问记录，也无法监控网站性能。",
  "cookie.functionalExplain": "此类Cookie能为网站提供增强功能及个性化服务，可由我们或添加至网站页面的第三方服务提供商设置。若用户拒绝此类 Cookie，部分或全部相关服务可能无法正常使用。",
  "cookie.targetingExplain": "此类Cookie可由我们的广告合作伙伴通过本网站设置，相关公司可利用其构建用户兴趣画像，并在其他网站向用户推送相关广告。它们不直接存储个人信息，而是基于浏览器及互联网设备的唯一标识。若用户拒绝此类 Cookie，将减少接收定向广告的数量。",
  "cookie.necessaryAccount": "身份证验证",
  "cookie.necessaryAccountExplain": "用于维持用户登录状态，是网站身份验证及会话管理的核心功能，缺少该Cookie可能导致用户访问页面无法显示账户信息",
  "cookie.sessionManagement": "会话管理",
  "cookie.sessionManagementExplain": "用于唯一标识用户会话，维持用户登录状态、购物车内容、表单数据等关键功能",
  "cookie.userInfo": "用户信息",
  "cookie.userInfoExplain": "用于统计页面浏览量(PV)、独立访客数(UV)等业务指标，分析系统流量及用户参与度，以优化功能优先级及核心需求匹配度",
  "cookie.deviceInfo": "设备信息",
  "cookie.deviceInfoExplain": "根据不同操作系统、设备型号及浏览器类型，解决各终端的布局及兼容性问题，优化不同设备的适配功能",
  "cookie.pageInfo": "页面信息",
  "cookie.pageInfoExplain": "记录页面访问路径、API请求及资源加载时间，识别性能瓶颈、请求失败及代码错误，协助开发团队快速解决异常问题",
  "cookie.networkInfo": "网络信息",
  "cookie.networkInfoExplain": "分析地理位置及互联网服务提供商(ISP)网络(如中国电信、中国移动4G/5G),识别恶意访问及异常流量，优化云服务提供商的内容分发效率",
  "cookie.userPreference": "界面偏好",
  "cookie.userPreferenceExplain": "仅用于记录用户界面偏好，提升用户体验，并非网站运行必需的核心功能",
  "cookie.longTerm": "长期有效",
  "cookie.duration180": "180天",
  "cookie.durationSession": "会话期间",
  "cookie.bannerExplain": "为优化浏览体验，我们使用Cookie功能，主要用于记录登录状态、记忆你的偏好设置、适配你的浏览习惯等，点击'接受全部'表示你同意我们的Cookie政策",
  "cookie.acceptNecessary": "仅必要",
  "cookie.openPreferences": "设置偏好",
  "cookie.acceptAll": "接受全部",
  "cookie.cookieSet": "Cookie设置",
  "cookie.cookieSetExplain": "更多信息可以查看",
  "cookie.cookiePolicy": "《Cookie政策》",
  "cookie.cookieCategory": "Cookie类别",
  "cookie.cookieName": "Cookie名称",
  "cookie.cookieDescription": "用途",
  "cookie.cookieDuration": "有效期",
  "cookie.cookieSwitch": "开关",
  "cookie.savePreferences": "保存偏好",
  "cookie.preferencesTitle": "Cookie偏好设置",
  "cookie.cookiePolicyText": "Cookie政策",
  "plant.settlementMeter": "结算电表",
  "plant.settlementSuccess": "{scope}调整成功",
  "plant.energyBalanceTip": "自发自用\n光伏发电被负载使用和给储能充电的电量（包括直流到交流转换效率损失和设备自身运行消耗）。\n上网电量\n统计周期内光伏电站馈入电网的电量。\n自给自足\n负载使用的来自光伏发电量和储能放电的电量。\n购买电量\n统计周期内从电网购买的电量。",
  "common.currentVersion": "当前版本",
  "common.versionUpdateNotice": "系统版本更新通知",
  "common.later": "稍后再说",
  "common.immediateUpdate": "立即更新",
  "device.defaultParams": "默认参数",
  "device.nonIOTDeviceTip": "非IOT设备，请检查",
  "device.advancedFeatures": "高级功能",
  "device.toSettings": "去设置",
  "device.dryNodeSettings": "干节点设置",
  "device.dryNodeSettingsTip": "逆变器集成的干接点可以被设置成多种功能。",
  "device.workModeSettingsTip": "配置设备的工作模式和参数。",
  "system.physicalModels": "物模型管理",
  "subtitle.physicalModelsDetail": "物模型详情",
  "physicalModels.functionSet": "功能集",
  "physicalModels.minItemsTip": "至少需要保留{scope}项",
  "physicalModels.maxItemsTip": "最多允许{scope}项",
  "physicalModels.Empty": "{scope}不能为空",
  "physicalModels.conflictTip": "冲突时段：{scope}",
  "physicalModels.name": "配置名称",
  "physicalModels.jsonCorrect": "JSON格式正确",
  "physicalModels.jsonCorrectTip": "JSON格式正确（未连接校验服务）",
  "physicalModels.jsonInCorrect": "JSON格式错误",
  "physicalModels.jsonComplete": "JSON补全",
  "physicalModels.jsonCompleteTip": "若JSON保存过，重新补全可能导致生产问题，请谨慎操作。",
  "physicalModels.actualDataData": "实际下发数据",
  "physicalModels.deleteFailed": "删除失败",
  "physicalModels.loadPreviewFailed": "加载预览配置失败",
  "physicalModels.configEditor": "配置编辑器",
  "physicalModels.selectTemplate": "选择预置模板",
  "physicalModels.jsonConfig": "JSON配置",
  "physicalModels.realTimePreview": "实时预览",
  "physicalModels.checkJsonFormat": "请检查 JSON 格式是否正确",
  "physicalModels.readDataStructure": "读取数据结构",
  "physicalModels.userBehaviorData": "用户行为原始数据",
  "physicalModels.ready": "就绪",
  "physicalModels.previewConfigLoaded": "已加载预览配置",
  "physicalModels.pasteFromClipboard": "已从剪贴板粘贴",
  "physicalModels.pasteFromClipboardTip": "请先在浏览器路径后拼接设备SN，例如：",
  "physicalModels.error": "错误",
  "physicalModels.missingIoTIdTip": "缺少IoTId或virtualId，请检查",
  "physicalModels.slotId": "广告标识",
  "physicalModels.moduleDisplay": "模块显示配置",
  "physicalModels.moduleLable": "模块标签",
  "physicalModels.display": "显示状态",
  "physicalModels.createIndex": "创建索引",
  "plant.deviceCount": "已安装设备量",
  "common.rangeErrorTip": "{scope}范围有误，请确认",
  "sidebar.policyConfig": "政策配置",
  "common.addScope": "新增{scope}",
  "editor.header.title": "标题",
  "editor.header.text": "正文",
  "editor.fontSize.title": "字号",
  "editor.fontSize.default": "默认字号",
  "editor.fontFamily.title": "字体",
  "editor.fontFamily.default": "默认字体",
  "editor.bold": "粗体",
  "editor.italic": "斜体",
  "editor.underline": "下划线",
  "editor.through": "删除线",
  "editor.code": "行内代码",
  "editor.sub": "下标",
  "editor.sup": "上标",
  "editor.clearStyle": "清除格式",
  "editor.color.color": "文字颜色",
  "editor.color.bgColor": "背景色",
  "editor.color.default": "默认颜色",
  "editor.color.clear": "清除颜色",
  "editor.bulletedList": "无序列表",
  "editor.numberedList": "有序列表",
  "editor.todo": "待办列表",
  "editor.todo.title": "待办",
  "editor.emotion.title": "表情",
  "editor.justifyLeft": "左对齐",
  "editor.justifyRight": "右对齐",
  "editor.justifyCenter": "居中对齐",
  "editor.justifyJustify": "两端对齐",
  "editor.indent": "增加缩进",
  "editor.delIndent": "减少缩进",
  "editor.indent.increase": "增加缩进",
  "editor.indent.decrease": "减少缩进",
  "editor.lineHeight.title": "行高",
  "editor.lineHeight.default": "默认行高",
  "editor.blockquote": "引用",
  "editor.link.insert": "插入链接",
  "editor.link.text": "链接文字",
  "editor.link.url": "链接地址",
  "editor.link.unLink": "取消链接",
  "editor.link.edit": "修改链接",
  "editor.link.view": "查看链接",
  "editor.image.netImage": "网络图片",
  "editor.image.delete": "删除图片",
  "editor.image.edit": "编辑图片",
  "editor.image.viewLink": "查看链接",
  "editor.image.src": "图片地址",
  "editor.image.desc": "图片描述",
  "editor.image.link": "图片链接",
  "editor.video.insert": "插入视频",
  "editor.video.delete": "删除视频",
  "editor.video.uploadVideo": "上传视频",
  "editor.video.insertVideo": "插入视频",
  "editor.video.videoSrc": "视频地址",
  "editor.video.videoSrcPlaceHolder": "请输入视频地址",
  "editor.video.videoPoster": "视频封面",
  "editor.video.videoPosterPlaceHolder": "请输入视频封面地址",
  "editor.video.ok": "确定",
  "editor.video.editSize": "修改尺寸",
  "editor.video.width": "宽度",
  "editor.video.height": "高度",
  "editor.table.header": "表格",
  "editor.table.insertTable": "插入表格",
  "editor.table.deleteTable": "删除表格",
  "editor.table.insertRow": "插入行",
  "editor.table.deleteRow": "删除行",
  "editor.table.insertCol": "插入列",
  "editor.table.deleteCol": "删除列",
  "editor.table.widthAuto": "宽度自适应",
  "editor.table.widthFixed": "宽度固定",
  "editor.codeBlock.title": "代码块",
  "editor.divider": "分割线",
  "editor.emotion": "表情",
  "editor.insertFormula": "插入公式",
  "editor.fullScreen": "全屏",
  "editor.undo": "撤销",
  "editor.redo": "重做",
  "editor.delete": "删除",
  "editor.enter": "回车",
  "editor.ok": "确定",
  "editor.cancel": "取消",
  "editor.uploadImgMaxSize": "图片最大",
  "editor.uploadImgMaxSizeErr": "图片大小超出限制",
  "editor.uploadImgMaxLength": "最多上传",
  "editor.uploadImgMaxLengthErr": "图片数量超出限制",
  "editor.uploadVideoMaxSize": "视频最大",
  "editor.uploadVideoMaxSizeErr": "视频大小超出限制",
  "editor.placeholder": "请输入内容...",
  "UserHome.plantFlow.load": "负载",
  "UserHome.plantFlow.grid": "电网",
  "UserHome.plantFlow.battery": "电池",
  "UserHome.plantFlow.pv": "光伏",
  "ota.don.upgrade": "通讯棒升级",
  "device.ota.tip.newversion": "当前版本是最新版本，无需任何更新。",
  "device.button.cancle": "返回",
  "common.title": "列展示设置",
  "common.fixedLeft": "固定在左侧",
  "common.fixedRight": "固定在右侧",
  "common.notFixed": "不固定",
  "common.unfix": "取消固定",
  "common.resetSuccess": "列设置重置成功",
  "plantScreen.singleSiteScree.PVPower": "光伏发电功率",
  "plantScreen.singleSiteScree.LoadPower": "负载功率",
  "plantScreen.singleSiteScree.SelfConsumptionRate": "自发自用率",
  "plantScreen.ChartSet.GenerationPower": "发电功率",
  "plantScreen.ChartSet.DayAheadForecast": "日前预测",
  "plantScreen.ChartSet.RealTimeForecast": "实时预测",
  "plantScreen.ChartSet.DayAheadScheduling": "日前调度",
  "plantScreen.ChartSet.RealTimeScheduling": "实时调度",
  "plantScreen.PlantInfo": "电站信息",
  "plantScreen.PhotovoltaicCapacity": "光伏装机量",
  "plantScreen.StorageCapacity": "储能容量",
  "plantScreen.EnergyDispatch": "能量调度",
  "plantScreen.SelfGenerationRate": "自发电率",
  "plantScreen.DailyStorageCharging": "当日充电量",
  "plantScreen.DailyStorageDischarging": "当日放电量",
  "plantScreen.DailyElectricitySold2": "当日卖电量",
  "plantScreen.ChartSet.Storage": "储能",
  "plantScreen.ChartSet.Solar": "光伏",
  "plantScreen.ChartSet.Load": "负荷",
  "plantScreen.singleSiteScree.GridImportPower": "购电功率",
  "plantScreen.singleSiteScree.GridExportPower": "上网功率",
  "plantScreen.singleSiteScree.ChargingPower": "充电功率",
  "plantScreen.singleSiteScree.DischargingPower": "放电功率",
  "plantScreen.ChartSet.ChargeDischargePower": "充放功率",
  "device.systemTime": "系统时间",
  "device.traceId": "链路追踪ID",
  "device.collectorSn": "采集器SN",
  "device.functionCode": "功能码",
  "device.encryptedStr": "加密报文",
  "device.decryptedStr": "解密报文",
  "device.dateRangeErrorScope": "日期范围应在{scope}天内",
  "common.noMore": "没有更多了",
  "solid.snake.test": "CCC",
  "plant.e-station": "零碳E站",
  "ADD": "新增",
  "DELETE": "删除",
  "EDIT": "编辑",
  "netherland.area": "荷兰",
  "cc": "q",
  "country.austria": "澳大利亚",
  "county.france": "法国",
  "test.code.update": "test.code.update",
  "epex.country.unit.netherland": "Netherlands",
  "epex.income.unit": "EUR",
  "plant.running.status.alarm": "告警",
  "nl.second.code": "NL",
  "50901.real_time.invRatedPower": "额定功率",
  "50901.real_time.dspVersionMainUVersion": "DSP版本(主U版本)",
  "50901.real_time.dspVersionAuxiliaryUVersion": "DSP版本(辅U版本)",
  "50901.real_time.afciVersion": "AFCI版本",
  "50901.real_time.workStatus": "运行状态",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria": "DRM状态（澳洲/德国/奥地利国家下使用）",
  "50901.real_time.masterSlave": "主机/从机",
  "50901.real_time.invRunningtime": "INV运行时长\n禾迈：机器正常运行的时间",
  "50901.real_time.pvPowerWholeSystem": "PV总功率（整个系统）",
  "50901.real_time.batteryPowerWholeSystem": "电池总功率（整个系统）",
  "50901.real_time.gridPowerWholeSystem": "电网总功率（整个系统）",
  "50901.real_time.loadPowerWholeSystem": "负载总功率（整个系统）",
  "50901.real_time.inverterTemp": "逆变器内部运行温度",
  "50901.real_time.inverterSideRadiatorTemperature": "逆变器侧散热器温度",
  "50901.real_time.mpptTemp": "光伏侧散热器温度",
  "50901.real_time.gridMeasurementOfRadiatorTemperature": "电网测散热器温度",
  "50901.real_time.internalFanSpeed1": "内测风扇转速1",
  "50901.real_time.internalFanSpeed2": "内测风扇转速2",
  "50901.real_time.internalFanSpeed3": "内测风扇转速3",
  "50901.real_time.externalFanSpeed1": "外侧风扇转速1",
  "50901.real_time.externalFanSpeed2": "外侧风扇转速2",
  "50901.real_time.externalFanSpeed3": "外侧风扇转速3",
  "50901.real_time.externalFanSpeed4": "外侧风扇转速4",
  "50901.real_time.pvPower": "PV总功率（整个系统）",
  "50901.real_time.pv1Power": "PV1功率",
  "50901.real_time.pv2Power": "PV2功率",
  "50901.real_time.pv3Power": "PV3功率",
  "50901.real_time.pv4Power": "PV4功率",
  "50901.real_time.pv1Voltage": "PV1电压",
  "50901.real_time.pv2Voltage": "PV2电压",
  "50901.real_time.pv3Voltage": "PV3电压",
  "50901.real_time.pv4Voltage": "PV4电压",
  "50901.real_time.pv1Current": "PV1电流",
  "50901.real_time.pv2Current": "PV2电流",
  "50901.real_time.pv3Current": "PV3电流",
  "50901.real_time.pv4Current": "PV4电流",
  "50901.real_time.pvToBatteryPower": "光伏流向电池的功率",
  "50901.real_time.pvToGridPower": "光伏流向电网的功率",
  "50901.real_time.pvToLoadPower": "光伏流向负载的功率",
  "50901.real_time.powerGeneration": "PV累计发电量",
  "50901.real_time.pvDailyYield": "PV日发电量",
  "50901.real_time.dailyPvToBatteryEnegry": "今日光伏流向电池的能量",
  "50901.real_time.dailyPvToGridEnegry": "今日光伏流向电网的能量",
  "50901.real_time.dailyPvToLoadEnegry": "今日光伏流向负载的能量",
  "50901.real_time.totalPvToBatteryEnegry": "累计-光伏流向电池的能量",
  "50901.real_time.totalPvToGridEnegry": "累计-光伏流向电网的能量",
  "50901.real_time.totalPvToLoadEnegry": "累计-光伏流向负载的能量",
  "50901.real_time.generatorPower": "发电机功率",
  "50901.real_time.generatorPowerA": "发电机A相功率",
  "50901.real_time.generatorPowerB": "发电机B相功率",
  "50901.real_time.generatorPowerC": "发电机C相功率",
  "50901.real_time.generatorVoltageA": "发电机A相电压",
  "50901.real_time.generatorVoltageB": "发电机B相电压",
  "50901.real_time.generatorVoltageC": "发电机C相电压",
  "50901.real_time.generatorCurrentA": "发电机A相电流",
  "50901.real_time.generatorCurrentB": "发电机B相电流",
  "50901.real_time.generatorCurrentC": "发电机C相电流",
  "50901.real_time.generatorTotalYield": "发电机累计发电量",
  "50901.real_time.generatorDailyYield": "发电机日发电量",
  "50901.real_time.pvMeterConnectionStatus": "光伏侧电表连接状态",
  "50901.real_time.pvMeterPower": "光伏侧电表功率",
  "50901.real_time.pvMeterPowerA": "光伏侧电表A相功率",
  "50901.real_time.pvMeterPowerB": "光伏侧电表B相功率",
  "50901.real_time.pvMeterPowerC": "光伏侧电表C相功率",
  "50901.real_time.pvMeterVoltageA": "光伏侧电表A相电压",
  "50901.real_time.pvMeterVoltageB": "光伏侧电表B相电压",
  "50901.real_time.pvMeterVoltageC": "光伏侧电表C相电压",
  "50901.real_time.pvMeterCurrentA": "光伏侧电表A相电流",
  "50901.real_time.pvMeterCurrentB": "光伏侧电表B相电流",
  "50901.real_time.pvMeterCurrentC": "光伏侧电表C相电流",
  "50901.real_time.pvMeterTotalYield": "外部逆变器累计发电量",
  "50901.real_time.pvMeterDailyYield": "外部逆变器日发电量",
  "50901.real_time.batteryConnectionStatus": "是否连接电池",
  "50901.real_time.batteryType_04": "电池类型",
  "50901.real_time.batteryModule": "电池型号",
  "50901.ctrl_dianchiguanli.batteryCapacity": "BMS容量",
  "50901.real_time.batteryWorkingStatus": "电池状态",
  "50901.real_time.batteryAlarm": "报警code",
  "50901.real_time.batterytotCap": "电池装机总容量",
  "50901.real_time.batteryPower": "电池功率（充电/放电）",
  "50901.real_time.batterySoc": "电池SOC",
  "50901.real_time.soh": "SOH",
  "50901.real_time.batteryVoltage": "电池电压",
  "50901.real_time.batteryCurrent": "电池电流",
  "50901.real_time.batteryToLoadPower": "电池流向负载的功率",
  "50901.real_time.batteryChargePower": "电池累计充电量",
  "50901.real_time.batteryDischargePower": "电池累计放电量",
  "50901.real_time.batteryDailyChargeEnergy": "电池日充电量",
  "50901.real_time.batteryDailyDischargeEnergy": "电池日放电量",
  "50901.real_time.dailyBatteryToLoadEnergy": "本日电池流向负载的能量",
  "50901.real_time.totalBatteryToLoadEnergy": "累计-电池流向负载的能量",
  "50901.real_time.bmsSoftwareVersion": "BMS版本-软件",
  "50901.real_time.MaxChargeCurrent": "最大充电电流",
  "50901.real_time.MaxDisChargeCurrent": "最大放电电流",
  "50901.real_time.packNum": "并联数量（电池Pack个数）",
  "50901.real_time.batteryModuleNum": "电池串数（模块单体电芯串数）",
  "50901.real_time.packSoc": "电池包SOC",
  "50901.real_time.packSoh": "电池包SOH",
  "50901.real_time.packPower": "电池包功率",
  "50901.real_time.packCurrent": "电池包电流",
  "50901.real_time.packVoltage": "电池包电压",
  "50901.real_time.numberOfChargingAndDischargingCyclesOfBatteryPack": "电池包充放电循环次数",
  "50901.ctrl_xitongjichupeizhi.materType": "电表类型",
  "50901.real_time.gridPower": "电网侧功率",
  "50901.real_time.gridTotalFrequency": "电网侧频率",
  "50901.real_time.gridPowerA": "电网侧A相功率",
  "50901.real_time.gridPowerB": "电网侧B相功率",
  "50901.real_time.gridPowerC": "电网侧C相功率",
  "50901.real_time.gridVoltageA": "电网侧A相电压",
  "50901.real_time.gridVoltageB": "电网侧B相电压",
  "50901.real_time.gridVoltageC": "电网侧C相电压",
  "50901.real_time.gridCurrentA": "电网侧A相电流",
  "50901.real_time.gridCurrentB": "电网侧B相电流",
  "50901.real_time.gridCurrentC": "电网侧C相电流",
  "50901.real_time.gridReactivePower": "电网侧无功功率",
  "50901.real_time.gridReactivePowerA": "电网侧A相无功功率",
  "50901.real_time.gridReactivePowerB": "电网侧B相无功功率",
  "50901.real_time.gridReactivePowerC": "电网侧C相无功功率",
  "50901.real_time.gridPowerFactor": "电网侧功率因数",
  "50901.real_time.gridPowerFactorA": "电网侧A相功率因数",
  "50901.real_time.gridPowerFactorB": "电网侧B相功率因数",
  "50901.real_time.gridPowerFactorC": "电网侧C相功率因数",
  "50901.real_time.inverCombinedActivePower": "逆变器交流侧输出功率",
  "50901.real_time.invAcFrequency": "逆变器交流侧输出频率",
  "50901.real_time.phaseAOfInverterActivePower": "逆变器交流侧A相功率",
  "50901.real_time.phaseBOfInverterActivePower": "逆变器交流侧B相功率",
  "50901.real_time.phaseCOfInverterActivePower": "逆变器交流侧C相功率",
  "50901.real_time.phaseAOfInverterSideVoltage": "逆变器交流侧A相电压",
  "50901.real_time.phaseBOfInverterSideVoltage": "逆变器交流侧B相电压",
  "50901.real_time.phaseCOfInverterSideVoltage": "逆变器交流侧C相电压",
  "50901.real_time.phaseAOfInverterSideCurrent": "逆变器交流侧A相电流",
  "50901.real_time.phaseBOfInverterSideCurrent": "逆变器交流侧B相电流",
  "50901.real_time.phaseCOfInverterSideCurrent": "逆变器交流侧C相电流",
  "50901.real_time.gridBuyPower": "累计买电量",
  "50901.real_time.gridSellPower": "累计卖电量",
  "50901.real_time.dailyImportEnergyFromGrid": "日买电量",
  "50901.real_time.dailyExportEnergyToGrid": "日卖电量",
  "50901.real_time.dailyGridToLoadEnergy": "本日电网流向负载的能量",
  "50901.real_time.totalGridToLoadEnergy": "累计-电网流向负载的能量",
  "50901.real_time.totalLoadEnergy": "负载累计用电量",
  "50901.real_time.loadEnergy": "负载日用电量",
  "50901.real_time.epsPower": "EPS侧功率",
  "50901.real_time.epsPowerA": "EPS侧A相功率",
  "50901.real_time.epsPowerB": "EPS侧B相功率",
  "50901.real_time.epsPowerC": "EPS侧C相功率",
  "50901.real_time.epsVoltageA": "EPS侧A相电压",
  "50901.real_time.epsVoltageB": "EPS侧B相电压",
  "50901.real_time.epsVoltageC": "EPS侧C相电压",
  "50901.real_time.epsCurrentA": "EPS侧A相电流",
  "50901.real_time.epsCurrentB": "EPS侧B相电流",
  "50901.real_time.epsCurrentC": "EPS侧C相电流",
  "50901.real_time.ssid": "SSID(wifi名称)",
  "50901.real_time.rssi": "信号强度",
  "50901.real_time.macAddr": "MAC地址",
  "50901.real_time.maxCellTemperature": "最高单体温度",
  "50901.real_time.minCellTemperature": "最低单体温度",
  "50901.real_time.maxCellTemperatureCellId": "最高单体温度对应序号",
  "50901.real_time.minCellTemperatureCellId": "最低单体温度对应序号",
  "50901.real_time.maxCellVoltage": "最高单体电压",
  "50901.real_time.minCellVoltage": "最低单体电压",
  "50901.real_time.maxCellVoltageCellId": "最高单体电压对应序号",
  "50901.real_time.minCellVoltageCellId": "最低单体电压对应序号",
  "50901.real_time.maxCellSoc": "最高单体SOC",
  "50901.real_time.minCellSoc": "最低单体SOC",
  "50901.real_time.maxCellSocCellId": "最高单体SOC对应序号",
  "50901.real_time.minCellSocCellId": "最低单体SOC对应序号",
  "50901.real_time.pv1RealTimePower": "PV1实时功率",
  "50901.real_time.pv2RealTimePower": "PV2实时功率",
  "50901.real_time.pv3RealTimePower": "PV3实时功率",
  "50901.real_time.pv4RealTimePower": "PV4实时功率",
  "50901.real_time.meterFlag": "电表标志位",
  "50901.real_time.inverterSn": "逆变器SN",
  "50901.real_time.inverterModelNumber": "逆变器机型编号",
  "50901.real_time.inverterHardwareVersion": "逆变器硬件版本",
  "50901.real_time.communicationStickSn": "通讯棒SN",
  "50901.real_time.communicationStickHardwareVersion": "通讯棒硬件版本",
  "50901.real_time.communicationStickSoftwareVersion": "通讯棒软件版本",
  "50901.real_time.meterFrequency": "电表频率",
  "50901.real_time.meterPhaseAActivePower": "电表A有功功率",
  "50901.real_time.meterPhaseBActivePower": "电表B有功功率",
  "50901.real_time.meterPhaseCActivePower": "电表C有功功率",
  "50901.real_time.meterPhaseAReactivePower": "电表A无功功率",
  "50901.real_time.meterPhaseBReactivePower": "电表B无功功率",
  "50901.real_time.meterPhaseCReactivePower": "电表C无功功率",
  "50901.real_time.meterPhaseAPowerFactor": "电表A功率因数",
  "50901.real_time.meterPhaseBPowerFactor": "电表B功率因数",
  "50901.real_time.meterPhaseCPowerFactor": "电表C功率因数",
  "50901.real_time.gatewayCommunicationAddress": "网关通信地址",
  "50901.real_time.boardAmbientTemperatureThreshold": "电路板环境温度阈值",
  "50901.real_time.ambientTemperatureThreshold": "环境温度阈值",
  "50901.real_time.essAccessPoint": "ess接入点",
  "50901.real_time.pvConnectionStatus": "光伏连接状态",
  "50901.real_time.generatorConnectionStatus": "发电机连接状态",
  "50901.real_time.serviceEntranceBreakerCurrent": "服务入口断路器电流",
  "50901.real_time.appSoftwareVersion": "APP软件版本",
  "50901.real_time.firmwareStartAddressHigh": "固件起始地址(高）",
  "50901.real_time.firmwareStartAddressLow": "固件起始地址(低)",
  "50901.real_time.firmwareEndAddressHigh": "固件结束地址(高)",
  "50901.real_time.firmwareEndAddressLow": "固件结束地址(低)",
  "50901.real_time.firmwareCrc": "固件CRC",
  "50901.real_time.firmwareInformationCrc": "固件信息CRC",
  "50901.real_time.firmwareBuildTimeYearMonth": "固件构建时间(年&月)",
  "50901.real_time.firmwareBuildTimeDateHour": "固件构建时间(天/小时)",
  "50901.real_time.bootSoftwareVersion": "启动软件版本",
  "50901.real_time.hoymilesSerialNumber": "Hoymiles序列号",
  "50901.real_time.oemSerialNumber": "OEM序列号",
  "50901.real_time.oemModelName": "OEM型号名称",
  "50901.real_time.gridMeterSerialNumber": "网侧电表序列号",
  "50901.real_time.pvMeterSerialNumber": "光伏表序列号",
  "50901.real_time.relaySupplyVoltageSampling": "继电器电源电压采样",
  "50901.real_time.12vAuxiliaryVoltageSampling": "12V辅助电压采样",
  "50901.real_time.12vOutputVoltageSampling": "12V输出电压采样",
  "50901.real_time.5vAuxiliaryVoltageSampling": "5V辅助电压采样",
  "50901.real_time.3_3vAuxiliaryVoltageSampling": "3.3V辅助电压采样",
  "50901.real_time.ambientTemperatureSampling": "环境温度采样",
  "50901.real_time.relayStatus": "继电器状态",
  "50901.ctrl_xitongjichupeizhi.clockSetting_year": "时钟设置-year",
  "50901.ctrl_xitongjichupeizhi.clockSetting_month": "时钟设置-month",
  "50901.ctrl_xitongjichupeizhi.clockSetting_day": "时钟设置-day",
  "50901.ctrl_xitongjichupeizhi.clockSetting_hour": "时钟设置-hour",
  "50901.ctrl_xitongjichupeizhi.clockSetting_minute": "时钟设置-minute",
  "50901.ctrl_xitongjichupeizhi.clockSetting_second": "时钟设置-second",
  "50901.ctrl_xitongjichupeizhi.clockSetting_weekday": "时钟设置-weekday",
  "50901.ctrl_xitongjichupeizhi.systemPowerOnOff": "系统开关机",
  "50901.ctrl_xitongjichupeizhi.workMode": "EMS工作模式",
  "50901.ctrl_dianchiguanli.maximumChargeLimit": "最大充电限制值",
  "50901.ctrl_dianchiguanli.maximumDischargeLimit": "最大放电限制值",
  "50901.ctrl_xitongjichupeizhi.gridType": "电网标准",
  "50901.ctrl_dianwangjiaohu.gridInPowerLimitationWhenValley": "限制网络功率",
  "50901.ctrl_xitongjichupeizhi.threePhaseUnbalanceEnable": "三相不平衡使能",
  "50901.ctrl_dianchiguanli.batteryMaxChargePower": "电池最大充电功率",
  "50901.ctrl_dianchiguanli.batteryMaxDischargePower": "电池最大放电功率",
  "50901.ctrl_dianchiguanli.maxSoc": "最大SOC",
  "50901.ctrl_dianchiguanli.minSoc": "最小SOC",
  "50901.ctrl_gaojigongneng.replenishPower": "功率补偿",
  "50901.ctrl_gaojigongneng.rsvdReplenishPower": "Rsvd补充功率",
  "50901.ctrl_dianwangjiaohu.batGridFeedPowerWhenPeak": "峰值时电网馈电功率",
  "50901.ctrl_dianchiguanli.batDischargePowerWhenPartialPeak": "峰值时电池最大放电功率",
  "50901.ctrl_dianchiguanli.leadAcidBatReplenishTime": "铅酸电池维护时间",
  "50901.ctrl_xitongjichupeizhi.bypassDisable": "绕过禁用",
  "50901.ctrl_xitongjichupeizhi.epsMode": "EPS模式",
  "50901.ctrl_xitongjichupeizhi.pvIslandModeEn": "PV模式使能",
  "50901.ctrl_dianchiguanli.batActivate": "电池激活",
  "50901.ctrl_xitongjichupeizhi.restartSystem": "重启系统",
  "50901.ctrl_anquanbaohu.restoreDefault": "恢复默认值",
  "50901.ctrl_anquanbaohu.clearFault": "清除故障",
  "50901.ctrl_gaojigongneng.selfTest": "自检",
  "50901.ctrl_anquanbaohu.arcFaultClear": "电弧故障清除",
  "50901.ctrl_dianchiguanli.batteryBalancing": "电池平衡",
  "50901.real_time.parallelNetworking": "并行网络",
  "50901.ctrl_xitongjichupeizhi.meterConfiguration": "仪表配置",
  "50901.ctrl_dianwangjiaohu.floatVoltage": "浮动电压",
  "50901.ctrl_dianwangjiaohu.absorptionVoltage": "吸收电压",
  "50901.ctrl_dianchiguanli.endOfChargeCurrent": "充电结束电流",
  "50901.ctrl_dianwangjiaohu.equalizationVoltage": "均衡电压",
  "50901.ctrl_gaojigongneng.equalizationIntervalDays": "均衡间隔天数",
  "50901.ctrl_gaojigongneng.equalizationTime": "均衡时间",
  "50901.ctrl_dianwangjiaohu.temperatureCorrectionFactor": "温度校正系数",
  "50901.ctrl_gaojigongneng.initialResistance": "初始阻力",
  "50901.real_time.cfgMultPcsBmsFlag": "BMS标志位",
  "50901.ctrl_dianchiguanli.endChargeVoltage": "结束充电电压",
  "50901.ctrl_dianchiguanli.equalizationChargeTimeout": "均衡充电超时",
  "50901.ctrl_xitongjichupeizhi.equalizationEnable": "均衡启用",
  "50901.ctrl_xitongjichupeizhi.dryWorkingMode": "干节点工作模式",
  "50901.ctrl_xitongjichupeizhi.loadControlMode": "负载控制模式",
  "50901.ctrl_xitongjichupeizhi.manualModeSwitch": "手动模式开关",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange1": "负载控制星期一",
  "50901.ctrl_gaojigongneng.timer1Hour": "定时1起-时",
  "50901.ctrl_gaojigongneng.timed1From1Min": "定时1起-分",
  "50901.ctrl_gaojigongneng.timed1EndHour": "定时1终-时",
  "50901.ctrl_gaojigongneng.timed1EndMinute": "定时1终-分",
  "50901.ctrl_gaojigongneng.timer2Hour": "定时2起-时",
  "50901.ctrl_gaojigongneng.timedFrom2Minutes": "定时2起-分",
  "50901.ctrl_gaojigongneng.timed2EndHour": "定时2终-时",
  "50901.ctrl_gaojigongneng.timed2EndMinutes": "定时2终-分",
  "50901.ctrl_gaojigongneng.weekRange2": "星期二",
  "50901.ctrl_gaojigongneng.timer1Hour_2": "定时1起_2-时",
  "50901.ctrl_gaojigongneng.timed1From1Min_2": "定时1起_2-分",
  "50901.ctrl_gaojigongneng.timed1EndHour_2": "定时1终_2-时",
  "50901.ctrl_gaojigongneng.timed1EndMinute_2": "定时1终_2-分",
  "50901.ctrl_gaojigongneng.timer2Hour_2": "定时2起_2-时",
  "50901.ctrl_gaojigongneng.timedFrom2Minutes_2": "定时2起_2-分",
  "50901.ctrl_gaojigongneng.timed2EndHour_2": "定时2终_2-时",
  "50901.ctrl_gaojigongneng.timed2EndMinutes_2": "定时2终_2-分",
  "50901.ctrl_gaojigongneng.smart_weekRange1": "时间范围1",
  "50901.ctrl_gaojigongneng.timer1Hour_3": "时间段1起-时",
  "50901.ctrl_gaojigongneng.timed1From1Min_3": "时间段1起-分",
  "50901.ctrl_gaojigongneng.timed1EndHour_3": "时间段1终-时",
  "50901.ctrl_gaojigongneng.timed1EndMinute_3": "时间段1终-分",
  "50901.ctrl_gaojigongneng.smart_weekRange2": "时间范围2",
  "50901.ctrl_gaojigongneng.timer2Hour_3": "时间段2起-时",
  "50901.ctrl_gaojigongneng.timedFrom2Minutes_3": "时间段2起-分",
  "50901.ctrl_gaojigongneng.timed2EndHour_3": "时间段2终-时",
  "50901.ctrl_gaojigongneng.timed2EndMinutes_3": "时间段2终-分",
  "50901.ctrl_gaojigongneng.minimumOnTime": "负载控制最短接通时间",
  "50901.ctrl_fuzaikongzhi.minimumOnLoadPower": "负载模式负载功率阈值",
  "50901.ctrl_dianchiguanli.offGridProtectionSoc": "离网保护SOC",
  "50901.ctrl_xitongjichupeizhi.generatorMode": "发电机模式",
  "50901.ctrl_dianchiguanli.generatorOpenBatteryCapacity": "柴发开启电池容量",
  "50901.ctrl_dianchiguanli.generatorCloseBatteryCapacity": "柴发关闭电池容量",
  "50901.ctrl_dianchiguanli.chargeTimeStartH": "发电机控制-充电开始时间-H",
  "50901.ctrl_dianchiguanli.chargeTimeStartMin": "发电机控制-充电开始时间-分钟",
  "50901.ctrl_dianchiguanli.chargeTimeEndH": "发电机控制-充电结束时间-H",
  "50901.ctrl_dianchiguanli.chargeTimeEndMin": "发电机控制-充电结束时间-分钟",
  "50901.ctrl_xitongjichupeizhi.quietTimeEnable": "待机时间启用",
  "50901.ctrl_gaojigongneng.quietTime1StartH": "待机时间1开始-H",
  "50901.ctrl_gaojigongneng.quietTime1StartMin": "待机时间1开始-分钟",
  "50901.ctrl_gaojigongneng.quietTime1EndH": "待机时间1End-H",
  "50901.ctrl_gaojigongneng.quietTime1EndMin": "待机时间1结束分钟",
  "50901.ctrl_gaojigongneng.quietTime2StartH": "待机时间2开始-H",
  "50901.ctrl_gaojigongneng.quietTime2StartMin": "待机时间2开始-Min",
  "50901.ctrl_gaojigongneng.quietTime2EndH": "待机时间2结束-H",
  "50901.ctrl_gaojigongneng.quietTime2EndMin": "待机时间2结束-Min",
  "50901.ctrl_xitongjichupeizhi.genPracticeModeEn": "发电机练习模式",
  "50901.ctrl_dianwangjiaohu.genPracticeFreq": "发电机练习模式频率",
  "50901.ctrl_xitongjichupeizhi.genPracticeModeWeek": "发电机练习模式启动时间",
  "50901.ctrl_xitongjichupeizhi.genPracticeModeStartH": "发电机练习模式启动时间-小时",
  "50901.ctrl_xitongjichupeizhi.genPracticeModeStartMin": "发电机练习模式启动时间-分钟",
  "50901.ctrl_xitongjichupeizhi.genPracticeModeRunningTime": "发电机练习模式运行时长",
  "50901.ctrl_dianchiguanli.selfUsedSoc": "自用SOC",
  "50901.ctrl_dianchiguanli.backupSoc": "备用SOC",
  "50901.ctrl_dianchiguanli.forceChargeSoc": "强制充电SOC",
  "50901.ctrl_dianchiguanli.maximumChargePower": "最大充电功率",
  "50901.ctrl_dianchiguanli.forceDischargeSoc": "强制放电SOC",
  "50901.ctrl_dianchiguanli.maximumDischargePower": "最大放电功率",
  "50901.ctrl_xitongjichupeizhi.economicModeSoc": "经济模式SOC",
  "50901.ctrl_xitongjichupeizhi.economyModeDateNumber": "经济模式日期编号",
  "50901.ctrl_dianwangjiaohu.section1StartMonth": "section1开始月",
  "50901.ctrl_dianwangjiaohu.section1StartDay": "section1开始天",
  "50901.ctrl_dianwangjiaohu.section1StopMonth": "section1停止月",
  "50901.ctrl_dianwangjiaohu.section1StopDay": "section1停止日",
  "50901.ctrl_dianwangjiaohu.section1WeekRange1": "section1周范围1",
  "50901.ctrl_dianwangjiaohu.section1PeakStartHour1": "section1 峰值开始时间1-小时",
  "50901.ctrl_dianwangjiaohu.section1PeakStartMinute1": "section1 峰值开始时间1-分钟",
  "50901.ctrl_dianwangjiaohu.section1PeakStopHour1": "section1 峰值停止时间1-小时",
  "50901.ctrl_dianwangjiaohu.section1PeakStopMinute1": "section1 峰值停止时间1-分钟",
  "50901.ctrl_dianwangjiaohu.section1ValleyStartHour1": "section1 低谷开始时间1- 小时",
  "50901.ctrl_dianwangjiaohu.section1ValleyStartMinute1": "section1 低谷开始时间1- 分钟",
  "50901.ctrl_dianwangjiaohu.section1ValleyStopHour1": "section1 低谷停止时间1- 小时",
  "50901.ctrl_dianwangjiaohu.section1ValleyStopMinute1": "section1 低谷停止时间1- 分钟",
  "50901.ctrl_dianwangjiaohu.section1WeekRange2": "section1周范围2",
  "50901.ctrl_dianwangjiaohu.section1PeakStartHour2": "section1峰值开始时间2-小时",
  "50901.ctrl_dianwangjiaohu.section1PeakStartMinute2": "section1峰值开始时间2-分钟",
  "50901.ctrl_dianwangjiaohu.section1PeakStopHour2": "section1峰值停止时间2-小时",
  "50901.ctrl_dianwangjiaohu.section1PeakStopMinute2": "section1峰值停止时间2-分钟",
  "50901.ctrl_dianwangjiaohu.section1ValleyStartHour2": "section1低估开始时间2-小时",
  "50901.ctrl_dianwangjiaohu.section1ValleyStartMinute2": "section1低估开始时间2-分钟",
  "50901.ctrl_dianwangjiaohu.section1ValleyStopHour2": "section1低估停止时间2-小时",
  "50901.ctrl_dianwangjiaohu.section1ValleyStopMinute2": "section1低估停止时间2-分钟",
  "50901.ctrl_dianwangjiaohu.section2StartMonth": "section2开始月",
  "50901.ctrl_dianwangjiaohu.section2StartDay": "section2开始天",
  "50901.ctrl_dianwangjiaohu.section2StopMonth": "section2停止月",
  "50901.ctrl_dianwangjiaohu.section2StopDay": "section2停止日",
  "50901.ctrl_dianwangjiaohu.section2WeekRange1": "section2周范围1",
  "50901.ctrl_dianwangjiaohu.section2PeakStartHour1": "section2峰值开始时间1-小时",
  "50901.ctrl_dianwangjiaohu.section2PeakStartMinute1": "section2峰值开始时间1-分钟",
  "50901.ctrl_dianwangjiaohu.section2PeakStopHour1": "section2峰值停止时间1-小时",
  "50901.ctrl_dianwangjiaohu.section2PeakStopMinute1": "section2峰值停止时间1-分钟",
  "50901.ctrl_dianwangjiaohu.section2ValleyStartHour1": "section2低估开始时间1-小时",
  "50901.ctrl_dianwangjiaohu.section2ValleyStartMinute1": "section2低估开始时间1-分钟",
  "50901.ctrl_dianwangjiaohu.section2ValleyStopHour1": "section2低估停止时间1-小时",
  "50901.ctrl_dianwangjiaohu.section2ValleyStopMinute1": "section2低估停止时间1-分钟",
  "50901.ctrl_dianwangjiaohu.section2WeekRange2": "section2周范围2",
  "50901.ctrl_dianwangjiaohu.section2PeakStartHour2": "section2峰值开始时间2-小时",
  "50901.ctrl_dianwangjiaohu.section2PeakStartMinute2": "section2峰值开始时间1-分钟",
  "50901.ctrl_dianwangjiaohu.section2PeakStopHour2": "section2峰值停止时间2-小时",
  "50901.ctrl_dianwangjiaohu.section2PeakStopMinute2": "section2峰值停止时间2-分钟",
  "50901.ctrl_dianwangjiaohu.section2ValleyStartHour2": "section2低估开始时间2-小时",
  "50901.ctrl_dianwangjiaohu.section2ValleyStartMinute2": "section2低估开始时间2-分钟",
  "50901.ctrl_dianwangjiaohu.section2ValleyStopHour2": "section2低估停止时间2-小时",
  "50901.ctrl_dianwangjiaohu.section2ValleyStopMinute2": "section2低估停止时间2-分钟",
  "50901.ctrl_dianwangjiaohu.section3StartMonth": "section3开始月",
  "50901.ctrl_dianwangjiaohu.section3StartDay": "section3开始天",
  "50901.ctrl_dianwangjiaohu.section3StopMonth": "section3停止月",
  "50901.ctrl_dianwangjiaohu.section3StopDay": "section3停止日",
  "50901.ctrl_dianwangjiaohu.section3WeekRange1": "section3周范围1",
  "50901.ctrl_dianwangjiaohu.section3PeakStartHour1": "section3峰值开始时间1-小时",
  "50901.ctrl_dianwangjiaohu.section3PeakStartMinute2": "section3峰值开始时间1-分钟",
  "50901.ctrl_dianwangjiaohu.section3PeakStopHour1": "section3峰值停止时间1-小时",
  "50901.ctrl_dianwangjiaohu.section3PeakStopMinute1": "section3峰值停止时间1-分钟",
  "50901.ctrl_dianwangjiaohu.section3ValleyStartHour1": "section3低谷开始时间1-小时",
  "50901.ctrl_dianwangjiaohu.section3ValleyStartMinute1": "section3低估开始时间1-分钟",
  "50901.ctrl_dianwangjiaohu.section3ValleyStopHour1": "section3低估停止时间1-小时",
  "50901.ctrl_dianwangjiaohu.section3ValleyStopMinute1": "section3低估停止时间1-分钟",
  "50901.ctrl_dianwangjiaohu.section3WeekRange2": "section3周范围2",
  "50901.ctrl_dianwangjiaohu.section3PeakStartHour2": "section3峰值开始时间2-小时",
  "50901.ctrl_dianwangjiaohu.section3PeakStartMinute1": "section3峰值开始时间2-分钟",
  "50901.ctrl_dianwangjiaohu.section3PeakStopHour2": "section3峰值停止时间2-小时",
  "50901.ctrl_dianwangjiaohu.section3PeakStopMinute2": "section3峰值停止时间2-分钟",
  "50901.ctrl_dianwangjiaohu.section3ValleyStartHour2": "section3低估开始时间2-小时",
  "50901.ctrl_dianwangjiaohu.section3ValleyStartMinute2": "section3低估开始时间2-分钟",
  "50901.ctrl_dianwangjiaohu.section3ValleyStopHour2": "section3低估停止时间2-小时",
  "50901.ctrl_dianwangjiaohu.section3ValleyStopMinute2": "section3低估停止时间2-分钟",
  "50901.ctrl_dianwangjiaohu.section4StartMonth": "section4开始月",
  "50901.ctrl_dianwangjiaohu.section4StartDay": "section4开始天",
  "50901.ctrl_dianwangjiaohu.section4StopMonth": "section4停止月",
  "50901.ctrl_dianwangjiaohu.section4StopDay": "section4停止日",
  "50901.ctrl_dianwangjiaohu.section4WeekRange1": "section4周范围1",
  "50901.ctrl_dianwangjiaohu.section4PeakStartHour1": "section4峰值开始时间1-小时",
  "50901.ctrl_dianwangjiaohu.section4PeakStartMinute1": "section4峰值开始时间1-分钟",
  "50901.ctrl_dianwangjiaohu.section4PeakStopHour1": "section4峰值停止时间1-小时",
  "50901.ctrl_dianwangjiaohu.section4PeakStopMinute1": "section4峰值停止时间1-分钟",
  "50901.ctrl_dianwangjiaohu.section4ValleyStartHour1": "section4低估开始时间1-小时",
  "50901.ctrl_dianwangjiaohu.section4ValleyStartMinute1": "section4低估开始时间1-分钟",
  "50901.ctrl_dianwangjiaohu.section4ValleyStopHour1": "section4低估停止时间1-小时",
  "50901.ctrl_dianwangjiaohu.section4ValleyStopMinute1": "section4低估停止时间1-分钟",
  "50901.ctrl_dianwangjiaohu.section4WeekRange2": "section4周范围2",
  "50901.ctrl_dianwangjiaohu.section4PeakStartHour2": "section4峰值开始时间2-小时",
  "50901.ctrl_dianwangjiaohu.section4PeakStartMinute2": "section4峰值开始时间2-分钟",
  "50901.ctrl_dianwangjiaohu.section4PeakStopHour2": "section4峰值停止时间2-小时",
  "50901.ctrl_dianwangjiaohu.section4PeakStopMinute2": "section4峰值停止时间2-分钟",
  "50901.ctrl_dianwangjiaohu.section4ValleyStartHour2": "section4低估开始时间2-小时",
  "50901.ctrl_dianwangjiaohu.section4ValleyStartMinute2": "section4低估开始时间2-分钟",
  "50901.ctrl_dianwangjiaohu.section4ValleyStopHour2": "section4低估停止时间2-小时",
  "50901.ctrl_dianwangjiaohu.section4ValleyStopMinute2": "section4低估停止时间2-分钟",
  "50901.ctrl_dianchiguanli.batteryHealing": "电池恢复",
  "50901.ctrl_dianchiguanli.peakMeterSoc": "峰值计SOC",
  "50901.ctrl_dianwangjiaohu.peakMeterPower": "峰值仪表功率",
  "50901.ctrl_gaojigongneng.timeOfUseRange": "TOU模式时间范围",
  "50901.ctrl_gaojigongneng.timeOfUseTime1ChrgStartH": "使用时间Time1ChrgStart-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime1ChrgStartMin": "使用时间Time1ChrgStart-\nMin\n",
  "50901.ctrl_gaojigongneng.timeOfUseTime1ChrgEndH": "使用时间Time1Chrg结束-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime1ChrgEndMin": "使用时间Time1Chrg结束-分钟",
  "50901.ctrl_dianchiguanli.timeOfUseTime1ChrgPower": "充电功率",
  "50901.ctrl_dianchiguanli.timeOfUseTime1ChrgStopSoc": "充电截止容量",
  "50901.ctrl_gaojigongneng.timeOfUseTime1DischrgStartH": "使用时间Time1DischrgStart-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime1DischrgStartMin": "使用时间Time1DischrgStart-Min",
  "50901.ctrl_gaojigongneng.timeOfUseTime1DischrgEndH": "使用时间Time1DischrgEnd-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime1DischrgEndMin": "使用时间Time1Dischrg结束-分钟",
  "50901.ctrl_dianchiguanli.timeOfUseTime1DischrgPower": "放电功率",
  "50901.ctrl_dianchiguanli.timeOfUseTime1DischrgStopSoc": "放电截止容量",
  "50901.ctrl_gaojigongneng.timeOfUseTime2ChrgStartH": "使用时间Time2ChrgStart-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime2ChrgStartMin": "使用时间Time2ChrgStart-\nMin\n",
  "50901.ctrl_gaojigongneng.timeOfUseTime2ChrgEndH": "使用时间Time2Chrg结束-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime2ChrgEndMin": "使用时间Time2Chrg结束-分钟",
  "50901.ctrl_dianchiguanli.timeOfUseTime2ChrgPower": "充电功率",
  "50901.ctrl_dianchiguanli.timeOfUseTime2ChrgStopSoc": "充电截止容量",
  "50901.ctrl_gaojigongneng.timeOfUseTime2DischrgStartH": "使用时间Time2DischrgStart-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime2DischrgStartMin": "使用时间Time2DischrgStart-Min",
  "50901.ctrl_gaojigongneng.timeOfUseTime2DischrgEndH": "使用时间Time2DischrgEnd-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime2DischrgEndMin": "使用时间Time2Dischrg结束-分钟",
  "50901.ctrl_dianchiguanli.timeOfUseTime2DischrgPower": "放电功率",
  "50901.ctrl_dianchiguanli.timeOfUseTime2DischrgStopSoc": "放电截止容量",
  "50901.ctrl_gaojigongneng.timeOfUseTime3ChrgStartH": "使用时间Time3ChrgStart-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime3ChrgStartMin": "使用时间Time3ChrgStart-\nMin\n",
  "50901.ctrl_gaojigongneng.timeOfUseTime3ChrgEndH": "使用时间Time3Chrg结束-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime3ChrgEndMin": "使用时间Time3Chrg结束-分钟",
  "50901.ctrl_dianchiguanli.timeOfUseTime3ChrgPower": "充电功率",
  "50901.ctrl_dianchiguanli.timeOfUseTime3ChrgStopSoc": "充电截止容量",
  "50901.ctrl_gaojigongneng.timeOfUseTime3DischrgStartH": "使用时间Time3DischrgStart-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime3DischrgStartMin": "使用时间Time3DischrgStart-Min",
  "50901.ctrl_gaojigongneng.timeOfUseTime3DischrgEndH": "使用时间Time3DischrgEnd-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime3DischrgEndMin": "使用时间Time3Dischrg结束-分钟",
  "50901.ctrl_dianchiguanli.timeOfUseTime3DischrgPower": "放电功率",
  "50901.ctrl_dianchiguanli.timeOfUseTime3DischrgStopSoc": "放电截止容量",
  "50901.ctrl_gaojigongneng.timeOfUseTime4ChrgStartH": "使用时间Time4ChrgStart-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime4ChrgStartMin": "使用时间Time4ChrgStart-\nMin\n",
  "50901.ctrl_gaojigongneng.timeOfUseTime4ChrgEndH": "使用时间Time4Chrg结束-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime4ChrgEndMin": "使用时间Time4Chrg结束-分钟",
  "50901.ctrl_dianchiguanli.timeOfUseTime4ChrgPower": "充电功率",
  "50901.ctrl_dianchiguanli.timeOfUseTime4ChrgStopSoc": "充电截止容量",
  "50901.ctrl_gaojigongneng.timeOfUseTime4DischrgStartH": "使用时间Time4DischrgStart-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime4DischrgStartMin": "使用时间Time4DischrgStart-Min",
  "50901.ctrl_gaojigongneng.timeOfUseTime4DischrgEndH": "使用时间Time4DischrgEnd-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime4DischrgEndMin": "使用时间Time4Dischrg结束-分钟",
  "50901.ctrl_dianchiguanli.timeOfUseTime4DischrgPower": "放电功率",
  "50901.ctrl_dianchiguanli.timeOfUseTime4DischrgStopSoc": "放电截止功率",
  "50901.ctrl_gaojigongneng.timeOfUseTime5ChrgStartH": "使用时间Time5ChrgStart-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime5ChrgStartMin": "使用时间Time5ChrgStart-\nMin\n",
  "50901.ctrl_gaojigongneng.timeOfUseTime5ChrgEndH": "使用时间Time5Chrg结束-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime5ChrgEndMin": "使用时间Time5Chrg结束-分钟",
  "50901.ctrl_dianchiguanli.timeOfUseTime5ChrgPower": "充电功率",
  "50901.ctrl_dianchiguanli.timeOfUseTime5ChrgStopSoc": "充电截止容量",
  "50901.ctrl_gaojigongneng.timeOfUseTime5DischrgStartH": "使用时间Time5DischrgStart-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime5DischrgStartMin": "使用时间Time5DischrgStart-Min",
  "50901.ctrl_gaojigongneng.timeOfUseTime5DischrgEndH": "使用时间Time5DischrgEnd-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime5DischrgEndMin": "使用时间Time5Dischrg结束-分钟",
  "50901.ctrl_dianchiguanli.timeOfUseTime5DischrgPower": "放电功率",
  "50901.ctrl_dianchiguanli.timeOfUseTime5DischrgStopSoc": "放电截止容量",
  "50901.ctrl_gaojigongneng.timeOfUseTime6ChrgStartH": "使用时间Time6ChrgStart-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime6ChrgStartMin": "使用时间Time6ChrgStart-\nMin\n",
  "50901.ctrl_gaojigongneng.timeOfUseTime6ChrgEndH": "使用时间Time6Chrg结束-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime6ChrgEndMin": "使用时间Time6Chrg结束-分钟",
  "50901.ctrl_dianchiguanli.timeOfUseTime6ChrgPower": "充电功率",
  "50901.ctrl_dianchiguanli.timeOfUseTime6ChrgStopSoc": "充电截止容量",
  "50901.ctrl_gaojigongneng.timeOfUseTime6DischrgStartH": "使用时间Time6DischrgStart-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime6DischrgStartMin": "使用时间Time6DischrgStart-Min",
  "50901.ctrl_gaojigongneng.timeOfUseTime6DischrgEndH": "使用时间Time6DischrgEnd-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime6DischrgEndMin": "使用时间Time6Dischrg结束-分钟",
  "50901.ctrl_dianchiguanli.timeOfUseTime6DischrgPower": "放电功率",
  "50901.ctrl_dianchiguanli.timeOfUseTime6DischrgStopSoc": "放电截止容量",
  "50901.ctrl_gaojigongneng.timeOfUseTime7ChrgStartH": "使用时间Time7ChrgStart-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime7ChrgStartMin": "使用时间Time7ChrgStart-\nMin\n",
  "50901.ctrl_gaojigongneng.timeOfUseTime7ChrgEndH": "使用时间Time7Chrg结束-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime7ChrgEndMin": "使用时间Time7Chrg结束-分钟",
  "50901.ctrl_dianchiguanli.timeOfUseTime7ChrgPower": "放电功率",
  "50901.ctrl_dianchiguanli.timeOfUseTime7ChrgStopSoc": "放电截止容量",
  "50901.ctrl_gaojigongneng.timeOfUseTime7DischrgStartH": "使用时间Time7DischrgStart-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime7DischrgStartMin": "使用时间Time7DischrgStart-Min",
  "50901.ctrl_gaojigongneng.timeOfUseTime7DischrgEndH": "使用时间Time7DischrgEnd-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime7DischrgEndMin": "使用时间Time7Dischrg结束-分钟",
  "50901.ctrl_dianchiguanli.timeOfUseTime7DischrgPower": "放电功率",
  "50901.ctrl_dianchiguanli.timeOfUseTime7DischrgStopSoc": "放电截止容量",
  "50901.ctrl_gaojigongneng.timeOfUseTime8ChrgStartH": "使用时间Time8ChrgStart-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime8ChrgStartMin": "使用时间Time8ChrgStart-\nMin\n",
  "50901.ctrl_gaojigongneng.timeOfUseTime8ChrgEndH": "使用时间Time8Chrg结束-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime8ChrgEndMin": "使用时间Time8Chrg结束-分钟",
  "50901.ctrl_dianchiguanli.timeOfUseTime8ChrgPower": "充电功率",
  "50901.ctrl_dianchiguanli.timeOfUseTime8ChrgStopSoc": "充电截止容量",
  "50901.ctrl_gaojigongneng.timeOfUseTime8DischrgStartH": "使用时间Time8DischrgStart-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime8DischrgStartMin": "使用时间Time8DischrgStart-Min",
  "50901.ctrl_gaojigongneng.timeOfUseTime8DischrgEndH": "使用时间Time8DischrgEnd-H",
  "50901.ctrl_gaojigongneng.timeOfUseTime8DischrgEndMin": "使用时间Time8Dischrg结束-分钟",
  "50901.ctrl_dianchiguanli.timeOfUseTime8DischrgPower": "放电功率",
  "50901.ctrl_dianchiguanli.timeOfUseTime8DischrgStopSoc": "放电截止容量",
  "50901.ctrl_xitongjichupeizhi.hpWorkMode": "HP工作模式",
  "50901.ctrl_gaojigongneng.hpStartPower": "hp启动功率",
  "50901.ctrl_gaojigongneng.hpMaxFeedbackPower": "HP最大反馈功率",
  "50901.ctrl_gaojigongneng.hpSupplyPower": "HP电源",
  "50901.ctrl_xitongjichupeizhi.hpBattSocDetectMode": "HPBattSoc检测模式",
  "50901.ctrl_dianwangjiaohu.hpDelayDetectTimeLmt": "HP延迟检测时间限制",
  "50901.ctrl_xitongjichupeizhi.hpMaxTimeDetectEnable": "HP最大时间检测启用",
  "50901.ctrl_gaojigongneng.hpMinRunTimeLmtOfOnce": "HP最小运行时间限制",
  "50901.ctrl_gaojigongneng.hpMaxRunTimeOfOneDay": "HP一天的最大运行时间",
  "50901.ctrl_dianchiguanli.hpStartSoc": "HP启动Soc",
  "50901.ctrl_dianchiguanli.hpCloseSoc": "HP关闭Soc",
  "50901.ctrl_gaojigongneng.hpWorkTimeParts": "HP工作时间",
  "50901.ctrl_gaojigongneng.hpTime1StartMonth": "HPTime1开始-月",
  "50901.ctrl_gaojigongneng.hpTime1StartDay": "HPTime1开始-天",
  "50901.ctrl_gaojigongneng.hpTime1EndMonth": "HPTime1结束-\n月",
  "50901.ctrl_gaojigongneng.hpTime1EndDay": "HPTime1结束-天",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange": "HPTime1周\n范围",
  "50901.ctrl_gaojigongneng.hpTime2StartMonth": "HPTime2开始-月",
  "50901.ctrl_gaojigongneng.hpTime2StartDay": "HPTime2开始-天",
  "50901.ctrl_gaojigongneng.hpTime2EndMonth": "HPTime2结束\n月",
  "50901.ctrl_gaojigongneng.hpTime2EndDay": "HPTime2结束-天",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange": "HPTime2周\n范围",
  "50901.ctrl_gaojigongneng.hpTime3StartMonth": "HPTime3开始-月",
  "50901.ctrl_gaojigongneng.hpTime3StartDay": "HPTime3开始-天",
  "50901.ctrl_gaojigongneng.hpTime3EndMonth": "HPTime3结束\n月",
  "50901.ctrl_gaojigongneng.hpTime3EndDay": "HPTime3结束-天",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange": "HPTime3周\n范围",
  "50901.ctrl_gaojigongneng.hpTime4StartMonth": "HPTime4Start-月",
  "50901.ctrl_gaojigongneng.hpTime4StartDay": "HPTime4开始-天",
  "50901.ctrl_gaojigongneng.hpTime4EndMonth": "HPTime4结束\n月",
  "50901.ctrl_gaojigongneng.hpTime4EndDay": "HPTime4结束-天",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange": "HPTime4周\n范围",
  "50901.ctrl_dianwangjiaohu.connectionRouterStatus": "连接路由器状态",
  "50901.ctrl_dianwangjiaohu.connectionServerStatus": "连接器服务状态",
  "50901.ctrl_gaojigongneng.absoluteTime": "绝对时间",
  "50901.ctrl_gaojigongneng.timeZone": "时区",
  "50901.ctrl_gaojigongneng.dfs": "能力集",
  "50901.ctrl_gaojigongneng.numberOfUnits": "机器数量",
  "50901.real_time.commAddress1Master": "通信地址1(主)",
  "50901.real_time.machineSnMaster": "机器SN(主)",
  "50901.real_time.commAddress2Slave1": "通信地址2(从1)",
  "50901.real_time.machineSnSlave1": "机器SN(从1)",
  "50901.real_time.commAddress3Slave2": "通信地址3(从2)",
  "50901.real_time.machineSnSlave2": "机器SN(从2)",
  "50901.real_time.commAddress3Slave3": "通信地址4(从3)",
  "50901.real_time.machineSnSlave3": "机器SN(从3)",
  "50901.real_time.commAddress4Slave4": "通信地址5(从4)",
  "50901.real_time.machineSnSlave4": "机器SN(从4）",
  "50901.real_time.commAddress6Slave6": "通信地址6(从5）",
  "50901.real_time.machineSnSlave5": "机器SN(从5）",
  "50901.real_time.commAddress7Slave6": "通信地址7(从6）",
  "50901.real_time.machineSnSlave6": "机器SN(从6）",
  "50901.real_time.commAddress8Slave7": "通信地址8(从7）",
  "50901.real_time.machineSnSlave7": "机器SN(从7）",
  "50901.real_time.commAddress9Slave8": "通信地址9(从8)",
  "50901.real_time.machineSnSlave8": "机器SN(从8）",
  "50901.real_time.commAddress10Slave9": "通信地址10(从9）",
  "50901.real_time.machineSnSlave9": "机器SN(从9)",
  "50901.ctrl_xitongjichupeizhi.gridRecoveryDelayTimeSeconds": "电网恢复延迟时间（秒）",
  "50901.ctrl_xitongjichupeizhi.networkingType": "联网类型",
  "50901.real_time.upgradeCommand": "升级指令",
  "50901.real_time.checkTime": "设备时间",
  "50901.real_time.workStatus.0": "电源初始化",
  "50901.real_time.workStatus.1": "待机模式",
  "50901.real_time.workStatus.2": "并网测试",
  "50901.real_time.workStatus.3": "并网模式",
  "50901.real_time.workStatus.4": "故障模式",
  "50901.real_time.workStatus.5": "离网模式",
  "50901.real_time.workStatus.6": "旁路模式",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.0": "功率限制解除，默认模式",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.1": "逆变器功率为0，脱网",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.2": "充电功率Pc=0,不脱网",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.3": "充电功率Pc<50%Pn 额度功率",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.4": "充电功率Pc<75%Pn 额度功率&&无功功率Q=Qmax ±4%",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.5": "充电功率Pc, 不做限制",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.6": "放电功率P=0,不脱网",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.7": "放电功率P<50%Pn额度功率",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.8": "放电功率P<75%Pn 额度功率&&Q= -Qmax±4%",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.9": "放电功率P 不做限制",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.10": "充电功率Pc<50%Pn 额度功率 --> 充电功率降为0",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.11": "充电功率Pc<50%Pn 额度功率&&Q=Qmax",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.12": "放电功率P<50%Pn 额度功率 --> 放电功率降为0",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.13": "充电功率P<50%Pn 额度功率&&Q=-Qmax",
  "50901.real_time.masterSlave.0": "单机",
  "50901.real_time.masterSlave.1": "主机",
  "50901.real_time.masterSlave.2": "从机",
  "50901.real_time.batteryConnectionStatus.0": "否",
  "50901.real_time.batteryConnectionStatus.1": "是",
  "50901.real_time.batteryType_04.0": "无电池",
  "50901.real_time.batteryType_04.1": "锂电池",
  "50901.real_time.batteryType_04.2": "铅酸电池",
  "50901.real_time.batteryModule.1": "Pylon LV",
  "50901.real_time.batteryModule.2": "Pylon HV",
  "50901.real_time.batteryModule.3": "Dyness LV",
  "50901.real_time.batteryModule.4": "Dyness HV",
  "50901.real_time.batteryModule.5": "Sunwoda LV",
  "50901.real_time.batteryModule.6": "Uz LV",
  "50901.real_time.batteryModule.7": "Soluna HV",
  "50901.real_time.batteryModule.8": "Soluna LV",
  "50901.real_time.batteryModule.9": "Steltec LV",
  "50901.real_time.batteryModule.10": "Xin Yi LV",
  "50901.real_time.batteryModule.11": "Vestwoods LV",
  "50901.real_time.batteryModule.12": "JK HV",
  "50901.real_time.batteryModule.13": "BYD LV",
  "50901.real_time.batteryModule.14": "Uz HV",
  "50901.real_time.batteryModule.15": "Zetara LV",
  "50901.real_time.batteryModule.16": "FEB HV",
  "50901.real_time.batteryModule.17": "Pytes LV",
  "50901.real_time.batteryModule.18": "Dmegc LV",
  "50901.real_time.batteryModule.19": "Weineng LV",
  "50901.real_time.batteryModule.20": "Weineng HV",
  "50901.real_time.batteryModule.21": "GSL LV",
  "50901.real_time.batteryModule.22": "HOY LV",
  "50901.real_time.batteryModule.23": "HOY HV",
  "50901.real_time.batteryModule.24": "FEB LV",
  "50901.real_time.batteryModule.25": "UHhome LV",
  "50901.real_time.batteryModule.26": "UHhome HV",
  "50901.real_time.batteryModule.27": "BYD HV",
  "50901.real_time.batteryModule.28": "Vestwoods HV",
  "50901.real_time.batteryModule.29": "Phylion HV",
  "50901.real_time.batteryModule.30": "Hoymiles LV",
  "50901.real_time.batteryModule.31": "Pholion LV",
  "50901.real_time.batteryModule.32": "Wattsonic LV",
  "50901.real_time.batteryModule.33": "Enershare HV",
  "50901.real_time.batteryModule.34": "Beghelli LV",
  "50901.real_time.batteryModule.35": "LvToPSUN LV",
  "50901.real_time.batteryModule.36": "PYTES HV",
  "50901.real_time.batteryModule.37": "LvToPSUN hv",
  "50901.real_time.batteryModule.38": "RAJA HV",
  "50901.real_time.batteryModule.39": "Felicity LV",
  "50901.real_time.batteryWorkingStatus.0": "待机",
  "50901.real_time.batteryWorkingStatus.1": "待机",
  "50901.real_time.batteryWorkingStatus.2": "放电",
  "50901.ctrl_xitongjichupeizhi.materType.00": "无网侧电表",
  "50901.ctrl_xitongjichupeizhi.materType.01": "正泰单相",
  "50901.real_time.meterFlag.0": "offline",
  "50901.real_time.meterFlag.1": "online",
  "50901.real_time.relayStatus.11": "重要负载B馈送",
  "50901.real_time.relayStatus.12": "保留",
  "50901.real_time.relayStatus.13": "保留",
  "50901.real_time.relayStatus.14": "保留",
  "50901.real_time.relayStatus.15": "保留",
  "50901.real_time.relayStatus.0": "KM1馈送",
  "50901.real_time.relayStatus.1": "KM1馈送",
  "50901.real_time.relayStatus.2": "发电机A馈送",
  "50901.real_time.relayStatus.3": "发电机A馈送",
  "50901.real_time.relayStatus.4": "发电机B馈送",
  "50901.real_time.relayStatus.5": "发电机B馈送",
  "50901.real_time.relayStatus.6": "发电机AB馈送",
  "50901.real_time.relayStatus.7": "发电机AB馈送",
  "50901.real_time.relayStatus.8": "重要负载A馈送",
  "50901.real_time.relayStatus.9": "重要负载A馈送",
  "50901.real_time.relayStatus.10": "重要负载B馈送",
  "50901.ctrl_xitongjichupeizhi.workMode.0": "自发自用",
  "50901.ctrl_xitongjichupeizhi.workMode.1": "经济模式",
  "50901.ctrl_xitongjichupeizhi.workMode.2": "备电模式",
  "50901.ctrl_xitongjichupeizhi.workMode.3": "离网模式",
  "50901.ctrl_xitongjichupeizhi.workMode.4": "强充模式",
  "50901.ctrl_xitongjichupeizhi.workMode.5": "强放模式",
  "50901.ctrl_xitongjichupeizhi.bypassDisable.0": "否",
  "50901.ctrl_xitongjichupeizhi.bypassDisable.1": "是",
  "50901.ctrl_xitongjichupeizhi.epsMode.0": "禁用",
  "50901.ctrl_xitongjichupeizhi.epsMode.1": "应急电源",
  "50901.ctrl_xitongjichupeizhi.epsMode.2": "不间断电源",
  "50901.ctrl_xitongjichupeizhi.pvIslandModeEn.0": "否",
  "50901.ctrl_xitongjichupeizhi.pvIslandModeEn.1": "是",
  "50901.ctrl_xitongjichupeizhi.restartSystem.0": "否",
  "50901.ctrl_xitongjichupeizhi.restartSystem.1": "是",
  "50901.real_time.parallelNetworking.0": "无效",
  "50901.real_time.parallelNetworking.1": "组网中",
  "50901.real_time.parallelNetworking.2": "解散组网",
  "50901.ctrl_xitongjichupeizhi.meterConfiguration.0": "无电表类型",
  "50901.ctrl_xitongjichupeizhi.meterConfiguration.1": "配置电网电表",
  "50901.real_time.cfgMultPcsBmsFlag.0": "否",
  "50901.real_time.cfgMultPcsBmsFlag.1": "是",
  "50901.ctrl_xitongjichupeizhi.equalizationEnable.0": "否",
  "50901.ctrl_xitongjichupeizhi.equalizationEnable.1": "是",
  "50901.ctrl_xitongjichupeizhi.dryWorkingMode.0": "无",
  "50901.ctrl_xitongjichupeizhi.dryWorkingMode.1": "接地故障",
  "50901.ctrl_xitongjichupeizhi.dryWorkingMode.2": "敷在控制",
  "50901.ctrl_xitongjichupeizhi.dryWorkingMode.3": "放电机",
  "50901.ctrl_xitongjichupeizhi.loadControlMode.1": "手动",
  "50901.ctrl_xitongjichupeizhi.loadControlMode.2": "时间模式",
  "50901.ctrl_xitongjichupeizhi.loadControlMode.3": "智能负载",
  "50901.ctrl_xitongjichupeizhi.loadControlMode.4": "离网智能负载",
  "50901.ctrl_xitongjichupeizhi.loadControlMode.5": "电动汽车充电器",
  "50901.ctrl_xitongjichupeizhi.manualModeSwitch.0": "否",
  "50901.ctrl_xitongjichupeizhi.manualModeSwitch.1": "是",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange1.0": "disable",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange1.1": "enable",
  "50901.ctrl_gaojigongneng.weekRange2.0": "disable",
  "50901.ctrl_gaojigongneng.weekRange2.1": "enable",
  "50901.ctrl_xitongjichupeizhi.generatorMode.0": "关",
  "50901.ctrl_xitongjichupeizhi.generatorMode.1": "手动",
  "50901.ctrl_xitongjichupeizhi.generatorMode.2": "自动",
  "50901.ctrl_xitongjichupeizhi.genPracticeModeEn.0": "否",
  "50901.ctrl_xitongjichupeizhi.genPracticeModeEn.1": "是",
  "50901.ctrl_dianwangjiaohu.genPracticeFreq.0": "无",
  "50901.ctrl_dianwangjiaohu.genPracticeFreq.1": "每周一次",
  "50901.ctrl_dianwangjiaohu.genPracticeFreq.2": "每2周一次",
  "50901.ctrl_dianwangjiaohu.genPracticeFreq.3": "每3周一次",
  "50901.ctrl_dianwangjiaohu.genPracticeFreq.4": "每4周一次",
  "50901.ctrl_xitongjichupeizhi.genPracticeModeWeek.0": "枚举值0的含义",
  "50901.ctrl_xitongjichupeizhi.genPracticeModeWeek.1": "枚举值2的含义",
  "50901.ctrl_dianwangjiaohu.section1WeekRange1.0": "枚举值0的含义",
  "50901.ctrl_dianwangjiaohu.section1WeekRange1.1": "枚举值2的含义",
  "50901.ctrl_dianwangjiaohu.section1WeekRange2.0": "枚举值0的含义",
  "50901.ctrl_dianwangjiaohu.section1WeekRange2.1": "枚举值1的含义",
  "50901.ctrl_dianwangjiaohu.section2WeekRange1.00": "枚举值0的含义",
  "50901.ctrl_dianwangjiaohu.section2WeekRange1.01": "枚举值2的含义",
  "50901.ctrl_dianwangjiaohu.section3WeekRange1.0": "枚举值0的含义",
  "50901.ctrl_dianwangjiaohu.section3WeekRange1.1": "枚举值2的含义",
  "50901.ctrl_dianwangjiaohu.section3WeekRange2.0": "枚举值0的含义",
  "50901.ctrl_dianwangjiaohu.section3WeekRange2.1": "枚举值1的含义",
  "50901.ctrl_dianwangjiaohu.section4WeekRange1.0": "枚举值0的含义",
  "50901.ctrl_dianwangjiaohu.section4WeekRange1.1": "枚举值2的含义",
  "50901.ctrl_dianwangjiaohu.section4WeekRange2.0": "枚举值0的含义",
  "50901.ctrl_dianwangjiaohu.section4WeekRange2.1": "枚举值1的含义",
  "50901.ctrl_xitongjichupeizhi.hpWorkMode.0": "否",
  "50901.ctrl_xitongjichupeizhi.hpWorkMode.1": "是",
  "50901.ctrl_xitongjichupeizhi.hpBattSocDetectMode.0": "否",
  "50901.ctrl_xitongjichupeizhi.hpBattSocDetectMode.1": "是",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange.0": "枚举值0的含义",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange.1": "枚举值1的含义",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange.0": "枚举值0的含义",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange.1": "枚举值1的含义",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange.0": "枚举值0的含义",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange.1": "枚举值1的含义",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange.0": "枚举值0的含义",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange.1": "枚举值1的含义",
  "50901.ctrl_xitongjichupeizhi.networkingType.1": "WIFI",
  "50901.ctrl_xitongjichupeizhi.networkingType.2": "以太网",
  "50901.real_time.invRatedPower.desc": "额定功率的说明。",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.desc": "DRM状态（澳洲/德国/奥地利国家下使用）的说明。",
  "50901.real_time.masterSlave.desc": "主机/从机的说明。",
  "50901.real_time.invRunningtime.desc": "INV运行时长\n禾迈：机器正常运行的时间的说明。",
  "50901.real_time.pvPowerWholeSystem.desc": "PV总功率（整个系统）的说明。",
  "50901.real_time.batteryPowerWholeSystem.desc": "电池总功率（整个系统）的说明。",
  "50901.real_time.gridPowerWholeSystem.desc": "电网总功率（整个系统）的说明。",
  "50901.real_time.loadPowerWholeSystem.desc": "负载总功率（整个系统）的说明。",
  "50901.real_time.pv1Power.desc": "PV1功率的说明。",
  "50901.real_time.pv1Voltage.desc": "PV1电压的说明。",
  "50901.real_time.pv1Current.desc": "PV1电流的说明。",
  "50901.real_time.pvToBatteryPower.desc": "光伏流向电池的功率的说明。",
  "50901.real_time.pvToGridPower.desc": "光伏流向电网的功率的说明。",
  "50901.real_time.pvToLoadPower.desc": "光伏流向负载的功率的说明。",
  "50901.real_time.generatorPowerA.desc": "发电机A相功率的说明。",
  "50901.real_time.generatorPowerB.desc": "发电机B相功率的说明。",
  "50901.real_time.generatorPowerC.desc": "发电机C相功率的说明。",
  "50901.real_time.generatorVoltageA.desc": "发电机A相电压的说明。",
  "50901.real_time.generatorCurrentA.desc": "发电机A相电流的说明。",
  "50901.real_time.pvMeterConnectionStatus.desc": "PV电表连接状态的说明。",
  "50901.real_time.pvMeterPowerA.desc": "PV电表A相功率的说明。",
  "50901.real_time.pvMeterVoltageA.desc": "PV电表A相电压的说明。",
  "50901.real_time.pvMeterCurrentA.desc": "PV电表A相电流的说明。",
  "50901.real_time.batteryConnectionStatus.desc": "是否连接电池的说明。",
  "50901.real_time.batteryType_04.desc": "电池类型的说明。",
  "50901.real_time.batteryPower.desc": "电池功率（充电/放电）的说明。",
  "50901.real_time.packNum.desc": "并联数量（电池Pack个数）的说明。",
  "50901.real_time.gridReactivePowerA.desc": "电网侧A相无功功率的说明。",
  "50901.real_time.gridPowerFactorA.desc": "电网侧A相功率因数的说明。",
  "50901.real_time.epsPower.desc": "EPS侧功率的说明。",
  "50901.real_time.epsVoltageA.desc": "EPS侧A相电压的说明。",
  "50901.real_time.epsCurrentA.desc": "EPS侧A相电流的说明。",
  "50901.real_time.rssi.desc": "信号强度的说明。",
  "50901.ctrl_xitongjichupeizhi.systemPowerOnOff.desc": "系统开关机的说明。",
  "50901.ctrl_xitongjichupeizhi.workMode.desc": "EMS工作模式的说明。",
  "50901.ctrl_xitongjichupeizhi.gridType.desc": "电网标准的说明。",
  "50901.ctrl_xitongjichupeizhi.bypassDisable.desc": "绕过禁用的说明。",
  "50901.ctrl_xitongjichupeizhi.epsMode.desc": "EPS模式的说明。",
  "50901.ctrl_xitongjichupeizhi.pvIslandModeEn.desc": "PV模式使能的说明。",
  "50901.ctrl_dianchiguanli.batActivate.desc": "电池激活的说明。",
  "50901.ctrl_xitongjichupeizhi.restartSystem.desc": "重启系统的说明。",
  "50901.ctrl_anquanbaohu.restoreDefault.desc": "恢复默认值的说明。",
  "50901.ctrl_anquanbaohu.clearFault.desc": "清除故障的说明。",
  "50901.ctrl_gaojigongneng.selfTest.desc": "自检的说明。",
  "50901.ctrl_anquanbaohu.arcFaultClear.desc": "电弧故障清除的说明。",
  "50901.ctrl_dianchiguanli.batteryBalancing.desc": "电池平衡的说明。",
  "50901.real_time.parallelNetworking.desc": "并行网络的说明。",
  "50901.ctrl_xitongjichupeizhi.meterConfiguration.desc": "仪表配置的说明。",
  "50901.ctrl_dianchiguanli.equalizationChargeTimeout.desc": "均衡充电超时的说明。",
  "50901.ctrl_xitongjichupeizhi.dryWorkingMode.desc": "干节点工作模式的说明。",
  "50901.ctrl_xitongjichupeizhi.loadControlMode.desc": "负载控制模式的说明。",
  "50901.ctrl_xitongjichupeizhi.manualModeSwitch.desc": "手动模式开关的说明。",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange1.desc": "负载控制星期一的说明。",
  "50901.ctrl_gaojigongneng.weekRange2.desc": "星期二的说明。",
  "50901.ctrl_xitongjichupeizhi.generatorMode.desc": "发电机模式的说明。",
  "50901.ctrl_xitongjichupeizhi.genPracticeModeEn.desc": "发电机练习模式的说明。",
  "50901.ctrl_dianwangjiaohu.genPracticeFreq.desc": "发电机练习模式频率的说明。",
  "50901.ctrl_xitongjichupeizhi.genPracticeModeWeek.desc": "发电机练习模式启动时间的说明。",
  "50901.ctrl_dianwangjiaohu.section1WeekRange1.desc": "section1周范围1的说明。",
  "50901.ctrl_dianwangjiaohu.section2WeekRange1.desc": "section2周范围1的说明。",
  "50901.ctrl_dianwangjiaohu.section3WeekRange1.desc": "section3周范围1的说明。",
  "50901.ctrl_dianwangjiaohu.section4WeekRange1.desc": "section4周范围1的说明。",
  "50901.ctrl_dianwangjiaohu.section4WeekRange2.desc": "section4周范围2的说明。",
  "50901.ctrl_xitongjichupeizhi.hpWorkMode.desc": "HP工作模式的说明。",
  "50901.ctrl_xitongjichupeizhi.hpBattSocDetectMode.desc": "HPBattSoc检测模式的说明。",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange.desc": "位0:星期一\n位1:星期二\n位2:星期三\n位3:星期四\n位4:星期五\n位5:星期六\n位6:星期日",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange.desc": "位0:星期一\n位1:星期二\n位2:星期三\n位3:星期四\n位4:星期五\n位5:星期六\n位6:星期日",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange.desc": "位0:星期一\n位1:星期二\n位2:星期三\n位3:星期四\n位4:星期五\n位5:星期六\n位6:星期日",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange.desc": "位0:星期一\n位1:星期二\n位2:星期三\n位3:星期四\n位4:星期五\n位5:星期六\n位6:星期日",
  "50901.ctrl_xitongjichupeizhi.networkingType.desc": "联网类型的说明。",
  "50901.ctrl_gaojigongneng": "高级功能",
  "50901.ctrl_fuzaikongzhi": "负载控制",
  "50901.real_time": "实时监控",
  "50901.ctrl_xitongjichupeizhi": "系统基础配置",
  "50901.ctrl_dianwangjiaohu": "电网交互",
  "50901.ctrl_anquanbaohu": "安全保护",
  "unit.norway": "Norway",
  "country.norway": "norwayAreas",
  "nether.areas": "NL",
  "nether.areas2": "NL2",
  "60420.real_time.id": "设备ID",
  "60420.real_time.collectorSn": "采集器序列号",
  "60420.real_time.deviceSn": "设备序列号",
  "60420.real_time.ratedPower": "机器额定功率",
  "60420.ctrl_param_shebeixinxishezhi.remoteShutdown": "远程关机",
  "60420.ctrl_param_shebeixinxishezhi.activePowerSet": "有功功率设置百分比",
  "60420.ctrl_param_shebeixinxishezhi.reactivePowerSet": "无功功率设置百分比",
  "60420.ctrl_param_qidongdianya_pinlvshezhi.pvStartVol": "PV启动电压",
  "60420.ctrl_param_qidongdianya_pinlvshezhi.acStartHighVol": "AC启动高压",
  "60420.ctrl_param_qidongdianya_pinlvshezhi.acStartLowVol": "AC启动低压",
  "60420.ctrl_param_qidongdianya_pinlvshezhi.acStartHighFreq": "AC启动高频",
  "60420.ctrl_param_qidongdianya_pinlvshezhi.acStartLowFreq": "AC启动低频",
  "60420.ctrl_param_qidongdianya_pinlvshezhi.startDelayTime": "启动延时时间",
  "60420.ctrl_param_qidongdianya_pinlvshezhi.restartDelayTime": "重启延时时间",
  "60420.ctrl_param_guoqianya_pinshezhi.acUnderVol1": "AC欠压一阶",
  "60420.ctrl_param_guoqianya_pinshezhi.acOverVol1": "AC过压一阶",
  "60420.ctrl_param_guoqianya_pinshezhi.acUnderVolTime1": "AC欠压一阶时间",
  "60420.ctrl_param_guoqianya_pinshezhi.acOverVolTime1": "AC过压一阶时间",
  "60420.ctrl_param_guoqianya_pinshezhi.acUnderVol2": "AC欠压二阶",
  "60420.ctrl_param_guoqianya_pinshezhi.acOverVol2": "AC过压二阶",
  "60420.ctrl_param_guoqianya_pinshezhi.acUnderVolTime2": "AC欠压二阶时间",
  "60420.ctrl_param_guoqianya_pinshezhi.acOverVolTime2": "AC过压二阶时间",
  "60420.ctrl_param_guoqianya_pinshezhi.acUnderFrequency1": "AC欠频一阶",
  "60420.ctrl_param_guoqianya_pinshezhi.acOverFrequency1": "AC过频一阶",
  "60420.ctrl_param_guoqianya_pinshezhi.acUnderFrequencyTime1": "AC欠频一阶时间",
  "60420.ctrl_param_guoqianya_pinshezhi.acOverFrequencyTime1": "AC过频一阶时间",
  "60420.ctrl_param_guoqianya_pinshezhi.acUnderFrequency2": "AC欠频二阶",
  "60420.ctrl_param_guoqianya_pinshezhi.acOverFrequency2": "AC过频二阶",
  "60420.ctrl_param_guoqianya_pinshezhi.acUnderFrequencyTime2": "AC欠频二阶时间",
  "60420.ctrl_param_guoqianya_pinshezhi.acOverFrequencyTime2": "AC过频二阶时间",
  "60420.ctrl_param_shebeixinxishezhi.startLoadingSlope": "启动加载斜率",
  "60420.real_time.sn": "逆变器SN号",
  "60420.real_time.softwareFlag": "软件版本标识",
  "60420.real_time.softwareVersion1": "软件版本号1",
  "60420.real_time.softwareVersion2": "软件版本号2",
  "60420.real_time.softwareVersion3": "软件版本号3",
  "60420.real_time.softwareVersion4": "软件版本号4",
  "60420.real_time.versionStr": "版本字符串",
  "60420.real_time.masterAlarmCode": "主告警码",
  "60420.real_time.subAlarmCode": "子告警码",
  "60420.real_time.masterFaultCode": "主故障码",
  "60420.real_time.subFaultCode": "子故障码",
  "60420.real_time.alarmBit": "告警位",
  "60420.real_time.faultBit": "故障位",
  "60420.real_time.pbusVol": "PBUS电压",
  "60420.real_time.nbusVol": "NBUS电压",
  "60420.real_time.rsGirdVol": "RS电网线电压",
  "60420.real_time.stGirdVol": "ST电网线电压",
  "60420.real_time.trGridVol": "TR电网线电压",
  "60420.real_time.rGridVol": "R电网相电压",
  "60420.real_time.sGridVol": "S电网相电压",
  "60420.real_time.tGridVol": "T电网相电压",
  "60420.real_time.rOnGridCurrent": "R相并网电流",
  "60420.real_time.sOnGridCurrent": "S相并网电流",
  "60420.real_time.tOnGridCurrent": "T相并网电流",
  "60420.real_time.rsGridFrequency": "RS电网频率",
  "60420.real_time.onGridCountdown": "并网倒计时",
  "60420.real_time.loadPower": "负载功率",
  "60420.real_time.pvPower": "有功功率",
  "60420.real_time.reactivePower": "无功功率",
  "60420.real_time.powerFactor": "功率因数",
  "60420.real_time.invRTemp": "INV模块R温度",
  "60420.real_time.invSTemp": "INV模块S温度",
  "60420.real_time.invTTemp": "INV模块T温度",
  "60420.real_time.envTemp": "环境温度",
  "60420.real_time.radiatorTemp": "散热器温度",
  "60420.real_time.gridPower": "电表功率",
  "60420.real_time.leakCurrent": "漏电流",
  "60420.real_time.deratedPower": "降额功率",
  "60420.real_time.loadDropMode": "降载模式",
  "60420.real_time.pvChargeTime": "发电时间",
  "60420.real_time.todayPvEnergy": "当天发电量",
  "60420.real_time.powerGeneration": "总发电量",
  "60420.real_time.rPhaseDci": "R相DCI",
  "60420.real_time.sPhaseDci": "S相DCI",
  "60420.real_time.tPhaseDci": "T相DCI",
  "60420.real_time.dcInsulationImpedance": "直流绝缘阻抗",
  "60420.real_time.pvInputVol1": "PV1输入电压",
  "60420.real_time.pvInputCurrent1": "PV1输入电流",
  "60420.real_time.pvInputVol2": "PV2输入电压",
  "60420.real_time.pvInputCurrent2": "PV2输入电流",
  "60420.real_time.pvInputVol3": "PV3输入电压",
  "60420.real_time.pvInputCurrent3": "PV3输入电流",
  "60420.real_time.pvInputVol4": "PV4输入电压",
  "60420.real_time.pvInputCurrent4": "PV4输入电流",
  "60420.real_time.pvInputVol5": "PV5输入电压",
  "60420.real_time.pvInputCurrent5": "PV5输入电流",
  "60420.real_time.pvInputVol6": "PV6输入电压",
  "60420.real_time.pvInputCurrent6": "PV6输入电流",
  "60420.real_time.pvInputVol7": "PV7输入电压",
  "60420.real_time.pvInputCurrent7": "PV7输入电流",
  "60420.real_time.pvInputVol8": "PV8输入电压",
  "60420.real_time.pvInputCurrent8": "PV8输入电流",
  "60420.real_time.pvInputVol9": "PV9输入电压",
  "60420.real_time.pvInputCurrent9": "PV9输入电流",
  "60420.real_time.pvInputVol10": "PV10输入电压",
  "60420.real_time.pvInputCurrent10": "PV10输入电流",
  "60420.real_time.pvInputVol11": "PV11输入电压",
  "60420.real_time.pvInputCurrent11": "PV11输入电流",
  "60420.real_time.pvInputVol12": "PV12输入电压",
  "60420.real_time.pvInputCurrent12": "PV12输入电流",
  "60420.real_time.groupStrCurrent1": "组串1电流",
  "60420.real_time.groupStrCurrent3": "组串3电流",
  "60420.real_time.groupStrCurrent5": "组串5电流",
  "60420.real_time.groupStrCurrent7": "组串7电流",
  "60420.real_time.groupStrCurrent9": "组串9电流",
  "60420.real_time.groupStrCurrent11": "组串11电流",
  "60420.real_time.groupStrCurrent13": "组串13电流",
  "60420.real_time.groupStrCurrent15": "组串15电流",
  "60420.real_time.groupStrCurrent17": "组串17电流",
  "60420.real_time.groupStrCurrent19": "组串19电流",
  "60420.real_time.groupStrCurrent21": "组串21电流",
  "60420.real_time.groupStrCurrent23": "组串23电流",
  "60420.real_time.scanStatus": "I/V扫描状态",
  "60420.real_time.scanPercentage": "I/V扫描百分比",
  "60420.real_time.btDspDebugInfo1": "BT DSP调试信息1",
  "60420.real_time.btDspDebugInfo2": "BT DSP调试信息2",
  "60420.real_time.btDspDebugInfo3": "BT DSP调试信息3",
  "60420.real_time.btDspDebugInfo4": "BT DSP调试信息4",
  "60420.real_time.btDspDebugInfo5": "BT DSP调试信息5",
  "60420.real_time.btDspDebugInfo6": "BT DSP调试信息6",
  "60420.real_time.btDspDebugInfo7": "BT DSP调试信息7",
  "60420.real_time.btDspDebugInfo8": "BT DSP调试信息8",
  "60420.real_time.invDspDebugInfo1": "INV DSP调试信息1",
  "60420.real_time.invDspDebugInfo2": "INV DSP调试信息2",
  "60420.real_time.invDspDebugInfo3": "INV DSP调试信息3",
  "60420.real_time.invDspDebugInfo4": "INV DSP调试信息4",
  "60420.real_time.invDspDebugInfo5": "INV DSP调试信息5",
  "60420.real_time.invDspDebugInfo6": "INV DSP调试信息6",
  "60420.real_time.invDspDebugInfo7": "INV DSP调试信息7",
  "60420.real_time.invDspDebugInfo8": "INV DSP调试信息8",
  "60420.real_time.armDebugInfo1": "ARM调试信息1",
  "60420.real_time.armDebugInfo2": "ARM调试信息2",
  "60420.real_time.armDebugInfo3": "ARM调试信息3",
  "60420.real_time.armDebugInfo4": "ARM调试信息4",
  "60420.real_time.armDebugInfo5": "ARM调试信息5",
  "60420.real_time.armDebugInfo6": "ARM调试信息6",
  "60420.real_time.armDebugInfo7": "ARM调试信息7",
  "60420.real_time.groupStrCurrent2": "组串2电流",
  "60420.real_time.groupStrCurrent4": "组串4电流",
  "60420.real_time.groupStrCurrent6": "组串6电流",
  "60420.real_time.groupStrCurrent8": "组串8电流",
  "60420.real_time.groupStrCurrent10": "组串10电流",
  "60420.real_time.groupStrCurrent12": "组串12电流",
  "60420.real_time.groupStrCurrent14": "组串14电流",
  "60420.real_time.groupStrCurrent16": "组串16电流",
  "60420.real_time.groupStrCurrent18": "组串18电流",
  "60420.real_time.groupStrCurrent20": "组串20电流",
  "60420.real_time.groupStrCurrent22": "组串22电流",
  "60420.real_time.pvPower1": "PV1功率",
  "60420.real_time.pvPower2": "PV2功率",
  "60420.real_time.pvPower3": "PV3功率",
  "60420.real_time.pvPower4": "PV4功率",
  "60420.real_time.pvPower5": "PV5功率",
  "60420.real_time.pvPower6": "PV6功率",
  "60420.real_time.pvPower7": "PV7功率",
  "60420.real_time.pvPower8": "PV8功率",
  "60420.real_time.pvPower9": "PV9功率",
  "60420.real_time.pvPower10": "PV10功率",
  "60420.real_time.pvPower11": "PV11功率",
  "60420.real_time.pvPower12": "PV12功率",
  "60420.real_time.acPower": "AC功率",
  "60420.fault.0X3809_F_0101": "PV 电压低",
  "60420.fault.0X3809_F_0102": "PV 电压高",
  "60420.fault.0X3809_F_0103": "PV 面板短路",
  "60420.fault.0X3809_F_0301": "BUS 电压低",
  "60420.fault.0X3809_F_0302": "BUS 电压高",
  "60420.fault.0X3809_F_0303": "BUS 电压不平衡",
  "60420.fault.0X3809_F_0304": "硬件 bus 过压",
  "60420.fault.0X3809_F_0501": "逆变硬件过流",
  "60420.fault.0X3809_F_0502": "逆变软件过流",
  "60420.fault.0X3809_F_0503": "BOOST 硬件过流",
  "60420.fault.0X3809_F_0504": "BOOST 软件过流",
  "60420.fault.0X3809_F_0505": "辅源硬件 TZ 故障",
  "60420.fault.0X3809_F_0506": "Bus 硬件 TZ 过压",
  "60420.fault.0X3809_F_0507": "LLC 侧硬件 TZ 故障",
  "60420.fault.0X3809_F_0508": "Buck-Boost 软件过流",
  "60420.fault.0X3809_F_0601": "逆变温度过温",
  "60420.fault.0X3809_F_0602": "BOOST 过温",
  "60420.fault.0X3809_F_0603": "散热器过温",
  "60420.fault.0X3809_F_0604": "环境过温",
  "60420.fault.0X3809_F_0605": "Buck-Boost 温度异常",
  "60420.fault.0X3809_F_0606": "NTC 开路",
  "60420.fault.0X3809_F_0607": "PV 端子过温保护故障",
  "60420.fault.0X3809_F_0701": "绝缘检测故障",
  "60420.fault.0X3809_F_0801": "驱动故障",
  "60420.fault.0X3809_F_0901": "主 DSP 接收 ARM 通讯故障",
  "60420.fault.0X3809_F_0902": "ARM 接收主 DSP 通讯故障",
  "60420.fault.0X3809_F_0903": "主 DSP 接收 ARM 通讯故障",
  "60420.fault.0X3809_F_0904": "  ARM 接收主 DSP 通讯故障",
  "60420.fault.0X3809_F_0905": "主从芯片通讯故障-主芯片故障",
  "60420.fault.0X3809_F_0906": " 主从芯片通讯故障-从芯片故障",
  "60420.fault.0X3809_F_0907": "DSP 与 AFCI 通信故障",
  "60420.fault.0X3809_F_1001": "静态漏电流高",
  "60420.fault.0X3809_F_1002": "30mA 突变故障",
  "60420.fault.0X3809_F_1003": "60mA 突变故障",
  "60420.fault.0X3809_F_1004": "150mA 突变故障",
  "60420.fault.0X3809_F_1101": "继电器开路",
  "60420.fault.0X3809_F_1102": "继电器短路",
  "60420.fault.0X3809_F_1103": "继电器自检异常",
  "60420.fault.0X3809_F_1201": "两个内部风扇均故障",
  "60420.fault.0X3809_F_1401": "R 相 DCI 故障",
  "60420.fault.0X3809_F_1402": "S 相 DCI 故障",
  "60420.fault.0X3809_F_1403": "T 相 DCI 故障",
  "60420.fault.0X3809_F_1901": "AC 电压检测不一致",
  "60420.fault.0X3809_F_1902": "BUS 电压检测不一致",
  "60420.fault.0X3809_F_1903": "ISO 电压检测不一致",
  "60420.fault.0X3809_F_1904": "PV 电压检测不一致",
  "60420.fault.0X3809_F_1905": "GFCI 不一致",
  "60420.fault.0X3809_F_1906": "Bus 电压采样异常",
  "60420.fault.0X3809_F_1907": "PV 电流采样异常",
  "60420.fault.0X3809_F_3101": "市电欠压 1 阶",
  "60420.fault.0X3809_F_3102": "市电过压 1 阶",
  "60420.fault.0X3809_F_3103": "无市电电压",
  "60420.fault.0X3809_F_3104": "市电欠压 2 阶",
  "60420.fault.0X3809_F_3105": "市电过压 2 阶",
  "60420.fault.0X3809_F_3106": "市电启动欠压",
  "60420.fault.0X3809_F_3107": "市电启动过压",
  "60420.fault.0X3809_F_3108": "中断瞬时过压",
  "60420.fault.0X3809_F_3109": "孤岛过压",
  "60420.fault.0X3809_F_3110": "电网电压震荡",
  "60420.fault.0X3809_F_3111": "市电欠压 3 阶",
  "60420.fault.0X3809_F_3112": "电网电压锁相故障",
  "60420.fault.0X3809_F_3113": "电网相序异常",
  "60420.fault.0X3809_F_3301": "市电欠频 1 阶",
  "60420.fault.0X3809_F_3302": "市电过频 1 阶",
  "60420.fault.0X3809_F_3303": " 市电欠频 2 阶",
  "60420.fault.0X3809_F_3304": "市电过频 2 阶",
  "60420.fault.0X3809_F_3305": "市电启动欠频",
  "60420.fault.0X3809_F_3306": " 市电启动过频",
  "60420.fault.0X3809_F_3701": " 远程关机指令",
  "60420.fault.0X3809_F_3801": "组串 1 故障",
  "60420.fault.0X3809_F_3802": "组串 2 故障",
  "60420.fault.0X3809_F_3803": "组串 3 故障",
  "60420.fault.0X3809_F_3804": "组串 4 故障",
  "60420.fault.0X3809_F_3805": "组串 5 故障",
  "60420.fault.0X3809_F_3806": "组串 6 故障",
  "60420.fault.0X3809_F_3807": "组串 7 故障",
  "60420.fault.0X3809_F_3808": "组串 8 故障",
  "60420.fault.0X3809_F_3809": "组串 9 故障",
  "60420.fault.0X3809_F_3810": "组串 10 故障",
  "60420.fault.0X3809_F_3811": "组串 11 故障",
  "60420.fault.0X3809_F_3812": "组串 12 故障",
  "60420.fault.0X3809_F_3813": "组串 13 故障",
  "60420.fault.0X3809_F_3814": "组串 14 故障",
  "60420.fault.0X3809_F_3815": "组串 15 故障",
  "60420.fault.0X3809_F_3816": "组串 16 故障",
  "60420.fault.0X3809_F_3817": "组串 17 故障",
  "60420.fault.0X3809_F_3818": "组串 18 故障",
  "60420.fault.0X3809_F_3819": "组串 19 故障",
  "60420.fault.0X3809_F_3820": "组串 20 故障",
  "60420.fault.0X3809_F_3901": "组串 1 自检报警",
  "60420.fault.0X3809_F_3902": "组串 2 自检报警",
  "60420.fault.0X3809_F_3903": "组串 3 自检报警",
  "60420.fault.0X3809_F_3904": "组串 4 自检报警",
  "60420.fault.0X3809_F_3905": "组串 5 自检报警",
  "60420.fault.0X3809_F_3906": "组串 6 自检报警",
  "60420.fault.0X3809_F_3907": "组串 7 自检报警",
  "60420.fault.0X3809_F_3908": "组串 8 自检报警",
  "60420.fault.0X3809_F_3909": "组串 9 自检报警",
  "60420.fault.0X3809_F_3910": "组串 10 自检报警",
  "60420.fault.0X3809_F_3911": "组串 11 自检报警",
  "60420.fault.0X3809_F_3912": "组串 12 自检报警",
  "60420.fault.0X3809_F_3913": "组串 13 自检报警",
  "60420.fault.0X3809_F_3914": "组串 14 自检报警",
  "60420.fault.0X3809_F_3915": "组串 15 自检报警",
  "60420.fault.0X3809_F_3916": "组串 16 自检报警",
  "60420.fault.0X3809_F_3917": "组串 17 自检报警",
  "60420.fault.0X3809_F_3918": "组串 18 自检报警",
  "60420.fault.0X3809_F_3919": "组串 19 自检报警",
  "60420.fault.0X3809_F_3920": "组串 20 自检报警",
  "60420.fault.0X3809_F_4101": "自动测试失败故障",
  "60420.fault.0X3809_F_4201": "N-PE 电压异常故障",
  "60420.fault.0X3809_F_4301": "漏电流自检故障",
  "60420.fault.0X3809_F_4401": "组串故障",
  "60420.fault.0X3809_F_4501": "辅助电源掉电",
  "60420.warn.0X3807_F_0101": "风扇 1",
  "60420.warn.0X3807_F_0102": "风扇 2",
  "60420.warn.0X3807_F_0103": "风扇 3",
  "60420.warn.0X3807_F_0104": "风扇 4",
  "60420.warn.0X3807_F_0105": "风扇 5",
  "60420.warn.0X3807_F_0106": "风扇 6",
  "60420.warn.0X3807_F_0107": "内部风扇 1",
  "60420.warn.0X3807_F_0108": "内部风扇 2",
  "60420.warn.0X3807_F_0109": "风扇 9",
  "60420.warn.0X3807_F_0110": "风扇 10",
  "60420.warn.0X3807_F_0201": "DC 防雷器",
  "60420.warn.0X3807_F_0202": "AC 防雷器",
  "60420.warn.0X3807_F_0301": "组串 1",
  "60420.warn.0X3807_F_0302": "组串 2",
  "60420.warn.0X3807_F_0303": "组串 3",
  "60420.warn.0X3807_F_0304": "组串 4",
  "60420.warn.0X3807_F_0305": "组串 5",
  "60420.warn.0X3807_F_0306": "组串 6",
  "60420.warn.0X3807_F_0307": "组串 7",
  "60420.warn.0X3807_F_0308": "组串 8",
  "60420.warn.0X3807_F_0309": "组串 9",
  "60420.warn.0X3807_F_0310": "组串 10",
  "60420.warn.0X3807_F_0311": "组串 11",
  "60420.warn.0X3807_F_0312": "组串 12",
  "60420.warn.0X3807_F_0313": "组串 13",
  "60420.warn.0X3807_F_0314": "组串 14",
  "60420.warn.0X3807_F_0315": "组串 15",
  "60420.warn.0X3807_F_0316": "组串 16",
  "60420.warn.0X3807_F_0317": "组串 17",
  "60420.warn.0X3807_F_0318": "组串 18",
  "60420.warn.0X3807_F_0319": "组串 19",
  "60420.warn.0X3807_F_0320": "组串 10",
  "60420.warn.0X3807_F_0321": "组串 21",
  "60420.warn.0X3807_F_0322": "组串 22",
  "60420.warn.0X3807_F_0323": "组串 23",
  "60420.warn.0X3807_F_0324": "组串 24",
  "60420.warn.0X3807_F_0401": "A 相电表异常警告",
  "60420.warn.0X3807_F_0402": "B 相电表异常警告",
  "60420.warn.0X3807_F_0404": "C 相电表异常警告",
  "60420.warn.0X3807_F_0408": "电表通讯异常警告",
  "60420.warn.0X3807_F_0416": "CT 接线异常警告",
  "60420.warn.0X3807_F_0500": "电压超范围告警",
  "60420.warn.0X3807_F_0601": "PV1 短路告警",
  "60420.warn.0X3807_F_0602": "PV2 短路告警",
  "60420.warn.0X3807_F_0603.+++": "PV 电压低告警",
  "60420.group_1.numberInput_int": "_numberInput_int",
  "60420.group_1.numberInput_long": "_numberInput_int",
  "60420.group_1.numberInput_float": "_numberInput_int",
  "60420.group_1.numberInput_double": "_numberInput_int",
  "60420.group_1.stringInput": "_stringInput",
  "60420.group_1.select_boolean": "_select_boolean",
  "60420.group_1.select_enum": "_select_enum",
  "60420.group_1.date_1": "_date_1",
  "60420.group_1.date_2": "_date_2",
  "60420.group_1.date_3": "_date_3",
  "60420.ctrl_fangniliushezhi.singleReverseFlowEnable": "单机防逆流使能",
  "60420.ctrl_fangniliushezhi.multiReverseFlowEnable": "多机防逆流使能",
  "60420.ctrl_fangniliushezhi.meterSelect": "防逆流电表",
  "60420.ctrl_fangniliushezhi.AllowCounterCurrentPower": "允许逆流功率",
  "60420.ctrl_fangniliushezhi.restrictCounterCurrent": "限制逆流方式",
  "60420.real_time.gridBuyPower": "电网买电（总购电量）",
  "60420.real_time.gridSellPower": "电网卖电（总并网量）",
  "60420.real_time.meterCommQuality": "电表通讯质量",
  "60420.real_time.meterRPower": "电表R相功率",
  "60420.real_time.meterSPower": "电表S相功率",
  "60420.real_time.meterTPower": "电表T相功率",
  "60420.real_time.rGridPower": "R 相并网功率",
  "60420.real_time.sGridPower": "S 相并网功率",
  "60420.real_time.tGridPower": "T 相并网功率",
  "60420.ctrl_param_shebeixinxishezhi.remoteShutdown.21845": "开机",
  "60420.ctrl_param_shebeixinxishezhi.remoteShutdown.43690": "关机",
  "60420.ctrl_param_shebeixinxishezhi.reactiveControlSet.0": "功率因数控制",
  "60420.ctrl_param_shebeixinxishezhi.reactiveControlSet.1": "无功功率百分比控制",
  "60420.ctrl_param_shebeixinxishezhi.reactiveControlSet.2": "QV 曲线控制(掉电保存)",
  "60420.ctrl_param_shebeixinxishezhi.inputModeSet.0": "输入独立模式",
  "60420.ctrl_param_shebeixinxishezhi.inputModeSet.1": "输入并联模式",
  "60420.ctrl_param_shebeixinxishezhi.inputModeSet.2": "直流源模式(老化模式) (掉电保存)",
  "60420.real_time.workStatus.0": "初始化",
  "60420.real_time.workStatus.1": "等待",
  "60420.real_time.workStatus.2": "正常",
  "60420.real_time.workStatus.3": "故障",
  "60420.real_time.workStatus.4": "烧录",
  "60420.real_time.internalHardwareError.0": "无异常",
  "60420.real_time.internalHardwareError.1": "外部 FLASH 异常",
  "60420.real_time.internalHardwareError.2": "读 EEPROM 异常",
  "60420.real_time.internalHardwareError.3": "写 EEPROM 异常",
  "60420.real_time.internalHardwareError.4": "GFCI 自检失败",
  "60420.group_1.select_enum.value_1": "text_2",
  "60420.group_1.select_enum.value_2": "test_2",
  "60420.real_time.id.desc": "设备唯一标识ID",
  "60420.real_time.collectorSn.desc": "数据采集器唯一识别码",
  "60420.real_time.deviceSn.desc": "设备序列号的说明。",
  "60420.real_time.ratedPower.desc": "机器额定功率的说明。",
  "60420.ctrl_param_shebeixinxishezhi.remoteShutdown.desc": "远程关机的说明。",
  "60420.ctrl_param_shebeixinxishezhi.activePowerSet.desc": "有功功率设置百分比的说明。",
  "60420.ctrl_param_shebeixinxishezhi.reactiveControlSet.desc": "无功控制方式设置的说明。",
  "60420.ctrl_param_shebeixinxishezhi.reactivePowerSet.desc": "无功功率设置百分比的说明。",
  "60420.ctrl_param_shebeixinxishezhi.inputModeSet.desc": "需\"关机\"后设置，\"并网状态\"时配置无效",
  "60420.ctrl_param_qidongdianya_pinlvshezhi.pvStartVol.desc": "PV启动电压的说明。",
  "60420.ctrl_param_qidongdianya_pinlvshezhi.acStartHighVol.desc": "AC启动高压的说明。",
  "60420.ctrl_param_qidongdianya_pinlvshezhi.acStartLowVol.desc": "AC启动低压的说明。",
  "60420.ctrl_param_qidongdianya_pinlvshezhi.acStartHighFreq.desc": "AC启动高频的说明。",
  "60420.ctrl_param_qidongdianya_pinlvshezhi.acStartLowFreq.desc": "AC启动低频的说明。",
  "60420.ctrl_param_qidongdianya_pinlvshezhi.startDelayTime.desc": "启动延时时间的说明。",
  "60420.ctrl_param_qidongdianya_pinlvshezhi.restartDelayTime.desc": "重启延时时间的说明。",
  "60420.ctrl_param_guoqianya_pinshezhi.acUnderVol1.desc": "AC欠压一阶的说明。",
  "60420.ctrl_param_guoqianya_pinshezhi.acOverVol1.desc": "AC过压一阶的说明。",
  "60420.ctrl_param_guoqianya_pinshezhi.acUnderVolTime1.desc": "AC欠压一阶时间的说明。",
  "60420.ctrl_param_guoqianya_pinshezhi.acOverVolTime1.desc": "AC过压一阶时间的说明。",
  "60420.ctrl_param_guoqianya_pinshezhi.acUnderVol2.desc": "AC欠压二阶的说明。",
  "60420.ctrl_param_guoqianya_pinshezhi.acOverVol2.desc": "AC过压二阶的说明。",
  "60420.ctrl_param_guoqianya_pinshezhi.acUnderVolTime2.desc": "AC欠压二阶时间的说明。",
  "60420.ctrl_param_guoqianya_pinshezhi.acOverVolTime2.desc": "AC过压二阶时间的说明。",
  "60420.ctrl_param_guoqianya_pinshezhi.acUnderFrequency1.desc": "AC欠频一阶的说明。",
  "60420.ctrl_param_guoqianya_pinshezhi.acOverFrequency1.desc": "AC过频一阶的说明。",
  "60420.ctrl_param_guoqianya_pinshezhi.acUnderFrequencyTime1.desc": "AC欠频一阶时间的说明。",
  "60420.ctrl_param_guoqianya_pinshezhi.acOverFrequencyTime1.desc": "AC过频一阶时间的说明。",
  "60420.ctrl_param_guoqianya_pinshezhi.acUnderFrequency2.desc": "AC欠频二阶的说明。",
  "60420.ctrl_param_guoqianya_pinshezhi.acOverFrequency2.desc": "AC过频二阶的说明。",
  "60420.ctrl_param_guoqianya_pinshezhi.acUnderFrequencyTime2.desc": "AC欠频二阶时间的说明。",
  "60420.ctrl_param_guoqianya_pinshezhi.acOverFrequencyTime2.desc": "AC过频二阶时间的说明。",
  "60420.ctrl_param_shebeixinxishezhi.startLoadingSlope.desc": "启动加载斜率的说明。",
  "60420.real_time.sn.desc": "逆变器SN号的说明。",
  "60420.real_time.softwareFlag.desc": "软件版本标识的说明。",
  "60420.real_time.softwareVersion1.desc": "软件版本号1的说明。",
  "60420.real_time.softwareVersion2.desc": "软件版本号2的说明。",
  "60420.real_time.softwareVersion3.desc": "软件版本号3的说明。",
  "60420.real_time.softwareVersion4.desc": "软件版本号4的说明。",
  "60420.real_time.versionStr.desc": "版本字符串的说明。",
  "60420.real_time.workStatus.desc": "逆变器工作状态的说明。",
  "60420.real_time.masterAlarmCode.desc": "主告警码的说明。",
  "60420.real_time.subAlarmCode.desc": "子告警码的说明。",
  "60420.real_time.masterFaultCode.desc": "主故障码的说明。",
  "60420.real_time.subFaultCode.desc": "子故障码的说明。",
  "60420.real_time.alarmBit.desc": "告警位的说明。",
  "60420.real_time.faultBit.desc": "故障位的说明。",
  "60420.real_time.pbusVol.desc": "PBUS电压的说明。",
  "60420.real_time.nbusVol.desc": "NBUS电压的说明。",
  "60420.real_time.rsGirdVol.desc": "RS电网线电压的说明。",
  "60420.real_time.stGirdVol.desc": "ST电网线电压的说明。",
  "60420.real_time.trGridVol.desc": "TR电网线电压的说明。",
  "60420.real_time.rGridVol.desc": "R电网相电压的说明。",
  "60420.real_time.sGridVol.desc": "S电网相电压的说明。",
  "60420.real_time.tGridVol.desc": "T电网相电压的说明。",
  "60420.real_time.rOnGridCurrent.desc": "R相并网电流的说明。",
  "60420.real_time.sOnGridCurrent.desc": "S相并网电流的说明。",
  "60420.real_time.tOnGridCurrent.desc": "T相并网电流的说明。",
  "60420.real_time.rsGridFrequency.desc": "RS电网频率的说明。",
  "60420.real_time.onGridCountdown.desc": "并网倒计时的说明。",
  "60420.real_time.loadPower.desc": "负载功率的说明。",
  "60420.real_time.pvPower.desc": "有功功率的说明。",
  "60420.real_time.reactivePower.desc": "无功功率的说明。",
  "60420.real_time.powerFactor.desc": "功率因数的说明。",
  "60420.real_time.invRTemp.desc": "INV模块R温度的说明。",
  "60420.real_time.invSTemp.desc": "INV模块S温度的说明。",
  "60420.real_time.invTTemp.desc": "INV模块T温度的说明。",
  "60420.real_time.envTemp.desc": "环境温度的说明。",
  "60420.real_time.radiatorTemp.desc": "散热器温度的说明。",
  "60420.real_time.gridPower.desc": "电表功率的说明。",
  "60420.real_time.leakCurrent.desc": "漏电流的说明。",
  "60420.real_time.deratedPower.desc": "降额功率的说明。",
  "60420.real_time.loadDropMode.desc": "降载模式的说明。",
  "60420.real_time.pvChargeTime.desc": "发电时间的说明。",
  "60420.real_time.todayPvEnergy.desc": "当天发电量的说明。",
  "60420.real_time.powerGeneration.desc": "总发电量的说明。",
  "60420.real_time.rPhaseDci.desc": "R相DCI的说明。",
  "60420.real_time.sPhaseDci.desc": "S相DCI的说明。",
  "60420.real_time.tPhaseDci.desc": "T相DCI的说明。",
  "60420.real_time.dcInsulationImpedance.desc": "直流绝缘阻抗的说明。",
  "60420.real_time.pvInputVol1.desc": "PV1输入电压的说明。",
  "60420.real_time.pvInputCurrent1.desc": "PV1输入电流的说明。",
  "60420.real_time.pvInputVol2.desc": "PV2输入电压的说明。",
  "60420.real_time.pvInputCurrent2.desc": "PV2输入电流的说明。",
  "60420.real_time.pvInputVol3.desc": "PV3输入电压的说明。",
  "60420.real_time.pvInputCurrent3.desc": "PV3输入电流的说明。",
  "60420.real_time.pvInputVol4.desc": "PV4输入电压的说明。",
  "60420.real_time.pvInputCurrent4.desc": "PV4输入电流的说明。",
  "60420.real_time.pvInputVol5.desc": "PV5输入电压的说明。",
  "60420.real_time.pvInputCurrent5.desc": "PV5输入电流的说明。",
  "60420.real_time.pvInputVol6.desc": "PV6输入电压的说明。",
  "60420.real_time.pvInputCurrent6.desc": "PV6输入电流的说明。",
  "60420.real_time.pvInputVol7.desc": "PV7输入电压的说明。",
  "60420.real_time.pvInputCurrent7.desc": "PV7输入电流的说明。",
  "60420.real_time.pvInputVol8.desc": "PV8输入电压的说明。",
  "60420.real_time.pvInputCurrent8.desc": "PV8输入电流的说明。",
  "60420.real_time.pvInputVol9.desc": "PV9输入电压的说明。",
  "60420.real_time.pvInputCurrent9.desc": "PV9输入电流的说明。",
  "60420.real_time.pvInputVol10.desc": "PV10输入电压的说明。",
  "60420.real_time.pvInputCurrent10.desc": "PV10输入电流的说明。",
  "60420.real_time.pvInputVol11.desc": "PV11输入电压的说明。",
  "60420.real_time.pvInputCurrent11.desc": "PV11输入电流的说明。",
  "60420.real_time.pvInputVol12.desc": "PV12输入电压的说明。",
  "60420.real_time.pvInputCurrent12.desc": "PV12输入电流的说明。",
  "60420.real_time.groupStrCurrent1.desc": "组串1电流的说明。",
  "60420.real_time.groupStrCurrent3.desc": "组串3电流的说明。",
  "60420.real_time.groupStrCurrent5.desc": "组串5电流的说明。",
  "60420.real_time.groupStrCurrent7.desc": "组串7电流的说明。",
  "60420.real_time.groupStrCurrent9.desc": "组串9电流的说明。",
  "60420.real_time.groupStrCurrent11.desc": "组串11电流的说明。",
  "60420.real_time.groupStrCurrent13.desc": "组串13电流的说明。",
  "60420.real_time.groupStrCurrent15.desc": "组串15电流的说明。",
  "60420.real_time.groupStrCurrent17.desc": "组串17电流的说明。",
  "60420.real_time.groupStrCurrent19.desc": "组串19电流的说明。",
  "60420.real_time.groupStrCurrent21.desc": "组串21电流的说明。",
  "60420.real_time.groupStrCurrent23.desc": "组串23电流的说明。",
  "60420.real_time.scanStatus.desc": "I/V扫描状态的说明。",
  "60420.real_time.scanPercentage.desc": "I/V扫描百分比的说明。",
  "60420.real_time.btDspDebugInfo1.desc": "BT DSP调试信息1的说明。",
  "60420.real_time.btDspDebugInfo2.desc": "BT DSP调试信息2的说明。",
  "60420.real_time.btDspDebugInfo3.desc": "BT DSP调试信息3的说明。",
  "60420.real_time.btDspDebugInfo4.desc": "BT DSP调试信息4的说明。",
  "60420.real_time.btDspDebugInfo5.desc": "BT DSP调试信息5的说明。",
  "60420.real_time.btDspDebugInfo6.desc": "BT DSP调试信息6的说明。",
  "60420.real_time.btDspDebugInfo7.desc": "BT DSP调试信息7的说明。",
  "60420.real_time.btDspDebugInfo8.desc": "BT DSP调试信息8的说明。",
  "60420.real_time.invDspDebugInfo1.desc": "INV DSP调试信息1的说明。",
  "60420.real_time.invDspDebugInfo2.desc": "INV DSP调试信息2的说明。",
  "60420.real_time.invDspDebugInfo3.desc": "INV DSP调试信息3的说明。",
  "60420.real_time.invDspDebugInfo4.desc": "INV DSP调试信息4的说明。",
  "60420.real_time.invDspDebugInfo5.desc": "INV DSP调试信息5的说明。",
  "60420.real_time.invDspDebugInfo6.desc": "INV DSP调试信息6的说明。",
  "60420.real_time.invDspDebugInfo7.desc": "INV DSP调试信息7的说明。",
  "60420.real_time.invDspDebugInfo8.desc": "INV DSP调试信息8的说明。",
  "60420.real_time.armDebugInfo1.desc": "ARM调试信息1的说明。",
  "60420.real_time.armDebugInfo2.desc": "ARM调试信息2的说明。",
  "60420.real_time.armDebugInfo3.desc": "ARM调试信息3的说明。",
  "60420.real_time.armDebugInfo4.desc": "ARM调试信息4的说明。",
  "60420.real_time.armDebugInfo5.desc": "ARM调试信息5的说明。",
  "60420.real_time.armDebugInfo6.desc": "ARM调试信息6的说明。",
  "60420.real_time.armDebugInfo7.desc": "ARM调试信息7的说明。",
  "60420.real_time.internalHardwareError.desc": "机器内部硬件异常状态",
  "60420.real_time.groupStrCurrent2.desc": "组串2电流的说明。",
  "60420.real_time.groupStrCurrent4.desc": "组串4电流的说明。",
  "60420.real_time.groupStrCurrent6.desc": "组串6电流的说明。",
  "60420.real_time.groupStrCurrent8.desc": "组串8电流的说明。",
  "60420.real_time.groupStrCurrent10.desc": "组串10电流的说明。",
  "60420.real_time.groupStrCurrent12.desc": "组串12电流的说明。",
  "60420.real_time.groupStrCurrent14.desc": "组串14电流的说明。",
  "60420.real_time.groupStrCurrent16.desc": "组串16电流的说明。",
  "60420.real_time.groupStrCurrent18.desc": "组串18电流的说明。",
  "60420.real_time.groupStrCurrent20.desc": "组串20电流的说明。",
  "60420.real_time.groupStrCurrent22.desc": "组串22电流的说明。",
  "60420.real_time.pvPower1.desc": "PV1功率的说明。",
  "60420.real_time.pvPower2.desc": "PV2功率的说明。",
  "60420.real_time.pvPower3.desc": "PV3功率的说明。",
  "60420.real_time.pvPower4.desc": "PV4功率的说明。",
  "60420.real_time.pvPower5.desc": "PV5功率的说明。",
  "60420.real_time.pvPower6.desc": "PV6功率的说明。",
  "60420.real_time.pvPower7.desc": "PV7功率的说明。",
  "60420.real_time.pvPower8.desc": "PV8功率的说明。",
  "60420.real_time.pvPower9.desc": "PV9功率的说明。",
  "60420.real_time.pvPower10.desc": "PV10功率的说明。",
  "60420.real_time.pvPower11.desc": "PV11功率的说明。",
  "60420.real_time.pvPower12.desc": "PV12功率的说明。",
  "60420.real_time.acPower.desc": "AC功率的说明。",
  "60420.warn": "告警",
  "60420.ctrl_param_shebeixinxishezhi": "设备信息设置",
  "60420.ctrl_param_guoqianya_pinshezhi": "过欠压/频设置",
  "60420.ctrl_fangniliushezhi": "防逆流设置",
  "60420.real_time": "实时监控",
  "60420.fault": "故障",
  "60420.ctrl_param_qidongdianya_pinlvshezhi": "启动电压/频率设置",
  "60420.group_1": "分组_1",
  "60420.warn.0X3807_F_0603.---": "PV 电压低告警",
  "1977927400569729024.group_collector.datalogSn": "采集器序列号",
  "1977927400569729024.group_collector.datalogName": "datalogName",
  "1977927400569729024.group_collector.type": "采集器类型",
  "1977927400569729024.group_collector.datalogStatus": "采集器状态",
  "1977927400569729024.group_collector.createTime": "首次连接时间",
  "1977927400569729024.group_collector.clientUrl": "连接地址",
  "1977927400569729024.group_collector.remoteDomainName": "远程服务域名",
  "1977927400569729024.group_collector.version": "采集器版本号",
  "1977927400569729024.group_collector.timeZone": "时区",
  "1977927400569729024.group_collector.collectorTime": "采集器时间",
  "1977927400569729024.group_collector.hardwareVersion": "硬件版本",
  "1977927400569729024.group_collector.slaveAddr": "从机地址",
  "1977927400569729024.group_collector.lastUpdateTime": "最后更新时间",
  "1977927400569729024.group_collector.updateTime": "系统更新时间",
  "1977927400569729024.group_collector.updateInterval": "更新间隔",
  "1977927400569729024.group_collector.userId": "用户ID",
  "1977927400569729024.group_collector.wifiSignal": "WiFi信号",
  "1977927400569729024.group_collector.meshId": "Mesh网络ID",
  "1977927400569729024.group_collector.imei": "IMEI号",
  "1977927400569729024.group_collector.iccid": "SIM卡号",
  "1977927400569729024.group_collector.remark": "备注",
  "1977927400569729024.group_collector.agreementType": "协议类型",
  "1977927400569729024.group_collector.connectTime": "接入时间",
  "1977927400569729024.group_collector.httpUrl": "Http下载文件的url",
  "1977927400569729024.group_collector.protocolVersion": "protocolVersion",
  "1977927400569729024.group_collector.inverterRangeStart": "inverterRangeStart",
  "1977927400569729024.group_collector.inverterRangeEnd": "inverterRangeEnd",
  "1977927400569729024.group_collector.reserved7": "reserved7",
  "1977927400569729024.group_collector.localDns": "localDns",
  "1977927400569729024.group_collector.localPort": "localPort",
  "1977927400569729024.group_collector.localMac": "localMac",
  "1977927400569729024.group_collector.remotePort": "remotePort",
  "1977927400569729024.group_collector.remoteUrl19": "remoteUrl19",
  "1977927400569729024.group_collector.zigbeeRadioChannel": "zigbeeRadioChannel",
  "1977927400569729024.group_collector.subnetMask": "subnetMask",
  "1977927400569729024.group_collector.defaultGateway": "defaultGateway",
  "1977927400569729024.group_collector.longitudeAndLatitude": "longitudeAndLatitude",
  "1977927400569729024.group_collector.dataloggerRestart": "dataloggerRestart",
  "1977927400569729024.group_collector.clearRecords": "clearRecords",
  "1977927400569729024.group_collector.setToFactory": "setToFactory",
  "1977927400569729024.group_collector.reserved39": "reserved39",
  "1977927400569729024.group_collector.invertersLimit": "invertersLimit",
  "1977927400569729024.group_collector.communicationProtectTime": "communicationProtectTime",
  "1977927400569729024.group_collector.dataTransferMode": "dataTransferMode",
  "1977927400569729024.group_collector.reserved43": "reserved43",
  "1977927400569729024.group_collector.updatePvDeviceMode": "updatePvDeviceMode",
  "1977927400569729024.group_collector.networkType": "networkType",
  "1977927400569729024.group_collector.rs485_1BaudRate": "rs485_1BaudRate",
  "1977927400569729024.group_collector.rs485_2BaudRate": "rs485_2BaudRate",
  "1977927400569729024.group_collector.testPattern": "testPattern",
  "1977927400569729024.group_collector.deviceStatus": "deviceStatus",
  "1977927400569729024.group_collector.bleToken": "bleToken",
  "1977927400569729024.group_collector.wifiConfigState": "wifiConfigState",
  "1977927400569729024.group_collector.wifiSsid": "wifiSsid",
  "1977927400569729024.group_collector.wifiPassword": "wifiPassword",
  "1977927400569729024.group_collector.threeGSignal": "threeGSignal",
  "1977927400569729024.group_collector.linkState": "linkState",
  "1977927400569729024.group_collector.reserved64": "reserved64",
  "1977927400569729024.group_collector.reserved65": "reserved65",
  "1977927400569729024.group_collector.reserved68": "reserved68",
  "1977927400569729024.group_collector.reserved69": "reserved69",
  "1977927400569729024.group_collector.reserved70": "reserved70",
  "1977927400569729024.group_collector.dhcpEnable": "dhcpEnable",
  "1977927400569729024.group_collector.getRouterName": "getRouterName",
  "1977927400569729024.group_collector.reserved77": "reserved77",
  "1977927400569729024.group_collector.reserved78": "reserved78",
  "1977927400569729024.group_collector.reserved79": "reserved79",
  "1977927400569729024.group_collector.reserved81": "reserved81",
  "1977927400569729024.group_collector.controllerId": "controllerId",
  "1977927400569729024.group_collector.deviceType": "deviceType",
  "1977927400569729024.group_collector.deviceReset": "deviceReset",
  "1977927400569729024.group_collector.bleEnable": "bleEnable",
  "1977927400569729024.group_collector.devicePwd": "devicePwd",
  "1977927400569729024.group_collector.devicePwdNew": "devicePwdNew",
  "1977927400569729024.group_collector.devicePwdCheckState": "devicePwdCheckState",
  "1977927400569729024.group_collector.gridMeterSn": "gridMeterSn",
  "1977927400569729024.group_collector.acMeterSn": "acMeterSn",
  "1977927400569729024.group_collector.datalogSn.desc": "采集器序列号",
  "1977927400569729024.group_collector.datalogName.desc": "采集器名称",
  "1977927400569729024.group_collector.type.desc": "采集器类型",
  "1977927400569729024.group_collector.datalogStatus.desc": "0:离线；1：在线",
  "1977927400569729024.group_collector.createTime.desc": "添加、首次连接时间",
  "1977927400569729024.group_collector.clientUrl.desc": "采集器的连接IP+端口",
  "1977927400569729024.group_collector.remoteDomainName.desc": "远程服务域名",
  "1977927400569729024.group_collector.version.desc": "采集器版本号",
  "1977927400569729024.group_collector.timeZone.desc": "时区",
  "1977927400569729024.group_collector.collectorTime.desc": "采集器时间",
  "1977927400569729024.group_collector.hardwareVersion.desc": "硬件版本",
  "1977927400569729024.group_collector.slaveAddr.desc": "Modbus从机地址",
  "1977927400569729024.group_collector.lastUpdateTime.desc": "采集器最后更新时间",
  "1977927400569729024.group_collector.updateTime.desc": "采集器系统更新时间",
  "1977927400569729024.group_collector.updateInterval.desc": "更新的间隔时间",
  "1977927400569729024.group_collector.userId.desc": "关联用户ID",
  "1977927400569729024.group_collector.wifiSignal.desc": "0~-50(强) -51~-75(中) -75~-113(弱)",
  "1977927400569729024.group_collector.meshId.desc": "设备的meshId",
  "1977927400569729024.group_collector.imei.desc": "4G采集器IMEI",
  "1977927400569729024.group_collector.iccid.desc": "4G采集器ICCID",
  "1977927400569729024.group_collector.remark.desc": "自定义备注信息",
  "1977927400569729024.group_collector.agreementType.desc": "0=5kw设备 1=10kw设备",
  "1977927400569729024.group_collector.connectTime.desc": "设备接入系统时间",
  "1977927400569729024.group_collector.protocolVersion.desc": "protocolVersion",
  "1977927400569729024.group_collector.inverterRangeStart.desc": "inverterRangeStart",
  "1977927400569729024.group_collector.inverterRangeEnd.desc": "inverterRangeEnd",
  "1977927400569729024.group_collector.reserved7.desc": "reserved7",
  "1977927400569729024.group_collector.localDns.desc": "localDns",
  "1977927400569729024.group_collector.localPort.desc": "localPort",
  "1977927400569729024.group_collector.localMac.desc": "localMac",
  "1977927400569729024.group_collector.remotePort.desc": "remotePort",
  "1977927400569729024.group_collector.remoteUrl19.desc": "remoteUrl19",
  "1977927400569729024.group_collector.zigbeeRadioChannel.desc": "zigbeeRadioChannel",
  "1977927400569729024.group_collector.subnetMask.desc": "subnetMask",
  "1977927400569729024.group_collector.defaultGateway.desc": "defaultGateway",
  "1977927400569729024.group_collector.longitudeAndLatitude.desc": "longitudeAndLatitude",
  "1977927400569729024.group_collector.dataloggerRestart.desc": "dataloggerRestart",
  "1977927400569729024.group_collector.clearRecords.desc": "clearRecords",
  "1977927400569729024.group_collector.setToFactory.desc": "setToFactory",
  "1977927400569729024.group_collector.reserved39.desc": "reserved39",
  "1977927400569729024.group_collector.invertersLimit.desc": "invertersLimit",
  "1977927400569729024.group_collector.communicationProtectTime.desc": "communicationProtectTime",
  "1977927400569729024.group_collector.dataTransferMode.desc": "dataTransferMode",
  "1977927400569729024.group_collector.reserved43.desc": "reserved43",
  "1977927400569729024.group_collector.updatePvDeviceMode.desc": "updatePvDeviceMode",
  "1977927400569729024.group_collector.networkType.desc": "networkType",
  "1977927400569729024.group_collector.rs485_1BaudRate.desc": "rs485_1BaudRate",
  "1977927400569729024.group_collector.rs485_2BaudRate.desc": "rs485_2BaudRate",
  "1977927400569729024.group_collector.testPattern.desc": "testPattern",
  "1977927400569729024.group_collector.deviceStatus.desc": "deviceStatus",
  "1977927400569729024.group_collector.bleToken.desc": "bleToken",
  "1977927400569729024.group_collector.wifiConfigState.desc": "wifiConfigState",
  "1977927400569729024.group_collector.wifiSsid.desc": "wifiSsid",
  "1977927400569729024.group_collector.wifiPassword.desc": "wifiPassword",
  "1977927400569729024.group_collector.threeGSignal.desc": "threeGSignal",
  "1977927400569729024.group_collector.linkState.desc": "linkState",
  "1977927400569729024.group_collector.reserved64.desc": "reserved64",
  "1977927400569729024.group_collector.reserved65.desc": "reserved65",
  "1977927400569729024.group_collector.reserved68.desc": "reserved68",
  "1977927400569729024.group_collector.reserved69.desc": "reserved69",
  "1977927400569729024.group_collector.reserved70.desc": "reserved70",
  "1977927400569729024.group_collector.dhcpEnable.desc": "dhcpEnable",
  "1977927400569729024.group_collector.getRouterName.desc": "getRouterName",
  "1977927400569729024.group_collector.reserved77.desc": "reserved77",
  "1977927400569729024.group_collector.reserved78.desc": "reserved78",
  "1977927400569729024.group_collector.reserved79.desc": "reserved79",
  "1977927400569729024.group_collector.reserved81.desc": "reserved81",
  "1977927400569729024.group_collector.controllerId.desc": "controllerId",
  "1977927400569729024.group_collector.deviceType.desc": "deviceType",
  "1977927400569729024.group_collector.deviceReset.desc": "deviceReset",
  "1977927400569729024.group_collector.bleEnable.desc": "bleEnable",
  "1977927400569729024.group_collector.devicePwd.desc": "devicePwd",
  "1977927400569729024.group_collector.devicePwdNew.desc": "devicePwdNew",
  "1977927400569729024.group_collector.devicePwdCheckState.desc": "devicePwdCheckState",
  "1977927400569729024.group_collector.gridMeterSn.desc": "gridMeterSn",
  "1977927400569729024.group_collector.acMeterSn.desc": "acMeterSn",
  "1977927400569729024.group_collector": "采集器分组",
  "60420.warn.0X3807_F_0603": "PV 电压低告警",
  "tag_test": "标签测试",
  "tag_test_1": "中文1",
  "60420.ctrl_fangniliushezhi.singleReverseFlowEnable.0": "禁止",
  "60420.ctrl_fangniliushezhi.singleReverseFlowEnable.1": "使能",
  "60420.ctrl_fangniliushezhi.multiReverseFlowEnable.0": "禁止",
  "60420.ctrl_fangniliushezhi.multiReverseFlowEnable.1": "使能",
  "60420.ctrl_fangniliushezhi.meterSelect.0": "CT",
  "60420.ctrl_fangniliushezhi.meterSelect.1": "斯通瑞电表",
  "60420.ctrl_fangniliushezhi.meterSelect.2": "东帆电表",
  "60420.ctrl_fangniliushezhi.meterSelect.3": "东鸿电表",
  "60420.ctrl_fangniliushezhi.meterSelect.4": "正泰电表",
  "60420.ctrl_fangniliushezhi.meterSelect.5": "益邦",
  "60420.ctrl_fangniliushezhi.meterSelect.6": "英臻",
  "60420.ctrl_fangniliushezhi.meterSelect.7": "能控云智能电表",
  "60420.ctrl_fangniliushezhi.restrictCounterCurrent.0": "限制三相总功率",
  "60420.ctrl_fangniliushezhi.restrictCounterCurrent.1": "限制单相功率",
  "50901.ctrl_dianwangjiaohu.powerLimitOfThePowerGrid": "电网功率限制限值",
  "50901.ctrl_dianchiguanli.BatteryModel": "电池型号",
  "50901.ctrl_xitongjichupeizhi.materType.0": "无网侧电表",
  "50901.ctrl_xitongjichupeizhi.materType.1": "正泰单相",
  "50901.ctrl_xitongjichupeizhi.materType.2": "正泰单相",
  "50901.ctrl_xitongjichupeizhi.materType.3": "正泰裂相",
  "50901.ctrl_xitongjichupeizhi.materType.5": "计量模块",
  "50901.ctrl_xitongjichupeizhi.materType.6": "安科瑞单路",
  "50901.ctrl_xitongjichupeizhi.materType.7": "安科瑞双路",
  "50901.ctrl_dianchiguanli.BatteryModel.1": "Pylon LV",
  "50901.ctrl_dianchiguanli.BatteryModel.2": "Pylon HV",
  "50901.ctrl_dianchiguanli.BatteryModel.3": "Dyness LV",
  "50901.ctrl_dianchiguanli.BatteryModel.4": "Dyness HV",
  "50901.ctrl_dianchiguanli.BatteryModel.5": "Sunwoda LV",
  "50901.ctrl_dianchiguanli.BatteryModel.6": "Uz LV",
  "50901.ctrl_dianchiguanli.BatteryModel.7": "Soluna HV",
  "50901.ctrl_dianchiguanli.BatteryModel.8": "Soluna LV",
  "50901.ctrl_dianchiguanli.BatteryModel.9": "Steltec LV",
  "50901.ctrl_dianchiguanli.BatteryModel.10": "Xin Yi LV",
  "50901.ctrl_dianchiguanli.BatteryModel.11": "Vestwoods LV",
  "50901.ctrl_dianchiguanli.BatteryModel.12": "JK HV",
  "50901.ctrl_dianchiguanli.BatteryModel.13": "BYD LV",
  "50901.ctrl_dianchiguanli.BatteryModel.14": "Uz HV",
  "50901.ctrl_dianchiguanli.BatteryModel.15": "Zetara LV",
  "50901.ctrl_dianchiguanli.BatteryModel.16": "FEB HV",
  "50901.ctrl_dianchiguanli.BatteryModel.17": "Pytes LV",
  "50901.ctrl_dianchiguanli.BatteryModel.18": "Dmegc LV",
  "50901.ctrl_dianchiguanli.BatteryModel.19": "Weineng LV",
  "50901.ctrl_dianchiguanli.BatteryModel.20": "Weineng HV",
  "50901.ctrl_dianchiguanli.BatteryModel.21": "GSL LV",
  "50901.ctrl_dianchiguanli.BatteryModel.22": "HOY LV",
  "50901.ctrl_dianchiguanli.BatteryModel.23": "HOY HV",
  "50901.ctrl_dianchiguanli.BatteryModel.24": "FEB LV",
  "50901.ctrl_dianchiguanli.BatteryModel.25": "UHhome LV",
  "50901.ctrl_dianchiguanli.BatteryModel.26": "UHhome HV",
  "50901.ctrl_dianchiguanli.BatteryModel.27": "BYD HV",
  "50901.ctrl_dianchiguanli.BatteryModel.28": "Vestwoods HV",
  "50901.ctrl_dianchiguanli.BatteryModel.29": "Phylion HV",
  "50901.ctrl_dianchiguanli.BatteryModel.30": "Hoymiles LV",
  "50901.ctrl_dianchiguanli.BatteryModel.31": "Pholion LV",
  "50901.ctrl_dianchiguanli.BatteryModel.32": "Wattsonic LV",
  "50901.ctrl_dianchiguanli.BatteryModel.33": "Enershare HV",
  "50901.ctrl_dianchiguanli.BatteryModel.34": "Beghelli LV",
  "50901.ctrl_dianchiguanli.BatteryModel.35": "LvToPSUN LV",
  "50901.ctrl_dianchiguanli.BatteryModel.36": "PYTES HV",
  "50901.ctrl_dianchiguanli.BatteryModel.37": "LvToPSUN HV",
  "50901.ctrl_dianchiguanli.BatteryModel.38": "RAJA HV",
  "50901.ctrl_dianchiguanli.BatteryModel.39": "Felicity LV",
  "UPDATE": "更新",
  "end.web": "WEB端",
  "50901.ctrl_gaojigongneng.weekRange1": "星期一",
  "50901.ctrl_gaojigongneng.smart_weekRange20": "星期一",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange1": "HPTime1周范围1",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange1": "HPTime2周范围1",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange1": "HPTime3周范围1",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange1": "HPTime4周范围1",
  "50901.ctrl_xitongjichupeizhi.ClockSetting": "时钟设置",
  "50901.ctrl_dianwangjiaohu.powerLimitForGridConnectionFeederNetwork": "并网点/馈网功率限值",
  "50901.ctrl_dianwangjiaohu.GridConnectionPointFeedinPowerLimit": "并网点/馈网功率限值",
  "50901.ctrl_dianchiguanli.batteryChargingPowerSettingValue": "电池的充电功率设置值",
  "50901.ctrl_dianchiguanli.batteryDischargePowerSettingValue": "电池的放电功率设置值",
  "50901.ctrl_anquanbaohu.nationalStandardsSafetyRegulationsStandards": "国家标准（安规标准）",
  "50901.ctrl_dianchiguanli.GridChargingAllowed": "是否允许电网充电",
  "50901.ctrl_dianchiguanli.CfgMultPcsBMSFlag": "多机并联BMS标识",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange2": "负载控制星期二",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange3": "负载控制星期三",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange4": "负载控制星期四",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange5": "负载控制星期五",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange6": "负载控制星期六",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange7": "负载控制星期天",
  "50901.ctrl_gaojigongneng.weekRange3": "星期三",
  "50901.ctrl_gaojigongneng.weekRange4": "星期四",
  "50901.ctrl_gaojigongneng.weekRange5": "星期五",
  "50901.ctrl_gaojigongneng.weekRange6": "星期六",
  "50901.ctrl_gaojigongneng.weekRange7": "星期天",
  "50901.ctrl_gaojigongneng.smart_weekRange21": "星期二",
  "50901.ctrl_gaojigongneng.smart_weekRange22": "星期三",
  "50901.ctrl_gaojigongneng.smart_weekRange23": "星期四",
  "50901.ctrl_gaojigongneng.smart_weekRange24": "星期五",
  "50901.ctrl_gaojigongneng.smart_weekRange25": "星期六",
  "50901.ctrl_gaojigongneng.smart_weekRange26": "星期天",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange2": "HPTime1周范围2",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange3": "HPTime1周范围3",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange4": "HPTime1周范围4",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange5": "HPTime1周范围5",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange6": "HPTime1周范围6",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange7": "HPTime1周范围7",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange2": "HPTime2周范围2",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange3": "HPTime2周范围3",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange4": "HPTime2周范围4",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange5": "HPTime2周范围5",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange6": "HPTime2周范围6",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange7": "HPTime2周范围7",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange2": "HPTime2周范围2",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange3": "HPTime2周范围3",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange4": "HPTime2周范围4",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange5": "HPTime2周范围5",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange6": "HPTime2周范围6",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange7": "HPTime2周范围7",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange2": "HPTime4周范围2",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange3": "HPTime4周范围3",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange4": "HPTime4周范围4",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange5": "HPTime4周范围5",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange6": "HPTime4周范围6",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange7": "HPTime4周范围7",
  "50901.ctrl_gaojigongneng.weekRange1.0": "enable",
  "50901.ctrl_gaojigongneng.weekRange1.1": "enable",
  "50901.ctrl_gaojigongneng.smart_weekRange20.0": "disable",
  "50901.ctrl_gaojigongneng.smart_weekRange20.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange1.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange1.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange1.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange1.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange1.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange1.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange1.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange1.1": "enable",
  "50901.ctrl_dianchiguanli.CfgMultPcsBMSFlag.0": "disable",
  "50901.ctrl_dianchiguanli.CfgMultPcsBMSFlag.1": "enable",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange2.0": "disable",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange2.1": "enable",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange3.0": "disable",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange3.1": "enable",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange4.0": "disable",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange4.1": "enable",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange5.0": "disable",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange5.1": "enable",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange6.0": "disable",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange6.1": "enable",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange7.0": "disable",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange7.1": "enable",
  "50901.ctrl_gaojigongneng.weekRange3.0": "disable",
  "50901.ctrl_gaojigongneng.weekRange3.1": "enable",
  "50901.ctrl_gaojigongneng.weekRange4.0": "disable",
  "50901.ctrl_gaojigongneng.weekRange4.1": "enable",
  "50901.ctrl_gaojigongneng.weekRange5.0": "disable",
  "50901.ctrl_gaojigongneng.weekRange5.1": "enable",
  "50901.ctrl_gaojigongneng.weekRange6.0": "disable",
  "50901.ctrl_gaojigongneng.weekRange6.1": "enable",
  "50901.ctrl_gaojigongneng.weekRange7.0": "disable",
  "50901.ctrl_gaojigongneng.weekRange7.1": "enable",
  "50901.ctrl_gaojigongneng.smart_weekRange21.0": "disable",
  "50901.ctrl_gaojigongneng.smart_weekRange21.1": "enable",
  "50901.ctrl_gaojigongneng.smart_weekRange22.0": "disable",
  "50901.ctrl_gaojigongneng.smart_weekRange22.1": "enable",
  "50901.ctrl_gaojigongneng.smart_weekRange23.0": "disable",
  "50901.ctrl_gaojigongneng.smart_weekRange23.1": "enable",
  "50901.ctrl_gaojigongneng.smart_weekRange24.0": "disable",
  "50901.ctrl_gaojigongneng.smart_weekRange24.1": "enable",
  "50901.ctrl_gaojigongneng.smart_weekRange25.0": "disable",
  "50901.ctrl_gaojigongneng.smart_weekRange25.1": "enable",
  "50901.ctrl_gaojigongneng.smart_weekRange26.0": "disable",
  "50901.ctrl_gaojigongneng.smart_weekRange26.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange2.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange2.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange3.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange3.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange4.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange4.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange5.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange5.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange6.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange6.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange7.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange7.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange2.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange2.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange3.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange3.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange4.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange4.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange5.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange5.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange6.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange6.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange7.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange7.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange2.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange2.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange3.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange3.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange4.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange4.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange5.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange5.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange6.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange6.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange7.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange7.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange2.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange2.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange3.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange3.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange4.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange4.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange5.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange5.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange6.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange6.1": "enable",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange7.0": "disable",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange7.1": "enable",
  "50901.ctrl_gaojigongneng.weekRange1.desc": "星期一的说明。",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange1.desc": "HPTime1周范围1的说明。",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange1.desc": "HPTime2周范围1的说明。",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange1.desc": "HPTime3周范围1的说明。",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange1.desc": "HPTime4周范围1的说明。",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange2.desc": "负载控制星期二的说明。",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange3.desc": "负载控制星期三的说明。",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange4.desc": "负载控制星期四的说明。",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange5.desc": "负载控制星期五的说明。",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange6.desc": "负载控制星期六的说明。",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange7.desc": "负载控制星期天的说明。",
  "50901.ctrl_gaojigongneng.weekRange3.desc": "星期三的说明。",
  "50901.ctrl_gaojigongneng.weekRange4.desc": "星期四的说明。",
  "50901.ctrl_gaojigongneng.weekRange5.desc": "星期五的说明。",
  "50901.ctrl_gaojigongneng.weekRange6.desc": "星期六的说明。",
  "50901.ctrl_gaojigongneng.weekRange7.desc": "星期天的说明。",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange2.desc": "HPTime1周范围2的说明。",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange3.desc": "HPTime1周范围3的说明。",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange4.desc": "HPTime1周范围4的说明。",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange5.desc": "HPTime1周范围5的说明。",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange6.desc": "HPTime1周范围6的说明。",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange7.desc": "HPTime1周范围7的说明。",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange2.desc": "HPTime2周范围2的说明。",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange3.desc": "HPTime2周范围3的说明。",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange4.desc": "HPTime2周范围4的说明。",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange5.desc": "HPTime2周范围5的说明。",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange6.desc": "HPTime2周范围6的说明。",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange7.desc": "HPTime2周范围7的说明。",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange2.desc": "HPTime2周范围2的说明。",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange3.desc": "HPTime2周范围3的说明。",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange4.desc": "HPTime2周范围4的说明。",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange5.desc": "HPTime2周范围5的说明。",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange6.desc": "HPTime2周范围6的说明。",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange7.desc": "HPTime2周范围7的说明。",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange2.desc": "HPTime4周范围2的说明。",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange3.desc": "HPTime4周范围3的说明。",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange4.desc": "HPTime4周范围4的说明。",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange5.desc": "HPTime4周范围5的说明。",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange6.desc": "HPTime4周范围6的说明。",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange7.desc": "HPTime4周范围7的说明。",
  "grid.connection.mode.selfUseNoGrid": "自发自用（不上网）",
  "grid.connection.mode.surplusPowerGrid": "余电上网",
  "grid.connection.mode.fullPowerGrid": "全额上网",
  "grid.connection.mode.offGridOnly": "纯离网",
  "grid.connection.mode.other": "其他",
  "plant.category.house.hold": "户用",
  "plant.category.industry.commerce": "工商业",
  "50901.real_time.analysis_eps_power.tag": "EPS 功率",
  "50901.ctrl_xitongjichupeizhi.DTSReset": "数据棒复位",
  "50901.real_time.数据分析_battery_status.tag": "battery_status",
  "50901.real_time.数据分析_grid_power_quality.tag": "grid_power_quality",
  "50901.real_time.数据分析_inverter_temperature.tag": "inverter_temperature",
  "50901.real_time.数据分析_energy_flow_daily.tag": "energy_flow_daily",
  "50901.real_time.数据分析_grid_electrical.tag": "grid_electrical",
  "50901.real_time.数据分析_eps_electrical.tag": "eps_electrical",
  "50901.real_time.数据分析_pv_power.tag": "pv_power",
  "50901.real_time.数据分析_meter_pv_electrical.tag": "meter_pv_electrical",
  "50901.real_time.数据分析_battery_cell_status.tag": "battery_cell_status",
  "50901.real_time.数据分析_battery_electrical.tag": "battery_electrical",
  "50901.real_time.数据分析_generator_electrical.tag": "generator_electrical",
  "50901.real_time.数据分析_grid_temperature.tag": "grid_temperature",
  "50901.real_time.数据分析_pv_electrical.tag": "pv_electrical",
  "50901.real_time.数据分析_energy_flow_cumulative.tag": "energy_flow_cumulative",
  "50901.real_time.数据分析_energy_daily.tag": "energy_daily",
  "50901.real_time.数据分析_generator_power.tag": "generator_power",
  "50901.real_time.数据分析_power_flow.tag": "power_flow",
  "50901.real_time.数据分析_energy_cumulative.tag": "energy_cumulative",
  "50901.real_time.数据分析_meter_ac_power.tag": "meter_ac_power",
  "50901.real_time.数据分析_internal_voltage.tag": "internal_voltage",
  "50901.real_time.数据分析_fan_speed.tag": "fan_speed",
  "50901.real_time.数据分析_load_power.tag": "load_power",
  "50901.real_time.数据分析_meter_ac_power_quality.tag": "meter_ac_power_quality",
  "50901.real_time.数据分析_inverter_ac_output.tag": "inverter_ac_output",
  "50901.real_time.数据分析_eps_power.tag": "eps_power",
  "50901.real_time.数据分析_meter_pv_power.tag": "meter_pv_power",
  "50901.real_time.数据分析_meter_ac_electrical.tag": "meter_ac_electrical",
  "50901.real_time.数据分析_comm_status.tag": "comm_status",
  "50901.real_time.数据分析_battery_power.tag": "battery_power",
  "50901.real_time.数据分析_grid_power.tag": "grid_power",
  "50901.real_time.数据分析_pv_temperature.tag": "pv_temperature",
  "50901.real_time.数据分析_ambient_temperature.tag": "ambient_temperature",
  "60001.group_collector.datalogSn": "采集器序列号",
  "60001.group_collector.datalogName": "datalogName",
  "60001.group_collector.type": "采集器类型",
  "60001.group_collector.datalogStatus": "采集器状态",
  "60001.group_collector.createTime": "首次连接时间",
  "60001.group_collector.clientUrl": "连接地址",
  "60001.group_collector.remoteDomainName": "远程服务域名",
  "60001.group_collector.version": "采集器版本号",
  "60001.group_collector.timeZone": "时区",
  "60001.group_collector.collectorTime": "采集器时间",
  "60001.group_collector.hardwareVersion": "硬件版本",
  "60001.group_collector.slaveAddr": "从机地址",
  "60001.group_collector.lastUpdateTime": "最后更新时间",
  "60001.group_collector.updateTime": "系统更新时间",
  "60001.group_collector.updateInterval": "更新间隔",
  "60001.group_collector.userId": "用户ID",
  "60001.group_collector.wifiSignal": "WiFi信号",
  "60001.group_collector.meshId": "Mesh网络ID",
  "60001.group_collector.imei": "4G模组的IMEI号",
  "60001.group_collector.iccid": "SIM卡的ICCID号",
  "60001.group_collector.remark": "备注",
  "60001.group_collector.agreementType": "协议类型",
  "60001.group_collector.connectTime": "接入时间",
  "60001.group_collector.httpUrl": "Http下载文件的url",
  "60001.group_collector.protocolVersion": "数服协议版本号",
  "60001.group_collector.inverterRangeStart": "inverterRangeStart",
  "60001.group_collector.inverterRangeEnd": "inverterRangeEnd",
  "60001.group_collector.reserved7": "reserved7",
  "60001.group_collector.localDns": "localDns",
  "60001.group_collector.localPort": "localPort",
  "60001.group_collector.localMac": "localMac",
  "60001.group_collector.remotePort": "远端网络服务器端口",
  "60001.group_collector.remoteUrl19": "remoteUrl19",
  "60001.group_collector.zigbeeRadioChannel": "zigbeeRadioChannel",
  "60001.group_collector.subnetMask": "subnetMask",
  "60001.group_collector.defaultGateway": "defaultGateway",
  "60001.group_collector.longitudeAndLatitude": "longitudeAndLatitude",
  "60001.group_collector.dataloggerRestart": "采集棒重启",
  "60001.group_collector.clearRecords": "clearRecords",
  "60001.group_collector.setToFactory": "setToFactory",
  "60001.group_collector.reserved39": "reserved39",
  "60001.group_collector.invertersLimit": "invertersLimit",
  "60001.group_collector.communicationProtectTime": "communicationProtectTime",
  "60001.group_collector.dataTransferMode": "dataTransferMode",
  "60001.group_collector.reserved43": "reserved43",
  "60001.group_collector.updatePvDeviceMode": "updatePvDeviceMode",
  "60001.group_collector.networkType": "networkType",
  "60001.group_collector.rs485_1BaudRate": "rs485_1BaudRate",
  "60001.group_collector.rs485_2BaudRate": "rs485_2BaudRate",
  "60001.group_collector.testPattern": "testPattern",
  "60001.group_collector.deviceStatus": "deviceStatus",
  "60001.group_collector.bleToken": "bleToken",
  "60001.group_collector.wifiConfigState": "wifiConfigState",
  "60001.group_collector.wifiSsid": "wifiSsid",
  "60001.group_collector.wifiPassword": "wifiPassword",
  "60001.group_collector.threeGSignal": "threeGSignal",
  "60001.group_collector.linkState": "linkState",
  "60001.group_collector.reserved64": "reserved64",
  "60001.group_collector.reserved65": "reserved65",
  "60001.group_collector.reserved68": "reserved68",
  "60001.group_collector.reserved69": "reserved69",
  "60001.group_collector.reserved70": "reserved70",
  "60001.group_collector.dhcpEnable": "dhcpEnable",
  "60001.group_collector.getRouterName": "getRouterName",
  "60001.group_collector.reserved77": "reserved77",
  "60001.group_collector.reserved78": "reserved78",
  "60001.group_collector.reserved79": "reserved79",
  "60001.group_collector.reserved81": "reserved81",
  "60001.group_collector.controllerId": "controllerId",
  "60001.group_collector.deviceType": "deviceType",
  "60001.group_collector.deviceReset": "deviceReset",
  "60001.group_collector.bleEnable": "蓝牙开关",
  "60001.group_collector.devicePwd": "devicePwd",
  "60001.group_collector.devicePwdNew": "devicePwdNew",
  "60001.group_collector.devicePwdCheckState": "devicePwdCheckState",
  "60001.group_collector.gridMeterSn": "gridMeterSn",
  "60001.group_collector.acMeterSn": "acMeterSn",
  "60001.group_collector.signalStrength": "4G信号强度",
  "60001.group_collector.datalogSn.desc": "未授权禁止更改，否则海尔云无法连接到该设备",
  "60001.group_collector.datalogName.desc": "采集器名称",
  "60001.group_collector.type.desc": "采集器类型的说明。",
  "60001.group_collector.datalogStatus.desc": "0:离线；1：在线",
  "60001.group_collector.createTime.desc": "添加、首次连接时间",
  "60001.group_collector.clientUrl.desc": "连接地址的说明。",
  "60001.group_collector.remoteDomainName.desc": "未授权禁止更改，否则无法连接海尔云服务器",
  "60001.group_collector.version.desc": "采集器版本号的说明。",
  "60001.group_collector.timeZone.desc": "时区",
  "60001.group_collector.collectorTime.desc": "采集器时间的说明。",
  "60001.group_collector.hardwareVersion.desc": "硬件版本的说明。",
  "60001.group_collector.slaveAddr.desc": "Modbus从机地址",
  "60001.group_collector.lastUpdateTime.desc": "最后更新时间的说明。",
  "60001.group_collector.updateTime.desc": "采集器系统更新时间",
  "60001.group_collector.updateInterval.desc": "逆变器实时数据的更新间隔时间",
  "60001.group_collector.userId.desc": "关联用户ID",
  "60001.group_collector.wifiSignal.desc": "0~-50(强) -51~-75(中) -75~-113(弱)",
  "60001.group_collector.meshId.desc": "设备的meshId",
  "60001.group_collector.imei.desc": "IMEI号的说明。",
  "60001.group_collector.iccid.desc": "SIM卡号的说明。",
  "60001.group_collector.remark.desc": "自定义备注信息",
  "60001.group_collector.agreementType.desc": "协议类型的说明。",
  "60001.group_collector.connectTime.desc": "设备接入系统时间",
  "60001.group_collector.protocolVersion.desc": "9.0以上的为欧洲RED合规认证的协议版本",
  "60001.group_collector.inverterRangeStart.desc": "inverterRangeStart",
  "60001.group_collector.inverterRangeEnd.desc": "inverterRangeEnd",
  "60001.group_collector.reserved7.desc": "reserved7",
  "60001.group_collector.localDns.desc": "localDns",
  "60001.group_collector.localPort.desc": "localPort",
  "60001.group_collector.localMac.desc": "localMac",
  "60001.group_collector.remotePort.desc": "remotePort的说明。",
  "60001.group_collector.remoteUrl19.desc": "remoteUrl19",
  "60001.group_collector.zigbeeRadioChannel.desc": "zigbeeRadioChannel",
  "60001.group_collector.subnetMask.desc": "subnetMask",
  "60001.group_collector.defaultGateway.desc": "defaultGateway",
  "60001.group_collector.longitudeAndLatitude.desc": "longitudeAndLatitude",
  "60001.group_collector.dataloggerRestart.desc": "dataloggerRestart",
  "60001.group_collector.clearRecords.desc": "clearRecords",
  "60001.group_collector.setToFactory.desc": "setToFactory",
  "60001.group_collector.reserved39.desc": "reserved39",
  "60001.group_collector.invertersLimit.desc": "invertersLimit",
  "60001.group_collector.communicationProtectTime.desc": "communicationProtectTime",
  "60001.group_collector.dataTransferMode.desc": "dataTransferMode",
  "60001.group_collector.reserved43.desc": "reserved43",
  "60001.group_collector.updatePvDeviceMode.desc": "updatePvDeviceMode",
  "60001.group_collector.networkType.desc": "networkType",
  "60001.group_collector.rs485_1BaudRate.desc": "rs485_1BaudRate",
  "60001.group_collector.rs485_2BaudRate.desc": "rs485_2BaudRate",
  "60001.group_collector.testPattern.desc": "testPattern",
  "60001.group_collector.deviceStatus.desc": "deviceStatus",
  "60001.group_collector.bleToken.desc": "bleToken",
  "60001.group_collector.wifiConfigState.desc": "wifiConfigState",
  "60001.group_collector.wifiSsid.desc": "wifiSsid",
  "60001.group_collector.wifiPassword.desc": "wifiPassword",
  "60001.group_collector.threeGSignal.desc": "threeGSignal",
  "60001.group_collector.linkState.desc": "linkState",
  "60001.group_collector.reserved64.desc": "reserved64",
  "60001.group_collector.reserved65.desc": "reserved65",
  "60001.group_collector.reserved68.desc": "reserved68",
  "60001.group_collector.reserved69.desc": "reserved69",
  "60001.group_collector.reserved70.desc": "reserved70",
  "60001.group_collector.dhcpEnable.desc": "dhcpEnable",
  "60001.group_collector.getRouterName.desc": "getRouterName",
  "60001.group_collector.reserved77.desc": "reserved77",
  "60001.group_collector.reserved78.desc": "reserved78",
  "60001.group_collector.reserved79.desc": "reserved79",
  "60001.group_collector.reserved81.desc": "reserved81",
  "60001.group_collector.controllerId.desc": "controllerId",
  "60001.group_collector.deviceType.desc": "deviceType",
  "60001.group_collector.deviceReset.desc": "deviceReset",
  "60001.group_collector.bleEnable.desc": "蓝牙使能",
  "60001.group_collector.devicePwd.desc": "devicePwd",
  "60001.group_collector.devicePwdNew.desc": "devicePwdNew",
  "60001.group_collector.devicePwdCheckState.desc": "devicePwdCheckState",
  "60001.group_collector.gridMeterSn.desc": "gridMeterSn",
  "60001.group_collector.acMeterSn.desc": "acMeterSn",
  "60001.group_collector.signalStrength.desc": "0~-80(极强)   -80~-90(强)  -90~-100(中等)  -100~-110(弱)   <-110(极弱)",
  "60001.group_collector": "采集器分组",
  "test.label_G_P_C_L2": "发电机L2 功率",
  "60420.ctrl_fangniliushezhi.regulatoryManufacturers": "法规厂商",
  "60420.real_time.wideVoltageLevel": "宽电压等级",
  "60420.ctrl_fangniliushezhi.regulatoryManufacturers.0": "CQC2013",
  "60420.ctrl_fangniliushezhi.regulatoryManufacturers.12": "泰国",
  "60420.ctrl_fangniliushezhi.regulatoryManufacturers.13": "曼谷",
  "60420.ctrl_fangniliushezhi.regulatoryManufacturers.6": "印度",
  "60420.ctrl_fangniliushezhi.regulatoryManufacturers.18": "德国",
  "60420.ctrl_fangniliushezhi.regulatoryManufacturers.19": "法国",
  "60420.real_time.wideVoltageLevel.0": "默认值",
  "60420.real_time.wideVoltageLevel.1": "1.2倍",
  "60420.real_time.wideVoltageLevel.2": "1.25倍",
  "60420.ctrl_fangniliushezhi.singleReverseFlowEnable.desc": "功能默认禁用，使能后由防逆流电表调控输出功率",
  "60420.ctrl_fangniliushezhi.regulatoryManufacturers.desc": "法规厂商",
  "60420.real_time.wideVoltageLevel.desc": "宽电压等级",
  "60420.real_time.regulatoryManufacturers": "法规+厂商选择",
  "60420.real_time.regulatoryManufacturers.0": "CQC2013",
  "60420.real_time.regulatoryManufacturers.6": "印度",
  "60420.real_time.regulatoryManufacturers.12": "泰国",
  "60420.real_time.regulatoryManufacturers.13": "曼谷",
  "60420.real_time.regulatoryManufacturers.18": "德国",
  "60420.real_time.regulatoryManufacturers.19": "法国",
  "60420.real_time.regulatoryManufacturers.desc": "未经许可禁止更改",
  "connect.type.other": "其他",
  "50901.warning.batteryLowVoltageAlarm": "电池欠压",
  "50901.fault.testFault": "testFault",
  "50901.warning.batteryHighVoltageAlarm": "电池过压报警",
  "50901.warning.batteryPackDischargeLowVoltageAlarm": "电池组放电欠压报警",
  "50901.warning.batteryPackChargeHighVoltageAlarm": "电池组充电过压报警",
  "50901.warning.chargeLowTemperatureAlarm": "充电低温报警",
  "50901.warning.chargeHighTemperatureAlarm": "充电高温报警",
  "50901.warning.dischargeLowTemperatureAlarm": "放电低温报警",
  "50901.warning.dischargeHighTemperatureAlarm": "放电高温报警",
  "50901.warning.inputOvervoltageAlarm": "输入过压报警",
  "50901.fault.shutDown": "系统关机",
  "50901.fault.hardwareProtection": "硬件保护触发",
  "50901.fault.comparatorFault": "比较器故障",
  "50901.fault.spiCommunicationFault": "SPI通信故障",
  "50901.fault.armCommunicationFault": "ARM通信故障",
  "50901.fault.samplingBiasAbnormality": "采样偏置异常",
  "50901.fault.cmpssBiasCalculationError": "CMPSS偏置计算错误",
  "50901.fault.e2rpomFault": "EEPROM故障",
  "50901.fault.pvFault": "光伏故障",
  "50901.warning.batteryFault": "电池故障",
  "50901.fault.auxiliaryPowerAbnormality": "辅助电源异常",
  "50901.fault.gridRelayProtection": "电网继电器保护",
  "50901.fault.busbarAbnormality": "母线异常",
  "50901.fault.fanFault": "风扇故障",
  "50901.fault.machineTypeMismatch": "机型不匹配",
  "50901.fault.versionMismatch": "版本不匹配",
  "50901.fault.wiringAbnormality": "接线异常",
  "50901.fault.pvVoltageExceedingBusVoltage": " PV电压超过母线电压",
  "50901.fault.driveAbnormality": "驱动异常",
  "50901.fault.temperatureAbnormality": "温度异常",
  "50901.fault.epsRelayProtection": "EPS继电器保护",
  "50901.fault.lowBatteryEnergy": "电池电量过低",
  "50901.fault.epsVoltageAbnormality": "EPS电压异常",
  "50901.fault.epsOverload": "EPS过载",
  "50901.fault.genAbnormality": "发电机异常",
  "50901.fault.genOverload": "发电机过载",
  "50901.fault.meterWiringAbnormality": "​​ 电表接线异常",
  "50901.fault.canCommunicationTimeout": "CAN 通讯超时",
  "50901.fault.preSynchronizationFailed": "预同步失败",
  "50901.fault.pllLockFailed": "PLL锁相失败",
  "50901.fault.gridVoltageAbnormality": "电网电压异常",
  "50901.fault.gridOvervoltage": "电网过压",
  "50901.fault.gridUndervoltage": "电网欠压",
  "50901.fault.tenMinuteOvervoltage": "10分钟过压",
  "50901.fault.gridOverfrequency": "电网过频",
  "50901.fault.gridUnderfrequency": "电网欠频",
  "50901.fault.frequencyVariationRateOutOfRange": "频率变化率超限",
  "50901.fault.reconnectionFailed": "重连失败",
  "50901.fault.gridPowerOutage": "电网断电",
  "50901.fault.neutralWireNotConnected": "零线未连接",
  "50901.fault.lineToEarthFault": "对地故障（相线对地）",
  "50901.fault.neutralWireToEarthFault": "零线对地故障",
  "50901.fault.arcSelfTestFault": " 电弧自检故障",
  "50901.fault.arcFault": "电弧故障",
  "50901.fault.insulationFault": "绝缘故障",
  "50901.fault.rcdSelfTestFault": "漏电保护器自检故障",
  "50901.fault.rcdFault": "漏电保护器故障",
  "50901.fault.flashCommunicationFault": "闪存通信故障",
  "50901.fault.gridOffVoltageDcOffsetOutOfRange": "离网电压直流偏置超限",
  "50901.fault.gridCurrentDcOffsetOutOfRange": "电网电流直流偏置超限",
  "50901.fault.interruptOverflow": "中断溢出",
  "50901.fault.microelectronicFault": "微电子故障",
  "50901.fault.lowAmbientTemperature": "环境温度过低",
  "50901.fault.overTemperature": "​​ 过温",
  "50901.warning.dspPwrCommunicationAbnormality": "​DSP电源通信异常",
  "50901.warning.dspSafCommunicationAbnormality": "​DSP安全通信异常​",
  "50901.warning.pvMeterCommunicationAbnormality": "光伏电表通信异常",
  "50901.warning.gridMeterCommunicationAbnormality": "电网电表通信异常",
  "50901.warning.bmsCanCommunicationAbnormality": "BMS_CAN 通信异常",
  "50901.warning.lowDtuVersion": "DTU版本过低",
  "50901.warning.dtsCommunicationAbnormality": "DTS 通信异常",
  "50901.warning.gridMeterTypeError": " 电网电表类型错误",
  "50901.warning.pvMeterTypeError": "光伏电表类型错误",
  "50901.warning.slaveWrongBatteryConnection": "从机电池连接错误",
  "50901.warning.dtu1Rs485CommunicationAbnormality": "DTU1 RS485 通信异常",
  "50901.warning.dtu2Rs485CommunicationAbnormality": " DTU2 RS485 通信异常",
  "50901.warning.dtu3Rs485CommunicationAbnormality": "DTU3 RS485 通信异常",
  "50901.warning.dtu4Rs485CommunicationAbnormality": "DTU4 RS485 通信异常",
  "50901.warning.dtu5Rs485CommunicationAbnormality": " DTU5 RS485 通信异常",
  "50901.warning.evCharger1CommunicationAbnormality": "电动汽车充电桩1通信异常",
  "50901.warning.evCharger2CommunicationAbnormality": "电动汽车充电桩2通信异常",
  "50901.warning.evCharger1Fault": "充电桩1故障",
  "50901.warning.evCharger2Fault": "充电桩2故障",
  "50901.warning.sustainedNegativeLoad": "持续负负载",
  "50901.warning.batteryCapacityAbnormality": " 电池容量异常",
  "50901.warning.fanSpeedAbnormality": "风扇转速异常",
  "50901.warning.batteryForceChargeRequest": " 电池强制充电请求",
  "50901.warning.hmidCommunicationAbnormality": "人机交互界面通信异常",
  "50901.warning.hmidMachineFault": "人机交互界面设备故障",
  "50901.warning.masterSlaveCommunicationAbnormality": "主从通信异常",
  "50901.fault.kmRelayFault": "KM继电器故障",
  "50901.fault.genRelayAFault": "​​ 发电机A继电器故障",
  "50901.fault.genRelayBFault": "发电机B继电器故障",
  "50901.fault.pvRelayAbFault": "光伏AB继电器故障",
  "50901.fault.loadRelayAFault": "负载A继电器故障",
  "50901.fault.loadRelayBFault": "​​ 负载B继电器故障",
  "50901.fault.gridMeter": "电网电表通信失败",
  "50901.fault.inverterCommunicationFailed": "逆变器通信失败",
  "50901.fault.inverterCanCommunicationFailed": "逆变器CAN通信失败",
  "50901.fault.overtemperatureAlarm": "过热报警",
  "50901.fault.threePointThreeVoltPowerSupplyFault": "3.3V电源故障",
  "50901.fault.fiveVoltPowerSupplyFault": " 5V电源故障",
  "50901.fault.twelveVoltPowerSupplyFault": "12V电源故障",
  "50901.fault.emergencyStopSwitchStatus": "紧急停止",
  "50901.fault.gridPortOvercurrent": "电网端口过流",
  "50901.fault.genPortOvercurrent": "发电机端口过流",
  "50901.fault.pvPortOvercurrent": "光伏端口过流",
  "50901.fault.smartloadPortOvercurrent": "智能负载端口过流",
  "50901.warning.batteryLowVoltageAlarm.0": "disable",
  "50901.warning.batteryLowVoltageAlarm.1": "enable",
  "50901.fault.testFault.0": "disable",
  "50901.fault.testFault.1": "enable",
  "50901.warning.batteryHighVoltageAlarm.0": "不使能",
  "50901.warning.batteryHighVoltageAlarm.1": "使能",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.0": "不使能",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.1": "enable",
  "50901.warning.batteryPackChargeHighVoltageAlarm.0": "disable",
  "50901.warning.batteryPackChargeHighVoltageAlarm.1": "enable",
  "50901.warning.chargeLowTemperatureAlarm.0": "disable",
  "50901.warning.chargeLowTemperatureAlarm.1": "enable",
  "50901.warning.chargeHighTemperatureAlarm.0": "disable",
  "50901.warning.chargeHighTemperatureAlarm.1": "enable",
  "50901.warning.dischargeLowTemperatureAlarm.0": "disable",
  "50901.warning.dischargeLowTemperatureAlarm.1": "enable",
  "50901.warning.dischargeHighTemperatureAlarm.0": "不使能",
  "50901.warning.dischargeHighTemperatureAlarm.1": "enable",
  "50901.warning.inputOvervoltageAlarm.0": "disable",
  "50901.warning.inputOvervoltageAlarm.1": "enable",
  "50901.fault.shutDown.0": "disable",
  "50901.fault.shutDown.1": "enable",
  "50901.fault.hardwareProtection.0": "不使能",
  "50901.fault.hardwareProtection.1": "使能",
  "50901.fault.comparatorFault.0": "disable",
  "50901.fault.comparatorFault.1": "enable",
  "50901.fault.spiCommunicationFault.0": "disable",
  "50901.fault.spiCommunicationFault.1": "enable",
  "50901.fault.armCommunicationFault.0": "disable",
  "50901.fault.armCommunicationFault.1": "使能",
  "50901.fault.samplingBiasAbnormality.0": "disable",
  "50901.fault.samplingBiasAbnormality.1": "enable",
  "50901.fault.cmpssBiasCalculationError.0": "disable",
  "50901.fault.cmpssBiasCalculationError.1": "enable",
  "50901.fault.e2rpomFault.0": "disable",
  "50901.fault.e2rpomFault.1": "enable",
  "50901.fault.pvFault.0": "disable",
  "50901.fault.pvFault.1": "enable",
  "50901.warning.batteryFault.0": "disable",
  "50901.warning.batteryFault.1": "enable",
  "50901.fault.auxiliaryPowerAbnormality.0": "disable",
  "50901.fault.auxiliaryPowerAbnormality.1": "enable",
  "50901.fault.gridRelayProtection.0": "disable",
  "50901.fault.gridRelayProtection.1": "enable",
  "50901.fault.busbarAbnormality.0": "disable",
  "50901.fault.busbarAbnormality.1": "enable",
  "50901.fault.fanFault.0": "不使能",
  "50901.fault.fanFault.1": "enable",
  "50901.fault.machineTypeMismatch.0": "disable",
  "50901.fault.machineTypeMismatch.1": "enable",
  "50901.fault.versionMismatch.0": "disable",
  "50901.fault.versionMismatch.1": "enable",
  "50901.fault.wiringAbnormality.0": "disable",
  "50901.fault.wiringAbnormality.1": "enable",
  "50901.fault.pvVoltageExceedingBusVoltage.0": "disable",
  "50901.fault.pvVoltageExceedingBusVoltage.1": "enable",
  "50901.fault.driveAbnormality.0": "disable",
  "50901.fault.driveAbnormality.1": "enable",
  "50901.fault.temperatureAbnormality.0": "disable",
  "50901.fault.temperatureAbnormality.1": "enable",
  "50901.fault.epsRelayProtection.0": "disable",
  "50901.fault.epsRelayProtection.1": "enable",
  "50901.fault.lowBatteryEnergy.0": "不使能",
  "50901.fault.lowBatteryEnergy.1": "使能",
  "50901.fault.epsVoltageAbnormality.0": "disable",
  "50901.fault.epsVoltageAbnormality.1": "enable",
  "50901.fault.epsOverload.0": "disable",
  "50901.fault.epsOverload.1": "enable",
  "50901.fault.genAbnormality.0": "disable",
  "50901.fault.genAbnormality.1": "enable",
  "50901.fault.genOverload.0": "disable",
  "50901.fault.genOverload.1": "enable",
  "50901.fault.meterWiringAbnormality.0": "disable",
  "50901.fault.meterWiringAbnormality.1": "enable",
  "50901.fault.canCommunicationTimeout.0": "不使能",
  "50901.fault.canCommunicationTimeout.1": "使能",
  "50901.fault.preSynchronizationFailed.0": "disable",
  "50901.fault.preSynchronizationFailed.1": "enable",
  "50901.fault.pllLockFailed.0": "disable",
  "50901.fault.pllLockFailed.1": "enable",
  "50901.fault.gridVoltageAbnormality.0": "disable",
  "50901.fault.gridVoltageAbnormality.1": "enable",
  "50901.fault.gridOvervoltage.0": "disable",
  "50901.fault.gridOvervoltage.1": "enable",
  "50901.fault.gridUndervoltage.0": "disable",
  "50901.fault.gridUndervoltage.1": "enable",
  "50901.fault.tenMinuteOvervoltage.0": "disable",
  "50901.fault.tenMinuteOvervoltage.1": "enable",
  "50901.fault.gridOverfrequency.0": "disable",
  "50901.fault.gridOverfrequency.1": "enable",
  "50901.fault.gridUnderfrequency.0": "disable",
  "50901.fault.gridUnderfrequency.1": "enable",
  "50901.fault.frequencyVariationRateOutOfRange.0": "disable",
  "50901.fault.frequencyVariationRateOutOfRange.1": "enable",
  "50901.fault.reconnectionFailed.0": "disable",
  "50901.fault.reconnectionFailed.1": "enable",
  "50901.fault.gridPowerOutage.0": "disable",
  "50901.fault.gridPowerOutage.1": "enable",
  "50901.fault.neutralWireNotConnected.0": "disable",
  "50901.fault.neutralWireNotConnected.1": "enable",
  "50901.fault.lineToEarthFault.0": "disable",
  "50901.fault.lineToEarthFault.1": "enable",
  "50901.fault.neutralWireToEarthFault.0": "disable",
  "50901.fault.neutralWireToEarthFault.1": "enable",
  "50901.fault.arcSelfTestFault.0": "disable",
  "50901.fault.arcSelfTestFault.1": "enable",
  "50901.fault.arcFault.0": "disable",
  "50901.fault.arcFault.1": "enable",
  "50901.fault.insulationFault.0": "disable",
  "50901.fault.insulationFault.1": "enable",
  "50901.fault.rcdSelfTestFault.0": "disable",
  "50901.fault.rcdSelfTestFault.1": "enable",
  "50901.fault.rcdFault.0": "disable",
  "50901.fault.rcdFault.1": "enable",
  "50901.fault.flashCommunicationFault.0": "disable",
  "50901.fault.flashCommunicationFault.1": "enable",
  "50901.fault.gridOffVoltageDcOffsetOutOfRange.0": "disable",
  "50901.fault.gridOffVoltageDcOffsetOutOfRange.1": "enable",
  "50901.fault.gridCurrentDcOffsetOutOfRange.0": "disable",
  "50901.fault.gridCurrentDcOffsetOutOfRange.1": "enable",
  "50901.fault.interruptOverflow.0": "disable",
  "50901.fault.interruptOverflow.1": "enable",
  "50901.fault.microelectronicFault.0": "disable",
  "50901.fault.microelectronicFault.1": "enable",
  "50901.fault.lowAmbientTemperature.0": "disable",
  "50901.fault.lowAmbientTemperature.1": "enable",
  "50901.fault.overTemperature.0": "disable",
  "50901.fault.overTemperature.1": "enable",
  "50901.warning.dspPwrCommunicationAbnormality.0": "disable",
  "50901.warning.dspPwrCommunicationAbnormality.1": "enable",
  "50901.warning.dspSafCommunicationAbnormality.0": "disable",
  "50901.warning.dspSafCommunicationAbnormality.1": "enable",
  "50901.warning.pvMeterCommunicationAbnormality.0": "disable",
  "50901.warning.pvMeterCommunicationAbnormality.1": "enable",
  "50901.warning.gridMeterCommunicationAbnormality.0": "disable",
  "50901.warning.gridMeterCommunicationAbnormality.1": "enable",
  "50901.warning.bmsCanCommunicationAbnormality.0": "disable",
  "50901.warning.bmsCanCommunicationAbnormality.1": "enable",
  "50901.warning.lowDtuVersion.0": "disable",
  "50901.warning.lowDtuVersion.1": "enable",
  "50901.warning.dtsCommunicationAbnormality.0": "disable",
  "50901.warning.dtsCommunicationAbnormality.1": "enable",
  "50901.warning.gridMeterTypeError.0": "disable",
  "50901.warning.gridMeterTypeError.1": "enable",
  "50901.warning.pvMeterTypeError.0": "disable",
  "50901.warning.pvMeterTypeError.1": "enable",
  "50901.warning.slaveWrongBatteryConnection.0": "disable",
  "50901.warning.slaveWrongBatteryConnection.1": "enable",
  "50901.warning.dtu1Rs485CommunicationAbnormality.0": "disable",
  "50901.warning.dtu1Rs485CommunicationAbnormality.1": "enable",
  "50901.warning.dtu2Rs485CommunicationAbnormality.0": "disable",
  "50901.warning.dtu2Rs485CommunicationAbnormality.1": "enable",
  "50901.warning.dtu3Rs485CommunicationAbnormality.0": "disable",
  "50901.warning.dtu3Rs485CommunicationAbnormality.1": "enable",
  "50901.warning.dtu4Rs485CommunicationAbnormality.0": "disable",
  "50901.warning.dtu4Rs485CommunicationAbnormality.1": "enable",
  "50901.warning.dtu5Rs485CommunicationAbnormality.0": "disable",
  "50901.warning.dtu5Rs485CommunicationAbnormality.1": "enable",
  "50901.warning.evCharger1CommunicationAbnormality.0": "disable",
  "50901.warning.evCharger1CommunicationAbnormality.1": "enable",
  "50901.warning.evCharger2CommunicationAbnormality.0": "disable",
  "50901.warning.evCharger2CommunicationAbnormality.1": "enable",
  "50901.warning.evCharger1Fault.0": "disable",
  "50901.warning.evCharger1Fault.1": "enable",
  "50901.warning.evCharger2Fault.0": "disable",
  "50901.warning.evCharger2Fault.1": "enable",
  "50901.warning.sustainedNegativeLoad.0": "disable",
  "50901.warning.sustainedNegativeLoad.1": "enable",
  "50901.warning.batteryCapacityAbnormality.0": "disable",
  "50901.warning.batteryCapacityAbnormality.1": "enable",
  "50901.warning.fanSpeedAbnormality.0": "disable",
  "50901.warning.fanSpeedAbnormality.1": "enable",
  "50901.warning.batteryForceChargeRequest.0": "disable",
  "50901.warning.batteryForceChargeRequest.1": "enable",
  "50901.warning.hmidCommunicationAbnormality.0": "disable",
  "50901.warning.hmidCommunicationAbnormality.1": "enable",
  "50901.warning.hmidMachineFault.0": "disable",
  "50901.warning.hmidMachineFault.1": "enable",
  "50901.warning.masterSlaveCommunicationAbnormality.0": "disable",
  "50901.warning.masterSlaveCommunicationAbnormality.1": "enable",
  "50901.fault.kmRelayFault.0": "disable",
  "50901.fault.kmRelayFault.1": "使能",
  "50901.fault.genRelayAFault.0": "disable",
  "50901.fault.genRelayAFault.1": "enable",
  "50901.fault.genRelayBFault.0": "disable",
  "50901.fault.genRelayBFault.1": "使能",
  "50901.fault.pvRelayAbFault.0": "disable",
  "50901.fault.pvRelayAbFault.1": "enable",
  "50901.fault.loadRelayAFault.0": "disable",
  "50901.fault.loadRelayAFault.1": "使能",
  "50901.fault.loadRelayBFault.0": "disable",
  "50901.fault.loadRelayBFault.1": "enable",
  "50901.fault.gridMeter.0": "不使能",
  "50901.fault.gridMeter.1": "enable",
  "50901.fault.inverterCommunicationFailed.0": "disable",
  "50901.fault.inverterCommunicationFailed.1": "enable",
  "50901.fault.inverterCanCommunicationFailed.0": "disable",
  "50901.fault.inverterCanCommunicationFailed.1": "enable",
  "50901.fault.overtemperatureAlarm.0": "disable",
  "50901.fault.overtemperatureAlarm.1": "enable",
  "50901.fault.threePointThreeVoltPowerSupplyFault.0": "disable",
  "50901.fault.threePointThreeVoltPowerSupplyFault.1": "enable",
  "50901.fault.fiveVoltPowerSupplyFault.0": "不使能",
  "50901.fault.fiveVoltPowerSupplyFault.1": "enable",
  "50901.fault.twelveVoltPowerSupplyFault.0": "disable",
  "50901.fault.twelveVoltPowerSupplyFault.1": "enable",
  "50901.fault.emergencyStopSwitchStatus.0": "disable",
  "50901.fault.emergencyStopSwitchStatus.1": "使能",
  "50901.fault.gridPortOvercurrent.0": "不使能",
  "50901.fault.gridPortOvercurrent.1": "enable",
  "50901.fault.genPortOvercurrent.0": "disable",
  "50901.fault.genPortOvercurrent.1": "enable",
  "50901.fault.pvPortOvercurrent.0": "不使能",
  "50901.fault.pvPortOvercurrent.1": "enable",
  "50901.fault.smartloadPortOvercurrent.0": "disable",
  "50901.fault.smartloadPortOvercurrent.1": "enable",
  "50901.warning": "告警",
  "50901.fault": "故障",
  "device.offline": "设备离线",
  "solid.snake.msf.test": "索力德",
  "bigboss.shaed.test": "通用端测试",
  "ywt.60419.AllowCounterCurrentPower": "允许逆流功率",
  "ywt.60419.internalharderror0": "无异常",
  "ywt.60419.loadDropMode": "降载模式",
  "ywt.60419.loadDropMode11": "单机防逆流降额",
  "ywt.60419.meterCommQuality": "电表通讯质量",
  "ywt.60419.meterRPower": "电表R相功率",
  "ywt.60419.meterSelect": "电表选择",
  "ywt.60419.meterSPower": "电表S相功率",
  "ywt.60419.meterTPower": "电表T相功率",
  "ywt.60419.multiReverseFlowEnable": "多机防逆流使能",
  "ywt.60419.restrictCounterCurrent": "限制逆流方式",
  "ywt.60419.singleReverseFlowEnable": "单机防逆流使能",
  "bw_param_ctrl_group_ParallelSetting": "并机设置",
  "bw_param_ctrl_group_SpecialSetting": "特殊设置",
  "bw_param_ctrl_name_PhaseOrderResume": "相序自适应",
  "bw_param_ctrl_note_ParallelModeSetting": "设置逆变器是并机运行的主单元还是从单元。",
  "bw_param_ctrl_option_host": "并机模式下的主机",
  "bw_param_ctrl_option_PhaseOrderResume": "复位",
  "bw_param_ctrl_option_single": "非并机模式（单机模式）",
  "bw_param_ctrl_option_Slave": "并机模式下的从机",
  "ice.robot.strategy.type.pea.sha.val.fil": "削峰填谷",
  "ice.robot.strategy.type.pho.con": "光伏消纳",
  "ice.robot.strategy.type.self.use": "自发自用",
  "ice.robot.strategy.type.sur.ele.on.grid": "余电上网",
  "ice.robot.strategy.type.grid.priority": "上网优先",
  "ice.robot.strategy.type.int.str": "智能策略",
  "ice.robot.strategy.type.manual.strategy": "手动策略",
  "charge.discharge.state.charge": "充电",
  "charge.discharge.state.discharge": "放电",
  "ice.rob.stra.det.typ.pea.sha.val.fil": "削峰填谷",
  "ice.rob.stra.det.typ.pea.cha.pri": "优先充电",
  "ice.rob.stra.det.typ.pea.discha.pri": "优先放电",
  "ice.rob.stra.det.typ.pho.con": "光伏消纳",
  "ice.rob.stra.det.typ.discha.pri": "优先放电",
  "ice.rob.stra.det.typ.cha.pri": "优先充电",
  "ice.rob.stra.execute.state.executing": "执行中",
  "ice.rob.stra.execute.state.executed": "执行完毕",
  "0X3809-F-0607": "PV端子过温保护故障",
  "0X3809-F-1103": "继电器自检异常",
  "0X3809-F-3112": "电网电压锁相故障",
  "0X3809-F-3113": "电网相序异常",
  "0X3809-S-0101": "1.检查光伏组件连接是否正常，组件是否存在损坏或表面积灰、有遮挡物的情况。\n2.检查光伏组件是否连接正常，组件电压规格是否高于逆变器工作电压范围。\n3.检查光伏组件是否存在短路情况。",
  "0X3809-S-0102": "1.检查光伏组件连接是否正常，组件是否存在损坏或表面积灰、有遮挡物的情况。\n2.检查光伏组件是否连接正常，组件电压规格是否高于逆变器工作电压范围。\n3.检查光伏组件是否存在短路情况。",
  "0X3809-S-0103": "1.检查光伏组件连接是否正常，组件是否存在损坏或表面积灰、有遮挡物的情况。\n2.检查光伏组件是否连接正常，组件电压规格是否高于逆变器工作电压范围。\n3.检查光伏组件是否存在短路情况。",
  "0X3809-S-0301": "1.多出现在清晨，请检查光伏面板表面清洁程度。\n2.检查光伏面板是否连接正常，面板电压规格是否高于逆变器工作电压范围。\n3.请重启逆变器，若故障未能消除，请联系经销商。",
  "0X3809-S-0302": "1.多出现在清晨，请检查光伏面板表面清洁程度。\n2.检查光伏面板是否连接正常，面板电压规格是否高于逆变器工作电压范围。\n3.请重启逆变器，若故障未能消除，请联系经销商。",
  "0X3809-S-0303": "1.多出现在清晨，请检查光伏面板表面清洁程度。\n2.检查光伏面板是否连接正常，面板电压规格是否高于逆变器工作电压范围。\n3.请重启逆变器，若故障未能消除，请联系经销商。",
  "0X3809-S-0304": "1.多出现在清晨，请检查光伏面板表面清洁程度。\n2.检查光伏面板是否连接正常，面板电压规格是否高于逆变器工作电压范围。\n3.请重启逆变器，若故障未能消除，请联系经销商。",
  "0X3809-S-0501": "请重启逆变器，若故障未能消除，请联系经销商。",
  "0X3809-S-0502": "请重启逆变器，若故障未能消除，请联系经销商。",
  "0X3809-S-0503": "请重启逆变器，若故障未能消除，请联系经销商。",
  "0X3809-S-0504": "请重启逆变器，若故障未能消除，请联系经销商。",
  "0X3809-S-0505": "请重启逆变器，若故障未能消除，请联系经销商。",
  "0X3809-S-0506": "请重启逆变器，若故障未能消除，请联系经销商。",
  "0X3809-S-0507": "请重启逆变器，若故障未能消除，请联系经销商。",
  "0X3809-S-0508": "请重启逆变器，若故障未能消除，请联系经销商。",
  "0X3809-S-0601": "1.检查风扇是否被异物卡住\n2.检查散热器风道是否被堵塞\n3.冷却后重启逆变器，若不能恢复，请联系经销商",
  "0X3809-S-0602": "1.检查风扇是否被异物卡住\n2.检查散热器风道是否被堵塞\n3.冷却后重启逆变器，若不能恢复，请联系经销商",
  "0X3809-S-0603": "1.检查风扇是否被异物卡住\n2.检查散热器风道是否被堵塞\n3.冷却后重启逆变器，若不能恢复，请联系经销商",
  "0X3809-S-0604": "1.检查风扇是否被异物卡住\n2.检查散热器风道是否被堵塞\n3.冷却后重启逆变器，若不能恢复，请联系经销商",
  "0X3809-S-0605": "1.检查风扇是否被异物卡住\n2.检查散热器风道是否被堵塞\n3.冷却后重启逆变器，若不能恢复，请联系经销商",
  "0X3809-S-0606": "1.检查风扇是否被异物卡住\n2.检查散热器风道是否被堵塞\n3.冷却后重启逆变器，若不能恢复，请联系经销商",
  "0X3809-S-0607": "1.检查风扇是否被异物卡住\n2.检查散热器风道是否被堵塞\n3.冷却后重启逆变器，若不能恢复，请联系经销商",
  "0X3809-S-0701": "1.检查组件是否对地短路\n2.检查直流是否有虚接现象\n3.确定直流没有问题的话，断电5分钟后，重新送电，如不能恢复，请联系经销商",
  "0X3809-S-0801": "1.驱动电路故障\n2.断电重启逆变器，如不能恢复，请联系经销商",
  "0X3809-S-0901": "1.控制板故障\n2.断电重启逆变器，如不能恢复，请联系经销商",
  "0X3809-S-0902": "1.控制板故障\n2.断电重启逆变器，如不能恢复，请联系经销商",
  "0X3809-S-0903": "1.控制板故障\n2.断电重启逆变器，如不能恢复，请联系经销商",
  "0X3809-S-0904": "1.控制板故障\n2.断电重启逆变器，如不能恢复，请联系经销商",
  "0X3809-S-0905": "1.控制板故障\n2.断电重启逆变器，如不能恢复，请联系经销商",
  "0X3809-S-0906": "1.控制板故障\n2.断电重启逆变器，如不能恢复，请联系经销商",
  "0X3809-S-0907": "1.控制板故障\n2.断电重启逆变器，如不能恢复，请联系经销商",
  "0X3809-S-1001": "1.如果偶然出现，可能是外部线路偶然异常导致，重启逆变器后会恢复正常工作。\n2.如果频繁出现或长时间无法恢复，请检查光伏组串接地是否可靠。",
  "0X3809-S-1002": "1.如果偶然出现，可能是外部线路偶然异常导致，重启逆变器后会恢复正常工作。\n2.如果频繁出现或长时间无法恢复，请检查光伏组串接地是否可靠。",
  "0X3809-S-1003": "1.如果偶然出现，可能是外部线路偶然异常导致，重启逆变器后会恢复正常工作。\n2.如果频繁出现或长时间无法恢复，请检查光伏组串接地是否可靠。",
  "0X3809-S-1004": "1.如果偶然出现，可能是外部线路偶然异常导致，重启逆变器后会恢复正常工作。\n2.如果频繁出现或长时间无法恢复，请检查光伏组串接地是否可靠。",
  "0X3809-S-1101": "1.检查交流侧地线是否存在带电情况\n2.内部继电器故障\n3.断电重启逆变器，如不能恢复，请联系经销商",
  "0X3809-S-1102": "1.检查交流侧地线是否存在带电情况\n2.内部继电器故障\n3.断电重启逆变器，如不能恢复，请联系经销商",
  "0X3809-S-1103": "1.检查交流侧地线是否存在带电情况\n2.内部继电器故障\n3.断电重启逆变器，如不能恢复，请联系经销商",
  "0X3809-S-1201": "1.内部风扇损坏\n2.风扇检测电路故障\n3.断电重启逆变器，如不能恢复，请联系经销商",
  "0X3809-S-1901": "断电重启逆变器，如不能恢复，请联系经销商",
  "0X3809-S-1902": "断电重启逆变器，如不能恢复，请联系经销商",
  "0X3809-S-1903": "断电重启逆变器，如不能恢复，请联系经销商",
  "0X3809-S-1904": "断电重启逆变器，如不能恢复，请联系经销商",
  "0X3809-S-1905": "断电重启逆变器，如不能恢复，请联系经销商",
  "0X3809-S-1906": "断电重启逆变器，如不能恢复，请联系经销商",
  "0X3809-S-1907": "断电重启逆变器，如不能恢复，请联系经销商",
  "0X3809-S-3101": "1.检查配电箱是否有空开跳闸\n2.测量实际电压是否超过逆变器范围\n3.如果是电压超范围，可以调整逆变器过欠压保护值",
  "0X3809-S-3102": "1.检查配电箱是否有空开跳闸\n2.测量实际电压是否超过逆变器范围\n3.如果是电压超范围，可以调整逆变器过欠压保护值",
  "0X3809-S-3103": "1.检查配电箱是否有空开跳闸\n2.测量实际电压是否超过逆变器范围\n3.如果是电压超范围，可以调整逆变器过欠压保护值",
  "0X3809-S-3104": "1.检查配电箱是否有空开跳闸\n2.测量实际电压是否超过逆变器范围\n3.如果是电压超范围，可以调整逆变器过欠压保护值",
  "0X3809-S-3105": "1.检查配电箱是否有空开跳闸\n2.测量实际电压是否超过逆变器范围\n3.如果是电压超范围，可以调整逆变器过欠压保护值",
  "0X3809-S-3106": "1.检查配电箱是否有空开跳闸\n2.测量实际电压是否超过逆变器范围\n3.如果是电压超范围，可以调整逆变器过欠压保护值",
  "0X3809-S-3107": "1.检查配电箱是否有空开跳闸\n2.测量实际电压是否超过逆变器范围\n3.如果是电压超范围，可以调整逆变器过欠压保护值",
  "0X3809-S-3108": "1.检查配电箱是否有空开跳闸\n2.测量实际电压是否超过逆变器范围\n3.如果是电压超范围，可以调整逆变器过欠压保护值",
  "0X3809-S-3109": "1.检查配电箱是否有空开跳闸\n2.测量实际电压是否超过逆变器范围\n3.如果是电压超范围，可以调整逆变器过欠压保护值",
  "0X3809-S-3110": "1.检查配电箱是否有空开跳闸\n2.测量实际电压是否超过逆变器范围\n3.如果是电压超范围，可以调整逆变器过欠压保护值",
  "0X3809-S-3111": "1.检查配电箱是否有空开跳闸\n2.测量实际电压是否超过逆变器范围\n3.如果是电压超范围，可以调整逆变器过欠压保护值",
  "0X3809-S-3112": "1.检查配电箱是否有空开跳闸\n2.测量实际电压是否超过逆变器范围\n3.如果是电压超范围，可以调整逆变器过欠压保护值",
  "0X3809-S-3113": "1.检查配电箱是否有空开跳闸\n2.测量实际电压是否超过逆变器范围\n3.如果是电压超范围，可以调整逆变器过欠压保护值",
  "0X3809-S-3301": "1.检查电网是否有虚接情况\n2.适当调整频率范围",
  "0X3809-S-3302": "1.检查电网是否有虚接情况\n2.适当调整频率范围",
  "0X3809-S-3303": "1.检查电网是否有虚接情况\n2.适当调整频率范围",
  "0X3809-S-3304": "1.检查电网是否有虚接情况\n2.适当调整频率范围",
  "0X3809-S-3305": "1.检查电网是否有虚接情况\n2.适当调整频率范围",
  "0X3809-S-3306": "1.检查电网是否有虚接情况\n2.适当调整频率范围",
  "0X3809-S-3701": "请检查是否认为对逆变器设置了关机",
  "0X3809-S-3801": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3802": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3803": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3804": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3805": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3806": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3807": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3808": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3809": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3810": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3811": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3812": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3813": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3814": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3815": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3816": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3817": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3818": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3819": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3820": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3901": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3902": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3903": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3904": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3905": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3906": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3907": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3908": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3909": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3910": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3911": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3912": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3913": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3914": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3915": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3916": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3917": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3918": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3919": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-3920": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-4101": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-4201": "检查N-PE电压是否异常",
  "0X3809-S-4301": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3809-S-4401": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "0X3807-F-02": "PV2短路告警",
  "0X3807-F-03": "PV电压低告警",
  "0X3807-S-0101": "1.检查风扇是否有异物卡住,\n2.检查风扇是否正常转动\n3.重启逆变器，不能恢复的话，请更换风扇",
  "0X3807-S-0102": "1.检查风扇是否有异物卡住,\n2.检查风扇是否正常转动\n3.重启逆变器，不能恢复的话，请更换风扇",
  "0X3807-S-0103": "1.检查风扇是否有异物卡住,\n2.检查风扇是否正常转动\n3.重启逆变器，不能恢复的话，请更换风扇",
  "0X3807-S-0104": "1.检查风扇是否有异物卡住,\n2.检查风扇是否正常转动\n3.重启逆变器，不能恢复的话，请更换风扇",
  "0X3807-S-0105": "1.检查风扇是否有异物卡住,\n2.检查风扇是否正常转动\n3.重启逆变器，不能恢复的话，请更换风扇",
  "0X3807-S-0106": "1.检查风扇是否有异物卡住,\n2.检查风扇是否正常转动\n3.重启逆变器，不能恢复的话，请更换风扇",
  "0X3807-S-0107": "1.检查风扇是否有异物卡住,\n2.检查风扇是否正常转动\n3.重启逆变器，不能恢复的话，请更换风扇",
  "0X3807-S-0108": "1.检查风扇是否有异物卡住,\n2.检查风扇是否正常转动\n3.重启逆变器，不能恢复的话，请更换风扇",
  "0X3807-S-0109": "1.检查风扇是否有异物卡住,\n2.检查风扇是否正常转动\n3.重启逆变器，不能恢复的话，请更换风扇",
  "0X3807-S-0110": "1.检查风扇是否有异物卡住,\n2.检查风扇是否正常转动\n3.重启逆变器，不能恢复的话，请更换风扇",
  "0X3807-S-0401": "检查电表接线是否错误",
  "0X3807-S-0402": "检查电表接线是否错误",
  "0X3807-S-0404": "检查电表接线是否错误",
  "0X3807-S-0408": "检查电表接线是否错误",
  "0X3807-S-0416": "检查电表接线是否错误",
  "0X3807-S-0500": "1.如偶然出现， 为电网瞬时出现异常，电网复常后逆变器会恢复正常工作；\n2.如频繁报此故障， 请检查电网是否异常。",
  "0X3807-S-0601": "关机后检查组件电压是否正常，重启不能恢复的话，说明逆变器内部故障",
  "0X3807-S-02": "关机后检查组件电压是否正常，重启不能恢复的话，说明逆变器内部故障",
  "0X3807-S-03": "关机后检查组件电压是否正常，重启不能恢复的话，说明逆变器内部故障",
  "In Alarm": "告警中",
  "50651.group_1.Inverter_edgl_YC": "额定功率",
  "50651.group_1.Inverter_dycgj_YC": "读远程关机",
  "50651.group_1.Inverter_dglsz_YC": "读功率设置",
  "50651.group_1.Inverter_nbqgzzt_YC": "逆变器工作状态",
  "50651.group_1.Inverter_zgjm_YC": "主告警码",
  "50651.group_1.Inverter_zgj1m_YC": "子告警码",
  "50651.group_1.Inverter_zgzm_YC": "主故障码",
  "50651.group_1.Inverter_zgz1m_YC": "子故障码",
  "50651.group_1.Inverter_PBUSdy_YC": "PBUS电压",
  "50651.group_1.Inverter_NBUSdy_YC": "NBUS电压",
  "50651.group_1.Inverter_RSdwxdy_YC": "RS电网线电压",
  "50651.group_1.Inverter_STdwxdy_YC": "ST电网线电压",
  "50651.group_1.Inverter_TRdwxdy_YC": "TR电网线电压",
  "50651.group_1.Inverter_Rdwxdy_YC": "R电网相电压",
  "50651.group_1.Inverter_Sdwxdy_YC": "S电网相电压",
  "50651.group_1.Inverter_Tdwxdy_YC": "T电网相电压",
  "50651.group_1.Inverter_Rxbwdl_YC": "R相并网电流",
  "50651.group_1.Inverter_Sxbwdl_YC": "S相并网电流",
  "50651.group_1.Inverter_Txbwdl_YC": "T相并网电流",
  "50651.group_1.Inverter_RSdwpl_YC": "RS电网频率",
  "50651.group_1.Inverter_yggl_YC": "有功功率",
  "50651.group_1.Inverter_wggl_YC": "无功功率",
  "50651.group_1.Inverter_glys_YC": "功率因数",
  "50651.group_1.Inverter_INVmkRwd_YC": "INV模块R温度",
  "50651.group_1.Inverter_INVmkSwd_YC": "INV模块S温度",
  "50651.group_1.Inverter_INVmkTwd_YC": "INV模块T温度",
  "50651.group_1.Inverter_hjwd_YC": "环境温度",
  "50651.group_1.Inverter_srqwd_YC": "散热器温度",
  "50651.group_1.Inverter_dtfdl_YC": "当天发电量",
  "50651.group_1.Inverter_zfdl_YC": "总发电量",
  "50651.group_1.Inverter_PV1srdy_YC": "PV1输入电压",
  "50651.group_1.Inverter_PV1srdl_YC": "PV1输入电流",
  "50651.group_1.Inverter_PV2srdy_YC": "PV2输入电压",
  "50651.group_1.Inverter_PV2srdl_YC": "PV2输入电流",
  "50651.group_1.Inverter_PV3srdy_YC": "PV3输入电压",
  "50651.group_1.Inverter_PV3srdl_YC": "PV3输入电流",
  "50651.group_1.Inverter_PV4srdy_YC": "PV4输入电压",
  "50651.group_1.Inverter_PV4srdl_YC": "PV4输入电流",
  "50651.group_1.Inverter_PV5srdy_YC": "PV5输入电压",
  "50651.group_1.Inverter_PV5srdl_YC": "PV5输入电流",
  "50651.group_1.Inverter_PV6srdy_YC": "PV6输入电压",
  "50651.group_1.Inverter_PV6srdl_YC": "PV6输入电流",
  "50651.group_1.Inverter_PV7srdy_YC": "PV7输入电压",
  "50651.group_1.Inverter_PV7srdl_YC": "PV7输入电流",
  "50651.group_1.Inverter_PV8srdy_YC": "PV8输入电压",
  "50651.group_1.Inverter_PV8srdl_YC": "PV8输入电流",
  "50651.group_1.Inverter_PV9srdy_YC": "PV9输入电压",
  "50651.group_1.Inverter_PV9srdl_YC": "PV9输入电流",
  "50651.group_1.Inverter_PV10srdy_YC": "PV10输入电压",
  "50651.group_1.Inverter_PV10srdl_YC": "PV10输入电流",
  "50651.group_1.Inverter_PV11srdy_YC": "PV11输入电压",
  "50651.group_1.Inverter_PV11srdl_YC": "PV11输入电流",
  "50651.group_1.Inverter_PV12srdy_YC": "PV12输入电压",
  "50651.group_1.Inverter_PV12srdl_YC": "PV12输入电流",
  "50651.group_1.Inverter_zc1dl_YC": "组串1电流",
  "50651.group_1.Inverter_zc3dl_YC": "组串3电流",
  "50651.group_1.Inverter_zc5dl_YC": "组串5电流",
  "50651.group_1.Inverter_zc7dl_YC": "组串7电流",
  "50651.group_1.Inverter_zc9dl_YC": "组串9电流",
  "50651.group_1.Inverter_zc11dl_YC": "组串11电流",
  "50651.group_1.Inverter_zc13dl_YC": "组串13电流",
  "50651.group_1.Inverter_zc15dl_YC": "组串15电流",
  "50651.group_1.Inverter_zc17dl_YC": "组串17电流",
  "50651.group_1.Inverter_zc19dl_YC": "组串19电流",
  "50651.group_1.Inverter_zc21dl_YC": "组串21电流",
  "50651.group_1.Inverter_zc23dl_YC": "组串23电流",
  "50651.group_47138489.Inverter_communication_status_YX": "通讯状态",
  "50651.group_61237278.setActivePower": "有功功率设置",
  "50651.group_61237278.setIsOn": "开关机设置",
  "50651.group_1.Inverter_nbqgzzt_YC.0": "初始化",
  "50651.group_1.Inverter_nbqgzzt_YC.1": "等待",
  "50651.group_1.Inverter_nbqgzzt_YC.2": "并网",
  "50651.group_1.Inverter_nbqgzzt_YC.3": "故障",
  "50651.group_1.Inverter_nbqgzzt_YC.4": "烧录",
  "50651.group_1.Inverter_nbqgzzt_YC.5": "离网",
  "50651.group_1.Inverter_nbqgzzt_YC.6": "旁路",
  "50651.group_1.Inverter_nbqgzzt_YC.7": "PID修复",
  "50651.group_1.Inverter_nbqgzzt_YC.8": "PID抑制",
  "50651.group_1.Inverter_nbqgzzt_YC.9": "除雪模式",
  "50651.group_47138489.Inverter_communication_status_YX.0": "离线",
  "50651.group_47138489.Inverter_communication_status_YX.1": "在线",
  "50651.group_47138489": "遥信",
  "50651.group_61237278": "遥控",
  "50651.group_1": "遥测",
  "collector.upgrade.progress:": "采集器升级进度",
  "获取固件失败": "获取固件失败",
  "File CRC check failed": "文件 CRC 校验失败",
  "烧录超时": "烧录超时",
  "burning failed": "烧录失败",
  "Inverter": "逆变器",
  "Controller": "控制器",
  "Collector": "采集器",
  "BMS": "BMS（.bin）",
  "Inverter (hex)": "逆变器（.hex）",
  "AFCI": "AFCI",
  "BMS（.S19）": "BMS（.S19）",
  "Grid-tie & Off-grid Control Box": "并离网控制盒",
  "逆变器ARM（禾迈）": "逆变器ARM（禾迈）",
  "数据棒（禾迈）": "数据棒（禾迈）",
  "Gateway (Weimai)": "Gateway（禾迈）",
  "Display Screen (Weimai)": "显示屏（禾迈）",
  "HMID (Weimai)": "hmid（禾迈）",
  "DCDC (Weimai)": "DCDC（禾迈）",
  "Battery BMS (Weimai)": "电池BMS（禾迈）",
  "Inverter Auxiliary DSP (Weimai)": "逆变器辅DSP（禾迈）",
  "Inverter Main DSP (Weimai)": "逆变器主DSP（禾迈）",
  "Charging Pile (Weimai)": "充电桩（禾迈）",
  "device.category.energyStorageCabinet": "储能柜",
  "device.category.commercialRobot": "工商业机器人",
  "device.category.pvinverter": "光伏逆变器",
  "settlementMeterType.type.checkpoint": "关口表",
  "settlementMeterType.type.GATEWAY_METER": "关口表",
  "settlementMeterType. PV_METER": "光伏表",
  "settlementMeterType. ENERGY_STORAGE_METER": "储能表",
  "collector.upgrade.progress": "采集器升级进度",
  "device.upgrade.progress": "设备升级进度",
  "failed.to.obtain.firmware": "获取固件失败",
  "file.CRC.check.failed": "文件 CRC 校验失败",
  "burning.timed.out": "烧录超时",
  "burning.failed": "烧录失败",
  "60001.group_collector.bleSignalStrength": "蓝牙信号强度",
  "60001.group_collector.quickReport": "快速上报",
  "60001.group_collector.quickReport.0": "0-上报一组03额定数据",
  "60001.group_collector.quickReport.1": "1-上报一组04实时数据 ",
  "60001.group_collector.bleSignalStrength.desc": "bleSignalStrength",
  "60001.group_collector.quickReport.desc": "快速上报的说明。",
  "shujvabng": "数据棒（禾迈）",
  "paramSet.select.dataError.tip": "该参数当前选项不是最佳选项，请重置它。",
  "ywt.60419.pbusVol": "PBUS电压",
  "common.60419.ywt_groupStrCurrent5": "组串 5 电流",
  "common.60419.ywt_groupStrCurrent6": "组串 6 电流",
  "50901.ctrl_dianchiguanli": "电池管理",
  "common.60419.ywt_groupStrCurrent3": "组串 3 电流",
  "common.60419.ywt_groupStrCurrent4": "组串 4 电流",
  "common.60419.ywt_groupStrCurrent1": "组串 1 电流",
  "common.60419.ywt_groupStrCurrent2": "组串 2 电流",
  "common.60419.ywt_pvInputVol7": "PV7 输入电压",
  "common.60419.ywt_pvInputVol8": "PV8 输入电压",
  "common.60419.ywt_pvInputVol9": "PV9 输入电压",
  "common.60419.ywt_groupStrCurrent9": "组串 9 电流",
  "common.60419.ywt_groupStrCurrent7": "组串 7 电流",
  "common.60419.ywt_groupStrCurrent8": "组串 8 电流",
  "common.60419.ywt_sGridVol": "S 电网相电压",
  "common.60419.ywt_pvInputVol1": "PV1 输入电压",
  "common.60419.ywt_pvInputVol2": "PV2 输入电压",
  "common.60419.ywt_pvInputCurrent10": "PV10 输入电流",
  "common.60419.ywt_pvInputVol3": "PV3 输入电压",
  "common.60419.ywt_pvInputCurrent11": "PV11 输入电流",
  "common.60419.ywt_pvInputVol4": "PV4 输入电压",
  "common.60419.ywt_pvInputCurrent12": "PV12 输入电流",
  "common.60419.ywt_pvInputVol5": "PV5 输入电压",
  "common.60419.ywt_pvInputVol6": "PV6 输入电压",
  "bw_param_qqq": "并机模式设置",
  "paramSet.dateTime.title.month": "月",
  "common.60419.ywt_reactivePower": "无功功率",
  "ywt.60419.invRTemp": "INV 模块 R 温度(℃)",
  "common.60419.ywt_sGridPower": "S 相并网功率",
  "ywt.60419.rGridPower": "R 相并网功率",
  "ywt.60419.sGridVol": "S电网相电压",
  "paramSet.dateTime.title.year": "年",
  "50500_0x7572-C-15": "散热器温度过高",
  "50500_0x7572-C-14": "拉弧故障",
  "50500_0x7572-C-13": "EPS电压低故障",
  "50500_0x7572-C-12": "手动模式下不逆变",
  "50500_0x7572-C-11": "OVER LOAD ",
  "50500_0x7572-C-10": "电池低压故障",
  "60420.real_time.analysis_AC_Side.tag": "交流侧",
  "common.60419.ywt_groupStrCurrent17": "组串 17 电流",
  "common.60419.ywt_groupStrCurrent16": "组串 16 电流",
  "common.60419.ywt_groupStrCurrent19": "组串 19 电流",
  "common.60419.ywt_groupStrCurrent18": "组串 18 电流",
  "common.60419.ywt_groupStrCurrent13": "组串 13 电流",
  "common.60419.ywt_groupStrCurrent12": "组串 12 电流",
  "common.60419.ywt_groupStrCurrent15": "组串 15 电流",
  "common.60419.ywt_groupStrCurrent14": "组串 14 电流",
  "ywt.60419.btDspDebugInfo8": "BT DSP 调试信息8",
  "60420.real_time.workStatus": "逆变器工作状态",
  "ywt.60419.btDspDebugInfo7": "BT DSP 调试信息7",
  "ywt.60419.btDspDebugInfo6": "BT DSP 调试信息6",
  "common.60419.ywt_groupStrCurrent11": "组串 11 电流",
  "common.60419.ywt_groupStrCurrent10": "组串 10 电流",
  "common.60419.ywt_groupStrCurrent23": "组串 23 电流",
  "ywt.60419.sPhaseDci": "S 相 DCI",
  "50500_0x756F-S-6": "DC/DC软启动故障\n 1. 检查电池保险丝；\n 2. 重启并检查是否正常；\n 3. 如果无法恢复到正常状态，请向我们寻求帮助",
  "50500_0x756F-S-7": "INV Relay Fault 1.Confirm that the wiring between each device is correct\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x756F-S-4": "EEPROM Read Fault\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x756F-S-5": "EEPROM Write Fault\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.internalharderror1": "外部 FLASH 异常",
  "ywt.60419.internalharderror3": "写 EEPROM 异常",
  "50500_0x756F-S-8": "Auxiliary power supply failure\n1. Wait for minutes then check;\n2. Remove wifi plug or other communicator;\n3. Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.internalharderror2": "读 EEPROM 异常",
  "50500_0x756F-S-9": "辅助电源故障\n 1. 等待几分钟后再检查；\n 2. 移除无线插头或其他通信设备；\n 3. 如果无法恢复到正常状态，请向我们寻求帮助",
  "common.60419.ywt_groupStrCurrent20": "组串 20 电流",
  "ywt.60419.armDebugInfo7": "ARM 调试信息7",
  "ywt.60419.internalharderror4": "GFCI 自检失败",
  "common.60419.ywt_groupStrCurrent22": "组串 22 电流",
  "ywt.60419.armDebugInfo5": "ARM 调试信息5",
  "common.60419.ywt_groupStrCurrent21": "组串 21 电流",
  "ywt.60419.armDebugInfo6": "ARM 调试信息6",
  "50500_0x756F-S-2": "GFCI Device Fault\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.armDebugInfo3": "ARM 调试信息3",
  "ywt.60419.armDebugInfo4": "ARM 调试信息4",
  "ywt.60419.armDebugInfo1": "ARM 调试信息1",
  "ywt.60419.armDebugInfo2": "ARM 调试信息2",
  "50500_0x756F-C-5": "EEPROM写故障",
  "50500_0x756F-C-4": "EEPROM读故障",
  "50500_0x756F-C-7": " \n逆变继电器故障",
  "50500_0x756F-C-6": "DC/DC软起故障",
  "50500_0x756F-C-9": "辅助电源故障",
  "ywt.60419.deratedPower": "降额功率",
  "50500_0x7570-F-14": "软起动故障",
  "50500_0x7570-F-12": "并联通讯故障",
  "50500_0x756F-C-2": "GFCI设备故障",
  "50500_0x7570-F-11": "并联设置故障",
  "50500_0x7570-F-10": "母线电压不平衡故障",
  "50500_0x756F-C-13": " 模式切换",
  "50500_0x756F-C-14": "逆变软件过流",
  "common.60419.ywt_pvInputPower9": "PV9 输入功率",
  "50500_0x756F-C-12": "电池模式切换故障",
  "common.60419.ywt_pvInputPower8": "PV8 输入功率",
  "common.60419.ywt_pvInputPower7": "PV7 输入功率",
  "common.60419.ywt_pvInputPower6": "PV6 输入功率",
  "common.60419.ywt_pvInputPower5": "PV5 输入功率",
  "common.60419.ywt_pvInputPower4": "PV4 输入功率",
  "common.60419.ywt_pvInputPower3": "PV3 输入功率",
  "common.60419.ywt_pvInputPower2": "PV2 输入功率",
  "common.60419.ywt_pvInputPower1": "PV1 输入功率",
  "ywt.60419.todayPvEnergy": "当天发电量",
  "ywt.60419.btDspDebugInfo1": "BT DSP 调试信息1",
  "ywt.60419.invSTemp": "INV 模块 S 温度(℃)",
  "ywt.60419.btDspDebugInfo5": "BT DSP 调试信息5",
  "ywt.60419.btDspDebugInfo4": "BT DSP 调试信息4",
  "ywt.60419.btDspDebugInfo3": "BT DSP 调试信息3",
  "ywt.60419.btDspDebugInfo2": "BT DSP 调试信息2",
  "ywt.60419.dcInsulationImpedance": "直流绝缘阻抗",
  "common.60419.ywt_sOnGridCurrent": "S 相并网电流",
  "60420.real_time.analysis_groupString.tag": "组串电流",
  "test.label_G_P_C_L1": "发电机L1 功率",
  "ywt.60419.internalHardwareError": "机器内部硬件异常",
  "ywt.60419.versionStr": "版本号",
  "test.label_G_P_C_L5": "发电机L2 电压",
  "common.50500.xnl_RTparam_name_G_P_V_L2": "发电机L2 电压",
  "test.label_G_P_C_L4": "发电机L1 电压",
  "common.60419.ywt_pvInputCurrent": "直流侧",
  "common.50500.xnl_RTparam_name_G_P_V_L3": "发电机L3 电压",
  "test.label_G_P_C_L3": "发电机L3 功率",
  "common.50500.xnl_RTparam_name_G_P_V_L1": "发电机L1 电压",
  "test.label_G_P_C_L6": "发电机L3 电压",
  "ywt.60419.envTemp": "环境温度",
  "bw_param_ctrl_name_ParallelSetting": "并机状态",
  "ywt.60419.rGridVol": "R电网相电压",
  "ywt.60419.scanStatus": "I/V 扫描状态",
  "common.60419.ywt_basic_info": "基本信息",
  "ywt.60419.groupStrCurrent1": "组串 1 电流",
  "ywt.60419.invTTemp": "INV 模块 T 温度(℃)",
  "ywt.60419.groupStrCurrent2": "组串 2 电流",
  "ywt.60419.groupStrCurrent5": "组串 5 电流",
  "common.60419.ywt_rGridVol": "R 电网相电压",
  "ywt.60419.groupStrCurrent6": "组串 6 电流",
  "ywt.60419.groupStrCurrent3": "组串 3 电流",
  "ywt.60419.groupStrCurrent4": "组串 4 电流",
  "ywt.60419.groupStrCurrent9": "组串 9 电流",
  "ywt.60419.groupStrCurrent7": "组串 7 电流",
  "ywt.60419.groupStrCurrent8": "组串 8 电流",
  "common.60419.ywt_activePower": "有功功率",
  "ywt.60419.pvInputVol2": "PV2 输入电压",
  "ywt.60419.pvInputVol1": "PV1 输入电压",
  "ywt.60419.pvPower2": "PV功率2",
  "ywt.60419.pvPower1": "PV功率1",
  "60420.real_time.internalHardwareError": "机器内部硬件异常",
  "ywt.60419.pvPower8": "PV功率8",
  "ywt.60419.pvPower7": "PV功率7",
  "ywt.60419.pvPower9": "PV功率9",
  "50500_0x7571-S-10": "1.Confirm that the wiring between each device is correct\n2. Check the AC voltage is in the range of standard voltage in specification;\n3.Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.pvPower4": "PV功率4",
  "50500_0x7571-S-15": "电网频率超出范围\n 1. 检查频率是否在规格范围内；\n 2.检查AC电缆是否牢固且正确连接；\n 3. 如果无法恢复正常状态，请向我们寻求帮助。",
  "ywt.60419.pvPower3": "PV功率3",
  "ywt.60419.pvPower6": "PV功率6",
  "50500_0x7571-S-13": "备用电池故障。 \n 1. 检查电池容量；\n 2. 检查电池与逆变器之间的连接；\n 3. 如果逆变器在减载后仍无法恢复正常，请向我们寻求帮助",
  "ywt.60419.pvPower5": "PV功率5",
  "50500_0x7571-S-14": "电网频率超出范围\n 1. 检查频率是否在规格范围内；\n 2. 检查AC电缆是否牢固且正确连接；\n 3. 如果无法恢复正常状态，请向我们寻求帮助。",
  "50500_0x7570-C-14": "Soft_Start_Failed",
  "50500_0x7570-C-12": "并联通讯故障",
  "50500_0x7570-C-10": "母线电压不平衡故障",
  "50500_0x7570-C-11": "并联设置故障",
  "ywt.60419.pvInputVol9": "PV9 输入电压",
  "ywt.60419.pvInputVol8": "PV8 输入电压",
  "ywt.60419.pvInputVol7": "PV7 输入电压",
  "ywt.60419.pvInputVol6": "PV6 输入电压",
  "ywt.60419.pvInputVol5": "PV5 输入电压",
  "ywt.60419.pvInputVol4": "PV4 输入电压",
  "ywt.60419.pvInputVol3": "PV3 输入电压",
  "60420.real_time.analysis_AC_Basic.tag": "基础信息",
  "common.60419.ywt_rOnGridCurrent": "R 相并网电流",
  "ywt.60419.pvChargeTime": "发电时间",
  "ywt.60419.invDspDebugInfo1": "INV DSP 调试信息1",
  "ywt.60419.invDspDebugInfo2": "INV DSP 调试信息2",
  "ywt.60419.invDspDebugInfo3": "INV DSP 调试信息3",
  "ywt.60419.invDspDebugInfo4": "INV DSP 调试信息4",
  "ywt.60419.invDspDebugInfo5": "INV DSP 调试信息5",
  "ywt.60419.invDspDebugInfo6": "INV DSP 调试信息6",
  "ywt.60419.invDspDebugInfo7": "INV DSP 调试信息7",
  "ywt.60419.invDspDebugInfo8": "INV DSP 调试信息8",
  "ywt.60419.workStatus0": "初始化",
  "ywt.60419.workStatus1": "等待",
  "ywt.60419.workStatus2": "并网",
  "ywt.60419.workStatus3": "故障",
  "ywt.60419.workStatus4": "烧录",
  "ywt.60419.workStatus5": "离网",
  "common.60419.ywt_tGridPower": "T 相并网功率",
  "ywt.60419.rPhaseDci": "R 相 DCI",
  "50500_0x756F-F-13": " 模式切换",
  "50500_0x756F-F-12": "电池模式切换故障",
  "50500_0x756F-F-14": "逆变软件过流",
  "common.50500.xnl_RTparam_name_G_P_C_L2": "发电机L2 功率",
  "common.50500.xnl_RTparam_name_G_P_C_L1": "发电机L1 功率",
  "common.50500.xnl_RTparam_name_G_P_C_L3": "发电机L3 功率",
  "paramSet.dateTime.title.hour": "时",
  "ywt.60419.tOnGridCurrent": "T相并网电流",
  "ywt.60419.tGridPower": "T 相并网功率",
  "ywt.60419.trGridVol": "TR电网线电压",
  "paramSet.dateTime.title.minute": "分",
  "ywt.60419.loadPower": "负载功率",
  "50500_0x7572-S-15": "散热器温度过高\n 1.检查工作环境温度是否过高；\n 2. 关闭逆变器10分钟后再重启；\n 3. 如果无法恢复正常状态，请向我们寻求帮助。",
  "50500_0x7572-S-14": "1. ARC故障检测仅适用于US市场；\n 2. 检查PV组件电缆连接并清除故障；\n 3. 如果无法恢复正常状态，请向我们寻求帮助。",
  "ywt.60419.tPhaseDci": "T 相 DCI",
  "50500_0x7572-S-13": "1.Confirm that the load is appropriate\n2.Ensure sufficient PV energy and Reduce the load appropriately\n3.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7572-S-12": "1.Confirm that the wiring between each device is correct\n2. Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.pvPower11": "PV功率11",
  "50500_0x7572-S-11": "1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Seek help from us, if can’t go back to noarmal state",
  "ywt.60419.pvPower10": "PV功率10",
  "50500_0x7572-S-10": "Batt Shutdown Fault\n1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Seek help from us, if can’t go back to noarmal state",
  "common.60419.ywt_pvInputCurrent1": "PV1 输入电流",
  "50500_0x7570-F-8": "AC_Active_Batt_Fault",
  "common.60419.ywt_pvInputCurrent2": "PV2 输入电流",
  "50500_0x7570-F-9": "直流母线不平衡",
  "common.60419.ywt_pvInputCurrent3": "PV3 输入电流",
  "common.60419.ywt_pvInputCurrent4": "PV4 输入电流",
  "ywt.60419.reactivePower": "无功功率",
  "common.60419.ywt_pvInputCurrent9": "PV9 输入电流",
  "50500_0x7570-F-0": "电池激活",
  "50500_0x7570-F-1": "硬件交流过流",
  "50500_0x7570-F-3": "硬件直流过流",
  "common.60419.ywt_pvInputCurrent5": "PV5 输入电流",
  "common.60419.ywt_pvInputCurrent6": "PV6 输入电流",
  "50500_0x7570-F-5": "急停故障（逆变器被锁定）",
  "common.60419.ywt_pvInputCurrent7": "PV7 输入电流",
  "50500_0x7570-F-6": "瞬时漏电流故障",
  "common.60419.ywt_pvInputCurrent8": "PV8 输入电流",
  "50500_0x7570-F-7": "方阵绝缘阻抗故障",
  "ywt.60419.rsGirdVol": "RS电网线电压",
  "ywt.60419.rOnGridCurrent": "R相并网电流",
  "ywt.60419.pvInputVol11": "PV11 输入电压",
  "ywt.60419.pvInputVol10": "PV10 输入电压",
  "ywt.60419.pvInputVol12": "PV12 输入电压",
  "50500_0x7571-F-13": "备份电池故障",
  "50500_0x7571-F-14": "交流过频",
  "50500_0x7571-F-15": "交流欠频",
  "50500_0x7570-S-3": "DC侧过流故障\n 1. 检查PV组件连接和电池连接；\n 2. 关闭DC开关和AC开关，然后等待一分钟，再重新打开DC/AC开关；\n 3. 如果无法恢复正常状态，请向我们寻求帮助。",
  "50500_0x7570-S-5": "向我们寻求帮助，这种故障很少发生。",
  "50500_0x7570-S-6": "漏电流故障\n 1. 检查PV组件和逆变器的电缆；\n 2.重启逆变器；\n 3. 如果无法恢复正常状态，请向我们寻求帮助。",
  "50500_0x7570-S-7": "PV绝缘电阻过低\n 1. 检查PV面板和逆变器的连接是否牢固且正确；\n 2. 检查逆变器的PE电缆是否接地；\n 3. 如果无法恢复正常状态，请向我们寻求帮助。",
  "50500_0x7570-S-8": "AC_Active_Batt_Fault\n1.Check the battery fuse;\n2.Confirm that the wiring between each device is correct\n3.Confirm that the device parameter settings are correct\n4. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7570-S-9": "1. 请稍等片刻，检查是否正常；\n 2. 如果仍然相同，则关闭DC开关和AC开关，等待一分钟，然后打开DC/AC开关；\n 3. 如果无法恢复到正常状态，请向我们寻求帮助。",
  "ywt.60419.totalPvEnergy": "总发电量",
  "50500_0x7570-S-0": "1.Check  insulation in the battery pack.\n2.Confirm that the wiring between each device is correct\n3.Confirm that the device parameter settings are correct\n4.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7570-S-1": "AC侧过流故障\n 1. 请检查备用负载功率和常用负载功率是否在范围内；\n 2. 重启并检查是否正常；\n 3. 如果无法恢复正常状态，请向我们寻求帮助。",
  "50500_0x7570-C-3": "硬件直流过流",
  "50500_0x7571-F-10": "电网电压故障",
  "50500_0x7570-C-5": "急停故障（逆变器被锁定）",
  "50500_0x7570-C-6": "瞬时漏电流故障",
  "60420.ctrl_param_shebeixinxishezhi.reactiveControlSet": "无功控制方式设置",
  "50500_0x7570-C-7": "方阵绝缘阻抗故障",
  "50500_0x7570-C-8": "AC_Active_Batt_Fault",
  "50500_0x7570-C-9": "直流母线不平衡",
  "50500_0x7571-C-8": "并联系统停机故障",
  "50500_0x7571-C-9": "线电压过低故障",
  "50500_0x7571-C-6": "DCLLC_Over_Current",
  "50500_0x7571-C-7": "Batt_Over_Current",
  "50500_0x756F-S-12": "Batt Mode Changed\n1.Confirm that the wiring between each device is correct\n2. Restart and check whether it is in normal;\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-C-4": "DCLLC_Soft_Over_Cur",
  "50500_0x7571-C-5": "Battery OV ",
  "50500_0x7570-C-0": "Active_Battery_Hold",
  "50500_0x756F-S-14": "INV OCP \n1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Confirm that the device parameter settings are correct\n4.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7570-C-1": "硬件交流过流",
  "50500_0x7571-C-2": "无市电",
  "50500_0x756F-S-13": "逆变器工作模式已更改\n 1. 等一下再检查；\n 2. 如果无法恢复正常状态，请向我们寻求帮助。",
  "paramSet.dateTime.title.second": "秒",
  "60420.ctrl_param_shebeixinxishezhi.inputModeSet": "输入模式设置",
  "common.60419.ywt_tOnGridCurrent": "T 相并网电流",
  "50500_0x7571-S-8": "在并联系统中，由于其他逆变器故障。\n 1. 等待几分钟，然后检查此并联系统中的所有逆变器；\n 2. 如果逆变器无法恢复到正常状态，请记录所有逆变器的故障代码，然后向我们寻求帮助。",
  "50500_0x7571-S-7": "1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Confirm that the device parameter settings are correct\n4.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-S-6": "1.Confirm that the wiring between each device is correct\n2.Confirm that the PV voltage is not too low\n3.Confirm that the load is appropriate\n4.Confirm that the device parameter settings are correct\n5.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-S-5": "1.Confirm if the battery specifications match our device\n2.Confirm that the wiring between each device is correct\n3.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-S-4": "DCLLC_Soft_Over_Cur\n1.Confirm that the wiring between each device is correct\n2.Confirm that the device parameter settings are correct\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7571-S-2": "无实用价值\n 1. 请确认电网是否失电；\n 2. 检查电网连接是否良好；\n 3. 检查逆变器与电网之间的开关是否开启；\n 4. 如果无法恢复正常状态，请向我们寻求帮助。",
  "ywt.60419.groupStrCurrent23": "组串 23 电流",
  "ywt.60419.groupStrCurrent22": "组串 22 电流",
  "ywt.60419.groupStrCurrent21": "组串 21 电流",
  "ywt.60419.groupStrCurrent20": "组串 20 电流",
  "ywt.60419.pvInputCurrent9": "PV9 输入电流",
  "ywt.60419.stGirdVol": "ST电网线电压",
  "ywt.60419.sGridPower": "S 相并网功率",
  "50500_0x7571-F-5": "Battery OV ",
  "50500_0x7571-F-6": "DCLLC_Over_Current",
  "50500_0x7571-F-4": "直流软起动过流",
  "ywt.60419.groupStrCurrent19": "组串 19 电流",
  "ywt.60419.groupStrCurrent18": "组串 18 电流",
  "50500_0x7571-F-2": "无市电",
  "ywt.60419.groupStrCurrent17": "组串 17 电流",
  "ywt.60419.groupStrCurrent16": "组串 16 电流",
  "ywt.60419.groupStrCurrent15": "组串 15 电流",
  "ywt.60419.groupStrCurrent14": "组串 14 电流",
  "ywt.60419.groupStrCurrent13": "组串 13 电流",
  "ywt.60419.groupStrCurrent12": "组串 12 电流",
  "ywt.60419.groupStrCurrent11": "组串 11 电流",
  "50500_0x7571-F-9": "线电压过低故障",
  "ywt.60419.groupStrCurrent10": "组串 10 电流",
  "50500_0x7571-F-7": "Batt_Over_Current",
  "50500_0x7571-F-8": "并联系统停机故障",
  "common.60419.ywt_groupCurrent": "组串电流",
  "ywt.60419.pvInputCurrent7": "PV7 输入电流",
  "ywt.60419.leakCurrent": "漏电流",
  "ywt.60419.pvInputCurrent8": "PV8 输入电流",
  "ywt.60419.pvInputCurrent5": "PV5 输入电流",
  "ywt.60419.pvInputCurrent6": "PV6 输入电流",
  "ywt.60419.pvInputCurrent3": "PV3 输入电流",
  "ywt.60419.pvInputCurrent4": "PV4 输入电流",
  "ywt.60419.pvInputCurrent1": "PV1 输入电流",
  "common.60419.ywt_pvInputCurrentjl": "交流侧",
  "ywt.60419.pvInputCurrent2": "PV2 输入电流",
  "ywt.60419.scanPercentage": "I/V 扫描百分比",
  "ywt.60419.powerFactor": "功率因数",
  "common.60419.ywt_rGridPower": "R 相并网功率",
  "ywt.60419.loadDropMode10": "ATE 调整降额",
  "50500_0x7572-C-0": "逆变电压一致性故障",
  "ywt.60419.loadDropMode12": "多机防逆流降额",
  "ywt.60419.loadDropMode13": "过频降额",
  "ywt.60419.onGridCountdown": "并网倒计时",
  "50500_0x7572-S-6": "PV Volt High Fault \n1. Check whether PV voltage is normal;\n2.Confirm that the wiring between each device is correct\n3. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-S-5": "DC Volt Low Fault\n1.Check whether PV voltage is normal;\n2.Check whether battery voltage is normal;\n3.Confirm that the wiring between each device is correct\n4. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-S-8": "Batt Over Load Fault\n1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3.Seek help from us, if can’t go back to noarmal state",
  "50500_0x7572-S-7": "电池电压低\n 1.检查电池电压是否过低；\n 2. 如果电池电压过低，则使用PV或电网对电池进行充电；\n 3. 如果无法恢复正常状态，请向我们寻求帮助。",
  "50500_0x7572-S-2": "GFCI Consistent Frault",
  "50500_0x7572-S-1": "Grid Volt Consistent Fault\n1. Check whether grid voltage is normal;\n2. Check whether AC cables are firmly and correctly connected;\n3. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-S-3": "Inter Comm Fault\n1.Confirm that the wiring between each device is correct\n2. Seek help from us, if can not go back to normal state.",
  "60420.real_time.analysis_DC_Side.tag": "直流侧",
  "50500_0x7572-S-9": "1.Confirm that the wiring between each device is correct\n2.Confirm that the device parameter settings are correct\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7572-C-5": "直流电压低故障",
  "50500_0x7572-C-6": "PV过压故障",
  "ywt.60419.radiatorTemp": "散热器温度(℃)",
  "50500_0x7572-C-7": "母线电压过低",
  "50500_0x7572-C-8": "电池过裁故障",
  "50500_0x7572-C-1": "电网电压一致性故障",
  "50500_0x7572-C-2": "GFCI一致性故障",
  "ywt.60419.rsGridFrequency": "RS电网频率",
  "50500_0x7572-C-3": "内部通讯故障",
  "50500_0x7572-S-0": "INV Volt Consistent Fauit\n1. Check whether grid voltage is normal;\n2. Check whether AC cables are firmly and correctly connected;\n3. Seek help from us, if can not go back to normal state.",
  "50500_0x7572-C-9": "通讯故障",
  "ywt.60419.loadDropMode3": "逆变降额",
  "ywt.60419.loadDropMode2": "BST 高温降额",
  "ywt.60419.loadDropMode1": "高压降额",
  "ywt.60419.loadDropMode0": "不降额",
  "50500_0x756F-F-9": "辅助电源故障",
  "ywt.60419.loadDropMode9": "AC 高压降额",
  "ywt.60419.loadDropMode8": "加载斜率降额",
  "ywt.60419.loadDropMode7": "无功降额",
  "ywt.60419.loadDropMode6": "重置 MPPT 降额",
  "ywt.60419.loadDropMode5": "PF 降额",
  "ywt.60419.loadDropMode4": "环温降额",
  "50500_0x756F-F-2": "GFCI设备故障",
  "50500_0x7570-S-12": "此故障仅适用于并联模式下工作的逆变器\n 1. 根据说明检查并行设置；\n 2. 检查CAN总线的连接；\n 3. 向我们寻求帮助",
  "common.60419.ywt_pvInputVol10": "PV10 输入电压",
  "50500_0x7571-C-10": "电池低压故障",
  "50500_0x756F-F-4": "EEPROM读故障",
  "common.60419.ywt_pvInputVol11": "PV11 输入电压",
  "50500_0x7570-S-14": "Soft_Start_Failed\n1.Confirm that the wiring between each device is correct\n2.Confirm that the device parameter settings are correct\n3.Confirm that the battery level is not too low\n4. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7572-F-10": "电池低压故障",
  "50500_0x756F-F-6": "DC/DC软起故障",
  "50500_0x756F-F-5": "EEPROM写故障",
  "50500_0x7571-C-15": "交流欠频",
  "ywt.60419.activePower": "有功功率",
  "50500_0x7570-S-11": "Parallel Set Faut \n1.Confirm that the device parameter settings are correct\n2.Confirm that the wiring between each device is correct\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x7572-F-12": "手动模式下不逆变",
  "50500_0x7571-C-14": "交流过频",
  "50500_0x7570-S-10": "Bus Volt unbanlence\n1.Confirm that the load is appropriate\n2.Confirm that the wiring between each device is correct\n3. Seek help from us, if can’t go back to noarmal state",
  "50500_0x756F-F-7": " \n逆变继电器故障",
  "50500_0x7572-F-11": "OVER LOAD ",
  "50500_0x7571-C-13": "备份电池故障",
  "paramSet.dateTime.title.day": "日",
  "common.60419.ywt_pvInputVol12": "PV12 输入电压",
  "50500_0x7572-F-2": "GFCI一致性故障",
  "50500_0x7572-F-3": "内部通讯故障",
  "50500_0x7572-F-5": "直流电压低故障",
  "50500_0x7572-F-0": "逆变电压一致性故障",
  "50500_0x7572-F-1": "电网电压一致性故障",
  "50500_0x7572-F-14": "拉弧故障",
  "50500_0x7572-F-13": "EPS电压低故障",
  "50500_0x7572-F-15": "散热器温度过高",
  "50500_0x7572-F-6": "PV过压故障",
  "50500_0x7572-F-7": "母线电压过低",
  "50500_0x7572-F-8": "电池过裁故障",
  "50500_0x7572-F-9": "通讯故障",
  "ywt.60419.meterPower": "电表总功率",
  "paramSet.input.dataError.tip": "当前参数值不在合理范围内。请重置它。",
  "ywt.60419.workStatus": "逆变器工作状态",
  "ywt.60419.tGridVol": "T电网相电压",
  "ywt.60419.sOnGridCurrent": "S相并网电流",
  "ywt.60419.nbusVol": "NBUS电压",
  "ywt.60419.pvInputCurrent10": "PV10 输入电流",
  "ywt.60419.pvInputCurrent11": "PV11 输入电流",
  "ywt.60419.pvInputCurrent12": "PV12 输入电流",
  "common.60419.ywt_pvInputPower10": "PV10 输入功率",
  "common.60419.ywt_pvInputPower11": "PV11 输入功率",
  "common.60419.ywt_pvInputPower12": "PV12 输入功率",
  "common.60419.ywt_tGridVol": "T 电网相电压",
  "current.collector.upgrade.progress": "当前采集器升级进度为",
  "CSP Plant": "光热站",
  "50901.real_time.analysis_battery_power.tag": "电池功率",
  "50901.null.sustainedNegativeLoad.00": "disable",
  "50901.null.sustainedNegativeLoad.01": "enable",
  "50901.null.microelectronicFault.00": "disable",
  "50901.null.microelectronicFault.01": "enable",
  "50901.null.batteryWorkingStatus.00": "待机",
  "50901.null.batteryWorkingStatus.01": "充电",
  "50901.null.batteryWorkingStatus.02": "放电",
  "50901.null.tenMinuteOvervoltage.00": "disable",
  "50901.null.tenMinuteOvervoltage.01": "enable",
  "50901.null.gridPortOvercurrent.00": "disable",
  "50901.null.gridPortOvercurrent.01": "enable",
  "50901.null.gridRelayProtection.00": "disable",
  "50901.null.gridRelayProtection.01": "enable",
  "50901.null.twelveVoltPowerSupplyFault.00": "disable",
  "50901.null.twelveVoltPowerSupplyFault.01": "enable",
  "50901.null.lineToEarthFault.00": "disable",
  "50901.null.lineToEarthFault.01": "enable",
  "50901.null.dtsCommunicationAbnormality.00": "disable",
  "50901.null.dtsCommunicationAbnormality.01": "enable",
  "50901.null.hpBattSocDetectMode.00": "否",
  "50901.null.hpBattSocDetectMode.01": "是",
  "50901.null.evCharger1CommunicationAbnormality.00": "disable",
  "50901.null.evCharger1CommunicationAbnormality.01": "enable",
  "50901.null.parallelNetworking.00": "无效",
  "50901.null.parallelNetworking.01": "组网中",
  "50901.null.parallelNetworking.02": "解散组网",
  "50901.null.pvIslandModeEn.00": "否",
  "50901.null.pvIslandModeEn.01": "是",
  "50901.null.bypassDisable.00": "否",
  "50901.null.bypassDisable.01": "是",
  "50901.null.reconnectionFailed.00": "disable",
  "50901.null.reconnectionFailed.01": "enable",
  "50901.null.meterWiringAbnormality.00": "disable",
  "50901.null.meterWiringAbnormality.01": "enable",
  "50901.null.batteryPackDischargeLowVoltageAlarm.00": "disable",
  "50901.null.batteryPackDischargeLowVoltageAlarm.01": "enable",
  "50901.null.dayOfTheWeekRange2.00": "disable",
  "50901.null.dayOfTheWeekRange2.01": "enable",
  "50901.null.dayOfTheWeekRange1.00": "disable",
  "50901.null.dayOfTheWeekRange1.01": "enable",
  "50901.null.dayOfTheWeekRange4.00": "disable",
  "50901.null.dayOfTheWeekRange4.01": "enable",
  "50901.null.dayOfTheWeekRange3.00": "disable",
  "50901.null.dayOfTheWeekRange3.01": "enable",
  "50901.null.dayOfTheWeekRange6.00": "disable",
  "50901.null.dayOfTheWeekRange6.01": "enable",
  "50901.null.dayOfTheWeekRange5.00": "disable",
  "50901.null.dayOfTheWeekRange5.01": "enable",
  "50901.null.dayOfTheWeekRange7.00": "disable",
  "50901.null.dayOfTheWeekRange7.01": "enable",
  "50901.null.hpTime4WeekRange6.00": "disable",
  "50901.null.hpTime4WeekRange6.01": "enable",
  "50901.null.hpTime4WeekRange7.00": "disable",
  "50901.null.hpTime4WeekRange7.01": "enable",
  "50901.null.rcdFault.00": "disable",
  "50901.null.rcdFault.01": "enable",
  "50901.null.hpTime4WeekRange2.00": "disable",
  "50901.null.hpTime4WeekRange2.01": "enable",
  "50901.null.hpTime4WeekRange3.00": "disable",
  "50901.null.hpTime4WeekRange3.01": "enable",
  "50901.null.gridOvervoltage.00": "disable",
  "50901.null.gridOvervoltage.01": "enable",
  "50901.null.hpTime4WeekRange4.00": "disable",
  "50901.null.hpTime4WeekRange4.01": "enable",
  "50901.null.hpTime4WeekRange5.00": "disable",
  "50901.null.hpTime4WeekRange5.01": "enable",
  "50901.null.hpTime4WeekRange1.00": "disable",
  "50901.null.hpTime4WeekRange1.01": "enable",
  "50901.null.fanFault.00": "disable",
  "50901.null.fanFault.01": "enable",
  "50901.null.masterSlave.00": "单机",
  "50901.null.masterSlave.01": "主机",
  "50901.null.masterSlave.02": "从机",
  "50901.null.loadRelayAFault.00": "disable",
  "50901.null.loadRelayAFault.01": "enable",
  "50901.null.canCommunicationTimeout.00": "disable",
  "50901.null.canCommunicationTimeout.01": "enable",
  "50901.null.genPortOvercurrent.00": "disable",
  "50901.null.genPortOvercurrent.01": "enable",
  "50901.null.dtu4Rs485CommunicationAbnormality.00": "disable",
  "50901.null.dtu4Rs485CommunicationAbnormality.01": "enable",
  "50901.null.gridMeter.00": "disable",
  "50901.null.gridMeter.01": "enable",
  "50901.null.neutralWireToEarthFault.00": "disable",
  "50901.null.neutralWireToEarthFault.01": "enable",
  "50901.null.armCommunicationFault.00": "disable",
  "50901.null.armCommunicationFault.01": "enable",
  "50901.null.inputOvervoltageAlarm.00": "disable",
  "50901.null.inputOvervoltageAlarm.01": "enable",
  "50901.null.batteryLowVoltageAlarm.00": "disable",
  "50901.null.batteryLowVoltageAlarm.01": "enable",
  "50901.null.hpWorkMode.00": "否",
  "50901.null.hpWorkMode.01": "是",
  "50901.null.flashCommunicationFault.00": "disable",
  "50901.null.flashCommunicationFault.01": "enable",
  "50901.null.lowBatteryEnergy.00": "disable",
  "50901.null.lowBatteryEnergy.01": "enable",
  "50901.null.workStatus.00": "电源初始化",
  "50901.null.workStatus.01": "待机模式",
  "50901.null.workStatus.02": "并网测试",
  "50901.null.workStatus.03": "并网模式",
  "50901.null.workStatus.04": "故障模式",
  "50901.null.workStatus.05": "离网模式",
  "50901.null.workStatus.06": "旁路模式",
  "50901.null.dtu3Rs485CommunicationAbnormality.00": "disable",
  "50901.null.dtu3Rs485CommunicationAbnormality.01": "enable",
  "50901.null.bmsCanCommunicationAbnormality.00": "disable",
  "50901.null.bmsCanCommunicationAbnormality.01": "enable",
  "50901.null.relayStatus.11": "重要负载B馈送",
  "50901.null.relayStatus.12": "保留",
  "50901.null.relayStatus.13": "保留",
  "50901.null.relayStatus.14": "保留",
  "50901.null.relayStatus.15": "保留",
  "50901.null.relayStatus.00": "KM1馈送",
  "50901.null.relayStatus.01": "KM1馈送",
  "50901.null.relayStatus.02": "发电机A馈送",
  "50901.null.relayStatus.03": "发电机A馈送",
  "50901.null.relayStatus.04": "发电机B馈送",
  "50901.null.relayStatus.05": "发电机B馈送",
  "50901.null.relayStatus.06": "发电机AB馈送",
  "50901.null.relayStatus.07": "发电机AB馈送",
  "50901.null.relayStatus.08": "重要负载A馈送",
  "50901.null.relayStatus.09": "重要负载A馈送",
  "50901.null.relayStatus.10": "重要负载B馈送",
  "50901.null.gridMeterTypeError.00": "disable",
  "50901.null.gridMeterTypeError.01": "enable",
  "50901.null.testFault.00": "disable",
  "50901.null.testFault.01": "enable",
  "50901.null.weekRange5.00": "disable",
  "50901.null.weekRange5.01": "enable",
  "50901.null.pvPortOvercurrent.00": "disable",
  "50901.null.pvPortOvercurrent.01": "enable",
  "50901.null.weekRange6.00": "disable",
  "50901.null.weekRange6.01": "enable",
  "50901.null.weekRange7.00": "disable",
  "50901.null.weekRange7.01": "enable",
  "50901.null.weekRange1.00": "enable",
  "50901.null.weekRange1.01": "enable",
  "50901.null.weekRange2.00": "disable",
  "50901.null.weekRange2.01": "enable",
  "50901.null.weekRange3.00": "disable",
  "50901.null.weekRange3.01": "enable",
  "50901.null.weekRange4.00": "disable",
  "50901.null.weekRange4.01": "enable",
  "50901.null.gridPowerOutage.00": "disable",
  "50901.null.gridPowerOutage.01": "enable",
  "50901.null.driveAbnormality.00": "disable",
  "50901.null.driveAbnormality.01": "enable",
  "50901.null.frequencyVariationRateOutOfRange.00": "disable",
  "50901.null.frequencyVariationRateOutOfRange.01": "enable",
  "50901.null.arcFault.00": "disable",
  "50901.null.arcFault.01": "enable",
  "50901.null.neutralWireNotConnected.00": "disable",
  "50901.null.neutralWireNotConnected.01": "enable",
  "50901.null.hardwareProtection.00": "disable",
  "50901.null.hardwareProtection.01": "enable",
  "50901.null.BatteryModel.22": "HOY LV",
  "50901.null.BatteryModel.23": "HOY HV",
  "50901.null.BatteryModel.24": "FEB LV",
  "50901.null.BatteryModel.25": "UHhome LV",
  "50901.null.BatteryModel.26": "UHhome HV",
  "50901.null.BatteryModel.27": "BYD HV",
  "50901.null.BatteryModel.28": "Vestwoods HV",
  "50901.null.BatteryModel.29": "Phylion HV",
  "50901.null.BatteryModel.30": "Hoymiles LV",
  "50901.null.BatteryModel.31": "Pholion LV",
  "50901.null.BatteryModel.10": "Xin Yi LV",
  "50901.null.BatteryModel.32": "Wattsonic LV",
  "50901.null.BatteryModel.11": "Vestwoods LV",
  "50901.null.BatteryModel.33": "Enershare HV",
  "50901.null.BatteryModel.12": "JK HV",
  "50901.null.BatteryModel.34": "Beghelli LV",
  "50901.null.BatteryModel.13": "BYD LV",
  "50901.null.BatteryModel.35": "LvToPSUN LV",
  "50901.null.BatteryModel.14": "Uz HV",
  "50901.null.BatteryModel.36": "PYTES HV",
  "50901.null.BatteryModel.15": "Zetara LV",
  "50901.null.BatteryModel.37": "LvToPSUN HV",
  "50901.null.BatteryModel.16": "FEB HV",
  "50901.null.BatteryModel.38": "RAJA HV",
  "50901.null.BatteryModel.17": "Pytes LV",
  "50901.null.BatteryModel.39": "Felicity LV",
  "50901.null.BatteryModel.18": "Dmegc LV",
  "50901.null.BatteryModel.19": "Weineng LV",
  "50901.null.BatteryModel.01": "Pylon LV",
  "50901.null.BatteryModel.02": "Pylon HV",
  "50901.null.BatteryModel.03": "Dyness LV",
  "50901.null.BatteryModel.04": "Dyness HV",
  "50901.null.BatteryModel.05": "Sunwoda LV",
  "50901.null.BatteryModel.06": "Uz LV",
  "50901.null.BatteryModel.07": "Soluna HV",
  "50901.null.BatteryModel.08": "Soluna LV",
  "50901.null.BatteryModel.09": "Steltec LV",
  "50901.null.BatteryModel.20": "Weineng HV",
  "50901.null.BatteryModel.21": "GSL LV",
  "50901.null.rcdSelfTestFault.00": "disable",
  "50901.null.rcdSelfTestFault.01": "enable",
  "50901.null.dtu1Rs485CommunicationAbnormality.00": "disable",
  "50901.null.dtu1Rs485CommunicationAbnormality.01": "enable",
  "50901.null.pvRelayAbFault.00": "disable",
  "50901.null.pvRelayAbFault.01": "enable",
  "50901.null.preSynchronizationFailed.00": "disable",
  "50901.null.preSynchronizationFailed.01": "enable",
  "50901.null.pvMeterCommunicationAbnormality.00": "disable",
  "50901.null.pvMeterCommunicationAbnormality.01": "enable",
  "50901.null.restartSystem.00": "否",
  "50901.null.restartSystem.01": "是",
  "50901.null.pvVoltageExceedingBusVoltage.00": "disable",
  "50901.null.pvVoltageExceedingBusVoltage.01": "enable",
  "50901.null.smartloadPortOvercurrent.00": "disable",
  "50901.null.smartloadPortOvercurrent.01": "enable",
  "50901.null.genAbnormality.00": "disable",
  "50901.null.genAbnormality.01": "enable",
  "50901.null.fanSpeedAbnormality.00": "disable",
  "50901.null.fanSpeedAbnormality.01": "enable",
  "50901.null.epsOverload.00": "disable",
  "50901.null.epsOverload.01": "enable",
  "50901.null.equalizationEnable.00": "否",
  "50901.null.equalizationEnable.01": "是",
  "50901.null.meterConfiguration.00": "无电表类型",
  "50901.null.meterConfiguration.01": "配置电网电表",
  "50901.null.gridUnderfrequency.00": "disable",
  "50901.null.gridUnderfrequency.01": "enable",
  "50901.null.lowDtuVersion.00": "disable",
  "50901.null.lowDtuVersion.01": "enable",
  "50901.null.loadRelayBFault.00": "disable",
  "50901.null.loadRelayBFault.01": "enable",
  "50901.null.pvFault.00": "disable",
  "50901.null.pvFault.01": "enable",
  "50901.null.batteryHighVoltageAlarm.00": "disable",
  "50901.null.batteryHighVoltageAlarm.01": "enable",
  "50901.null.smart_weekRange25.00": "disable",
  "50901.null.smart_weekRange25.01": "enable",
  "50901.null.genRelayAFault.00": "disable",
  "50901.null.genRelayAFault.01": "enable",
  "50901.null.smart_weekRange26.00": "disable",
  "50901.null.smart_weekRange26.01": "enable",
  "50901.null.batteryType_04.00": "无电池",
  "50901.null.batteryType_04.01": "锂电池",
  "50901.null.batteryType_04.02": "铅酸电池",
  "50901.null.smart_weekRange23.00": "disable",
  "50901.null.smart_weekRange23.01": "enable",
  "50901.null.smart_weekRange24.00": "disable",
  "50901.null.smart_weekRange24.01": "enable",
  "50901.null.smart_weekRange21.00": "disable",
  "50901.null.smart_weekRange21.01": "enable",
  "50901.null.smart_weekRange22.00": "disable",
  "50901.null.smart_weekRange22.01": "enable",
  "50901.null.gridCurrentDcOffsetOutOfRange.00": "disable",
  "50901.null.gridCurrentDcOffsetOutOfRange.01": "enable",
  "50901.null.smart_weekRange20.00": "disable",
  "50901.null.smart_weekRange20.01": "enable",
  "50901.null.genPracticeModeEn.00": "否",
  "50901.null.genPracticeModeEn.01": "是",
  "50901.null.CfgMultPcsBMSFlag.00": "否",
  "50901.null.CfgMultPcsBMSFlag.01": "是",
  "50901.null.inverterCommunicationFailed.00": "disable",
  "50901.null.inverterCommunicationFailed.01": "enable",
  "50901.null.gridMeterCommunicationAbnormality.00": "disable",
  "50901.null.gridMeterCommunicationAbnormality.01": "enable",
  "50901.null.masterSlaveCommunicationAbnormality.00": "disable",
  "50901.null.masterSlaveCommunicationAbnormality.01": "enable",
  "50901.null.batteryFault.00": "disable",
  "50901.null.batteryFault.01": "enable",
  "50901.null.pvMeterTypeError.00": "disable",
  "50901.null.pvMeterTypeError.01": "enable",
  "50901.null.lowAmbientTemperature.00": "disable",
  "50901.null.lowAmbientTemperature.01": "enable",
  "50901.null.batteryConnectionStatus.00": "否",
  "50901.null.batteryConnectionStatus.01": "是",
  "50901.null.hmidMachineFault.00": "disable",
  "50901.null.hmidMachineFault.01": "enable",
  "50901.null.machineTypeMismatch.00": "disable",
  "50901.null.machineTypeMismatch.01": "enable",
  "50901.null.evCharger1Fault.00": "disable",
  "50901.null.evCharger1Fault.01": "enable",
  "50901.null.busbarAbnormality.00": "disable",
  "50901.null.busbarAbnormality.01": "enable",
  "50901.null.batteryPackChargeHighVoltageAlarm.00": "disable",
  "50901.null.batteryPackChargeHighVoltageAlarm.01": "enable",
  "50901.null.chargeLowTemperatureAlarm.00": "disable",
  "50901.null.chargeLowTemperatureAlarm.01": "enable",
  "50901.null.threePointThreeVoltPowerSupplyFault.00": "disable",
  "50901.null.threePointThreeVoltPowerSupplyFault.01": "enable",
  "50901.null.batteryCapacityAbnormality.00": "disable",
  "50901.null.batteryCapacityAbnormality.01": "enable",
  "50901.null.emergencyStopSwitchStatus.00": "disable",
  "50901.null.emergencyStopSwitchStatus.01": "enable",
  "50901.null.loadControlMode.01": "手动",
  "50901.null.loadControlMode.02": "时间模式",
  "50901.null.loadControlMode.03": "智能负载",
  "50901.null.loadControlMode.04": "离网智能负载",
  "50901.null.loadControlMode.05": "电动汽车充电器",
  "50901.null.workMode.00": "自发自用",
  "50901.null.workMode.01": "经济模式",
  "50901.null.workMode.02": "备电模式",
  "50901.null.workMode.03": "离网模式",
  "50901.null.workMode.04": "强充模式",
  "50901.null.workMode.05": "强放模式",
  "50901.null.genRelayBFault.00": "disable",
  "50901.null.genRelayBFault.01": "enable",
  "50901.null.batteryForceChargeRequest.00": "disable",
  "50901.null.batteryForceChargeRequest.01": "enable",
  "50901.null.arcSelfTestFault.00": "disable",
  "50901.null.arcSelfTestFault.01": "enable",
  "50901.null.e2rpomFault.00": "disable",
  "50901.null.e2rpomFault.01": "enable",
  "50901.null.materType.00": "无网侧电表",
  "50901.null.materType.01": "正泰单相",
  "50901.null.materType.02": "正泰单相",
  "50901.null.materType.03": "正泰裂相",
  "50901.null.materType.05": "计量模块",
  "50901.null.materType.06": "安科瑞单路",
  "50901.null.materType.07": "安科瑞双路",
  "50901.null.wiringAbnormality.00": "disable",
  "50901.null.wiringAbnormality.01": "enable",
  "50901.null.hmidCommunicationAbnormality.00": "disable",
  "50901.null.hmidCommunicationAbnormality.01": "enable",
  "50901.null.section4WeekRange1.00": "枚举值0的含义",
  "50901.null.section4WeekRange1.01": "枚举值2的含义",
  "50901.null.epsMode.00": "禁用",
  "50901.null.epsMode.01": "应急电源",
  "50901.null.epsMode.02": "不间断电源",
  "50901.null.section4WeekRange2.00": "枚举值0的含义",
  "50901.null.section4WeekRange2.01": "枚举值1的含义",
  "50901.null.samplingBiasAbnormality.00": "disable",
  "50901.null.samplingBiasAbnormality.01": "enable",
  "50901.null.dischargeHighTemperatureAlarm.00": "disable",
  "50901.null.dischargeHighTemperatureAlarm.01": "enable",
  "50901.null.meterFlag.00": "offline",
  "50901.null.meterFlag.01": "online",
  "50901.null.slaveWrongBatteryConnection.00": "disable",
  "50901.null.slaveWrongBatteryConnection.01": "enable",
  "50901.null.dtu2Rs485CommunicationAbnormality.00": "disable",
  "50901.null.dtu2Rs485CommunicationAbnormality.01": "enable",
  "50901.null.auxiliaryPowerAbnormality.00": "disable",
  "50901.null.auxiliaryPowerAbnormality.01": "enable",
  "50901.null.drmStatusUsedInAustraliaGermanyAustria.11": "充电功率Pc<50%Pn 额度功率&&Q=Qmax",
  "50901.null.drmStatusUsedInAustraliaGermanyAustria.12": "放电功率P<50%Pn 额度功率 --> 放电功率降为0",
  "50901.null.drmStatusUsedInAustraliaGermanyAustria.13": "充电功率P<50%Pn 额度功率&&Q=-Qmax",
  "50901.null.drmStatusUsedInAustraliaGermanyAustria.00": "功率限制解除，默认模式",
  "50901.null.drmStatusUsedInAustraliaGermanyAustria.01": "逆变器功率为0，脱网",
  "50901.null.drmStatusUsedInAustraliaGermanyAustria.02": "充电功率Pc=0,不脱网",
  "50901.null.drmStatusUsedInAustraliaGermanyAustria.03": "充电功率Pc<50%Pn 额度功率",
  "50901.null.drmStatusUsedInAustraliaGermanyAustria.04": "充电功率Pc<75%Pn 额度功率&&无功功率Q=Qmax ±4%",
  "50901.null.drmStatusUsedInAustraliaGermanyAustria.05": "充电功率Pc, 不做限制",
  "50901.null.drmStatusUsedInAustraliaGermanyAustria.06": "放电功率P=0,不脱网",
  "50901.null.drmStatusUsedInAustraliaGermanyAustria.07": "放电功率P<50%Pn额度功率",
  "50901.null.drmStatusUsedInAustraliaGermanyAustria.08": "放电功率P<75%Pn 额度功率&&Q= -Qmax±4%",
  "50901.null.drmStatusUsedInAustraliaGermanyAustria.09": "放电功率P 不做限制",
  "50901.null.drmStatusUsedInAustraliaGermanyAustria.10": "充电功率Pc<50%Pn 额度功率 --> 充电功率降为0",
  "50901.null.spiCommunicationFault.00": "disable",
  "50901.null.spiCommunicationFault.01": "enable",
  "50901.null.dryWorkingMode.00": "无",
  "50901.null.dryWorkingMode.01": "接地故障",
  "50901.null.dryWorkingMode.02": "敷在控制",
  "50901.null.dryWorkingMode.03": "放电机",
  "50901.null.comparatorFault.00": "disable",
  "50901.null.comparatorFault.01": "enable",
  "50901.null.pllLockFailed.00": "disable",
  "50901.null.pllLockFailed.01": "enable",
  "50901.null.generatorMode.00": "关",
  "50901.null.generatorMode.01": "手动",
  "50901.null.generatorMode.02": "自动",
  "50901.null.dspPwrCommunicationAbnormality.00": "disable",
  "50901.null.dspPwrCommunicationAbnormality.01": "enable",
  "50901.null.kmRelayFault.00": "disable",
  "50901.null.kmRelayFault.01": "enable",
  "50901.null.genOverload.00": "disable",
  "50901.null.genOverload.01": "enable",
  "50901.null.fiveVoltPowerSupplyFault.00": "disable",
  "50901.null.fiveVoltPowerSupplyFault.01": "enable",
  "50901.null.temperatureAbnormality.00": "disable",
  "50901.null.temperatureAbnormality.01": "enable",
  "50901.null.genPracticeFreq.00": "无",
  "50901.null.genPracticeFreq.01": "每周一次",
  "50901.null.genPracticeFreq.02": "每2周一次",
  "50901.null.genPracticeFreq.03": "每3周一次",
  "50901.null.genPracticeFreq.04": "每4周一次",
  "50901.null.epsVoltageAbnormality.00": "disable",
  "50901.null.epsVoltageAbnormality.01": "enable",
  "50901.null.cmpssBiasCalculationError.00": "disable",
  "50901.null.cmpssBiasCalculationError.01": "enable",
  "50901.null.manualModeSwitch.00": "否",
  "50901.null.manualModeSwitch.01": "是",
  "50901.null.epsRelayProtection.00": "disable",
  "50901.null.epsRelayProtection.01": "enable",
  "50901.null.evCharger2Fault.00": "disable",
  "50901.null.evCharger2Fault.01": "enable",
  "50901.null.hpTime1WeekRange7.00": "disable",
  "50901.null.hpTime1WeekRange7.01": "enable",
  "50901.null.hpTime1WeekRange5.00": "disable",
  "50901.null.hpTime1WeekRange5.01": "enable",
  "50901.null.hpTime1WeekRange6.00": "disable",
  "50901.null.hpTime1WeekRange6.01": "enable",
  "50901.null.hpTime1WeekRange3.00": "disable",
  "50901.null.hpTime1WeekRange3.01": "enable",
  "50901.null.dspSafCommunicationAbnormality.00": "disable",
  "50901.null.dspSafCommunicationAbnormality.01": "enable",
  "50901.null.hpTime1WeekRange4.00": "disable",
  "50901.null.hpTime1WeekRange4.01": "enable",
  "50901.null.hpTime1WeekRange1.00": "disable",
  "50901.null.hpTime1WeekRange1.01": "enable",
  "50901.null.hpTime1WeekRange2.00": "disable",
  "50901.null.hpTime1WeekRange2.01": "enable",
  "50901.null.interruptOverflow.00": "disable",
  "50901.null.interruptOverflow.01": "enable",
  "50901.null.gridOverfrequency.00": "disable",
  "50901.null.gridOverfrequency.01": "enable",
  "50901.null.insulationFault.00": "disable",
  "50901.null.insulationFault.01": "enable",
  "50901.null.evCharger2CommunicationAbnormality.00": "disable",
  "50901.null.evCharger2CommunicationAbnormality.01": "enable",
  "50901.null.dischargeLowTemperatureAlarm.00": "disable",
  "50901.null.dischargeLowTemperatureAlarm.01": "enable",
  "50901.null.gridOffVoltageDcOffsetOutOfRange.00": "disable",
  "50901.null.gridOffVoltageDcOffsetOutOfRange.01": "enable",
  "50901.null.section1WeekRange2.00": "枚举值0的含义",
  "50901.null.section1WeekRange2.01": "枚举值1的含义",
  "50901.null.section1WeekRange1.00": "枚举值0的含义",
  "50901.null.section1WeekRange1.01": "枚举值2的含义",
  "50901.null.networkingType.01": "WIFI",
  "50901.null.networkingType.02": "以太网",
  "50901.null.hpTime3WeekRange3.00": "disable",
  "50901.null.hpTime3WeekRange3.01": "enable",
  "50901.null.hpTime3WeekRange4.00": "disable",
  "50901.null.hpTime3WeekRange4.01": "enable",
  "50901.null.hpTime3WeekRange5.00": "disable",
  "50901.null.hpTime3WeekRange5.01": "enable",
  "50901.null.hpTime3WeekRange6.00": "disable",
  "50901.null.hpTime3WeekRange6.01": "enable",
  "50901.null.hpTime3WeekRange7.00": "disable",
  "50901.null.hpTime3WeekRange7.01": "enable",
  "50901.null.inverterCanCommunicationFailed.00": "disable",
  "50901.null.inverterCanCommunicationFailed.01": "enable",
  "50901.null.gridVoltageAbnormality.00": "disable",
  "50901.null.gridVoltageAbnormality.01": "enable",
  "50901.null.dtu5Rs485CommunicationAbnormality.00": "disable",
  "50901.null.dtu5Rs485CommunicationAbnormality.01": "enable",
  "50901.null.hpTime3WeekRange1.00": "disable",
  "50901.null.hpTime3WeekRange1.01": "enable",
  "50901.null.gridUndervoltage.00": "disable",
  "50901.null.gridUndervoltage.01": "enable",
  "50901.null.hpTime3WeekRange2.00": "disable",
  "50901.null.hpTime3WeekRange2.01": "enable",
  "50901.null.versionMismatch.00": "disable",
  "50901.null.versionMismatch.01": "enable",
  "50901.null.shutDown.00": "disable",
  "50901.null.shutDown.01": "enable",
  "50901.null.hpTime2WeekRange3.00": "disable",
  "50901.null.hpTime2WeekRange3.01": "enable",
  "50901.null.genPracticeModeWeek.00": "枚举值0的含义",
  "50901.null.genPracticeModeWeek.01": "枚举值2的含义",
  "50901.null.hpTime2WeekRange2.00": "disable",
  "50901.null.hpTime2WeekRange2.01": "enable",
  "50901.null.overtemperatureAlarm.00": "disable",
  "50901.null.overtemperatureAlarm.01": "enable",
  "50901.null.hpTime2WeekRange1.00": "disable",
  "50901.null.hpTime2WeekRange1.01": "enable",
  "50901.null.hpTime2WeekRange7.00": "disable",
  "50901.null.hpTime2WeekRange7.01": "enable",
  "50901.null.hpTime2WeekRange6.00": "disable",
  "50901.null.hpTime2WeekRange6.01": "enable",
  "50901.null.hpTime2WeekRange5.00": "disable",
  "50901.null.hpTime2WeekRange5.01": "enable",
  "50901.null.section3WeekRange1.00": "枚举值0的含义",
  "50901.null.section3WeekRange1.01": "枚举值2的含义",
  "50901.null.hpTime2WeekRange4.00": "disable",
  "50901.null.hpTime2WeekRange4.01": "enable",
  "50901.null.section3WeekRange2.00": "枚举值0的含义",
  "50901.null.section3WeekRange2.01": "枚举值1的含义",
  "50901.null.overTemperature.00": "disable",
  "50901.null.overTemperature.01": "enable",
  "50901.null.chargeHighTemperatureAlarm.00": "disable",
  "50901.null.chargeHighTemperatureAlarm.01": "enable",
  "50901.null.section2WeekRange1.00": "枚举值0的含义",
  "50901.null.section2WeekRange1.01": "枚举值2的含义",
  "50901.null.batteryModule.22": "HOY LV",
  "50901.null.batteryModule.23": "HOY HV",
  "50901.null.batteryModule.24": "FEB LV",
  "50901.null.batteryModule.25": "UHhome LV",
  "50901.null.batteryModule.26": "UHhome HV",
  "50901.null.batteryModule.27": "BYD HV",
  "50901.null.batteryModule.28": "Vestwoods HV",
  "50901.null.batteryModule.29": "Phylion HV",
  "50901.null.batteryModule.30": "Hoymiles LV",
  "50901.null.batteryModule.31": "Pholion LV",
  "50901.null.batteryModule.10": "Xin Yi LV",
  "50901.null.batteryModule.32": "Wattsonic LV",
  "50901.null.batteryModule.11": "Vestwoods LV",
  "50901.null.batteryModule.33": "Enershare HV",
  "50901.null.batteryModule.12": "JK HV",
  "50901.null.batteryModule.34": "Beghelli LV",
  "50901.null.batteryModule.13": "BYD LV",
  "50901.null.batteryModule.35": "LvToPSUN LV",
  "50901.null.batteryModule.14": "Uz HV",
  "50901.null.batteryModule.36": "PYTES HV",
  "50901.null.batteryModule.15": "Zetara LV",
  "50901.null.batteryModule.37": "LvToPSUN hv",
  "50901.null.batteryModule.16": "FEB HV",
  "50901.null.batteryModule.38": "RAJA HV",
  "50901.null.batteryModule.17": "Pytes LV",
  "50901.null.batteryModule.39": "Felicity LV",
  "50901.null.batteryModule.18": "Dmegc LV",
  "50901.null.batteryModule.19": "Weineng LV",
  "50901.null.batteryModule.01": "Pylon LV",
  "50901.null.batteryModule.02": "Pylon HV",
  "50901.null.batteryModule.03": "Dyness LV",
  "50901.null.batteryModule.04": "Dyness HV",
  "50901.null.batteryModule.05": "Sunwoda LV",
  "50901.null.batteryModule.06": "Uz LV",
  "50901.null.batteryModule.07": "Soluna HV",
  "50901.null.batteryModule.08": "Soluna LV",
  "50901.null.batteryModule.09": "Steltec LV",
  "50901.null.batteryModule.20": "Weineng HV",
  "50901.null.batteryModule.21": "GSL LV",
  "50901.null.meterFrequency.desc": "电表频率的说明。",
  "50901.null.commAddress8Slave7.desc": "通信地址8(从7）的说明。",
  "50901.null.section2ValleyStartHour2.desc": "section2低估开始时间2-小时的说明。",
  "50901.null.timeOfUseTime4DischrgEndH.desc": "使用时间Time4DischrgEnd-H的说明。",
  "50901.null.hpTime1StartDay.desc": "HPTime1开始-天的说明。",
  "50901.null.pv1Power.desc": "PV1功率的说明。",
  "50901.null.sustainedNegativeLoad.desc": "持续负负载的说明。",
  "50901.null.microelectronicFault.desc": "微电子故障的说明。",
  "50901.null.section2ValleyStartHour1.desc": "section2低估开始时间1-小时的说明。",
  "50901.null.gridBuyPower.desc": "累计买电量的说明。",
  "50901.null.timeOfUseTime1ChrgStartMin.desc": "使用时间Time1ChrgStart-\nMin\n的说明。",
  "50901.null.phaseAOfInverterSideCurrent.desc": "逆变器交流侧A相电流的说明。",
  "50901.null.packPower.desc": "电池包功率的说明。",
  "50901.null.timeOfUseTime2ChrgStartMin.desc": "使用时间Time2ChrgStart-\nMin\n的说明。",
  "50901.null.pvToLoadPower.desc": "光伏流向负载的功率的说明。",
  "50901.null.batteryCapacity.desc": "BMS容量的说明。",
  "50901.null.batteryHealing.desc": "电池恢复的说明。",
  "50901.null.batteryWorkingStatus.desc": "电池状态的说明。",
  "50901.null.tenMinuteOvervoltage.desc": "10分钟过压的说明。",
  "50901.null.relaySupplyVoltageSampling.desc": "继电器电源电压采样的说明。",
  "50901.null.minCellSocCellId.desc": "最低单体SOC对应序号的说明。",
  "50901.null.gridRecoveryDelayTimeSeconds.desc": "电网恢复延迟时间（秒）的说明。",
  "50901.null.gridPortOvercurrent.desc": "电网端口过流的说明。",
  "50901.null.gridRelayProtection.desc": "电网继电器保护的说明。",
  "50901.null.timeOfUseTime8ChrgStartMin.desc": "使用时间Time8ChrgStart-\nMin\n的说明。",
  "50901.null.pv1Current.desc": "PV1电流的说明。",
  "50901.null.powerLimitOfThePowerGrid.desc": "电网功率限制限值的说明。",
  "50901.null.timeOfUseTime5ChrgStartMin.desc": "使用时间Time5ChrgStart-\nMin\n的说明。",
  "50901.null.timed2EndMinutes_3.desc": "时间段2终-分的说明。",
  "50901.null.timeZone.desc": "时区的说明。",
  "50901.null.timed2EndMinutes_2.desc": "定时2终_2-分的说明。",
  "50901.null.timeOfUseTime4ChrgStartMin.desc": "使用时间Time4ChrgStart-\nMin\n的说明。",
  "50901.null.twelveVoltPowerSupplyFault.desc": "12V电源故障的说明。",
  "50901.null.lineToEarthFault.desc": "对地故障（相线对地）的说明。",
  "50901.null.section3StopMonth.desc": "section3停止月的说明。",
  "50901.null.timeOfUseTime3ChrgStartMin.desc": "使用时间Time3ChrgStart-\nMin\n的说明。",
  "50901.null.boardAmbientTemperatureThreshold.desc": "电路板环境温度阈值的说明。",
  "50901.null.gridPowerFactor.desc": "电网侧功率因数的说明。",
  "50901.null.pvPower.desc": "PV功率的说明。",
  "50901.null.dtsCommunicationAbnormality.desc": "DTS 通信异常的说明。",
  "50901.null.dfs.desc": "能力集的说明。",
  "50901.null.temperatureCorrectionFactor.desc": "温度校正系数的说明。",
  "50901.null.minCellTemperature.desc": "最低单体温度的说明。",
  "50901.null.hpMaxRunTimeOfOneDay.desc": "HP一天的最大运行时间的说明。",
  "50901.null.checkTime.desc": "设备时间的说明。",
  "50901.null.hpBattSocDetectMode.desc": "HPBattSoc检测模式的说明。",
  "50901.null.phaseBOfInverterSideCurrent.desc": "逆变器交流侧B相电流的说明。",
  "50901.null.maxCellTemperature.desc": "最高单体温度的说明。",
  "50901.null.pvToGridPower.desc": "光伏流向电网的功率的说明。",
  "50901.null.timeOfUseTime6ChrgStartMin.desc": "使用时间Time6ChrgStart-\nMin\n的说明。",
  "50901.null.timeOfUseTime5ChrgEndMin.desc": "使用时间Time5Chrg结束-分钟的说明。",
  "50901.null.hpDelayDetectTimeLmt.desc": "HP延迟检测时间限制的说明。",
  "50901.null.section2StartMonth.desc": "section2开始月的说明。",
  "50901.null.timeOfUseTime7ChrgStartMin.desc": "使用时间Time7ChrgStart-\nMin\n的说明。",
  "50901.null.gridMeasurementOfRadiatorTemperature.desc": "电网测散热器温度的说明。",
  "50901.null.pv2Voltage.desc": "PV2电压的说明。",
  "50901.null.hpTime4StartDay.desc": "HPTime4开始-天的说明。",
  "50901.null.hpTime1StartMonth.desc": "HPTime1开始-月的说明。",
  "50901.null.3_3vAuxiliaryVoltageSampling.desc": "3.3V辅助电压采样的说明。",
  "50901.null.batteryDischargePowerSettingValue.desc": "电池的放电功率设置值的说明。",
  "50901.null.timeOfUseTime1ChrgPower.desc": "充电功率的说明。",
  "50901.null.forceDischargeSoc.desc": "强制放电SOC的说明。",
  "50901.null.evCharger1CommunicationAbnormality.desc": "电动汽车充电桩1通信异常的说明。",
  "50901.null.parallelNetworking.desc": "并行网络的说明。",
  "50901.null.pvIslandModeEn.desc": "PV模式使能的说明。",
  "50901.null.bypassDisable.desc": "绕过禁用的说明。",
  "50901.null.reconnectionFailed.desc": "重连失败的说明。",
  "50901.null.timeOfUseTime5ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.null.rssi.desc": "信号强度的说明。",
  "50901.null.meterWiringAbnormality.desc": "​​ 电表接线异常的说明。",
  "50901.null.batteryPackDischargeLowVoltageAlarm.desc": "电池组放电欠压报警的说明。",
  "50901.null.dayOfTheWeekRange2.desc": "负载控制星期二的说明。",
  "50901.null.dayOfTheWeekRange1.desc": "负载控制星期一的说明。",
  "50901.null.dayOfTheWeekRange4.desc": "负载控制星期四的说明。",
  "50901.null.dayOfTheWeekRange3.desc": "负载控制星期三的说明。",
  "50901.null.timeOfUseTime7ChrgStartH.desc": "使用时间Time7ChrgStart-H的说明。",
  "50901.null.dayOfTheWeekRange6.desc": "负载控制星期六的说明。",
  "50901.null.dayOfTheWeekRange5.desc": "负载控制星期五的说明。",
  "50901.null.equalizationVoltage.desc": "均衡电压的说明。",
  "50901.null.firmwareEndAddressHigh.desc": "固件结束地址(高)的说明。",
  "50901.null.dayOfTheWeekRange7.desc": "负载控制星期天的说明。",
  "50901.null.maxCellVoltage.desc": "最高单体电压的说明。",
  "50901.null.timeOfUseTime7ChrgEndMin.desc": "使用时间Time7Chrg结束-分钟的说明。",
  "50901.null.hpTime4WeekRange6.desc": "HPTime4周范围6的说明。",
  "50901.null.quietTime1StartMin.desc": "待机时间1开始-分钟的说明。",
  "50901.null.epsCurrentA.desc": "EPS侧A相电流的说明。",
  "50901.null.hpTime4WeekRange7.desc": "HPTime4周范围7的说明。",
  "50901.null.epsCurrentB.desc": "EPS侧B相电流的说明。",
  "50901.null.epsCurrentC.desc": "EPS侧C相电流的说明。",
  "50901.null.rcdFault.desc": "漏电保护器故障的说明。",
  "50901.null.hpTime4WeekRange2.desc": "HPTime4周范围2的说明。",
  "50901.null.hpTime4WeekRange3.desc": "HPTime4周范围3的说明。",
  "50901.null.gridOvervoltage.desc": "电网过压的说明。",
  "50901.null.hpTime4WeekRange4.desc": "HPTime4周范围4的说明。",
  "50901.null.hpTime4WeekRange5.desc": "HPTime4周范围5的说明。",
  "50901.null.clockSetting_year.desc": "时钟设置-year的说明。",
  "50901.null.hpSupplyPower.desc": "HP电源的说明。",
  "50901.null.timer2Hour_2.desc": "定时2起_2-时的说明。",
  "50901.null.hpTime4WeekRange1.desc": "HPTime4周范围1的说明。",
  "50901.null.timer2Hour_3.desc": "时间段2起-时的说明。",
  "50901.null.ClockSetting.desc": "时钟设置的说明。",
  "50901.null.fanFault.desc": "风扇故障的说明。",
  "50901.null.GridChargingAllowed.desc": "是否允许电网充电的说明。",
  "50901.null.maximumDischargeLimit.desc": "最大放电限制值的说明。",
  "50901.null.epsVoltageB.desc": "EPS侧B相电压的说明。",
  "50901.null.absoluteTime.desc": "绝对时间的说明。",
  "50901.null.peakMeterPower.desc": "峰值仪表功率的说明。",
  "50901.null.epsVoltageC.desc": "EPS侧C相电压的说明。",
  "50901.null.epsVoltageA.desc": "EPS侧A相电压的说明。",
  "50901.null.phaseCOfInverterSideVoltage.desc": "逆变器交流侧C相电压的说明。",
  "50901.null.masterSlave.desc": "主机/从机的说明。",
  "50901.null.machineSnMaster.desc": "机器SN(主)的说明。",
  "50901.null.pv4RealTimePower.desc": "PV4实时功率的说明。",
  "50901.null.section1PeakStartMinute2.desc": "section1峰值开始时间2-分钟的说明。",
  "50901.null.threePhaseUnbalanceEnable.desc": "三相不平衡使能的说明。",
  "50901.null.section1PeakStartMinute1.desc": "section1 峰值开始时间1-分钟的说明。",
  "50901.null.quietTime2StartH.desc": "待机时间2开始-H的说明。",
  "50901.null.section4PeakStartMinute1.desc": "section4峰值开始时间1-分钟的说明。",
  "50901.null.genPracticeModeStartMin.desc": "发电机练习模式启动时间-分钟的说明。",
  "50901.null.floatVoltage.desc": "浮动电压的说明。",
  "50901.null.replenishPower.desc": "功率补偿的说明。",
  "50901.null.loadRelayAFault.desc": "负载A继电器故障的说明。",
  "50901.null.hpStartPower.desc": "hp启动功率的说明。",
  "50901.null.section4PeakStartMinute2.desc": "section4峰值开始时间2-分钟的说明。",
  "50901.null.batteryPower.desc": "电池功率（充电/放电）的说明。",
  "50901.null.hpTime4EndMonth.desc": "HPTime4结束\n月的说明。",
  "50901.null.canCommunicationTimeout.desc": "CAN通信超时的说明。",
  "50901.null.genPortOvercurrent.desc": "发电机端口过流的说明。",
  "50901.null.quietTime2EndH.desc": "待机时间2结束-H的说明。",
  "50901.null.dtu4Rs485CommunicationAbnormality.desc": "DTU4 RS485 通信异常的说明。",
  "50901.null.gridMeter.desc": "电网电表通信失败的说明。",
  "50901.null.backupSoc.desc": "备用SOC的说明。",
  "50901.null.meterPhaseBReactivePower.desc": "电表B无功功率的说明。",
  "50901.null.pvMeterDailyYield.desc": "外部逆变器日发电量的说明。",
  "50901.null.neutralWireToEarthFault.desc": "零线对地故障的说明。",
  "50901.null.dailyPvToBatteryEnegry.desc": "今日光伏流向电池的能量的说明。",
  "50901.null.maximumDischargePower.desc": "最大放电功率的说明。",
  "50901.null.batteryDischargePower.desc": "电池累计放电量的说明。",
  "50901.null.timed2EndHour.desc": "定时2终-时的说明。",
  "50901.null.chargeTimeEndH.desc": "发电机控制-充电结束时间-H的说明。",
  "50901.null.gridInPowerLimitationWhenValley.desc": "限制网络功率的说明。",
  "50901.null.armCommunicationFault.desc": "ARM通信故障的说明。",
  "50901.null.inputOvervoltageAlarm.desc": "输入过压报警的说明。",
  "50901.null.pvMeterVoltageB.desc": "PV电表B相电压的说明。",
  "50901.null.pvMeterVoltageA.desc": "PV电表A相电压的说明。",
  "50901.null.batteryLowVoltageAlarm.desc": "电池欠压的说明。",
  "50901.null.pvMeterVoltageC.desc": "PV电表C相电压的说明。",
  "50901.null.dailyGridToLoadEnergy.desc": "本日电网流向负载的能量的说明。",
  "50901.null.hpWorkMode.desc": "HP工作模式的说明。",
  "50901.null.timeOfUseTime2ChrgEndH.desc": "使用时间Time2Chrg结束-H的说明。",
  "50901.null.communicationStickSn.desc": "通讯棒SN的说明。",
  "50901.null.generatorTotalYield.desc": "发电机累计发电量的说明。",
  "50901.null.initialResistance.desc": "初始阻力的说明。",
  "50901.null.flashCommunicationFault.desc": "闪存通信故障的说明。",
  "50901.null.lowBatteryEnergy.desc": "电池电量过低的说明。",
  "50901.null.appSoftwareVersion.desc": "APP软件版本的说明。",
  "50901.null.phaseCOfInverterSideCurrent.desc": "逆变器交流侧C相电流的说明。",
  "50901.null.timeOfUseRange.desc": "TOU模式时间范围的说明。",
  "50901.null.workStatus.desc": "运行状态的说明。",
  "50901.null.epsPowerC.desc": "EPS侧C相功率的说明。",
  "50901.null.dtu3Rs485CommunicationAbnormality.desc": "DTU3 RS485 通信异常的说明。",
  "50901.null.bmsCanCommunicationAbnormality.desc": "BMS_CAN 通信异常的说明。",
  "50901.null.epsPowerB.desc": "EPS侧B相功率的说明。",
  "50901.null.batteryMaxChargePower.desc": "电池最大充电功率的说明。",
  "50901.null.epsPowerA.desc": "EPS侧A相功率的说明。",
  "50901.null.relayStatus.desc": "继电器状态的说明。",
  "50901.null.gridMeterTypeError.desc": " 电网电表类型错误的说明。",
  "50901.null.batteryVoltage.desc": "电池电压的说明。",
  "50901.null.pv2Current.desc": "PV2电流的说明。",
  "50901.null.maxCellVoltageCellId.desc": "最高单体电压对应序号的说明。",
  "50901.null.pvPowerWholeSystem.desc": "PV总功率（整个系统）的说明。",
  "50901.null.batteryToLoadPower.desc": "电池流向负载的功率的说明。",
  "50901.null.dailyExportEnergyToGrid.desc": "日卖电量的说明。",
  "50901.null.testFault.desc": "testFault的说明。",
  "50901.null.hpStartSoc.desc": "HP启动Soc的说明。",
  "50901.null.phaseAOfInverterSideVoltage.desc": "逆变器交流侧A相电压的说明。",
  "50901.null.batteryDailyDischargeEnergy.desc": "电池日放电量的说明。",
  "50901.null.section3PeakStopMinute1.desc": "section3峰值停止时间1-分钟的说明。",
  "50901.null.section3PeakStopMinute2.desc": "section3峰值停止时间2-分钟的说明。",
  "50901.null.essAccessPoint.desc": "ess接入点的说明。",
  "50901.null.timeOfUseTime1DischrgStartH.desc": "使用时间Time1DischrgStart-H的说明。",
  "50901.null.dailyPvToGridEnegry.desc": "今日光伏流向电网的能量的说明。",
  "50901.null.DTSReset.desc": "数据棒复位的说明。",
  "50901.null.timeOfUseTime8DischrgStartMin.desc": "使用时间Time8DischrgStart-Min的说明。",
  "50901.null.macAddr.desc": "MAC地址的说明。",
  "50901.null.weekRange5.desc": "星期五的说明。",
  "50901.null.section2StopMonth.desc": "section2停止月的说明。",
  "50901.null.communicationStickSoftwareVersion.desc": "通讯棒软件版本的说明。",
  "50901.null.pvPortOvercurrent.desc": "光伏端口过流的说明。",
  "50901.null.weekRange6.desc": "星期六的说明。",
  "50901.null.weekRange7.desc": "星期天的说明。",
  "50901.null.timeOfUseTime6DischrgPower.desc": "放电功率的说明。",
  "50901.null.timeOfUseTime7DischrgEndH.desc": "使用时间Time7DischrgEnd-H的说明。",
  "50901.null.weekRange1.desc": "星期一的说明。",
  "50901.null.weekRange2.desc": "星期二的说明。",
  "50901.null.weekRange3.desc": "星期三的说明。",
  "50901.null.weekRange4.desc": "星期四的说明。",
  "50901.null.timeOfUseTime1DischrgStartMin.desc": "使用时间Time1DischrgStart-Min的说明。",
  "50901.null.internalFanSpeed2.desc": "内测风扇转速2的说明。",
  "50901.null.meterPhaseAPowerFactor.desc": "电表A功率因数的说明。",
  "50901.null.internalFanSpeed1.desc": "内测风扇转速1的说明。",
  "50901.null.timeOfUseTime2DischrgPower.desc": "放电功率的说明。",
  "50901.null.internalFanSpeed3.desc": "内测风扇转速3的说明。",
  "50901.null.dailyPvToLoadEnegry.desc": "今日光伏流向负载的能量的说明。",
  "50901.null.maxCellTemperatureCellId.desc": "最高单体温度对应序号的说明。",
  "50901.null.gridPowerOutage.desc": "电网断电的说明。",
  "50901.null.section1ValleyStopHour1.desc": "section1 低谷停止时间1- 小时的说明。",
  "50901.null.section1ValleyStopHour2.desc": "section1低估停止时间2-小时的说明。",
  "50901.null.driveAbnormality.desc": "驱动异常的说明。",
  "50901.null.timeOfUseTime5ChrgEndH.desc": "使用时间Time5Chrg结束-H的说明。",
  "50901.null.timeOfUseTime3ChrgStartH.desc": "使用时间Time3ChrgStart-H的说明。",
  "50901.null.frequencyVariationRateOutOfRange.desc": "频率变化率超限的说明。",
  "50901.null.timeOfUseTime1DischrgEndMin.desc": "使用时间Time1Dischrg结束-分钟的说明。",
  "50901.null.arcFault.desc": "电弧故障的说明。",
  "50901.null.neutralWireNotConnected.desc": "零线未连接的说明。",
  "50901.null.section3StartDay.desc": "section3开始天的说明。",
  "50901.null.leadAcidBatReplenishTime.desc": "铅酸电池维护时间的说明。",
  "50901.null.hardwareProtection.desc": "硬件保护的说明。",
  "50901.null.timeOfUseTime2ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.null.selfUsedSoc.desc": "自用SOC的说明。",
  "50901.null.arcFaultClear.desc": "电弧故障清除的说明。",
  "50901.null.connectionServerStatus.desc": "连接器服务状态的说明。",
  "50901.null.inverterTemp.desc": "逆变器内部运行温度的说明。",
  "50901.null.quietTime2StartMin.desc": "待机时间2开始-Min的说明。",
  "50901.null.maximumChargePower.desc": "最大充电功率的说明。",
  "50901.null.BatteryModel.desc": "电池型号的说明。",
  "50901.null.clearFault.desc": "清除故障的说明。",
  "50901.null.pvConnectionStatus.desc": "光伏连接状态的说明。",
  "50901.null.rcdSelfTestFault.desc": "漏电保护器自检故障的说明。",
  "50901.null.dtu1Rs485CommunicationAbnormality.desc": "DTU1 RS485 通信异常的说明。",
  "50901.null.timeOfUseTime4ChrgStartH.desc": "使用时间Time4ChrgStart-H的说明。",
  "50901.null.batGridFeedPowerWhenPeak.desc": "峰值时电网馈电功率的说明。",
  "50901.null.section2PeakStopMinute1.desc": "section2峰值停止时间1-分钟的说明。",
  "50901.null.pvRelayAbFault.desc": "光伏AB继电器故障的说明。",
  "50901.null.commAddress6Slave6.desc": "通信地址6(从5）的说明。",
  "50901.null.timeOfUseTime1ChrgEndMin.desc": "使用时间Time1Chrg结束-分钟的说明。",
  "50901.null.generatorPowerC.desc": "发电机C相功率的说明。",
  "50901.null.minimumOnLoadPower.desc": "负载模式负载功率阈值的说明。",
  "50901.null.packNum.desc": "并联数量（电池Pack个数）的说明。",
  "50901.null.generatorPowerB.desc": "发电机B相功率的说明。",
  "50901.null.preSynchronizationFailed.desc": "预同步失败的说明。",
  "50901.null.connectionRouterStatus.desc": "连接路由器状态的说明。",
  "50901.null.hpCloseSoc.desc": "HP关闭Soc的说明。",
  "50901.null.timeOfUseTime2DischrgStartMin.desc": "使用时间Time2DischrgStart-Min的说明。",
  "50901.null.genPracticeModeStartH.desc": "发电机练习模式启动时间-小时的说明。",
  "50901.null.gridType.desc": "电网标准的说明。",
  "50901.null.hpTime4StartMonth.desc": "HPTime4Start-月的说明。",
  "50901.null.generatorPowerA.desc": "发电机A相功率的说明。",
  "50901.null.chargeTimeStartMin.desc": "发电机控制-充电开始时间-分钟的说明。",
  "50901.null.meterPhaseBPowerFactor.desc": "电表B功率因数的说明。",
  "50901.null.section2PeakStopMinute2.desc": "section2峰值停止时间2-分钟的说明。",
  "50901.null.timer1Hour_2.desc": "定时1起_2-时的说明。",
  "50901.null.pvMeterCommunicationAbnormality.desc": "光伏电表通信异常的说明。",
  "50901.null.timer1Hour_3.desc": "时间段1起-时的说明。",
  "50901.null.economyModeDateNumber.desc": "经济模式日期编号的说明。",
  "50901.null.section3StopDay.desc": "section3停止日的说明。",
  "50901.null.timeOfUseTime2DischrgEndH.desc": "使用时间Time2DischrgEnd-H的说明。",
  "50901.null.batteryChargePower.desc": "电池累计充电量的说明。",
  "50901.null.timeOfUseTime2DischrgEndMin.desc": "使用时间Time2Dischrg结束-分钟的说明。",
  "50901.null.restartSystem.desc": "重启系统的说明。",
  "50901.null.packVoltage.desc": "电池包电压的说明。",
  "50901.null.pv4Current.desc": "PV4电流的说明。",
  "50901.null.timeOfUseTime8DischrgEndMin.desc": "使用时间Time8Dischrg结束-分钟的说明。",
  "50901.null.pvVoltageExceedingBusVoltage.desc": " PV电压超过母线电压的说明。",
  "50901.null.timer2Hour.desc": "定时2起-时的说明。",
  "50901.null.firmwareInformationCrc.desc": "固件信息CRC的说明。",
  "50901.null.dspVersionAuxiliaryUVersion.desc": "DSP版本(辅U版本)的说明。",
  "50901.null.smartloadPortOvercurrent.desc": "智能负载端口过流的说明。",
  "50901.null.systemPowerOnOff.desc": "系统开关机的说明。",
  "50901.null.numberOfUnits.desc": "机器数量的说明。",
  "50901.null.timeOfUseTime2DischrgStartH.desc": "使用时间Time2DischrgStart-H的说明。",
  "50901.null.timeOfUseTime4DischrgStartH.desc": "使用时间Time4DischrgStart-H的说明。",
  "50901.null.timed1From1Min.desc": "定时1起-分的说明。",
  "50901.null.firmwareEndAddressLow.desc": "固件结束地址(低)的说明。",
  "50901.null.genAbnormality.desc": "发电机异常的说明。",
  "50901.null.endChargeVoltage.desc": "结束充电电压的说明。",
  "50901.null.smart_weekRange1.desc": "时间范围1的说明。",
  "50901.null.firmwareStartAddressHigh.desc": "固件起始地址(高）的说明。",
  "50901.null.fanSpeedAbnormality.desc": "风扇转速异常的说明。",
  "50901.null.machineSnSlave2.desc": "机器SN(从2)的说明。",
  "50901.null.minCellTemperatureCellId.desc": "最低单体温度对应序号的说明。",
  "50901.null.machineSnSlave1.desc": "机器SN(从1)的说明。",
  "50901.null.machineSnSlave4.desc": "机器SN(从4）的说明。",
  "50901.null.generatorCloseBatteryCapacity.desc": "柴发关闭电池容量的说明。",
  "50901.null.machineSnSlave3.desc": "机器SN(从3)的说明。",
  "50901.null.section1PeakStopMinute1.desc": "section1 峰值停止时间1-分钟的说明。",
  "50901.null.clockSetting_second.desc": "时钟设置-second的说明。",
  "50901.null.section1PeakStopMinute2.desc": "section1峰值停止时间2-分钟的说明。",
  "50901.null.gridVoltageA.desc": "电网侧A相电压的说明。",
  "50901.null.epsOverload.desc": "EPS过载的说明。",
  "50901.null.gridVoltageB.desc": "电网侧B相电压的说明。",
  "50901.null.equalizationEnable.desc": "均衡启用的说明。",
  "50901.null.gridVoltageC.desc": "电网侧C相电压的说明。",
  "50901.null.meterConfiguration.desc": "仪表配置的说明。",
  "50901.null.section4StartMonth.desc": "section4开始月的说明。",
  "50901.null.soh.desc": "SOH的说明。",
  "50901.null.timeOfUseTime6ChrgStartH.desc": "使用时间Time6ChrgStart-H的说明。",
  "50901.null.inverterSideRadiatorTemperature.desc": "逆变器侧散热器温度的说明。",
  "50901.null.gridUnderfrequency.desc": "电网欠频的说明。",
  "50901.null.totalPvToBatteryEnegry.desc": "累计-光伏流向电池的能量的说明。",
  "50901.null.hpTime2StartMonth.desc": "HPTime2开始-月的说明。",
  "50901.null.pvMeterPower.desc": "PV电表功率的说明。",
  "50901.null.timed2EndMinutes.desc": "定时2终-分的说明。",
  "50901.null.lowDtuVersion.desc": "DTU版本过低的说明。",
  "50901.null.loadRelayBFault.desc": "​​ 负载B继电器故障的说明。",
  "50901.null.timeOfUseTime5ChrgStartH.desc": "使用时间Time5ChrgStart-H的说明。",
  "50901.null.externalFanSpeed3.desc": "外侧风扇转速3的说明。",
  "50901.null.timeOfUseTime3DischrgStartMin.desc": "使用时间Time3DischrgStart-Min的说明。",
  "50901.null.externalFanSpeed4.desc": "外侧风扇转速4的说明。",
  "50901.null.pvFault.desc": "光伏故障的说明。",
  "50901.null.timeOfUseTime6ChrgPower.desc": "充电功率的说明。",
  "50901.null.section4StopDay.desc": "section4停止日的说明。",
  "50901.null.externalFanSpeed1.desc": "外侧风扇转速1的说明。",
  "50901.null.externalFanSpeed2.desc": "外侧风扇转速2的说明。",
  "50901.null.batteryHighVoltageAlarm.desc": "电池过压报警的说明。",
  "50901.null.gatewayCommunicationAddress.desc": "网关通信地址的说明。",
  "50901.null.meterPhaseAReactivePower.desc": "电表A无功功率的说明。",
  "50901.null.timeOfUseTime2ChrgEndMin.desc": "使用时间Time2Chrg结束-分钟的说明。",
  "50901.null.smart_weekRange25.desc": "星期六的说明。",
  "50901.null.batteryChargingPowerSettingValue.desc": "电池的充电功率设置值的说明。",
  "50901.null.meterPhaseAActivePower.desc": "电表A有功功率的说明。",
  "50901.null.genRelayAFault.desc": "​​ 发电机A继电器故障的说明。",
  "50901.null.smart_weekRange26.desc": "星期天的说明。",
  "50901.null.equalizationTime.desc": "均衡时间的说明。",
  "50901.null.firmwareBuildTimeDateHour.desc": "固件构建时间(天/小时)的说明。",
  "50901.null.inverterModelNumber.desc": "逆变器机型编号的说明。",
  "50901.null.batteryType_04.desc": "电池类型的说明。",
  "50901.null.smart_weekRange23.desc": "星期四的说明。",
  "50901.null.generatorCurrentB.desc": "发电机B相电流的说明。",
  "50901.null.smart_weekRange24.desc": "星期五的说明。",
  "50901.null.generatorCurrentC.desc": "发电机C相电流的说明。",
  "50901.null.smart_weekRange21.desc": "星期二的说明。",
  "50901.null.smart_weekRange22.desc": "星期三的说明。",
  "50901.null.generatorCurrentA.desc": "发电机A相电流的说明。",
  "50901.null.gridCurrentDcOffsetOutOfRange.desc": "电网电流直流偏置超限的说明。",
  "50901.null.timeOfUseTime6DischrgEndH.desc": "使用时间Time6DischrgEnd-H的说明。",
  "50901.null.smart_weekRange20.desc": "星期一的说明。",
  "50901.null.machineSnSlave6.desc": "机器SN(从6）的说明。",
  "50901.null.machineSnSlave5.desc": "机器SN(从5）的说明。",
  "50901.null.commAddress10Slave9.desc": "通信地址10(从9）的说明。",
  "50901.null.machineSnSlave8.desc": "机器SN(从8）的说明。",
  "50901.null.section3ValleyStopMinute1.desc": "section3低估停止时间1-分钟的说明。",
  "50901.null.machineSnSlave7.desc": "机器SN(从7）的说明。",
  "50901.null.section3ValleyStopMinute2.desc": "section3低估停止时间2-分钟的说明。",
  "50901.null.gridPowerWholeSystem.desc": "电网总功率（整个系统）的说明。",
  "50901.null.machineSnSlave9.desc": "机器SN(从9)的说明。",
  "50901.null.genPracticeModeEn.desc": "发电机练习模式的说明。",
  "50901.null.maxCellSocCellId.desc": "最高单体SOC对应序号的说明。",
  "50901.null.CfgMultPcsBMSFlag.desc": "BMS标志位的说明。",
  "50901.null.section2ValleyStopHour2.desc": "section2低估停止时间2-小时的说明。",
  "50901.null.inverterCommunicationFailed.desc": "逆变器通信失败的说明。",
  "50901.null.pv3Voltage.desc": "PV3电压的说明。",
  "50901.null.gridMeterCommunicationAbnormality.desc": "电网电表通信异常的说明。",
  "50901.null.masterSlaveCommunicationAbnormality.desc": "主从通信异常的说明。",
  "50901.null.batteryFault.desc": "电池故障的说明。",
  "50901.null.upgradeCommand.desc": "升级指令的说明。",
  "50901.null.pvMeterTypeError.desc": "光伏电表类型错误的说明。",
  "50901.null.lowAmbientTemperature.desc": "环境温度过低的说明。",
  "50901.null.pvMeterPowerC.desc": "PV电表C相功率的说明。",
  "50901.null.nationalStandardsSafetyRegulationsStandards.desc": "国家标准（安规标准）的说明。",
  "50901.null.batteryConnectionStatus.desc": "是否连接电池的说明。",
  "50901.null.pvMeterPowerB.desc": "PV电表B相功率的说明。",
  "50901.null.section3StartMonth.desc": "section3开始月的说明。",
  "50901.null.hmidMachineFault.desc": "人机交互界面设备故障的说明。",
  "50901.null.commAddress3Slave2.desc": "通信地址3(从2)的说明。",
  "50901.null.timeOfUseTime6ChrgEndH.desc": "使用时间Time6Chrg结束-H的说明。",
  "50901.null.epsPower.desc": "EPS侧功率的说明。",
  "50901.null.machineTypeMismatch.desc": "机型不匹配的说明。",
  "50901.null.commAddress3Slave3.desc": "通信地址4(从3)的说明。",
  "50901.null.hpTime3EndMonth.desc": "HPTime3结束\n月的说明。",
  "50901.null.evCharger1Fault.desc": "充电桩1故障的说明。",
  "50901.null.section1ValleyStartMinute1.desc": "section1 低谷开始时间1- 分钟的说明。",
  "50901.null.section1ValleyStartMinute2.desc": "section1低估开始时间2-分钟的说明。",
  "50901.null.bmsSoftwareVersion.desc": "BMS版本-软件的说明。",
  "50901.null.timed1From1Min_2.desc": "定时1起_2-分的说明。",
  "50901.null.timed1From1Min_3.desc": "时间段1起-分的说明。",
  "50901.null.busbarAbnormality.desc": "母线异常的说明。",
  "50901.null.section4StartDay.desc": "section4开始天的说明。",
  "50901.null.section1ValleyStartHour1.desc": "section1 低谷开始时间1- 小时的说明。",
  "50901.null.section1ValleyStartHour2.desc": "section1低估开始时间2-小时的说明。",
  "50901.null.pvMeterTotalYield.desc": "外部逆变器累计发电量的说明。",
  "50901.null.clockSetting_minute.desc": "时钟设置-minute的说明。",
  "50901.null.loadEnergy.desc": "负载日用电量的说明。",
  "50901.null.batteryPackChargeHighVoltageAlarm.desc": "电池组充电过压报警的说明。",
  "50901.null.commAddress4Slave4.desc": "通信地址5(从4)的说明。",
  "50901.null.timeOfUseTime3ChrgEndMin.desc": "使用时间Time3Chrg结束-分钟的说明。",
  "50901.null.pvMeterPowerA.desc": "PV电表A相功率的说明。",
  "50901.null.equalizationChargeTimeout.desc": "均衡充电超时的说明。",
  "50901.null.timed2EndHour_2.desc": "定时2终_2-时的说明。",
  "50901.null.section4ValleyStartHour2.desc": "section4低估开始时间2-小时的说明。",
  "50901.null.timed1EndHour.desc": "定时1终-时的说明。",
  "50901.null.powerGeneration.desc": "PV累计发电量的说明。",
  "50901.null.section4ValleyStartHour1.desc": "section4低估开始时间1-小时的说明。",
  "50901.null.timeOfUseTime3DischrgStartH.desc": "使用时间Time3DischrgStart-H的说明。",
  "50901.null.5vAuxiliaryVoltageSampling.desc": "5V辅助电压采样的说明。",
  "50901.null.hpTime3StartMonth.desc": "HPTime3开始-月的说明。",
  "50901.null.timer1Hour.desc": "定时1起-时的说明。",
  "50901.null.timed2EndHour_3.desc": "时间段2终-时的说明。",
  "50901.null.section2ValleyStopHour1.desc": "section2低估停止时间1-小时的说明。",
  "50901.null.batDischargePowerWhenPartialPeak.desc": "峰值时电池最大放电功率的说明。",
  "50901.null.inverterSn.desc": "逆变器SN的说明。",
  "50901.null.gridCurrentC.desc": "电网侧C相电流的说明。",
  "50901.null.pvToBatteryPower.desc": "光伏流向电池的功率的说明。",
  "50901.null.generatorVoltageC.desc": "发电机C相电压的说明。",
  "50901.null.timeOfUseTime6ChrgEndMin.desc": "使用时间Time6Chrg结束-分钟的说明。",
  "50901.null.chargeTimeEndMin.desc": "发电机控制-充电结束时间-分钟的说明。",
  "50901.null.chargeLowTemperatureAlarm.desc": "充电低温报警的说明。",
  "50901.null.threePointThreeVoltPowerSupplyFault.desc": "3.3V电源故障的说明。",
  "50901.null.timeOfUseTime1ChrgEndH.desc": "使用时间Time1Chrg结束-H的说明。",
  "50901.null.generatorVoltageA.desc": "发电机A相电压的说明。",
  "50901.null.generatorVoltageB.desc": "发电机B相电压的说明。",
  "50901.null.maxSoc.desc": "最大SOC的说明。",
  "50901.null.totalBatteryToLoadEnergy.desc": "累计-电池流向负载的能量的说明。",
  "50901.null.batteryCapacityAbnormality.desc": " 电池容量异常的说明。",
  "50901.null.hpTime2EndMonth.desc": "HPTime2结束\n月的说明。",
  "50901.null.section4ValleyStartMinute1.desc": "section4低估开始时间1-分钟的说明。",
  "50901.null.section2PeakStopHour1.desc": "section2峰值停止时间1-小时的说明。",
  "50901.null.section4ValleyStartMinute2.desc": "section4低估开始时间2-分钟的说明。",
  "50901.null.section1StartMonth.desc": "section1开始月的说明。",
  "50901.null.mpptTemp.desc": "光伏侧散热器温度的说明。",
  "50901.null.gridCurrentA.desc": "电网侧A相电流的说明。",
  "50901.null.gridCurrentB.desc": "电网侧B相电流的说明。",
  "50901.null.pv3Current.desc": "PV3电流的说明。",
  "50901.null.gridPower.desc": "电网侧功率的说明。",
  "50901.null.commAddress2Slave1.desc": "通信地址2(从1)的说明。",
  "50901.null.section2PeakStopHour2.desc": "section2峰值停止时间2-小时的说明。",
  "50901.null.maximumChargeLimit.desc": "最大充电限制值的说明。",
  "50901.null.emergencyStopSwitchStatus.desc": "紧急停止的说明。",
  "50901.null.serviceEntranceBreakerCurrent.desc": "服务入口断路器电流的说明。",
  "50901.null.section3PeakStartMinute2.desc": "section3峰值开始时间1-分钟的说明。",
  "50901.null.minSoc.desc": "最小SOC的说明。",
  "50901.null.section3PeakStartMinute1.desc": "section3峰值开始时间2-分钟的说明。",
  "50901.null.gridReactivePowerC.desc": "电网侧C相无功功率的说明。",
  "50901.null.gridReactivePowerB.desc": "电网侧B相无功功率的说明。",
  "50901.null.timeOfUseTime4DischrgStartMin.desc": "使用时间Time4DischrgStart-Min的说明。",
  "50901.null.loadControlMode.desc": "负载控制模式的说明。",
  "50901.null.gridReactivePowerA.desc": "电网侧A相无功功率的说明。",
  "50901.null.genPracticeModeRunningTime.desc": "发电机练习模式运行时长的说明。",
  "50901.null.generatorDailyYield.desc": "发电机日发电量的说明。",
  "50901.null.meterPhaseBActivePower.desc": "电表B有功功率的说明。",
  "50901.null.timed1EndMinute.desc": "定时1终-分的说明。",
  "50901.null.section2ValleyStartMinute2.desc": "section2低估开始时间2-分钟的说明。",
  "50901.null.workMode.desc": "EMS工作模式的说明。",
  "50901.null.dailyBatteryToLoadEnergy.desc": "本日电池流向负载的能量的说明。",
  "50901.null.genRelayBFault.desc": "发电机B继电器故障的说明。",
  "50901.null.timeOfUseTime5DischrgStartMin.desc": "使用时间Time5DischrgStart-Min的说明。",
  "50901.null.quietTime1StartH.desc": "待机时间1开始-H的说明。",
  "50901.null.inverCombinedActivePower.desc": "逆变器交流侧输出功率的说明。",
  "50901.null.section2ValleyStartMinute1.desc": "section2低估开始时间1-分钟的说明。",
  "50901.null.batteryForceChargeRequest.desc": " 电池强制充电请求的说明。",
  "50901.null.arcSelfTestFault.desc": " 电弧自检故障的说明。",
  "50901.null.totalPvToGridEnegry.desc": "累计-光伏流向电网的能量的说明。",
  "50901.null.timeOfUseTime3DischrgEndH.desc": "使用时间Time3DischrgEnd-H的说明。",
  "50901.null.GridConnectionPointFeedinPowerLimit.desc": "并网点/馈网功率限值的说明。",
  "50901.null.timeOfUseTime4ChrgEndH.desc": "使用时间Time4Chrg结束-H的说明。",
  "50901.null.timeOfUseTime4ChrgEndMin.desc": "使用时间Time4Chrg结束-分钟的说明。",
  "50901.null.pv3Power.desc": "PV3功率的说明。",
  "50901.null.timeOfUseTime7DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.null.totalPvToLoadEnegry.desc": "累计-光伏流向负载的能量的说明。",
  "50901.null.timeOfUseTime4DischrgEndMin.desc": "使用时间Time4Dischrg结束-分钟的说明。",
  "50901.null.timeOfUseTime3ChrgPower.desc": "充电功率的说明。",
  "50901.null.section2StartDay.desc": "section2开始天的说明。",
  "50901.null.oemSerialNumber.desc": "OEM序列号的说明。",
  "50901.null.commAddress7Slave6.desc": "通信地址7(从6）的说明。",
  "50901.null.timeOfUseTime6DischrgStartH.desc": "使用时间Time6DischrgStart-H的说明。",
  "50901.null.12vAuxiliaryVoltageSampling.desc": "12V辅助电压采样的说明。",
  "50901.null.section4ValleyStopMinute2.desc": "section4低估停止时间2-分钟的说明。",
  "50901.null.rsvdReplenishPower.desc": "Rsvd补充功率的说明。",
  "50901.null.section4ValleyStopMinute1.desc": "section4低估停止时间1-分钟的说明。",
  "50901.null.timeOfUseTime6DischrgEndMin.desc": "使用时间Time6Dischrg结束-分钟的说明。",
  "50901.null.meterPhaseCPowerFactor.desc": "电表C功率因数的说明。",
  "50901.null.timeOfUseTime8DischrgStartH.desc": "使用时间Time8DischrgStart-H的说明。",
  "50901.null.timeOfUseTime6ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.null.e2rpomFault.desc": "EEPROM故障的说明。",
  "50901.null.gridSellPower.desc": "累计卖电量的说明。",
  "50901.null.inverterHardwareVersion.desc": "逆变器硬件版本的说明。",
  "50901.null.timedFrom2Minutes_2.desc": "定时2起_2-分的说明。",
  "50901.null.timedFrom2Minutes_3.desc": "时间段2起-分的说明。",
  "50901.null.materType.desc": "电表类型的说明。",
  "50901.null.timeOfUseTime8ChrgPower.desc": "充电功率的说明。",
  "50901.null.minCellVoltageCellId.desc": "最低单体电压对应序号的说明。",
  "50901.null.timeOfUseTime6DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.null.clockSetting_month.desc": "时钟设置-month的说明。",
  "50901.null.gridTotalFrequency.desc": "电网侧频率的说明。",
  "50901.null.MaxDisChargeCurrent.desc": "最大放电电流的说明。",
  "50901.null.wiringAbnormality.desc": "接线异常的说明。",
  "50901.null.quietTimeEnable.desc": "待机时间启用的说明。",
  "50901.null.hmidCommunicationAbnormality.desc": "人机交互界面通信异常的说明。",
  "50901.null.section4WeekRange1.desc": "section4周范围1的说明。",
  "50901.null.epsMode.desc": "EPS模式的说明。",
  "50901.null.section4WeekRange2.desc": "section4周范围2的说明。",
  "50901.null.section3ValleyStopHour1.desc": "section3低估停止时间1-小时的说明。",
  "50901.null.section3ValleyStopHour2.desc": "section3低估停止时间2-小时的说明。",
  "50901.null.samplingBiasAbnormality.desc": "采样偏置异常的说明。",
  "50901.null.timeOfUseTime7ChrgEndH.desc": "使用时间Time7Chrg结束-H的说明。",
  "50901.null.timeOfUseTime1ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.null.section4PeakStopHour1.desc": "section4峰值停止时间1-小时的说明。",
  "50901.null.dischargeHighTemperatureAlarm.desc": "放电高温报警的说明。",
  "50901.null.peakMeterSoc.desc": "峰值计SOC的说明。",
  "50901.null.section4PeakStopHour2.desc": "section4峰值停止时间2-小时的说明。",
  "50901.null.meterFlag.desc": "电表标志位的说明。",
  "50901.null.slaveWrongBatteryConnection.desc": "从机电池连接错误的说明。",
  "50901.null.oemModelName.desc": "OEM型号名称的说明。",
  "50901.null.section2StopDay.desc": "section2停止日的说明。",
  "50901.null.commAddress9Slave8.desc": "通信地址9(从8)的说明。",
  "50901.null.12vOutputVoltageSampling.desc": "12V输出电压采样的说明。",
  "50901.null.dtu2Rs485CommunicationAbnormality.desc": " DTU2 RS485 通信异常的说明。",
  "50901.null.timeOfUseTime8DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.null.gridPowerFactorB.desc": "电网侧B相功率因数的说明。",
  "50901.null.gridPowerFactorC.desc": "电网侧C相功率因数的说明。",
  "50901.null.gridPowerFactorA.desc": "电网侧A相功率因数的说明。",
  "50901.null.timeOfUseTime5DischrgEndH.desc": "使用时间Time5DischrgEnd-H的说明。",
  "50901.null.auxiliaryPowerAbnormality.desc": "辅助电源异常的说明。",
  "50901.null.phaseAOfInverterActivePower.desc": "逆变器交流侧A相功率的说明。",
  "50901.null.drmStatusUsedInAustraliaGermanyAustria.desc": "DRM状态（澳洲/德国/奥地利国家下使用）的说明。",
  "50901.null.hpTime2StartDay.desc": "HPTime2开始-天的说明。",
  "50901.null.pv4Voltage.desc": "PV4电压的说明。",
  "50901.null.minCellSoc.desc": "最低单体SOC的说明。",
  "50901.null.spiCommunicationFault.desc": "SPI通信故障的说明。",
  "50901.null.dryWorkingMode.desc": "干节点工作模式的说明。",
  "50901.null.section2ValleyStopMinute1.desc": "section2低估停止时间1-分钟的说明。",
  "50901.null.comparatorFault.desc": "比较器故障的说明。",
  "50901.null.section2ValleyStopMinute2.desc": "section2低估停止时间2-分钟的说明。",
  "50901.null.timed1EndMinute_3.desc": "时间段1终-分的说明。",
  "50901.null.timeOfUseTime4ChrgPower.desc": "充电功率的说明。",
  "50901.null.timed1EndMinute_2.desc": "定时1终_2-分的说明。",
  "50901.null.timeOfUseTime7ChrgPower.desc": "放电功率的说明。",
  "50901.null.section3PeakStopHour1.desc": "section3峰值停止时间1-小时的说明。",
  "50901.null.section3PeakStopHour2.desc": "section3峰值停止时间2-小时的说明。",
  "50901.null.section4ValleyStopHour2.desc": "section4低估停止时间2-小时的说明。",
  "50901.null.minimumOnTime.desc": "负载控制最短接通时间的说明。",
  "50901.null.offGridProtectionSoc.desc": "离网保护SOC的说明。",
  "50901.null.timeOfUseTime8ChrgStartH.desc": "使用时间Time8ChrgStart-H的说明。",
  "50901.null.section4ValleyStopHour1.desc": "section4低估停止时间1-小时的说明。",
  "50901.null.clockSetting_hour.desc": "时钟设置-hour的说明。",
  "50901.null.pllLockFailed.desc": "PLL锁相失败的说明。",
  "50901.null.timeOfUseTime3DischrgEndMin.desc": "使用时间Time3Dischrg结束-分钟的说明。",
  "50901.null.communicationStickHardwareVersion.desc": "通讯棒硬件版本的说明。",
  "50901.null.timeOfUseTime5DischrgStartH.desc": "使用时间Time5DischrgStart-H的说明。",
  "50901.null.afciVersion.desc": "AFCI版本的说明。",
  "50901.null.hpMaxTimeDetectEnable.desc": "HP最大时间检测启用的说明。",
  "50901.null.generatorMode.desc": "发电机模式的说明。",
  "50901.null.pv1RealTimePower.desc": "PV1实时功率的说明。",
  "50901.null.gridPowerA.desc": "电网侧A相功率的说明。",
  "50901.null.timeOfUseTime7DischrgEndMin.desc": "使用时间Time7Dischrg结束-分钟的说明。",
  "50901.null.gridPowerB.desc": "电网侧B相功率的说明。",
  "50901.null.equalizationIntervalDays.desc": "均衡间隔天数的说明。",
  "50901.null.gridPowerC.desc": "电网侧C相功率的说明。",
  "50901.null.selfTest.desc": "自检的说明。",
  "50901.null.dspPwrCommunicationAbnormality.desc": "​DSP电源通信异常的说明。",
  "50901.null.phaseCOfInverterActivePower.desc": "逆变器交流侧C相功率的说明。",
  "50901.null.kmRelayFault.desc": "KM继电器故障的说明。",
  "50901.null.minCellVoltage.desc": "最低单体电压的说明。",
  "50901.null.timeOfUseTime3DischrgPower.desc": "放电功率的说明。",
  "50901.null.section3ValleyStartMinute2.desc": "section3低估开始时间2-分钟的说明。",
  "50901.null.section3ValleyStartMinute1.desc": "section3低估开始时间1-分钟的说明。",
  "50901.null.packCurrent.desc": "电池包电流的说明。",
  "50901.null.timeOfUseTime5DischrgPower.desc": "放电功率的说明。",
  "50901.null.genOverload.desc": "发电机过载的说明。",
  "50901.null.timeOfUseTime7DischrgPower.desc": "放电功率的说明。",
  "50901.null.timeOfUseTime8DischrgPower.desc": "放电功率的说明。",
  "50901.null.fiveVoltPowerSupplyFault.desc": " 5V电源故障的说明。",
  "50901.null.endOfChargeCurrent.desc": "充电结束电流的说明。",
  "50901.null.bootSoftwareVersion.desc": "启动软件版本的说明。",
  "50901.null.batterySoc.desc": "电池SOC的说明。",
  "50901.null.totalLoadEnergy.desc": "负载累计用电量的说明。",
  "50901.null.timeOfUseTime2ChrgPower.desc": "充电功率的说明。",
  "50901.null.timeOfUseTime4DischrgStopSoc.desc": "放电截止功率的说明。",
  "50901.null.clockSetting_day.desc": "时钟设置-day的说明。",
  "50901.null.temperatureAbnormality.desc": "温度异常的说明。",
  "50901.null.timeOfUseTime1DischrgPower.desc": "放电功率的说明。",
  "50901.null.numberOfChargingAndDischargingCyclesOfBatteryPack.desc": "电池包充放电循环次数的说明。",
  "50901.null.genPracticeFreq.desc": "发电机练习模式频率的说明。",
  "50901.null.hoymilesSerialNumber.desc": "Hoymiles序列号的说明。",
  "50901.null.epsVoltageAbnormality.desc": "EPS电压异常的说明。",
  "50901.null.cmpssBiasCalculationError.desc": "CMPSS偏置计算错误的说明。",
  "50901.null.timedFrom2Minutes.desc": "定时2起-分的说明。",
  "50901.null.meterPhaseCReactivePower.desc": "电表C无功功率的说明。",
  "50901.null.timeOfUseTime2ChrgStartH.desc": "使用时间Time2ChrgStart-H的说明。",
  "50901.null.quietTime1EndH.desc": "待机时间1End-H的说明。",
  "50901.null.section4PeakStartHour1.desc": "section4峰值开始时间1-小时的说明。",
  "50901.null.section4PeakStartHour2.desc": "section4峰值开始时间2-小时的说明。",
  "50901.null.manualModeSwitch.desc": "手动模式开关的说明。",
  "50901.null.pvDailyYield.desc": "PV日发电量的说明。",
  "50901.null.clockSetting_weekday.desc": "时钟设置-weekday的说明。",
  "50901.null.forceChargeSoc.desc": "强制充电SOC的说明。",
  "50901.null.epsRelayProtection.desc": "EPS继电器保护的说明。",
  "50901.null.section1ValleyStopMinute1.desc": "section1 低谷停止时间1- 分钟的说明。",
  "50901.null.section1ValleyStopMinute2.desc": "section1低估停止时间2-分钟的说明。",
  "50901.null.evCharger2Fault.desc": "充电桩2故障的说明。",
  "50901.null.pv1Voltage.desc": "PV1电压的说明。",
  "50901.null.hpTime1WeekRange7.desc": "HPTime1周范围7的说明。",
  "50901.null.hpTime1WeekRange5.desc": "HPTime1周范围5的说明。",
  "50901.null.economicModeSoc.desc": "经济模式SOC的说明。",
  "50901.null.hpTime1WeekRange6.desc": "HPTime1周范围6的说明。",
  "50901.null.hpTime1WeekRange3.desc": "HPTime1周范围3的说明。",
  "50901.null.timeOfUseTime3ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.null.dspSafCommunicationAbnormality.desc": "​DSP安全通信异常​的说明。",
  "50901.null.hpTime1WeekRange4.desc": "HPTime1周范围4的说明。",
  "50901.null.hpTime1WeekRange1.desc": "HPTime1周范围1的说明。",
  "50901.null.hpTime1WeekRange2.desc": "HPTime1周范围2的说明。",
  "50901.null.packSoc.desc": "电池包SOC的说明。",
  "50901.null.hpTime1EndMonth.desc": "HPTime1结束-\n月的说明。",
  "50901.null.ssid.desc": "SSID(wifi名称)的说明。",
  "50901.null.invAcFrequency.desc": "逆变器交流侧输出频率的说明。",
  "50901.null.pv4Power.desc": "PV4功率的说明。",
  "50901.null.dspVersionMainUVersion.desc": "DSP版本(主U版本)的说明。",
  "50901.null.timeOfUseTime1ChrgStartH.desc": "使用时间Time1ChrgStart-H的说明。",
  "50901.null.interruptOverflow.desc": "中断溢出的说明。",
  "50901.null.hpTime4EndDay.desc": "HPTime4结束-天的说明。",
  "50901.null.packSoh.desc": "电池包SOH的说明。",
  "50901.null.ambientTemperatureSampling.desc": "环境温度采样的说明。",
  "50901.null.generatorConnectionStatus.desc": "发电机连接状态的说明。",
  "50901.null.timeOfUseTime8ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.null.batteryPowerWholeSystem.desc": "电池总功率（整个系统）的说明。",
  "50901.null.batteryBalancing.desc": "电池平衡的说明。",
  "50901.null.section3ValleyStartHour1.desc": "section3低谷开始时间1-小时的说明。",
  "50901.null.pvMeterSerialNumber.desc": "光伏表序列号的说明。",
  "50901.null.section3ValleyStartHour2.desc": "section3低估开始时间2-小时的说明。",
  "50901.null.batteryCurrent.desc": "电池电流的说明。",
  "50901.null.gridOverfrequency.desc": "电网过频的说明。",
  "50901.null.section4PeakStopMinute2.desc": "section4峰值停止时间2-分钟的说明。",
  "50901.null.timeOfUseTime5DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.null.timed1EndHour_2.desc": "定时1终_2-时的说明。",
  "50901.null.section4PeakStopMinute1.desc": "section4峰值停止时间1-分钟的说明。",
  "50901.null.timed1EndHour_3.desc": "时间段1终-时的说明。",
  "50901.null.insulationFault.desc": "绝缘故障的说明。",
  "50901.null.evCharger2CommunicationAbnormality.desc": "电动汽车充电桩2通信异常的说明。",
  "50901.null.dischargeLowTemperatureAlarm.desc": "放电低温报警的说明。",
  "50901.null.timeOfUseTime8ChrgEndH.desc": "使用时间Time8Chrg结束-H的说明。",
  "50901.null.timeOfUseTime7DischrgStartMin.desc": "使用时间Time7DischrgStart-Min的说明。",
  "50901.null.pv2RealTimePower.desc": "PV2实时功率的说明。",
  "50901.null.loadPowerWholeSystem.desc": "负载总功率（整个系统）的说明。",
  "50901.null.batteryDailyChargeEnergy.desc": "电池日充电量的说明。",
  "50901.null.gridOffVoltageDcOffsetOutOfRange.desc": "离网电压直流偏置超限的说明。",
  "50901.null.timeOfUseTime1DischrgEndH.desc": "使用时间Time1DischrgEnd-H的说明。",
  "50901.null.section1WeekRange2.desc": "section1周范围2的说明。",
  "50901.null.ambientTemperatureThreshold.desc": "环境温度阈值的说明。",
  "50901.null.section1WeekRange1.desc": "section1周范围1的说明。",
  "50901.null.networkingType.desc": "联网类型的说明。",
  "50901.null.invRunningtime.desc": "INV运行时长\n禾迈：机器正常运行的时间的说明。",
  "50901.null.hpTime3StartDay.desc": "HPTime3开始-天的说明。",
  "50901.null.firmwareCrc.desc": "固件CRC的说明。",
  "50901.null.timeOfUseTime3ChrgEndH.desc": "使用时间Time3Chrg结束-H的说明。",
  "50901.null.timeOfUseTime7ChrgStopSoc.desc": "放电截止容量的说明。",
  "50901.null.hpMinRunTimeLmtOfOnce.desc": "HP最小运行时间限制的说明。",
  "50901.null.hpMaxFeedbackPower.desc": "HP最大反馈功率的说明。",
  "50901.null.batteryModuleNum.desc": "电池串数（模块单体电芯串数）的说明。",
  "50901.null.restoreDefault.desc": "恢复默认值的说明。",
  "50901.null.hpTime3WeekRange3.desc": "HPTime2周范围3的说明。",
  "50901.null.hpTime3WeekRange4.desc": "HPTime2周范围4的说明。",
  "50901.null.hpTime3WeekRange5.desc": "HPTime2周范围5的说明。",
  "50901.null.chargeTimeStartH.desc": "发电机控制-充电开始时间-H的说明。",
  "50901.null.hpTime3WeekRange6.desc": "HPTime2周范围6的说明。",
  "50901.null.hpTime3WeekRange7.desc": "HPTime2周范围7的说明。",
  "50901.null.firmwareStartAddressLow.desc": "固件起始地址(低)的说明。",
  "50901.null.timeOfUseTime4ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.null.pvMeterConnectionStatus.desc": "PV电表连接状态的说明。",
  "50901.null.inverterCanCommunicationFailed.desc": "逆变器CAN通信失败的说明。",
  "50901.null.gridVoltageAbnormality.desc": "电网电压异常的说明。",
  "50901.null.absorptionVoltage.desc": "吸收电压的说明。",
  "50901.null.timeOfUseTime6DischrgStartMin.desc": "使用时间Time6DischrgStart-Min的说明。",
  "50901.null.dtu5Rs485CommunicationAbnormality.desc": " DTU5 RS485 通信异常的说明。",
  "50901.null.phaseBOfInverterSideVoltage.desc": "逆变器交流侧B相电压的说明。",
  "50901.null.gridReactivePower.desc": "电网侧无功功率的说明。",
  "50901.null.section3PeakStartHour1.desc": "section3峰值开始时间1-小时的说明。",
  "50901.null.commAddress1Master.desc": "通信地址1(主)的说明。",
  "50901.null.section3PeakStartHour2.desc": "section3峰值开始时间2-小时的说明。",
  "50901.null.hpTime3WeekRange1.desc": "HPTime3周范围1的说明。",
  "50901.null.hpTime1EndDay.desc": "HPTime1结束-天的说明。",
  "50901.null.gridUndervoltage.desc": "电网欠压的说明。",
  "50901.null.hpTime3WeekRange2.desc": "HPTime2周范围2的说明。",
  "50901.null.batActivate.desc": "电池激活的说明。",
  "50901.null.section1StartDay.desc": "section1开始天的说明。",
  "50901.null.totalGridToLoadEnergy.desc": "累计-电网流向负载的能量的说明。",
  "50901.null.section4StopMonth.desc": "section4停止月的说明。",
  "50901.null.versionMismatch.desc": "版本不匹配的说明。",
  "50901.null.timeOfUseTime3DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.null.section1PeakStopHour1.desc": "section1 峰值停止时间1-小时的说明。",
  "50901.null.section1PeakStopHour2.desc": "section1峰值停止时间2-小时的说明。",
  "50901.null.shutDown.desc": "系统关机的说明。",
  "50901.null.firmwareBuildTimeYearMonth.desc": "固件构建时间(年&月)的说明。",
  "50901.null.hpTime2WeekRange3.desc": "HPTime2周范围3的说明。",
  "50901.null.genPracticeModeWeek.desc": "发电机练习模式启动时间的说明。",
  "50901.null.hpTime2WeekRange2.desc": "HPTime2周范围2的说明。",
  "50901.null.overtemperatureAlarm.desc": "过热报警的说明。",
  "50901.null.hpTime2WeekRange1.desc": "HPTime2周范围1的说明。",
  "50901.null.hpTime2WeekRange7.desc": "HPTime2周范围7的说明。",
  "50901.null.timeOfUseTime5ChrgPower.desc": "充电功率的说明。",
  "50901.null.hpTime2WeekRange6.desc": "HPTime2周范围6的说明。",
  "50901.null.hpTime2WeekRange5.desc": "HPTime2周范围5的说明。",
  "50901.null.section3WeekRange1.desc": "section3周范围1的说明。",
  "50901.null.batterytotCap.desc": "电池装机总容量的说明。",
  "50901.null.hpTime2WeekRange4.desc": "HPTime2周范围4的说明。",
  "50901.null.section3WeekRange2.desc": "section3周范围2的说明。",
  "50901.null.invRatedPower.desc": "额定功率的说明。",
  "50901.null.maxCellSoc.desc": "最高单体SOC的说明。",
  "50901.null.overTemperature.desc": "​​ 过温的说明。",
  "50901.null.timeOfUseTime8ChrgEndMin.desc": "使用时间Time8Chrg结束-分钟的说明。",
  "50901.null.quietTime1EndMin.desc": "待机时间1结束分钟的说明。",
  "50901.null.meterPhaseCActivePower.desc": "电表C有功功率的说明。",
  "50901.null.timeOfUseTime1DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.null.generatorOpenBatteryCapacity.desc": "柴发开启电池容量的说明。",
  "50901.null.gridMeterSerialNumber.desc": "网侧电表序列号的说明。",
  "50901.null.MaxChargeCurrent.desc": "最大充电电流的说明。",
  "50901.null.chargeHighTemperatureAlarm.desc": "充电高温报警的说明。",
  "50901.null.hpTime3EndDay.desc": "HPTime3结束-天的说明。",
  "50901.null.timeOfUseTime8DischrgEndH.desc": "使用时间Time8DischrgEnd-H的说明。",
  "50901.null.hpWorkTimeParts.desc": "HP工作时间的说明。",
  "50901.null.phaseBOfInverterActivePower.desc": "逆变器交流侧B相功率的说明。",
  "50901.null.pvMeterCurrentA.desc": "PV电表A相电流的说明。",
  "50901.null.section1PeakStartHour2.desc": "section1峰值开始时间2-小时的说明。",
  "50901.null.section1PeakStartHour1.desc": "section1 峰值开始时间1-小时的说明。",
  "50901.null.section2WeekRange1.desc": "section2周范围1的说明。",
  "50901.null.section2WeekRange2.desc": "section2周范围2的说明。",
  "50901.null.pvMeterCurrentC.desc": "PV电表C相电流的说明。",
  "50901.null.pvMeterCurrentB.desc": "PV电表B相电流的说明。",
  "50901.null.quietTime2EndMin.desc": "待机时间2结束-Min的说明。",
  "50901.null.section1StopDay.desc": "section1停止日的说明。",
  "50901.null.pv2Power.desc": "PV2功率的说明。",
  "50901.null.dailyImportEnergyFromGrid.desc": "日买电量的说明。",
  "50901.null.timeOfUseTime7DischrgStartH.desc": "使用时间Time7DischrgStart-H的说明。",
  "50901.null.pv3RealTimePower.desc": "PV3实时功率的说明。",
  "50901.null.timeOfUseTime5DischrgEndMin.desc": "使用时间Time5Dischrg结束-分钟的说明。",
  "50901.null.generatorPower.desc": "发电机功率的说明。",
  "50901.null.timeOfUseTime2DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.null.batteryMaxDischargePower.desc": "电池最大放电功率的说明。",
  "50901.null.section2PeakStartHour2.desc": "section2峰值开始时间2-小时的说明。",
  "50901.null.batteryModule.desc": "电池型号的说明。",
  "50901.null.section2PeakStartMinute2.desc": "section2峰值开始时间1-分钟的说明。",
  "50901.null.hpTime2EndDay.desc": "HPTime2结束-天的说明。",
  "50901.null.powerLimitForGridConnectionFeederNetwork.desc": "并网点/馈网功率限值的说明。",
  "50901.null.timeOfUseTime4DischrgPower.desc": "放电功率的说明。",
  "50901.null.section2PeakStartMinute1.desc": "section2峰值开始时间1-分钟的说明。",
  "50901.null.section1StopMonth.desc": "section1停止月的说明。",
  "50901.null.section2PeakStartHour1.desc": "section2峰值开始时间1-小时的说明。",
  "50901.null.数据分析_energy_daily.tag": "energy_daily",
  "50901.null.数据分析_energy_flow_daily.tag": "energy_flow_daily",
  "50901.null.数据分析_battery_power.tag": "battery_power",
  "50901.null.数据分析_grid_power.tag": "grid_power",
  "50901.null.数据分析_battery_cell_status.tag": "battery_cell_status",
  "50901.null.数据分析_load_power.tag": "load_power",
  "50901.null.数据分析_grid_electrical.tag": "grid_electrical",
  "50901.null.数据分析_pv_temperature.tag": "pv_temperature",
  "50901.null.数据分析_energy_cumulative.tag": "energy_cumulative",
  "50901.null.数据分析_generator_power.tag": "generator_power",
  "50901.null.数据分析_meter_ac_power_quality.tag": "meter_ac_power_quality",
  "50901.null.数据分析_inverter_temperature.tag": "inverter_temperature",
  "50901.null.数据分析_ambient_temperature.tag": "ambient_temperature",
  "50901.null.数据分析_energy_flow_cumulative.tag": "energy_flow_cumulative",
  "50901.null.数据分析_comm_status.tag": "comm_status",
  "50901.null.数据分析_generator_electrical.tag": "generator_electrical",
  "50901.null.数据分析_meter_ac_electrical.tag": "meter_ac_electrical",
  "50901.null.数据分析_meter_pv_power.tag": "meter_pv_power",
  "50901.null.数据分析_inverter_ac_output.tag": "inverter_ac_output",
  "50901.null.数据分析_pv_power.tag": "pv_power",
  "50901.null.数据分析_power_flow.tag": "power_flow",
  "50901.null.数据分析_internal_voltage.tag": "internal_voltage",
  "50901.null.数据分析_pv_electrical.tag": "pv_electrical",
  "50901.null.数据分析_grid_power_quality.tag": "grid_power_quality",
  "50901.null.数据分析_meter_ac_power.tag": "meter_ac_power",
  "50901.null.数据分析_eps_power.tag": "eps_power",
  "50901.null.数据分析_battery_electrical.tag": "battery_electrical",
  "50901.null.数据分析_eps_electrical.tag": "eps_electrical",
  "50901.null.数据分析_meter_pv_electrical.tag": "meter_pv_electrical",
  "50901.null.数据分析_fan_speed.tag": "fan_speed",
  "50901.null.数据分析_battery_status.tag": "battery_status",
  "50901.null.数据分析_grid_temperature.tag": "grid_temperature",
  "50901.warning.sustainedNegativeLoad.00": "disable",
  "50901.warning.sustainedNegativeLoad.01": "enable",
  "50901.fault.microelectronicFault.00": "不使能",
  "50901.fault.microelectronicFault.01": "使能",
  "50901.real_time.batteryWorkingStatus.00": "待机",
  "50901.real_time.batteryWorkingStatus.01": "充电",
  "50901.real_time.batteryWorkingStatus.02": "放电",
  "50901.fault.tenMinuteOvervoltage.00": "不使能",
  "50901.fault.tenMinuteOvervoltage.01": "使能",
  "50901.fault.gridPortOvercurrent.00": "不使能",
  "50901.fault.gridPortOvercurrent.01": "使能",
  "50901.fault.gridRelayProtection.00": "不使能",
  "50901.fault.gridRelayProtection.01": "使能",
  "50901.fault.twelveVoltPowerSupplyFault.00": "不使能",
  "50901.fault.twelveVoltPowerSupplyFault.01": "使能",
  "50901.fault.lineToEarthFault.00": "不使能",
  "50901.fault.lineToEarthFault.01": "使能",
  "50901.warning.dtsCommunicationAbnormality.00": "disable",
  "50901.warning.dtsCommunicationAbnormality.01": "enable",
  "50901.ctrl_xitongjichupeizhi.hpBattSocDetectMode.00": "否",
  "50901.ctrl_xitongjichupeizhi.hpBattSocDetectMode.01": "是",
  "50901.warning.evCharger1CommunicationAbnormality.00": "disable",
  "50901.warning.evCharger1CommunicationAbnormality.01": "enable",
  "50901.real_time.parallelNetworking.00": "无效",
  "50901.real_time.parallelNetworking.01": "组网中",
  "50901.real_time.parallelNetworking.02": "解散组网",
  "50901.ctrl_xitongjichupeizhi.pvIslandModeEn.00": "否",
  "50901.ctrl_xitongjichupeizhi.pvIslandModeEn.01": "是",
  "50901.ctrl_xitongjichupeizhi.bypassDisable.00": "否",
  "50901.ctrl_xitongjichupeizhi.bypassDisable.01": "是",
  "50901.fault.reconnectionFailed.00": "不使能",
  "50901.fault.reconnectionFailed.01": "使能",
  "50901.fault.meterWiringAbnormality.00": "不使能",
  "50901.fault.meterWiringAbnormality.01": "使能",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.00": "不使能",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.01": "使能",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange2.00": "disable",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange2.01": "enable",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange1.00": "disable",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange1.01": "enable",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange4.00": "disable",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange4.01": "enable",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange3.00": "disable",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange3.01": "enable",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange6.00": "disable",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange6.01": "enable",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange5.00": "disable",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange5.01": "enable",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange7.00": "disable",
  "50901.ctrl_gaojigongneng.dayOfTheWeekRange7.01": "enable",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange6.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange6.01": "enable",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange7.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange7.01": "enable",
  "50901.fault.rcdFault.00": "不使能",
  "50901.fault.rcdFault.01": "使能",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange2.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange2.01": "enable",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange3.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange3.01": "enable",
  "50901.fault.gridOvervoltage.00": "不使能",
  "50901.fault.gridOvervoltage.01": "使能",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange4.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange4.01": "enable",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange5.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange5.01": "enable",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange1.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime4WeekRange1.01": "enable",
  "50901.fault.fanFault.00": "不使能",
  "50901.fault.fanFault.01": "使能",
  "50901.real_time.masterSlave.00": "单机",
  "50901.real_time.masterSlave.01": "主机",
  "50901.real_time.masterSlave.02": "从机",
  "50901.fault.loadRelayAFault.00": "不使能",
  "50901.fault.loadRelayAFault.01": "使能",
  "50901.fault.canCommunicationTimeout.00": "disable",
  "50901.fault.canCommunicationTimeout.01": "enable",
  "50901.fault.genPortOvercurrent.00": "不使能",
  "50901.fault.genPortOvercurrent.01": "使能",
  "50901.warning.dtu4Rs485CommunicationAbnormality.00": "disable",
  "50901.warning.dtu4Rs485CommunicationAbnormality.01": "enable",
  "50901.fault.gridMeter.00": "不使能",
  "50901.fault.gridMeter.01": "使能",
  "50901.fault.neutralWireToEarthFault.00": "不使能",
  "50901.fault.neutralWireToEarthFault.01": "使能",
  "50901.fault.armCommunicationFault.00": "不使能",
  "50901.fault.armCommunicationFault.01": "使能",
  "50901.warning.inputOvervoltageAlarm.00": "不使能",
  "50901.warning.inputOvervoltageAlarm.01": "使能",
  "50901.warning.batteryLowVoltageAlarm.00": "不使能",
  "50901.warning.batteryLowVoltageAlarm.01": "使能",
  "50901.ctrl_xitongjichupeizhi.hpWorkMode.00": "否",
  "50901.ctrl_xitongjichupeizhi.hpWorkMode.01": "是",
  "50901.fault.flashCommunicationFault.00": "不使能",
  "50901.fault.flashCommunicationFault.01": "使能",
  "50901.fault.lowBatteryEnergy.00": "disable",
  "50901.fault.lowBatteryEnergy.01": "enable",
  "50901.real_time.workStatus.00": "电源初始化",
  "50901.real_time.workStatus.01": "待机模式",
  "50901.real_time.workStatus.02": "并网测试",
  "50901.real_time.workStatus.03": "并网模式",
  "50901.real_time.workStatus.04": "故障模式",
  "50901.real_time.workStatus.05": "离网模式",
  "50901.real_time.workStatus.06": "旁路模式",
  "50901.warning.dtu3Rs485CommunicationAbnormality.00": "disable",
  "50901.warning.dtu3Rs485CommunicationAbnormality.01": "enable",
  "50901.warning.bmsCanCommunicationAbnormality.00": "disable",
  "50901.warning.bmsCanCommunicationAbnormality.01": "enable",
  "50901.real_time.relayStatus.00": "KM1馈送",
  "50901.real_time.relayStatus.01": "KM1馈送",
  "50901.real_time.relayStatus.02": "发电机A馈送",
  "50901.real_time.relayStatus.03": "发电机A馈送",
  "50901.real_time.relayStatus.04": "发电机B馈送",
  "50901.real_time.relayStatus.05": "发电机B馈送",
  "50901.real_time.relayStatus.06": "发电机AB馈送",
  "50901.real_time.relayStatus.07": "发电机AB馈送",
  "50901.real_time.relayStatus.08": "重要负载A馈送",
  "50901.real_time.relayStatus.09": "重要负载A馈送",
  "50901.warning.gridMeterTypeError.00": "disable",
  "50901.warning.gridMeterTypeError.01": "enable",
  "50901.fault.testFault.00": "disable",
  "50901.fault.testFault.01": "enable",
  "50901.ctrl_gaojigongneng.weekRange5.00": "disable",
  "50901.ctrl_gaojigongneng.weekRange5.01": "enable",
  "50901.fault.pvPortOvercurrent.00": "不使能",
  "50901.fault.pvPortOvercurrent.01": "使能",
  "50901.ctrl_gaojigongneng.weekRange6.00": "disable",
  "50901.ctrl_gaojigongneng.weekRange6.01": "enable",
  "50901.ctrl_gaojigongneng.weekRange7.00": "disable",
  "50901.ctrl_gaojigongneng.weekRange7.01": "enable",
  "50901.ctrl_gaojigongneng.weekRange1.00": "enable",
  "50901.ctrl_gaojigongneng.weekRange1.01": "enable",
  "50901.ctrl_gaojigongneng.weekRange2.00": "disable",
  "50901.ctrl_gaojigongneng.weekRange2.01": "enable",
  "50901.ctrl_gaojigongneng.weekRange3.00": "disable",
  "50901.ctrl_gaojigongneng.weekRange3.01": "enable",
  "50901.ctrl_gaojigongneng.weekRange4.00": "disable",
  "50901.ctrl_gaojigongneng.weekRange4.01": "enable",
  "50901.fault.gridPowerOutage.00": "不使能",
  "50901.fault.gridPowerOutage.01": "使能",
  "50901.fault.driveAbnormality.00": "不使能",
  "50901.fault.driveAbnormality.01": "使能",
  "50901.fault.frequencyVariationRateOutOfRange.00": "不使能",
  "50901.fault.frequencyVariationRateOutOfRange.01": "使能",
  "50901.fault.arcFault.00": "不使能",
  "50901.fault.arcFault.01": "使能",
  "50901.fault.neutralWireNotConnected.00": "不使能",
  "50901.fault.neutralWireNotConnected.01": "使能",
  "50901.fault.hardwareProtection.00": "disable",
  "50901.fault.hardwareProtection.01": "enable",
  "50901.ctrl_dianchiguanli.BatteryModel.01": "Pylon LV",
  "50901.ctrl_dianchiguanli.BatteryModel.02": "Pylon HV",
  "50901.ctrl_dianchiguanli.BatteryModel.03": "Dyness LV",
  "50901.ctrl_dianchiguanli.BatteryModel.04": "Dyness HV",
  "50901.ctrl_dianchiguanli.BatteryModel.05": "Sunwoda LV",
  "50901.ctrl_dianchiguanli.BatteryModel.06": "Uz LV",
  "50901.ctrl_dianchiguanli.BatteryModel.07": "Soluna HV",
  "50901.ctrl_dianchiguanli.BatteryModel.08": "Soluna LV",
  "50901.ctrl_dianchiguanli.BatteryModel.09": "Steltec LV",
  "50901.fault.rcdSelfTestFault.00": "不使能",
  "50901.fault.rcdSelfTestFault.01": "使能",
  "50901.warning.dtu1Rs485CommunicationAbnormality.00": "disable",
  "50901.warning.dtu1Rs485CommunicationAbnormality.01": "enable",
  "50901.fault.pvRelayAbFault.00": "不使能",
  "50901.fault.pvRelayAbFault.01": "使能",
  "50901.fault.preSynchronizationFailed.00": "不使能",
  "50901.fault.preSynchronizationFailed.01": "使能",
  "50901.warning.pvMeterCommunicationAbnormality.00": "disable",
  "50901.warning.pvMeterCommunicationAbnormality.01": "enable",
  "50901.ctrl_xitongjichupeizhi.restartSystem.00": "否",
  "50901.ctrl_xitongjichupeizhi.restartSystem.01": "是",
  "50901.fault.pvVoltageExceedingBusVoltage.00": "不使能",
  "50901.fault.pvVoltageExceedingBusVoltage.01": "使能",
  "50901.fault.smartloadPortOvercurrent.00": "不使能",
  "50901.fault.smartloadPortOvercurrent.01": "使能",
  "50901.fault.genAbnormality.00": "不使能",
  "50901.fault.genAbnormality.01": "使能",
  "50901.warning.fanSpeedAbnormality.00": "disable",
  "50901.warning.fanSpeedAbnormality.01": "enable",
  "50901.fault.epsOverload.00": "不使能",
  "50901.fault.epsOverload.01": "使能",
  "50901.ctrl_xitongjichupeizhi.equalizationEnable.00": "否",
  "50901.ctrl_xitongjichupeizhi.equalizationEnable.01": "是",
  "50901.ctrl_xitongjichupeizhi.meterConfiguration.00": "无电表类型",
  "50901.ctrl_xitongjichupeizhi.meterConfiguration.01": "配置电网电表",
  "50901.fault.gridUnderfrequency.00": "不使能",
  "50901.fault.gridUnderfrequency.01": "使能",
  "50901.warning.lowDtuVersion.00": "disable",
  "50901.warning.lowDtuVersion.01": "enable",
  "50901.fault.loadRelayBFault.00": "不使能",
  "50901.fault.loadRelayBFault.01": "使能",
  "50901.fault.pvFault.00": "不使能",
  "50901.fault.pvFault.01": "使能",
  "50901.warning.batteryHighVoltageAlarm.00": "不使能",
  "50901.warning.batteryHighVoltageAlarm.01": "使能",
  "50901.ctrl_gaojigongneng.smart_weekRange25.00": "disable",
  "50901.ctrl_gaojigongneng.smart_weekRange25.01": "enable",
  "50901.fault.genRelayAFault.00": "不使能",
  "50901.fault.genRelayAFault.01": "使能",
  "50901.ctrl_gaojigongneng.smart_weekRange26.00": "disable",
  "50901.ctrl_gaojigongneng.smart_weekRange26.01": "enable",
  "50901.real_time.batteryType_04.00": "无电池",
  "50901.real_time.batteryType_04.01": "锂电池",
  "50901.real_time.batteryType_04.02": "铅酸电池",
  "50901.ctrl_gaojigongneng.smart_weekRange23.00": "disable",
  "50901.ctrl_gaojigongneng.smart_weekRange23.01": "enable",
  "50901.ctrl_gaojigongneng.smart_weekRange24.00": "disable",
  "50901.ctrl_gaojigongneng.smart_weekRange24.01": "enable",
  "50901.ctrl_gaojigongneng.smart_weekRange21.00": "disable",
  "50901.ctrl_gaojigongneng.smart_weekRange21.01": "enable",
  "50901.ctrl_gaojigongneng.smart_weekRange22.00": "disable",
  "50901.ctrl_gaojigongneng.smart_weekRange22.01": "enable",
  "50901.fault.gridCurrentDcOffsetOutOfRange.00": "不使能",
  "50901.fault.gridCurrentDcOffsetOutOfRange.01": "使能",
  "50901.ctrl_gaojigongneng.smart_weekRange20.00": "disable",
  "50901.ctrl_gaojigongneng.smart_weekRange20.01": "enable",
  "50901.ctrl_xitongjichupeizhi.genPracticeModeEn.00": "否",
  "50901.ctrl_xitongjichupeizhi.genPracticeModeEn.01": "是",
  "50901.ctrl_dianchiguanli.CfgMultPcsBMSFlag.00": "disable",
  "50901.ctrl_dianchiguanli.CfgMultPcsBMSFlag.01": "enable",
  "50901.fault.inverterCommunicationFailed.00": "不使能",
  "50901.fault.inverterCommunicationFailed.01": "使能",
  "50901.warning.gridMeterCommunicationAbnormality.00": "disable",
  "50901.warning.gridMeterCommunicationAbnormality.01": "enable",
  "50901.warning.masterSlaveCommunicationAbnormality.00": "disable",
  "50901.warning.masterSlaveCommunicationAbnormality.01": "enable",
  "50901.warning.batteryFault.00": "disable",
  "50901.warning.batteryFault.01": "enable",
  "50901.warning.pvMeterTypeError.00": "disable",
  "50901.warning.pvMeterTypeError.01": "enable",
  "50901.fault.lowAmbientTemperature.00": "不使能",
  "50901.fault.lowAmbientTemperature.01": "使能",
  "50901.real_time.batteryConnectionStatus.00": "否",
  "50901.real_time.batteryConnectionStatus.01": "是",
  "50901.warning.hmidMachineFault.00": "disable",
  "50901.warning.hmidMachineFault.01": "enable",
  "50901.fault.machineTypeMismatch.00": "不使能",
  "50901.fault.machineTypeMismatch.01": "使能",
  "50901.warning.evCharger1Fault.00": "disable",
  "50901.warning.evCharger1Fault.01": "enable",
  "50901.fault.busbarAbnormality.00": "不使能",
  "50901.fault.busbarAbnormality.01": "使能",
  "50901.warning.batteryPackChargeHighVoltageAlarm.00": "不使能",
  "50901.warning.batteryPackChargeHighVoltageAlarm.01": "使能",
  "50901.warning.chargeLowTemperatureAlarm.00": "不使能",
  "50901.warning.chargeLowTemperatureAlarm.01": "使能",
  "50901.fault.threePointThreeVoltPowerSupplyFault.00": "不使能",
  "50901.fault.threePointThreeVoltPowerSupplyFault.01": "使能",
  "50901.warning.batteryCapacityAbnormality.00": "disable",
  "50901.warning.batteryCapacityAbnormality.01": "enable",
  "50901.fault.emergencyStopSwitchStatus.00": "不使能",
  "50901.fault.emergencyStopSwitchStatus.01": "使能",
  "50901.ctrl_xitongjichupeizhi.loadControlMode.01": "手动",
  "50901.ctrl_xitongjichupeizhi.loadControlMode.02": "时间模式",
  "50901.ctrl_xitongjichupeizhi.loadControlMode.03": "智能负载",
  "50901.ctrl_xitongjichupeizhi.loadControlMode.04": "离网智能负载",
  "50901.ctrl_xitongjichupeizhi.loadControlMode.05": "电动汽车充电器",
  "50901.ctrl_xitongjichupeizhi.workMode.00": "自发自用",
  "50901.ctrl_xitongjichupeizhi.workMode.01": "经济模式",
  "50901.ctrl_xitongjichupeizhi.workMode.02": "备电模式",
  "50901.ctrl_xitongjichupeizhi.workMode.03": "离网模式",
  "50901.ctrl_xitongjichupeizhi.workMode.04": "强充模式",
  "50901.ctrl_xitongjichupeizhi.workMode.05": "强放模式",
  "50901.fault.genRelayBFault.00": "不使能",
  "50901.fault.genRelayBFault.01": "使能",
  "50901.real_time.cfgMultPcsBmsFlag.00": "否",
  "50901.real_time.cfgMultPcsBmsFlag.01": "是",
  "50901.warning.batteryForceChargeRequest.00": "disable",
  "50901.warning.batteryForceChargeRequest.01": "enable",
  "50901.fault.arcSelfTestFault.00": "不使能",
  "50901.fault.arcSelfTestFault.01": "使能",
  "50901.fault.e2rpomFault.00": "不使能",
  "50901.fault.e2rpomFault.01": "使能",
  "50901.ctrl_xitongjichupeizhi.materType.02": "正泰单相",
  "50901.ctrl_xitongjichupeizhi.materType.03": "正泰裂相",
  "50901.ctrl_xitongjichupeizhi.materType.05": "计量模块",
  "50901.ctrl_xitongjichupeizhi.materType.06": "安科瑞单路",
  "50901.ctrl_xitongjichupeizhi.materType.07": "安科瑞双路",
  "50901.fault.wiringAbnormality.00": "不使能",
  "50901.fault.wiringAbnormality.01": "使能",
  "50901.warning.hmidCommunicationAbnormality.00": "disable",
  "50901.warning.hmidCommunicationAbnormality.01": "enable",
  "50901.ctrl_dianwangjiaohu.section4WeekRange1.00": "枚举值0的含义",
  "50901.ctrl_dianwangjiaohu.section4WeekRange1.01": "枚举值2的含义",
  "50901.ctrl_xitongjichupeizhi.epsMode.00": "禁用",
  "50901.ctrl_xitongjichupeizhi.epsMode.01": "应急电源",
  "50901.ctrl_xitongjichupeizhi.epsMode.02": "不间断电源",
  "50901.ctrl_dianwangjiaohu.section4WeekRange2.00": "枚举值0的含义",
  "50901.ctrl_dianwangjiaohu.section4WeekRange2.01": "枚举值1的含义",
  "50901.fault.samplingBiasAbnormality.00": "不使能",
  "50901.fault.samplingBiasAbnormality.01": "使能",
  "50901.warning.dischargeHighTemperatureAlarm.00": "不使能",
  "50901.warning.dischargeHighTemperatureAlarm.01": "使能",
  "50901.real_time.meterFlag.00": "offline",
  "50901.real_time.meterFlag.01": "online",
  "50901.warning.slaveWrongBatteryConnection.00": "disable",
  "50901.warning.slaveWrongBatteryConnection.01": "enable",
  "50901.warning.dtu2Rs485CommunicationAbnormality.00": "disable",
  "50901.warning.dtu2Rs485CommunicationAbnormality.01": "enable",
  "50901.fault.auxiliaryPowerAbnormality.00": "不使能",
  "50901.fault.auxiliaryPowerAbnormality.01": "使能",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.00": "功率限制解除，默认模式",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.01": "逆变器功率为0，脱网",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.02": "充电功率Pc=0,不脱网",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.03": "充电功率Pc<50%Pn 额度功率",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.04": "充电功率Pc<75%Pn 额度功率&&无功功率Q=Qmax ±4%",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.05": "充电功率Pc, 不做限制",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.06": "放电功率P=0,不脱网",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.07": "放电功率P<50%Pn额度功率",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.08": "放电功率P<75%Pn 额度功率&&Q= -Qmax±4%",
  "50901.real_time.drmStatusUsedInAustraliaGermanyAustria.09": "放电功率P 不做限制",
  "50901.fault.spiCommunicationFault.00": "不使能",
  "50901.fault.spiCommunicationFault.01": "使能",
  "50901.ctrl_xitongjichupeizhi.dryWorkingMode.00": "无",
  "50901.ctrl_xitongjichupeizhi.dryWorkingMode.01": "接地故障",
  "50901.ctrl_xitongjichupeizhi.dryWorkingMode.02": "敷在控制",
  "50901.ctrl_xitongjichupeizhi.dryWorkingMode.03": "放电机",
  "50901.fault.comparatorFault.00": "不使能",
  "50901.fault.comparatorFault.01": "使能",
  "50901.fault.pllLockFailed.00": "不使能",
  "50901.fault.pllLockFailed.01": "使能",
  "50901.ctrl_xitongjichupeizhi.generatorMode.00": "关",
  "50901.ctrl_xitongjichupeizhi.generatorMode.01": "手动",
  "50901.ctrl_xitongjichupeizhi.generatorMode.02": "自动",
  "50901.warning.dspPwrCommunicationAbnormality.00": "disable",
  "50901.warning.dspPwrCommunicationAbnormality.01": "enable",
  "50901.fault.kmRelayFault.00": "不使能",
  "50901.fault.kmRelayFault.01": "使能",
  "50901.fault.genOverload.00": "不使能",
  "50901.fault.genOverload.01": "使能",
  "50901.fault.fiveVoltPowerSupplyFault.00": "不使能",
  "50901.fault.fiveVoltPowerSupplyFault.01": "使能",
  "50901.fault.temperatureAbnormality.00": "不使能",
  "50901.fault.temperatureAbnormality.01": "使能",
  "50901.ctrl_dianwangjiaohu.genPracticeFreq.00": "无",
  "50901.ctrl_dianwangjiaohu.genPracticeFreq.01": "每周一次",
  "50901.ctrl_dianwangjiaohu.genPracticeFreq.02": "每2周一次",
  "50901.ctrl_dianwangjiaohu.genPracticeFreq.03": "每3周一次",
  "50901.ctrl_dianwangjiaohu.genPracticeFreq.04": "每4周一次",
  "50901.fault.epsVoltageAbnormality.00": "不使能",
  "50901.fault.epsVoltageAbnormality.01": "使能",
  "50901.fault.cmpssBiasCalculationError.00": "不使能",
  "50901.fault.cmpssBiasCalculationError.01": "使能",
  "50901.ctrl_xitongjichupeizhi.manualModeSwitch.00": "否",
  "50901.ctrl_xitongjichupeizhi.manualModeSwitch.01": "是",
  "50901.fault.epsRelayProtection.00": "不使能",
  "50901.fault.epsRelayProtection.01": "使能",
  "50901.warning.evCharger2Fault.00": "disable",
  "50901.warning.evCharger2Fault.01": "enable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange7.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange7.01": "enable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange5.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange5.01": "enable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange6.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange6.01": "enable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange3.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange3.01": "enable",
  "50901.warning.dspSafCommunicationAbnormality.00": "disable",
  "50901.warning.dspSafCommunicationAbnormality.01": "enable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange4.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange4.01": "enable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange1.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange1.01": "enable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange2.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime1WeekRange2.01": "enable",
  "50901.fault.interruptOverflow.00": "不使能",
  "50901.fault.interruptOverflow.01": "使能",
  "50901.fault.gridOverfrequency.00": "不使能",
  "50901.fault.gridOverfrequency.01": "使能",
  "50901.fault.insulationFault.00": "不使能",
  "50901.fault.insulationFault.01": "使能",
  "50901.warning.evCharger2CommunicationAbnormality.00": "disable",
  "50901.warning.evCharger2CommunicationAbnormality.01": "enable",
  "50901.warning.dischargeLowTemperatureAlarm.00": "不使能",
  "50901.warning.dischargeLowTemperatureAlarm.01": "使能",
  "50901.fault.gridOffVoltageDcOffsetOutOfRange.00": "不使能",
  "50901.fault.gridOffVoltageDcOffsetOutOfRange.01": "使能",
  "50901.ctrl_dianwangjiaohu.section1WeekRange2.00": "枚举值0的含义",
  "50901.ctrl_dianwangjiaohu.section1WeekRange2.01": "枚举值1的含义",
  "50901.ctrl_dianwangjiaohu.section1WeekRange1.00": "枚举值0的含义",
  "50901.ctrl_dianwangjiaohu.section1WeekRange1.01": "枚举值2的含义",
  "50901.ctrl_xitongjichupeizhi.networkingType.01": "WIFI",
  "50901.ctrl_xitongjichupeizhi.networkingType.02": "以太网",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange3.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange3.01": "enable",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange4.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange4.01": "enable",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange5.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange5.01": "enable",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange6.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange6.01": "enable",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange7.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange7.01": "enable",
  "50901.fault.inverterCanCommunicationFailed.00": "不使能",
  "50901.fault.inverterCanCommunicationFailed.01": "使能",
  "50901.fault.gridVoltageAbnormality.00": "不使能",
  "50901.fault.gridVoltageAbnormality.01": "使能",
  "50901.warning.dtu5Rs485CommunicationAbnormality.00": "disable",
  "50901.warning.dtu5Rs485CommunicationAbnormality.01": "enable",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange1.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange1.01": "enable",
  "50901.fault.gridUndervoltage.00": "不使能",
  "50901.fault.gridUndervoltage.01": "使能",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange2.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime3WeekRange2.01": "enable",
  "50901.fault.versionMismatch.00": "不使能",
  "50901.fault.versionMismatch.01": "使能",
  "50901.fault.shutDown.00": "不使能",
  "50901.fault.shutDown.01": "使能",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange3.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange3.01": "enable",
  "50901.ctrl_xitongjichupeizhi.genPracticeModeWeek.00": "枚举值0的含义",
  "50901.ctrl_xitongjichupeizhi.genPracticeModeWeek.01": "枚举值2的含义",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange2.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange2.01": "enable",
  "50901.fault.overtemperatureAlarm.00": "不使能",
  "50901.fault.overtemperatureAlarm.01": "使能",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange1.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange1.01": "enable",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange7.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange7.01": "enable",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange6.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange6.01": "enable",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange5.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange5.01": "enable",
  "50901.ctrl_dianwangjiaohu.section3WeekRange1.00": "枚举值0的含义",
  "50901.ctrl_dianwangjiaohu.section3WeekRange1.01": "枚举值2的含义",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange4.00": "disable",
  "50901.ctrl_gaojigongneng.hpTime2WeekRange4.01": "enable",
  "50901.ctrl_dianwangjiaohu.section3WeekRange2.00": "枚举值0的含义",
  "50901.ctrl_dianwangjiaohu.section3WeekRange2.01": "枚举值1的含义",
  "50901.fault.overTemperature.00": "不使能",
  "50901.fault.overTemperature.01": "使能",
  "50901.warning.chargeHighTemperatureAlarm.00": "不使能",
  "50901.warning.chargeHighTemperatureAlarm.01": "使能",
  "50901.real_time.batteryModule.01": "Pylon LV",
  "50901.real_time.batteryModule.02": "Pylon HV",
  "50901.real_time.batteryModule.03": "Dyness LV",
  "50901.real_time.batteryModule.04": "Dyness HV",
  "50901.real_time.batteryModule.05": "Sunwoda LV",
  "50901.real_time.batteryModule.06": "Uz LV",
  "50901.real_time.batteryModule.07": "Soluna HV",
  "50901.real_time.batteryModule.08": "Soluna LV",
  "50901.real_time.batteryModule.09": "Steltec LV",
  "50901.real_time.meterFrequency.desc": "电表频率的说明。",
  "50901.real_time.commAddress8Slave7.desc": "通信地址8(从7）的说明。",
  "50901.ctrl_dianwangjiaohu.section2ValleyStartHour2.desc": "section2低估开始时间2-小时的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime4DischrgEndH.desc": "使用时间Time4DischrgEnd-H的说明。",
  "50901.ctrl_gaojigongneng.hpTime1StartDay.desc": "HPTime1开始-天的说明。",
  "50901.warning.sustainedNegativeLoad.desc": "持续负负载的说明。",
  "50901.fault.microelectronicFault.desc": "微电子故障的说明。",
  "50901.ctrl_dianwangjiaohu.section2ValleyStartHour1.desc": "section2低估开始时间1-小时的说明。",
  "50901.real_time.gridBuyPower.desc": "累计买电量的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime1ChrgStartMin.desc": "使用时间Time1ChrgStart-\nMin\n的说明。",
  "50901.real_time.phaseAOfInverterSideCurrent.desc": "逆变器交流侧A相电流的说明。",
  "50901.real_time.packPower.desc": "电池包功率的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime2ChrgStartMin.desc": "使用时间Time2ChrgStart-\nMin\n的说明。",
  "50901.ctrl_dianchiguanli.batteryCapacity.desc": "BMS容量的说明。",
  "50901.ctrl_dianchiguanli.batteryHealing.desc": "电池恢复的说明。",
  "50901.real_time.batteryWorkingStatus.desc": "电池状态的说明。",
  "50901.fault.tenMinuteOvervoltage.desc": "10分钟过压的说明。",
  "50901.real_time.relaySupplyVoltageSampling.desc": "继电器电源电压采样的说明。",
  "50901.real_time.minCellSocCellId.desc": "最低单体SOC对应序号的说明。",
  "50901.ctrl_xitongjichupeizhi.gridRecoveryDelayTimeSeconds.desc": "电网恢复延迟时间（秒）的说明。",
  "50901.fault.gridPortOvercurrent.desc": "电网端口过流的说明。",
  "50901.fault.gridRelayProtection.desc": "电网继电器保护的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime8ChrgStartMin.desc": "使用时间Time8ChrgStart-\nMin\n的说明。",
  "50901.ctrl_dianwangjiaohu.powerLimitOfThePowerGrid.desc": "电网功率限制限值的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime5ChrgStartMin.desc": "使用时间Time5ChrgStart-\nMin\n的说明。",
  "50901.ctrl_gaojigongneng.timed2EndMinutes_3.desc": "时间段2终-分的说明。",
  "50901.ctrl_gaojigongneng.timeZone.desc": "时区的说明。",
  "50901.ctrl_gaojigongneng.timed2EndMinutes_2.desc": "定时2终_2-分的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime4ChrgStartMin.desc": "使用时间Time4ChrgStart-\nMin\n的说明。",
  "50901.fault.twelveVoltPowerSupplyFault.desc": "12V电源故障的说明。",
  "50901.fault.lineToEarthFault.desc": "对地故障（相线对地）的说明。",
  "50901.ctrl_dianwangjiaohu.section3StopMonth.desc": "section3停止月的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime3ChrgStartMin.desc": "使用时间Time3ChrgStart-\nMin\n的说明。",
  "50901.real_time.boardAmbientTemperatureThreshold.desc": "电路板环境温度阈值的说明。",
  "50901.real_time.gridPowerFactor.desc": "电网侧功率因数的说明。",
  "50901.real_time.pvPower.desc": "PV功率的说明。",
  "50901.warning.dtsCommunicationAbnormality.desc": "DTS 通信异常的说明。",
  "50901.ctrl_gaojigongneng.dfs.desc": "能力集的说明。",
  "50901.ctrl_dianwangjiaohu.temperatureCorrectionFactor.desc": "温度校正系数的说明。",
  "50901.real_time.minCellTemperature.desc": "最低单体温度的说明。",
  "50901.ctrl_gaojigongneng.hpMaxRunTimeOfOneDay.desc": "HP一天的最大运行时间的说明。",
  "50901.real_time.checkTime.desc": "设备时间的说明。",
  "50901.real_time.phaseBOfInverterSideCurrent.desc": "逆变器交流侧B相电流的说明。",
  "50901.real_time.maxCellTemperature.desc": "最高单体温度的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime6ChrgStartMin.desc": "使用时间Time6ChrgStart-\nMin\n的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime5ChrgEndMin.desc": "使用时间Time5Chrg结束-分钟的说明。",
  "50901.ctrl_dianwangjiaohu.hpDelayDetectTimeLmt.desc": "HP延迟检测时间限制的说明。",
  "50901.ctrl_dianwangjiaohu.section2StartMonth.desc": "section2开始月的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime7ChrgStartMin.desc": "使用时间Time7ChrgStart-\nMin\n的说明。",
  "50901.real_time.gridMeasurementOfRadiatorTemperature.desc": "电网测散热器温度的说明。",
  "50901.real_time.pv2Voltage.desc": "PV2电压的说明。",
  "50901.ctrl_gaojigongneng.hpTime4StartDay.desc": "HPTime4开始-天的说明。",
  "50901.ctrl_gaojigongneng.hpTime1StartMonth.desc": "HPTime1开始-月的说明。",
  "50901.real_time.3_3vAuxiliaryVoltageSampling.desc": "3.3V辅助电压采样的说明。",
  "50901.ctrl_dianchiguanli.batteryDischargePowerSettingValue.desc": "电池的放电功率设置值的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime1ChrgPower.desc": "充电功率的说明。",
  "50901.ctrl_dianchiguanli.forceDischargeSoc.desc": "强制放电SOC的说明。",
  "50901.warning.evCharger1CommunicationAbnormality.desc": "电动汽车充电桩1通信异常的说明。",
  "50901.fault.reconnectionFailed.desc": "重连失败的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime5ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.fault.meterWiringAbnormality.desc": "​​ 电表接线异常的说明。",
  "50901.warning.batteryPackDischargeLowVoltageAlarm.desc": "电池组放电欠压报警的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime7ChrgStartH.desc": "使用时间Time7ChrgStart-H的说明。",
  "50901.ctrl_dianwangjiaohu.equalizationVoltage.desc": "均衡电压的说明。",
  "50901.real_time.firmwareEndAddressHigh.desc": "固件结束地址(高)的说明。",
  "50901.real_time.maxCellVoltage.desc": "最高单体电压的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime7ChrgEndMin.desc": "使用时间Time7Chrg结束-分钟的说明。",
  "50901.ctrl_gaojigongneng.quietTime1StartMin.desc": "待机时间1开始-分钟的说明。",
  "50901.real_time.epsCurrentB.desc": "EPS侧B相电流的说明。",
  "50901.real_time.epsCurrentC.desc": "EPS侧C相电流的说明。",
  "50901.fault.rcdFault.desc": "漏电保护器故障的说明。",
  "50901.fault.gridOvervoltage.desc": "电网过压的说明。",
  "50901.ctrl_xitongjichupeizhi.clockSetting_year.desc": "时钟设置-year的说明。",
  "50901.ctrl_gaojigongneng.hpSupplyPower.desc": "HP电源的说明。",
  "50901.ctrl_gaojigongneng.timer2Hour_2.desc": "定时2起_2-时的说明。",
  "50901.ctrl_gaojigongneng.timer2Hour_3.desc": "时间段2起-时的说明。",
  "50901.ctrl_xitongjichupeizhi.ClockSetting.desc": "时钟设置的说明。",
  "50901.fault.fanFault.desc": "风扇故障的说明。",
  "50901.ctrl_dianchiguanli.GridChargingAllowed.desc": "是否允许电网充电的说明。",
  "50901.ctrl_dianchiguanli.maximumDischargeLimit.desc": "最大放电限制值的说明。",
  "50901.real_time.epsVoltageB.desc": "EPS侧B相电压的说明。",
  "50901.ctrl_gaojigongneng.absoluteTime.desc": "绝对时间的说明。",
  "50901.ctrl_dianwangjiaohu.peakMeterPower.desc": "峰值仪表功率的说明。",
  "50901.real_time.epsVoltageC.desc": "EPS侧C相电压的说明。",
  "50901.real_time.phaseCOfInverterSideVoltage.desc": "逆变器交流侧C相电压的说明。",
  "50901.real_time.machineSnMaster.desc": "机器SN(主)的说明。",
  "50901.real_time.pv4RealTimePower.desc": "PV4实时功率的说明。",
  "50901.ctrl_dianwangjiaohu.section1PeakStartMinute2.desc": "section1峰值开始时间2-分钟的说明。",
  "50901.ctrl_xitongjichupeizhi.threePhaseUnbalanceEnable.desc": "三相不平衡使能的说明。",
  "50901.ctrl_dianwangjiaohu.section1PeakStartMinute1.desc": "section1 峰值开始时间1-分钟的说明。",
  "50901.ctrl_gaojigongneng.quietTime2StartH.desc": "待机时间2开始-H的说明。",
  "50901.ctrl_dianwangjiaohu.section4PeakStartMinute1.desc": "section4峰值开始时间1-分钟的说明。",
  "50901.ctrl_xitongjichupeizhi.genPracticeModeStartMin.desc": "发电机练习模式启动时间-分钟的说明。",
  "50901.ctrl_dianwangjiaohu.floatVoltage.desc": "浮动电压的说明。",
  "50901.ctrl_gaojigongneng.replenishPower.desc": "功率补偿的说明。",
  "50901.fault.loadRelayAFault.desc": "负载A继电器故障的说明。",
  "50901.ctrl_gaojigongneng.hpStartPower.desc": "hp启动功率的说明。",
  "50901.ctrl_dianwangjiaohu.section4PeakStartMinute2.desc": "section4峰值开始时间2-分钟的说明。",
  "50901.ctrl_gaojigongneng.hpTime4EndMonth.desc": "HPTime4结束\n月的说明。",
  "50901.fault.canCommunicationTimeout.desc": "CAN通信超时的说明。",
  "50901.fault.genPortOvercurrent.desc": "发电机端口过流的说明。",
  "50901.ctrl_gaojigongneng.quietTime2EndH.desc": "待机时间2结束-H的说明。",
  "50901.warning.dtu4Rs485CommunicationAbnormality.desc": "DTU4 RS485 通信异常的说明。",
  "50901.fault.gridMeter.desc": "电网电表通信失败的说明。",
  "50901.ctrl_dianchiguanli.backupSoc.desc": "备用SOC的说明。",
  "50901.real_time.meterPhaseBReactivePower.desc": "电表B无功功率的说明。",
  "50901.real_time.pvMeterDailyYield.desc": "外部逆变器日发电量的说明。",
  "50901.fault.neutralWireToEarthFault.desc": "零线对地故障的说明。",
  "50901.real_time.dailyPvToBatteryEnegry.desc": "今日光伏流向电池的能量的说明。",
  "50901.ctrl_dianchiguanli.maximumDischargePower.desc": "最大放电功率的说明。",
  "50901.real_time.batteryDischargePower.desc": "电池累计放电量的说明。",
  "50901.ctrl_gaojigongneng.timed2EndHour.desc": "定时2终-时的说明。",
  "50901.ctrl_dianchiguanli.chargeTimeEndH.desc": "发电机控制-充电结束时间-H的说明。",
  "50901.ctrl_dianwangjiaohu.gridInPowerLimitationWhenValley.desc": "限制网络功率的说明。",
  "50901.fault.armCommunicationFault.desc": "ARM通信故障的说明。",
  "50901.warning.inputOvervoltageAlarm.desc": "输入过压报警的说明。",
  "50901.real_time.pvMeterVoltageB.desc": "PV电表B相电压的说明。",
  "50901.warning.batteryLowVoltageAlarm.desc": "电池欠压的说明。",
  "50901.real_time.pvMeterVoltageC.desc": "PV电表C相电压的说明。",
  "50901.real_time.dailyGridToLoadEnergy.desc": "本日电网流向负载的能量的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime2ChrgEndH.desc": "使用时间Time2Chrg结束-H的说明。",
  "50901.real_time.communicationStickSn.desc": "通讯棒SN的说明。",
  "50901.real_time.generatorTotalYield.desc": "发电机累计发电量的说明。",
  "50901.ctrl_gaojigongneng.initialResistance.desc": "初始阻力的说明。",
  "50901.fault.flashCommunicationFault.desc": "闪存通信故障的说明。",
  "50901.fault.lowBatteryEnergy.desc": "电池电量过低的说明。",
  "50901.real_time.appSoftwareVersion.desc": "APP软件版本的说明。",
  "50901.real_time.phaseCOfInverterSideCurrent.desc": "逆变器交流侧C相电流的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseRange.desc": "TOU模式时间范围的说明。",
  "50901.real_time.workStatus.desc": "运行状态的说明。",
  "50901.real_time.epsPowerC.desc": "EPS侧C相功率的说明。",
  "50901.warning.dtu3Rs485CommunicationAbnormality.desc": "DTU3 RS485 通信异常的说明。",
  "50901.warning.bmsCanCommunicationAbnormality.desc": "BMS_CAN 通信异常的说明。",
  "50901.real_time.epsPowerB.desc": "EPS侧B相功率的说明。",
  "50901.ctrl_dianchiguanli.batteryMaxChargePower.desc": "电池最大充电功率的说明。",
  "50901.real_time.epsPowerA.desc": "EPS侧A相功率的说明。",
  "50901.real_time.relayStatus.desc": "继电器状态的说明。",
  "50901.warning.gridMeterTypeError.desc": " 电网电表类型错误的说明。",
  "50901.real_time.batteryVoltage.desc": "电池电压的说明。",
  "50901.real_time.pv2Current.desc": "PV2电流的说明。",
  "50901.real_time.maxCellVoltageCellId.desc": "最高单体电压对应序号的说明。",
  "50901.real_time.batteryToLoadPower.desc": "电池流向负载的功率的说明。",
  "50901.real_time.dailyExportEnergyToGrid.desc": "日卖电量的说明。",
  "50901.fault.testFault.desc": "testFault的说明。",
  "50901.ctrl_dianchiguanli.hpStartSoc.desc": "HP启动Soc的说明。",
  "50901.real_time.phaseAOfInverterSideVoltage.desc": "逆变器交流侧A相电压的说明。",
  "50901.real_time.batteryDailyDischargeEnergy.desc": "电池日放电量的说明。",
  "50901.ctrl_dianwangjiaohu.section3PeakStopMinute1.desc": "section3峰值停止时间1-分钟的说明。",
  "50901.ctrl_dianwangjiaohu.section3PeakStopMinute2.desc": "section3峰值停止时间2-分钟的说明。",
  "50901.real_time.essAccessPoint.desc": "ess接入点的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime1DischrgStartH.desc": "使用时间Time1DischrgStart-H的说明。",
  "50901.real_time.dailyPvToGridEnegry.desc": "今日光伏流向电网的能量的说明。",
  "50901.ctrl_xitongjichupeizhi.DTSReset.desc": "数据棒复位的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime8DischrgStartMin.desc": "使用时间Time8DischrgStart-Min的说明。",
  "50901.real_time.macAddr.desc": "MAC地址的说明。",
  "50901.ctrl_dianwangjiaohu.section2StopMonth.desc": "section2停止月的说明。",
  "50901.real_time.communicationStickSoftwareVersion.desc": "通讯棒软件版本的说明。",
  "50901.fault.pvPortOvercurrent.desc": "光伏端口过流的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime6DischrgPower.desc": "放电功率的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime7DischrgEndH.desc": "使用时间Time7DischrgEnd-H的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime1DischrgStartMin.desc": "使用时间Time1DischrgStart-Min的说明。",
  "50901.real_time.internalFanSpeed2.desc": "内测风扇转速2的说明。",
  "50901.real_time.meterPhaseAPowerFactor.desc": "电表A功率因数的说明。",
  "50901.real_time.internalFanSpeed1.desc": "内测风扇转速1的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime2DischrgPower.desc": "放电功率的说明。",
  "50901.real_time.internalFanSpeed3.desc": "内测风扇转速3的说明。",
  "50901.real_time.dailyPvToLoadEnegry.desc": "今日光伏流向负载的能量的说明。",
  "50901.real_time.maxCellTemperatureCellId.desc": "最高单体温度对应序号的说明。",
  "50901.fault.gridPowerOutage.desc": "电网断电的说明。",
  "50901.ctrl_dianwangjiaohu.section1ValleyStopHour1.desc": "section1 低谷停止时间1- 小时的说明。",
  "50901.ctrl_dianwangjiaohu.section1ValleyStopHour2.desc": "section1低估停止时间2-小时的说明。",
  "50901.fault.driveAbnormality.desc": "驱动异常的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime5ChrgEndH.desc": "使用时间Time5Chrg结束-H的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime3ChrgStartH.desc": "使用时间Time3ChrgStart-H的说明。",
  "50901.fault.frequencyVariationRateOutOfRange.desc": "频率变化率超限的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime1DischrgEndMin.desc": "使用时间Time1Dischrg结束-分钟的说明。",
  "50901.fault.arcFault.desc": "电弧故障的说明。",
  "50901.fault.neutralWireNotConnected.desc": "零线未连接的说明。",
  "50901.ctrl_dianwangjiaohu.section3StartDay.desc": "section3开始天的说明。",
  "50901.ctrl_dianchiguanli.leadAcidBatReplenishTime.desc": "铅酸电池维护时间的说明。",
  "50901.fault.hardwareProtection.desc": "硬件保护的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime2ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.ctrl_dianchiguanli.selfUsedSoc.desc": "自用SOC的说明。",
  "50901.ctrl_dianwangjiaohu.connectionServerStatus.desc": "连接器服务状态的说明。",
  "50901.real_time.inverterTemp.desc": "逆变器内部运行温度的说明。",
  "50901.ctrl_gaojigongneng.quietTime2StartMin.desc": "待机时间2开始-Min的说明。",
  "50901.ctrl_dianchiguanli.maximumChargePower.desc": "最大充电功率的说明。",
  "50901.ctrl_dianchiguanli.BatteryModel.desc": "电池型号的说明。",
  "50901.real_time.pvConnectionStatus.desc": "光伏连接状态的说明。",
  "50901.fault.rcdSelfTestFault.desc": "漏电保护器自检故障的说明。",
  "50901.warning.dtu1Rs485CommunicationAbnormality.desc": "DTU1 RS485 通信异常的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime4ChrgStartH.desc": "使用时间Time4ChrgStart-H的说明。",
  "50901.ctrl_dianwangjiaohu.batGridFeedPowerWhenPeak.desc": "峰值时电网馈电功率的说明。",
  "50901.ctrl_dianwangjiaohu.section2PeakStopMinute1.desc": "section2峰值停止时间1-分钟的说明。",
  "50901.fault.pvRelayAbFault.desc": "光伏AB继电器故障的说明。",
  "50901.real_time.commAddress6Slave6.desc": "通信地址6(从5）的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime1ChrgEndMin.desc": "使用时间Time1Chrg结束-分钟的说明。",
  "50901.ctrl_fuzaikongzhi.minimumOnLoadPower.desc": "负载模式负载功率阈值的说明。",
  "50901.fault.preSynchronizationFailed.desc": "预同步失败的说明。",
  "50901.ctrl_dianwangjiaohu.connectionRouterStatus.desc": "连接路由器状态的说明。",
  "50901.ctrl_dianchiguanli.hpCloseSoc.desc": "HP关闭Soc的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime2DischrgStartMin.desc": "使用时间Time2DischrgStart-Min的说明。",
  "50901.ctrl_xitongjichupeizhi.genPracticeModeStartH.desc": "发电机练习模式启动时间-小时的说明。",
  "50901.ctrl_gaojigongneng.hpTime4StartMonth.desc": "HPTime4Start-月的说明。",
  "50901.ctrl_dianchiguanli.chargeTimeStartMin.desc": "发电机控制-充电开始时间-分钟的说明。",
  "50901.real_time.meterPhaseBPowerFactor.desc": "电表B功率因数的说明。",
  "50901.ctrl_dianwangjiaohu.section2PeakStopMinute2.desc": "section2峰值停止时间2-分钟的说明。",
  "50901.ctrl_gaojigongneng.timer1Hour_2.desc": "定时1起_2-时的说明。",
  "50901.warning.pvMeterCommunicationAbnormality.desc": "光伏电表通信异常的说明。",
  "50901.ctrl_gaojigongneng.timer1Hour_3.desc": "时间段1起-时的说明。",
  "50901.ctrl_xitongjichupeizhi.economyModeDateNumber.desc": "经济模式日期编号的说明。",
  "50901.ctrl_dianwangjiaohu.section3StopDay.desc": "section3停止日的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime2DischrgEndH.desc": "使用时间Time2DischrgEnd-H的说明。",
  "50901.real_time.batteryChargePower.desc": "电池累计充电量的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime2DischrgEndMin.desc": "使用时间Time2Dischrg结束-分钟的说明。",
  "50901.real_time.packVoltage.desc": "电池包电压的说明。",
  "50901.real_time.pv4Current.desc": "PV4电流的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime8DischrgEndMin.desc": "使用时间Time8Dischrg结束-分钟的说明。",
  "50901.fault.pvVoltageExceedingBusVoltage.desc": " PV电压超过母线电压的说明。",
  "50901.ctrl_gaojigongneng.timer2Hour.desc": "定时2起-时的说明。",
  "50901.real_time.firmwareInformationCrc.desc": "固件信息CRC的说明。",
  "50901.real_time.dspVersionAuxiliaryUVersion.desc": "DSP版本(辅U版本)的说明。",
  "50901.fault.smartloadPortOvercurrent.desc": "智能负载端口过流的说明。",
  "50901.ctrl_gaojigongneng.numberOfUnits.desc": "机器数量的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime2DischrgStartH.desc": "使用时间Time2DischrgStart-H的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime4DischrgStartH.desc": "使用时间Time4DischrgStart-H的说明。",
  "50901.ctrl_gaojigongneng.timed1From1Min.desc": "定时1起-分的说明。",
  "50901.real_time.firmwareEndAddressLow.desc": "固件结束地址(低)的说明。",
  "50901.fault.genAbnormality.desc": "发电机异常的说明。",
  "50901.ctrl_dianchiguanli.endChargeVoltage.desc": "结束充电电压的说明。",
  "50901.ctrl_gaojigongneng.smart_weekRange1.desc": "时间范围1的说明。",
  "50901.real_time.firmwareStartAddressHigh.desc": "固件起始地址(高）的说明。",
  "50901.warning.fanSpeedAbnormality.desc": "风扇转速异常的说明。",
  "50901.real_time.machineSnSlave2.desc": "机器SN(从2)的说明。",
  "50901.real_time.minCellTemperatureCellId.desc": "最低单体温度对应序号的说明。",
  "50901.real_time.machineSnSlave1.desc": "机器SN(从1)的说明。",
  "50901.real_time.machineSnSlave4.desc": "机器SN(从4）的说明。",
  "50901.ctrl_dianchiguanli.generatorCloseBatteryCapacity.desc": "柴发关闭电池容量的说明。",
  "50901.real_time.machineSnSlave3.desc": "机器SN(从3)的说明。",
  "50901.ctrl_dianwangjiaohu.section1PeakStopMinute1.desc": "section1 峰值停止时间1-分钟的说明。",
  "50901.ctrl_xitongjichupeizhi.clockSetting_second.desc": "时钟设置-second的说明。",
  "50901.ctrl_dianwangjiaohu.section1PeakStopMinute2.desc": "section1峰值停止时间2-分钟的说明。",
  "50901.real_time.gridVoltageA.desc": "电网侧A相电压的说明。",
  "50901.fault.epsOverload.desc": "EPS过载的说明。",
  "50901.real_time.gridVoltageB.desc": "电网侧B相电压的说明。",
  "50901.ctrl_xitongjichupeizhi.equalizationEnable.desc": "均衡启用的说明。",
  "50901.real_time.gridVoltageC.desc": "电网侧C相电压的说明。",
  "50901.ctrl_dianwangjiaohu.section4StartMonth.desc": "section4开始月的说明。",
  "50901.real_time.soh.desc": "SOH的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime6ChrgStartH.desc": "使用时间Time6ChrgStart-H的说明。",
  "50901.real_time.inverterSideRadiatorTemperature.desc": "逆变器侧散热器温度的说明。",
  "50901.fault.gridUnderfrequency.desc": "电网欠频的说明。",
  "50901.real_time.totalPvToBatteryEnegry.desc": "累计-光伏流向电池的能量的说明。",
  "50901.ctrl_gaojigongneng.hpTime2StartMonth.desc": "HPTime2开始-月的说明。",
  "50901.real_time.pvMeterPower.desc": "PV电表功率的说明。",
  "50901.ctrl_gaojigongneng.timed2EndMinutes.desc": "定时2终-分的说明。",
  "50901.warning.lowDtuVersion.desc": "DTU版本过低的说明。",
  "50901.fault.loadRelayBFault.desc": "​​ 负载B继电器故障的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime5ChrgStartH.desc": "使用时间Time5ChrgStart-H的说明。",
  "50901.real_time.externalFanSpeed3.desc": "外侧风扇转速3的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime3DischrgStartMin.desc": "使用时间Time3DischrgStart-Min的说明。",
  "50901.real_time.externalFanSpeed4.desc": "外侧风扇转速4的说明。",
  "50901.fault.pvFault.desc": "光伏故障的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime6ChrgPower.desc": "充电功率的说明。",
  "50901.ctrl_dianwangjiaohu.section4StopDay.desc": "section4停止日的说明。",
  "50901.real_time.externalFanSpeed1.desc": "外侧风扇转速1的说明。",
  "50901.real_time.externalFanSpeed2.desc": "外侧风扇转速2的说明。",
  "50901.warning.batteryHighVoltageAlarm.desc": "电池过压报警的说明。",
  "50901.real_time.gatewayCommunicationAddress.desc": "网关通信地址的说明。",
  "50901.real_time.meterPhaseAReactivePower.desc": "电表A无功功率的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime2ChrgEndMin.desc": "使用时间Time2Chrg结束-分钟的说明。",
  "50901.ctrl_gaojigongneng.smart_weekRange25.desc": "星期六的说明。",
  "50901.ctrl_dianchiguanli.batteryChargingPowerSettingValue.desc": "电池的充电功率设置值的说明。",
  "50901.real_time.meterPhaseAActivePower.desc": "电表A有功功率的说明。",
  "50901.fault.genRelayAFault.desc": "​​ 发电机A继电器故障的说明。",
  "50901.ctrl_gaojigongneng.smart_weekRange26.desc": "星期天的说明。",
  "50901.ctrl_gaojigongneng.equalizationTime.desc": "均衡时间的说明。",
  "50901.real_time.firmwareBuildTimeDateHour.desc": "固件构建时间(天/小时)的说明。",
  "50901.real_time.inverterModelNumber.desc": "逆变器机型编号的说明。",
  "50901.ctrl_gaojigongneng.smart_weekRange23.desc": "星期四的说明。",
  "50901.real_time.generatorCurrentB.desc": "发电机B相电流的说明。",
  "50901.ctrl_gaojigongneng.smart_weekRange24.desc": "星期五的说明。",
  "50901.real_time.generatorCurrentC.desc": "发电机C相电流的说明。",
  "50901.ctrl_gaojigongneng.smart_weekRange21.desc": "星期二的说明。",
  "50901.ctrl_gaojigongneng.smart_weekRange22.desc": "星期三的说明。",
  "50901.fault.gridCurrentDcOffsetOutOfRange.desc": "电网电流直流偏置超限的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime6DischrgEndH.desc": "使用时间Time6DischrgEnd-H的说明。",
  "50901.ctrl_gaojigongneng.smart_weekRange20.desc": "星期一的说明。",
  "50901.real_time.machineSnSlave6.desc": "机器SN(从6）的说明。",
  "50901.real_time.machineSnSlave5.desc": "机器SN(从5）的说明。",
  "50901.real_time.commAddress10Slave9.desc": "通信地址10(从9）的说明。",
  "50901.real_time.machineSnSlave8.desc": "机器SN(从8）的说明。",
  "50901.ctrl_dianwangjiaohu.section3ValleyStopMinute1.desc": "section3低估停止时间1-分钟的说明。",
  "50901.real_time.machineSnSlave7.desc": "机器SN(从7）的说明。",
  "50901.ctrl_dianwangjiaohu.section3ValleyStopMinute2.desc": "section3低估停止时间2-分钟的说明。",
  "50901.real_time.machineSnSlave9.desc": "机器SN(从9)的说明。",
  "50901.real_time.maxCellSocCellId.desc": "最高单体SOC对应序号的说明。",
  "50901.ctrl_dianchiguanli.CfgMultPcsBMSFlag.desc": "多机并联BMS标识的说明。",
  "50901.ctrl_dianwangjiaohu.section2ValleyStopHour2.desc": "section2低估停止时间2-小时的说明。",
  "50901.fault.inverterCommunicationFailed.desc": "逆变器通信失败的说明。",
  "50901.real_time.pv3Voltage.desc": "PV3电压的说明。",
  "50901.warning.gridMeterCommunicationAbnormality.desc": "电网电表通信异常的说明。",
  "50901.warning.masterSlaveCommunicationAbnormality.desc": "主从通信异常的说明。",
  "50901.warning.batteryFault.desc": "电池故障的说明。",
  "50901.real_time.upgradeCommand.desc": "升级指令的说明。",
  "50901.warning.pvMeterTypeError.desc": "光伏电表类型错误的说明。",
  "50901.fault.lowAmbientTemperature.desc": "环境温度过低的说明。",
  "50901.real_time.pvMeterPowerC.desc": "PV电表C相功率的说明。",
  "50901.ctrl_anquanbaohu.nationalStandardsSafetyRegulationsStandards.desc": "国家标准（安规标准）的说明。",
  "50901.real_time.pvMeterPowerB.desc": "PV电表B相功率的说明。",
  "50901.ctrl_dianwangjiaohu.section3StartMonth.desc": "section3开始月的说明。",
  "50901.warning.hmidMachineFault.desc": "人机交互界面设备故障的说明。",
  "50901.real_time.commAddress3Slave2.desc": "通信地址3(从2)的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime6ChrgEndH.desc": "使用时间Time6Chrg结束-H的说明。",
  "50901.fault.machineTypeMismatch.desc": "机型不匹配的说明。",
  "50901.real_time.commAddress3Slave3.desc": "通信地址4(从3)的说明。",
  "50901.ctrl_gaojigongneng.hpTime3EndMonth.desc": "HPTime3结束\n月的说明。",
  "50901.warning.evCharger1Fault.desc": "充电桩1故障的说明。",
  "50901.ctrl_dianwangjiaohu.section1ValleyStartMinute1.desc": "section1 低谷开始时间1- 分钟的说明。",
  "50901.ctrl_dianwangjiaohu.section1ValleyStartMinute2.desc": "section1低估开始时间2-分钟的说明。",
  "50901.real_time.bmsSoftwareVersion.desc": "BMS版本-软件的说明。",
  "50901.ctrl_gaojigongneng.timed1From1Min_2.desc": "定时1起_2-分的说明。",
  "50901.ctrl_gaojigongneng.timed1From1Min_3.desc": "时间段1起-分的说明。",
  "50901.fault.busbarAbnormality.desc": "母线异常的说明。",
  "50901.ctrl_dianwangjiaohu.section4StartDay.desc": "section4开始天的说明。",
  "50901.ctrl_dianwangjiaohu.section1ValleyStartHour1.desc": "section1 低谷开始时间1- 小时的说明。",
  "50901.ctrl_dianwangjiaohu.section1ValleyStartHour2.desc": "section1低估开始时间2-小时的说明。",
  "50901.real_time.pvMeterTotalYield.desc": "外部逆变器累计发电量的说明。",
  "50901.ctrl_xitongjichupeizhi.clockSetting_minute.desc": "时钟设置-minute的说明。",
  "50901.real_time.loadEnergy.desc": "负载日用电量的说明。",
  "50901.warning.batteryPackChargeHighVoltageAlarm.desc": "电池组充电过压报警的说明。",
  "50901.real_time.commAddress4Slave4.desc": "通信地址5(从4)的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime3ChrgEndMin.desc": "使用时间Time3Chrg结束-分钟的说明。",
  "50901.ctrl_gaojigongneng.timed2EndHour_2.desc": "定时2终_2-时的说明。",
  "50901.ctrl_dianwangjiaohu.section4ValleyStartHour2.desc": "section4低估开始时间2-小时的说明。",
  "50901.ctrl_gaojigongneng.timed1EndHour.desc": "定时1终-时的说明。",
  "50901.real_time.powerGeneration.desc": "PV累计发电量的说明。",
  "50901.ctrl_dianwangjiaohu.section4ValleyStartHour1.desc": "section4低估开始时间1-小时的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime3DischrgStartH.desc": "使用时间Time3DischrgStart-H的说明。",
  "50901.real_time.5vAuxiliaryVoltageSampling.desc": "5V辅助电压采样的说明。",
  "50901.ctrl_gaojigongneng.hpTime3StartMonth.desc": "HPTime3开始-月的说明。",
  "50901.ctrl_gaojigongneng.timer1Hour.desc": "定时1起-时的说明。",
  "50901.ctrl_gaojigongneng.timed2EndHour_3.desc": "时间段2终-时的说明。",
  "50901.ctrl_dianwangjiaohu.section2ValleyStopHour1.desc": "section2低估停止时间1-小时的说明。",
  "50901.ctrl_dianchiguanli.batDischargePowerWhenPartialPeak.desc": "峰值时电池最大放电功率的说明。",
  "50901.real_time.inverterSn.desc": "逆变器SN的说明。",
  "50901.real_time.gridCurrentC.desc": "电网侧C相电流的说明。",
  "50901.real_time.generatorVoltageC.desc": "发电机C相电压的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime6ChrgEndMin.desc": "使用时间Time6Chrg结束-分钟的说明。",
  "50901.ctrl_dianchiguanli.chargeTimeEndMin.desc": "发电机控制-充电结束时间-分钟的说明。",
  "50901.warning.chargeLowTemperatureAlarm.desc": "充电低温报警的说明。",
  "50901.fault.threePointThreeVoltPowerSupplyFault.desc": "3.3V电源故障的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime1ChrgEndH.desc": "使用时间Time1Chrg结束-H的说明。",
  "50901.real_time.generatorVoltageB.desc": "发电机B相电压的说明。",
  "50901.ctrl_dianchiguanli.maxSoc.desc": "最大SOC的说明。",
  "50901.real_time.totalBatteryToLoadEnergy.desc": "累计-电池流向负载的能量的说明。",
  "50901.warning.batteryCapacityAbnormality.desc": " 电池容量异常的说明。",
  "50901.ctrl_gaojigongneng.hpTime2EndMonth.desc": "HPTime2结束\n月的说明。",
  "50901.ctrl_dianwangjiaohu.section4ValleyStartMinute1.desc": "section4低估开始时间1-分钟的说明。",
  "50901.ctrl_dianwangjiaohu.section2PeakStopHour1.desc": "section2峰值停止时间1-小时的说明。",
  "50901.ctrl_dianwangjiaohu.section4ValleyStartMinute2.desc": "section4低估开始时间2-分钟的说明。",
  "50901.ctrl_dianwangjiaohu.section1StartMonth.desc": "section1开始月的说明。",
  "50901.real_time.mpptTemp.desc": "光伏侧散热器温度的说明。",
  "50901.real_time.gridCurrentA.desc": "电网侧A相电流的说明。",
  "50901.real_time.gridCurrentB.desc": "电网侧B相电流的说明。",
  "50901.real_time.pv3Current.desc": "PV3电流的说明。",
  "50901.real_time.gridPower.desc": "电网侧功率的说明。",
  "50901.real_time.commAddress2Slave1.desc": "通信地址2(从1)的说明。",
  "50901.ctrl_dianwangjiaohu.section2PeakStopHour2.desc": "section2峰值停止时间2-小时的说明。",
  "50901.ctrl_dianchiguanli.maximumChargeLimit.desc": "最大充电限制值的说明。",
  "50901.fault.emergencyStopSwitchStatus.desc": "紧急停止的说明。",
  "50901.real_time.serviceEntranceBreakerCurrent.desc": "服务入口断路器电流的说明。",
  "50901.ctrl_dianwangjiaohu.section3PeakStartMinute2.desc": "section3峰值开始时间1-分钟的说明。",
  "50901.ctrl_dianchiguanli.minSoc.desc": "最小SOC的说明。",
  "50901.ctrl_dianwangjiaohu.section3PeakStartMinute1.desc": "section3峰值开始时间2-分钟的说明。",
  "50901.real_time.gridReactivePowerC.desc": "电网侧C相无功功率的说明。",
  "50901.real_time.gridReactivePowerB.desc": "电网侧B相无功功率的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime4DischrgStartMin.desc": "使用时间Time4DischrgStart-Min的说明。",
  "50901.ctrl_xitongjichupeizhi.genPracticeModeRunningTime.desc": "发电机练习模式运行时长的说明。",
  "50901.real_time.generatorDailyYield.desc": "发电机日发电量的说明。",
  "50901.real_time.meterPhaseBActivePower.desc": "电表B有功功率的说明。",
  "50901.ctrl_gaojigongneng.timed1EndMinute.desc": "定时1终-分的说明。",
  "50901.ctrl_dianwangjiaohu.section2ValleyStartMinute2.desc": "section2低估开始时间2-分钟的说明。",
  "50901.real_time.dailyBatteryToLoadEnergy.desc": "本日电池流向负载的能量的说明。",
  "50901.fault.genRelayBFault.desc": "发电机B继电器故障的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime5DischrgStartMin.desc": "使用时间Time5DischrgStart-Min的说明。",
  "50901.ctrl_gaojigongneng.quietTime1StartH.desc": "待机时间1开始-H的说明。",
  "50901.real_time.cfgMultPcsBmsFlag.desc": "BMS标志位的说明。",
  "50901.real_time.inverCombinedActivePower.desc": "逆变器交流侧输出功率的说明。",
  "50901.ctrl_dianwangjiaohu.section2ValleyStartMinute1.desc": "section2低估开始时间1-分钟的说明。",
  "50901.warning.batteryForceChargeRequest.desc": " 电池强制充电请求的说明。",
  "50901.fault.arcSelfTestFault.desc": " 电弧自检故障的说明。",
  "50901.real_time.totalPvToGridEnegry.desc": "累计-光伏流向电网的能量的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime3DischrgEndH.desc": "使用时间Time3DischrgEnd-H的说明。",
  "50901.ctrl_dianwangjiaohu.GridConnectionPointFeedinPowerLimit.desc": "并网点/馈网功率限值的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime4ChrgEndH.desc": "使用时间Time4Chrg结束-H的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime4ChrgEndMin.desc": "使用时间Time4Chrg结束-分钟的说明。",
  "50901.real_time.pv3Power.desc": "PV3功率的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime7DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.real_time.totalPvToLoadEnegry.desc": "累计-光伏流向负载的能量的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime4DischrgEndMin.desc": "使用时间Time4Dischrg结束-分钟的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime3ChrgPower.desc": "充电功率的说明。",
  "50901.ctrl_dianwangjiaohu.section2StartDay.desc": "section2开始天的说明。",
  "50901.real_time.oemSerialNumber.desc": "OEM序列号的说明。",
  "50901.real_time.commAddress7Slave6.desc": "通信地址7(从6）的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime6DischrgStartH.desc": "使用时间Time6DischrgStart-H的说明。",
  "50901.real_time.12vAuxiliaryVoltageSampling.desc": "12V辅助电压采样的说明。",
  "50901.ctrl_dianwangjiaohu.section4ValleyStopMinute2.desc": "section4低估停止时间2-分钟的说明。",
  "50901.ctrl_gaojigongneng.rsvdReplenishPower.desc": "Rsvd补充功率的说明。",
  "50901.ctrl_dianwangjiaohu.section4ValleyStopMinute1.desc": "section4低估停止时间1-分钟的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime6DischrgEndMin.desc": "使用时间Time6Dischrg结束-分钟的说明。",
  "50901.real_time.meterPhaseCPowerFactor.desc": "电表C功率因数的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime8DischrgStartH.desc": "使用时间Time8DischrgStart-H的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime6ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.fault.e2rpomFault.desc": "EEPROM故障的说明。",
  "50901.real_time.gridSellPower.desc": "累计卖电量的说明。",
  "50901.real_time.inverterHardwareVersion.desc": "逆变器硬件版本的说明。",
  "50901.ctrl_gaojigongneng.timedFrom2Minutes_2.desc": "定时2起_2-分的说明。",
  "50901.ctrl_gaojigongneng.timedFrom2Minutes_3.desc": "时间段2起-分的说明。",
  "50901.ctrl_xitongjichupeizhi.materType.desc": "电表类型的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime8ChrgPower.desc": "充电功率的说明。",
  "50901.real_time.minCellVoltageCellId.desc": "最低单体电压对应序号的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime6DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.ctrl_xitongjichupeizhi.clockSetting_month.desc": "时钟设置-month的说明。",
  "50901.real_time.gridTotalFrequency.desc": "电网侧频率的说明。",
  "50901.real_time.MaxDisChargeCurrent.desc": "最大放电电流的说明。",
  "50901.fault.wiringAbnormality.desc": "接线异常的说明。",
  "50901.ctrl_xitongjichupeizhi.quietTimeEnable.desc": "待机时间启用的说明。",
  "50901.warning.hmidCommunicationAbnormality.desc": "人机交互界面通信异常的说明。",
  "50901.ctrl_dianwangjiaohu.section3ValleyStopHour1.desc": "section3低估停止时间1-小时的说明。",
  "50901.ctrl_dianwangjiaohu.section3ValleyStopHour2.desc": "section3低估停止时间2-小时的说明。",
  "50901.fault.samplingBiasAbnormality.desc": "采样偏置异常的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime7ChrgEndH.desc": "使用时间Time7Chrg结束-H的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime1ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.ctrl_dianwangjiaohu.section4PeakStopHour1.desc": "section4峰值停止时间1-小时的说明。",
  "50901.warning.dischargeHighTemperatureAlarm.desc": "放电高温报警的说明。",
  "50901.ctrl_dianchiguanli.peakMeterSoc.desc": "峰值计SOC的说明。",
  "50901.ctrl_dianwangjiaohu.section4PeakStopHour2.desc": "section4峰值停止时间2-小时的说明。",
  "50901.real_time.meterFlag.desc": "电表标志位的说明。",
  "50901.warning.slaveWrongBatteryConnection.desc": "从机电池连接错误的说明。",
  "50901.real_time.oemModelName.desc": "OEM型号名称的说明。",
  "50901.ctrl_dianwangjiaohu.section2StopDay.desc": "section2停止日的说明。",
  "50901.real_time.commAddress9Slave8.desc": "通信地址9(从8)的说明。",
  "50901.real_time.12vOutputVoltageSampling.desc": "12V输出电压采样的说明。",
  "50901.warning.dtu2Rs485CommunicationAbnormality.desc": " DTU2 RS485 通信异常的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime8DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.real_time.gridPowerFactorB.desc": "电网侧B相功率因数的说明。",
  "50901.real_time.gridPowerFactorC.desc": "电网侧C相功率因数的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime5DischrgEndH.desc": "使用时间Time5DischrgEnd-H的说明。",
  "50901.fault.auxiliaryPowerAbnormality.desc": "辅助电源异常的说明。",
  "50901.real_time.phaseAOfInverterActivePower.desc": "逆变器交流侧A相功率的说明。",
  "50901.ctrl_gaojigongneng.hpTime2StartDay.desc": "HPTime2开始-天的说明。",
  "50901.real_time.pv4Voltage.desc": "PV4电压的说明。",
  "50901.real_time.minCellSoc.desc": "最低单体SOC的说明。",
  "50901.fault.spiCommunicationFault.desc": "SPI通信故障的说明。",
  "50901.ctrl_dianwangjiaohu.section2ValleyStopMinute1.desc": "section2低估停止时间1-分钟的说明。",
  "50901.fault.comparatorFault.desc": "比较器故障的说明。",
  "50901.ctrl_dianwangjiaohu.section2ValleyStopMinute2.desc": "section2低估停止时间2-分钟的说明。",
  "50901.ctrl_gaojigongneng.timed1EndMinute_3.desc": "时间段1终-分的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime4ChrgPower.desc": "充电功率的说明。",
  "50901.ctrl_gaojigongneng.timed1EndMinute_2.desc": "定时1终_2-分的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime7ChrgPower.desc": "放电功率的说明。",
  "50901.ctrl_dianwangjiaohu.section3PeakStopHour1.desc": "section3峰值停止时间1-小时的说明。",
  "50901.ctrl_dianwangjiaohu.section3PeakStopHour2.desc": "section3峰值停止时间2-小时的说明。",
  "50901.ctrl_dianwangjiaohu.section4ValleyStopHour2.desc": "section4低估停止时间2-小时的说明。",
  "50901.ctrl_gaojigongneng.minimumOnTime.desc": "负载控制最短接通时间的说明。",
  "50901.ctrl_dianchiguanli.offGridProtectionSoc.desc": "离网保护SOC的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime8ChrgStartH.desc": "使用时间Time8ChrgStart-H的说明。",
  "50901.ctrl_dianwangjiaohu.section4ValleyStopHour1.desc": "section4低估停止时间1-小时的说明。",
  "50901.ctrl_xitongjichupeizhi.clockSetting_hour.desc": "时钟设置-hour的说明。",
  "50901.fault.pllLockFailed.desc": "PLL锁相失败的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime3DischrgEndMin.desc": "使用时间Time3Dischrg结束-分钟的说明。",
  "50901.real_time.communicationStickHardwareVersion.desc": "通讯棒硬件版本的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime5DischrgStartH.desc": "使用时间Time5DischrgStart-H的说明。",
  "50901.real_time.afciVersion.desc": "AFCI版本的说明。",
  "50901.ctrl_xitongjichupeizhi.hpMaxTimeDetectEnable.desc": "HP最大时间检测启用的说明。",
  "50901.real_time.pv1RealTimePower.desc": "PV1实时功率的说明。",
  "50901.real_time.gridPowerA.desc": "电网侧A相功率的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime7DischrgEndMin.desc": "使用时间Time7Dischrg结束-分钟的说明。",
  "50901.real_time.gridPowerB.desc": "电网侧B相功率的说明。",
  "50901.ctrl_gaojigongneng.equalizationIntervalDays.desc": "均衡间隔天数的说明。",
  "50901.real_time.gridPowerC.desc": "电网侧C相功率的说明。",
  "50901.warning.dspPwrCommunicationAbnormality.desc": "​DSP电源通信异常的说明。",
  "50901.real_time.phaseCOfInverterActivePower.desc": "逆变器交流侧C相功率的说明。",
  "50901.fault.kmRelayFault.desc": "KM继电器故障的说明。",
  "50901.real_time.minCellVoltage.desc": "最低单体电压的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime3DischrgPower.desc": "放电功率的说明。",
  "50901.ctrl_dianwangjiaohu.section3ValleyStartMinute2.desc": "section3低估开始时间2-分钟的说明。",
  "50901.ctrl_dianwangjiaohu.section3ValleyStartMinute1.desc": "section3低估开始时间1-分钟的说明。",
  "50901.real_time.packCurrent.desc": "电池包电流的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime5DischrgPower.desc": "放电功率的说明。",
  "50901.fault.genOverload.desc": "发电机过载的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime7DischrgPower.desc": "放电功率的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime8DischrgPower.desc": "放电功率的说明。",
  "50901.fault.fiveVoltPowerSupplyFault.desc": " 5V电源故障的说明。",
  "50901.ctrl_dianchiguanli.endOfChargeCurrent.desc": "充电结束电流的说明。",
  "50901.real_time.bootSoftwareVersion.desc": "启动软件版本的说明。",
  "50901.real_time.batterySoc.desc": "电池SOC的说明。",
  "50901.real_time.totalLoadEnergy.desc": "负载累计用电量的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime2ChrgPower.desc": "充电功率的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime4DischrgStopSoc.desc": "放电截止功率的说明。",
  "50901.ctrl_xitongjichupeizhi.clockSetting_day.desc": "时钟设置-day的说明。",
  "50901.fault.temperatureAbnormality.desc": "温度异常的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime1DischrgPower.desc": "放电功率的说明。",
  "50901.real_time.numberOfChargingAndDischargingCyclesOfBatteryPack.desc": "电池包充放电循环次数的说明。",
  "50901.real_time.hoymilesSerialNumber.desc": "Hoymiles序列号的说明。",
  "50901.fault.epsVoltageAbnormality.desc": "EPS电压异常的说明。",
  "50901.fault.cmpssBiasCalculationError.desc": "CMPSS偏置计算错误的说明。",
  "50901.ctrl_gaojigongneng.timedFrom2Minutes.desc": "定时2起-分的说明。",
  "50901.real_time.meterPhaseCReactivePower.desc": "电表C无功功率的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime2ChrgStartH.desc": "使用时间Time2ChrgStart-H的说明。",
  "50901.ctrl_gaojigongneng.quietTime1EndH.desc": "待机时间1End-H的说明。",
  "50901.ctrl_dianwangjiaohu.section4PeakStartHour1.desc": "section4峰值开始时间1-小时的说明。",
  "50901.ctrl_dianwangjiaohu.section4PeakStartHour2.desc": "section4峰值开始时间2-小时的说明。",
  "50901.real_time.pvDailyYield.desc": "PV日发电量的说明。",
  "50901.ctrl_xitongjichupeizhi.clockSetting_weekday.desc": "时钟设置-weekday的说明。",
  "50901.ctrl_dianchiguanli.forceChargeSoc.desc": "强制充电SOC的说明。",
  "50901.fault.epsRelayProtection.desc": "EPS继电器保护的说明。",
  "50901.ctrl_dianwangjiaohu.section1ValleyStopMinute1.desc": "section1 低谷停止时间1- 分钟的说明。",
  "50901.ctrl_dianwangjiaohu.section1ValleyStopMinute2.desc": "section1低估停止时间2-分钟的说明。",
  "50901.warning.evCharger2Fault.desc": "充电桩2故障的说明。",
  "50901.ctrl_xitongjichupeizhi.economicModeSoc.desc": "经济模式SOC的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime3ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.warning.dspSafCommunicationAbnormality.desc": "​DSP安全通信异常​的说明。",
  "50901.real_time.packSoc.desc": "电池包SOC的说明。",
  "50901.ctrl_gaojigongneng.hpTime1EndMonth.desc": "HPTime1结束-\n月的说明。",
  "50901.real_time.ssid.desc": "SSID(wifi名称)的说明。",
  "50901.real_time.invAcFrequency.desc": "逆变器交流侧输出频率的说明。",
  "50901.real_time.pv4Power.desc": "PV4功率的说明。",
  "50901.real_time.dspVersionMainUVersion.desc": "DSP版本(主U版本)的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime1ChrgStartH.desc": "使用时间Time1ChrgStart-H的说明。",
  "50901.fault.interruptOverflow.desc": "中断溢出的说明。",
  "50901.ctrl_gaojigongneng.hpTime4EndDay.desc": "HPTime4结束-天的说明。",
  "50901.real_time.packSoh.desc": "电池包SOH的说明。",
  "50901.real_time.ambientTemperatureSampling.desc": "环境温度采样的说明。",
  "50901.real_time.generatorConnectionStatus.desc": "发电机连接状态的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime8ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.ctrl_dianwangjiaohu.section3ValleyStartHour1.desc": "section3低谷开始时间1-小时的说明。",
  "50901.real_time.pvMeterSerialNumber.desc": "光伏表序列号的说明。",
  "50901.ctrl_dianwangjiaohu.section3ValleyStartHour2.desc": "section3低估开始时间2-小时的说明。",
  "50901.real_time.batteryCurrent.desc": "电池电流的说明。",
  "50901.fault.gridOverfrequency.desc": "电网过频的说明。",
  "50901.ctrl_dianwangjiaohu.section4PeakStopMinute2.desc": "section4峰值停止时间2-分钟的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime5DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.ctrl_gaojigongneng.timed1EndHour_2.desc": "定时1终_2-时的说明。",
  "50901.ctrl_dianwangjiaohu.section4PeakStopMinute1.desc": "section4峰值停止时间1-分钟的说明。",
  "50901.ctrl_gaojigongneng.timed1EndHour_3.desc": "时间段1终-时的说明。",
  "50901.fault.insulationFault.desc": "绝缘故障的说明。",
  "50901.warning.evCharger2CommunicationAbnormality.desc": "电动汽车充电桩2通信异常的说明。",
  "50901.warning.dischargeLowTemperatureAlarm.desc": "放电低温报警的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime8ChrgEndH.desc": "使用时间Time8Chrg结束-H的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime7DischrgStartMin.desc": "使用时间Time7DischrgStart-Min的说明。",
  "50901.real_time.pv2RealTimePower.desc": "PV2实时功率的说明。",
  "50901.real_time.batteryDailyChargeEnergy.desc": "电池日充电量的说明。",
  "50901.fault.gridOffVoltageDcOffsetOutOfRange.desc": "离网电压直流偏置超限的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime1DischrgEndH.desc": "使用时间Time1DischrgEnd-H的说明。",
  "50901.ctrl_dianwangjiaohu.section1WeekRange2.desc": "section1周范围2的说明。",
  "50901.real_time.ambientTemperatureThreshold.desc": "环境温度阈值的说明。",
  "50901.ctrl_gaojigongneng.hpTime3StartDay.desc": "HPTime3开始-天的说明。",
  "50901.real_time.firmwareCrc.desc": "固件CRC的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime3ChrgEndH.desc": "使用时间Time3Chrg结束-H的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime7ChrgStopSoc.desc": "放电截止容量的说明。",
  "50901.ctrl_gaojigongneng.hpMinRunTimeLmtOfOnce.desc": "HP最小运行时间限制的说明。",
  "50901.ctrl_gaojigongneng.hpMaxFeedbackPower.desc": "HP最大反馈功率的说明。",
  "50901.real_time.batteryModuleNum.desc": "电池串数（模块单体电芯串数）的说明。",
  "50901.ctrl_dianchiguanli.chargeTimeStartH.desc": "发电机控制-充电开始时间-H的说明。",
  "50901.real_time.firmwareStartAddressLow.desc": "固件起始地址(低)的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime4ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.fault.inverterCanCommunicationFailed.desc": "逆变器CAN通信失败的说明。",
  "50901.fault.gridVoltageAbnormality.desc": "电网电压异常的说明。",
  "50901.ctrl_dianwangjiaohu.absorptionVoltage.desc": "吸收电压的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime6DischrgStartMin.desc": "使用时间Time6DischrgStart-Min的说明。",
  "50901.warning.dtu5Rs485CommunicationAbnormality.desc": " DTU5 RS485 通信异常的说明。",
  "50901.real_time.phaseBOfInverterSideVoltage.desc": "逆变器交流侧B相电压的说明。",
  "50901.real_time.gridReactivePower.desc": "电网侧无功功率的说明。",
  "50901.ctrl_dianwangjiaohu.section3PeakStartHour1.desc": "section3峰值开始时间1-小时的说明。",
  "50901.real_time.commAddress1Master.desc": "通信地址1(主)的说明。",
  "50901.ctrl_dianwangjiaohu.section3PeakStartHour2.desc": "section3峰值开始时间2-小时的说明。",
  "50901.ctrl_gaojigongneng.hpTime1EndDay.desc": "HPTime1结束-天的说明。",
  "50901.fault.gridUndervoltage.desc": "电网欠压的说明。",
  "50901.ctrl_dianwangjiaohu.section1StartDay.desc": "section1开始天的说明。",
  "50901.real_time.totalGridToLoadEnergy.desc": "累计-电网流向负载的能量的说明。",
  "50901.ctrl_dianwangjiaohu.section4StopMonth.desc": "section4停止月的说明。",
  "50901.fault.versionMismatch.desc": "版本不匹配的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime3DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.ctrl_dianwangjiaohu.section1PeakStopHour1.desc": "section1 峰值停止时间1-小时的说明。",
  "50901.ctrl_dianwangjiaohu.section1PeakStopHour2.desc": "section1峰值停止时间2-小时的说明。",
  "50901.fault.shutDown.desc": "系统关机的说明。",
  "50901.real_time.firmwareBuildTimeYearMonth.desc": "固件构建时间(年&月)的说明。",
  "50901.fault.overtemperatureAlarm.desc": "过热报警的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime5ChrgPower.desc": "充电功率的说明。",
  "50901.real_time.batterytotCap.desc": "电池装机总容量的说明。",
  "50901.ctrl_dianwangjiaohu.section3WeekRange2.desc": "section3周范围2的说明。",
  "50901.real_time.maxCellSoc.desc": "最高单体SOC的说明。",
  "50901.fault.overTemperature.desc": "​​ 过温的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime8ChrgEndMin.desc": "使用时间Time8Chrg结束-分钟的说明。",
  "50901.ctrl_gaojigongneng.quietTime1EndMin.desc": "待机时间1结束分钟的说明。",
  "50901.real_time.meterPhaseCActivePower.desc": "电表C有功功率的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime1DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.ctrl_dianchiguanli.generatorOpenBatteryCapacity.desc": "柴发开启电池容量的说明。",
  "50901.real_time.gridMeterSerialNumber.desc": "网侧电表序列号的说明。",
  "50901.real_time.MaxChargeCurrent.desc": "最大充电电流的说明。",
  "50901.warning.chargeHighTemperatureAlarm.desc": "充电高温报警的说明。",
  "50901.ctrl_gaojigongneng.hpTime3EndDay.desc": "HPTime3结束-天的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime8DischrgEndH.desc": "使用时间Time8DischrgEnd-H的说明。",
  "50901.ctrl_gaojigongneng.hpWorkTimeParts.desc": "HP工作时间的说明。",
  "50901.real_time.phaseBOfInverterActivePower.desc": "逆变器交流侧B相功率的说明。",
  "50901.ctrl_dianwangjiaohu.section1PeakStartHour2.desc": "section1峰值开始时间2-小时的说明。",
  "50901.ctrl_dianwangjiaohu.section1PeakStartHour1.desc": "section1 峰值开始时间1-小时的说明。",
  "50901.ctrl_dianwangjiaohu.section2WeekRange2.desc": "section2周范围2的说明。",
  "50901.real_time.pvMeterCurrentC.desc": "PV电表C相电流的说明。",
  "50901.real_time.pvMeterCurrentB.desc": "PV电表B相电流的说明。",
  "50901.ctrl_gaojigongneng.quietTime2EndMin.desc": "待机时间2结束-Min的说明。",
  "50901.ctrl_dianwangjiaohu.section1StopDay.desc": "section1停止日的说明。",
  "50901.real_time.pv2Power.desc": "PV2功率的说明。",
  "50901.real_time.dailyImportEnergyFromGrid.desc": "日买电量的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime7DischrgStartH.desc": "使用时间Time7DischrgStart-H的说明。",
  "50901.real_time.pv3RealTimePower.desc": "PV3实时功率的说明。",
  "50901.ctrl_gaojigongneng.timeOfUseTime5DischrgEndMin.desc": "使用时间Time5Dischrg结束-分钟的说明。",
  "50901.real_time.generatorPower.desc": "发电机功率的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime2DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.ctrl_dianchiguanli.batteryMaxDischargePower.desc": "电池最大放电功率的说明。",
  "50901.ctrl_dianwangjiaohu.section2PeakStartHour2.desc": "section2峰值开始时间2-小时的说明。",
  "50901.real_time.batteryModule.desc": "电池型号的说明。",
  "50901.ctrl_dianwangjiaohu.section2PeakStartMinute2.desc": "section2峰值开始时间1-分钟的说明。",
  "50901.ctrl_gaojigongneng.hpTime2EndDay.desc": "HPTime2结束-天的说明。",
  "50901.ctrl_dianwangjiaohu.powerLimitForGridConnectionFeederNetwork.desc": "并网点/馈网功率限值的说明。",
  "50901.ctrl_dianchiguanli.timeOfUseTime4DischrgPower.desc": "放电功率的说明。",
  "50901.ctrl_dianwangjiaohu.section2PeakStartMinute1.desc": "section2峰值开始时间1-分钟的说明。",
  "50901.ctrl_dianwangjiaohu.section1StopMonth.desc": "section1停止月的说明。",
  "50901.ctrl_dianwangjiaohu.section2PeakStartHour1.desc": "section2峰值开始时间1-小时的说明。",
  "51306.group_1.HumidityValue": "湿度值",
  "51306.group_1.TemperatureValue": "温度值",
  "51306.group_1.AddressCode": "地址码",
  "51306.group_1": "分组_1",
  "51301.group_1.heatingSetTemperature": "制热设定温度",
  "51301.group_1.hotWaterSetTemperature": "热水设定温度",
  "51301.group_1.floorHeatingSetTemperature": "地暖设定温度",
  "51301.group_1.operatingMode": "设定模式",
  "51301.group_1.onOffControl": "开关机",
  "51301.group_1.compressorOperatingFrequency": "压缩机运行频率",
  "51301.group_1.fanOperatingFrequency": "风机运行频率",
  "51301.group_1.outdoorAmbientTemperature": "外环境温度",
  "51301.group_1.outdoorCoilTemperature": "外盘管(翅片)温度",
  "51301.group_1.indoorCoilTemperature": "内盘管(板换)温度",
  "51301.group_1.suctionGasTemperature": "回气温度",
  "51301.group_1.dischargeGasTemperature": "排气温度",
  "51301.group_1.inletWaterTemperature": "进水温度",
  "51301.group_1.outletWaterTemperature": "出水温度",
  "51301.group_1.waterFlowRate": "水流量",
  "51301.group_1.photovoltaicPower": "光伏功率",
  "51301.group_1.pvPg": "光伏发电量",
  "51301.group_1.pvInputVolt": "光伏输入电压",
  "51301.group_1.pvInputCurr": "光伏输入电流",
  "51301.group_1.mainsPower": "市电功率",
  "51301.group_1.mainsPg": "市电电量",
  "51301.group_1.heatingSetTemperature.desc": "参数范围：20-60",
  "51301.group_1.hotWaterSetTemperature.desc": "参数范围：20-75",
  "51301.group_1.floorHeatingSetTemperature.desc": "参数范围：20-60",
  "51301.group_1.operatingMode.desc": "0：制冷\n1：制热\n2：热水\n3：地暖\n4：热水+制冷\n5：热水+制热\n6：预留\n7：热水+地暖",
  "51301.group_1.onOffControl.desc": "0：关机/1：开机",
  "51301.group_1.compressorOperatingFrequency.desc": "实测值",
  "51301.group_1.fanOperatingFrequency.desc": "实测值",
  "51301.group_1.outdoorAmbientTemperature.desc": "实测值",
  "51301.group_1.outdoorCoilTemperature.desc": "实测值",
  "51301.group_1.indoorCoilTemperature.desc": "实测值",
  "51301.group_1.suctionGasTemperature.desc": "实测值",
  "51301.group_1.dischargeGasTemperature.desc": "实测值",
  "51301.group_1.inletWaterTemperature.desc": "实测值",
  "51301.group_1.outletWaterTemperature.desc": "实测值",
  "51301.group_1.waterFlowRate.desc": "实测值",
  "51301.group_1.photovoltaicPower.desc": "实测值",
  "51301.group_1": "分组_1",
  "51304.group_1.temperatureValue1": "温度值1",
  "51304.group_1.temperatureValue2": "温度值2",
  "51304.group_1.temperatureValue3": "温度值3",
  "51304.group_1.temperatureValue4": "温度值4",
  "51304.group_1.temperatureValue5": "温度值5",
  "51304.group_1.temperatureValue6": "温度值6",
  "51304.group_1.temperatureValue7": "温度值7",
  "51304.group_1.temperatureValue8": "温度值8",
  "51304.group_1.temperatureValue9": "温度值9",
  "51304.group_1.temperatureValue10": "温度值10",
  "51304.group_1": "分组_1",
  "51103.group_1.FlowRate": "瞬时流量",
  "51103.group_1.Power": "瞬时功率",
  "51103.group_1.TotalFlow": "累积流量",
  "51103.group_1.HeatEnergy": "累积热量",
  "51103.group_1.CoolEnergy": "累积冷量",
  "51103.group_1.TempInlet": "进水温度",
  "51103.group_1.TempOutlet": "回水温度",
  "51103.group_1.OperatingHours": "累积工作时间",
  "51103.group_1": "分组_1",
  "51302.group_1.voltage": "电压",
  "51302.group_1.current": "电流",
  "51302.group_1.frequency": "频率",
  "51302.group_1.temperature1": "温度1",
  "51302.group_1.voltTransRatio": "电压变比",
  "51302.group_1.currTransRatio": "电流变比",
  "51302.group_1": "分组_1",
  "plant.others": "其他",
  "plant.csp": "光热站",
  "50601.real_time.sn": "SN",
  "50601.real_time.firmwareVersion": "固件版本",
  "50601.real_time.dataServiceProtocolVersion": "⽀持的“数服协议”（即本协议）的版本号",
  "50601.real_time.runningStatus": "运行状态",
  "50601.real_time.faultCode": "故障码",
  "50601.real_time.systemRunningTime": "系统运行时长",
  "50601.real_time.cpuCoreCount": "CPU核心数",
  "50601.real_time.cpuUsageRate": "CPU使用率",
  "50601.real_time.memoryUsageRate": "内存使用率",
  "50601.real_time.totalPhysicalMemory": "总物理内存",
  "50601.real_time.usedMemory": "已用内存",
  "50601.real_time.dnsConfig": "DNS 配置",
  "50601.real_time.defaultGateway": "默认⽹关",
  "50601.real_time.eth1IpAddr": "网口1 IP 地址",
  "50601.real_time.eth1SubnetMask": "网口1⼦⽹掩码",
  "50601.real_time.eth1Status": "网口1状态",
  "50601.real_time.eth2IpAddr": "网口2 IP 地址",
  "50601.real_time.eth2SubnetMask": "网口2⼦⽹掩码",
  "50601.real_time.eth2Status": "网口2状态",
  "50601.real_time.wlanIpAddr": "wlan IP地址",
  "50601.real_time.wlanSubnetMask": "wlan 子⽹掩码",
  "50601.real_time.wlanStatus": "wlan状态",
  "50601.real_time.wifiAccount": "wifi账号",
  "50601.real_time.wifiSignalStrength": "wifi信号强度",
  "50601.real_time.rs485_1Status": "RS485-1状态",
  "50601.real_time.rs485_1CollectDevice": "R485-1采集设备",
  "50601.real_time.rs485_1DeviceSn": "RS485-1设备sn",
  "50601.real_time.rs485_1Reserve": "RS485-1预留",
  "50601.real_time.rs485_2Status": "RS485-2状态",
  "50601.real_time.rs485_2CollectDevice": "R485-2采集设备",
  "50601.real_time.rs485_2DeviceSn": "RS485-2设备sn",
  "50601.real_time.rs485_2Reserve": "RS485-2预留",
  "50601.real_time.rs485_3Status": "RS485-3状态",
  "50601.real_time.rs485_3CollectDevice": "R485-3采集设备",
  "50601.real_time.rs485_3DeviceSn": "RS485-3设备sn",
  "50601.real_time.rs485_3Reserve": "RS485-3预留",
  "50601.real_time.rs485_4Status": "RS485-4状态",
  "50601.real_time.rs485_4CollectDevice": "R485-4采集设备",
  "50601.real_time.rs485_4DeviceSn": "RS485-4设备sn",
  "50601.real_time.rs485_4Reserve": "RS485-4预留",
  "50601.real_time.predictionType": "预测类型",
  "50601.real_time.pvPredictionStartTime": "光伏发电预测开始时间",
  "50601.real_time.pvPredictionPower1": "光伏发电预测电量1",
  "50601.real_time.pvPredictionPower2": "光伏发电预测电量2",
  "50601.real_time.pvPredictionPower3": "光伏发电预测电量3",
  "50601.real_time.pvPredictionPower4": "光伏发电预测电量4",
  "50601.real_time.pvPredictionPower5": "光伏发电预测电量5",
  "50601.real_time.pvPredictionPower6": "光伏发电预测电量6",
  "50601.real_time.pvPredictionPower7": "光伏发电预测电量7",
  "50601.real_time.pvPredictionPower8": "光伏发电预测电量8",
  "50601.real_time.pvPredictionPower9": "光伏发电预测电量9",
  "50601.real_time.pvPredictionPower10": "光伏发电预测电量10",
  "50601.real_time.pvPredictionPower11": "光伏发电预测电量11",
  "50601.real_time.pvPredictionPower12": "光伏发电预测电量12",
  "50601.real_time.pvPredictionPower13": "光伏发电预测电量13",
  "50601.real_time.pvPredictionPower14": "光伏发电预测电量14",
  "50601.real_time.pvPredictionPower15": "光伏发电预测电量15",
  "50601.real_time.pvPredictionPower16": "光伏发电预测电量16",
  "50601.real_time.pvPredictionPower17": "光伏发电预测电量17",
  "50601.real_time.pvPredictionPower18": "光伏发电预测电量18",
  "50601.real_time.pvPredictionPower19": "光伏发电预测电量19",
  "50601.real_time.pvPredictionPower20": "光伏发电预测电量20",
  "50601.real_time.pvPredictionPower21": "光伏发电预测电量21",
  "50601.real_time.pvPredictionPower22": "光伏发电预测电量22",
  "50601.real_time.pvPredictionPower23": "光伏发电预测电量23",
  "50601.real_time.pvPredictionPower24": "光伏发电预测电量24",
  "50601.real_time.pvPredictionPower25": "光伏发电预测电量25",
  "50601.real_time.pvPredictionPower26": "光伏发电预测电量26",
  "50601.real_time.pvPredictionPower27": "光伏发电预测电量27",
  "50601.real_time.pvPredictionPower28": "光伏发电预测电量28",
  "50601.real_time.pvPredictionPower29": "光伏发电预测电量29",
  "50601.real_time.pvPredictionPower30": "光伏发电预测电量30",
  "50601.real_time.pvPredictionPower31": "光伏发电预测电量31",
  "50601.real_time.pvPredictionPower32": "光伏发电预测电量32",
  "50601.real_time.pvPredictionPower33": "光伏发电预测电量33",
  "50601.real_time.pvPredictionPower34": "光伏发电预测电量34",
  "50601.real_time.pvPredictionPower35": "光伏发电预测电量35",
  "50601.real_time.pvPredictionPower36": "光伏发电预测电量36",
  "50601.real_time.pvPredictionPower37": "光伏发电预测电量37",
  "50601.real_time.pvPredictionPower38": "光伏发电预测电量38",
  "50601.real_time.pvPredictionPower39": "光伏发电预测电量39",
  "50601.real_time.pvPredictionPower40": "光伏发电预测电量40",
  "50601.real_time.pvPredictionPower41": "光伏发电预测电量41",
  "50601.real_time.pvPredictionPower42": "光伏发电预测电量42",
  "50601.real_time.pvPredictionPower43": "光伏发电预测电量43",
  "50601.real_time.pvPredictionPower44": "光伏发电预测电量44",
  "50601.real_time.pvPredictionPower45": "光伏发电预测电量45",
  "50601.real_time.pvPredictionPower46": "光伏发电预测电量46",
  "50601.real_time.pvPredictionPower47": "光伏发电预测电量47",
  "50601.real_time.pvPredictionPower48": "光伏发电预测电量48",
  "50601.real_time.pvPredictionPower49": "光伏发电预测电量49",
  "50601.real_time.pvPredictionPower50": "光伏发电预测电量50",
  "50601.real_time.pvPredictionPower51": "光伏发电预测电量51",
  "50601.real_time.pvPredictionPower52": "光伏发电预测电量52",
  "50601.real_time.pvPredictionPower53": "光伏发电预测电量53",
  "50601.real_time.pvPredictionPower54": "光伏发电预测电量54",
  "50601.real_time.pvPredictionPower55": "光伏发电预测电量55",
  "50601.real_time.pvPredictionPower56": "光伏发电预测电量56",
  "50601.real_time.pvPredictionPower57": "光伏发电预测电量57",
  "50601.real_time.pvPredictionPower58": "光伏发电预测电量58",
  "50601.real_time.pvPredictionPower59": "光伏发电预测电量59",
  "50601.real_time.pvPredictionPower60": "光伏发电预测电量60",
  "50601.real_time.pvPredictionPower61": "光伏发电预测电量61",
  "50601.real_time.pvPredictionPower62": "光伏发电预测电量62",
  "50601.real_time.pvPredictionPower63": "光伏发电预测电量63",
  "50601.real_time.pvPredictionPower64": "光伏发电预测电量64",
  "50601.real_time.pvPredictionPower65": "光伏发电预测电量65",
  "50601.real_time.pvPredictionPower66": "光伏发电预测电量66",
  "50601.real_time.pvPredictionPower67": "光伏发电预测电量67",
  "50601.real_time.pvPredictionPower68": "光伏发电预测电量68",
  "50601.real_time.pvPredictionPower69": "光伏发电预测电量69",
  "50601.real_time.pvPredictionPower70": "光伏发电预测电量70",
  "50601.real_time.pvPredictionPower71": "光伏发电预测电量71",
  "50601.real_time.pvPredictionPower72": "光伏发电预测电量72",
  "50601.real_time.pvPredictionPower73": "光伏发电预测电量73",
  "50601.real_time.pvPredictionPower74": "光伏发电预测电量74",
  "50601.real_time.pvPredictionPower75": "光伏发电预测电量75",
  "50601.real_time.pvPredictionPower76": "光伏发电预测电量76",
  "50601.real_time.pvPredictionPower77": "光伏发电预测电量77",
  "50601.real_time.pvPredictionPower78": "光伏发电预测电量78",
  "50601.real_time.pvPredictionPower79": "光伏发电预测电量79",
  "50601.real_time.pvPredictionPower80": "光伏发电预测电量80",
  "50601.real_time.pvPredictionPower81": "光伏发电预测电量81",
  "50601.real_time.pvPredictionPower82": "光伏发电预测电量82",
  "50601.real_time.pvPredictionPower83": "光伏发电预测电量83",
  "50601.real_time.pvPredictionPower84": "光伏发电预测电量84",
  "50601.real_time.pvPredictionPower85": "光伏发电预测电量85",
  "50601.real_time.pvPredictionPower86": "光伏发电预测电量86",
  "50601.real_time.pvPredictionPower87": "光伏发电预测电量87",
  "50601.real_time.pvPredictionPower88": "光伏发电预测电量88",
  "50601.real_time.pvPredictionPower89": "光伏发电预测电量89",
  "50601.real_time.pvPredictionPower90": "光伏发电预测电量90",
  "50601.real_time.pvPredictionPower91": "光伏发电预测电量91",
  "50601.real_time.pvPredictionPower92": "光伏发电预测电量92",
  "50601.real_time.pvPredictionPower93": "光伏发电预测电量93",
  "50601.real_time.pvPredictionPower94": "光伏发电预测电量94",
  "50601.real_time.pvPredictionPower95": "光伏发电预测电量95",
  "50601.real_time.pvPredictionPower96": "光伏发电预测电量96",
  "50601.real_time.pvPredictionAccuracy": "光伏发电预测电量准确度",
  "50601.real_time.predictedPowerGeneration": "预测发电量",
  "50601.real_time.chargeDischargePeriod1": "充放电时段 1",
  "50601.real_time.chargeDischargePeriod2": "充放电时段 2",
  "50601.real_time.chargeDischargePeriod3": "充放电时段 3",
  "50601.real_time.chargeDischargePeriod4": "充放电时段 4",
  "50601.real_time.chargeDischargePeriod5": "充放电时段 5",
  "50601.real_time.chargeDischargePeriod6": "充放电时段 6",
  "50601.real_time.chargeDischargePeriod7": "充放电时段 7",
  "50601.real_time.chargeDischargePeriod8": "充放电时段 8",
  "50601.real_time.chargeDischargePeriod9": "充放电时段 9",
  "50601.real_time.chargeDischargePeriod10": "充放电时段 10",
  "50601.real_time.chargeDischargePeriod11": "充放电时段 11",
  "50601.real_time.chargeDischargePeriod12": "充放电时段 12",
  "50601.real_time.chargeDischargePeriod13": "充放电时段 13",
  "50601.real_time.chargeDischargePeriod14": "充放电时段 14",
  "50601.real_time.chargeDischargePeriod15": "充放电时段 15",
  "50601.real_time.chargeDischargePeriod16": "充放电时段 16",
  "50601.real_time.chargeDischargePeriod17": "充放电时段 17",
  "50601.real_time.chargeDischargePeriod18": "充放电时段 18",
  "50601.real_time.chargeDischargePeriod19": "充放电时段 19",
  "50601.real_time.chargeDischargePeriod20": "充放电时段 20",
  "50601.real_time.chargeDischargePeriod21": "充放电时段 21",
  "50601.real_time.chargeDischargePeriod22": "充放电时段 22",
  "50601.real_time.chargeDischargePeriod23": "充放电时段 23",
  "50601.real_time.chargeDischargePeriod24": "充放电时段 24",
  "50601.real_time.strategyModeChangeTime": "策略模式变化时间",
  "50601.real_time.strategyModeLog": "策略模式日志",
  "50601.real_time.wholeHouseLoadPredictionDate": "全屋负荷预测日期",
  "50601.real_time.wholeHouseLoad24hPredictionPower": "全屋负荷24小时预测电量",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPriceEffectiveDate": "分时段动态电价生效日期",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice1": "分时段动态买电电价1",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice2": "分时段动态买电电价2",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice3": "分时段动态买电电价3",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice4": "分时段动态买电电价4",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice5": "分时段动态买电电价5",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice6": "分时段动态买电电价6",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice7": "分时段动态买电电价7",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice8": "分时段动态买电电价8",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice9": "分时段动态买电电价9",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice10": "分时段动态买电电价10",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice11": "分时段动态买电电价11",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice12": "分时段动态买电电价12",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice13": "分时段动态买电电价13",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice14": "分时段动态买电电价14",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice15": "分时段动态买电电价15",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice16": "分时段动态买电电价16",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice17": "分时段动态买电电价17",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice18": "分时段动态买电电价18",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice19": "分时段动态买电电价19",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice20": "分时段动态买电电价20",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice21": "分时段动态买电电价21",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice22": "分时段动态买电电价22",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice23": "分时段动态买电电价23",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice24": "分时段动态买电电价24",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice1": "分时段动态卖电电价1",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice2": "分时段动态卖电电价2",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice3": "分时段动态卖电电价3",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice4": "分时段动态卖电电价4",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice5": "分时段动态卖电电价5",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice6": "分时段动态卖电电价6",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice7": "分时段动态卖电电价7",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice8": "分时段动态卖电电价8",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice9": "分时段动态卖电电价9",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice10": "分时段动态卖电电价10",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice11": "分时段动态卖电电价11",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice12": "分时段动态卖电电价12",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice13": "分时段动态卖电电价13",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice14": "分时段动态卖电电价14",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice15": "分时段动态卖电电价15",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice16": "分时段动态卖电电价16",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice17": "分时段动态卖电电价17",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice18": "分时段动态卖电电价18",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice19": "分时段动态卖电电价19",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice20": "分时段动态卖电电价20",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice21": "分时段动态卖电电价21",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice22": "分时段动态卖电电价22",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice23": "分时段动态卖电电价23",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice24": "分时段动态卖电电价24",
  "50601.ctrl_suanfakongzhi.energyStorageSOCUpperLimit": "储能SOC上限",
  "50601.ctrl_suanfakongzhi.energyStorageSOCLowerLimit": "储能SOC下限",
  "50601.ctrl_suanfakongzhi.heatPumpSetTemperatureDeltaT": "热泵设置温度差值",
  "50601.ctrl_suanfakongzhi.backupPowerMode": "备电模式",
  "50601.ctrl_suanfakongzhi.backupPowerCapacity": "备电量",
  "50601.ctrl_suanfakongzhi.expectedBackupPowerCompletionTime": "期望备电完成时间",
  "50601.ctrl_suanfakongzhi.heatPumpControllability": "热泵是否可控",
  "50601.ctrl_suanfakongzhi.reserved": "预留字段",
  "50601.ctrl_suanfakongzhi.aiModeSwitch": "AI模式开关",
  "50601.ctrl_suanfakongzhi.basicModeSettings": "基础模式设置",
  "50601.ctrl_suanfakongzhi.aiDispatchMode": "AI调度模式",
  "50601.ctrl_suanfakongzhi.energyManagementAlgorithmRunningStatus": "能量管理算法运行状态",
  "50601.ctrl_suanfakongzhi.photovoltaicInstalledCapacity": "光伏装机容量",
  "50601.ctrl_suanfakongzhi.energyStorageInstalledCapacity": "储能装机容量",
  "50601.ctrl_suanfakongzhi.chargingEfficiency": "充电效率",
  "50601.ctrl_suanfakongzhi.dischargingEfficiency": "放电效率",
  "50601.ctrl_suanfakongzhi.selfDischargeRate": "自放电率",
  "50601.ctrl_suanfakongzhi.depthOfDischarge": "放电深度",
  "50601.ctrl_suanfakongzhi.chargingRate": "充电倍率",
  "50601.ctrl_suanfakongzhi.dischargingRate": "放电倍率",
  "50601.ctrl_kaiguanxinxi.di1SwitchStatusRead": "DI1分合读取",
  "50601.ctrl_kaiguanxinxi.di2SwitchStatusRead": "DI2分合读取",
  "50601.ctrl_kaiguanxinxi.di3SwitchStatusRead": "DI3分合读取",
  "50601.ctrl_kaiguanxinxi.do1SwitchControl": "DO1分合控制",
  "50601.ctrl_kaiguanxinxi.do2SwitchControl": "DO2分合控制",
  "50601.ctrl_kaiguanxinxi.do3SwitchControl": "DO3分合控制",
  "50601.ctrl_xitongxinxi.systemCurrentTime": "系统当前时间",
  "50601.ctrl_xitongxinxi.systemCurrentTimezone": "系统当前时区",
  "50601.ctrl_xitongxinxi.remoteRestart": "远程重启",
  "50601.ctrl_xitongxinxi.restoreFactorySettings": "恢复出厂设置",
  "50601.ctrl_xitongxinxi.dataTransmissionIntervalToNetworkServer": "向⽹络服务器传送数据的间隔时间",
  "50601.ctrl_qixiangxinxi.weatherDataUpdateTime": "气象数据更新时间",
  "50601.ctrl_qixiangxinxi.latitude": "纬度",
  "50601.ctrl_qixiangxinxi.longitude": "经度",
  "50601.ctrl_qixiangxinxi.weatherType": "气象类型",
  "50601.ctrl_qixiangxinxi.reserved0": "预留",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature1": "2米气温1",
  "50601.ctrl_qixiangxinxi.precipitation1": "降水量1",
  "50601.ctrl_qixiangxinxi.scatteringRadiation1": "散射辐射1",
  "50601.ctrl_qixiangxinxi.directRadiation1": "直射辐射1",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation1": "短波辐射1",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity1": "2米相对湿度1",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed1": "10米风速1",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection1": "10米风向1",
  "50601.ctrl_qixiangxinxi.surfacePressure1": "地表气压1",
  "50601.ctrl_qixiangxinxi.reserved1": "预留1",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature2": "2米气温2",
  "50601.ctrl_qixiangxinxi.precipitation2": "降水量2",
  "50601.ctrl_qixiangxinxi.scatteringRadiation2": "散射辐射2",
  "50601.ctrl_qixiangxinxi.directRadiation2": "直射辐射2",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation2": "短波辐射2",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity2": "2米相对湿度2",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed2": "10米风速2",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection2": "10米风向2",
  "50601.ctrl_qixiangxinxi.surfacePressure2": "地表气压2",
  "50601.ctrl_qixiangxinxi.reserved2": "预留2",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature3": "2米气温3",
  "50601.ctrl_qixiangxinxi.precipitation3": "降水量3",
  "50601.ctrl_qixiangxinxi.scatteringRadiation3": "散射辐射3",
  "50601.ctrl_qixiangxinxi.directRadiation3": "直射辐射3",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation3": "短波辐射3",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity3": "2米相对湿度3",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed3": "10米风速3",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection3": "10米风向3",
  "50601.ctrl_qixiangxinxi.surfacePressure3": "地表气压3",
  "50601.ctrl_qixiangxinxi.reserved3": "预留3",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature4": "2米气温4",
  "50601.ctrl_qixiangxinxi.precipitation4": "降水量4",
  "50601.ctrl_qixiangxinxi.scatteringRadiation4": "散射辐射4",
  "50601.ctrl_qixiangxinxi.directRadiation4": "直射辐射4",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation4": "短波辐射4",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity4": "2米相对湿度4",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed4": "10米风速4",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection4": "10米风向4",
  "50601.ctrl_qixiangxinxi.surfacePressure4": "地表气压4",
  "50601.ctrl_qixiangxinxi.reserved4": "预留4",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature5": "2米气温5",
  "50601.ctrl_qixiangxinxi.precipitation5": "降水量5",
  "50601.ctrl_qixiangxinxi.scatteringRadiation5": "散射辐射5",
  "50601.ctrl_qixiangxinxi.directRadiation5": "直射辐射5",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation5": "短波辐射5",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity5": "2米相对湿度5",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed5": "10米风速5",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection5": "10米风向5",
  "50601.ctrl_qixiangxinxi.surfacePressure5": "地表气压5",
  "50601.ctrl_qixiangxinxi.reserved5": "预留5",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature6": "2米气温6",
  "50601.ctrl_qixiangxinxi.precipitation6": "降水量6",
  "50601.ctrl_qixiangxinxi.scatteringRadiation6": "散射辐射6",
  "50601.ctrl_qixiangxinxi.directRadiation6": "直射辐射6",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation6": "短波辐射6",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity6": "2米相对湿度6",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed6": "10米风速6",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection6": "10米风向6",
  "50601.ctrl_qixiangxinxi.surfacePressure6": "地表气压6",
  "50601.ctrl_qixiangxinxi.reserved6": "预留6",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature7": "2米气温7",
  "50601.ctrl_qixiangxinxi.precipitation7": "降水量7",
  "50601.ctrl_qixiangxinxi.scatteringRadiation7": "散射辐射7",
  "50601.ctrl_qixiangxinxi.directRadiation7": "直射辐射7",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation7": "短波辐射7",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity7": "2米相对湿度7",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed7": "10米风速7",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection7": "10米风向7",
  "50601.ctrl_qixiangxinxi.surfacePressure7": "地表气压7",
  "50601.ctrl_qixiangxinxi.reserved7": "预留7",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature8": "2米气温8",
  "50601.ctrl_qixiangxinxi.precipitation8": "降水量8",
  "50601.ctrl_qixiangxinxi.scatteringRadiation8": "散射辐射8",
  "50601.ctrl_qixiangxinxi.directRadiation8": "直射辐射8",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation8": "短波辐射8",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity8": "2米相对湿度8",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed8": "10米风速8",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection8": "10米风向8",
  "50601.ctrl_qixiangxinxi.surfacePressure8": "地表气压8",
  "50601.ctrl_qixiangxinxi.reserved8": "预留8",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature9": "2米气温9",
  "50601.ctrl_qixiangxinxi.precipitation9": "降水量9",
  "50601.ctrl_qixiangxinxi.scatteringRadiation9": "散射辐射9",
  "50601.ctrl_qixiangxinxi.directRadiation9": "直射辐射9",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation9": "短波辐射9",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity9": "2米相对湿度9",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed9": "10米风速9",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection9": "10米风向9",
  "50601.ctrl_qixiangxinxi.surfacePressure9": "地表气压9",
  "50601.ctrl_qixiangxinxi.reserved9": "预留9",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature10": "2米气温10",
  "50601.ctrl_qixiangxinxi.precipitation10": "降水量10",
  "50601.ctrl_qixiangxinxi.scatteringRadiation10": "散射辐射10",
  "50601.ctrl_qixiangxinxi.directRadiation10": "直射辐射10",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation10": "短波辐射10",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity10": "2米相对湿度10",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed10": "10米风速10",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection10": "10米风向10",
  "50601.ctrl_qixiangxinxi.surfacePressure10": "地表气压10",
  "50601.ctrl_qixiangxinxi.reserved10": "预留10",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature11": "2米气温11",
  "50601.ctrl_qixiangxinxi.precipitation11": "降水量11",
  "50601.ctrl_qixiangxinxi.scatteringRadiation11": "散射辐射11",
  "50601.ctrl_qixiangxinxi.directRadiation11": "直射辐射11",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation11": "短波辐射11",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity11": "2米相对湿度11",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed11": "10米风速11",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection11": "10米风向11",
  "50601.ctrl_qixiangxinxi.surfacePressure11": "地表气压11",
  "50601.ctrl_qixiangxinxi.reserved11": "预留11",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature12": "2米气温12",
  "50601.ctrl_qixiangxinxi.precipitation12": "降水量12",
  "50601.ctrl_qixiangxinxi.scatteringRadiation12": "散射辐射12",
  "50601.ctrl_qixiangxinxi.directRadiation12": "直射辐射12",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation12": "短波辐射12",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity12": "2米相对湿度12",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed12": "10米风速12",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection12": "10米风向12",
  "50601.ctrl_qixiangxinxi.surfacePressure12": "地表气压12",
  "50601.ctrl_qixiangxinxi.reserved12": "预留12",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature13": "2米气温13",
  "50601.ctrl_qixiangxinxi.precipitation13": "降水量13",
  "50601.ctrl_qixiangxinxi.scatteringRadiation13": "散射辐射13",
  "50601.ctrl_qixiangxinxi.directRadiation13": "直射辐射13",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation13": "短波辐射13",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity13": "2米相对湿度13",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed13": "10米风速13",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection13": "10米风向13",
  "50601.ctrl_qixiangxinxi.surfacePressure13": "地表气压13",
  "50601.ctrl_qixiangxinxi.reserved13": "预留13",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature14": "2米气温14",
  "50601.ctrl_qixiangxinxi.precipitation14": "降水量14",
  "50601.ctrl_qixiangxinxi.scatteringRadiation14": "散射辐射14",
  "50601.ctrl_qixiangxinxi.directRadiation14": "直射辐射14",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation14": "短波辐射14",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity14": "2米相对湿度14",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed14": "10米风速14",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection14": "10米风向14",
  "50601.ctrl_qixiangxinxi.surfacePressure14": "地表气压14",
  "50601.ctrl_qixiangxinxi.reserved14": "预留14",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature15": "2米气温15",
  "50601.ctrl_qixiangxinxi.precipitation15": "降水量15",
  "50601.ctrl_qixiangxinxi.scatteringRadiation15": "散射辐射15",
  "50601.ctrl_qixiangxinxi.directRadiation15": "直射辐射15",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation15": "短波辐射15",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity15": "2米相对湿度15",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed15": "10米风速15",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection15": "10米风向15",
  "50601.ctrl_qixiangxinxi.surfacePressure15": "地表气压15",
  "50601.ctrl_qixiangxinxi.reserved15": "预留15",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature16": "2米气温16",
  "50601.ctrl_qixiangxinxi.precipitation16": "降水量16",
  "50601.ctrl_qixiangxinxi.scatteringRadiation16": "散射辐射16",
  "50601.ctrl_qixiangxinxi.directRadiation16": "直射辐射16",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation16": "短波辐射16",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity16": "2米相对湿度16",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed16": "10米风速16",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection16": "10米风向16",
  "50601.ctrl_qixiangxinxi.surfacePressure16": "地表气压16",
  "50601.ctrl_qixiangxinxi.reserved16": "预留16",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature17": "2米气温17",
  "50601.ctrl_qixiangxinxi.precipitation17": "降水量17",
  "50601.ctrl_qixiangxinxi.scatteringRadiation17": "散射辐射17",
  "50601.ctrl_qixiangxinxi.directRadiation17": "直射辐射17",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation17": "短波辐射17",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity17": "2米相对湿度17",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed17": "10米风速17",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection17": "10米风向17",
  "50601.ctrl_qixiangxinxi.surfacePressure17": "地表气压17",
  "50601.ctrl_qixiangxinxi.reserved17": "预留17",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature18": "2米气温18",
  "50601.ctrl_qixiangxinxi.precipitation18": "降水量18",
  "50601.ctrl_qixiangxinxi.scatteringRadiation18": "散射辐射18",
  "50601.ctrl_qixiangxinxi.directRadiation18": "直射辐射18",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation18": "短波辐射18",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity18": "2米相对湿度18",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed18": "10米风速18",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection18": "10米风向18",
  "50601.ctrl_qixiangxinxi.surfacePressure18": "地表气压18",
  "50601.ctrl_qixiangxinxi.reserved18": "预留18",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature19": "2米气温19",
  "50601.ctrl_qixiangxinxi.precipitation19": "降水量19",
  "50601.ctrl_qixiangxinxi.scatteringRadiation19": "散射辐射19",
  "50601.ctrl_qixiangxinxi.directRadiation19": "直射辐射19",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation19": "短波辐射19",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity19": "2米相对湿度19",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed19": "10米风速19",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection19": "10米风向19",
  "50601.ctrl_qixiangxinxi.surfacePressure19": "地表气压19",
  "50601.ctrl_qixiangxinxi.reserved19": "预留19",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature20": "2米气温20",
  "50601.ctrl_qixiangxinxi.precipitation20": "降水量20",
  "50601.ctrl_qixiangxinxi.scatteringRadiation20": "散射辐射20",
  "50601.ctrl_qixiangxinxi.directRadiation20": "直射辐射20",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation20": "短波辐射20",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity20": "2米相对湿度20",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed20": "10米风速20",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection20": "10米风向20",
  "50601.ctrl_qixiangxinxi.surfacePressure20": "地表气压20",
  "50601.ctrl_qixiangxinxi.reserved20": "预留20",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature21": "2米气温21",
  "50601.ctrl_qixiangxinxi.precipitation21": "降水量21",
  "50601.ctrl_qixiangxinxi.scatteringRadiation21": "散射辐射21",
  "50601.ctrl_qixiangxinxi.directRadiation21": "直射辐射21",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation21": "短波辐射21",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity21": "2米相对湿度21",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed21": "10米风速21",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection21": "10米风向21",
  "50601.ctrl_qixiangxinxi.surfacePressure21": "地表气压21",
  "50601.ctrl_qixiangxinxi.reserved21": "预留21",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature22": "2米气温22",
  "50601.ctrl_qixiangxinxi.precipitation22": "降水量22",
  "50601.ctrl_qixiangxinxi.scatteringRadiation22": "散射辐射22",
  "50601.ctrl_qixiangxinxi.directRadiation22": "直射辐射22",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation22": "短波辐射22",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity22": "2米相对湿度22",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed22": "10米风速22",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection22": "10米风向22",
  "50601.ctrl_qixiangxinxi.surfacePressure22": "地表气压22",
  "50601.ctrl_qixiangxinxi.reserved22": "预留22",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature23": "2米气温23",
  "50601.ctrl_qixiangxinxi.precipitation23": "降水量23",
  "50601.ctrl_qixiangxinxi.scatteringRadiation23": "散射辐射23",
  "50601.ctrl_qixiangxinxi.directRadiation23": "直射辐射23",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation23": "短波辐射23",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity23": "2米相对湿度23",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed23": "10米风速23",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection23": "10米风向23",
  "50601.ctrl_qixiangxinxi.surfacePressure23": "地表气压23",
  "50601.ctrl_qixiangxinxi.reserved23": "预留23",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature24": "2米气温24",
  "50601.ctrl_qixiangxinxi.precipitation24": "降水量24",
  "50601.ctrl_qixiangxinxi.scatteringRadiation24": "散射辐射24",
  "50601.ctrl_qixiangxinxi.directRadiation24": "直射辐射24",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation24": "短波辐射24",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity24": "2米相对湿度24",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed24": "10米风速24",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection24": "10米风向24",
  "50601.ctrl_qixiangxinxi.surfacePressure24": "地表气压24",
  "50601.ctrl_qixiangxinxi.reserved24": "预留24",
  "50601.group_90614129.otaHttpUrl": "otaHttpUrl",
  "50601.real_time.sn.desc": "设备序列号  ",
  "50601.real_time.firmwareVersion.desc": "设备固件版本号  ",
  "50601.real_time.dataServiceProtocolVersion.desc": "支持的数据协议版本号  ",
  "50601.real_time.runningStatus.desc": "设备运行状态  ",
  "50601.real_time.faultCode.desc": "设备故障代码  ",
  "50601.real_time.systemRunningTime.desc": "系统运行总时长  ",
  "50601.real_time.cpuCoreCount.desc": "CPU核心数量  ",
  "50601.real_time.cpuUsageRate.desc": "CPU使用百分比  ",
  "50601.real_time.memoryUsageRate.desc": "内存使用百分比  ",
  "50601.real_time.totalPhysicalMemory.desc": "总物理内存大小  ",
  "50601.real_time.usedMemory.desc": "已使用内存大小  ",
  "50601.real_time.dnsConfig.desc": "DNS服务器配置  ",
  "50601.real_time.defaultGateway.desc": "默认网关地址  ",
  "50601.real_time.eth1IpAddr.desc": "网口1的IP地址  ",
  "50601.real_time.eth1SubnetMask.desc": "网口1的子网掩码  ",
  "50601.real_time.eth1Status.desc": "网口1的连接状态  ",
  "50601.real_time.eth2IpAddr.desc": "网口2的IP地址  ",
  "50601.real_time.eth2SubnetMask.desc": "网口2的子网掩码  ",
  "50601.real_time.eth2Status.desc": "网口2的连接状态  ",
  "50601.real_time.wlanIpAddr.desc": "无线局域网IP地址  ",
  "50601.real_time.wlanSubnetMask.desc": "无线局域网子网掩码  ",
  "50601.real_time.wlanStatus.desc": "无线局域网状态  ",
  "50601.real_time.wifiAccount.desc": "WiFi网络名称  ",
  "50601.real_time.wifiSignalStrength.desc": "WiFi信号强度  ",
  "50601.real_time.rs485_1Status.desc": "RS485-1接口状态  ",
  "50601.real_time.rs485_1CollectDevice.desc": "连接到RS485-1接口的采集设备信息  ",
  "50601.real_time.rs485_1DeviceSn.desc": "RS485-1接口上设备的序列号  ",
  "50601.real_time.rs485_1Reserve.desc": "RS485-1接口预留字段  ",
  "50601.real_time.rs485_2Status.desc": "RS485-2接口状态  ",
  "50601.real_time.rs485_2CollectDevice.desc": "连接到RS485-2接口的采集设备信息  ",
  "50601.real_time.rs485_2DeviceSn.desc": "RS485-2接口上设备的序列号  ",
  "50601.real_time.rs485_2Reserve.desc": "RS485-2接口预留字段  ",
  "50601.real_time.rs485_3Status.desc": "RS485-3接口状态  ",
  "50601.real_time.rs485_3CollectDevice.desc": "连接到RS485-3接口的采集设备信息  ",
  "50601.real_time.rs485_3DeviceSn.desc": "RS485-3接口上设备的序列号  ",
  "50601.real_time.rs485_3Reserve.desc": "RS485-3接口预留字段  ",
  "50601.real_time.rs485_4Status.desc": "RS485-4接口状态  ",
  "50601.real_time.rs485_4CollectDevice.desc": "连接到RS485-4接口的采集设备信息  ",
  "50601.real_time.rs485_4DeviceSn.desc": "RS485-4接口上设备的序列号  ",
  "50601.real_time.rs485_4Reserve.desc": "RS485-4接口预留字段  ",
  "50601.real_time.predictionType.desc": "预测类型  ",
  "50601.real_time.pvPredictionStartTime.desc": "光伏发电预测开始时间  ",
  "50601.real_time.pvPredictionPower1.desc": "第1时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower2.desc": "第2时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower3.desc": "第3时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower4.desc": "第4时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower5.desc": "第5时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower6.desc": "第6时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower7.desc": "第7时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower8.desc": "第8时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower9.desc": "第9时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower10.desc": "第10时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower11.desc": "第11时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower12.desc": "第12时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower13.desc": "第13时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower14.desc": "第14时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower15.desc": "第15时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower16.desc": "第16时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower17.desc": "第17时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower18.desc": "第18时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower19.desc": "第19时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower20.desc": "第20时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower21.desc": "第21时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower22.desc": "第22时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower23.desc": "第23时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower24.desc": "第24时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower25.desc": "第25时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower26.desc": "第26时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower27.desc": "第27时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower28.desc": "第28时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower29.desc": "第29时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower30.desc": "第30时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower31.desc": "第31时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower32.desc": "第32时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower33.desc": "第33时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower34.desc": "第34时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower35.desc": "第35时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower36.desc": "第36时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower37.desc": "第37时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower38.desc": "第38时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower39.desc": "第39时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower40.desc": "第40时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower41.desc": "第41时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower42.desc": "第42时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower43.desc": "第43时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower44.desc": "第44时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower45.desc": "第45时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower46.desc": "第46时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower47.desc": "第47时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower48.desc": "第48时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower49.desc": "第49时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower50.desc": "第50时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower51.desc": "第51时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower52.desc": "第52时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower53.desc": "第53时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower54.desc": "第54时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower55.desc": "第55时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower56.desc": "第56时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower57.desc": "第57时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower58.desc": "第58时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower59.desc": "第59时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower60.desc": "第60时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower61.desc": "第61时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower62.desc": "第62时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower63.desc": "第63时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower64.desc": "第64时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower65.desc": "第65时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower66.desc": "第66时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower67.desc": "第67时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower68.desc": "第68时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower69.desc": "第69时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower70.desc": "第70时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower71.desc": "第71时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower72.desc": "第72时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower73.desc": "第73时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower74.desc": "第74时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower75.desc": "第75时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower76.desc": "第76时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower77.desc": "第77时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower78.desc": "第78时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower79.desc": "第79时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower80.desc": "第80时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower81.desc": "第81时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower82.desc": "第82时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower83.desc": "第83时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower84.desc": "第84时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower85.desc": "第85时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower86.desc": "第86时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower87.desc": "第87时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower88.desc": "第88时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower89.desc": "第89时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower90.desc": "第90时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower91.desc": "第91时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower92.desc": "第92时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower93.desc": "第93时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower94.desc": "第94时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower95.desc": "第95时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionPower96.desc": "第96时间点光伏发电预测电量  ",
  "50601.real_time.pvPredictionAccuracy.desc": "光伏发电预测电量准确度  ",
  "50601.real_time.predictedPowerGeneration.desc": "预测发电量  ",
  "50601.real_time.chargeDischargePeriod1.desc": "充放电时段1的时间设置  ",
  "50601.real_time.chargeDischargePeriod2.desc": "充放电时段2的时间设置  ",
  "50601.real_time.chargeDischargePeriod3.desc": "充放电时段3的时间设置  ",
  "50601.real_time.chargeDischargePeriod4.desc": "充放电时段4的时间设置  ",
  "50601.real_time.chargeDischargePeriod5.desc": "充放电时段5的时间设置  ",
  "50601.real_time.chargeDischargePeriod6.desc": "充放电时段6的时间设置  ",
  "50601.real_time.chargeDischargePeriod7.desc": "充放电时段7的时间设置  ",
  "50601.real_time.chargeDischargePeriod8.desc": "充放电时段8的时间设置  ",
  "50601.real_time.chargeDischargePeriod9.desc": "充放电时段9的时间设置  ",
  "50601.real_time.chargeDischargePeriod10.desc": "充放电时段10的时间设置  ",
  "50601.real_time.chargeDischargePeriod11.desc": "充放电时段11的时间设置  ",
  "50601.real_time.chargeDischargePeriod12.desc": "充放电时段12的时间设置  ",
  "50601.real_time.chargeDischargePeriod13.desc": "充放电时段13的时间设置  ",
  "50601.real_time.chargeDischargePeriod14.desc": "充放电时段14的时间设置  ",
  "50601.real_time.chargeDischargePeriod15.desc": "充放电时段15的时间设置  ",
  "50601.real_time.chargeDischargePeriod16.desc": "充放电时段16的时间设置  ",
  "50601.real_time.chargeDischargePeriod17.desc": "充放电时段17的时间设置  ",
  "50601.real_time.chargeDischargePeriod18.desc": "充放电时段18的时间设置  ",
  "50601.real_time.chargeDischargePeriod19.desc": "充放电时段19的时间设置  ",
  "50601.real_time.chargeDischargePeriod20.desc": "充放电时段20的时间设置  ",
  "50601.real_time.chargeDischargePeriod21.desc": "充放电时段21的时间设置  ",
  "50601.real_time.chargeDischargePeriod22.desc": "充放电时段22的时间设置  ",
  "50601.real_time.chargeDischargePeriod23.desc": "充放电时段23的时间设置  ",
  "50601.real_time.chargeDischargePeriod24.desc": "充放电时段24的时间设置  ",
  "50601.real_time.strategyModeChangeTime.desc": "策略模式变化的时间  ",
  "50601.real_time.strategyModeLog.desc": "策略模式日志记录  ",
  "50601.real_time.wholeHouseLoadPredictionDate.desc": "全屋负荷预测的日期  ",
  "50601.real_time.wholeHouseLoad24hPredictionPower.desc": "全屋24小时负荷预测电量",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPriceEffectiveDate.desc": "分时段动态电价生效日期",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice1.desc": "分时段动态买电电价1",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice2.desc": "分时段动态买电电价2",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice3.desc": "分时段动态买电电价3",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice4.desc": "分时段动态买电电价4",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice5.desc": "分时段动态买电电价5",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice6.desc": "分时段动态买电电价6",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice7.desc": "分时段动态买电电价7",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice8.desc": "分时段动态买电电价8",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice9.desc": "分时段动态买电电价9",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice10.desc": "分时段动态买电电价10",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice11.desc": "分时段动态买电电价11",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice12.desc": "分时段动态买电电价12",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice13.desc": "分时段动态买电电价13",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice14.desc": "分时段动态买电电价14",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice15.desc": "分时段动态买电电价15",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice16.desc": "分时段动态买电电价16",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice17.desc": "分时段动态买电电价17",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice18.desc": "分时段动态买电电价18",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice19.desc": "分时段动态买电电价19",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice20.desc": "分时段动态买电电价20",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice21.desc": "分时段动态买电电价21",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice22.desc": "分时段动态买电电价22",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice23.desc": "分时段动态买电电价23",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicPurchasePrice24.desc": "分时段动态买电电价24",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice1.desc": "分时段动态卖电电价1",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice2.desc": "分时段动态卖电电价2",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice3.desc": "分时段动态卖电电价3",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice4.desc": "分时段动态卖电电价4",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice5.desc": "分时段动态卖电电价5",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice6.desc": "分时段动态卖电电价6",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice7.desc": "分时段动态卖电电价7",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice8.desc": "分时段动态卖电电价8",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice9.desc": "分时段动态卖电电价9",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice10.desc": "分时段动态卖电电价10",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice11.desc": "分时段动态卖电电价11",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice12.desc": "分时段动态卖电电价12",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice13.desc": "分时段动态卖电电价13",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice14.desc": "分时段动态卖电电价14",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice15.desc": "分时段动态卖电电价15",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice16.desc": "分时段动态卖电电价16",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice17.desc": "分时段动态卖电电价17",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice18.desc": "分时段动态卖电电价18",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice19.desc": "分时段动态卖电电价19",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice20.desc": "分时段动态卖电电价20",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice21.desc": "分时段动态卖电电价21",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice22.desc": "分时段动态卖电电价22",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice23.desc": "分时段动态卖电电价23",
  "50601.ctrl_dongtaidianjia.timeOfUseDynamicSellPrice24.desc": "分时段动态卖电电价24",
  "50601.ctrl_suanfakongzhi.energyStorageSOCUpperLimit.desc": "储能SOC上限",
  "50601.ctrl_suanfakongzhi.energyStorageSOCLowerLimit.desc": "储能SOC下限",
  "50601.ctrl_suanfakongzhi.heatPumpSetTemperatureDeltaT.desc": "热泵设置温度△t",
  "50601.ctrl_suanfakongzhi.backupPowerMode.desc": "备电模式",
  "50601.ctrl_suanfakongzhi.backupPowerCapacity.desc": "备电量",
  "50601.ctrl_suanfakongzhi.expectedBackupPowerCompletionTime.desc": "期望备电完成时间",
  "50601.ctrl_suanfakongzhi.heatPumpControllability.desc": "热泵是否可控",
  "50601.ctrl_suanfakongzhi.reserved.desc": "（预留）",
  "50601.ctrl_suanfakongzhi.aiModeSwitch.desc": "AI模式开关",
  "50601.ctrl_suanfakongzhi.basicModeSettings.desc": "基础模式设置",
  "50601.ctrl_suanfakongzhi.aiDispatchMode.desc": "AI调度模式",
  "50601.ctrl_suanfakongzhi.energyManagementAlgorithmRunningStatus.desc": "能量管理算法运行状态",
  "50601.ctrl_suanfakongzhi.photovoltaicInstalledCapacity.desc": "光伏装机容量",
  "50601.ctrl_suanfakongzhi.energyStorageInstalledCapacity.desc": "储能装机容量",
  "50601.ctrl_suanfakongzhi.chargingEfficiency.desc": "充电效率",
  "50601.ctrl_suanfakongzhi.dischargingEfficiency.desc": "放电效率",
  "50601.ctrl_suanfakongzhi.selfDischargeRate.desc": "自放电率",
  "50601.ctrl_suanfakongzhi.depthOfDischarge.desc": "放电深度",
  "50601.ctrl_suanfakongzhi.chargingRate.desc": "充电倍率",
  "50601.ctrl_suanfakongzhi.dischargingRate.desc": "放电倍率",
  "50601.ctrl_kaiguanxinxi.di1SwitchStatusRead.desc": "1：合位，0：分位，FF：无效",
  "50601.ctrl_kaiguanxinxi.di2SwitchStatusRead.desc": "1：合位，0：分位，FF：无效",
  "50601.ctrl_kaiguanxinxi.di3SwitchStatusRead.desc": "1：合位，0：分位，FF：无效",
  "50601.ctrl_kaiguanxinxi.do1SwitchControl.desc": "1：合位，0：分位，FF：无效",
  "50601.ctrl_kaiguanxinxi.do2SwitchControl.desc": "1：合位，0：分位，FF：无效",
  "50601.ctrl_kaiguanxinxi.do3SwitchControl.desc": "1：合位，0：分位，FF：无效",
  "50601.ctrl_xitongxinxi.systemCurrentTime.desc": "秒级时间戳",
  "50601.ctrl_xitongxinxi.systemCurrentTimezone.desc": "数字时区，如8东八区",
  "50601.ctrl_xitongxinxi.remoteRestart.desc": "固定 1 个字符，编码定义如下：\n0：正常⼯作\n1：重启设备\n默认为 0，当设置为 1 时，重启设备，重启后，该寄存器恢复到默认值",
  "50601.ctrl_xitongxinxi.restoreFactorySettings.desc": "0：保持；1：恢复出厂设置\n下发设置为1后，系统恢复出厂设置并自动重启，重启后恢复为0",
  "50601.ctrl_xitongxinxi.dataTransmissionIntervalToNetworkServer.desc": "取值范围[0,65535],默认为 300。 如字符 300 表⽰间隔时间为 300 秒。",
  "50601.ctrl_qixiangxinxi.weatherDataUpdateTime.desc": "气象数据更新时间",
  "50601.ctrl_qixiangxinxi.latitude.desc": "纬度",
  "50601.ctrl_qixiangxinxi.longitude.desc": "经度",
  "50601.ctrl_qixiangxinxi.weatherType.desc": "气象类型",
  "50601.ctrl_qixiangxinxi.reserved0.desc": "预留",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature1.desc": "2米气温1",
  "50601.ctrl_qixiangxinxi.precipitation1.desc": "降水量1",
  "50601.ctrl_qixiangxinxi.scatteringRadiation1.desc": "散射辐射1",
  "50601.ctrl_qixiangxinxi.directRadiation1.desc": "直射辐射1",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation1.desc": "短波辐射1",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity1.desc": "2米相对湿度1",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed1.desc": "10米风速1",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection1.desc": "10米风向1",
  "50601.ctrl_qixiangxinxi.surfacePressure1.desc": "地表气压1",
  "50601.ctrl_qixiangxinxi.reserved1.desc": "预留1",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature2.desc": "2米气温2",
  "50601.ctrl_qixiangxinxi.precipitation2.desc": "降水量2",
  "50601.ctrl_qixiangxinxi.scatteringRadiation2.desc": "散射辐射2",
  "50601.ctrl_qixiangxinxi.directRadiation2.desc": "直射辐射2",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation2.desc": "短波辐射2",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity2.desc": "2米相对湿度2",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed2.desc": "10米风速2",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection2.desc": "10米风向2",
  "50601.ctrl_qixiangxinxi.surfacePressure2.desc": "地表气压2",
  "50601.ctrl_qixiangxinxi.reserved2.desc": "预留2",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature3.desc": "2米气温3",
  "50601.ctrl_qixiangxinxi.precipitation3.desc": "降水量3",
  "50601.ctrl_qixiangxinxi.scatteringRadiation3.desc": "散射辐射3",
  "50601.ctrl_qixiangxinxi.directRadiation3.desc": "直射辐射3",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation3.desc": "短波辐射3",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity3.desc": "2米相对湿度3",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed3.desc": "10米风速3",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection3.desc": "10米风向3",
  "50601.ctrl_qixiangxinxi.surfacePressure3.desc": "地表气压3",
  "50601.ctrl_qixiangxinxi.reserved3.desc": "预留3",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature4.desc": "2米气温4",
  "50601.ctrl_qixiangxinxi.precipitation4.desc": "降水量4",
  "50601.ctrl_qixiangxinxi.scatteringRadiation4.desc": "散射辐射4",
  "50601.ctrl_qixiangxinxi.directRadiation4.desc": "直射辐射4",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation4.desc": "短波辐射4",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity4.desc": "2米相对湿度4",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed4.desc": "10米风速4",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection4.desc": "10米风向4",
  "50601.ctrl_qixiangxinxi.surfacePressure4.desc": "地表气压4",
  "50601.ctrl_qixiangxinxi.reserved4.desc": "预留4",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature5.desc": "2米气温5",
  "50601.ctrl_qixiangxinxi.precipitation5.desc": "降水量5",
  "50601.ctrl_qixiangxinxi.scatteringRadiation5.desc": "散射辐射5",
  "50601.ctrl_qixiangxinxi.directRadiation5.desc": "直射辐射5",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation5.desc": "短波辐射5",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity5.desc": "2米相对湿度5",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed5.desc": "10米风速5",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection5.desc": "10米风向5",
  "50601.ctrl_qixiangxinxi.surfacePressure5.desc": "地表气压5",
  "50601.ctrl_qixiangxinxi.reserved5.desc": "预留5",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature6.desc": "2米气温6",
  "50601.ctrl_qixiangxinxi.precipitation6.desc": "降水量6",
  "50601.ctrl_qixiangxinxi.scatteringRadiation6.desc": "散射辐射6",
  "50601.ctrl_qixiangxinxi.directRadiation6.desc": "直射辐射6",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation6.desc": "短波辐射6",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity6.desc": "2米相对湿度6",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed6.desc": "10米风速6",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection6.desc": "10米风向6",
  "50601.ctrl_qixiangxinxi.surfacePressure6.desc": "地表气压6",
  "50601.ctrl_qixiangxinxi.reserved6.desc": "预留6",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature7.desc": "2米气温7",
  "50601.ctrl_qixiangxinxi.precipitation7.desc": "降水量7",
  "50601.ctrl_qixiangxinxi.scatteringRadiation7.desc": "散射辐射7",
  "50601.ctrl_qixiangxinxi.directRadiation7.desc": "直射辐射7",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation7.desc": "短波辐射7",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity7.desc": "2米相对湿度7",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed7.desc": "10米风速7",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection7.desc": "10米风向7",
  "50601.ctrl_qixiangxinxi.surfacePressure7.desc": "地表气压7",
  "50601.ctrl_qixiangxinxi.reserved7.desc": "预留7",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature8.desc": "2米气温8",
  "50601.ctrl_qixiangxinxi.precipitation8.desc": "降水量8",
  "50601.ctrl_qixiangxinxi.scatteringRadiation8.desc": "散射辐射8",
  "50601.ctrl_qixiangxinxi.directRadiation8.desc": "直射辐射8",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation8.desc": "短波辐射8",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity8.desc": "2米相对湿度8",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed8.desc": "10米风速8",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection8.desc": "10米风向8",
  "50601.ctrl_qixiangxinxi.surfacePressure8.desc": "地表气压8",
  "50601.ctrl_qixiangxinxi.reserved8.desc": "预留8",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature9.desc": "2米气温9",
  "50601.ctrl_qixiangxinxi.precipitation9.desc": "降水量9",
  "50601.ctrl_qixiangxinxi.scatteringRadiation9.desc": "散射辐射9",
  "50601.ctrl_qixiangxinxi.directRadiation9.desc": "直射辐射9",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation9.desc": "短波辐射9",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity9.desc": "2米相对湿度9",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed9.desc": "10米风速9",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection9.desc": "10米风向9",
  "50601.ctrl_qixiangxinxi.surfacePressure9.desc": "地表气压9",
  "50601.ctrl_qixiangxinxi.reserved9.desc": "预留9",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature10.desc": "2米气温10",
  "50601.ctrl_qixiangxinxi.precipitation10.desc": "降水量10",
  "50601.ctrl_qixiangxinxi.scatteringRadiation10.desc": "散射辐射10",
  "50601.ctrl_qixiangxinxi.directRadiation10.desc": "直射辐射10",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation10.desc": "短波辐射10",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity10.desc": "2米相对湿度10",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed10.desc": "10米风速10",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection10.desc": "10米风向10",
  "50601.ctrl_qixiangxinxi.surfacePressure10.desc": "地表气压10",
  "50601.ctrl_qixiangxinxi.reserved10.desc": "预留10",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature11.desc": "2米气温11",
  "50601.ctrl_qixiangxinxi.precipitation11.desc": "降水量11",
  "50601.ctrl_qixiangxinxi.scatteringRadiation11.desc": "散射辐射11",
  "50601.ctrl_qixiangxinxi.directRadiation11.desc": "直射辐射11",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation11.desc": "短波辐射11",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity11.desc": "2米相对湿度11",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed11.desc": "10米风速11",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection11.desc": "10米风向11",
  "50601.ctrl_qixiangxinxi.surfacePressure11.desc": "地表气压11",
  "50601.ctrl_qixiangxinxi.reserved11.desc": "预留11",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature12.desc": "2米气温12",
  "50601.ctrl_qixiangxinxi.precipitation12.desc": "降水量12",
  "50601.ctrl_qixiangxinxi.scatteringRadiation12.desc": "散射辐射12",
  "50601.ctrl_qixiangxinxi.directRadiation12.desc": "直射辐射12",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation12.desc": "短波辐射12",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity12.desc": "2米相对湿度12",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed12.desc": "10米风速12",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection12.desc": "10米风向12",
  "50601.ctrl_qixiangxinxi.surfacePressure12.desc": "地表气压12",
  "50601.ctrl_qixiangxinxi.reserved12.desc": "预留12",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature13.desc": "2米气温13",
  "50601.ctrl_qixiangxinxi.precipitation13.desc": "降水量13",
  "50601.ctrl_qixiangxinxi.scatteringRadiation13.desc": "散射辐射13",
  "50601.ctrl_qixiangxinxi.directRadiation13.desc": "直射辐射13",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation13.desc": "短波辐射13",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity13.desc": "2米相对湿度13",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed13.desc": "10米风速13",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection13.desc": "10米风向13",
  "50601.ctrl_qixiangxinxi.surfacePressure13.desc": "地表气压13",
  "50601.ctrl_qixiangxinxi.reserved13.desc": "预留13",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature14.desc": "2米气温14",
  "50601.ctrl_qixiangxinxi.precipitation14.desc": "降水量14",
  "50601.ctrl_qixiangxinxi.scatteringRadiation14.desc": "散射辐射14",
  "50601.ctrl_qixiangxinxi.directRadiation14.desc": "直射辐射14",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation14.desc": "短波辐射14",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity14.desc": "2米相对湿度14",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed14.desc": "10米风速14",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection14.desc": "10米风向14",
  "50601.ctrl_qixiangxinxi.surfacePressure14.desc": "地表气压14",
  "50601.ctrl_qixiangxinxi.reserved14.desc": "预留14",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature15.desc": "2米气温15",
  "50601.ctrl_qixiangxinxi.precipitation15.desc": "降水量15",
  "50601.ctrl_qixiangxinxi.scatteringRadiation15.desc": "散射辐射15",
  "50601.ctrl_qixiangxinxi.directRadiation15.desc": "直射辐射15",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation15.desc": "短波辐射15",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity15.desc": "2米相对湿度15",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed15.desc": "10米风速15",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection15.desc": "10米风向15",
  "50601.ctrl_qixiangxinxi.surfacePressure15.desc": "地表气压15",
  "50601.ctrl_qixiangxinxi.reserved15.desc": "预留15",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature16.desc": "2米气温16",
  "50601.ctrl_qixiangxinxi.precipitation16.desc": "降水量16",
  "50601.ctrl_qixiangxinxi.scatteringRadiation16.desc": "散射辐射16",
  "50601.ctrl_qixiangxinxi.directRadiation16.desc": "直射辐射16",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation16.desc": "短波辐射16",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity16.desc": "2米相对湿度16",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed16.desc": "10米风速16",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection16.desc": "10米风向16",
  "50601.ctrl_qixiangxinxi.surfacePressure16.desc": "地表气压16",
  "50601.ctrl_qixiangxinxi.reserved16.desc": "预留16",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature17.desc": "2米气温17",
  "50601.ctrl_qixiangxinxi.precipitation17.desc": "降水量17",
  "50601.ctrl_qixiangxinxi.scatteringRadiation17.desc": "散射辐射17",
  "50601.ctrl_qixiangxinxi.directRadiation17.desc": "直射辐射17",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation17.desc": "短波辐射17",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity17.desc": "2米相对湿度17",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed17.desc": "10米风速17",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection17.desc": "10米风向17",
  "50601.ctrl_qixiangxinxi.surfacePressure17.desc": "地表气压17",
  "50601.ctrl_qixiangxinxi.reserved17.desc": "预留17",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature18.desc": "2米气温18",
  "50601.ctrl_qixiangxinxi.precipitation18.desc": "降水量18",
  "50601.ctrl_qixiangxinxi.scatteringRadiation18.desc": "散射辐射18",
  "50601.ctrl_qixiangxinxi.directRadiation18.desc": "直射辐射18",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation18.desc": "短波辐射18",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity18.desc": "2米相对湿度18",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed18.desc": "10米风速18",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection18.desc": "10米风向18",
  "50601.ctrl_qixiangxinxi.surfacePressure18.desc": "地表气压18",
  "50601.ctrl_qixiangxinxi.reserved18.desc": "预留18",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature19.desc": "2米气温19",
  "50601.ctrl_qixiangxinxi.precipitation19.desc": "降水量19",
  "50601.ctrl_qixiangxinxi.scatteringRadiation19.desc": "散射辐射19",
  "50601.ctrl_qixiangxinxi.directRadiation19.desc": "直射辐射19",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation19.desc": "短波辐射19",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity19.desc": "2米相对湿度19",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed19.desc": "10米风速19",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection19.desc": "10米风向19",
  "50601.ctrl_qixiangxinxi.surfacePressure19.desc": "地表气压19",
  "50601.ctrl_qixiangxinxi.reserved19.desc": "预留19",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature20.desc": "2米气温20",
  "50601.ctrl_qixiangxinxi.precipitation20.desc": "降水量20",
  "50601.ctrl_qixiangxinxi.scatteringRadiation20.desc": "散射辐射20",
  "50601.ctrl_qixiangxinxi.directRadiation20.desc": "直射辐射20",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation20.desc": "短波辐射20",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity20.desc": "2米相对湿度20",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed20.desc": "10米风速20",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection20.desc": "10米风向20",
  "50601.ctrl_qixiangxinxi.surfacePressure20.desc": "地表气压20",
  "50601.ctrl_qixiangxinxi.reserved20.desc": "预留20",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature21.desc": "2米气温21",
  "50601.ctrl_qixiangxinxi.precipitation21.desc": "降水量21",
  "50601.ctrl_qixiangxinxi.scatteringRadiation21.desc": "散射辐射21",
  "50601.ctrl_qixiangxinxi.directRadiation21.desc": "直射辐射21",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation21.desc": "短波辐射21",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity21.desc": "2米相对湿度21",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed21.desc": "10米风速21",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection21.desc": "10米风向21",
  "50601.ctrl_qixiangxinxi.surfacePressure21.desc": "地表气压21",
  "50601.ctrl_qixiangxinxi.reserved21.desc": "预留21",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature22.desc": "2米气温22",
  "50601.ctrl_qixiangxinxi.precipitation22.desc": "降水量22",
  "50601.ctrl_qixiangxinxi.scatteringRadiation22.desc": "散射辐射22",
  "50601.ctrl_qixiangxinxi.directRadiation22.desc": "直射辐射22",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation22.desc": "短波辐射22",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity22.desc": "2米相对湿度22",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed22.desc": "10米风速22",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection22.desc": "10米风向22",
  "50601.ctrl_qixiangxinxi.surfacePressure22.desc": "地表气压22",
  "50601.ctrl_qixiangxinxi.reserved22.desc": "预留22",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature23.desc": "2米气温23",
  "50601.ctrl_qixiangxinxi.precipitation23.desc": "降水量23",
  "50601.ctrl_qixiangxinxi.scatteringRadiation23.desc": "散射辐射23",
  "50601.ctrl_qixiangxinxi.directRadiation23.desc": "直射辐射23",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation23.desc": "短波辐射23",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity23.desc": "2米相对湿度23",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed23.desc": "10米风速23",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection23.desc": "10米风向23",
  "50601.ctrl_qixiangxinxi.surfacePressure23.desc": "地表气压23",
  "50601.ctrl_qixiangxinxi.reserved23.desc": "预留23",
  "50601.ctrl_qixiangxinxi.twoMeterTemperature24.desc": "2米气温24",
  "50601.ctrl_qixiangxinxi.precipitation24.desc": "降水量24",
  "50601.ctrl_qixiangxinxi.scatteringRadiation24.desc": "散射辐射24",
  "50601.ctrl_qixiangxinxi.directRadiation24.desc": "直射辐射24",
  "50601.ctrl_qixiangxinxi.shortwaveRadiation24.desc": "短波辐射24",
  "50601.ctrl_qixiangxinxi.twoMeterRelativeHumidity24.desc": "2米相对湿度24",
  "50601.ctrl_qixiangxinxi.tenMeterWindSpeed24.desc": "10米风速24",
  "50601.ctrl_qixiangxinxi.tenMeterWindDirection24.desc": "10米风向24",
  "50601.ctrl_qixiangxinxi.surfacePressure24.desc": "地表气压24",
  "50601.ctrl_qixiangxinxi.reserved24.desc": "预留24",
  "50601.group_90614129.otaHttpUrl.desc": "ota升级",
  "50601.group_90614129": "ota升级",
  "50601.ctrl_kaiguanxinxi": "开关信息",
  "50601.ctrl_suanfakongzhi": "算法控制",
  "50601.ctrl_xitongxinxi": "系统信息",
  "50601.ctrl_qixiangxinxi": "气象信息",
  "50601.real_time": "real_time",
  "50601.ctrl_dongtaidianjia": "动态电价",
  "50652.realtime_ems.emsPower": "系统输出功率",
  "50652.realtime_ems.emsStatus": "系统运行状态",
  "50652.realtime_ems.emsSOC": "系统SOC",
  "50652.realtime_ems.emsDayChgEnergy": "系统今日充电量",
  "50652.realtime_ems.emsDayDischgEnergy": "系统今日放电量",
  "50652.realtime_pcs.pcsDayChgEnergy": "今日充电量",
  "50652.realtime_pcs.pcsDayDischgEnergy": "今日放电量",
  "50652.realtime_pcs.pcsStatus": "PCS状态",
  "50652.realtime_pcs.pcsFaultStatus": "PCS故障状态",
  "50652.realtime_pcs.pcsOffgridMode": "PCS离并网模式",
  "50652.realtime_pcs.pcsUab": "PCS交流AB线电压",
  "50652.realtime_pcs.pcsUbc": "PCS交流BC线电压",
  "50652.realtime_pcs.pcsUca": "PCS交流CA线电压",
  "50652.realtime_pcs.pcsIa": "PCS交流A相电流",
  "50652.realtime_pcs.pcsIb": "PCS交流B相电流",
  "50652.realtime_pcs.pcsIc": "PCS交流C相电流",
  "50652.realtime_pcs.pcsS": "PCS交流输出视在功率",
  "50652.realtime_pcs.pcsP": "PCS交流输出有功功率",
  "50652.realtime_pcs.pcsQ": "PCS交流输出无功功率",
  "50652.realtime_pcs.pcsFr": "PCS交流电压频率",
  "50652.realtime_pcs.pcsDCVol": "PCS直流电压",
  "50652.realtime_pcs.pcsDCCur": "PCS直流电流",
  "50652.realtime_pcs.pcsTemp": "PCS模块温度",
  "50652.realtime_pcs.pcsPf": "PCS功率因数",
  "50652.realtime_pcs.rdOffgridSwitch": "读离并网切换",
  "50652.realtime_pcs.rdWorkMode": "读工作模式",
  "50652.realtime_pcs.rdPowerSet": "读远程有功功率设定",
  "50652.realtime_pcs.rdOffgridMode": "读离网工作模式",
  "50652.realtime_bms.bmsVol": "电池电压",
  "50652.realtime_bms.bmsCur": "电池电流",
  "50652.realtime_bms.bmsSOC": "电池SOC",
  "50652.realtime_bms.bmsSOH": "电池SOH",
  "50652.realtime_bms.bmsMaxCellVolBMUID": "电池最高单体电压BMU号",
  "50652.realtime_bms.bmsMaxCellVolICSID": "电池最高单体电压箱内序号",
  "50652.realtime_bms.bmsMaxCellVol": "电池最高单体电压",
  "50652.realtime_bms.bmsMinCellVolBMUID": "电池最低单体电压BMU号",
  "50652.realtime_bms.bmsMinCellVolICSID": "电池最低单体电压箱内序号",
  "50652.realtime_bms.bmsMinCellVol": "电池最低单体电压",
  "50652.realtime_bms.bmsMaxCellTempBMUID": "电池最高单体温度BMU号",
  "50652.realtime_bms.bmsMaxCellTempICSID": "电池最高单体温度箱内序号",
  "50652.realtime_bms.bmsMaxCellTemp": "电池最高单体温度",
  "50652.realtime_bms.bmsMinCellTempBMUID": "电池最低单体温度BMU号",
  "50652.realtime_bms.bmsMinCellTempICSID": "电池最低单体温度箱内序号",
  "50652.realtime_bms.bmsMinCellTemp": "电池最低单体温度",
  "50652.realtime_bms.bmsMaxChgCur": "电池请求最大充电电流",
  "50652.realtime_bms.bmsMaxDischgCur": "电池请求最大放电电流",
  "50652.realtime_bms.bmsOneChgEnergy": "电池单次充电量",
  "50652.realtime_bms.bmsOneDischgEnergy": "电池单次放电量",
  "50652.realtime_lcs.outWaterTemp": "出水温度",
  "50652.realtime_lcs.returnWaterTemp": "回水温度",
  "50652.realtime_lcs.envTemp": "液冷环境温度",
  "50652.realtime_lcs.inWaterPressure": "进水口压力值",
  "50652.realtime_lcs.outWaterPressure": "出水口压力值",
  "50652.realtime_lcs.pumpStatus": "水泵开关",
  "50652.realtime_lcs.compressorStatus": "压缩机状态",
  "50652.realtime_lcs.coolUnitStatus": "液冷机组状态",
  "50652.realtime_lcs.nowAlarmLevel": "当前告警等级",
  "50652.fault_lcs.outHighTemp": "出水高温",
  "50652.fault_lcs.outLowTemp": "出水低温",
  "50652.fault_lcs.outTempSensorFault": "出水温感故障",
  "50652.fault_lcs.returnTempSensorFault": "回水温感故障",
  "50652.fault_lcs.vfdComFault": "变频器通讯故障",
  "50652.fault_lcs.sysHighPresLock": "系统高压锁定",
  "50652.fault_lcs.sysLowPresLock": "系统低压锁定",
  "50652.fault_lcs.exhaustOverTempLock": "排气温度过高锁定",
  "50652.fault_lcs.vfdOverCurLock": "变频器过流锁定",
  "50652.fault_lcs.vfdOverTempLock": "变频器过温锁定",
  "50652.fault_lcs.vfdOverVolLock": "变频器过压锁定",
  "50652.fault_lcs.vfdUnderVolLock": "变频器欠压锁定",
  "50652.fault_lcs.vfdPhaseLossLock": "变频器缺相锁定",
  "50652.fault_lcs.vfdOtherFaultLock": "变频器其他故障锁定",
  "50652.fault_lcs.makeupWaterAlarm": "补水告警",
  "50652.fault_lcs.sysHighPresAlarm": "系统压力过高告警",
  "50652.fault_lcs.outHighPresAlarm": "出水压力过高告警",
  "50652.fault_ems.comStatus": "通讯状态",
  "50652.control.powerSet": "有功功率设定",
  "50652.control.onoffSet": "远程开关机设置",
  "50652.realtime_ems.emsStatus.01": "待机",
  "50652.realtime_ems.emsStatus.02": "充电",
  "50652.realtime_ems.emsStatus.03": "放电",
  "50652.realtime_pcs.pcsStatus.01": "待机",
  "50652.realtime_pcs.pcsStatus.02": "充电",
  "50652.realtime_pcs.pcsStatus.03": "放电",
  "50652.realtime_pcs.pcsFaultStatus.00": "正常",
  "50652.realtime_pcs.pcsFaultStatus.01": "故障",
  "50652.realtime_pcs.pcsOffgridMode.00": "并网",
  "50652.realtime_pcs.pcsOffgridMode.01": "离网",
  "50652.realtime_pcs.rdOffgridSwitch.00": "并网",
  "50652.realtime_pcs.rdOffgridSwitch.01": "离网",
  "50652.realtime_pcs.rdWorkMode.00": "计划模式",
  "50652.realtime_pcs.rdWorkMode.01": "手动模式",
  "50652.realtime_pcs.rdWorkMode.02": "远程模式",
  "50652.realtime_pcs.rdOffgridMode.00": "无效",
  "50652.realtime_pcs.rdOffgridMode.01": "确认切换",
  "50652.realtime_lcs.pumpStatus.00": "关闭",
  "50652.realtime_lcs.pumpStatus.01": "开启",
  "50652.realtime_lcs.compressorStatus.00": "关闭",
  "50652.realtime_lcs.compressorStatus.01": "开启",
  "50652.realtime_lcs.coolUnitStatus.00": "关闭",
  "50652.realtime_lcs.coolUnitStatus.01": "自循环",
  "50652.realtime_lcs.coolUnitStatus.02": "制冷",
  "50652.realtime_lcs.coolUnitStatus.03": "制热",
  "50652.fault_lcs.outHighTemp.00": "正常",
  "50652.fault_lcs.outHighTemp.01": "告警",
  "50652.fault_lcs.outLowTemp.00": "正常",
  "50652.fault_lcs.outLowTemp.01": "告警",
  "50652.fault_lcs.outTempSensorFault.00": "正常",
  "50652.fault_lcs.outTempSensorFault.01": "告警",
  "50652.fault_lcs.returnTempSensorFault.00": "正常",
  "50652.fault_lcs.returnTempSensorFault.01": "告警",
  "50652.fault_lcs.vfdComFault.00": "正常",
  "50652.fault_lcs.vfdComFault.01": "告警",
  "50652.fault_lcs.sysHighPresLock.00": "正常",
  "50652.fault_lcs.sysHighPresLock.01": "告警",
  "50652.fault_lcs.sysLowPresLock.00": "正常",
  "50652.fault_lcs.sysLowPresLock.01": "告警",
  "50652.fault_lcs.exhaustOverTempLock.00": "正常",
  "50652.fault_lcs.exhaustOverTempLock.01": "告警",
  "50652.fault_lcs.vfdOverCurLock.00": "正常",
  "50652.fault_lcs.vfdOverCurLock.01": "告警",
  "50652.fault_lcs.vfdOverTempLock.00": "正常",
  "50652.fault_lcs.vfdOverTempLock.01": "告警",
  "50652.fault_lcs.vfdOverVolLock.00": "正常",
  "50652.fault_lcs.vfdOverVolLock.01": "告警",
  "50652.fault_lcs.vfdUnderVolLock.00": "正常",
  "50652.fault_lcs.vfdUnderVolLock.01": "告警",
  "50652.fault_lcs.vfdPhaseLossLock.00": "正常",
  "50652.fault_lcs.vfdPhaseLossLock.01": "告警",
  "50652.fault_lcs.vfdOtherFaultLock.00": "正常",
  "50652.fault_lcs.vfdOtherFaultLock.01": "告警",
  "50652.fault_lcs.makeupWaterAlarm.00": "正常",
  "50652.fault_lcs.makeupWaterAlarm.01": "告警",
  "50652.fault_lcs.sysHighPresAlarm.00": "正常",
  "50652.fault_lcs.sysHighPresAlarm.01": "告警",
  "50652.fault_lcs.outHighPresAlarm.00": "正常",
  "50652.fault_lcs.outHighPresAlarm.01": "告警",
  "50652.fault_ems.comStatus.00": "断开",
  "50652.fault_ems.comStatus.01": "连接",
  "50653.realtime.Ua": "A相电压",
  "50653.realtime.Ub": "B相电压",
  "50653.realtime.Uc": "C相电压",
  "50653.realtime.Uab": "AB线电压",
  "50653.realtime.Ubc": "BC线电压",
  "50653.realtime.Uca": "CA线电压",
  "50653.realtime.Ia": "A相电流",
  "50653.realtime.Ib": "B相电流",
  "50653.realtime.Ic": "C相电流",
  "50653.realtime.Pa": "A相有功总功率",
  "50653.realtime.Pb": "B相有功总功率",
  "50653.realtime.Pc": "C相有功总功率",
  "50653.realtime.P": "总有功功率",
  "50653.realtime.Qa": "A相无功总功率",
  "50653.realtime.Qb": "B相无功总功率",
  "50653.realtime.Qc": "C相无功总功率",
  "50653.realtime.Q": "总无功功率",
  "50653.realtime.Pfa": "A相功率因数",
  "50653.realtime.Pfb": "B相功率因数",
  "50653.realtime.Pfc": "C相功率因数",
  "50653.realtime.Pf": "总功率因数",
  "50653.realtime.Sa": "A相视在功率",
  "50653.realtime.Sb": "B相视在功率",
  "50653.realtime.Sc": "C相视在功率",
  "50653.realtime.S": "总视在功率",
  "50653.realtime.Fr": "频率",
  "50653.realtime.FTAE": "正向总有功电能",
  "50653.realtime.RTAE": "反向总有功电能",
  "50653.realtime.FASE": "正向有功尖电能",
  "50653.realtime.FAPE": "正向峰有功电能",
  "50653.realtime.FAFE": "正向平有功电能",
  "50653.realtime.FAVE": "正向谷有功电能",
  "50653.realtime.FADE": "正向深谷有功电能",
  "50653.realtime.RASE": "反向尖有功电能",
  "50653.realtime.RAPE": "反向峰有功电能",
  "50653.realtime.RAFE": "反向平有功电能",
  "50653.realtime.RAVE": "反向谷有功电能",
  "50653.realtime.RADE": "反向深谷有功电能",
  "50653.fault.comStatus": "通讯状态",
  "50653.fault.comStatus.00": "断开",
  "50653.fault.comStatus.01": "连接",
  "51301.real_time.heatingSetTemperature": "制热设定温度",
  "51301.real_time.hotWaterSetTemperature": "热水设定温度",
  "51301.real_time.floorHeatingSetTemperature": "地暖设定温度",
  "51301.real_time.operatingMode": "设定模式",
  "51301.real_time.onOffControl": "开关机",
  "51301.real_time.compressorOperatingFrequency": "压缩机运行频率",
  "51301.real_time.fanOperatingFrequency": "风机运行频率",
  "51301.real_time.outdoorAmbientTemperature": "外环境温度",
  "51301.real_time.outdoorCoilTemperature": "外盘管(翅片)温度",
  "51301.real_time.indoorCoilTemperature": "内盘管(板换)温度",
  "51301.real_time.suctionGasTemperature": "回气温度",
  "51301.real_time.dischargeGasTemperature": "排气温度",
  "51301.real_time.inletWaterTemperature": "进水温度",
  "51301.real_time.outletWaterTemperature": "出水温度",
  "51301.real_time.waterFlowRate": "水流量",
  "51301.real_time.pvPower": "光伏发电功率",
  "51301.real_time.powerGeneration": "发电量",
  "51301.real_time.pvInputVolt": "光伏输入电压",
  "51301.real_time.pvInputCurr": "光伏输入电流",
  "51301.real_time.gridPower": "电网功率",
  "51301.real_time.gridBuyPower": "电网买电",
  "51301.real_time.heatingSetTemperature.desc": "参数范围：20-60",
  "51301.real_time.hotWaterSetTemperature.desc": "参数范围：20-75",
  "51301.real_time.floorHeatingSetTemperature.desc": "参数范围：20-60",
  "51301.real_time.operatingMode.desc": "0：制冷\n1：制热\n2：热水\n3：地暖\n4：热水+制冷\n5：热水+制热\n6：预留\n7：热水+地暖",
  "51301.real_time.onOffControl.desc": "0：关机/1：开机",
  "51301.real_time.compressorOperatingFrequency.desc": "实测值",
  "51301.real_time.fanOperatingFrequency.desc": "实测值",
  "51301.real_time.outdoorAmbientTemperature.desc": "实测值",
  "51301.real_time.outdoorCoilTemperature.desc": "实测值",
  "51301.real_time.indoorCoilTemperature.desc": "实测值",
  "51301.real_time.suctionGasTemperature.desc": "实测值",
  "51301.real_time.dischargeGasTemperature.desc": "实测值",
  "51301.real_time.inletWaterTemperature.desc": "实测值",
  "51301.real_time.outletWaterTemperature.desc": "实测值",
  "51301.real_time.waterFlowRate.desc": "实测值",
  "51301.real_time.pvPower.desc": "实测值",
  "51301.real_time": "分组_1",
  "50651.realtime_inv.ratedPower": "额定功率",
  "50651.realtime_inv.rdOffStatus": "读远程关机",
  "50651.realtime_inv.rdPowerSet": "读功率设置",
  "50651.realtime_inv.workStatus": "逆变器工作状态",
  "50651.realtime_inv.masterAlarmCode": "主告警码",
  "50651.realtime_inv.subAlarmCode": "子告警码",
  "50651.realtime_inv.masterFaultCode": "主故障码",
  "50651.realtime_inv.subFaultCode": "子故障码",
  "50651.realtime_inv.pbusVol": "PBUS电压",
  "50651.realtime_inv.nbusVol": "NBUS电压",
  "50651.realtime_inv.invRTemp": "INV模块R温度",
  "50651.realtime_inv.invSTemp": "INV模块S温度",
  "50651.realtime_inv.invTTemp": "INV模块T温度",
  "50651.realtime_inv.envTemp": "环境温度",
  "50651.realtime_inv.radiatorTemp": "散热器温度",
  "50651.realtime_inv.Edaily": "当天发电量",
  "50651.realtime_inv.Etotal": "总发电量",
  "50651.realtime_grid.Uab": "RS电网线电压",
  "50651.realtime_grid.Ubc": "ST电网线电压",
  "50651.realtime_grid.Uca": "TR电网线电压",
  "50651.realtime_grid.Ua": "R电网相电压",
  "50651.realtime_grid.Ub": "S电网相电压",
  "50651.realtime_grid.Uc": "T电网相电压",
  "50651.realtime_grid.Ia": "R相并网电流",
  "50651.realtime_grid.Ib": "S相并网电流",
  "50651.realtime_grid.Ic": "T相并网电流",
  "50651.realtime_grid.Fr": "RS电网频率",
  "50651.realtime_grid.P": "有功功率",
  "50651.realtime_grid.Q": "无功功率",
  "50651.realtime_grid.Pf": "功率因数",
  "50651.realtime_pv.Upv1": "PV1电压",
  "50651.realtime_pv.Ipv1": "PV1电流",
  "50651.realtime_pv.Ppv1": "PV1功率",
  "50651.realtime_pv.Upv2": "PV2电压",
  "50651.realtime_pv.Ipv2": "PV2电流",
  "50651.realtime_pv.Ppv2": "PV2功率",
  "50651.realtime_pv.Upv3": "PV3电压",
  "50651.realtime_pv.Ipv3": "PV3电流",
  "50651.realtime_pv.Upv4": "PV4电压",
  "50651.realtime_pv.Ipv4": "PV4电流",
  "50651.realtime_pv.Upv5": "PV5电压",
  "50651.realtime_pv.Ipv5": "PV5电流",
  "50651.realtime_pv.Upv6": "PV6电压",
  "50651.realtime_pv.Ipv6": "PV6电流",
  "50651.realtime_pv.Upv7": "PV7电压",
  "50651.realtime_pv.Ipv7": "PV7电流",
  "50651.realtime_pv.Upv8": "PV8电压",
  "50651.realtime_pv.Ipv8": "PV8电流",
  "50651.realtime_pv.Upv9": "PV9电压",
  "50651.realtime_pv.Ipv9": "PV9电流",
  "50651.realtime_pv.Upv10": "PV10电压",
  "50651.realtime_pv.Ipv10": "PV10电流",
  "50651.realtime_pv.Upv11": "PV11电压",
  "50651.realtime_pv.Ipv11": "PV11电流",
  "50651.realtime_pv.Upv12": "PV12电压",
  "50651.realtime_pv.Ipv12": "PV12电流",
  "50651.realtime_pv.Istr1": "组串1电流",
  "50651.realtime_pv.Istr2": "组串2电流",
  "50651.fault.comStatus": "通讯状态",
  "50651.control.powerSet": "有功功率设置",
  "50651.control.onoffSet": "远程开关机设置",
  "50651.realtime_inv.rdOffStatus.00": "关机",
  "50651.realtime_inv.rdOffStatus.01": "开机",
  "50651.realtime_inv.workStatus.00": "初始化",
  "50651.realtime_inv.workStatus.01": "等待",
  "50651.realtime_inv.workStatus.02": "并网",
  "50651.realtime_inv.workStatus.03": "故障",
  "50651.realtime_inv.workStatus.04": "烧录",
  "50651.realtime_inv.workStatus.05": "离网",
  "50651.realtime_inv.workStatus.06": "旁路",
  "50651.realtime_inv.workStatus.07": "PID修复",
  "50651.realtime_inv.workStatus.08": "PID抑制",
  "50651.realtime_inv.workStatus.09": "除雪模式",
  "50651.fault.comStatus.00": "断开",
  "50651.fault.comStatus.01": "连接",
  "50655.realtime.sn": "SN",
  "50655.realtime.firmwareVersion": "固件版本号",
  "50655.realtime.protocolVersion": "协议版本号",
  "50655.realtime.runningStatus": "运行状态",
  "50655.realtime.faultCode": "故障码",
  "50655.realtime.uptimeHours": "系统运行时长",
  "50655.realtime.cpuCores": "CPU核心数",
  "50655.realtime.cpuUsage": "CPU使用率",
  "50655.realtime.memUsage": "内存使用率",
  "50655.realtime.memTotalMb": "总物理内存",
  "50655.realtime.memUsedMb": "已用内存",
  "50655.realtime.net1IP": "网口1IP地址",
  "50655.realtime.net1Netmask": "网口1⼦⽹掩码",
  "50655.realtime.net1Status": "网口1状态",
  "50655.realtime.net2IP": "网口2IP地址",
  "50655.realtime.net2Netmask": "网口2⼦⽹掩码",
  "50655.realtime.net2Status": "网口2状态",
  "50655.realtime.net3IP": "网口3IP地址",
  "50655.realtime.net3Netmask": "网口3⼦⽹掩码",
  "50655.realtime.net3Status": "网口3状态",
  "50655.realtime.net4IP": "网口4IP地址",
  "50655.realtime.net4Netmask": "网口4⼦⽹掩码",
  "50655.realtime.net4Status": "网口4状态",
  "50655.control.strategyConfig": "策略配置",
  "50655.control.electricityPriceConfig": "电价配置下发",
  "50655.control.modelParameter": "模型参数",
  "50655.control.weatherForecast": "气象预报下发",
  "50655.control.powerForecast": "功率预测数据上报",
  "50655.control.capacityProtection": "变压器容量保护",
  "50655.control.reversePower": "防逆流保护阈值",
  "50655.control.emsProtection": "储能保护",
  "50655.realtime.runningStatus.00": "运行正常",
  "50655.realtime.runningStatus.01": "运行异常",
  "50655.realtime.faultCode.00": "无故障",
  "50655.realtime.faultCode.01": "内存不足",
  "50655.realtime.faultCode.02": "网络异常",
  "50655.realtime.faultCode.03": "CPU过载",
  "50655.realtime.net1Status.00": "未连接",
  "50655.realtime.net1Status.01": "已连接",
  "50655.realtime.net2Status.00": "未连接",
  "50655.realtime.net2Status.01": "已连接",
  "50655.realtime.net3Status.00": "未连接",
  "50655.realtime.net3Status.01": "已连接",
  "50655.realtime.net4Status.00": "未连接",
  "50655.realtime.net4Status.01": "已连接",
  "50654.realtime.WS": "风速",
  "50654.realtime.WF": "风力",
  "50654.realtime.WD": "风向",
  "50654.realtime.WDD": "风向度数",
  "50654.realtime.DPT": "露点温度",
  "50654.realtime.SD": "日照时数",
  "50654.realtime.AH": "空气湿度",
  "50654.realtime.T": "空气温度",
  "50654.realtime.AP": "大气压力",
  "50654.realtime.IL": "光照度",
  "50654.realtime.GR": "总辐射",
  "50654.realtime.PAR": "光和有效辐射",
  "50654.fault.comStatus": "通讯状态",
  "50654.fault.comStatus.00": "断开",
  "50654.fault.comStatus.01": "连接",
  "50901.ctrl_ESS_Advanced_Config-System.meter_model": "电表型号",
  "50901.ctrl_ESS_Advanced_Config-System.brightness": "显示屏亮度",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_config_mode": "柴发端口模式",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_position": "柴发位置",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_type": "柴发类型",
  "50901.ctrl_ESS_Advanced_Config-Generator.min_run_time": "最小运行时间",
  "50901.ctrl_ESS_Advanced_Config-Generator.max_run_time": "最大运行时间",
  "50901.ctrl_ESS_Advanced_Config-Generator.run_protect_threshold": "运行保护间隔",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_sync_time": "柴发同步时间",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_shutdown_delay": "柴发关机延时",
  "50901.ctrl_ESS_Advanced_Config-System.grid_ct_reverse_enable": "Grid CT反向使能",
  "50901.ctrl_ESS_Advanced_Config-System.pv_ct_reverse_enable": "PV CT反向使能",
  "50901.ctrl_ESS_Advanced_Config-System.grid_meter_ratio": "Grid CT电表匝比设置",
  "50901.ctrl_ESS_Advanced_Config-System.pv_meter_ratio": "PV CT电表匝比设置",
  "50901.ctrl_ESS_Advanced_Config-System.mid_gateway_enable": "MID / Gateway使能",
  "50901.ctrl_Config-Grid Profile.country": "国家/并网标准国家",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtFuncCode": "VRT功能码",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtVoltageHighLimit3": "电压上限3",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtVoltageHighLimit3Time": "电压上限3持续时间",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtVoltageHighLimit2": "电压上限2",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtVoltageHighLimit2Time": "电压上限2持续时间",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtVoltageHighLimit1": "电压上限1",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtVoltageHighLimit1Time": "电压上限1持续时间",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtVoltageLowLimit1": "电压下限1",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtVoltageLowLimit1Time": "电压下限1持续时间",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtVoltageLowLimit2": "电压下限2",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtVoltageLowLimit2Time": "电压下限2持续时间",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtVoltageLowLimit3": "电压下限3",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtVoltageLowLimit3Time": "电压下限3持续时间",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtRecoveryStableTime": "VRT恢复稳定时间",
  "50901.ctrl_ESS_Safety_Config-VRT.vrt10MinAvgVoltage": "10分钟平均电压",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtEn": "VRT使能",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtHighLimit": "VRT高电压门限",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtLowLimit": "VRT低电压门限",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtTransientOverVoltage": "瞬时过电压门限",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtTransientOverTime": "瞬时过电压持续时间",
  "50901.ctrl_ESS_Safety_Config-FRT.frtFuncCode": "FRT功能码",
  "50901.ctrl_ESS_Safety_Config-FRT.frtHighLimit3": "频率上限3",
  "50901.ctrl_ESS_Safety_Config-FRT.frtHighLimit3Time": "频率上限3持续时间",
  "50901.ctrl_ESS_Safety_Config-FRT.frtHighLimit2": "频率上限2",
  "50901.ctrl_ESS_Safety_Config-FRT.frtHighLimit2Time": "频率上限2持续时间",
  "50901.ctrl_ESS_Safety_Config-FRT.frtHighLimit1": "频率上限1",
  "50901.ctrl_ESS_Safety_Config-FRT.frtHighLimit1Time": "频率上限1持续时间",
  "50901.ctrl_ESS_Safety_Config-FRT.frtLowLimit1": "频率下限1",
  "50901.ctrl_ESS_Safety_Config-FRT.frtLowLimit1Time": "频率下限1持续时间",
  "50901.ctrl_ESS_Safety_Config-FRT.frtLowLimit2": "频率下限2",
  "50901.ctrl_ESS_Safety_Config-FRT.frtLowLimit2Time": "频率下限2持续时间",
  "50901.ctrl_ESS_Safety_Config-FRT.frtLowLimit3": "频率下限3",
  "50901.ctrl_ESS_Safety_Config-FRT.frtLowLimit3Time": "频率下限3持续时间",
  "50901.ctrl_ESS_Safety_Config-RT.rtFuncCode": "RT功能码",
  "50901.ctrl_ESS_Safety_Config-RT.rtNMTime": "RT_NM时间",
  "50901.ctrl_ESS_Safety_Config-RT.rtSRTTime": "RT_SRT时间",
  "50901.ctrl_ESS_Safety_Config-RT.rtVoltRecoveryHighValue": "RT电压恢复上限值",
  "50901.ctrl_ESS_Safety_Config-RT.rtVoltRecoveryLowValue": "RT电压恢复下限值",
  "50901.ctrl_ESS_Safety_Config-RT.rtFreqRecoveryHighValue": "RT频率恢复上限值",
  "50901.ctrl_ESS_Safety_Config-RT.rtFreqRecoveryLowValue": "RT频率恢复下限值",
  "50901.ctrl_ESS_Safety_Config-RCD.rcdEnable": "RCD使能",
  "50901.ctrl_ESS_Safety_Config-RCD.continueLimitValue": "RCD连续限值电流",
  "50901.ctrl_ESS_Safety_Config-RCD.continueLimitTime": "RCD连续限值时间",
  "50901.ctrl_ESS_Safety_Config-RCD.step1LimitValue": "RCD阶梯1限值电流",
  "50901.ctrl_ESS_Safety_Config-RCD.step1LimitTime": "RCD阶梯1限值时间",
  "50901.ctrl_ESS_Safety_Config-RCD.step2LimitValue": "RCD阶梯2限值电流",
  "50901.ctrl_ESS_Safety_Config-RCD.step2LimitTime": "RCD阶梯2限值时间",
  "50901.ctrl_ESS_Safety_Config-RCD.step3LimitValue": "RCD阶梯3限值电流",
  "50901.ctrl_ESS_Safety_Config-RCD.step3LimitTime": "RCD阶梯3限值时间",
  "50901.ctrl_ESS_Safety_Config-DCI.dciEnable": "DCI使能",
  "50901.ctrl_ESS_Safety_Config-DCI.upperLimit": "DCI上限电流",
  "50901.ctrl_ESS_Safety_Config-DCI.upperTime": "DCI上限时间",
  "50901.ctrl_ESS_Safety_Config-DCI.lowerLimit": "DCI下限电流",
  "50901.ctrl_ESS_Safety_Config-DCI.lowerTime": "DCI下限时间",
  "50901.ctrl_ESS_Safety_Config-GCF.gridLevel2LimitTimeScale": "电网二级限值时间尺度",
  "50901.ctrl_ESS_Safety_Config-GCF.permitEnable": "许可使能",
  "50901.ctrl_ESS_Safety_Config-GCF.drmEnable": "DRM使能",
  "50901.ctrl_ESS_Safety_Config-GCF.antiIslandingEnable": "孤岛防护使能",
  "50901.ctrl_ESS_Safety_Config-RR.rrFuncCode": "RR功能码",
  "50901.ctrl_ESS_Safety_Config-RR.rrRurNm": "RR_RUR_NM",
  "50901.ctrl_ESS_Safety_Config-RR.rrRurSs": "RR_RUR_SS",
  "50901.ctrl_ESS_Safety_Config-FW.fwFuncCode": "FW功能码",
  "50901.ctrl_ESS_Safety_Config-FW.fwEnable": "FW使能",
  "50901.ctrl_ESS_Safety_Config-FW.fwDiffInBatMode": "FW电池模式差异使能",
  "50901.ctrl_ESS_Safety_Config-FW.fwTr": "FW_Tr时间",
  "50901.ctrl_ESS_Safety_Config-FW.fwRecoveryUpperFrequency": "FW恢复频率上限",
  "50901.ctrl_ESS_Safety_Config-FW.fwRecoveryLowerFrequency": "FW恢复频率下限",
  "50901.ctrl_ESS_Safety_Config-FW.fwRecoveryStableTime": "FW恢复稳定时间",
  "50901.ctrl_ESS_Safety_Config-FW.fwOverStartFreq": "FW过频起始频率",
  "50901.ctrl_ESS_Safety_Config-FW.fwOverEndFreq": "FW过频结束频率",
  "50901.ctrl_ESS_Safety_Config-FW.fwOverTransFreq": "FW过频转换频率",
  "50901.ctrl_ESS_Safety_Config-FW.fwUnderStartFreq": "FW欠频起始频率",
  "50901.ctrl_ESS_Safety_Config-FW.fwUnderEndFreq": "FW欠频结束频率",
  "50901.ctrl_ESS_Safety_Config-FW.fwUnderStopFreq": "FW欠频停止频率",
  "50901.ctrl_ESS_Safety_Config-VW.vwFuncCode": "VW功能码",
  "50901.ctrl_ESS_Safety_Config-VW.vwEnable": "VW使能",
  "50901.ctrl_ESS_Safety_Config-VW.vwDiffInBatMode": "VW电池模式差异使能",
  "50901.ctrl_ESS_Safety_Config-VW.vwTr": "VW_Tr时间",
  "50901.ctrl_ESS_Safety_Config-VW.vwRecoveryUpperVoltage": "VW恢复电压上限",
  "50901.ctrl_ESS_Safety_Config-VW.vwRecoveryLowerVoltage": "VW恢复电压下限",
  "50901.ctrl_ESS_Safety_Config-VW.vwRecoveryStableTime": "VW恢复稳定时间",
  "50901.ctrl_ESS_Safety_Config-VW.vwOverStartVolt": "VW过压起始电压",
  "50901.ctrl_ESS_Safety_Config-VW.vwOverEndVolt": "VW过压结束电压",
  "50901.ctrl_ESS_Safety_Config-VW.vwOverKPVolt": "VW过压KP电压/系数电压",
  "50901.ctrl_ESS_Safety_Config-VW.vwUnderStartVolt": "VW欠压起始电压",
  "50901.ctrl_ESS_Safety_Config-VW.vwUnderEndVolt": "VW欠压结束电压",
  "50901.ctrl_ESS_Safety_Config-VW.vwUnderKPVolt": "VW欠压KP电压/系数电压",
  "50901.ctrl_ESS_Safety_Config-RPC.rpcMode": "RPC模式",
  "50901.ctrl_ESS_Safety_Config-RPC.rpcTr": "RPC_Tr时间",
  "50901.ctrl_ESS_Safety_Config-RPC.rpcPf": "RPC功率因数PF",
  "50901.ctrl_ESS_Safety_Config-RPC.rpcReactPowerRatio": "RPC无功功率比例",
  "50901.ctrl_ESS_Safety_Config-RPC.wpfFuncCode": "WPF功能码",
  "50901.ctrl_ESS_Safety_Config-RPC.wpfPowerStartRatio": "WPF功率起始比例",
  "50901.ctrl_ESS_Safety_Config-RPC.wpfPowerEndRatio": "WPF功率结束比例",
  "50901.ctrl_ESS_Safety_Config-RPC.wpfMinPFOver": "WPF过功率最小PF",
  "50901.ctrl_ESS_Safety_Config-RPC.wpfMinPFUnder": "WPF欠功率最小PF",
  "50901.ctrl_ESS_Safety_Config-RPC.wpfLockIn": "WPF锁定投入值",
  "50901.ctrl_ESS_Safety_Config-RPC.wpfLockOut": "WPF锁定退出值",
  "50901.ctrl_ESS_Safety_Config-RPC.vvFuncCode": "Volt-Var功能码",
  "50901.ctrl_ESS_Safety_Config-RPC.vvV1": "Voltage Set Point_V1",
  "50901.ctrl_ESS_Safety_Config-RPC.vvV2": "Voltage Set Point_V2",
  "50901.ctrl_ESS_Safety_Config-RPC.vvV3": "Voltage Set Point_V3",
  "50901.ctrl_ESS_Safety_Config-RPC.vvV4": "Voltage Set Point_V4",
  "50901.ctrl_ESS_Safety_Config-RPC.vvQ1": "Reactive Set Point_Q1",
  "50901.ctrl_ESS_Safety_Config-RPC.vvQ2": "Reactive Set Point_Q2",
  "50901.ctrl_ESS_Safety_Config-RPC.vvQ3": "Reactive Set Point_Q3",
  "50901.ctrl_ESS_Safety_Config-RPC.vvQ4": "Reactive Set Point_Q4",
  "50901.ctrl_ESS_Safety_Config-RPC.vvLockIn": "VV锁定投入值",
  "50901.ctrl_ESS_Safety_Config-RPC.vvLockOut": "VV锁定退出值",
  "50901.ctrl_ESS_Safety_Config-RPC.vvVref": "调压参考值(Vref)",
  "50901.ctrl_ESS_Safety_Config-RPC.vvVrefTr": "调压参考值Tr时间",
  "50901.ctrl_ESS_Safety_Config-GCF.gcfFuncCode": "GCF功能码",
  "50901.ctrl_ESS_Safety_Config-GCF.gcfEn": "GCF使能",
  "50901.ctrl_ESS_Safety_Config-GCF.gcfExportSoftLimitRatio": "GCF外送软限比例",
  "50901.ctrl_ESS_Safety_Config-GCF.gcfExportHardLimitRatio": "GCF外送硬限比例",
  "50901.ctrl_ESS_Safety_Config-GCF.gcfExportHardTime": "GCF外送硬限时间",
  "50901.ctrl_ESS_Safety_Config-GCF.gcfGenerationSoftLimitRatio": "GCF发电软限比例",
  "50901.ctrl_ESS_Safety_Config-GCF.gcfGenerationHardLimitRatio": "GCF发电硬限比例",
  "50901.ctrl_ESS_Safety_Config-GCF.gcfGenerationHardTime": "GCF发电硬限时间",
  "50901.ctrl_ESS_Safety_Config-GCF.gcfReconnectionTime": "GCF重连时间",
  "50901.ctrl_ESS_Safety_Config-PRP.wattRegulationPriority": "瓦特调节优先级",
  "50901.ctrl_ESS_Safety_Config-PRP.pqP6": "PQ_P6",
  "50901.ctrl_ESS_Safety_Config-PRP.pqP5": "PQ_P5",
  "50901.ctrl_ESS_Safety_Config-PRP.pqP4": "PQ_P4",
  "50901.ctrl_ESS_Safety_Config-PRP.pqP3": "PQ_P3",
  "50901.ctrl_ESS_Safety_Config-PRP.pqP2": "PQ_P2",
  "50901.ctrl_ESS_Safety_Config-PRP.pqP1": "PQ_P1",
  "50901.ctrl_ESS_Safety_Config-PRP.pqQ6": "PQ_Q6",
  "50901.ctrl_ESS_Safety_Config-PRP.pqQ5": "PQ_Q5",
  "50901.ctrl_ESS_Safety_Config-PRP.pqQ4": "PQ_Q4",
  "50901.ctrl_ESS_Safety_Config-PRP.pqQ3": "PQ_Q3",
  "50901.ctrl_ESS_Safety_Config-PRP.pqQ2": "PQ_Q2",
  "50901.ctrl_ESS_Safety_Config-PRP.pqQ1": "PQ_Q1",
  "50901.ctrl_ESS_Safety_Config-APC.apcEn": "APC使能",
  "50901.ctrl_ESS_Safety_Config-APC.apcPwrLmt": "APC功率限值",
  "50901.ctrl_ESS_Safety_Config-APC.apcRamp": "APC爬坡率/斜坡",
  "50901.ctrl_ESS_Safety_Config-FW.relayU16NlineRlyTestDis": "继电器N线测试禁用",
  "50901.ctrl_ESS_Safety_Config-GCF.gcfImportLimitRatio": "GCF受电(导入)限值比例",
  "50901.ctrl_ESS_Safety_Config-GCF.gcfImportHardTime": "GCF受电(导入)硬限时间",
  "50901.ctrl_ESS_Safety_Config-GCF.phaseOrderInverseDisable": "相序反向禁用",
  "50901.ctrl_ESS_Safety_Config-APC.fixPfTr": "FixPF_Tr时间",
  "50901.ctrl_ESS_Safety_Config-APC.wpfTr": "WPF_Tr时间",
  "50901.ctrl_ESS_Safety_Config-APC.vvTr": "VV_Tr时间",
  "50901.ctrl_ESS_Safety_Config-APC.pqTr": "PQ_Tr时间",
  "50901.ctrl_ESS_Safety_Config-APC.functionCode": "功能码",
  "50901.ctrl_ESS_Safety_Config-PRP.rpaP1": "RPA_P1",
  "50901.ctrl_ESS_Safety_Config-PRP.rpaQ1": "RPA_Q1",
  "50901.ctrl_ESS_Safety_Config-PRP.rpaP2": "RPA_P2",
  "50901.ctrl_ESS_Safety_Config-PRP.rpaQ2": "RPA_Q2",
  "50901.ctrl_ESS_Safety_Config-FW.fwOverFdroop": "FW过频下垂系数",
  "50901.ctrl_ESS_Safety_Config-FW.fwUnderFdroop": "FW欠频下垂系数",
  "50901.ctrl_ESS_Safety_Config-FW.fwDelayTime": "FW延时",
  "50901.ESS_Safety_Config-APC.pqFuncCode": "PQ功能码",
  "50901.ctrl_ESS_Advanced_Config-System.gridInPowerLimitationWhenValley": "限制网络功率",
  "50901.ctrl_ESS_Advanced_Config-System.threePhaseUnbalanceEnable": "三相不平衡使能",
  "50901.ctrl_ESS_Advanced_Config-Battery.batteryMaxChargePower": "电池最大充电功率",
  "50901.ctrl_ESS_Advanced_Config-Battery.batteryChargingPowerSettingValue": "电池的充电功率设置值",
  "50901.ctrl_ESS_Advanced_Config-Battery.batteryDischargePowerSettingValue": "电池的放电功率设置值",
  "50901.ctrl_ESS_Advanced_Config-Battery.batteryMaxDischargePower": "电池最大放电功率",
  "50901.ctrl_ESS_Advanced_Config-Battery.maxSoc": "最大SOC",
  "50901.ctrl_ESS_Advanced_Config-Battery.minSoc": "最小SOC",
  "50901.ctrl_ESS_Advanced_Config-Battery.replenishPower": "功率补偿",
  "50901.ctrl_ESS_Advanced_Config-Battery.rsvdReplenishPower": "Rsvd补充功率",
  "50901.ctrl_ESS_Advanced_Config-Battery.batGridFeedPowerWhenPeak": "峰值时电网馈电功率",
  "50901.ctrl_ESS_Advanced_Config-Battery.batDischargePowerWhenPartialPeak": "峰值时电池最大放电功率",
  "50901.ctrl_ESS_Advanced_Config-Battery.leadAcidBatReplenishTime": "铅酸电池维护时间",
  "50901.ctrl_ESS_Advanced_Config-PV.mppt_global_scan_enable": "全局扫描使能",
  "50901.ctrl_ESS_Advanced_Config-EPS.bypassDisable": "绕过禁用",
  "50901.ctrl_ESS_Advanced_Config-EPS.epsMode": "EPS模式",
  "50901.ctrl_ESS_Advanced_Config-EPS.pvIslandModeEn": "PV模式使能",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_rated_power": "多机并联下发电机给电池充电功率",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_high_limit_volt": "发电机电压上限",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_low_limit_volt": "发电机电压下限",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_high_limit_freq": "发电机频率上限",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_low_limit_freq": "发电机频率下限",
  "50901.ctrl_Connection.dtu_comm_enable": "DTU通讯使能",
  "50901.ctrl_Device .batActivate": "电池激活",
  "50901.ctrl_Device .systemPowerOnOff": "系统开关机",
  "50901.ctrl_Device .restartSystem": "重启系统",
  "50901.ctrl_Device .restoreDefault": "恢复默认值",
  "50901.ctrl_Device .clearFault": "清除故障",
  "50901.ctrl_Device .selfTest": "自检",
  "50901.ctrl_Device .arcFaultClear": "电弧故障清除",
  "50901.ctrl_Device .batteryBalancing": "电池平衡",
  "50901.ctrl_Device .parallelNetworking": "并行网络",
  "50901.ctrl_Device .meterConfiguration": "仪表配置",
  "50901.real_time.BatteryModel": "电池型号",
  "50901.ctrl_Battery.batteryCapacity": "BMS容量",
  "50901.ctrl_Battery.maximumChargeLimit": "最大充电限制值",
  "50901.ctrl_Battery.maximumDischargeLimit": "最大放电限制值",
  "50901.ctrl_Battery.floatVoltage": "浮动电压",
  "50901.ctrl_Battery.absorptionVoltage": "吸收电压",
  "50901.ctrl_Battery.endOfChargeCurrent": "充电结束电流",
  "50901.ctrl_Battery.equalizationVoltage": "均衡电压",
  "50901.ctrl_Battery.equalizationIntervalDays": "均衡间隔天数",
  "50901.ctrl_Battery.equalizationTime": "均衡时间",
  "50901.ctrl_Battery.temperatureCorrectionFactor": "温度校正系数",
  "50901.ctrl_Battery.initialResistance": "初始阻力",
  "50901.ctrl_Battery.endChargeVoltage": "结束充电电压",
  "50901.ctrl_Battery.equalizationChargeTimeout": "均衡充电超时",
  "50901.ctrl_Battery.equalizationEnable": "均衡启用",
  "50901.ctrl_Dry_Contact_Settings.dryWorkingMode": "干节点工作模式",
  "50901.ctrl_Dry_Contact_Settings-Load_Control.loadControlMode": "负载控制模式",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.manualModeSwitch": "手动模式开关",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange2": "负载控制星期二",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange1": "负载控制星期一",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange4": "负载控制星期四",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange3": "负载控制星期三",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange6": "负载控制星期六",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange5": "负载控制星期五",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange7": "负载控制星期天",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timer1Hour": "定时1起-时",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed1From1Min": "定时1起-分",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed1EndHour": "定时1终-时",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed1EndMinute": "定时1终-分",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timer2Hour": "定时2起-时",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timedFrom2Minutes": "定时2起-分",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed2EndHour": "定时2终-时",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed2EndMinutes": "定时2终-分",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange5": "星期五",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange6": "星期六",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange7": "星期天",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange1": "星期一",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange2": "星期二",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange3": "星期三",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange4": "星期四",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timer1Hour_2": "定时1起_2-时",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed1From1Min_2": "定时1起_2-分",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed1EndHour_2": "定时1终_2-时",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed1EndMinute_2": "定时1终_2-分",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timer2Hour_2": "定时2起_2-时",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timedFrom2Minutes_2": "定时2起_2-分",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed2EndHour_2": "定时2终_2-时",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed2EndMinutes_2": "定时2终_2-分",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange1": "时间范围1",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timer1Hour_3": "时间段1起-时",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed1From1Min_3": "时间段1起-分",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed1EndHour_3": "时间段1终-时",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed1EndMinute_3": "时间段1终-分",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange25": "星期六",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange26": "星期天",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange23": "星期四",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange24": "星期五",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange21": "星期二",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange22": "星期三",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange20": "星期一",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timer2Hour_3": "时间段2起-时",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timedFrom2Minutes_3": "时间段2起-分",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed2EndHour_3": "时间段2终-时",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed2EndMinutes_3": "时间段2终-分",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.minimumOnTime": "负载控制最短接通时间",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.minimumOnLoadPower": "负载模式负载功率阈值",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.offGridProtectionSoc": "离网保护SOC",
  "50901.ctrl_Dry_Contact_Generator.generatorMode": "发电机模式",
  "50901.ctrl_Dry_Contact_Generator.generatorOpenBatteryCapacity": "柴发开启电池容量",
  "50901.ctrl_Dry_Contact_Generator.generatorCloseBatteryCapacity": "柴发关闭电池容量",
  "50901.ctrl_Dry_Contact_Generator.chargeTimeStartH": "发电机控制-充电开始时间-小时",
  "50901.ctrl_Dry_Contact_Generator.chargeTimeStartMin": "发电机控制-充电开始时间-分钟",
  "50901.ctrl_Dry_Contact_Generator.chargeTimeEndH": "发电机控制-充电结束时间-小时",
  "50901.ctrl_Dry_Contact_Generator.chargeTimeEndMin": "发电机控制-充电结束时间-分钟",
  "50901.ctrl_Dry_Contact_Generator.quietTimeEnable": "待机时间启用",
  "50901.ctrl_Dry_Contact_Generator.quietTime1StartH": "待机时间1开始-小时",
  "50901.ctrl_Dry_Contact_Generator.quietTime1StartMin": "待机时间1开始-分钟",
  "50901.ctrl_Dry_Contact_Generator.quietTime1EndH": "待机时间1结束-小时",
  "50901.ctrl_Dry_Contact_Generator.quietTime1EndMin": "待机时间1结束-分钟",
  "50901.ctrl_Dry_Contact_Generator.quietTime2StartH": "待机时间2开始-小时",
  "50901.ctrl_Dry_Contact_Generator.quietTime2StartMin": "待机时间2开始-分钟",
  "50901.ctrl_Dry_Contact_Generator.quietTime2EndH": "待机时间2结束-小时",
  "50901.ctrl_Dry_Contact_Generator.quietTime2EndMin": "待机时间2结束-分红",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeEn": "发电机练习模式",
  "50901.ctrl_Dry_Contact_Generator.genPracticeFreq": "发电机练习模式频率",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeWeek": "发电机练习模式启动时间",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeStartH": "发电机练习模式启动时间-小时",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeStartMin": "发电机练习模式启动时间-分钟",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeRunningTime": "发电机练习模式运行时长",
  "50901.ctrl_WorkMode.workMode": "EMS工作模式",
  "50901.ctrl_WorkMode-Selfuse.selfUsedSoc": "自用SOC",
  "50901.ctrl_WorkMode-Backup.backupSoc": "备用SOC",
  "50901.ctrl_WorkMode-forceCharge.forceChargeSoc": "强制充电SOC",
  "50901.ctrl_WorkMode-forceCharge.maximumChargePower": "最大充电功率",
  "50901.ctrl_WorkMode-forceDischarge.forceDischargeSoc": "强制放电SOC",
  "50901.ctrl_WorkMode-forceDischarge.maximumDischargePower": "最大放电功率",
  "50901.ctrl_WorkMode-economic.economicModeSoc": "经济模式SOC",
  "50901.ctrl_WorkMode-economic.economyModeDateNumber": "经济模式日期编号",
  "50901.ctrl_WorkMode-economic.section1StartMonth": "时段1开始月",
  "50901.ctrl_WorkMode-economic.section1StartDay": "时段1开始天",
  "50901.ctrl_WorkMode-economic.section1StopMonth": "时段1停止月",
  "50901.ctrl_WorkMode-economic.section1StopDay": "时段1停止日",
  "50901.ctrl_WorkMode-economic.section1WeekRange1": "时段1周范围1",
  "50901.ctrl_WorkMode-economic.section1PeakStartHour1": "时段1 峰值开始时间1-小时",
  "50901.ctrl_WorkMode-economic.section1PeakStartMinute1": "时段1 峰值开始时间1-分钟",
  "50901.ctrl_WorkMode-economic.section1PeakStopHour1": "时段1 峰值停止时间1-小时",
  "50901.ctrl_WorkMode-economic.section1PeakStopMinute1": "时段1 峰值停止时间1-分钟",
  "50901.ctrl_WorkMode-economic.section1ValleyStartHour1": "时段1 低谷开始时间1- 小时",
  "50901.ctrl_WorkMode-economic.section1ValleyStartMinute1": "时段1 低谷开始时间1- 分钟",
  "50901.ctrl_WorkMode-economic.section1ValleyStopHour1": "时段1 低谷停止时间1- 小时",
  "50901.ctrl_WorkMode-economic.section1ValleyStopMinute1": "时段1 低谷停止时间1- 分钟",
  "50901.ctrl_WorkMode-economic.section1WeekRange2": "时段1周范围2",
  "50901.ctrl_WorkMode-economic.section1PeakStartHour2": "时段1峰值开始时间2-小时",
  "50901.ctrl_WorkMode-economic.section1PeakStartMinute2": "时段1峰值开始时间2-分钟",
  "50901.ctrl_WorkMode-economic.section1PeakStopHour2": "时段1峰值停止时间2-小时",
  "50901.ctrl_WorkMode-economic.section1PeakStopMinute2": "时段1峰值停止时间2-分钟",
  "50901.ctrl_WorkMode-economic.section1ValleyStartHour2": "时段1低估开始时间2-小时",
  "50901.ctrl_WorkMode-economic.section1ValleyStartMinute2": "时段1低估开始时间2-分钟",
  "50901.ctrl_WorkMode-economic.section1ValleyStopHour2": "时段1低估停止时间2-小时",
  "50901.ctrl_WorkMode-economic.section1ValleyStopMinute2": "时段1低估停止时间2-分钟",
  "50901.ctrl_WorkMode-economic.section2StartMonth": "时段2开始月",
  "50901.ctrl_WorkMode-economic.section2StartDay": "时段2开始天",
  "50901.ctrl_WorkMode-economic.section2StopMonth": "时段2停止月",
  "50901.ctrl_WorkMode-economic.section2StopDay": "时段2停止日",
  "50901.ctrl_WorkMode-economic.section2WeekRange1": "时段2周范围1",
  "50901.ctrl_WorkMode-economic.section2PeakStartHour1": "时段2峰值开始时间1-小时",
  "50901.ctrl_WorkMode-economic.section2PeakStartMinute1": "时段2峰值开始时间1-分钟",
  "50901.ctrl_WorkMode-economic.section2PeakStopHour1": "时段2峰值停止时间1-小时",
  "50901.ctrl_WorkMode-economic.section2PeakStopMinute1": "时段2峰值停止时间1-分钟",
  "50901.ctrl_WorkMode-economic.section2ValleyStartHour1": "时段2低估开始时间1-小时",
  "50901.ctrl_WorkMode-economic.section2ValleyStartMinute1": "时段2低估开始时间1-分钟",
  "50901.ctrl_WorkMode-economic.section2ValleyStopHour1": "时段2低估停止时间1-小时",
  "50901.ctrl_WorkMode-economic.section2ValleyStopMinute1": "时段2低估停止时间1-分钟",
  "50901.ctrl_WorkMode-economic.section2WeekRange2": "时段2周范围2",
  "50901.ctrl_WorkMode-economic.section2PeakStartHour2": "时段2峰值开始时间2-小时",
  "50901.ctrl_WorkMode-economic.section2PeakStartMinute2": "时段2峰值开始时间1-分钟",
  "50901.ctrl_WorkMode-economic.section2PeakStopHour2": "时段2峰值停止时间2-小时",
  "50901.ctrl_WorkMode-economic.section2PeakStopMinute2": "时段2峰值停止时间2-分钟",
  "50901.ctrl_WorkMode-economic.section2ValleyStartHour2": "时段2低估开始时间2-小时",
  "50901.ctrl_WorkMode-economic.section2ValleyStartMinute2": "时段2低估开始时间2-分钟",
  "50901.ctrl_WorkMode-economic.section2ValleyStopHour2": "时段2低估停止时间2-小时",
  "50901.ctrl_WorkMode-economic.section2ValleyStopMinute2": "时段2低估停止时间2-分钟",
  "50901.ctrl_WorkMode-economic.section3StartMonth": "时段3开始月",
  "50901.ctrl_WorkMode-economic.section3StartDay": "时段3开始天",
  "50901.ctrl_WorkMode-economic.section3StopMonth": "时段3停止月",
  "50901.ctrl_WorkMode-economic.section3StopDay": "时段3停止日",
  "50901.ctrl_WorkMode-economic.section3WeekRange1": "时段3周范围1",
  "50901.ctrl_WorkMode-economic.section3PeakStartHour1": "时段3峰值开始时间1-小时",
  "50901.ctrl_WorkMode-economic.section3PeakStartMinute2": "时段3峰值开始时间1-分钟",
  "50901.ctrl_WorkMode-economic.section3PeakStopHour1": "时段3峰值停止时间1-小时",
  "50901.ctrl_WorkMode-economic.section3PeakStopMinute1": "时段3峰值停止时间1-分钟",
  "50901.ctrl_WorkMode-economic.section3ValleyStartHour1": "时段3低谷开始时间1-小时",
  "50901.ctrl_WorkMode-economic.section3ValleyStartMinute1": "时段3低估开始时间1-分钟",
  "50901.ctrl_WorkMode-economic.section3ValleyStopHour1": "时段3低估停止时间1-小时",
  "50901.ctrl_WorkMode-economic.section3ValleyStopMinute1": "时段3低估停止时间1-分钟",
  "50901.ctrl_WorkMode-economic.section3WeekRange2": "时段3周范围2",
  "50901.ctrl_WorkMode-economic.section3PeakStartHour2": "时段3峰值开始时间2-小时",
  "50901.ctrl_WorkMode-economic.section3PeakStartMinute1": "时段3峰值开始时间2-分钟",
  "50901.ctrl_WorkMode-economic.section3PeakStopHour2": "时段3峰值停止时间2-小时",
  "50901.ctrl_WorkMode-economic.section3PeakStopMinute2": "时段3峰值停止时间2-分钟",
  "50901.ctrl_WorkMode-economic.section3ValleyStartHour2": "时段3低估开始时间2-小时",
  "50901.ctrl_WorkMode-economic.section3ValleyStartMinute2": "时段3低估开始时间2-分钟",
  "50901.ctrl_WorkMode-economic.section3ValleyStopHour2": "时段3低估停止时间2-小时",
  "50901.ctrl_WorkMode-economic.section3ValleyStopMinute2": "时段3低估停止时间2-分钟",
  "50901.ctrl_WorkMode-economic.section4StartMonth": "时段4开始月",
  "50901.ctrl_WorkMode-economic.section4StartDay": "时段4开始天",
  "50901.ctrl_WorkMode-economic.section4StopMonth": "时段4停止月",
  "50901.ctrl_WorkMode-economic.section4StopDay": "时段4停止日",
  "50901.ctrl_WorkMode-economic.section4WeekRange1": "时段4周范围1",
  "50901.ctrl_WorkMode-economic.section4PeakStartHour1": "时段4峰值开始时间1-小时",
  "50901.ctrl_WorkMode-economic.section4PeakStartMinute1": "时段4峰值开始时间1-分钟",
  "50901.ctrl_WorkMode-economic.section4PeakStopHour1": "时段4峰值停止时间1-小时",
  "50901.ctrl_WorkMode-economic.section4PeakStopMinute1": "时段4峰值停止时间1-分钟",
  "50901.ctrl_WorkMode-economic.section4ValleyStartHour1": "时段4低估开始时间1-小时",
  "50901.ctrl_WorkMode-economic.section4ValleyStartMinute1": "时段4低估开始时间1-分钟",
  "50901.ctrl_WorkMode-economic.section4ValleyStopHour1": "时段4低估停止时间1-小时",
  "50901.ctrl_WorkMode-economic.section4ValleyStopMinute1": "时段4低估停止时间1-分钟",
  "50901.ctrl_WorkMode-economic.section4WeekRange2": "时段4周范围2",
  "50901.ctrl_WorkMode-economic.section4PeakStartHour2": "时段4峰值开始时间2-小时",
  "50901.ctrl_WorkMode-economic.section4PeakStartMinute2": "时段4峰值开始时间2-分钟",
  "50901.ctrl_WorkMode-economic.section4PeakStopHour2": "时段4峰值停止时间2-小时",
  "50901.ctrl_WorkMode-economic.section4PeakStopMinute2": "时段4峰值停止时间2-分钟",
  "50901.ctrl_WorkMode-economic.section4ValleyStartHour2": "时段4低估开始时间2-小时",
  "50901.ctrl_WorkMode-economic.section4ValleyStartMinute2": "时段4低估开始时间2-分钟",
  "50901.ctrl_WorkMode-economic.section4ValleyStopHour2": "时段4低估停止时间2-小时",
  "50901.ctrl_WorkMode-economic.section4ValleyStopMinute2": "时段4低估停止时间2-分钟",
  "50901.ctrl_Battery.batteryHealing": "电池恢复",
  "50901.ctrl_WorkMode-peakMeter.peakMeterSoc": "峰值计SOC",
  "50901.ctrl_WorkMode-peakMeter.peakMeterPower": "峰值仪表功率",
  "50901.ctrl_WorkMode-TOU.timeOfUseRange": "TOU模式时间范围",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime1ChrgStartH": "使用时间时段1充电起始-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime1ChrgStartMin": "使用时间时段1充电起始-\n分钟\n",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime1ChrgEndH": "使用时间时段1充电结束-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime1ChrgEndMin": "使用时间时段1充电结束-分钟",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime1ChrgPower": "充电功率",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime1ChrgStopSoc": "充电截止容量",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime1DischrgStartH": "使用时间时段1放电起始-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime1DischrgStartMin": "使用时间时段1放电起始-分钟",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime1DischrgEndH": "使用时间时段1放电结束-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime1DischrgEndMin": "使用时间时段1放电结束-分钟",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime1DischrgPower": "放电功率",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime1DischrgStopSoc": "放电截止容量",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime2ChrgStartH": "使用时间时段2充电起始-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime2ChrgStartMin": "使用时间时段2充电起始-\n分钟\n",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime2ChrgEndH": "使用时间时段2充电结束-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime2ChrgEndMin": "使用时间时段2充电结束-分钟",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime2ChrgPower": "充电功率",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime2ChrgStopSoc": "充电截止容量",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime2DischrgStartH": "使用时间时段2放电起始-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime2DischrgStartMin": "使用时间时段2放电起始-分钟",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime2DischrgEndH": "使用时间时段2放电结束-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime2DischrgEndMin": "使用时间时段2放电结束-分钟",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime2DischrgPower": "放电功率",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime2DischrgStopSoc": "放电截止容量",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime3ChrgStartH": "使用时间时段3充电起始-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime3ChrgStartMin": "使用时间时段3充电起始-\n分钟\n",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime3ChrgEndH": "使用时间时段3充电结束-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime3ChrgEndMin": "使用时间时段3充电结束-分钟",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime3ChrgPower": "充电功率",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime3ChrgStopSoc": "充电截止容量",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime3DischrgStartH": "使用时间时段3放电起始-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime3DischrgStartMin": "使用时间时段3放电起始-分钟",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime3DischrgEndH": "使用时间时段3放电结束-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime3DischrgEndMin": "使用时间时段3放电结束-分钟",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime3DischrgPower": "放电功率",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime3DischrgStopSoc": "放电截止容量",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime4ChrgStartH": "使用时间时段4充电起始-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime4ChrgStartMin": "使用时间时段4充电起始-\n分钟\n",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime4ChrgEndH": "使用时间时段4充电结束-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime4ChrgEndMin": "使用时间时段4充电结束-分钟",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime4ChrgPower": "充电功率",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime4ChrgStopSoc": "充电截止容量",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime4DischrgStartH": "使用时间时段4放电起始-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime4DischrgStartMin": "使用时间时段4放电起始-分钟",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime4DischrgEndH": "使用时间时段4放电结束-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime4DischrgEndMin": "使用时间时段4放电结束-分钟",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime4DischrgPower": "放电功率",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime4DischrgStopSoc": "放电截止功率",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime5ChrgStartH": "使用时间时段5充电起始-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime5ChrgStartMin": "使用时间时段5充电起始-\n分钟\n",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime5ChrgEndH": "使用时间时段5充电结束-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime5ChrgEndMin": "使用时间时段5充电结束-分钟",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime5ChrgPower": "充电功率",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime5ChrgStopSoc": "充电截止容量",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime5DischrgStartH": "使用时间时段5放电起始-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime5DischrgStartMin": "使用时间时段5放电起始-分钟",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime5DischrgEndH": "使用时间时段5放电结束-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime5DischrgEndMin": "使用时间时段5放电结束-分钟",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime5DischrgPower": "放电功率",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime5DischrgStopSoc": "放电截止容量",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime6ChrgStartH": "使用时间时段6充电起始-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime6ChrgStartMin": "使用时间时段6充电起始-\n分钟\n",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime6ChrgEndH": "使用时间时段6充电结束-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime6ChrgEndMin": "使用时间时段6充电结束-分钟",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime6ChrgPower": "充电功率",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime6ChrgStopSoc": "充电截止容量",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime6DischrgStartH": "使用时间时段6放电起始-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime6DischrgStartMin": "使用时间时段6放电起始-分钟",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime6DischrgEndH": "使用时间时段6放电结束-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime6DischrgEndMin": "使用时间时段6放电结束-分钟",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime6DischrgPower": "放电功率",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime6DischrgStopSoc": "放电截止容量",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime7ChrgStartH": "使用时间时段7充电起始-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime7ChrgStartMin": "使用时间时段7充电起始-\n分钟\n",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime7ChrgEndH": "使用时间时段7充电结束-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime7ChrgEndMin": "使用时间时段7充电结束-分钟",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime7ChrgPower": "放电功率",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime7ChrgStopSoc": "放电截止容量",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime7DischrgStartH": "使用时间时段7放电起始-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime7DischrgStartMin": "使用时间时段7放电起始-分钟",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime7DischrgEndH": "使用时间时段7放电结束-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime7DischrgEndMin": "使用时间时段7放电结束-分钟",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime7DischrgPower": "放电功率",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime7DischrgStopSoc": "放电截止容量",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime8ChrgStartH": "使用时间时段8充电起始-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime8ChrgStartMin": "使用时间时段8充电起始-\n分钟\n",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime8ChrgEndH": "使用时间时段8充电结束-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime8ChrgEndMin": "使用时间时段8充电结束-分钟",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime8ChrgPower": "充电功率",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime8ChrgStopSoc": "充电截止容量",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime8DischrgStartH": "使用时间时段8放电起始-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime8DischrgStartMin": "使用时间时段8放电起始-分钟",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime8DischrgEndH": "使用时间时段8放电结束-小时",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime8DischrgEndMin": "使用时间时段8放电结束-分钟",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime8DischrgPower": "放电功率",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime8DischrgStopSoc": "放电截止容量",
  "50901.ctrl_ClockSetting.ClockSetting": "时钟设置",
  "50901.ctrl_ClockSetting.clockSetting_year": "时钟设置-year",
  "50901.ctrl_ClockSetting.clockSetting_month": "时钟设置-month",
  "50901.ctrl_ClockSetting.clockSetting_day": "时钟设置-day",
  "50901.ctrl_ClockSetting.clockSetting_hour": "时钟设置-hour",
  "50901.ctrl_ClockSetting.clockSetting_minute": "时钟设置-minute",
  "50901.ctrl_ClockSetting.clockSetting_second": "时钟设置-second",
  "50901.ctrl_ClockSetting.clockSetting_weekday": "时钟设置-weekday",
  "50901.ctrl_Gateway.gatewayCommunicationAddress": "网关通信地址",
  "50901.ctrl_Gateway.boardAmbientTemperatureThreshold": "电路板环境温度阈值",
  "50901.ctrl_Gateway.ambientTemperatureThreshold": "环境温度阈值",
  "50901.ctrl_Connection.connectionRouterStatus": "连接路由器状态",
  "50901.ctrl_Connection.connectionServerStatus": "连接器服务状态",
  "50901.ctrl_Connection.absoluteTime": "绝对时间",
  "50901.ctrl_Connection.timeZone": "时区",
  "50901.ctrl_Connection.dfs": "能力集",
  "50901.ctrl_Device.masterSlave": "主机/从机",
  "50901.real_time.numberOfUnits": "机器数量",
  "50901.real_time.materType": "电表类型",
  "50901.warning.canCommunicationTimeout": "CAN通信超时",
  "50901.warning.lowBatteryEnergy": "电池电量过低",
  "50901.warning.hardwareProtection": "硬件保护",
  "50901.Fault.evCharger1CommunicationAbnormality": "充电桩 1 通讯异常",
  "50901.Fault.bmsCanCommunicationAbnormality": "BMS CAN 通讯异常",
  "50901.Fault.dtu3Rs485CommunicationAbnormality": "DTU3 RS485 通讯异常",
  "50901.Fault.gridMeterTypeError": "电网电表型号错误",
  "50901.Fault.lowDtuVersion": "DTU 版本过低",
  "50901.Fault.gridMeterCommunicationAbnormality": "电网电表通讯异常",
  "50901.Fault.pvMeterTypeError": "光伏电表型号错误",
  "50901.Fault.dspPwrCommunicationAbnormality": "DSP_PWR 通讯异常",
  "50901.Fault.evCharger2CommunicationAbnormality": "充电桩 2 通讯异常",
  "50901.Fault.dtu5Rs485CommunicationAbnormality": "DTU5 RS485 通讯异常",
  "50901.Fault.dtsCommunicationAbnormality": "DTS 设备通讯异常",
  "50901.Fault.dtu4Rs485CommunicationAbnormality": "DTU4 RS485 通讯异常",
  "50901.Fault.dtu1Rs485CommunicationAbnormality": "DTU1 RS485 通讯异常",
  "50901.Fault.pvMeterCommunicationAbnormality": "光伏电表通讯异常",
  "50901.Fault.slaveWrongBatteryConnection": "从机电池接线错误（多 PCS 单电池场景）",
  "50901.Fault.dtu2Rs485CommunicationAbnormality": "DTU2 RS485 通讯异常",
  "50901.Fault.dspSafCommunicationAbnormality": "DSP_SAF 通讯异常",
  "50901.Fault.sustainedNegativeLoad": "持续负载",
  "50901.Fault.hmidMachineFault": "人机交互模块硬件故障",
  "50901.Fault.evCharger1Fault": "EV 充电器 1 故障",
  "50901.Fault.evCharger2Fault": "EV 充电器 2 故障",
  "50901.Fault.fanSpeedAbnormality": "风扇转速异常",
  "50901.Fault.batteryFault": "电池故障",
  "50901.Fault.masterSlaveCommunicationAbnormality": "主从通讯异常",
  "50901.Fault.batteryCapacityAbnormality": "电池容量异常",
  "50901.Fault.batteryForceChargeRequest": "电池强制充电请求",
  "50901.Fault.hmidCommunicationAbnormality": "人机交互模块通讯异常",
  "50901.ctrl_Device.networkingType": "联网类型",
  "50901.ctrl_Device.checkTime": "设备时间",
  "50901.real_time.dTSReset": "数据棒复位",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.homeInletBreakerRatedCurrent": "入户空开额定电流",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.chargingPileRatedCurrent": "充电桩额定电流",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timerModeBatterySocEnable": "定时模式-电池SOC使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timerModeBatteryStartSoc": "定时模式-电池启动SOC",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timerModeBatteryStopSoc": "定时模式-电池关闭SOC",
  "50901.ctrl_WorkMode-TOU.touModeReserveSoc": "TOU模式预留SOC",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_config_mode.00": "禁止",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_config_mode.01": "外接光伏",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_config_mode.02": "外接柴发",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_config_mode.03": "force on",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_config_mode.04": "load control",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_position.00": "无",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_position.01": "柴发侧",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_position.02": "电网侧",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_type.00": "手动",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_type.01": "DI/DO",
  "50901.ctrl_ESS_Advanced_Config-System.grid_ct_reverse_enable.00": "disable",
  "50901.ctrl_ESS_Advanced_Config-System.grid_ct_reverse_enable.01": "enable",
  "50901.ctrl_ESS_Advanced_Config-System.pv_ct_reverse_enable.00": "disable",
  "50901.ctrl_ESS_Advanced_Config-System.pv_ct_reverse_enable.01": "enable",
  "50901.ctrl_ESS_Advanced_Config-System.mid_gateway_enable.00": "disable",
  "50901.ctrl_ESS_Advanced_Config-System.mid_gateway_enable.01": "enable",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtEn.00": "disable",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtEn.01": "enable",
  "50901.ctrl_ESS_Safety_Config-RCD.rcdEnable.00": "disable",
  "50901.ctrl_ESS_Safety_Config-RCD.rcdEnable.01": "enable",
  "50901.ctrl_ESS_Safety_Config-DCI.dciEnable.00": "disable",
  "50901.ctrl_ESS_Safety_Config-DCI.dciEnable.01": "enable",
  "50901.ctrl_ESS_Safety_Config-GCF.permitEnable.00": "disable",
  "50901.ctrl_ESS_Safety_Config-GCF.permitEnable.01": "enable",
  "50901.ctrl_ESS_Safety_Config-GCF.drmEnable.00": "disable",
  "50901.ctrl_ESS_Safety_Config-GCF.drmEnable.01": "enable",
  "50901.ctrl_ESS_Safety_Config-GCF.antiIslandingEnable.00": "disable",
  "50901.ctrl_ESS_Safety_Config-GCF.antiIslandingEnable.01": "enable",
  "50901.ctrl_ESS_Safety_Config-FW.fwEnable.00": "disable",
  "50901.ctrl_ESS_Safety_Config-FW.fwEnable.01": "enable",
  "50901.ctrl_ESS_Safety_Config-FW.fwDiffInBatMode.00": "disable",
  "50901.ctrl_ESS_Safety_Config-FW.fwDiffInBatMode.01": "enable",
  "50901.ctrl_ESS_Safety_Config-VW.vwEnable.00": "disable",
  "50901.ctrl_ESS_Safety_Config-VW.vwEnable.01": "enable",
  "50901.ctrl_ESS_Safety_Config-VW.vwDiffInBatMode.00": "disable",
  "50901.ctrl_ESS_Safety_Config-VW.vwDiffInBatMode.01": "enable",
  "50901.ctrl_ESS_Safety_Config-RPC.rpcMode.00": "disable",
  "50901.ctrl_ESS_Safety_Config-RPC.rpcMode.01": "Fixed Power Factor, PF Mode",
  "50901.ctrl_ESS_Safety_Config-RPC.rpcMode.02": "Fixed Reactive Power, Q Mode",
  "50901.ctrl_ESS_Safety_Config-RPC.rpcMode.03": "PF(P) Curve, PF(P) Mode",
  "50901.ctrl_ESS_Safety_Config-RPC.rpcMode.04": "W",
  "50901.ctrl_ESS_Safety_Config-RPC.rpcMode.05": "PQ",
  "50901.ctrl_ESS_Safety_Config-GCF.gcfEn.00": "disable",
  "50901.ctrl_ESS_Safety_Config-GCF.gcfEn.01": "enable",
  "50901.ctrl_ESS_Safety_Config-APC.apcEn.00": "disable",
  "50901.ctrl_ESS_Safety_Config-APC.apcEn.01": "enable",
  "50901.ctrl_ESS_Safety_Config-FW.relayU16NlineRlyTestDis.00": "disable",
  "50901.ctrl_ESS_Safety_Config-FW.relayU16NlineRlyTestDis.01": "enable",
  "50901.ctrl_ESS_Safety_Config-GCF.phaseOrderInverseDisable.00": "disable",
  "50901.ctrl_ESS_Safety_Config-GCF.phaseOrderInverseDisable.01": "enable",
  "50901.ctrl_ESS_Advanced_Config-PV.mppt_global_scan_enable.00": "不使能",
  "50901.ctrl_ESS_Advanced_Config-PV.mppt_global_scan_enable.01": "使能",
  "50901.ctrl_ESS_Advanced_Config-EPS.bypassDisable.00": "否",
  "50901.ctrl_ESS_Advanced_Config-EPS.bypassDisable.01": "是",
  "50901.ctrl_ESS_Advanced_Config-EPS.epsMode.00": "禁用",
  "50901.ctrl_ESS_Advanced_Config-EPS.epsMode.01": "应急电源",
  "50901.ctrl_ESS_Advanced_Config-EPS.epsMode.02": "不间断电源",
  "50901.ctrl_ESS_Advanced_Config-EPS.pvIslandModeEn.00": "否",
  "50901.ctrl_ESS_Advanced_Config-EPS.pvIslandModeEn.01": "是",
  "50901.ctrl_Connection.dtu_comm_enable.00": "disable",
  "50901.ctrl_Connection.dtu_comm_enable.01": "enable",
  "50901.ctrl_Device .restartSystem.00": "否",
  "50901.ctrl_Device .restartSystem.01": "是",
  "50901.ctrl_Device .parallelNetworking.00": "无效",
  "50901.ctrl_Device .parallelNetworking.01": "组网中",
  "50901.ctrl_Device .parallelNetworking.02": "解散组网",
  "50901.ctrl_Device .meterConfiguration.00": "无电表类型",
  "50901.ctrl_Device .meterConfiguration.01": "配置电网电表",
  "50901.real_time.BatteryModel.22": "HOY LV",
  "50901.real_time.BatteryModel.23": "HOY HV",
  "50901.real_time.BatteryModel.01": "Pylon LV",
  "50901.real_time.BatteryModel.24": "FEB LV",
  "50901.real_time.BatteryModel.02": "Pylon HV",
  "50901.real_time.BatteryModel.25": "UHhome LV",
  "50901.real_time.BatteryModel.03": "Dyness LV",
  "50901.real_time.BatteryModel.26": "UHhome HV",
  "50901.real_time.BatteryModel.04": "Dyness HV",
  "50901.real_time.BatteryModel.27": "BYD HV",
  "50901.real_time.BatteryModel.05": "Sunwoda LV",
  "50901.real_time.BatteryModel.28": "Vestwoods HV",
  "50901.real_time.BatteryModel.06": "Uz LV",
  "50901.real_time.BatteryModel.29": "Phylion HV",
  "50901.real_time.BatteryModel.07": "Soluna HV",
  "50901.real_time.BatteryModel.08": "Soluna LV",
  "50901.real_time.BatteryModel.09": "Steltec LV",
  "50901.real_time.BatteryModel.30": "Hoymiles LV",
  "50901.real_time.BatteryModel.31": "Pholion LV",
  "50901.real_time.BatteryModel.10": "Xin Yi LV",
  "50901.real_time.BatteryModel.32": "Wattsonic LV",
  "50901.real_time.BatteryModel.11": "Vestwoods LV",
  "50901.real_time.BatteryModel.33": "Enershare HV",
  "50901.real_time.BatteryModel.12": "JK HV",
  "50901.real_time.BatteryModel.34": "Beghelli LV",
  "50901.real_time.BatteryModel.13": "BYD LV",
  "50901.real_time.BatteryModel.35": "LvToPSUN LV",
  "50901.real_time.BatteryModel.14": "Uz HV",
  "50901.real_time.BatteryModel.36": "PYTES HV",
  "50901.real_time.BatteryModel.15": "Zetara LV",
  "50901.real_time.BatteryModel.37": "LvToPSUN HV",
  "50901.real_time.BatteryModel.16": "FEB HV",
  "50901.real_time.BatteryModel.38": "RAJA HV",
  "50901.real_time.BatteryModel.17": "Pytes LV",
  "50901.real_time.BatteryModel.39": "Felicity LV",
  "50901.real_time.BatteryModel.18": "Dmegc LV",
  "50901.real_time.BatteryModel.19": "Weineng LV",
  "50901.real_time.BatteryModel.20": "Weineng HV",
  "50901.real_time.BatteryModel.21": "GSL LV",
  "50901.ctrl_Battery.equalizationEnable.00": "否",
  "50901.ctrl_Battery.equalizationEnable.01": "是",
  "50901.ctrl_Dry_Contact_Settings.dryWorkingMode.00": "无",
  "50901.ctrl_Dry_Contact_Settings.dryWorkingMode.01": "接地故障",
  "50901.ctrl_Dry_Contact_Settings.dryWorkingMode.02": "敷在控制",
  "50901.ctrl_Dry_Contact_Settings.dryWorkingMode.03": "放电机",
  "50901.ctrl_Dry_Contact_Settings-Load_Control.loadControlMode.01": "手动",
  "50901.ctrl_Dry_Contact_Settings-Load_Control.loadControlMode.02": "时间模式",
  "50901.ctrl_Dry_Contact_Settings-Load_Control.loadControlMode.03": "智能负载",
  "50901.ctrl_Dry_Contact_Settings-Load_Control.loadControlMode.04": "离网智能负载",
  "50901.ctrl_Dry_Contact_Settings-Load_Control.loadControlMode.05": "电动汽车充电器",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.manualModeSwitch.00": "否",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.manualModeSwitch.01": "是",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange2.00": "disable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange2.01": "enable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange1.00": "disable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange1.01": "enable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange4.00": "disable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange4.01": "enable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange3.00": "disable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange3.01": "enable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange6.00": "disable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange6.01": "enable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange5.00": "disable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange5.01": "enable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange7.00": "disable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange7.01": "enable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange5.00": "disable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange5.01": "enable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange6.00": "disable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange6.01": "enable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange7.00": "disable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange7.01": "enable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange1.00": "enable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange1.01": "enable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange2.00": "disable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange2.01": "enable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange3.00": "disable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange3.01": "enable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange4.00": "disable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange4.01": "enable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange25.00": "disable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange25.01": "enable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange26.00": "disable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange26.01": "enable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange23.00": "disable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange23.01": "enable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange24.00": "disable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange24.01": "enable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange21.00": "disable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange21.01": "enable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange22.00": "disable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange22.01": "enable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange20.00": "disable",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange20.01": "enable",
  "50901.ctrl_Dry_Contact_Generator.generatorMode.00": "关",
  "50901.ctrl_Dry_Contact_Generator.generatorMode.01": "手动",
  "50901.ctrl_Dry_Contact_Generator.generatorMode.02": "自动",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeEn.00": "否",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeEn.01": "是",
  "50901.ctrl_Dry_Contact_Generator.genPracticeFreq.00": "无",
  "50901.ctrl_Dry_Contact_Generator.genPracticeFreq.01": "每周一次",
  "50901.ctrl_Dry_Contact_Generator.genPracticeFreq.02": "每2周一次",
  "50901.ctrl_Dry_Contact_Generator.genPracticeFreq.03": "每3周一次",
  "50901.ctrl_Dry_Contact_Generator.genPracticeFreq.04": "每4周一次",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeWeek.00": "枚举值0的含义",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeWeek.01": "枚举值2的含义",
  "50901.ctrl_WorkMode.workMode.00": "自发自用",
  "50901.ctrl_WorkMode.workMode.01": "经济模式",
  "50901.ctrl_WorkMode.workMode.02": "备电模式",
  "50901.ctrl_WorkMode.workMode.03": "离网模式",
  "50901.ctrl_WorkMode.workMode.04": "强充模式",
  "50901.ctrl_WorkMode.workMode.05": "强放模式",
  "50901.ctrl_WorkMode-economic.section1WeekRange1.00": "枚举值0的含义",
  "50901.ctrl_WorkMode-economic.section1WeekRange1.01": "枚举值2的含义",
  "50901.ctrl_WorkMode-economic.section1WeekRange2.00": "枚举值0的含义",
  "50901.ctrl_WorkMode-economic.section1WeekRange2.01": "枚举值1的含义",
  "50901.ctrl_WorkMode-economic.section2WeekRange1.00": "枚举值0的含义",
  "50901.ctrl_WorkMode-economic.section2WeekRange1.01": "枚举值2的含义",
  "50901.ctrl_WorkMode-economic.section3WeekRange1.00": "枚举值0的含义",
  "50901.ctrl_WorkMode-economic.section3WeekRange1.01": "枚举值2的含义",
  "50901.ctrl_WorkMode-economic.section3WeekRange2.00": "枚举值0的含义",
  "50901.ctrl_WorkMode-economic.section3WeekRange2.01": "枚举值1的含义",
  "50901.ctrl_WorkMode-economic.section4WeekRange1.00": "枚举值0的含义",
  "50901.ctrl_WorkMode-economic.section4WeekRange1.01": "枚举值2的含义",
  "50901.ctrl_WorkMode-economic.section4WeekRange2.00": "枚举值0的含义",
  "50901.ctrl_WorkMode-economic.section4WeekRange2.01": "枚举值1的含义",
  "50901.ctrl_Device.masterSlave.00": "单机",
  "50901.ctrl_Device.masterSlave.01": "主机",
  "50901.ctrl_Device.masterSlave.02": "从机",
  "50901.real_time.materType.00": "无网侧电表",
  "50901.real_time.materType.01": "正泰单相",
  "50901.real_time.materType.02": "正泰单相",
  "50901.real_time.materType.03": "正泰裂相",
  "50901.real_time.materType.05": "计量模块",
  "50901.real_time.materType.06": "安科瑞单路",
  "50901.real_time.materType.07": "安科瑞双路",
  "50901.warning.canCommunicationTimeout.00": "不使能",
  "50901.warning.canCommunicationTimeout.01": "使能",
  "50901.warning.lowBatteryEnergy.00": "不使能",
  "50901.warning.lowBatteryEnergy.01": "使能",
  "50901.warning.hardwareProtection.00": "不使能",
  "50901.warning.hardwareProtection.01": "使能",
  "50901.Fault.evCharger1CommunicationAbnormality.00": "不使能",
  "50901.Fault.evCharger1CommunicationAbnormality.01": "使能",
  "50901.Fault.bmsCanCommunicationAbnormality.00": "不使能",
  "50901.Fault.bmsCanCommunicationAbnormality.01": "使能",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.00": "不使能",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.01": "使能",
  "50901.Fault.gridMeterTypeError.00": "不使能",
  "50901.Fault.gridMeterTypeError.01": "使能",
  "50901.Fault.lowDtuVersion.00": "不使能",
  "50901.Fault.lowDtuVersion.01": "使能",
  "50901.Fault.gridMeterCommunicationAbnormality.00": "不使能",
  "50901.Fault.gridMeterCommunicationAbnormality.01": "使能",
  "50901.Fault.pvMeterTypeError.00": "不使能",
  "50901.Fault.pvMeterTypeError.01": "使能",
  "50901.Fault.dspPwrCommunicationAbnormality.00": "不使能",
  "50901.Fault.dspPwrCommunicationAbnormality.01": "使能",
  "50901.Fault.evCharger2CommunicationAbnormality.00": "不使能",
  "50901.Fault.evCharger2CommunicationAbnormality.01": "使能",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.00": "不使能",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.01": "使能",
  "50901.Fault.dtsCommunicationAbnormality.00": "不使能",
  "50901.Fault.dtsCommunicationAbnormality.01": "使能",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.00": "不使能",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.01": "使能",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.00": "不使能",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.01": "使能",
  "50901.Fault.pvMeterCommunicationAbnormality.00": "不使能",
  "50901.Fault.pvMeterCommunicationAbnormality.01": "使能",
  "50901.Fault.slaveWrongBatteryConnection.00": "不使能",
  "50901.Fault.slaveWrongBatteryConnection.01": "使能",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.00": "不使能",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.01": "使能",
  "50901.Fault.dspSafCommunicationAbnormality.00": "不使能",
  "50901.Fault.dspSafCommunicationAbnormality.01": "使能",
  "50901.Fault.sustainedNegativeLoad.00": "不使能",
  "50901.Fault.sustainedNegativeLoad.01": "使能",
  "50901.Fault.hmidMachineFault.00": "不使能",
  "50901.Fault.hmidMachineFault.01": "使能",
  "50901.Fault.evCharger1Fault.00": "不使能",
  "50901.Fault.evCharger1Fault.01": "使能",
  "50901.Fault.evCharger2Fault.00": "不使能",
  "50901.Fault.evCharger2Fault.01": "使能",
  "50901.Fault.fanSpeedAbnormality.00": "不使能",
  "50901.Fault.fanSpeedAbnormality.01": "使能",
  "50901.Fault.batteryFault.00": "不使能",
  "50901.Fault.batteryFault.01": "使能",
  "50901.Fault.masterSlaveCommunicationAbnormality.00": "不使能",
  "50901.Fault.masterSlaveCommunicationAbnormality.01": "使能",
  "50901.Fault.batteryCapacityAbnormality.00": "不使能",
  "50901.Fault.batteryCapacityAbnormality.01": "使能",
  "50901.Fault.batteryForceChargeRequest.00": "不使能",
  "50901.Fault.batteryForceChargeRequest.01": "使能",
  "50901.Fault.hmidCommunicationAbnormality.00": "不使能",
  "50901.Fault.hmidCommunicationAbnormality.01": "使能",
  "50901.ctrl_Device.networkingType.01": "WIFI",
  "50901.ctrl_Device.networkingType.02": "以太网",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timerModeBatterySocEnable.0": "不使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timerModeBatterySocEnable.1": "使能",
  "50901.ctrl_ESS_Advanced_Config-System.meter_model.desc": "电表型号的说明",
  "50901.ctrl_ESS_Advanced_Config-System.brightness.desc": "显示屏亮度的说明",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_config_mode.desc": "柴发端口模式的说明",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_position.desc": "柴发位置的说明",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_type.desc": "柴发类型的说明",
  "50901.ctrl_ESS_Advanced_Config-Generator.min_run_time.desc": "最小运行时间的说明",
  "50901.ctrl_ESS_Advanced_Config-Generator.max_run_time.desc": "最大运行时间的说明",
  "50901.ctrl_ESS_Advanced_Config-Generator.run_protect_threshold.desc": "运行保护间隔的说明",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_sync_time.desc": "柴发同步时间的说明",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_shutdown_delay.desc": "柴发关机延时的说明",
  "50901.ctrl_ESS_Advanced_Config-System.grid_ct_reverse_enable.desc": "Grid CT反向使能的说明",
  "50901.ctrl_ESS_Advanced_Config-System.pv_ct_reverse_enable.desc": "PV CT反向使能的说明",
  "50901.ctrl_ESS_Advanced_Config-System.grid_meter_ratio.desc": "Grid CT电表匝比设置的说明",
  "50901.ctrl_ESS_Advanced_Config-System.pv_meter_ratio.desc": "PV CT电表匝比设置的说明",
  "50901.ctrl_ESS_Advanced_Config-System.mid_gateway_enable.desc": "MID / Gateway使能的说明",
  "50901.ctrl_Config-Grid Profile.country.desc": "国家/并网标准国家的说明。",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtFuncCode.desc": "VRT功能码的说明。",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtVoltageHighLimit3.desc": "电压上限3的说明。",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtVoltageHighLimit3Time.desc": "电压上限3持续时间的说明。",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtVoltageHighLimit2.desc": "电压上限2的说明。",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtVoltageHighLimit2Time.desc": "电压上限2持续时间的说明。",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtVoltageHighLimit1.desc": "电压上限1的说明。",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtVoltageHighLimit1Time.desc": "电压上限1持续时间的说明。",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtVoltageLowLimit1.desc": "电压下限1的说明。",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtVoltageLowLimit1Time.desc": "电压下限1持续时间的说明。",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtVoltageLowLimit2.desc": "电压下限2的说明。",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtVoltageLowLimit2Time.desc": "电压下限2持续时间的说明。",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtVoltageLowLimit3.desc": "电压下限3的说明。",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtVoltageLowLimit3Time.desc": "电压下限3持续时间的说明。",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtRecoveryStableTime.desc": "VRT恢复稳定时间的说明。",
  "50901.ctrl_ESS_Safety_Config-VRT.vrt10MinAvgVoltage.desc": "10分钟平均电压的说明。",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtEn.desc": "VRT使能的说明。",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtHighLimit.desc": "VRT高电压门限的说明。",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtLowLimit.desc": "VRT低电压门限的说明。",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtTransientOverVoltage.desc": "瞬时过电压门限的说明。",
  "50901.ctrl_ESS_Safety_Config-VRT.vrtTransientOverTime.desc": "瞬时过电压持续时间的说明。",
  "50901.ctrl_ESS_Safety_Config-FRT.frtFuncCode.desc": "FRT功能码的说明。",
  "50901.ctrl_ESS_Safety_Config-FRT.frtHighLimit3.desc": "频率上限3的说明。",
  "50901.ctrl_ESS_Safety_Config-FRT.frtHighLimit3Time.desc": "频率上限3持续时间的说明。",
  "50901.ctrl_ESS_Safety_Config-FRT.frtHighLimit2.desc": "频率上限2的说明。",
  "50901.ctrl_ESS_Safety_Config-FRT.frtHighLimit2Time.desc": "频率上限2持续时间的说明。",
  "50901.ctrl_ESS_Safety_Config-FRT.frtHighLimit1.desc": "频率上限1的说明。",
  "50901.ctrl_ESS_Safety_Config-FRT.frtHighLimit1Time.desc": "频率上限1持续时间的说明。",
  "50901.ctrl_ESS_Safety_Config-FRT.frtLowLimit1.desc": "频率下限1的说明。",
  "50901.ctrl_ESS_Safety_Config-FRT.frtLowLimit1Time.desc": "频率下限1持续时间的说明。",
  "50901.ctrl_ESS_Safety_Config-FRT.frtLowLimit2.desc": "频率下限2的说明。",
  "50901.ctrl_ESS_Safety_Config-FRT.frtLowLimit2Time.desc": "频率下限2持续时间的说明。",
  "50901.ctrl_ESS_Safety_Config-FRT.frtLowLimit3.desc": "频率下限3的说明。",
  "50901.ctrl_ESS_Safety_Config-FRT.frtLowLimit3Time.desc": "频率下限3持续时间的说明。",
  "50901.ctrl_ESS_Safety_Config-RT.rtFuncCode.desc": "RT功能码的说明。",
  "50901.ctrl_ESS_Safety_Config-RT.rtNMTime.desc": "RT_NM时间的说明。",
  "50901.ctrl_ESS_Safety_Config-RT.rtSRTTime.desc": "RT_SRT时间的说明。",
  "50901.ctrl_ESS_Safety_Config-RT.rtVoltRecoveryHighValue.desc": "RT电压恢复上限值的说明。",
  "50901.ctrl_ESS_Safety_Config-RT.rtVoltRecoveryLowValue.desc": "RT电压恢复下限值的说明。",
  "50901.ctrl_ESS_Safety_Config-RT.rtFreqRecoveryHighValue.desc": "RT频率恢复上限值的说明。",
  "50901.ctrl_ESS_Safety_Config-RT.rtFreqRecoveryLowValue.desc": "RT频率恢复下限值的说明。",
  "50901.ctrl_ESS_Safety_Config-RCD.rcdEnable.desc": "RCD使能的说明。",
  "50901.ctrl_ESS_Safety_Config-RCD.continueLimitValue.desc": "RCD连续限值电流的说明。",
  "50901.ctrl_ESS_Safety_Config-RCD.continueLimitTime.desc": "RCD连续限值时间的说明。",
  "50901.ctrl_ESS_Safety_Config-RCD.step1LimitValue.desc": "RCD阶梯1限值电流的说明。",
  "50901.ctrl_ESS_Safety_Config-RCD.step1LimitTime.desc": "RCD阶梯1限值时间的说明。",
  "50901.ctrl_ESS_Safety_Config-RCD.step2LimitValue.desc": "RCD阶梯2限值电流的说明。",
  "50901.ctrl_ESS_Safety_Config-RCD.step2LimitTime.desc": "RCD阶梯2限值时间的说明。",
  "50901.ctrl_ESS_Safety_Config-RCD.step3LimitValue.desc": "RCD阶梯3限值电流的说明。",
  "50901.ctrl_ESS_Safety_Config-RCD.step3LimitTime.desc": "RCD阶梯3限值时间的说明。",
  "50901.ctrl_ESS_Safety_Config-DCI.dciEnable.desc": "DCI使能的说明。",
  "50901.ctrl_ESS_Safety_Config-DCI.upperLimit.desc": "DCI上限电流的说明。",
  "50901.ctrl_ESS_Safety_Config-DCI.upperTime.desc": "DCI上限时间的说明。",
  "50901.ctrl_ESS_Safety_Config-DCI.lowerLimit.desc": "DCI下限电流的说明。",
  "50901.ctrl_ESS_Safety_Config-DCI.lowerTime.desc": "DCI下限时间的说明。",
  "50901.ctrl_ESS_Safety_Config-GCF.gridLevel2LimitTimeScale.desc": "电网二级限值时间尺度的说明。",
  "50901.ctrl_ESS_Safety_Config-GCF.permitEnable.desc": "许可使能的说明。",
  "50901.ctrl_ESS_Safety_Config-GCF.drmEnable.desc": "DRM使能的说明。",
  "50901.ctrl_ESS_Safety_Config-GCF.antiIslandingEnable.desc": "孤岛防护使能的说明。",
  "50901.ctrl_ESS_Safety_Config-RR.rrFuncCode.desc": "RR功能码的说明。",
  "50901.ctrl_ESS_Safety_Config-RR.rrRurNm.desc": "RR_RUR_NM的说明。",
  "50901.ctrl_ESS_Safety_Config-RR.rrRurSs.desc": "RR_RUR_SS的说明。",
  "50901.ctrl_ESS_Safety_Config-FW.fwFuncCode.desc": "FW功能码的说明。",
  "50901.ctrl_ESS_Safety_Config-FW.fwEnable.desc": "FW使能的说明。",
  "50901.ctrl_ESS_Safety_Config-FW.fwDiffInBatMode.desc": "FW电池模式差异使能的说明。",
  "50901.ctrl_ESS_Safety_Config-FW.fwTr.desc": "FW_Tr时间的说明。",
  "50901.ctrl_ESS_Safety_Config-FW.fwRecoveryUpperFrequency.desc": "FW恢复频率上限的说明。",
  "50901.ctrl_ESS_Safety_Config-FW.fwRecoveryLowerFrequency.desc": "FW恢复频率下限的说明。",
  "50901.ctrl_ESS_Safety_Config-FW.fwRecoveryStableTime.desc": "FW恢复稳定时间的说明。",
  "50901.ctrl_ESS_Safety_Config-FW.fwOverStartFreq.desc": "FW过频起始频率的说明。",
  "50901.ctrl_ESS_Safety_Config-FW.fwOverEndFreq.desc": "FW过频结束频率的说明。",
  "50901.ctrl_ESS_Safety_Config-FW.fwOverTransFreq.desc": "FW过频转换频率的说明。",
  "50901.ctrl_ESS_Safety_Config-FW.fwUnderStartFreq.desc": "FW欠频起始频率的说明。",
  "50901.ctrl_ESS_Safety_Config-FW.fwUnderEndFreq.desc": "FW欠频结束频率的说明。",
  "50901.ctrl_ESS_Safety_Config-FW.fwUnderStopFreq.desc": "FW欠频停止频率的说明。",
  "50901.ctrl_ESS_Safety_Config-VW.vwFuncCode.desc": "VW功能码的说明。",
  "50901.ctrl_ESS_Safety_Config-VW.vwEnable.desc": "VW使能的说明。",
  "50901.ctrl_ESS_Safety_Config-VW.vwDiffInBatMode.desc": "VW电池模式差异使能的说明。",
  "50901.ctrl_ESS_Safety_Config-VW.vwTr.desc": "VW_Tr时间的说明。",
  "50901.ctrl_ESS_Safety_Config-VW.vwRecoveryUpperVoltage.desc": "VW恢复电压上限的说明。",
  "50901.ctrl_ESS_Safety_Config-VW.vwRecoveryLowerVoltage.desc": "VW恢复电压下限的说明。",
  "50901.ctrl_ESS_Safety_Config-VW.vwRecoveryStableTime.desc": "VW恢复稳定时间的说明。",
  "50901.ctrl_ESS_Safety_Config-VW.vwOverStartVolt.desc": "VW过压起始电压的说明。",
  "50901.ctrl_ESS_Safety_Config-VW.vwOverEndVolt.desc": "VW过压结束电压的说明。",
  "50901.ctrl_ESS_Safety_Config-VW.vwOverKPVolt.desc": "VW过压KP电压/系数电压的说明。",
  "50901.ctrl_ESS_Safety_Config-VW.vwUnderStartVolt.desc": "VW欠压起始电压的说明。",
  "50901.ctrl_ESS_Safety_Config-VW.vwUnderEndVolt.desc": "VW欠压结束电压的说明。",
  "50901.ctrl_ESS_Safety_Config-VW.vwUnderKPVolt.desc": "VW欠压KP电压/系数电压的说明。",
  "50901.ctrl_ESS_Safety_Config-RPC.rpcMode.desc": "RP模式的说明。",
  "50901.ctrl_ESS_Safety_Config-RPC.rpcTr.desc": "RPC_Tr时间的说明。",
  "50901.ctrl_ESS_Safety_Config-RPC.rpcPf.desc": "RPC功率因数PF的说明。",
  "50901.ctrl_ESS_Safety_Config-RPC.rpcReactPowerRatio.desc": "RPC无功功率比例的说明。",
  "50901.ctrl_ESS_Safety_Config-RPC.wpfFuncCode.desc": "WPF功能码的说明。",
  "50901.ctrl_ESS_Safety_Config-RPC.wpfPowerStartRatio.desc": "WPF功率起始比例的说明。",
  "50901.ctrl_ESS_Safety_Config-RPC.wpfPowerEndRatio.desc": "WPF功率结束比例的说明。",
  "50901.ctrl_ESS_Safety_Config-RPC.wpfMinPFOver.desc": "WPF过功率最小PF的说明。",
  "50901.ctrl_ESS_Safety_Config-RPC.wpfMinPFUnder.desc": "WPF欠功率最小PF的说明。",
  "50901.ctrl_ESS_Safety_Config-RPC.wpfLockIn.desc": "WPF锁定投入值的说明。",
  "50901.ctrl_ESS_Safety_Config-RPC.wpfLockOut.desc": "WPF锁定退出值的说明。",
  "50901.ctrl_ESS_Safety_Config-RPC.vvFuncCode.desc": "VV功能码的说明。",
  "50901.ctrl_ESS_Safety_Config-RPC.vvV1.desc": "VV_V1的说明。",
  "50901.ctrl_ESS_Safety_Config-RPC.vvV2.desc": "VV_V2的说明。",
  "50901.ctrl_ESS_Safety_Config-RPC.vvV3.desc": "VV_V3的说明。",
  "50901.ctrl_ESS_Safety_Config-RPC.vvV4.desc": "VV_V4的说明。",
  "50901.ctrl_ESS_Safety_Config-RPC.vvQ1.desc": "VV_Q1的说明。",
  "50901.ctrl_ESS_Safety_Config-RPC.vvQ2.desc": "VV_Q2的说明。",
  "50901.ctrl_ESS_Safety_Config-RPC.vvQ3.desc": "VV_Q3的说明。",
  "50901.ctrl_ESS_Safety_Config-RPC.vvQ4.desc": "VV_Q4的说明。",
  "50901.ctrl_ESS_Safety_Config-RPC.vvLockIn.desc": "VV锁定投入值的说明。",
  "50901.ctrl_ESS_Safety_Config-RPC.vvLockOut.desc": "VV锁定退出值的说明。",
  "50901.ctrl_ESS_Safety_Config-RPC.vvVref.desc": "VV参考值(Vref)的说明。",
  "50901.ctrl_ESS_Safety_Config-RPC.vvVrefTr.desc": "VV参考值Tr时间的说明。",
  "50901.ctrl_ESS_Safety_Config-GCF.gcfFuncCode.desc": "GCF功能码的说明。",
  "50901.ctrl_ESS_Safety_Config-GCF.gcfEn.desc": "GCF使能的说明。",
  "50901.ctrl_ESS_Safety_Config-GCF.gcfExportSoftLimitRatio.desc": "GCF外送软限比例的说明。",
  "50901.ctrl_ESS_Safety_Config-GCF.gcfExportHardLimitRatio.desc": "GCF外送硬限比例的说明。",
  "50901.ctrl_ESS_Safety_Config-GCF.gcfExportHardTime.desc": "GCF外送硬限时间的说明。",
  "50901.ctrl_ESS_Safety_Config-GCF.gcfGenerationSoftLimitRatio.desc": "GCF发电软限比例的说明。",
  "50901.ctrl_ESS_Safety_Config-GCF.gcfGenerationHardLimitRatio.desc": "GCF发电硬限比例的说明。",
  "50901.ctrl_ESS_Safety_Config-GCF.gcfGenerationHardTime.desc": "GCF发电硬限时间的说明。",
  "50901.ctrl_ESS_Safety_Config-GCF.gcfReconnectionTime.desc": "GCF重连时间的说明。",
  "50901.ctrl_ESS_Safety_Config-PRP.wattRegulationPriority.desc": "瓦特调节优先级的说明。",
  "50901.ctrl_ESS_Safety_Config-PRP.pqP6.desc": "PQ_P6的说明。",
  "50901.ctrl_ESS_Safety_Config-PRP.pqP5.desc": "PQ_P5的说明。",
  "50901.ctrl_ESS_Safety_Config-PRP.pqP4.desc": "PQ_P4的说明。",
  "50901.ctrl_ESS_Safety_Config-PRP.pqP3.desc": "PQ_P3的说明。",
  "50901.ctrl_ESS_Safety_Config-PRP.pqP2.desc": "PQ_P2的说明。",
  "50901.ctrl_ESS_Safety_Config-PRP.pqP1.desc": "PQ_P1的说明。",
  "50901.ctrl_ESS_Safety_Config-PRP.pqQ6.desc": "PQ_Q6的说明。",
  "50901.ctrl_ESS_Safety_Config-PRP.pqQ5.desc": "PQ_Q5的说明。",
  "50901.ctrl_ESS_Safety_Config-PRP.pqQ4.desc": "PQ_Q4的说明。",
  "50901.ctrl_ESS_Safety_Config-PRP.pqQ3.desc": "PQ_Q3的说明。",
  "50901.ctrl_ESS_Safety_Config-PRP.pqQ2.desc": "PQ_Q2的说明。",
  "50901.ctrl_ESS_Safety_Config-PRP.pqQ1.desc": "PQ_Q1的说明。",
  "50901.ctrl_ESS_Safety_Config-APC.apcEn.desc": "APC使能的说明。",
  "50901.ctrl_ESS_Safety_Config-APC.apcPwrLmt.desc": "APC功率限值的说明。",
  "50901.ctrl_ESS_Safety_Config-APC.apcRamp.desc": "APC爬坡率/斜坡的说明。",
  "50901.ctrl_ESS_Safety_Config-FW.relayU16NlineRlyTestDis.desc": "继电器N线测试禁用的说明。",
  "50901.ctrl_ESS_Safety_Config-GCF.gcfImportLimitRatio.desc": "GCF受电(导入)限值比例的说明。",
  "50901.ctrl_ESS_Safety_Config-GCF.gcfImportHardTime.desc": "GCF受电(导入)硬限时间的说明。",
  "50901.ctrl_ESS_Safety_Config-GCF.phaseOrderInverseDisable.desc": "相序反向禁用的说明。",
  "50901.ctrl_ESS_Safety_Config-APC.fixPfTr.desc": "FixPF_Tr时间的说明。",
  "50901.ctrl_ESS_Safety_Config-APC.wpfTr.desc": "WPF_Tr时间的说明。",
  "50901.ctrl_ESS_Safety_Config-APC.vvTr.desc": "VV_Tr时间的说明。",
  "50901.ctrl_ESS_Safety_Config-APC.pqTr.desc": "PQ_Tr时间的说明。",
  "50901.ctrl_ESS_Safety_Config-APC.functionCode.desc": "功能码的说明。",
  "50901.ctrl_ESS_Safety_Config-PRP.rpaP1.desc": "RPA_P1的说明。",
  "50901.ctrl_ESS_Safety_Config-PRP.rpaQ1.desc": "RPA_Q1的说明。",
  "50901.ctrl_ESS_Safety_Config-PRP.rpaP2.desc": "RPA_P2的说明。",
  "50901.ctrl_ESS_Safety_Config-PRP.rpaQ2.desc": "RPA_Q2的说明。",
  "50901.ctrl_ESS_Safety_Config-FW.fwOverFdroop.desc": "FW过频下垂系数的说明。",
  "50901.ctrl_ESS_Safety_Config-FW.fwUnderFdroop.desc": "FW欠频下垂系数的说明。",
  "50901.ctrl_ESS_Safety_Config-FW.fwDelayTime.desc": "FW延时的说明。",
  "50901.ESS_Safety_Config-APC.pqFuncCode.desc": "PQ功能码的说明。",
  "50901.ctrl_ESS_Advanced_Config-System.gridInPowerLimitationWhenValley.desc": "限制网络功率的说明。",
  "50901.ctrl_ESS_Advanced_Config-System.threePhaseUnbalanceEnable.desc": "三相不平衡使能的说明。",
  "50901.ctrl_ESS_Advanced_Config-Battery.batteryMaxChargePower.desc": "电池最大充电功率的说明。",
  "50901.ctrl_ESS_Advanced_Config-Battery.batteryChargingPowerSettingValue.desc": "电池的充电功率设置值的说明。",
  "50901.ctrl_ESS_Advanced_Config-Battery.batteryDischargePowerSettingValue.desc": "电池的放电功率设置值的说明。",
  "50901.ctrl_ESS_Advanced_Config-Battery.batteryMaxDischargePower.desc": "电池最大放电功率的说明。",
  "50901.ctrl_ESS_Advanced_Config-Battery.maxSoc.desc": "最大SOC的说明。",
  "50901.ctrl_ESS_Advanced_Config-Battery.minSoc.desc": "最小SOC的说明。",
  "50901.ctrl_ESS_Advanced_Config-Battery.replenishPower.desc": "功率补偿的说明。",
  "50901.ctrl_ESS_Advanced_Config-Battery.rsvdReplenishPower.desc": "Rsvd补充功率的说明。",
  "50901.ctrl_ESS_Advanced_Config-Battery.batGridFeedPowerWhenPeak.desc": "峰值时电网馈电功率的说明。",
  "50901.ctrl_ESS_Advanced_Config-Battery.batDischargePowerWhenPartialPeak.desc": "峰值时电池最大放电功率的说明。",
  "50901.ctrl_ESS_Advanced_Config-Battery.leadAcidBatReplenishTime.desc": "铅酸电池维护时间的说明。",
  "50901.ctrl_ESS_Advanced_Config-PV.mppt_global_scan_enable.desc": "全局扫描使能的说明",
  "50901.ctrl_ESS_Advanced_Config-EPS.bypassDisable.desc": "绕过禁用的说明。",
  "50901.ctrl_ESS_Advanced_Config-EPS.epsMode.desc": "EPS模式的说明。",
  "50901.ctrl_ESS_Advanced_Config-EPS.pvIslandModeEn.desc": "PV模式使能的说明。",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_rated_power.desc": "多机并联下发电机给电池充电功率的说明",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_high_limit_volt.desc": "发电机电压上限的说明",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_low_limit_volt.desc": "发电机电压下限的说明",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_high_limit_freq.desc": "发电机频率上限的说明",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_low_limit_freq.desc": "发电机频率下限的说明",
  "50901.ctrl_Connection.dtu_comm_enable.desc": "DTU通讯使能的说明",
  "50901.ctrl_Device .batActivate.desc": "电池激活的说明。",
  "50901.ctrl_Device .systemPowerOnOff.desc": "系统开关机的说明。",
  "50901.ctrl_Device .restartSystem.desc": "重启系统的说明。",
  "50901.ctrl_Device .restoreDefault.desc": "恢复默认值的说明。",
  "50901.ctrl_Device .clearFault.desc": "清除故障的说明。",
  "50901.ctrl_Device .selfTest.desc": "自检的说明。",
  "50901.ctrl_Device .arcFaultClear.desc": "电弧故障清除的说明。",
  "50901.ctrl_Device .batteryBalancing.desc": "电池平衡的说明。",
  "50901.ctrl_Device .parallelNetworking.desc": "并行网络的说明。",
  "50901.ctrl_Device .meterConfiguration.desc": "仪表配置的说明。",
  "50901.real_time.BatteryModel.desc": "电池型号的说明。",
  "50901.ctrl_Battery.batteryCapacity.desc": "BMS容量的说明。",
  "50901.ctrl_Battery.maximumChargeLimit.desc": "最大充电限制值的说明。",
  "50901.ctrl_Battery.maximumDischargeLimit.desc": "最大放电限制值的说明。",
  "50901.ctrl_Battery.floatVoltage.desc": "浮动电压的说明。",
  "50901.ctrl_Battery.absorptionVoltage.desc": "吸收电压的说明。",
  "50901.ctrl_Battery.endOfChargeCurrent.desc": "充电结束电流的说明。",
  "50901.ctrl_Battery.equalizationVoltage.desc": "均衡电压的说明。",
  "50901.ctrl_Battery.equalizationIntervalDays.desc": "均衡间隔天数的说明。",
  "50901.ctrl_Battery.equalizationTime.desc": "均衡时间的说明。",
  "50901.ctrl_Battery.temperatureCorrectionFactor.desc": "温度校正系数的说明。",
  "50901.ctrl_Battery.initialResistance.desc": "初始阻力的说明。",
  "50901.ctrl_Battery.endChargeVoltage.desc": "结束充电电压的说明。",
  "50901.ctrl_Battery.equalizationChargeTimeout.desc": "均衡充电超时的说明。",
  "50901.ctrl_Battery.equalizationEnable.desc": "均衡启用的说明。",
  "50901.ctrl_Dry_Contact_Settings.dryWorkingMode.desc": "干节点工作模式的说明。",
  "50901.ctrl_Dry_Contact_Settings-Load_Control.loadControlMode.desc": "负载控制模式的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.manualModeSwitch.desc": "手动模式开关的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange2.desc": "负载控制星期二的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange1.desc": "负载控制星期一的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange4.desc": "负载控制星期四的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange3.desc": "负载控制星期三的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange6.desc": "负载控制星期六的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange5.desc": "负载控制星期五的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange7.desc": "负载控制星期天的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timer1Hour.desc": "定时1起-时的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed1From1Min.desc": "定时1起-分的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed1EndHour.desc": "定时1终-时的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed1EndMinute.desc": "定时1终-分的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timer2Hour.desc": "定时2起-时的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timedFrom2Minutes.desc": "定时2起-分的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed2EndHour.desc": "定时2终-时的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed2EndMinutes.desc": "定时2终-分的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange5.desc": "星期五的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange6.desc": "星期六的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange7.desc": "星期天的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange1.desc": "星期一的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange2.desc": "星期二的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange3.desc": "星期三的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange4.desc": "星期四的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timer1Hour_2.desc": "定时1起_2-时的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed1From1Min_2.desc": "定时1起_2-分的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed1EndHour_2.desc": "定时1终_2-时的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed1EndMinute_2.desc": "定时1终_2-分的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timer2Hour_2.desc": "定时2起_2-时的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timedFrom2Minutes_2.desc": "定时2起_2-分的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed2EndHour_2.desc": "定时2终_2-时的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed2EndMinutes_2.desc": "定时2终_2-分的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange1.desc": "时间范围1的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timer1Hour_3.desc": "时间段1起-时的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed1From1Min_3.desc": "时间段1起-分的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed1EndHour_3.desc": "时间段1终-时的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed1EndMinute_3.desc": "时间段1终-分的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange25.desc": "星期六的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange26.desc": "星期天的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange23.desc": "星期四的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange24.desc": "星期五的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange21.desc": "星期二的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange22.desc": "星期三的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange20.desc": "星期一的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timer2Hour_3.desc": "时间段2起-时的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timedFrom2Minutes_3.desc": "时间段2起-分的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed2EndHour_3.desc": "时间段2终-时的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timed2EndMinutes_3.desc": "时间段2终-分的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.minimumOnTime.desc": "负载控制最短接通时间的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.minimumOnLoadPower.desc": "负载模式负载功率阈值的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.offGridProtectionSoc.desc": "离网保护SOC的说明。",
  "50901.ctrl_Dry_Contact_Generator.generatorMode.desc": "发电机模式的说明。",
  "50901.ctrl_Dry_Contact_Generator.generatorOpenBatteryCapacity.desc": "柴发开启电池容量的说明。",
  "50901.ctrl_Dry_Contact_Generator.generatorCloseBatteryCapacity.desc": "柴发关闭电池容量的说明。",
  "50901.ctrl_Dry_Contact_Generator.chargeTimeStartH.desc": "发电机控制-充电开始时间-H的说明。",
  "50901.ctrl_Dry_Contact_Generator.chargeTimeStartMin.desc": "发电机控制-充电开始时间-分钟的说明。",
  "50901.ctrl_Dry_Contact_Generator.chargeTimeEndH.desc": "发电机控制-充电结束时间-H的说明。",
  "50901.ctrl_Dry_Contact_Generator.chargeTimeEndMin.desc": "发电机控制-充电结束时间-分钟的说明。",
  "50901.ctrl_Dry_Contact_Generator.quietTimeEnable.desc": "待机时间启用的说明。",
  "50901.ctrl_Dry_Contact_Generator.quietTime1StartH.desc": "待机时间1开始-H的说明。",
  "50901.ctrl_Dry_Contact_Generator.quietTime1StartMin.desc": "待机时间1开始-分钟的说明。",
  "50901.ctrl_Dry_Contact_Generator.quietTime1EndH.desc": "待机时间1End-H的说明。",
  "50901.ctrl_Dry_Contact_Generator.quietTime1EndMin.desc": "待机时间1结束分钟的说明。",
  "50901.ctrl_Dry_Contact_Generator.quietTime2StartH.desc": "待机时间2开始-H的说明。",
  "50901.ctrl_Dry_Contact_Generator.quietTime2StartMin.desc": "待机时间2开始-Min的说明。",
  "50901.ctrl_Dry_Contact_Generator.quietTime2EndH.desc": "待机时间2结束-H的说明。",
  "50901.ctrl_Dry_Contact_Generator.quietTime2EndMin.desc": "待机时间2结束-Min的说明。",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeEn.desc": "发电机练习模式的说明。",
  "50901.ctrl_Dry_Contact_Generator.genPracticeFreq.desc": "发电机练习模式频率的说明。",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeWeek.desc": "发电机练习模式启动时间的说明。",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeStartH.desc": "发电机练习模式启动时间-小时的说明。",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeStartMin.desc": "发电机练习模式启动时间-分钟的说明。",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeRunningTime.desc": "发电机练习模式运行时长的说明。",
  "50901.ctrl_WorkMode.workMode.desc": "EMS工作模式的说明。",
  "50901.ctrl_WorkMode-Selfuse.selfUsedSoc.desc": "自用SOC的说明。",
  "50901.ctrl_WorkMode-Backup.backupSoc.desc": "备用SOC的说明。",
  "50901.ctrl_WorkMode-forceCharge.forceChargeSoc.desc": "强制充电SOC的说明。",
  "50901.ctrl_WorkMode-forceCharge.maximumChargePower.desc": "最大充电功率的说明。",
  "50901.ctrl_WorkMode-forceDischarge.forceDischargeSoc.desc": "强制放电SOC的说明。",
  "50901.ctrl_WorkMode-forceDischarge.maximumDischargePower.desc": "最大放电功率的说明。",
  "50901.ctrl_WorkMode-economic.economicModeSoc.desc": "经济模式SOC的说明。",
  "50901.ctrl_WorkMode-economic.economyModeDateNumber.desc": "经济模式日期编号的说明。",
  "50901.ctrl_WorkMode-economic.section1StartMonth.desc": "section1开始月的说明。",
  "50901.ctrl_WorkMode-economic.section1StartDay.desc": "section1开始天的说明。",
  "50901.ctrl_WorkMode-economic.section1StopMonth.desc": "section1停止月的说明。",
  "50901.ctrl_WorkMode-economic.section1StopDay.desc": "section1停止日的说明。",
  "50901.ctrl_WorkMode-economic.section1WeekRange1.desc": "section1周范围1的说明。",
  "50901.ctrl_WorkMode-economic.section1PeakStartHour1.desc": "section1 峰值开始时间1-小时的说明。",
  "50901.ctrl_WorkMode-economic.section1PeakStartMinute1.desc": "section1 峰值开始时间1-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section1PeakStopHour1.desc": "section1 峰值停止时间1-小时的说明。",
  "50901.ctrl_WorkMode-economic.section1PeakStopMinute1.desc": "section1 峰值停止时间1-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section1ValleyStartHour1.desc": "section1 低谷开始时间1- 小时的说明。",
  "50901.ctrl_WorkMode-economic.section1ValleyStartMinute1.desc": "section1 低谷开始时间1- 分钟的说明。",
  "50901.ctrl_WorkMode-economic.section1ValleyStopHour1.desc": "section1 低谷停止时间1- 小时的说明。",
  "50901.ctrl_WorkMode-economic.section1ValleyStopMinute1.desc": "section1 低谷停止时间1- 分钟的说明。",
  "50901.ctrl_WorkMode-economic.section1WeekRange2.desc": "section1周范围2的说明。",
  "50901.ctrl_WorkMode-economic.section1PeakStartHour2.desc": "section1峰值开始时间2-小时的说明。",
  "50901.ctrl_WorkMode-economic.section1PeakStartMinute2.desc": "section1峰值开始时间2-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section1PeakStopHour2.desc": "section1峰值停止时间2-小时的说明。",
  "50901.ctrl_WorkMode-economic.section1PeakStopMinute2.desc": "section1峰值停止时间2-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section1ValleyStartHour2.desc": "section1低估开始时间2-小时的说明。",
  "50901.ctrl_WorkMode-economic.section1ValleyStartMinute2.desc": "section1低估开始时间2-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section1ValleyStopHour2.desc": "section1低估停止时间2-小时的说明。",
  "50901.ctrl_WorkMode-economic.section1ValleyStopMinute2.desc": "section1低估停止时间2-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section2StartMonth.desc": "section2开始月的说明。",
  "50901.ctrl_WorkMode-economic.section2StartDay.desc": "section2开始天的说明。",
  "50901.ctrl_WorkMode-economic.section2StopMonth.desc": "section2停止月的说明。",
  "50901.ctrl_WorkMode-economic.section2StopDay.desc": "section2停止日的说明。",
  "50901.ctrl_WorkMode-economic.section2WeekRange1.desc": "section2周范围1的说明。",
  "50901.ctrl_WorkMode-economic.section2PeakStartHour1.desc": "section2峰值开始时间1-小时的说明。",
  "50901.ctrl_WorkMode-economic.section2PeakStartMinute1.desc": "section2峰值开始时间1-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section2PeakStopHour1.desc": "section2峰值停止时间1-小时的说明。",
  "50901.ctrl_WorkMode-economic.section2PeakStopMinute1.desc": "section2峰值停止时间1-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section2ValleyStartHour1.desc": "section2低估开始时间1-小时的说明。",
  "50901.ctrl_WorkMode-economic.section2ValleyStartMinute1.desc": "section2低估开始时间1-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section2ValleyStopHour1.desc": "section2低估停止时间1-小时的说明。",
  "50901.ctrl_WorkMode-economic.section2ValleyStopMinute1.desc": "section2低估停止时间1-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section2WeekRange2.desc": "section2周范围2的说明。",
  "50901.ctrl_WorkMode-economic.section2PeakStartHour2.desc": "section2峰值开始时间2-小时的说明。",
  "50901.ctrl_WorkMode-economic.section2PeakStartMinute2.desc": "section2峰值开始时间1-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section2PeakStopHour2.desc": "section2峰值停止时间2-小时的说明。",
  "50901.ctrl_WorkMode-economic.section2PeakStopMinute2.desc": "section2峰值停止时间2-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section2ValleyStartHour2.desc": "section2低估开始时间2-小时的说明。",
  "50901.ctrl_WorkMode-economic.section2ValleyStartMinute2.desc": "section2低估开始时间2-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section2ValleyStopHour2.desc": "section2低估停止时间2-小时的说明。",
  "50901.ctrl_WorkMode-economic.section2ValleyStopMinute2.desc": "section2低估停止时间2-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section3StartMonth.desc": "section3开始月的说明。",
  "50901.ctrl_WorkMode-economic.section3StartDay.desc": "section3开始天的说明。",
  "50901.ctrl_WorkMode-economic.section3StopMonth.desc": "section3停止月的说明。",
  "50901.ctrl_WorkMode-economic.section3StopDay.desc": "section3停止日的说明。",
  "50901.ctrl_WorkMode-economic.section3WeekRange1.desc": "section3周范围1的说明。",
  "50901.ctrl_WorkMode-economic.section3PeakStartHour1.desc": "section3峰值开始时间1-小时的说明。",
  "50901.ctrl_WorkMode-economic.section3PeakStartMinute2.desc": "section3峰值开始时间1-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section3PeakStopHour1.desc": "section3峰值停止时间1-小时的说明。",
  "50901.ctrl_WorkMode-economic.section3PeakStopMinute1.desc": "section3峰值停止时间1-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section3ValleyStartHour1.desc": "section3低谷开始时间1-小时的说明。",
  "50901.ctrl_WorkMode-economic.section3ValleyStartMinute1.desc": "section3低估开始时间1-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section3ValleyStopHour1.desc": "section3低估停止时间1-小时的说明。",
  "50901.ctrl_WorkMode-economic.section3ValleyStopMinute1.desc": "section3低估停止时间1-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section3WeekRange2.desc": "section3周范围2的说明。",
  "50901.ctrl_WorkMode-economic.section3PeakStartHour2.desc": "section3峰值开始时间2-小时的说明。",
  "50901.ctrl_WorkMode-economic.section3PeakStartMinute1.desc": "section3峰值开始时间2-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section3PeakStopHour2.desc": "section3峰值停止时间2-小时的说明。",
  "50901.ctrl_WorkMode-economic.section3PeakStopMinute2.desc": "section3峰值停止时间2-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section3ValleyStartHour2.desc": "section3低估开始时间2-小时的说明。",
  "50901.ctrl_WorkMode-economic.section3ValleyStartMinute2.desc": "section3低估开始时间2-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section3ValleyStopHour2.desc": "section3低估停止时间2-小时的说明。",
  "50901.ctrl_WorkMode-economic.section3ValleyStopMinute2.desc": "section3低估停止时间2-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section4StartMonth.desc": "section4开始月的说明。",
  "50901.ctrl_WorkMode-economic.section4StartDay.desc": "section4开始天的说明。",
  "50901.ctrl_WorkMode-economic.section4StopMonth.desc": "section4停止月的说明。",
  "50901.ctrl_WorkMode-economic.section4StopDay.desc": "section4停止日的说明。",
  "50901.ctrl_WorkMode-economic.section4WeekRange1.desc": "section4周范围1的说明。",
  "50901.ctrl_WorkMode-economic.section4PeakStartHour1.desc": "section4峰值开始时间1-小时的说明。",
  "50901.ctrl_WorkMode-economic.section4PeakStartMinute1.desc": "section4峰值开始时间1-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section4PeakStopHour1.desc": "section4峰值停止时间1-小时的说明。",
  "50901.ctrl_WorkMode-economic.section4PeakStopMinute1.desc": "section4峰值停止时间1-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section4ValleyStartHour1.desc": "section4低估开始时间1-小时的说明。",
  "50901.ctrl_WorkMode-economic.section4ValleyStartMinute1.desc": "section4低估开始时间1-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section4ValleyStopHour1.desc": "section4低估停止时间1-小时的说明。",
  "50901.ctrl_WorkMode-economic.section4ValleyStopMinute1.desc": "section4低估停止时间1-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section4WeekRange2.desc": "section4周范围2的说明。",
  "50901.ctrl_WorkMode-economic.section4PeakStartHour2.desc": "section4峰值开始时间2-小时的说明。",
  "50901.ctrl_WorkMode-economic.section4PeakStartMinute2.desc": "section4峰值开始时间2-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section4PeakStopHour2.desc": "section4峰值停止时间2-小时的说明。",
  "50901.ctrl_WorkMode-economic.section4PeakStopMinute2.desc": "section4峰值停止时间2-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section4ValleyStartHour2.desc": "section4低估开始时间2-小时的说明。",
  "50901.ctrl_WorkMode-economic.section4ValleyStartMinute2.desc": "section4低估开始时间2-分钟的说明。",
  "50901.ctrl_WorkMode-economic.section4ValleyStopHour2.desc": "section4低估停止时间2-小时的说明。",
  "50901.ctrl_WorkMode-economic.section4ValleyStopMinute2.desc": "section4低估停止时间2-分钟的说明。",
  "50901.ctrl_Battery.batteryHealing.desc": "电池恢复的说明。",
  "50901.ctrl_WorkMode-peakMeter.peakMeterSoc.desc": "峰值计SOC的说明。",
  "50901.ctrl_WorkMode-peakMeter.peakMeterPower.desc": "峰值仪表功率的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseRange.desc": "TOU模式时间范围的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime1ChrgStartH.desc": "使用时间Time1ChrgStart-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime1ChrgStartMin.desc": "使用时间Time1ChrgStart-\nMin\n的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime1ChrgEndH.desc": "使用时间Time1Chrg结束-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime1ChrgEndMin.desc": "使用时间Time1Chrg结束-分钟的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime1ChrgPower.desc": "充电功率的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime1ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime1DischrgStartH.desc": "使用时间Time1DischrgStart-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime1DischrgStartMin.desc": "使用时间Time1DischrgStart-Min的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime1DischrgEndH.desc": "使用时间Time1DischrgEnd-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime1DischrgEndMin.desc": "使用时间Time1Dischrg结束-分钟的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime1DischrgPower.desc": "放电功率的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime1DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime2ChrgStartH.desc": "使用时间Time2ChrgStart-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime2ChrgStartMin.desc": "使用时间Time2ChrgStart-\nMin\n的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime2ChrgEndH.desc": "使用时间Time2Chrg结束-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime2ChrgEndMin.desc": "使用时间Time2Chrg结束-分钟的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime2ChrgPower.desc": "充电功率的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime2ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime2DischrgStartH.desc": "使用时间Time2DischrgStart-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime2DischrgStartMin.desc": "使用时间Time2DischrgStart-Min的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime2DischrgEndH.desc": "使用时间Time2DischrgEnd-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime2DischrgEndMin.desc": "使用时间Time2Dischrg结束-分钟的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime2DischrgPower.desc": "放电功率的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime2DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime3ChrgStartH.desc": "使用时间Time3ChrgStart-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime3ChrgStartMin.desc": "使用时间Time3ChrgStart-\nMin\n的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime3ChrgEndH.desc": "使用时间Time3Chrg结束-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime3ChrgEndMin.desc": "使用时间Time3Chrg结束-分钟的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime3ChrgPower.desc": "充电功率的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime3ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime3DischrgStartH.desc": "使用时间Time3DischrgStart-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime3DischrgStartMin.desc": "使用时间Time3DischrgStart-Min的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime3DischrgEndH.desc": "使用时间Time3DischrgEnd-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime3DischrgEndMin.desc": "使用时间Time3Dischrg结束-分钟的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime3DischrgPower.desc": "放电功率的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime3DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime4ChrgStartH.desc": "使用时间Time4ChrgStart-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime4ChrgStartMin.desc": "使用时间Time4ChrgStart-\nMin\n的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime4ChrgEndH.desc": "使用时间Time4Chrg结束-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime4ChrgEndMin.desc": "使用时间Time4Chrg结束-分钟的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime4ChrgPower.desc": "充电功率的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime4ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime4DischrgStartH.desc": "使用时间Time4DischrgStart-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime4DischrgStartMin.desc": "使用时间Time4DischrgStart-Min的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime4DischrgEndH.desc": "使用时间Time4DischrgEnd-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime4DischrgEndMin.desc": "使用时间Time4Dischrg结束-分钟的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime4DischrgPower.desc": "放电功率的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime4DischrgStopSoc.desc": "放电截止功率的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime5ChrgStartH.desc": "使用时间Time5ChrgStart-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime5ChrgStartMin.desc": "使用时间Time5ChrgStart-\nMin\n的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime5ChrgEndH.desc": "使用时间Time5Chrg结束-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime5ChrgEndMin.desc": "使用时间Time5Chrg结束-分钟的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime5ChrgPower.desc": "充电功率的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime5ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime5DischrgStartH.desc": "使用时间Time5DischrgStart-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime5DischrgStartMin.desc": "使用时间Time5DischrgStart-Min的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime5DischrgEndH.desc": "使用时间Time5DischrgEnd-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime5DischrgEndMin.desc": "使用时间Time5Dischrg结束-分钟的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime5DischrgPower.desc": "放电功率的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime5DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime6ChrgStartH.desc": "使用时间Time6ChrgStart-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime6ChrgStartMin.desc": "使用时间Time6ChrgStart-\nMin\n的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime6ChrgEndH.desc": "使用时间Time6Chrg结束-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime6ChrgEndMin.desc": "使用时间Time6Chrg结束-分钟的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime6ChrgPower.desc": "充电功率的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime6ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime6DischrgStartH.desc": "使用时间Time6DischrgStart-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime6DischrgStartMin.desc": "使用时间Time6DischrgStart-Min的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime6DischrgEndH.desc": "使用时间Time6DischrgEnd-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime6DischrgEndMin.desc": "使用时间Time6Dischrg结束-分钟的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime6DischrgPower.desc": "放电功率的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime6DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime7ChrgStartH.desc": "使用时间Time7ChrgStart-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime7ChrgStartMin.desc": "使用时间Time7ChrgStart-\nMin\n的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime7ChrgEndH.desc": "使用时间Time7Chrg结束-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime7ChrgEndMin.desc": "使用时间Time7Chrg结束-分钟的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime7ChrgPower.desc": "放电功率的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime7ChrgStopSoc.desc": "放电截止容量的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime7DischrgStartH.desc": "使用时间Time7DischrgStart-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime7DischrgStartMin.desc": "使用时间Time7DischrgStart-Min的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime7DischrgEndH.desc": "使用时间Time7DischrgEnd-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime7DischrgEndMin.desc": "使用时间Time7Dischrg结束-分钟的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime7DischrgPower.desc": "放电功率的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime7DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime8ChrgStartH.desc": "使用时间Time8ChrgStart-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime8ChrgStartMin.desc": "使用时间Time8ChrgStart-\nMin\n的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime8ChrgEndH.desc": "使用时间Time8Chrg结束-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime8ChrgEndMin.desc": "使用时间Time8Chrg结束-分钟的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime8ChrgPower.desc": "充电功率的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime8ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime8DischrgStartH.desc": "使用时间Time8DischrgStart-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime8DischrgStartMin.desc": "使用时间Time8DischrgStart-Min的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime8DischrgEndH.desc": "使用时间Time8DischrgEnd-H的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime8DischrgEndMin.desc": "使用时间Time8Dischrg结束-分钟的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime8DischrgPower.desc": "放电功率的说明。",
  "50901.ctrl_WorkMode-TOU.timeOfUseTime8DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.ctrl_ClockSetting.ClockSetting.desc": "时钟设置的说明。",
  "50901.ctrl_ClockSetting.clockSetting_year.desc": "时钟设置-year的说明。",
  "50901.ctrl_ClockSetting.clockSetting_month.desc": "时钟设置-month的说明。",
  "50901.ctrl_ClockSetting.clockSetting_day.desc": "时钟设置-day的说明。",
  "50901.ctrl_ClockSetting.clockSetting_hour.desc": "时钟设置-hour的说明。",
  "50901.ctrl_ClockSetting.clockSetting_minute.desc": "时钟设置-minute的说明。",
  "50901.ctrl_ClockSetting.clockSetting_second.desc": "时钟设置-second的说明。",
  "50901.ctrl_ClockSetting.clockSetting_weekday.desc": "时钟设置-weekday的说明。",
  "50901.ctrl_Gateway.gatewayCommunicationAddress.desc": "网关通信地址的说明。",
  "50901.ctrl_Gateway.boardAmbientTemperatureThreshold.desc": "电路板环境温度阈值的说明。",
  "50901.ctrl_Gateway.ambientTemperatureThreshold.desc": "环境温度阈值的说明。",
  "50901.ctrl_Connection.connectionRouterStatus.desc": "连接路由器状态的说明。",
  "50901.ctrl_Connection.connectionServerStatus.desc": "连接器服务状态的说明。",
  "50901.ctrl_Connection.absoluteTime.desc": "绝对时间的说明。",
  "50901.ctrl_Connection.timeZone.desc": "时区的说明。",
  "50901.ctrl_Connection.dfs.desc": "能力集的说明。",
  "50901.ctrl_Device.masterSlave.desc": "主机/从机的说明。",
  "50901.real_time.numberOfUnits.desc": "机器数量的说明。",
  "50901.real_time.materType.desc": "电表类型的说明。",
  "50901.warning.canCommunicationTimeout.desc": "CAN通信超时的说明。",
  "50901.warning.lowBatteryEnergy.desc": "电池电量过低的说明。",
  "50901.warning.hardwareProtection.desc": "硬件保护的说明。",
  "50901.Fault.evCharger1CommunicationAbnormality.desc": "电动汽车充电桩1通信异常的说明。",
  "50901.Fault.bmsCanCommunicationAbnormality.desc": "BMS_CAN 通信异常的说明。",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.desc": "DTU3 RS485 通信异常的说明。",
  "50901.Fault.gridMeterTypeError.desc": " 电网电表类型错误的说明。",
  "50901.Fault.lowDtuVersion.desc": "DTU版本过低的说明。",
  "50901.Fault.gridMeterCommunicationAbnormality.desc": "电网电表通信异常的说明。",
  "50901.Fault.pvMeterTypeError.desc": "光伏电表类型错误的说明。",
  "50901.Fault.dspPwrCommunicationAbnormality.desc": "​DSP电源通信异常的说明。",
  "50901.Fault.evCharger2CommunicationAbnormality.desc": "电动汽车充电桩2通信异常的说明。",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.desc": " DTU5 RS485 通信异常的说明。",
  "50901.Fault.dtsCommunicationAbnormality.desc": "DTS 通信异常的说明。",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.desc": "DTU4 RS485 通信异常的说明。",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.desc": "DTU1 RS485 通信异常的说明。",
  "50901.Fault.pvMeterCommunicationAbnormality.desc": "光伏电表通信异常的说明。",
  "50901.Fault.slaveWrongBatteryConnection.desc": "从机电池连接错误的说明。",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.desc": " DTU2 RS485 通信异常的说明。",
  "50901.Fault.dspSafCommunicationAbnormality.desc": "​DSP安全通信异常​的说明。",
  "50901.Fault.sustainedNegativeLoad.desc": "持续负负载的说明。",
  "50901.Fault.hmidMachineFault.desc": "人机交互界面设备故障的说明。",
  "50901.Fault.evCharger1Fault.desc": "充电桩1故障的说明。",
  "50901.Fault.evCharger2Fault.desc": "充电桩2故障的说明。",
  "50901.Fault.fanSpeedAbnormality.desc": "风扇转速异常的说明。",
  "50901.Fault.batteryFault.desc": "电池故障的说明。",
  "50901.Fault.masterSlaveCommunicationAbnormality.desc": "主从通信异常的说明。",
  "50901.Fault.batteryCapacityAbnormality.desc": " 电池容量异常的说明。",
  "50901.Fault.batteryForceChargeRequest.desc": " 电池强制充电请求的说明。",
  "50901.Fault.hmidCommunicationAbnormality.desc": "人机交互界面通信异常的说明。",
  "50901.ctrl_Device.networkingType.desc": "联网类型的说明。",
  "50901.ctrl_Device.checkTime.desc": "设备时间的说明。",
  "50901.real_time.dTSReset.desc": "数据棒复位的说明。",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.homeInletBreakerRatedCurrent.desc": "入户空开额定电流",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.chargingPileRatedCurrent.desc": "充电桩额定电流",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timerModeBatterySocEnable.desc": "定时模式-电池SOC使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timerModeBatteryStartSoc.desc": "定时模式-电池启动SOC",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timerModeBatteryStopSoc.desc": "定时模式-电池关闭SOC",
  "50901.ctrl_WorkMode-TOU.touModeReserveSoc.desc": "TOU模式预留SOC",
  "50901.real_time.数据分析_AC光伏电流.tag": "AC光伏电流",
  "50901.real_time.数据分析_发电机电流.tag": "发电机电流",
  "50901.real_time.数据分析_电网功率.tag": "电网功率",
  "50901.real_time.数据分析_EPS功率.tag": "EPS功率",
  "50901.real_time.数据分析_混逆光伏电压.tag": "混逆光伏电压",
  "50901.real_time.数据分析_电网电压.tag": "电网电压",
  "50901.real_time.数据分析_电网电流.tag": "电网电流",
  "50901.real_time.数据分析_AC光伏电压.tag": "AC光伏电压",
  "50901.real_time.数据分析_电池包.tag": "电池包",
  "50901.real_time.数据分析_发电机功率.tag": "发电机功率",
  "50901.real_time.数据分析_EPS电流.tag": "EPS电流",
  "50901.real_time.数据分析_AC光伏无功功率.tag": "AC光伏无功功率",
  "50901.real_time.数据分析_单体SOC.tag": "单体SOC",
  "50901.real_time.数据分析_混逆光伏功率.tag": "混逆光伏功率",
  "50901.real_time.数据分析_发电机电压.tag": "发电机电压",
  "50901.real_time.数据分析_混逆光伏电流.tag": "混逆光伏电流",
  "50901.real_time.数据分析_EPS电压.tag": "EPS电压",
  "50901.real_time.数据分析_AC光伏有功功率.tag": "AC光伏有功功率",
  "50901.real_time.数据分析_AC光伏功率.tag": "AC光伏功率",
  "51301.real_time.operatingMode.0": "制冷",
  "51301.real_time.operatingMode.1": "制热",
  "51301.real_time.operatingMode.3": "地暖",
  "51301.real_time.operatingMode.4": "热水+制冷",
  "51301.real_time.operatingMode.5": "热水+制热",
  "51301.real_time.operatingMode.2": "热水",
  "51301.real_time.operatingMode.6": "预留",
  "51301.real_time.operatingMode.7": "水热+地暖",
  "51301.real_time.onOffControl.0": "关机",
  "51301.real_time.onOffControl.1": "开机",
  "50901.otaHttpUrl.otaHttpUrl": "升级指令",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timerModeBatterySocEnable.00": "不使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.timerModeBatterySocEnable.01": "使能",
  "50901.otaHttpUrl.otaHttpUrl.desc": "升级指令的说明。",
  "ice.robot.strategy.type.peak.storage.valley": "光储峰谷",
  "50901.real_time.pvMeterFrequency": "光伏侧电表频率",
  "50901.real_time.pvMeterPhaseAActivePower": "光伏侧电表A有功功率",
  "50901.real_time.pvMeterPhaseBActivePower": "光伏侧电表B有功功率",
  "50901.real_time.pvMeterPhaseCActivePower": "光伏侧电表C有功功率",
  "50901.real_time.pvMeterPhaseAReactivePower": "光伏侧电表A无功功率",
  "50901.real_time.pvMeterPhaseBReactivePower": "光伏侧电表B无功功率",
  "50901.real_time.pvMeterPhaseCReactivePower": "光伏侧电表C无功功率",
  "50901.real_time.pvMeterPhaseAPowerFactor": "光伏侧电表A功率因数",
  "50901.real_time.pvMeterPhaseBPowerFactor": "光伏侧电表B功率因数",
  "50901.real_time.pvMeterPhaseCPowerFactor": "光伏侧电表C功率因数",
  "50901.real_time.pvMeterFrequency.desc": "电表频率的说明。",
  "50901.real_time.pvMeterPhaseAActivePower.desc": "电表A有功功率的说明。",
  "50901.real_time.pvMeterPhaseBActivePower.desc": "电表B有功功率的说明。",
  "50901.real_time.pvMeterPhaseCActivePower.desc": "电表C有功功率的说明。",
  "50901.real_time.pvMeterPhaseAReactivePower.desc": "电表A无功功率的说明。",
  "50901.real_time.pvMeterPhaseBReactivePower.desc": "电表B无功功率的说明。",
  "50901.real_time.pvMeterPhaseCReactivePower.desc": "电表C无功功率的说明。",
  "50901.real_time.pvMeterPhaseAPowerFactor.desc": "电表A功率因数的说明。",
  "50901.real_time.pvMeterPhaseBPowerFactor.desc": "电表B功率因数的说明。",
  "50901.real_time.pvMeterPhaseCPowerFactor.desc": "电表C功率因数的说明。",
  "50901.real_time.BatteryModel.2": "Pylon HV",
  "50901.real_time.BatteryModel.3": "Dyness LV",
  "50901.real_time.BatteryModel.4": "Dyness HV",
  "50901.real_time.BatteryModel.5": "Sunwoda LV",
  "50901.real_time.BatteryModel.6": "Uz LV",
  "50901.real_time.BatteryModel.7": "Soluna HV",
  "50901.real_time.BatteryModel.8": "Soluna LV",
  "50901.real_time.BatteryModel.9": "Steltec LV",
  "50901.real_time.materType.0": "无网侧电表",
  "50901.real_time.materType.1": "正泰单相",
  "50901.real_time.materType.2": "正泰单相",
  "50901.real_time.materType.3": "正泰裂相",
  "50901.real_time.materType.5": "计量模块",
  "50901.real_time.materType.6": "安科瑞单路",
  "50901.real_time.materType.7": "安科瑞双路",
  "50901.ctrl_ESS_Safety_Config-VW": "安全配置-VW",
  "50901.ctrl_ESS_Safety_Config-APC": "安全配置-APC",
  "50901.ESS_Safety_Config-APC": "安全配置-FW",
  "50901.ctrl_ESS_Advanced_Config-System": "高级配置-系统",
  "50901.ctrl_ESS_Safety_Config-RR": "安全配置-RR",
  "50901.ctrl_ESS_Advanced_Config-EPS": "高级配置-应急电源",
  "50901.ctrl_ESS_Safety_Config-RT": "安全配置-FR",
  "50901.ctrl_WorkMode": "工作模式",
  "50901.ctrl_Connection": " 控制_通信连接",
  "50901.ctrl_WorkMode-economic": "工作模式-经济模式",
  "50901.ctrl_ESS_Safety_Config-RCD": "安全配置-RCD",
  "50901.ctrl_ESS_Safety_Config-FW": "安全配置-FW",
  "50901.ctrl_ESS_Safety_Config-RPC": "安全配置-RPC",
  "50901.ctrl_Config-Grid Profile": "配置-电网参数",
  "50901.ctrl_ESS_Safety_Config-FRT": "安全配置-FRT",
  "50901.ctrl_WorkMode-forceDischarge": "工作模式-强制放电",
  "50901.ctrl_ESS_Advanced_Config-Generator": "高级配置-发电机",
  "50901.ctrl_WorkMode-forceCharge": "工作模式-强制充电",
  "50901.ctrl_Dry_Contact_Generator": "干接点_发电机",
  "50901.ctrl_ESS_Advanced_Config-PV": "高级配置-光伏",
  "50901.ctrl_ESS_Safety_Config-VRT": "安全配置-VRT",
  "50901.ctrl_ESS_Advanced_Config-Battery": "高级配置-电池",
  "50901.ctrl_Dry_Contact_Settings-Load_Control": "干接点设置-负载控制",
  "50901.ctrl_Battery": " 控制_电池",
  "50901.ctrl_ESS_Safety_Config-PRP": "安全配置-PRP",
  "50901.ctrl_WorkMode-TOU": "工作模式-分时电价",
  "50901.ctrl_Dry_Contact_Settings": "干接点设置",
  "50901.ctrl_WorkMode-Backup": "工作模式-备用",
  "50901.ctrl_ESS_Safety_Config-DCI": "安全配置-DCI",
  "50901.ctrl_ESS_Safety_Config-GCF": "安全配置-GCF",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control": "干接点设置-手动控制",
  "50901.ctrl_Gateway": " 控制_网关",
  "50901.ctrl_Device": " 控制_设备",
  "50901.ctrl_WorkMode-peakMeter": "工作模式-峰值计量",
  "50901.ctrl_ClockSetting": "时钟设置",
  "50901.ctrl_WorkMode-Selfuse": "工作模式-自发自用",
  "50901.ctrl_WorkMode.workMode.0": "自发自用",
  "50901.ctrl_WorkMode.workMode.1": "经济模式",
  "50901.ctrl_WorkMode.workMode.2": "备电模式",
  "50901.ctrl_WorkMode.workMode.3": "离网模式",
  "50901.ctrl_WorkMode.workMode.4": "强充模式",
  "50901.ctrl_WorkMode.workMode.5": "强放模式",
  "50901.ctrl_Device.networkingType.1": "WIFI",
  "50901.ctrl_Device.networkingType.2": "以太网",
  "50901.ctrl_Device.batActivate": "电池激活",
  "50901.ctrl_Device.systemPowerOnOff": "系统开关机",
  "50901.ctrl_Device.restartSystem": "重启系统",
  "50901.ctrl_Device.restoreDefault": "恢复默认值",
  "50901.ctrl_Device.clearFault": "清除故障",
  "50901.ctrl_Device.selfTest": "自检",
  "50901.ctrl_Device.arcFaultClear": "电弧故障清除",
  "50901.ctrl_Device.batteryBalancing": "电池平衡",
  "50901.ctrl_Device.parallelNetworking": "并行网络",
  "50901.ctrl_Device.meterConfiguration": "电表配置",
  "50901.ctrl_Device.restartSystem.00": "否",
  "50901.ctrl_Device.restartSystem.01": "是",
  "50901.ctrl_Device.parallelNetworking.00": "无效",
  "50901.ctrl_Device.parallelNetworking.01": "组网中",
  "50901.ctrl_Device.parallelNetworking.02": "解散组网",
  "50901.ctrl_Device.meterConfiguration.00": "无电表类型",
  "50901.ctrl_Device.meterConfiguration.01": "配置电网电表",
  "50901.ctrl_Device.batActivate.desc": "电池激活的说明。",
  "50901.ctrl_Device.systemPowerOnOff.desc": "系统开关机的说明。",
  "50901.ctrl_Device.restartSystem.desc": "重启系统的说明。",
  "50901.ctrl_Device.restoreDefault.desc": "恢复默认值的说明。",
  "50901.ctrl_Device.clearFault.desc": "清除故障的说明。",
  "50901.ctrl_Device.selfTest.desc": "自检的说明。",
  "50901.ctrl_Device.arcFaultClear.desc": "电弧故障清除的说明。",
  "50901.ctrl_Device.batteryBalancing.desc": "电池平衡的说明。",
  "50901.ctrl_Device.parallelNetworking.desc": "并行网络的说明。",
  "50901.ctrl_Device.meterConfiguration.desc": "仪表配置的说明。",
  "50901..vrtEn.00": "disable",
  "50901..vrtEn.01": "enable",
  "50901..rcdEnable.00": "disable",
  "50901..rcdEnable.01": "enable",
  "50901..dciEnable.00": "disable",
  "50901..dciEnable.01": "enable",
  "50901..permitEnable.00": "disable",
  "50901..permitEnable.01": "enable",
  "50901..drmEnable.00": "disable",
  "50901..drmEnable.01": "enable",
  "50901..antiIslandingEnable.00": "disable",
  "50901..antiIslandingEnable.01": "enable",
  "50901..fwEnable.00": "disable",
  "50901..fwEnable.01": "enable",
  "50901..fwDiffInBatMode.00": "disable",
  "50901..fwDiffInBatMode.01": "enable",
  "50901..vwEnable.00": "disable",
  "50901..vwEnable.01": "enable",
  "50901..vwDiffInBatMode.00": "disable",
  "50901..vwDiffInBatMode.01": "enable",
  "50901..rpcMode.00": "disable",
  "50901..rpcMode.01": "Fixed Power Factor, PF Mode",
  "50901..rpcMode.02": "Fixed Reactive Power, Q Mode",
  "50901..rpcMode.03": "PF(P) Curve, PF(P) Mode",
  "50901..rpcMode.04": "W",
  "50901..rpcMode.05": "PQ",
  "50901..gcfEn.00": "disable",
  "50901..gcfEn.01": "enable",
  "50901..apcEn.00": "disable",
  "50901..apcEn.01": "enable",
  "50901..relayU16NlineRlyTestDis.00": "不使能",
  "50901..relayU16NlineRlyTestDis.01": "使能",
  "50901..phaseOrderInverseDisable.00": "不使能",
  "50901..phaseOrderInverseDisable.01": "使能",
  "50901.ctrl_ESS_Advanced_Config-PV.mppt_global_scan_enable.0": "不使能",
  "50901.ctrl_ESS_Advanced_Config-PV.mppt_global_scan_enable.1": "使能",
  "50901.ctrl_ESS_Advanced_Config-EPS.bypassDisable.0": "否",
  "50901.ctrl_ESS_Advanced_Config-EPS.bypassDisable.1": "是",
  "50901.ctrl_ESS_Advanced_Config-EPS.epsMode.0": "禁用",
  "50901.ctrl_ESS_Advanced_Config-EPS.epsMode.1": "应急电源",
  "50901.ctrl_ESS_Advanced_Config-EPS.epsMode.2": "不间断电源",
  "50901.ctrl_ESS_Advanced_Config-EPS.pvIslandModeEn.0": "否",
  "50901.ctrl_ESS_Advanced_Config-EPS.pvIslandModeEn.1": "是",
  "50901.ctrl_Connection.dtu_comm_enable.0": "不使能",
  "50901.ctrl_Connection.dtu_comm_enable.1": "使能",
  "50901.ctrl_Device.restartSystem.0": "否",
  "50901.ctrl_Device.restartSystem.1": "是",
  "50901.ctrl_Device.parallelNetworking.0": "无效",
  "50901.ctrl_Device.parallelNetworking.1": "组网中",
  "50901.ctrl_Device.parallelNetworking.2": "解散组网",
  "50901.ctrl_Device.meterConfiguration.0": "无电表类型",
  "50901.ctrl_Device.meterConfiguration.1": "配置网侧电表",
  "50901.ctrl_Battery.equalizationEnable.0": "否",
  "50901.ctrl_Battery.equalizationEnable.1": "是",
  "50901.ctrl_Dry_Contact_Settings.dryWorkingMode.0": "无",
  "50901.ctrl_Dry_Contact_Settings.dryWorkingMode.1": "接地故障",
  "50901.ctrl_Dry_Contact_Settings.dryWorkingMode.2": "负载控制",
  "50901.ctrl_Dry_Contact_Settings.dryWorkingMode.3": "放电机",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.manualModeSwitch.0": "否",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.manualModeSwitch.1": "是",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange2.0": "不使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange2.1": "使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange1.0": "不使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange1.1": "使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange4.0": "不使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange4.1": "使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange3.0": "不使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange3.1": "使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange6.0": "不使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange6.1": "使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange5.0": "不使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange5.1": "使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange7.0": "不使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.dayOfTheWeekRange7.1": "使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange5.0": "不使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange5.1": "使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange6.0": "不使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange6.1": "使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange7.0": "不使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange7.1": "使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange1.0": "不使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange1.1": "使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange2.0": "不使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange2.1": "使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange3.0": "不使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange3.1": "使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange4.0": "不使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.weekRange4.1": "使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange25.0": "不使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange25.1": "使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange26.0": "不使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange26.1": "使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange23.0": "不使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange23.1": "使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange24.0": "不使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange24.1": "使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange21.0": "不使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange21.1": "使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange22.0": "不使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange22.1": "使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange20.0": "不使能",
  "50901.ctrl_Dry_Contact_Settings-Manual_Control.smart_weekRange20.1": "使能",
  "50901.ctrl_Dry_Contact_Generator.generatorMode.0": "关",
  "50901.ctrl_Dry_Contact_Generator.generatorMode.1": "手动",
  "50901.ctrl_Dry_Contact_Generator.generatorMode.2": "自动",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeEn.0": "否",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeEn.1": "是",
  "50901.ctrl_Dry_Contact_Generator.genPracticeFreq.0": "无",
  "50901.ctrl_Dry_Contact_Generator.genPracticeFreq.1": "每周一次",
  "50901.ctrl_Dry_Contact_Generator.genPracticeFreq.2": "每2周一次",
  "50901.ctrl_Dry_Contact_Generator.genPracticeFreq.3": "每3周一次",
  "50901.ctrl_Dry_Contact_Generator.genPracticeFreq.4": "每4周一次",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeWeek.0": "不使能",
  "50901.ctrl_Dry_Contact_Generator.genPracticeModeWeek.1": "使能",
  "50901.ctrl_Device.masterSlave.0": "单机",
  "50901.ctrl_Device.masterSlave.1": "主机",
  "50901.ctrl_Device.masterSlave.2": "从机",
  "50901..vrtFuncCode.desc": "VRT功能码的说明。",
  "50901..vrtVoltageHighLimit3.desc": "电压上限3的说明。",
  "50901..vrtVoltageHighLimit3Time.desc": "电压上限3持续时间的说明。",
  "50901..vrtVoltageHighLimit2.desc": "电压上限2的说明。",
  "50901..vrtVoltageHighLimit2Time.desc": "电压上限2持续时间的说明。",
  "50901..vrtVoltageHighLimit1.desc": "电压上限1的说明。",
  "50901..vrtVoltageHighLimit1Time.desc": "电压上限1持续时间的说明。",
  "50901..vrtVoltageLowLimit1.desc": "电压下限1的说明。",
  "50901..vrtVoltageLowLimit1Time.desc": "电压下限1持续时间的说明。",
  "50901..vrtVoltageLowLimit2.desc": "电压下限2的说明。",
  "50901..vrtVoltageLowLimit2Time.desc": "电压下限2持续时间的说明。",
  "50901..vrtVoltageLowLimit3.desc": "电压下限3的说明。",
  "50901..vrtVoltageLowLimit3Time.desc": "电压下限3持续时间的说明。",
  "50901..vrtRecoveryStableTime.desc": "VRT恢复稳定时间的说明。",
  "50901..vrt10MinAvgVoltage.desc": "10分钟平均电压的说明。",
  "50901..vrtEn.desc": "VRT使能的说明。",
  "50901..vrtHighLimit.desc": "VRT高电压门限的说明。",
  "50901..vrtLowLimit.desc": "VRT低电压门限的说明。",
  "50901..vrtTransientOverVoltage.desc": "瞬时过电压门限的说明。",
  "50901..vrtTransientOverTime.desc": "瞬时过电压持续时间的说明。",
  "50901..frtFuncCode.desc": "FRT功能码的说明。",
  "50901..frtHighLimit3.desc": "频率上限3的说明。",
  "50901..frtHighLimit3Time.desc": "频率上限3持续时间的说明。",
  "50901..frtHighLimit2.desc": "频率上限2的说明。",
  "50901..frtHighLimit2Time.desc": "频率上限2持续时间的说明。",
  "50901..frtHighLimit1.desc": "频率上限1的说明。",
  "50901..frtHighLimit1Time.desc": "频率上限1持续时间的说明。",
  "50901..frtLowLimit1.desc": "频率下限1的说明。",
  "50901..frtLowLimit1Time.desc": "频率下限1持续时间的说明。",
  "50901..frtLowLimit2.desc": "频率下限2的说明。",
  "50901..frtLowLimit2Time.desc": "频率下限2持续时间的说明。",
  "50901..frtLowLimit3.desc": "频率下限3的说明。",
  "50901..frtLowLimit3Time.desc": "频率下限3持续时间的说明。",
  "50901..rtFuncCode.desc": "RT功能码的说明。",
  "50901..rtNMTime.desc": "RT_NM时间的说明。",
  "50901..rtSRTTime.desc": "RT_SRT时间的说明。",
  "50901..rtVoltRecoveryHighValue.desc": "RT电压恢复上限值的说明。",
  "50901..rtVoltRecoveryLowValue.desc": "RT电压恢复下限值的说明。",
  "50901..rtFreqRecoveryHighValue.desc": "RT频率恢复上限值的说明。",
  "50901..rtFreqRecoveryLowValue.desc": "RT频率恢复下限值的说明。",
  "50901..rcdEnable.desc": "RCD使能的说明。",
  "50901..continueLimitValue.desc": "RCD连续限值电流的说明。",
  "50901..continueLimitTime.desc": "RCD连续限值时间的说明。",
  "50901..step1LimitValue.desc": "RCD阶梯1限值电流的说明。",
  "50901..step1LimitTime.desc": "RCD阶梯1限值时间的说明。",
  "50901..step2LimitValue.desc": "RCD阶梯2限值电流的说明。",
  "50901..step2LimitTime.desc": "RCD阶梯2限值时间的说明。",
  "50901..step3LimitValue.desc": "RCD阶梯3限值电流的说明。",
  "50901..step3LimitTime.desc": "RCD阶梯3限值时间的说明。",
  "50901..dciEnable.desc": "DCI使能的说明。",
  "50901..upperLimit.desc": "DCI上限电流的说明。",
  "50901..upperTime.desc": "DCI上限时间的说明。",
  "50901..lowerLimit.desc": "DCI下限电流的说明。",
  "50901..lowerTime.desc": "DCI下限时间的说明。",
  "50901..gridLevel2LimitTimeScale.desc": "电网二级限值时间尺度的说明。",
  "50901..permitEnable.desc": "许可使能的说明。",
  "50901..drmEnable.desc": "DRM使能的说明。",
  "50901..antiIslandingEnable.desc": "孤岛防护使能的说明。",
  "50901..rrFuncCode.desc": "RR功能码的说明。",
  "50901..rrRurNm.desc": "RR_RUR_NM的说明。",
  "50901..rrRurSs.desc": "RR_RUR_SS的说明。",
  "50901..fwFuncCode.desc": "FW功能码的说明。",
  "50901..fwEnable.desc": "FW使能的说明。",
  "50901..fwDiffInBatMode.desc": "FW电池模式差异使能的说明。",
  "50901..fwTr.desc": "FW_Tr时间的说明。",
  "50901..fwRecoveryUpperFrequency.desc": "FW恢复频率上限的说明。",
  "50901..fwRecoveryLowerFrequency.desc": "FW恢复频率下限的说明。",
  "50901..fwRecoveryStableTime.desc": "FW恢复稳定时间的说明。",
  "50901..fwOverStartFreq.desc": "FW过频起始频率的说明。",
  "50901..fwOverEndFreq.desc": "FW过频结束频率的说明。",
  "50901..fwOverTransFreq.desc": "FW过频转换频率的说明。",
  "50901..fwUnderStartFreq.desc": "FW欠频起始频率的说明。",
  "50901..fwUnderEndFreq.desc": "FW欠频结束频率的说明。",
  "50901..fwUnderStopFreq.desc": "FW欠频停止频率的说明。",
  "50901..vwFuncCode.desc": "VW功能码的说明。",
  "50901..vwEnable.desc": "VW使能的说明。",
  "50901..vwDiffInBatMode.desc": "VW电池模式差异使能的说明。",
  "50901..vwTr.desc": "VW_Tr时间的说明。",
  "50901..vwRecoveryUpperVoltage.desc": "VW恢复电压上限的说明。",
  "50901..vwRecoveryLowerVoltage.desc": "VW恢复电压下限的说明。",
  "50901..vwRecoveryStableTime.desc": "VW恢复稳定时间的说明。",
  "50901..vwOverStartVolt.desc": "VW过压起始电压的说明。",
  "50901..vwOverEndVolt.desc": "VW过压结束电压的说明。",
  "50901..vwOverKPVolt.desc": "VW过压KP电压/系数电压的说明。",
  "50901..vwUnderStartVolt.desc": "VW欠压起始电压的说明。",
  "50901..vwUnderEndVolt.desc": "VW欠压结束电压的说明。",
  "50901..vwUnderKPVolt.desc": "VW欠压KP电压/系数电压的说明。",
  "50901..rpcMode.desc": "RP模式的说明。",
  "50901..rpcTr.desc": "RPC_Tr时间的说明。",
  "50901..rpcPf.desc": "RPC功率因数PF的说明。",
  "50901..rpcReactPowerRatio.desc": "RPC无功功率比例的说明。",
  "50901..wpfFuncCode.desc": "WPF功能码的说明。",
  "50901..wpfPowerStartRatio.desc": "WPF功率起始比例的说明。",
  "50901..wpfPowerEndRatio.desc": "WPF功率结束比例的说明。",
  "50901..wpfMinPFOver.desc": "WPF过功率最小PF的说明。",
  "50901..wpfMinPFUnder.desc": "WPF欠功率最小PF的说明。",
  "50901..wpfLockIn.desc": "WPF锁定投入值的说明。",
  "50901..wpfLockOut.desc": "WPF锁定退出值的说明。",
  "50901..vvFuncCode.desc": "VV功能码的说明。",
  "50901..vvV1.desc": "VV_V1的说明。",
  "50901..vvV2.desc": "VV_V2的说明。",
  "50901..vvV3.desc": "VV_V3的说明。",
  "50901..vvV4.desc": "VV_V4的说明。",
  "50901..vvQ1.desc": "VV_Q1的说明。",
  "50901..vvQ2.desc": "VV_Q2的说明。",
  "50901..vvQ3.desc": "VV_Q3的说明。",
  "50901..vvQ4.desc": "VV_Q4的说明。",
  "50901..vvLockIn.desc": "VV锁定投入值的说明。",
  "50901..vvLockOut.desc": "VV锁定退出值的说明。",
  "50901..vvVref.desc": "VV参考值(Vref)的说明。",
  "50901..vvVrefTr.desc": "VV参考值Tr时间的说明。",
  "50901..gcfFuncCode.desc": "GCF功能码的说明。",
  "50901..gcfEn.desc": "GCF使能的说明。",
  "50901..gcfExportSoftLimitRatio.desc": "GCF外送软限比例的说明。",
  "50901..gcfExportHardLimitRatio.desc": "GCF外送硬限比例的说明。",
  "50901..gcfExportHardTime.desc": "GCF外送硬限时间的说明。",
  "50901..gcfGenerationSoftLimitRatio.desc": "GCF发电软限比例的说明。",
  "50901..gcfGenerationHardLimitRatio.desc": "GCF发电硬限比例的说明。",
  "50901..gcfGenerationHardTime.desc": "GCF发电硬限时间的说明。",
  "50901..gcfReconnectionTime.desc": "GCF重连时间的说明。",
  "50901..wattRegulationPriority.desc": "瓦特调节优先级的说明。",
  "50901..pqP6.desc": "PQ_P6的说明。",
  "50901..pqP5.desc": "PQ_P5的说明。",
  "50901..pqP4.desc": "PQ_P4的说明。",
  "50901..pqP3.desc": "PQ_P3的说明。",
  "50901..pqP2.desc": "PQ_P2的说明。",
  "50901..pqP1.desc": "PQ_P1的说明。",
  "50901..pqQ6.desc": "PQ_Q6的说明。",
  "50901..pqQ5.desc": "PQ_Q5的说明。",
  "50901..pqQ4.desc": "PQ_Q4的说明。",
  "50901..pqQ3.desc": "PQ_Q3的说明。",
  "50901..pqQ2.desc": "PQ_Q2的说明。",
  "50901..pqQ1.desc": "PQ_Q1的说明。",
  "50901..apcEn.desc": "APC使能的说明。",
  "50901..apcPwrLmt.desc": "APC功率限值的说明。",
  "50901..apcRamp.desc": "APC爬坡率/斜坡的说明。",
  "50901..relayU16NlineRlyTestDis.desc": "继电器N线测试禁用的说明。",
  "50901..gcfImportLimitRatio.desc": "GCF受电(导入)限值比例的说明。",
  "50901..gcfImportHardTime.desc": "GCF受电(导入)硬限时间的说明。",
  "50901..phaseOrderInverseDisable.desc": "相序反向禁用的说明。",
  "50901..fixPfTr.desc": "FixPF_Tr时间的说明。",
  "50901..wpfTr.desc": "WPF_Tr时间的说明。",
  "50901..vvTr.desc": "VV_Tr时间的说明。",
  "50901..pqTr.desc": "PQ_Tr时间的说明。",
  "50901..functionCode.desc": "功能码的说明。",
  "50901..rpaP1.desc": "RPA_P1的说明。",
  "50901..rpaQ1.desc": "RPA_Q1的说明。",
  "50901..rpaP2.desc": "RPA_P2的说明。",
  "50901..rpaQ2.desc": "RPA_Q2的说明。",
  "50901..fwOverFdroop.desc": "FW过频下垂系数的说明。",
  "50901..fwUnderFdroop.desc": "FW欠频下垂系数的说明。",
  "50901..fwDelayTime.desc": "FW延时的说明。",
  "50901..pqFuncCode.desc": "PQ功能码的说明。",
  "60420.ctrl_fangniliushezhi.multiReverseFlowEnable.desc": "功能默认禁用，使能后由防逆流电表调控输出功率",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_config_mode.0": "禁止",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_config_mode.1": "外接光伏",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_config_mode.2": "外接柴发",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_config_mode.3": "强制启动",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_config_mode.4": "本地控制",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_position.0": "无",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_position.1": "柴发侧",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_position.2": "电网侧",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_type.0": "手动",
  "50901.ctrl_ESS_Advanced_Config-Generator.generator_type.1": "DI/DO",
  "50901.ctrl_ESS_Advanced_Config-System.grid_ct_reverse_enable.0": "不使能",
  "50901.ctrl_ESS_Advanced_Config-System.grid_ct_reverse_enable.1": "使能",
  "50901.ctrl_ESS_Advanced_Config-System.pv_ct_reverse_enable.0": "不使能",
  "50901.ctrl_ESS_Advanced_Config-System.pv_ct_reverse_enable.1": "使能",
  "50901.ctrl_ESS_Advanced_Config-System.mid_gateway_enable.0": "不使能",
  "50901.ctrl_ESS_Advanced_Config-System.mid_gateway_enable.1": "使能",
  "50901.ctrl_Dry_Contact_Settings-Load_Control.loadControlMode.1": "手动",
  "50901.ctrl_Dry_Contact_Settings-Load_Control.loadControlMode.2": "时间模式",
  "50901.ctrl_Dry_Contact_Settings-Load_Control.loadControlMode.3": "智能负载",
  "50901.ctrl_Dry_Contact_Settings-Load_Control.loadControlMode.4": "离网智能负载",
  "50901.ctrl_Dry_Contact_Settings-Load_Control.loadControlMode.5": "电动汽车充电器",
  "50901.ctrl_ESS_Advanced_Config-System.meter_model.0": "不使用电表",
  "50901.ctrl_ESS_Advanced_Config-System.meter_model.1": "单相电表",
  "50901.ctrl_ESS_Advanced_Config-System.meter_model.2": "两相电表",
  "50901.ctrl_ESS_Advanced_Config-System.meter_model.3": "三相电表",
  "50901.ctrl_ESS_Advanced_Config-System.meter_model.4": "智能电表（HMID表）",
  "50901.ctrl_ESS_Advanced_Config-System.meter_model.5": "电流互感器（CT）",
  "50901.ctrl_ESS_Advanced_Config-System.meter_model.6": "安科瑞单相电表",
  "50901.ctrl_ESS_Advanced_Config-System.meter_model.7": "安科瑞双相电表",
  "50901.ctrl_Config-Grid Profile.country.1": "EN_EN50549(Default)",
  "50901.ctrl_Config-Grid Profile.country.9": "US_IEEE1547(USA)",
  "50901.ctrl_Config-Grid Profile.country.18": "USHECO_Rule14(Hawaii)",
  "50901.ctrl_Config-Grid Profile.country.27": "IEEE1547_208(USA)",
  "50901.ctrl_Config-Grid Profile.country.29": "LX_US_50HZ(USA TEST)",
  "50901.ctrl_Config-Grid Profile.country.30": "IEEE1547_220(USA)",
  "50901.ctrl_Config-Grid Profile.country.44": "US_MISO_208V(USA)",
  "50901.ctrl_Config-Grid Profile.country.45": "US_MISO_240V(USA)",
  "50901.ctrl_ESS_Advanced_Config-System.threePhaseUnbalanceEnable.0": "不使能",
  "50901.ctrl_ESS_Advanced_Config-System.threePhaseUnbalanceEnable.1": "使能",
  "50901.ctrl_Device.batActivate.0": "否",
  "50901.ctrl_Device.batActivate.1": "是",
  "50901.ctrl_Device.systemPowerOnOff.0": "停止系统",
  "50901.ctrl_Device.systemPowerOnOff.1": "启动系统",
  "50901.ctrl_Device.restoreDefault.0": "否",
  "50901.ctrl_Device.restoreDefault.1": "是",
  "50901.ctrl_Device.clearFault.0": "否",
  "50901.ctrl_Device.clearFault.1": "是",
  "50901.ctrl_Device.selfTest.0": "否",
  "50901.ctrl_Device.selfTest.1": "是",
  "50901.ctrl_Device.arcFaultClear.0": "否",
  "50901.ctrl_Device.arcFaultClear.1": "是",
  "50901.ctrl_Device.batteryBalancing.0": "否",
  "50901.ctrl_Device.batteryBalancing.1": "是",
  "50901..connectionRouterStatus.0": "未连接",
  "50901..connectionRouterStatus.1": "已连接",
  "50901..connectionRouterStatus.3": "未连接",
  "50901..connectionServerStatus.0": "未连接",
  "50901..connectionServerStatus.3": "未连接",
  "50901..connectionServerStatus.1": "已连接",
  "50901..connectionServerStatus.2": "已连接",
  "50901..brightness.desc": "显示屏亮度的说明",
  "50901..batteryHealing.desc": "电池恢复的说明。",
  "50901..connectionRouterStatus.desc": "连接路由器状态的说明。",
  "50901..connectionServerStatus.desc": "连接器服务状态的说明。",
  "51301.real_time.coolingSetTemperature": "制冷设定温度",
  "51301.real_time.versionDemo01": "versionDemo01",
  "51301.real_time.versionDemo02": "versionDemo02",
  "51301.real_time.versionDemo03": "versionDemo03",
  "51301.real_time.coolingSetTemperature.desc": "参数范围：7-25",
  "platformType.android": "安卓版本",
  "platformType.ios": "IOS版本",
  "50901.ctrl_Safety_VRT.vrtFuncCode": "VRT功能码",
  "50901.ctrl_Safety_VRT.vrtVoltageHighLimit3": "电压上限3",
  "50901.ctrl_Safety_VRT.vrtVoltageHighLimit3Time": "电压上限3持续时间",
  "50901.ctrl_Safety_VRT.vrtVoltageHighLimit2": "电压上限2",
  "50901.ctrl_Safety_VRT.vrtVoltageHighLimit2Time": "电压上限2持续时间",
  "50901.ctrl_Safety_VRT.vrtVoltageHighLimit1": "电压上限1",
  "50901.ctrl_Safety_VRT.vrtVoltageHighLimit1Time": "电压上限1持续时间",
  "50901.ctrl_Safety_VRT.vrtVoltageLowLimit1": "电压下限1",
  "50901.ctrl_Safety_VRT.vrtVoltageLowLimit1Time": "电压下限1持续时间",
  "50901.ctrl_Safety_VRT.vrtVoltageLowLimit2": "电压下限2",
  "50901.ctrl_Safety_VRT.vrtVoltageLowLimit2Time": "电压下限2持续时间",
  "50901.ctrl_Safety_VRT.vrtVoltageLowLimit3": "电压下限3",
  "50901.ctrl_Safety_VRT.vrtVoltageLowLimit3Time": "电压下限3持续时间",
  "50901.ctrl_Safety_VRT.vrtRecoveryStableTime": "VRT恢复稳定时间",
  "50901.ctrl_Safety_VRT.vrt10MinAvgVoltage": "10分钟平均电压",
  "50901.ctrl_Safety_VRT.vrtEn": "VRT使能",
  "50901.ctrl_Safety_VRT.vrtHighLimit": "VRT高电压门限",
  "50901.ctrl_Safety_VRT.vrtLowLimit": "VRT低电压门限",
  "50901.ctrl_Safety_VRT.vrtTransientOverVoltage": "瞬时过电压门限",
  "50901.ctrl_Safety_VRT.vrtTransientOverTime": "瞬时过电压持续时间",
  "50901.ctrl_Safety_FRT.frtFuncCode": "FRT功能码",
  "50901.ctrl_Safety_FRT.frtHighLimit3": "频率上限3",
  "50901.ctrl_Safety_FRT.frtHighLimit3Time": "频率上限3持续时间",
  "50901.ctrl_Safety_FRT.frtHighLimit2": "频率上限2",
  "50901.ctrl_Safety_FRT.frtHighLimit2Time": "频率上限2持续时间",
  "50901.ctrl_Safety_FRT.frtHighLimit1": "频率上限1",
  "50901.ctrl_Safety_FRT.frtHighLimit1Time": "频率上限1持续时间",
  "50901.ctrl_Safety_FRT.frtLowLimit1": "频率下限1",
  "50901.ctrl_Safety_FRT.frtLowLimit1Time": "频率下限1持续时间",
  "50901.ctrl_Safety_FRT.frtLowLimit2": "频率下限2",
  "50901.ctrl_Safety_FRT.frtLowLimit2Time": "频率下限2持续时间",
  "50901.ctrl_Safety_FRT.frtLowLimit3": "频率下限3",
  "50901.ctrl_Safety_FRT.frtLowLimit3Time": "频率下限3持续时间",
  "50901.ctrl_Safety_RT.rtFuncCode": "RT功能码",
  "50901.ctrl_Safety_RT.rtNMTime": "RT_NM时间",
  "50901.ctrl_Safety_RT.rtSRTTime": "RT_SRT时间",
  "50901.ctrl_Safety_RT.rtVoltRecoveryHighValue": "RT电压恢复上限值",
  "50901.ctrl_Safety_RT.rtVoltRecoveryLowValue": "RT电压恢复下限值",
  "50901.ctrl_Safety_RT.rtFreqRecoveryHighValue": "RT频率恢复上限值",
  "50901.ctrl_Safety_RT.rtFreqRecoveryLowValue": "RT频率恢复下限值",
  "50901.ctrl_Safety_RCD.rcdEnable": "RCD使能",
  "50901.ctrl_Safety_RCD.continueLimitValue": "RCD连续限值电流",
  "50901.ctrl_Safety_RCD.continueLimitTime": "RCD连续限值时间",
  "50901.ctrl_Safety_RCD.step1LimitValue": "RCD阶梯1限值电流",
  "50901.ctrl_Safety_RCD.step1LimitTime": "RCD阶梯1限值时间",
  "50901.ctrl_Safety_RCD.step2LimitValue": "RCD阶梯2限值电流",
  "50901.ctrl_Safety_RCD.step2LimitTime": "RCD阶梯2限值时间",
  "50901.ctrl_Safety_RCD.step3LimitValue": "RCD阶梯3限值电流",
  "50901.ctrl_Safety_RCD.step3LimitTime": "RCD阶梯3限值时间",
  "50901.ctrl_Safety_DCI.dciEnable": "DCI使能",
  "50901.ctrl_Safety_DCI.upperLimit": "DCI上限电流",
  "50901.ctrl_Safety_DCI.upperTime": "DCI上限时间",
  "50901.ctrl_Safety_DCI.lowerLimit": "DCI下限电流",
  "50901.ctrl_Safety_DCI.lowerTime": "DCI下限时间",
  "50901.ctrl_Safety_RR.rrFuncCode": "RR功能码",
  "50901.ctrl_Safety_RR.rrRurNm": "RR_RUR_NM",
  "50901.ctrl_Safety_RR.rrRurSs": "RR_RUR_SS",
  "50901.ctrl_Safety_FW.fwFuncCode": "FW功能码",
  "50901.ctrl_Safety_FW.fwEnable": "FW使能",
  "50901.ctrl_Safety_FW.fwDiffInBatMode": "FW电池模式差异使能",
  "50901.ctrl_Safety_FW.fwTr": "FW_Tr时间",
  "50901.ctrl_Safety_FW.fwRecoveryUpperFrequency": "FW恢复频率上限",
  "50901.ctrl_Safety_FW.fwRecoveryLowerFrequency": "FW恢复频率下限",
  "50901.ctrl_Safety_FW.fwRecoveryStableTime": "FW恢复稳定时间",
  "50901.ctrl_Safety_FW.fwOverStartFreq": "FW过频起始频率",
  "50901.ctrl_Safety_FW.fwOverEndFreq": "FW过频结束频率",
  "50901.ctrl_Safety_FW.fwOverTransFreq": "FW过频转换频率",
  "50901.ctrl_Safety_FW.fwUnderStartFreq": "FW欠频起始频率",
  "50901.ctrl_Safety_FW.fwUnderEndFreq": "FW欠频结束频率",
  "50901.ctrl_Safety_FW.fwUnderStopFreq": "FW欠频停止频率",
  "50901.ctrl_Safety_VW.vwFuncCode": "VW功能码",
  "50901.ctrl_Safety_FW.vwEnable": "VW使能",
  "50901.ctrl_Safety_FW.vwDiffInBatMode": "VW电池模式差异使能",
  "50901.ctrl_Safety_FW.vwTr": "VW_Tr时间",
  "50901.ctrl_Safety_FW.vwRecoveryUpperVoltage": "VW恢复电压上限",
  "50901.ctrl_Safety_FW.vwRecoveryLowerVoltage": "VW恢复电压下限",
  "50901.ctrl_Safety_FW.vwRecoveryStableTime": "VW恢复稳定时间",
  "50901.ctrl_Safety_FW.vwOverStartVolt": "VW过压起始电压",
  "50901.ctrl_Safety_FW.vwOverEndVolt": "VW过压结束电压",
  "50901.ctrl_Safety_FW.vwOverKPVolt": "VW过压KP电压/系数电压",
  "50901.ctrl_Safety_FW.vwUnderStartVolt": "VW欠压起始电压",
  "50901.ctrl_Safety_FW.vwUnderEndVolt": "VW欠压结束电压",
  "50901.ctrl_Safety_FW.vwUnderKPVolt": "VW欠压KP电压/系数电压",
  "50901.ctrl_Safety_RPC.rpcMode": "RPC模式",
  "50901.ctrl_Safety_RPC.rpcTr": "RPC_Tr时间",
  "50901.ctrl_Safety_RPC.rpcPf": "RPC功率因数PF",
  "50901.ctrl_Safety_RPC.rpcReactPowerRatio": "RPC无功功率比例",
  "50901.ctrl_Safety_RPC.wpfFuncCode": "WPF功能码",
  "50901.ctrl_Safety_RPC.wpfPowerStartRatio": "WPF功率起始比例",
  "50901.ctrl_Safety_RPC.wpfPowerEndRatio": "WPF功率结束比例",
  "50901.ctrl_Safety_RPC.wpfMinPFOver": "WPF过功率最小PF",
  "50901.ctrl_Safety_RPC.wpfMinPFUnder": "WPF欠功率最小PF",
  "50901.ctrl_Safety_RPC.wpfLockIn": "WPF锁定投入值",
  "50901.ctrl_Safety_RPC.wpfLockOut": "WPF锁定退出值",
  "50901.ctrl_Safety_RPC.vvFuncCode": "Volt-Var功能码",
  "50901.ctrl_Safety_RPC.vvV1": "Voltage Set Point_V1",
  "50901.ctrl_Safety_RPC.vvV2": "Voltage Set Point_V2",
  "50901.ctrl_Safety_RPC.vvV3": "Voltage Set Point_V3",
  "50901.ctrl_Safety_RPC.vvV4": "Voltage Set Point_V4",
  "50901.ctrl_Safety_RPC.vvQ1": "Reactive Set Point_Q1",
  "50901.ctrl_Safety_RPC.vvQ2": "Reactive Set Point_Q2",
  "50901.ctrl_Safety_RPC.vvQ3": "Reactive Set Point_Q3",
  "50901.ctrl_Safety_RPC.vvQ4": "Reactive Set Point_Q4",
  "50901.ctrl_Safety_RPC.vvLockIn": "VV锁定投入值",
  "50901.ctrl_Safety_RPC.vvLockOut": "VV锁定退出值",
  "50901.ctrl_Safety_RPC.vvVref": "调压参考值(Vref)",
  "50901.ctrl_Safety_RPC.vvVrefTr": "调压参考值Tr时间",
  "50901.ctrl_Safety_GCF.gcfFuncCode": "GCF功能码",
  "50901.ctrl_Safety_GCF.gcfEn": "GCF使能",
  "50901.ctrl_Safety_GCF.gcfExportSoftLimitRatio": "GCF外送软限比例",
  "50901.ctrl_Safety_GCF.gcfExportHardLimitRatio": "GCF外送硬限比例",
  "50901.ctrl_Safety_VRT.vrtEn.00": "disable",
  "50901.ctrl_Safety_VRT.vrtEn.01": "enable",
  "50901.ctrl_Safety_RCD.rcdEnable.00": "disable",
  "50901.ctrl_Safety_RCD.rcdEnable.01": "enable",
  "50901.ctrl_Safety_DCI.dciEnable.00": "disable",
  "50901.ctrl_Safety_DCI.dciEnable.01": "enable",
  "50901.ctrl_Safety_FW.fwEnable.00": "disable",
  "50901.ctrl_Safety_FW.fwEnable.01": "enable",
  "50901.ctrl_Safety_FW.fwDiffInBatMode.00": "disable",
  "50901.ctrl_Safety_FW.fwDiffInBatMode.01": "enable",
  "50901.ctrl_Safety_FW.vwEnable.00": "disable",
  "50901.ctrl_Safety_FW.vwEnable.01": "enable",
  "50901.ctrl_Safety_FW.vwDiffInBatMode.00": "disable",
  "50901.ctrl_Safety_FW.vwDiffInBatMode.01": "enable",
  "50901.ctrl_Safety_RPC.rpcMode.00": "disable",
  "50901.ctrl_Safety_RPC.rpcMode.01": "Fixed Power Factor, PF Mode",
  "50901.ctrl_Safety_RPC.rpcMode.02": "Fixed Reactive Power, Q Mode",
  "50901.ctrl_Safety_RPC.rpcMode.03": "PF(P) Curve, PF(P) Mode",
  "50901.ctrl_Safety_RPC.rpcMode.04": "W",
  "50901.ctrl_Safety_RPC.rpcMode.05": "PQ",
  "50901.ctrl_Safety_GCF.gcfEn.00": "disable",
  "50901.ctrl_Safety_GCF.gcfEn.01": "enable",
  "50901.ctrl_Safety_VRT.vrtFuncCode.desc": "VRT功能码的说明。",
  "50901.ctrl_Safety_VRT.vrtVoltageHighLimit3.desc": "电压上限3的说明。",
  "50901.ctrl_Safety_VRT.vrtVoltageHighLimit3Time.desc": "电压上限3持续时间的说明。",
  "50901.ctrl_Safety_VRT.vrtVoltageHighLimit2.desc": "电压上限2的说明。",
  "50901.ctrl_Safety_VRT.vrtVoltageHighLimit2Time.desc": "电压上限2持续时间的说明。",
  "50901.ctrl_Safety_VRT.vrtVoltageHighLimit1.desc": "电压上限1的说明。",
  "50901.ctrl_Safety_VRT.vrtVoltageHighLimit1Time.desc": "电压上限1持续时间的说明。",
  "50901.ctrl_Safety_VRT.vrtVoltageLowLimit1.desc": "电压下限1的说明。",
  "50901.ctrl_Safety_VRT.vrtVoltageLowLimit1Time.desc": "电压下限1持续时间的说明。",
  "50901.ctrl_Safety_VRT.vrtVoltageLowLimit2.desc": "电压下限2的说明。",
  "50901.ctrl_Safety_VRT.vrtVoltageLowLimit2Time.desc": "电压下限2持续时间的说明。",
  "50901.ctrl_Safety_VRT.vrtVoltageLowLimit3.desc": "电压下限3的说明。",
  "50901.ctrl_Safety_VRT.vrtVoltageLowLimit3Time.desc": "电压下限3持续时间的说明。",
  "50901.ctrl_Safety_VRT.vrtRecoveryStableTime.desc": "VRT恢复稳定时间的说明。",
  "50901.ctrl_Safety_VRT.vrt10MinAvgVoltage.desc": "10分钟平均电压的说明。",
  "50901.ctrl_Safety_VRT.vrtEn.desc": "VRT使能的说明。",
  "50901.ctrl_Safety_VRT.vrtHighLimit.desc": "VRT高电压门限的说明。",
  "50901.ctrl_Safety_VRT.vrtLowLimit.desc": "VRT低电压门限的说明。",
  "50901.ctrl_Safety_VRT.vrtTransientOverVoltage.desc": "瞬时过电压门限的说明。",
  "50901.ctrl_Safety_VRT.vrtTransientOverTime.desc": "瞬时过电压持续时间的说明。",
  "50901.ctrl_Safety_FRT.frtFuncCode.desc": "FRT功能码的说明。",
  "50901.ctrl_Safety_FRT.frtHighLimit3.desc": "频率上限3的说明。",
  "50901.ctrl_Safety_FRT.frtHighLimit3Time.desc": "频率上限3持续时间的说明。",
  "50901.ctrl_Safety_FRT.frtHighLimit2.desc": "频率上限2的说明。",
  "50901.ctrl_Safety_FRT.frtHighLimit2Time.desc": "频率上限2持续时间的说明。",
  "50901.ctrl_Safety_FRT.frtHighLimit1.desc": "频率上限1的说明。",
  "50901.ctrl_Safety_FRT.frtHighLimit1Time.desc": "频率上限1持续时间的说明。",
  "50901.ctrl_Safety_FRT.frtLowLimit1.desc": "频率下限1的说明。",
  "50901.ctrl_Safety_FRT.frtLowLimit1Time.desc": "频率下限1持续时间的说明。",
  "50901.ctrl_Safety_FRT.frtLowLimit2.desc": "频率下限2的说明。",
  "50901.ctrl_Safety_FRT.frtLowLimit2Time.desc": "频率下限2持续时间的说明。",
  "50901.ctrl_Safety_FRT.frtLowLimit3.desc": "频率下限3的说明。",
  "50901.ctrl_Safety_FRT.frtLowLimit3Time.desc": "频率下限3持续时间的说明。",
  "50901.ctrl_Safety_RT.rtFuncCode.desc": "RT功能码的说明。",
  "50901.ctrl_Safety_RT.rtNMTime.desc": "RT_NM时间的说明。",
  "50901.ctrl_Safety_RT.rtSRTTime.desc": "RT_SRT时间的说明。",
  "50901.ctrl_Safety_RT.rtVoltRecoveryHighValue.desc": "RT电压恢复上限值的说明。",
  "50901.ctrl_Safety_RT.rtVoltRecoveryLowValue.desc": "RT电压恢复下限值的说明。",
  "50901.ctrl_Safety_RT.rtFreqRecoveryHighValue.desc": "RT频率恢复上限值的说明。",
  "50901.ctrl_Safety_RT.rtFreqRecoveryLowValue.desc": "RT频率恢复下限值的说明。",
  "50901.ctrl_Safety_RCD.rcdEnable.desc": "RCD使能的说明。",
  "50901.ctrl_Safety_RCD.continueLimitValue.desc": "RCD连续限值电流的说明。",
  "50901.ctrl_Safety_RCD.continueLimitTime.desc": "RCD连续限值时间的说明。",
  "50901.ctrl_Safety_RCD.step1LimitValue.desc": "RCD阶梯1限值电流的说明。",
  "50901.ctrl_Safety_RCD.step1LimitTime.desc": "RCD阶梯1限值时间的说明。",
  "50901.ctrl_Safety_RCD.step2LimitValue.desc": "RCD阶梯2限值电流的说明。",
  "50901.ctrl_Safety_RCD.step2LimitTime.desc": "RCD阶梯2限值时间的说明。",
  "50901.ctrl_Safety_RCD.step3LimitValue.desc": "RCD阶梯3限值电流的说明。",
  "50901.ctrl_Safety_RCD.step3LimitTime.desc": "RCD阶梯3限值时间的说明。",
  "50901.ctrl_Safety_DCI.dciEnable.desc": "DCI使能的说明。",
  "50901.ctrl_Safety_DCI.upperLimit.desc": "DCI上限电流的说明。",
  "50901.ctrl_Safety_DCI.upperTime.desc": "DCI上限时间的说明。",
  "50901.ctrl_Safety_DCI.lowerLimit.desc": "DCI下限电流的说明。",
  "50901.ctrl_Safety_DCI.lowerTime.desc": "DCI下限时间的说明。",
  "50901.ctrl_Safety_RR.rrFuncCode.desc": "RR功能码的说明。",
  "50901.ctrl_Safety_RR.rrRurNm.desc": "RR_RUR_NM的说明。",
  "50901.ctrl_Safety_RR.rrRurSs.desc": "RR_RUR_SS的说明。",
  "50901.ctrl_Safety_FW.fwFuncCode.desc": "FW功能码的说明。",
  "50901.ctrl_Safety_FW.fwEnable.desc": "FW使能的说明。",
  "50901.ctrl_Safety_FW.fwDiffInBatMode.desc": "FW电池模式差异使能的说明。",
  "50901.ctrl_Safety_FW.fwTr.desc": "FW_Tr时间的说明。",
  "50901.ctrl_Safety_FW.fwRecoveryUpperFrequency.desc": "FW恢复频率上限的说明。",
  "50901.ctrl_Safety_FW.fwRecoveryLowerFrequency.desc": "FW恢复频率下限的说明。",
  "50901.ctrl_Safety_FW.fwRecoveryStableTime.desc": "FW恢复稳定时间的说明。",
  "50901.ctrl_Safety_FW.fwOverStartFreq.desc": "FW过频起始频率的说明。",
  "50901.ctrl_Safety_FW.fwOverEndFreq.desc": "FW过频结束频率的说明。",
  "50901.ctrl_Safety_FW.fwOverTransFreq.desc": "FW过频转换频率的说明。",
  "50901.ctrl_Safety_FW.fwUnderStartFreq.desc": "FW欠频起始频率的说明。",
  "50901.ctrl_Safety_FW.fwUnderEndFreq.desc": "FW欠频结束频率的说明。",
  "50901.ctrl_Safety_FW.fwUnderStopFreq.desc": "FW欠频停止频率的说明。",
  "50901.ctrl_Safety_VW.vwFuncCode.desc": "VW功能码的说明。",
  "50901.ctrl_Safety_FW.vwEnable.desc": "VW使能的说明。",
  "50901.ctrl_Safety_FW.vwDiffInBatMode.desc": "VW电池模式差异使能的说明。",
  "50901.ctrl_Safety_FW.vwTr.desc": "VW_Tr时间的说明。",
  "50901.ctrl_Safety_FW.vwRecoveryUpperVoltage.desc": "VW恢复电压上限的说明。",
  "50901.ctrl_Safety_FW.vwRecoveryLowerVoltage.desc": "VW恢复电压下限的说明。",
  "50901.ctrl_Safety_FW.vwRecoveryStableTime.desc": "VW恢复稳定时间的说明。",
  "50901.ctrl_Safety_FW.vwOverStartVolt.desc": "VW过压起始电压的说明。",
  "50901.ctrl_Safety_FW.vwOverEndVolt.desc": "VW过压结束电压的说明。",
  "50901.ctrl_Safety_FW.vwOverKPVolt.desc": "VW过压KP电压/系数电压的说明。",
  "50901.ctrl_Safety_FW.vwUnderStartVolt.desc": "VW欠压起始电压的说明。",
  "50901.ctrl_Safety_FW.vwUnderEndVolt.desc": "VW欠压结束电压的说明。",
  "50901.ctrl_Safety_FW.vwUnderKPVolt.desc": "VW欠压KP电压/系数电压的说明。",
  "50901.ctrl_Safety_RPC.rpcMode.desc": "RP模式的说明。",
  "50901.ctrl_Safety_RPC.rpcTr.desc": "RPC_Tr时间的说明。",
  "50901.ctrl_Safety_RPC.rpcPf.desc": "RPC功率因数PF的说明。",
  "50901.ctrl_Safety_RPC.rpcReactPowerRatio.desc": "RPC无功功率比例的说明。",
  "50901.ctrl_Safety_RPC.wpfFuncCode.desc": "WPF功能码的说明。",
  "50901.ctrl_Safety_RPC.wpfPowerStartRatio.desc": "WPF功率起始比例的说明。",
  "50901.ctrl_Safety_RPC.wpfPowerEndRatio.desc": "WPF功率结束比例的说明。",
  "50901.ctrl_Safety_RPC.wpfMinPFOver.desc": "WPF过功率最小PF的说明。",
  "50901.ctrl_Safety_RPC.wpfMinPFUnder.desc": "WPF欠功率最小PF的说明。",
  "50901.ctrl_Safety_RPC.wpfLockIn.desc": "WPF锁定投入值的说明。",
  "50901.ctrl_Safety_RPC.wpfLockOut.desc": "WPF锁定退出值的说明。",
  "50901.ctrl_Safety_RPC.vvFuncCode.desc": "VV功能码的说明。",
  "50901.ctrl_Safety_RPC.vvV1.desc": "VV_V1的说明。",
  "50901.ctrl_Safety_RPC.vvV2.desc": "VV_V2的说明。",
  "50901.ctrl_Safety_RPC.vvV3.desc": "VV_V3的说明。",
  "50901.ctrl_Safety_RPC.vvV4.desc": "VV_V4的说明。",
  "50901.ctrl_Safety_RPC.vvQ1.desc": "VV_Q1的说明。",
  "50901.ctrl_Safety_RPC.vvQ2.desc": "VV_Q2的说明。",
  "50901.ctrl_Safety_RPC.vvQ3.desc": "VV_Q3的说明。",
  "50901.ctrl_Safety_RPC.vvQ4.desc": "VV_Q4的说明。",
  "50901.ctrl_Safety_RPC.vvLockIn.desc": "VV锁定投入值的说明。",
  "50901.ctrl_Safety_RPC.vvLockOut.desc": "VV锁定退出值的说明。",
  "50901.ctrl_Safety_RPC.vvVref.desc": "VV参考值(Vref)的说明。",
  "50901.ctrl_Safety_RPC.vvVrefTr.desc": "VV参考值Tr时间的说明。",
  "50901.ctrl_Safety_GCF.gcfFuncCode.desc": "GCF功能码的说明。",
  "50901.ctrl_Safety_GCF.gcfEn.desc": "GCF使能的说明。",
  "50901.ctrl_Safety_GCF.gcfExportSoftLimitRatio.desc": "GCF外送软限比例的说明。",
  "50901.ctrl_Safety_GCF.gcfExportHardLimitRatio.desc": "GCF外送硬限比例的说明。",
  "50901.ctrl_Safety_FW": "安规-电压漂移",
  "50901.ctrl_Safety_VRT": "安规-电压穿越",
  "50901.ctrl_Safety_RPC": "安规-无功功率控制",
  "50901.ctrl_Safety_FRT": "安规-频率穿越",
  "50901.ctrl_Safety_DCI": "安规-直流隔离",
  "50901.ctrl_Safety_GCF": "安规",
  "50901.ctrl_Safety_RCD": "安规-漏电保护",
  "50901.ctrl_Safety_VW": "安规-电压漂移",
  "50901.ctrl_Safety_RT": "安规-穿越",
  "50901.ctrl_Safety_RR": "安规-变化速率",
  "settlementMeterType.GATEWAY_METER": "关口表",
  "settlementMeterType.PV_METER": "光伏表",
  "settlementMeterType.ENERGY_STORAGE_METER": "储能表",
  "settlementMeterType.CHARGING_PILE_METER": "充电桩表",
  "NC2022": "New Caledonia_NC2022",
  "EN50549_IE": "EU_EN50549_IE",
  "PR_240VAC": "PR_240VAC",
  "VDE0126_GR": "France_VDE0126_GR",
  "PPDS": "Czechia_PPDS",
  "NCRFG": "Poland_NCRFG",
  "NF50549_1": "France_NF50549_1",
  "RESERVE_SFAY_E": "China_NBT32004",
  "50901.ctrl_WorkMode.workMode.6": "削峰模式",
  "50901.ctrl_WorkMode.workMode.7": "定时充放模式",
  "50901.real_time.meterFlag.3": "gateway通讯正常",
  "50901.real_time.meterFlag.4": "gateway通讯断开",
  "connect.type.wifi": "WIFi+热点",
  "connect.type.lan": "网线",
  "50901.ctrl_ESS_Advanced_Config-System/bigboss/snake.meter_model": "电表型号",
  "50901.ctrl_ESS_Advanced_Config-System/bigboss/snake.meter_model.0": "不使用电表",
  "50901.ctrl_ESS_Advanced_Config-System/bigboss/snake.meter_model.1": "单相电表",
  "50901.ctrl_ESS_Advanced_Config-System/bigboss/snake.meter_model.2": "两相电表",
  "50901.ctrl_ESS_Advanced_Config-System/bigboss/snake.meter_model.3": "三相电表",
  "50901.ctrl_ESS_Advanced_Config-System/bigboss/snake.meter_model.4": "智能电表（HMID表）",
  "50901.ctrl_ESS_Advanced_Config-System/bigboss/snake.meter_model.5": "电流互感器（CT）",
  "50901.ctrl_ESS_Advanced_Config-System/bigboss/snake.meter_model.6": "安科瑞单相电表",
  "50901.ctrl_ESS_Advanced_Config-System/bigboss/snake.meter_model.7": "安科瑞双相电表",
  "50901.ctrl_ESS_Advanced_Config-System/bigboss/snake.meter_model.desc": "电表型号的说明",
  "50901.ctrl_ESS_Advanced_Config-System/bigboss/snake": "高级配置-系统",
  "50901.ctrl_Safety_VRT.vrtEn.0": "disable",
  "50901.ctrl_Safety_VRT.vrtEn.1": "enable",
  "50901.ctrl_Safety_RCD.rcdEnable.0": "disable",
  "50901.ctrl_Safety_RCD.rcdEnable.1": "enable",
  "50901.ctrl_Safety_DCI.dciEnable.0": "disable",
  "50901.ctrl_Safety_DCI.dciEnable.1": "enable",
  "50901..permitEnable.0": "disable",
  "50901..permitEnable.1": "使能",
  "50901..drmEnable.0": "不使能",
  "50901..drmEnable.1": "enable",
  "50901..antiIslandingEnable.0": "disable",
  "50901..antiIslandingEnable.1": "使能",
  "50901.ctrl_Safety_FW.fwEnable.0": "disable",
  "50901.ctrl_Safety_FW.fwEnable.1": "enable",
  "50901.ctrl_Safety_FW.fwDiffInBatMode.0": "disable",
  "50901.ctrl_Safety_FW.fwDiffInBatMode.1": "enable",
  "50901.ctrl_Safety_FW.vwEnable.0": "disable",
  "50901.ctrl_Safety_FW.vwEnable.1": "enable",
  "50901.ctrl_Safety_FW.vwDiffInBatMode.0": "disable",
  "50901.ctrl_Safety_FW.vwDiffInBatMode.1": "enable",
  "50901.ctrl_Safety_GCF.gcfEn.0": "disable",
  "50901.ctrl_Safety_GCF.gcfEn.1": "enable",
  "50901..apcEn.0": "disable",
  "50901..apcEn.1": "enable",
  "50901..absoluteTime.desc": "绝对时间的说明。",
  "50901..timeZone.desc": "时区的说明。",
  "50901..dfs.desc": "能力集的说明。",
  "ice.rob.stra.execute.state.pen.exe": "待执行",
  "50901.ctrl_ESS_shit_Advanced_Config-System/bigboss/snake.meter_model": "电表型号",
  "50901.ctrl_group.first.second.param_group": "参数_组",
  "50901.ctrl_WorkMode-economic.section1WeekRange1.0": "周一",
  "50901.ctrl_WorkMode-economic.section1WeekRange1.1": "周二",
  "50901.ctrl_WorkMode-economic.section1WeekRange1.2": "周三",
  "50901.ctrl_WorkMode-economic.section1WeekRange1.3": "周四",
  "50901.ctrl_WorkMode-economic.section1WeekRange1.4": "周五",
  "50901.ctrl_WorkMode-economic.section1WeekRange1.5": "周六",
  "50901.ctrl_WorkMode-economic.section1WeekRange1.6": "周日",
  "50901.ctrl_group.first.second": "二级组测试",
  "60420.ctrl_param_shebeixinxishezhi.485_3address": "485_3地址设置",
  "60420.ctrl_param_shebeixinxishezhi.485_3address.desc": "485_3地址设置的说明。",
  "60001.group_collector.resetDevice": "采集棒重置",
  "60001.group_collector.type.11": "SDatalog-WiFi",
  "60001.group_collector.type.12": "SDatalog-BWiFi ",
  "60001.group_collector.type.23": "SDatalog-4G",
  "60001.group_collector.bleEnable.0": "关闭",
  "60001.group_collector.bleEnable.1": "打开",
  "60001.group_collector.resetDevice.desc": "重置通讯棒，蓝牙密码恢复至初始默认密码",
  "50901.real_time.copy_dspVersionMainUVersion": "DSP版本(主U版本)",
  "50901.ctrl_first.second.third.property_grouping_test": "分组名测试参数",
  "50901.ctrl_Device.meterConfiguration.2": "配置PV电表",
  "50901.ctrl_Device.meterConfiguration.3": "配置网侧+PV电表",
  "50901..dspVersionMainUVersion.desc": "DSP版本(主U版本)的说明。",
  "50901.real_time.copy_dspVersionMainUVersion.desc": "DSP版本(主U版本)的说明。",
  "50901.ctrl_first": "一级分组",
  "50901.second": "二级分组",
  "50901.third": "三级分组",
  "50901.ctrl_first.second.property_grouping_test_default": "分组名测试参数默认",
  "50901.ctrl_first.property_grouping_test_first_default": "分组名测试参数一级默认",
  "50901.ctrl_ESS_Advanced_Config.ctrl_ESS_Advanced_Config-System.meter_model": "电表型号",
  "50901.ctrl_ESS_Advanced_Config.ctrl_ESS_Advanced_Config-System.meter_model.0": "不使用电表",
  "50901.ctrl_ESS_Advanced_Config.ctrl_ESS_Advanced_Config-System.meter_model.1": "单相电表",
  "50901.ctrl_ESS_Advanced_Config.ctrl_ESS_Advanced_Config-System.meter_model.2": "两相电表",
  "50901.ctrl_ESS_Advanced_Config.ctrl_ESS_Advanced_Config-System.meter_model.3": "三相电表",
  "50901.ctrl_ESS_Advanced_Config.ctrl_ESS_Advanced_Config-System.meter_model.4": "智能电表（HMID表）",
  "50901.ctrl_ESS_Advanced_Config.ctrl_ESS_Advanced_Config-System.meter_model.5": "电流互感器（CT）",
  "50901.ctrl_ESS_Advanced_Config.ctrl_ESS_Advanced_Config-System.meter_model.6": "安科瑞单相电表",
  "50901.ctrl_ESS_Advanced_Config.ctrl_ESS_Advanced_Config-System.meter_model.7": "安科瑞双相电表",
  "50901.ctrl_ESS_Advanced_Config.ctrl_ESS_Advanced_Config-System.meter_model.desc": "电表型号的说明",
  "50901.ctrl_ESS_Advanced_Config": "高级配置",
  "50901.ctrl_WorkModeSetting": "工作模式设置",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model": "电表型号",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode": "柴发端口模式",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position": "柴发位置",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type": "柴发类型",
  "50901.ctrl_ESS_Advanced_Config.Generator.min_run_time": "最小运行时间",
  "50901.ctrl_ESS_Advanced_Config.Generator.max_run_time": "最大运行时间",
  "50901.ctrl_ESS_Advanced_Config.Generator.run_protect_threshold": "运行保护间隔",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_sync_time": "柴发同步时间",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_shutdown_delay": "柴发关机延时",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable": "Grid CT反向使能",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable": "PV CT反向使能",
  "50901.ctrl_ESS_Advanced_Config.System.grid_meter_ratio": "Grid CT电表匝比设置",
  "50901.ctrl_ESS_Advanced_Config.System.pv_meter_ratio": "PV CT电表匝比设置",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable": "MID / Gateway使能",
  "50901.ctrl_Config.Grid Profile.country": "国家/并网标准国家",
  "50901.ctrl_Safety.VRT.vrtFuncCode": "VRT功能码",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit3": "电压上限3",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit3Time": "电压上限3持续时间",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit2": "电压上限2",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit2Time": "电压上限2持续时间",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit1": "电压上限1",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit1Time": "电压上限1持续时间",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit1": "电压下限1",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit1Time": "电压下限1持续时间",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit2": "电压下限2",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit2Time": "电压下限2持续时间",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit3": "电压下限3",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit3Time": "电压下限3持续时间",
  "50901.ctrl_Safety.VRT.vrtRecoveryStableTime": "VRT恢复稳定时间",
  "50901.ctrl_Safety.VRT.vrt10MinAvgVoltage": "10分钟平均电压",
  "50901.ctrl_Safety.VRT.vrtEn": "VRT使能",
  "50901.ctrl_Safety.VRT.vrtHighLimit": "VRT高电压门限",
  "50901.ctrl_Safety.VRT.vrtLowLimit": "VRT低电压门限",
  "50901.ctrl_Safety.VRT.vrtTransientOverVoltage": "瞬时过电压门限",
  "50901.ctrl_Safety.VRT.vrtTransientOverTime": "瞬时过电压持续时间",
  "50901.ctrl_Safety.FRT.frtFuncCode": "FRT功能码",
  "50901.ctrl_Safety.FRT.frtHighLimit3": "频率上限3",
  "50901.ctrl_Safety.FRT.frtHighLimit3Time": "频率上限3持续时间",
  "50901.ctrl_Safety.FRT.frtHighLimit2": "频率上限2",
  "50901.ctrl_Safety.FRT.frtHighLimit2Time": "频率上限2持续时间",
  "50901.ctrl_Safety.FRT.frtHighLimit1": "频率上限1",
  "50901.ctrl_Safety.FRT.frtHighLimit1Time": "频率上限1持续时间",
  "50901.ctrl_Safety.FRT.frtLowLimit1": "频率下限1",
  "50901.ctrl_Safety.FRT.frtLowLimit1Time": "频率下限1持续时间",
  "50901.ctrl_Safety.FRT.frtLowLimit2": "频率下限2",
  "50901.ctrl_Safety.FRT.frtLowLimit2Time": "频率下限2持续时间",
  "50901.ctrl_Safety.FRT.frtLowLimit3": "频率下限3",
  "50901.ctrl_Safety.FRT.frtLowLimit3Time": "频率下限3持续时间",
  "50901.ctrl_Safety.RT.rtFuncCode": "RT功能码",
  "50901.ctrl_Safety.RT.rtNMTime": "RT_NM时间",
  "50901.ctrl_Safety.RT.rtSRTTime": "RT_SRT时间",
  "50901.ctrl_Safety.RT.rtVoltRecoveryHighValue": "RT电压恢复上限值",
  "50901.ctrl_Safety.RT.rtVoltRecoveryLowValue": "RT电压恢复下限值",
  "50901.ctrl_Safety.RT.rtFreqRecoveryHighValue": "RT频率恢复上限值",
  "50901.ctrl_Safety.RT.rtFreqRecoveryLowValue": "RT频率恢复下限值",
  "50901.ctrl_Safety.RCD.rcdEnable": "RCD使能",
  "50901.ctrl_Safety.RCD.continueLimitValue": "RCD连续限值电流",
  "50901.ctrl_Safety.RCD.continueLimitTime": "RCD连续限值时间",
  "50901.ctrl_Safety.RCD.step1LimitValue": "RCD阶梯1限值电流",
  "50901.ctrl_Safety.RCD.step1LimitTime": "RCD阶梯1限值时间",
  "50901.ctrl_Safety.RCD.step2LimitValue": "RCD阶梯2限值电流",
  "50901.ctrl_Safety.RCD.step2LimitTime": "RCD阶梯2限值时间",
  "50901.ctrl_Safety.RCD.step3LimitValue": "RCD阶梯3限值电流",
  "50901.ctrl_Safety.RCD.step3LimitTime": "RCD阶梯3限值时间",
  "50901.ctrl_Safety.DCI.dciEnable": "DCI使能",
  "50901.ctrl_Safety.DCI.upperLimit": "DCI上限电流",
  "50901.ctrl_Safety.DCI.upperTime": "DCI上限时间",
  "50901.ctrl_Safety.DCI.lowerLimit": "DCI下限电流",
  "50901.ctrl_Safety.DCI.lowerTime": "DCI下限时间",
  "50901.ctrl_Safety.RR.rrFuncCode": "RR功能码",
  "50901.ctrl_Safety.RR.rrRurNm": "RR_RUR_NM",
  "50901.ctrl_Safety.RR.rrRurSs": "RR_RUR_SS",
  "50901.ctrl_Safety.FW.fwFuncCode": "FW功能码",
  "50901.ctrl_Safety.FW.fwEnable": "FW使能",
  "50901.ctrl_Safety.FW.fwDiffInBatMode": "FW电池模式差异使能",
  "50901.ctrl_Safety.FW.fwTr": "FW_Tr时间",
  "50901.ctrl_Safety.FW.fwRecoveryUpperFrequency": "FW恢复频率上限",
  "50901.ctrl_Safety.FW.fwRecoveryLowerFrequency": "FW恢复频率下限",
  "50901.ctrl_Safety.FW.fwRecoveryStableTime": "FW恢复稳定时间",
  "50901.ctrl_Safety.FW.fwOverStartFreq": "FW过频起始频率",
  "50901.ctrl_Safety.FW.fwOverEndFreq": "FW过频结束频率",
  "50901.ctrl_Safety.FW.fwOverTransFreq": "FW过频转换频率",
  "50901.ctrl_Safety.FW.fwUnderStartFreq": "FW欠频起始频率",
  "50901.ctrl_Safety.FW.fwUnderEndFreq": "FW欠频结束频率",
  "50901.ctrl_Safety.FW.fwUnderStopFreq": "FW欠频停止频率",
  "50901.ctrl_Safety.VW.vwFuncCode": "VW功能码",
  "50901.ctrl_Safety.VW.vwEnable": "VW使能",
  "50901.ctrl_Safety.VW.vwDiffInBatMode": "VW电池模式差异使能",
  "50901.ctrl_Safety.VW.vwTr": "VW_Tr时间",
  "50901.ctrl_Safety.VW.vwRecoveryUpperVoltage": "VW恢复电压上限",
  "50901.ctrl_Safety.VW.vwRecoveryLowerVoltage": "VW恢复电压下限",
  "50901.ctrl_Safety.VW.vwRecoveryStableTime": "VW恢复稳定时间",
  "50901.ctrl_Safety.VW.vwOverStartVolt": "VW过压起始电压",
  "50901.ctrl_Safety.VW.vwOverEndVolt": "VW过压结束电压",
  "50901.ctrl_Safety.VW.vwOverKPVolt": "VW过压KP电压/系数电压",
  "50901.ctrl_Safety.VW.vwUnderStartVolt": "VW欠压起始电压",
  "50901.ctrl_Safety.VW.vwUnderEndVolt": "VW欠压结束电压",
  "50901.ctrl_Safety.VW.vwUnderKPVolt": "VW欠压KP电压/系数电压",
  "50901.ctrl_Safety.RPC.rpcMode": "RPC模式",
  "50901.ctrl_Safety.RPC.rpcTr": "RPC_Tr时间",
  "50901.ctrl_Safety.RPC.rpcPf": "RPC功率因数PF",
  "50901.ctrl_Safety.RPC.rpcReactPowerRatio": "RPC无功功率比例",
  "50901.ctrl_Safety.RPC.wpfFuncCode": "WPF功能码",
  "50901.ctrl_Safety.RPC.wpfPowerStartRatio": "WPF功率起始比例",
  "50901.ctrl_Safety.RPC.wpfPowerEndRatio": "WPF功率结束比例",
  "50901.ctrl_Safety.RPC.wpfMinPFOver": "WPF过功率最小PF",
  "50901.ctrl_Safety.RPC.wpfMinPFUnder": "WPF欠功率最小PF",
  "50901.ctrl_Safety.RPC.wpfLockIn": "WPF锁定投入值",
  "50901.ctrl_Safety.RPC.wpfLockOut": "WPF锁定退出值",
  "50901.ctrl_Safety.RPC.vvFuncCode": "Volt-Var功能码",
  "50901.ctrl_Safety.RPC.vvV1": "电压设定值_V1",
  "50901.ctrl_Safety.RPC.vvV2": "电压设定值_V2",
  "50901.ctrl_Safety.RPC.vvV3": "电压设定值_V3",
  "50901.ctrl_Safety.RPC.vvV4": "电压设定值_V4",
  "50901.ctrl_Safety.RPC.vvQ1": "无功设定值_Q1",
  "50901.ctrl_Safety.RPC.vvQ2": "无功设定值_Q2",
  "50901.ctrl_Safety.RPC.vvQ3": "无功设定值_Q3",
  "50901.ctrl_Safety.RPC.vvQ4": "无功设定值_Q4",
  "50901.ctrl_Safety.RPC.vvLockIn": "VV锁定投入值",
  "50901.ctrl_Safety.RPC.vvLockOut": "VV锁定退出值",
  "50901.ctrl_Safety.RPC.vvVref": "调压参考值(Vref)",
  "50901.ctrl_Safety.RPC.vvVrefTr": "调压参考值Tr时间",
  "50901.ctrl_Safety.RPC.gcfFuncCode": "GCF功能码",
  "50901.ctrl_Safety.RPC.gcfEn": "GCF使能",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.0": "不使用电表",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.1": "单相电表",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.2": "两相电表",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.3": "三相电表",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.4": "智能电表（HMID表）",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.5": "电流互感器（CT）",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.6": "安科瑞单相电表",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.7": "安科瑞双相电表",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.0": "禁止",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.1": "外接光伏",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.2": "外接柴发",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.3": "强制启动",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.4": "本地控制",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.0": "无",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.1": "柴发侧",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.2": "电网侧",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type.0": "手动",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type.1": "DI/DO",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable.0": "不使能",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable.1": "使能",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable.0": "不使能",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable.1": "使能",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable.0": "不使能",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable.1": "使能",
  "50901.ctrl_Config.Grid Profile.country.1": "德国 DE_VDE 4105",
  "50901.ctrl_Config.Grid Profile.country.9": "美国 US_IEEE1547",
  "50901.ctrl_Config.Grid Profile.country.18": "USHECO_Rule14(Hawaii)",
  "50901.ctrl_Config.Grid Profile.country.27": "美国 IEE1547_208V",
  "50901.ctrl_Config.Grid Profile.country.29": "LX_US_50HZ(USA TEST)",
  "50901.ctrl_Config.Grid Profile.country.30": "美国 EEE1547-220 V",
  "50901.ctrl_Config.Grid Profile.country.44": "美国 US_MISO_208V",
  "50901.ctrl_Config.Grid Profile.country.45": "美国 US_MISO_240V",
  "50901.ctrl_Safety.VRT.vrtEn.0": "不使能",
  "50901.ctrl_Safety.VRT.vrtEn.1": "使能",
  "50901.ctrl_Safety.RCD.rcdEnable.0": "不使能",
  "50901.ctrl_Safety.RCD.rcdEnable.1": "使能",
  "50901.ctrl_Safety.DCI.dciEnable.0": "不使能",
  "50901.ctrl_Safety.DCI.dciEnable.1": "使能",
  "50901.ctrl_Safety.FW.fwEnable.0": "不使能",
  "50901.ctrl_Safety.FW.fwEnable.1": "enable",
  "50901.ctrl_Safety.FW.fwDiffInBatMode.0": "不使能",
  "50901.ctrl_Safety.FW.fwDiffInBatMode.1": "enable",
  "50901.ctrl_Safety.VW.vwEnable.0": "不使能",
  "50901.ctrl_Safety.VW.vwEnable.1": "使能",
  "50901.ctrl_Safety.VW.vwDiffInBatMode.0": "不使能",
  "50901.ctrl_Safety.VW.vwDiffInBatMode.1": "使能",
  "50901.ctrl_Safety.RPC.rpcMode.00": "不使能",
  "50901.ctrl_Safety.RPC.rpcMode.01": "Fixed Power Factor, PF Mode",
  "50901.ctrl_Safety.RPC.rpcMode.02": "Fixed Reactive Power, Q Mode",
  "50901.ctrl_Safety.RPC.rpcMode.03": "PF(P) Curve, PF(P) Mode",
  "50901.ctrl_Safety.RPC.rpcMode.04": "W",
  "50901.ctrl_Safety.RPC.rpcMode.05": "PQ",
  "50901.ctrl_Safety.RPC.gcfEn.0": "不使能",
  "50901.ctrl_Safety.RPC.gcfEn.1": "使能",
  "50901.ctrl_ESS_Advanced_Config.System.meter_model.desc": "单相逆变器：选择 “Single-phase Meter”, “Three-phase Meter”, “Meter_1S/IT_G3”, “Meter_2S/2T_G3” 或 “CT (Only G3)”\n三相逆变器：选择 “Three-phase Meter”, “Meter_1S/IT_G3”, “Meter_2S/2T_G3” 或 “CT (Only G3)”",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_config_mode.desc": "根据实际安装选择 “PV”, “Generator” 或 “Smart Load (Only G3)”",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_position.desc": "为确保发电机正常运行，请选择 “GenSide”",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_type.desc": "如果发电机不能通过干接点控制，请选择 “Manual”；如果可以，请选择 “DI/DO”",
  "50901.ctrl_ESS_Advanced_Config.Generator.min_run_time.desc": "最小运行时间",
  "50901.ctrl_ESS_Advanced_Config.Generator.max_run_time.desc": "最大运行时间",
  "50901.ctrl_ESS_Advanced_Config.Generator.run_protect_threshold.desc": "保护间隔",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_sync_time.desc": "同步时间",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_shutdown_delay.desc": "停机延迟",
  "50901.ctrl_ESS_Advanced_Config.System.grid_ct_reverse_enable.desc": "当电网侧 CT 反接时，启用此功能可获得正确的采样电流",
  "50901.ctrl_ESS_Advanced_Config.System.pv_ct_reverse_enable.desc": "当光伏逆变器侧 CT 反接时，启用此功能可获得正确的采样电流",
  "50901.ctrl_ESS_Advanced_Config.System.grid_meter_ratio.desc": "设置电网侧 CT 变比",
  "50901.ctrl_ESS_Advanced_Config.System.pv_meter_ratio.desc": "设置光伏逆变器侧 CT 变比",
  "50901.ctrl_ESS_Advanced_Config.System.mid_gateway_enable.desc": "手动启用或禁用 HMID 或网关",
  "50901.ctrl_Config.Grid Profile.country.desc": "国家/并网标准国家的说明。",
  "50901.ctrl_Safety.VRT.vrtFuncCode.desc": "VRT功能码的说明。",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit3.desc": "电压上限3的说明。",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit3Time.desc": "电压上限3持续时间的说明。",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit2.desc": "电压上限2的说明。",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit2Time.desc": "电压上限2持续时间的说明。",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit1.desc": "电压上限1的说明。",
  "50901.ctrl_Safety.VRT.vrtVoltageHighLimit1Time.desc": "电压上限1持续时间的说明。",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit1.desc": "电压下限1的说明。",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit1Time.desc": "电压下限1持续时间的说明。",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit2.desc": "电压下限2的说明。",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit2Time.desc": "电压下限2持续时间的说明。",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit3.desc": "电压下限3的说明。",
  "50901.ctrl_Safety.VRT.vrtVoltageLowLimit3Time.desc": "电压下限3持续时间的说明。",
  "50901.ctrl_Safety.VRT.vrtRecoveryStableTime.desc": "VRT恢复稳定时间的说明。",
  "50901.ctrl_Safety.VRT.vrt10MinAvgVoltage.desc": "10分钟平均电压的说明。",
  "50901.ctrl_Safety.VRT.vrtEn.desc": "VRT使能的说明。",
  "50901.ctrl_Safety.VRT.vrtHighLimit.desc": "VRT高电压门限的说明。",
  "50901.ctrl_Safety.VRT.vrtLowLimit.desc": "VRT低电压门限的说明。",
  "50901.ctrl_Safety.VRT.vrtTransientOverVoltage.desc": "瞬时过电压门限的说明。",
  "50901.ctrl_Safety.VRT.vrtTransientOverTime.desc": "瞬时过电压持续时间的说明。",
  "50901.ctrl_Safety.FRT.frtFuncCode.desc": "FRT功能码的说明。",
  "50901.ctrl_Safety.FRT.frtHighLimit3.desc": "频率上限3的说明。",
  "50901.ctrl_Safety.FRT.frtHighLimit3Time.desc": "频率上限3持续时间的说明。",
  "50901.ctrl_Safety.FRT.frtHighLimit2.desc": "频率上限2的说明。",
  "50901.ctrl_Safety.FRT.frtHighLimit2Time.desc": "频率上限2持续时间的说明。",
  "50901.ctrl_Safety.FRT.frtHighLimit1.desc": "频率上限1的说明。",
  "50901.ctrl_Safety.FRT.frtHighLimit1Time.desc": "频率上限1持续时间的说明。",
  "50901.ctrl_Safety.FRT.frtLowLimit1.desc": "频率下限1的说明。",
  "50901.ctrl_Safety.FRT.frtLowLimit1Time.desc": "频率下限1持续时间的说明。",
  "50901.ctrl_Safety.FRT.frtLowLimit2.desc": "频率下限2的说明。",
  "50901.ctrl_Safety.FRT.frtLowLimit2Time.desc": "频率下限2持续时间的说明。",
  "50901.ctrl_Safety.FRT.frtLowLimit3.desc": "频率下限3的说明。",
  "50901.ctrl_Safety.FRT.frtLowLimit3Time.desc": "频率下限3持续时间的说明。",
  "50901.ctrl_Safety.RT.rtFuncCode.desc": "RT功能码的说明。",
  "50901.ctrl_Safety.RT.rtNMTime.desc": "RT_NM时间的说明。",
  "50901.ctrl_Safety.RT.rtSRTTime.desc": "RT_SRT时间的说明。",
  "50901.ctrl_Safety.RT.rtVoltRecoveryHighValue.desc": "RT电压恢复上限值的说明。",
  "50901.ctrl_Safety.RT.rtVoltRecoveryLowValue.desc": "RT电压恢复下限值的说明。",
  "50901.ctrl_Safety.RT.rtFreqRecoveryHighValue.desc": "RT频率恢复上限值的说明。",
  "50901.ctrl_Safety.RT.rtFreqRecoveryLowValue.desc": "RT频率恢复下限值的说明。",
  "50901.ctrl_Safety.RCD.rcdEnable.desc": "RCD使能的说明。",
  "50901.ctrl_Safety.RCD.continueLimitValue.desc": "RCD连续限值电流的说明。",
  "50901.ctrl_Safety.RCD.continueLimitTime.desc": "RCD连续限值时间的说明。",
  "50901.ctrl_Safety.RCD.step1LimitValue.desc": "RCD阶梯1限值电流的说明。",
  "50901.ctrl_Safety.RCD.step1LimitTime.desc": "RCD阶梯1限值时间的说明。",
  "50901.ctrl_Safety.RCD.step2LimitValue.desc": "RCD阶梯2限值电流的说明。",
  "50901.ctrl_Safety.RCD.step2LimitTime.desc": "RCD阶梯2限值时间的说明。",
  "50901.ctrl_Safety.RCD.step3LimitValue.desc": "RCD阶梯3限值电流的说明。",
  "50901.ctrl_Safety.RCD.step3LimitTime.desc": "RCD阶梯3限值时间的说明。",
  "50901.ctrl_Safety.DCI.dciEnable.desc": "DCI使能的说明。",
  "50901.ctrl_Safety.DCI.upperLimit.desc": "DCI上限电流的说明。",
  "50901.ctrl_Safety.DCI.upperTime.desc": "DCI上限时间的说明。",
  "50901.ctrl_Safety.DCI.lowerLimit.desc": "DCI下限电流的说明。",
  "50901.ctrl_Safety.DCI.lowerTime.desc": "DCI下限时间的说明。",
  "50901.ctrl_Safety.RR.rrFuncCode.desc": "RR功能码的说明。",
  "50901.ctrl_Safety.RR.rrRurNm.desc": "RR_RUR_NM的说明。",
  "50901.ctrl_Safety.RR.rrRurSs.desc": "RR_RUR_SS的说明。",
  "50901.ctrl_Safety.FW.fwFuncCode.desc": "FW功能码的说明。",
  "50901.ctrl_Safety.FW.fwEnable.desc": "FW使能的说明。",
  "50901.ctrl_Safety.FW.fwDiffInBatMode.desc": "FW电池模式差异使能的说明。",
  "50901.ctrl_Safety.FW.fwTr.desc": "FW_Tr时间的说明。",
  "50901.ctrl_Safety.FW.fwRecoveryUpperFrequency.desc": "FW恢复频率上限的说明。",
  "50901.ctrl_Safety.FW.fwRecoveryLowerFrequency.desc": "FW恢复频率下限的说明。",
  "50901.ctrl_Safety.FW.fwRecoveryStableTime.desc": "FW恢复稳定时间的说明。",
  "50901.ctrl_Safety.FW.fwOverStartFreq.desc": "FW过频起始频率的说明。",
  "50901.ctrl_Safety.FW.fwOverEndFreq.desc": "FW过频结束频率的说明。",
  "50901.ctrl_Safety.FW.fwOverTransFreq.desc": "FW过频转换频率的说明。",
  "50901.ctrl_Safety.FW.fwUnderStartFreq.desc": "FW欠频起始频率的说明。",
  "50901.ctrl_Safety.FW.fwUnderEndFreq.desc": "FW欠频结束频率的说明。",
  "50901.ctrl_Safety.FW.fwUnderStopFreq.desc": "FW欠频停止频率的说明。",
  "50901.ctrl_Safety.VW.vwFuncCode.desc": "VW功能码的说明。",
  "50901.ctrl_Safety.VW.vwEnable.desc": "VW使能的说明。",
  "50901.ctrl_Safety.VW.vwDiffInBatMode.desc": "VW电池模式差异使能的说明。",
  "50901.ctrl_Safety.VW.vwTr.desc": "VW_Tr时间的说明。",
  "50901.ctrl_Safety.VW.vwRecoveryUpperVoltage.desc": "VW恢复电压上限的说明。",
  "50901.ctrl_Safety.VW.vwRecoveryLowerVoltage.desc": "VW恢复电压下限的说明。",
  "50901.ctrl_Safety.VW.vwRecoveryStableTime.desc": "VW恢复稳定时间的说明。",
  "50901.ctrl_Safety.VW.vwOverStartVolt.desc": "VW过压起始电压的说明。",
  "50901.ctrl_Safety.VW.vwOverEndVolt.desc": "VW过压结束电压的说明。",
  "50901.ctrl_Safety.VW.vwOverKPVolt.desc": "VW过压KP电压/系数电压的说明。",
  "50901.ctrl_Safety.VW.vwUnderStartVolt.desc": "VW欠压起始电压的说明。",
  "50901.ctrl_Safety.VW.vwUnderEndVolt.desc": "VW欠压结束电压的说明。",
  "50901.ctrl_Safety.VW.vwUnderKPVolt.desc": "VW欠压KP电压/系数电压的说明。",
  "50901.ctrl_Safety.RPC.rpcMode.desc": "RP模式的说明。",
  "50901.ctrl_Safety.RPC.rpcTr.desc": "RPC_Tr时间的说明。",
  "50901.ctrl_Safety.RPC.rpcPf.desc": "RPC功率因数PF的说明。",
  "50901.ctrl_Safety.RPC.rpcReactPowerRatio.desc": "RPC无功功率比例的说明。",
  "50901.ctrl_Safety.RPC.wpfFuncCode.desc": "WPF功能码的说明。",
  "50901.ctrl_Safety.RPC.wpfPowerStartRatio.desc": "WPF功率起始比例的说明。",
  "50901.ctrl_Safety.RPC.wpfPowerEndRatio.desc": "WPF功率结束比例的说明。",
  "50901.ctrl_Safety.RPC.wpfMinPFOver.desc": "WPF过功率最小PF的说明。",
  "50901.ctrl_Safety.RPC.wpfMinPFUnder.desc": "WPF欠功率最小PF的说明。",
  "50901.ctrl_Safety.RPC.wpfLockIn.desc": "WPF锁定投入值的说明。",
  "50901.ctrl_Safety.RPC.wpfLockOut.desc": "WPF锁定退出值的说明。",
  "50901.ctrl_Safety.RPC.vvFuncCode.desc": "VV功能码的说明。",
  "50901.ctrl_Safety.RPC.vvV1.desc": "VV_V1的说明。",
  "50901.ctrl_Safety.RPC.vvV2.desc": "VV_V2的说明。",
  "50901.ctrl_Safety.RPC.vvV3.desc": "VV_V3的说明。",
  "50901.ctrl_Safety.RPC.vvV4.desc": "VV_V4的说明。",
  "50901.ctrl_Safety.RPC.vvQ1.desc": "VV_Q1的说明。",
  "50901.ctrl_Safety.RPC.vvQ2.desc": "VV_Q2的说明。",
  "50901.ctrl_Safety.RPC.vvQ3.desc": "VV_Q3的说明。",
  "50901.ctrl_Safety.RPC.vvQ4.desc": "VV_Q4的说明。",
  "50901.ctrl_Safety.RPC.vvLockIn.desc": "VV锁定投入值的说明。",
  "50901.ctrl_Safety.RPC.vvLockOut.desc": "VV锁定退出值的说明。",
  "50901.ctrl_Safety.RPC.vvVref.desc": "VV参考值(Vref)的说明。",
  "50901.ctrl_Safety.RPC.vvVrefTr.desc": "VV参考值Tr时间的说明。",
  "50901.ctrl_Safety.RPC.gcfFuncCode.desc": "GCF功能码的说明。",
  "50901.ctrl_Safety.RPC.gcfEn.desc": "GCF使能的说明。",
  "50901.ctrl_Safety": "安规",
  "50901.FRT": "频率穿越",
  "50901.RPC": "无功功率控制",
  "50901.RR": "变化速率",
  "50901.RT": "穿越",
  "50901.VW": "电压漂移",
  "50901.Generator": "发电机",
  "50901.ctrl_Config": "通信连接控制",
  "50901.Grid Profile": "电网参数",
  "50901.RCD": "漏电保护",
  "50901.FW": "频率漂移",
  "50901.System": "系统",
  "50901.DCI": "直流隔离",
  "50901.VRT": "电压穿越",
  "50901.ctrl_ESS_Advanced_Config.System.gridInPowerLimitationWhenValley": "限制网络功率",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable": "三相不平衡使能",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxChargePower": "电池最大充电功率",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxDischargePower": "电池最大放电功率",
  "50901.ctrl_ESS_Advanced_Config.Battery.maxSoc": "最大SOC",
  "50901.ctrl_ESS_Advanced_Config.Battery.minSoc": "最小SOC",
  "50901.ctrl_ESS_Advanced_Config.Battery.replenishPower": "功率补偿",
  "50901.ctrl_ESS_Advanced_Config.Battery.rsvdReplenishPower": "Rsvd补充功率",
  "50901.ctrl_ESS_Advanced_Config.Battery.batGridFeedPowerWhenPeak": "峰值时电网馈电功率",
  "50901.ctrl_ESS_Advanced_Config.Battery.batDischargePowerWhenPartialPeak": "峰值时电池最大放电功率",
  "50901.ctrl_ESS_Advanced_Config.Battery.leadAcidBatReplenishTime": "铅酸电池维护时间",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable": "全局扫描使能",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable": "绕过禁用",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode": "EPS模式",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn": "PV模式使能",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_rated_power": "多机并联下发电机给电池充电功率",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_high_limit_volt": "发电机电压上限",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_low_limit_volt": "发电机电压下限",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_high_limit_freq": "发电机频率上限",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_low_limit_freq": "发电机频率下限",
  "50901.ctrl_Config.Connection.dtu_comm_enable": "DTU通讯使能",
  "50901.ctrl_Config.Device.batActivate": "电池激活",
  "50901.ctrl_Config.Device.systemPowerOnOff": "系统开关机",
  "50901.ctrl_Config.Device.restartSystem": "重启系统",
  "50901.ctrl_Config.Device.restoreDefault": "恢复默认值",
  "50901.ctrl_Config.Device.clearFault": "清除故障",
  "50901.ctrl_Config.Device.selfTest": "自检",
  "50901.ctrl_Config.Device.arcFaultClear": "电弧故障清除",
  "50901.ctrl_Config.Device.batteryBalancing": "电池平衡",
  "50901.ctrl_Config.Device.parallelNetworking": "并行网络",
  "50901.ctrl_Config.Device.meterConfiguration": "电表配置",
  "50901.ctrl_Config.Battery.batteryCapacity": "BMS容量",
  "50901.ctrl_Config.Battery.maximumChargeLimit": "最大充电限制值",
  "50901.ctrl_Config.Battery.maximumDischargeLimit": "最大放电限制值",
  "50901.ctrl_Config.Battery.floatVoltage": "浮动电压",
  "50901.ctrl_Config.Battery.absorptionVoltage": "吸收电压",
  "50901.ctrl_Config.Battery.endOfChargeCurrent": "充电结束电流",
  "50901.ctrl_Config.Battery.equalizationVoltage": "均衡电压",
  "50901.ctrl_Config.Battery.equalizationIntervalDays": "均衡间隔天数",
  "50901.ctrl_Config.Battery.equalizationTime": "均衡时间",
  "50901.ctrl_Config.Battery.temperatureCorrectionFactor": "温度校正系数",
  "50901.ctrl_Config.Battery.initialResistance": "初始阻力",
  "50901.ctrl_Config.Battery.endChargeVoltage": "结束充电电压",
  "50901.ctrl_Config.Battery.equalizationChargeTimeout": "均衡充电超时",
  "50901.ctrl_Config.Battery.equalizationEnable": "均衡启用",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode": "干节点工作模式",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode": "负载控制模式",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch": "手动模式开关",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2": "定时1负载控制星期二",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1": "定时1负载控制星期一",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4": "定时1负载控制星期四",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3": "定时1负载控制星期三",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6": "定时1负载控制星期六",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5": "定时1负载控制星期五",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7": "定时1负载控制星期天",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour": "定时1时段1起-时",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min": "定时1时段1起-分",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour": "定时1时段1终-时",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute": "定时1时段1终-分",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour": "定时1时段2起-时",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes": "定时1时段2起-分",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour": "定时1时段2终-时",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes": "定时1时段2终-分",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5": "定时2负载控制星期五",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6": "定时2负载控制星期六",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7": "定时2负载控制星期天",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1": "定时2负载控制星期一",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2": "定时2负载控制星期二",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3": "定时2负载控制星期三",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4": "定时2负载控制星期四",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour_2": "定时2时段1起_时",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min_2": "定时2时段1起_分",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour_2": "定时2时段1终_时",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute_2": "定时2时段1终_分",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour_2": "定时2时段2起_时",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes_2": "定时2时段2起_分",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour_2": "定时2时段2终_时",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes_2": "定时2时段2终_分",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange1": "时间范围1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour_3": "时间段1起-时",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min_3": "时间段1起-分",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour_3": "时间段1终-时",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute_3": "时间段1终-分",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25": "星期五",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26": "星期六",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23": "星期三",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24": "星期四",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21": "星期一",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22": "星期二",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange20": "星期一",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour_3": "时间段2起-时",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes_3": "时间段2起-分",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour_3": "时间段2终-时",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes_3": "时间段2终-分",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.minimumOnTime": "负载控制最短接通时间",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.minimumOnLoadPower": "负载模式负载功率阈值",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.offGridProtectionSoc": "离网保护SOC",
  "50901.ctrl_Dry_Contact.Generator.generatorMode": "发电机模式",
  "50901.ctrl_Dry_Contact.Generator.generatorOpenBatteryCapacity": "柴发开启电池容量",
  "50901.ctrl_Dry_Contact.Generator.generatorCloseBatteryCapacity": "柴发关闭电池容量",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartH": "发电机控制-充电开始时间-小时",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartMin": "发电机控制-充电开始时间-分钟",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeEndH": "发电机控制-充电结束时间-小时",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeEndMin": "发电机控制-充电结束时间-分钟",
  "50901.ctrl_Dry_Contact.Generator.quietTimeEnable": "待机时间启用",
  "50901.ctrl_Dry_Contact.Generator.quietTime1StartH": "待机时间1开始-小时",
  "50901.ctrl_Dry_Contact.Generator.quietTime1StartMin": "待机时间1开始-分钟",
  "50901.ctrl_Dry_Contact.Generator.quietTime1EndH": "待机时间1结束-小时",
  "50901.ctrl_Dry_Contact.Generator.quietTime1EndMin": "待机时间1结束-分钟",
  "50901.ctrl_Dry_Contact.Generator.quietTime2StartH": "待机时间2开始-小时",
  "50901.ctrl_Dry_Contact.Generator.quietTime2StartMin": "待机时间2开始-分钟",
  "50901.ctrl_Dry_Contact.Generator.quietTime2EndH": "待机时间2结束-小时",
  "50901.ctrl_Dry_Contact.Generator.quietTime2EndMin": "待机时间2结束-分钟",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn": "发电机练习模式",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq": "发电机练习模式频率",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek": "发电机练习模式启动时间",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeStartH": "发电机练习模式启动时间-小时",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeStartMin": "发电机练习模式启动时间-分钟",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeRunningTime": "发电机练习模式运行时长",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable.0": "不使能",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable.1": "使能",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable.0": "不使能",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable.1": "使能",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable.0": "否",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable.1": "是",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.0": "禁用",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.1": "应急电源",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.2": "不间断电源",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn.0": "否",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn.1": "是",
  "50901.ctrl_Config.Connection.dtu_comm_enable.0": "不使能",
  "50901.ctrl_Config.Connection.dtu_comm_enable.1": "使能",
  "50901.ctrl_Config.Device.batActivate.0": "否",
  "50901.ctrl_Config.Device.batActivate.1": "是",
  "50901.ctrl_Config.Device.systemPowerOnOff.0": "停止系统",
  "50901.ctrl_Config.Device.systemPowerOnOff.1": "启动系统",
  "50901.ctrl_Config.Device.restartSystem.0": "否",
  "50901.ctrl_Config.Device.restartSystem.1": "是",
  "50901.ctrl_Config.Device.restoreDefault.0": "否",
  "50901.ctrl_Config.Device.restoreDefault.1": "是",
  "50901.ctrl_Config.Device.clearFault.0": "否",
  "50901.ctrl_Config.Device.clearFault.1": "是",
  "50901.ctrl_Config.Device.selfTest.0": "否",
  "50901.ctrl_Config.Device.selfTest.1": "是",
  "50901.ctrl_Config.Device.arcFaultClear.0": "否",
  "50901.ctrl_Config.Device.arcFaultClear.1": "是",
  "50901.ctrl_Config.Device.batteryBalancing.0": "否",
  "50901.ctrl_Config.Device.batteryBalancing.1": "是",
  "50901.ctrl_Config.Device.parallelNetworking.0": "无效",
  "50901.ctrl_Config.Device.parallelNetworking.1": "组网中",
  "50901.ctrl_Config.Device.parallelNetworking.2": "解散组网",
  "50901.ctrl_Config.Device.meterConfiguration.0": "无电表类型",
  "50901.ctrl_Config.Device.meterConfiguration.1": "配置网侧电表",
  "50901.ctrl_Config.Device.meterConfiguration.2": "配置PV电表",
  "50901.ctrl_Config.Device.meterConfiguration.3": "配置网侧+PV电表",
  "50901.ctrl_Config.Battery.equalizationEnable.0": "否",
  "50901.ctrl_Config.Battery.equalizationEnable.1": "是",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.0": "无",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.1": "接地故障",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.2": "负载控制",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.3": "发电机",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.1": "手动",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.2": "时间模式",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.3": "智能负载",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.4": "离网智能负载",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.5": "电动汽车充电器",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch.0": "否",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch.1": "是",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2.0": "不使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2.1": "使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1.0": "不使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1.1": "使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4.0": "不使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4.1": "使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3.0": "不使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3.1": "使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6.0": "不使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6.1": "使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5.0": "不使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5.1": "使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7.0": "不使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7.1": "使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5.0": "不使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5.1": "使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6.0": "不使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6.1": "使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7.0": "不使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7.1": "使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1.0": "不使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1.1": "使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2.0": "不使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2.1": "使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3.0": "不使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3.1": "使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4.0": "不使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4.1": "使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25.0": "不使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25.1": "使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26.0": "不使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26.1": "使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23.0": "不使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23.1": "使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24.0": "不使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24.1": "使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21.0": "不使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21.1": "使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22.0": "不使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22.1": "使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange20.0": "不使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange20.1": "使能",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.0": "关",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.1": "手动",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.2": "自动",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn.0": "否",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn.1": "是",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.0": "无",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.1": "每周一次",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.2": "每2周一次",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.3": "每3周一次",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.4": "每4周一次",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek.0": "不使能",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek.1": "使能",
  "50901.ctrl_ESS_Advanced_Config.System.gridInPowerLimitationWhenValley.desc": "最大电网充电功率",
  "50901.ctrl_ESS_Advanced_Config.System.threePhaseUnbalanceEnable.desc": "当三相逆变器负载不平衡时启用此功能，可对每相负载进行补偿",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxChargePower.desc": "设置最大充电功率",
  "50901.ctrl_ESS_Advanced_Config.Battery.batteryMaxDischargePower.desc": "设置最大放电功率",
  "50901.ctrl_ESS_Advanced_Config.Battery.maxSoc.desc": "设置电池最大容量（按电池制造商推荐）",
  "50901.ctrl_ESS_Advanced_Config.Battery.minSoc.desc": "设置电池最小容量（按电池制造商推荐）",
  "50901.ctrl_ESS_Advanced_Config.Battery.replenishPower.desc": "当电池 SOC 低于设定的最小 SOC 时，强制充电的功率",
  "50901.ctrl_ESS_Advanced_Config.Battery.rsvdReplenishPower.desc": "当电池 SOC 低于预留 SOC 时，强制充电的功率",
  "50901.ctrl_ESS_Advanced_Config.Battery.batGridFeedPowerWhenPeak.desc": "设置峰值时段电池馈电功率的最大值",
  "50901.ctrl_ESS_Advanced_Config.Battery.batDischargePowerWhenPartialPeak.desc": "设置谷值时段从电网给电池充电的最大功率",
  "50901.ctrl_ESS_Advanced_Config.Battery.leadAcidBatReplenishTime.desc": "铅酸电池的补电维持时间",
  "50901.ctrl_ESS_Advanced_Config.PV.mppt_global_scan_enable.desc": "如果光伏组件被遮挡，启用此功能",
  "50901.ctrl_ESS_Advanced_Config.EPS.bypassDisable.desc": "对于带有外部 ATS (EPS) 箱的逆变器，当外部旁路开关启用时，逆变器 EPS 端口工作在离网模式，不会工作在并网模式。",
  "50901.ctrl_ESS_Advanced_Config.EPS.epsMode.desc": "当 EPS 端口连接时，可选择 “EPS” 或 “UPS”。负载需要连续供电时可选择 “UPS”，系统在 UPS 模式下自动切换并网/离网模式。\nEPS 特点为持续供电，正常供电时负载由旁路供电，断电时直流电逆变供电，最大化能源利用。\nUPS 提供稳定电压和频率，切换时间要求极严格，不仅断电时工作，过压、欠压、浪涌等异常时也能输出高质量电力。\n当逆变器用作光伏逆变器时，选择 “Disable”。",
  "50901.ctrl_ESS_Advanced_Config.EPS.pvIslandModeEn.desc": "离网模式下，无电池连接时，混合逆变器支持仅使用光伏运行。（此模式系统不稳定，不推荐）",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_rated_power.desc": "多机并联下发电机给电池充电功率的说明",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_high_limit_volt.desc": "发电机电压上限的说明",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_low_limit_volt.desc": "发电机电压下限的说明",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_high_limit_freq.desc": "发电机频率上限的说明",
  "50901.ctrl_ESS_Advanced_Config.Generator.generator_low_limit_freq.desc": "发电机频率下限的说明",
  "50901.ctrl_Config.Connection.dtu_comm_enable.desc": "DTU通讯使能的说明",
  "50901.ctrl_Config.Device.batActivate.desc": "电池激活的说明。",
  "50901.ctrl_Config.Device.systemPowerOnOff.desc": "系统开关机的说明。",
  "50901.ctrl_Config.Device.restartSystem.desc": "重启系统的说明。",
  "50901.ctrl_Config.Device.restoreDefault.desc": "恢复默认值的说明。",
  "50901.ctrl_Config.Device.clearFault.desc": "清除故障的说明。",
  "50901.ctrl_Config.Device.selfTest.desc": "自检的说明。",
  "50901.ctrl_Config.Device.arcFaultClear.desc": "电弧故障清除的说明。",
  "50901.ctrl_Config.Device.batteryBalancing.desc": "电池平衡的说明。",
  "50901.ctrl_Config.Device.parallelNetworking.desc": "并行网络的说明。",
  "50901.ctrl_Config.Device.meterConfiguration.desc": "仪表配置的说明。",
  "50901.ctrl_Config.Battery.batteryCapacity.desc": "BMS容量的说明。",
  "50901.ctrl_Config.Battery.maximumChargeLimit.desc": "最大充电限制值的说明。",
  "50901.ctrl_Config.Battery.maximumDischargeLimit.desc": "最大放电限制值的说明。",
  "50901.ctrl_Config.Battery.floatVoltage.desc": "浮动电压的说明。",
  "50901.ctrl_Config.Battery.absorptionVoltage.desc": "吸收电压的说明。",
  "50901.ctrl_Config.Battery.endOfChargeCurrent.desc": "充电结束电流的说明。",
  "50901.ctrl_Config.Battery.equalizationVoltage.desc": "均衡电压的说明。",
  "50901.ctrl_Config.Battery.equalizationIntervalDays.desc": "均衡间隔天数的说明。",
  "50901.ctrl_Config.Battery.equalizationTime.desc": "均衡时间的说明。",
  "50901.ctrl_Config.Battery.temperatureCorrectionFactor.desc": "温度校正系数的说明。",
  "50901.ctrl_Config.Battery.initialResistance.desc": "初始阻力的说明。",
  "50901.ctrl_Config.Battery.endChargeVoltage.desc": "结束充电电压的说明。",
  "50901.ctrl_Config.Battery.equalizationChargeTimeout.desc": "均衡充电超时的说明。",
  "50901.ctrl_Config.Battery.equalizationEnable.desc": "均衡启用的说明。",
  "50901.ctrl_Dry_Contact.Settings.dryWorkingMode.desc": "干节点工作模式的说明。",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.desc": "负载控制模式的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.manualModeSwitch.desc": "手动模式开关的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange2.desc": "负载控制星期二的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange1.desc": "负载控制星期一的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange4.desc": "负载控制星期四的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange3.desc": "负载控制星期三的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange6.desc": "负载控制星期六的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange5.desc": "负载控制星期五的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dayOfTheWeekRange7.desc": "负载控制星期天的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour.desc": "定时1起-时的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min.desc": "定时1起-分的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour.desc": "定时1终-时的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute.desc": "定时1终-分的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour.desc": "定时2起-时的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes.desc": "定时2起-分的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour.desc": "定时2终-时的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes.desc": "定时2终-分的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange5.desc": "星期五的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange6.desc": "星期六的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange7.desc": "星期天的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange1.desc": "星期一的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange2.desc": "星期二的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange3.desc": "星期三的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.weekRange4.desc": "星期四的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour_2.desc": "定时1起_2-时的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min_2.desc": "定时1起_2-分的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour_2.desc": "定时1终_2-时的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute_2.desc": "定时1终_2-分的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour_2.desc": "定时2起_2-时的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes_2.desc": "定时2起_2-分的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour_2.desc": "定时2终_2-时的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes_2.desc": "定时2终_2-分的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange1.desc": "时间范围1的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer1Hour_3.desc": "时间段1起-时的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1From1Min_3.desc": "时间段1起-分的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndHour_3.desc": "时间段1终-时的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed1EndMinute_3.desc": "时间段1终-分的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange25.desc": "星期六的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange26.desc": "星期天的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange23.desc": "星期四的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange24.desc": "星期五的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange21.desc": "星期二的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange22.desc": "星期三的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange20.desc": "星期一的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timer2Hour_3.desc": "时间段2起-时的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timedFrom2Minutes_3.desc": "时间段2起-分的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndHour_3.desc": "时间段2终-时的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timed2EndMinutes_3.desc": "时间段2终-分的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.minimumOnTime.desc": "负载控制最短接通时间的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.minimumOnLoadPower.desc": "负载模式负载功率阈值的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.offGridProtectionSoc.desc": "离网保护SOC的说明。",
  "50901.ctrl_Dry_Contact.Generator.generatorMode.desc": "发电机模式的说明。",
  "50901.ctrl_Dry_Contact.Generator.generatorOpenBatteryCapacity.desc": "发电机模式下，当电池容量低于安全 SOC 时启动发电机",
  "50901.ctrl_Dry_Contact.Generator.generatorCloseBatteryCapacity.desc": "发电机模式下，当电池容量高于安全 SOC 时关闭发电机",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartH.desc": "发电机将在预设时段内给电池充电。选择光伏功率较低的时间段，避免浪费光伏电力",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeStartMin.desc": "发电机将在预设时段内给电池充电。选择光伏功率较低的时间段，避免浪费光伏电力",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeEndH.desc": "发电机控制-充电结束时间-H的说明。",
  "50901.ctrl_Dry_Contact.Generator.chargeTimeEndMin.desc": "发电机控制-充电结束时间-分钟的说明。",
  "50901.ctrl_Dry_Contact.Generator.quietTimeEnable.desc": "静默时间内禁用发电机。设置此时间会影响正常用电",
  "50901.ctrl_Dry_Contact.Generator.quietTime1StartH.desc": "待机时间1开始-H的说明。",
  "50901.ctrl_Dry_Contact.Generator.quietTime1StartMin.desc": "待机时间1开始-分钟的说明。",
  "50901.ctrl_Dry_Contact.Generator.quietTime1EndH.desc": "待机时间1End-H的说明。",
  "50901.ctrl_Dry_Contact.Generator.quietTime1EndMin.desc": "待机时间1结束分钟的说明。",
  "50901.ctrl_Dry_Contact.Generator.quietTime2StartH.desc": "待机时间2开始-H的说明。",
  "50901.ctrl_Dry_Contact.Generator.quietTime2StartMin.desc": "待机时间2开始-Min的说明。",
  "50901.ctrl_Dry_Contact.Generator.quietTime2EndH.desc": "待机时间2结束-H的说明。",
  "50901.ctrl_Dry_Contact.Generator.quietTime2EndMin.desc": "待机时间2结束-Min的说明。",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeEn.desc": "发电机练习模式的说明。",
  "50901.ctrl_Dry_Contact.Generator.genPracticeFreq.desc": "发电机按此频率定期启动",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek.desc": "发电机在此时间定期启动",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeStartH.desc": "发电机练习模式启动时间-小时的说明。",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeStartMin.desc": "发电机练习模式启动时间-分钟的说明。",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeRunningTime.desc": "发电机运行此时长后停止",
  "50901.EPS": "应急电源",
  "50901.ctrl_Dry_Contact": "干接点设置",
  "50901.Settings-Manual_Control": "手动控制",
  "50901.Device": "设备",
  "50901.PV": "光伏",
  "50901.Battery": "电池",
  "50901.Connection": "通信连接",
  "50901.Settings-Load_Control": "负载控制",
  "Do_not_connect": "暂不联网",
  "connect.type.Do.not.connect": "暂不联网",
  "50901.ctrl_WorkMode.Switch.workMode": "EMS工作模式",
  "50901.ctrl_WorkMode.Selfuse.selfUsedSoc": "自用SOC",
  "50901.ctrl_WorkMode.Backup.backupSoc": "备用SOC",
  "50901.ctrl_WorkMode.forceCharge.forceChargeSoc": "强制充电SOC",
  "50901.ctrl_WorkMode.forceCharge.maximumChargePower": "最大充电功率",
  "50901.ctrl_WorkMode.forceDischarge.forceDischargeSoc": "强制放电SOC",
  "50901.ctrl_WorkMode.forceDischarge.maximumDischargePower": "最大放电功率",
  "50901.ctrl_WorkMode.economic.economicModeSoc": "经济模式SOC",
  "50901.ctrl_WorkMode.economic.economyModeDateNumber": "经济模式日期编号",
  "50901.ctrl_WorkMode.economic.section1StartMonth": "时段1开始月",
  "50901.ctrl_WorkMode.economic.section1StartDay": "时段1开始日",
  "50901.ctrl_WorkMode.economic.section1StopMonth": "时段1停止月",
  "50901.ctrl_WorkMode.economic.section1StopDay": "时段1停止日",
  "50901.ctrl_WorkMode.economic.section1WeekRange1": "时段1周范围1",
  "50901.ctrl_WorkMode.economic.section1PeakStartHour1": "时段1 峰值开始时间1-小时",
  "50901.ctrl_WorkMode.economic.section1PeakStartMinute1": "时段1 峰值开始时间1-分钟",
  "50901.ctrl_WorkMode.economic.section1PeakStopHour1": "时段1 峰值停止时间1-小时",
  "50901.ctrl_WorkMode.economic.section1PeakStopMinute1": "时段1 峰值停止时间1-分钟",
  "50901.ctrl_WorkMode.economic.section1ValleyStartHour1": "时段1 低谷开始时间1- 小时",
  "50901.ctrl_WorkMode.economic.section1ValleyStartMinute1": "时段1 低谷开始时间1- 分钟",
  "50901.ctrl_WorkMode.economic.section1ValleyStopHour1": "时段1 低谷停止时间1- 小时",
  "50901.ctrl_WorkMode.economic.section1ValleyStopMinute1": "时段1 低谷停止时间1- 分钟",
  "50901.ctrl_WorkMode.economic.section1WeekRange2": "时段1周范围2",
  "50901.ctrl_WorkMode.economic.section1PeakStartHour2": "时段1峰值开始时间2-小时",
  "50901.ctrl_WorkMode.economic.section1PeakStartMinute2": "时段1峰值开始时间2-分钟",
  "50901.ctrl_WorkMode.economic.section1PeakStopHour2": "时段1峰值停止时间2-小时",
  "50901.ctrl_WorkMode.economic.section1PeakStopMinute2": "时段1峰值停止时间2-分钟",
  "50901.ctrl_WorkMode.economic.section1ValleyStartHour2": "时段1低估开始时间2-小时",
  "50901.ctrl_WorkMode.economic.section1ValleyStartMinute2": "时段1低估开始时间2-分钟",
  "50901.ctrl_WorkMode.economic.section1ValleyStopHour2": "时段1低估停止时间2-小时",
  "50901.ctrl_WorkMode.economic.section1ValleyStopMinute2": "时段1低估停止时间2-分钟",
  "50901.ctrl_WorkMode.economic.section2StartMonth": "时段2开始月",
  "50901.ctrl_WorkMode.economic.section2StartDay": "时段2开始天",
  "50901.ctrl_WorkMode.economic.section2StopMonth": "时段2停止月",
  "50901.ctrl_WorkMode.economic.section2StopDay": "时段2停止日",
  "50901.ctrl_WorkMode.economic.section2WeekRange1": "时段2周范围1",
  "50901.ctrl_WorkMode.economic.section2PeakStartHour1": "时段2峰值开始时间1-小时",
  "50901.ctrl_WorkMode.economic.section2PeakStartMinute1": "时段2峰值开始时间1-分钟",
  "50901.ctrl_WorkMode.economic.section2PeakStopHour1": "时段2峰值停止时间1-小时",
  "50901.ctrl_WorkMode.economic.section2PeakStopMinute1": "时段2峰值停止时间1-分钟",
  "50901.ctrl_WorkMode.economic.section2ValleyStartHour1": "时段2低估开始时间1-小时",
  "50901.ctrl_WorkMode.economic.section2ValleyStartMinute1": "时段2低估开始时间1-分钟",
  "50901.ctrl_WorkMode.economic.section2ValleyStopHour1": "时段2低估停止时间1-小时",
  "50901.ctrl_WorkMode.economic.section2ValleyStopMinute1": "时段2低估停止时间1-分钟",
  "50901.ctrl_WorkMode.economic.section2WeekRange2": "时段2周范围2",
  "50901.ctrl_WorkMode.economic.section2PeakStartHour2": "时段2峰值开始时间2-小时",
  "50901.ctrl_WorkMode.economic.section2PeakStartMinute2": "时段2峰值开始时间1-分钟",
  "50901.ctrl_WorkMode.economic.section2PeakStopHour2": "时段2峰值停止时间2-小时",
  "50901.ctrl_WorkMode.economic.section2PeakStopMinute2": "时段2峰值停止时间2-分钟",
  "50901.ctrl_WorkMode.economic.section2ValleyStartHour2": "时段2低估开始时间2-小时",
  "50901.ctrl_WorkMode.economic.section2ValleyStartMinute2": "时段2低估开始时间2-分钟",
  "50901.ctrl_WorkMode.economic.section2ValleyStopHour2": "时段2低估停止时间2-小时",
  "50901.ctrl_WorkMode.economic.section2ValleyStopMinute2": "时段2低估停止时间2-分钟",
  "50901.ctrl_WorkMode.economic.section3StartMonth": "时段3开始月",
  "50901.ctrl_WorkMode.economic.section3StartDay": "时段3开始天",
  "50901.ctrl_WorkMode.economic.section3StopMonth": "时段3停止月",
  "50901.ctrl_WorkMode.economic.section3StopDay": "时段3停止日",
  "50901.ctrl_WorkMode.economic.section3WeekRange1": "时段3周范围1",
  "50901.ctrl_WorkMode.economic.section3PeakStartHour1": "时段3峰值开始时间1-小时",
  "50901.ctrl_WorkMode.economic.section3PeakStartMinute2": "时段3峰值开始时间1-分钟",
  "50901.ctrl_WorkMode.economic.section3PeakStopHour1": "时段3峰值停止时间1-小时",
  "50901.ctrl_WorkMode.economic.section3PeakStopMinute1": "时段3峰值停止时间1-分钟",
  "50901.ctrl_WorkMode.economic.section3ValleyStartHour1": "时段3低谷开始时间1-小时",
  "50901.ctrl_WorkMode.economic.section3ValleyStartMinute1": "时段3低估开始时间1-分钟",
  "50901.ctrl_WorkMode.economic.section3ValleyStopHour1": "时段3低估停止时间1-小时",
  "50901.ctrl_WorkMode.economic.section3ValleyStopMinute1": "时段3低估停止时间1-分钟",
  "50901.ctrl_WorkMode.economic.section3WeekRange2": "时段3周范围2",
  "50901.ctrl_WorkMode.economic.section3PeakStartHour2": "时段3峰值开始时间2-小时",
  "50901.ctrl_WorkMode.economic.section3PeakStartMinute1": "时段3峰值开始时间2-分钟",
  "50901.ctrl_WorkMode.economic.section3PeakStopHour2": "时段3峰值停止时间2-小时",
  "50901.ctrl_WorkMode.economic.section3PeakStopMinute2": "时段3峰值停止时间2-分钟",
  "50901.ctrl_WorkMode.economic.section3ValleyStartHour2": "时段3低估开始时间2-小时",
  "50901.ctrl_WorkMode.economic.section3ValleyStartMinute2": "时段3低估开始时间2-分钟",
  "50901.ctrl_WorkMode.economic.section3ValleyStopHour2": "时段3低估停止时间2-小时",
  "50901.ctrl_WorkMode.economic.section3ValleyStopMinute2": "时段3低估停止时间2-分钟",
  "50901.ctrl_WorkMode.economic.section4StartMonth": "时段4开始月",
  "50901.ctrl_WorkMode.economic.section4StartDay": "时段4开始天",
  "50901.ctrl_WorkMode.economic.section4StopMonth": "时段4停止月",
  "50901.ctrl_WorkMode.economic.section4StopDay": "时段4停止日",
  "50901.ctrl_WorkMode.economic.section4WeekRange1": "时段4周范围1",
  "50901.ctrl_WorkMode.economic.section4PeakStartHour1": "时段4峰值开始时间1-小时",
  "50901.ctrl_WorkMode.economic.section4PeakStartMinute1": "时段4峰值开始时间1-分钟",
  "50901.ctrl_WorkMode.economic.section4PeakStopHour1": "时段4峰值停止时间1-小时",
  "50901.ctrl_WorkMode.economic.section4PeakStopMinute1": "时段4峰值停止时间1-分钟",
  "50901.ctrl_WorkMode.economic.section4ValleyStartHour1": "时段4低估开始时间1-小时",
  "50901.ctrl_WorkMode.economic.section4ValleyStartMinute1": "时段4低估开始时间1-分钟",
  "50901.ctrl_WorkMode.economic.section4ValleyStopHour1": "时段4低估停止时间1-小时",
  "50901.ctrl_WorkMode.economic.section4ValleyStopMinute1": "时段4低估停止时间1-分钟",
  "50901.ctrl_WorkMode.economic.section4WeekRange2": "时段4周范围2",
  "50901.ctrl_WorkMode.economic.section4PeakStartHour2": "时段4峰值开始时间2-小时",
  "50901.ctrl_WorkMode.economic.section4PeakStartMinute2": "时段4峰值开始时间2-分钟",
  "50901.ctrl_WorkMode.economic.section4PeakStopHour2": "时段4峰值停止时间2-小时",
  "50901.ctrl_WorkMode.economic.section4PeakStopMinute2": "时段4峰值停止时间2-分钟",
  "50901.ctrl_WorkMode.economic.section4ValleyStartHour2": "时段4低估开始时间2-小时",
  "50901.ctrl_WorkMode.economic.section4ValleyStartMinute2": "时段4低估开始时间2-分钟",
  "50901.ctrl_WorkMode.economic.section4ValleyStopHour2": "时段4低估停止时间2-小时",
  "50901.ctrl_WorkMode.economic.section4ValleyStopMinute2": "时段4低估停止时间2-分钟",
  "50901.ctrl_WorkMode.peakMeter.peakMeterSoc": "峰值计SOC",
  "50901.ctrl_WorkMode.peakMeter.peakMeterPower": "峰值仪表功率",
  "50901.ctrl_WorkMode.TOU.timeOfUseRange": "TOU模式时间范围",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStartH": "使用时间时段1充电起始-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStartMin": "使用时间时段1充电起始-\n分钟\n",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgEndH": "使用时间时段1充电结束-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgEndMin": "使用时间时段1充电结束-分钟",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgPower": "充电功率",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStopSoc": "充电截止容量",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStartH": "使用时间时段1放电起始-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStartMin": "使用时间时段1放电起始-分钟",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgEndH": "使用时间时段1放电结束-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgEndMin": "使用时间时段1放电结束-分钟",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgPower": "放电功率",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStopSoc": "放电截止容量",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStartH": "使用时间时段2充电起始-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStartMin": "使用时间时段2充电起始-\n分钟\n",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgEndH": "使用时间时段2充电结束-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgEndMin": "使用时间时段2充电结束-分钟",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgPower": "充电功率",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStopSoc": "充电截止容量",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStartH": "使用时间时段2放电起始-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStartMin": "使用时间时段2放电起始-分钟",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgEndH": "使用时间时段2放电结束-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgEndMin": "使用时间时段2放电结束-分钟",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgPower": "放电功率",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStopSoc": "放电截止容量",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStartH": "使用时间时段3充电起始-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStartMin": "使用时间时段3充电起始-\n分钟\n",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgEndH": "使用时间时段3充电结束-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgEndMin": "使用时间时段3充电结束-分钟",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgPower": "充电功率",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStopSoc": "充电截止容量",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStartH": "使用时间时段3放电起始-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStartMin": "使用时间时段3放电起始-分钟",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgEndH": "使用时间时段3放电结束-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgEndMin": "使用时间时段3放电结束-分钟",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgPower": "放电功率",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStopSoc": "放电截止容量",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStartH": "使用时间时段4充电起始-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStartMin": "使用时间时段4充电起始-\n分钟\n",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgEndH": "使用时间时段4充电结束-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgEndMin": "使用时间时段4充电结束-分钟",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgPower": "充电功率",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStopSoc": "充电截止容量",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStartH": "使用时间时段4放电起始-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStartMin": "使用时间时段4放电起始-分钟",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgEndH": "使用时间时段4放电结束-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgEndMin": "使用时间时段4放电结束-分钟",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgPower": "放电功率",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStopSoc": "放电截止功率",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStartH": "使用时间时段5充电起始-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStartMin": "使用时间时段5充电起始-\n分钟\n",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgEndH": "使用时间时段5充电结束-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgEndMin": "使用时间时段5充电结束-分钟",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgPower": "充电功率",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStopSoc": "充电截止容量",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStartH": "使用时间时段5放电起始-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStartMin": "使用时间时段5放电起始-分钟",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgEndH": "使用时间时段5放电结束-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgEndMin": "使用时间时段5放电结束-分钟",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgPower": "放电功率",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStopSoc": "放电截止容量",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStartH": "使用时间时段6充电起始-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStartMin": "使用时间时段6充电起始-\n分钟\n",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgEndH": "使用时间时段6充电结束-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgEndMin": "使用时间时段6充电结束-分钟",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgPower": "充电功率",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStopSoc": "充电截止容量",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStartH": "使用时间时段6放电起始-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStartMin": "使用时间时段6放电起始-分钟",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgEndH": "使用时间时段6放电结束-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgEndMin": "使用时间时段6放电结束-分钟",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgPower": "放电功率",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStopSoc": "放电截止容量",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStartH": "使用时间时段7充电起始-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStartMin": "使用时间时段7充电起始-\n分钟\n",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgEndH": "使用时间时段7充电结束-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgEndMin": "使用时间时段7充电结束-分钟",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgPower": "放电功率",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStopSoc": "放电截止容量",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStartH": "使用时间时段7放电起始-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStartMin": "使用时间时段7放电起始-分钟",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgEndH": "使用时间时段7放电结束-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgEndMin": "使用时间时段7放电结束-分钟",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgPower": "放电功率",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStopSoc": "放电截止容量",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStartH": "使用时间时段8充电起始-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStartMin": "使用时间时段8充电起始-\n分钟\n",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgEndH": "使用时间时段8充电结束-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgEndMin": "使用时间时段8充电结束-分钟",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgPower": "充电功率",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStopSoc": "充电截止容量",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStartH": "使用时间时段8放电起始-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStartMin": "使用时间时段8放电起始-分钟",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgEndH": "使用时间时段8放电结束-小时",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgEndMin": "使用时间时段8放电结束-分钟",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgPower": "放电功率",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStopSoc": "放电截止容量",
  "50901.ctrl_Config.ClockSetting.ClockSetting": "时钟设置",
  "50901.ctrl_Config.ClockSetting.clockSetting_year": "时钟设置-year",
  "50901.ctrl_Config.ClockSetting.clockSetting_month": "时钟设置-month",
  "50901.ctrl_Config.ClockSetting.clockSetting_day": "时钟设置-day",
  "50901.ctrl_Config.ClockSetting.clockSetting_hour": "时钟设置-hour",
  "50901.ctrl_Config.ClockSetting.clockSetting_minute": "时钟设置-minute",
  "50901.ctrl_Config.ClockSetting.clockSetting_second": "时钟设置-second",
  "50901.ctrl_Config.ClockSetting.clockSetting_weekday": "时钟设置-weekday",
  "50901.ctrl_Config.Gateway.gatewayCommunicationAddress": "网关通信地址",
  "50901.ctrl_Config.Gateway.boardAmbientTemperatureThreshold": "电路板环境温度阈值",
  "50901.ctrl_Config.Gateway.ambientTemperatureThreshold": "环境温度阈值",
  "50901.ctrl_Config.Device.masterSlave": "主机/从机",
  "50901.ctrl_Config.Device.networkingType": "联网类型",
  "50901.ctrl_Config.Device.checkTime": "设备时间",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.homeInletBreakerRatedCurrent": "入户空开额定电流",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.chargingPileRatedCurrent": "充电桩额定电流",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable": "定时模式-电池SOC使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatteryStartSoc": "定时模式-电池启动SOC",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatteryStopSoc": "定时模式-电池关闭SOC",
  "50901.ctrl_WorkMode.TOU.touModeReserveSoc": "TOU模式预留SOC",
  "50901.ctrl_WorkMode.Switch.workMode.0": "自发自用",
  "50901.ctrl_WorkMode.Switch.workMode.1": "经济模式",
  "50901.ctrl_WorkMode.Switch.workMode.2": "备电模式",
  "50901.ctrl_WorkMode.Switch.workMode.3": "离网模式",
  "50901.ctrl_WorkMode.Switch.workMode.4": "强充模式",
  "50901.ctrl_WorkMode.Switch.workMode.5": "强放模式",
  "50901.ctrl_WorkMode.Switch.workMode.6": "削峰模式",
  "50901.ctrl_WorkMode.Switch.workMode.7": "定时充放模式",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.0": "周一",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.1": "周二",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.2": "周三",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.3": "周四",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.4": "周五",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.5": "周六",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.6": "周日",
  "50901.ctrl_WorkMode.economic.section1WeekRange2.00": "枚举值0的含义",
  "50901.ctrl_WorkMode.economic.section1WeekRange2.01": "枚举值1的含义",
  "50901.ctrl_WorkMode.economic.section2WeekRange1.00": "枚举值0的含义",
  "50901.ctrl_WorkMode.economic.section2WeekRange1.01": "枚举值2的含义",
  "50901.ctrl_WorkMode.economic.section3WeekRange1.00": "枚举值0的含义",
  "50901.ctrl_WorkMode.economic.section3WeekRange1.01": "枚举值2的含义",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.00": "枚举值0的含义",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.01": "枚举值1的含义",
  "50901.ctrl_WorkMode.economic.section4WeekRange1.00": "枚举值0的含义",
  "50901.ctrl_WorkMode.economic.section4WeekRange1.01": "枚举值2的含义",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.00": "枚举值0的含义",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.01": "枚举值1的含义",
  "50901.ctrl_Config.Device.masterSlave.0": "单机",
  "50901.ctrl_Config.Device.masterSlave.1": "主机",
  "50901.ctrl_Config.Device.masterSlave.2": "从机",
  "50901.ctrl_Config.Device.networkingType.1": "WIFI",
  "50901.ctrl_Config.Device.networkingType.2": "以太网",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable.0": "不使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable.1": "使能",
  "50901.ctrl_WorkMode.Switch.workMode.desc": "EMS工作模式的说明。",
  "50901.ctrl_WorkMode.Selfuse.selfUsedSoc.desc": "自用SOC的说明。",
  "50901.ctrl_WorkMode.Backup.backupSoc.desc": "备用SOC的说明。",
  "50901.ctrl_WorkMode.forceCharge.forceChargeSoc.desc": "强制充电SOC的说明。",
  "50901.ctrl_WorkMode.forceCharge.maximumChargePower.desc": "最大充电功率的说明。",
  "50901.ctrl_WorkMode.forceDischarge.forceDischargeSoc.desc": "强制放电SOC的说明。",
  "50901.ctrl_WorkMode.forceDischarge.maximumDischargePower.desc": "最大放电功率的说明。",
  "50901.ctrl_WorkMode.economic.economicModeSoc.desc": "经济模式SOC的说明。",
  "50901.ctrl_WorkMode.economic.economyModeDateNumber.desc": "经济模式日期编号的说明。",
  "50901.ctrl_WorkMode.economic.section1StartMonth.desc": "section1开始月的说明。",
  "50901.ctrl_WorkMode.economic.section1StartDay.desc": "section1开始天的说明。",
  "50901.ctrl_WorkMode.economic.section1StopMonth.desc": "section1停止月的说明。",
  "50901.ctrl_WorkMode.economic.section1StopDay.desc": "section1停止日的说明。",
  "50901.ctrl_WorkMode.economic.section1WeekRange1.desc": "section1周范围1的说明。",
  "50901.ctrl_WorkMode.economic.section1PeakStartHour1.desc": "section1 峰值开始时间1-小时的说明。",
  "50901.ctrl_WorkMode.economic.section1PeakStartMinute1.desc": "section1 峰值开始时间1-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section1PeakStopHour1.desc": "section1 峰值停止时间1-小时的说明。",
  "50901.ctrl_WorkMode.economic.section1PeakStopMinute1.desc": "section1 峰值停止时间1-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section1ValleyStartHour1.desc": "section1 低谷开始时间1- 小时的说明。",
  "50901.ctrl_WorkMode.economic.section1ValleyStartMinute1.desc": "section1 低谷开始时间1- 分钟的说明。",
  "50901.ctrl_WorkMode.economic.section1ValleyStopHour1.desc": "section1 低谷停止时间1- 小时的说明。",
  "50901.ctrl_WorkMode.economic.section1ValleyStopMinute1.desc": "section1 低谷停止时间1- 分钟的说明。",
  "50901.ctrl_WorkMode.economic.section1WeekRange2.desc": "section1周范围2的说明。",
  "50901.ctrl_WorkMode.economic.section1PeakStartHour2.desc": "section1峰值开始时间2-小时的说明。",
  "50901.ctrl_WorkMode.economic.section1PeakStartMinute2.desc": "section1峰值开始时间2-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section1PeakStopHour2.desc": "section1峰值停止时间2-小时的说明。",
  "50901.ctrl_WorkMode.economic.section1PeakStopMinute2.desc": "section1峰值停止时间2-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section1ValleyStartHour2.desc": "section1低估开始时间2-小时的说明。",
  "50901.ctrl_WorkMode.economic.section1ValleyStartMinute2.desc": "section1低估开始时间2-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section1ValleyStopHour2.desc": "section1低估停止时间2-小时的说明。",
  "50901.ctrl_WorkMode.economic.section1ValleyStopMinute2.desc": "section1低估停止时间2-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section2StartMonth.desc": "section2开始月的说明。",
  "50901.ctrl_WorkMode.economic.section2StartDay.desc": "section2开始天的说明。",
  "50901.ctrl_WorkMode.economic.section2StopMonth.desc": "section2停止月的说明。",
  "50901.ctrl_WorkMode.economic.section2StopDay.desc": "section2停止日的说明。",
  "50901.ctrl_WorkMode.economic.section2WeekRange1.desc": "section2周范围1的说明。",
  "50901.ctrl_WorkMode.economic.section2PeakStartHour1.desc": "section2峰值开始时间1-小时的说明。",
  "50901.ctrl_WorkMode.economic.section2PeakStartMinute1.desc": "section2峰值开始时间1-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section2PeakStopHour1.desc": "section2峰值停止时间1-小时的说明。",
  "50901.ctrl_WorkMode.economic.section2PeakStopMinute1.desc": "section2峰值停止时间1-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section2ValleyStartHour1.desc": "section2低估开始时间1-小时的说明。",
  "50901.ctrl_WorkMode.economic.section2ValleyStartMinute1.desc": "section2低估开始时间1-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section2ValleyStopHour1.desc": "section2低估停止时间1-小时的说明。",
  "50901.ctrl_WorkMode.economic.section2ValleyStopMinute1.desc": "section2低估停止时间1-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section2WeekRange2.desc": "section2周范围2的说明。",
  "50901.ctrl_WorkMode.economic.section2PeakStartHour2.desc": "section2峰值开始时间2-小时的说明。",
  "50901.ctrl_WorkMode.economic.section2PeakStartMinute2.desc": "section2峰值开始时间1-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section2PeakStopHour2.desc": "section2峰值停止时间2-小时的说明。",
  "50901.ctrl_WorkMode.economic.section2PeakStopMinute2.desc": "section2峰值停止时间2-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section2ValleyStartHour2.desc": "section2低估开始时间2-小时的说明。",
  "50901.ctrl_WorkMode.economic.section2ValleyStartMinute2.desc": "section2低估开始时间2-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section2ValleyStopHour2.desc": "section2低估停止时间2-小时的说明。",
  "50901.ctrl_WorkMode.economic.section2ValleyStopMinute2.desc": "section2低估停止时间2-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section3StartMonth.desc": "section3开始月的说明。",
  "50901.ctrl_WorkMode.economic.section3StartDay.desc": "section3开始天的说明。",
  "50901.ctrl_WorkMode.economic.section3StopMonth.desc": "section3停止月的说明。",
  "50901.ctrl_WorkMode.economic.section3StopDay.desc": "section3停止日的说明。",
  "50901.ctrl_WorkMode.economic.section3WeekRange1.desc": "section3周范围1的说明。",
  "50901.ctrl_WorkMode.economic.section3PeakStartHour1.desc": "section3峰值开始时间1-小时的说明。",
  "50901.ctrl_WorkMode.economic.section3PeakStartMinute2.desc": "section3峰值开始时间1-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section3PeakStopHour1.desc": "section3峰值停止时间1-小时的说明。",
  "50901.ctrl_WorkMode.economic.section3PeakStopMinute1.desc": "section3峰值停止时间1-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section3ValleyStartHour1.desc": "section3低谷开始时间1-小时的说明。",
  "50901.ctrl_WorkMode.economic.section3ValleyStartMinute1.desc": "section3低估开始时间1-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section3ValleyStopHour1.desc": "section3低估停止时间1-小时的说明。",
  "50901.ctrl_WorkMode.economic.section3ValleyStopMinute1.desc": "section3低估停止时间1-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.desc": "section3周范围2的说明。",
  "50901.ctrl_WorkMode.economic.section3PeakStartHour2.desc": "section3峰值开始时间2-小时的说明。",
  "50901.ctrl_WorkMode.economic.section3PeakStartMinute1.desc": "section3峰值开始时间2-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section3PeakStopHour2.desc": "section3峰值停止时间2-小时的说明。",
  "50901.ctrl_WorkMode.economic.section3PeakStopMinute2.desc": "section3峰值停止时间2-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section3ValleyStartHour2.desc": "section3低估开始时间2-小时的说明。",
  "50901.ctrl_WorkMode.economic.section3ValleyStartMinute2.desc": "section3低估开始时间2-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section3ValleyStopHour2.desc": "section3低估停止时间2-小时的说明。",
  "50901.ctrl_WorkMode.economic.section3ValleyStopMinute2.desc": "section3低估停止时间2-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section4StartMonth.desc": "section4开始月的说明。",
  "50901.ctrl_WorkMode.economic.section4StartDay.desc": "section4开始天的说明。",
  "50901.ctrl_WorkMode.economic.section4StopMonth.desc": "section4停止月的说明。",
  "50901.ctrl_WorkMode.economic.section4StopDay.desc": "section4停止日的说明。",
  "50901.ctrl_WorkMode.economic.section4WeekRange1.desc": "section4周范围1的说明。",
  "50901.ctrl_WorkMode.economic.section4PeakStartHour1.desc": "section4峰值开始时间1-小时的说明。",
  "50901.ctrl_WorkMode.economic.section4PeakStartMinute1.desc": "section4峰值开始时间1-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section4PeakStopHour1.desc": "section4峰值停止时间1-小时的说明。",
  "50901.ctrl_WorkMode.economic.section4PeakStopMinute1.desc": "section4峰值停止时间1-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section4ValleyStartHour1.desc": "section4低估开始时间1-小时的说明。",
  "50901.ctrl_WorkMode.economic.section4ValleyStartMinute1.desc": "section4低估开始时间1-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section4ValleyStopHour1.desc": "section4低估停止时间1-小时的说明。",
  "50901.ctrl_WorkMode.economic.section4ValleyStopMinute1.desc": "section4低估停止时间1-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.desc": "section4周范围2的说明。",
  "50901.ctrl_WorkMode.economic.section4PeakStartHour2.desc": "section4峰值开始时间2-小时的说明。",
  "50901.ctrl_WorkMode.economic.section4PeakStartMinute2.desc": "section4峰值开始时间2-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section4PeakStopHour2.desc": "section4峰值停止时间2-小时的说明。",
  "50901.ctrl_WorkMode.economic.section4PeakStopMinute2.desc": "section4峰值停止时间2-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section4ValleyStartHour2.desc": "section4低估开始时间2-小时的说明。",
  "50901.ctrl_WorkMode.economic.section4ValleyStartMinute2.desc": "section4低估开始时间2-分钟的说明。",
  "50901.ctrl_WorkMode.economic.section4ValleyStopHour2.desc": "section4低估停止时间2-小时的说明。",
  "50901.ctrl_WorkMode.economic.section4ValleyStopMinute2.desc": "section4低估停止时间2-分钟的说明。",
  "50901.ctrl_WorkMode.peakMeter.peakMeterSoc.desc": "峰值计SOC的说明。",
  "50901.ctrl_WorkMode.peakMeter.peakMeterPower.desc": "峰值仪表功率的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseRange.desc": "TOU模式时间范围的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStartH.desc": "使用时间Time1ChrgStart-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStartMin.desc": "使用时间Time1ChrgStart-\nMin\n的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgEndH.desc": "使用时间Time1Chrg结束-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgEndMin.desc": "使用时间Time1Chrg结束-分钟的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgPower.desc": "充电功率的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStartH.desc": "使用时间Time1DischrgStart-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStartMin.desc": "使用时间Time1DischrgStart-Min的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgEndH.desc": "使用时间Time1DischrgEnd-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgEndMin.desc": "使用时间Time1Dischrg结束-分钟的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgPower.desc": "放电功率的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime1DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStartH.desc": "使用时间Time2ChrgStart-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStartMin.desc": "使用时间Time2ChrgStart-\nMin\n的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgEndH.desc": "使用时间Time2Chrg结束-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgEndMin.desc": "使用时间Time2Chrg结束-分钟的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgPower.desc": "充电功率的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStartH.desc": "使用时间Time2DischrgStart-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStartMin.desc": "使用时间Time2DischrgStart-Min的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgEndH.desc": "使用时间Time2DischrgEnd-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgEndMin.desc": "使用时间Time2Dischrg结束-分钟的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgPower.desc": "放电功率的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime2DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStartH.desc": "使用时间Time3ChrgStart-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStartMin.desc": "使用时间Time3ChrgStart-\nMin\n的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgEndH.desc": "使用时间Time3Chrg结束-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgEndMin.desc": "使用时间Time3Chrg结束-分钟的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgPower.desc": "充电功率的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStartH.desc": "使用时间Time3DischrgStart-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStartMin.desc": "使用时间Time3DischrgStart-Min的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgEndH.desc": "使用时间Time3DischrgEnd-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgEndMin.desc": "使用时间Time3Dischrg结束-分钟的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgPower.desc": "放电功率的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime3DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStartH.desc": "使用时间Time4ChrgStart-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStartMin.desc": "使用时间Time4ChrgStart-\nMin\n的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgEndH.desc": "使用时间Time4Chrg结束-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgEndMin.desc": "使用时间Time4Chrg结束-分钟的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgPower.desc": "充电功率的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStartH.desc": "使用时间Time4DischrgStart-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStartMin.desc": "使用时间Time4DischrgStart-Min的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgEndH.desc": "使用时间Time4DischrgEnd-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgEndMin.desc": "使用时间Time4Dischrg结束-分钟的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgPower.desc": "放电功率的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime4DischrgStopSoc.desc": "放电截止功率的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStartH.desc": "使用时间Time5ChrgStart-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStartMin.desc": "使用时间Time5ChrgStart-\nMin\n的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgEndH.desc": "使用时间Time5Chrg结束-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgEndMin.desc": "使用时间Time5Chrg结束-分钟的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgPower.desc": "充电功率的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStartH.desc": "使用时间Time5DischrgStart-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStartMin.desc": "使用时间Time5DischrgStart-Min的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgEndH.desc": "使用时间Time5DischrgEnd-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgEndMin.desc": "使用时间Time5Dischrg结束-分钟的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgPower.desc": "放电功率的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime5DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStartH.desc": "使用时间Time6ChrgStart-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStartMin.desc": "使用时间Time6ChrgStart-\nMin\n的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgEndH.desc": "使用时间Time6Chrg结束-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgEndMin.desc": "使用时间Time6Chrg结束-分钟的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgPower.desc": "充电功率的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStartH.desc": "使用时间Time6DischrgStart-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStartMin.desc": "使用时间Time6DischrgStart-Min的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgEndH.desc": "使用时间Time6DischrgEnd-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgEndMin.desc": "使用时间Time6Dischrg结束-分钟的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgPower.desc": "放电功率的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime6DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStartH.desc": "使用时间Time7ChrgStart-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStartMin.desc": "使用时间Time7ChrgStart-\nMin\n的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgEndH.desc": "使用时间Time7Chrg结束-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgEndMin.desc": "使用时间Time7Chrg结束-分钟的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgPower.desc": "放电功率的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7ChrgStopSoc.desc": "放电截止容量的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStartH.desc": "使用时间Time7DischrgStart-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStartMin.desc": "使用时间Time7DischrgStart-Min的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgEndH.desc": "使用时间Time7DischrgEnd-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgEndMin.desc": "使用时间Time7Dischrg结束-分钟的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgPower.desc": "放电功率的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime7DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStartH.desc": "使用时间Time8ChrgStart-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStartMin.desc": "使用时间Time8ChrgStart-\nMin\n的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgEndH.desc": "使用时间Time8Chrg结束-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgEndMin.desc": "使用时间Time8Chrg结束-分钟的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgPower.desc": "充电功率的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8ChrgStopSoc.desc": "充电截止容量的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStartH.desc": "使用时间Time8DischrgStart-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStartMin.desc": "使用时间Time8DischrgStart-Min的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgEndH.desc": "使用时间Time8DischrgEnd-H的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgEndMin.desc": "使用时间Time8Dischrg结束-分钟的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgPower.desc": "放电功率的说明。",
  "50901.ctrl_WorkMode.TOU.timeOfUseTime8DischrgStopSoc.desc": "放电截止容量的说明。",
  "50901.ctrl_Config.ClockSetting.ClockSetting.desc": "时钟设置的说明。",
  "50901.ctrl_Config.ClockSetting.clockSetting_year.desc": "时钟设置-year的说明。",
  "50901.ctrl_Config.ClockSetting.clockSetting_month.desc": "时钟设置-month的说明。",
  "50901.ctrl_Config.ClockSetting.clockSetting_day.desc": "时钟设置-day的说明。",
  "50901.ctrl_Config.ClockSetting.clockSetting_hour.desc": "时钟设置-hour的说明。",
  "50901.ctrl_Config.ClockSetting.clockSetting_minute.desc": "时钟设置-minute的说明。",
  "50901.ctrl_Config.ClockSetting.clockSetting_second.desc": "时钟设置-second的说明。",
  "50901.ctrl_Config.ClockSetting.clockSetting_weekday.desc": "时钟设置-weekday的说明。",
  "50901.ctrl_Config.Gateway.gatewayCommunicationAddress.desc": "网关通信地址的说明。",
  "50901.ctrl_Config.Gateway.boardAmbientTemperatureThreshold.desc": "电路板环境温度阈值的说明。",
  "50901.ctrl_Config.Gateway.ambientTemperatureThreshold.desc": "环境温度阈值的说明。",
  "50901.ctrl_Config.Device.masterSlave.desc": "主机/从机的说明。",
  "50901.ctrl_Config.Device.networkingType.desc": "联网类型的说明。",
  "50901.ctrl_Config.Device.checkTime.desc": "设备时间的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.homeInletBreakerRatedCurrent.desc": "入户空开额定电流",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.chargingPileRatedCurrent.desc": "充电桩额定电流",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatterySocEnable.desc": "定时模式-电池SOC使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatteryStartSoc.desc": "定时模式-电池启动SOC",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.timerModeBatteryStopSoc.desc": "定时模式-电池关闭SOC",
  "50901.ctrl_WorkMode.TOU.touModeReserveSoc.desc": "TOU模式预留SOC",
  "50901.Switch": "模式切换",
  "50901.economic": "经济模式",
  "50901.ClockSetting": "时钟设置",
  "50901.Gateway": "网关",
  "50901.peakMeter": "峰值计量",
  "50901.forceDischarge": "强制放电",
  "50901.TOU": "分时电价",
  "50901.forceCharge": "强制充电",
  "50901.Backup": "备用",
  "50901.Selfuse": "自发自用",
  "50901.ctrl_WorkMode.economic.section2WeekRange1.0": "枚举值0的含义",
  "50901.ctrl_WorkMode.economic.section2WeekRange1.1": "枚举值2的含义",
  "50901.ctrl_WorkMode.economic.section2WeekRange1.2": "周三",
  "50901.ctrl_WorkMode.economic.section2WeekRange1.3": "周四",
  "50901.ctrl_WorkMode.economic.section2WeekRange1.4": "周五",
  "50901.ctrl_WorkMode.economic.section2WeekRange1.5": "周六",
  "50901.ctrl_WorkMode.economic.section2WeekRange1.6": "周日",
  "50901.ctrl_WorkMode.economic.section3WeekRange1.0": "枚举值0的含义",
  "50901.ctrl_WorkMode.economic.section3WeekRange1.1": "枚举值2的含义",
  "50901.ctrl_WorkMode.economic.section3WeekRange1.2": "周三",
  "50901.ctrl_WorkMode.economic.section3WeekRange1.3": "周四",
  "50901.ctrl_WorkMode.economic.section3WeekRange1.4": "周五",
  "50901.ctrl_WorkMode.economic.section3WeekRange1.5": "周六",
  "50901.ctrl_WorkMode.economic.section3WeekRange1.6": "周日",
  "common.device.check.tab.communication": "通信",
  "common.device.check.tab.inveter": "逆变器",
  "50901.Settings": "工作模式",
  "50901.ctrl_Config.Grid Profile.country.0": "欧盟 EN_EN50549",
  "50901.ctrl_Config.Grid Profile.country.2": "澳大利亚 AU_AS4777_A",
  "50901.ctrl_Config.Grid Profile.country.3": "奥地利 AT_TOR",
  "50901.ctrl_Config.Grid Profile.country.4": "波兰 PL_EN50549",
  "50901.ctrl_Config.Grid Profile.country.5": "爱沙尼亚 EE_EVS_EN50549",
  "50901.ctrl_Config.Grid Profile.country.6": "匈牙利 \tHU_EN50549",
  "50901.ctrl_Config.Grid Profile.country.7": "澳大利亚 AU_AS4777_B",
  "50901.ctrl_Config.Grid Profile.country.8": "澳大利亚 AU_AS4777_C",
  "50901.ctrl_Config.Grid Profile.country.10": "澳大利亚 AU AS 4777 AZ",
  "50901.ctrl_Config.Grid Profile.country.11": "菲律宾 pH",
  "50901.ctrl_Config.Grid Profile.country.12": "巴西 BR_Inmetro_220v",
  "50901.ctrl_Config.Grid Profile.country.13": "巴基斯坦 PAK, EN 50549",
  "50901.ctrl_Config.Grid Profile.country.14": "泰国 THA-PEA",
  "50901.ctrl_Config.Grid Profile.country.15": "意大利 IT.CEIO-21",
  "50901.ctrl_Config.Grid Profile.country.17": "哥伦比亚 CNO_1862_240V",
  "50901.ctrl_Config.Grid Profile.country.19": "英国 UK_G98/G9",
  "50901.ctrl_Config.Grid Profile.country.20": "英国 UK. G98NI/G99NI",
  "50901.ctrl_Config.Grid Profile.country.21": "厄瓜多尔 EC IEEE1547",
  "50901.ctrl_Config.Grid Profile.country.22": "斯洛文尼亚 EN 50549_SI",
  "50901.ctrl_Config.Grid Profile.country.23": "法国 FR_VFR 2019",
  "50901.ctrl_Config.Grid Profile.country.24": "西班牙 ES_RD1699",
  "50901.ctrl_Config.Grid Profile.country.25": "西班牙 ES_RD647",
  "50901.ctrl_Config.Grid Profile.country.26": "立陶宛 LT.EN50549",
  "50901.ctrl_Config.Grid Profile.country.28": "泰国 THA-EMA",
  "50901.ctrl_Config.Grid Profile.country.31": "英国 UK_G98",
  "50901.ctrl_Config.Grid Profile.country.32": "英国 UK_G99",
  "50901.ctrl_Config.Grid Profile.country.33": "英国 UK_G98NI",
  "50901.ctrl_Config.Grid Profile.country.34": "英国 UK_G99 NI",
  "50901.ctrl_Config.Grid Profile.country.35": "越南 VN_CCDE",
  "50901.ctrl_Config.Grid Profile.country.36": "巴拿马 PA_GRID_240V",
  "50901.ctrl_Config.Grid Profile.country.37": "巴西 BR_Inmetro_220V_US",
  "50901.ctrl_Config.Grid Profile.country.38": "波多黎各 LUMAPR-2024_208V",
  "50901.ctrl_Config.Grid Profile.country.39": "波多黎各 LUMAPR-2024_240V",
  "50901.ctrl_Config.Grid Profile.country.40": "印度 IND_IEC61727",
  "50901.ctrl_Config.Grid Profile.country.41": "罗马尼亚 RO_Ordinul208_2018",
  "50901.ctrl_Config.Grid Profile.country.42": "中国 CN_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.43": "伊拉克 IRAQ_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.46": "沙特电网\tSA_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.47": "斯里兰卡 LK_IEC61727",
  "50901.ctrl_Config.Grid Profile.country.48": "捷克 CZ_PPDS2020",
  "50901.ctrl_Config.Grid Profile.country.49": "比利时 BE_C10_26",
  "50901.ctrl_Config.Grid Profile.country.50": "荷兰 NL_NEN_EN50549_1",
  "50901.ctrl_Config.Grid Profile.country.51": "乌克兰 UA_EN50549_1",
  "50901.ctrl_Config.Grid Profile.country.52": "加拿大 NA_IEEE1547_240V",
  "50901.ctrl_Config.Grid Profile.country.53": "加拿大 NA_IEEE1547_208V",
  "50901.ctrl_Config.Grid Profile.country.54": "马来西亚 MY_CODE",
  "50901.ctrl_Config.Grid Profile.country.55": "印度尼西亚 ID_GRID_220V",
  "50901.ctrl_Config.Grid Profile.country.56": "南非 ZA_NRS097_2024",
  "50901.ctrl_Config.Grid Profile.country.57": "瑞典 SE_SS-EN 50549",
  "50901.ctrl_Config.Grid Profile.country.58": "希腊 GR_VDE0126",
  "50901.ctrl_Config.Grid Profile.country.59": "卢森堡 LU_EN 50549",
  "50901.ctrl_Config.Grid Profile.country.60": "爱尔兰 IE_EN50438",
  "50901.ctrl_Config.Grid Profile.country.61": "赞比亚 ZAM_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.62": "柴发 GEN_GRID_50HZ",
  "50901.ctrl_Config.Grid Profile.country.63": "柴发 GEN_GRID_60HZ",
  "50901.ctrl_Config.Grid Profile.country.64": "沙特 SA_GRID_2025_265V",
  "50901.ctrl_Config.Grid Profile.country.65": "塞尔维亚 SRB_EN50549_1",
  "50901.ctrl_Config.Grid Profile.country.66": "瑞士 CH_NAEEA_NE7",
  "50901.ctrl_Config.Grid Profile.country.67": "黎巴嫩 RL_GRID_2025",
  "50901.ctrl_Config.Grid Profile.country.68": "智利 CL_220V",
  "50901.ctrl_Config.Grid Profile.country.69": "叙利亚 SYR_GRID_2026",
  "50901.ctrl_Safety.RPC.rpcMode.0": "不使能",
  "50901.ctrl_Safety.RPC.rpcMode.1": "Fixed Power Factor, PF Mode",
  "50901.ctrl_Safety.RPC.rpcMode.2": "Fixed Reactive Power, Q Mode",
  "50901.ctrl_Safety.RPC.rpcMode.3": "PF(P) Curve, PF(P) Mode",
  "50901.ctrl_Safety.RPC.rpcMode.4": "W",
  "50901.ctrl_Safety.RPC.rpcMode.5": "PQ",
  "50901.warning.canCommunicationTimeout.0": "disable",
  "50901.warning.canCommunicationTimeout.1": "enable",
  "50901.warning.lowBatteryEnergy.0": "disable",
  "50901.warning.lowBatteryEnergy.1": "enable",
  "50901.warning.hardwareProtection.0": "disable",
  "50901.warning.hardwareProtection.1": "enable",
  "50901.Fault.evCharger1CommunicationAbnormality.0": "disable",
  "50901.Fault.evCharger1CommunicationAbnormality.1": "enable",
  "50901.Fault.bmsCanCommunicationAbnormality.0": "不使能",
  "50901.Fault.bmsCanCommunicationAbnormality.1": "使能",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.0": "disable",
  "50901.Fault.dtu3Rs485CommunicationAbnormality.1": "enable",
  "50901.Fault.gridMeterTypeError.0": "disable",
  "50901.Fault.gridMeterTypeError.1": "enable",
  "50901.Fault.lowDtuVersion.0": "disable",
  "50901.Fault.lowDtuVersion.1": "使能",
  "50901.Fault.gridMeterCommunicationAbnormality.0": "disable",
  "50901.Fault.gridMeterCommunicationAbnormality.1": "使能",
  "50901.Fault.pvMeterTypeError.0": "disable",
  "50901.Fault.pvMeterTypeError.1": "enable",
  "50901.Fault.dspPwrCommunicationAbnormality.0": "disable",
  "50901.Fault.dspPwrCommunicationAbnormality.1": "使能",
  "50901.Fault.evCharger2CommunicationAbnormality.0": "disable",
  "50901.Fault.evCharger2CommunicationAbnormality.1": "enable",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.0": "disable",
  "50901.Fault.dtu5Rs485CommunicationAbnormality.1": "enable",
  "50901.Fault.dtsCommunicationAbnormality.0": "不使能",
  "50901.Fault.dtsCommunicationAbnormality.1": "使能",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.0": "disable",
  "50901.Fault.dtu4Rs485CommunicationAbnormality.1": "enable",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.0": "disable",
  "50901.Fault.dtu1Rs485CommunicationAbnormality.1": "enable",
  "50901.Fault.pvMeterCommunicationAbnormality.0": "不使能",
  "50901.Fault.pvMeterCommunicationAbnormality.1": "enable",
  "50901.Fault.slaveWrongBatteryConnection.0": "disable",
  "50901.Fault.slaveWrongBatteryConnection.1": "enable",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.0": "disable",
  "50901.Fault.dtu2Rs485CommunicationAbnormality.1": "enable",
  "50901.Fault.dspSafCommunicationAbnormality.0": "disable",
  "50901.Fault.dspSafCommunicationAbnormality.1": "enable",
  "50901.Fault.sustainedNegativeLoad.0": "不使能",
  "50901.Fault.sustainedNegativeLoad.1": "使能",
  "50901.Fault.hmidMachineFault.0": "disable",
  "50901.Fault.hmidMachineFault.1": "enable",
  "50901.Fault.evCharger1Fault.0": "disable",
  "50901.Fault.evCharger1Fault.1": "enable",
  "50901.Fault.evCharger2Fault.0": "disable",
  "50901.Fault.evCharger2Fault.1": "enable",
  "50901.Fault.fanSpeedAbnormality.0": "不使能",
  "50901.Fault.fanSpeedAbnormality.1": "enable",
  "50901.Fault.batteryFault.0": "disable",
  "50901.Fault.batteryFault.1": "enable",
  "50901.Fault.masterSlaveCommunicationAbnormality.0": "disable",
  "50901.Fault.masterSlaveCommunicationAbnormality.1": "enable",
  "50901.Fault.batteryCapacityAbnormality.0": "disable",
  "50901.Fault.batteryCapacityAbnormality.1": "enable",
  "50901.Fault.batteryForceChargeRequest.0": "disable",
  "50901.Fault.batteryForceChargeRequest.1": "enable",
  "50901.Fault.hmidCommunicationAbnormality.0": "disable",
  "50901.Fault.hmidCommunicationAbnormality.1": "enable",
  "platformType.web": "Web版本",
  "ceshi": "ceshi",
  "50901.ctrl_Safety_GCF.RPC.gcfExportSoftLimitRatio": "GCF外送软限比例",
  "50901.ctrl_Safety_GCF.RPC.gcfExportHardLimitRatio": "GCF外送硬限比例",
  "50901.ctrl_Safety_GCF.RPC.gcfExportSoftLimitRatio.desc": "GCF外送软限比例的说明。",
  "50901.ctrl_Safety_GCF.RPC.gcfExportHardLimitRatio.desc": "GCF外送硬限比例的说明。",
  "50901.ctrl_Safety.RPC.gcfExportSoftLimitRatio": "GCF外送软限比例",
  "50901.ctrl_Safety.RPC.gcfExportHardLimitRatio": "GCF外送硬限比例",
  "50901.ctrl_Safety.RPC.gcfExportSoftLimitRatio.desc": "GCF外送软限比例的说明。",
  "50901.ctrl_Safety.RPC.gcfExportHardLimitRatio.desc": "GCF外送硬限比例的说明。",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange27": "星期天",
  "50901.real_time.copy_bmsSoftwareVersion": "BMS版本-软件",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkMode": "热泵工作模式",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartPower": "热泵启动功率",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxFeedbackPower": "热泵最大反馈功率",
  "50901.ctrl_Dry_Contact.HeatPump.hpSupplyPower": "热泵电源",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode": "热泵BattSoc检测模式",
  "50901.ctrl_Dry_Contact.HeatPump.hpDelayDetectTimeLmt": "热泵延迟检测时间限制",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxTimeDetectEnable": "热泵最大时间检测启用",
  "50901.ctrl_Dry_Contact.HeatPump.hpMinRunTimeLmtOfOnce": "热泵最小运行时间限制",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxRunTimeOfOneDay": "热泵一天的最大运行时间",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartSoc": "热泵启动Soc",
  "50901.ctrl_Dry_Contact.HeatPump.hpCloseSoc": "热泵关闭Soc",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkTimeParts": "热泵工作时间",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1StartMonth": "热泵时间1开始-月",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1StartDay": "热泵时间1开始-天",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1EndMonth": "热泵时间1结束-\n月",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1EndDay": "热泵时间1结束-天",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange1": "热泵时间1周1",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange2": "热泵时间1周2",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange3": "热泵时间1周3",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange4": "热泵时间1周4",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange5": "热泵时间1周5",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange6": "热泵时间1周6",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange7": "热泵时间1周7",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2StartMonth": "热泵时间2开始-月",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2StartDay": "热泵时间2开始-天",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2EndMonth": "热泵时间2结束\n月",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2EndDay": "热泵时间2结束-天",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange1": "热泵时间2周1",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange2": "热泵时间2周2",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange3": "热泵时间2周3",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange4": "热泵时间2周4",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange5": "热泵时间2周5",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange6": "热泵时间2周6",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange7": "热泵时间2周7",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3StartMonth": "热泵时间3开始-月",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3StartDay": "热泵时间3开始-天",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3EndMonth": "热泵时间3结束\n月",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3EndDay": "热泵时间3结束-天",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange1": "热泵时间2周1",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange2": "热泵时间2周2",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange3": "热泵时间2周3",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange4": "热泵时间2周4",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange5": "热泵时间2周5",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange6": "热泵时间3周6",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange7": "热泵时间2周7",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4StartMonth": "热泵时间4Start-月",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4StartDay": "热泵时间4开始-天",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4EndMonth": "热泵时间4结束-月",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4EndDay": "热泵时间4结束-天",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange1": "热泵时间4周1",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange2": "热泵时间4周2",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange3": "热泵时间4周3",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange4": "热泵时间4周4",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange5": "热泵时间4周5",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange6": "热泵时间4周6",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange7": "热泵时间4周7",
  "50901.real_time.copy_communicationStickSoftwareVersion": "通讯棒软件版本",
  "50901..relayU16NlineRlyTestDis.0": "不使能",
  "50901..relayU16NlineRlyTestDis.1": "enable",
  "50901..phaseOrderInverseDisable.0": "disable",
  "50901..phaseOrderInverseDisable.1": "enable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange27.0": "不使能",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange27.1": "使能",
  "50901.ctrl_WorkMode.economic.section1WeekRange2.0": "枚举值0的含义",
  "50901.ctrl_WorkMode.economic.section1WeekRange2.1": "枚举值1的含义",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.0": "枚举值0的含义",
  "50901.ctrl_WorkMode.economic.section3WeekRange2.1": "枚举值1的含义",
  "50901.ctrl_WorkMode.economic.section4WeekRange1.0": "枚举值0的含义",
  "50901.ctrl_WorkMode.economic.section4WeekRange1.1": "枚举值2的含义",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.0": "枚举值0的含义",
  "50901.ctrl_WorkMode.economic.section4WeekRange2.1": "枚举值1的含义",
  "50901.real_time.packNum.0": "0",
  "50901.real_time.packNum.3": "2",
  "50901.real_time.packNum.7": "3",
  "50901.real_time.packNum.15": "4",
  "50901.real_time.packNum.31": "5",
  "50901.real_time.packNum.63": "6",
  "50901.real_time.packNum.127": "7",
  "50901.real_time.packNum.255": "8",
  "50901.real_time.packNum.511": "9",
  "50901.real_time.packNum.1023": "10",
  "50901.real_time.packNum.2047": "11",
  "50901.real_time.packNum.4095": "12",
  "50901.real_time.packNum.8191": "13",
  "50901.real_time.packNum.16383": "14",
  "50901.real_time.packNum.32767": "15",
  "50901.real_time.packNum.65535": "16",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkMode.0": "否",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkMode.1": "是",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode.0": "否",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode.1": "是",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange1.0": "不使能",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange1.1": "使能",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange2.0": "不使能",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange2.1": "使能",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange3.0": "不使能",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange3.1": "使能",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange4.0": "不使能",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange4.1": "使能",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange5.0": "不使能",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange5.1": "使能",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange6.0": "不使能",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange6.1": "使能",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange7.0": "不使能",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange7.1": "使能",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange1.0": "disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange1.1": "enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange2.0": "disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange2.1": "enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange3.0": "disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange3.1": "enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange4.0": "disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange4.1": "enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange5.0": "disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange5.1": "enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange6.0": "disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange6.1": "enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange7.0": "disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange7.1": "enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange1.0": "disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange1.1": "enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange2.0": "disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange2.1": "enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange3.0": "disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange3.1": "enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange4.0": "disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange4.1": "enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange5.0": "disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange5.1": "enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange6.0": "disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange6.1": "enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange7.0": "disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange7.1": "enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange1.0": "disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange1.1": "enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange2.0": "disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange2.1": "enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange3.0": "disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange3.1": "enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange4.0": "disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange4.1": "enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange5.0": "disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange5.1": "enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange6.0": "disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange6.1": "enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange7.0": "disable",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange7.1": "enable",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.smart_weekRange27.desc": "星期一的说明。",
  "50901..bmsSoftwareVersion.desc": "BMS版本-软件的说明。",
  "50901..communicationStickSoftwareVersion.desc": "通讯棒软件版本的说明。",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkMode.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartPower.desc": "当启动功率达到该值时，热泵控制模式启用",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxFeedbackPower.desc": "Maximum network feeding power of the heat pump",
  "50901.ctrl_Dry_Contact.HeatPump.hpSupplyPower.desc": "The heat pump takes power",
  "50901.ctrl_Dry_Contact.HeatPump.hpBattSocDetectMode.desc": "SOC Enabling mode for heat pump batteries 0: Disable 1: Enable",
  "50901.ctrl_Dry_Contact.HeatPump.hpDelayDetectTimeLmt.desc": "Delay detection threshold of heat pump",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxTimeDetectEnable.desc": "Max Time Detect Enable of heat pump",
  "50901.ctrl_Dry_Contact.HeatPump.hpMinRunTimeLmtOfOnce.desc": "当单次运行时间达到该值时，热泵控制模式禁用",
  "50901.ctrl_Dry_Contact.HeatPump.hpMaxRunTimeOfOneDay.desc": "当当日运行时间达到该值时，热泵控制模式禁用",
  "50901.ctrl_Dry_Contact.HeatPump.hpStartSoc.desc": "当电池 SOC 达到该值时，热泵控制模式启用",
  "50901.ctrl_Dry_Contact.HeatPump.hpCloseSoc.desc": "当电池 SOC 达到该值时，热泵控制模式禁用",
  "50901.ctrl_Dry_Contact.HeatPump.hpWorkTimeParts.desc": "最多可设置 4 个运行时段",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1StartMonth.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1StartDay.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1EndMonth.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1EndDay.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange1.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange2.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange3.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange4.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange5.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange6.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime1WeekRange7.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2StartMonth.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2StartDay.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2EndMonth.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2EndDay.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange1.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange2.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange3.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange4.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange5.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange6.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime2WeekRange7.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3StartMonth.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3StartDay.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3EndMonth.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3EndDay.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange1.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange2.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange3.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange4.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange5.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange6.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime3WeekRange7.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4StartMonth.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4StartDay.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4EndMonth.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4EndDay.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange1.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange2.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange3.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange4.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange5.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange6.desc": "读,写,上报",
  "50901.ctrl_Dry_Contact.HeatPump.hpTime4WeekRange7.desc": "读,写,上报",
  "50901.real_time.copy_communicationStickSoftwareVersion.desc": "通讯棒软件版本的说明。",
  "50901.HeatPump": "热泵控制",
  "50901.realtime.controllerarmFirmwareVersion": "逆变器ARM版本",
  "50901..cfgMultPcsBmsFlag.0": "否",
  "50901..cfgMultPcsBmsFlag.1": "是",
  "50901..materType.0": "无网侧电表",
  "50901..materType.1": "正泰单相",
  "50901..materType.2": "正泰单相",
  "50901..materType.3": "正泰裂相",
  "50901..materType.5": "计量模块",
  "50901..materType.6": "安科瑞单路",
  "50901..materType.7": "安科瑞双路",
  "50901..cfgMultPcsBmsFlag.desc": "BMS标志位的说明。",
  "50901..materType.desc": "电表类型的说明。",
  "50901..packVoltage.desc": "电池包电压的说明。",
  "50901..packCurrent.desc": "电池包电流的说明。",
  "50901..packPower.desc": "电池包功率的说明。",
  "50901..batteryModuleNum.desc": "电池串数（模块单体电芯串数）的说明。",
  "50901..maxCellVoltageCellId.desc": "最高单体电压对应序号的说明。",
  "50901..minCellVoltageCellId.desc": "最低单体电压对应序号的说明。",
  "50901..maxCellTemperatureCellId.desc": "最高单体温度对应序号的说明。",
  "50901..minCellTemperatureCellId.desc": "最低单体温度对应序号的说明。",
  "50901..maxCellSocCellId.desc": "最高单体SOC对应序号的说明。",
  "50901..minCellSocCellId.desc": "最低单体SOC对应序号的说明。",
  "50901..maxCellSoc.desc": "最高单体SOC的说明。",
  "50901..minCellSoc.desc": "最低单体SOC的说明。",
  "50901..packSoc.desc": "电池包SOC的说明。",
  "50901..packSoh.desc": "电池包SOH的说明。",
  "50901..numberOfChargingAndDischargingCyclesOfBatteryPack.desc": "电池包充放电循环次数的说明。",
  "50901..数据分析_单体SOC.tag": "单体SOC",
  "50901..数据分析_电池包.tag": "电池包",
  "50901.real_time.batteryCapacity": "电池装机容量",
  "50901.ctrl_WorkMode.economic.section1WeekRange11": "时段1第1组星期一",
  "50901.ctrl_WorkMode.economic.section1WeekRange12": "时段1第1组星期二",
  "50901.ctrl_WorkMode.economic.section1WeekRange13": "时段1第1组星期三",
  "50901.ctrl_WorkMode.economic.section1WeekRange14": "时段1第1组星期四",
  "50901.ctrl_WorkMode.economic.section1WeekRange15": "时段1第1组星期五",
  "50901.ctrl_WorkMode.economic.section1WeekRange16": "时段1第1组星期六",
  "50901.ctrl_WorkMode.economic.section1WeekRange17": "时段1第1组星期日",
  "50901.ctrl_WorkMode.economic.section1WeekRange21": "时段1第2组星期一",
  "50901.ctrl_WorkMode.economic.section1WeekRange22": "时段1第2组星期二",
  "50901.ctrl_WorkMode.economic.section1WeekRange23": "时段1第2组星期三",
  "50901.ctrl_WorkMode.economic.section1WeekRange24": "时段1第2组星期四",
  "50901.ctrl_WorkMode.economic.section1WeekRange25": "时段1第2组星期五",
  "50901.ctrl_WorkMode.economic.section1WeekRange26": "时段1第2组星期六",
  "50901.ctrl_WorkMode.economic.section1WeekRange27": "时段1第2组星期七",
  "50901.ctrl_WorkMode.economic.section2WeekRange11": "时段2第1组星期一",
  "50901.ctrl_WorkMode.economic.section2WeekRange12": "时段2第1组星期二",
  "50901.ctrl_WorkMode.economic.section2WeekRange13": "时段2第1组星期三",
  "50901.ctrl_WorkMode.economic.section2WeekRange14": "时段2第1组星期四",
  "50901.ctrl_WorkMode.economic.section2WeekRange15": "时段2第1组星期五",
  "50901.ctrl_WorkMode.economic.section2WeekRange16": "时段2第1组星期六",
  "50901.ctrl_WorkMode.economic.section2WeekRange17": "时段2第1组星期日",
  "50901.ctrl_WorkMode.economic.section2WeekRange21": "时段2第2组星期一",
  "50901.ctrl_WorkMode.economic.section2WeekRange22": "时段2第2组星期二",
  "50901.ctrl_WorkMode.economic.section2WeekRange23": "时段2第2组星期三",
  "50901.ctrl_WorkMode.economic.section2WeekRange24": "时段2第2组星期四",
  "50901.ctrl_WorkMode.economic.section2WeekRange25": "时段2第2组星期五",
  "50901.ctrl_WorkMode.economic.section2WeekRange26": "时段2第2组星期六",
  "50901.ctrl_WorkMode.economic.section2WeekRange27": "时段2第2组星期七",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContactTimer1": "干节点时段1",
  "50901..section1WeekRange1.0": "周一",
  "50901..section1WeekRange1.1": "周二",
  "50901..section1WeekRange1.2": "周三",
  "50901..section1WeekRange1.3": "周四",
  "50901..section1WeekRange1.4": "周五",
  "50901..section1WeekRange1.5": "周六",
  "50901..section1WeekRange1.6": "周日",
  "50901.ctrl_WorkMode.economic.section1WeekRange11.0": "不使能",
  "50901.ctrl_WorkMode.economic.section1WeekRange11.1": "使能",
  "50901.ctrl_WorkMode.economic.section1WeekRange12.0": "不使能",
  "50901.ctrl_WorkMode.economic.section1WeekRange12.1": "使能",
  "50901.ctrl_WorkMode.economic.section1WeekRange13.0": "不使能",
  "50901.ctrl_WorkMode.economic.section1WeekRange13.1": "使能",
  "50901.ctrl_WorkMode.economic.section1WeekRange14.0": "不使能",
  "50901.ctrl_WorkMode.economic.section1WeekRange14.1": "使能",
  "50901.ctrl_WorkMode.economic.section1WeekRange15.0": "不使能",
  "50901.ctrl_WorkMode.economic.section1WeekRange15.1": "使能",
  "50901.ctrl_WorkMode.economic.section1WeekRange16.0": "不使能",
  "50901.ctrl_WorkMode.economic.section1WeekRange16.1": "使能",
  "50901.ctrl_WorkMode.economic.section1WeekRange17.0": "不使能",
  "50901.ctrl_WorkMode.economic.section1WeekRange17.1": "使能",
  "50901..section1WeekRange2.0": "枚举值0的含义",
  "50901..section1WeekRange2.1": "枚举值1的含义",
  "50901.ctrl_WorkMode.economic.section1WeekRange21.0": "不使能",
  "50901.ctrl_WorkMode.economic.section1WeekRange21.1": "使能",
  "50901.ctrl_WorkMode.economic.section1WeekRange22.0": "不使能",
  "50901.ctrl_WorkMode.economic.section1WeekRange22.1": "使能",
  "50901.ctrl_WorkMode.economic.section1WeekRange23.0": "不使能",
  "50901.ctrl_WorkMode.economic.section1WeekRange23.1": "使能",
  "50901.ctrl_WorkMode.economic.section1WeekRange24.0": "不使能",
  "50901.ctrl_WorkMode.economic.section1WeekRange24.1": "使能",
  "50901.ctrl_WorkMode.economic.section1WeekRange25.0": "不使能",
  "50901.ctrl_WorkMode.economic.section1WeekRange25.1": "使能",
  "50901.ctrl_WorkMode.economic.section1WeekRange26.0": "不使能",
  "50901.ctrl_WorkMode.economic.section1WeekRange26.1": "使能",
  "50901.ctrl_WorkMode.economic.section1WeekRange27.0": "不使能",
  "50901.ctrl_WorkMode.economic.section1WeekRange27.1": "使能",
  "50901..section2WeekRange1.0": "枚举值0的含义",
  "50901..section2WeekRange1.1": "枚举值2的含义",
  "50901.ctrl_WorkMode.economic.section2WeekRange11.0": "不使能",
  "50901.ctrl_WorkMode.economic.section2WeekRange11.1": "使能",
  "50901.ctrl_WorkMode.economic.section2WeekRange12.0": "不使能",
  "50901.ctrl_WorkMode.economic.section2WeekRange12.1": "使能",
  "50901.ctrl_WorkMode.economic.section2WeekRange13.0": "不使能",
  "50901.ctrl_WorkMode.economic.section2WeekRange13.1": "使能",
  "50901.ctrl_WorkMode.economic.section2WeekRange14.0": "不使能",
  "50901.ctrl_WorkMode.economic.section2WeekRange14.1": "使能",
  "50901.ctrl_WorkMode.economic.section2WeekRange15.0": "不使能",
  "50901.ctrl_WorkMode.economic.section2WeekRange15.1": "使能",
  "50901.ctrl_WorkMode.economic.section2WeekRange16.0": "不使能",
  "50901.ctrl_WorkMode.economic.section2WeekRange16.1": "使能",
  "50901.ctrl_WorkMode.economic.section2WeekRange17.0": "不使能",
  "50901.ctrl_WorkMode.economic.section2WeekRange17.1": "使能",
  "50901.ctrl_WorkMode.economic.section2WeekRange21.0": "不使能",
  "50901.ctrl_WorkMode.economic.section2WeekRange21.1": "使能",
  "50901.ctrl_WorkMode.economic.section2WeekRange22.0": "不使能",
  "50901.ctrl_WorkMode.economic.section2WeekRange22.1": "使能",
  "50901.ctrl_WorkMode.economic.section2WeekRange23.0": "不使能",
  "50901.ctrl_WorkMode.economic.section2WeekRange23.1": "使能",
  "50901.ctrl_WorkMode.economic.section2WeekRange24.0": "不使能",
  "50901.ctrl_WorkMode.economic.section2WeekRange24.1": "使能",
  "50901.ctrl_WorkMode.economic.section2WeekRange25.0": "不使能",
  "50901.ctrl_WorkMode.economic.section2WeekRange25.1": "使能",
  "50901.ctrl_WorkMode.economic.section2WeekRange26.0": "不使能",
  "50901.ctrl_WorkMode.economic.section2WeekRange26.1": "使能",
  "50901.ctrl_WorkMode.economic.section2WeekRange27.0": "不使能",
  "50901.ctrl_WorkMode.economic.section2WeekRange27.1": "使能",
  "50901.real_time.batteryCapacity.desc": "BMS容量的说明。",
  "50901..section1WeekRange1.desc": "section1周范围1的说明。",
  "50901..section1WeekRange2.desc": "section1周范围2的说明。",
  "50901..section2WeekRange1.desc": "section2周范围1的说明。",
  "50901..section2WeekRange2.desc": "section2周范围2的说明。",
  "50901..batterytotCap.desc": "电池装机总容量的说明。",
  "60420.ctrl_param_shebeixinxishezhi.wideVoltageLevel": "宽电压等级",
  "60420.real_time.regulatoryManufacturers.00": "CQC2013",
  "60420.real_time.regulatoryManufacturers.06": "印度",
  "60420.ctrl_fangniliushezhi.multiReverseFlowEnable.00": "禁止",
  "60420.ctrl_fangniliushezhi.multiReverseFlowEnable.01": "使能",
  "60420.ctrl_fangniliushezhi.restrictCounterCurrent.00": "限制三相总功率",
  "60420.ctrl_fangniliushezhi.restrictCounterCurrent.01": "限制单相功率",
  "60420.ctrl_param_shebeixinxishezhi.inputModeSet.00": "输入独立模式",
  "60420.ctrl_param_shebeixinxishezhi.inputModeSet.01": "输入并联模式",
  "60420.ctrl_param_shebeixinxishezhi.inputModeSet.02": "直流源模式(老化模式) (掉电保存)",
  "60420.real_time.internalHardwareError.00": "无异常",
  "60420.real_time.internalHardwareError.01": "外部 FLASH 异常",
  "60420.real_time.internalHardwareError.02": "读 EEPROM 异常",
  "60420.real_time.internalHardwareError.03": "写 EEPROM 异常",
  "60420.real_time.internalHardwareError.04": "GFCI 自检失败",
  "60420.ctrl_param_shebeixinxishezhi.wideVoltageLevel.00": "默认值",
  "60420.ctrl_param_shebeixinxishezhi.wideVoltageLevel.01": "1.2倍",
  "60420.ctrl_param_shebeixinxishezhi.wideVoltageLevel.02": "1.25倍",
  "60420.ctrl_fangniliushezhi.singleReverseFlowEnable.00": "禁止",
  "60420.ctrl_fangniliushezhi.singleReverseFlowEnable.01": "使能",
  "60420.ctrl_param_shebeixinxishezhi.reactiveControlSet.00": "功率因数控制",
  "60420.ctrl_param_shebeixinxishezhi.reactiveControlSet.01": "无功功率百分比控制",
  "60420.ctrl_param_shebeixinxishezhi.reactiveControlSet.02": "QV 曲线控制(掉电保存)",
  "60420.real_time.workStatus.00": "初始化",
  "60420.real_time.workStatus.01": "等待",
  "60420.real_time.workStatus.02": "正常",
  "60420.real_time.workStatus.03": "故障",
  "60420.real_time.workStatus.04": "烧录",
  "60420.ctrl_fangniliushezhi.meterSelect.00": "CT",
  "60420.ctrl_fangniliushezhi.meterSelect.01": "斯通瑞电表",
  "60420.ctrl_fangniliushezhi.meterSelect.02": "东帆电表",
  "60420.ctrl_fangniliushezhi.meterSelect.03": "东鸿电表",
  "60420.ctrl_fangniliushezhi.meterSelect.04": "正泰电表",
  "60420.ctrl_fangniliushezhi.meterSelect.05": "益邦",
  "60420.ctrl_fangniliushezhi.meterSelect.06": "英臻",
  "60420.ctrl_fangniliushezhi.meterSelect.07": "能控云智能电表",
  "60420.ctrl_param_shebeixinxishezhi.wideVoltageLevel.desc": " 0(默认值）:230V标准电压；  1(表示1.2倍):276V宽电压;   2(表示1.25倍):287V宽电压",
  "65323.real_time.time": "时间戳",
  "65323.control_param.deviceSn": "设备序列号",
  "65323.control_param.collectorSn": "所属采集器",
  "65323.real_time.title2030M17": "标题字段M17",
  "65323.real_time.title2026M1": "标题字段M1",
  "65323.real_time.runStatus": "运行状态",
  "65323.real_time.faultStatus1": "故障状态1",
  "65323.real_time.faultStatus2": "故障状态2",
  "65323.real_time.warningStatus": "告警状态",
  "65323.real_time.relayStatus": "继电器状态",
  "65323.real_time.inverterTemperature": "逆变温度",
  "65323.real_time.dcTemperature": "DC温度",
  "65323.real_time.drmStatus": "DRM状态",
  "65323.real_time.mpptTemperature": "MPPT温度",
  "65323.real_time.gridVoltageAB": "电网电压AB",
  "65323.real_time.gridVoltageBC": "电网电压BC",
  "65323.real_time.gridVoltageCA": "电网电压CA",
  "65323.real_time.gridCurrentA": "电网电流A",
  "65323.real_time.gridCurrentB": "电网电流B",
  "65323.real_time.gridCurrentC": "电网电流C",
  "65323.real_time.gridFrequencyA": "电网频率A",
  "65323.real_time.gridFrequencyB": "电网频率B",
  "65323.real_time.gridFrequencyC": "电网频率C",
  "65323.real_time.gridActivePower": "电网有功功率",
  "65323.real_time.gridAPhaseActivePower": "电网A相有功功率",
  "65323.real_time.gridBPhaseActivePower": "电网B相有功功率",
  "65323.real_time.gridCPhaseActivePower": "电网C相有功功率",
  "65323.real_time.gridReactivePower": "电网无功功率",
  "65323.real_time.gridApparentPower": "电网视在功率",
  "65323.real_time.powerFactor": "功率因数",
  "65323.real_time.dcComponentA": "直流分量A",
  "65323.real_time.dcComponentB": "直流分量B",
  "65323.real_time.dcComponentC": "直流分量C",
  "65323.real_time.phaseOrder": "相序",
  "65323.real_time.leakageCurrent": "漏电流",
  "65323.real_time.clsStatus": "CLS状态",
  "65323.real_time.clsLockNum": "CLS锁定次数",
  "65323.real_time.clsLockTime": "CLS锁定时间",
  "65323.real_time.meterReturnPortVoltageA": "电表回流端口A相电压",
  "65323.real_time.meterReturnPortVoltageB": "电表回流端口B相电压",
  "65323.real_time.meterReturnPortVoltageC": "电表回流端口C相电压",
  "65323.real_time.meterReturnPortCurrentA": "电表回流端口A相电流",
  "65323.real_time.meterReturnPortCurrentB": "电表回流端口B相电流",
  "65323.real_time.meterReturnPortCurrentC": "电表回流端口C相电流",
  "65323.real_time.meterReturnPortActivePower": "电表回流端口总有功功率",
  "65323.real_time.meterReturnPortReactivePower": "电表回流端口总无功功率",
  "65323.real_time.meterReturnPortApparentPower": "电表回流端口视在功率",
  "65323.real_time.meterReturnPortPowerFactor": "电表回流端口功率因数",
  "65323.real_time.meterEnergyMetered": "电表总计量电量",
  "65323.real_time.meterImportEnergy": "电表总输入电量",
  "65323.real_time.meterExportEnergy": "电表总输出电量",
  "65323.real_time.meterAImportEnergy": "电表A相输入电量",
  "65323.real_time.meterAExportEnergy": "电表A相输出电量",
  "65323.real_time.meterBImportEnergy": "电表B相输入电量",
  "65323.real_time.meterBExportEnergy": "电表B相输出电量",
  "65323.real_time.meterCImportEnergy": "电表C相输入电量",
  "65323.real_time.meterCExportEnergy": "电表C相输出电量",
  "65323.real_time.loadMeterVoltageA": "负载电表A相电压",
  "65323.real_time.loadMeterVoltageB": "负载电表B相电压",
  "65323.real_time.loadMeterVoltageC": "负载电表C相电压",
  "65323.real_time.loadMeterCurrentA": "负载电表A相电流",
  "65323.real_time.loadMeterCurrentB": "负载电表B相电流",
  "65323.real_time.loadMeterCurrentC": "负载电表C相电流",
  "65323.real_time.loadMeterActivePower": "负载电表总有功功率",
  "65323.real_time.loadMeterReactivePower": "负载电表总无功功率",
  "65323.real_time.loadMeterApparentPower": "负载电表视在功率",
  "65323.real_time.loadMeterPowerFactor": "负载电表功率因数",
  "65323.real_time.loadMeterEnergyMetered": "负载电表总计量电量",
  "65323.real_time.pvVoltage1": "光伏电压1",
  "65323.real_time.pvVoltage2": "光伏电压2",
  "65323.real_time.pvCurrent1": "光伏电流1",
  "65323.real_time.pvCurrent2": "光伏电流2",
  "65323.real_time.pvPower1": "光伏功率1",
  "65323.real_time.pvPower2": "光伏功率2",
  "65323.real_time.pvTotalPower": "光伏总功率",
  "65323.real_time.insulationImpedancePositive": "正母线绝缘阻抗",
  "65323.real_time.insulationImpedanceNegative": "负母线绝缘阻抗",
  "65323.real_time.batteryVoltage": "电池电压",
  "65323.real_time.batteryCurrent": "电池电流",
  "65323.real_time.batteryPower": "电池功率",
  "65323.real_time.batterySoc": "电池SOC",
  "65323.real_time.batterySoH": "电池SOH",
  "65323.real_time.bmsBatteryVoltage": "BMS电池电压",
  "65323.real_time.bmsBatteryCurrent": "BMS电池电流",
  "65323.real_time.bmsBatterySoc": "BMS电池SOC",
  "65323.real_time.bmsBatterySoH": "BMS电池SOH",
  "65323.real_time.bmsBatteryTemperature": "BMS电池温度",
  "65323.real_time.bmsBatteryStatus": "BMS电池状态",
  "65323.real_time.generatorVoltageAB": "发电机电压AB",
  "65323.real_time.generatorVoltageBC": "发电机电压BC",
  "65323.real_time.generatorVoltageCA": "发电机电压CA",
  "65323.real_time.generatorCurrentA": "发电机电流A",
  "65323.real_time.generatorCurrentB": "发电机电流B",
  "65323.real_time.generatorCurrentC": "发电机电流C",
  "65323.real_time.generatorFrequencyA": "发电机频率A",
  "65323.real_time.generatorFrequencyB": "发电机频率B",
  "65323.real_time.generatorFrequencyC": "发电机频率C",
  "65323.real_time.generatorActivePower": "发电机总有功功率",
  "65323.real_time.generatorReactivePower": "发电机总无功功率",
  "65323.real_time.generatorApparentPower": "发电机视在功率",
  "65323.real_time.generatorPowerFactor": "发电机功率因数",
  "65323.real_time.generatorRelayStatus": "发电机继电器状态",
  "65323.real_time.spiTestResult": "SPI测试结果",
  "65323.real_time.spiTestTime": "SPI测试时间",
  "65323.real_time.pvStringPower1": "光伏组串1功率",
  "65323.real_time.pvStringPower2": "光伏组串2功率",
  "65323.real_time.dcBusVoltage": "直流母线电压",
  "65323.real_time.pvPowerGeneratedToday": "今日光伏发电量",
  "65323.real_time.pvPowerGeneratedTotal": "总光伏发电量",
  "65323.real_time.pvVoltage3": "光伏3电压",
  "65323.real_time.pvVoltage4": "光伏4电压",
  "65323.real_time.pvVoltage5": "光伏5电压",
  "65323.real_time.pvVoltage6": "光伏6电压",
  "65323.real_time.pvCurrent3": "光伏3电流",
  "65323.real_time.pvCurrent4": "光伏4电流",
  "65323.real_time.pvCurrent5": "光伏5电流",
  "65323.real_time.pvCurrent6": "光伏6电流",
  "65323.real_time.pvPower3": "光伏3功率",
  "65323.real_time.pvPower4": "光伏4功率",
  "65323.real_time.pvPower5": "光伏5功率",
  "65323.real_time.pvPower6": "光伏6功率",
  "65323.real_time.pvMonthlyEnergy": "光伏当月发电量",
  "65323.real_time.pvAnnualEnergy": "光伏当年发电量",
  "65323.real_time.batteryStatus": "电池状态",
  "65323.real_time.batChargeVoltage": "电池充电电压",
  "65323.real_time.bmsTemperature": "BMS温度",
  "65323.real_time.bmsChargeCurrentLimit": "BMS充电电流限制",
  "65323.real_time.bmsDischargeCurrentLimit": "BMS放电电流限制",
  "65323.real_time.batTodayChargeEnergy": "电池今日充电量",
  "65323.real_time.batTodayDischargeEnergy": "电池今日放电量",
  "65323.real_time.batTotalChargeEnergy": "电池总充电量",
  "65323.real_time.batTotalDischargeEnergy": "电池总放电量",
  "65323.real_time.bmsMaxVoltage": "BMS最大电压",
  "65323.real_time.bmsMinVoltage": "BMS最小电压",
  "65323.real_time.batFaultFlag": "电池故障标志",
  "65323.real_time.batAlarmFlag": "电池告警标志",
  "65323.real_time.bmsRequestFlag": "BMS请求标志",
  "65323.real_time.positiveElectrodeInsulationImpedance1": "正极绝缘阻抗1",
  "65323.real_time.positiveElectrodeInsulationImpedance2": "正极绝缘阻抗2",
  "65323.real_time.positiveElectrodeInsulationImpedance3": "正极绝缘阻抗3",
  "65323.real_time.positiveElectrodeInsulationImpedance4": "正极绝缘阻抗4",
  "65323.real_time.positiveElectrodeInsulationImpedance5": "正极绝缘阻抗5",
  "65323.real_time.positiveElectrodeInsulationImpedance6": "正极绝缘阻抗6",
  "65323.real_time.loadFrequency": "负载频率",
  "65323.real_time.loadAPhaseActivePower": "负载A相有功功率",
  "65323.real_time.loadBPhaseActivePower": "负载B相有功功率",
  "65323.real_time.loadCPhaseActivePower": "负载C相有功功率",
  "65323.real_time.loadTodayConsumeEnergy": "负载当日用电量",
  "65323.real_time.loadTotalConsumeEnergy": "负载累计用电量",
  "65323.real_time.ctStatus": "电表状态",
  "65323.real_time.ctVoltageA": "电表电压A",
  "65323.real_time.ctVoltageB": "电表电压B",
  "65323.real_time.ctVoltageC": "电表电压C",
  "65323.real_time.ctCurrentA": "电表电流A",
  "65323.real_time.ctCurrentB": "电表电流B",
  "65323.real_time.ctCurrentC": "电表电流C",
  "65323.real_time.ctTotalActivePower": "电表总有功功率",
  "65323.real_time.ctAPhaseActivePower": "电表A相有功功率",
  "65323.real_time.ctBPhaseActivePower": "电表B相有功功率",
  "65323.real_time.ctCPhaseActivePower": "电表C相有功功率",
  "65323.real_time.ctReactivePower": "电表无功功率",
  "65323.real_time.ctApparentPower": "电表视在功率",
  "65323.real_time.ctFrequency": "电表频率",
  "65323.real_time.ctPowerFactor": "电表功率因数",
  "65323.real_time.spiAutoTestEndFlag": "SPI自动测试结束标志",
  "65323.real_time.spiAutoTestThresholdAPhaseU1": "SPI自动测试阈值A相U>>",
  "65323.real_time.spiAutoTestThresholdAPhaseU2": "SPI自动测试阈值A相U>10min",
  "65323.real_time.spiAutoTestThresholdAPhaseU3": "SPI自动测试阈值A相U<",
  "65323.real_time.spiAutoTestThresholdAPhaseU4": "SPI自动测试阈值A相U<<",
  "65323.real_time.spiAutoTestThresholdBPhaseU1": "SPI自动测试阈值B相U>>",
  "65323.real_time.spiAutoTestThresholdBPhaseU2": "SPI自动测试阈值B相U>10min",
  "65323.real_time.spiAutoTestThresholdBPhaseU3": "SPI自动测试阈值B相U<",
  "65323.real_time.spiAutoTestThresholdBPhaseU4": "SPI自动测试阈值B相U<<",
  "65323.real_time.spiAutoTestThresholdCPhaseU1": "SPI自动测试阈值C相U>>",
  "65323.real_time.spiAutoTestThresholdCPhaseU2": "SPI自动测试阈值C相U>10min",
  "65323.real_time.spiAutoTestThresholdCPhaseU3": "SPI自动测试阈值C相U<",
  "65323.real_time.spiAutoTestThresholdCPhaseU4": "SPI自动测试阈值C相U<<",
  "65323.real_time.spiAutoTestThresholdF1": "SPI自动测试阈值F>>",
  "65323.real_time.spiAutoTestThresholdF2": "SPI自动测试阈值F>",
  "65323.real_time.spiAutoTestThresholdF3": "SPI自动测试阈值F<",
  "65323.real_time.spiAutoTestThresholdF4": "SPI自动测试阈值F<<",
  "65323.real_time.spiAutoTestTimeAPhaseU1": "SPI自动测试时间A相U>>",
  "65323.real_time.spiAutoTestTimeAPhaseU2": "SPI自动测试时间A相U>10min",
  "65323.real_time.spiAutoTestTimeAPhaseU3": "SPI自动测试时间A相U<",
  "65323.real_time.spiAutoTestTimeAPhaseU4": "SPI自动测试时间A相U<<",
  "65323.real_time.spiAutoTestTimeBPhaseU1": "SPI自动测试时间B相U>>",
  "65323.real_time.spiAutoTestTimeBPhaseU2": "SPI自动测试时间B相U>10min",
  "65323.real_time.spiAutoTestTimeBPhaseU3": "SPI自动测试时间B相U<",
  "65323.real_time.spiAutoTestTimeBPhaseU4": "SPI自动测试时间B相U<<",
  "65323.real_time.spiAutoTestTimeCPhaseU1": "SPI自动测试时间C相U>>",
  "65323.real_time.spiAutoTestTimeCPhaseU2": "SPI自动测试时间C相U>10min",
  "65323.real_time.spiAutoTestTimeCPhaseU3": "SPI自动测试时间C相U<",
  "65323.real_time.spiAutoTestTimeCPhaseU4": "SPI自动测试时间C相U<<",
  "65323.real_time.spiAutoTestTimeF1": "SPI自动测试时间F>>",
  "65323.real_time.spiAutoTestTimeF2": "SPI自动测试时间F>",
  "65323.real_time.spiAutoTestTimeF3": "SPI自动测试时间F<",
  "65323.real_time.spiAutoTestTimeF4": "SPI自动测试时间F<<",
  "65323.real_time.load2GeneratorVoltageA": "负载2/发电机电压A",
  "65323.real_time.load2GeneratorVoltageB": "负载2/发电机电压B",
  "65323.real_time.load2GeneratorVoltageC": "负载2/发电机电压C",
  "65323.real_time.load2GeneratorCurrentA": "负载2/发电机电流A",
  "65323.real_time.load2GeneratorCurrentB": "负载2/发电机电流B",
  "65323.real_time.load2GeneratorCurrentC": "负载2/发电机电流C",
  "65323.real_time.load2GeneratorFrequency": "负载2/发电机频率",
  "65323.real_time.load2GeneratorActivePower": "负载2/发电机总有功功率",
  "65323.real_time.load2GeneratorAPhaseActivePower": "负载2/发电机A相有功功率",
  "65323.real_time.load2GeneratorBPhaseActivePower": "负载2/发电机B相有功功率",
  "65323.real_time.load2GeneratorCPhaseActivePower": "负载2/发电机C相有功功率",
  "65323.real_time.load2GeneratorReactivePower": "负载2/发电机无功功率",
  "65323.real_time.load2GeneratorTodayConsumeEnergy": "负载2/发电机当日用电量",
  "65323.real_time.load2GeneratorTotalConsumeEnergy": "负载2/发电机累计用电量",
  "65323.real_time.load2GeneratorTodayGenerateEnergy": "负载2/发电机当日发电量",
  "65323.real_time.load2GeneratorTotalGenerateEnergy": "负载2/发电机累计发电量",
  "65323.control_param.deviceStatus": "采集器状态",
  "65323.control_param.lastUpdateTime": "该时区最后更新时间",
  "65323.control_param.lastUpdateTimeStamp": "最后更新时间戳",
  "65323.control_param.createTime": "系统创建时间",
  "65323.control_param.updateTime": "系统更新时间",
  "65323.control_param.updateTimeStamp": "更新时间戳",
  "65323.control_param.deviceType": "设备类型",
  "65323.control_param.himiVersion": "HIMI软件版本",
  "65323.control_param.dspVersion": "DSP软件版本",
  "65323.control_param.protocolVersion": "协议版本",
  "65323.control_param.deviceAddress": "设备地址",
  "65323.control_param.invTime": "逆变器时间",
  "65323.control_param.deviceRestart": "设备重启",
  "65323.control_param.factoryReset": "恢复出厂设置",
  "65323.control_param.defaultWorkMode": "默认工作模式",
  "65323.control_param.startUpEnable": "开机使能",
  "65323.control_param.protectionSwitch": "保护开关",
  "65323.control_param.faultClear": "故障清除",
  "65323.control_param.drmFunctionSwitch": "DRM功能开关",
  "65323.control_param.externalSignalEnable": "外部信号使能",
  "65323.control_param.localCommandEnable": "本地命令使能",
  "65323.control_param.commCommunicationTimeout": "Comm口通信超时时间",
  "65323.control_param.gridStandard": "电网标准",
  "65323.control_param.powerFactorSetting": "功率因数设置",
  "65323.control_param.activePowerLimit": "有功功率限值",
  "65323.control_param.reactivePowerLimit": "无功功率限值",
  "65323.control_param.dcComponentSetting": "直流分量设置",
  "65323.control_param.returnFlowLimitEnable": "回流限制使能",
  "65323.control_param.returnFlowPowerLimit": "回流功率限值",
  "65323.control_param.reactiveControlMode": "无功控制模式",
  "65323.control_param.ratedGridVoltage": "额定电网电压",
  "65323.control_param.ratedGridFrequency": "额定电网频率",
  "65323.control_param.faultReconnectTime": "故障重连时间",
  "65323.control_param.gridRecoveryVoltageUpperLimit": "电网恢复电压上限",
  "65323.control_param.gridRecoveryVoltageLowerLimit": "电网恢复电压下限",
  "65323.control_param.gridRecoveryFrequencyUpperLimit": "电网恢复频率上限",
  "65323.control_param.gridRecoveryFrequencyLowerLimit": "电网恢复频率下限",
  "65323.control_param.gridFaultVoltageU1": "电网故障电压U>>",
  "65323.control_param.gridFaultVoltageU2": "电网故障电压U>",
  "65323.control_param.gridFaultVoltageU3": "电网故障电压U<",
  "65323.control_param.gridFaultVoltageU4": "电网故障电压U<<",
  "65323.control_param.gridFaultFrequencyF1": "电网故障频率f>>",
  "65323.control_param.gridFaultFrequencyF2": "电网故障频率f>",
  "65323.control_param.gridFaultFrequencyF3": "电网故障频率f<",
  "65323.control_param.gridFaultFrequencyF4": "电网故障频率f<<",
  "65323.control_param.voltageProtectionTimeU1": "电压保护时间U>>",
  "65323.control_param.voltageProtectionTimeU2": "电压保护时间U>",
  "65323.control_param.voltageProtectionTimeU3": "电压保护时间U<",
  "65323.control_param.voltageProtectionTimeU4": "电压保护时间U<<",
  "65323.control_param.frequencyProtectionTimeF1": "频率保护时间f>>",
  "65323.control_param.frequencyProtectionTimeF2": "频率保护时间f>",
  "65323.control_param.frequencyProtectionTimeF3": "频率保护时间f<",
  "65323.control_param.frequencyProtectionTimeF4": "频率保护时间f<<",
  "65323.control_param.returnFlowPowerLimitPercentage": "回流功率限值百分比",
  "65323.control_param.overFrequencyDeratingRecoveryThreshold": "过频降额恢复阈值",
  "65323.control_param.overFrequencyDeratingStartDelay": "过频降额启动延时",
  "65323.control_param.overFrequencyDeratingRecoveryDelay": "过频降额恢复延时",
  "65323.control_param.pModeEnable": "P(U)模式使能",
  "65323.control_param.pModeActiveChangeRateTau": "P(U)有功变化率(tau)",
  "65323.control_param.pModeStartVoltageRatio": "P(U)模式启动电压比例",
  "65323.control_param.pModePowerChangeSlope": "P(U)功率变化斜率",
  "65323.control_param.pModeSoftStartRate": "有功软起动速率",
  "65323.control_param.reactiveChangeRateTau": "无功变化率(tau)",
  "65323.control_param.minPowerFactor": "最小功率因数",
  "65323.control_param.maxReactivePowerRatio": "最大无功功率比例",
  "65323.control_param.minReactivePowerRatio": "最小无功功率比例",
  "65323.control_param.qModeVoltageDeadZone": "Q(U)模式电压死区",
  "65323.control_param.qUModeOverElectricalReactiveSlope": "Q(U)过励磁无功斜率",
  "65323.control_param.qUModeUnderElectricalReactiveSlope": "Q(U)欠励磁无功斜率",
  "65323.control_param.qModeStartPowerRatio": "Q(U)模式启动功率比例",
  "65323.control_param.qModeExitPowerRatio": "Q(U)模式退出功率比例",
  "65323.control_param.qModeMinMiddlePowerRatio": "Q(P)模式最小中段功率比例",
  "65323.control_param.qModeMaxMiddlePowerRatio": "Q(P)模式最大中段功率比例",
  "65323.control_param.qPModeOverElectricalReactiveSlope": "Q(P)过励磁无功斜率",
  "65323.control_param.qPModeUnderElectricalReactiveSlope": "Q(P)欠励磁无功斜率",
  "65323.control_param.qModeMiddleReactiveSlope": "Q(P)中段无功斜率",
  "65323.control_param.qModeStartVoltageRatio": "Q(P)模式启动电压比例",
  "65323.control_param.qModeExitVoltageRatio": "Q(P)模式退出电压比例",
  "65323.control_param.gridFaultCrossingTriggerUpperLimit": "电网故障穿越触发上限",
  "65323.control_param.gridFaultCrossingTriggerLowerLimit": "电网故障穿越触发下限",
  "65323.control_param.clsEnable": "CLS开关",
  "65323.control_param.clsMaxOutputCurrent": "CLS最大输出电流",
  "65323.control_param.clsMaxInputCurrent": "CLS最大输入电流",
  "65323.control_param.clsMaxResponseTime": "CLS最大响应时间",
  "65323.control_param.clsReset": "CLS复位",
  "65323.control_param.ctType": "电表类型",
  "65323.control_param.backupPowerSwitch": "后备电源开关",
  "65323.control_param.pvSettingEnable": "光伏设置使能",
  "65323.control_param.pvDisconnectVoltage": "光伏断开电压",
  "65323.control_param.pvReconnectVoltage": "光伏重连电压",
  "65323.control_param.batterySettingEnable": "电池设置使能",
  "65323.control_param.batteryDischargeTimeSlot1Start": "电池放电时段1起始",
  "65323.control_param.batteryDischargeTimeSlot1End": "电池放电时段1结束",
  "65323.control_param.batteryDischargeTimeSlot2Start": "电池放电时段2起始",
  "65323.control_param.batteryDischargeTimeSlot2End": "电池放电时段2结束",
  "65323.control_param.batteryChargeTimeSlot1Start": "电池充电时段1起始",
  "65323.control_param.batteryChargeTimeSlot1End": "电池充电时段1结束",
  "65323.control_param.batteryChargeTimeSlot2Start": "电池充电时段2起始",
  "65323.control_param.batteryChargeTimeSlot2End": "电池充电时段2结束",
  "65323.control_param.offGridDischargeMinSOC": "离网放电最小SOC",
  "65323.control_param.offGridDischargeMinBatteryVoltage": "离网放电最小电池电压",
  "65323.control_param.autoPowerSupplementaryEnable": "自动补电使能",
  "65323.control_param.generatorMode": "发电机模式",
  "65323.control_param.generatorMaxInputPower": "发电机最大输入功率",
  "65323.control_param.generatorRatedVoltage": "发电机额定电压",
  "65323.control_param.generatorRatedFrequency": "发电机额定频率",
  "65323.control_param.spiAutoTestInitThreshold": "SPI自动测试初始阈值",
  "65323.control_param.spiAutoTestSetTimeF4": "SPI自动测试设置时间",
  "65323.fault.2026_M_0": "电网过压A/AB",
  "65323.fault.2026_M_1": "电网欠压A/AB",
  "65323.real_time.time.desc": "数据采集时间戳",
  "65323.control_param.deviceSn.desc": "设备序列号",
  "65323.control_param.collectorSn.desc": "所属采集器",
  "65323.real_time.title2030M17.desc": "设备标题信息字段M17",
  "65323.real_time.title2026M1.desc": "设备标题信息字段M1",
  "65323.real_time.runStatus.desc": "逆变器运行状态",
  "65323.real_time.faultStatus1.desc": "逆变器故障状态1",
  "65323.real_time.faultStatus2.desc": "逆变器故障状态2",
  "65323.real_time.warningStatus.desc": "逆变器告警状态",
  "65323.real_time.relayStatus.desc": "逆变器继电器状态",
  "65323.real_time.inverterTemperature.desc": "逆变器内部温度",
  "65323.real_time.dcTemperature.desc": "直流侧温度",
  "65323.real_time.drmStatus.desc": "DRM功能状态",
  "65323.real_time.mpptTemperature.desc": "MPPT温度",
  "65323.real_time.gridVoltageAB.desc": "电网AB线电压监测值",
  "65323.real_time.gridVoltageBC.desc": "电网BC线电压监测值",
  "65323.real_time.gridVoltageCA.desc": "电网CA线电压监测值",
  "65323.real_time.gridCurrentA.desc": "电网A相电流监测值",
  "65323.real_time.gridCurrentB.desc": "电网B相电流监测值",
  "65323.real_time.gridCurrentC.desc": "电网C相电流监测值",
  "65323.real_time.gridFrequencyA.desc": "电网A相频率监测值",
  "65323.real_time.gridFrequencyB.desc": "电网B相频率监测值",
  "65323.real_time.gridFrequencyC.desc": "电网C相频率监测值",
  "65323.real_time.gridActivePower.desc": "电网总有功功率监测值",
  "65323.real_time.gridAPhaseActivePower.desc": "电网A相有功功率监测值",
  "65323.real_time.gridBPhaseActivePower.desc": "电网B相有功功率监测值",
  "65323.real_time.gridCPhaseActivePower.desc": "电网C相有功功率监测值",
  "65323.real_time.gridReactivePower.desc": "电网总无功功率监测值",
  "65323.real_time.gridApparentPower.desc": "电网视在功率监测值",
  "65323.real_time.powerFactor.desc": "电网功率因数监测值",
  "65323.real_time.dcComponentA.desc": "A相直流分量监测值",
  "65323.real_time.dcComponentB.desc": "B相直流分量监测值",
  "65323.real_time.dcComponentC.desc": "C相直流分量监测值",
  "65323.real_time.phaseOrder.desc": "电网相序状态",
  "65323.real_time.leakageCurrent.desc": "漏电流监测值",
  "65323.real_time.clsStatus.desc": "CLS功能状态",
  "65323.real_time.clsLockNum.desc": "CLS锁定次数统计",
  "65323.real_time.clsLockTime.desc": "CLS锁定时间",
  "65323.real_time.meterReturnPortVoltageA.desc": "电表回流端口A相的电压监测值",
  "65323.real_time.meterReturnPortVoltageB.desc": "电表回流端口B相的电压监测值",
  "65323.real_time.meterReturnPortVoltageC.desc": "电表回流端口C相的电压监测值",
  "65323.real_time.meterReturnPortCurrentA.desc": "电表回流端口A相的电流监测值",
  "65323.real_time.meterReturnPortCurrentB.desc": "电表回流端口B相的电流监测值",
  "65323.real_time.meterReturnPortCurrentC.desc": "电表回流端口C相的电流监测值",
  "65323.real_time.meterReturnPortActivePower.desc": "电表回流端口总有功功率监测值",
  "65323.real_time.meterReturnPortReactivePower.desc": "电表回流端口总无功功率监测值",
  "65323.real_time.meterReturnPortApparentPower.desc": "电表回流端口视在功率监测值",
  "65323.real_time.meterReturnPortPowerFactor.desc": "电表回流端口功率因数监测值",
  "65323.real_time.meterEnergyMetered.desc": "电表总计量电量统计值",
  "65323.real_time.meterImportEnergy.desc": "电表总输入电量统计值",
  "65323.real_time.meterExportEnergy.desc": "电表总输出电量统计值",
  "65323.real_time.meterAImportEnergy.desc": "电表A相输入电量统计值",
  "65323.real_time.meterAExportEnergy.desc": "电表A相输出电量统计值",
  "65323.real_time.meterBImportEnergy.desc": "电表B相输入电量统计值",
  "65323.real_time.meterBExportEnergy.desc": "电表B相输出电量统计值",
  "65323.real_time.meterCImportEnergy.desc": "电表C相输入电量统计值",
  "65323.real_time.meterCExportEnergy.desc": "电表C相输出电量统计值",
  "65323.real_time.loadMeterVoltageA.desc": "负载电表A相的电压监测值",
  "65323.real_time.loadMeterVoltageB.desc": "负载电表B相的电压监测值",
  "65323.real_time.loadMeterVoltageC.desc": "负载电表C相的电压监测值",
  "65323.real_time.loadMeterCurrentA.desc": "负载电表A相的电流监测值",
  "65323.real_time.loadMeterCurrentB.desc": "负载电表B相的电流监测值",
  "65323.real_time.loadMeterCurrentC.desc": "负载电表C相的电流监测值",
  "65323.real_time.loadMeterActivePower.desc": "负载电表总有功功率监测值",
  "65323.real_time.loadMeterReactivePower.desc": "负载电表总无功功率监测值",
  "65323.real_time.loadMeterApparentPower.desc": "负载电表视在功率监测值",
  "65323.real_time.loadMeterPowerFactor.desc": "负载电表功率因数监测值",
  "65323.real_time.loadMeterEnergyMetered.desc": "负载电表总计量电量统计值",
  "65323.real_time.pvVoltage1.desc": "光伏组串1电压监测值",
  "65323.real_time.pvVoltage2.desc": "光伏组串2电压监测值",
  "65323.real_time.pvCurrent1.desc": "光伏组串1电流监测值",
  "65323.real_time.pvCurrent2.desc": "光伏组串2电流监测值",
  "65323.real_time.pvPower1.desc": "光伏组串1功率监测值",
  "65323.real_time.pvPower2.desc": "光伏组串2功率监测值",
  "65323.real_time.pvTotalPower.desc": "光伏总功率监测值",
  "65323.real_time.insulationImpedancePositive.desc": "正母线绝缘阻抗监测值",
  "65323.real_time.insulationImpedanceNegative.desc": "负母线绝缘阻抗监测值",
  "65323.real_time.batteryVoltage.desc": "电池组电压监测值",
  "65323.real_time.batteryCurrent.desc": "电池组电流监测值",
  "65323.real_time.batteryPower.desc": "电池组功率监测值",
  "65323.real_time.batterySoc.desc": "电池荷电状态",
  "65323.real_time.batterySoH.desc": "电池健康状态",
  "65323.real_time.bmsBatteryVoltage.desc": "BMS电池组电压监测值",
  "65323.real_time.bmsBatteryCurrent.desc": "BMS电池组电流监测值",
  "65323.real_time.bmsBatterySoc.desc": "BMS电池荷电状态",
  "65323.real_time.bmsBatterySoH.desc": "BMS电池健康状态",
  "65323.real_time.bmsBatteryTemperature.desc": "BMS电池温度监测值",
  "65323.real_time.bmsBatteryStatus.desc": "BMS电池状态",
  "65323.real_time.generatorVoltageAB.desc": "发电机AB线电压监测值",
  "65323.real_time.generatorVoltageBC.desc": "发电机BC线电压监测值",
  "65323.real_time.generatorVoltageCA.desc": "发电机CA线电压监测值",
  "65323.real_time.generatorCurrentA.desc": "发电机A相电流监测值",
  "65323.real_time.generatorCurrentB.desc": "发电机B相电流监测值",
  "65323.real_time.generatorCurrentC.desc": "发电机C相电流监测值",
  "65323.real_time.generatorFrequencyA.desc": "发电机A相频率监测值",
  "65323.real_time.generatorFrequencyB.desc": "发电机B相频率监测值",
  "65323.real_time.generatorFrequencyC.desc": "发电机C相频率监测值",
  "65323.real_time.generatorActivePower.desc": "发电机总有功功率监测值",
  "65323.real_time.generatorReactivePower.desc": "发电机总无功功率监测值",
  "65323.real_time.generatorApparentPower.desc": "发电机视在功率监测值",
  "65323.real_time.generatorPowerFactor.desc": "发电机功率因数监测值",
  "65323.real_time.generatorRelayStatus.desc": "发电机继电器状态",
  "65323.real_time.spiTestResult.desc": "SPI自动测试结果",
  "65323.real_time.spiTestTime.desc": "SPI自动测试时间",
  "65323.real_time.pvStringPower1.desc": "光伏组串1功率监测值",
  "65323.real_time.pvStringPower2.desc": "光伏组串2功率监测值",
  "65323.real_time.dcBusVoltage.desc": "直流母线电压监测值",
  "65323.real_time.pvPowerGeneratedToday.desc": "今日光伏发电量统计值",
  "65323.real_time.pvPowerGeneratedTotal.desc": "总光伏发电量统计值",
  "65323.real_time.pvVoltage3.desc": "光伏组串3的电压监测值",
  "65323.real_time.pvVoltage4.desc": "光伏组串4的电压监测值",
  "65323.real_time.pvVoltage5.desc": "光伏组串5的电压监测值",
  "65323.real_time.pvVoltage6.desc": "光伏组串6的电压监测值",
  "65323.real_time.pvCurrent3.desc": "光伏组串3的电流监测值",
  "65323.real_time.pvCurrent4.desc": "光伏组串4的电流监测值",
  "65323.real_time.pvCurrent5.desc": "光伏组串5的电流监测值",
  "65323.real_time.pvCurrent6.desc": "光伏组串6的电流监测值",
  "65323.real_time.pvPower3.desc": "光伏组串3的功率监测值",
  "65323.real_time.pvPower4.desc": "光伏组串4的功率监测值",
  "65323.real_time.pvPower5.desc": "光伏组串5的功率监测值",
  "65323.real_time.pvPower6.desc": "光伏组串6的功率监测值",
  "65323.real_time.pvMonthlyEnergy.desc": "光伏当月发电量",
  "65323.real_time.pvAnnualEnergy.desc": "光伏当年发电量",
  "65323.real_time.batteryStatus.desc": "电池运行状态标识",
  "65323.real_time.batChargeVoltage.desc": "电池充电电压监测值",
  "65323.real_time.bmsTemperature.desc": "BMS电池温度监测值",
  "65323.real_time.bmsChargeCurrentLimit.desc": "BMS充电电流限制值",
  "65323.real_time.bmsDischargeCurrentLimit.desc": "BMS放电电流限制值",
  "65323.real_time.batTodayChargeEnergy.desc": "电池今日充电量统计值",
  "65323.real_time.batTodayDischargeEnergy.desc": "电池今日放电量统计值",
  "65323.real_time.batTotalChargeEnergy.desc": "电池总充电量统计值",
  "65323.real_time.batTotalDischargeEnergy.desc": "电池总放电量统计值",
  "65323.real_time.bmsMaxVoltage.desc": "BMS电池组最大电压监测值",
  "65323.real_time.bmsMinVoltage.desc": "BMS电池组最小电压监测值",
  "65323.real_time.batFaultFlag.desc": "电池故障标志位",
  "65323.real_time.batAlarmFlag.desc": "电池告警标志位",
  "65323.real_time.bmsRequestFlag.desc": "BMS控制请求标志位",
  "65323.real_time.positiveElectrodeInsulationImpedance1.desc": "电池正极对地绝缘阻抗监测值1",
  "65323.real_time.positiveElectrodeInsulationImpedance2.desc": "电池正极对地绝缘阻抗监测值2",
  "65323.real_time.positiveElectrodeInsulationImpedance3.desc": "电池正极对地绝缘阻抗监测值3",
  "65323.real_time.positiveElectrodeInsulationImpedance4.desc": "电池正极对地绝缘阻抗监测值4",
  "65323.real_time.positiveElectrodeInsulationImpedance5.desc": "电池正极对地绝缘阻抗监测值5",
  "65323.real_time.positiveElectrodeInsulationImpedance6.desc": "电池正极对地绝缘阻抗监测值6",
  "65323.real_time.loadFrequency.desc": "负载的电网频率监测值",
  "65323.real_time.loadAPhaseActivePower.desc": "负载A相单独的有功功率监测值",
  "65323.real_time.loadBPhaseActivePower.desc": "负载B相单独的有功功率监测值",
  "65323.real_time.loadCPhaseActivePower.desc": "负载C相单独的有功功率监测值",
  "65323.real_time.loadTodayConsumeEnergy.desc": "负载当日的累计电能消耗值",
  "65323.real_time.loadTotalConsumeEnergy.desc": "负载全生命周期的累计电能消耗值",
  "65323.real_time.ctStatus.desc": "电表运行状态标识",
  "65323.real_time.ctVoltageA.desc": "电流互感器A相电压监测值",
  "65323.real_time.ctVoltageB.desc": "电流互感器B相电压监测值",
  "65323.real_time.ctVoltageC.desc": "电流互感器C相电压监测值",
  "65323.real_time.ctCurrentA.desc": "电流互感器A相电流监测值",
  "65323.real_time.ctCurrentB.desc": "电流互感器B相电流监测值",
  "65323.real_time.ctCurrentC.desc": "电流互感器C相电流监测值",
  "65323.real_time.ctTotalActivePower.desc": "电流互感器A、B、C三相总有功功率监测值",
  "65323.real_time.ctAPhaseActivePower.desc": "电流互感器A相单独的有功功率监测值",
  "65323.real_time.ctBPhaseActivePower.desc": "电流互感器B相单独的有功功率监测值",
  "65323.real_time.ctCPhaseActivePower.desc": "电流互感器C相单独的有功功率监测值",
  "65323.real_time.ctReactivePower.desc": "电流互感器的无功功率监测值",
  "65323.real_time.ctApparentPower.desc": "电流互感器的视在功率监测值",
  "65323.real_time.ctFrequency.desc": "电流互感器的电网频率监测值",
  "65323.real_time.ctPowerFactor.desc": "电流互感器的功率因数监测值",
  "65323.real_time.spiAutoTestEndFlag.desc": "SPI自动测试结束标志位",
  "65323.real_time.spiAutoTestThresholdAPhaseU1.desc": "SPI自动测试阈值A相U>>",
  "65323.real_time.spiAutoTestThresholdAPhaseU2.desc": "SPI自动测试阈值A相U>10min",
  "65323.real_time.spiAutoTestThresholdAPhaseU3.desc": "SPI自动测试阈值A相U<",
  "65323.real_time.spiAutoTestThresholdAPhaseU4.desc": "SPI自动测试阈值A相U<<",
  "65323.real_time.spiAutoTestThresholdBPhaseU1.desc": "SPI自动测试阈值B相U>>",
  "65323.real_time.spiAutoTestThresholdBPhaseU2.desc": "SPI自动测试阈值B相U>10min",
  "65323.real_time.spiAutoTestThresholdBPhaseU3.desc": "SPI自动测试阈值B相U<",
  "65323.real_time.spiAutoTestThresholdBPhaseU4.desc": "SPI自动测试阈值B相U<<",
  "65323.real_time.spiAutoTestThresholdCPhaseU1.desc": "SPI自动测试阈值C相U>>",
  "65323.real_time.spiAutoTestThresholdCPhaseU2.desc": "SPI自动测试阈值C相U>10min",
  "65323.real_time.spiAutoTestThresholdCPhaseU3.desc": "SPI自动测试阈值C相U<",
  "65323.real_time.spiAutoTestThresholdCPhaseU4.desc": "SPI自动测试阈值C相U<<",
  "65323.real_time.spiAutoTestThresholdF1.desc": "SPI自动测试阈值F>>",
  "65323.real_time.spiAutoTestThresholdF2.desc": "SPI自动测试阈值F>",
  "65323.real_time.spiAutoTestThresholdF3.desc": "SPI自动测试阈值F<",
  "65323.real_time.spiAutoTestThresholdF4.desc": "SPI自动测试阈值F<<",
  "65323.real_time.spiAutoTestTimeAPhaseU1.desc": "SPI自动测试时间A相U>>",
  "65323.real_time.spiAutoTestTimeAPhaseU2.desc": "SPI自动测试时间A相U>10min",
  "65323.real_time.spiAutoTestTimeAPhaseU3.desc": "SPI自动测试时间A相U<",
  "65323.real_time.spiAutoTestTimeAPhaseU4.desc": "SPI自动测试时间A相U<<",
  "65323.real_time.spiAutoTestTimeBPhaseU1.desc": "SPI自动测试时间B相U>>",
  "65323.real_time.spiAutoTestTimeBPhaseU2.desc": "SPI自动测试时间B相U>10min",
  "65323.real_time.spiAutoTestTimeBPhaseU3.desc": "SPI自动测试时间B相U<",
  "65323.real_time.spiAutoTestTimeBPhaseU4.desc": "SPI自动测试时间B相U<<",
  "65323.real_time.spiAutoTestTimeCPhaseU1.desc": "SPI自动测试时间C相U>>",
  "65323.real_time.spiAutoTestTimeCPhaseU2.desc": "SPI自动测试时间C相U>10min",
  "65323.real_time.spiAutoTestTimeCPhaseU3.desc": "SPI自动测试时间C相U<",
  "65323.real_time.spiAutoTestTimeCPhaseU4.desc": "SPI自动测试时间C相U<<",
  "65323.real_time.spiAutoTestTimeF1.desc": "SPI自动测试时间F>>",
  "65323.real_time.spiAutoTestTimeF2.desc": "SPI自动测试时间F>",
  "65323.real_time.spiAutoTestTimeF3.desc": "SPI自动测试时间F<",
  "65323.real_time.spiAutoTestTimeF4.desc": "SPI自动测试时间F<<",
  "65323.real_time.load2GeneratorVoltageA.desc": "负载2/发电机电压A监测值",
  "65323.real_time.load2GeneratorVoltageB.desc": "负载2/发电机电压B监测值",
  "65323.real_time.load2GeneratorVoltageC.desc": "负载2/发电机电压C监测值",
  "65323.real_time.load2GeneratorCurrentA.desc": "负载2/发电机电流A监测值",
  "65323.real_time.load2GeneratorCurrentB.desc": "负载2/发电机电流B监测值",
  "65323.real_time.load2GeneratorCurrentC.desc": "负载2/发电机电流C监测值",
  "65323.real_time.load2GeneratorFrequency.desc": "负载2/发电机频率监测值",
  "65323.real_time.load2GeneratorActivePower.desc": "负载2/发电机总有功功率监测值",
  "65323.real_time.load2GeneratorAPhaseActivePower.desc": "负载2/发电机A相有功功率监测值",
  "65323.real_time.load2GeneratorBPhaseActivePower.desc": "负载2/发电机B相有功功率监测值",
  "65323.real_time.load2GeneratorCPhaseActivePower.desc": "负载2/发电机C相有功功率监测值",
  "65323.real_time.load2GeneratorReactivePower.desc": "负载2/发电机无功功率监测值",
  "65323.real_time.load2GeneratorTodayConsumeEnergy.desc": "负载2/发电机当日用电量",
  "65323.real_time.load2GeneratorTotalConsumeEnergy.desc": "负载2/发电机累计用电量",
  "65323.real_time.load2GeneratorTodayGenerateEnergy.desc": "负载2/发电机当日发电量",
  "65323.real_time.load2GeneratorTotalGenerateEnergy.desc": "负载2/发电机累计发电量",
  "65323.control_param.deviceStatus.desc": "采集器状态 0:离线；1：在线",
  "65323.control_param.lastUpdateTime.desc": "该时区最后更新时间",
  "65323.control_param.lastUpdateTimeStamp.desc": "最后更新时间戳",
  "65323.control_param.createTime.desc": "系统创建时间",
  "65323.control_param.updateTime.desc": "系统更新时间",
  "65323.control_param.updateTimeStamp.desc": "更新时间戳",
  "65323.control_param.deviceType.desc": "设备类型",
  "65323.control_param.himiVersion.desc": "HIMI软件版本",
  "65323.control_param.dspVersion.desc": "DSP软件版本",
  "65323.control_param.protocolVersion.desc": "协议版本",
  "65323.control_param.deviceAddress.desc": "设备地址",
  "65323.control_param.invTime.desc": "逆变器时间",
  "65323.control_param.deviceRestart.desc": "设备重启",
  "65323.control_param.factoryReset.desc": "恢复出厂设置",
  "65323.control_param.defaultWorkMode.desc": "默认工作模式",
  "65323.control_param.startUpEnable.desc": "开机使能",
  "65323.control_param.protectionSwitch.desc": "保护开关",
  "65323.control_param.faultClear.desc": "故障清除",
  "65323.control_param.drmFunctionSwitch.desc": "DRM功能开关",
  "65323.control_param.externalSignalEnable.desc": "外部信号使能",
  "65323.control_param.localCommandEnable.desc": "本地命令使能",
  "65323.control_param.commCommunicationTimeout.desc": "Comm口通信超时时间",
  "65323.control_param.gridStandard.desc": "电网标准",
  "65323.control_param.powerFactorSetting.desc": "功率因数设置",
  "65323.control_param.activePowerLimit.desc": "有功功率限值",
  "65323.control_param.reactivePowerLimit.desc": "无功功率限值",
  "65323.control_param.dcComponentSetting.desc": "直流分量设置",
  "65323.control_param.returnFlowLimitEnable.desc": "回流限制使能",
  "65323.control_param.returnFlowPowerLimit.desc": "回流功率限值",
  "65323.control_param.reactiveControlMode.desc": "无功控制模式",
  "65323.control_param.ratedGridVoltage.desc": "额定电网电压",
  "65323.control_param.ratedGridFrequency.desc": "额定电网频率",
  "65323.control_param.faultReconnectTime.desc": "故障重连时间",
  "65323.control_param.gridRecoveryVoltageUpperLimit.desc": "电网恢复电压上限",
  "65323.control_param.gridRecoveryVoltageLowerLimit.desc": "电网恢复电压下限",
  "65323.control_param.gridRecoveryFrequencyUpperLimit.desc": "电网恢复频率上限",
  "65323.control_param.gridRecoveryFrequencyLowerLimit.desc": "电网恢复频率下限",
  "65323.control_param.gridFaultVoltageU1.desc": "电网故障电压U>>",
  "65323.control_param.gridFaultVoltageU2.desc": "电网故障电压U>",
  "65323.control_param.gridFaultVoltageU3.desc": "电网故障电压U<",
  "65323.control_param.gridFaultVoltageU4.desc": "电网故障电压U<<",
  "65323.control_param.gridFaultFrequencyF1.desc": "电网故障频率f>>",
  "65323.control_param.gridFaultFrequencyF2.desc": "电网故障频率f>",
  "65323.control_param.gridFaultFrequencyF3.desc": "电网故障频率f<",
  "65323.control_param.gridFaultFrequencyF4.desc": "电网故障频率f<<",
  "65323.control_param.voltageProtectionTimeU1.desc": "电压保护时间U>>",
  "65323.control_param.voltageProtectionTimeU2.desc": "电压保护时间U>",
  "65323.control_param.voltageProtectionTimeU3.desc": "电压保护时间U<",
  "65323.control_param.voltageProtectionTimeU4.desc": "电压保护时间U<<",
  "65323.control_param.frequencyProtectionTimeF1.desc": "频率保护时间f>>",
  "65323.control_param.frequencyProtectionTimeF2.desc": "频率保护时间f>",
  "65323.control_param.frequencyProtectionTimeF3.desc": "频率保护时间f<",
  "65323.control_param.frequencyProtectionTimeF4.desc": "频率保护时间f<<",
  "65323.control_param.returnFlowPowerLimitPercentage.desc": "回流功率限值百分比",
  "65323.control_param.overFrequencyDeratingRecoveryThreshold.desc": "过频降额恢复阈值",
  "65323.control_param.overFrequencyDeratingStartDelay.desc": "过频降额启动延时",
  "65323.control_param.overFrequencyDeratingRecoveryDelay.desc": "过频降额恢复延时",
  "65323.control_param.pModeEnable.desc": "P(U)模式使能",
  "65323.control_param.pModeActiveChangeRateTau.desc": "P(U)有功变化率(tau)",
  "65323.control_param.pModeStartVoltageRatio.desc": "P(U)模式启动电压比例",
  "65323.control_param.pModePowerChangeSlope.desc": "P(U)功率变化斜率",
  "65323.control_param.pModeSoftStartRate.desc": "有功软起动速率",
  "65323.control_param.reactiveChangeRateTau.desc": "无功变化率(tau)",
  "65323.control_param.minPowerFactor.desc": "最小功率因数",
  "65323.control_param.maxReactivePowerRatio.desc": "最大无功功率比例",
  "65323.control_param.minReactivePowerRatio.desc": "最小无功功率比例",
  "65323.control_param.qModeVoltageDeadZone.desc": "Q(U)模式电压死区",
  "65323.control_param.qUModeOverElectricalReactiveSlope.desc": "Q(U)过励磁无功斜率",
  "65323.control_param.qUModeUnderElectricalReactiveSlope.desc": "Q(U)欠励磁无功斜率",
  "65323.control_param.qModeStartPowerRatio.desc": "Q(U)模式启动功率比例",
  "65323.control_param.qModeExitPowerRatio.desc": "Q(U)模式退出功率比例",
  "65323.control_param.qModeMinMiddlePowerRatio.desc": "Q(P)模式最小中段功率比例",
  "65323.control_param.qModeMaxMiddlePowerRatio.desc": "Q(P)模式最大中段功率比例",
  "65323.control_param.qPModeOverElectricalReactiveSlope.desc": "Q(P)过励磁无功斜率",
  "65323.control_param.qPModeUnderElectricalReactiveSlope.desc": "Q(P)欠励磁无功斜率",
  "65323.control_param.qModeMiddleReactiveSlope.desc": "Q(P)中段无功斜率",
  "65323.control_param.qModeStartVoltageRatio.desc": "Q(P)模式启动电压比例",
  "65323.control_param.qModeExitVoltageRatio.desc": "Q(P)模式退出电压比例",
  "65323.control_param.gridFaultCrossingTriggerUpperLimit.desc": "电网故障穿越触发上限",
  "65323.control_param.gridFaultCrossingTriggerLowerLimit.desc": "电网故障穿越触发下限",
  "65323.control_param.clsEnable.desc": "CLS开关",
  "65323.control_param.clsMaxOutputCurrent.desc": "CLS最大输出电流",
  "65323.control_param.clsMaxInputCurrent.desc": "CLS最大输入电流",
  "65323.control_param.clsMaxResponseTime.desc": "CLS最大响应时间",
  "65323.control_param.clsReset.desc": "CLS复位",
  "65323.control_param.ctType.desc": "电表类型",
  "65323.control_param.backupPowerSwitch.desc": "后备电源开关",
  "65323.control_param.pvSettingEnable.desc": "光伏设置使能",
  "65323.control_param.pvDisconnectVoltage.desc": "光伏断开电压",
  "65323.control_param.pvReconnectVoltage.desc": "光伏重连电压",
  "65323.control_param.batterySettingEnable.desc": "电池设置使能",
  "65323.control_param.batteryDischargeTimeSlot1Start.desc": "电池放电时段1起始",
  "65323.control_param.batteryDischargeTimeSlot1End.desc": "电池放电时段1结束",
  "65323.control_param.batteryDischargeTimeSlot2Start.desc": "电池放电时段2起始",
  "65323.control_param.batteryDischargeTimeSlot2End.desc": "电池放电时段2结束",
  "65323.control_param.batteryChargeTimeSlot1Start.desc": "电池充电时段1起始",
  "65323.control_param.batteryChargeTimeSlot1End.desc": "电池充电时段1结束",
  "65323.control_param.batteryChargeTimeSlot2Start.desc": "电池充电时段2起始",
  "65323.control_param.batteryChargeTimeSlot2End.desc": "电池充电时段2结束",
  "65323.control_param.offGridDischargeMinSOC.desc": "离网放电最小SOC",
  "65323.control_param.offGridDischargeMinBatteryVoltage.desc": "离网放电最小电池电压",
  "65323.control_param.autoPowerSupplementaryEnable.desc": "自动补电使能",
  "65323.control_param.generatorMode.desc": "发电机模式",
  "65323.control_param.generatorMaxInputPower.desc": "发电机最大输入功率",
  "65323.control_param.generatorRatedVoltage.desc": "发电机额定电压",
  "65323.control_param.generatorRatedFrequency.desc": "发电机额定频率",
  "65323.control_param.spiAutoTestInitThreshold.desc": "SPI自动测试初始阈值",
  "65323.control_param.spiAutoTestSetTimeF4.desc": "SPI自动测试设置时间",
  "65323.control_param": "control_param",
  "65323.real_time": "real_time",
  "65323.fault": "告警",
  "50901..invAcFrequency.desc": "逆变器交流侧输出频率的说明。",
  "50901..phaseAOfInverterSideVoltage.desc": "逆变器交流侧A相电压的说明。",
  "50901..phaseBOfInverterSideVoltage.desc": "逆变器交流侧B相电压的说明。",
  "50901..phaseCOfInverterSideVoltage.desc": "逆变器交流侧C相电压的说明。",
  "50901..phaseAOfInverterSideCurrent.desc": "逆变器交流侧A相电流的说明。",
  "50901..phaseBOfInverterSideCurrent.desc": "逆变器交流侧B相电流的说明。",
  "50901..phaseCOfInverterSideCurrent.desc": "逆变器交流侧C相电流的说明。",
  "50901..inverCombinedActivePower.desc": "逆变器交流侧输出功率的说明。",
  "50901..phaseAOfInverterActivePower.desc": "逆变器交流侧A相功率的说明。",
  "50901..phaseBOfInverterActivePower.desc": "逆变器交流侧B相功率的说明。",
  "50901..phaseCOfInverterActivePower.desc": "逆变器交流侧C相功率的说明。",
  "50901..gridBuyPower.desc": "累计买电量的说明。",
  "50901..gridSellPower.desc": "累计卖电量的说明。",
  "50901..totalLoadEnergy.desc": "负载累计用电量的说明。",
  "50901..totalBatteryToLoadEnergy.desc": "累计-电池流向负载的能量的说明。",
  "50901..totalGridToLoadEnergy.desc": "累计-电网流向负载的能量的说明。",
  "50901..dailyImportEnergyFromGrid.desc": "日买电量的说明。",
  "50901..dailyExportEnergyToGrid.desc": "日卖电量的说明。",
  "50901..dailyBatteryToLoadEnergy.desc": "本日电池流向负载的能量的说明。",
  "50901..dailyGridToLoadEnergy.desc": "本日电网流向负载的能量的说明。",
  "50901..pvPowerdontuse.desc": "PV功率的说明。",
  "50901..数据分析_电网电压.tag": "电网电压",
  "50901..数据分析_电网电流.tag": "电网电流",
  "50901..数据分析_电网功率.tag": "电网功率",
  "60420.ctrl_param_shebeixinxishezhi.regulatoryManufacturers": "法规",
  "60420.ctrl_param_shebeixinxishezhi.regulatoryManufacturers.00": "CQC2013",
  "60420.ctrl_param_shebeixinxishezhi.regulatoryManufacturers.12": "泰国",
  "60420.ctrl_param_shebeixinxishezhi.regulatoryManufacturers.13": "曼谷",
  "60420.ctrl_param_shebeixinxishezhi.regulatoryManufacturers.06": "印度",
  "60420.ctrl_param_shebeixinxishezhi.regulatoryManufacturers.18": "德国",
  "60420.ctrl_param_shebeixinxishezhi.regulatoryManufacturers.19": "法国",
  "60420.ctrl_param_shebeixinxishezhi.regulatoryManufacturers.desc": "勿随意修改，需联系安装商并符合当地法规",
  "60420.ctrl_param_shebeixinxishezhi.regulatoryManufacturers.0": "CQC2013",
  "60420.ctrl_param_shebeixinxishezhi.regulatoryManufacturers.6": "印度",
  "60420.ctrl_param_shebeixinxishezhi.wideVoltageLevel.0": "默认值",
  "60420.ctrl_param_shebeixinxishezhi.wideVoltageLevel.1": "1.2倍",
  "60420.ctrl_param_shebeixinxishezhi.wideVoltageLevel.2": "1.25倍",
  "tt": "测试",
  "tt1": "测试",
  "tt2": "测",
  "tt3": "ce是",
  "test23": "测试实施",
  "50901.ctrl_WorkMode.economic.section3WeekRange11": "时段3第1组星期一",
  "50901.ctrl_WorkMode.economic.section3WeekRange12": "时段3第1组星期二",
  "50901.ctrl_WorkMode.economic.section3WeekRange13": "时段3第1组星期三",
  "50901.ctrl_WorkMode.economic.section3WeekRange14": "时段3第1组星期四",
  "50901.ctrl_WorkMode.economic.section3WeekRange15": "时段3第1组星期五",
  "50901.ctrl_WorkMode.economic.section3WeekRange16": "时段3第1组星期六",
  "50901.ctrl_WorkMode.economic.section3WeekRange17": "时段3第1组星期日",
  "50901.ctrl_WorkMode.economic.section4WeekRange11": "时段4第1组星期一",
  "50901.ctrl_WorkMode.economic.section4WeekRange12": "时段4第1组星期二",
  "50901.ctrl_WorkMode.economic.section4WeekRange13": "时段4第1组星期三",
  "50901.ctrl_WorkMode.economic.section4WeekRange14": "时段4第1组星期四",
  "50901.ctrl_WorkMode.economic.section4WeekRange15": "时段4第1组星期五",
  "50901.ctrl_WorkMode.economic.section4WeekRange16": "时段4第1组星期六",
  "50901.ctrl_WorkMode.economic.section4WeekRange17": "时段4第1组星期七",
  "50901..section3WeekRange1.0": "枚举值0的含义",
  "50901..section3WeekRange1.1": "枚举值2的含义",
  "50901.ctrl_WorkMode.economic.section3WeekRange11.0": "不使能",
  "50901.ctrl_WorkMode.economic.section3WeekRange11.1": "使能",
  "50901.ctrl_WorkMode.economic.section3WeekRange12.0": "不使能",
  "50901.ctrl_WorkMode.economic.section3WeekRange12.1": "使能",
  "50901.ctrl_WorkMode.economic.section3WeekRange13.0": "不使能",
  "50901.ctrl_WorkMode.economic.section3WeekRange13.1": "使能",
  "50901.ctrl_WorkMode.economic.section3WeekRange14.0": "不使能",
  "50901.ctrl_WorkMode.economic.section3WeekRange14.1": "使能",
  "50901.ctrl_WorkMode.economic.section3WeekRange15.0": "不使能",
  "50901.ctrl_WorkMode.economic.section3WeekRange15.1": "使能",
  "50901.ctrl_WorkMode.economic.section3WeekRange16.0": "不使能",
  "50901.ctrl_WorkMode.economic.section3WeekRange16.1": "使能",
  "50901.ctrl_WorkMode.economic.section3WeekRange17.0": "不使能",
  "50901.ctrl_WorkMode.economic.section3WeekRange17.1": "使能",
  "50901..section4WeekRange1.0": "枚举值0的含义",
  "50901..section4WeekRange1.1": "枚举值2的含义",
  "50901.ctrl_WorkMode.economic.section4WeekRange11.0": "不使能",
  "50901.ctrl_WorkMode.economic.section4WeekRange11.1": "使能",
  "50901.ctrl_WorkMode.economic.section4WeekRange12.0": "不使能",
  "50901.ctrl_WorkMode.economic.section4WeekRange12.1": "使能",
  "50901.ctrl_WorkMode.economic.section4WeekRange13.0": "不使能",
  "50901.ctrl_WorkMode.economic.section4WeekRange13.1": "使能",
  "50901.ctrl_WorkMode.economic.section4WeekRange14.0": "不使能",
  "50901.ctrl_WorkMode.economic.section4WeekRange14.1": "使能",
  "50901.ctrl_WorkMode.economic.section4WeekRange15.0": "不使能",
  "50901.ctrl_WorkMode.economic.section4WeekRange15.1": "使能",
  "50901.ctrl_WorkMode.economic.section4WeekRange16.0": "不使能",
  "50901.ctrl_WorkMode.economic.section4WeekRange16.1": "使能",
  "50901.ctrl_WorkMode.economic.section4WeekRange17.0": "不使能",
  "50901.ctrl_WorkMode.economic.section4WeekRange17.1": "使能",
  "50901..section3WeekRange1.desc": "section3周范围1的说明。",
  "50901..section4WeekRange1.desc": "section4周范围1的说明。",
  "60420.real_time.数据分析_组串电流.tag": "组串电流",
  "60420.real_time.数据分析_交流侧.tag": "交流侧",
  "60420.real_time.数据分析_直流侧.tag": "直流侧",
  "60420.real_time.数据分析_DSP调试信息.tag": "DSP调试信息",
  "60420.real_time.数据分析_ARM调试信息.tag": "ARM调试信息",
  "60420.real_time.数据分析_温度.tag": "温度",
  "60420.real_time.数据分析_直流侧PV功率.tag": "直流侧PV功率",
  "60420.real_time.数据分析_直流侧PV电压.tag": "直流侧PV电压",
  "60420.real_time.数据分析_基础信息.tag": "基础信息",
  "60420.real_time.数据分析_直流侧PV电流.tag": "直流侧PV电流",
  "50901.realtime.copy_controllerarmFirmwareVersion": "逆变器ARM版本",
  "50901..powerGeneration.desc": "PV累计发电量的说明。",
  "50901..pvMeterTotalYield.desc": "外部逆变器累计发电量的说明。",
  "50901..totalPvToBatteryEnegry.desc": "累计-光伏流向电池的能量的说明。",
  "50901..totalPvToLoadEnegry.desc": "累计-光伏流向负载的能量的说明。",
  "50901..totalPvToGridEnegry.desc": "累计-光伏流向电网的能量的说明。",
  "50901..generatorTotalYield.desc": "发电机累计发电量的说明。",
  "50901..pvDailyYield.desc": "PV日发电量的说明。",
  "50901..pvMeterDailyYield.desc": "外部逆变器日发电量的说明。",
  "50901..dailyPvToBatteryEnegry.desc": "今日光伏流向电池的能量的说明。",
  "50901..dailyPvToLoadEnegry.desc": "今日光伏流向负载的能量的说明。",
  "50901..dailyPvToGridEnegry.desc": "今日光伏流向电网的能量的说明。",
  "50901..loadEnergy.desc": "负载日用电量的说明。",
  "50901..generatorDailyYield.desc": "发电机日发电量的说明。",
  "50901..pv1RealTimePower.desc": "PV1实时功率的说明。",
  "50901..pv2RealTimePower.desc": "PV2实时功率的说明。",
  "50901..pv3RealTimePower.desc": "PV3实时功率的说明。",
  "50901..pv4RealTimePower.desc": "PV4实时功率的说明。",
  "50901..loadPowerWholeSystem.desc": "负载总功率（整个系统）的说明。",
  "50901..generatorPowerA.desc": "发电机A相功率的说明。",
  "50901..generatorPowerB.desc": "发电机B相功率的说明。",
  "50901..generatorPowerC.desc": "发电机C相功率的说明。",
  "50901..pvToBatteryPower.desc": "光伏流向电池的功率的说明。",
  "50901..pvToLoadPower.desc": "光伏流向负载的功率的说明。",
  "50901..pvToGridPower.desc": "光伏流向电网的功率的说明。",
  "50901..batteryToLoadPower.desc": "电池流向负载的功率的说明。",
  "50901..数据分析_混逆光伏功率.tag": "混逆光伏功率",
  "50901..数据分析_发电机功率.tag": "发电机功率",
  "50901.ctrl_Dry_Contact.Settings-Load_Control.loadControlMode.6": "热泵控制",
  "50901..hpTime2WeekRange1.0": "不使能",
  "50901..hpTime2WeekRange1.1": "enable",
  "50901..hpTime2WeekRange2.0": "disable",
  "50901..hpTime2WeekRange2.1": "enable",
  "50901..hpTime2WeekRange3.0": "disable",
  "50901..hpTime2WeekRange3.1": "使能",
  "50901..hpTime2WeekRange4.0": "不使能",
  "50901..hpTime2WeekRange4.1": "enable",
  "50901..hpTime2WeekRange5.0": "disable",
  "50901..hpTime2WeekRange5.1": "enable",
  "50901..hpTime2WeekRange6.0": "disable",
  "50901..hpTime2WeekRange6.1": "使能",
  "50901..hpTime2WeekRange7.0": "不使能",
  "50901..hpTime2WeekRange7.1": "enable",
  "50901..hpTime3WeekRange1.0": "disable",
  "50901..hpTime3WeekRange1.1": "enable",
  "50901..hpTime3WeekRange2.0": "disable",
  "50901..hpTime3WeekRange2.1": "使能",
  "50901..hpTime3WeekRange3.0": "不使能",
  "50901..hpTime3WeekRange3.1": "enable",
  "50901..hpTime3WeekRange4.0": "disable",
  "50901..hpTime3WeekRange4.1": "enable",
  "50901..hpTime3WeekRange5.0": "disable",
  "50901..hpTime3WeekRange5.1": "使能",
  "50901..hpTime3WeekRange6.0": "不使能",
  "50901..hpTime3WeekRange6.1": "enable",
  "50901..hpTime3WeekRange7.0": "disable",
  "50901..hpTime3WeekRange7.1": "enable",
  "50901..hpTime4WeekRange1.0": "disable",
  "50901..hpTime4WeekRange1.1": "使能",
  "50901..hpTime4WeekRange2.0": "不使能",
  "50901..hpTime4WeekRange2.1": "enable",
  "50901..hpTime4WeekRange3.0": "disable",
  "50901..hpTime4WeekRange3.1": "enable",
  "50901..hpTime4WeekRange4.0": "disable",
  "50901..hpTime4WeekRange4.1": "使能",
  "50901..hpTime4WeekRange5.0": "不使能",
  "50901..hpTime4WeekRange5.1": "enable",
  "50901..hpTime4WeekRange6.0": "disable",
  "50901..hpTime4WeekRange6.1": "enable",
  "50901..hpTime4WeekRange7.0": "disable",
  "50901..hpTime4WeekRange7.1": "使能",
  "50901..hpTime2StartMonth.desc": "读,写,上报",
  "50901..hpTime2StartDay.desc": "读,写,上报",
  "50901..hpTime2EndMonth.desc": "读,写,上报",
  "50901..hpTime2EndDay.desc": "读,写,上报",
  "50901..hpTime2WeekRange1.desc": "读,写,上报",
  "50901..hpTime2WeekRange2.desc": "读,写,上报",
  "50901..hpTime2WeekRange3.desc": "读,写,上报",
  "50901..hpTime2WeekRange4.desc": "读,写,上报",
  "50901..hpTime2WeekRange5.desc": "读,写,上报",
  "50901..hpTime2WeekRange6.desc": "读,写,上报",
  "50901..hpTime2WeekRange7.desc": "读,写,上报",
  "50901..hpTime3StartMonth.desc": "读,写,上报",
  "50901..hpTime3StartDay.desc": "读,写,上报",
  "50901..hpTime3EndMonth.desc": "读,写,上报",
  "50901..hpTime3EndDay.desc": "读,写,上报",
  "50901..hpTime3WeekRange1.desc": "读,写,上报",
  "50901..hpTime3WeekRange2.desc": "读,写,上报",
  "50901..hpTime3WeekRange3.desc": "读,写,上报",
  "50901..hpTime3WeekRange4.desc": "读,写,上报",
  "50901..hpTime3WeekRange5.desc": "读,写,上报",
  "50901..hpTime3WeekRange6.desc": "读,写,上报",
  "50901..hpTime3WeekRange7.desc": "读,写,上报",
  "50901..hpTime4StartMonth.desc": "读,写,上报",
  "50901..hpTime4StartDay.desc": "读,写,上报",
  "50901..hpTime4EndMonth.desc": "读,写,上报",
  "50901..hpTime4EndDay.desc": "读,写,上报",
  "50901..hpTime4WeekRange1.desc": "读,写,上报",
  "50901..hpTime4WeekRange2.desc": "读,写,上报",
  "50901..hpTime4WeekRange3.desc": "读,写,上报",
  "50901..hpTime4WeekRange4.desc": "读,写,上报",
  "50901..hpTime4WeekRange5.desc": "读,写,上报",
  "50901..hpTime4WeekRange6.desc": "读,写,上报",
  "50901..hpTime4WeekRange7.desc": "读,写,上报",
  "60420.real_time.armDebugInfo8": "ARM调试信息8",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact1Timer1": "干节点定时1时段1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact1Timer2": "干节点定时1时段2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact2Timer1": "干节点定时2时段1",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContact2Timer2": "干节点定时2时段2",
  "50901.ctrl_Dry_Contact.Settings-Manual_Control.dryContactTimer2": "干节点时段2",
  "50901.ctrl_Dry_Contact.Generator.dryContactGeCharge": "干节点发电机充电",
  "50901.ctrl_Dry_Contact.Generator.dryContactGeWait1": "干节点发电机待机1",
  "50901.ctrl_Dry_Contact.Generator.dryContactGeWait2": "干节点发电机待机2",
  "50901.ctrl_Dry_Contact.Generator.dryContactPracticeTime": "发电机练习模式启动时间",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer1": "模式节点时段1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Peak1": "模式节点时段1峰值1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Down1": "模式节点时段1低谷1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Peak2": "模式节点时段1峰值2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi1Down2": "模式节点时段1低谷2",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer2": "模式节点时段2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Peak1": "模式节点时段2峰值1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Down1": "模式节点时段2低谷1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Peak2": "模式节点时段2峰值2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi2Down2": "模式节点时段2低谷2",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer3": "模式节点时段3",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Peak1": "模式节点时段3峰值1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Down1": "模式节点时段3低谷1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Peak2": "模式节点时段3峰值2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi3Down2": "模式节点时段3低谷2",
  "50901.ctrl_WorkMode.economic.dryContactWoTimer4": "模式节点时段4",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Peak1": "模式节点时段4峰值1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Down1": "模式节点时段4低谷1",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Peak2": "模式节点时段4峰值2",
  "50901.ctrl_WorkMode.economic.dryContactWoTi4Down2": "模式节点时段4低谷2",
  "50901.ctrl_WorkMode.TOU.dryContactTOU1Chag": "分时节点时段1充电",
  "50901.ctrl_WorkMode.TOU.dryContactTOU1Out": "分时节点时段1放电",
  "50901.ctrl_WorkMode.TOU.dryContactTOU2Chag": "分时节点时段2充电",
  "50901.ctrl_WorkMode.TOU.dryContactTOU2Out": "分时节点时段2放电",
  "50901.ctrl_WorkMode.TOU.dryContactTOU3Chag": "分时节点时段3充电",
  "50901.ctrl_WorkMode.TOU.dryContactTOU3Out": "分时节点时段3放电",
  "50901.ctrl_WorkMode.TOU.dryContactTOU4Chag": "分时节点时段4充电",
  "50901.ctrl_WorkMode.TOU.dryContactTOU4Out": "分时节点时段4放电",
  "50901.ctrl_WorkMode.TOU.dryContactTOU5Chag": "分时节点时段5充电",
  "50901.ctrl_WorkMode.TOU.dryContactTOU5Out": "分时节点时段5放电",
  "50901.ctrl_WorkMode.TOU.dryContactTOU6Chag": "分时节点时段6充电",
  "50901.ctrl_WorkMode.TOU.dryContactTOU6Out": "分时节点时段6放电",
  "50901.ctrl_WorkMode.TOU.dryContactTOU7Chag": "分时节点时段7充电",
  "50901.ctrl_WorkMode.TOU.dryContactTOU7Out": "分时节点时段7放电",
  "50901.ctrl_WorkMode.TOU.dryContactTOU8Chag": "分时节点时段8充电",
  "50901.ctrl_WorkMode.TOU.dryContactTOU8Out": "分时节点时段8放电",
  "50901.ctrl_Config.ClockSetting.clockSet": "时钟设置时段",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump1": "热泵时间段1",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump2": "热泵时间段2",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump3": "热泵时间段3",
  "50901.ctrl_Dry_Contact.HeatPump.dryContactDump4": "热泵时间段4",
  "50610.device_info.inverterSn": "逆变器SN",
  "50610.device_info.model": "型号",
  "50610.real_time.pvPower": "光伏发电功率",
  "50610.real_time.powerGeneration": "发电量",
  "50610.real_time.workStatus": "运行状态",
  "50610.real_time.gridTotalFrequency": "总频率",
  "50610.real_time.inverterTemp": "逆变器温度",
  "50610.real_time.dcdcTemp": "DCDC温度",
  "50610.real_time.mpptTemp": "MPPT温度",
  "50610.warning.errorCode": "故障码",
  "50610.ctrl_group.Remote_onoff": "远程开关机",
  "50610.ctrl_group.uvpt1": "一级欠压保护点",
  "50610.ctrl_group.ovpt1": "一级过压保护点",
  "50610.ctrl_group.uvpt2": "二级欠压保护点",
  "50610.ctrl_group.ovpt2": "二级过压保护点",
  "50610.ctrl_group.maxGrv": "电网重连电压上限",
  "50610.ctrl_group.minGrv": "电网重连电压下限",
  "50610.ctrl_group.maxGrf": "电网重连频率上限",
  "50610.ctrl_group.minGrf": "电网重连频率下限",
  "50610.ctrl_group.ofpt1": "一级过频保护点",
  "50610.ctrl_group.ufpt1": "一级欠频保护点",
  "50610.ctrl_group.ofpt2": "二级过频保护点",
  "50610.ctrl_group.ufpt2": "二级欠频保护点",
  "50610.ctrl_group.pac": "有功功率限定值",
  "50610.ctrl_group.pacRatio": "有功功率百分比限值",
  "50610.ctrl_group.powerFactor": "功率因数限值",
  "50610.real_time.vpv1": "PV1输入电压",
  "50610.real_time.ipv1": "PV1输入电流",
  "50610.real_time.vpv2": "PV2输入电压",
  "50610.real_time.ipv2": "PV2输入电流",
  "50610.real_time.vpv3": "PV3输入电压",
  "50610.real_time.ipv3": "PV3输入电流",
  "50610.real_time.vpv4": "PV4输入电压",
  "50610.real_time.ipv4": "PV4输入电流",
  "50610.real_time.vpv5": "PV5输入电压",
  "50610.real_time.ipv5": "PV5输入电流",
  "50610.real_time.vpv6": "PV6输入电压",
  "50610.real_time.ipv6": "PV6输入电流",
  "50610.real_time.vpv7": "PV7输入电压",
  "50610.real_time.ipv7": "PV7输入电流",
  "50610.real_time.vpv8": "PV8输入电压",
  "50610.real_time.ipv8": "PV8输入电流",
  "50610.real_time.vpv9": "PV9输入电压",
  "50610.real_time.ipv9": "PV9输入电流",
  "50610.real_time.vpv10": "PV10输入电压",
  "50610.real_time.ipv10": "PV10输入电流",
  "50610.real_time.vpv11": "PV11输入电压",
  "50610.real_time.ipv11": "PV11输入电流",
  "50610.real_time.vpv12": "PV12输入电压",
  "50610.real_time.ipv12": "PV12输入电流",
  "50610.real_time.vacA": "A相电压",
  "50610.real_time.iacA": "A相电流",
  "50610.real_time.vacB": "B相电压",
  "50610.real_time.iacB": "B相电流",
  "50610.real_time.vacC": "C相电压",
  "50610.real_time.iacC": "C相电流",
  "50610.real_time.workStatus.0": "正常",
  "50610.real_time.workStatus.10": "故障",
  "50610.real_time.workStatus.20": "待机",
  "50610.warning.errorCode.214": "温度低",
  "50610.warning.errorCode.221": "MPPT启动电压超出范围",
  "50610.warning.errorCode.232": "设备型号不匹配",
  "50610.warning.errorCode.1": "电网电压异常",
  "50610.warning.errorCode.4": "电网频率异常",
  "50610.warning.errorCode.5": "无市电",
  "50610.warning.errorCode.6": "相序反接",
  "50610.warning.errorCode.7": "漏电流故障",
  "50610.warning.errorCode.8": "绝缘阻抗故障",
  "50610.warning.errorCode.9": "输出电流直流分量高",
  "50610.warning.errorCode.10": "NPE电压异常",
  "50610.warning.errorCode.21": "设备异常",
  "50610.warning.errorCode.23": "高温",
  "50610.warning.errorCode.24": "主副版本不一致",
  "50610.warning.errorCode.25": "通信异常",
  "50610.warning.errorCode.26": "通信异常",
  "50610.warning.errorCode.33": "BUS过压",
  "50610.warning.errorCode.39": "AFCI故障",
  "50610.warning.errorCode.40": "PV过压",
  "50610.warning.errorCode.41": "PV反接",
  "50610.warning.errorCode.42": "PV过配",
  "50610.warning.errorCode.44": "温度严重过高",
  "50610.warning.errorCode.65": "继电器故障",
  "50610.warning.errorCode.79": "内部风扇故障",
  "50610.warning.errorCode.80": "外部风扇故障",
  "50610.warning.errorCode.20000": "电网过压",
  "50610.warning.errorCode.20001": "电网欠压",
  "50610.warning.errorCode.20002": "电网不平衡",
  "50610.warning.errorCode.20003": "电网瞬时过压",
  "50610.warning.errorCode.20004": "十分钟电网过压",
  "50610.warning.errorCode.20005": "电网过频",
  "50610.warning.errorCode.20006": "电网欠频",
  "50610.warning.errorCode.20007": "无市电",
  "50610.warning.errorCode.20008": "电网高压穿越",
  "50610.warning.errorCode.20009": "电网低压穿越",
  "50610.warning.errorCode.20010": "孤岛",
  "50610.warning.errorCode.20011": "电网反序",
  "50610.warning.errorCode.20012": "电网缺相",
  "50610.warning.errorCode.20013": "NPE电压异常",
  "50610.warning.errorCode.20014": "输出电流不平衡",
  "50610.warning.errorCode.20015": "谐波电流超限",
  "50610.warning.errorCode.20016": "输出电流直流分量高",
  "50610.warning.errorCode.20017": "设备异常",
  "50610.warning.errorCode.20018": "PE漏接",
  "50610.warning.errorCode.20019": "火线接地",
  "50610.warning.errorCode.20020": "谐波电压超限",
  "50610.warning.errorCode.20021": "电网异常",
  "50610.warning.errorCode.20032": "设备异常",
  "50610.warning.errorCode.20033": "设备异常",
  "50610.warning.errorCode.20034": "设备异常",
  "50610.warning.errorCode.20035": "设备异常",
  "50610.warning.errorCode.20036": "设备异常",
  "50610.warning.errorCode.20037": "设备异常",
  "50610.warning.errorCode.20038": "设备异常",
  "50610.warning.errorCode.20039": "设备异常",
  "50610.warning.errorCode.20040": "设备异常",
  "50610.warning.errorCode.20041": "设备异常",
  "50610.warning.errorCode.20042": "交流电容电流异常",
  "50610.warning.errorCode.20064": "拉弧",
  "50610.warning.errorCode.20065": "漏电流故障",
  "50610.warning.errorCode.20066": "绝缘阻抗故障",
  "50610.warning.errorCode.20067": "PV对地电压高",
  "50610.warning.errorCode.20068": "软硬件版本不匹配",
  "50610.warning.errorCode.20069": "软件升级",
  "50610.warning.errorCode.20070": "通信异常",
  "50610.warning.errorCode.20071": "通信异常",
  "50610.warning.errorCode.20072": "通信异常",
  "50610.warning.errorCode.20073": "通信异常",
  "50610.warning.errorCode.20074": "设备异常",
  "50610.warning.errorCode.20075": "设备异常",
  "50610.warning.errorCode.20076": "继电器故障",
  "50610.warning.errorCode.20078": "设备异常",
  "50610.warning.errorCode.20079": "直流防雷器故障",
  "50610.warning.errorCode.20080": "交流防雷器故障",
  "50610.warning.errorCode.20081": "设备异常",
  "50610.warning.errorCode.20082": "设备异常",
  "50610.warning.errorCode.20083": "设备异常",
  "50610.warning.errorCode.20084": "设备异常",
  "50610.warning.errorCode.20085": "继电器故障",
  "50610.warning.errorCode.20086": "设备异常",
  "50610.warning.errorCode.20087": "设备异常",
  "50610.warning.errorCode.20088": "设备异常",
  "50610.warning.errorCode.20089": "设备异常",
  "50610.warning.errorCode.20090": "设备异常",
  "50610.warning.errorCode.20091": "设备异常",
  "50610.warning.errorCode.20092": "设备异常",
  "50610.warning.errorCode.20093": "设备异常",
  "50610.warning.errorCode.20096": "温度高",
  "50610.warning.errorCode.20097": "温度高",
  "50610.warning.errorCode.20098": "设备异常",
  "50610.warning.errorCode.20099": "设备异常",
  "50610.warning.errorCode.20100": "设备异常",
  "50610.warning.errorCode.20101": "设备异常",
  "50610.warning.errorCode.20102": "设备异常",
  "50610.warning.errorCode.20110": "严重过温",
  "50610.warning.errorCode.20111": "温度低",
  "50610.warning.errorCode.20112": "内部风扇故障",
  "50610.warning.errorCode.20113": "内部风扇故障",
  "50610.warning.errorCode.20114": "内部风扇故障",
  "50610.warning.errorCode.20115": "外部风扇故障",
  "50610.warning.errorCode.20116": "外部风扇故障",
  "50610.warning.errorCode.20117": "外部风扇故障",
  "50610.warning.errorCode.20118": "外部风扇故障",
  "50610.warning.errorCode.20119": "外部风扇故障",
  "50610.warning.errorCode.20120": "外部风扇故障",
  "50610.warning.errorCode.20121": "内部风扇故障",
  "50610.warning.errorCode.20122": "内部风扇故障",
  "50610.warning.errorCode.20123": "外部风扇故障",
  "50610.warning.errorCode.20124": "外部风扇故障",
  "50610.warning.errorCode.20125": "外部风扇故障",
  "50610.warning.errorCode.20126": "外部风扇故障",
  "50610.warning.errorCode.20127": "内部风扇故障",
  "50610.warning.errorCode.20128": "设备异常",
  "50610.warning.errorCode.20129": "设备异常",
  "50610.warning.errorCode.20130": "设备异常",
  "50610.warning.errorCode.20131": "设备异常",
  "50610.warning.errorCode.20132": "设备异常",
  "50610.warning.errorCode.20133": "设备异常",
  "50610.warning.errorCode.20134": "设备异常",
  "50610.warning.errorCode.20135": "设备异常",
  "50610.warning.errorCode.20136": "设备异常",
  "50610.warning.errorCode.20137": "设备异常",
  "50610.warning.errorCode.20138": "设备异常",
  "50610.warning.errorCode.20139": "设备异常",
  "50610.warning.errorCode.20160": "母线过压",
  "50610.warning.errorCode.20161": "母线过压",
  "50610.warning.errorCode.20162": "母线过压",
  "50610.warning.errorCode.20163": "母线过压",
  "50610.warning.errorCode.20164": "母线过压",
  "50610.warning.errorCode.20165": "母线过压",
  "50610.warning.errorCode.20166": "设备异常",
  "50610.warning.errorCode.20167": "设备异常",
  "50610.warning.errorCode.20168": "设备异常",
  "50610.warning.errorCode.20169": "母线过压",
  "50610.warning.errorCode.20176": "MPPT1输入过压",
  "50610.warning.errorCode.20177": "MPPT1输入过流",
  "50610.warning.errorCode.20178": "设备异常",
  "50610.warning.errorCode.20179": "设备异常",
  "50610.warning.errorCode.20180": "设备异常",
  "50610.warning.errorCode.20181": "设备异常",
  "50610.warning.errorCode.20182": "MPPT1电流反向",
  "50610.warning.errorCode.20183": "MPPT1组串异常接地",
  "50610.warning.errorCode.20184": "设备异常",
  "50610.warning.errorCode.20192": "MPPT2输入过压",
  "50610.warning.errorCode.20193": "MPPT2输入过流",
  "50610.warning.errorCode.20194": "设备异常",
  "50610.warning.errorCode.20195": "设备异常",
  "50610.warning.errorCode.20196": "设备异常",
  "50610.warning.errorCode.20197": "设备异常",
  "50610.warning.errorCode.20198": "MPPT2电流反向",
  "50610.warning.errorCode.20199": "MPPT2组串异常接地",
  "50610.warning.errorCode.20200": "设备异常",
  "50610.warning.errorCode.20208": "MPPT3输入过压",
  "50610.warning.errorCode.20209": "MPPT3输入过流",
  "50610.warning.errorCode.20210": "设备异常",
  "50610.warning.errorCode.20211": "设备异常",
  "50610.warning.errorCode.20212": "设备异常",
  "50610.warning.errorCode.20213": "设备异常",
  "50610.warning.errorCode.20214": "MPPT3电流反向",
  "50610.warning.errorCode.20215": "MPPT3组串异常接地",
  "50610.warning.errorCode.20216": "设备异常",
  "50610.warning.errorCode.20224": "MPPT4输入过压",
  "50610.warning.errorCode.20225": "MPPT4输入过流",
  "50610.warning.errorCode.20226": "设备异常",
  "50610.warning.errorCode.20227": "设备异常",
  "50610.warning.errorCode.20228": "设备异常",
  "50610.warning.errorCode.20229": "设备异常",
  "50610.warning.errorCode.20230": "MPPT4电流反向",
  "50610.warning.errorCode.20231": "MPPT4组串异常接地",
  "50610.warning.errorCode.20232": "设备异常",
  "50610.warning.errorCode.20240": "MPPT5输入过压",
  "50610.warning.errorCode.20241": "MPPT5输入过流",
  "50610.warning.errorCode.20242": "设备异常",
  "50610.warning.errorCode.20243": "设备异常",
  "50610.warning.errorCode.20244": "设备异常",
  "50610.warning.errorCode.20245": "设备异常",
  "50610.warning.errorCode.20246": "MPPT5电流反向",
  "50610.warning.errorCode.20247": "MPPT5组串异常接地",
  "50610.warning.errorCode.20248": "设备异常",
  "50610.warning.errorCode.20256": "MPPT6输入过压",
  "50610.warning.errorCode.20257": "MPPT6输入过流",
  "50610.warning.errorCode.20258": "设备异常",
  "50610.warning.errorCode.20259": "设备异常",
  "50610.warning.errorCode.20260": "设备异常",
  "50610.warning.errorCode.20261": "设备异常",
  "50610.warning.errorCode.20262": "MPPT6电流反向",
  "50610.warning.errorCode.20263": "MPPT6组串异常接地",
  "50610.warning.errorCode.20264": "设备异常",
  "50610.warning.errorCode.20272": "PV1异常",
  "50610.warning.errorCode.20273": "PV1过流",
  "50610.warning.errorCode.20274": "PV1电流反灌",
  "50610.warning.errorCode.20275": "PV1反接",
  "50610.warning.errorCode.20287": "PV1端子温度异常",
  "50610.warning.errorCode.20288": "PV2异常",
  "50610.warning.errorCode.20289": "PV2过流",
  "50610.warning.errorCode.20290": "PV2电流反灌",
  "50610.warning.errorCode.20291": "PV2反接",
  "50610.warning.errorCode.20303": "PV2端子温度异常",
  "50610.warning.errorCode.20304": "PV3异常",
  "50610.warning.errorCode.20305": "PV3过流",
  "50610.warning.errorCode.20306": "PV3电流反灌",
  "50610.warning.errorCode.20307": "PV3反接",
  "50610.warning.errorCode.20319": "PV3端子温度异常",
  "50610.warning.errorCode.20320": "PV4异常",
  "50610.warning.errorCode.20321": "PV4过流",
  "50610.warning.errorCode.20322": "PV4电流反灌",
  "50610.warning.errorCode.20323": "PV4反接",
  "50610.warning.errorCode.20335": "PV4端子温度异常",
  "50610.warning.errorCode.20336": "PV5异常",
  "50610.warning.errorCode.20337": "PV5过流",
  "50610.warning.errorCode.20338": "PV5电流反灌",
  "50610.warning.errorCode.20339": "PV5反接",
  "50610.warning.errorCode.20351": "PV5端子温度异常",
  "50610.warning.errorCode.20352": "PV6异常",
  "50610.warning.errorCode.20353": "PV6过流",
  "50610.warning.errorCode.20354": "PV6电流反灌",
  "50610.warning.errorCode.20355": "PV6反接",
  "50610.warning.errorCode.20367": "PV6端子温度异常",
  "50610.warning.errorCode.20368": "PV7异常",
  "50610.warning.errorCode.20369": "PV7过流",
  "50610.warning.errorCode.20370": "PV7电流反灌",
  "50610.warning.errorCode.20371": "PV7反接",
  "50610.warning.errorCode.20383": "PV7端子温度异常",
  "50610.warning.errorCode.20384": "PV8异常",
  "50610.warning.errorCode.20385": "PV8过流",
  "50610.warning.errorCode.20386": "PV8电流反灌",
  "50610.warning.errorCode.20387": "PV8反接",
  "50610.warning.errorCode.20399": "PV8端子温度异常",
  "50610.warning.errorCode.20400": "PV9异常",
  "50610.warning.errorCode.20401": "PV9过流",
  "50610.warning.errorCode.20402": "PV9电流反灌",
  "50610.warning.errorCode.20403": "PV9反接",
  "50610.warning.errorCode.20415": "PV9端子温度异常",
  "50610.warning.errorCode.20416": "PV10异常",
  "50610.warning.errorCode.20417": "PV10过流",
  "50610.warning.errorCode.20418": "PV10电流反灌",
  "50610.warning.errorCode.20419": "PV10反接",
  "50610.warning.errorCode.20431": "PV10端子温度异常",
  "50610.warning.errorCode.20432": "PV11异常",
  "50610.warning.errorCode.20433": "PV11过流",
  "50610.warning.errorCode.20434": "PV11电流反灌",
  "50610.warning.errorCode.20435": "PV11反接",
  "50610.warning.errorCode.20447": "PV11端子温度异常",
  "50610.warning.errorCode.20448": "PV12异常",
  "50610.warning.errorCode.20449": "PV12过流",
  "50610.warning.errorCode.20450": "PV12电流反灌",
  "50610.warning.errorCode.20451": "PV12反接",
  "50610.warning.errorCode.20463": "PV12端子温度异常",
  "50610.warning.errorCode.20464": "PV13异常",
  "50610.warning.errorCode.20465": "PV13过流",
  "50610.warning.errorCode.20466": "PV13电流反灌",
  "50610.warning.errorCode.20467": "PV13反接",
  "50610.warning.errorCode.20479": "PV13端子温度异常",
  "50610.warning.errorCode.20480": "PV14异常",
  "50610.warning.errorCode.20481": "PV14过流",
  "50610.warning.errorCode.20482": "PV14电流反灌",
  "50610.warning.errorCode.20483": "PV14反接",
  "50610.warning.errorCode.20495": "PV14端子温度异常",
  "50610.warning.errorCode.20496": "PV15异常",
  "50610.warning.errorCode.20497": "PV15过流",
  "50610.warning.errorCode.20498": "PV15电流反灌",
  "50610.warning.errorCode.20499": "PV15反接",
  "50610.warning.errorCode.20511": "PV15端子温度异常",
  "50610.warning.errorCode.20512": "PV16异常",
  "50610.warning.errorCode.20513": "PV16过流",
  "50610.warning.errorCode.20514": "PV16电流反灌",
  "50610.warning.errorCode.20515": "PV16反接",
  "50610.warning.errorCode.20527": "PV16端子温度异常",
  "50610.warning.errorCode.20528": "PV17异常",
  "50610.warning.errorCode.20529": "PV17过流",
  "50610.warning.errorCode.20530": "PV17电流反灌",
  "50610.warning.errorCode.20531": "PV17反接",
  "50610.warning.errorCode.20543": "PV17端子温度异常",
  "50610.warning.errorCode.20544": "PV18异常",
  "50610.warning.errorCode.20545": "PV18过流",
  "50610.warning.errorCode.20546": "PV18电流反灌",
  "50610.warning.errorCode.20547": "PV18反接",
  "50610.warning.errorCode.20559": "PV18端子温度异常",
  "50610.warning.errorCode.20560": "PV19异常",
  "50610.warning.errorCode.20561": "PV19过流",
  "50610.warning.errorCode.20562": "PV19电流反灌",
  "50610.warning.errorCode.20563": "PV19反接",
  "50610.warning.errorCode.20575": "PV19端子温度异常",
  "50610.warning.errorCode.20576": "PV20异常",
  "50610.warning.errorCode.20577": "PV20过流",
  "50610.warning.errorCode.20578": "PV20电流反灌",
  "50610.warning.errorCode.20579": "PV20反接",
  "50610.warning.errorCode.20591": "PV20端子温度异常",
  "50610.warning.errorCode.20592": "PV21异常",
  "50610.warning.errorCode.20593": "PV21过流",
  "50610.warning.errorCode.20594": "PV21电流反灌",
  "50610.warning.errorCode.20595": "PV21反接",
  "50610.warning.errorCode.20607": "PV21端子温度异常",
  "50610.warning.errorCode.20608": "PV22异常",
  "50610.warning.errorCode.20609": "PV22过流",
  "50610.warning.errorCode.20610": "PV22电流反灌",
  "50610.warning.errorCode.20611": "PV22反接",
  "50610.warning.errorCode.20623": "PV22端子温度异常",
  "50610.warning.errorCode.20624": "PV23异常",
  "50610.warning.errorCode.20625": "PV23过流",
  "50610.warning.errorCode.20626": "PV23电流反灌",
  "50610.warning.errorCode.20627": "PV23反接",
  "50610.warning.errorCode.20639": "PV23端子温度异常",
  "50610.warning.errorCode.20640": "PV24异常",
  "50610.warning.errorCode.20641": "PV24过流",
  "50610.warning.errorCode.20642": "PV24电流反灌",
  "50610.warning.errorCode.20643": "PV24反接",
  "50610.warning.errorCode.20655": "PV24端子温度异常",
  "50610.warning.errorCode.0": "无告警",
  "50610.ctrl_group.Remote_onoff.0": "开机",
  "50610.ctrl_group.Remote_onoff.1": "关机",
  "50610.device_info": "设备信息",
  "50610.ctrl_group": "设置量",
  "50610.real_time": "光伏",
  "50610.warning": "故障",
  "50611.device_Info.collectorSn": "序列号",
  "50611.real_time.rssi": "信号强度",
  "50611.real_time.rssi.desc": "dBm",
  "50611.device_Info": "设备信息",
  "50611.real_time": "实时数据",
  "60420.ctrl_fangniliushezhi.AllowCounterCurrentPower.desc": "允许逆流功率的说明。",
  "60420.real_time.gridBuyPower.desc": "电网买电（总购电量）的说明。",
  "60420.real_time.armDebugInfo8.desc": "ARM调试信息8的说明。",
  "60420.ctrl_fangniliushezhi.restrictCounterCurrent.desc": "限制逆流方式的说明。",
  "60420.real_time.meterTPower.desc": "电表T相功率的说明。",
  "60420.real_time.gridSellPower.desc": "电网卖电（总并网量）的说明。",
  "60420.real_time.meterCommQuality.desc": "电表通讯质量的说明。",
  "60420.real_time.meterSPower.desc": "电表S相功率的说明。",
  "60420.real_time.meterRPower.desc": "电表R相功率的说明。",
  "60420.ctrl_fangniliushezhi.meterSelect.desc": "防逆流电表的说明。",
  "50610.real_time.inverterSn": "逆变器SN",
  "50610.real_time.model": "型号",
  "50610.real_time.源；数据分析_实时监控.tag": "析_实时监控",
  "50610.real_time.网；数据分析_负载.tag": "析_负载",
  "50610.real_time.源；数据分析_光伏.tag": "析_光伏",
  "60420.real_time.groupStrCurrent24": "组串24电流",
  "{}.alarm.{}.excDesc": "继电器故障",
  "{}.alarm.{}.suggestion": "1. 重启逆变器，确认逆变器是否可以正常工作。\n2. 确认逆变器N线与地线接线是否良好。\n若频繁发生，请联系上能电气售后服务中心",
  "{}.alarm.{}.desc": "继电器故障",
  "50610.real_time.数据分析_实时监控.tag": "实时监控",
  "50610.real_time.数据分析_负载.tag": "负载",
  "50610.real_time.数据分析_光伏.tag": "光伏",
  "50610.real_time.vpv13": "PV13输入电压",
  "50610.real_time.ipv13": "PV13输入电流",
  "50610.real_time.vpv14": "PV14输入电压",
  "50610.real_time.ipv14": "PV14输入电流",
  "50610.real_time.vpv15": "PV15输入电压",
  "50610.real_time.ipv15": "PV15输入电流",
  "50610.real_time.vpv16": "PV16输入电压",
  "50610.real_time.ipv16": "PV16输入电流",
  "50610.real_time.vpv17": "PV17输入电压",
  "50610.real_time.ipv17": "PV17输入电流",
  "50610.real_time.vpv18": "PV18输入电压",
  "50610.real_time.ipv18": "PV18输入电流",
  "50610.real_time.vpv19": "PV19输入电压",
  "50610.real_time.ipv19": "PV19输入电流",
  "50610.real_time.vpv20": "PV20输入电压",
  "50610.real_time.ipv20": "PV20输入电流",
  "50610.real_time.vpv21": "PV21输入电压",
  "50610.real_time.ipv21": "PV21输入电流",
  "50610.real_time.vpv22": "PV22输入电压",
  "50610.real_time.ipv22": "PV22输入电流",
  "50610.real_time.vpv23": "PV23输入电压",
  "50610.real_time.ipv23": "PV23输入电流",
  "50610.real_time.vpv24": "PV24输入电压",
  "50610.real_time.ipv24": "PV24输入电流",
  "50610.real_time.meterEtotalSell": "电表上网电量",
  "50610.real_time.meterEtotalBuy": "电表购网电量",
  "50610.real_time.meterPower": "电表功率",
  "50610.real_time.meterLoadPower": "电表负载有功功率",
  "50610.real_time.meterLoadEtotal": "电表负载总消耗电能",
  "alarm.trigger.condition": "设备触发",
  "alarm.iot": "IoT告警",
  "module.alarmInfo": "故障告警",
  "alarm.name.1976179721629065216": "电网过压A/AB",
  "alarm.desc.1976179721629065216": "攸能创\nhttps://ihaier.feishu.cn/wiki/ETwmwtpW4i1X4Kk3cf5cGXNUnqc",
  "alarm.name.1976182092941746176": "旁路继电器故障",
  "alarm.name.1976179881167806464": "电网欠压A/AB",
  "alarm.name.1976179976554668032": "电网过压B/BC",
  "alarm.name.1976180051322331136": "电网欠压B/BC",
  "alarm.name.1976180127889350656": "电网过压C/CA",
  "alarm.name.1976180188287328256": "电网欠压C/CA",
  "alarm.name.1976180241991196672": "电网过频",
  "alarm.name.1976180299910340608": "电网欠频",
  "alarm.name.1976180354583093248": "漏电流保护",
  "alarm.name.1976180408215658496": "直流分量过大",
  "alarm.name.1976180467212738560": "逆变过流",
  "alarm.name.1976180536276148224": "逆变输出过压A/AB",
  "alarm.name.1976180589082435584": "逆变输出过压B/BC",
  "alarm.name.1976180644711489536": "逆变输出过压C/CA",
  "alarm.name.1976180700546064384": "母线欠压",
  "alarm.name.1976180765993984000": "PV输入反接",
  "alarm.name.1976180820901617664": "电池过压",
  "alarm.name.1976180889214246912": "电池过流",
  "alarm.name.1976180970717962240": "电池过温",
  "alarm.name.1976181032802050048": "LLC过压",
  "alarm.name.1976181094428958720": "PV输入过压1",
  "alarm.name.1976181158421454848": "PV输入过流1",
  "alarm.name.1976181218576162816": "PV输入过压2",
  "alarm.name.1976181274121330688": "PV输入过流2",
  "alarm.name.1976181346292719616": "PV输入过压3",
  "alarm.name.1976181403347836928": "PV输入过流3",
  "alarm.name.1976181463607402496": "PV输入过压4",
  "alarm.name.1976181529235677184": "PV输入过流4",
  "alarm.name.1976181590283771904": "PV输入过压5",
  "alarm.name.1976181648265830400": "PV输入过流5",
  "alarm.name.1976181698266128384": "PV输入过压6",
  "alarm.name.1976181755413520384": "PV输入过流6",
  "alarm.name.1976181811252289536": "PV对地阻抗过低",
  "alarm.name.2032118848258973696": "EPS微逆电压低故障",
  "alarm.name.1976181925006008320": "正负母线失衡",
  "alarm.name.1976181973185978368": "并网继电器故障",
  "alarm.name.1976182026831126528": "负载继电器故障",
  "alarm.name.1976182165184438272": "硬件故障",
  "alarm.desc.1976182165184438272": "硬件故障",
  "alarm.name.1976182228069638144": "母线电池过压硬件保护",
  "alarm.name.1976182282117439488": "LLC电流硬件保护",
  "alarm.name.1976182335615787008": "光伏电池过流硬件保护",
  "alarm.name.1976182599047438336": "逆变过流硬件保护",
  "alarm.name.1976182648322121728": "设备过温保护",
  "alarm.name.1976182697768771584": "风扇故障",
  "alarm.name.1976182748419186688": "备电过载保护",
  "alarm.name.1976182807890223104": "副DSP保护",
  "alarm.name.1976182862760108032": "电表通信故障",
  "alarm.name.1976182919563567104": "电池通信故障",
  "alarm.name.1976182967470907392": "外部风机故障",
  "alarm.name.1976183017638977536": "DSP通信故障",
  "alarm.name.1976183066464870400": "设备低温保护",
  "alarm.name.1976183120328122368": "HMI通信故障",
  "alarm.name.1976183171641237504": "电网10min均值过压",
  "alarm.name.1976183433860734976": "孤岛保护",
  "alarm.name.1976183497115033600": "负载端口2断开",
  "alarm.name.1976183555394887680": "电池提升母线电压失败",
  "alarm.name.1976183640014970880": "PV提升母线电压失败",
  "alarm.name.1976183695048433664": "逆变提升母线电压失败",
  "alarm.name.1976183755257667584": "供电电压欠压",
  "alarm.name.1976183814007283712": "温度过高",
  "alarm.name.1976183876338835456": "副DSP通信超时",
  "alarm.name.1976183931431018496": "离网切换并网同步超时",
  "alarm.name.1976183985306853376": "漏电流传感器自检错误",
  "alarm.name.1976184038838755328": "电池电量不足",
  "alarm.name.1976184102353100800": "电网故障",
  "alarm.name.1976184158493859840": "电池异常",
  "alarm.name.1976184220976406528": "电池充电过流",
  "alarm.name.1976184277138137088": "电池放电过流",
  "alarm.name.1976184331454373888": "电池短路",
  "alarm.name.1976184384797532160": "电池过温",
  "alarm.name.1976184442804756480": "电池低温",
  "alarm.name.1976184496613482496": "电池欠压",
  "alarm.name.1976184556558475264": "电池过压",
  "alarm.name.1976184611780681728": "电池Cell欠压过大",
  "alarm.name.1976184666617012224": "电池输入反接",
  "alarm.name.1976184717594583040": "电池系统错误",
  "alarm.name.1976184772594491392": "电池充电电流高",
  "alarm.name.1976184826264805376": "电池放电电流高",
  "alarm.name.1976184885165416448": "电池温度高",
  "alarm.name.1976184945802469376": "电池温度低",
  "alarm.name.1976185016581349376": "电池电压高",
  "alarm.name.1976185071098912768": "电池电压低",
  "alarm.name.1976185125410955264": "电池电压过大",
  "alarm.name.1976185181912424448": "电池通信故障",
  "alarm.name.1976185235234611200": "电池系统告警",
  "alarm.name.1982722691356168192": "LLC侧硬件TZ故障",
  "alarm.name.1976185286522560512": "电池充电失效",
  "alarm.desc.1976185286522560512": "{故障原因：}\n{修复建议：}",
  "alarm.name.1976185338917806080": "电池放电失效",
  "alarm.desc.1976185338917806080": "{故障原因：}\n{修复建议：}",
  "alarm.name.1982703891357372416": "PV电压低",
  "alarm.name.1982704010538520576": "PV电压高",
  "alarm.name.1982722818460356608": "逆变温度过温",
  "alarm.name.1982704393965015040": "PV面板短路",
  "alarm.name.1982722893995577344": "BOOST过温",
  "alarm.name.1982722971384680448": "散热器过温",
  "alarm.name.1982723058189996032": "环境过温",
  "alarm.name.1982723196656553984": "Buck-Boost温度异常",
  "alarm.name.1982723274389590016": " NTC开路",
  "alarm.name.1982723329695682560": "PV端子过温保护故障",
  "alarm.name.1982723418367463424": "绝缘检测故障",
  "alarm.name.1982723579764281344": "驱动故障",
  "alarm.name.1982723656469712896": "主DSP接收ARM通讯故障",
  "alarm.name.1982723721590476800": " ARM接收主DSP通讯故障",
  "alarm.name.1982719642378178560": "Buck-Boost软件过流",
  "alarm.name.1982721765924933632": "BUS电压低",
  "alarm.name.1982721926059266048": "BUS电压不平衡",
  "alarm.name.1982722075145801728": "BUS电压高",
  "alarm.name.1982722150966235136": "硬件bus过压",
  "alarm.name.1982722274509459456": "逆变硬件过流",
  "alarm.name.1982722328636952576": "逆变软件过流",
  "alarm.name.1982722386715480064": "BOOST硬件过流",
  "alarm.name.1982722464633065472": "BOOST软件过流",
  "alarm.name.1982722537903362048": "辅源硬件TZ故障",
  "alarm.name.1982722640437317632": "Bus硬件TZ过压",
  "alarm.name.1982724866710966272": "主从芯片通讯故障-主芯片故障",
  "alarm.name.1982724925741600768": "主从芯片通讯故障-从芯片故障",
  "alarm.name.1982724976895332352": " DSP与AFCI通信故障",
  "alarm.name.1982725063071502336": "静态漏电流高",
  "alarm.name.1982725114715967488": " 30mA突变故障",
  "alarm.name.1982725156881305600": " 60mA突变故障",
  "alarm.name.1982725197679300608": "150mA突变故障",
  "alarm.name.1982725239853027328": "继电器开路",
  "alarm.name.1982725281879953408": "继电器短路",
  "alarm.name.1982725329606938624": "继电器自检异常",
  "alarm.name.1982725375903666176": "两个内部风扇均故障",
  "alarm.name.2016775369290260480": "PV电压故障",
  "alarm.excDesc.2016775369290260480": "PV电压故障",
  "alarm.suggestion.2016775369290260480": "1.检查光伏组件连接是否正常，组件是否存在损坏或表面积灰、有遮挡物的情况。\n2.检查光伏组件是否连接正常，组件电压规格是否高于逆变器工作电压范围。\n3.检查光伏组件是否存在短路情况。",
  "alarm.desc.2016775369290260480": "\\",
  "alarm.name.2016775369453838336": "过流故障",
  "alarm.excDesc.2016775369453838336": "过流故障",
  "alarm.suggestion.2016775369453838336": "请重启逆变器，若故障未能消除，请联系经销商。",
  "alarm.desc.2016775369453838336": "\\",
  "alarm.name.2016775369705496576": "DCI故障",
  "alarm.excDesc.2016775369705496576": "DCI故障",
  "alarm.suggestion.2016775369705496576": "1， 检查组件对地是否有短路情况\n2， 断电重启逆变器，如不能恢复，请联系经销商",
  "alarm.desc.2016775369705496576": "\\",
  "alarm.name.2016775369797771264": "市电电压故障",
  "alarm.excDesc.2016775369797771264": "市电电压故障",
  "alarm.suggestion.2016775369797771264": "1， 检查配电箱是否有空开跳闸\n2， 测量实际电压是否超过逆变器范围\n3， 如果是电压超范围，可以调整逆变器过欠压保护值",
  "alarm.desc.2016775369797771264": "\\",
  "alarm.name.2016775369915211776": "AFCI自检故障",
  "alarm.excDesc.2016775369915211776": "AFCI自检故障",
  "alarm.suggestion.2016775369915211776": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "alarm.desc.2016775369915211776": "\\",
  "alarm.name.2016775370003292160": "N-PE故障",
  "alarm.excDesc.2016775370003292160": "N-PE故障",
  "alarm.suggestion.2016775370003292160": "检查N-PE电压是否异常",
  "alarm.desc.2016775370003292160": "\\",
  "alarm.name.2016775370066206720": "组串检测故障",
  "alarm.excDesc.2016775370066206720": "组串检测故障",
  "alarm.suggestion.2016775370066206720": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "alarm.desc.2016775370066206720": "\\",
  "alarm.name.2028758663173447680": "网侧欠压保护",
  "alarm.name.2032119025682227200": "EPS微逆电压高故障",
  "alarm.name.2033183800291098624": "变频器其他故障锁定",
  "alarm.name.2016775369600638976": "通信故障",
  "alarm.excDesc.2016775369600638976": "通信故障",
  "alarm.suggestion.2016775369600638976": "1， 控制板故障\n2， 断电重启逆变器，如不能恢复，请联系经销商",
  "alarm.name.1982725425249652736": " R相DCI故障",
  "alarm.name.1982725478236295168": "S相DCI故障",
  "alarm.name.1982725522251321344": " T相DCI故障",
  "alarm.name.1982725589238550528": "AC电压检测不一致",
  "alarm.name.1982725654057324544": "BUS电压检测不一致",
  "alarm.name.1982725729487687680": " ISO电压检测不一致",
  "alarm.name.1982725772970037248": " PV电压检测不一致",
  "alarm.name.1982725818763448320": " GFCI不一致",
  "alarm.name.1982725861310468096": " Bus电压采样异常",
  "alarm.name.1982725920299159552": "PV电流采样异常",
  "alarm.name.1982726216974864384": "市电欠压1阶",
  "alarm.name.1982726278794711040": "市电过压1阶",
  "alarm.name.1982726326253260800": "无市电电压",
  "alarm.name.1982726367105781760": "市电欠压2阶",
  "alarm.name.1982726402929332224": "市电过压2阶",
  "alarm.name.1982726439218450432": "市电启动欠压",
  "alarm.name.1982726475981524992": "市电启动过压",
  "alarm.name.1982726523523960832": "中断瞬时过压",
  "alarm.name.1982726569774551040": "孤岛过压",
  "alarm.name.1982726611772116992": "电网电压震荡",
  "alarm.name.1982726650300993536": "市电欠压3阶",
  "alarm.name.1982726702226477056": "电网电压锁相故障",
  "alarm.name.1982726737278275584": "电网相序异常",
  "alarm.name.1982726776817979392": "市电欠频1阶",
  "alarm.name.1982726819830566912": "市电过频1阶",
  "alarm.name.1982726860121051136": "市电欠频2阶",
  "alarm.name.1982726902605156352": "市电过频2阶",
  "alarm.name.1982726941616377856": "市电启动欠频",
  "alarm.name.1982726978417201152": "市电启动过频",
  "alarm.name.1982727022411255808": "远程关机指令",
  "alarm.name.1982727438452658176": "组串1故障",
  "alarm.name.1982727492773089280": "组串2故障",
  "alarm.name.1982727547231932416": "组串3故障",
  "alarm.name.1982727720985169920": "组串4故障",
  "alarm.name.1982727761862856704": "组串5故障",
  "alarm.name.1982727832880812032": "组串6故障",
  "alarm.name.1982727878745526272": "组串7故障",
  "alarm.name.1982727930389991424": "组串8故障",
  "alarm.name.1982727966091907072": "组串9故障",
  "alarm.name.2016775369390923776": "BUS电压错误",
  "alarm.excDesc.2016775369390923776": "BUS电压错误",
  "alarm.suggestion.2016775369390923776": "1.多出现在清晨，请检查光伏面板表面清洁程度。\n2.检查光伏面板是否连接正常，面板电压规格是否高于逆变器工作电压范围。\n3.请重启逆变器，若故障未能消除，请联系经销商。",
  "alarm.desc.2016775369390923776": "\\",
  "alarm.name.2016775369499975680": "温度异常故障",
  "alarm.excDesc.2016775369499975680": "温度异常故障",
  "alarm.suggestion.2016775369499975680": "1， 检查风扇是否被异物卡住\n2， 检查散热器风道是否被堵塞\n3， 冷却后重启逆变器，若不能恢复，请联系经销商",
  "alarm.desc.2016775369499975680": "\\",
  "alarm.name.2016775369751633920": "一致性故障",
  "alarm.excDesc.2016775369751633920": "一致性故障",
  "alarm.suggestion.2016775369751633920": "断电重启逆变器，如不能恢复，请联系经销商",
  "alarm.desc.2016775369751633920": "\\",
  "alarm.name.2016775369843908608": "市电频率故障",
  "alarm.excDesc.2016775369843908608": "市电频率故障",
  "alarm.suggestion.2016775369843908608": "1， 检查电网是否有虚接情况\n2， 适当调整频率范围",
  "alarm.desc.2016775369843908608": "\\",
  "alarm.name.2016775369961349120": "AutoTest 自检故障",
  "alarm.excDesc.2016775369961349120": "AutoTest 自检故障",
  "alarm.suggestion.2016775369961349120": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "alarm.desc.2016775369961349120": "\\",
  "alarm.name.2028758713719005184": "网侧过频保护",
  "alarm.name.2032119116388245504": "EPS微逆频率低故障",
  "alarm.name.2033183899905818624": "补水告警",
  "alarm.name.1982728115090362368": "组串10故障",
  "alarm.name.1982728170052521984": "组串11故障",
  "alarm.name.1982728216508633088": "组串12故障",
  "alarm.name.1982728268677386240": "组串13故障",
  "alarm.name.1982728315074777088": "组串14故障",
  "alarm.name.1982728369663643648": "组串15故障",
  "alarm.name.1982728425221394432": "组串16故障",
  "alarm.name.1982728462668140544": "组串17故障",
  "alarm.name.1982728497036267520": "组串18故障",
  "alarm.name.1982728539063193600": "组串19故障",
  "alarm.name.1982728577889865728": "组串20故障",
  "alarm.name.1982728613516283904": "组串1自检报警",
  "alarm.name.1982728656671477760": "组串2自检报警",
  "alarm.name.1982728690544676864": "组串3自检报警",
  "alarm.name.1982728727437774848": "组串4自检报警",
  "alarm.name.1982728764624474112": "组串5自检报警",
  "alarm.name.1982728805036593152": "组串6自检报警",
  "alarm.name.1982728852545474560": "组串7自检报警",
  "alarm.name.1982728934460231680": "组串8自检报警",
  "alarm.name.1982728983453896704": "组串9自检报警",
  "alarm.name.1982729016622452736": "组串10自检报警",
  "alarm.name.1982729058271891456": "组串11自检报警",
  "alarm.name.1982729087980146688": "组串12自检报警",
  "alarm.name.1982729127431770112": "组串13自检报警",
  "alarm.name.1982729161011367936": "组串14自检报警",
  "alarm.name.1982729191088721920": "组串15自检报警",
  "alarm.name.1982729224966115328": "组串16自检报警",
  "alarm.name.1982729270314930176": "组串17自检报警",
  "alarm.name.1982729323460956160": "组串18自检报警",
  "alarm.name.1982729741117165568": "组串19自检报警",
  "alarm.name.1982729783395749888": "组串20自检报警",
  "alarm.name.1982729815385706496": "自动测试失败故障",
  "alarm.name.1982729887968137216": " N-PE电压异常故障",
  "alarm.name.1982729954783399936": "漏电流自检故障",
  "alarm.name.1982730005194739712": "组串故障",
  "alarm.name.1982730061343887360": "辅助电源掉电",
  "alarm.name.1982730302180823040": "风扇1",
  "alarm.name.1982730343477940224": "风扇2",
  "alarm.name.1982730396821098496": "风扇3",
  "alarm.name.1982731050482405376": "风扇4",
  "alarm.name.1982731096548446208": "风扇5",
  "alarm.name.1982731149929353216": "风扇6",
  "alarm.name.1982731198281289728": "内部风扇1",
  "alarm.name.1982731249154002944": "内部风扇2",
  "alarm.name.1982731299783446528": "风扇9",
  "alarm.name.1982731337943224320": "风扇10",
  "alarm.name.1982731597973295104": " DC防雷器",
  "alarm.name.1982731652004319232": " AC防雷器",
  "alarm.name.1982731694115131392": "组串1",
  "alarm.name.1982731735827484672": "组串2",
  "alarm.name.1982731817205370880": "组串3",
  "alarm.name.1982731849895776256": "组串4",
  "alarm.name.1982731882720399360": "组串5",
  "alarm.name.1982731924759908352": "组串6",
  "alarm.name.1982731964429635584": "组串7",
  "alarm.name.1982732001243041792": "组串8",
  "alarm.name.1982732050819715072": "组串9",
  "alarm.name.1982732101780508672": "组串10",
  "alarm.name.1982732159489937408": "组串11",
  "alarm.name.1982732194915028992": "组串12",
  "alarm.name.1982732236052762624": "组串13",
  "alarm.name.1982732267820421120": "组串14",
  "alarm.name.1982732305925672960": "组串15",
  "alarm.name.1982732356613836800": "组串16",
  "alarm.name.1982732394165440512": "组串17",
  "alarm.name.1982732496439349248": "组串18",
  "alarm.name.1982732531944132608": "组串19",
  "alarm.name.1982732571207012352": "组串20",
  "alarm.name.1982732791659630592": "组串21",
  "alarm.name.1982732833640419328": "组串22",
  "alarm.name.1982732881732308992": "组串23",
  "alarm.name.1982732918268891136": "组串24",
  "alarm.name.1982732950015578112": " A相电表异常警告",
  "alarm.name.1982733002142388224": "B相电表异常警告",
  "alarm.name.1982733036330160128": "C相电表异常警告",
  "alarm.name.1982733073336504320": "电表通讯异常警告",
  "alarm.name.1982733110758084608": " CT接线异常警告",
  "alarm.name.1982733139698782208": "电压超范围告警",
  "alarm.name.1982733175522332672": " PV1短路告警",
  "alarm.name.1982733219281506304": " PV2短路告警",
  "alarm.name.1982733261329403904": " PV电压低告警",
  "alarm.name.1983439405542199296": "市电锁相失败预警",
  "alarm.name.1983439045175988224": "整流器表示逆变交流输出过压保护预警",
  "alarm.name.1983441336801087488": "充电器低压预警",
  "alarm.name.1983439867410567168": "并机二级锁相失败预警",
  "alarm.name.1983440030644490240": "温度1过高预警",
  "alarm.name.1983440069064314880": "温度2过高预警",
  "alarm.name.1983439274679914496": "整流器逆变交流输出欠频保护预警",
  "alarm.name.1983439207671713792": "整流器逆变交流输出过频保护预警",
  "alarm.name.1983439137320652800": "整流器逆变交流输出欠压保护预警",
  "alarm.name.1983436267409551360": "电网频率高预警",
  "alarm.name.1983437704076111872": "整流器逆变电压有效值故障预警",
  "alarm.name.1983437607649062912": "输出旁路过载延时到故障预警",
  "alarm.name.1983437415860318208": "输出逆变过载延时到故障预警",
  "alarm.name.1983437182401163264": "U2母线电压过高预警",
  "alarm.name.1983437105314050048": "U2母线电压过低预警",
  "alarm.name.1983436687959830528": "U1母线电压过高预警",
  "alarm.name.1983436622725820416": "U1母线电压过低预警",
  "alarm.name.1983436504584859648": "整流器母线低压预警",
  "alarm.name.1983436385919610880": "电网交流输入过流预警",
  "alarm.name.1983436181082386432": "电网频率低预警",
  "alarm.name.1983436111293362176": "电网电压高预警",
  "alarm.name.1983436018762821632": "电网电压低预警",
  "alarm.name.1983441041266233344": "旁路电压低预警",
  "alarm.name.1983441128797163520": "旁路电压高预警",
  "alarm.name.1983441197533417472": "旁路频率低预警",
  "alarm.name.1983441244052443136": "旁路频率高预警",
  "alarm.name.1983441386105131008": "充电器高压预警",
  "alarm.name.1983441554057646080": "放电器电池低压故障预警",
  "alarm.name.1983441639826968576": "放电器电池高压故障预警",
  "alarm.name.1983441703756550144": "放电器母线低压故障预警",
  "alarm.name.1983441814028996608": "系统U1 和 U2 软件版本不匹配预警",
  "alarm.name.1983442051867004928": "PV1DC低压故障预警",
  "alarm.name.1983442128111063040": "PV1DC高压故障预警",
  "alarm.name.1983442211623849984": "PV1输入欠压预警",
  "alarm.name.1983442307820212224": "PV1输入过压预警",
  "alarm.name.1983442411306274816": "PV2DC低压故障预警",
  "alarm.name.1983442486581448704": "PV2DC高压故障预警",
  "alarm.name.1983442601962557440": "PV2输入欠压预警",
  "alarm.name.1983442655385407488": "PV2输入过压预警",
  "alarm.name.1983442776789536768": "PV3DC低压故障预警",
  "alarm.name.1983442979227619328": "PV3DC高压故障预警",
  "alarm.name.1983443053852676096": "PV3输入欠压预警",
  "alarm.name.1983443112048644096": "PV3输入过压预警",
  "alarm.name.1983443231611473920": "PV4DC低压故障预警",
  "alarm.name.1983443306404302848": "PV4DC高压故障预警",
  "alarm.name.1983443380442157056": "PV4输入欠压预警",
  "alarm.name.1983443427661631488": "PV4输入过压预警",
  "alarm.name.1983443624508706816": "并机频率体系不一致故障预警",
  "alarm.name.1983443771271598080": "并机均流故障预警",
  "alarm.name.1983443928079847424": "电芯均组压高预警",
  "alarm.name.1983444026759237632": "电芯高压预警",
  "alarm.name.1983444145172828160": "电芯组均压低预警",
  "alarm.name.1983444194439122944": "电芯低压预警",
  "alarm.name.1983444345144659968": "电芯充电过流慢检预警",
  "alarm.name.1983444511176183808": "电芯放电过流慢检预警",
  "alarm.name.1983444632710336512": "电芯一级过温（充电）预警",
  "alarm.name.1983444709449322496": "电芯二级过温（充电）预警",
  "alarm.name.1983444786439966720": "电芯一级低温（充电）预警",
  "alarm.name.1983444866660225024": "电芯二级低温（充电）预警",
  "alarm.name.1983444948281380864": "电芯一级过温（放电）预警",
  "alarm.name.1983445017030217728": "电芯二级过温（放电）预警",
  "alarm.name.1983445076367036416": "电芯一级低温（放电）预警",
  "alarm.name.1983445186899529728": "电芯二级低温（放电）预警",
  "alarm.name.1983445428072009728": "电芯环境过温预警",
  "alarm.name.1983445507302412288": "电芯环境低温预警",
  "alarm.name.1983445568627331072": "电芯MOS 过温预警",
  "alarm.name.1983445648063254528": "电芯温差过大预警",
  "alarm.name.1983446483765743616": "EPS微逆电压低预警",
  "alarm.name.1983446659964260352": "EPS微逆电压高预警",
  "alarm.name.1983446720391598080": "EPS微逆频率低预警",
  "alarm.name.1983446765874630656": "EPS微逆频率高预警",
  "alarm.name.1983446922850652160": "EPS微逆交流输入过流预警",
  "alarm.name.1983449795403632640": "PV1DC 低压故障",
  "alarm.name.1983447013749608448": "电网电压低",
  "alarm.name.1983447269279191040": "电网电压高",
  "alarm.name.1983447315064213504": "电网频率低",
  "alarm.name.1983447371880255488": "电网频率高",
  "alarm.name.1983447794460577792": "电网交流输入过流",
  "alarm.name.1983447853789007872": "整流器母线低压",
  "alarm.name.1983448070043127808": "U1母线电压过低",
  "alarm.name.1983448136455737344": "U1母线电压过高",
  "alarm.name.1983448178398777344": "U2母线电压过低",
  "alarm.name.1983448224443846656": "U2母线电压过高",
  "alarm.name.1983448511883694080": "整流器逆变电压有效值故障",
  "alarm.name.1983448569744117760": "整流器逆变交流输出过压保护",
  "alarm.name.1983448626644045824": "整流器逆变交流输出欠压保护",
  "alarm.name.1983448682113716224": "整流器逆变交流输出过频保护",
  "alarm.name.1983448744743063552": "整流器逆变交流输出欠频保护",
  "alarm.name.1983448793942249472": "整流器逆变交流输出欠频保护",
  "alarm.name.1983448888179871744": "市电锁相失败",
  "alarm.name.1983448936133349376": "并机二级锁相失败",
  "alarm.name.1983449226484043776": "温度1过高",
  "alarm.name.1983449270029307904": "温度2过高",
  "alarm.name.1983449350677385216": "旁路温度过高",
  "alarm.name.1983449419979870208": "充电器低压",
  "alarm.name.1983449468461830144": "充电器高压",
  "alarm.name.1983449552578596864": "放电器电池低压故障",
  "alarm.name.1983449611462430720": "放电器母线低压故障",
  "alarm.name.1983449671361286144": "放电器电池高压故障",
  "alarm.name.1983449852345503744": "PV1DC 高压故障",
  "alarm.name.1983450204427964416": "PV 1输入欠压",
  "alarm.name.1983450317959385088": "PV 1输入过压",
  "alarm.name.1983450395319128064": "PV2DC 低压故障",
  "alarm.name.1983448391486197760": "输出旁路过载延时到告警",
  "alarm.name.1983450485723156480": "PV2DC 高压故障",
  "alarm.name.1983450598428299264": "PV 2输入欠压",
  "alarm.name.1983450649506533376": "PV 2输入过压",
  "alarm.name.1983450781161541632": "PV3DC低压故障",
  "alarm.name.1983450853437788160": "PV3DC高压故障",
  "alarm.name.1983450945389514752": "PV 3输入欠压",
  "alarm.name.1983451066164498432": "PV 3输入过压",
  "alarm.name.1983451209831993344": "PV4DC低压故障",
  "alarm.name.1983451257269571584": "PV4DC高压故障",
  "alarm.name.1983451311959101440": "PV 4输入欠压",
  "alarm.name.1983451359711252480": "PV 4输入过压",
  "alarm.name.1983784282721275904": "EPS微逆电压低",
  "alarm.name.1983769637490970624": "并机频率体系不一致故障",
  "alarm.name.1983769711579156480": "并机均流故障",
  "alarm.name.1983770070053736448": "电芯均组压高",
  "alarm.name.1983770134935425024": "电芯高压",
  "alarm.name.1983770179407630336": "电芯组均压低",
  "alarm.name.1983781198578241536": "电芯低压",
  "alarm.name.1983782488247029760": "电芯充电过流慢检",
  "alarm.name.1983782546879205376": "电芯放电过流慢检",
  "alarm.name.1983782792745111552": "电芯一级过温（充电）",
  "alarm.name.1983782845652062208": "电芯二级过温（充电）",
  "alarm.name.1983782890296233984": "电芯一级低温（充电）",
  "alarm.name.1983782952359350272": "电芯二级低温（充电）",
  "alarm.name.1983783000384131072": "电芯一级过温（放电）",
  "alarm.name.1983783056600387584": "电芯二级过温（放电）",
  "alarm.name.1983783750313103360": "电芯一级低温（放电）",
  "alarm.name.1983783805426257920": "电芯二级低温（放电）",
  "alarm.name.1983783933784543232": "电芯环境过温",
  "alarm.name.1983783994077663232": "电芯环境低温",
  "alarm.name.1983784109530075136": "电芯MOS 过温",
  "alarm.name.1983784166736187392": "电芯温差过大",
  "alarm.name.1983784355509227520": "EPS微逆电压高",
  "alarm.name.1983784414653108224": "EPS微逆频率低",
  "alarm.name.1983784471796305920": "EPS微逆频率高",
  "alarm.name.1983784572803534848": "EPS微逆交流输入过流",
  "alarm.name.1983735175692603392": "PV电压高",
  "alarm.name.1983784922449104896": "电网故障汇总",
  "alarm.name.1983785609815838720": "电网电压异常",
  "alarm.name.2016775686341894144": "远程关机",
  "alarm.excDesc.2016775686341894144": "远程关机",
  "alarm.suggestion.2016775686341894144": "请检查是否认为对逆变器设置了关机",
  "alarm.desc.2016775686341894144": "\\",
  "alarm.name.1983785962993012736": "电网市电掉电",
  "alarm.name.1983786019267989504": "电网市电浪涌",
  "alarm.name.1983786131650170880": "电网继电器开路",
  "alarm.name.1983786689308053504": "整流故障汇总",
  "alarm.name.1983786760258899968": "整流硬件软起故障",
  "alarm.name.1983786841204772864": "整流软件软起故障",
  "alarm.name.1983786921655717888": "整流母线低压",
  "alarm.name.1983787030342717440": "整流内部通信故障",
  "alarm.name.1983787089142665216": "整流对外通信故障",
  "alarm.name.1983787406747947008": "U1母线故障汇总",
  "alarm.name.1983787530156953600": "U1母线低压异常",
  "alarm.name.1983787681722322944": "U1母线高压异常",
  "alarm.name.1983787781534175232": "U1母线电压过低",
  "alarm.name.1983787851801350144": "U1母线电压过高",
  "alarm.name.1983788040402423808": "U1母线电压过高快检",
  "alarm.name.1983788108840882176": "U2母线故障汇总",
  "alarm.name.1983788632046751744": "U2母线低压异常",
  "alarm.name.1983788708295004160": "U2母线高压异常",
  "alarm.name.1983788848892268544": "U2母线电压过低",
  "alarm.name.1983788894991863808": "U2母线电压过高",
  "alarm.name.1983788966961926144": "U2母线电压过高快检",
  "alarm.name.1983789199263453184": "正负母线不平衡",
  "alarm.name.1983789308390854656": "U2母线均压电流高",
  "alarm.name.1983789390242697216": "U2母线均压电流过高",
  "alarm.name.1983789483788259328": "U2母线均压电流过高快检",
  "alarm.name.1983789576885030912": "输出故障汇总",
  "alarm.name.1983790005408681984": "逆变继电器开路",
  "alarm.name.1983790320040202240": "逆变故障汇总",
  "alarm.name.1983790397521580032": "逆变器快检故障",
  "alarm.name.1983791538141581312": "逆变器慢检故障",
  "alarm.name.1983791754081128448": "继电器连锡故障",
  "alarm.name.1983796888936828928": "逆变短路故障",
  "alarm.name.1983797033942306816": "逆变内部通信故障",
  "alarm.name.1983797113093017600": " 逆变对外通信故障",
  "alarm.name.1983797209310351360": "逆变电压有效值故障",
  "alarm.name.1983797318987206656": "逆变交流输出过压保护",
  "alarm.name.1983797438277406720": "逆变交流输出欠压保护",
  "alarm.name.1983797615289618432": "逆变交流输出过频保护",
  "alarm.name.1983797669161259008": "逆变交流输出欠频保护",
  "alarm.name.1983797767966478336": "锁相故障汇总",
  "alarm.name.1983798184691552256": "温度1故障汇总",
  "alarm.name.1983798246465261568": "温度2故障汇总",
  "alarm.name.1983798308217999360": "温度1温度过高",
  "alarm.name.1983798550569078784": "温度2温度过高",
  "alarm.name.1983798631280070656": "温度2探头未插",
  "alarm.name.1983798432763662336": "温度1探头未插",
  "alarm.name.1983798765829148672": "旁路故障汇总",
  "alarm.name.1983798851934015488": "旁路电压异常",
  "alarm.name.1983798927637008384": "旁路频率异常",
  "alarm.name.1983798984507576320": "旁路电压低",
  "alarm.name.1983799063247245312": "旁路电压高",
  "alarm.name.1983799119652245504": "旁路频率低",
  "alarm.name.1983799359339941888": "旁路频率高",
  "alarm.name.1983799416466362368": "旁路掉电",
  "alarm.name.1983799588046950400": "旁路浪涌",
  "alarm.name.1983799641507549184": "旁路内部通信故障",
  "alarm.name.1983799702828273664": "旁路对外通信故障",
  "alarm.name.1983799792024342528": "充电器故障汇总",
  "alarm.name.1983799934769090560": "充电器输出短路",
  "alarm.name.1983800029145124864": "充电器软启故障",
  "alarm.name.1983800191510827008": "充电器母线电压异常",
  "alarm.name.1983800321412616192": "充电器输出电压过低快检",
  "alarm.name.1983800427843080192": "充电器输出电压过高快检",
  "alarm.name.1983800588782718976": "充电器输出电压过高",
  "alarm.name.1983800831200907264": "充电器AC剩余充电功率不足（PV+AC联合充电）",
  "alarm.name.1983800908350935040": "充电器内部通信故障",
  "alarm.name.1983800957260713984": "充电器对外通信故障",
  "alarm.name.1983801024126308352": "充电器剩余充电功率不足（AC 边充边放）",
  "alarm.name.1983801174852816896": "充电器旁路突加载故障",
  "alarm.name.1983801276484997120": "放电器故障汇总",
  "alarm.name.1983801360270413824": "放电器电池低压故障",
  "alarm.name.1983801422564216832": "放电器母线低压故障",
  "alarm.name.1983801500246921216": "放电器电池高压故障",
  "alarm.name.1983801530043256832": "放电器电池电压过高故障",
  "alarm.name.1983801674272788480": "放电器内部通信故障",
  "alarm.name.1983801711178469376": "放电器对外通信故障",
  "alarm.name.1983801763913453568": "放电器电池电压过低故障",
  "alarm.name.1983801813964083200": "放电器软启故障",
  "alarm.name.1983801880162783232": "机型不匹配",
  "alarm.name.1983802428156989440": "系统内部通信故障",
  "alarm.name.1983802480975859712": "系统对外通信故障",
  "alarm.name.1983802827555393536": "PV1故障汇总",
  "alarm.name.1983802901488390144": "PV1DC 低压故障",
  "alarm.name.1983803047508889600": "PV2故障汇总",
  "alarm.name.1983803107101560832": "PV3故障汇总",
  "alarm.name.1983803140374974464": "PV4故障汇总",
  "alarm.name.1983803195307773952": "PV2DC 低压故障",
  "alarm.name.1983803306586853376": "PV3DC 低压故障",
  "alarm.name.1983803339541499904": "PV4DC 低压故障",
  "alarm.name.1983803446789853184": "PV1DC 高压故障",
  "alarm.name.1983803480814047232": "PV2DC 高压故障",
  "alarm.name.1983803517937831936": "PV3DC 高压故障",
  "alarm.name.1983803559033622528": "PV4DC 高压故障",
  "alarm.name.1983803683566702592": "PV1软启故障",
  "alarm.name.1983803721294467072": "PV2软启故障",
  "alarm.name.1983803752709804032": "PV3软启故障",
  "alarm.name.1983803780304130048": "PV4软启故障",
  "alarm.name.1983803898080186368": "PV1输出短路故障",
  "alarm.name.1983803925791952896": "PV2输出短路故障",
  "alarm.name.1983803954782982144": "PV3输出短路故障",
  "alarm.name.1983803993970364416": "PV4输出短路故障",
  "alarm.name.1983804062723395584": "PV1输出短路启机故障",
  "alarm.name.1983804095728373760": "PV2输出短路启机故障",
  "alarm.name.1983804134328553472": "PV3输出短路启机故障",
  "alarm.name.1983804180411371520": "PV4输出短路启机故障",
  "alarm.name.1983804292361539584": "PV1DC 电压过高",
  "alarm.name.1983804318785654784": "PV2DC 电压过高",
  "alarm.name.1983804351241179136": "PV3DC 电压过高",
  "alarm.name.1983804382799122432": "PV4DC 电压过高",
  "alarm.name.1983805670735663104": "PV1DC 电压过高快检",
  "alarm.name.1983805699131101184": "PV2DC 电压过高快检",
  "alarm.name.1983805731670511616": "PV3DC 电压过高快检",
  "alarm.name.1983805771549954048": "PV4DC 电压过高快检",
  "alarm.name.1983805909236371456": "PV2工作电压异常",
  "alarm.name.1983805851547914240": "PV1工作电压异常",
  "alarm.name.1983805970125082624": "PV3工作电压异常",
  "alarm.name.1983806003989893120": "PV4工作电压异常",
  "alarm.name.1983806249134379008": "PV1内部通信故障",
  "alarm.name.1983806276951003136": "PV2内部通信故障",
  "alarm.name.1983806306697007104": "PV3内部通信故障",
  "alarm.name.1983806337529335808": "PV4内部通信故障",
  "alarm.name.1983806382970425344": "PV1对外通信故障",
  "alarm.name.1983806416159952896": "PV2对外通信故障",
  "alarm.name.1983806448825192448": "PV3对外通信故障",
  "alarm.name.1983806475614212096": "PV4对外通信故障",
  "alarm.name.1983806605440503808": "PV1输入欠压",
  "alarm.name.1983806709912227840": "PV2输入欠压",
  "alarm.name.1983806865495740416": "PV3输入欠压",
  "alarm.name.1983806903714238464": "PV4输入欠压",
  "alarm.name.1983806981480828928": "PV1输入过压",
  "alarm.name.1983807014213177344": "PV2输入过压",
  "alarm.name.1983807174104240128": "PV3输入过压",
  "alarm.name.1983807225601904640": "PV4输入过压",
  "alarm.name.1983807375669907456": "并机1故障汇总",
  "alarm.name.1983807764880347136": "并机 ID 冲突故障",
  "alarm.name.1983807890071932928": "并机通信故障",
  "alarm.name.1983807932954497024": "并机频率体系不一致故障",
  "alarm.name.1983807973433724928": "并机失败故障",
  "alarm.name.1983808130623655936": "并机2故障汇总",
  "alarm.name.1983808183115370496": "并机均流故障",
  "alarm.name.1983808476930560000": "并机工频同步信号故障",
  "alarm.name.1983808751980433408": "电芯组均压高保护",
  "alarm.name.1983808836717957120": "电芯组均压低保护",
  "alarm.name.1983808893118763008": "电芯高压保护",
  "alarm.name.1983809224930152448": "电芯低压保护",
  "alarm.name.1983809331310284800": "电芯电池节数不匹配",
  "alarm.name.1983809418363064320": "电芯单体失效",
  "alarm.name.1983809481613168640": "电芯组压差过大（AFE 总压与 ADC 采样总压相差较大）",
  "alarm.name.1983809521521971200": "电芯严重高压保护",
  "alarm.name.1983809594037293056": "电芯严重低压保护",
  "alarm.name.1983809634688487424": "电芯严重低压保护关机",
  "alarm.name.1983809691420643328": "电芯一级强充状态-不控制，只播报",
  "alarm.name.1983809743006388224": "电芯二级强充状态-不控制，只播报",
  "alarm.name.1983809807141490688": "电芯严重过压保护",
  "alarm.name.1983810192287649792": "电芯充电过流快检",
  "alarm.name.1983810291432607744": "电芯放电过流快检",
  "alarm.name.1983810389604487168": "电芯充电过流错误",
  "alarm.name.1983810439260852224": "电芯放电过流错误",
  "alarm.name.1983810523394396160": "电芯采样温度探头未插",
  "alarm.name.1983810628767895552": "电芯一级过温保护（充电）",
  "alarm.name.1983810702575063040": "电芯二级过温保护（充电）",
  "alarm.name.1983810750222356480": "电芯一级低温保护（充电）",
  "alarm.name.1983810783957143552": "电芯二级低温保护（充电）",
  "alarm.name.1983810933953843200": "电芯一级过温保护（放电）",
  "alarm.name.1983810977994035200": "电芯一级低温保护（放电）",
  "alarm.name.1983811022726287360": "电芯二级过温保护（放电）",
  "alarm.name.1983811063117434880": "电芯二级低温保护（放电）",
  "alarm.name.1983811208496205824": "电芯环境过温保护",
  "alarm.name.1983811291191103488": "电芯环境低温保护",
  "alarm.name.1983811412058361856": "电芯MOS过温保护",
  "alarm.name.1983812771230961664": "EPS微逆输入浪涌",
  "alarm.name.1983811993133043712": "高压侧MOS采样探头未插",
  "alarm.name.1983812099588673536": "EPS微逆故障汇总",
  "alarm.name.1983812303893221376": "EPS微逆电压异常",
  "alarm.name.1983812383069097984": "EPS微逆频率异常",
  "alarm.name.1983812518926798848": "EPS微逆电压过低",
  "alarm.name.1983812723705303040": "EPS微逆输入掉电",
  "alarm.name.1983812896749703168": "EPS微逆继电器开路",
  "alarm.name.1983812992384028672": "EPS微逆输入过流",
  "alarm.name.1993612331686473728": "sy_校时上线告警",
  "alarm.desc.1993612331686473728": "2025年11月26日17:26:33",
  "alarm.name.2032119198336557056": "EPS微逆频率高故障",
  "alarm.name.2018505196888236032": "风扇转速低",
  "alarm.excDesc.2018505196888236032": "风扇转速低",
  "alarm.suggestion.2018505196888236032": "1、检查风扇是否有异物卡住\n2、检查风扇是否正常转动\n3、重启逆变器，不能恢复的话，请更换风扇",
  "alarm.desc.2018505196888236032": "\\",
  "alarm.name.2018505197106339840": "电压超范告警",
  "alarm.excDesc.2018505197106339840": "电压超范告警",
  "alarm.suggestion.2018505197106339840": "1.如偶然出现，为电网瞬时出现异常，电网复常后逆变器会恢复正常工作。\n2.如频繁报此故障， 请检查电网是否异常。",
  "alarm.desc.2018505197106339840": "\\",
  "alarm.name.2028758812129959936": "网侧过温保护",
  "alarm.name.2032265711215050752": "计量电表通信故障",
  "alarm.excDesc.2032265711215050752": "与网关通讯断开",
  "alarm.name.1997963644599709696": "TEST测试告警配置",
  "alarm.desc.1997963644599709696": "2025年12月8日17:37:05",
  "alarm.name.2033183990062383104": "系统压力过高告警",
  "alarm.excDesc.2033183990062383104": "过高",
  "alarm.suggestion.2033183990062383104": "需要处理",
  "alarm.desc.2033183990062383104": "需要处理说明",
  "alarm.name.2005894346846035969": "电池欠压",
  "alarm.desc.2005894346846035969": "1,当电池系统电压满足系统欠压告警清除条件后，此告警\n将自动清除。\n2,或修改EMS模式，将电池SOC强制充电至30%以上，此\n告警将自动清除。\n3,重启电池，观察电池侧告警是否可以自动清除。\n4,如电池侧告警一直无法清除，请联系电池厂商处理。\n5,如电池无异常告警，但告警依然存在，请联系经销商。 ",
  "alarm.name.2005894346846035970": "电池过压报警",
  "alarm.desc.2005894346846035970": "1,当电池系统电压满足系统过压告警清除条件后，此告警\n将自动清除。\n2,或修改EMS模式，将电池SOC强制放电至95%以下，\n此告警将自动清除。\n3,重启电池，观察电池侧告警是否可以自动清除。\n4,如电池侧告警一直无法清除，请联系电池厂商处理。\n5,如电池无异常告警，但告警依然存在，请联系经销商",
  "alarm.name.2005894346846035971": "电池组放电欠压报警",
  "alarm.desc.2005894346846035971": "1,当电池模组电压满足模组欠压告警清除条件后，此告警\n将自动清除。\n2,或修改EMS模式，将电池SOC强制充电至30%以上，\n此告警将自动清除。\n3,重启电池，观察电池侧告警是否可以自动清除。\n4,如电池侧告警一直无法清除，请联系电池厂商处理。\n5,如电池无异常告警，但告警依然存在，请联系经销商。",
  "alarm.name.2005894346846035972": "电池组充电过压报警",
  "alarm.desc.2005894346846035972": "1,当电池模组电压满足模组过压告警清除条件后，此告警\n将自动清除。\n2,或修改EMS模式，将电池SOC强制放电至95%以下，此\n告警将自动清除。\n3,重启电池，观察电池侧告警是否可以自动清除。\n4,如电池侧告警一直无法清除，请联系电池厂商处理。\n5,如电池无异常告警，但告警依然存在，请联系经销商。",
  "alarm.name.2005894346846035973": "充电低温报警",
  "alarm.desc.2005894346846035973": "1. 检查电池工作时，环温是否过低，如是，待环温上升后，告警将自动清除。 \n2. 重启电池，观察电池侧告警是否可以自动清除。 \n3. 如电池侧告警一直无法清除，请联系电池厂商处理。 \n4. 如电池无异常告警，但告警依然存在，请联系经销商",
  "alarm.name.2005894346846035974": "充电高温报警",
  "alarm.desc.2005894346846035974": "1. 检查电池工作时，环温是否过高，待环温降低后，告警将自动清除。 \n2. 检查电池的安装是否满足安装要求，如间距过小、阳光直射等，如是，请参考安装要求\n进行修改。 \n3. 检查电池的外包是否有杂物或泡沫覆盖，如是，则清理，保持电池外观无覆盖。 \n4. 重启电池，观察电池侧告警是否可以自动清除。 \n5. 如电池侧告警一直无法清除，请联系电池厂商处理。 \n6. 如电池无异常告警，但告警依然存在，请联系经销商。",
  "alarm.name.2005894346846035975": "放电低温报警",
  "alarm.desc.2005894346846035975": "1. 检查电池工作时，环温是否过低，如是，待环温上升后，告警将自动清除。 \n2. 重启电池，观察电池侧告警是否可以自动清除。 \n3. 如电池侧告警一直无法清除，请联系电池厂商处理。 \n4. 如电池无异常告警，但告警依然存在，请联系经销商。",
  "alarm.name.2005894346846035976": "放电高温报警",
  "alarm.desc.2005894346846035976": "1. 检查电池工作时，环温是否过高，待环温降低后，告警将自动清除。 \n2. 检查电池的安装是否满足安装要求，如间距过小、阳光直射等，如是，请参考安装要求\n进行修改。 \n3. 检查电池的外包是否有杂物或泡沫覆盖，如是，则清理，保持电池外观无覆盖。 \n4. 重启电池，观察电池侧告警是否可以自动清除。 \n5. 如电池侧告警一直无法清除，请联系电池厂商处理。 \n6. 如电池无异常告警，但告警依然存在，请联系经销商。",
  "alarm.name.2005894346846035977": "输入过压报警",
  "alarm.desc.2005894346846035977": "1,重启电池，观察电池侧告警是否可以自动清除。\n2,如电池侧告警一直无法清除，请联系电池厂商处理。\n3,如电池无异常告警，但告警依然存在，请联系经销商。",
  "alarm.name.2005894346846035978": "系统关机",
  "alarm.name.2005894346846035979": "硬件保护",
  "alarm.name.2005894346846035980": "比较器故障",
  "alarm.name.2005894346846035981": "SPI通信故障",
  "alarm.name.2005894346846035982": "ARM通信故障",
  "alarm.desc.2005894346846035982": "1,如因升级ARM版本导致告警，在升级完成后，告警会\n自动消除。\n2,断开交流输出侧开关、DC Switch和电池开关，5分钟后\n闭合，观察告警是否自动消除。\n3,如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846035983": "采样偏置异常",
  "alarm.desc.2005894346846035983": "1,请将逆变器的软件升级至最新版，观察告警是否自动消除。\n2,清除告警，观察逆变器是否可以恢复运行。\n3,断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，\n观察告警是否自动消除。\n4,如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846035984": "CMPSS偏置计算错误",
  "alarm.desc.2005894346846035984": "1,请将逆变器的软件升级至最新版，观察告警是否自动消除。\n2,清除告警，观察逆变器是否可以恢复运行。\n3,断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，\n观察告警是否自动消除。\n4,如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846035985": "EEPROM故障",
  "alarm.desc.2005894346846035985": "1,请将逆变器的软件升级至最新版，观察告警是否自动消除。\n2,清除告警，观察逆变器是否可以恢复运行。\n3,断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，\n观察告警是否自动消除。\n4,如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846035986": "光伏故障",
  "alarm.desc.2005894346846035986": "1. 测量组串开路电压，并观察组串开路电压是否在逆变器允许的范围内，如是，则进行步骤2。 \n2. 将组串接入PV端口并开机，观察逆变器检测的PV电压、电流是否正常。 \n3. 清除告警，观察逆变器是否可以恢复运行。 \n4. 断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，观察告警是否自动消除。 \n5. 如告警依然存在，请联系经销商",
  "alarm.name.2005894346846035987": "电池故障",
  "alarm.desc.2005894346846035987": "1. 请将逆变器的软件升级至最新版，观察告警是否自动消除。 \n2. 清除告警，观察逆变器是否可以恢复运行。 \n3. 断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，观察告警是否自动消除。 \n4. 如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846035988": "辅助电源异常",
  "alarm.desc.2005894346846035988": "1,请将逆变器的软件升级至最新版，观察告警是否自动消除。\n2,清除告警，观察逆变器是否可以恢复运行。\n3,断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，\n观察告警是否自动消除。\n4,如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846035989": "电网继电器保护",
  "alarm.name.2005894346846035990": "母线异常",
  "alarm.name.2005894346846035991": "风扇故障",
  "alarm.desc.2005894346846035991": "1,请将逆变器的软件升级至最新版，观察告警是否自动消除。\n2,清除告警，观察逆变器是否可以恢复运行。\n3,断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，\n观察告警是否自动消除。\n4,如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846035992": "机器类型不匹配",
  "alarm.desc.2005894346846035992": "暂未启用",
  "alarm.name.2005894346846035993": "版本不匹配",
  "alarm.desc.2005894346846035993": "1,请将逆变器的软件升级至最新版，观察告警是否自动消除。\n2,如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846035994": "接线异常",
  "alarm.name.2005894346846035995": " PV电压超过母线电压",
  "alarm.desc.2005894346846035995": "1. 请将逆变器的软件升级至最新版，观察告警是否自动消除。 \n2. 清除告警，观察逆变器是否可以恢复运行。 \n3. 断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，观察告警是否自动消除。 \n4. 如告警依然存在，请联系经销商。 ",
  "alarm.name.2005894346846035996": "驱动异常",
  "alarm.desc.2005894346846035996": "观察故障产生时，是否伴随着其他电网异常告警；如是，则是电\n网异常波动引起的，当电网恢复后，告警也会恢复。如果告警持\n续出现，则进行以下排查：\n\n1,请将逆变器的软件升级至最新版，观察告警是否自动消除。\n2,清除告警，观察逆变器是否可以恢复运行。\n3,断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，\n观察告警是否自动消除。\n4,如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846035997": "温度异常",
  "alarm.desc.2005894346846035997": "通常情况下，该告警会在环境温度恢复正常后自动清除，逆变器会自动恢复运行。当告警长\n时间无法且无法自动恢复时，请进行以下排查。\n\n1,检查并确认逆变器安装环境、空间是否满足用户手册的要求，如否，请参考用户手册的要\n求进行调整。\n2,检查并确认风扇风道或散热器是否存在堵塞或覆盖的情况，如是，请清理。\n3,检查并确认异常时刻是否伴随“风扇故障”告警，如是，请参考风扇异常告警处理方案进行\n排查。\n4,请将逆变器的软件升级至最新版，观察告警是否自动消除。\n5,清除告警，观察逆变器是否可以恢复运行。\n6,断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，观察告警是否自动消除。\n7,如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846035998": "EPS继电器保护",
  "alarm.desc.2005894346846035998": "观察故障产生时，是否伴随着其他电网异常告警；如是，则是电\n网异常波动引起的，当电网恢复后，告警也会恢复。如果告警持续\n出现，则进行以下排查：\n\n1,检查EPS负载侧是否有其他的电源供电，如有，请重新接线，\nEPS负载只能由逆变器的EPS端口供电。\n2,请将逆变器的软件升级至最新版，观察告警是否自动消除。\n3,清除告警，观察逆变器是否可以恢复运行。\n4,断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，\n观察告警是否自动消除。\n5,如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846035999": "电池电量过低",
  "alarm.desc.2005894346846035999": "1,离网情况下，需等待光伏组件给电池充电，等到电池SOC升到告\n警时的SOC+30时或电网恢复后，系统可以正常带载运行。\n2,如告警依然存在，请联系经销商。 ",
  "alarm.name.2005894346846036000": "EPS电压异常",
  "alarm.name.2005894346846036001": "EPS过载",
  "alarm.desc.2005894346846036001": "1,减小 EPS 侧负载总功率，或者移除部分 EPS 侧负载，逆变器会自动恢复运行。\n2,请将逆变器的软件升级至最新版，观察告警是否自动消除。\n3,清除告警，观察逆变器是否可以恢复运行。\n4,断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，观察告警是否自动消除。\n5,如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846036002": "发电机异常",
  "alarm.name.2005894346846036003": "发电机过载",
  "alarm.desc.2005894346846036003": "1,如果偶尔报警，可能是负载启停时功率波动过大导致的，\n待负载用电功率稳定后，该告警会自动清除，逆变器将自\n动恢复正常工作状态。\n2,观察故障产生时，是否有其他大型负载启动或使柴发超\n负荷工作的情况；\n请将负载的用电功率控制在柴发的额定功率范围内，柴发\n电压会趋于稳定。\n3,将交流端子拆下，检查交流接线处是否存在松动、熏黑、\n烧坏、融化等问题；如有，请修复。\n4,检测逆变器到柴发的连接线路中的线缆接头，空开的\n触点等位置是否存在松动、熏黑、烧坏、融化等问题；\n如有，请修复。\n5,检查EPS侧负载是否存在对地短路、相间短路等情况，\n如有，请修复。\n6,如以上均无问题，请断开交流输出侧开关、DC Switch\n和电池开关，5分钟后闭合，观察告警是否自动消除。",
  "alarm.name.2005894346846036004": "​​ 电表接线异常",
  "alarm.desc.2005894346846036004": "1,确保PV电表安装遵照用户手册说明。\n2,检查PV电表的CT的相序是否与输入电压的相序一致，\n如是，请调整相序或CT。\n3,检查PV电表的CT方向是否正常，PV电表的CT方向由外接\n光伏指向逆变器。\n4,请检查高级设置中的PV CT reverse是否设置正确，\n如否，请修复。\n5,如果是AC couple系统中，该告警持续产生，需要检测故\n障时刻，PV电流检测的电流是否为负值，正常情况下PV电\n流必须为正。\n6,如果系统中GEN端口未接外部光伏，需要将GEN Port设置\n为disable。",
  "alarm.name.2005894346846036005": "CAN通信超时",
  "alarm.desc.2005894346846036005": "1,检查主机（第一台）和最后一台逆变器的拨码开关是否拨到了\nON位置，如否，请将拨码拨到ON。\n2,检查通讯线两端RJ45端子的压接是否异常，如是，请重新更换\nRJ45端子后重新压接或更换通讯线。\n3,清除告警，观察逆变器是否可以恢复运行。\n4,请断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，\n观察告警是否自动消除。\n5,如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846036006": "预同步失败",
  "alarm.desc.2005894346846036006": "观察故障产生时，是否伴随着其他电网异常告警；如是，则是电网异常波动引起的，当电网\n恢复后，告警也会恢复。如果告警持续出现，则进行以下排查：\n\n1,请将逆变器的软件升级至最新版，观察告警是否自动消除。\n2,将 EMS 模式改成纯离网，观察逆变器离网模式下是否可以正常运行，且运行数据是否正常，\n如是，请切回原模式。\n3,清除告警，观察逆变器是否可以恢复运行。\n4,断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，观察告警是否自动消除。\n5,如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846036007": "PLL锁相失败",
  "alarm.desc.2005894346846036007": "暂未启用",
  "alarm.name.2005894346846036009": "电网过压",
  "alarm.desc.2005894346846036009": "通常，待电网恢复后，且满足并网文件的重连保护参数后，逆变器会重新连接。如果告警频\n繁出现，请进行以下排查。\n\n1,如果偶尔报警，可能是电网偶有异常。电网恢复正常后，逆变器自动恢复正常工作状态。\n2,根据当地电网要求，设置正确的并网法规。\n3,新并网机器需要检查交流接线端子是否存在相序接错的情况，特别是火线和零线接反问题。\n4,将交流端子拆下，检查交流接线处是否存在松动、熏黑、烧坏、融化等问题。\n5,检测逆变器的并网回路中的线缆接头、空开的触点等位置是否存在松动、熏黑、烧坏、\n融化等问题。\n6,如果逆变器并网后，采样电压上升明显，请检查交流导线的材质、线径、长度，建议\n根据推荐范围选择合适的导线。\n7,经当地电网公司同意后，适当调整逆变器并网文件中的电网 10 分钟过压保护值。\n8,断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，观察告警是否自动消除。\n9,如告警依然存在，请联系经销商。",
  "alarm.name.2018505197173448704": "PV短路告警",
  "alarm.excDesc.2018505197173448704": "PV短路告警",
  "alarm.suggestion.2018505197173448704": "关机后检查组件电压是否正常，重启不能恢复的话，说明逆变器内部故障",
  "alarm.desc.2018505197173448704": "\\",
  "alarm.name.2005894346846036011": "10分钟过压",
  "alarm.desc.2005894346846036011": "通常，待电网恢复后，且满足并网文件的重连保护参数后，逆变器会重新连接。如果告警\n频繁出现，请进行以下排查。\n\n1,如果偶尔报警，可能是电网偶有异常。电网恢复正常后，逆变器自动恢复正常工作状态。\n2,根据当地电网要求，设置正确的并网法规。\n3,新并网机器需要检查交流接线端子是否存在相序接错的情况，特别是火线和零线接反问题。\n4,将交流端子拆下，检查交流接线处是否存在松动、熏黑、烧坏、融化等问题。\n5,检测逆变器的并网回路中的线缆接头、空开的触点等位置是否存在松动、熏黑、烧坏、\n融化等问题。\n6,如果逆变器并网后，采样电压上升明显，请检查交流导线的材质、线径、长度，建议根据\n推荐范围选择合适的导线。\n7,经当地电网公司同意后，适当调整逆变器并网文件中的电网 10 分钟过压保护值。\n8,断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，观察告警是否自动消除。\n9,如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846036013": "电网欠频",
  "alarm.desc.2005894346846036013": "观察故障产生时，是否伴随着其他电网异常告警；\n如是，则是电网异常波动引起的，当电网恢复后，\n告警也会恢复。如果告警频繁出现，则进行以下排查：\n1,如果偶尔报警，可能是电网偶有异常。电网恢复正常\n后，逆变器自动恢复正常工作状态。\n2,观察故障产生时，是否有其他大型感性负载启动；\n待负载正常启动后，频率会趋于稳定。\n3,将交流端子拆下，检查交流接线处是否存在松动、\n熏黑、烧坏、融化等问题；如有，请修复。\n4,检测逆变器的并网回路中的线缆接头、空开的触\n点等位置是否存在松动、熏黑、烧坏、融化等问题；\n如有，请修复。\n5,经当地电网公司同意后，适当调整逆变器并网文件\n中欠频保护值。\n6,如以上均无问题，请断开交流输出侧开关、DC Switch\n 和电池开关，5分钟后闭合，观察告警是否自动消除。",
  "alarm.name.2005894346846036014": "频率变化率超限",
  "alarm.name.2005894346846036015": "重连失败",
  "alarm.desc.2005894346846036015": "1,检查选择的并网文件是否满足安装地的电网要求，如否，请选择\n合适的并网文件。\n2,检查故障时刻，电网的频率、电压是否满足并网文件中的重连\n参数要求，如不满足要求，需要在经过当地电网公司同意后，适\n当修改重连范围。\n3,如非以上两种情况，请将逆变器的软件升级至最新版，观察告警\n是否自动消除。\n4,清除告警，观察逆变器是否可以恢复运行。\n5,断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，\n观察告警是否自动消除。\n6,如告警依然存在，请联系经销商",
  "alarm.name.2005894346846036032": "闪存通信故障",
  "alarm.desc.2005894346846036032": "1,清除告警，观察逆变器是否可以恢复运行。\n2,断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，观察告警是否自动消除。\n3,如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846036033": "离网电压直流偏置超限",
  "alarm.name.2005894346846036034": "电网电流直流偏置超限",
  "alarm.name.2005894346846036012": "电网过频",
  "alarm.excDesc.2005894346846036012": "电网过频",
  "alarm.suggestion.2005894346846036012": "1. 确认逆变器交流输出频率是否满足电网要求。\n2. 确认交流线相序连接正确，N线、PE接线顺序正确、牢固。\n3. 确认故障发生频率，如果偶尔发生，可能是瞬时电网频率变化导致，无需处理。",
  "alarm.desc.2005894346846036012": "1. 确认逆变器交流输出频率是否满足电网要求。\n2. 确认交流线相序连接正确，N线、PE接线顺序正确、牢固。\n3. 确认故障发生频率，如果偶尔发生，可能是瞬时电网频率变化导致，无需处理。",
  "alarm.name.2028758757377515520": "网侧欠频保护",
  "alarm.name.2032268885783085056": "设备通信故障",
  "alarm.name.2033184073625501696": "出水压力过高告警",
  "alarm.name.2018505197001482240": "防逆流电表通信异常",
  "alarm.excDesc.2018505197001482240": "防逆流电表通信异常",
  "alarm.suggestion.2018505197001482240": "检查电表接线是否错误",
  "alarm.desc.2018505197001482240": "\\",
  "alarm.name.2005894346846036016": "电网断电",
  "alarm.desc.2005894346846036016": "通常，电网恢复后，逆变器会重新连接。\n\n1,如果偶尔报警，可能是电网偶有异常。电网恢复正常后，逆变器自动恢复正常工作状态。\n2,检查交流侧是否加装了自恢复型过欠压保护器或漏电保护器。如果保护器频繁动作，在当\n地电网同意后，更换更大规格的保护器或拆除。\n3,根据当地电网要求，设置正确的并网文件。\n4,新并网机器需要检查交流接线端子是否存在相序接错的情况，特别是火线和零线接反问题。\n5,将交流端子拆下，检查交流接线处是否存在松动、熏黑、烧坏等问题。\n6,检测逆变器的并网回路中的线缆接头、空开的触点等位置是否存在松动、熏黑、烧坏、融\n化等问题。\n7,如果逆变器并网后，采样电压上升明显，请检查交流导线的材质、线径、长度，建议根据\n推荐范围选择合适的导线。\n8,断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，观察告警是否自动消除。\n9,如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846036017": "零线未连接",
  "alarm.desc.2005894346846036017": "暂未启用",
  "alarm.name.2005894346846036018": "对地故障（相线对地）",
  "alarm.desc.2005894346846036018": "暂未启用",
  "alarm.name.2005894346846036019": "零线对地故障",
  "alarm.desc.2005894346846036019": "暂未启用",
  "alarm.name.2005894346846036020": "机型不匹配",
  "alarm.desc.2005894346846036020": "暂未启用",
  "alarm.name.2005894346846036021": "版本不匹配",
  "alarm.desc.2005894346846036021": "1,请将逆变器的软件升级至最新版，观察告警是否自动消除。\n2,如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846036022": " 电弧自检故障",
  "alarm.desc.2005894346846036022": "1. 请将逆变器的软件更新至最新版，观察故障是否消除。 \n2. 请断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，观察告警是否自动消除。 \n3. 尝试将直流电弧功能关闭，观察逆变器是否可以正常运行。 \n4. 如告警依然存在，则可能是采样电路存在异常，请联系经销商。",
  "alarm.name.2005894346846036023": "电弧故障",
  "alarm.desc.2005894346846036023": "1,请将逆变器的软件更新至最新版，观察故障是否消除。\n2,请断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，\n观察告警是否自动消除。\n3,尝试将直流电弧功能关闭，观察逆变器是否可以正常运行。\n4,如告警依然存在，则可能是采样电路存在异常，请联系经销商。",
  "alarm.name.2005894346846036024": "绝缘故障",
  "alarm.name.2005894346846036025": "漏电保护器自检故障",
  "alarm.desc.2005894346846036025": "1,请将逆变器的软件升级至最新版，观察告警是否自动消除。\n2,清除告警，观察逆变器是否可以恢复运行。\n3,请断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，观察告警是否自动消除。\n4,如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846036026": "漏电保护器故障",
  "alarm.desc.2005894346846036026": "1,如果该告警只发生在阴雨或雨雪天气中，此时空气湿度大可能\n导致临时绝缘下降，待天气好转后，故障可自动消除。\n2,检查光伏组件、电缆槽等区域是否有积水或渗水痕迹，如是，则现场整改。\n3,查看是否有 PV 电缆外皮破损、动物啃咬、组件玻璃碎裂或背板烧焦痕迹，\n如有，则更换相应的器件。\n4,使用万用表测量组串的开路电压和 PV 组串正极对地电压、PV 负极对地电压。\n正常情况下 PV 正负极对地电压均为组串开路电压的一半，电压值持续下降，\n无限接近于 0。\n5,使用兆欧表 1000V 档测量 PV 组串正极对地、负极对地电阻，正常值应＞1MΩ。\n当阻值过低时，则说明该组串绝缘存在异常。\n6,如逆变器有多个 PV 组串时，可以将 PV 组串依次接入逆变器。在每次插拔组串前，\n需要将逆变器关机，通过逆变器的绝缘阻抗检测功能筛选异常的组串。对于异常的组串，\n可以采用分段法进行定位，找到异常点。\n7,将电网侧断电后，使用兆欧表测量交流侧相间、相对地、N 对 PE、和相对 N 之间\n的电阻，正常值应＞1MΩ。\n8,请将逆变器的软件升级至最新版，观察告警是否自动消除。\n9,请断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，观察告警是否自动消除。\n10,如告警依然存在，则可能是采样电路存在异常，请联系经销商。",
  "alarm.name.2005894346846036027": "电网继电器保护",
  "alarm.name.2005894346846036028": "辅助电源异常",
  "alarm.desc.2005894346846036028": "1. 请将逆变器的软件升级至最新版，观察告警是否自动消除。 \n2. 清除告警，观察逆变器是否可以恢复运行。 \n3. 断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，观察告警是否自动消除。 \n4. 如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846036029": "SPI通信故障",
  "alarm.name.2005894346846036030": "ARM通信故障",
  "alarm.desc.2005894346846036030": "1. 如因升级 ARM 版本导致告警，在升级完成后，告警会自动消除。 \n2. 断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，观察告警是否自动消除。 \n3. 如告警依然存在，请联系经销商",
  "alarm.name.2005894346846036031": "采样偏置异常",
  "alarm.desc.2005894346846036031": "1,请将逆变器的软件更新至最新版，观察故障是否消除。\n2,请断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，\n观察告警是否自动消除。\n3,尝试将直流电弧功能关闭，观察逆变器是否可以正常运行。\n4,如告警依然存在，则可能是采样电路存在异常，请联系经销商。",
  "alarm.name.2028758625105944576": "网侧过压保护",
  "alarm.name.2005894346846036035": "中断溢出",
  "alarm.desc.2005894346846036035": "1,请将逆变器的软件更新至最新版，观察故障是否消除。\n2,请断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，\n观察告警是否自动消除。\n3,尝试将直流电弧功能关闭，观察逆变器是否可以正常运行。\n4,如告警依然存在，则可能是采样电路存在异常，请联系经销商。",
  "alarm.name.2005894346846036036": "微电子故障",
  "alarm.desc.2005894346846036036": "1,请将逆变器的软件更新至最新版，观察故障是否消除。\n2,请断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，\n观察告警是否自动消除。\n3,尝试将直流电弧功能关闭，观察逆变器是否可以正常运行。\n4,如告警依然存在，则可能是采样电路存在异常，请联系经销商。",
  "alarm.name.2005894346846036037": "环境温度过低",
  "alarm.desc.2005894346846036037": "通常情况下，该告警会在环境温度升高后自动清除，逆变器会自动恢复运行。当告警长时间无\n法且无法自动恢复时，请进行以下排查。\n\n1,检查并确认逆变器安装环境、空间是否满足用户手册的要求，如否，请参考用户手册的要求\n进行调整。\n2,请将逆变器的软件升级至最新版，观察告警是否自动消除。\n3,清除告警，观察逆变器是否可以恢复运行。\n4,断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，观察告警是否自动消除。\n5,如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846036038": "​​ 过温",
  "alarm.desc.2005894346846036038": "通常情况下，该告警会在环境温度降低后自动清除，逆变器会自动恢复运行。当告警长时间无\n法且无法自动恢复时，请进行以下排查。\n\n1,检查并确认逆变器安装环境、空间是否满足用户手册的要求，如否，请参考用户手册的要求\n进行调整。\n2,检查并确认风扇风道或散热器是否存在堵塞或覆盖的情况，如是，请清理。\n3,检查并确认异常时刻是否伴随“风扇故障”告警，如是，请参考风扇异常告警处理方案进行排\n查。\n4,请将逆变器的软件升级至最新版，观察告警是否自动消除。\n5,清除告警，观察逆变器是否可以恢复运行。\n6,断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，观察告警是否自动消除。\n7,如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846036039": "比较器故障",
  "alarm.name.2005894346846036040": "风扇故障",
  "alarm.desc.2005894346846036040": "1,检查故障时刻，是否存在某个风扇不转的情况，如是，可以尝试\n使用外力助力风扇旋转，如仍无法旋转，可以进行下一步。\n2,如果只是其他一个风扇不转，可将逆变器完全关机后，将两个风\n扇互换供电线路，观察并判断是风扇问题还是内部供电线路问题。\n如果对调后，原来的异常风扇仍无法运行，则可能是风扇故障，请\n更换风扇。\n3,请断开交流输出侧开关、DC Switch和电池开关，5分钟后闭合，\n观察告警是否自动消除。\n4,如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846036041": "​DSP电源通信异常",
  "alarm.name.2005894346846036042": "​DSP安全通信异常​",
  "alarm.name.2005894346846036043": "光伏电表通信异常",
  "alarm.name.2005894346846036044": "电网电表通信异常",
  "alarm.desc.2005894346846036044": "检查电表的供电是否正常，显示屏是否可以正常点亮；如否，请检查电源供电和电表自身问题，\n如是电源问题，请修复，如电表问题，请联系经销商或禾迈技术服务中心，否则，进行以下检\n查。如安装 HMID 时，电表通讯异常排查方法同下。\n\n1,检查通讯线缆是否存在开路、短路、A/B 线接反的问题，如果有，请改正或更换线缆。\n2,检查电表的地址、波特率，数据位，检验位与主机不一致，如不一致，请更正；请注意：\n电网侧的电表地址为 002，GEN 侧的电表为 001。\n3,为保证电表与主机的通讯协议一致，请使用禾迈配发的电表或从禾迈购买的电表。\n4,如果电表与逆变器存在通讯频繁中断，可能现场存在干扰，需要将逆变器的外壳可靠接\n地，接地电阻小于 4Ω。\n5,如果通讯距离超过 100 米，且参数设置正确，则在通讯线缆的开始处或终端处加装匹\n配 120Ω 的匹配电阻；当使用网线进行通讯时，通讯距离不允许超过 60 米。\n6,断开电表和逆变器之间的通讯接线，单独测量电表的 485 线缆电压，正常情况下，电表\n的 485 电压在 4.5V 左右，如果电压为 0，在排除线缆异常的情况下，建议更换电表。\n7,断开电表和逆变器之间的通讯接线，单独测量逆变器 meter 端口的 485 线缆电压，正常\n情况下，meter 端口 4 和 5 之间的电压在 4.5V 左右，如果电压为 0，请联系经销商。",
  "alarm.name.2005894346846036045": "BMS_CAN 通信异常",
  "alarm.desc.2005894346846036045": "如果系统实际没有安装电池，请设置电池类型为 No Battery。\n如果是锂电池，则进行以下排查：\n\n1,检查电池型号是否在逆变器的匹配列表内，如否，建议更换电池。\n2,请将逆变器和 BMS 的软件版本均更新至最新版，观察告警是否可以清除。\n3,检查通讯线的线序是否正确，BMS 的线序和逆变器的线序需要与安装手册保持一致，\nBMS 端和逆变器端是否接反，如是，请修复以上问题或更换通讯线。\n4,检查 BMS 是否正常开机，如否，请正常开机。部分厂家的电池通讯时有拨码的限制，\n需要根据用户手册进行拨码。\n5,重启电池，观察通讯是否恢复。\n6,将逆变器的外壳和电池的外壳可靠接地，接地电阻小于 4Ω。\n7,检查电池的故障指示灯是否亮起，如是，请联系电池厂家进行故障排查。\n8,断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，使用万用表测量逆变器\n的 BMS 端口 4 和 5 之间的阻值。正常情况下，阻值为 130Ω 左右。如果阻值偏大，\n或无阻值，可能是逆变器内部通讯板出现异常，可以尝试更换逆变器，观察新逆变器是\n否可以和电池通讯。如是，请联系经销商。",
  "alarm.name.2005894346846036046": "DTU版本过低",
  "alarm.name.2005894346846036047": "DTS 通信异常",
  "alarm.desc.2005894346846036047": "通常情况下，该告警会在DTS连接逆变器后自动清除，如果该告警频繁出现，请进行以下排查。\n\n1,请将DTS的软件升级至最新版，观察告警是否自动消除。\n2,检查路由器和DTS之间的通讯距离是否过长，中间是否有墙隔开，在DTS处测试路由器的WiFi\n信号是否过弱。\n3,检查网关心跳中的csq值是否过低，正常csq值需要大于50，100时信号最好。\n4,检查DTS和逆变器连接是否紧固可靠，如否，请紧固DTS的固定螺丝。\n5,检查故障时刻，当地是否出现了网络中断的情况。\n6,断开交流输出侧开关、DC Switch和电池开关，5分钟后闭合，观察告警是否自动消除。\n7,如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846036048": " 电网电表类型错误",
  "alarm.desc.2005894346846036048": "1,检查现场是否存在单相电表接在三相逆变器的系统中，如是，请更换成三相电表。\n2,检查现场是否存在单相电表接在裂相逆变器的系统中，如是，请更换成裂相电表。\n3,检查现场是否存在裂相电表接在单相逆变器的系统中，如是，请根据系统电网类型更换单\n相或三相电表。\n4,请将逆变器的软件升级至最新版，观察告警是否自动消除。\n5,断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，观察告警是否自动消除。\n6,如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846036049": "光伏电表类型错误",
  "alarm.desc.2005894346846036049": "1,检查现场是否存在单相电表接在三相逆变器的系统中，如是，请更换成三相电表。\n2,检查现场是否存在单相电表接在裂相逆变器的系统中，如是，请更换成裂相电表。\n3,检查现场是否存在裂相电表或三相电表接在单相逆变器的系统中，如是，请更换成单相电表。\n4,请将逆变器的软件升级至最新版，观察告警是否自动消除。\n5,清除告警，观察逆变器是否可以恢复运行。\n6,断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，观察告警是否自动消除。\n7,如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846036050": "从机电池连接错误 \n（多PCS，单电池）",
  "alarm.desc.2005894346846036050": "1,检查系统是否为多PCS并联场景，如是，则进行步骤2，如否，则进行步骤3。\n2,检查其余主机是否与电池进行了通讯连接，如是，请断开从机与电池的通讯连接，并清除告\n警。\n3,请将逆变器的软件升级至最新版，观察告警是否自动消除。\n4,清除告警，观察逆变器是否可以恢复运行。\n5,断开交流输出侧开关、DC Switch 和电池开关，5 分钟后闭合，观察告警是否自动消除。\n6,如告警依然存在，请联系经销商",
  "alarm.name.2005894346846036051": "DTU1 RS485 通信异常",
  "alarm.desc.2005894346846036051": "1,请将逆变器的软件升级至最新版，观察告警是否自动消除。\n部分老的版本不支持此功能。\n2,检查通讯线缆是否存在开路、短路、接反的问题，如果有，\n请改正或更换线缆。\n3,检查DTU的地址是否设置正确，DTU-1的地址为101，如错\n误，请更正。\n4,如果DTU与逆变器存在通讯频繁中断，可能现场存在干扰，\n需要将逆变器的外壳可靠接地，接地电阻小于4Ω。\n5,如果通讯距离超过200米，且参数设置正确，当RS485电缆\n长度超过200米时，建议在最远段DTU的RS485端口前两个引\n脚上使用短路跳线。\n6,测量DTU的485线缆电压，万用表的红表笔接485-A，黑表\n笔接485-B；正常情况下，DTU的485电压在4.5V左右，如果\n电压为0，在排除线缆异常的情况下，建议更换DTU。\n7,测量逆变器BMS端口的485线缆电压，万用表的红表笔接7，\n黑表笔接8；正常情况下，BMS端口7和8之间的电压在4.5V左\n右，如果测量正常，请联系经销商",
  "alarm.name.2005894346846036052": " DTU2 RS485 通信异常",
  "alarm.desc.2005894346846036052": "1,请将逆变器的软件升级至最新版，观察告警是否自动消除。\n部分老的版本不支持此功能。\n2,检查通讯线缆是否存在开路、短路、接反的问题，如果有，\n请改正或更换线缆。\n3,检查DTU的地址是否设置正确，DTU-2的地址为102，如错误，\n请更正。\n4,如果DTU与逆变器存在通讯频繁中断，可能现场存在干扰，\n需要将逆变器的外壳可靠接地，接地电阻小于4Ω。\n5,如果通讯距离超过200米，且参数设置正确，当RS485电缆\n长度超过200米时，建议在最远段DTU的RS485端口前两个引\n脚上使用短路跳线。\n6,测量DTU的485线缆电压，万用表的红表笔接485-A，黑表\n笔接485-B；正常情况下，DTU的485电压在4.5V左右，如果\n电压为0，在排除线缆异常的情况下，建议更换DTU。\n7,测量逆变器BMS端口的485线缆电压，万用表的红表笔接7，\n黑表笔接8；正常情况下，BMS端口7和8之间的电压在4.5V左右，\n如果测量正常，请联系经销商",
  "alarm.name.2005894346846036053": "DTU3 RS485 通信异常",
  "alarm.desc.2005894346846036053": "1,请将逆变器的软件升级至最新版，观察告警是否自动消除。部分\n老的版本不支持此功能。\n2,检查通讯线缆是否存在开路、短路、接反的问题，如果有，请改\n正或更换线缆。\n3,检查DTU的地址是否设置正确，DTU-3的地址为103，如错误，\n请更正。\n4,如果DTU与逆变器存在通讯频繁中断，可能现场存在干扰，需\n要将逆变器的外壳可靠接地，接地电阻小于4Ω。\n5,如果通讯距离超过200米，且参数设置正确，当RS485电缆长度\n超过200米时，建议在最远段DTU的RS485端口前两个引脚上使用\n短路跳线。\n6,测量DTU的485线缆电压，万用表的红表笔接485-A，黑表笔接\n485-B；正常情况下，DTU的485电压在4.5V左右，如果电压为0，\n在排除线缆异常的情况下，建议更换DTU。\n7,测量逆变器BMS端口的485线缆电压，万用表的红表笔接7，黑表\n笔接8；正常情况下，BMS端口7和8之间的电压在4.5V左右，如果\n测量正常，请联系经销商。",
  "alarm.name.2005894346846036065": "人机交互界面通信异常",
  "alarm.desc.2005894346846036065": "1,检查通讯线缆是否存在开路、短路、A/B线接反的问题，如果有，请改正或更换线缆。\n2,如果HMID与逆变器存在通讯频繁中断，可能现场存在干扰，需要将逆变器的外壳可靠接地，\n接地电阻小于4Ω。\n3,如果通讯距离超过100米，且参数设置正确，则在通讯线缆的开始处或终端处加装匹配\n120Ω的匹配电阻；当使用网线进行通讯时，通讯距离不允许超过60米。\n4,断开电表和逆变器之间的通讯接线，单独测量逆变器meter端口的485线缆电压，正常情\n况下，meter端口4和5之间的电压在4.5V左右，如果电压为0，请联系经销商。",
  "alarm.name.2005894346846036054": "DTU4 RS485 通信异常",
  "alarm.desc.2005894346846036054": "1,请将逆变器的软件升级至最新版，观察告警是否自动消除。部分\n老的版本不支持此功能。\n2,检查通讯线缆是否存在开路、短路、接反的问题，如果有，请改\n正或更换线缆。\n3,检查DTU的地址是否设置正确，DTU-4的地址为104，如错误，请\n更正。\n4,如果DTU与逆变器存在通讯频繁中断，可能现场存在干扰，需要\n将逆变器的外壳可靠接地，接地电阻小于4Ω。\n5,如果通讯距离超过200米，且参数设置正确，当RS485电缆长度\n超过200米时，建议在最远段DTU的RS485端口前两个引脚上使用\n短路跳线。\n6,测量DTU的485线缆电压，万用表的红表笔接485-A，黑表笔接\n485-B；正常情况下，DTU的485电压在4.5V左右，如果电压为0，\n在排除线缆异常的情况下，建议更换DTU。\n7,测量逆变器BMS端口的485线缆电压，万用表的红表笔接7，黑表\n笔接8；正常情况下，BMS端口7和8之间的电压在4.5V左右，如果\n测量正常，请联系经销商。 ",
  "alarm.name.2005894346846036055": " DTU5 RS485 通信异常",
  "alarm.desc.2005894346846036055": "1,请将逆变器的软件升级至最新版，观察告警是否自动消除。部分\n老的版本不支持此功能。\n2,检查通讯线缆是否存在开路、短路、接反的问题，如果有，请改\n正或更换线缆。\n3,检查DTU的地址是否设置正确，DTU-5的地址为105，如错误，\n请更正。\n4,如果DTU与逆变器存在通讯频繁中断，可能现场存在干扰，需要\n将逆变器的外壳可靠接地，接地电阻小于4Ω。\n5,如果通讯距离超过200米，且参数设置正确，当RS485电缆长度\n超过200米时，建议在最远段DTU的RS485端口前两个引脚上使用\n短路跳线。\n6,测量DTU的485线缆电压，万用表的红表笔接485-A，黑表笔\n接485-B；正常情况下，DTU的485电压在4.5V左右，如果电压\n为0，在排除线缆异常的情况下，建议更换DTU。\n7,测量逆变器BMS端口的485线缆电压，万用表的红表笔接7，黑表\n笔接8；正常情况下，BMS端口7和8之间的电压在4.5V左右，如果\n测量正常，请联系经销商 ",
  "alarm.name.2005894346846036056": "电动汽车充电桩1通信异常",
  "alarm.desc.2005894346846036056": "1,请将逆变器的软件升级至最新版，观察告警是否自动消除。部分\n老的版本不支持此功能。\n2,检查通讯线缆是否存在开路、短路、接反的问题，如果有，请改\n正或更换线缆。\n3,如果与逆变器存在通讯频繁中断，可能现场存在干扰，需要将逆\n变器的外壳可靠接地，接地电阻小于4Ω。\n4,测量充电桩的485线缆电压，万用表的红表笔接485‑A，黑表笔\n接485‑B；正常情况下，充电桩的485电压在2.0V左右，如果电压\n为0，在排除线缆异常的情况下，建议更换充电桩。\n5,测量逆变器BMS端口的485线缆电压，万用表的红表笔接7，黑表\n笔接8；正常情况下，BMS端口7和8之间的电压在4.5V左右，如果\n测量正常，请联系经销商。",
  "alarm.name.2005894346846036057": "电动汽车充电桩2通信异常",
  "alarm.desc.2005894346846036057": "1,请将逆变器的软件升级至最新版，观察告警是否自动消除。部分\n老的版本不支持此功能。\n2,检查通讯线缆是否存在开路、短路、接反的问题，如果有，请改\n正或更换线缆。\n3,如果与逆变器存在通讯频繁中断，可能现场存在干扰，需要将逆\n变器的外壳可靠接地，接地电阻小于4Ω。\n4,测量充电桩的485线缆电压，万用表的红表笔接485‑A，黑表笔\n接485‑B；正常情况下，充电桩的485电压在2.0V左右，如果电压\n为0，在排除线缆异常的情况下，建议更换充电桩。\n5,测量逆变器BMS端口的485线缆电压，万用表的红表笔接7，黑表\n笔接8；正常情况下，BMS端口7和8之间的电压在4.5V左右，如果\n测量正常，请联系经销商。",
  "alarm.name.2005894346846036058": "充电桩1故障",
  "alarm.desc.2005894346846036058": "1,根据充电桩的故障排查指导进行处理，找出故障原因并\n修复。\n2,如充电桩无异常，但是逆变器持续告警，请断开交流输出\n侧开关、DC Switch 和电池开关，5分钟后闭合，观察告警\n是否自动消除。\n3,如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846036059": "充电桩2故障",
  "alarm.desc.2005894346846036059": "1,根据充电桩的故障排查指导进行处理，找出故障原因并\n修复。\n2,如充电桩无异常，但是逆变器持续告警，请断开交流输出\n侧开关、DC Switch 和电池开关，5分钟后闭合，观察告警\n是否自动消除。\n3,如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846036060": "持续负负载",
  "alarm.desc.2005894346846036060": "1,观察系统内是否存在外部光伏逆变器，且光伏逆变器的\n发电功率没有被PV电表统计到，如是，请调整现场接线，\n使PV电表完全统计到光伏逆变器的发电量。\n2,检查PV电表是否和逆变器通讯正常，如否，请参考\nERR-381进行排查。\n3,检查网侧电表是否存在错相、反向或CT卡接不到位，\n导致功率采样异常的情况，如是，请修复。\n4,检查网侧电表的CT是否设置正确，如果CT变比设置错误，\n请根据CT的真实变比进行设置。\n5,检查PV电表的CT是否设置正确，如果CT变比设置错误，\n请根据CT的真实变比进行设置。\n6,如以上检查均无异常，请将逆变器的软件升级至最新版，\n观察告警是否可以消除。\n7,断开交流输出侧开关、DC Switch和电池开关，5分钟后\n闭合，观察告警是否自动消除。",
  "alarm.name.2005894346846036061": " 电池容量异常",
  "alarm.desc.2005894346846036061": "1,检测故障时刻，电池包数量是否进行了改变，如是，请重\n新设置实际的电池容量。\n2,重新设置电池容量。\n3,如告警依然存在，请联系经销商。",
  "alarm.name.2005894346846036062": "电池故障",
  "alarm.desc.2005894346846036062": "1,通常此告警产生时，电池侧必存在异常告警，且当电池类告警\n清除后，此告警将自动清除，无需处理。\n2,重启电池，观察电池侧告警是否可以自动清除。\n3,如电池侧告警一直无法清除，请联系电池厂商处理。\n4,如电池无异常告警，但告警依然存在，请联系经销商。",
  "alarm.name.2005894346846036063": "风扇转速异常",
  "alarm.name.2005894346846036064": " 电池强制充电请求",
  "alarm.desc.2005894346846036064": "无需处理",
  "alarm.name.2005894346846036066": "人机交互界面设备故障",
  "alarm.desc.2005894346846036066": "1,检测到HMID告警异常，检查继电器是否正常，各部分继电器是否正常吸合断开；\n2,检查电表和HMID通信线是否正常；\n3,检查辅助电源是否正常；\n4,检查急停开关是否被按下；\n5,实时数据观察电网，柴发，光伏，智能负载，各部分端口电流是否过大！\n6,如HMID设备无异常，但告警依然存在，请联系经销商。",
  "alarm.name.2005894346846036067": "主从通信异常",
  "alarm.name.2005894346846036068": "KM继电器故障",
  "alarm.name.2005894346846036069": "​​ 发电机A继电器故障",
  "alarm.name.2005894346846036070": "发电机B继电器故障",
  "alarm.name.2005894346846036071": "光伏AB继电器故障",
  "alarm.name.2005894346846036072": "负载A继电器故障",
  "alarm.name.2005894346846036073": "​​ 负载B继电器故障",
  "alarm.name.2005894346846036074": "电网电表通信失败",
  "alarm.name.2005894346846036075": "逆变器通信失败",
  "alarm.name.2005894346846036076": "逆变器CAN通信失败",
  "alarm.name.2005894346846036077": "过热报警",
  "alarm.name.2005894346846036078": "3.3V电源故障",
  "alarm.name.2005894346846036079": " 5V电源故障",
  "alarm.name.2005894346846036080": "12V电源故障",
  "alarm.name.2005894346846036081": "紧急停止",
  "alarm.name.2005894346846036082": "电网端口过流",
  "alarm.name.2005894346846036083": "发电机端口过流",
  "alarm.name.2005894346846036084": "光伏端口过流",
  "alarm.name.2005894346846036085": "智能负载端口过流",
  "alarm.name.232": "设备型号不匹配",
  "alarm.excDesc.232": "设备型号不匹配",
  "alarm.suggestion.232": "联系上能电气售后服务中心",
  "alarm.desc.232": "设备型号不匹配",
  "alarm.name.2018953676272898048": "内存不足",
  "alarm.name.2032106970728243200": "PV1 DC低压告警",
  "alarm.name.2032271415397187584": "AI机器人离线",
  "alarm.excDesc.2032271415397187584": "1）检查现场网络与电源是否断开；2）尝试重启AI机器人。",
  "alarm.name.2035232200977154048": "风扇转速低告警",
  "alarm.excDesc.2035232200977154048": "风扇转速低告警",
  "alarm.suggestion.2035232200977154048": "1、检查风扇是否有异物卡住\n2、检查风扇是否正常转动\n3、重启逆变器，不能恢复的话，请更换风扇",
  "alarm.desc.2035232200977154048": "\\",
  "alarm.name.6": "相序反接",
  "alarm.excDesc.6": "相序反接",
  "alarm.suggestion.6": "1. 确认交流线相序连接正确\n2. 若无需相序检测，可开启相序自适应功能",
  "alarm.desc.6": "相序反接",
  "alarm.name.5": "无市电",
  "alarm.excDesc.5": "无市电",
  "alarm.suggestion.5": "一般情况下， 电网恢复正常后逆变器会重新并网。若反复出现：\n1. 确认逆变器上级交流开关是否已闭合。\n2. 确认交流线相序连接正确，N线、PE接线顺序正\n确、牢固。",
  "alarm.desc.5": "无市电",
  "alarm.name.7": "漏电流故障",
  "alarm.excDesc.7": "漏电流故障",
  "alarm.suggestion.7": "等待逆变器恢复正常，若反复出现：\n1.电池板环境潮湿或者光照不良会导致该故障，一般情况下，环境改善后逆变器会重新并网；\n2.如果环境正常，检查直流及交流线缆绝缘是否正常；\n3.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.7": "漏电流故障",
  "alarm.name.9": "输出电流直流分量高",
  "alarm.excDesc.9": "输出电流直流分量高",
  "alarm.suggestion.9": "若频繁发生，请确认交流线相序连接正确，N线、PE接线顺序正确、牢固。",
  "alarm.desc.9": "输出电流直流分量高",
  "alarm.name.214": "温度低",
  "alarm.excDesc.214": "温度低",
  "alarm.suggestion.214": "等待环境温度恢复至规格书范围内，逆变器自动开机",
  "alarm.desc.214": "温度低",
  "alarm.name.221": "MPPT启动电压超出范围",
  "alarm.excDesc.221": "MPPT启动电压超出范围",
  "alarm.suggestion.221": "检查光伏电池板的串联配置，保证每个组串的开路电压低于逆变器的最大工作电压，配置正确后，逆变器自动开机",
  "alarm.desc.221": "MPPT启动电压超出范围",
  "alarm.name.2018955023013580800": "CPU过载",
  "alarm.name.20009": "电网低压穿越",
  "alarm.excDesc.20009": "电网低压穿越",
  "alarm.suggestion.20009": "确认逆变器交流输出侧电压是否满足电网要求",
  "alarm.desc.20009": "电网低压穿越",
  "alarm.name.33": "BUS过压",
  "alarm.excDesc.33": "BUS过压",
  "alarm.suggestion.33": "1. 重启逆变器，确认逆变器是否可以正常工作。\n2. 确认PV组串电压是否满足逆变器最大输入电压\n要求。",
  "alarm.desc.33": "BUS过压",
  "alarm.name.40": "PV过压",
  "alarm.excDesc.40": "PV过压",
  "alarm.suggestion.40": "1. 确认PV组串输入电压与逆变器显示值是否一致。\n2. 确认PV组串电压是否满足逆变器最大输入电压\n要求。",
  "alarm.desc.40": "PV过压",
  "alarm.name.42": "PV过配",
  "alarm.excDesc.42": "PV过配",
  "alarm.suggestion.42": "1. 确认PV组串输入电压与逆变器显示值是否一致。\n2. 确认PV组串电压是否满足逆变器最大输入电压\n要求。",
  "alarm.desc.42": "PV过配",
  "alarm.name.80": "外部风扇故障",
  "alarm.excDesc.80": "外部风扇故障",
  "alarm.suggestion.80": "1. 重启逆变器，确认逆变器是否可以正常工作。\n2. 检查逆变器外部风扇是否有异物遮挡，确认风扇\n运行是否正常。\n3. 如果频繁发生请联系上能电气售后服务中心",
  "alarm.desc.80": "外部风扇故障",
  "alarm.name.20011": "电网反序",
  "alarm.excDesc.20011": "电网反序",
  "alarm.suggestion.20011": "1. 确认交流线相序连接正确\n2. 若无需相序检测，可开启相序自适应功能",
  "alarm.desc.20011": "电网反序",
  "alarm.name.20015": "谐波电流超限",
  "alarm.excDesc.20015": "谐波电流超限",
  "alarm.suggestion.20015": "1. 故障消失后逆变器会恢复\n正常工作，不需要人工干预。\n2. 如果频繁出现，影响到正常发电，请联系上能电气售后服务中心",
  "alarm.desc.20015": "谐波电流超限",
  "alarm.name.20019": "火线接地",
  "alarm.excDesc.20019": "火线接地",
  "alarm.suggestion.20019": "1.确认逆变器交流输出侧火线对地电压是否满足电网要求。\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20019": "火线接地",
  "alarm.name.20021": "电网异常",
  "alarm.excDesc.20021": "电网异常",
  "alarm.suggestion.20021": "1.确认逆变器交流输出侧电压是否满足电网要求。\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20021": "电网异常",
  "alarm.name.20064": "拉弧",
  "alarm.excDesc.20064": "拉弧",
  "alarm.suggestion.20064": "检查组串线路是否存在拉弧或接触不良的情况。",
  "alarm.desc.20064": "拉弧",
  "alarm.name.2032109526342836224": "电网电压低故障",
  "alarm.name.2032275218448121856": "逆变器故障",
  "alarm.name.8": "绝缘阻抗故障",
  "alarm.excDesc.8": "绝缘阻抗故障",
  "alarm.suggestion.8": "等待逆变器恢复正常，若反复出现：\n1. 检查组串以及直流线缆对地阻抗，如果有短路或\n线缆绝缘层破损的情况，请采取整改措施；\n2. 如果线缆正常且故障在阴雨天（或有露水的早晨）发生， 待天气好转后再次确认；\n3.若确认非以上原因，而故障依然存在，请联系上能电气售后服务中心",
  "alarm.desc.8": "绝缘阻抗故障",
  "alarm.name.10": "NPE电压异常",
  "alarm.excDesc.10": "NPE电压异常",
  "alarm.suggestion.10": "1. 测量N线对地电压是否大于30V。",
  "alarm.desc.10": "NPE电压异常",
  "alarm.name.23": "高温",
  "alarm.excDesc.23": "高温",
  "alarm.suggestion.23": "1. 确认逆变器安装环境、空间是否满足散热要求。\n2. 检查风扇是否有异物遮挡，确认风扇可正常工作。\n3. 确认逆变器工作环境温度是否过高。",
  "alarm.desc.23": "高温",
  "alarm.name.25": "通信异常",
  "alarm.excDesc.25": "通信异常",
  "alarm.suggestion.25": "1.等待逆变器恢复正常\n2.如果故障频繁发生，请联系上能电气售后服务中心",
  "alarm.desc.25": "通信异常",
  "alarm.name.20003": "电网瞬时过压",
  "alarm.excDesc.20003": "电网瞬时过压",
  "alarm.suggestion.20003": "1. 确认逆变器交流输出侧电压是否满足电网要求。\n2. 确认交流线相序连接正确，N线、PE接线顺序正确、牢固。",
  "alarm.desc.20003": "电网瞬时过压",
  "alarm.name.2018955573075578880": "网络异常",
  "alarm.name.44": "温度严重过高",
  "alarm.excDesc.44": "温度严重过高",
  "alarm.suggestion.44": "1. 确认逆变器安装环境、空间是否满足散热要求。\n2. 检查风扇是否有异物遮挡，确认风扇可正常工作。\n3. 确认逆变器工作环境温度是否过高。\n4. 手动清除故障后，可重新开启逆变器；如果频繁发生请联系上能电气售后服务中心",
  "alarm.desc.44": "温度严重过高",
  "alarm.name.20008": "电网高压穿越",
  "alarm.excDesc.20008": "电网高压穿越",
  "alarm.suggestion.20008": "确认逆变器交流输出侧电压是否满足电网要求",
  "alarm.desc.20008": "电网高压穿越",
  "alarm.name.79": "内部风扇故障",
  "alarm.excDesc.79": "内部风扇故障",
  "alarm.suggestion.79": "如果频繁发生请联系上能电气售后服务中心",
  "alarm.desc.79": "内部风扇故障",
  "alarm.name.20002": "电网不平衡",
  "alarm.excDesc.20002": "电网不平衡",
  "alarm.suggestion.20002": "1. 确认逆变器交流输出侧电压是否满足电网要求。\n2. 确认交流线相序连接正确，N线、PE接线顺序正确、牢固。",
  "alarm.desc.20002": "电网不平衡",
  "alarm.name.20010": "孤岛",
  "alarm.excDesc.20010": "孤岛",
  "alarm.suggestion.20010": "确认逆变器交流输出侧电压是否满足电网要求。",
  "alarm.desc.20010": "孤岛",
  "alarm.name.20012": "电网缺相",
  "alarm.excDesc.20012": "电网缺相",
  "alarm.suggestion.20012": "1. 确认逆变器交流输出侧电压是否满足电网要求。\n2. 确认交流线缆连接正确，N线、PE接线顺序正确、牢固。",
  "alarm.desc.20012": "电网缺相",
  "alarm.name.20014": "输出电流不平衡",
  "alarm.excDesc.20014": "输出电流不平衡",
  "alarm.suggestion.20014": "1. 故障消失后逆变器会恢复\n正常工作，不需要人工干预。\n2. 如果频繁出现，影响到正常发电，请联系上能电气售后服务中心",
  "alarm.desc.20014": "输出电流不平衡",
  "alarm.name.20020": "谐波电压超限",
  "alarm.excDesc.20020": "谐波电压超限",
  "alarm.suggestion.20020": "1.确认逆变器交流输出侧电压是否满足电网要求。\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20020": "谐波电压超限",
  "alarm.name.20042": "交流电容电流异常",
  "alarm.excDesc.20042": "交流电容电流异常",
  "alarm.suggestion.20042": "断开交流输出侧开关、直流输入\n侧开关，15分钟后闭合交流输出\n侧开关、直流输入侧开关，如故\n障依然存在，请联系上能电气售后服务中心",
  "alarm.desc.20042": "交流电容电流异常",
  "alarm.name.20305": "PV3过流",
  "alarm.excDesc.20305": "PV3过流",
  "alarm.suggestion.20305": "检查光伏电池板配置，保证每路组串电流低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20305": "PV3过流",
  "alarm.name.2032109727212249088": "电网电压高故障",
  "alarm.name.2032342416717905920": "副DSP接收ARM通讯故障",
  "alarm.name.24": "主副版本不一致",
  "alarm.excDesc.24": "主副版本不一致",
  "alarm.suggestion.24": "逆变器软件版本错误，请联系上能电气售后服务中心",
  "alarm.desc.24": "主副版本不一致",
  "alarm.name.39": "AFCI故障",
  "alarm.excDesc.39": "AFCI故障",
  "alarm.suggestion.39": "1.  检查直流侧是否存在线缆破损、接线端子松动和接触不良， 零部件出现灼烧痕迹的现象；如果有，更换存在异常的线缆、端子或其他零部件等。\n2. 清除报错信息，如果频繁发生请联系上能电气售后服务中心",
  "alarm.desc.39": "AFCI故障",
  "alarm.name.41": "PV反接",
  "alarm.excDesc.41": "PV反接",
  "alarm.suggestion.41": "1.检查告警对应的组串是否接反。如果是，建议待\n太阳辐射度减低， 组串电流降低至0.5A以下时断\n开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.41": "PV反接",
  "alarm.name.20004": "十分钟电网过压",
  "alarm.excDesc.20004": "十分钟电网过压",
  "alarm.suggestion.20004": "1. 确认逆变器交流输出侧电压是否满足电网要求。\n2. 确认交流线相序连接正确，N线、PE接线顺序正确、牢固。",
  "alarm.desc.20004": "十分钟电网过压",
  "alarm.name.20018": "PE漏接",
  "alarm.excDesc.20018": "PE漏接",
  "alarm.suggestion.20018": "1.确认逆变器PE端子是否可靠接地。\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20018": "PE漏接",
  "alarm.name.2018956833455542272": "运行异常",
  "alarm.name.2032109871341117440": "电网频率低故障",
  "alarm.name.2032342508111790080": "ARM接收副DSP通讯故障",
  "alarm.name.20067": "PV对地电压高",
  "alarm.excDesc.20067": "PV对地电压高",
  "alarm.suggestion.20067": "等待逆变器恢复正常，若反复出现：\n1. 检查组串以及直流线缆对地阻抗，如果有短路或线缆绝缘层破损的情况，请采取整改措施\n2.若确认非以上原因，而故障依然存在，请联系上能电气售后服务中心",
  "alarm.desc.20067": "PV对地电压高",
  "alarm.name.20069": "软件升级",
  "alarm.excDesc.20069": "软件升级",
  "alarm.suggestion.20069": "逆变器软件需升级，请联系上能电气售后服务中心",
  "alarm.desc.20069": "软件升级",
  "alarm.name.20080": "交流防雷器故障",
  "alarm.excDesc.20080": "交流防雷器故障",
  "alarm.suggestion.20080": "断开交流输出侧开关、直流输入\n侧开关，15分钟后闭合交流输出\n侧开关、直流输入侧开关，如故\n障依然存在，请联系上能电气售后服务中心",
  "alarm.desc.20080": "交流防雷器故障",
  "alarm.name.20096": "温度高",
  "alarm.excDesc.20096": "温度高",
  "alarm.suggestion.20096": "1. 确认逆变器安装环境、空间是否满足散热要求。\n2. 检查风扇是否有异物遮挡，确认风扇可正常工作。\n3. 确认逆变器工作环境温度是否过高。",
  "alarm.desc.20096": "温度高",
  "alarm.name.20176": "MPPT1输入过压",
  "alarm.excDesc.20176": "MPPT1输入过压",
  "alarm.suggestion.20176": "检查光伏电池板的串联配置，保证每个组串的开路电压低于逆变器的最大工作电压，配置正确后，逆变器自动开机",
  "alarm.desc.20176": "MPPT1输入过压",
  "alarm.name.20177": "MPPT1输入过流",
  "alarm.excDesc.20177": "MPPT1输入过流",
  "alarm.suggestion.20177": "检查光伏电池板配置，保证每路MPPT对应组串电流之和低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20177": "MPPT1输入过流",
  "alarm.name.20193": "MPPT2输入过流",
  "alarm.excDesc.20193": "MPPT2输入过流",
  "alarm.suggestion.20193": "检查光伏电池板配置，保证每路MPPT对应组串电流之和低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20193": "MPPT2输入过流",
  "alarm.name.20198": "MPPT2电流反向",
  "alarm.excDesc.20198": "MPPT2电流反向",
  "alarm.suggestion.20198": "1.检查告警对应的组串是否接反。如果是，建议待\n太阳辐射度减低， 组串电流降低至0.5A以下时断\n开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20198": "MPPT2电流反向",
  "alarm.name.20199": "MPPT2组串异常接地",
  "alarm.excDesc.20199": "MPPT2组串异常接地",
  "alarm.suggestion.20199": "等待逆变器恢复正常，若反复出现：\n1. 检查组串以及直流线缆对地阻抗，如果有短路或线缆绝缘层破损的情况，请采取整改措施；\n2. 如果线缆正常且故障在阴雨天（或有露水的早晨）发生， 待天气好转后再次确认；\n3.若确认非以上原因，而故障依然存在，请联系上能电气售后服务中心",
  "alarm.desc.20199": "MPPT2组串异常接地",
  "alarm.name.20208": "MPPT3输入过压",
  "alarm.excDesc.20208": "MPPT3输入过压",
  "alarm.suggestion.20208": "检查光伏电池板的串联配置，保证每个组串的开路电压低于逆变器的最大工作电压，配置正确后，逆变器自动开机",
  "alarm.desc.20208": "MPPT3输入过压",
  "alarm.name.2028753319005200384": "通道1过流",
  "alarm.name.2032110003923066880": "电网频率高故障",
  "alarm.name.2033182277926518784": "出水高温",
  "alarm.name.20079": "直流防雷器故障",
  "alarm.excDesc.20079": "直流防雷器故障",
  "alarm.suggestion.20079": "断开交流输出侧开关、直流输入\n侧开关，15分钟后闭合交流输出\n侧开关、直流输入侧开关，如故\n障依然存在，请联系上能电气售后服务中心",
  "alarm.desc.20079": "直流防雷器故障",
  "alarm.name.20110": "严重过温",
  "alarm.excDesc.20110": "严重过温",
  "alarm.suggestion.20110": "1. 确认逆变器安装环境、空间是否满足散热要求。\n2. 检查风扇是否有异物遮挡，确认风扇可正常工作。\n3. 确认逆变器工作环境温度是否过高。\n4. 手动清除故障后，可重新开启逆变器；如果频繁发生请联系上能电气售后服务中心",
  "alarm.desc.20110": "严重过温",
  "alarm.name.20182": "MPPT1电流反向",
  "alarm.excDesc.20182": "MPPT1电流反向",
  "alarm.suggestion.20182": "1.检查告警对应的组串是否接反。如果是，建议待\n太阳辐射度减低， 组串电流降低至0.5A以下时断\n开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20182": "MPPT1电流反向",
  "alarm.name.20183": "MPPT1组串异常接地",
  "alarm.excDesc.20183": "MPPT1组串异常接地",
  "alarm.suggestion.20183": "等待逆变器恢复正常，若反复出现：\n1. 检查组串以及直流线缆对地阻抗，如果有短路或线缆绝缘层破损的情况，请采取整改措施；\n2. 如果线缆正常且故障在阴雨天（或有露水的早晨）发生， 待天气好转后再次确认；\n3.若确认非以上原因，而故障依然存在，请联系上能电气售后服务中心",
  "alarm.desc.20183": "MPPT1组串异常接地",
  "alarm.name.20192": "MPPT2输入过压",
  "alarm.excDesc.20192": "MPPT2输入过压",
  "alarm.suggestion.20192": "检查光伏电池板的串联配置，保证每个组串的开路电压低于逆变器的最大工作电压，配置正确后，逆变器自动开机",
  "alarm.desc.20192": "MPPT2输入过压",
  "alarm.name.20247": "MPPT5组串异常接地",
  "alarm.excDesc.20247": "MPPT5组串异常接地",
  "alarm.suggestion.20247": "等待逆变器恢复正常，若反复出现：\n1. 检查组串以及直流线缆对地阻抗，如果有短路或线缆绝缘层破损的情况，请采取整改措施；\n2. 如果线缆正常且故障在阴雨天（或有露水的早晨）发生， 待天气好转后再次确认；\n3.若确认非以上原因，而故障依然存在，请联系上能电气售后服务中心",
  "alarm.desc.20247": "MPPT5组串异常接地",
  "alarm.name.20256": "MPPT6输入过压",
  "alarm.excDesc.20256": "MPPT6输入过压",
  "alarm.suggestion.20256": "检查光伏电池板的串联配置，保证每个组串的开路电压低于逆变器的最大工作电压，配置正确后，逆变器自动开机",
  "alarm.desc.20256": "MPPT6输入过压",
  "alarm.name.20262": "MPPT6电流反向",
  "alarm.excDesc.20262": "MPPT6电流反向",
  "alarm.suggestion.20262": "1.检查告警对应的组串是否接反。如果是，建议待\n太阳辐射度减低， 组串电流降低至0.5A以下时断\n开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20262": "MPPT6电流反向",
  "alarm.name.20273": "PV1过流",
  "alarm.excDesc.20273": "PV1过流",
  "alarm.suggestion.20273": "检查光伏电池板配置，保证每路组串电流低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20273": "PV1过流",
  "alarm.name.20288": "PV2异常",
  "alarm.excDesc.20288": "PV2异常",
  "alarm.suggestion.20288": "1. 请检查组串的开路电压是否异常。\n2. 请检查组串是否受到遮挡。",
  "alarm.desc.20288": "PV2异常",
  "alarm.name.20290": "PV2电流反灌",
  "alarm.excDesc.20290": "PV2电流反灌",
  "alarm.suggestion.20290": "1. 请检查逆变器上对应的组串串联个数是否比其他组串少，如\n果是，组串电流降低至0.5A以下时断开直流开关，请调整组串个数。\n2. 请检查组串的开路电压是否异\n常。\n3. 请检查组串是否受到遮挡。",
  "alarm.desc.20290": "PV2电流反灌",
  "alarm.name.20303": "PV2端子温度异常",
  "alarm.excDesc.20303": "PV2端子温度异常",
  "alarm.suggestion.20303": "检查组串端子是否存在拉弧或接触不良的情况",
  "alarm.desc.20303": "PV2端子温度异常",
  "alarm.name.2028755408863305728": "通道1过压",
  "alarm.name.2032111626476986368": "电网交流输入过流故障",
  "alarm.name.2033182449616158720": "出水低温",
  "alarm.name.20215": "MPPT3组串异常接地",
  "alarm.excDesc.20215": "MPPT3组串异常接地",
  "alarm.suggestion.20215": "等待逆变器恢复正常，若反复出现：\n1. 检查组串以及直流线缆对地阻抗，如果有短路或线缆绝缘层破损的情况，请采取整改措施；\n2. 如果线缆正常且故障在阴雨天（或有露水的早晨）发生， 待天气好转后再次确认；\n3.若确认非以上原因，而故障依然存在，请联系上能电气售后服务中心",
  "alarm.desc.20215": "MPPT3组串异常接地",
  "alarm.name.20224": "MPPT4输入过压",
  "alarm.excDesc.20224": "MPPT4输入过压",
  "alarm.suggestion.20224": "检查光伏电池板的串联配置，保证每个组串的开路电压低于逆变器的最大工作电压，配置正确后，逆变器自动开机",
  "alarm.desc.20224": "MPPT4输入过压",
  "alarm.name.20230": "MPPT4电流反向",
  "alarm.excDesc.20230": "MPPT4电流反向",
  "alarm.suggestion.20230": "1.检查告警对应的组串是否接反。如果是，建议待\n太阳辐射度减低， 组串电流降低至0.5A以下时断\n开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20230": "MPPT4电流反向",
  "alarm.name.20241": "MPPT5输入过流",
  "alarm.excDesc.20241": "MPPT5输入过流",
  "alarm.suggestion.20241": "检查光伏电池板配置，保证每路MPPT对应组串电流之和低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20241": "MPPT5输入过流",
  "alarm.name.20275": "PV1反接",
  "alarm.excDesc.20275": "PV1反接",
  "alarm.suggestion.20275": "1.检查告警对应的组串是否接反。如果是，建议待太阳辐射度减低， 组串电流降低至0.5A以下时断开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20275": "PV1反接",
  "alarm.name.20240": "MPPT5输入过压",
  "alarm.excDesc.20240": "MPPT5输入过压",
  "alarm.suggestion.20240": "检查光伏电池板的串联配置，保证每个组串的开路电压低于逆变器的最大工作电压，配置正确后，逆变器自动开机",
  "alarm.desc.20240": "MPPT5输入过压",
  "alarm.name.20246": "MPPT5电流反向",
  "alarm.excDesc.20246": "MPPT5电流反向",
  "alarm.suggestion.20246": "1.检查告警对应的组串是否接反。如果是，建议待\n太阳辐射度减低， 组串电流降低至0.5A以下时断\n开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20246": "MPPT5电流反向",
  "alarm.name.20272": "PV1异常",
  "alarm.excDesc.20272": "PV1异常",
  "alarm.suggestion.20272": "1. 请检查组串的开路电压是否异常。\n2. 请检查组串是否受到遮挡。",
  "alarm.desc.20272": "PV1异常",
  "alarm.name.20274": "PV1电流反灌",
  "alarm.excDesc.20274": "PV1电流反灌",
  "alarm.suggestion.20274": "1. 请检查逆变器上对应的组串串联个数是否比其他组串少，如\n果是，组串电流降低至0.5A以下时断开直流开关，请调整组串个数。\n2. 请检查组串的开路电压是否异\n常。\n3. 请检查组串是否受到遮挡。",
  "alarm.desc.20274": "PV1电流反灌",
  "alarm.name.20287": "PV1端子温度异常",
  "alarm.excDesc.20287": "PV1端子温度异常",
  "alarm.suggestion.20287": "检查组串端子是否存在拉弧或接触不良的情况",
  "alarm.desc.20287": "PV1端子温度异常",
  "alarm.name.20289": "PV2过流",
  "alarm.excDesc.20289": "PV2过流",
  "alarm.suggestion.20289": "检查光伏电池板配置，保证每路组串电流低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20289": "PV2过流",
  "alarm.name.20304": "PV3异常",
  "alarm.excDesc.20304": "PV3异常",
  "alarm.suggestion.20304": "1. 请检查组串的开路电压是否异常。\n2. 请检查组串是否受到遮挡。",
  "alarm.desc.20304": "PV3异常",
  "alarm.name.20576": "PV20异常",
  "alarm.excDesc.20576": "PV20异常",
  "alarm.suggestion.20576": "1. 请检查组串的开路电压是否异常。\n2. 请检查组串是否受到遮挡。",
  "alarm.desc.20576": "PV20异常",
  "alarm.name.2028755462424567808": "通道1欠压",
  "alarm.name.1983448336968634368": "输出逆变过载延时到告警",
  "alarm.name.2033182619921678336": "出水温感故障",
  "alarm.name.20225": "MPPT4输入过流",
  "alarm.excDesc.20225": "MPPT4输入过流",
  "alarm.suggestion.20225": "检查光伏电池板配置，保证每路MPPT对应组串电流之和低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20225": "MPPT4输入过流",
  "alarm.name.20231": "MPPT4组串异常接地",
  "alarm.excDesc.20231": "MPPT4组串异常接地",
  "alarm.suggestion.20231": "等待逆变器恢复正常，若反复出现：\n1. 检查组串以及直流线缆对地阻抗，如果有短路或线缆绝缘层破损的情况，请采取整改措施；\n2. 如果线缆正常且故障在阴雨天（或有露水的早晨）发生， 待天气好转后再次确认；\n3.若确认非以上原因，而故障依然存在，请联系上能电气售后服务中心",
  "alarm.desc.20231": "MPPT4组串异常接地",
  "alarm.name.20257": "MPPT6输入过流",
  "alarm.excDesc.20257": "MPPT6输入过流",
  "alarm.suggestion.20257": "检查光伏电池板配置，保证每路MPPT对应组串电流之和低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20257": "MPPT6输入过流",
  "alarm.name.20263": "MPPT6组串异常接地",
  "alarm.excDesc.20263": "MPPT6组串异常接地",
  "alarm.suggestion.20263": "等待逆变器恢复正常，若反复出现：\n1. 检查组串以及直流线缆对地阻抗，如果有短路或线缆绝缘层破损的情况，请采取整改措施；\n2. 如果线缆正常且故障在阴雨天（或有露水的早晨）发生， 待天气好转后再次确认；\n3.若确认非以上原因，而故障依然存在，请联系上能电气售后服务中心",
  "alarm.desc.20263": "MPPT6组串异常接地",
  "alarm.name.20291": "PV2反接",
  "alarm.excDesc.20291": "PV2反接",
  "alarm.suggestion.20291": "1.检查告警对应的组串是否接反。如果是，建议待太阳辐射度减低， 组串电流降低至0.5A以下时断开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20291": "PV2反接",
  "alarm.name.20321": "PV4过流",
  "alarm.excDesc.20321": "PV4过流",
  "alarm.suggestion.20321": "检查光伏电池板配置，保证每路组串电流低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20321": "PV4过流",
  "alarm.name.20353": "PV6过流",
  "alarm.excDesc.20353": "PV6过流",
  "alarm.suggestion.20353": "检查光伏电池板配置，保证每路组串电流低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20353": "PV6过流",
  "alarm.name.20355": "PV6反接",
  "alarm.excDesc.20355": "PV6反接",
  "alarm.suggestion.20355": "1.检查告警对应的组串是否接反。如果是，建议待太阳辐射度减低， 组串电流降低至0.5A以下时断开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20355": "PV6反接",
  "alarm.name.20368": "PV7异常",
  "alarm.excDesc.20368": "PV7异常",
  "alarm.suggestion.20368": "1. 请检查组串的开路电压是否异常。\n2. 请检查组串是否受到遮挡。",
  "alarm.desc.20368": "PV7异常",
  "alarm.name.20370": "PV7电流反灌",
  "alarm.excDesc.20370": "PV7电流反灌",
  "alarm.suggestion.20370": "1. 请检查逆变器上对应的组串串联个数是否比其他组串少，如\n果是，组串电流降低至0.5A以下时断开直流开关，请调整组串个数。\n2. 请检查组串的开路电压是否异\n常。\n3. 请检查组串是否受到遮挡。",
  "alarm.desc.20370": "PV7电流反灌",
  "alarm.name.20383": "PV7端子温度异常",
  "alarm.excDesc.20383": "PV7端子温度异常",
  "alarm.suggestion.20383": "检查组串端子是否存在拉弧或接触不良的情况",
  "alarm.desc.20383": "PV7端子温度异常",
  "alarm.name.20385": "PV8过流",
  "alarm.excDesc.20385": "PV8过流",
  "alarm.suggestion.20385": "检查光伏电池板配置，保证每路组串电流低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20385": "PV8过流",
  "alarm.name.20387": "PV8反接",
  "alarm.excDesc.20387": "PV8反接",
  "alarm.suggestion.20387": "1.检查告警对应的组串是否接反。如果是，建议待太阳辐射度减低， 组串电流降低至0.5A以下时断开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20387": "PV8反接",
  "alarm.name.20400": "PV9异常",
  "alarm.excDesc.20400": "PV9异常",
  "alarm.suggestion.20400": "1. 请检查组串的开路电压是否异常。\n2. 请检查组串是否受到遮挡。",
  "alarm.desc.20400": "PV9异常",
  "alarm.name.20577": "PV20过流",
  "alarm.excDesc.20577": "PV20过流",
  "alarm.suggestion.20577": "检查光伏电池板配置，保证每路组串电流低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20577": "PV20过流",
  "alarm.name.2028755616019980288": "通道2欠压",
  "alarm.name.2028755515654479872": "通道2过流",
  "alarm.name.2032115619114655744": "逆变过载延时到故障",
  "alarm.name.2033182750951735296": "回水温感故障",
  "alarm.name.20319": "PV3端子温度异常",
  "alarm.excDesc.20319": "PV3端子温度异常",
  "alarm.suggestion.20319": "检查组串端子是否存在拉弧或接触不良的情况",
  "alarm.desc.20319": "PV3端子温度异常",
  "alarm.name.20323": "PV4反接",
  "alarm.excDesc.20323": "PV4反接",
  "alarm.suggestion.20323": "1.检查告警对应的组串是否接反。如果是，建议待太阳辐射度减低， 组串电流降低至0.5A以下时断开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20323": "PV4反接",
  "alarm.name.20336": "PV5异常",
  "alarm.excDesc.20336": "PV5异常",
  "alarm.suggestion.20336": "1. 请检查组串的开路电压是否异常。\n2. 请检查组串是否受到遮挡。",
  "alarm.desc.20336": "PV5异常",
  "alarm.name.20338": "PV5电流反灌",
  "alarm.excDesc.20338": "PV5电流反灌",
  "alarm.suggestion.20338": "1. 请检查逆变器上对应的组串串联个数是否比其他组串少，如\n果是，组串电流降低至0.5A以下时断开直流开关，请调整组串个数。\n2. 请检查组串的开路电压是否异\n常。\n3. 请检查组串是否受到遮挡。",
  "alarm.desc.20338": "PV5电流反灌",
  "alarm.name.20351": "PV5端子温度异常",
  "alarm.excDesc.20351": "PV5端子温度异常",
  "alarm.suggestion.20351": "检查组串端子是否存在拉弧或接触不良的情况",
  "alarm.desc.20351": "PV5端子温度异常",
  "alarm.name.20337": "PV5过流",
  "alarm.excDesc.20337": "PV5过流",
  "alarm.suggestion.20337": "检查光伏电池板配置，保证每路组串电流低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20337": "PV5过流",
  "alarm.name.20339": "PV5反接",
  "alarm.excDesc.20339": "PV5反接",
  "alarm.suggestion.20339": "1.检查告警对应的组串是否接反。如果是，建议待太阳辐射度减低， 组串电流降低至0.5A以下时断开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20339": "PV5反接",
  "alarm.name.20352": "PV6异常",
  "alarm.excDesc.20352": "PV6异常",
  "alarm.suggestion.20352": "1. 请检查组串的开路电压是否异常。\n2. 请检查组串是否受到遮挡。",
  "alarm.desc.20352": "PV6异常",
  "alarm.name.20354": "PV6电流反灌",
  "alarm.excDesc.20354": "PV6电流反灌",
  "alarm.suggestion.20354": "1. 请检查逆变器上对应的组串串联个数是否比其他组串少，如\n果是，组串电流降低至0.5A以下时断开直流开关，请调整组串个数。\n2. 请检查组串的开路电压是否异\n常。\n3. 请检查组串是否受到遮挡。",
  "alarm.desc.20354": "PV6电流反灌",
  "alarm.name.20367": "PV6端子温度异常",
  "alarm.excDesc.20367": "PV6端子温度异常",
  "alarm.suggestion.20367": "检查组串端子是否存在拉弧或接触不良的情况",
  "alarm.desc.20367": "PV6端子温度异常",
  "alarm.name.20369": "PV7过流",
  "alarm.excDesc.20369": "PV7过流",
  "alarm.suggestion.20369": "检查光伏电池板配置，保证每路组串电流低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20369": "PV7过流",
  "alarm.name.20371": "PV7反接",
  "alarm.excDesc.20371": "PV7反接",
  "alarm.suggestion.20371": "1.检查告警对应的组串是否接反。如果是，建议待太阳辐射度减低， 组串电流降低至0.5A以下时断开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20371": "PV7反接",
  "alarm.name.20384": "PV8异常",
  "alarm.excDesc.20384": "PV8异常",
  "alarm.suggestion.20384": "1. 请检查组串的开路电压是否异常。\n2. 请检查组串是否受到遮挡。",
  "alarm.desc.20384": "PV8异常",
  "alarm.name.20399": "PV8端子温度异常",
  "alarm.excDesc.20399": "PV8端子温度异常",
  "alarm.suggestion.20399": "检查组串端子是否存在拉弧或接触不良的情况",
  "alarm.desc.20399": "PV8端子温度异常",
  "alarm.name.20401": "PV9过流",
  "alarm.excDesc.20401": "PV9过流",
  "alarm.suggestion.20401": "检查光伏电池板配置，保证每路组串电流低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20401": "PV9过流",
  "alarm.name.2028755573410045952": "通道2过压",
  "alarm.name.2032115720910413824": "旁路过载延时到故障",
  "alarm.name.2033182937631817728": "变频器通讯故障",
  "alarm.name.20307": "PV3反接",
  "alarm.excDesc.20307": "PV3反接",
  "alarm.suggestion.20307": "1.检查告警对应的组串是否接反。如果是，建议待太阳辐射度减低， 组串电流降低至0.5A以下时断开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20307": "PV3反接",
  "alarm.name.20320": "PV4异常",
  "alarm.excDesc.20320": "PV4异常",
  "alarm.suggestion.20320": "1. 请检查组串的开路电压是否异常。\n2. 请检查组串是否受到遮挡。",
  "alarm.desc.20320": "PV4异常",
  "alarm.name.20322": "PV4电流反灌",
  "alarm.excDesc.20322": "PV4电流反灌",
  "alarm.suggestion.20322": "1. 请检查逆变器上对应的组串串联个数是否比其他组串少，如\n果是，组串电流降低至0.5A以下时断开直流开关，请调整组串个数。\n2. 请检查组串的开路电压是否异\n常。\n3. 请检查组串是否受到遮挡。",
  "alarm.desc.20322": "PV4电流反灌",
  "alarm.name.20335": "PV4端子温度异常",
  "alarm.excDesc.20335": "PV4端子温度异常",
  "alarm.suggestion.20335": "检查组串端子是否存在拉弧或接触不良的情况",
  "alarm.desc.20335": "PV4端子温度异常",
  "alarm.name.20386": "PV8电流反灌",
  "alarm.excDesc.20386": "PV8电流反灌",
  "alarm.suggestion.20386": "1. 请检查逆变器上对应的组串串联个数是否比其他组串少，如\n果是，组串电流降低至0.5A以下时断开直流开关，请调整组串个数。\n2. 请检查组串的开路电压是否异\n常。\n3. 请检查组串是否受到遮挡。",
  "alarm.desc.20386": "PV8电流反灌",
  "alarm.name.20415": "PV9端子温度异常",
  "alarm.excDesc.20415": "PV9端子温度异常",
  "alarm.suggestion.20415": "检查组串端子是否存在拉弧或接触不良的情况",
  "alarm.desc.20415": "PV9端子温度异常",
  "alarm.name.20447": "PV11端子温度异常",
  "alarm.excDesc.20447": "PV11端子温度异常",
  "alarm.suggestion.20447": "检查组串端子是否存在拉弧或接触不良的情况",
  "alarm.desc.20447": "PV11端子温度异常",
  "alarm.name.20449": "PV12过流",
  "alarm.excDesc.20449": "PV12过流",
  "alarm.suggestion.20449": "检查光伏电池板配置，保证每路组串电流低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20449": "PV12过流",
  "alarm.name.20451": "PV12反接",
  "alarm.excDesc.20451": "PV12反接",
  "alarm.suggestion.20451": "1.检查告警对应的组串是否接反。如果是，建议待太阳辐射度减低， 组串电流降低至0.5A以下时断开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20451": "PV12反接",
  "alarm.name.20464": "PV13异常",
  "alarm.excDesc.20464": "PV13异常",
  "alarm.suggestion.20464": "1. 请检查组串的开路电压是否异常。\n2. 请检查组串是否受到遮挡。",
  "alarm.desc.20464": "PV13异常",
  "alarm.name.20466": "PV13电流反灌",
  "alarm.excDesc.20466": "PV13电流反灌",
  "alarm.suggestion.20466": "1. 请检查逆变器上对应的组串串联个数是否比其他组串少，如\n果是，组串电流降低至0.5A以下时断开直流开关，请调整组串个数。\n2. 请检查组串的开路电压是否异\n常。\n3. 请检查组串是否受到遮挡。",
  "alarm.desc.20466": "PV13电流反灌",
  "alarm.name.20479": "PV13端子温度异常",
  "alarm.excDesc.20479": "PV13端子温度异常",
  "alarm.suggestion.20479": "检查组串端子是否存在拉弧或接触不良的情况",
  "alarm.desc.20479": "PV13端子温度异常",
  "alarm.name.20481": "PV14过流",
  "alarm.excDesc.20481": "PV14过流",
  "alarm.suggestion.20481": "检查光伏电池板配置，保证每路组串电流低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20481": "PV14过流",
  "alarm.name.20483": "PV14反接",
  "alarm.excDesc.20483": "PV14反接",
  "alarm.suggestion.20483": "1.检查告警对应的组串是否接反。如果是，建议待太阳辐射度减低， 组串电流降低至0.5A以下时断开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20483": "PV14反接",
  "alarm.name.20496": "PV15异常",
  "alarm.excDesc.20496": "PV15异常",
  "alarm.suggestion.20496": "1. 请检查组串的开路电压是否异常。\n2. 请检查组串是否受到遮挡。",
  "alarm.desc.20496": "PV15异常",
  "alarm.name.2028755657967214592": "通道3过流",
  "alarm.name.2032116027992186880": "市电锁相失败故障",
  "alarm.name.2033183101490692096": "系统高压锁定",
  "alarm.name.20402": "PV9电流反灌",
  "alarm.excDesc.20402": "PV9电流反灌",
  "alarm.suggestion.20402": "1. 请检查逆变器上对应的组串串联个数是否比其他组串少，如\n果是，组串电流降低至0.5A以下时断开直流开关，请调整组串个数。\n2. 请检查组串的开路电压是否异\n常。\n3. 请检查组串是否受到遮挡。",
  "alarm.desc.20402": "PV9电流反灌",
  "alarm.name.20417": "PV10过流",
  "alarm.excDesc.20417": "PV10过流",
  "alarm.suggestion.20417": "检查光伏电池板配置，保证每路组串电流低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20417": "PV10过流",
  "alarm.name.20419": "PV10反接",
  "alarm.excDesc.20419": "PV10反接",
  "alarm.suggestion.20419": "1.检查告警对应的组串是否接反。如果是，建议待太阳辐射度减低， 组串电流降低至0.5A以下时断开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20419": "PV10反接",
  "alarm.name.20432": "PV11异常",
  "alarm.excDesc.20432": "PV11异常",
  "alarm.suggestion.20432": "1. 请检查组串的开路电压是否异常。\n2. 请检查组串是否受到遮挡。",
  "alarm.desc.20432": "PV11异常",
  "alarm.name.20434": "PV11电流反灌",
  "alarm.excDesc.20434": "PV11电流反灌",
  "alarm.suggestion.20434": "1. 请检查逆变器上对应的组串串联个数是否比其他组串少，如\n果是，组串电流降低至0.5A以下时断开直流开关，请调整组串个数。\n2. 请检查组串的开路电压是否异\n常。\n3. 请检查组串是否受到遮挡。",
  "alarm.desc.20434": "PV11电流反灌",
  "alarm.name.20431": "PV10端子温度异常",
  "alarm.excDesc.20431": "PV10端子温度异常",
  "alarm.suggestion.20431": "检查组串端子是否存在拉弧或接触不良的情况",
  "alarm.desc.20431": "PV10端子温度异常",
  "alarm.name.20433": "PV11过流",
  "alarm.excDesc.20433": "PV11过流",
  "alarm.suggestion.20433": "检查光伏电池板配置，保证每路组串电流低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20433": "PV11过流",
  "alarm.name.20435": "PV11反接",
  "alarm.excDesc.20435": "PV11反接",
  "alarm.suggestion.20435": "1.检查告警对应的组串是否接反。如果是，建议待太阳辐射度减低， 组串电流降低至0.5A以下时断开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20435": "PV11反接",
  "alarm.name.20463": "PV12端子温度异常",
  "alarm.excDesc.20463": "PV12端子温度异常",
  "alarm.suggestion.20463": "检查组串端子是否存在拉弧或接触不良的情况",
  "alarm.desc.20463": "PV12端子温度异常",
  "alarm.name.20465": "PV13过流",
  "alarm.excDesc.20465": "PV13过流",
  "alarm.suggestion.20465": "检查光伏电池板配置，保证每路组串电流低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20465": "PV13过流",
  "alarm.name.20467": "PV13反接",
  "alarm.excDesc.20467": "PV13反接",
  "alarm.suggestion.20467": "1.检查告警对应的组串是否接反。如果是，建议待太阳辐射度减低， 组串电流降低至0.5A以下时断开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20467": "PV13反接",
  "alarm.name.20480": "PV14异常",
  "alarm.excDesc.20480": "PV14异常",
  "alarm.suggestion.20480": "1. 请检查组串的开路电压是否异常。\n2. 请检查组串是否受到遮挡。",
  "alarm.desc.20480": "PV14异常",
  "alarm.name.20482": "PV14电流反灌",
  "alarm.excDesc.20482": "PV14电流反灌",
  "alarm.suggestion.20482": "1. 请检查逆变器上对应的组串串联个数是否比其他组串少，如\n果是，组串电流降低至0.5A以下时断开直流开关，请调整组串个数。\n2. 请检查组串的开路电压是否异\n常。\n3. 请检查组串是否受到遮挡。",
  "alarm.desc.20482": "PV14电流反灌",
  "alarm.name.20495": "PV14端子温度异常",
  "alarm.excDesc.20495": "PV14端子温度异常",
  "alarm.suggestion.20495": "检查组串端子是否存在拉弧或接触不良的情况",
  "alarm.desc.20495": "PV14端子温度异常",
  "alarm.name.20497": "PV15过流",
  "alarm.excDesc.20497": "PV15过流",
  "alarm.suggestion.20497": "检查光伏电池板配置，保证每路组串电流低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20497": "PV15过流",
  "alarm.name.2028755702464585728": "通道3过压",
  "alarm.name.2032116119465762816": "并机二级锁相失败故障",
  "alarm.name.2033183345288806400": "系统低压锁定",
  "alarm.name.20403": "PV9反接",
  "alarm.excDesc.20403": "PV9反接",
  "alarm.suggestion.20403": "1.检查告警对应的组串是否接反。如果是，建议待太阳辐射度减低， 组串电流降低至0.5A以下时断开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20403": "PV9反接",
  "alarm.name.20416": "PV10异常",
  "alarm.excDesc.20416": "PV10异常",
  "alarm.suggestion.20416": "1. 请检查组串的开路电压是否异常。\n2. 请检查组串是否受到遮挡。",
  "alarm.desc.20416": "PV10异常",
  "alarm.name.20418": "PV10电流反灌",
  "alarm.excDesc.20418": "PV10电流反灌",
  "alarm.suggestion.20418": "1. 请检查逆变器上对应的组串串联个数是否比其他组串少，如\n果是，组串电流降低至0.5A以下时断开直流开关，请调整组串个数。\n2. 请检查组串的开路电压是否异\n常。\n3. 请检查组串是否受到遮挡。",
  "alarm.desc.20418": "PV10电流反灌",
  "alarm.name.20448": "PV12异常",
  "alarm.excDesc.20448": "PV12异常",
  "alarm.suggestion.20448": "1. 请检查组串的开路电压是否异常。\n2. 请检查组串是否受到遮挡。",
  "alarm.desc.20448": "PV12异常",
  "alarm.name.20450": "PV12电流反灌",
  "alarm.excDesc.20450": "PV12电流反灌",
  "alarm.suggestion.20450": "1. 请检查逆变器上对应的组串串联个数是否比其他组串少，如\n果是，组串电流降低至0.5A以下时断开直流开关，请调整组串个数。\n2. 请检查组串的开路电压是否异\n常。\n3. 请检查组串是否受到遮挡。",
  "alarm.desc.20450": "PV12电流反灌",
  "alarm.name.20511": "PV15端子温度异常",
  "alarm.excDesc.20511": "PV15端子温度异常",
  "alarm.suggestion.20511": "检查组串端子是否存在拉弧或接触不良的情况",
  "alarm.desc.20511": "PV15端子温度异常",
  "alarm.name.2028755758840225792": "通道3欠压",
  "alarm.name.2032116389436334080": "充电器低压故障",
  "alarm.name.2033183429304909824": "排气温度过高锁定",
  "alarm.name.20498": "PV15电流反灌",
  "alarm.excDesc.20498": "PV15电流反灌",
  "alarm.suggestion.20498": "1. 请检查逆变器上对应的组串串联个数是否比其他组串少，如\n果是，组串电流降低至0.5A以下时断开直流开关，请调整组串个数。\n2. 请检查组串的开路电压是否异\n常。\n3. 请检查组串是否受到遮挡。",
  "alarm.desc.20498": "PV15电流反灌",
  "alarm.name.20513": "PV16过流",
  "alarm.excDesc.20513": "PV16过流",
  "alarm.suggestion.20513": "检查光伏电池板配置，保证每路组串电流低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20513": "PV16过流",
  "alarm.name.20515": "PV16反接",
  "alarm.excDesc.20515": "PV16反接",
  "alarm.suggestion.20515": "1.检查告警对应的组串是否接反。如果是，建议待太阳辐射度减低， 组串电流降低至0.5A以下时断开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20515": "PV16反接",
  "alarm.name.20528": "PV17异常",
  "alarm.excDesc.20528": "PV17异常",
  "alarm.suggestion.20528": "1. 请检查组串的开路电压是否异常。\n2. 请检查组串是否受到遮挡。",
  "alarm.desc.20528": "PV17异常",
  "alarm.name.20530": "PV17电流反灌",
  "alarm.excDesc.20530": "PV17电流反灌",
  "alarm.suggestion.20530": "1. 请检查逆变器上对应的组串串联个数是否比其他组串少，如\n果是，组串电流降低至0.5A以下时断开直流开关，请调整组串个数。\n2. 请检查组串的开路电压是否异\n常。\n3. 请检查组串是否受到遮挡。",
  "alarm.desc.20530": "PV17电流反灌",
  "alarm.name.20543": "PV17端子温度异常",
  "alarm.excDesc.20543": "PV17端子温度异常",
  "alarm.suggestion.20543": "检查组串端子是否存在拉弧或接触不良的情况",
  "alarm.desc.20543": "PV17端子温度异常",
  "alarm.name.20545": "PV18过流",
  "alarm.excDesc.20545": "PV18过流",
  "alarm.suggestion.20545": "检查光伏电池板配置，保证每路组串电流低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20545": "PV18过流",
  "alarm.name.20527": "PV16端子温度异常",
  "alarm.excDesc.20527": "PV16端子温度异常",
  "alarm.suggestion.20527": "检查组串端子是否存在拉弧或接触不良的情况",
  "alarm.desc.20527": "PV16端子温度异常",
  "alarm.name.20529": "PV17过流",
  "alarm.excDesc.20529": "PV17过流",
  "alarm.suggestion.20529": "检查光伏电池板配置，保证每路组串电流低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20529": "PV17过流",
  "alarm.name.20547": "PV18反接",
  "alarm.excDesc.20547": "PV18反接",
  "alarm.suggestion.20547": "1.检查告警对应的组串是否接反。如果是，建议待太阳辐射度减低， 组串电流降低至0.5A以下时断开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20547": "PV18反接",
  "alarm.name.20559": "PV18端子温度异常",
  "alarm.excDesc.20559": "PV18端子温度异常",
  "alarm.suggestion.20559": "检查组串端子是否存在拉弧或接触不良的情况",
  "alarm.desc.20559": "PV18端子温度异常",
  "alarm.name.20560": "PV19异常",
  "alarm.excDesc.20560": "PV19异常",
  "alarm.suggestion.20560": "1. 请检查组串的开路电压是否异常。\n2. 请检查组串是否受到遮挡。",
  "alarm.desc.20560": "PV19异常",
  "alarm.name.20561": "PV19过流",
  "alarm.excDesc.20561": "PV19过流",
  "alarm.suggestion.20561": "检查光伏电池板配置，保证每路组串电流低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20561": "PV19过流",
  "alarm.name.20562": "PV19电流反灌",
  "alarm.excDesc.20562": "PV19电流反灌",
  "alarm.suggestion.20562": "1. 请检查逆变器上对应的组串串联个数是否比其他组串少，如\n果是，组串电流降低至0.5A以下时断开直流开关，请调整组串个数。\n2. 请检查组串的开路电压是否异\n常。\n3. 请检查组串是否受到遮挡。",
  "alarm.desc.20562": "PV19电流反灌",
  "alarm.name.20563": "PV19反接",
  "alarm.excDesc.20563": "PV19反接",
  "alarm.suggestion.20563": "1.检查告警对应的组串是否接反。如果是，建议待太阳辐射度减低， 组串电流降低至0.5A以下时断开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20563": "PV19反接",
  "alarm.name.20575": "PV19端子温度异常",
  "alarm.excDesc.20575": "PV19端子温度异常",
  "alarm.suggestion.20575": "检查组串端子是否存在拉弧或接触不良的情况",
  "alarm.desc.20575": "PV19端子温度异常",
  "alarm.name.2028755964398870528": "通道4过流",
  "alarm.name.2032116462731796480": "充电器高压故障",
  "alarm.name.2033183492114612224": "变频器过流锁定",
  "alarm.name.2033183602525470720": "变频器过压锁定",
  "alarm.name.20512": "PV16异常",
  "alarm.excDesc.20512": "PV16异常",
  "alarm.suggestion.20512": "1. 请检查组串的开路电压是否异常。\n2. 请检查组串是否受到遮挡。",
  "alarm.desc.20512": "PV16异常",
  "alarm.name.20514": "PV16电流反灌",
  "alarm.excDesc.20514": "PV16电流反灌",
  "alarm.suggestion.20514": "1. 请检查逆变器上对应的组串串联个数是否比其他组串少，如\n果是，组串电流降低至0.5A以下时断开直流开关，请调整组串个数。\n2. 请检查组串的开路电压是否异\n常。\n3. 请检查组串是否受到遮挡。",
  "alarm.desc.20514": "PV16电流反灌",
  "alarm.name.20531": "PV17反接",
  "alarm.excDesc.20531": "PV17反接",
  "alarm.suggestion.20531": "1.检查告警对应的组串是否接反。如果是，建议待太阳辐射度减低， 组串电流降低至0.5A以下时断开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20531": "PV17反接",
  "alarm.name.20544": "PV18异常",
  "alarm.excDesc.20544": "PV18异常",
  "alarm.suggestion.20544": "1. 请检查组串的开路电压是否异常。\n2. 请检查组串是否受到遮挡。",
  "alarm.desc.20544": "PV18异常",
  "alarm.name.20546": "PV18电流反灌",
  "alarm.excDesc.20546": "PV18电流反灌",
  "alarm.suggestion.20546": "1. 请检查逆变器上对应的组串串联个数是否比其他组串少，如\n果是，组串电流降低至0.5A以下时断开直流开关，请调整组串个数。\n2. 请检查组串的开路电压是否异\n常。\n3. 请检查组串是否受到遮挡。",
  "alarm.desc.20546": "PV18电流反灌",
  "alarm.name.20608": "PV22异常",
  "alarm.excDesc.20608": "PV22异常",
  "alarm.suggestion.20608": "1. 请检查组串的开路电压是否异常。\n2. 请检查组串是否受到遮挡。",
  "alarm.desc.20608": "PV22异常",
  "alarm.name.20610": "PV22电流反灌",
  "alarm.excDesc.20610": "PV22电流反灌",
  "alarm.suggestion.20610": "1. 请检查逆变器上对应的组串串联个数是否比其他组串少，如\n果是，组串电流降低至0.5A以下时断开直流开关，请调整组串个数。\n2. 请检查组串的开路电压是否异\n常。\n3. 请检查组串是否受到遮挡。",
  "alarm.desc.20610": "PV22电流反灌",
  "alarm.name.20623": "PV22端子温度异常",
  "alarm.excDesc.20623": "PV22端子温度异常",
  "alarm.suggestion.20623": "检查组串端子是否存在拉弧或接触不良的情况",
  "alarm.desc.20623": "PV22端子温度异常",
  "alarm.name.20625": "PV23过流",
  "alarm.excDesc.20625": "PV23过流",
  "alarm.suggestion.20625": "检查光伏电池板配置，保证每路组串电流低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20625": "PV23过流",
  "alarm.name.20655": "PV24端子温度异常",
  "alarm.excDesc.20655": "PV24端子温度异常",
  "alarm.suggestion.20655": "检查组串端子是否存在拉弧或接触不良的情况",
  "alarm.desc.20655": "PV24端子温度异常",
  "alarm.name.2028756008564891648": "通道4过压",
  "alarm.name.2032118185949011968": "电芯充电过流慢检故障",
  "alarm.name.2033183548381200384": "变频器过温锁定",
  "alarm.name.20578": "PV20电流反灌",
  "alarm.excDesc.20578": "PV20电流反灌",
  "alarm.suggestion.20578": "1. 请检查逆变器上对应的组串串联个数是否比其他组串少，如\n果是，组串电流降低至0.5A以下时断开直流开关，请调整组串个数。\n2. 请检查组串的开路电压是否异\n常。\n3. 请检查组串是否受到遮挡。",
  "alarm.desc.20578": "PV20电流反灌",
  "alarm.name.20591": "PV20端子温度异常",
  "alarm.excDesc.20591": "PV20端子温度异常",
  "alarm.suggestion.20591": "检查组串端子是否存在拉弧或接触不良的情况",
  "alarm.desc.20591": "PV20端子温度异常",
  "alarm.name.20593": "PV21过流",
  "alarm.excDesc.20593": "PV21过流",
  "alarm.suggestion.20593": "检查光伏电池板配置，保证每路组串电流低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20593": "PV21过流",
  "alarm.name.20595": "PV21反接",
  "alarm.excDesc.20595": "PV21反接",
  "alarm.suggestion.20595": "1.检查告警对应的组串是否接反。如果是，建议待太阳辐射度减低， 组串电流降低至0.5A以下时断开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20595": "PV21反接",
  "alarm.name.20627": "PV23反接",
  "alarm.excDesc.20627": "PV23反接",
  "alarm.suggestion.20627": "1.检查告警对应的组串是否接反。如果是，建议待太阳辐射度减低， 组串电流降低至0.5A以下时断开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20627": "PV23反接",
  "alarm.name.20640": "PV24异常",
  "alarm.excDesc.20640": "PV24异常",
  "alarm.suggestion.20640": "1. 请检查组串的开路电压是否异常。\n2. 请检查组串是否受到遮挡。",
  "alarm.desc.20640": "PV24异常",
  "alarm.name.20642": "PV24电流反灌",
  "alarm.excDesc.20642": "PV24电流反灌",
  "alarm.suggestion.20642": "1. 请检查逆变器上对应的组串串联个数是否比其他组串少，如\n果是，组串电流降低至0.5A以下时断开直流开关，请调整组串个数。\n2. 请检查组串的开路电压是否异\n常。\n3. 请检查组串是否受到遮挡。",
  "alarm.desc.20642": "PV24电流反灌",
  "alarm.name.20592": "PV21异常",
  "alarm.excDesc.20592": "PV21异常",
  "alarm.suggestion.20592": "1. 请检查组串的开路电压是否异常。\n2. 请检查组串是否受到遮挡。",
  "alarm.desc.20592": "PV21异常",
  "alarm.name.1976181873151827968": "母线过压",
  "alarm.excDesc.1976181873151827968": "母线过压",
  "alarm.suggestion.1976181873151827968": "1. 重启逆变器，确认逆变器是否可以正常工作。\n2. 确认PV组串电压是否满足逆变器最大输入电压要求。",
  "alarm.name.2005894346846036008": "电网电压异常",
  "alarm.excDesc.2005894346846036008": "电网电压异常",
  "alarm.suggestion.2005894346846036008": "观察故障产生时，是否伴随着其他电网异常类告警；如是，则是电网异常波动引起的，当电网\n恢复后，告警也会恢复。如果告警持续出现，请参考对应的故障代码进行排查。",
  "alarm.name.20594": "PV21电流反灌",
  "alarm.excDesc.20594": "PV21电流反灌",
  "alarm.suggestion.20594": "1. 请检查逆变器上对应的组串串联个数是否比其他组串少，如\n果是，组串电流降低至0.5A以下时断开直流开关，请调整组串个数。\n2. 请检查组串的开路电压是否异\n常。\n3. 请检查组串是否受到遮挡。",
  "alarm.desc.20594": "PV21电流反灌",
  "alarm.name.20607": "PV21端子温度异常",
  "alarm.excDesc.20607": "PV21端子温度异常",
  "alarm.suggestion.20607": "检查组串端子是否存在拉弧或接触不良的情况",
  "alarm.desc.20607": "PV21端子温度异常",
  "alarm.name.20611": "PV22反接",
  "alarm.excDesc.20611": "PV22反接",
  "alarm.suggestion.20611": "1.检查告警对应的组串是否接反。如果是，建议待太阳辐射度减低， 组串电流降低至0.5A以下时断开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20611": "PV22反接",
  "alarm.name.20624": "PV23异常",
  "alarm.excDesc.20624": "PV23异常",
  "alarm.suggestion.20624": "1. 请检查组串的开路电压是否异常。\n2. 请检查组串是否受到遮挡。",
  "alarm.desc.20624": "PV23异常",
  "alarm.name.20626": "PV23电流反灌",
  "alarm.excDesc.20626": "PV23电流反灌",
  "alarm.suggestion.20626": "1. 请检查逆变器上对应的组串串联个数是否比其他组串少，如\n果是，组串电流降低至0.5A以下时断开直流开关，请调整组串个数。\n2. 请检查组串的开路电压是否异\n常。\n3. 请检查组串是否受到遮挡。",
  "alarm.desc.20626": "PV23电流反灌",
  "alarm.name.20639": "PV23端子温度异常",
  "alarm.excDesc.20639": "PV23端子温度异常",
  "alarm.suggestion.20639": "检查组串端子是否存在拉弧或接触不良的情况",
  "alarm.desc.20639": "PV23端子温度异常",
  "alarm.name.20641": "PV24过流",
  "alarm.excDesc.20641": "PV24过流",
  "alarm.suggestion.20641": "检查光伏电池板配置，保证每路组串电流低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20641": "PV24过流",
  "alarm.name.20643": "PV24反接",
  "alarm.excDesc.20643": "PV24反接",
  "alarm.suggestion.20643": "1.检查告警对应的组串是否接反。如果是，建议待太阳辐射度减低， 组串电流降低至0.5A以下时断开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20643": "PV24反接",
  "alarm.name.2028756048914096128": "通道4欠压",
  "alarm.name.2032118267440144384": "电芯放电过流慢检故障",
  "alarm.name.2033183654757138432": "变频器欠压锁定",
  "alarm.name.21": "设备异常",
  "alarm.excDesc.21": "设备异常",
  "alarm.suggestion.21": "1.等待逆变器恢复正常\n2.断开交流测开关及直流开关， 等待15分钟后依次\n闭合交直流开关， 重启逆变器， 如果故障依然存\n在，请联系上能电气售后服务中心",
  "alarm.desc.21": "设备异常",
  "alarm.name.65": "继电器故障",
  "alarm.excDesc.65": "继电器故障",
  "alarm.suggestion.65": "1. 重启逆变器，确认逆变器是否可以正常工作。\n2. 确认逆变器N线与地线接线是否良好。\n若频繁发生，请联系上能电气售后服务中心",
  "alarm.desc.65": "继电器故障",
  "alarm.name.20579": "PV20反接",
  "alarm.excDesc.20579": "PV20反接",
  "alarm.suggestion.20579": "1.检查告警对应的组串是否接反。如果是，建议待太阳辐射度减低， 组串电流降低至0.5A以下时断开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20579": "PV20反接",
  "alarm.name.20609": "PV22过流",
  "alarm.excDesc.20609": "PV22过流",
  "alarm.suggestion.20609": "检查光伏电池板配置，保证每路组串电流低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20609": "PV22过流",
  "alarm.name.2005894346846036010": "电网欠压",
  "alarm.suggestion.2005894346846036010": "1、如果偶尔出现，可能为短时电网异常，当电网正常后会恢复正常，无需人工干预；\n2、如果频繁出现，请确认电网电压是否在允许范围内满足电网要求，或通过监控平台修改电网欠压限值;\n3、如果电网电压很低并且长时间无法恢复，请检查交流侧开关或接线是否正常。",
  "alarm.desc.2005894346846036010": "1、如果偶尔出现，可能为短时电网异常，当电网正常后会恢复正常，无需人工干预；\n2、如果频繁出现，请确认电网电压是否在允许范围内满足电网要求，或通过监控平台修改电网欠压限值;\n3、如果电网电压很低并且长时间无法恢复，请检查交流侧开关或接线是否正常。\n",
  "alarm.name.1983785728816631808": "电网频率异常",
  "alarm.excDesc.1983785728816631808": "电网频率异常",
  "alarm.suggestion.1983785728816631808": "1. 确认逆变器交流输出频率是否满足电网要求。\n2. 确认交流线相序连接正确，N线、PE接线顺序正确、牢固。\n3. 确认故障发生频率，如果偶尔发生，可能是瞬时电网频率变化导致，无需处理。",
  "alarm.name.2028758548350181376": "EEPROM故障1",
  "alarm.name.2016691768087388160": "ARM接收主DSP通讯故障6666",
  "alarm.excDesc.2016691768087388160": "ARM板通讯线没接/线缆断开",
  "alarm.suggestion.2016691768087388160": "处理建议：123456789",
  "alarm.desc.2016691768087388160": "5689",
  "alarm.name.2028758460995411968": "硬件保护1",
  "alarm.name.2032118563641892864": "电芯温度温差过大故障",
  "alarm.name.20068": "软硬件版本不匹配",
  "alarm.excDesc.20068": "软硬件版本不匹配",
  "alarm.suggestion.20068": "1.等待逆变器恢复正常\n2.断开交流测开关及直流开关， 等待15分钟后依次闭合交直流开关， 重启逆变器， 如果故障依然存在，请联系上能电气售后服务中心",
  "alarm.desc.20068": "软硬件版本不匹配",
  "alarm.name.20209": "MPPT3输入过流",
  "alarm.excDesc.20209": "MPPT3输入过流",
  "alarm.suggestion.20209": "检查光伏电池板配置，保证每路MPPT对应组串电流之和低于标称电流，配置正确后，逆变器自动开机",
  "alarm.desc.20209": "MPPT3输入过流",
  "alarm.name.20214": "MPPT3电流反向",
  "alarm.excDesc.20214": "MPPT3电流反向",
  "alarm.suggestion.20214": "1.检查告警对应的组串是否接反。如果是，建议待\n太阳辐射度减低， 组串电流降低至0.5A以下时断\n开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20214": "MPPT3电流反向",
  "alarm.name.20306": "PV3电流反灌",
  "alarm.excDesc.20306": "PV3电流反灌",
  "alarm.suggestion.20306": "1. 请检查逆变器上对应的组串串联个数是否比其他组串少，如\n果是，组串电流降低至0.5A以下时断开直流开关，请调整组串个数。\n2. 请检查组串的开路电压是否异\n常。\n3. 请检查组串是否受到遮挡。",
  "alarm.desc.20306": "PV3电流反灌",
  "alarm.name.20499": "PV15反接",
  "alarm.excDesc.20499": "PV15反接",
  "alarm.suggestion.20499": "1.检查告警对应的组串是否接反。如果是，建议待太阳辐射度减低， 组串电流降低至0.5A以下时断开直流开关，调整组串极性；\n2.确认非以上原因， 且故障依然存在， 请联系上能电气售后服务中心",
  "alarm.desc.20499": "PV15反接",
  "alarm.name.2033183719500414976": "变频器缺相锁定",
  "alarm.suggestion.1976182165184438272": "1223",
  "user.privacy.user": "用户协议",
  "user.privacy.pivacy": "隐私政策",
  "user.privacy.cookie": "Cookie政策",
  "privacy.exist": "该语言已存在协议",
  "51002.ctrl_inverter.enaINVTR": "逆变器远程开关机",
  "51002.ctrl_inverter.enaRestoretodefault": "恢复默认的保护值和功能开关",
  "51002.ctrl_antireverse.enaPAVE_FEEDINLIMIT": "防逆流使能",
  "51002.ctrl_antireverse.dynamicPowerLimit": "防逆流功率限定百分比值",
  "51002.ctrl_inverter.enaAPP_PWSET": "用户功率设定使能",
  "51002.ctrl_inverter.powersetUserApp": "用户功率限定值百分比（Pn）",
  "51002.ctrl_inverter.contrycode": "安装所在地国家编号",
  "51002.ctrl_inverter.factoryparam": "工厂模式参数",
  "51002.warning.stOV_Vgrid": "网侧电压过压保护",
  "51002.warning.stUV_Vgrid": "网侧电压欠压保护",
  "51002.warning.stOV_Fgrid": "网侧电压过频保护",
  "51002.warning.stUV_Fgrid": "网侧电压欠频保护",
  "51002.warning.stOV_Temp": "逆变器过温保护",
  "51002.warning.stHW_Fault": "逆变器硬件保护",
  "51002.warning.stErrOP_Relay": "网侧继电器异常保护",
  "51002.warning.stErrAccess_EEPROM": "EEPROM存取异常",
  "51002.warning.stAbnorm_Ris": "绝缘阻抗异常",
  "51002.real_time.Vacrms": "网侧电压有效值",
  "51002.real_time.Iacrms": "网侧电流有效值",
  "51002.real_time.Fgrid": "网侧频率",
  "51002.real_time.Temperature": "逆变器工作温度",
  "51002.warning.stPV1_UV": "PV输入1欠压",
  "51002.warning.stPV1_OV": "PV输入1过压",
  "51002.real_time.Vpv1": "PV1输入电压",
  "51002.real_time.Ipv1": "PV1输入电流",
  "51002.real_time.Energy_PV1": "PV1累计发电量",
  "51002.warning.stPV2_UV": "PV输入2欠压",
  "51002.warning.stPV2_OV": "PV输入2过压",
  "51002.real_time.Vpv2": "PV2输入电压",
  "51002.real_time.Ipv2": "PV2输入电流",
  "51002.real_time.Energy_PV2": "PV2累计发电量",
  "51002.warning.stPV3_UV": "PV输入3欠压",
  "51002.warning.stPV3_OV": "PV输入3过压",
  "51002.real_time.Vpv3": "PV3输入电压",
  "51002.real_time.Ipv3": "PV3输入电流",
  "51002.real_time.Energy_PV3": "PV3累计发电量",
  "51002.warning.stPV4_UV": "PV输入4欠压",
  "51002.warning.stPV4_OV": "PV输入4过压",
  "51002.real_time.Vpv4": "PV4输入电压",
  "51002.real_time.Ipv4": "PV4输入电流",
  "51002.real_time.Energy_PV4": "PV4累计发电量",
  "51002.real_time.StINVTPOWERON": "逆变器功率输出运行状态",
  "51002.real_time.stRelayoN": "继电器接通状态",
  "51002.real_time.activePower": "有功输出功率",
  "51002.real_time.Un": "并网电网额定电压有效值",
  "51002.real_time.Fn": "并网电网额定频率",
  "51002.real_time.Pn": "最大并网有功功率",
  "51002.real_time.Irmsmax": "最大并网电流有效值",
  "51002.real_time.Vmpptmin": "最小mppt电压",
  "51002.real_time.Vmpptmax": "最大mppt电压",
  "51002.real_time.Powpvmax": "最大输入PV功率",
  "51002.real_time.Ipvmax": "最大输入PV电流",
  "51002.real_time.Tempmax": "最大工作温度",
  "51002.real_time.Firmware_ver": "固件版本号",
  "51002.ctrl_antireverse": "防逆流控制",
  "51002.real_time": "实时监控",
  "51002.warning": "告警",
  "51002.ctrl_inverter": "控制",
  "60420.ctrl_param_shebeixinxishezhi.statutory": "法规",
  "60420.ctrl_param_shebeixinxishezhi.wideVoltageGrade": "宽电压等级",
  "60420.ctrl_param_shebeixinxishezhi.statutory.0": "CQC2013",
  "60420.ctrl_param_shebeixinxishezhi.statutory.12": "泰国",
  "60420.ctrl_param_shebeixinxishezhi.statutory.13": "曼谷",
  "60420.ctrl_param_shebeixinxishezhi.statutory.6": "印度",
  "60420.ctrl_param_shebeixinxishezhi.statutory.18": "德国",
  "60420.ctrl_param_shebeixinxishezhi.statutory.19": "法国",
  "60420.ctrl_param_shebeixinxishezhi.wideVoltageGrade.0": "默认值",
  "60420.ctrl_param_shebeixinxishezhi.wideVoltageGrade.1": "1.2倍",
  "60420.ctrl_param_shebeixinxishezhi.wideVoltageGrade.2": "1.25倍",
  "60420.ctrl_param_shebeixinxishezhi.statutory.desc": "勿随意修改，需联系安装商并符合当地法规",
  "60420.ctrl_param_shebeixinxishezhi.wideVoltageGrade.desc": " 0(默认值）:230V标准电压；  1(表示1.2倍):276V宽电压;   2(表示1.25倍):287V宽电压",
  "50652.fault_pcs.pcsFault4_13": "有功调节输出达到限幅值",
  "50652.fault_pcs.pcsFault4_12": "有功功率偏差大",
  "50652.fault_pcs.pcsFault4_11": "交直流功率不匹配",
  "50652.fault_pcs.pcsFault4_10": "过温降载",
  "50652.realtime_bms.bmsAlarm2H": "2级报警码H",
  "50652.realtime_bms.bmsAlarm1L": "1级报警码L",
  "50652.realtime_bms.bmsAlarm1H": "1级报警码H",
  "50652.fault_stack.stackAlarmH_12": "高压箱温度线故障",
  "50652.fault_stack.stackAlarmH_11": "维护充电",
  "50652.fault_stack.stackAlarmH_14": "主动均衡故障",
  "50652.fault_stack.stackAlarmH_13": "被动均衡故障",
  "50652.fault_stack.stackAlarmH_15": "SBCU-QF断路器故障",
  "50652.fault_pcs.pcsFault4_15": "无功达到限幅值",
  "50652.fault_pcs.pcsFault4_14": "无功调节输出达到限幅值",
  "50652.fault_bms.bmsAlarm2L_7": "SOE低2级",
  "50652.fault_bms.bmsAlarm1L_11": "绝缘低1级",
  "50652.fault_bms.bmsAlarm2L_6": "SOC高2级",
  "50652.fault_bms.bmsAlarm1L_10": "温差大1级",
  "50652.fault_bms.bmsAlarm2L_5": "SOC低2级",
  "50652.fault_bms.bmsAlarm2L_4": "单体充电压差大2级",
  "50652.fault_bms.bmsAlarm1L_15": "充电温度低1级",
  "50652.fault_bms.bmsAlarm1L_14": "充电温度高1级",
  "50652.fault_stack.stackAlarmH_10": "初始化阻塞",
  "50652.fault_bms.bmsAlarm2L_9": "放电电流大2级",
  "50652.fault_bms.bmsAlarm1L_13": "总压低1级",
  "50652.fault_bms.bmsAlarm2L_8": "充电电流大2级",
  "50652.fault_bms.bmsAlarm1L_12": "总压高1级",
  "50652.fault_bms.bmsAlarm2L_3": "单体电压低2级",
  "50652.fault_bms.bmsAlarm2L_2": "单体电压高2级",
  "50652.fault_bms.bmsAlarm2L_1": "放电温度低2级",
  "50652.fault_bms.bmsAlarm2L_0": "放电温度高2级",
  "50652.realtime_bms.bmsAlarm3L": "3级报警码L",
  "50652.fault_fire.AuxEqptAlarmH_1": "消防故障",
  "50652.fault_fire.AuxEqptAlarmH_0": "PCS故障",
  "50652.realtime_bms.bmsAlarm3H": "3级报警码H",
  "50652.realtime_bms.bmsAlarm2L": "2级报警码L",
  "50652.fault_pcs.pcsFault1_9": "高穿保护",
  "50652.fault_pcs.pcsFault1_8": "电网孤岛状态",
  "50652.fault_bms.bmsAlarm3H_4": "单包放电压差大3级",
  "50652.fault_pcs.pcsFault1_7": "电网电压不平衡",
  "50652.fault_bms.bmsAlarm3H_3": "极柱温度高3级",
  "50652.fault_pcs.pcsFault1_6": "电网缺相",
  "50652.fault_bms.bmsAlarm3H_2": "单包电压低3级",
  "50652.fault_pcs.pcsFault1_5": "电网相序错误",
  "50652.fault_bms.bmsAlarm3H_1": "单包电压高3级",
  "50652.fault_pcs.pcsFault1_4": "电网欠频",
  "50652.fault_pcs.pcsFault1_3": "电网过频",
  "50652.fault_pcs.pcsFault1_2": "电网欠压",
  "50652.fault_bms.bmsAlarm3H_6": "单体放电压差大3级",
  "50652.fault_pcs.pcsFault1_1": "电网过压",
  "50652.fault_bms.bmsAlarm3H_5": "单包充电压差大3级",
  "50652.fault_pcs.pcsFault1_0": "电网未上电",
  "50652.fault_bms.bmsAlarm3H_0": "温升快3级",
  "50652.fault_stack.stackAlarmL_15": "继电器强制控制",
  "50652.fault_stack.stackAlarmL_10": "总压采集无效",
  "50652.fault_pcs.pcsFault5_15": "并网接触器故障",
  "50652.fault_stack.stackAlarmL_14": "温度极高",
  "50652.fault_stack.stackAlarmL_13": "单体极低",
  "50652.fault_stack.stackAlarmL_12": "单体极高",
  "50652.fault_stack.stackAlarmL_11": "单体电压异常升高",
  "50652.fault_pcs.pcsFault5_10": "交流对地绝缘故障",
  "50652.fault_pcs.pcsFault5_11": "预充电接触器故障",
  "50652.fault_pcs.pcsFault5_12": "主接触器故障",
  "50652.fault_pcs.pcsFault5_13": "直流预充电接触故障",
  "50652.fault_pcs.pcsFault5_14": "直流主接触器故障",
  "50652.fault_bms.bmsAlarm1L_5": "SOC低1级",
  "50652.fault_bms.bmsAlarm1L_6": "SOC高1级",
  "50652.fault_bms.bmsAlarm1L_3": "单体电压低1级",
  "50652.fault_bms.bmsAlarm1L_4": "单体充电压差大1级",
  "50652.fault_bms.bmsAlarm1L_9": "放电电流大1级",
  "50652.fault_pcs.pcsFault2_9": "主机故障",
  "50652.fault_bms.bmsAlarm1L_7": "SOE低1级",
  "50652.fault_pcs.pcsFault2_8": "载波同步失效",
  "50652.fault_bms.bmsAlarm1L_8": "充电电流大1级",
  "50652.fault_pcs.pcsFault2_7": "从机故障",
  "50652.fault_pcs.pcsFault2_6": "EMS通讯故障",
  "50652.fault_pcs.pcsFault2_5": "BMS通讯故障",
  "50652.fault_pcs.pcsFault2_4": "电池电流硬件过流",
  "50652.fault_pcs.pcsFault2_3": "电源故障",
  "50652.fault_bms.bmsAlarm1L_1": "放电温度低1级",
  "50652.fault_pcs.pcsFault2_2": "母线硬件过压",
  "50652.fault_bms.bmsAlarm1L_2": "单体电压高1级",
  "50652.fault_pcs.pcsFault2_1": "逐波限流超限",
  "50652.fault_pcs.pcsFault2_0": "模块硬件过流",
  "50652.fault_bms.bmsAlarm1L_0": "放电温度高1级",
  "50652.fault_bms.bmsAlarm2L_10": "温差大2级",
  "50652.fault_bms.bmsAlarm2L_12": "总压高2级",
  "50652.fault_bms.bmsAlarm2L_11": "绝缘低2级",
  "50652.fault_bms.bmsAlarm2L_14": "充电温度高2级",
  "50652.fault_bms.bmsAlarm2L_13": "总压低2级",
  "50652.fault_stack.stackAlarmH_0": "簇间压差大",
  "50652.fault_stack.stackAlarmH_1": "与主控通讯异常",
  "50652.fault_stack.stackAlarmH_2": "与EMS通讯失败",
  "50652.fault_stack.stackAlarmH_3": "EMS/PCS强控继电器",
  "50652.fault_stack.stackAlarmH_4": "PCS通讯超时",
  "50652.fault_stack.stackAlarmH_5": "显示屏通讯故障",
  "50652.fault_stack.stackAlarmH_6": "风扇故障",
  "50652.fault_stack.stackAlarmH_7": "电池簇就位数量不足",
  "50652.fault_stack.stackAlarmH_8": "电池簇就位数量超出",
  "50652.fault_stack.stackAlarmH_9": "SBAU断路器故障",
  "50652.fault_bms.bmsAlarm2L_15": "充电温度低2级",
  "50652.fault_pcs.pcsFault3_9": "电池电压检测异常",
  "50652.fault_pcs.pcsFault3_8": "直流电源未准备好",
  "50652.fault_pcs.pcsFault3_7": "直流系统预充电未准备好",
  "50652.fault_pcs.pcsFault3_6": "正负母线对地不平衡",
  "50652.fault_pcs.pcsFault3_5": "母线电压检测异常",
  "50652.fault_pcs.pcsFault3_4": "母线短路",
  "50652.fault_pcs.pcsFault3_3": "正负母线不平衡",
  "50652.fault_pcs.pcsFault3_2": "母线欠压",
  "50652.fault_pcs.pcsFault3_1": "母线过压",
  "50652.fault_pcs.pcsFault3_0": "预充电超时",
  "50652.realtime_pcs.pcsFault4": "系统故障4",
  "50652.realtime_pcs.pcsFault5": "系统故障5",
  "50652.realtime_bms.AuxEqptAlarmH": "辅助设备报警码H",
  "50652.fault_pcs.pcsFault1_10": "低穿保护",
  "50652.realtime_pcs.pcsFault2": "系统故障2",
  "50652.realtime_pcs.pcsFault3": "系统故障3",
  "50652.realtime_bms.AuxEqptAlarmL": "辅助设备报警码L",
  "50652.realtime_pcs.pcsFault6": "系统故障6",
  "50652.fault_bms.bmsAlarm2H_3": "极柱温度高2级",
  "50652.fault_bms.bmsAlarm2H_2": "单包电压低2级",
  "50652.fault_bms.bmsAlarm2H_1": "单包电压高2级",
  "50652.fault_bms.bmsAlarm2H_0": "温升快2级",
  "50652.fault_bms.bmsAlarm2H_6": "单体放电压差大2级",
  "50652.fault_fire.AuxEqptAlarmL_12": "温湿度通讯异常",
  "50652.fault_bms.bmsAlarm2H_5": "单包充电压差大2级",
  "50652.fault_fire.AuxEqptAlarmL_11": "水浸通讯异常",
  "50652.fault_bms.bmsAlarm2H_4": "单包放电压差大2级",
  "50652.fault_fire.AuxEqptAlarmL_10": "液冷通讯异常",
  "50652.realtime_pcs.pcsFault1": "系统故障1",
  "50652.fault_pcs.pcsFault2_10": "主机通讯故障",
  "50652.fault_pcs.pcsFault2_11": "从机通讯故障",
  "50652.fault_pcs.pcsFault4_9": "有功达到限幅值",
  "50652.fault_bms.bmsAlarm3L_10": "温差大3级",
  "50652.fault_pcs.pcsFault4_8": "有功功率过大",
  "50652.fault_bms.bmsAlarm3L_11": "绝缘低3级",
  "50652.fault_pcs.pcsFault4_7": "调试错误",
  "50652.fault_bms.bmsAlarm3L_12": "总压高3级",
  "50652.fault_pcs.pcsFault4_6": "滤波电容欠压",
  "50652.fault_bms.bmsAlarm3L_13": "总压低3级",
  "50652.fault_pcs.pcsFault4_5": "滤波电容过压",
  "50652.fault_pcs.pcsFault4_4": "模块过温",
  "50652.fault_pcs.pcsFault4_3": "模块I2t过载",
  "50652.fault_pcs.pcsFault4_2": "网侧模块电流不平衡",
  "50652.fault_pcs.pcsFault4_1": "网侧漏电流过大",
  "50652.fault_pcs.pcsFault4_0": "模块过流",
  "50652.fault_pcs.pcsFault2_14": "STS故障",
  "50652.fault_pcs.pcsFault2_12": "STS通讯故障",
  "50652.fault_pcs.pcsFault2_13": "并离网切换命令异常",
  "50652.fault_fire.AuxEqptAlarmL_3": "空调故障",
  "50652.fault_fire.AuxEqptAlarmL_2": "消防设备动作",
  "50652.fault_fire.AuxEqptAlarmL_1": "消防设备故障",
  "50652.fault_fire.AuxEqptAlarmL_0": "火警报警",
  "50652.fault_fire.AuxEqptAlarmL_7": "保留",
  "50652.fault_fire.AuxEqptAlarmL_6": "水浸告警",
  "50652.fault_fire.AuxEqptAlarmL_5": "AC防雷故障",
  "50652.fault_fire.AuxEqptAlarmL_4": "DC防雷故障",
  "50652.fault_fire.AuxEqptAlarmL_9": "UPS故障",
  "50652.fault_fire.AuxEqptAlarmL_8": "UPS放空",
  "50652.fault_bms.bmsAlarm3L_14": "充电温度高3级",
  "50652.fault_bms.bmsAlarm3L_15": "充电温度低3级",
  "50652.fault_bms.bmsAlarm3L_8": "充电电流大3级",
  "50652.fault_bms.bmsAlarm3L_7": "SOE低3级",
  "50652.fault_bms.bmsAlarm3L_6": "SOC高3级",
  "50652.fault_bms.bmsAlarm3L_5": "SOC低3级",
  "50652.fault_bms.bmsAlarm3L_9": "放电电流大3级",
  "50652.fault_bms.bmsAlarm3L_0": "放电温度高3级",
  "50652.realtime_bms.stackAlarmL": "堆维护报警码L",
  "50652.fault_bms.bmsAlarm3L_4": "单体充电压差大3级",
  "50652.fault_bms.bmsAlarm3L_3": "单体电压低3级",
  "50652.fault_bms.bmsAlarm3L_2": "单体电压高3级",
  "50652.fault_bms.bmsAlarm3L_1": "放电温度低3级",
  "50652.fault_pcs.pcsFault5_0": "交流防雷器故障",
  "50652.fault_pcs.pcsFault5_1": "直流防雷器故障",
  "50652.fault_pcs.pcsFault5_2": "内部风扇故障",
  "50652.fault_pcs.pcsFault5_3": "外部风扇故障",
  "50652.fault_pcs.pcsFault5_4": "紧急停机",
  "50652.fault_pcs.pcsFault5_5": "漏电流传感器自检失败",
  "50652.fault_pcs.pcsFault5_6": "直流对地绝缘阻抗失效",
  "50652.fault_pcs.pcsFault5_7": "漏电流零漂采样过大",
  "50652.fault_pcs.pcsFault5_8": "内部环境温度过高",
  "50652.fault_pcs.pcsFault5_9": "AD采样零漂过大",
  "50652.fault_bms.bmsAlarm1H_1": "单包电压高1级",
  "50652.fault_bms.bmsAlarm1H_2": "单包电压低1级",
  "50652.fault_bms.bmsAlarm1H_0": "温升快1级",
  "50652.fault_bms.bmsAlarm1H_5": "单包充电压差大1级",
  "50652.fault_bms.bmsAlarm1H_6": "单体放电压差大1级",
  "50652.fault_bms.bmsAlarm1H_3": "极柱温度高1级",
  "50652.fault_bms.bmsAlarm1H_4": "单包放电压差大1级",
  "50652.fault_pcs.pcsFault6_0": "BMS故障",
  "50652.fault_pcs.pcsFault6_1": "充电终止",
  "50652.fault_pcs.pcsFault6_2": "放电终止",
  "50652.fault_pcs.pcsFault3_12": "电池欠压",
  "50652.fault_pcs.pcsFault3_11": "电池过压",
  "50652.fault_pcs.pcsFault3_10": "电池电压极性反接检测异常",
  "50652.fault_stack.stackAlarmL_0": "SBMU硬件故障",
  "50652.fault_stack.stackAlarmL_1": "电池接线故障",
  "50652.fault_stack.stackAlarmL_2": "SBMU通讯故障",
  "50652.fault_stack.stackAlarmL_3": "温敏线故障",
  "50652.fault_stack.stackAlarmL_4": "主负继电器故障",
  "50652.fault_stack.stackAlarmL_5": "主正继电器故障",
  "50652.fault_stack.stackAlarmL_6": "预充故障",
  "50652.fault_stack.stackAlarmL_7": "保险丝故障",
  "50652.fault_stack.stackAlarmL_8": "急停",
  "50652.fault_stack.stackAlarmL_9": "电流环故障",
  "50652.realtime_bms.stackAlarmH": "堆维护报警码H",
  "50652.fault_pcs.pcsFault3_13": "电池过流",
  "50652.realtime_pcs.pcsFaultTest": "PCS故障测试",
  "50652.fault_bms": "",
  "50652.fault_pcs": "",
  "50652.fault_stack": "",
  "50652.fault_fire": "",
  "60001.group_collector.httpUrl.desc": "Http下载文件的url的说明。",
  "60001.group_collector.bleProtocolVersion": "本地通讯协议版本号",
  "60001.group_collector.inverterSn": "逆变器SN",
  "60001.group_collector.bleProtocolVersion.desc": "欧洲RED合规认证的协议版本号从9.0开始",
  "50901.null.phaseAOfInverterReactivePower.desc": "逆变器交流侧A相无功率的说明",
  "alarm.name.2038937740871077888": "单包放电压差大1级",
  "alarm.excDesc.2038937740871077888": "无",
  "alarm.suggestion.2038937740871077888": "无",
  "alarm.desc.2038937740871077888": "无",
  "alarm.name.2038937741735104512": "温升快2级",
  "alarm.excDesc.2038937741735104512": "无",
  "alarm.suggestion.2038937741735104512": "无",
  "alarm.desc.2038937741735104512": "无",
  "alarm.name.2038937741823184896": "单包电压低2级",
  "alarm.excDesc.2038937741823184896": "无",
  "alarm.suggestion.2038937741823184896": "无",
  "alarm.desc.2038937741823184896": "无",
  "alarm.name.2038937740921409536": "单包充电压差大1级",
  "alarm.excDesc.2038937740921409536": "无",
  "alarm.suggestion.2038937740921409536": "无",
  "alarm.desc.2038937740921409536": "无",
  "alarm.name.2038937741013684224": "放电温度高1级",
  "alarm.excDesc.2038937741013684224": "无",
  "alarm.suggestion.2038937741013684224": "无",
  "alarm.desc.2038937741013684224": "无",
  "alarm.name.2038937741097570304": "单体电压高1级",
  "alarm.excDesc.2038937741097570304": "无",
  "alarm.suggestion.2038937741097570304": "无",
  "alarm.desc.2038937741097570304": "无",
  "alarm.name.2038937741206622208": "单体充电压差大1级",
  "alarm.excDesc.2038937741206622208": "无",
  "alarm.suggestion.2038937741206622208": "无",
  "alarm.desc.2038937741206622208": "无",
  "alarm.name.2038937741294702592": "SOC高1级",
  "alarm.excDesc.2038937741294702592": "无",
  "alarm.suggestion.2038937741294702592": "无",
  "alarm.desc.2038937741294702592": "无",
  "alarm.name.2038937741382782976": "充电电流大1级",
  "alarm.excDesc.2038937741382782976": "无",
  "alarm.suggestion.2038937741382782976": "无",
  "alarm.desc.2038937741382782976": "无",
  "alarm.name.2038937741470863360": "温差大1级",
  "alarm.excDesc.2038937741470863360": "无",
  "alarm.suggestion.2038937741470863360": "无",
  "alarm.desc.2038937741470863360": "无",
  "alarm.name.2038937741563138048": "总压高1级",
  "alarm.excDesc.2038937741563138048": "无",
  "alarm.suggestion.2038937741563138048": "无",
  "alarm.desc.2038937741563138048": "无",
  "alarm.name.2038937741651218432": "充电温度高1级",
  "alarm.excDesc.2038937741651218432": "无",
  "alarm.suggestion.2038937741651218432": "无",
  "alarm.desc.2038937741651218432": "无",
  "alarm.name.2038937741911265280": "单包放电压差大2级",
  "alarm.excDesc.2038937741911265280": "无",
  "alarm.suggestion.2038937741911265280": "无",
  "alarm.desc.2038937741911265280": "无",
  "alarm.name.2038937741995151360": "单体放电压差大2级",
  "alarm.excDesc.2038937741995151360": "无",
  "alarm.suggestion.2038937741995151360": "无",
  "alarm.desc.2038937741995151360": "无",
  "alarm.name.2038937742087426048": "放电温度低2级",
  "alarm.excDesc.2038937742087426048": "无",
  "alarm.suggestion.2038937742087426048": "无",
  "alarm.desc.2038937742087426048": "无",
  "alarm.name.2038937742171312128": "单体电压低2级",
  "alarm.excDesc.2038937742171312128": "无",
  "alarm.suggestion.2038937742171312128": "无",
  "alarm.desc.2038937742171312128": "无",
  "alarm.name.2038937742280364032": "SOC低2级",
  "alarm.excDesc.2038937742280364032": "无",
  "alarm.suggestion.2038937742280364032": "无",
  "alarm.desc.2038937742280364032": "无",
  "alarm.name.2038937742364250112": "SOE低2级",
  "alarm.excDesc.2038937742364250112": "无",
  "alarm.suggestion.2038937742364250112": "无",
  "alarm.desc.2038937742364250112": "无",
  "alarm.name.2038937742460719104": "放电电流大2级",
  "alarm.excDesc.2038937742460719104": "无",
  "alarm.suggestion.2038937742460719104": "无",
  "alarm.desc.2038937742460719104": "无",
  "alarm.name.2038937742552993792": "绝缘低2级",
  "alarm.excDesc.2038937742552993792": "无",
  "alarm.suggestion.2038937742552993792": "无",
  "alarm.desc.2038937742552993792": "无",
  "alarm.name.2038937740967546880": "单体放电压差大1级",
  "alarm.excDesc.2038937740967546880": "无",
  "alarm.suggestion.2038937740967546880": "无",
  "alarm.desc.2038937740967546880": "无",
  "alarm.name.2038937741055627264": "放电温度低1级",
  "alarm.excDesc.2038937741055627264": "无",
  "alarm.suggestion.2038937741055627264": "无",
  "alarm.desc.2038937741055627264": "无",
  "alarm.name.2038937741143707648": "单体电压低1级",
  "alarm.excDesc.2038937741143707648": "无",
  "alarm.suggestion.2038937741143707648": "无",
  "alarm.desc.2038937741143707648": "无",
  "alarm.name.2038937741252759552": "SOC低1级",
  "alarm.excDesc.2038937741252759552": "无",
  "alarm.suggestion.2038937741252759552": "无",
  "alarm.desc.2038937741252759552": "无",
  "alarm.name.2038937741340839936": "SOE低1级",
  "alarm.excDesc.2038937741340839936": "无",
  "alarm.suggestion.2038937741340839936": "无",
  "alarm.desc.2038937741340839936": "无",
  "alarm.name.2038937741428920320": "放电电流大1级",
  "alarm.excDesc.2038937741428920320": "无",
  "alarm.suggestion.2038937741428920320": "无",
  "alarm.desc.2038937741428920320": "无",
  "alarm.name.2038937741517000704": "绝缘低1级",
  "alarm.excDesc.2038937741517000704": "无",
  "alarm.suggestion.2038937741517000704": "无",
  "alarm.desc.2038937741517000704": "无",
  "alarm.name.2038937741605081088": "总压低1级",
  "alarm.excDesc.2038937741605081088": "无",
  "alarm.suggestion.2038937741605081088": "无",
  "alarm.desc.2038937741605081088": "无",
  "alarm.name.2038937741693161472": "充电温度低1级",
  "alarm.excDesc.2038937741693161472": "无",
  "alarm.suggestion.2038937741693161472": "无",
  "alarm.desc.2038937741693161472": "无",
  "alarm.name.2038937741781241856": "单包电压高2级",
  "alarm.excDesc.2038937741781241856": "无",
  "alarm.suggestion.2038937741781241856": "无",
  "alarm.desc.2038937741781241856": "无",
  "alarm.name.2038937741865127936": "极柱温度高2级",
  "alarm.excDesc.2038937741865127936": "无",
  "alarm.suggestion.2038937741865127936": "无",
  "alarm.desc.2038937741865127936": "无",
  "alarm.name.2038937741953208320": "单包充电压差大2级",
  "alarm.excDesc.2038937741953208320": "无",
  "alarm.suggestion.2038937741953208320": "无",
  "alarm.desc.2038937741953208320": "无",
  "alarm.name.2038937742041288704": "放电温度高2级",
  "alarm.excDesc.2038937742041288704": "无",
  "alarm.suggestion.2038937742041288704": "无",
  "alarm.desc.2038937742041288704": "无",
  "alarm.name.2038937742129369088": "单体电压高2级",
  "alarm.excDesc.2038937742129369088": "无",
  "alarm.suggestion.2038937742129369088": "无",
  "alarm.desc.2038937742129369088": "无",
  "alarm.name.2038937742217449472": "单体充电压差大2级",
  "alarm.excDesc.2038937742217449472": "无",
  "alarm.suggestion.2038937742217449472": "无",
  "alarm.desc.2038937742217449472": "无",
  "alarm.name.2038937742322307072": "SOC高2级",
  "alarm.excDesc.2038937742322307072": "无",
  "alarm.suggestion.2038937742322307072": "无",
  "alarm.desc.2038937742322307072": "无",
  "alarm.name.2038937742410387456": "充电电流大2级",
  "alarm.excDesc.2038937742410387456": "无",
  "alarm.suggestion.2038937742410387456": "无",
  "alarm.desc.2038937742410387456": "无",
  "alarm.name.2038937742502662144": "温差大2级",
  "alarm.excDesc.2038937742502662144": "无",
  "alarm.suggestion.2038937742502662144": "无",
  "alarm.desc.2038937742502662144": "无",
  "alarm.name.2038937742615908352": "总压高2级",
  "alarm.excDesc.2038937742615908352": "无",
  "alarm.suggestion.2038937742615908352": "无",
  "alarm.desc.2038937742615908352": "无",
  "alarm.name.2038937742712377344": "充电温度高2级",
  "alarm.excDesc.2038937742712377344": "无",
  "alarm.suggestion.2038937742712377344": "无",
  "alarm.desc.2038937742712377344": "无",
  "alarm.name.2038937742800457728": "温升快3级",
  "alarm.excDesc.2038937742800457728": "无",
  "alarm.suggestion.2038937742800457728": "无",
  "alarm.desc.2038937742800457728": "无",
  "alarm.name.2038937742892732416": "单包电压低3级",
  "alarm.excDesc.2038937742892732416": "无",
  "alarm.suggestion.2038937742892732416": "无",
  "alarm.desc.2038937742892732416": "无",
  "alarm.name.2038937742980812800": "单包放电压差大3级",
  "alarm.excDesc.2038937742980812800": "无",
  "alarm.suggestion.2038937742980812800": "无",
  "alarm.desc.2038937742980812800": "无",
  "alarm.name.2038937743068893184": "单体放电压差大3级",
  "alarm.excDesc.2038937743068893184": "无",
  "alarm.suggestion.2038937743068893184": "无",
  "alarm.desc.2038937743068893184": "无",
  "alarm.name.2038937743156973568": "放电温度低3级",
  "alarm.excDesc.2038937743156973568": "无",
  "alarm.suggestion.2038937743156973568": "无",
  "alarm.desc.2038937743156973568": "无",
  "alarm.name.2038937743249248256": "单体电压低3级",
  "alarm.excDesc.2038937743249248256": "无",
  "alarm.suggestion.2038937743249248256": "无",
  "alarm.desc.2038937743249248256": "无",
  "alarm.name.2038937743341522944": "SOC低3级",
  "alarm.excDesc.2038937743341522944": "无",
  "alarm.suggestion.2038937743341522944": "无",
  "alarm.desc.2038937743341522944": "无",
  "alarm.name.2038937742754320384": "充电温度低2级",
  "alarm.excDesc.2038937742754320384": "无",
  "alarm.suggestion.2038937742754320384": "无",
  "alarm.desc.2038937742754320384": "无",
  "alarm.name.2038937742842400768": "单包电压高3级",
  "alarm.excDesc.2038937742842400768": "无",
  "alarm.suggestion.2038937742842400768": "无",
  "alarm.desc.2038937742842400768": "无",
  "alarm.name.2038937742934675456": "极柱温度高3级",
  "alarm.excDesc.2038937742934675456": "无",
  "alarm.suggestion.2038937742934675456": "无",
  "alarm.desc.2038937742934675456": "无",
  "alarm.name.2038937743022755840": "单包充电压差大3级",
  "alarm.excDesc.2038937743022755840": "无",
  "alarm.suggestion.2038937743022755840": "无",
  "alarm.desc.2038937743022755840": "无",
  "alarm.name.2038937743115030528": "放电温度高3级",
  "alarm.excDesc.2038937743115030528": "无",
  "alarm.suggestion.2038937743115030528": "无",
  "alarm.desc.2038937743115030528": "无",
  "alarm.name.2038937743203110912": "单体电压高3级",
  "alarm.excDesc.2038937743203110912": "无",
  "alarm.suggestion.2038937743203110912": "无",
  "alarm.desc.2038937743203110912": "无",
  "alarm.name.2038937743295385600": "单体充电压差大3级",
  "alarm.excDesc.2038937743295385600": "无",
  "alarm.suggestion.2038937743295385600": "无",
  "alarm.desc.2038937743295385600": "无",
  "alarm.name.2038937743383465984": "SOC高3级",
  "alarm.excDesc.2038937743383465984": "无",
  "alarm.suggestion.2038937743383465984": "无",
  "alarm.desc.2038937743383465984": "无",
  "alarm.name.2038937743471546368": "充电电流大3级",
  "alarm.excDesc.2038937743471546368": "无",
  "alarm.suggestion.2038937743471546368": "无",
  "alarm.desc.2038937743471546368": "无",
  "alarm.name.2038937743563821056": "温差大3级",
  "alarm.excDesc.2038937743563821056": "无",
  "alarm.suggestion.2038937743563821056": "无",
  "alarm.desc.2038937743563821056": "无",
  "alarm.name.2038937743660290048": "总压高3级",
  "alarm.excDesc.2038937743660290048": "无",
  "alarm.suggestion.2038937743660290048": "无",
  "alarm.desc.2038937743660290048": "无",
  "alarm.name.2038937742666240000": "总压低2级",
  "alarm.excDesc.2038937742666240000": "无",
  "alarm.suggestion.2038937742666240000": "无",
  "alarm.desc.2038937742666240000": "无",
  "alarm.name.2038937743748370432": "充电温度高3级",
  "alarm.excDesc.2038937743748370432": "无",
  "alarm.suggestion.2038937743748370432": "无",
  "alarm.desc.2038937743748370432": "无",
  "alarm.name.2038937743840645120": "簇间压差大",
  "alarm.excDesc.2038937743840645120": "无",
  "alarm.suggestion.2038937743840645120": "无",
  "alarm.desc.2038937743840645120": "无",
  "alarm.name.2038937743928725504": "与EMS通讯失败",
  "alarm.excDesc.2038937743928725504": "无",
  "alarm.suggestion.2038937743928725504": "无",
  "alarm.desc.2038937743928725504": "无",
  "alarm.name.2038937744012611584": "PCS通讯超时",
  "alarm.excDesc.2038937744012611584": "无",
  "alarm.suggestion.2038937744012611584": "无",
  "alarm.desc.2038937744012611584": "无",
  "alarm.name.2038937744159412224": "电池簇就位数量不足",
  "alarm.excDesc.2038937744159412224": "无",
  "alarm.suggestion.2038937744159412224": "无",
  "alarm.desc.2038937744159412224": "无",
  "alarm.name.2038937744327184384": "SBAU断路器故障",
  "alarm.excDesc.2038937744327184384": "无",
  "alarm.suggestion.2038937744327184384": "无",
  "alarm.desc.2038937744327184384": "无",
  "alarm.name.2038937743429603328": "SOE低3级",
  "alarm.excDesc.2038937743429603328": "无",
  "alarm.suggestion.2038937743429603328": "无",
  "alarm.desc.2038937743429603328": "无",
  "alarm.name.2038937743517683712": "放电电流大3级",
  "alarm.excDesc.2038937743517683712": "无",
  "alarm.suggestion.2038937743517683712": "无",
  "alarm.desc.2038937743517683712": "无",
  "alarm.name.2038937743614152704": "绝缘低3级",
  "alarm.excDesc.2038937743614152704": "无",
  "alarm.suggestion.2038937743614152704": "无",
  "alarm.desc.2038937743614152704": "无",
  "alarm.name.2038937743706427392": "总压低3级",
  "alarm.excDesc.2038937743706427392": "无",
  "alarm.suggestion.2038937743706427392": "无",
  "alarm.desc.2038937743706427392": "无",
  "alarm.name.2038937743882588160": "与主控通讯异常",
  "alarm.excDesc.2038937743882588160": "无",
  "alarm.suggestion.2038937743882588160": "无",
  "alarm.desc.2038937743882588160": "无",
  "alarm.name.2038937743970668544": "EMS/PCS强控继电器",
  "alarm.excDesc.2038937743970668544": "无",
  "alarm.suggestion.2038937743970668544": "无",
  "alarm.desc.2038937743970668544": "无",
  "alarm.name.2038937743794507776": "充电温度低3级",
  "alarm.excDesc.2038937743794507776": "无",
  "alarm.suggestion.2038937743794507776": "无",
  "alarm.desc.2038937743794507776": "无",
  "alarm.name.2038937744062943232": "显示屏通讯故障",
  "alarm.excDesc.2038937744062943232": "无",
  "alarm.suggestion.2038937744062943232": "无",
  "alarm.desc.2038937744062943232": "无",
  "alarm.name.2038937744230715392": "电池簇就位数量超出",
  "alarm.excDesc.2038937744230715392": "无",
  "alarm.suggestion.2038937744230715392": "无",
  "alarm.desc.2038937744230715392": "无",
  "alarm.name.2038937744406876160": "初始化阻塞",
  "alarm.excDesc.2038937744406876160": "无",
  "alarm.suggestion.2038937744406876160": "无",
  "alarm.desc.2038937744406876160": "无",
  "alarm.name.2038937744880832512": "被动均衡故障",
  "alarm.excDesc.2038937744880832512": "无",
  "alarm.suggestion.2038937744880832512": "无",
  "alarm.desc.2038937744880832512": "无",
  "alarm.name.2038937744486567936": "维护充电",
  "alarm.excDesc.2038937744486567936": "无",
  "alarm.suggestion.2038937744486567936": "无",
  "alarm.desc.2038937744486567936": "无",
  "alarm.name.2038937745090547712": "SBCU-QF断路器故障",
  "alarm.excDesc.2038937745090547712": "无",
  "alarm.suggestion.2038937745090547712": "无",
  "alarm.desc.2038937745090547712": "无",
  "alarm.name.2038937745178628096": "电池接线故障",
  "alarm.excDesc.2038937745178628096": "无",
  "alarm.suggestion.2038937745178628096": "无",
  "alarm.desc.2038937745178628096": "无",
  "alarm.name.2038937745266708480": "温敏线故障",
  "alarm.excDesc.2038937745266708480": "无",
  "alarm.suggestion.2038937745266708480": "无",
  "alarm.desc.2038937745266708480": "无",
  "alarm.name.2038937745358983168": "主正继电器故障",
  "alarm.excDesc.2038937745358983168": "无",
  "alarm.suggestion.2038937745358983168": "无",
  "alarm.desc.2038937745358983168": "无",
  "alarm.name.2038937745451257856": "保险丝故障",
  "alarm.excDesc.2038937745451257856": "无",
  "alarm.suggestion.2038937745451257856": "无",
  "alarm.desc.2038937745451257856": "无",
  "alarm.name.2038937744792752128": "高压箱温度线故障",
  "alarm.excDesc.2038937744792752128": "无",
  "alarm.suggestion.2038937744792752128": "无",
  "alarm.desc.2038937744792752128": "无",
  "alarm.name.2038937745044410368": "主动均衡故障",
  "alarm.excDesc.2038937745044410368": "无",
  "alarm.suggestion.2038937745044410368": "无",
  "alarm.desc.2038937745044410368": "无",
  "alarm.name.2038937745136685056": "SBMU硬件故障",
  "alarm.excDesc.2038937745136685056": "无",
  "alarm.suggestion.2038937745136685056": "无",
  "alarm.desc.2038937745136685056": "无",
  "alarm.name.2038937745224765440": "SBMU通讯故障",
  "alarm.excDesc.2038937745224765440": "无",
  "alarm.suggestion.2038937745224765440": "无",
  "alarm.desc.2038937745224765440": "无",
  "alarm.name.2038937745312845824": "主负继电器故障",
  "alarm.excDesc.2038937745312845824": "无",
  "alarm.suggestion.2038937745312845824": "无",
  "alarm.desc.2038937745312845824": "无",
  "alarm.name.2038937745405120512": "预充故障",
  "alarm.excDesc.2038937745405120512": "无",
  "alarm.suggestion.2038937745405120512": "无",
  "alarm.desc.2038937745405120512": "无",
  "alarm.name.2038937745497395200": "电流环故障",
  "alarm.excDesc.2038937745497395200": "无",
  "alarm.suggestion.2038937745497395200": "无",
  "alarm.desc.2038937745497395200": "无",
  "alarm.name.2038937745589669888": "单体电压异常升高",
  "alarm.excDesc.2038937745589669888": "无",
  "alarm.suggestion.2038937745589669888": "无",
  "alarm.desc.2038937745589669888": "无",
  "alarm.name.2038937745686138880": "单体极低",
  "alarm.excDesc.2038937745686138880": "无",
  "alarm.suggestion.2038937745686138880": "无",
  "alarm.desc.2038937745686138880": "无",
  "alarm.name.2038937745778413568": "继电器强制控制",
  "alarm.excDesc.2038937745778413568": "无",
  "alarm.suggestion.2038937745778413568": "无",
  "alarm.desc.2038937745778413568": "无",
  "alarm.name.2038937745870688256": "消防故障",
  "alarm.excDesc.2038937745870688256": "无",
  "alarm.suggestion.2038937745870688256": "无",
  "alarm.desc.2038937745870688256": "无",
  "alarm.name.2038937745954574336": "消防设备故障",
  "alarm.excDesc.2038937745954574336": "无",
  "alarm.suggestion.2038937745954574336": "无",
  "alarm.desc.2038937745954574336": "无",
  "alarm.name.2038937746046849024": "空调故障",
  "alarm.excDesc.2038937746046849024": "无",
  "alarm.suggestion.2038937746046849024": "无",
  "alarm.desc.2038937746046849024": "无",
  "alarm.name.2038937746134929408": "AC防雷故障",
  "alarm.excDesc.2038937746134929408": "无",
  "alarm.suggestion.2038937746134929408": "无",
  "alarm.desc.2038937746134929408": "无",
  "alarm.name.2038937746223009792": "UPS放空",
  "alarm.excDesc.2038937746223009792": "无",
  "alarm.suggestion.2038937746223009792": "无",
  "alarm.desc.2038937746223009792": "无",
  "alarm.name.2038937746306895872": "液冷通讯异常",
  "alarm.excDesc.2038937746306895872": "无",
  "alarm.suggestion.2038937746306895872": "无",
  "alarm.desc.2038937746306895872": "无",
  "alarm.name.2038937746394976256": "温湿度通讯异常",
  "alarm.excDesc.2038937746394976256": "无",
  "alarm.suggestion.2038937746394976256": "无",
  "alarm.desc.2038937746394976256": "无",
  "alarm.name.2038937745640001536": "单体极高",
  "alarm.excDesc.2038937745640001536": "无",
  "alarm.suggestion.2038937745640001536": "无",
  "alarm.desc.2038937745640001536": "无",
  "alarm.name.2038937745732276224": "温度极高",
  "alarm.excDesc.2038937745732276224": "无",
  "alarm.suggestion.2038937745732276224": "无",
  "alarm.desc.2038937745732276224": "无",
  "alarm.name.2038937745824550912": "PCS故障",
  "alarm.excDesc.2038937745824550912": "无",
  "alarm.suggestion.2038937745824550912": "无",
  "alarm.desc.2038937745824550912": "无",
  "alarm.name.2038937745543532544": "总压采集无效",
  "alarm.excDesc.2038937745543532544": "无",
  "alarm.suggestion.2038937745543532544": "无",
  "alarm.desc.2038937745543532544": "无",
  "alarm.name.2038937745912631296": "火警报警",
  "alarm.excDesc.2038937745912631296": "无",
  "alarm.suggestion.2038937745912631296": "无",
  "alarm.desc.2038937745912631296": "无",
  "alarm.name.2038937746000711680": "消防设备动作",
  "alarm.excDesc.2038937746000711680": "无",
  "alarm.suggestion.2038937746000711680": "无",
  "alarm.desc.2038937746000711680": "无",
  "alarm.name.2038937746092986368": "DC防雷故障",
  "alarm.excDesc.2038937746092986368": "无",
  "alarm.suggestion.2038937746092986368": "无",
  "alarm.desc.2038937746092986368": "无",
  "alarm.name.2038937746181066752": "水浸告警",
  "alarm.excDesc.2038937746181066752": "无",
  "alarm.suggestion.2038937746181066752": "无",
  "alarm.desc.2038937746181066752": "无",
  "alarm.name.2038937746264952832": "UPS故障",
  "alarm.excDesc.2038937746264952832": "无",
  "alarm.suggestion.2038937746264952832": "无",
  "alarm.desc.2038937746264952832": "无",
  "alarm.name.2038937746348838912": "水浸通讯异常",
  "alarm.excDesc.2038937746348838912": "无",
  "alarm.suggestion.2038937746348838912": "无",
  "alarm.desc.2038937746348838912": "无",
  "alarm.name.2038937736509001728": "电网未上电",
  "alarm.excDesc.2038937736509001728": "无",
  "alarm.suggestion.2038937736509001728": "无",
  "alarm.desc.2038937736509001728": "无",
  "alarm.name.2038937736630636544": "电网电压不平衡",
  "alarm.excDesc.2038937736630636544": "无",
  "alarm.suggestion.2038937736630636544": "无",
  "alarm.desc.2038937736630636544": "无",
  "alarm.name.2038937736731299840": "高穿保护",
  "alarm.excDesc.2038937736731299840": "无",
  "alarm.suggestion.2038937736731299840": "无",
  "alarm.desc.2038937736731299840": "无",
  "alarm.name.2038937736852934656": "模块硬件过流",
  "alarm.excDesc.2038937736852934656": "无",
  "alarm.suggestion.2038937736852934656": "无",
  "alarm.desc.2038937736852934656": "无",
  "alarm.name.2038937736966180864": "母线硬件过压",
  "alarm.excDesc.2038937736966180864": "无",
  "alarm.suggestion.2038937736966180864": "无",
  "alarm.desc.2038937736966180864": "无",
  "alarm.name.2038937737066844160": "电池电流硬件过流",
  "alarm.excDesc.2038937737066844160": "无",
  "alarm.suggestion.2038937737066844160": "无",
  "alarm.desc.2038937737066844160": "无",
  "alarm.name.2038937737167507456": "EMS通讯故障",
  "alarm.excDesc.2038937737167507456": "无",
  "alarm.suggestion.2038937737167507456": "无",
  "alarm.desc.2038937737167507456": "无",
  "alarm.name.2038937737259782144": "载波同步失效",
  "alarm.excDesc.2038937737259782144": "无",
  "alarm.suggestion.2038937737259782144": "无",
  "alarm.desc.2038937737259782144": "无",
  "alarm.name.2038937737356251136": "主机通讯故障",
  "alarm.excDesc.2038937737356251136": "无",
  "alarm.suggestion.2038937737356251136": "无",
  "alarm.desc.2038937737356251136": "无",
  "alarm.name.2038937736571916288": "电网相序错误",
  "alarm.excDesc.2038937736571916288": "无",
  "alarm.suggestion.2038937736571916288": "无",
  "alarm.desc.2038937736571916288": "无",
  "alarm.name.2038937736680968192": "电网孤岛状态",
  "alarm.excDesc.2038937736680968192": "无",
  "alarm.suggestion.2038937736680968192": "无",
  "alarm.desc.2038937736680968192": "无",
  "alarm.name.2038937736781631488": "低穿保护",
  "alarm.excDesc.2038937736781631488": "无",
  "alarm.suggestion.2038937736781631488": "无",
  "alarm.desc.2038937736781631488": "无",
  "alarm.name.2038937736911654912": "逐波限流超限",
  "alarm.excDesc.2038937736911654912": "无",
  "alarm.suggestion.2038937736911654912": "无",
  "alarm.desc.2038937736911654912": "无",
  "alarm.name.2038937737016512512": "电源故障",
  "alarm.excDesc.2038937737016512512": "无",
  "alarm.suggestion.2038937737016512512": "无",
  "alarm.desc.2038937737016512512": "无",
  "alarm.name.2038937737121370112": "BMS通讯故障",
  "alarm.excDesc.2038937737121370112": "无",
  "alarm.suggestion.2038937737121370112": "无",
  "alarm.desc.2038937737121370112": "无",
  "alarm.name.2038937737213644800": "从机故障",
  "alarm.excDesc.2038937737213644800": "无",
  "alarm.suggestion.2038937737213644800": "无",
  "alarm.desc.2038937737213644800": "无",
  "alarm.name.2038937737310113792": "主机故障",
  "alarm.excDesc.2038937737310113792": "无",
  "alarm.suggestion.2038937737310113792": "无",
  "alarm.desc.2038937737310113792": "无",
  "alarm.name.2038937737402388480": "从机通讯故障",
  "alarm.excDesc.2038937737402388480": "无",
  "alarm.suggestion.2038937737402388480": "无",
  "alarm.desc.2038937737402388480": "无",
  "alarm.name.2038937737490468864": "并离网切换命令异常",
  "alarm.excDesc.2038937737490468864": "无",
  "alarm.suggestion.2038937737490468864": "无",
  "alarm.desc.2038937737490468864": "无",
  "alarm.name.2038937737582743552": "预充电超时",
  "alarm.excDesc.2038937737582743552": "无",
  "alarm.suggestion.2038937737582743552": "无",
  "alarm.desc.2038937737582743552": "无",
  "alarm.name.2038937737687601152": "母线电压检测异常",
  "alarm.excDesc.2038937737687601152": "无",
  "alarm.suggestion.2038937737687601152": "无",
  "alarm.desc.2038937737687601152": "无",
  "alarm.name.2038937737775681536": "直流系统预充电未准备好",
  "alarm.excDesc.2038937737775681536": "无",
  "alarm.suggestion.2038937737775681536": "无",
  "alarm.desc.2038937737775681536": "无",
  "alarm.name.2038937737867956224": "电池电压检测异常",
  "alarm.excDesc.2038937737867956224": "无",
  "alarm.suggestion.2038937737867956224": "无",
  "alarm.desc.2038937737867956224": "无",
  "alarm.name.2038937738018951168": "网侧漏电流过大",
  "alarm.excDesc.2038937738018951168": "无",
  "alarm.suggestion.2038937738018951168": "无",
  "alarm.desc.2038937738018951168": "无",
  "alarm.name.2038937737444331520": "STS通讯故障",
  "alarm.excDesc.2038937737444331520": "无",
  "alarm.suggestion.2038937737444331520": "无",
  "alarm.desc.2038937737444331520": "无",
  "alarm.name.2038937737536606208": "STS故障",
  "alarm.excDesc.2038937737536606208": "无",
  "alarm.suggestion.2038937737536606208": "无",
  "alarm.desc.2038937737536606208": "无",
  "alarm.name.2038937737633075200": "母线短路",
  "alarm.excDesc.2038937737633075200": "无",
  "alarm.suggestion.2038937737633075200": "无",
  "alarm.desc.2038937737633075200": "无",
  "alarm.name.2038937737729544192": "正负母线对地不平衡",
  "alarm.excDesc.2038937737729544192": "无",
  "alarm.suggestion.2038937737729544192": "无",
  "alarm.desc.2038937737729544192": "无",
  "alarm.name.2038937737826013184": "直流电源未准备好",
  "alarm.excDesc.2038937737826013184": "无",
  "alarm.suggestion.2038937737826013184": "无",
  "alarm.desc.2038937737826013184": "无",
  "alarm.name.2038937737909899264": "电池电压极性反接检测异常",
  "alarm.excDesc.2038937737909899264": "无",
  "alarm.suggestion.2038937737909899264": "无",
  "alarm.desc.2038937737909899264": "无",
  "alarm.name.2038937737972813824": "模块过流",
  "alarm.excDesc.2038937737972813824": "无",
  "alarm.suggestion.2038937737972813824": "无",
  "alarm.desc.2038937737972813824": "无",
  "alarm.name.2038937738065088512": "网侧模块电流不平衡",
  "alarm.excDesc.2038937738065088512": "无",
  "alarm.suggestion.2038937738065088512": "无",
  "alarm.desc.2038937738065088512": "无",
  "alarm.name.2038937738165751808": "模块过温",
  "alarm.excDesc.2038937738165751808": "无",
  "alarm.suggestion.2038937738165751808": "无",
  "alarm.desc.2038937738165751808": "无",
  "alarm.name.2038937738258026496": "滤波电容欠压",
  "alarm.excDesc.2038937738258026496": "无",
  "alarm.suggestion.2038937738258026496": "无",
  "alarm.desc.2038937738258026496": "无",
  "alarm.name.2038937738346106880": "有功功率过大",
  "alarm.excDesc.2038937738346106880": "无",
  "alarm.suggestion.2038937738346106880": "无",
  "alarm.desc.2038937738346106880": "无",
  "alarm.name.2038937738438381568": "过温降载",
  "alarm.excDesc.2038937738438381568": "无",
  "alarm.suggestion.2038937738438381568": "无",
  "alarm.desc.2038937738438381568": "无",
  "alarm.name.2038937738534850560": "有功功率偏差大",
  "alarm.excDesc.2038937738534850560": "无",
  "alarm.suggestion.2038937738534850560": "无",
  "alarm.desc.2038937738534850560": "无",
  "alarm.name.2038937738635513856": "无功调节输出达到限幅值",
  "alarm.excDesc.2038937738635513856": "无",
  "alarm.suggestion.2038937738635513856": "无",
  "alarm.desc.2038937738635513856": "无",
  "alarm.name.2038937738123808768": "模块I2t过载",
  "alarm.excDesc.2038937738123808768": "无",
  "alarm.suggestion.2038937738123808768": "无",
  "alarm.desc.2038937738123808768": "无",
  "alarm.name.2038937738211889152": "滤波电容过压",
  "alarm.excDesc.2038937738211889152": "无",
  "alarm.suggestion.2038937738211889152": "无",
  "alarm.desc.2038937738211889152": "无",
  "alarm.name.2038937738299969536": "调试错误",
  "alarm.excDesc.2038937738299969536": "无",
  "alarm.suggestion.2038937738299969536": "无",
  "alarm.desc.2038937738299969536": "无",
  "alarm.name.2038937738392244224": "有功达到限幅值",
  "alarm.excDesc.2038937738392244224": "无",
  "alarm.suggestion.2038937738392244224": "无",
  "alarm.desc.2038937738392244224": "无",
  "alarm.name.2038937738484518912": "交直流功率不匹配",
  "alarm.excDesc.2038937738484518912": "无",
  "alarm.suggestion.2038937738484518912": "无",
  "alarm.desc.2038937738484518912": "无",
  "alarm.name.2038937738580987904": "有功调节输出达到限幅值",
  "alarm.excDesc.2038937738580987904": "无",
  "alarm.suggestion.2038937738580987904": "无",
  "alarm.desc.2038937738580987904": "无",
  "alarm.name.2038937738685845504": "无功达到限幅值",
  "alarm.excDesc.2038937738685845504": "无",
  "alarm.suggestion.2038937738685845504": "无",
  "alarm.desc.2038937738685845504": "无",
  "alarm.name.2038937738778120192": "漏电流传感器自检失败",
  "alarm.excDesc.2038937738778120192": "无",
  "alarm.suggestion.2038937738778120192": "无",
  "alarm.desc.2038937738778120192": "无",
  "alarm.name.2038937738878783488": "漏电流零漂采样过大",
  "alarm.excDesc.2038937738878783488": "无",
  "alarm.suggestion.2038937738878783488": "无",
  "alarm.desc.2038937738878783488": "无",
  "alarm.name.2038937738992029696": "AD采样零漂过大",
  "alarm.excDesc.2038937738992029696": "无",
  "alarm.suggestion.2038937738992029696": "无",
  "alarm.desc.2038937738992029696": "无",
  "alarm.name.2038937739096887296": "预充电接触器故障",
  "alarm.excDesc.2038937739096887296": "无",
  "alarm.suggestion.2038937739096887296": "无",
  "alarm.desc.2038937739096887296": "无",
  "alarm.name.2038937739193356288": "直流预充电接触故障",
  "alarm.excDesc.2038937739193356288": "无",
  "alarm.suggestion.2038937739193356288": "无",
  "alarm.desc.2038937739193356288": "无",
  "alarm.name.2038937739298213888": "并网接触器故障",
  "alarm.excDesc.2038937739298213888": "无",
  "alarm.suggestion.2038937739298213888": "无",
  "alarm.desc.2038937739298213888": "无",
  "alarm.name.2038937739398877184": "充电终止",
  "alarm.excDesc.2038937739398877184": "无",
  "alarm.suggestion.2038937739398877184": "无",
  "alarm.desc.2038937739398877184": "无",
  "alarm.name.2038937739499540480": "温升快1级",
  "alarm.excDesc.2038937739499540480": "无",
  "alarm.suggestion.2038937739499540480": "无",
  "alarm.desc.2038937739499540480": "无",
  "alarm.name.2038937738736177152": "紧急停机",
  "alarm.excDesc.2038937738736177152": "无",
  "alarm.suggestion.2038937738736177152": "无",
  "alarm.desc.2038937738736177152": "无",
  "alarm.name.2038937738832646144": "直流对地绝缘阻抗失效",
  "alarm.excDesc.2038937738832646144": "无",
  "alarm.suggestion.2038937738832646144": "无",
  "alarm.desc.2038937738832646144": "无",
  "alarm.name.2038937738941698048": "内部环境温度过高",
  "alarm.excDesc.2038937738941698048": "无",
  "alarm.suggestion.2038937738941698048": "无",
  "alarm.desc.2038937738941698048": "无",
  "alarm.name.2038937739046555648": "交流对地绝缘故障",
  "alarm.excDesc.2038937739046555648": "无",
  "alarm.suggestion.2038937739046555648": "无",
  "alarm.desc.2038937739046555648": "无",
  "alarm.name.2038937739147218944": "主接触器故障",
  "alarm.excDesc.2038937739147218944": "无",
  "alarm.suggestion.2038937739147218944": "无",
  "alarm.desc.2038937739147218944": "无",
  "alarm.name.2038937739247882240": "直流主接触器故障",
  "alarm.excDesc.2038937739247882240": "无",
  "alarm.suggestion.2038937739247882240": "无",
  "alarm.desc.2038937739247882240": "无",
  "alarm.name.2038937739348545536": "BMS故障",
  "alarm.excDesc.2038937739348545536": "无",
  "alarm.suggestion.2038937739348545536": "无",
  "alarm.desc.2038937739348545536": "无",
  "alarm.name.2038937739445014528": "放电终止",
  "alarm.excDesc.2038937739445014528": "无",
  "alarm.suggestion.2038937739445014528": "无",
  "alarm.desc.2038937739445014528": "无",
  "alarm.name.2038937740334206976": "单包电压高1级",
  "alarm.excDesc.2038937740334206976": "无",
  "alarm.suggestion.2038937740334206976": "无",
  "alarm.desc.2038937740334206976": "无",
  "alarm.name.2038937740460036096": "单包电压低1级",
  "alarm.excDesc.2038937740460036096": "无",
  "alarm.suggestion.2038937740460036096": "无",
  "alarm.desc.2038937740460036096": "无",
  "alarm.name.2038937740774608896": "极柱温度高1级",
  "alarm.excDesc.2038937740774608896": "无",
  "alarm.suggestion.2038937740774608896": "无",
  "alarm.desc.2038937740774608896": "无",
  "50901.real_time.previous_gridPowerC": "电网侧C相功率",
  "50901.real_time.previous_gridPower": "电网侧功率",
  "50901..previous_gridPowerA.desc": "电网侧A相功率的说明。",
  "50901..previous_gridPowerB.desc": "电网侧B相功率的说明。",
  "50901.real_time.previous_gridPowerC.desc": "电网侧C相功率的说明。",
  "50655.realtime.powerForecast": "功率预测数据上报",
  "50655.control.reversePower.0": "失效",
  "50655.control.reversePower.1": "生效",
  "50655.control.reverseEnable": "防逆流使能",
  "50655.control.reverseEnable.0": "关闭",
  "50655.control.reverseEnable.1": "开启",
  "51102.s\\collector.c_firmwareversion": "采集器软件版本号",
  "51102.s\\collector.c_hardversion": "采集器硬件版本",
  "51102.s\\collector.c_protocalver": "设备通信协议版本",
  "51102.s\\collector.c_mqtts_protocalver": "mqtts通信协议版本",
  "51102.s\\collector.c_ble_protocalver": "蓝牙通信协议版本",
  "51102.s\\collector.c_wifi_rssi": "WIFI信号强度",
  "51102.s\\collector.checkTime": "系统时间",
  "51102.s\\collector.c_wifi_ssid": "WIFI名称",
  "51102.s\\collector.c_wifi_passwd": "WIFI密码",
  "51102.s\\collector.c_ble_name": "BLE名称",
  "51102.s\\collector.c_mqtts_url": "服务器url",
  "51102.s\\collector.c_mqtts_port": "服务器端口号",
  "51102.s\\collector.otaHttpUrl": "升级包url",
  "51102.s\\collector.c_datalogger_reboot": "采集器重启",
  "51102.s\\collector.c_datalogger_factory_reset": "采集器恢复出厂设置",
  "51102.s\\collector.c_datalogger_ble_onoff": "蓝牙使能",
  "51102.s\\collector.c_eletMeter1_sn": "电表1SN",
  "51102.s\\collector.c_eletMeter1_insPlace": "电表1安装位置",
  "51102.s\\collector.c_eletMeter1_commType": "电表1通信方式",
  "51102.s\\collector.c_eletMeter1_phaseNo": "电表1设备安装相位",
  "51102.s\\collector.c_eletMeter2_sn": "电表2SN",
  "51102.s\\collector.c_eletMeter2_insPlace": "电表2安装位置",
  "51102.s\\collector.c_eletMeter2_commType": "电表2通信方式",
  "51102.s\\collector.c_eletMeter2_phaseNo": "电表2设备安装相位",
  "51102.s\\collector.c_eletMeter3_sn": "电表3SN",
  "51102.s\\collector.c_eletMeter3_insPlace": "电表3安装位置",
  "51102.s\\collector.c_eletMeter3_commType": "电表3通信方式",
  "51102.s\\collector.c_eletMeter3_phaseNo": "电表3设备安装相位",
  "51102.s\\real_time.dev_series": "设备型号",
  "51102.s\\real_time.dev_type": "设备类型",
  "51102.s\\real_time.Protocol_type": "协议类型",
  "51102.s\\real_time.protocol_ver": "协议版本",
  "51102.s\\real_time.manu_info": "厂家信息",
  "51102.s\\real_time.SN": "产品SN",
  "51102.s\\real_time.softver1": "软件版本1",
  "51102.s\\real_time.softver2": "软件版本2",
  "51102.s\\real_time.hardver1": "硬件版本1",
  "51102.s\\real_time.hardver2": "硬件版本2",
  "51102.s\\real_time.softnumber1": "软件编码1",
  "51102.s\\real_time.softnumber2": "软件编码2",
  "51102.s\\real_time.battcorecnt": "电芯个数",
  "51102.s\\real_time.battcoretmpcnt": "电芯温度个数",
  "51102.s\\real_time.ratedpower": "额定功率",
  "51102.s\\real_time.bms_status": "BMS状态字",
  "51102.s\\real_time.bms_total_v": "电池组总电压",
  "51102.s\\real_time.bms_total_I": "电池组总电流",
  "51102.s\\real_time.batterySoc": "电池组SOC",
  "51102.s\\real_time.bms_total_SOH": "电池组SOH",
  "51102.s\\real_time.chg_full_time": "预计充满时间",
  "51102.s\\real_time.dischg_time": "剩余放电时间",
  "51102.s\\real_time.cell_max_v": "单体最高电压",
  "51102.s\\real_time.cell_min_v": "单体最低电压",
  "51102.s\\real_time.cell_max_v_id": "最高单体电池电压编号",
  "51102.s\\real_time.cell_min_v_id": "最低单体电池电压编号",
  "51102.s\\real_time.cell_max_temp": "单体最高温度",
  "51102.s\\real_time.cell_min_temp": "单体最低温度",
  "51102.s\\real_time.cell_max_temp_id": "最高单体电池温度编号",
  "51102.s\\real_time.cell_min_temp_id": "最低单体电池温度编号",
  "51102.s\\real_time.batt_SOP": "电池组SOP",
  "51102.s\\real_time.batt_type": "电池类型",
  "51102.s\\real_time.batt_rated_Q": "单体电池额定容量",
  "51102.s\\real_time.batt_DC_port_V": "DC端口电压",
  "51102.s\\real_time.heat_film_I": "加热膜电流",
  "51102.s\\real_time.heat_film_P": "加热膜功率",
  "51102.s\\real_time.cell_1_v": "电芯1电压",
  "51102.s\\real_time.cell_2_v": "电芯2电压",
  "51102.s\\real_time.cell_3_v": "电芯3电压",
  "51102.s\\real_time.cell_4_v": "电芯4电压",
  "51102.s\\real_time.cell_5_v": "电芯5电压",
  "51102.s\\real_time.cell_1_temp": "电芯1温度",
  "51102.s\\real_time.cell_2_temp": "电芯2温度",
  "51102.s\\real_time.cell_3_temp": "电芯3温度",
  "51102.s\\real_time.cell_4_temp": "电芯4温度",
  "51102.s\\real_time.cell_5_temp": "电芯5温度",
  "51102.s\\real_time.batt_term_tmp": "极柱温度",
  "51102.s\\real_time.batt_copper_temp": "铜排温度",
  "51102.s\\real_time.dischg_mos_tmp": "放电MOS温度",
  "51102.s\\real_time.chg_mos_tmp": "充电MOS温度",
  "51102.s\\real_time.palnetif_v": "并网口电压",
  "51102.s\\real_time.palnetif_I": "并网口电流",
  "51102.s\\real_time.palnetif_f": "并网口频率",
  "51102.s\\real_time.palnetif_P": "并网口有功功率",
  "51102.s\\real_time.palnetif_Q": "并网口无功功率",
  "51102.s\\real_time.palnetif_S": "并网口视在功率",
  "51102.s\\real_time.palnetif_PF": "并网口功率因数",
  "51102.s\\real_time.eps_v": "ESP口电压",
  "51102.s\\real_time.eps_I": "ESP口电流",
  "51102.s\\real_time.eps_f": "ESP口频率",
  "51102.s\\real_time.eps_P": "ESP口有功功率",
  "51102.s\\real_time.eps_Q": "ESP口无功功率",
  "51102.s\\real_time.eps_S": "ESP口视在功率",
  "51102.s\\real_time.eps_PF": "ESP口功率因数",
  "51102.s\\real_time.batt_v": "电池电压",
  "51102.s\\real_time.batt_I": "电池电流",
  "51102.s\\real_time.batt_P": "电池功率",
  "51102.s\\real_time.chg_v": "充电电压",
  "51102.s\\real_time.chg_I": "充电电流",
  "51102.s\\real_time.chg_P": "充电功率",
  "51102.s\\real_time.pv1_input_v": "PV1输入电压",
  "51102.s\\real_time.pv1_input_I": "PV1输入电流",
  "51102.s\\real_time.pv1_input_P": "PV1输入功率",
  "51102.s\\real_time.pv1_output_v": "PV1输出电压",
  "51102.s\\real_time.pv1_output_I": "PV1输出电流",
  "51102.s\\real_time.pv1_output_P": "PV1输出功率",
  "51102.s\\real_time.pv2_input_v": "PV2输入电压",
  "51102.s\\real_time.pv2_input_I": "PV2输入电流",
  "51102.s\\real_time.pv2_input_P": "PV2输入功率",
  "51102.s\\real_time.pv2_output_v": "PV2输出电压",
  "51102.s\\real_time.pv2_output_I": "PV2输出电流",
  "51102.s\\real_time.pv2_output_P": "PV2输出功率",
  "51102.s\\real_time.pv3_input_v": "PV3输入电压",
  "51102.s\\real_time.pv3_input_I": "PV3输入电流",
  "51102.s\\real_time.pv3_input_P": "PV3输入功率",
  "51102.s\\real_time.pv3_output_v": "PV3输出电压",
  "51102.s\\real_time.pv3_output_I": "PV3输出电流",
  "51102.s\\real_time.pv3_output_P": "PV3输出功率",
  "51102.s\\real_time.pv4_input_v": "PV4输入电压",
  "51102.s\\real_time.pv4_input_I": "PV4输入电流",
  "51102.s\\real_time.pv4_input_P": "PV4输入功率",
  "51102.s\\real_time.pv4_output_v": "PV4输出电压",
  "51102.s\\real_time.pv4_output_I": "PV4输出电流",
  "51102.s\\real_time.pv4_output_P": "PV4输出功率",
  "51102.s\\real_time.env_temp_1": "环境温度1",
  "51102.s\\real_time.env_temp_2": "环境温度2",
  "51102.s\\real_time.PFC_temp": "PFC散热器温度",
  "51102.s\\real_time.DC_temp1": "DC散热器温度1",
  "51102.s\\real_time.DC_temp2": "DC散热器温度2",
  "51102.s\\real_time.PV1_temp": "PV1散热器温度",
  "51102.s\\real_time.PV2_temp": "PV2散热器温度",
  "51102.s\\real_time.PV3_temp": "PV3散热器温度",
  "51102.s\\real_time.PV4_temp": "PV4散热器温度",
  "51102.s\\real_time.bus_v": "母线电压",
  "51102.s\\real_time.anti_curr_status": "防逆流功能状态",
  "51102.s\\real_time.low_volt_cross_status": "低电压穿越功能状态",
  "51102.s\\real_time.f_cross_status": "频率穿越功能状态",
  "51102.s\\real_time.reconn_cross_status": "并网重连功能状态",
  "51102.s\\real_time.inv_ver": "逆变器软件版本",
  "51102.s\\real_time.inv_hard_ver": "逆变器硬件版本",
  "51102.s\\real_time.inv_profile": "逆变器国家规格",
  "51102.s\\real_time.inv_manufac": "逆变器厂家信息",
  "51102.s\\real_time.inv_SN": "逆变器序列号",
  "51102.s\\real_time.deviceStatus": "微储状态",
  "51102.s\\real_time.Wifi_BT_Online": "wifi/蓝牙在线状态",
  "51102.s\\real_time.Wifi_BT_Sleep": "wifi/蓝牙休眠",
  "51102.s\\real_time.workStatus": "系统工作状态",
  "51102.s\\real_time.workMode": "工作模式",
  "51102.s\\real_time.parelletRunStatue": "并机状态",
  "51102.s\\real_time.acDischargeMode": "AC放电状态",
  "51102.s\\real_time.acchargeStatus": "AC充电状态",
  "51102.s\\real_time.MPPTStatus": "MPPT状态",
  "51102.s\\real_time.SleepStatus": "系统休眠状态",
  "51102.s\\real_time.gridConnStatus": "并离网状态",
  "51102.s\\real_time.antiReverseIStatus": "防逆流状态",
  "51102.s\\real_time.masterOrSlaveStatus": "主从机状态",
  "51102.s\\real_time.EPSConnStatus": "EPS接入状态",
  "51102.s\\real_time.remote_onoff_status": "远程开关机状态",
  "51102.s\\real_time.shunt_trip_status": "分励脱扣器状态",
  "51102.s\\real_time.mod_grid_P": "并网口功率",
  "51102.s\\real_time.mod_PV_P": "PV发电功率",
  "51102.s\\real_time.mod_batteryPower": "电池侧功率",
  "51102.s\\real_time.mod_EPS_P": "EPS口功率",
  "51102.s\\real_time.mod_batt2Grid_P": "电池流向并网口的馈网功率",
  "51102.s\\real_time.mod_batt2EPS_P": "电池流向EPS负载的功率",
  "51102.s\\real_time.mod_PV2Batt_P": "PV流向电池的功率",
  "51102.s\\real_time.mod_PV2EPS_P": "PV流向EPS负载的功率",
  "51102.s\\real_time.mod_PV2Grid_P": "PV流向并网口的馈网功率",
  "51102.s\\real_time.mod_Grid2Batt_P": "并网口流向电池的功率",
  "51102.s\\real_time.mod_Grid2EPS_P": "并网口流向EPS负载的功率",
  "51102.s\\real_time.mod_inv2Grid_P": "EPS微逆流向并网口的功率",
  "51102.s\\real_time.mod_EPS2Batt_P": "EPS微逆流向电池的功率",
  "51102.s\\real_time.mod_GridElctMeter_P": "网侧入户电表功率",
  "51102.s\\real_time.mod_ACElctMeter_P": "AC微逆电表功率",
  "51102.s\\real_time.mod_battGrp_soc": "电池组SOC",
  "51102.s\\real_time.acc_buy_energy": "累计买电电量",
  "51102.s\\real_time.acc_sell_energy": "累计卖电电量",
  "51102.s\\real_time.acc_PV_prod_energy": "光伏PV总发电量",
  "51102.s\\real_time.acc_EPS_prod_energy": "EPS微逆总发电量",
  "51102.s\\real_time.acc_AC_prod_energy": "AC微逆总发电量",
  "51102.s\\real_time.acc_load_use_enery": "负载累计用电量",
  "51102.s\\real_time.acc_bat_dischg_enery": "电池累计放电电量",
  "51102.s\\real_time.acc_bat_chg_enery": "电池累计充电电量",
  "51102.s\\real_time.acc_PV2Bat_E": "光伏PV流向电池的总电量",
  "51102.s\\real_time.acc_PV2Load_E": "光伏PV流向负载的总电量",
  "51102.s\\real_time.acc_PV2grid_E": "光伏PV流向电网的总电量",
  "51102.s\\real_time.acc_EPS_load_E": "ESP负载累计用电量",
  "51102.s\\real_time.today_buy_E": "今日买电电量",
  "51102.s\\real_time.today_sell_E": "今日卖电电量",
  "51102.s\\real_time.today_PV_E": "光伏PV今日累计发电量",
  "51102.s\\real_time.today_EPS_E": "EPS微逆今日累计发电量",
  "51102.s\\real_time.today_AC_E": "AC微逆今日累计发电量",
  "51102.s\\real_time.today_BattDischg_E": "电池今日放电电量",
  "51102.s\\real_time.today_Battchg_E": "电池今日充电电量",
  "51102.s\\real_time.today_PV2Batt_E": "光伏PV今日流向电池电量",
  "51102.s\\real_time.today_PV2Load_E": "光伏PV今日流向负载电量",
  "51102.s\\real_time.today_PV2Grid_E": "光伏PV今日流向电网电量",
  "51102.s\\real_time.mon_buy_E": "本月买电电量",
  "51102.s\\real_time.mon_sell_E": "本月卖电电量",
  "51102.s\\real_time.mon_PV_E": "光伏PV本月累计发电量",
  "51102.s\\real_time.mon_EPS_E": "EPS微逆本月累计发电量",
  "51102.s\\real_time.mon_AC_E": "AC微逆本月累计发电量",
  "51102.s\\real_time.mon_BattDischg_E": "电池本月放电电量",
  "51102.s\\real_time.mon_Battchg_E": "电池本月充电电量",
  "51102.s\\real_time.mon_PV2Batt_E": "光伏PV本月流向电池电量",
  "51102.s\\real_time.mon_PV2Load_E": "光伏PV本月流向负载电量",
  "51102.s\\real_time.mon_PV2Grid_E": "光伏PV本月流向电网电量",
  "51102.s\\real_time.year_buy_E": "年度买电电量",
  "51102.s\\real_time.year_sell_E": "年度卖电电量",
  "51102.s\\real_time.year_PV_E": "光伏PV年度累计发电量",
  "51102.s\\real_time.year_EPS_E": "EPS微逆年度累计发电量",
  "51102.s\\real_time.year_AC_E": "AC微逆年度累计发电量",
  "51102.s\\real_time.year_BattDischg_E": "电池年度放电电量",
  "51102.s\\real_time.year_Battchg_E": "电池年度充电电量",
  "51102.s\\real_time.year_PV2Batt_E": "光伏PV年度流向电池电量",
  "51102.s\\real_time.year_PV2Load_E": "光伏PV年度流向负载电量",
  "51102.s\\real_time.year_PV2Grid_E": "光伏PV年度流向电网电量",
  "51102.s\\real_time.eps_load_E_day": "EPS负载今日用电量",
  "51102.s\\real_time.load_E_day": "负载今日用电量",
  "51102.s\\real_time.eps_load_E_month": "EPS负载本月用电量",
  "51102.s\\real_time.load_E_month": "负载本月用电量",
  "51102.s\\real_time.eps_load_E_year": "EPS负载年度用电量",
  "51102.s\\real_time.load_E_year": "负载年度用电量",
  "51102.s\\real_time.parallel_status": "并机工作状态",
  "51102.s\\real_time.parallel_cnt": "并机台数",
  "51102.s\\real_time.parallel_ID": "并机台数",
  "51102.s\\real_time.parallel_isMaster": "并机主从机",
  "51102.m\\real_time.all_mod_tot_grid_P": "并机下并网口总功率",
  "51102.m\\real_time.all_mod_tot_PV_P": "并机下PV发电总功率",
  "51102.m\\real_time.batteryPower": "并机下电池侧总功率",
  "51102.m\\real_time.all_mod_tot_EPS_P": "并机下EPS口总功率",
  "51102.m\\real_time.all_mod_tot_batt2Grid_P": "并机下电池流向并网口的馈网总功率",
  "51102.m\\real_time.all_mod_tot_batt2EPS_P": "并机下电池流向EPS负载的总功率",
  "51102.m\\real_time.all_mod_tot_PV2Batt_P": "并机下PV流向电池的总功率",
  "51102.m\\real_time.all_mod_tot_PV2EPS_P": "并机下PV流向EPS负载的总功率",
  "51102.m\\real_time.all_mod_tot_PV2Grid_P": "并机下PV流向并网口的馈网总功率",
  "51102.m\\real_time.all_mod_tot_Grid2Batt_P": "并机下并网口流向电池的总功率",
  "51102.m\\real_time.all_mod_tot_Grid2EPS_P": "并机下并网口流向EPS负载的总功率",
  "51102.m\\real_time.all_mod_tot_inv2Grid_P": "并机下EPS微逆流向并网口的总功率",
  "51102.m\\real_time.all_mod_tot_EPS2Batt_P": "并机下EPS微逆流向电池的总功率",
  "51102.m\\real_time.all_mod_tot_GridElctMeter_P": "网侧入户电表功率",
  "51102.m\\real_time.all_mod_tot_ACElctMeter_P": "AC微逆电表功率",
  "51102.m\\real_time.all_mod_battGrp_soc": "并机下电池SOC",
  "51102.m\\real_time.all_mod_tot_buy_E": "并机下累计买电电量",
  "51102.m\\real_time.all_mod_tot_sell_E": "并机下累计卖电电量",
  "51102.m\\real_time.p_acc_PV_prod_energy": "并机下光伏PV总发电量",
  "51102.m\\real_time.p_acc_EPS_prod_energy": "并机下EPS微逆总发电量",
  "51102.m\\real_time.p_acc_AC_prod_energy": "并机下AC微逆总发电量",
  "51102.m\\real_time.p_acc_load_use_enery": "并机下负载累计用电量",
  "51102.m\\real_time.batteryDischargePower": "并机下电池累计放电电量",
  "51102.m\\real_time.batteryChargerPower": "并机下电池累计充电电量",
  "51102.m\\real_time.p_acc_PV2Bat_E": "并机下光伏PV流向电池的总电量",
  "51102.m\\real_time.p_acc_PV2Load_E": "并机下光伏PV流向负载的总电量",
  "51102.m\\real_time.p_acc_PV2grid_E": "并机下光伏PV流向电网的总电量",
  "51102.m\\real_time.p_acc_EPS_load_E": "并机下ESP负载累计用电量",
  "51102.m\\real_time.p_today_buy_E": "并机下今日买电电量",
  "51102.m\\real_time.p_today_sell_E": "并机下今日卖电电量",
  "51102.m\\real_time.p_today_PV_E": "并机下光伏PV今日累计发电量",
  "51102.m\\real_time.p_today_EPS_E": "并机下EPS微逆今日累计发电量",
  "51102.m\\real_time.p_today_AC_E": "并机下AC微逆今日累计发电量",
  "51102.m\\real_time.p_today_BattDischg_E": "并机下电池今日放电电量",
  "51102.m\\real_time.p_today_Battchg_E": "并机下电池今日充电电量",
  "51102.m\\real_time.p_today_PV2Batt_E": "并机下光伏PV今日流向电池电量",
  "51102.m\\real_time.p_today_PV2Load_E": "并机下光伏PV今日流向负载电量",
  "51102.m\\real_time.p_today_PV2Grid_E": "并机下光伏PV今日流向电网电量",
  "51102.m\\real_time.p_mon_buy_E": "并机下本月买电电量",
  "51102.m\\real_time.p_mon_sell_E": "并机下本月卖电电量",
  "51102.m\\real_time.p_mon_PV_E": "并机下光伏PV本月累计发电量",
  "51102.m\\real_time.p_mon_EPS_E": "并机下EPS微逆本月累计发电量",
  "51102.m\\real_time.p_mon_AC_E": "并机下AC微逆本月累计发电量",
  "51102.m\\real_time.p_mon_BattDischg_E": "并机下电池本月放电电量",
  "51102.m\\real_time.p_mon_Battchg_E": "并机下电池本月充电电量",
  "51102.m\\real_time.p_mon_PV2Batt_E": "并机下光伏PV本月流向电池电量",
  "51102.m\\real_time.p_mon_PV2Load_E": "并机下光伏PV本月流向负载电量",
  "51102.m\\real_time.p_mon_PV2Grid_E": "并机下光伏PV本月流向电网电量",
  "51102.m\\real_time.p_year_buy_E": "并机下年度买电电量",
  "51102.m\\real_time.p_year_sell_E": "并机下年度卖电电量",
  "51102.m\\real_time.p_year_PV_E": "并机下光伏PV年度累计发电量",
  "51102.m\\real_time.p_year_EPS_E": "并机下EPS微逆年度累计发电量",
  "51102.m\\real_time.p_year_AC_E": "并机下AC微逆年度累计发电量",
  "51102.m\\real_time.p_year_BattDischg_E": "并机下电池年度放电电量",
  "51102.m\\real_time.p_year_Battchg_E": "并机下电池年度充电电量",
  "51102.m\\real_time.p_year_PV2Batt_E": "并机下光伏PV年度流向电池电量",
  "51102.m\\real_time.p_year_PV2Load_E": "并机下光伏PV年度流向负载电量",
  "51102.m\\real_time.p_year_PV2Grid_E": "并机下光伏PV年度流向电网电量",
  "51102.m\\real_time.tot_eps_load_E_day": "并机下EPS负载今日用电量",
  "51102.m\\real_time.tot_load_E_day": "并机下负载今日用电量",
  "51102.m\\real_time.tot_eps_load_E_month": "并机下EPS负载本月用电量",
  "51102.m\\real_time.tot_load_E_month": "并机下负载本月用电量",
  "51102.m\\real_time.tot_eps_load_E_year": "并机下EPS负载年度用电量",
  "51102.m\\real_time.tot_load_E_year": "并机下负载年度用电量",
  "51102.s\\real_time.EPS_status": "EPS微逆状态",
  "51102.s\\real_time.EPS_total_power_time": "EPS微逆总发电时长",
  "51102.s\\real_time.EPS_today_power_time": "EPS微逆今日发电时长",
  "51102.s\\real_time.EPS_volt": "EPS微逆电压",
  "51102.s\\real_time.EPS_freq": "EPS微逆频率",
  "51102.s\\real_time.PV1_online_status": "PV1在位状态",
  "51102.s\\real_time.PV2_online_status": "PV2在位状态",
  "51102.s\\real_time.PV3_online_status": "PV3在位状态",
  "51102.s\\real_time.PV4_online_status": "PV4在位状态",
  "51102.s\\real_time.PV_total_P": "PV实时总功率",
  "51102.s\\real_time.PV_total_time": "PV总发电时长",
  "51102.s\\real_time.PV_today_time": "PV今日发电时长",
  "51102.s\\real_time.PV1_V": "PV1实时电压",
  "51102.s\\real_time.PV1_I": "PV1实时电流",
  "51102.s\\real_time.PV1_P": "PV1实时功率",
  "51102.s\\real_time.PV2_V": "PV2实时电压",
  "51102.s\\real_time.PV2_I": "PV2实时电流",
  "51102.s\\real_time.PV2_P": "PV2实时功率",
  "51102.s\\real_time.PV3_V": "PV3实时电压",
  "51102.s\\real_time.PV3_I": "PV3实时电流",
  "51102.s\\real_time.PV3_P": "PV3实时功率",
  "51102.s\\real_time.PV4_V": "PV4实时电压",
  "51102.s\\real_time.PV4_I": "PV4实时电流",
  "51102.s\\real_time.PV4_P": "PV4实时功率",
  "51102.s\\real_time.PV1_positive_temp": "PV1+温度",
  "51102.s\\real_time.PV1_negative_temp": "PV1-温度",
  "51102.s\\real_time.PV2_positive_temp": "PV2+温度",
  "51102.s\\real_time.PV2_negative_temp": "PV2-温度",
  "51102.s\\real_time.PV3_positive_temp": "PV3+温度",
  "51102.s\\real_time.PV3_negative_temp": "PV3-温度",
  "51102.s\\real_time.PV4_positive_temp": "PV4+温度",
  "51102.s\\real_time.PV4_negative_temp": "PV4-温度",
  "51102.s_w\\ctl_BMS.env_max_temp_alrm": "环境高温告警",
  "51102.s_w\\ctl_BMS.env_min_temp_alrm": "环境低温告警",
  "51102.s_w\\ctl_BMS.cell_level_1_overtmp_chg": "电芯一级过温告警(充电)",
  "51102.s_w\\ctl_BMS.cell_level_1_lowtmp_chg": "电芯一级低温告警(充电)",
  "51102.s_w\\ctl_BMS.cell_level_1_overtmp_dischg": "电芯一级过温告警(放电)",
  "51102.s_w\\ctl_BMS.cell_level_1_lowtmp_dischg": "电芯一级低温告警(放电)",
  "51102.s_w\\ctl_BMS.cell_level_1_overtmp_protect": "电芯一级过温保护(充电)",
  "51102.s_w\\ctl_BMS.cell_level_2_overtmp_protect": "电芯二级过温保护(充电)",
  "51102.s_w\\ctl_BMS.cell_level_1_lowtmp_protect": "电芯一级低温保护(充电)",
  "51102.s_w\\ctl_BMS.cell_level_2_lowtmp_protect": "电芯二级低温保护(充电)",
  "51102.s_w\\ctl_BMS.cell_level_1_overtmp_protect_dischg": "电芯一级过温保护(放电)",
  "51102.s_w\\ctl_BMS.cell_level_2_overtmp_protect_dischg": "电芯二级过温保护(放电)",
  "51102.s_w\\ctl_BMS.cell_level_1_lowtmp_protect_dischg": "电芯一级低温保护(放电)",
  "51102.s_w\\ctl_BMS.cell_level_2_lowtmp_protect_dischg": "电芯二级低温保护(放电)",
  "51102.s_w\\ctl_BMS.env_overtmp_protect": "环境高温保护",
  "51102.s_w\\ctl_BMS.env_lowtmp_protect": "环境低温保护",
  "51102.s_w\\ctl_BMS.mos_overtmp_alarm": "MOS温度高温告警",
  "51102.s_w\\ctl_BMS.mos_overtmp_protect": "MOS温度高温保护",
  "51102.s_w\\ctl_BMS.batt_avg_volt_high_protect": "电芯组均压高保护",
  "51102.s_w\\ctl_BMS.batt_overvolt_protect": "电芯高压保护",
  "51102.s_w\\ctl_BMS.batt_avg_volt_low_protect": "电芯组均压低保护",
  "51102.s_w\\ctl_BMS.batt_lowvolt_protect": "电芯低压保护",
  "51102.s_w\\ctl_BMS.cell_diffvolt_toohigh_protect": "电芯压差过大保护",
  "51102.s_w\\ctl_BMS.batt_avgvolt_high_alarm": "电芯组均压高告警",
  "51102.s_w\\ctl_BMS.cell_highvolt_alarm": "电芯高压告警",
  "51102.s_w\\ctl_BMS.batt_avgvolt_low_alarm": "电芯组均压低告警",
  "51102.s_w\\ctl_BMS.cell_lowVolt_alarm": "电芯低压告警",
  "51102.s_w\\ctl_BMS.soc_low_alarm": "电量低告警",
  "51102.s_w\\ctl_BMS.cell_unavail": "电芯单体失效",
  "51102.s_w\\ctl_BMS.cell_diffvolt_toohigh_alrm": "电芯温差大告警",
  "51102.s_w\\ctl_BMS.cell_diffvolt_toohigh_fault": "电芯温差大故障",
  "51102.s_w\\ctl_BMS.batt_chg_overcurrent_alarm": "电池充电过流告警",
  "51102.s_w\\ctl_BMS.batt_chg_overcurrent_slow_check_protect": "电池充电过流慢检保护",
  "51102.s_w\\ctl_BMS.batt_chg_overcurrent_fast_check_protect": "电池充电过流快检保护",
  "51102.s_w\\ctl_BMS.batt_chg_overcurrent_fault": "电池充电过流故障",
  "51102.s_w\\ctl_BMS.batt_dischg_overcurrent_alarm": "电池放电过流告警",
  "51102.s_w\\ctl_BMS.batt_dischg_overcurrent_slow_check_protect": "电池放电过流慢检保护",
  "51102.s_w\\ctl_BMS.batt_dischg_overcurrent_fast_check_protect": "电池放电过流快检保护",
  "51102.s_w\\ctl_BMS.batt_dischg_overcurrent_fault": "电池放电过流故障",
  "51102.s_w\\ctl_BMS.cell_too_high_volt_fault": "电芯电压严重高故障",
  "51102.s_w\\ctl_BMS.cell_too_low_volt_fault": "电芯电压严重低故障",
  "51102.s_w\\ctl_BMS.cell_too_low_volt_shutdown": "电芯电压低关机",
  "51102.s_w\\ctl_BMS.cell_term_overTemp_alarm": "极柱温度高告警",
  "51102.s_w\\ctl_BMS.cell_term_overTemp_protect": "极柱温度高保护",
  "51102.s_w\\ctl_BMS.cell_term_overTemp_fault": "极柱温度高故障",
  "51102.s_w\\ctl_BMS.cell_copper_overTemp_alrm": "铜排温度高告警",
  "51102.s_w\\ctl_BMS.cell_copper_overTemp_protect": "铜排温度高保护",
  "51102.s_w\\ctl_BMS.cell_copper_overTemp_fault": "铜排温度高故障",
  "51102.s_w\\ctl_inv.setting_chg_v": "设置充电电压",
  "51102.s_w\\ctl_inv.setting_chg_I": "设置充电电流",
  "51102.s_w\\ctl_inv.setting_trickle_chg_V": "设置涓充充电电压",
  "51102.s_w\\ctl_inv.setting_trickle_chg_I": "设置涓充充电电流",
  "51102.s_w\\ctl_inv.prl_grid_overV_protect": "并网口输入过压保护",
  "51102.s_w\\ctl_inv.prl_grid_overV_recovery": "并网口输入过压恢复",
  "51102.s_w\\ctl_inv.prl_grid_lowV_protect": "并网口输入欠压保护",
  "51102.s_w\\ctl_inv.prl_grid_lowV_recovery": "并网口输入欠压恢复",
  "51102.s_w\\ctl_inv.prl_grid_overFreq_protect": "并网口输入过频保护",
  "51102.s_w\\ctl_inv.prl_grid_overFreq_recovery": "并网口输入过频恢复",
  "51102.s_w\\ctl_inv.prl_grid_lowFreq_protect": "并网口输入欠频保护",
  "51102.s_w\\ctl_inv.prl_grid_lowFreq_recovery": "并网口输入欠频恢复",
  "51102.s_w\\ctl_inv.EPS_overV_protect": "ESP口输入过压保护",
  "51102.s_w\\ctl_inv.EPS_overV_recovery": "EPS口输入过压恢复",
  "51102.s_w\\ctl_inv.EPS_lowV_protect": "EPS口输入欠压保护",
  "51102.s_w\\ctl_inv.EPS__lowV_recovery": "EPS口输入欠压恢复",
  "51102.s_w\\ctl_inv.EPS_overFreq_protect": "EPS口输入过频保护",
  "51102.s_w\\ctl_inv.EPS_overFreq_recovery": "EPS口输入过频恢复",
  "51102.s_w\\ctl_inv.EPS_lowFreq_protect": "EPS口输入欠频保护",
  "51102.s_w\\ctl_inv.EPS_lowFreq_recovery": "EPS口输入欠频恢复",
  "51102.s_w\\ctl_inv.DC_input_overV_protect": "直流输入过压保护",
  "51102.s_w\\ctl_inv.DC_input_overV_recovery": "直流输入过压恢复",
  "51102.s_w\\ctl_inv.DC_input_lowV_protect": "直流输入欠压保护",
  "51102.s_w\\ctl_inv.DC_input_lowV_recovery": "直流输入欠压恢复",
  "51102.s_w\\ctl_inv.PV_input_overV_protect": "PV输入过压保护",
  "51102.s_w\\ctl_inv.PV_input_overV_recovery": "PV输入过压恢复",
  "51102.s_w\\ctl_inv.PV_input_lowV_protect": "PV输入欠压保护",
  "51102.s_w\\ctl_inv.PV_input_lowV_recovery": "PV输入欠压恢复",
  "51102.s_w\\ctl_inv.env_tmp1_over_protect": "环境温度1过温保护",
  "51102.s_w\\ctl_inv.env_tmp1_over_recovery": "环境温度1过温恢复",
  "51102.s_w\\ctl_inv.env_tmp2_over_protect": "环境温度2过温保护",
  "51102.s_w\\ctl_inv.env_tmp2_over_recovery": "环境温度2过温恢复",
  "51102.s_w\\ctl_inv.PFC_overT_protect": "PFC散热器温度过温保护",
  "51102.s_w\\ctl_inv.PFC_overT_recovery": "PFC散热器温度过温恢复",
  "51102.s_w\\ctl_inv.DC_overT_protect": "DC散热器温度1过温保护",
  "51102.s_w\\ctl_inv.DC_overT_recovery": "DC散热器温度1过温恢复",
  "51102.s_w\\ctl_inv.DC_overT2_protect": "DC散热器温度2过温保护",
  "51102.s_w\\ctl_inv.DC_overT2_recovery": "DC散热器温度2过温恢复",
  "51102.s_w\\ctl_inv.PV1_overT_protect": "PV1散热器温度过温保护",
  "51102.s_w\\ctl_inv.PV1_overT_recovery": "PV1散热器温度过温恢复",
  "51102.s_w\\ctl_inv.PV2_overT_protect": "PV2散热器温度过温保护",
  "51102.s_w\\ctl_inv.PV2_overT_recovery": "PV2散热器温度过温恢复",
  "51102.s_w\\ctl_inv.PV3_overT_protect": "PV3散热器温度过温保护",
  "51102.s_w\\ctl_inv.PV3_overT_recovery": "PV3散热器温度过温恢复",
  "51102.s_w\\ctl_inv.PV4_overT_protect": "PV4散热器温度过温保护",
  "51102.s_w\\ctl_inv.PV4_overT_recovery": "PV4散热器温度过温恢复",
  "51102.s_w\\ctl_islandProtection.island_overV": "过压保护阈值",
  "51102.s_w\\ctl_islandProtection.island_lowV": "欠压保护阈值",
  "51102.s_w\\ctl_islandProtection.island_overFreq": "过频保护阈值",
  "51102.s_w\\ctl_islandProtection.island_lowFreq": "欠频保护阈值",
  "51102.s_w\\ctl_reverseFlowProtection.rfp_action_time": "动作保护时间",
  "51102.s_w\\ctl_actpower.actpower_ctl_en": "有功功率控制使能",
  "51102.s_w\\ctl_actpower.max_oP": "最大输出有功功率",
  "51102.s_w\\ctl_actpower.p_ramp_rate": "有功功率爬坡率",
  "51102.s_w\\ctl_reactpower.reactpower_ctl_en": "无功功率控制使能",
  "51102.s_w\\ctl_reactpower.max_oQ": "最大输出无功功率",
  "51102.s_w\\ctl_reactpower.reactpower_ctl_mode": "无功功率控制模式",
  "51102.s_w\\ctl_reactpower.PF_set": "功率因数",
  "51102.s_w\\ctl_reactpower.VreactPCurveVsetValue1": "电压无功功率曲线电压设置值V1",
  "51102.s_w\\ctl_reactpower.VreactPCurveVsetValue2": "电压无功功率曲线电压设置值V2",
  "51102.s_w\\ctl_reactpower.VreactPCurveVsetValue3": "电压无功功率曲线电压设置值V3",
  "51102.s_w\\ctl_reactpower.VreactPCurveQsetValue1": "电压无功功率曲线无功功率设置值Q1",
  "51102.s_w\\ctl_reactpower.VreactPCurveQsetValue2": "电压无功功率曲线无功功率设置值Q2",
  "51102.s_w\\ctl_reactpower.VreactPCurveQsetValue3": "电压无功功率曲线无功功率设置值Q3",
  "51102.s_w\\volt_ride_through.lowVlimit1": "低压限制1",
  "51102.s_w\\volt_ride_through.lowVlimit1Time": "低压限制1时间",
  "51102.s_w\\volt_ride_through.lowVlimit2": "低压限制2",
  "51102.s_w\\volt_ride_through.lowVlimit2Time": "低压限制2时间",
  "51102.s_w\\volt_ride_through.lowVlimit3": "低压限制3",
  "51102.s_w\\volt_ride_through.lowVlimit3Time": "低压限制3时间",
  "51102.s_w\\volt_ride_through.overVlimit1": "过压限制1",
  "51102.s_w\\volt_ride_through.overVlimit1Time": "过压限制1时间",
  "51102.s_w\\volt_ride_through.overVlimit2": "过压限制2",
  "51102.s_w\\volt_ride_through.overVlimit2Time": "过压限制2时间",
  "51102.s_w\\volt_ride_through.overVlimit3": "过压限制3",
  "51102.s_w\\volt_ride_through.overVlimit3Time": "过压限制3时间",
  "51102.s_w\\volt_ride_through.VrecoveryTime": "电压恢复时间",
  "51102.s_w\\volt_ride_through.LVRTThredUplmt": "LVRT阈值上限",
  "51102.s_w\\volt_ride_through.LVRTThredDownlmt": "LVRT阈值下限",
  "51102.s_w\\Freq_ride_through.lowFreqLimit1": "低频限制1",
  "51102.s_w\\Freq_ride_through.lowFreqLimit1Time": "低频限制1时间",
  "51102.s_w\\Freq_ride_through.lowFreqLimit2": "低频限制2",
  "51102.s_w\\Freq_ride_through.lowFreqLimit2Time": "低频限制2时间",
  "51102.s_w\\Freq_ride_through.lowFreqLimit3": "低频限制3",
  "51102.s_w\\Freq_ride_through.lowFreqLimit3Time": "低频限制3时间",
  "51102.s_w\\Freq_ride_through.overFreqLimit1": "过频限制1",
  "51102.s_w\\Freq_ride_through.overFreqLimit1Time": "过频限制1时间",
  "51102.s_w\\Freq_ride_through.overFreqLimit2": "过频限制2",
  "51102.s_w\\Freq_ride_through.overFreqLimit2Time": "过频限制2时间",
  "51102.s_w\\Freq_ride_through.overFreqLimit3": "过频限制3",
  "51102.s_w\\Freq_ride_through.overFreqLimit3Time": "过频限制3时间",
  "51102.s_w\\grid_reconn_args.pareGridReConnTime": "并网重连时间",
  "51102.s_w\\grid_reconn_args.reConnGridVHighLevel": "重连电压高位",
  "51102.s_w\\grid_reconn_args.reConnGridVLowLevel": "重连电压低位",
  "51102.s_w\\grid_reconn_args.reConnGridFHighLevel": "重连频率高位",
  "51102.s_w\\grid_reconn_args.reConnGridFLowLevel": "重连频率低位",
  "51102.m_w\\ctl_EMS.ems_ctrl_work_mode": "工作模式设置",
  "51102.m_w\\ctl_EMS.anti_reverse_curr": "防逆流模式使能",
  "51102.s_w\\ctl_EMS.remote_on_off_ctrl": "远程开关机",
  "51102.s_w\\ctl_EMS.batt_shutdown_ctrl": "电池断电控制",
  "51102.s_w\\ctl_EMS.factory_recovery": "恢复出厂设置",
  "51102.m_w\\ctl_EMS.user_type": "用户类型",
  "51102.m_w\\ctl_EMS.self_consupt_chg_soc": "自发自用模式充电SOC阈值",
  "51102.m_w\\ctl_EMS.self_consupt_dischg_soc": "自发自用模式放电SOC阈值",
  "51102.m_w\\ctl_EMS.self_consupt_max_chg_P": "自发自用模式最大充电功率",
  "51102.m_w\\ctl_EMS.self_consupt_max_feedGrid_P": "自发自用模式最大馈网功率",
  "51102.m_w\\ctl_EMS.feedGrid_chg_soc": "馈网优先模式充电SOC阈值",
  "51102.m_w\\ctl_EMS.feedGrid_dischg_soc": "馈网优先模式放电SOC阈值",
  "51102.m_w\\ctl_EMS.feedGrid_max_chg_P": "馈网优先模式最大充电功率",
  "51102.m_w\\ctl_EMS.feedGrid_max_feedGrid_P": "馈网优先模式最大馈网功率",
  "51102.m_w\\ctl_EMS.bakMode_chg_soc": "备电模式充电SOC阈值",
  "51102.m_w\\ctl_EMS.bakMode_dischg_soc": "备电模式放电SOC阈值",
  "51102.m_w\\ctl_EMS.bakMode_max_chg_P": "备电模式最大充电功率",
  "51102.m_w\\ctl_EMS.bakMode_max_feedGrid_P": "备电模式最大馈网功率",
  "51102.m_w\\ctl_EMS.PSVFMode_chg_soc": "削峰填谷模式充电SOC阈值",
  "51102.m_w\\ctl_EMS.PSVFMode_dischg_soc": "削峰填谷模式放电SOC阈值",
  "51102.m_w\\ctl_EMS.PSVFMode_max_chg_P": "削峰填谷模式最大充电功率",
  "51102.m_w\\ctl_EMS.PSVFMode_max_feedGrid_P": "削峰填谷模式最大馈网功率",
  "51102.m_w\\ctl_EMS.PSVFMode_chgDischg_tm_sect_cnt": "削峰填谷模式充放电时间段数",
  "51102.m_w\\ctl_EMS.s_mon": "开始时间-月",
  "51102.m_w\\ctl_EMS.s_day": "开始时间-日",
  "51102.m_w\\ctl_EMS.e_mon": "结束时间-月",
  "51102.m_w\\ctl_EMS.e_day": "结束时间-日",
  "51102.m_w\\ctl_EMS.s_chg_hour_1": "充电开始时间1-时",
  "51102.m_w\\ctl_EMS.s_chg_min_1": "充电开始时间1-分",
  "51102.m_w\\ctl_EMS.e_chg_hour_1": "充电结束时间1-时",
  "51102.m_w\\ctl_EMS.e_chg_min_1": "充电结束时间1-分",
  "51102.m_w\\ctl_EMS.s_dischg_hour_1": "放电开始时间1-时",
  "51102.m_w\\ctl_EMS.s_dischg_min_1": "放电开始时间1-分",
  "51102.m_w\\ctl_EMS.e_dischg_hour_1": "放电结束时间1-时",
  "51102.m_w\\ctl_EMS.e_dischg_min_1": "放电结束时间1-分",
  "51102.m_w\\ctl_EMS.s_chg_hour_2": "充电开始时间2-时",
  "51102.m_w\\ctl_EMS.s_chg_min_2": "充电开始时间2-分",
  "51102.m_w\\ctl_EMS.e_chg_hour_2": "充电结束时间2-时",
  "51102.m_w\\ctl_EMS.e_chg_min_2": "充电结束时间2-分",
  "51102.m_w\\ctl_EMS.s_dischg_hour_2": "放电开始时间2-时",
  "51102.m_w\\ctl_EMS.s_dischg_min_2": "放电开始时间2-分",
  "51102.m_w\\ctl_EMS.e_dischg_hour_2": "放电结束时间2-时",
  "51102.m_w\\ctl_EMS.e_dischg_min_2": "放电结束时间2-分",
  "51102.m_w\\ctl_EMS.s_chg_hour_3": "充电开始时间3-时",
  "51102.m_w\\ctl_EMS.s_chg_min_3": "充电开始时间3-分",
  "51102.m_w\\ctl_EMS.e_chg_hour_3": "充电结束时间3-时",
  "51102.m_w\\ctl_EMS.e_chg_min_3": "充电结束时间3-分",
  "51102.m_w\\ctl_EMS.s_dischg_hour_3": "放电开始时间3-时",
  "51102.m_w\\ctl_EMS.s_dischg_min_3": "放电开始时间3-分",
  "51102.m_w\\ctl_EMS.e_dischg_hour_3": "放电结束时间3-时",
  "51102.m_w\\ctl_EMS.e_dischg_min_3": "放电结束时间3-分",
  "51102.m_w\\ctl_EMS.s_chg_hour_4": "充电开始时间4-时",
  "51102.m_w\\ctl_EMS.s_chg_min_4": "充电开始时间4-分",
  "51102.m_w\\ctl_EMS.e_chg_hour_4": "充电结束时间4-时",
  "51102.m_w\\ctl_EMS.e_chg_min_4": "充电结束时间4-分",
  "51102.m_w\\ctl_EMS.s_dischg_hour_4": "放电开始时间4-时",
  "51102.m_w\\ctl_EMS.s_dischg_min_4": "放电开始时间4-分",
  "51102.m_w\\ctl_EMS.e_dischg_hour_4": "放电结束时间4-时",
  "51102.m_w\\ctl_EMS.e_dischg_min_4": "放电结束时间4-分",
  "51102.m_w\\ctl_EMS.s_chg_hour_5": "充电开始时间5-时",
  "51102.m_w\\ctl_EMS.s_chg_min_5": "充电开始时间5-分",
  "51102.m_w\\ctl_EMS.e_chg_hour_5": "充电结束时间5-时",
  "51102.m_w\\ctl_EMS.e_chg_min_5": "充电结束时间5-分",
  "51102.m_w\\ctl_EMS.s_dischg_hour_5": "放电开始时间5-时",
  "51102.m_w\\ctl_EMS.s_dischg_min_5": "放电开始时间5-分",
  "51102.m_w\\ctl_EMS.e_dischg_hour_5": "放电结束时间5-时",
  "51102.m_w\\ctl_EMS.e_dischg_min_5": "放电结束时间5-分",
  "51102.m_w\\ctl_EMS.s_chg_hour_6": "充电开始时间6-时",
  "51102.m_w\\ctl_EMS.s_chg_min_6": "充电开始时间6-分",
  "51102.m_w\\ctl_EMS.e_chg_hour_6": "充电结束时间6-时",
  "51102.m_w\\ctl_EMS.e_chg_min_6": "充电结束时间6-分",
  "51102.m_w\\ctl_EMS.s_dischg_hour_6": "放电开始时间6-时",
  "51102.m_w\\ctl_EMS.s_dischg_min_6": "放电开始时间6-分",
  "51102.m_w\\ctl_EMS.e_dischg_hour_6": "放电结束时间6-时",
  "51102.m_w\\ctl_EMS.e_dischg_min_6": "放电结束时间6-分",
  "51102.m_w\\ctl_EMS.gridType": "国家电网标准",
  "51102.m_w\\ctl_EMS.TOU_work_status": "TOU模式工作状态",
  "51102.m_w\\ctl_EMS.TOU_max_chg_P": "TOU模式最大充电功率",
  "51102.m_w\\ctl_EMS.TOU_max_feedGrid_P": "TOU模式最大馈网功率",
  "51102.m_w\\ctl_EMS.TOU_chg_SOC": "TOU模式充电截止SOC",
  "51102.m_w\\ctl_EMS.TOU_dischg_SOC": "TOU模式放电截止SOC",
  "51102.m_w\\ctl_EMS.TOU_time_section_num": "TOU模式充放电时间段数",
  "51102.m_w\\ctl_EMS.TOU_s_chg_hour_1": "TOU充电开始时间1-时",
  "51102.m_w\\ctl_EMS.TOU_s_chg_min_1": "TOU充电开始时间1-分",
  "51102.m_w\\ctl_EMS.TOU_e_chg_hour_1": "TOU充电结束时间1-时",
  "51102.m_w\\ctl_EMS.TOU_e_chg_min_1": "TOU充电结束时间1-分",
  "51102.m_w\\ctl_EMS.TOU_s_dischg_hour_1": "TOU放电开始时间1-时",
  "51102.m_w\\ctl_EMS.TOU_s_dischg_min_1": "TOU放电开始时间1-分",
  "51102.m_w\\ctl_EMS.TOU_e_dischg_hour_1": "TOU放电结束时间1-时",
  "51102.m_w\\ctl_EMS.TOU_e_dischg_min_1": "TOU放电结束时间1-分",
  "51102.m_w\\ctl_EMS.TOU_s_chg_hour_2": "TOU充电开始时间2-时",
  "51102.m_w\\ctl_EMS.TOU_s_chg_min_2": "TOU充电开始时间2-分",
  "51102.m_w\\ctl_EMS.TOU_e_chg_hour_2": "TOU充电结束时间2-时",
  "51102.m_w\\ctl_EMS.TOU_e_chg_min_2": "TOU充电结束时间2-分",
  "51102.m_w\\ctl_EMS.TOU_s_dischg_hour_2": "TOU放电开始时间2-时",
  "51102.m_w\\ctl_EMS.TOU_s_dischg_min_2": "TOU放电开始时间2-分",
  "51102.m_w\\ctl_EMS.TOU_e_dischg_hour_2": "TOU放电结束时间2-时",
  "51102.m_w\\ctl_EMS.TOU_e_dischg_min_2": "TOU放电结束时间2-分",
  "51102.m_w\\ctl_EMS.TOU_s_chg_hour_3": "TOU充电开始时间3-时",
  "51102.m_w\\ctl_EMS.TOU_s_chg_min_3": "TOU充电开始时间3-分",
  "51102.m_w\\ctl_EMS.TOU_e_chg_hour_3": "TOU充电结束时间3-时",
  "51102.m_w\\ctl_EMS.TOU_e_chg_min_3": "TOU充电结束时间3-分",
  "51102.m_w\\ctl_EMS.TOU_s_dischg_hour_3": "TOU放电开始时间3-时",
  "51102.m_w\\ctl_EMS.TOU_s_dischg_min_3": "TOU放电开始时间3-分",
  "51102.m_w\\ctl_EMS.TOU_e_dischg_hour_3": "TOU放电结束时间3-时",
  "51102.m_w\\ctl_EMS.TOU_e_dischg_min_3": "TOU放电结束时间3-分",
  "51102.m_w\\ctl_EMS.TOU_s_chg_hour_4": "TOU充电开始时间4-时",
  "51102.m_w\\ctl_EMS.TOU_s_chg_min_4": "TOU充电开始时间4-分",
  "51102.m_w\\ctl_EMS.TOU_e_chg_hour_4": "TOU充电结束时间4-时",
  "51102.m_w\\ctl_EMS.TOU_e_chg_min_4": "TOU充电结束时间4-分",
  "51102.m_w\\ctl_EMS.TOU_s_dischg_hour_4": "TOU放电开始时间4-时",
  "51102.m_w\\ctl_EMS.TOU_s_dischg_min_4": "TOU放电开始时间4-分",
  "51102.m_w\\ctl_EMS.TOU_e_dischg_hour_4": "TOU放电结束时间4-时",
  "51102.m_w\\ctl_EMS.TOU_e_dischg_min_4": "TOU放电结束时间4-分",
  "51102.m_w\\ctl_EMS.TOU_s_chg_hour_5": "TOU充电开始时间5-时",
  "51102.m_w\\ctl_EMS.TOU_s_chg_min_5": "TOU充电开始时间5-分",
  "51102.m_w\\ctl_EMS.TOU_e_chg_hour_5": "TOU充电结束时间5-时",
  "51102.m_w\\ctl_EMS.TOU_e_chg_min_5": "TOU充电结束时间5-分",
  "51102.m_w\\ctl_EMS.TOU_s_dischg_hour_5": "TOU放电开始时间5-时",
  "51102.m_w\\ctl_EMS.TOU_s_dischg_min_5": "TOU放电开始时间5-分",
  "51102.m_w\\ctl_EMS.TOU_e_dischg_hour_5": "TOU放电结束时间5-时",
  "51102.m_w\\ctl_EMS.TOU_e_dischg_min_5": "TOU放电结束时间5-分",
  "51102.m_w\\ctl_EMS.TOU_s_chg_hour_6": "TOU充电开始时间6-时",
  "51102.m_w\\ctl_EMS.TOU_s_chg_min_6": "TOU充电开始时间6-分",
  "51102.m_w\\ctl_EMS.TOU_e_chg_hour_6": "TOU充电结束时间6-时",
  "51102.m_w\\ctl_EMS.TOU_e_chg_min_6": "TOU充电结束时间6-分",
  "51102.m_w\\ctl_EMS.TOU_s_dischg_hour_6": "TOU放电开始时间6-时",
  "51102.m_w\\ctl_EMS.TOU_s_dischg_min_6": "TOU放电开始时间6-分",
  "51102.m_w\\ctl_EMS.TOU_e_dischg_hour_6": "TOU放电结束时间6-时",
  "51102.m_w\\ctl_EMS.TOU_e_dischg_min_6": "TOU放电结束时间6-分",
  "51102.s\\alarm.alrm_grid_v_low": "电网电压低",
  "51102.s\\alarm.alrm_grid_v_high": "电网电压高",
  "51102.s\\alarm.alrm_grid_f_low": "电网频率低",
  "51102.s\\alarm.alrm_grid_f_high": "电网频率高",
  "51102.s\\alarm.alrm_grid_input_overI": "电网交流输入过流预警",
  "51102.s\\alarm.alrm_PFC_bus_v_low": "整流器预警(母线电压低)",
  "51102.s\\alarm.alrm_U1_bus_v_low": "U1母线预警(电压低)",
  "51102.s\\alarm.alrm_U1_bus_v_high": "U1母线预警(电压高)",
  "51102.s\\alarm.alrm_U2_bus_v_low": "U2母线预警(电压低)",
  "51102.s\\alarm.alrm_U2_bus_v_high": "U2母线预警(电压高)",
  "51102.s\\alarm.alrm_inv_overload": "输出预警(逆变器过载)",
  "51102.s\\alarm.alrm_bypass_overload": "输出预警(旁路过载)",
  "51102.s\\alarm.alrm_inv_v_fault": "整流器预警(逆变电压有效值故障)",
  "51102.s\\alarm.alrm_inv_overV_protect": "整流器预警(逆变交流输出过压保护)",
  "51102.s\\alarm.alrm_inv_lowV_protect": "整流器预警(逆变交流输出欠压保护)",
  "51102.s\\alarm.alrm_inv_overF_protect": "整流器预警(逆变交流输出过频保护)",
  "51102.s\\alarm.alrm_inv_lowF_protect": "整流器预警(逆变交流输出欠频保护)",
  "51102.s\\alarm.alrm_lock_phase_failure": "锁相预警(市电锁相失败)",
  "51102.s\\alarm.alrm_level2_lock_phase_failure": "锁相预警(并机二级锁相失败)",
  "51102.s\\alarm.alrm_T1_tooHigh": "温度预警1(温度过高)",
  "51102.s\\alarm.alrm_T2_tooHigh": "温度预警2(温度过高)",
  "51102.s\\alarm.alrm_bypass_lowV": "旁路预警(电压低)",
  "51102.s\\alarm.alrm_bypass_highV": "旁路预警(电压高)",
  "51102.s\\alarm.alrm_bypass_lowF": "旁路预警(频率低)",
  "51102.s\\alarm.alrm_bypass_highF": "旁路预警(频率高)",
  "51102.s\\alarm.alrm_chg_lowV": "充电器预警(充电器低压)",
  "51102.s\\alarm.alrm_chg_highV": "充电器预警(充电器高压)",
  "51102.s\\alarm.alrm_dischg_lowV": "放电器预警(电池低压故障)",
  "51102.s\\alarm.alrm_dischg_bus_lowV": "放电器预警(母线低压故障)",
  "51102.s\\alarm.alrm_dischg_batt_highV": "放电器预警(电池高压故障)",
  "51102.s\\alarm.alrm_u1_u2_ver_mismatch": "系统预警(U1和U2软件版本不匹配)",
  "51102.s\\alarm.alrm_PV1_DC_lowV": "PV1预警(DC低压故障)",
  "51102.s\\alarm.alrm_PV1_DC_highV": "PV1预警(DC高压故障)",
  "51102.s\\alarm.alrm_PV1_input_lowV": "PV1预警(PV输入欠压)",
  "51102.s\\alarm.alrm_PV1_input_highV": "PV1预警(PV输入过压)",
  "51102.s\\alarm.alrm_PV2_DC_lowV": "PV2预警(DC低压故障)",
  "51102.s\\alarm.alrm_PV2_DC_highV": "PV2预警(DC高压故障)",
  "51102.s\\alarm.alrm_PV2_input_lowV": "PV2预警(PV输入欠压)",
  "51102.s\\alarm.alrm_PV2_input_highV": "PV2预警(PV输入过压)",
  "51102.s\\alarm.alrm_PV3_DC_lowV": "PV3预警(DC低压故障)",
  "51102.s\\alarm.alrm_PV3_DC_highV": "PV3预警(DC高压故障)",
  "51102.s\\alarm.alrm_PV3_input_lowV": "PV3预警(PV输入欠压)",
  "51102.s\\alarm.alrm_PV3_input_highV": "PV3预警(PV输入过压)",
  "51102.s\\alarm.alrm_PV4_DC_lowV": "PV4预警(DC低压故障)",
  "51102.s\\alarm.alrm_PV4_DC_highV": "PV4预警(DC高压故障)",
  "51102.s\\alarm.alrm_PV4_input_lowV": "PV4预警(PV输入欠压)",
  "51102.s\\alarm.alrm_PV4_input_highV": "PV4预警(PV输入过压)",
  "51102.s\\alarm.alrm_parellet_freq_differ": "并机预警1(并机频率体系不一致故障)",
  "51102.s\\alarm.alrm_parellet2_avg_I": "并机预警2(并机均流故障)",
  "51102.s\\alarm.alrm_batt_highV": "电芯预警1(电芯组均压高)",
  "51102.s\\alarm.alrm_batt_cell_highV": "电芯预警1(电芯高压)",
  "51102.s\\alarm.alrm_batt_lowV": "电芯预警1(电芯组均压低)",
  "51102.s\\alarm.alrm_batt_cell_lowV": "电芯预警1(电芯低压)",
  "51102.s\\alarm.alrm_cell_slow_check_overI": "电芯预警2(电芯充电过流慢检)",
  "51102.s\\alarm.alrm_cell_dischg_slow_check_overI": "电芯预警2(电芯放电过流慢检)",
  "51102.s\\alarm.alrm_cell_chg1_overT": "电芯温度预警(电芯一级过温(充电))",
  "51102.s\\alarm.alrm_cell_chg2_overT": "电芯温度预警(电芯二级过温(充电))",
  "51102.s\\alarm.alrm_cell_chg1_lowT": "电芯温度预警(电芯一级低温(充电))",
  "51102.s\\alarm.alrm_cell_chg2_lowT": "电芯温度预警(电芯二级低温(充电))",
  "51102.s\\alarm.alrm_cell_dischg1_overT": "电芯温度预警(电芯一级过温(放电))",
  "51102.s\\alarm.alrm_cell_dischg2_overT": "电芯温度预警(电芯二级过温(放电))",
  "51102.s\\alarm.alrm_cell_dischg1_lowT": "电芯温度预警(电芯一级低温(放电))",
  "51102.s\\alarm.alrm_cell_dischg2_lowT": "电芯温度预警(电芯二级低温(放电))",
  "51102.s\\alarm.alrm_cell_env_overT": "电芯温度预警(环境过温)",
  "51102.s\\alarm.alrm_cell_env_lowT": "电芯温度预警(环境低温)",
  "51102.s\\alarm.alrm_cell_mos_overT": "电芯温度预警(MOS过温)",
  "51102.s\\alarm.alrm_cell_diffT_large": "电芯温度预警(温差过大)",
  "51102.s\\alarm.alrm_eps_lowV": "EPS微逆预警(电压低)",
  "51102.s\\alarm.alrm_eps_highV": "EPS微逆预警(电压高)",
  "51102.s\\alarm.alrm_eps_lowF": "EPS微逆预警(频率低)",
  "51102.s\\alarm.alrm_eps_highF": "EPS微逆预警(频率高)",
  "51102.s\\alarm.alrm_eps_ac_overI": "EPS微逆预警(交流输入过流)",
  "51102.s\\warn.warn_grid_v_low": "电网告警(电网电压低)",
  "51102.s\\warn.warn_grid_v_high": "电网告警(电网电压高)",
  "51102.s\\warn.warn_grid_f_low": "电网告警(电网频率低)",
  "51102.s\\warn.warn_grid_f_high": "电网告警(电网频率高)",
  "51102.s\\warn.warn_grid_I_over": "电网告警(交流输入过流)",
  "51102.s\\warn.warn_PFC_bus_v_low": "整流器告警(母线低压)",
  "51102.s\\warn.warn_U1_bus_v_low": "U1母线告警(电压低)",
  "51102.s\\warn.warn_U1_bus_v_high": "U1母线告警(电压高)",
  "51102.s\\warn.warn_U2_bus_v_low": "U2母线告警(电压低)",
  "51102.s\\warn.warn_U2_bus_v_high": "U2母线告警(电压高)",
  "51102.s\\warn.warn_o_inv_overLoad": "输出告警(逆变过载)",
  "51102.s\\warn.warn_o_byp_overLoad": "输出告警(旁路过载)",
  "51102.s\\warn.warn_PFC_inv_v": "整流器告警(逆变电压有效值故障)",
  "51102.s\\warn.warn_PFC_inv_o_over_v": "整流器告警(逆变交流输出过压保护)",
  "51102.s\\warn.warn_PFC_inv_o_low_v": "整流器告警(逆变交流输出欠压保护)",
  "51102.s\\warn.warn_PFC_inv_o_over_f": "逆变交流输出过频保护告警",
  "51102.s\\warn.warn_PFC_inv_o_low_f": "整流器告警(逆变交流输出欠频保护)",
  "51102.s\\warn.warn_PLL_grid_pll": "锁相告警(市电锁相失败)",
  "51102.s\\warn.warn_PLL_parellet_pll": "锁相告警(并机二级锁相失败)",
  "51102.s\\warn.warn_T1_overT": "温度告警1(温度过高)",
  "51102.s\\warn.warn_T2_overT": "温度告警2(温度过高)",
  "51102.s\\warn.warn_byp_overT": "旁路告警(温度过高)",
  "51102.s\\warn.warn_chg_lowV": "充电器告警(充电器低压)",
  "51102.s\\warn.warn_chg_highV": "充电器告警(充电器高压)",
  "51102.s\\warn.warn_dischg_battV": "放电器告警(电池低压故障)",
  "51102.s\\warn.warn_dischg_busV": "放电器告警(母线低压故障)",
  "51102.s\\warn.warn_dischg_battOverV": "放电器告警(电池高压故障)",
  "51102.s\\warn.warn_PV1_dc_lowV": "PV1告警(DC低压故障)",
  "51102.s\\warn.warn_PV1_dc_highV": "PV1告警(DC高压故障)",
  "51102.s\\warn.warn_PV1_pv_input_lowV": "PV1告警(PV输入欠压)",
  "51102.s\\warn.warn_PV1_pv_input_overV": "PV1告警(PV输入过压)",
  "51102.s\\warn.warn_PV2_dc_lowV": "PV2告警(DC低压故障)",
  "51102.s\\warn.warn_PV2_dc_highV": "PV2告警(DC高压故障)",
  "51102.s\\warn.warn_PV2_pv_input_lowV": "PV2告警(PV输入欠压)",
  "51102.s\\warn.warn_PV2_pv_input_overV": "PV2告警(PV输入过压)",
  "51102.s\\warn.warn_PV3_dc_lowV": "PV3告警(DC低压故障)",
  "51102.s\\warn.warn_PV3_dc_highV": "PV3告警(DC高压故障)",
  "51102.s\\warn.warn_PV3_pv_input_lowV": "PV3告警(PV输入欠压)",
  "51102.s\\warn.warn_PV3_pv_input_overV": "PV3告警(PV输入过压)",
  "51102.s\\warn.warn_PV4_dc_lowV": "PV4告警(DC低压故障)",
  "51102.s\\warn.warn_PV4_dc_highV": "PV4告警(DC高压故障)",
  "51102.s\\warn.warn_PV4_pv_input_lowV": "PV4告警(PV输入欠压)",
  "51102.s\\warn.warn_PV4_pv_input_overV": "PV4告警(PV输入过压)",
  "51102.s\\warn.warn_prllt1_f_mismatch": "并机告警1(并机频率体系不一致)",
  "51102.s\\warn.warn_prllt2_avg_I": "并机告警1(并机均流故障)",
  "51102.s\\warn.warn_cell1_grp_avgV_high": "电芯告警1(电芯组均压高)",
  "51102.s\\warn.warn_cell1_overV": "电芯告警1(电芯高压)",
  "51102.s\\warn.warn_cell1_grp_avgV_low": "电芯告警1(电芯组均压低)",
  "51102.s\\warn.warn_cell1_lowV": "电芯告警1(电芯低压)",
  "51102.s\\warn.warn_cell2_chgOverISlowChck": "电芯告警2(充电过流慢检(电芯))",
  "51102.s\\warn.warn_cell2_dischgOverISlowChck": "电芯告警2(放电过流慢检(电芯))",
  "51102.s\\warn.warn_cellT_L1_overT_chg": "电芯温度告警(电芯一级过温(充电))",
  "51102.s\\warn.warn_cellT_L2_overT_chg": "电芯温度告警(电芯二级过温(充电))",
  "51102.s\\warn.warn_cellT_L1_lowT_chg": "电芯温度告警(电芯一级低温(充电))",
  "51102.s\\warn.warn_cellT_L2_lowT_chg": "电芯温度告警(电芯二级低温(充电))",
  "51102.s\\warn.warn_cellT_L1_overT_dischg": "电芯温度告警(电芯一级过温(放电))",
  "51102.s\\warn.warn_cellT_L2_overT_dischg": "电芯温度告警(电芯二级过温(放电))",
  "51102.s\\warn.warn_cellT_L1_lowT_dischg": "电芯温度告警(电芯一级低温(放电))",
  "51102.s\\warn.warn_cellT_L2_lowT_dischg": "电芯温度告警(电芯二级低温(放电))",
  "51102.s\\warn.warn_cellT_env_overT": "电芯温度告警(环境过温)",
  "51102.s\\warn.warn_cellT_env_lowT": "电芯温度告警(环境低温)",
  "51102.s\\warn.warn_cellT_mos_overT": "电芯温度告警(MOS过温)",
  "51102.s\\warn.warn_cellT_diffT_toolarge": "电芯温度告警(温差过大)",
  "51102.s\\warn.warn_eps_lowV": "EPS微逆告警(电压低)",
  "51102.s\\warn.warn_eps_highV": "EPS微逆告警(电压高)",
  "51102.s\\warn.warn_eps_lowF": "EPS微逆告警(频率低)",
  "51102.s\\warn.warn_eps_highF": "EPS微逆告警(频率高)",
  "51102.s\\warn.warn_eps_i_overI": "EPS微逆告警(交流输入过流)",
  "51102.s\\fault.fault_grid_summary": "电网故障(故障汇总)",
  "51102.s\\fault.fault_grid_Vabnormal": "电网故障(电压异常)",
  "51102.s\\fault.fault_grid_Fabnormal": "电网故障(频率异常)",
  "51102.s\\fault.fault_grid_lowV": "电网故障(电压低)",
  "51102.s\\fault.fault_grid_highV": "电网故障(电压高)",
  "51102.s\\fault.fault_grid_lowF": "电网故障(频率低)",
  "51102.s\\fault.fault_grid_highF": "电网故障(频率高)",
  "51102.s\\fault.fault_grid_gridLost": "电网故障(市电掉电)",
  "51102.s\\fault.fault_grid_gridSurge": "电网故障(市电浪涌)",
  "51102.s\\fault.fault_grid_relayOpen": "电网故障(电网继电器开路)",
  "51102.s\\fault.fault_grid_ac_i_overI": "电网故障(交流输入过流)",
  "51102.s\\fault.fault_PFC_summary": "整流故障(故障汇总)",
  "51102.s\\fault.fault_PFC_hardSoftStrtup": "整流故障(硬件软起故障)",
  "51102.s\\fault.fault_PFC_softSoftStrtup": "整流故障(软件软起故障)",
  "51102.s\\fault.fault_PFC_bus_lowV": "整流故障(母线低压)",
  "51102.s\\fault.fault_PFC_intr_comm_lost": "整流故障(内部通信故障)",
  "51102.s\\fault.fault_PFC_extrnl_comm_lost": "整流故障(对外通信故障)",
  "51102.s\\fault.fault_U1bus_summary": "U1母线故障(故障汇总)",
  "51102.s\\fault.fault_U1bus_lowV_abnormal": "U1母线故障(低压异常)",
  "51102.s\\fault.fault_U1bus_highV_abnormal": "U1母线故障(高压异常)",
  "51102.s\\fault.fault_U1bus_tooLowV": "U1母线故障(电压过低)",
  "51102.s\\fault.fault_U1bus_tooHighV": "U1母线故障(电压过高)",
  "51102.s\\fault.fault_U1bus_VtooHighFastChck": "U1母线故障(电压过高快检)",
  "51102.s\\fault.fault_U2bus_summary": "U2母线故障(故障汇总)",
  "51102.s\\fault.fault_U2bus_lowV_abnormal": "U2母线故障(低压异常)",
  "51102.s\\fault.fault_U2bus_highV_abnormal": "U2母线故障(高压异常)",
  "51102.s\\fault.fault_U2bus_tooLowV": "U2母线故障(电压过低)",
  "51102.s\\fault.fault_U2bus_tooHighV": "U2母线故障(电压过高)",
  "51102.s\\fault.fault_U2bus_VtooHighFastChck": "U2母线故障(电压过高快检)",
  "51102.s\\fault.fault_U2bus_PNbusUnbalance": "U2母线故障(正负母线不平衡)",
  "51102.s\\fault.fault_U2bus_busAvgVlargeV": "U2母线故障(母线均压高)",
  "51102.s\\fault.fault_U2bus_busAvgVlargeI": "U2母线故障(母线均压电流过高)",
  "51102.s\\fault.fault_U2bus_busAvgVlargeIFastChck": "U2母线故障(母线均压电流过高快检)",
  "51102.s\\fault.fault_o_summary": "输出故障(故障汇总)",
  "51102.s\\fault.fault_o_invRalayOpen": "输出故障(逆变继电器开路)",
  "51102.s\\fault.fault_o_invOverLoad": "输出故障(逆变过载延时到故障)",
  "51102.s\\fault.fault_o_bypOverLoad": "输出故障(旁路过载延时到故障)",
  "51102.s\\fault.fault_inv_summary": "逆变故障(故障汇总)",
  "51102.s\\fault.fault_inv_invFastChck": "逆变故障(逆变器快检故障)",
  "51102.s\\fault.fault_inv_invSlowChck": "逆变故障(逆变器慢检故障)",
  "51102.s\\fault.fault_inv_RelayStuck": "逆变故障(继电器连锡故障)",
  "51102.s\\fault.fault_inv_invShortCircuit": "逆变故障(逆变短路故障)",
  "51102.s\\fault.fault_inv_intrCommErr": "逆变故障(内部通信故障)",
  "51102.s\\fault.fault_inv_extCommErr": "逆变故障(对外通信故障)",
  "51102.s\\fault.fault_inv_invVabnormal": "逆变故障(逆变电压有效值故障)",
  "51102.s\\fault.fault_inv_outputOverVProtect": "逆变故障(逆变交流输出过压保护)",
  "51102.s\\fault.fault_inv_outputLowVProtect": "逆变故障(逆变交流输出欠压保护)",
  "51102.s\\fault.fault_inv_outputOverFProtect": "逆变故障(逆变交流输出过频保护)",
  "51102.s\\fault.fault_inv_outputlowFProtect": "逆变故障(逆变交流输出欠频保护)",
  "51102.s\\fault.fault_PLL_summary": "锁相故障(故障汇总)",
  "51102.s\\fault.fault_PLL_acMainPll": "锁相故障(市电锁相失败)",
  "51102.s\\fault.fault_PLL_secondaryPllLocked": "锁相故障(并机二级锁相失败)",
  "51102.s\\fault.fault_T_summary": "温度故障1(故障汇总)",
  "51102.s\\fault.fault_T_TtooHigh": "温度故障1(温度过高)",
  "51102.s\\fault.fault_T_TmpPinDisconn": "温度故障1(温度探头未插)",
  "51102.s\\fault.fault_T2_summary": "温度故障2(故障汇总)",
  "51102.s\\fault.fault_T2_TtooHigh": "温度故障2(温度过高)",
  "51102.s\\fault.fault_T2_TmpPinDisconn": "温度故障2(温度探头未插)",
  "51102.s\\fault.fault_byp_summary": "旁路故障(故障汇总)",
  "51102.s\\fault.fault_byp_Vabnormal": "旁路故障(电压异常)",
  "51102.s\\fault.fault_byp_Fabnormal": "旁路故障(频率异常)",
  "51102.s\\fault.fault_byp_VtooLow": "旁路故障(电压低)",
  "51102.s\\fault.fault_byp_VtooHigh": "旁路故障(电压高)",
  "51102.s\\fault.fault_byp_FtooLow": "旁路故障(频率低)",
  "51102.s\\fault.fault_byp_FtooHigh": "旁路故障(频率高)",
  "51102.s\\fault.fault_byp_bypShtdwn": "旁路故障(旁路掉电)",
  "51102.s\\fault.fault_byp_bypInrush": "旁路故障(旁路浪涌)",
  "51102.s\\fault.fault_byp_intrCommErr": "旁路故障(内部通信故障)",
  "51102.s\\fault.fault_byp_extCommErr": "旁路故障(对外通信故障)",
  "51102.s\\fault.fault_chg_summary": "充电器故障(故障汇总)",
  "51102.s\\fault.fault_chg_lowV": "充电器故障(充电器低压)",
  "51102.s\\fault.fault_chg_HighV": "充电器故障(充电器高压)",
  "51102.s\\fault.fault_chg_OutputShortCircuit": "充电器故障(充电器输出短路)",
  "51102.s\\fault.fault_chg_softStrpup": "充电器故障(充电器软启故障)",
  "51102.s\\fault.fault_chg_busVAbnormal": "充电器故障(母线电压异常)",
  "51102.s\\fault.fault_chg_oVTooLowFastChck": "充电器故障(输出电压过低快检)",
  "51102.s\\fault.fault_chg_oVTooHigh": "充电器故障(输出电压过高)",
  "51102.s\\fault.fault_chg_oVTooHighFastChck": "充电器故障(输出电压过高快检)",
  "51102.s\\fault.fault_chg_acChgUnenough": "充电器故障(AC剩余充电功率不足(PV+AC联合充电))",
  "51102.s\\fault.fault_chg_intrCommErr": "充电器故障(内部通信故障)",
  "51102.s\\fault.fault_chg_outCommErr": "充电器对外通信故障",
  "51102.s\\fault.fault_chg_extCommErr": "充电器故障(剩余充电功率不足(AC边充边放))",
  "51102.s\\fault.fault_chg_bypSundenlyAddLoad": "充电器故障(旁路突加载故障)",
  "51102.s\\fault.fault_dischg_summary": "放电器故障(故障汇总)",
  "51102.s\\fault.fault_dischg_battLowV": "放电器故障(电池低压故障)",
  "51102.s\\fault.fault_dischg_busLowV": "放电器故障(母线低压故障)",
  "51102.s\\fault.fault_dischg_battHighV": "放电器故障(电池高压故障)",
  "51102.s\\fault.fault_dischg_battTooHighV": "放电器故障(电池电压过高故障)",
  "51102.s\\fault.fault_dischg_intrCommLost": "放电器故障(内部通信故障)",
  "51102.s\\fault.fault_dischg_extrCommLost": "放电器故障(对外通信故障)",
  "51102.s\\fault.fault_dischg_battVtooLow": "放电器故障(电池电压过低故障)",
  "51102.s\\fault.fault_dischg_softStrpup": "放电器故障(放电器软启故障)",
  "51102.s\\fault.fault_sys_dismatch": "系统故障(机型不匹配)",
  "51102.s\\fault.fault_sys_intrCommLost": "系统故障(内部通信故障)",
  "51102.s\\fault.fault_sys_extCommLost": "系统故障(对外通信故障)",
  "51102.s\\fault.fault_PV1_summary": "PV1故障(故障汇总)",
  "51102.s\\fault.fault_PV1_DCLowV": "PV1故障(DC低压故障)",
  "51102.s\\fault.fault_PV1_DCHighV": "PV1故障(DC高压故障)",
  "51102.s\\fault.fault_PV1_softStrpUp": "PV1故障(软启故障)",
  "51102.s\\fault.fault_PV1_outpuShrtCircuit": "PV1故障(输出短路故障)",
  "51102.s\\fault.fault_PV1_outpuShrtCircuitStrtup": "PV1故障(输出短路启机故障)",
  "51102.s\\fault.fault_PV1_DCVTooHigh": "PV1故障(DC电压过高)",
  "51102.s\\fault.fault_PV1_DCVTooHighFstChck": "PV1故障(DC电压过高快检)",
  "51102.s\\fault.fault_PV1_Vabnormal": "PV1故障(PV工作电压异常)",
  "51102.s\\fault.fault_PV1_inCommLost": "PV1故障(内部通信故障)",
  "51102.s\\fault.fault_PV1_extCommLost": "PV1故障(对外通信故障)",
  "51102.s\\fault.fault_PV1_inputLowV": "PV1故障(PV输入欠压)",
  "51102.s\\fault.fault_PV1_inputHighV": "PV1故障(PV输入过压)",
  "51102.s\\fault.fault_PV2_summary": "PV2故障(故障汇总)",
  "51102.s\\fault.fault_PV2_DCLowV": "PV2故障(DC低压故障)",
  "51102.s\\fault.fault_PV2_DCHighV": "PV2故障(DC高压故障)",
  "51102.s\\fault.fault_PV2_softStrpUp": "PV2故障(软启故障)",
  "51102.s\\fault.fault_PV2_outpuShrtCircuit": "PV2故障(输出短路故障)",
  "51102.s\\fault.fault_PV2_outpuShrtCircuitStrtup": "PV2故障(输出短路启机故障)",
  "51102.s\\fault.fault_PV2_DCVTooHigh": "PV2故障(DC电压过高)",
  "51102.s\\fault.fault_PV2_DCVTooHighFstChck": "PV2故障(DC电压过高快检)",
  "51102.s\\fault.fault_PV2_Vabnormal": "PV2故障(PV工作电压异常)",
  "51102.s\\fault.fault_PV2_inCommLost": "PV2故障(内部通信故障)",
  "51102.s\\fault.fault_PV2_extCommLost": "PV2故障(对外通信故障)",
  "51102.s\\fault.fault_PV2_inputLowV": "PV2故障(PV输入欠压)",
  "51102.s\\fault.fault_PV2_inputHighV": "PV2故障(PV输入过压)",
  "51102.s\\fault.fault_PV3_summary": "PV3故障(故障汇总)",
  "51102.s\\fault.fault_PV3_DCLowV": "PV3故障(DC低压故障)",
  "51102.s\\fault.fault_PV3_DCHighV": "PV3故障(DC高压故障)",
  "51102.s\\fault.fault_PV3_softStrpUp": "PV3故障(软启故障)",
  "51102.s\\fault.fault_PV3_outpuShrtCircuit": "PV3故障(输出短路故障)",
  "51102.s\\fault.fault_PV3_outpuShrtCircuitStrtup": "PV3故障(输出短路启机故障)",
  "51102.s\\fault.fault_PV3_DCVTooHigh": "PV3故障(DC电压过高)",
  "51102.s\\fault.fault_PV3_DCVTooHighFstChck": "PV3故障(DC电压过高快检)",
  "51102.s\\fault.fault_PV3_Vabnormal": "PV3故障(PV工作电压异常)",
  "51102.s\\fault.fault_PV3_inCommLost": "PV3故障(内部通信故障)",
  "51102.s\\fault.fault_PV3_extCommLost": "PV3故障(对外通信故障)",
  "51102.s\\fault.fault_PV3_inputLowV": "PV3故障(PV输入欠压)",
  "51102.s\\fault.fault_PV3_inputHighV": "PV3故障(PV输入过压)",
  "51102.s\\fault.fault_PV4_summary": "PV4故障(故障汇总)",
  "51102.s\\fault.fault_PV4_DCLowV": "PV4故障(DC低压故障)",
  "51102.s\\fault.fault_PV4_DCHighV": "PV4故障(DC高压故障)",
  "51102.s\\fault.fault_PV4_softStrpUp": "PV4故障(软启故障)",
  "51102.s\\fault.fault_PV4_outpuShrtCircuit": "PV4故障(输出短路故障)",
  "51102.s\\fault.fault_PV4_outpuShrtCircuitStrtup": "PV4故障(输出短路启机故障)",
  "51102.s\\fault.fault_PV4_DCVTooHigh": "PV4故障(DC电压过高)",
  "51102.s\\fault.fault_PV4_DCVTooHighFstChck": "PV4故障(DC电压过高快检)",
  "51102.s\\fault.fault_PV4_Vabnormal": "PV4故障(PV工作电压异常)",
  "51102.s\\fault.fault_PV4_inCommLost": "PV4故障(内部通信故障)",
  "51102.s\\fault.fault_PV4_extCommLost": "PV4故障(对外通信故障)",
  "51102.s\\fault.fault_PV4_inputLowV": "PV4故障(PV输入欠压)",
  "51102.s\\fault.fault_PV4_inputHighV": "PV4故障(PV输入过压)",
  "51102.s\\fault.fault_prllt_summary": "并机故障1(故障汇总)",
  "51102.s\\fault.fault_prllt_idConflict": "并机故障1(并机ID冲突故障)",
  "51102.s\\fault.fault_prllt_commErr": "并机故障1(并机通信故障)",
  "51102.s\\fault.fault_prllt_Fdismatch": "并机故障1(并机频率体系不一致)",
  "51102.s\\fault.fault_prllt_failure": "并机故障1(并机失败故障)",
  "51102.s\\fault.fault_prllt2_summary": "并机故障2(故障汇总)",
  "51102.s\\fault.fault_prllt2_avgI": "并机故障2(并机均流故障)",
  "51102.s\\fault.fault_prllt2_FsyncSig": "并机故障2(并机工频同步信号故障)",
  "51102.s\\fault.fault_cell1_avgVHighProtect": "电芯故障1(电芯组均压高保护)",
  "51102.s\\fault.fault_cell1_HighVProtect": "电芯故障1(电芯高压保护)",
  "51102.s\\fault.fault_cell1_avgVlowProtect": "电芯故障1(电芯组均压低保护)",
  "51102.s\\fault.fault_cell1_lowVProtect": "电芯故障1(电芯低压保护)",
  "51102.s\\fault.fault_cell1_cellCntDismatch": "电芯故障1(电池节数不匹配)",
  "51102.s\\fault.fault_cell1_cellUnavail": "电芯故障1(电芯单体失效)",
  "51102.s\\fault.fault_cell1_cellGrpDiffVtooLarge": "电芯故障1(电芯组压差过大)",
  "51102.s\\fault.fault_cell1_seriousHighVProtect": "电芯故障1(电芯严重高压保护)",
  "51102.s\\fault.fault_cell1_seriousLowVProtect": "电芯故障1(电芯严重低压保护)",
  "51102.s\\fault.fault_cell1_srsLowVPrtctShtdwn": "电芯故障1(电芯严重低压保护关机)",
  "51102.s\\fault.fault_cell1_l1ChgStatus": "电芯故障1(一级强充状态-不控制，只播报)",
  "51102.s\\fault.fault_cell1_l2ChgStatus": "电芯故障1(二级强充状态-不控制，只播报)",
  "51102.s\\fault.fault_cell1_tooOverVProtect": "电芯故障1(电芯严重过压保护)",
  "51102.s\\fault.fault_cell2_chgOverISlwChck": "电芯故障2(充电过流慢检(电芯))",
  "51102.s\\fault.fault_cell2_chgOverIFstChck": "电芯故障2(充电过流快检(电芯))",
  "51102.s\\fault.fault_cell2_dischgOverISlwChck": "电芯故障2(放电过流慢检(电芯))",
  "51102.s\\fault.fault_cell2_dischgOverIFstChck": "电芯故障2(放电过流快检(电芯))",
  "51102.s\\fault.fault_cell2_chgOverI": "电芯故障2(充电过流错误)",
  "51102.s\\fault.fault_cell2_dischgOverI": "电芯故障2(放电过流错误)",
  "51102.s\\fault.fault_cellT_TmpSensorDisconn": "电芯温度故障(电芯采样温度探头未插)",
  "51102.s\\fault.fault_cellT_l1OverTChg": "电芯温度故障(电芯一级过温保护(充电))",
  "51102.s\\fault.fault_cellT_l2OverTChg": "电芯温度故障(电芯二级过温保护(充电))",
  "51102.s\\fault.fault_cellT_l1lowTChg": "电芯温度故障(电芯一级低温保护(充电))",
  "51102.s\\fault.fault_cellT_l2lowTChg": "电芯温度故障(电芯二级低温保护(充电))",
  "51102.s\\fault.fault_cellT_l1OverTdisChg": "电芯温度故障(电芯一级过温保护(放电))",
  "51102.s\\fault.fault_cellT_l2OverTdisChg": "电芯温度故障(电芯二级过温保护(放电))",
  "51102.s\\fault.fault_cellT_l1lowTdisChg": "电芯温度故障(电芯一级低温保护(放电))",
  "51102.s\\fault.fault_cellT_l2lowTdisChg": "电芯温度故障(电芯二级低温保护(放电))",
  "51102.s\\fault.fault_cellT_envOverT": "电芯温度故障(环境过温保护)",
  "51102.s\\fault.fault_cellT_envlowT": "电芯温度故障(环境低温保护)",
  "51102.s\\fault.fault_cellT_mosOverT": "电芯温度故障(MOS过温保护)",
  "51102.s\\fault.fault_cellT_diffTtooHigh": "电芯温度故障(温差过大)",
  "51102.s\\fault.fault_cellT_highVsideMosDisconn": "电芯温度故障(高压侧MOS采样探头未插)",
  "51102.s\\fault.fault_eps_summary": "EPS微逆故障(故障汇总)",
  "51102.s\\fault.fault_eps_Vabnormal": "EPS微逆故障(电压异常)",
  "51102.s\\fault.fault_eps_Fabnormal": "EPS微逆故障(频率异常)",
  "51102.s\\fault.fault_eps_VtooLow": "EPS微逆故障(电压过低)",
  "51102.s\\fault.fault_eps_VLow": "EPS微逆故障(电压低)",
  "51102.s\\fault.fault_eps_VHigh": "EPS微逆故障(电压高)",
  "51102.s\\fault.fault_eps_Flow": "EPS微逆故障(频率低)",
  "51102.s\\fault.fault_eps_FHigh": "EPS微逆故障(频率高)",
  "51102.s\\fault.fault_eps_acMainLost": "EPS微逆故障(输入掉电)",
  "51102.s\\fault.fault_eps_inpuSurge": "EPS微逆故障(输入浪涌)",
  "51102.s\\fault.fault_eps_relayOpenCircuit": "EPS微逆故障(继电器开路)",
  "51102.s\\fault.fault_eps_inputOverI": "EPS微逆故障(输入过流)",
  "51102.s\\elct_meter.elct_meter1_SN": "网侧电表SN",
  "51102.s\\elct_meter.elct_meter1_soft_no": "网侧电表软件编号",
  "51102.s\\elct_meter.elct_meter1_soft_ver": "网侧电表软件版本",
  "51102.s\\elct_meter.elct_meter1_hard_ver": "网侧电表硬件版本号",
  "51102.s\\elct_meter.elct_meter1_phase_no": "逆变器所在相位",
  "51102.s\\elct_meter.elct_meter1_online_status": "网侧电表在线状态",
  "51102.s\\elct_meter.elct_meter1_total_active_energy": "网侧电表总有功电能",
  "51102.s\\elct_meter.gridBuyPower": "网侧电表正向有功电能",
  "51102.s\\elct_meter.gridSellPower": "网侧电表反向有功电能",
  "51102.s\\elct_meter.elct_meter1_total_reactive_energy": "网侧电表总无功电能",
  "51102.s\\elct_meter.elct_meter1_forward_reactive_energy": "网侧电表正向无功电能",
  "51102.s\\elct_meter.elct_meter1_reverse_reactive_energy": "网侧电表反向无功电能",
  "51102.s\\elct_meter.elct_meter1_voltage": "网侧电表电压",
  "51102.s\\elct_meter.elct_meter1_current": "网侧电表电流",
  "51102.s\\elct_meter.gridTotalFrequency": "网侧电表频率",
  "51102.s\\elct_meter.gridPower": "网侧电表有功功率",
  "51102.s\\elct_meter.elct_meter1_reactive_power": "网侧电表无功功率",
  "51102.s\\elct_meter.elct_meter1_apparent_power": "网侧电表视在功率",
  "51102.s\\elct_meter.elct_meter1_power_factor": "网侧电表功率因数",
  "51102.s\\elct_meter.elct_meter2_SN": "AC微逆侧电表SN",
  "51102.s\\elct_meter.elct_meter2_soft_no": "AC微逆侧电表软件编号",
  "51102.s\\elct_meter.elct_meter2_soft_ver": "AC微逆侧电表软件版本",
  "51102.s\\elct_meter.elct_meter2_hard_ver": "AC微逆侧电表硬件版本号",
  "51102.s\\elct_meter.elct_meter2_phase_no": "逆变器所在相位",
  "51102.s\\elct_meter.elct_meter2_online_status": "AC微逆侧电表在线状态",
  "51102.s\\elct_meter.elct_meter2_total_active_energy": "AC微逆侧电表总有功电能",
  "51102.s\\elct_meter.elct_meter2_forward_active_energy": "AC微逆侧电表正向有功电能",
  "51102.s\\elct_meter.elct_meter2_reverse_active_energy": "AC微逆侧电表反向有功电能",
  "51102.s\\elct_meter.elct_meter2_total_reactive_energy": "AC微逆侧电表总无功电能",
  "51102.s\\elct_meter.elct_meter2_forward_reactive_energy": "AC微逆侧电表正向无功电能",
  "51102.s\\elct_meter.elct_meter2_reverse_reactive_energy": "AC微逆侧电表反向无功电能",
  "51102.s\\elct_meter.elct_meter2_voltage": "AC微逆侧电表电压",
  "51102.s\\elct_meter.elct_meter2_current": "AC微逆侧电表电流",
  "51102.s\\elct_meter.elct_meter2_frequency": "AC微逆侧电表频率",
  "51102.s\\elct_meter.elct_meter2_active_power": "AC微逆侧电表有功功率",
  "51102.s\\elct_meter.elct_meter2_reactive_power": "AC微逆侧电表无功功率",
  "51102.s\\elct_meter.elct_meter2_apparent_power": "AC微逆侧电表视在功率",
  "51102.s\\elct_meter.elct_meter2_power_factor": "AC微逆侧电表功率因数",
  "51102.s\\collector.c_datalogger_reboot.12544": "重启",
  "51102.s\\collector.c_datalogger_factory_reset.12544": "恢复出厂设置",
  "51102.s\\collector.c_datalogger_ble_onoff.12288": "关闭",
  "51102.s\\collector.c_datalogger_ble_onoff.12544": "打开",
  "51102.s\\collector.c_eletMeter1_insPlace.0": "未设置",
  "51102.s\\collector.c_eletMeter1_insPlace.1": "电网侧",
  "51102.s\\collector.c_eletMeter1_insPlace.2": "AC微逆侧",
  "51102.s\\collector.c_eletMeter1_commType.0": "未设置",
  "51102.s\\collector.c_eletMeter1_commType.1": "无线",
  "51102.s\\collector.c_eletMeter1_commType.2": "有线",
  "51102.s\\collector.c_eletMeter1_phaseNo.0": "单相",
  "51102.s\\collector.c_eletMeter1_phaseNo.1": "A相",
  "51102.s\\collector.c_eletMeter1_phaseNo.2": "B相",
  "51102.s\\collector.c_eletMeter1_phaseNo.3": "C相",
  "51102.s\\collector.c_eletMeter2_insPlace.0": "未设置",
  "51102.s\\collector.c_eletMeter2_insPlace.1": "电网侧",
  "51102.s\\collector.c_eletMeter2_insPlace.2": "AC微逆侧",
  "51102.s\\collector.c_eletMeter2_commType.0": "未设置",
  "51102.s\\collector.c_eletMeter2_commType.1": "无线",
  "51102.s\\collector.c_eletMeter2_commType.2": "有线",
  "51102.s\\collector.c_eletMeter2_phaseNo.0": "单相",
  "51102.s\\collector.c_eletMeter2_phaseNo.1": "A相",
  "51102.s\\collector.c_eletMeter2_phaseNo.2": "B相",
  "51102.s\\collector.c_eletMeter2_phaseNo.3": "C相",
  "51102.s\\collector.c_eletMeter3_insPlace.0": "未设置",
  "51102.s\\collector.c_eletMeter3_insPlace.1": "电网侧",
  "51102.s\\collector.c_eletMeter3_insPlace.2": "AC微逆侧",
  "51102.s\\collector.c_eletMeter3_commType.0": "未设置",
  "51102.s\\collector.c_eletMeter3_commType.1": "无线",
  "51102.s\\collector.c_eletMeter3_commType.2": "有线",
  "51102.s\\collector.c_eletMeter3_phaseNo.0": "单相",
  "51102.s\\collector.c_eletMeter3_phaseNo.1": "A相",
  "51102.s\\collector.c_eletMeter3_phaseNo.2": "B相",
  "51102.s\\collector.c_eletMeter3_phaseNo.3": "C相",
  "51102.s\\real_time.dev_type.0": "微储",
  "51102.s\\real_time.dev_type.1": "户储",
  "51102.s\\real_time.dev_type.2": "混合逆变器",
  "51102.s\\real_time.bms_status.0": "正常",
  "51102.s\\real_time.bms_status.1": "禁放",
  "51102.s\\real_time.bms_status.2": "禁充",
  "51102.s\\real_time.bms_status.3": "禁充禁放",
  "51102.s\\real_time.bms_status.4": "禁充禁放且分励脱扣断开",
  "51102.s\\real_time.bms_status.5": "满充",
  "51102.s\\real_time.bms_status.6": "满放",
  "51102.s\\real_time.bms_status.8": "整机下电",
  "51102.s\\real_time.batt_type.0": "314电芯",
  "51102.s\\real_time.batt_type.1": "其他",
  "51102.s\\real_time.anti_curr_status.0": "未开启",
  "51102.s\\real_time.anti_curr_status.1": "开启",
  "51102.s\\real_time.low_volt_cross_status.0": "未开启",
  "51102.s\\real_time.low_volt_cross_status.1": "开启",
  "51102.s\\real_time.f_cross_status.0": "未开启",
  "51102.s\\real_time.f_cross_status.1": "开启",
  "51102.s\\real_time.reconn_cross_status.0": "未开启",
  "51102.s\\real_time.reconn_cross_status.1": "开启",
  "51102.s\\real_time.inv_profile.0": "欧洲通用（默认），230V/50Hz",
  "51102.s\\real_time.inv_profile.1": "德国，230V/50Hz",
  "51102.s\\real_time.inv_profile.2": "澳洲，230V/50Hz",
  "51102.s\\real_time.inv_profile.3": "澳洲西，230V/50Hz",
  "51102.s\\real_time.inv_profile.4": "新西兰，230V/50Hz",
  "51102.s\\real_time.inv_profile.5": "英国，230V/50Hz",
  "51102.s\\real_time.inv_profile.6": "巴基斯坦，230V/50Hz",
  "51102.s\\real_time.inv_profile.7": "韩国，220V/60Hz",
  "51102.s\\real_time.inv_profile.8": "菲律宾，220V/60Hz",
  "51102.s\\real_time.inv_profile.9": "中国，220V/50Hz",
  "51102.s\\real_time.inv_profile.10": "美国，120V/60Hz",
  "51102.s\\real_time.inv_profile.11": "泰国PEA，220V/50Hz",
  "51102.s\\real_time.inv_profile.12": "南非，230V/50Hz",
  "51102.s\\real_time.inv_profile.13": "Custom 50Hz，自定义50Hz",
  "51102.s\\real_time.inv_profile.14": "Custom 60Hz，自定义60Hz",
  "51102.s\\real_time.inv_profile.15": "波兰，230V/50Hz",
  "51102.s\\real_time.inv_profile.16": "意大利，230V/50Hz",
  "51102.s\\real_time.inv_profile.17": "斯洛文尼亚，230V/50Hz",
  "51102.s\\real_time.inv_profile.18": "捷克，230V/50Hz",
  "51102.s\\real_time.inv_profile.19": "瑞典，230V/50Hz",
  "51102.s\\real_time.inv_profile.20": "匈牙利，230V/50Hz",
  "51102.s\\real_time.inv_profile.21": "斯洛伐克，230V/50Hz",
  "51102.s\\real_time.inv_profile.22": "奥地利，230V/50Hz",
  "51102.s\\real_time.inv_profile.23": "比利时，230V/50Hz",
  "51102.s\\real_time.inv_profile.24": "牙买加，110/220V 60Hz",
  "51102.s\\real_time.inv_profile.25": "爱尔兰，230V/50Hz",
  "51102.s\\real_time.inv_profile.26": "科威特，230V/50Hz",
  "51102.s\\real_time.inv_profile.27": "罗马尼亚，230V/50Hz",
  "51102.s\\real_time.inv_profile.28": "法国，230V/50Hz",
  "51102.s\\real_time.inv_profile.29": "荷兰，230V/50Hz",
  "51102.s\\real_time.inv_profile.30": "瑞士，230V/50Hz",
  "51102.s\\real_time.inv_profile.31": "西班牙，230V/50Hz",
  "51102.s\\real_time.inv_profile.32": "泰国MEA，220V/50Hz",
  "51102.s\\real_time.inv_manufac.0": "图为",
  "51102.s\\real_time.deviceStatus.0": "未激活",
  "51102.s\\real_time.deviceStatus.1": "激活",
  "51102.s\\real_time.Wifi_BT_Online.0": "离线",
  "51102.s\\real_time.Wifi_BT_Online.1": "在线",
  "51102.s\\real_time.Wifi_BT_Sleep.0": "不休眠",
  "51102.s\\real_time.workStatus.0": "关机",
  "51102.s\\real_time.workStatus.1": "待机",
  "51102.s\\real_time.workStatus.2": "AC充电",
  "51102.s\\real_time.workStatus.3": "AC边充边放",
  "51102.s\\real_time.workStatus.4": "旁路放电",
  "51102.s\\real_time.workStatus.5": "电池放电",
  "51102.s\\real_time.workStatus.6": "PV充电",
  "51102.s\\real_time.workStatus.7": "PV边充边放",
  "51102.s\\real_time.workStatus.8": "PV+AC联合充电",
  "51102.s\\real_time.workStatus.9": "PV+AC联合充电，旁路放电",
  "51102.s\\real_time.workStatus.10": "微逆充电",
  "51102.s\\real_time.workStatus.11": "微逆馈网",
  "51102.s\\real_time.workStatus.12": "微逆+PV联合充电",
  "51102.s\\real_time.workStatus.13": "故障",
  "51102.s\\real_time.workMode.0": "自发自用模式",
  "51102.s\\real_time.workMode.1": "馈网优先模式",
  "51102.s\\real_time.workMode.2": "削峰填谷模式",
  "51102.s\\real_time.workMode.3": "备电模式",
  "51102.s\\real_time.workMode.4": "TOU模式",
  "51102.s\\real_time.workMode.5": "三方调度",
  "51102.s\\real_time.parelletRunStatue.0": "单机",
  "51102.s\\real_time.parelletRunStatue.1": "并机",
  "51102.s\\real_time.acDischargeMode.0": "未输出",
  "51102.s\\real_time.acDischargeMode.1": "正在输出",
  "51102.s\\real_time.acchargeStatus.0": "未充电",
  "51102.s\\real_time.acchargeStatus.1": "正在充电",
  "51102.s\\real_time.MPPTStatus.0": "未充电",
  "51102.s\\real_time.MPPTStatus.1": "正在充电",
  "51102.s\\real_time.SleepStatus.0": "未休眠",
  "51102.s\\real_time.SleepStatus.1": "休眠",
  "51102.s\\real_time.gridConnStatus.0": "并网",
  "51102.s\\real_time.gridConnStatus.1": "离网",
  "51102.s\\real_time.antiReverseIStatus.0": "未开启",
  "51102.s\\real_time.antiReverseIStatus.1": "开启",
  "51102.s\\real_time.masterOrSlaveStatus.0": "从机",
  "51102.s\\real_time.masterOrSlaveStatus.1": "主机",
  "51102.s\\real_time.EPSConnStatus.0": "负载",
  "51102.s\\real_time.EPSConnStatus.1": "微逆",
  "51102.s\\real_time.remote_onoff_status.0": "单台关机",
  "51102.s\\real_time.remote_onoff_status.1": "单台开机",
  "51102.s\\real_time.remote_onoff_status.2": "全部关机",
  "51102.s\\real_time.remote_onoff_status.3": "全部开机",
  "51102.s\\real_time.shunt_trip_status.0": "闭合",
  "51102.s\\real_time.shunt_trip_status.1": "断开",
  "51102.s\\real_time.parallel_status.0": "未开启",
  "51102.s\\real_time.parallel_status.1": "开启",
  "51102.s\\real_time.parallel_isMaster.0": "从机",
  "51102.s\\real_time.parallel_isMaster.1": "主机",
  "51102.s\\real_time.EPS_status.0": "未接入",
  "51102.s\\real_time.EPS_status.1": "已接入",
  "51102.s\\real_time.PV1_online_status.0": "不在位",
  "51102.s\\real_time.PV1_online_status.1": "在位",
  "51102.s\\real_time.PV2_online_status.0": "不在位",
  "51102.s\\real_time.PV2_online_status.1": "在位",
  "51102.s\\real_time.PV3_online_status.0": "不在位",
  "51102.s\\real_time.PV3_online_status.1": "在位",
  "51102.s\\real_time.PV4_online_status.0": "不在位",
  "51102.s\\real_time.PV4_online_status.1": "在位",
  "51102.s_w\\ctl_actpower.actpower_ctl_en.0": "不使能",
  "51102.s_w\\ctl_actpower.actpower_ctl_en.1": "使能",
  "51102.s_w\\ctl_reactpower.reactpower_ctl_en.0": "不使能",
  "51102.s_w\\ctl_reactpower.reactpower_ctl_en.1": "使能",
  "51102.s_w\\ctl_reactpower.reactpower_ctl_mode.0": "功率因数模式",
  "51102.s_w\\ctl_reactpower.reactpower_ctl_mode.1": "电压无功功率曲线模式",
  "51102.m_w\\ctl_EMS.ems_ctrl_work_mode.0": "自发自用模式使能",
  "51102.m_w\\ctl_EMS.ems_ctrl_work_mode.1": "馈网优先模式使能",
  "51102.m_w\\ctl_EMS.ems_ctrl_work_mode.2": "削峰填谷模式使能",
  "51102.m_w\\ctl_EMS.ems_ctrl_work_mode.3": "备电模式使能",
  "51102.m_w\\ctl_EMS.ems_ctrl_work_mode.4": "TOU模式使能",
  "51102.m_w\\ctl_EMS.ems_ctrl_work_mode.5": "第三方调度使能",
  "51102.m_w\\ctl_EMS.anti_reverse_curr.0": "禁用",
  "51102.m_w\\ctl_EMS.anti_reverse_curr.1": "使能",
  "51102.s_w\\ctl_EMS.remote_on_off_ctrl.0": "单台关机",
  "51102.s_w\\ctl_EMS.remote_on_off_ctrl.1": "单台开机",
  "51102.s_w\\ctl_EMS.remote_on_off_ctrl.2": "全部关机",
  "51102.s_w\\ctl_EMS.remote_on_off_ctrl.3": "全部开机",
  "51102.s_w\\ctl_EMS.batt_shutdown_ctrl.0": "禁用",
  "51102.s_w\\ctl_EMS.batt_shutdown_ctrl.1": "使能",
  "51102.s_w\\ctl_EMS.factory_recovery.0": "无操作",
  "51102.s_w\\ctl_EMS.factory_recovery.1": "清除电量信息",
  "51102.s_w\\ctl_EMS.factory_recovery.2": "清除日志信息",
  "51102.s_w\\ctl_EMS.factory_recovery.3": "完全恢复出厂设置",
  "51102.m_w\\ctl_EMS.user_type.0": "普通用户",
  "51102.m_w\\ctl_EMS.gridType.0": "EN50549，欧洲通用",
  "51102.m_w\\ctl_EMS.gridType.2": "AU，澳洲",
  "51102.m_w\\ctl_EMS.gridType.3": "AU-W， 澳洲西",
  "51102.m_w\\ctl_EMS.gridType.4": "NZ，新西兰",
  "51102.m_w\\ctl_EMS.gridType.5": "UK，英国",
  "51102.m_w\\ctl_EMS.gridType.6": "PK，巴基斯坦",
  "51102.m_w\\ctl_EMS.gridType.7": "KR，韩国",
  "51102.m_w\\ctl_EMS.gridType.8": "PHI，菲律宾",
  "51102.m_w\\ctl_EMS.gridType.9": "CN，中国",
  "51102.m_w\\ctl_EMS.gridType.10": "US，美国",
  "51102.m_w\\ctl_EMS.gridType.11": "TAI-PEA，泰国PEA",
  "51102.m_w\\ctl_EMS.gridType.12": "ZA，南非",
  "51102.m_w\\ctl_EMS.gridType.13": "Custom 50Hz，自定义50Hz",
  "51102.m_w\\ctl_EMS.gridType.14": "Custom 60Hz，自定义60Hz",
  "51102.m_w\\ctl_EMS.gridType.15": "POL，波兰",
  "51102.m_w\\ctl_EMS.gridType.16": "ITA，意大利",
  "51102.m_w\\ctl_EMS.gridType.17": "SLO，斯洛文尼亚，采用EN50549",
  "51102.m_w\\ctl_EMS.gridType.18": "CZE，捷克，采用EN50549",
  "51102.m_w\\ctl_EMS.gridType.19": "SWE，瑞典，采用EN50549",
  "51102.m_w\\ctl_EMS.gridType.20": "HU，匈牙利",
  "51102.m_w\\ctl_EMS.gridType.21": "SK，斯洛伐克",
  "51102.m_w\\ctl_EMS.gridType.22": "AT，奥地利",
  "51102.m_w\\ctl_EMS.gridType.23": "BE，比利时",
  "51102.m_w\\ctl_EMS.gridType.24": "JM，牙买加",
  "51102.m_w\\ctl_EMS.gridType.25": "IE，爱尔兰",
  "51102.m_w\\ctl_EMS.gridType.26": "KW，科威特",
  "51102.m_w\\ctl_EMS.gridType.27": "ROU，罗马尼亚",
  "51102.m_w\\ctl_EMS.gridType.28": "FR，法国",
  "51102.m_w\\ctl_EMS.gridType.29": "NL，荷兰",
  "51102.m_w\\ctl_EMS.gridType.30": "CH，瑞士",
  "51102.m_w\\ctl_EMS.gridType.31": "ES，西班牙",
  "51102.m_w\\ctl_EMS.gridType.32": "TAI-MEA，泰国MEA",
  "51102.m_w\\ctl_EMS.TOU_work_status.0": "未开启",
  "51102.m_w\\ctl_EMS.TOU_work_status.1": "开启",
  "51102.s\\alarm.alrm_grid_v_low.0": "正常",
  "51102.s\\alarm.alrm_grid_v_low.1": "预警",
  "51102.s\\alarm.alrm_grid_v_high.0": "正常",
  "51102.s\\alarm.alrm_grid_v_high.1": "预警",
  "51102.s\\alarm.alrm_grid_f_low.0": "正常",
  "51102.s\\alarm.alrm_grid_f_low.1": "预警",
  "51102.s\\alarm.alrm_grid_f_high.0": "正常",
  "51102.s\\alarm.alrm_grid_f_high.1": "预警",
  "51102.s\\alarm.alrm_grid_input_overI.0": "正常",
  "51102.s\\alarm.alrm_grid_input_overI.1": "预警",
  "51102.s\\alarm.alrm_PFC_bus_v_low.0": "正常",
  "51102.s\\alarm.alrm_PFC_bus_v_low.1": "预警",
  "51102.s\\alarm.alrm_U1_bus_v_low.0": "正常",
  "51102.s\\alarm.alrm_U1_bus_v_low.1": "预警",
  "51102.s\\alarm.alrm_U1_bus_v_high.0": "正常",
  "51102.s\\alarm.alrm_U1_bus_v_high.1": "预警",
  "51102.s\\alarm.alrm_U2_bus_v_low.0": "正常",
  "51102.s\\alarm.alrm_U2_bus_v_low.1": "预警",
  "51102.s\\alarm.alrm_U2_bus_v_high.0": "正常",
  "51102.s\\alarm.alrm_U2_bus_v_high.1": "预警",
  "51102.s\\alarm.alrm_inv_overload.0": "正常",
  "51102.s\\alarm.alrm_inv_overload.1": "预警",
  "51102.s\\alarm.alrm_bypass_overload.0": "正常",
  "51102.s\\alarm.alrm_bypass_overload.1": "预警",
  "51102.s\\alarm.alrm_inv_v_fault.0": "正常",
  "51102.s\\alarm.alrm_inv_v_fault.1": "预警",
  "51102.s\\alarm.alrm_inv_overV_protect.0": "正常",
  "51102.s\\alarm.alrm_inv_overV_protect.1": "预警",
  "51102.s\\alarm.alrm_inv_lowV_protect.0": "正常",
  "51102.s\\alarm.alrm_inv_lowV_protect.1": "预警",
  "51102.s\\alarm.alrm_inv_overF_protect.0": "正常",
  "51102.s\\alarm.alrm_inv_overF_protect.1": "预警",
  "51102.s\\alarm.alrm_inv_lowF_protect.0": "正常",
  "51102.s\\alarm.alrm_inv_lowF_protect.1": "预警",
  "51102.s\\alarm.alrm_lock_phase_failure.0": "正常",
  "51102.s\\alarm.alrm_lock_phase_failure.1": "预警",
  "51102.s\\alarm.alrm_level2_lock_phase_failure.0": "正常",
  "51102.s\\alarm.alrm_level2_lock_phase_failure.1": "预警",
  "51102.s\\alarm.alrm_T1_tooHigh.0": "正常",
  "51102.s\\alarm.alrm_T1_tooHigh.1": "预警",
  "51102.s\\alarm.alrm_T2_tooHigh.0": "正常",
  "51102.s\\alarm.alrm_T2_tooHigh.1": "预警",
  "51102.s\\alarm.alrm_bypass_lowV.0": "正常",
  "51102.s\\alarm.alrm_bypass_lowV.1": "预警",
  "51102.s\\alarm.alrm_bypass_highV.0": "正常",
  "51102.s\\alarm.alrm_bypass_highV.1": "预警",
  "51102.s\\alarm.alrm_bypass_lowF.0": "正常",
  "51102.s\\alarm.alrm_bypass_lowF.1": "预警",
  "51102.s\\alarm.alrm_bypass_highF.0": "正常",
  "51102.s\\alarm.alrm_bypass_highF.1": "预警",
  "51102.s\\alarm.alrm_chg_lowV.0": "正常",
  "51102.s\\alarm.alrm_chg_lowV.1": "预警",
  "51102.s\\alarm.alrm_chg_highV.0": "正常",
  "51102.s\\alarm.alrm_chg_highV.1": "预警",
  "51102.s\\alarm.alrm_dischg_lowV.0": "正常",
  "51102.s\\alarm.alrm_dischg_lowV.1": "预警",
  "51102.s\\alarm.alrm_dischg_bus_lowV.0": "正常",
  "51102.s\\alarm.alrm_dischg_bus_lowV.1": "预警",
  "51102.s\\alarm.alrm_dischg_batt_highV.0": "正常",
  "51102.s\\alarm.alrm_dischg_batt_highV.1": "预警",
  "51102.s\\alarm.alrm_u1_u2_ver_mismatch.0": "正常",
  "51102.s\\alarm.alrm_u1_u2_ver_mismatch.1": "预警",
  "51102.s\\alarm.alrm_PV1_DC_lowV.0": "正常",
  "51102.s\\alarm.alrm_PV1_DC_lowV.1": "预警",
  "51102.s\\alarm.alrm_PV1_DC_highV.0": "正常",
  "51102.s\\alarm.alrm_PV1_DC_highV.1": "预警",
  "51102.s\\alarm.alrm_PV1_input_lowV.0": "正常",
  "51102.s\\alarm.alrm_PV1_input_lowV.1": "预警",
  "51102.s\\alarm.alrm_PV1_input_highV.0": "正常",
  "51102.s\\alarm.alrm_PV1_input_highV.1": "预警",
  "51102.s\\alarm.alrm_PV2_DC_lowV.0": "正常",
  "51102.s\\alarm.alrm_PV2_DC_lowV.1": "预警",
  "51102.s\\alarm.alrm_PV2_DC_highV.0": "正常",
  "51102.s\\alarm.alrm_PV2_DC_highV.1": "预警",
  "51102.s\\alarm.alrm_PV2_input_lowV.0": "正常",
  "51102.s\\alarm.alrm_PV2_input_lowV.1": "预警",
  "51102.s\\alarm.alrm_PV2_input_highV.0": "正常",
  "51102.s\\alarm.alrm_PV2_input_highV.1": "预警",
  "51102.s\\alarm.alrm_PV3_DC_lowV.0": "正常",
  "51102.s\\alarm.alrm_PV3_DC_lowV.1": "预警",
  "51102.s\\alarm.alrm_PV3_DC_highV.0": "正常",
  "51102.s\\alarm.alrm_PV3_DC_highV.1": "预警",
  "51102.s\\alarm.alrm_PV3_input_lowV.0": "正常",
  "51102.s\\alarm.alrm_PV3_input_lowV.1": "预警",
  "51102.s\\alarm.alrm_PV3_input_highV.0": "正常",
  "51102.s\\alarm.alrm_PV3_input_highV.1": "预警",
  "51102.s\\alarm.alrm_PV4_DC_lowV.0": "正常",
  "51102.s\\alarm.alrm_PV4_DC_lowV.1": "预警",
  "51102.s\\alarm.alrm_PV4_DC_highV.0": "正常",
  "51102.s\\alarm.alrm_PV4_DC_highV.1": "预警",
  "51102.s\\alarm.alrm_PV4_input_lowV.0": "正常",
  "51102.s\\alarm.alrm_PV4_input_lowV.1": "预警",
  "51102.s\\alarm.alrm_PV4_input_highV.0": "正常",
  "51102.s\\alarm.alrm_PV4_input_highV.1": "预警",
  "51102.s\\alarm.alrm_parellet_freq_differ.0": "正常",
  "51102.s\\alarm.alrm_parellet_freq_differ.1": "预警",
  "51102.s\\alarm.alrm_parellet2_avg_I.0": "正常",
  "51102.s\\alarm.alrm_parellet2_avg_I.1": "预警",
  "51102.s\\alarm.alrm_batt_highV.0": "正常",
  "51102.s\\alarm.alrm_batt_highV.1": "预警",
  "51102.s\\alarm.alrm_batt_cell_highV.0": "正常",
  "51102.s\\alarm.alrm_batt_cell_highV.1": "预警",
  "51102.s\\alarm.alrm_batt_lowV.0": "正常",
  "51102.s\\alarm.alrm_batt_lowV.1": "预警",
  "51102.s\\alarm.alrm_batt_cell_lowV.0": "正常",
  "51102.s\\alarm.alrm_batt_cell_lowV.1": "预警",
  "51102.s\\alarm.alrm_cell_slow_check_overI.0": "正常",
  "51102.s\\alarm.alrm_cell_slow_check_overI.1": "预警",
  "51102.s\\alarm.alrm_cell_dischg_slow_check_overI.0": "正常",
  "51102.s\\alarm.alrm_cell_dischg_slow_check_overI.1": "预警",
  "51102.s\\alarm.alrm_cell_chg1_overT.0": "正常",
  "51102.s\\alarm.alrm_cell_chg1_overT.1": "预警",
  "51102.s\\alarm.alrm_cell_chg2_overT.0": "正常",
  "51102.s\\alarm.alrm_cell_chg2_overT.1": "预警",
  "51102.s\\alarm.alrm_cell_chg1_lowT.0": "正常",
  "51102.s\\alarm.alrm_cell_chg1_lowT.1": "预警",
  "51102.s\\alarm.alrm_cell_chg2_lowT.0": "正常",
  "51102.s\\alarm.alrm_cell_chg2_lowT.1": "预警",
  "51102.s\\alarm.alrm_cell_dischg1_overT.0": "正常",
  "51102.s\\alarm.alrm_cell_dischg1_overT.1": "预警",
  "51102.s\\alarm.alrm_cell_dischg2_overT.0": "正常",
  "51102.s\\alarm.alrm_cell_dischg2_overT.1": "预警",
  "51102.s\\alarm.alrm_cell_dischg1_lowT.0": "正常",
  "51102.s\\alarm.alrm_cell_dischg1_lowT.1": "预警",
  "51102.s\\alarm.alrm_cell_dischg2_lowT.0": "正常",
  "51102.s\\alarm.alrm_cell_dischg2_lowT.1": "预警",
  "51102.s\\alarm.alrm_cell_env_overT.0": "正常",
  "51102.s\\alarm.alrm_cell_env_overT.1": "预警",
  "51102.s\\alarm.alrm_cell_env_lowT.0": "正常",
  "51102.s\\alarm.alrm_cell_env_lowT.1": "预警",
  "51102.s\\alarm.alrm_cell_mos_overT.0": "正常",
  "51102.s\\alarm.alrm_cell_mos_overT.1": "预警",
  "51102.s\\alarm.alrm_cell_diffT_large.0": "正常",
  "51102.s\\alarm.alrm_cell_diffT_large.1": "预警",
  "51102.s\\alarm.alrm_eps_lowV.0": "正常",
  "51102.s\\alarm.alrm_eps_lowV.1": "预警",
  "51102.s\\alarm.alrm_eps_highV.0": "正常",
  "51102.s\\alarm.alrm_eps_highV.1": "预警",
  "51102.s\\alarm.alrm_eps_lowF.0": "正常",
  "51102.s\\alarm.alrm_eps_lowF.1": "预警",
  "51102.s\\alarm.alrm_eps_highF.0": "正常",
  "51102.s\\alarm.alrm_eps_highF.1": "预警",
  "51102.s\\alarm.alrm_eps_ac_overI.0": "正常",
  "51102.s\\alarm.alrm_eps_ac_overI.1": "预警",
  "51102.s\\warn.warn_grid_v_low.0": "正常",
  "51102.s\\warn.warn_grid_v_low.1": "告警",
  "51102.s\\warn.warn_grid_v_high.0": "正常",
  "51102.s\\warn.warn_grid_v_high.1": "告警",
  "51102.s\\warn.warn_grid_f_low.0": "正常",
  "51102.s\\warn.warn_grid_f_low.1": "告警",
  "51102.s\\warn.warn_grid_f_high.0": "正常",
  "51102.s\\warn.warn_grid_f_high.1": "告警",
  "51102.s\\warn.warn_grid_I_over.0": "正常",
  "51102.s\\warn.warn_grid_I_over.1": "告警",
  "51102.s\\warn.warn_PFC_bus_v_low.0": "正常",
  "51102.s\\warn.warn_PFC_bus_v_low.1": "告警",
  "51102.s\\warn.warn_U1_bus_v_low.0": "正常",
  "51102.s\\warn.warn_U1_bus_v_low.1": "告警",
  "51102.s\\warn.warn_U1_bus_v_high.0": "正常",
  "51102.s\\warn.warn_U1_bus_v_high.1": "告警",
  "51102.s\\warn.warn_U2_bus_v_low.0": "正常",
  "51102.s\\warn.warn_U2_bus_v_low.1": "告警",
  "51102.s\\warn.warn_U2_bus_v_high.0": "正常",
  "51102.s\\warn.warn_U2_bus_v_high.1": "告警",
  "51102.s\\warn.warn_o_inv_overLoad.0": "正常",
  "51102.s\\warn.warn_o_inv_overLoad.1": "告警",
  "51102.s\\warn.warn_o_byp_overLoad.0": "正常",
  "51102.s\\warn.warn_o_byp_overLoad.1": "告警",
  "51102.s\\warn.warn_PFC_inv_v.0": "正常",
  "51102.s\\warn.warn_PFC_inv_v.1": "告警",
  "51102.s\\warn.warn_PFC_inv_o_over_v.0": "正常",
  "51102.s\\warn.warn_PFC_inv_o_over_v.1": "告警",
  "51102.s\\warn.warn_PFC_inv_o_low_v.0": "正常",
  "51102.s\\warn.warn_PFC_inv_o_low_v.1": "告警",
  "51102.s\\warn.warn_PFC_inv_o_over_f.0": "正常",
  "51102.s\\warn.warn_PFC_inv_o_over_f.1": "告警",
  "51102.s\\warn.warn_PFC_inv_o_low_f.0": "正常",
  "51102.s\\warn.warn_PFC_inv_o_low_f.1": "告警",
  "51102.s\\warn.warn_PLL_grid_pll.0": "正常",
  "51102.s\\warn.warn_PLL_grid_pll.1": "告警",
  "51102.s\\warn.warn_PLL_parellet_pll.0": "正常",
  "51102.s\\warn.warn_PLL_parellet_pll.1": "告警",
  "51102.s\\warn.warn_T1_overT.0": "正常",
  "51102.s\\warn.warn_T1_overT.1": "告警",
  "51102.s\\warn.warn_T2_overT.0": "正常",
  "51102.s\\warn.warn_T2_overT.1": "告警",
  "51102.s\\warn.warn_byp_overT.0": "正常",
  "51102.s\\warn.warn_byp_overT.1": "告警",
  "51102.s\\warn.warn_chg_lowV.0": "正常",
  "51102.s\\warn.warn_chg_lowV.1": "告警",
  "51102.s\\warn.warn_chg_highV.0": "正常",
  "51102.s\\warn.warn_chg_highV.1": "告警",
  "51102.s\\warn.warn_dischg_battV.0": "正常",
  "51102.s\\warn.warn_dischg_battV.1": "告警",
  "51102.s\\warn.warn_dischg_busV.0": "正常",
  "51102.s\\warn.warn_dischg_busV.1": "告警",
  "51102.s\\warn.warn_dischg_battOverV.0": "正常",
  "51102.s\\warn.warn_dischg_battOverV.1": "告警",
  "51102.s\\warn.warn_PV1_dc_lowV.0": "正常",
  "51102.s\\warn.warn_PV1_dc_lowV.1": "告警",
  "51102.s\\warn.warn_PV1_dc_highV.0": "正常",
  "51102.s\\warn.warn_PV1_dc_highV.1": "告警",
  "51102.s\\warn.warn_PV1_pv_input_lowV.0": "正常",
  "51102.s\\warn.warn_PV1_pv_input_lowV.1": "告警",
  "51102.s\\warn.warn_PV1_pv_input_overV.0": "正常",
  "51102.s\\warn.warn_PV1_pv_input_overV.1": "告警",
  "51102.s\\warn.warn_PV2_dc_lowV.0": "正常",
  "51102.s\\warn.warn_PV2_dc_lowV.1": "告警",
  "51102.s\\warn.warn_PV2_dc_highV.0": "正常",
  "51102.s\\warn.warn_PV2_dc_highV.1": "告警",
  "51102.s\\warn.warn_PV2_pv_input_lowV.0": "正常",
  "51102.s\\warn.warn_PV2_pv_input_lowV.1": "告警",
  "51102.s\\warn.warn_PV2_pv_input_overV.0": "正常",
  "51102.s\\warn.warn_PV2_pv_input_overV.1": "告警",
  "51102.s\\warn.warn_PV3_dc_lowV.0": "正常",
  "51102.s\\warn.warn_PV3_dc_lowV.1": "告警",
  "51102.s\\warn.warn_PV3_dc_highV.0": "正常",
  "51102.s\\warn.warn_PV3_dc_highV.1": "告警",
  "51102.s\\warn.warn_PV3_pv_input_lowV.0": "正常",
  "51102.s\\warn.warn_PV3_pv_input_lowV.1": "告警",
  "51102.s\\warn.warn_PV3_pv_input_overV.0": "正常",
  "51102.s\\warn.warn_PV3_pv_input_overV.1": "告警",
  "51102.s\\warn.warn_PV4_dc_lowV.0": "正常",
  "51102.s\\warn.warn_PV4_dc_lowV.1": "告警",
  "51102.s\\warn.warn_PV4_dc_highV.0": "正常",
  "51102.s\\warn.warn_PV4_dc_highV.1": "告警",
  "51102.s\\warn.warn_PV4_pv_input_lowV.0": "正常",
  "51102.s\\warn.warn_PV4_pv_input_lowV.1": "告警",
  "51102.s\\warn.warn_PV4_pv_input_overV.0": "正常",
  "51102.s\\warn.warn_PV4_pv_input_overV.1": "告警",
  "51102.s\\warn.warn_prllt1_f_mismatch.0": "正常",
  "51102.s\\warn.warn_prllt1_f_mismatch.1": "告警",
  "51102.s\\warn.warn_prllt2_avg_I.0": "正常",
  "51102.s\\warn.warn_prllt2_avg_I.1": "告警",
  "51102.s\\warn.warn_cell1_grp_avgV_high.0": "正常",
  "51102.s\\warn.warn_cell1_grp_avgV_high.1": "告警",
  "51102.s\\warn.warn_cell1_overV.0": "正常",
  "51102.s\\warn.warn_cell1_overV.1": "告警",
  "51102.s\\warn.warn_cell1_grp_avgV_low.0": "正常",
  "51102.s\\warn.warn_cell1_grp_avgV_low.1": "告警",
  "51102.s\\warn.warn_cell1_lowV.0": "正常",
  "51102.s\\warn.warn_cell1_lowV.1": "告警",
  "51102.s\\warn.warn_cell2_chgOverISlowChck.0": "正常",
  "51102.s\\warn.warn_cell2_chgOverISlowChck.1": "告警",
  "51102.s\\warn.warn_cell2_dischgOverISlowChck.0": "正常",
  "51102.s\\warn.warn_cell2_dischgOverISlowChck.1": "告警",
  "51102.s\\warn.warn_cellT_L1_overT_chg.0": "正常",
  "51102.s\\warn.warn_cellT_L1_overT_chg.1": "告警",
  "51102.s\\warn.warn_cellT_L2_overT_chg.0": "正常",
  "51102.s\\warn.warn_cellT_L2_overT_chg.1": "告警",
  "51102.s\\warn.warn_cellT_L1_lowT_chg.0": "正常",
  "51102.s\\warn.warn_cellT_L1_lowT_chg.1": "告警",
  "51102.s\\warn.warn_cellT_L2_lowT_chg.0": "正常",
  "51102.s\\warn.warn_cellT_L2_lowT_chg.1": "告警",
  "51102.s\\warn.warn_cellT_L1_overT_dischg.0": "正常",
  "51102.s\\warn.warn_cellT_L1_overT_dischg.1": "告警",
  "51102.s\\warn.warn_cellT_L2_overT_dischg.0": "正常",
  "51102.s\\warn.warn_cellT_L2_overT_dischg.1": "告警",
  "51102.s\\warn.warn_cellT_L1_lowT_dischg.0": "正常",
  "51102.s\\warn.warn_cellT_L1_lowT_dischg.1": "告警",
  "51102.s\\warn.warn_cellT_L2_lowT_dischg.0": "正常",
  "51102.s\\warn.warn_cellT_L2_lowT_dischg.1": "告警",
  "51102.s\\warn.warn_cellT_env_overT.0": "正常",
  "51102.s\\warn.warn_cellT_env_overT.1": "告警",
  "51102.s\\warn.warn_cellT_env_lowT.0": "正常",
  "51102.s\\warn.warn_cellT_env_lowT.1": "告警",
  "51102.s\\warn.warn_cellT_mos_overT.0": "正常",
  "51102.s\\warn.warn_cellT_mos_overT.1": "告警",
  "51102.s\\warn.warn_cellT_diffT_toolarge.0": "正常",
  "51102.s\\warn.warn_cellT_diffT_toolarge.1": "告警",
  "51102.s\\warn.warn_eps_lowV.0": "正常",
  "51102.s\\warn.warn_eps_lowV.1": "告警",
  "51102.s\\warn.warn_eps_highV.0": "正常",
  "51102.s\\warn.warn_eps_highV.1": "告警",
  "51102.s\\warn.warn_eps_lowF.0": "正常",
  "51102.s\\warn.warn_eps_lowF.1": "告警",
  "51102.s\\warn.warn_eps_highF.0": "正常",
  "51102.s\\warn.warn_eps_highF.1": "告警",
  "51102.s\\warn.warn_eps_i_overI.0": "正常",
  "51102.s\\warn.warn_eps_i_overI.1": "告警",
  "51102.s\\fault.fault_grid_summary.0": "正常",
  "51102.s\\fault.fault_grid_summary.1": "故障",
  "51102.s\\fault.fault_grid_Vabnormal.0": "正常",
  "51102.s\\fault.fault_grid_Vabnormal.1": "故障",
  "51102.s\\fault.fault_grid_Fabnormal.0": "正常",
  "51102.s\\fault.fault_grid_Fabnormal.1": "故障",
  "51102.s\\fault.fault_grid_lowV.0": "正常",
  "51102.s\\fault.fault_grid_lowV.1": "故障",
  "51102.s\\fault.fault_grid_highV.0": "正常",
  "51102.s\\fault.fault_grid_highV.1": "故障",
  "51102.s\\fault.fault_grid_lowF.0": "正常",
  "51102.s\\fault.fault_grid_lowF.1": "故障",
  "51102.s\\fault.fault_grid_highF.0": "正常",
  "51102.s\\fault.fault_grid_highF.1": "故障",
  "51102.s\\fault.fault_grid_gridLost.0": "正常",
  "51102.s\\fault.fault_grid_gridLost.1": "故障",
  "51102.s\\fault.fault_grid_gridSurge.0": "正常",
  "51102.s\\fault.fault_grid_gridSurge.1": "故障",
  "51102.s\\fault.fault_grid_relayOpen.0": "正常",
  "51102.s\\fault.fault_grid_relayOpen.1": "故障",
  "51102.s\\fault.fault_grid_ac_i_overI.0": "正常",
  "51102.s\\fault.fault_grid_ac_i_overI.1": "故障",
  "51102.s\\fault.fault_PFC_summary.0": "正常",
  "51102.s\\fault.fault_PFC_summary.1": "故障",
  "51102.s\\fault.fault_PFC_hardSoftStrtup.0": "正常",
  "51102.s\\fault.fault_PFC_hardSoftStrtup.1": "故障",
  "51102.s\\fault.fault_PFC_softSoftStrtup.0": "正常",
  "51102.s\\fault.fault_PFC_softSoftStrtup.1": "故障",
  "51102.s\\fault.fault_PFC_bus_lowV.0": "正常",
  "51102.s\\fault.fault_PFC_bus_lowV.1": "故障",
  "51102.s\\fault.fault_PFC_intr_comm_lost.0": "正常",
  "51102.s\\fault.fault_PFC_intr_comm_lost.1": "故障",
  "51102.s\\fault.fault_PFC_extrnl_comm_lost.0": "正常",
  "51102.s\\fault.fault_PFC_extrnl_comm_lost.1": "故障",
  "51102.s\\fault.fault_U1bus_summary.0": "正常",
  "51102.s\\fault.fault_U1bus_summary.1": "故障",
  "51102.s\\fault.fault_U1bus_lowV_abnormal.0": "正常",
  "51102.s\\fault.fault_U1bus_lowV_abnormal.1": "故障",
  "51102.s\\fault.fault_U1bus_highV_abnormal.0": "正常",
  "51102.s\\fault.fault_U1bus_highV_abnormal.1": "故障",
  "51102.s\\fault.fault_U1bus_tooLowV.0": "正常",
  "51102.s\\fault.fault_U1bus_tooLowV.1": "故障",
  "51102.s\\fault.fault_U1bus_tooHighV.0": "正常",
  "51102.s\\fault.fault_U1bus_tooHighV.1": "故障",
  "51102.s\\fault.fault_U1bus_VtooHighFastChck.0": "正常",
  "51102.s\\fault.fault_U1bus_VtooHighFastChck.1": "故障",
  "51102.s\\fault.fault_U2bus_summary.0": "正常",
  "51102.s\\fault.fault_U2bus_summary.1": "故障",
  "51102.s\\fault.fault_U2bus_lowV_abnormal.0": "正常",
  "51102.s\\fault.fault_U2bus_lowV_abnormal.1": "故障",
  "51102.s\\fault.fault_U2bus_highV_abnormal.0": "正常",
  "51102.s\\fault.fault_U2bus_highV_abnormal.1": "故障",
  "51102.s\\fault.fault_U2bus_tooLowV.0": "正常",
  "51102.s\\fault.fault_U2bus_tooLowV.1": "故障",
  "51102.s\\fault.fault_U2bus_tooHighV.0": "正常",
  "51102.s\\fault.fault_U2bus_tooHighV.1": "故障",
  "51102.s\\fault.fault_U2bus_VtooHighFastChck.0": "正常",
  "51102.s\\fault.fault_U2bus_VtooHighFastChck.1": "故障",
  "51102.s\\fault.fault_U2bus_PNbusUnbalance.0": "正常",
  "51102.s\\fault.fault_U2bus_PNbusUnbalance.1": "故障",
  "51102.s\\fault.fault_U2bus_busAvgVlargeV.0": "正常",
  "51102.s\\fault.fault_U2bus_busAvgVlargeV.1": "故障",
  "51102.s\\fault.fault_U2bus_busAvgVlargeI.0": "正常",
  "51102.s\\fault.fault_U2bus_busAvgVlargeI.1": "故障",
  "51102.s\\fault.fault_U2bus_busAvgVlargeIFastChck.0": "正常",
  "51102.s\\fault.fault_U2bus_busAvgVlargeIFastChck.1": "故障",
  "51102.s\\fault.fault_o_summary.0": "正常",
  "51102.s\\fault.fault_o_summary.1": "故障",
  "51102.s\\fault.fault_o_invRalayOpen.0": "正常",
  "51102.s\\fault.fault_o_invRalayOpen.1": "故障",
  "51102.s\\fault.fault_o_invOverLoad.0": "正常",
  "51102.s\\fault.fault_o_invOverLoad.1": "故障",
  "51102.s\\fault.fault_o_bypOverLoad.0": "正常",
  "51102.s\\fault.fault_o_bypOverLoad.1": "故障",
  "51102.s\\fault.fault_inv_summary.0": "正常",
  "51102.s\\fault.fault_inv_summary.1": "故障",
  "51102.s\\fault.fault_inv_invFastChck.0": "正常",
  "51102.s\\fault.fault_inv_invFastChck.1": "故障",
  "51102.s\\fault.fault_inv_invSlowChck.0": "正常",
  "51102.s\\fault.fault_inv_invSlowChck.1": "故障",
  "51102.s\\fault.fault_inv_RelayStuck.0": "正常",
  "51102.s\\fault.fault_inv_RelayStuck.1": "故障",
  "51102.s\\fault.fault_inv_invShortCircuit.0": "正常",
  "51102.s\\fault.fault_inv_invShortCircuit.1": "故障",
  "51102.s\\fault.fault_inv_intrCommErr.0": "正常",
  "51102.s\\fault.fault_inv_intrCommErr.1": "故障",
  "51102.s\\fault.fault_inv_extCommErr.0": "正常",
  "51102.s\\fault.fault_inv_extCommErr.1": "故障",
  "51102.s\\fault.fault_inv_invVabnormal.0": "正常",
  "51102.s\\fault.fault_inv_invVabnormal.1": "故障",
  "51102.s\\fault.fault_inv_outputOverVProtect.0": "正常",
  "51102.s\\fault.fault_inv_outputOverVProtect.1": "故障",
  "51102.s\\fault.fault_inv_outputLowVProtect.0": "正常",
  "51102.s\\fault.fault_inv_outputLowVProtect.1": "故障",
  "51102.s\\fault.fault_inv_outputOverFProtect.0": "正常",
  "51102.s\\fault.fault_inv_outputOverFProtect.1": "故障",
  "51102.s\\fault.fault_inv_outputlowFProtect.0": "正常",
  "51102.s\\fault.fault_inv_outputlowFProtect.1": "故障",
  "51102.s\\fault.fault_PLL_summary.0": "正常",
  "51102.s\\fault.fault_PLL_summary.1": "故障",
  "51102.s\\fault.fault_PLL_acMainPll.0": "正常",
  "51102.s\\fault.fault_PLL_acMainPll.1": "故障",
  "51102.s\\fault.fault_PLL_secondaryPllLocked.0": "正常",
  "51102.s\\fault.fault_PLL_secondaryPllLocked.1": "故障",
  "51102.s\\fault.fault_T_summary.0": "正常",
  "51102.s\\fault.fault_T_summary.1": "故障",
  "51102.s\\fault.fault_T_TtooHigh.0": "正常",
  "51102.s\\fault.fault_T_TtooHigh.1": "故障",
  "51102.s\\fault.fault_T_TmpPinDisconn.0": "正常",
  "51102.s\\fault.fault_T_TmpPinDisconn.1": "故障",
  "51102.s\\fault.fault_T2_summary.0": "正常",
  "51102.s\\fault.fault_T2_summary.1": "故障",
  "51102.s\\fault.fault_T2_TtooHigh.0": "正常",
  "51102.s\\fault.fault_T2_TtooHigh.1": "故障",
  "51102.s\\fault.fault_T2_TmpPinDisconn.0": "正常",
  "51102.s\\fault.fault_T2_TmpPinDisconn.1": "故障",
  "51102.s\\fault.fault_byp_summary.0": "正常",
  "51102.s\\fault.fault_byp_summary.1": "故障",
  "51102.s\\fault.fault_byp_Vabnormal.0": "正常",
  "51102.s\\fault.fault_byp_Vabnormal.1": "故障",
  "51102.s\\fault.fault_byp_Fabnormal.0": "正常",
  "51102.s\\fault.fault_byp_Fabnormal.1": "故障",
  "51102.s\\fault.fault_byp_VtooLow.0": "正常",
  "51102.s\\fault.fault_byp_VtooLow.1": "故障",
  "51102.s\\fault.fault_byp_VtooHigh.0": "正常",
  "51102.s\\fault.fault_byp_VtooHigh.1": "故障",
  "51102.s\\fault.fault_byp_FtooLow.0": "正常",
  "51102.s\\fault.fault_byp_FtooLow.1": "故障",
  "51102.s\\fault.fault_byp_FtooHigh.0": "正常",
  "51102.s\\fault.fault_byp_FtooHigh.1": "故障",
  "51102.s\\fault.fault_byp_bypShtdwn.0": "正常",
  "51102.s\\fault.fault_byp_bypShtdwn.1": "故障",
  "51102.s\\fault.fault_byp_bypInrush.0": "正常",
  "51102.s\\fault.fault_byp_bypInrush.1": "故障",
  "51102.s\\fault.fault_byp_intrCommErr.0": "正常",
  "51102.s\\fault.fault_byp_intrCommErr.1": "故障",
  "51102.s\\fault.fault_byp_extCommErr.0": "正常",
  "51102.s\\fault.fault_byp_extCommErr.1": "故障",
  "51102.s\\fault.fault_chg_summary.0": "正常",
  "51102.s\\fault.fault_chg_summary.1": "故障",
  "51102.s\\fault.fault_chg_lowV.0": "正常",
  "51102.s\\fault.fault_chg_lowV.1": "故障",
  "51102.s\\fault.fault_chg_HighV.0": "正常",
  "51102.s\\fault.fault_chg_HighV.1": "故障",
  "51102.s\\fault.fault_chg_OutputShortCircuit.0": "正常",
  "51102.s\\fault.fault_chg_OutputShortCircuit.1": "故障",
  "51102.s\\fault.fault_chg_softStrpup.0": "正常",
  "51102.s\\fault.fault_chg_softStrpup.1": "故障",
  "51102.s\\fault.fault_chg_busVAbnormal.0": "正常",
  "51102.s\\fault.fault_chg_busVAbnormal.1": "故障",
  "51102.s\\fault.fault_chg_oVTooLowFastChck.0": "正常",
  "51102.s\\fault.fault_chg_oVTooLowFastChck.1": "故障",
  "51102.s\\fault.fault_chg_oVTooHigh.0": "正常",
  "51102.s\\fault.fault_chg_oVTooHigh.1": "故障",
  "51102.s\\fault.fault_chg_oVTooHighFastChck.0": "正常",
  "51102.s\\fault.fault_chg_oVTooHighFastChck.1": "故障",
  "51102.s\\fault.fault_chg_acChgUnenough.0": "正常",
  "51102.s\\fault.fault_chg_acChgUnenough.1": "故障",
  "51102.s\\fault.fault_chg_intrCommErr.0": "正常",
  "51102.s\\fault.fault_chg_intrCommErr.1": "故障",
  "51102.s\\fault.fault_chg_outCommErr.0": "正常",
  "51102.s\\fault.fault_chg_outCommErr.1": "故障",
  "51102.s\\fault.fault_chg_extCommErr.0": "正常",
  "51102.s\\fault.fault_chg_extCommErr.1": "故障",
  "51102.s\\fault.fault_chg_bypSundenlyAddLoad.0": "正常",
  "51102.s\\fault.fault_chg_bypSundenlyAddLoad.1": "故障",
  "51102.s\\fault.fault_dischg_summary.0": "正常",
  "51102.s\\fault.fault_dischg_summary.1": "故障",
  "51102.s\\fault.fault_dischg_battLowV.0": "正常",
  "51102.s\\fault.fault_dischg_battLowV.1": "故障",
  "51102.s\\fault.fault_dischg_busLowV.0": "正常",
  "51102.s\\fault.fault_dischg_busLowV.1": "故障",
  "51102.s\\fault.fault_dischg_battHighV.0": "正常",
  "51102.s\\fault.fault_dischg_battHighV.1": "故障",
  "51102.s\\fault.fault_dischg_battTooHighV.0": "正常",
  "51102.s\\fault.fault_dischg_battTooHighV.1": "故障",
  "51102.s\\fault.fault_dischg_intrCommLost.0": "正常",
  "51102.s\\fault.fault_dischg_intrCommLost.1": "故障",
  "51102.s\\fault.fault_dischg_extrCommLost.0": "正常",
  "51102.s\\fault.fault_dischg_extrCommLost.1": "故障",
  "51102.s\\fault.fault_dischg_battVtooLow.0": "正常",
  "51102.s\\fault.fault_dischg_battVtooLow.1": "故障",
  "51102.s\\fault.fault_dischg_softStrpup.0": "正常",
  "51102.s\\fault.fault_dischg_softStrpup.1": "故障",
  "51102.s\\fault.fault_sys_dismatch.0": "正常",
  "51102.s\\fault.fault_sys_dismatch.1": "故障",
  "51102.s\\fault.fault_sys_intrCommLost.0": "正常",
  "51102.s\\fault.fault_sys_intrCommLost.1": "故障",
  "51102.s\\fault.fault_sys_extCommLost.0": "正常",
  "51102.s\\fault.fault_sys_extCommLost.1": "故障",
  "51102.s\\fault.fault_PV1_summary.0": "正常",
  "51102.s\\fault.fault_PV1_summary.1": "故障",
  "51102.s\\fault.fault_PV1_DCLowV.0": "正常",
  "51102.s\\fault.fault_PV1_DCLowV.1": "故障",
  "51102.s\\fault.fault_PV1_DCHighV.0": "正常",
  "51102.s\\fault.fault_PV1_DCHighV.1": "故障",
  "51102.s\\fault.fault_PV1_softStrpUp.0": "正常",
  "51102.s\\fault.fault_PV1_softStrpUp.1": "故障",
  "51102.s\\fault.fault_PV1_outpuShrtCircuit.0": "正常",
  "51102.s\\fault.fault_PV1_outpuShrtCircuit.1": "故障",
  "51102.s\\fault.fault_PV1_outpuShrtCircuitStrtup.0": "正常",
  "51102.s\\fault.fault_PV1_outpuShrtCircuitStrtup.1": "故障",
  "51102.s\\fault.fault_PV1_DCVTooHigh.0": "正常",
  "51102.s\\fault.fault_PV1_DCVTooHigh.1": "故障",
  "51102.s\\fault.fault_PV1_DCVTooHighFstChck.0": "正常",
  "51102.s\\fault.fault_PV1_DCVTooHighFstChck.1": "故障",
  "51102.s\\fault.fault_PV1_Vabnormal.0": "正常",
  "51102.s\\fault.fault_PV1_Vabnormal.1": "故障",
  "51102.s\\fault.fault_PV1_inCommLost.0": "正常",
  "51102.s\\fault.fault_PV1_inCommLost.1": "故障",
  "51102.s\\fault.fault_PV1_extCommLost.0": "正常",
  "51102.s\\fault.fault_PV1_extCommLost.1": "故障",
  "51102.s\\fault.fault_PV1_inputLowV.0": "正常",
  "51102.s\\fault.fault_PV1_inputLowV.1": "故障",
  "51102.s\\fault.fault_PV1_inputHighV.0": "正常",
  "51102.s\\fault.fault_PV1_inputHighV.1": "故障",
  "51102.s\\fault.fault_PV2_summary.0": "正常",
  "51102.s\\fault.fault_PV2_summary.1": "故障",
  "51102.s\\fault.fault_PV2_DCLowV.0": "正常",
  "51102.s\\fault.fault_PV2_DCLowV.1": "故障",
  "51102.s\\fault.fault_PV2_DCHighV.0": "正常",
  "51102.s\\fault.fault_PV2_DCHighV.1": "故障",
  "51102.s\\fault.fault_PV2_softStrpUp.0": "正常",
  "51102.s\\fault.fault_PV2_softStrpUp.1": "故障",
  "51102.s\\fault.fault_PV2_outpuShrtCircuit.0": "正常",
  "51102.s\\fault.fault_PV2_outpuShrtCircuit.1": "故障",
  "51102.s\\fault.fault_PV2_outpuShrtCircuitStrtup.0": "正常",
  "51102.s\\fault.fault_PV2_outpuShrtCircuitStrtup.1": "故障",
  "51102.s\\fault.fault_PV2_DCVTooHigh.0": "正常",
  "51102.s\\fault.fault_PV2_DCVTooHigh.1": "故障",
  "51102.s\\fault.fault_PV2_DCVTooHighFstChck.0": "正常",
  "51102.s\\fault.fault_PV2_DCVTooHighFstChck.1": "故障",
  "51102.s\\fault.fault_PV2_Vabnormal.0": "正常",
  "51102.s\\fault.fault_PV2_Vabnormal.1": "故障",
  "51102.s\\fault.fault_PV2_inCommLost.0": "正常",
  "51102.s\\fault.fault_PV2_inCommLost.1": "故障",
  "51102.s\\fault.fault_PV2_extCommLost.0": "正常",
  "51102.s\\fault.fault_PV2_extCommLost.1": "故障",
  "51102.s\\fault.fault_PV2_inputLowV.0": "正常",
  "51102.s\\fault.fault_PV2_inputLowV.1": "故障",
  "51102.s\\fault.fault_PV2_inputHighV.0": "正常",
  "51102.s\\fault.fault_PV2_inputHighV.1": "故障",
  "51102.s\\fault.fault_PV3_summary.0": "正常",
  "51102.s\\fault.fault_PV3_summary.1": "故障",
  "51102.s\\fault.fault_PV3_DCLowV.0": "正常",
  "51102.s\\fault.fault_PV3_DCLowV.1": "故障",
  "51102.s\\fault.fault_PV3_DCHighV.0": "正常",
  "51102.s\\fault.fault_PV3_DCHighV.1": "故障",
  "51102.s\\fault.fault_PV3_softStrpUp.0": "正常",
  "51102.s\\fault.fault_PV3_softStrpUp.1": "故障",
  "51102.s\\fault.fault_PV3_outpuShrtCircuit.0": "正常",
  "51102.s\\fault.fault_PV3_outpuShrtCircuit.1": "故障",
  "51102.s\\fault.fault_PV3_outpuShrtCircuitStrtup.0": "正常",
  "51102.s\\fault.fault_PV3_outpuShrtCircuitStrtup.1": "故障",
  "51102.s\\fault.fault_PV3_DCVTooHigh.0": "正常",
  "51102.s\\fault.fault_PV3_DCVTooHigh.1": "故障",
  "51102.s\\fault.fault_PV3_DCVTooHighFstChck.0": "正常",
  "51102.s\\fault.fault_PV3_DCVTooHighFstChck.1": "故障",
  "51102.s\\fault.fault_PV3_Vabnormal.0": "正常",
  "51102.s\\fault.fault_PV3_Vabnormal.1": "故障",
  "51102.s\\fault.fault_PV3_inCommLost.0": "正常",
  "51102.s\\fault.fault_PV3_inCommLost.1": "故障",
  "51102.s\\fault.fault_PV3_extCommLost.0": "正常",
  "51102.s\\fault.fault_PV3_extCommLost.1": "故障",
  "51102.s\\fault.fault_PV3_inputLowV.0": "正常",
  "51102.s\\fault.fault_PV3_inputLowV.1": "故障",
  "51102.s\\fault.fault_PV3_inputHighV.0": "正常",
  "51102.s\\fault.fault_PV3_inputHighV.1": "故障",
  "51102.s\\fault.fault_PV4_summary.0": "正常",
  "51102.s\\fault.fault_PV4_summary.1": "故障",
  "51102.s\\fault.fault_PV4_DCLowV.0": "正常",
  "51102.s\\fault.fault_PV4_DCLowV.1": "故障",
  "51102.s\\fault.fault_PV4_DCHighV.0": "正常",
  "51102.s\\fault.fault_PV4_DCHighV.1": "故障",
  "51102.s\\fault.fault_PV4_softStrpUp.0": "正常",
  "51102.s\\fault.fault_PV4_softStrpUp.1": "故障",
  "51102.s\\fault.fault_PV4_outpuShrtCircuit.0": "正常",
  "51102.s\\fault.fault_PV4_outpuShrtCircuit.1": "故障",
  "51102.s\\fault.fault_PV4_outpuShrtCircuitStrtup.0": "正常",
  "51102.s\\fault.fault_PV4_outpuShrtCircuitStrtup.1": "故障",
  "51102.s\\fault.fault_PV4_DCVTooHigh.0": "正常",
  "51102.s\\fault.fault_PV4_DCVTooHigh.1": "故障",
  "51102.s\\fault.fault_PV4_DCVTooHighFstChck.0": "正常",
  "51102.s\\fault.fault_PV4_DCVTooHighFstChck.1": "故障",
  "51102.s\\fault.fault_PV4_Vabnormal.0": "正常",
  "51102.s\\fault.fault_PV4_Vabnormal.1": "故障",
  "51102.s\\fault.fault_PV4_inCommLost.0": "正常",
  "51102.s\\fault.fault_PV4_inCommLost.1": "故障",
  "51102.s\\fault.fault_PV4_extCommLost.0": "正常",
  "51102.s\\fault.fault_PV4_extCommLost.1": "故障",
  "51102.s\\fault.fault_PV4_inputLowV.0": "正常",
  "51102.s\\fault.fault_PV4_inputLowV.1": "故障",
  "51102.s\\fault.fault_PV4_inputHighV.0": "正常",
  "51102.s\\fault.fault_PV4_inputHighV.1": "故障",
  "51102.s\\fault.fault_prllt_summary.0": "正常",
  "51102.s\\fault.fault_prllt_summary.1": "故障",
  "51102.s\\fault.fault_prllt_idConflict.0": "正常",
  "51102.s\\fault.fault_prllt_idConflict.1": "故障",
  "51102.s\\fault.fault_prllt_commErr.0": "正常",
  "51102.s\\fault.fault_prllt_commErr.1": "故障",
  "51102.s\\fault.fault_prllt_Fdismatch.0": "正常",
  "51102.s\\fault.fault_prllt_Fdismatch.1": "故障",
  "51102.s\\fault.fault_prllt_failure.0": "正常",
  "51102.s\\fault.fault_prllt_failure.1": "故障",
  "51102.s\\fault.fault_prllt2_summary.0": "正常",
  "51102.s\\fault.fault_prllt2_summary.1": "故障",
  "51102.s\\fault.fault_prllt2_avgI.0": "正常",
  "51102.s\\fault.fault_prllt2_avgI.1": "故障",
  "51102.s\\fault.fault_prllt2_FsyncSig.0": "正常",
  "51102.s\\fault.fault_prllt2_FsyncSig.1": "故障",
  "51102.s\\fault.fault_cell1_avgVHighProtect.0": "正常",
  "51102.s\\fault.fault_cell1_avgVHighProtect.1": "故障",
  "51102.s\\fault.fault_cell1_HighVProtect.0": "正常",
  "51102.s\\fault.fault_cell1_HighVProtect.1": "故障",
  "51102.s\\fault.fault_cell1_avgVlowProtect.0": "正常",
  "51102.s\\fault.fault_cell1_avgVlowProtect.1": "故障",
  "51102.s\\fault.fault_cell1_lowVProtect.0": "正常",
  "51102.s\\fault.fault_cell1_lowVProtect.1": "故障",
  "51102.s\\fault.fault_cell1_cellCntDismatch.0": "正常",
  "51102.s\\fault.fault_cell1_cellCntDismatch.1": "故障",
  "51102.s\\fault.fault_cell1_cellUnavail.0": "正常",
  "51102.s\\fault.fault_cell1_cellUnavail.1": "故障",
  "51102.s\\fault.fault_cell1_cellGrpDiffVtooLarge.0": "正常",
  "51102.s\\fault.fault_cell1_cellGrpDiffVtooLarge.1": "故障",
  "51102.s\\fault.fault_cell1_seriousHighVProtect.0": "正常",
  "51102.s\\fault.fault_cell1_seriousHighVProtect.1": "故障",
  "51102.s\\fault.fault_cell1_seriousLowVProtect.0": "正常",
  "51102.s\\fault.fault_cell1_seriousLowVProtect.1": "故障",
  "51102.s\\fault.fault_cell1_srsLowVPrtctShtdwn.0": "正常",
  "51102.s\\fault.fault_cell1_srsLowVPrtctShtdwn.1": "故障",
  "51102.s\\fault.fault_cell1_l1ChgStatus.0": "正常",
  "51102.s\\fault.fault_cell1_l1ChgStatus.1": "故障",
  "51102.s\\fault.fault_cell1_l2ChgStatus.0": "正常",
  "51102.s\\fault.fault_cell1_l2ChgStatus.1": "故障",
  "51102.s\\fault.fault_cell1_tooOverVProtect.0": "正常",
  "51102.s\\fault.fault_cell1_tooOverVProtect.1": "故障",
  "51102.s\\fault.fault_cell2_chgOverISlwChck.0": "正常",
  "51102.s\\fault.fault_cell2_chgOverISlwChck.1": "故障",
  "51102.s\\fault.fault_cell2_chgOverIFstChck.0": "正常",
  "51102.s\\fault.fault_cell2_chgOverIFstChck.1": "故障",
  "51102.s\\fault.fault_cell2_dischgOverISlwChck.0": "正常",
  "51102.s\\fault.fault_cell2_dischgOverISlwChck.1": "故障",
  "51102.s\\fault.fault_cell2_dischgOverIFstChck.0": "正常",
  "51102.s\\fault.fault_cell2_dischgOverIFstChck.1": "故障",
  "51102.s\\fault.fault_cell2_chgOverI.0": "正常",
  "51102.s\\fault.fault_cell2_chgOverI.1": "故障",
  "51102.s\\fault.fault_cell2_dischgOverI.0": "正常",
  "51102.s\\fault.fault_cell2_dischgOverI.1": "故障",
  "51102.s\\fault.fault_cellT_TmpSensorDisconn.0": "正常",
  "51102.s\\fault.fault_cellT_TmpSensorDisconn.1": "故障",
  "51102.s\\fault.fault_cellT_l1OverTChg.0": "正常",
  "51102.s\\fault.fault_cellT_l1OverTChg.1": "故障",
  "51102.s\\fault.fault_cellT_l2OverTChg.0": "正常",
  "51102.s\\fault.fault_cellT_l2OverTChg.1": "故障",
  "51102.s\\fault.fault_cellT_l1lowTChg.0": "正常",
  "51102.s\\fault.fault_cellT_l1lowTChg.1": "故障",
  "51102.s\\fault.fault_cellT_l2lowTChg.0": "正常",
  "51102.s\\fault.fault_cellT_l2lowTChg.1": "故障",
  "51102.s\\fault.fault_cellT_l1OverTdisChg.0": "正常",
  "51102.s\\fault.fault_cellT_l1OverTdisChg.1": "故障",
  "51102.s\\fault.fault_cellT_l2OverTdisChg.0": "正常",
  "51102.s\\fault.fault_cellT_l2OverTdisChg.1": "故障",
  "51102.s\\fault.fault_cellT_l1lowTdisChg.0": "正常",
  "51102.s\\fault.fault_cellT_l1lowTdisChg.1": "故障",
  "51102.s\\fault.fault_cellT_l2lowTdisChg.0": "正常",
  "51102.s\\fault.fault_cellT_l2lowTdisChg.1": "故障",
  "51102.s\\fault.fault_cellT_envOverT.0": "正常",
  "51102.s\\fault.fault_cellT_envOverT.1": "故障",
  "51102.s\\fault.fault_cellT_envlowT.0": "正常",
  "51102.s\\fault.fault_cellT_envlowT.1": "故障",
  "51102.s\\fault.fault_cellT_mosOverT.0": "正常",
  "51102.s\\fault.fault_cellT_mosOverT.1": "故障",
  "51102.s\\fault.fault_cellT_diffTtooHigh.0": "正常",
  "51102.s\\fault.fault_cellT_diffTtooHigh.1": "故障",
  "51102.s\\fault.fault_cellT_highVsideMosDisconn.0": "正常",
  "51102.s\\fault.fault_cellT_highVsideMosDisconn.1": "故障",
  "51102.s\\fault.fault_eps_summary.0": "正常",
  "51102.s\\fault.fault_eps_summary.1": "故障",
  "51102.s\\fault.fault_eps_Vabnormal.0": "正常",
  "51102.s\\fault.fault_eps_Vabnormal.1": "故障",
  "51102.s\\fault.fault_eps_Fabnormal.0": "正常",
  "51102.s\\fault.fault_eps_Fabnormal.1": "故障",
  "51102.s\\fault.fault_eps_VtooLow.0": "正常",
  "51102.s\\fault.fault_eps_VtooLow.1": "故障",
  "51102.s\\fault.fault_eps_VLow.0": "正常",
  "51102.s\\fault.fault_eps_VLow.1": "故障",
  "51102.s\\fault.fault_eps_VHigh.0": "正常",
  "51102.s\\fault.fault_eps_VHigh.1": "故障",
  "51102.s\\fault.fault_eps_Flow.0": "正常",
  "51102.s\\fault.fault_eps_Flow.1": "故障",
  "51102.s\\fault.fault_eps_FHigh.0": "正常",
  "51102.s\\fault.fault_eps_FHigh.1": "故障",
  "51102.s\\fault.fault_eps_acMainLost.0": "正常",
  "51102.s\\fault.fault_eps_acMainLost.1": "故障",
  "51102.s\\fault.fault_eps_inpuSurge.0": "正常",
  "51102.s\\fault.fault_eps_inpuSurge.1": "故障",
  "51102.s\\fault.fault_eps_relayOpenCircuit.0": "正常",
  "51102.s\\fault.fault_eps_relayOpenCircuit.1": "故障",
  "51102.s\\fault.fault_eps_inputOverI.0": "正常",
  "51102.s\\fault.fault_eps_inputOverI.1": "故障",
  "51102.s\\elct_meter.elct_meter1_phase_no.0": "单相",
  "51102.s\\elct_meter.elct_meter1_phase_no.1": "A相",
  "51102.s\\elct_meter.elct_meter1_phase_no.2": "B相",
  "51102.s\\elct_meter.elct_meter1_phase_no.3": "C相",
  "51102.s\\elct_meter.elct_meter1_online_status.0": "不在线",
  "51102.s\\elct_meter.elct_meter1_online_status.1": "在线",
  "51102.s\\elct_meter.elct_meter2_phase_no.0": "单相",
  "51102.s\\elct_meter.elct_meter2_phase_no.1": "A相",
  "51102.s\\elct_meter.elct_meter2_phase_no.2": "B相",
  "51102.s\\elct_meter.elct_meter2_phase_no.3": "C相",
  "51102.s\\elct_meter.elct_meter2_online_status.0": "不在线",
  "51102.s\\elct_meter.elct_meter2_online_status.1": "在线",
  "51102.s\\collector": "采集器",
  "51102.s_w\\ctl_BMS": "BMS参数",
  "51102.s_w\\grid_reconn_args": "并网重连参数",
  "51102.s\\elct_meter": "电表数据",
  "51102.s_w\\ctl_islandProtection": "防孤岛保护参数",
  "51102.s_w\\ctl_EMS": "EMS参数",
  "51102.s_w\\volt_ride_through": "电压穿越参数",
  "51102.s_w\\Freq_ride_through": "频率穿越参数",
  "51102.m_w\\ctl_EMS": "EMS参数",
  "51102.s_w\\ctl_reverseFlowProtection": "防逆流保护参数",
  "51102.s_w\\ctl_actpower": "有功功率控制",
  "51102.s\\warn": "告警信息",
  "51102.s\\real_time": "实时数据",
  "51102.s\\fault": "故障信息",
  "51102.s_w\\ctl_inv": "逆变器控制参数",
  "51102.m\\real_time": "实时数据",
  "51102.s_w\\ctl_reactpower": "无功功率控制",
  "51102.s\\alarm": "预警信息",
  "module.selfReport": "自助报表",
  "ice.robot.strategy.type.int.str.sta.rev.pri": "场站收益优先",
  "edit.failed": "编辑失败",
  "50901.real_time.BatteryModel.1": "Haier HV",
  "60001.group_collector.resetDevice.1": "1-重置一次",
  "60001.group_collector.DataloggerRestart.1": "1-重启一次",
  "50901.real_time.copy_controllerarmFirmwareVersion": "逆变器ARM版本",
  "51102.s\\fault.fault_pcs_selfTest": "PCS自检故障",
  "51102.s\\fault.fault_elctMeter_selfTest": "电表自检故障",
  "51102.s\\fault.fault_MOS_selfTest": "MOS自检故障",
  "51102.s\\fault.fault_pcs_selfTest.0": "正常",
  "51102.s\\fault.fault_pcs_selfTest.1": "故障",
  "51102.s\\fault.fault_elctMeter_selfTest.0": "正常",
  "51102.s\\fault.fault_elctMeter_selfTest.1": "故障",
  "51102.s\\fault.fault_MOS_selfTest.0": "正常",
  "51102.s\\fault.fault_MOS_selfTest.1": "故障",
  "tag_test_3": "缓存测试3",
  "plant.create.type.1": "用户端创建",
  "50655.control.otaHttpUrl": "固件升级地址",
  "60421.ctrl_device.CosPhi_P_P_3": "  CosPhi(P)  P  3",
  "60421.ctrl_device.CosPhi_P_P_4": "CosPhi(P)  P  4",
  "60421.real_time.PV5_string_2_KWH": "PV5  串  2  千瓦时",
  "60421.real_time.Grid_R_current": "电网R相电流",
  "60421.real_time.PV3_voltage": "PV3  电压",
  "60421.real_time.E_total": "AC总发电量",
  "60421.ctrl_device.AutoTest_Enable": "自动测试启用",
  "60421.real_time.PV7_string_1_KWH": "PV7  串  1  千瓦时",
  "60421.real_time.Export_energy_from_meter": "电表计量的馈电能量",
  "60421.ctrl_device.Device_type": "设备类型",
  "60421.real_time.PV7_string_2_current": "PV7  串  2  电流",
  "60421.ctrl_device.Over_frequency_response_enable": "过频降载使能",
  "60421.ctrl_device.Under_voltage_protection_value_3": "欠压保护值  3",
  "60421.real_time.Grid_S_voltage": "电网S相电压",
  "60421.ctrl_device.LVRT_Volt_Lower_Percent": "LVRT  电压下限百分比",
  "60421.real_time.PV2_current": "PV2  电流",
  "60421.ctrl_device.LVRT_Volt_recovery_Lower_Percent": "LVRT  电压恢复降低百分比  2",
  "60421.ctrl_device.Grid_faut_recovery_time": "电网故障恢复时间",
  "60421.ctrl_device.Under_Frequency_increase_rate": "欠频加载加载功率斜率",
  "60421.ctrl_device.Start_stop_command": "启动/停止命令",
  "60421.real_time.PV5_current": "PV5  电流",
  "60421.ctrl_device.Reactive_power_control_mode": "无功功率控制模式",
  "60421.real_time.PVkWH": "光伏发电量",
  "60421.ctrl_device.Under_Frequency_s": "欠频",
  "60421.real_time.Grid_Line_Voltage_TR": "电网TR线电压",
  "60421.ctrl_device.Under_voltage_trigger_time_3": "欠压触发时间  3",
  "60421.ctrl_device.Under_Frequency_Fstart": "欠频加载起始频率",
  "60421.ctrl_device.Fixed_cosPhi_phase": "固定  cosPhi  相位",
  "60421.ctrl_device.Fixed_Active_power_value": "固定有功功率值",
  "60421.ctrl_device.Under_frequency_P_referance": "欠频  P  参考",
  "60421.ctrl_device.Under_voltage_trigger_time_1": "欠压触发时间  1",
  "60421.ctrl_device.Q_U_Q_3_phase": "  Q(U)  Q  3相",
  "60421.ctrl_device.Under_voltage_trigger_time_2": "欠压触发时间  2",
  "60421.real_time.PV1_string_1_current": "PV1  串  1  电流",
  "60421.ctrl_device.CosPhi_P_P_1": "  CosPhi(P)  P  1",
  "60421.ctrl_device.CosPhi_P_P_2": "  CosPhi(P)  P  2",
  "60421.ctrl_device.Under_frequency_trigger_time_2": "欠频触发时间  2",
  "60421.ctrl_device.Under_voltage_protection_value": "欠压保护值  1",
  "60421.real_time.PV6_string_2_KWH": "PV6  串  2  千瓦时",
  "60421.ctrl_device.Under_frequency_trigger_time_3": "欠频触发时间  3",
  "60421.ctrl_device.First_connection_frequency_lower_value": "首次连接频率下限",
  "60421.real_time.PV2__voltage": "PV2  电压",
  "60421.ctrl_device.Model_name": "型号名称",
  "60421.real_time.PV4_string_2_KWH": "PV4  串  2  千瓦时",
  "60421.real_time.PV8_voltage": "PV8  电压",
  "60421.real_time.Grid_Line_Voltage_ST": "电网ST线电压",
  "60421.ctrl_device.Over_frequency_trigger_time_3": "过频触发时间  3",
  "60421.ctrl_device.Over_frequency_trigger_time_1": "过频触发时间  1",
  "60421.ctrl_device.Over_frequency_trigger_time_2": "过频触发时间  2",
  "60421.ctrl_device.CosPhi_P_cosPhi_4_phase": "CosPhi(P)  cosPhi  四相",
  "60421.ctrl_device.Fixed_Q_phase": "  固定  Q  相",
  "60421.ctrl_device.Fixed_active_power_response_time": "固定有功功率响应时间",
  "60421.ctrl_device.HVRT_Volt_recovery_Upper_Percent": "HVRT  电压恢复上限百分比  2",
  "60421.ctrl_device.Fixed_active_power": "固定有功功率",
  "60421.ctrl_device.Fault_code": " 故障代码",
  "60421.ctrl_device.Over_frequency_protection_value3": "过频保护值  3",
  "60421.ctrl_device.Under_Frequency_Enable": "欠频加载使能",
  "60421.ctrl_device.Over_frequency_protection_value2": "过频保护值  2",
  "60421.ctrl_device.Over_frequency_protection_value1": "过频保护值  1",
  "60421.ctrl_device.Q_U_Q_4_phase": "  Q(U)  Q  4  相",
  "60421.ctrl_device.Meter_limit_mode": "电表/CT限制功率模式",
  "60421.ctrl_device.No_MPPT": "MPPT数量",
  "60421.real_time.Grid_Line_Voltage_RS": "电网RS线电压",
  "60421.ctrl_device.Lock_Out_Pn": "  锁定  Pn",
  "60421.ctrl_device.Over_frequency_recovery_delay_time": "过频恢复延迟时间",
  "60421.ctrl_device.Over_frequency_s": "过频",
  "60421.ctrl_device.Q_U_Q_response_time": "  Q(U)  Q  响应时间",
  "60421.ctrl_device.Parallelmma": "并联模式Modbus地址",
  "60421.real_time.PV5_voltage": "PV5  电压",
  "60421.ctrl_device.CosPhi_P_cosPhi_3_phase": "  CosPhi(P)  cosPhi  三相",
  "60421.real_time.PV8_string_2_current": "PV8  串  2  电流",
  "60421.real_time.PV1_string_1_KWH": "PV1  串  1  千瓦时",
  "60421.ctrl_device.UpgradeState": "  升级状态",
  "60421.real_time.PV1__current": "PV1  电流",
  "60421.ctrl_device.Manufacturer_name": "  制造商名称",
  "60421.ctrl_device.Over_frequency_response_Fback": "过频降载恢复频率",
  "60421.ctrl_device.ModbusAddress": " Modbus地址",
  "60421.real_time.PV5_string_1_KWH": "PV5  串  1  千瓦时",
  "60421.real_time.Meter_Power_S": "电表计量S相功率",
  "60421.real_time.Meter_Power_R": "电表计量R相功率",
  "60421.ctrl_device.Startup_loading_slope": "加载斜率",
  "60421.ctrl_device.First_connection_voltage_lower_value": "首次连接电压下限",
  "60421.ctrl_device.Over_voltage_recovery_value": "过压恢复值",
  "60421.real_time.Meter_Power_T": "电表计量T相功率",
  "60421.ctrl_device.Q_U_Q_4": " Q(U)  Q  4",
  "60421.ctrl_device.Q_U_Q_3": " Q(U)  Q  3",
  "60421.ctrl_device.Q_U_Q_2": " Q(U)  Q  2",
  "60421.ctrl_device.Q_U_Q_1": "  Q(U) Q 1",
  "60421.real_time.PV6_string_1_current": "PV6  串  1  电流",
  "60421.real_time.PV4_string_1_current": "PV4  串  1  电流",
  "60421.ctrl_device.HVRT_Volt_Upper_Percent": " HVRT  电压上限百分比",
  "60421.ctrl_device.AFCI_Function_Enable": "  AFCI  功能使能",
  "60421.real_time.PV4__voltage": "PV4  电压",
  "60421.real_time.PV7_current": "PV7  电流",
  "60421.ctrl_device.LocalControl": "本地控件",
  "60421.real_time.Output_Q": " 输出无功功率",
  "60421.real_time.Output_P": "输出有功功率",
  "60421.ctrl_device.CosPhi_Mode": "cosPhi模式",
  "60421.real_time.Output_S": "输出视在功率",
  "60421.ctrl_device.Over_frequency_P_referance": "过频  P  参考",
  "60421.real_time.Internal_heatsink_temperature": "内部散热器温度",
  "60421.real_time.PV4_current_": "PV4  电流",
  "60421.ctrl_device.Under_frequency_recovery_value": "频率恢复值",
  "60421.ctrl_device.WIFI_KEY": "WIFI 密钥",
  "60421.real_time.PV2_voltage": "PV2  电压",
  "60421.real_time.PV6_string_1_KWH": "PV6  串  1  千瓦时",
  "60421.ctrl_device.Under_fequency_trigger_time_1": "频率触发时间  1",
  "60421.ctrl_device.Fixed_Q": " 固定  Q",
  "60421.real_time.Grid_S_current": "电网S相电流",
  "60421.ctrl_device.CosPhi_P_cosPhi_1_phase": "  CosPhi(P)  cosPhi  1  相",
  "60421.real_time.PV2_string_2_current": "PV2  串  2  电流",
  "60421.ctrl_device.P_U_curve_P_4": "P(U)  曲线  P  4",
  "60421.ctrl_device.Q_U_mode": "  Q(U) 模式",
  "60421.ctrl_device.Over_frequency_recovery_value": "过频恢复值",
  "60421.ctrl_device.P_U_curve_P_1": "P(U)  曲线  P  1",
  "60421.ctrl_device.Protocol_version": "协议版本",
  "60421.ctrl_device.P_U_curve_P_3": "P(U)  曲线  P  3",
  "60421.ctrl_device.P_U_curve_P_2": "P(U)  曲线  P  2",
  "60421.ctrl_device.DRM7_Q": "  DRM7  Q",
  "60421.ctrl_device.AFCI_Firmware_version": "  AFCI  固件版本  4",
  "60421.real_time.PV1_current": "PV1  电流",
  "60421.real_time.PV2_string_1_KWH": "PV2  串  1  千瓦时",
  "60421.real_time.Grid_T_voltage": "电网T相电压",
  "60421.real_time.Grid_frequency": "电网频率",
  "60421.ctrl_device.average_voltage_trigger_time": "10min电压触发时间",
  "60421.ctrl_device.Under_Frequency_Fback": "欠频加载恢复频率",
  "60421.real_time.PV4_current": "PV4  电流",
  "60421.ctrl_device.AFCI_Fault_Clear": " AFCI故障清除",
  "60421.real_time.Output_PF": " 输出功率因数",
  "60421.ctrl_device.P_U_P_response_time": "P(U)  P  响应时间",
  "60421.ctrl_device.Active_power_Increase_Rate": "有功功率增加斜率",
  "60421.real_time.PV1__voltage": "PV1  电压",
  "60421.real_time.PV_Power": "PV总功率",
  "60421.ctrl_device.Over_frequency_response_Fstart": "过频降载起始频率",
  "60421.real_time.PV3_string_1_current": "PV3  串  1  电流",
  "60421.ctrl_device.Power_reconnect_recovery_rate_after_reconnect": "电网重新连接功率加载斜率",
  "60421.real_time.PV7_voltage": "PV7  电压",
  "60421.real_time.PV1_string_2_KWH": "PV1  串  2  千瓦时",
  "60421.ctrl_device.Under_Frequency_decrease_rate": "欠频降载功率恢复斜率",
  "60421.ctrl_device.Meter_limit_power": "馈网功率限制值",
  "60421.real_time.Inverter_state": "逆变器状态",
  "60421.ctrl_device.Over_voltage_trigger_time_2": "过压触发时间  2",
  "60421.ctrl_device.Over_voltage_trigger_time_1": "过压触发时间  1",
  "60421.ctrl_device.CosPhi_P_cosPhi_4": "  CosPhi(P)  cosPhi  4",
  "60421.ctrl_device.Over_voltage_trigger_time_3": "过压触发时间  3",
  "60421.ctrl_device.CosPhi_P_cosPhi_3": "  CosPhi(P)  cosPhi  3",
  "60421.real_time.PV3_string_1_KWH": "PV3  串  1  千瓦时",
  "60421.ctrl_device.CosPhi_P_cosPhi_2": "  CosPhi(P)  cosPhi  2",
  "60421.ctrl_device.CosPhi_P_cosPhi_1": "  CosPhi(P)  cosPhi  1",
  "60421.ctrl_device.Grid_Type": "电网类型（是否接N线）",
  "60421.ctrl_device.CosPhi_P_cosPhi_2_phase": "  CosPhi(P)  cosPhi  2  相",
  "60421.ctrl_device.Grid_fault_reconnection_time": "电网故障重连时间",
  "60421.ctrl_device.Hardware_version": "硬件版本",
  "60421.ctrl_device.Safety_type": "安规代码",
  "60421.ctrl_device.Q_response_time": "  Q  响应时间",
  "60421.real_time.Waiting_time": "等待时间",
  "60421.real_time.PV5_string_2_current": "PV5  串  2  电流",
  "60421.ctrl_device.WIFI_SSID": "  WIFI  SSID",
  "60421.real_time.PV8_string_2_KWH": "PV8  串  2  千瓦时",
  "60421.ctrl_device.CosPhi_Lock_Out_Un": "  CosPhi  锁定  Un（输出）",
  "60421.real_time.PV4_voltage": "PV4  电压",
  "60421.ctrl_device.Under_frequency_protection_value1": "频率保护值  1",
  "60421.ctrl_device.Active_power_Decrease_Rate": "有功功率下降斜率",
  "60421.real_time.PV2_string_2_KWH": "PV2  串  2  千瓦时",
  "60421.ctrl_device.Warning_code": " 警告代码",
  "60421.real_time.PV4_string_2_current": "PV4  串  2  电流",
  "60421.ctrl_device.CosPhi_response_time": "  CosPhi  响应时间",
  "60421.real_time.Meter_Power": "电表功率",
  "60421.real_time.PV3__current": "PV3  电流",
  "60421.ctrl_device.LVRT_Q_Response_time_Cnt": "LVRT  Q  响应时间  Cnt  2",
  "60421.real_time.PV7_string_1_current": "PV7  串  1  电流",
  "60421.ctrl_device.average_voltage_protection_value": "10min保护值平均值",
  "60421.ctrl_device.Systemcm": "系统连接模式",
  "60421.ctrl_device.Over_frequency_response_mode": "过频降载模式",
  "60421.real_time.PV6_current": "PV6  电流",
  "60421.ctrl_device.First_connection_power_increase_rate": "首次连接功率加载斜率",
  "60421.ctrl_device.CosPhi_P_cosPhi_response_time": "  CosPhi(P)  cosPhi  响应时间",
  "60421.ctrl_device.CosPhi_Lock_In_Un": "  CosPhi  锁定  Un(输入)",
  "60421.real_time.PV1_voltage": "PV1  电压",
  "60421.ctrl_device.Lock_In_Pn": "  锁定  Pn",
  "60421.real_time.PV1_string_2_current": "PV1  串  2  电流",
  "60421.real_time.PV3_string_2_KWH": "PV3  串  2  千瓦时",
  "60421.real_time.Grid_T_current": "电网T相电流",
  "60421.real_time.PV2_string_1_current": "PV2  串  1  电流",
  "60421.ctrl_device.First_connection_time": "首次连接时间",
  "60421.ctrl_device.P_U_curve_U_2": "P(U)  曲线  U  2",
  "60421.ctrl_device.P_U_curve_U_1": "P(U)  曲线  U  1",
  "60421.real_time.PV7_string_2_KWH": "PV7  串  2  千瓦时",
  "60421.ctrl_device.Q_U_U_1": "Q(U)  U 1",
  "60421.real_time.Grid_R_voltage": "电网R相电压",
  "60421.real_time.PV3_current": "PV3  电流",
  "60421.ctrl_device.Under_frequency_protection_value_3": "频率保护值  3",
  "60421.ctrl_device.Under_frequency_protection_value_2": "频率保护值  2",
  "60421.ctrl_device.Over_frequency_response_Fstop": "过频降载结束频率",
  "60421.ctrl_device.P_U_curve_U_4": "P(U)  曲线  U  4",
  "60421.ctrl_device.P_U_curve_U_3": "P(U)  曲线  U  3",
  "60421.real_time.PV3__voltage": "PV3  电压",
  "60421.ctrl_device.ExternalSigna": "外部信号",
  "60421.ctrl_device.Under_Frequency_recovery_delay_time": "欠频恢复延迟时间",
  "60421.ctrl_device.Parameter_version": "安规参数版本",
  "60421.real_time.QorPF_direction": "  Q/PF  方向",
  "60421.ctrl_device.Active_power_control_mode": "有功功率控制模式",
  "60421.ctrl_device.Q_U_U_4": "  Q(U)  U  4",
  "60421.ctrl_device.Meter_type": "电表/CT类型",
  "60421.ctrl_device.Q_U_U_3": "  Q(U)  U  3",
  "60421.ctrl_device.Q_U_U_2": "  Q(U)  U  2",
  "60421.real_time.PV3_string_2_current": "PV3  串  2  电流",
  "60421.ctrl_device.Fixed_cosPhi": "固定cosPhi",
  "60421.ctrl_device.Under_Frequency_Mode": "欠频加载模式",
  "60421.real_time.Import_energy_from_meter": "电表计量的取电能量",
  "60421.ctrl_device.Q_U_Q_response_time_2": "  Q(U)  Q  响应时间  2",
  "60421.ctrl_device.Under_voltage_protect_ion_value": "欠压保护值  2",
  "60421.ctrl_device.Fixed_Reactive_power_value": "固定无功功率值",
  "60421.ctrl_device.Under_Frequency_response_delay_time": "欠频加载延迟时间",
  "60421.real_time.PV8_string_1_KWH": "PV8  串  1  千瓦时",
  "60421.ctrl_device.Plant_limit_power": "电站功率限制",
  "60421.real_time.PV8_string_1_current": "PV8  串  1  电流",
  "60421.ctrl_device.P_U_curve_enable": "P(U)  曲线使能",
  "60421.ctrl_device.Over_frequency_response_delay_time": "过频降载延迟时间",
  "60421.real_time.PV4_string_1_KWH": "PV4  串  1  千瓦时",
  "60421.real_time.PV6_voltage": "PV6  电压",
  "60421.ctrl_device.Q_U_Q_2_phase": "  Q(U)  Q  2  相",
  "60421.ctrl_device.Over_frequency_response_P_recovery_rate": "过频降载功率恢复斜率",
  "60421.real_time.PV5_string_1_current": "PV5  串  1  电流",
  "60421.ctrl_device.Serial_number": "序列号",
  "60421.real_time.PV6_string_2_current": "PV6  串  2  电流",
  "60421.ctrl_device.Over_frequency_response_P_drop_rate": "过频降载功率下降斜率",
  "60421.ctrl_device.First_connection_frequency_upper_value": "首次连接频率上限",
  "60421.ctrl_device.Under_Frequency_Fstop": "欠频加载结束频率",
  "60421.ctrl_device.Under_voltage_recovery_value": "欠压恢复值",
  "60421.real_time.Internal_ambient_temperature": "内部环境温度",
  "60421.ctrl_device.First_connection_voltage_upper_value": "首次连接电压上限",
  "60421.ctrl_device.Over_voltage_protection_value_3": "过压保护值  3",
  "60421.ctrl_device.Over_voltage_protection_value_2": "过压保护值  2",
  "60421.ctrl_device.Over_voltage_protection_value_1": "过压保护值  1",
  "60421.ctrl_device.Q_U_Q_1_phase": "Q(U)  Q  1  相",
  "60421.real_time.PV8_current": "PV8  电流",
  "60421.real_time.PV2__current": "PV2  电流",
  "60421.ctrl_device.Software_version": "软件版本",
  "60421.ctrl_device.AutoTest_Enable.0": "Disable",
  "60421.ctrl_device.AutoTest_Enable.1": "Enable",
  "60421.ctrl_device.Device_type.0": "Solar inverter",
  "60421.ctrl_device.Device_type.1": "Grid connected storage inverter storage inverter ",
  "60421.ctrl_device.Device_type.2": "Micro inverter",
  "60421.ctrl_device.Device_type.3": "Off grid inverter",
  "60421.ctrl_device.Over_frequency_response_enable.0": "Disable",
  "60421.ctrl_device.Over_frequency_response_enable.1": "Enable",
  "60421.ctrl_device.Start_stop_command.0": "Start",
  "60421.ctrl_device.Start_stop_command.1": "Stop",
  "60421.ctrl_device.Reactive_power_control_mode.0": "No used ",
  "60421.ctrl_device.Reactive_power_control_mode.1": "Fixed cosPhi",
  "60421.ctrl_device.Reactive_power_control_mode.2": "Fixed Q ",
  "60421.ctrl_device.Reactive_power_control_mode.3": "Cosphi(P)",
  "60421.ctrl_device.Reactive_power_control_mode.4": "Q(U)",
  "60421.ctrl_device.Reactive_power_control_mode.5": "DRED",
  "60421.ctrl_device.Fixed_cosPhi_phase.1": "Lag",
  "60421.ctrl_device.Fixed_cosPhi_phase.2": "Lead",
  "60421.ctrl_device.Fixed_Q_phase.1": "Lag",
  "60421.ctrl_device.Fixed_Q_phase.2": "Lead",
  "60421.ctrl_device.Fault_code.22": "CT未接",
  "60421.ctrl_device.Fault_code.23": "CT反接",
  "60421.ctrl_device.Fault_code.24": "电池未接",
  "60421.ctrl_device.Fault_code.25": "Backup负载过压",
  "60421.ctrl_device.Fault_code.26": "直流拉弧故障",
  "60421.ctrl_device.Fault_code.27": "AFCI自检故障",
  "60421.ctrl_device.Fault_code.10": "电网电压超范围",
  "60421.ctrl_device.Fault_code.11": "电网频率超范围",
  "60421.ctrl_device.Fault_code.12": "直流分量电流超范围",
  "60421.ctrl_device.Fault_code.13": "EEPROM故障",
  "60421.ctrl_device.Fault_code.14": "主副MCU通信故障",
  "60421.ctrl_device.Fault_code.15": "BUS电压高故障",
  "60421.ctrl_device.Fault_code.16": "BUS电压低故障",
  "60421.ctrl_device.Fault_code.17": "DRM S9故障",
  "60421.ctrl_device.Fault_code.18": "DRM S0故障",
  "60421.ctrl_device.Fault_code.19": "接地故障(PE connection missing)",
  "60421.ctrl_device.Fault_code.0": "No fault",
  "60421.ctrl_device.Fault_code.1": "MCU故障",
  "60421.ctrl_device.Fault_code.2": "电流传感器故障",
  "60421.ctrl_device.Fault_code.3": "GFCI传感器故障",
  "60421.ctrl_device.Fault_code.4": "继电器故障",
  "60421.ctrl_device.Fault_code.5": "PV电压过高",
  "60421.ctrl_device.Fault_code.6": "绝缘阻抗错误",
  "60421.ctrl_device.Fault_code.7": "GFCI超范围",
  "60421.ctrl_device.Fault_code.8": "温度超范围",
  "60421.ctrl_device.Fault_code.9": "无市电",
  "60421.ctrl_device.Fault_code.20": "Bus voltage unbalance Bus电压不平衡",
  "60421.ctrl_device.Fault_code.21": "BMS通信故障",
  "60421.ctrl_device.Under_Frequency_Enable.0": "Disable",
  "60421.ctrl_device.Under_Frequency_Enable.1": "Enable",
  "60421.ctrl_device.Q_U_Q_4_phase.1": "Lag",
  "60421.ctrl_device.Q_U_Q_4_phase.2": "Lead",
  "60421.ctrl_device.Meter_limit_mode.0": "Total three phases active power control ",
  "60421.ctrl_device.Meter_limit_mode.1": "Minimum phase active power control",
  "60421.ctrl_device.UpgradeState.0": "没有升级 ",
  "60421.ctrl_device.UpgradeState.1": "正在升级",
  "60421.ctrl_device.UpgradeState.2": "升级失败",
  "60421.real_time.PV4__voltage.0": "Disable",
  "60421.real_time.PV4__voltage.1": "Enable",
  "60421.ctrl_device.CosPhi_Mode.0": "Cosphi-P NoHypst",
  "60421.ctrl_device.CosPhi_Mode.1": "Cosphi-P Hypst",
  "60421.ctrl_device.CosPhi_P_cosPhi_1_phase.1": "Lag",
  "60421.ctrl_device.CosPhi_P_cosPhi_1_phase.2": "Lead",
  "60421.ctrl_device.Q_U_mode.0": "P lock-in lock-out Disable",
  "60421.ctrl_device.Q_U_mode.1": "P lock-in lock-out Enable",
  "60421.ctrl_device.AFCI_Fault_Clear.0": "Disable",
  "60421.ctrl_device.AFCI_Fault_Clear.1": "Enable",
  "60421.real_time.Inverter_state.0": "Wait ",
  "60421.real_time.Inverter_state.1": "Normal ",
  "60421.real_time.Inverter_state.2": "Fault ",
  "60421.real_time.Inverter_state.3": "Null",
  "60421.real_time.Inverter_state.4": "off grid",
  "60421.ctrl_device.Grid_Type.0": "N line not connected",
  "60421.ctrl_device.Grid_Type.1": "N line connected",
  "60421.ctrl_device.Safety_type.44": "BR No.140:2022",
  "60421.ctrl_device.Safety_type.45": "CZ 01 EN 50549-1:2019 ",
  "60421.ctrl_device.Safety_type.46": "CZ 02 EN 50549-1:2019 ",
  "60421.ctrl_device.Safety_type.47": "NI G98/NI-1",
  "60421.ctrl_device.Safety_type.48": "NI G99/NI-1",
  "60421.ctrl_device.Safety_type.49": "PL B EN 50549-1:2019",
  "60421.ctrl_device.Safety_type.50": "Mexico 02",
  "60421.ctrl_device.Safety_type.51": "TW CNS 15382:2018",
  "60421.ctrl_device.Safety_type.52": "AT TOR Type A:2022",
  "60421.ctrl_device.Safety_type.53": "TH MEA 2015",
  "60421.ctrl_device.Safety_type.10": "Mexico",
  "60421.ctrl_device.Safety_type.54": "TH PEA 2016",
  "60421.ctrl_device.Safety_type.11": "CN GB/T 37408:2019",
  "60421.ctrl_device.Safety_type.55": "CH A EN 50549-1:2019",
  "60421.ctrl_device.Safety_type.12": "EN 50549-2:2019",
  "60421.ctrl_device.Safety_type.56": "Philippine",
  "60421.ctrl_device.Safety_type.13": "IEC 61727:2004",
  "60421.ctrl_device.Safety_type.57": "IE 02 EN50549-1:2019",
  "60421.ctrl_device.Safety_type.14": "PL EN 50549-1:2019",
  "60421.ctrl_device.Safety_type.58": "FR NF EN50549-1:2019",
  "60421.ctrl_device.Safety_type.15": "VN IEC 61727:2004",
  "60421.ctrl_device.Safety_type.16": "LK IEC 61727:2004",
  "60421.ctrl_device.Safety_type.17": "IT CEI 0-21:2019",
  "60421.ctrl_device.Safety_type.18": "MA IEC 61727:2004",
  "60421.ctrl_device.Safety_type.19": "AR IEC 61727:2004",
  "60421.ctrl_device.Safety_type.0": "Default",
  "60421.ctrl_device.Safety_type.1": "AU AS/NZS 4777.2:2015",
  "60421.ctrl_device.Safety_type.2": "NZ AS/NZS 4777.2:2015",
  "60421.ctrl_device.Safety_type.3": "CN NB/T 32004:2018",
  "60421.ctrl_device.Safety_type.4": "EN 50549-1:2019",
  "60421.ctrl_device.Safety_type.5": "NL EN 50549-1:2019",
  "60421.ctrl_device.Safety_type.6": "UK G98-1",
  "60421.ctrl_device.Safety_type.7": "UK G99-1",
  "60421.ctrl_device.Safety_type.8": "DE VDE-AR-N 4105:2018",
  "60421.ctrl_device.Safety_type.9": "BR ABNT NBR 16149:2013",
  "60421.ctrl_device.Safety_type.20": "IT B CEI 0-21:2019",
  "60421.ctrl_device.Safety_type.21": "IT M CEI 0-21:2022",
  "60421.ctrl_device.Safety_type.22": "ZA NRS 097-2-1:2017",
  "60421.ctrl_device.Safety_type.23": "BE C10/11:2019",
  "60421.ctrl_device.Safety_type.24": "DK1 EN 50549-1:2019 ",
  "60421.ctrl_device.Safety_type.25": "DK2 EN 50549-1:2019",
  "60421.ctrl_device.Safety_type.26": "IE EN 50549-1:2019  ",
  "60421.ctrl_device.Safety_type.27": "CL IEC 61727:2004",
  "60421.ctrl_device.Safety_type.28": "RO EN 50549-1:2019",
  "60421.ctrl_device.Safety_type.29": "HU EN 50549-1:2019",
  "60421.ctrl_device.Safety_type.30": "UL 1741:2010",
  "60421.ctrl_device.Safety_type.31": "AU A AS/NZS 4777.2:2020",
  "60421.ctrl_device.Safety_type.32": "AU B AS/NZS 4777.2:2020",
  "60421.ctrl_device.Safety_type.33": "AU C AS/NZS 4777.2:2020",
  "60421.ctrl_device.Safety_type.34": "NZ 20 AS/NZS 4777.2:2020",
  "60421.ctrl_device.Safety_type.35": "IT CEI 0-16:2019",
  "60421.ctrl_device.Safety_type.36": "ES RD-1699",
  "60421.ctrl_device.Safety_type.37": "BR LV ABNT 16149:2013",
  "60421.ctrl_device.Safety_type.38": "JO DC RFG:2015",
  "60421.ctrl_device.Safety_type.39": "FR VFR 2019",
  "60421.ctrl_device.Safety_type.40": "FR Island 50Hz",
  "60421.ctrl_device.Safety_type.41": "FR Island 60Hz",
  "60421.ctrl_device.Safety_type.42": "LV EN 50549-1:2019",
  "60421.ctrl_device.Safety_type.43": "SE EN 50549-1:2019",
  "60421.ctrl_device.Warning_code.11": "逆变过流",
  "60421.ctrl_device.Warning_code.12": "孤岛",
  "60421.ctrl_device.Warning_code.13": "电网峰值过压",
  "60421.ctrl_device.Warning_code.14": "固件更新",
  "60421.ctrl_device.Warning_code.15": "PE connection missing(接地故障)",
  "60421.ctrl_device.Warning_code.16": "电网电压一致性警告",
  "60421.ctrl_device.Warning_code.17": "风扇运行异常警告",
  "60421.ctrl_device.Warning_code.18": "Backup负载过载",
  "60421.ctrl_device.Warning_code.19": "SPD failed Warning",
  "60421.ctrl_device.Warning_code.0": "No warning",
  "60421.ctrl_device.Warning_code.1": "PV1过流",
  "60421.ctrl_device.Warning_code.2": "PV2过流",
  "60421.ctrl_device.Warning_code.3": "PV3过流",
  "60421.ctrl_device.Warning_code.4": "PV4过流",
  "60421.ctrl_device.Warning_code.5": "PV1欠压",
  "60421.ctrl_device.Warning_code.6": "PV2欠压",
  "60421.ctrl_device.Warning_code.7": "PV3欠压",
  "60421.ctrl_device.Warning_code.8": "PV4欠压",
  "60421.ctrl_device.Warning_code.9": "BUS过压",
  "60421.ctrl_device.Warning_code.10": "BUS欠压",
  "60421.ctrl_device.Systemcm.0": "单机系统",
  "60421.ctrl_device.Systemcm.1": "多机主机",
  "60421.ctrl_device.Systemcm.2": "多机从机",
  "60421.ctrl_device.Over_frequency_response_mode.0": "Null",
  "60421.ctrl_device.Over_frequency_response_mode.1": "Hysteresis mode",
  "60421.ctrl_device.Over_frequency_response_mode.2": "No hysteresis mode",
  "60421.real_time.QorPF_direction.1": "Lag",
  "60421.real_time.QorPF_direction.2": "Lead",
  "60421.ctrl_device.Active_power_control_mode.0": "No used ",
  "60421.ctrl_device.Active_power_control_mode.1": "Fixed active power ",
  "60421.ctrl_device.Active_power_control_mode.2": "DRED",
  "60421.ctrl_device.Active_power_control_mode.3": "Meter/CT",
  "60421.ctrl_device.Active_power_control_mode.4": "Plant control",
  "60421.ctrl_device.Meter_type.0": "SDM230",
  "60421.ctrl_device.Meter_type.1": "SDM630",
  "60421.ctrl_device.Meter_type.2": "Internal CT",
  "60421.ctrl_device.Meter_type.3": "DZS100-S",
  "60421.ctrl_device.Meter_type.4": "DZS320",
  "60421.ctrl_device.Meter_type.5": "ACC(SDM120&Internal CT) ",
  "60421.ctrl_device.Meter_type.6": "DTSU666",
  "60421.ctrl_device.Meter_type.7": "CT-ACC(single phase)",
  "60421.ctrl_device.Under_Frequency_Mode.1": "Hysteresis mode",
  "60421.ctrl_device.Under_Frequency_Mode.2": "No hysteresis mode",
  "60421.ctrl_device.P_U_curve_enable.0": "Disable",
  "60421.ctrl_device.P_U_curve_enable.1": "Enable",
  "60421.ctrl_device": "任意",
  "60421.real_time": "实时监控",
  "plant.create.type.0": "安装商创建",
  "50657.realtime.Ua": "A相电压",
  "50657.realtime.Ub": "B相电压",
  "50657.realtime.Uc": "C相电压",
  "50657.realtime.Uab": "AB线电压",
  "50657.realtime.Ubc": "BC线电压",
  "50657.realtime.Uca": "CA线电压",
  "50657.realtime.Ia": "A相电流",
  "50657.realtime.Ib": "B相电流",
  "50657.realtime.Ic": "C相电流",
  "50657.realtime.Pa": "A相有功总功率",
  "50657.realtime.Pb": "B相有功总功率",
  "50657.realtime.Pc": "C相有功总功率",
  "50657.realtime.P": "总有功功率",
  "50657.realtime.Qa": "A相无功总功率",
  "50657.realtime.Qb": "B相无功总功率",
  "50657.realtime.Qc": "C相无功总功率",
  "50657.realtime.Q": "总无功功率",
  "50657.realtime.Pfa": "A相功率因数",
  "50657.realtime.Pfb": "B相功率因数",
  "50657.realtime.Pfc": "C相功率因数",
  "50657.realtime.Pf": "总功率因数",
  "50657.realtime.Sa": "A相视在功率",
  "50657.realtime.Sb": "B相视在功率",
  "50657.realtime.Sc": "C相视在功率",
  "50657.realtime.S": "总视在功率",
  "50657.realtime.Fr": "频率",
  "50657.realtime.FTAE": "正向总有功电能",
  "50657.realtime.RTAE": "反向总有功电能",
  "50657.realtime.FASE": "正向有功尖电能",
  "50657.realtime.FAPE": "正向峰有功电能",
  "50657.realtime.FAFE": "正向平有功电能",
  "50657.realtime.FAVE": "正向谷有功电能",
  "50657.realtime.FADE": "正向深谷有功电能",
  "50657.realtime.RASE": "反向尖有功电能",
  "50657.realtime.RAPE": "反向峰有功电能",
  "50657.realtime.RAFE": "反向平有功电能",
  "50657.realtime.RAVE": "反向谷有功电能",
  "50657.realtime.RADE": "反向深谷有功电能",
  "50657.fault.comStatus": "通讯状态",
  "50657.realtime.Zf": "正向阻抗",
  "50657.realtime.Z0": "零序阻抗",
  "50657.realtime.T": "温度",
  "50657.realtime.FAPVE": "正向峰谷有功电能",
  "50657.realtime.FTAE_PSD": "上1结算日正向总有功电能",
  "50657.realtime.FASE_PSD": "上1结算日正向尖有功电能",
  "50657.realtime.FAPE_PSD": "上1结算日正向峰有功电能",
  "50657.realtime.FAFE_PSD": "上1结算日正向平有功电能",
  "50657.realtime.FAVE_PSD": "上1结算日正向谷有功电能",
  "50657.realtime.FAPVE_PSD": "上1结算日正向峰谷有功电能",
  "50657.fault.comStatus.00": "断开",
  "50657.fault.comStatus.01": "连接",
  "60420.ctrl_param_shebeixinxishezhi.statutory.14": "CQC2018",
  "60420.ctrl_param_shebeixinxishezhi.statutory.2": "EN50549",
  "60420.ctrl_param_shebeixinxishezhi.statutory.3": "巴西",
  "60420.ctrl_param_shebeixinxishezhi.statutory.4": "西班牙",
  "60420.ctrl_param_shebeixinxishezhi.statutory.5": "菲律宾",
  "60420.ctrl_param_shebeixinxishezhi.statutory.7": "比利时",
  "60420.ctrl_param_shebeixinxishezhi.statutory.8": "EU EN50438",
  "60420.ctrl_param_shebeixinxishezhi.statutory.9": "南非 NRS",
  "60420.ctrl_param_shebeixinxishezhi.statutory.10": "澳洲西部",
  "60420.ctrl_param_shebeixinxishezhi.statutory.11": "荷兰",
  "60420.ctrl_param_shebeixinxishezhi.statutory.15": "希腊",
  "60420.ctrl_param_shebeixinxishezhi.statutory.16": "挪威",
  "60420.ctrl_param_shebeixinxishezhi.statutory.17": "韩国",
  "60420.ctrl_param_shebeixinxishezhi.statutory.20": "爱尔兰",
  "60420.ctrl_param_shebeixinxishezhi.statutory.21": "土耳其",
  "60420.ctrl_param_shebeixinxishezhi.statutory.22": "台湾地区",
  "60420.ctrl_param_shebeixinxishezhi.statutory.23": "意大利Italy",
  "60420.ctrl_param_shebeixinxishezhi.statutory.24": "斯洛伐克",
  "60420.ctrl_param_shebeixinxishezhi.statutory.1": "预留",
  "China": "中国大陆",
  "Australia": "澳洲",
  "SoutheastAsia": "东南亚",
  "Europe": "欧洲",
  "Jimo_Factory": "即墨工厂MES",
  "Transit_Warehouse": "中转仓",
  "module.dashboard": "监控大屏",
  "module.ai": "AI",
  "bw_Param_strl_option_GridUseMeter": "电网使用电表",
  "bw_Param_strl_option_GridUseCT": "电网使用CT",
  "50901.fault.dSPSAFcomparatorFault": "比较器故障",
  "50901.fault.dSPPWRfanFault": "风扇故障",
  "50901.fault.dSPPWRgridRelayProtection": "电网继电器保护触发",
  "50901.fault.dSPPWRmachineTypeMismatch": "机型不匹配",
  "50901.fault.dSPSAFbatteryFault": "电池故障",
  "50901.fault.dSPSAFfanFault": "风扇故障",
  "50901.fault.dSPSAFgridRelayProtection": "电网继电器保护触发",
  "50901.fault.dSPPWRbatteryFault": "电池侧故障",
  "50901.fault.dSPPWRcomparatorFault": "比较器故障",
  "50901.fault.dSPSAFauxiliaryPowerAbnormality": "辅助电源异常",
  "50901.fault.dSPSAFmachineTypeMismatch": "机型不匹配",
  "50901.fault.dSPSAFsamplingBiasAbnormality": "采样偏置异常",
  "50901.fault.dSPPWRauxiliaryPowerAbnormality": "辅助电源异常",
  "50901.fault.dSPSAFarmCommunicationFault": "ARM 通讯故障",
  "50901.fault.dSPSAFspiCommunicationFault": "SPI 通讯故障",
  "50901.fault.dSPSAFversionMismatch": "版本不匹配",
  "50901.fault.dSPPWRarmCommunicationFault": "ARM 通讯故障",
  "50901.fault.dSPPWRsamplingBiasAbnormality": "采样偏置异常",
  "50901.fault.dSPPWRspiCommunicationFault": "SPI 通讯故障",
  "50901.fault.dSPPWRversionMismatch": "版本不匹配（软硬件版本不一致）",
  "50901.fault.dSPPWRgridRelayProtection.0": "不使能",
  "50901.fault.dSPPWRgridRelayProtection.1": "使能",
  "50901.fault.dSPPWRmachineTypeMismatch.0": "不使能",
  "50901.fault.dSPPWRmachineTypeMismatch.1": "使能",
  "50901.fault.dSPPWRsamplingBiasAbnormality.0": "不使能",
  "50901.fault.dSPPWRbatteryFault.1": "使能",
  "50901.fault.dSPPWRcomparatorFault.0": "不使能",
  "50901.fault.dSPPWRcomparatorFault.1": "使能",
  "50901.fault.dSPPWRfanFault.0": "不使能",
  "50901.fault.dSPPWRfanFault.1": "使能",
  "50901.fault.dSPPWRarmCommunicationFault.0": "不使能",
  "50901.fault.dSPPWRarmCommunicationFault.1": "使能",
  "50901.fault.dSPPWRauxiliaryPowerAbnormality.0": "不使能",
  "50901.fault.dSPPWRauxiliaryPowerAbnormality.1": "使能",
  "50901.fault.dSPPWRbatteryFault.0": "不使能",
  "50901.fault.dSPPWRsamplingBiasAbnormality.1": "使能",
  "50901.fault.dSPSAFsamplingBiasAbnormality.1": "使能",
  "50901.fault.dSPSAFspiCommunicationFault.0": "不使能",
  "50901.fault.dSPSAFspiCommunicationFault.1": "使能",
  "50901.fault.dSPSAFversionMismatch.0": "不使能",
  "50901.fault.dSPSAFversionMismatch.1": "使能",
  "50901.fault.dSPSAFarmCommunicationFault.0": "不使能",
  "50901.fault.dSPSAFgridRelayProtection.1": "使能",
  "50901.fault.dSPSAFmachineTypeMismatch.0": "不使能",
  "50901.fault.dSPSAFmachineTypeMismatch.1": "使能",
  "50901.fault.dSPSAFsamplingBiasAbnormality.0": "不使能",
  "50901.fault.dSPSAFbatteryFault.0": "不使能",
  "50901.fault.dSPSAFbatteryFault.1": "使能",
  "50901.fault.dSPSAFcomparatorFault.0": "不使能",
  "50901.fault.dSPSAFcomparatorFault.1": "使能",
  "50901.fault.dSPSAFfanFault.0": "不使能",
  "50901.fault.dSPSAFfanFault.1": "使能",
  "50901.fault.dSPPWRversionMismatch.0": "不使能",
  "50901.fault.dSPPWRversionMismatch.1": "使能",
  "50901.fault.dSPSAFarmCommunicationFault.1": "使能",
  "50901.fault.dSPSAFauxiliaryPowerAbnormality.0": "不使能",
  "50901.fault.dSPSAFauxiliaryPowerAbnormality.1": "使能",
  "50901.fault.dSPPWRspiCommunicationFault.0": "不使能",
  "50901.fault.dSPPWRspiCommunicationFault.1": "使能",
  "50901.fault.dSPSAFgridRelayProtection.0": "不使能",
  "50901.Fault": "故障",
  "50901.Fault.arcFault.0": "disable",
  "50901.Fault.arcFault.1": "enable",
  "50901.Fault.arcSelfTestFault.0": "不使能",
  "50901.Fault.arcSelfTestFault.1": "使能",
  "50901.Fault.busbarAbnormality.0": "disable",
  "50901.Fault.busbarAbnormality.1": "enable",
  "50901.Fault.cmpssBiasCalculationError.0": "disable",
  "50901.Fault.cmpssBiasCalculationError.1": "使能",
  "50901.Fault.driveAbnormality.0": "disable",
  "50901.Fault.driveAbnormality.1": "enable",
  "50901.Fault.e2rpomFault.0": "disable",
  "50901.Fault.e2rpomFault.1": "enable",
  "50901.Fault.epsOverload.0": "disable",
  "50901.Fault.epsOverload.1": "使能",
  "50901.Fault.epsRelayProtection.0": "disable",
  "50901.Fault.epsRelayProtection.1": "enable",
  "50901.Fault.epsVoltageAbnormality.0": "disable",
  "50901.Fault.epsVoltageAbnormality.1": "使能",
  "50901.Fault.flashCommunicationFault.0": "disable",
  "50901.Fault.flashCommunicationFault.1": "enable",
  "50901.Fault.frequencyVariationRateOutOfRange.0": "不使能",
  "50901.Fault.frequencyVariationRateOutOfRange.1": "使能",
  "50901.Fault.genAbnormality.0": "disable",
  "50901.Fault.genAbnormality.1": "enable",
  "50901.Fault.genOverload.0": "不使能",
  "50901.Fault.genOverload.1": "使能",
  "50901.Fault.gridCurrentDcOffsetOutOfRange.0": "disable",
  "50901.Fault.gridCurrentDcOffsetOutOfRange.1": "enable",
  "50901.Fault.gridOffVoltageDcOffsetOutOfRange.0": "不使能",
  "50901.Fault.gridOffVoltageDcOffsetOutOfRange.1": "enable",
  "50901.Fault.gridOverfrequency.0": "不使能",
  "50901.Fault.gridOverfrequency.1": "使能",
  "50901.Fault.gridOvervoltage.0": "disable",
  "50901.Fault.gridOvervoltage.1": "enable",
  "50901.Fault.gridPowerOutage.0": "disable",
  "50901.Fault.gridPowerOutage.1": "enable",
  "50901.Fault.gridUnderfrequency.0": "不使能",
  "50901.Fault.gridUnderfrequency.1": "enable",
  "50901.Fault.gridUndervoltage.0": "disable",
  "50901.Fault.gridUndervoltage.1": "enable",
  "50901.Fault.gridVoltageAbnormality.0": "不使能",
  "50901.Fault.gridVoltageAbnormality.1": "enable",
  "50901.Fault.insulationFault.0": "不使能",
  "50901.Fault.insulationFault.1": "使能",
  "50901.Fault.interruptOverflow.0": "disable",
  "50901.Fault.interruptOverflow.1": "enable",
  "50901.Fault.lineToEarthFault.0": "disable",
  "50901.Fault.lineToEarthFault.1": "enable",
  "50901.Fault.lowAmbientTemperature.0": "不使能",
  "50901.Fault.lowAmbientTemperature.1": "enable",
  "50901.Fault.meterWiringAbnormality.0": "不使能",
  "50901.Fault.meterWiringAbnormality.1": "enable",
  "50901.Fault.microelectronicFault.0": "disable",
  "50901.Fault.microelectronicFault.1": "使能",
  "50901.Fault.neutralWireNotConnected.0": "不使能",
  "50901.Fault.neutralWireNotConnected.1": "enable",
  "50901.Fault.neutralWireToEarthFault.0": "disable",
  "50901.Fault.neutralWireToEarthFault.1": "使能",
  "50901.Fault.overTemperature.0": "不使能",
  "50901.Fault.overTemperature.1": "enable",
  "50901.Fault.pllLockFailed.0": "disable",
  "50901.Fault.pllLockFailed.1": "enable",
  "50901.Fault.preSynchronizationFailed.0": "不使能",
  "50901.Fault.preSynchronizationFailed.1": "使能",
  "50901.Fault.pvFault.0": "disable",
  "50901.Fault.pvFault.1": "enable",
  "50901.Fault.pvVoltageExceedingBusVoltage.0": "不使能",
  "50901.Fault.pvVoltageExceedingBusVoltage.1": "enable",
  "50901.Fault.rcdFault.0": "disable",
  "50901.Fault.rcdFault.1": "enable",
  "50901.Fault.rcdSelfTestFault.0": "不使能",
  "50901.Fault.rcdSelfTestFault.1": "使能",
  "50901.Fault.reconnectionFailed.0": "disable",
  "50901.Fault.reconnectionFailed.1": "enable",
  "50901.Fault.shutDown.0": "不使能",
  "50901.Fault.shutDown.1": "使能",
  "50901.Fault.temperatureAbnormality.0": "disable",
  "50901.Fault.temperatureAbnormality.1": "enable",
  "50901.Fault.tenMinuteOvervoltage.0": "不使能",
  "50901.Fault.tenMinuteOvervoltage.1": "使能",
  "50901.Fault.wiringAbnormality.0": "disable",
  "50901.Fault.wiringAbnormality.1": "enable",
  "50901.real_time.packNum.1": "1",
  "50901..parallelNetworking.0": "无效",
  "50901..parallelNetworking.1": "组网中",
  "50901..parallelNetworking.2": "解散组网",
  "50901.ctrl_Config.Device.arcfaultClear.0": "否",
  "50901.ctrl_Config.Device.arcfaultClear.1": "是",
  "50901.ctrl_Config.Device.clearfault.0": "否",
  "50901.ctrl_Config.Device.clearfault.1": "是",
  "50901.Fault.arcFault": "电弧故障",
  "50901.Fault.arcSelfTestFault": "电弧自检故障",
  "50901.Fault.busbarAbnormality": "母线异常",
  "50901.Fault.cmpssBiasCalculationError": "CMPSS偏置计算错误",
  "50901.Fault.driveAbnormality": "驱动异常（功率管驱动故障）",
  "50901.Fault.e2rpomFault": "EEPROM故障",
  "50901.Fault.epsOverload": "EPS 过载",
  "50901.Fault.epsRelayProtection": "EPS 继电器保护触发（EPS 为应急电源系统）",
  "50901.Fault.epsVoltageAbnormality": "EPS 电压异常",
  "50901.Fault.flashCommunicationFault": "Flash 通讯故障",
  "50901.Fault.frequencyVariationRateOutOfRange": "频率变化率超限",
  "50901.Fault.genAbnormality": "发电机侧异常",
  "50901.Fault.genOverload": "发电机侧过载",
  "50901.Fault.gridCurrentDcOffsetOutOfRange": "电网电流直流偏置超限",
  "50901.Fault.gridOffVoltageDcOffsetOutOfRange": "离网电压直流偏置超限",
  "50901.Fault.gridOverfrequency": "电网过频",
  "50901.Fault.gridOvervoltage": "电网过压",
  "50901.Fault.gridPowerOutage": "电网停电",
  "50901.Fault.gridUnderfrequency": "电网欠频",
  "50901.Fault.gridUndervoltage": "电网欠压",
  "50901.Fault.gridVoltageAbnormality": "电网电压异常",
  "50901.Fault.insulationFault": "绝缘故障",
  "50901.Fault.interruptOverflow": "中断溢出",
  "50901.Fault.lineToEarthFault": "相线接地故障",
  "50901.Fault.lowAmbientTemperature": "环境温度过低",
  "50901.Fault.meterWiringAbnormality": "电表接线异常",
  "50901.Fault.microelectronicFault": "微电子故障",
  "50901.Fault.neutralWireNotConnected": "中性线未连接",
  "50901.Fault.neutralWireToEarthFault": "中性线接地故障",
  "50901.Fault.overTemperature": "超温",
  "50901.Fault.pllLockFailed": "锁相环失锁（PLL 锁相失败）",
  "50901.Fault.preSynchronizationFailed": "预同步失败（并网前同步失败）",
  "50901.Fault.pvFault": "光伏侧故障",
  "50901.Fault.pvVoltageExceedingBusVoltage": "光伏电压高于母线电压",
  "50901.Fault.rcdFault": "剩余电流保护器故障",
  "50901.Fault.rcdSelfTestFault": "剩余电流保护器自检故障",
  "50901.Fault.reconnectionFailed": "重连失败",
  "50901.Fault.shutDown": "停机保护（故障停机）",
  "50901.Fault.temperatureAbnormality": "温度异常",
  "50901.Fault.tenMinuteOvervoltage": "10 分钟持续过压",
  "50901.Fault.wiringAbnormality": "接线异常",
  "50901.ctrl_Config.Device.arcfaultClear": "电弧故障清除",
  "50901.ctrl_Config.Device.clearfault": "清除故障",
  "51102.s\\real_time.AI_LED_status": "AI LED灯状态",
  "51102.s\\real_time.ai_elct_meter_check": "AI智能电表检测状态",
  "51102.m\\real_time.all_mod_tot_BAT_P": "并机下电池侧总功率",
  "51102.s\\real_time.EPS_I": "EPS微逆电流",
  "51102.s\\real_time.EPS_P": "EPS微逆有功功率",
  "51102.s\\real_time.EPS_S": "EPS微逆视在功率",
  "51102.s\\real_time.EPS_Q": "EPS微逆无功功率",
  "51102.s\\real_time.EPS_PF": "EPS微逆功率因数",
  "51102.s\\real_time.pvPower": "PV发电功率",
  "51102.s_w\\ctl_EMS.ai_tou_enable": "AI智能调度使能",
  "51102.s_w\\ctl_EMS.ai_meshing_status": "AI智能组网状态",
  "51102.s\\elct_meter.gridBuyPower_1": "网侧电表正向有功电能",
  "51102.s\\elct_meter.gridSellPower_1": "网侧电表反向有功电能",
  "51102.s\\real_time.AI_LED_status.0": "熄灭",
  "51102.s\\real_time.AI_LED_status.1": "点亮",
  "51102.s\\real_time.ai_elct_meter_check.0": "检测完成",
  "51102.s\\real_time.ai_elct_meter_check.1": "检测双电表位置",
  "51102.s\\real_time.ai_elct_meter_check.2": "检测电表相序",
  "51102.s_w\\ctl_EMS.ai_tou_enable.0": "禁用",
  "51102.s_w\\ctl_EMS.ai_tou_enable.1": "使能",
  "51102.s_w\\ctl_EMS.ai_meshing_status.0": "组网完成",
  "51102.s_w\\ctl_EMS.ai_meshing_status.1": "智能组网中",
  "org.aiMessage.charge.fail": "充电失败（重试3次），后续时段AI自动重试。关闭AI模式后可手动处理。",
  "org.aiMessage.charge.success": "充电指令已成功执行，AI策略运行正常。",
  "org.aiMessage.discharge.fail": "放电失败（重试3次），后续时段AI自动重试。关闭AI模式后可手动处理。",
  "org.aiMessage.discharge.success": "放电指令已成功执行，AI策略运行正常。",
  "ai.message.charge.title.success": "充电指令执行成功",
  "ai.message.charge.title.fail": "充电指令执行失败",
  "ai.message.charge.content.success": "充电指令已成功执行，AI策略运行正常。",
  "ai.message.charge.content.fail": "的充电指令执行失败（已自动重试3次），后续时段AI自动重试。关闭AI模式后可手动处理。",
  "ai.message.discharge.title.success": "放电指令执行成功",
  "ai.message.discharge.title.fail": "放电指令执行失败",
  "ai.message.discharge.content.success": "放电指令已成功执行，AI策略运行正常",
  "ai.message.discharge.content.fail": "的放电指令执行失败（已自动重试3次），后续时段AI自动重试。关闭AI模式后可手动处理。",
  "50901.fault.evCharger1CommunicationAbnormality": "充电桩 1 通讯异常",
  "50901.fault.bmsCanCommunicationAbnormality": "BMS CAN 通讯异常",
  "50901.fault.dtu3Rs485CommunicationAbnormality": "DTU3 RS485 通讯异常",
  "50901.fault.gridMeterTypeError": "电网电表型号错误",
  "50901.fault.lowDtuVersion": "DTU 版本过低",
  "50901.fault.gridMeterCommunicationAbnormality": "电网电表通讯异常",
  "50901.fault.pvMeterTypeError": "光伏电表型号错误",
  "50901.fault.dspPwrCommunicationAbnormality": "DSP_PWR 通讯异常",
  "50901.fault.evCharger2CommunicationAbnormality": "充电桩 2 通讯异常",
  "50901.fault.dtu5Rs485CommunicationAbnormality": "DTU5 RS485 通讯异常",
  "50901.fault.dtsCommunicationAbnormality": "DTS 设备通讯异常",
  "50901.fault.dtu4Rs485CommunicationAbnormality": "DTU4 RS485 通讯异常",
  "50901.fault.dtu1Rs485CommunicationAbnormality": "DTU1 RS485 通讯异常",
  "50901.fault.pvMeterCommunicationAbnormality": "光伏电表通讯异常",
  "50901.fault.slaveWrongBatteryConnection": "从机电池接线错误（多 PCS 单电池场景）",
  "50901.fault.dtu2Rs485CommunicationAbnormality": "DTU2 RS485 通讯异常",
  "50901.fault.dspSafCommunicationAbnormality": "DSP_SAF 通讯异常",
  "50901.fault.sustainedNegativeLoad": "持续负载",
  "50901.fault.hmidMachineFault": "人机交互模块硬件故障",
  "50901.fault.evCharger1Fault": "EV 充电器 1 故障",
  "50901.fault.evCharger2Fault": "EV 充电器 2 故障",
  "50901.fault.fanSpeedAbnormality": "风扇转速异常",
  "50901.fault.masterSlaveCommunicationAbnormality": "主从通讯异常",
  "50901.fault.batteryCapacityAbnormality": "电池容量异常",
  "50901.fault.batteryForceChargeRequest": "电池强制充电请求",
  "50901.fault.hmidCommunicationAbnormality": "人机交互模块通讯异常",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7.desc": "发电机在此时间定期启动",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6.desc": "发电机在此时间定期启动",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1.desc": "发电机在此时间定期启动",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2.desc": "发电机在此时间定期启动",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5.desc": "发电机在此时间定期启动",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3.desc": "发电机在此时间定期启动",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4.desc": "发电机在此时间定期启动",
  "50901.fault.loadRelayAfault.0": "不使能",
  "50901.fault.fiveVoltPowerSupplyfault.0": "不使能",
  "50901.fault.fiveVoltPowerSupplyfault.1": "使能",
  "50901.fault.genRelayAfault.0": "不使能",
  "50901.fault.genRelayAfault.1": "使能",
  "50901.fault.genRelayBfault.0": "不使能",
  "50901.fault.genRelayBfault.1": "使能",
  "50901.fault.kmRelayfault.0": "不使能",
  "50901.fault.kmRelayfault.1": "使能",
  "50901.fault.twelveVoltPowerSupplyfault.1": "使能",
  "50901.fault.loadRelayAfault.1": "使能",
  "50901.fault.loadRelayBfault.0": "不使能",
  "50901.fault.loadRelayBfault.1": "使能",
  "50901.fault.pvRelayAbfault.0": "不使能",
  "50901.fault.pvRelayAbfault.1": "使能",
  "50901.fault.threePointThreeVoltPowerSupplyfault.0": "不使能",
  "50901.fault.threePointThreeVoltPowerSupplyfault.1": "使能",
  "50901.fault.twelveVoltPowerSupplyfault.0": "不使能",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2.0": "不使能",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3.1": "使能",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3.0": "不使能",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7.0": "不使能",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4.0": "不使能",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4.1": "使能",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2.1": "使能",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5.0": "不使能",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5.1": "使能",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1.1": "使能",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6.0": "不使能",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6.1": "使能",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1.0": "不使能",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7.1": "使能",
  "50901.fault.loadRelayAfault": "负载A继电器故障",
  "50901.fault.threePointThreeVoltPowerSupplyfault": "3.3V电源故障",
  "50901.fault.pvRelayAbfault": "光伏AB继电器故障",
  "50901.fault.twelveVoltPowerSupplyfault": "12V电源故障",
  "50901.fault.loadRelayBfault": "负载B继电器故障",
  "50901.fault.kmRelayfault": "KM继电器故障",
  "50901.fault.genRelayBfault": "发电机B继电器故障",
  "50901.fault.genRelayAfault": "发电机A继电器故障",
  "50901.fault.fiveVoltPowerSupplyfault": "5V电源故障",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek4": "发电机练习模式启动时间周四",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek3": "发电机练习模式启动时间周三",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek5": "发电机练习模式启动时间周五",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek6": "发电机练习模式启动时间周六",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek2": "发电机练习模式启动时间周二",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek7": "发电机练习模式启动时间周日",
  "50901.ctrl_Dry_Contact.Generator.genPracticeModeWeek1": "发电机练习模式启动时间周一",
  "50901.fault.evCharger1CommunicationAbnormality.0": "不使能",
  "50901.fault.evCharger1CommunicationAbnormality.1": "使能",
  "50901.fault.bmsCanCommunicationAbnormality.0": "不使能",
  "50901.fault.bmsCanCommunicationAbnormality.1": "使能",
  "50901.fault.dtu3Rs485CommunicationAbnormality.0": "不使能",
  "50901.fault.dtu3Rs485CommunicationAbnormality.1": "使能",
  "50901.fault.gridMeterTypeError.0": "不使能",
  "50901.fault.gridMeterTypeError.1": "使能",
  "50901.fault.lowDtuVersion.0": "不使能",
  "50901.fault.lowDtuVersion.1": "使能",
  "50901.fault.gridMeterCommunicationAbnormality.0": "不使能",
  "50901.fault.gridMeterCommunicationAbnormality.1": "使能",
  "50901.fault.pvMeterTypeError.0": "不使能",
  "50901.fault.pvMeterTypeError.1": "使能",
  "50901.fault.dspPwrCommunicationAbnormality.0": "不使能",
  "50901.fault.dspPwrCommunicationAbnormality.1": "使能",
  "50901.fault.evCharger2CommunicationAbnormality.0": "不使能",
  "50901.fault.evCharger2CommunicationAbnormality.1": "使能",
  "50901.fault.dtu5Rs485CommunicationAbnormality.0": "不使能",
  "50901.fault.dtu5Rs485CommunicationAbnormality.1": "使能",
  "50901.fault.dtsCommunicationAbnormality.0": "不使能",
  "50901.fault.dtsCommunicationAbnormality.1": "使能",
  "50901.fault.dtu4Rs485CommunicationAbnormality.0": "不使能",
  "50901.fault.dtu4Rs485CommunicationAbnormality.1": "使能",
  "50901.fault.dtu1Rs485CommunicationAbnormality.0": "不使能",
  "50901.fault.dtu1Rs485CommunicationAbnormality.1": "使能",
  "50901.fault.pvMeterCommunicationAbnormality.0": "不使能",
  "50901.fault.pvMeterCommunicationAbnormality.1": "使能",
  "50901.fault.slaveWrongBatteryConnection.0": "不使能",
  "50901.fault.slaveWrongBatteryConnection.1": "使能",
  "50901.fault.dtu2Rs485CommunicationAbnormality.0": "不使能",
  "50901.fault.dtu2Rs485CommunicationAbnormality.1": "使能",
  "50901.fault.dspSafCommunicationAbnormality.0": "不使能",
  "50901.fault.dspSafCommunicationAbnormality.1": "使能",
  "50901.fault.sustainedNegativeLoad.0": "不使能",
  "50901.fault.sustainedNegativeLoad.1": "使能",
  "50901.fault.hmidMachineFault.0": "不使能",
  "50901.fault.hmidMachineFault.1": "使能",
  "50901.fault.evCharger1Fault.0": "不使能",
  "50901.fault.evCharger1Fault.1": "使能",
  "50901.fault.evCharger2Fault.0": "不使能",
  "50901.fault.evCharger2Fault.1": "使能",
  "50901.fault.fanSpeedAbnormality.0": "不使能",
  "50901.fault.fanSpeedAbnormality.1": "使能",
  "50901.fault.masterSlaveCommunicationAbnormality.0": "不使能",
  "50901.fault.masterSlaveCommunicationAbnormality.1": "使能",
  "50901.fault.batteryCapacityAbnormality.0": "不使能",
  "50901.fault.batteryCapacityAbnormality.1": "使能",
  "50901.fault.batteryForceChargeRequest.0": "不使能",
  "50901.fault.batteryForceChargeRequest.1": "使能",
  "50901.fault.hmidCommunicationAbnormality.0": "不使能",
  "50901.fault.hmidCommunicationAbnormality.1": "使能",
  "50901.fault.batteryFault": "电池故障",
  "50901.fault.batteryFault.0": "不使能",
  "50901.fault.batteryFault.1": "使能",
  "50901.fault.evCharger1CommunicationAbnormality.desc": "电动汽车充电桩1通信异常的说明。",
  "50901.fault.bmsCanCommunicationAbnormality.desc": "BMS_CAN 通信异常的说明。",
  "50901.fault.dtu3Rs485CommunicationAbnormality.desc": "DTU3 RS485 通信异常的说明。",
  "50901.fault.gridMeterTypeError.desc": "电网电表类型错误的说明。",
  "50901.fault.lowDtuVersion.desc": "DTU版本过低的说明。",
  "50901.fault.gridMeterCommunicationAbnormality.desc": "电网电表通信异常的说明。",
  "50901.fault.pvMeterTypeError.desc": "光伏电表类型错误的说明。",
  "50901.fault.dspPwrCommunicationAbnormality.desc": "​DSP电源通信异常的说明。",
  "50901.fault.evCharger2CommunicationAbnormality.desc": "电动汽车充电桩2通信异常的说明。",
  "50901.fault.dtu5Rs485CommunicationAbnormality.desc": "DTU5 RS485 通信异常的说明。",
  "50901.fault.dtsCommunicationAbnormality.desc": "DTS 通信异常的说明。",
  "50901.fault.dtu4Rs485CommunicationAbnormality.desc": "DTU4 RS485 通信异常的说明。",
  "50901.fault.dtu1Rs485CommunicationAbnormality.desc": "DTU1 RS485 通信异常的说明。",
  "50901.fault.pvMeterCommunicationAbnormality.desc": "光伏电表通信异常的说明。",
  "50901.fault.slaveWrongBatteryConnection.desc": "从机电池连接错误的说明。",
  "50901.fault.dtu2Rs485CommunicationAbnormality.desc": "DTU2 RS485 通信异常的说明。",
  "50901.fault.dspSafCommunicationAbnormality.desc": "​DSP安全通信异常​的说明。",
  "50901.fault.sustainedNegativeLoad.desc": "持续负负载的说明。",
  "50901.fault.hmidMachineFault.desc": "人机交互界面设备故障的说明。",
  "50901.fault.evCharger1Fault.desc": "充电桩1故障的说明。",
  "50901.fault.evCharger2Fault.desc": "充电桩2故障的说明。",
  "50901.fault.fanSpeedAbnormality.desc": "风扇转速异常的说明。",
  "50901.fault.batteryFault.desc": "电池故障的说明。",
  "50901.fault.masterSlaveCommunicationAbnormality.desc": "主从通信异常的说明。",
  "50901.fault.batteryCapacityAbnormality.desc": "电池容量异常的说明。",
  "50901.fault.batteryForceChargeRequest.desc": "电池强制充电请求的说明。",
  "50901.fault.hmidCommunicationAbnormality.desc": "人机交互界面通信异常的说明。",
  "50901.fault.evCharger1CommunicationAbnormality.00": "不使能",
  "50901.fault.evCharger1CommunicationAbnormality.01": "使能",
  "50901.fault.bmsCanCommunicationAbnormality.00": "不使能",
  "50901.fault.bmsCanCommunicationAbnormality.01": "使能",
  "50901.fault.dtu3Rs485CommunicationAbnormality.00": "不使能",
  "50901.fault.dtu3Rs485CommunicationAbnormality.01": "使能",
  "50901.fault.gridMeterTypeError.00": "不使能",
  "50901.fault.gridMeterTypeError.01": "使能",
  "50901.fault.lowDtuVersion.00": "不使能",
  "50901.fault.lowDtuVersion.01": "使能",
  "50901.fault.gridMeterCommunicationAbnormality.00": "不使能",
  "50901.fault.gridMeterCommunicationAbnormality.01": "使能",
  "50901.fault.pvMeterTypeError.00": "不使能",
  "50901.fault.pvMeterTypeError.01": "使能",
  "50901.fault.dspPwrCommunicationAbnormality.00": "不使能",
  "50901.fault.dspPwrCommunicationAbnormality.01": "使能",
  "50901.fault.evCharger2CommunicationAbnormality.00": "不使能",
  "50901.fault.evCharger2CommunicationAbnormality.01": "使能",
  "50901.fault.dtu5Rs485CommunicationAbnormality.00": "不使能",
  "50901.fault.dtu5Rs485CommunicationAbnormality.01": "使能",
  "50901.fault.dtsCommunicationAbnormality.00": "不使能",
  "50901.fault.dtsCommunicationAbnormality.01": "使能",
  "50901.fault.dtu4Rs485CommunicationAbnormality.00": "不使能",
  "50901.fault.dtu4Rs485CommunicationAbnormality.01": "使能",
  "50901.fault.dtu1Rs485CommunicationAbnormality.00": "不使能",
  "50901.fault.dtu1Rs485CommunicationAbnormality.01": "使能",
  "50901.fault.pvMeterCommunicationAbnormality.00": "不使能",
  "50901.fault.pvMeterCommunicationAbnormality.01": "使能",
  "50901.fault.slaveWrongBatteryConnection.00": "不使能",
  "50901.fault.slaveWrongBatteryConnection.01": "使能",
  "50901.fault.dtu2Rs485CommunicationAbnormality.00": "不使能",
  "50901.fault.dtu2Rs485CommunicationAbnormality.01": "使能",
  "50901.fault.dspSafCommunicationAbnormality.00": "不使能",
  "50901.fault.dspSafCommunicationAbnormality.01": "使能",
  "50901.fault.sustainedNegativeLoad.00": "不使能",
  "50901.fault.sustainedNegativeLoad.01": "使能",
  "50901.fault.hmidMachineFault.00": "不使能",
  "50901.fault.hmidMachineFault.01": "使能",
  "50901.fault.evCharger1Fault.00": "不使能",
  "50901.fault.evCharger1Fault.01": "使能",
  "50901.fault.evCharger2Fault.00": "不使能",
  "50901.fault.evCharger2Fault.01": "使能",
  "50901.fault.fanSpeedAbnormality.00": "不使能",
  "50901.fault.fanSpeedAbnormality.01": "使能",
  "50901.fault.batteryFault.00": "不使能",
  "50901.fault.batteryFault.01": "使能",
  "50901.fault.masterSlaveCommunicationAbnormality.00": "不使能",
  "50901.fault.masterSlaveCommunicationAbnormality.01": "使能",
  "50901.fault.batteryCapacityAbnormality.00": "不使能",
  "50901.fault.batteryCapacityAbnormality.01": "使能",
  "50901.fault.batteryForceChargeRequest.00": "不使能",
  "50901.fault.batteryForceChargeRequest.01": "使能",
  "50901.fault.hmidCommunicationAbnormality.00": "不使能",
  "50901.fault.hmidCommunicationAbnormality.01": "使能",
  "alarm.excDesc.2047494139783155712": "ARM通讯故障",
  "alarm.name.2047494139783155712": "ARM通讯故障",
  "alarm.excDesc.1982704393965015040": "PV短路告警",
  "alarm.suggestion.1982704393965015040": "关机后检查组件电压是否正常，重启不能恢复的话，说明逆变器内部故障",
  "alarm.excDesc.1982723579764281344": "驱动故障",
  "alarm.suggestion.1982723579764281344": "1，驱动电路故障\n2、断电重启逆变器，如不能恢复，请联系经销商",
  "alarm.desc.1982723579764281344": "\\",
  "alarm.excDesc.1982723418367463424": "绝缘检测故障",
  "alarm.suggestion.1982723418367463424": "1，检查组件是否对地短路\n2，检查直流是否有虚接现象\n3、确定直流没有问题的话，断电5分钟后，重新送电，如不能恢复，请联系经销商",
  "alarm.desc.1982723418367463424": "\\",
  "alarm.name.2042270101758898176": "PCS自检故障",
  "alarm.excDesc.1982733139698782208": "电压超范围告警",
  "alarm.suggestion.1982733139698782208": "1.如偶然出现， 为电网瞬时出现异常，电网复\n常后逆变器会恢复正常工作；\n2.如频繁报此故障， 请检查电网是否异常。",
  "alarm.name.2042270204868263936": "电表自检故障",
  "alarm.name.2042270275135438848": "MOS自检故障",
  "alarm.excDesc.1982729954783399936": "漏电流自检故障",
  "alarm.suggestion.1982729954783399936": "请将逆变器关机并断开输入输出开关，5分钟后重启逆变器，若故障未能清除，请联系经销商。",
  "alarm.desc.1982729954783399936": "\\",
  "device.dryWorking": "干节点设置",
  "51102.real_time.mod_battGrp_soc": "电池组SOC",
  "51102.real_time.cell_max_temp": "单体最高温度",
  "51102.s\\real_time.inverterTemp": "PFC散热器温度",
  "51102.s\\real_time.dcdcTemp": "DC散热器温度1",
  "51102.s\\real_time.batteryPower": "电池侧功率",
  "51102.s\\real_time.mod_PV_to_Grid_P": "PV流向并网口的馈网功率",
  "51102.s\\real_time.gridPower": "网侧入户电表功率",
  "51102.s\\real_time.powerGeneration": "总发电量",
  "51102.s\\real_time.batteryDischargePower": "电池累计放电电量",
  "51102.s\\real_time.batteryChargePower": "电池累计充电电量",
  "51102.m\\real_time.gridBuyPower": "并机下累计买电电量",
  "51102.m\\real_time.gridSellPower": "并机下累计卖电电量",
  "51102.m\\real_time.tot_batt_acc_dischg_energy": "并机下电池累计放电电量",
  "51102.m\\real_time.tot_batt_acc_chg_energy": "并机下电池累计充电电量",
  "51102.m_w\\ctl_EMS.PSVFMode_date": "削峰填谷模式应用日期",
  "51102.m_w\\ctl_EMS.s_chg_time1": "充电时段1",
  "51102.m_w\\ctl_EMS.s_dischg_time1": "放电时段1",
  "51102.m_w\\ctl_EMS.s_chg_time2": "充电时段2",
  "51102.m_w\\ctl_EMS.s_dischg_time2": "放电时段2",
  "51102.m_w\\ctl_EMS.s_chg_time3": "充电时段3",
  "51102.m_w\\ctl_EMS.s_dischg_time3": "放电时段3",
  "51102.m_w\\ctl_EMS.s_chg_time4": "充电时段4",
  "51102.m_w\\ctl_EMS.s_dischg_time4": "放电时段4",
  "51102.m_w\\ctl_EMS.s_chg_time5": "充电时段5",
  "51102.m_w\\ctl_EMS.s_dischg_time5": "放电时段5",
  "51102.m_w\\ctl_EMS.s_chg_time6": "充电时段6",
  "51102.m_w\\ctl_EMS.s_dischg_time6": "放电时段6",
  "51102.m_w\\ctl_EMS.TOU_chg_time1": "TOU充电时段1",
  "51102.m_w\\ctl_EMS.TOU_dischg_time1": "TOU放电时段1",
  "51102.m_w\\ctl_EMS.TOU_chg_time2": "TOU充电时段2",
  "51102.m_w\\ctl_EMS.TOU_dischg_time2": "TOU放电时段2",
  "51102.m_w\\ctl_EMS.TOU_chg_time3": "TOU充电时段3",
  "51102.m_w\\ctl_EMS.TOU_dischg_time3": "TOU放电时段3",
  "51102.m_w\\ctl_EMS.TOU_chg_time4": "TOU充电时段4",
  "51102.m_w\\ctl_EMS.TOU_dischg_time4": "TOU放电时段4",
  "51102.m_w\\ctl_EMS.TOU_chg_time5": "TOU充电时段5",
  "51102.m_w\\ctl_EMS.TOU_dischg_time5": "TOU放电时段5",
  "51102.m_w\\ctl_EMS.TOU_chg_time6": "TOU充电时段6",
  "51102.m_w\\ctl_EMS.TOU_dischg_time6": "TOU放电时段6",
  "51102.s\\elct_meter.grid_active_energy_forward": "网侧电表正向有功电能",
  "51102.s\\elct_meter.grid_active_energy_reverse": "网侧电表反向有功电能",
  "51102.s\\elct_meter.gridPower_from_elct_meter": "网侧电表有功功率",
  "51102.real_time": "实时监控",
  "51102.real_time.数据分析_电池.tag": "电池",
  "Other": "其他",
  "51101.s\\collector.c_firmwareversion": "采集器软件版本号",
  "51101.s\\collector.c_hardversion": "采集器硬件版本",
  "51101.s\\collector.c_protocalver": "设备通信协议版本",
  "51101.s\\collector.c_mqtts_protocalver": "mqtts通信协议版本",
  "51101.s\\collector.c_ble_protocalver": "蓝牙通信协议版本",
  "51101.s\\collector.c_wifi_rssi": "WIFI信号强度",
  "51101.s\\collector.checkTime": "系统时间",
  "51101.s\\collector.c_wifi_ssid": "WIFI名称",
  "51101.s\\collector.c_wifi_passwd": "WIFI密码",
  "51101.s\\collector.c_ble_name": "BLE名称",
  "51101.s\\collector.c_mqtts_url": "服务器url",
  "51101.s\\collector.c_mqtts_port": "服务器端口号",
  "51101.s\\collector.otaHttpUrl": "升级包url",
  "51101.s\\collector.c_firmware_len": "升级包长度",
  "51101.s\\collector.c_sha256": "升级包SHA256",
  "51101.s\\collector.c_datalogger_reboot": "采集器重启",
  "51101.s\\collector.c_datalogger_factory_reset": "采集器恢复出厂设置",
  "51101.s\\collector.c_datalogger_ble_onoff": "蓝牙使能",
  "51101.s\\collector.c_eletMeter1_sn": "电表1SN",
  "51101.s\\collector.c_eletMeter1_insPlace": "电表1安装位置",
  "51101.s\\collector.c_eletMeter1_commType": "电表1通信方式",
  "51101.s\\collector.c_eletMeter1_phaseNo": "电网侧设备安装相位",
  "51101.s\\collector.c_eletMeter2_sn": "电表2SN",
  "51101.s\\collector.c_eletMeter2_insPlace": "电表2安装位置",
  "51101.s\\collector.c_eletMeter2_commType": "电表2通信方式",
  "51101.s\\collector.c_eletMeter2_phaseNo": "AC微逆侧设备安装相位",
  "51101.s\\real_time.dev_series": "设备型号",
  "51101.s\\real_time.dev_type": "设备类型",
  "51101.s\\real_time.Protocol_type": "协议类型",
  "51101.s\\real_time.protocol_ver": "协议版本",
  "51101.s\\real_time.manu_info": "厂家信息",
  "51101.s\\real_time.SN": "产品SN",
  "51101.s\\real_time.softver1": "软件版本1",
  "51101.s\\real_time.softver2": "软件版本2",
  "51101.s\\real_time.hardver1": "硬件版本1",
  "51101.s\\real_time.hardver2": "硬件版本2",
  "51101.s\\real_time.softnumber1": "软件编码1",
  "51101.s\\real_time.softnumber2": "软件编码2",
  "51101.s\\real_time.battcorecnt": "电芯个数",
  "51101.s\\real_time.battcoretmpcnt": "电芯温度个数",
  "51101.s\\real_time.ratedpower": "额定功率",
  "51101.s\\real_time.bms_status": "BMS状态字",
  "51101.s\\real_time.bms_total_v": "电池组总电压",
  "51101.s\\real_time.bms_total_I": "电池组总电流",
  "51101.s\\real_time.batterySoc": "电池组SOC",
  "51101.s\\real_time.bms_total_SOH": "电池组SOH",
  "51101.s\\real_time.chg_full_time": "预计充满时间",
  "51101.s\\real_time.dischg_time": "剩余放电时间",
  "51101.s\\real_time.cell_max_v": "单体最高电压",
  "51101.s\\real_time.cell_min_v": "单体最低电压",
  "51101.s\\real_time.cell_max_v_id": "最高单体电池电压编号",
  "51101.s\\real_time.cell_min_v_id": "最低单体电池电压编号",
  "51101.s\\real_time.cell_max_temp": "单体最高温度",
  "51101.s\\real_time.cell_min_temp": "单体最低温度",
  "51101.s\\real_time.cell_max_temp_id": "最高单体电池温度编号",
  "51101.s\\real_time.cell_min_temp_id": "最低单体电池温度编号",
  "51101.s\\real_time.batt_SOP": "电池组SOP",
  "51101.s\\real_time.batt_type": "电池类型",
  "51101.s\\real_time.batt_rated_Q": "单体电池额定容量",
  "51101.s\\real_time.cell_1_v": "电芯1电压",
  "51101.s\\real_time.cell_2_v": "电芯2电压",
  "51101.s\\real_time.cell_3_v": "电芯3电压",
  "51101.s\\real_time.cell_4_v": "电芯4电压",
  "51101.s\\real_time.cell_5_v": "电芯5电压",
  "51101.s\\real_time.cell_1_temp": "电芯1温度",
  "51101.s\\real_time.cell_2_temp": "电芯2温度",
  "51101.s\\real_time.cell_3_temp": "电芯3温度",
  "51101.s\\real_time.cell_4_temp": "电芯4温度",
  "51101.s\\real_time.cell_5_temp": "电芯5温度",
  "51101.s\\real_time.batt_term_tmp": "极柱温度",
  "51101.s\\real_time.batt_copper_temp": "铜排温度",
  "51101.s\\real_time.dischg_mos_tmp": "放电MOS温度",
  "51101.s\\real_time.chg_mos_tmp": "充电MOS温度",
  "51101.s\\real_time.palnetif_v": "并网口电压",
  "51101.s\\real_time.palnetif_I": "并网口电流",
  "51101.s\\real_time.palnetif_f": "并网口频率",
  "51101.s\\real_time.palnetif_P": "并网口有功功率",
  "51101.s\\real_time.palnetif_Q": "并网口无功功率",
  "51101.s\\real_time.palnetif_S": "并网口视在功率",
  "51101.s\\real_time.palnetif_PF": "并网口功率因数",
  "51101.s\\real_time.eps_v": "ESP口电压",
  "51101.s\\real_time.eps_I": "ESP口电流",
  "51101.s\\real_time.eps_f": "ESP口频率",
  "51101.s\\real_time.eps_P": "ESP口有功功率",
  "51101.s\\real_time.eps_Q": "ESP口无功功率",
  "51101.s\\real_time.eps_S": "ESP口视在功率",
  "51101.s\\real_time.eps_PF": "ESP口功率因数",
  "51101.s\\real_time.batt_v": "电池电压",
  "51101.s\\real_time.batt_I": "电池电流",
  "51101.s\\real_time.batt_P": "电池功率",
  "51101.s\\real_time.chg_v": "充电电压",
  "51101.s\\real_time.chg_I": "充电电流",
  "51101.s\\real_time.chg_P": "充电功率",
  "51101.s\\real_time.pv1_input_v": "PV1输入电压",
  "51101.s\\real_time.pv1_input_I": "PV1输入电流",
  "51101.s\\real_time.pv1_input_P": "PV1输入功率",
  "51101.s\\real_time.pv1_output_v": "PV1输出电压",
  "51101.s\\real_time.pv1_output_I": "PV1输出电流",
  "51101.s\\real_time.pv1_output_P": "PV1输出功率",
  "51101.s\\real_time.pv2_input_v": "PV2输入电压",
  "51101.s\\real_time.pv2_input_I": "PV2输入电流",
  "51101.s\\real_time.pv2_input_P": "PV2输入功率",
  "51101.s\\real_time.pv2_output_v": "PV2输出电压",
  "51101.s\\real_time.pv2_output_I": "PV2输出电流",
  "51101.s\\real_time.pv2_output_P": "PV2输出功率",
  "51101.s\\real_time.pv3_input_v": "PV3输入电压",
  "51101.s\\real_time.pv3_input_I": "PV3输入电流",
  "51101.s\\real_time.pv3_input_P": "PV3输入功率",
  "51101.s\\real_time.pv3_output_v": "PV3输出电压",
  "51101.s\\real_time.pv3_output_I": "PV3输出电流",
  "51101.s\\real_time.pv3_output_P": "PV3输出功率",
  "51101.s\\real_time.pv4_input_v": "PV4输入电压",
  "51101.s\\real_time.pv4_input_I": "PV4输入电流",
  "51101.s\\real_time.pv4_input_P": "PV4输入功率",
  "51101.s\\real_time.pv4_output_v": "PV4输出电压",
  "51101.s\\real_time.pv4_output_I": "PV4输出电流",
  "51101.s\\real_time.pv4_output_P": "PV4输出功率",
  "51101.s\\real_time.env_temp_1": "环境温度1",
  "51101.s\\real_time.env_temp_2": "环境温度2",
  "51101.s\\real_time.PFC_temp": "PFC散热器温度",
  "51101.s\\real_time.DC_temp1": "DC散热器温度1",
  "51101.s\\real_time.DC_temp2": "DC散热器温度2",
  "51101.s\\real_time.PV1_temp": "PV1散热器温度",
  "51101.s\\real_time.PV2_temp": "PV2散热器温度",
  "51101.s\\real_time.PV3_temp": "PV3散热器温度",
  "51101.s\\real_time.PV4_temp": "PV4散热器温度",
  "51101.s\\real_time.bus_v": "母线电压",
  "51101.s\\real_time.anti_curr_status": "防逆流功能状态",
  "51101.s\\real_time.low_volt_cross_status": "低电压穿越功能状态",
  "51101.s\\real_time.f_cross_status": "频率穿越功能状态",
  "51101.s\\real_time.reconn_cross_status": "并网重连功能状态",
  "51101.s\\real_time.inv_ver": "逆变器软件版本",
  "51101.s\\real_time.inv_hard_ver": "逆变器硬件版本",
  "51101.s\\real_time.inv_profile": "逆变器国家规格",
  "51101.s\\real_time.inv_manufac": "逆变器厂家信息",
  "51101.s\\real_time.inv_SN": "逆变器序列号",
  "51101.s\\real_time.deviceStatus": "微储状态",
  "51101.s\\real_time.Wifi_BT_Online": "wifi/蓝牙在线状态",
  "51101.s\\real_time.Wifi_BT_Sleep": "wifi/蓝牙休眠",
  "51101.s\\real_time.workStatus": "系统工作状态",
  "51101.s\\real_time.workMode": "工作模式",
  "51101.s\\real_time.parelletRunStatue": "并机状态",
  "51101.s\\real_time.acDischargeMode": "AC放电状态",
  "51101.s\\real_time.acchargeStatus": "AC充电状态",
  "51101.s\\real_time.MPPTStatus": "MPPT状态",
  "51101.s\\real_time.SleepStatus": "系统休眠状态",
  "51101.s\\real_time.gridConnStatus": "并离网状态",
  "51101.s\\real_time.antiReverseIStatus": "防逆流状态",
  "51101.s\\real_time.masterOrSlaveStatus": "主从机状态",
  "51101.s\\real_time.EPSConnStatus": "EPS接入状态",
  "51101.s\\real_time.remote_onoff_status": "远程开关机状态",
  "51101.s\\real_time.shunt_trip_status": "分励脱扣器状态",
  "51101.s\\real_time.mod_grid_P": "并网口功率",
  "51101.s\\real_time.mod_PV_P": "PV发电功率",
  "51101.s\\real_time.mod_batteryPower": "电池侧功率",
  "51101.s\\real_time.mod_EPS_P": "EPS口功率",
  "51101.s\\real_time.mod_batt2Grid_P": "电池流向并网口的馈网功率",
  "51101.s\\real_time.mod_batt2EPS_P": "电池流向EPS负载的功率",
  "51101.s\\real_time.mod_PV2Batt_P": "PV流向电池的功率",
  "51101.s\\real_time.mod_PV2EPS_P": "PV流向EPS负载的功率",
  "51101.s\\real_time.mod_PV2Grid_P": "PV流向并网口的馈网功率",
  "51101.s\\real_time.mod_Grid2Batt_P": "并网口流向电池的功率",
  "51101.s\\real_time.mod_Grid2EPS_P": "并网口流向EPS负载的功率",
  "51101.s\\real_time.mod_inv2Grid_P": "EPS微逆流向并网口的功率",
  "51101.s\\real_time.mod_EPS2Batt_P": "EPS微逆流向电池的功率",
  "51101.s\\real_time.mod_GridElctMeter_P": "网侧入户电表功率",
  "51101.s\\real_time.mod_ACElctMeter_P": "AC微逆电表功率",
  "51101.s\\real_time.acc_buy_energy": "累计买电电量",
  "51101.s\\real_time.acc_sell_energy": "累计卖电电量",
  "51101.s\\real_time.acc_PV_prod_energy": "光伏PV总发电量",
  "51101.s\\real_time.acc_EPS_prod_energy": "EPS微逆总发电量",
  "51101.s\\real_time.acc_AC_prod_energy": "AC微逆总发电量",
  "51101.s\\real_time.acc_load_use_enery": "负载累计用电量",
  "51101.s\\real_time.acc_bat_dischg_enery": "电池累计放电电量",
  "51101.s\\real_time.acc_bat_chg_enery": "电池累计充电电量",
  "51101.s\\real_time.acc_PV2Bat_E": "光伏PV流向电池的总电量",
  "51101.s\\real_time.acc_PV2Load_E": "光伏PV流向负载的总电量",
  "51101.s\\real_time.acc_PV2grid_E": "光伏PV流向电网的总电量",
  "51101.s\\real_time.acc_EPS_load_E": "ESP负载累计用电量",
  "51101.s\\real_time.today_buy_E": "今日买电电量",
  "51101.s\\real_time.today_sell_E": "今日卖电电量",
  "51101.s\\real_time.today_PV_E": "光伏PV今日累计发电量",
  "51101.s\\real_time.today_EPS_E": "EPS微逆今日累计发电量",
  "51101.s\\real_time.today_AC_E": "AC微逆今日累计发电量",
  "51101.s\\real_time.today_BattDischg_E": "电池今日放电电量",
  "51101.s\\real_time.today_Battchg_E": "电池今日充电电量",
  "51101.s\\real_time.today_PV2Batt_E": "光伏PV今日流向电池电量",
  "51101.s\\real_time.today_PV2Load_E": "光伏PV今日流向负载电量",
  "51101.s\\real_time.today_PV2Grid_E": "光伏PV今日流向电网电量",
  "51101.s\\real_time.mon_buy_E": "本月买电电量",
  "51101.s\\real_time.mon_sell_E": "本月卖电电量",
  "51101.s\\real_time.mon_PV_E": "光伏PV本月累计发电量",
  "51101.s\\real_time.mon_EPS_E": "EPS微逆本月累计发电量",
  "51101.s\\real_time.mon_AC_E": "AC微逆本月累计发电量",
  "51101.s\\real_time.mon_BattDischg_E": "电池本月放电电量",
  "51101.s\\real_time.mon_Battchg_E": "电池本月充电电量",
  "51101.s\\real_time.mon_PV2Batt_E": "光伏PV本月流向电池电量",
  "51101.s\\real_time.mon_PV2Load_E": "光伏PV本月流向负载电量",
  "51101.s\\real_time.mon_PV2Grid_E": "光伏PV本月流向电网电量",
  "51101.s\\real_time.year_buy_E": "年度买电电量",
  "51101.s\\real_time.year_sell_E": "年度卖电电量",
  "51101.s\\real_time.year_PV_E": "光伏PV年度累计发电量",
  "51101.s\\real_time.year_EPS_E": "EPS微逆年度累计发电量",
  "51101.s\\real_time.year_AC_E": "AC微逆年度累计发电量",
  "51101.s\\real_time.year_BattDischg_E": "电池年度放电电量",
  "51101.s\\real_time.year_Battchg_E": "电池年度充电电量",
  "51101.s\\real_time.year_PV2Batt_E": "光伏PV年度流向电池电量",
  "51101.s\\real_time.year_PV2Load_E": "光伏PV年度流向负载电量",
  "51101.s\\real_time.year_PV2Grid_E": "光伏PV年度流向电网电量",
  "51101.s\\real_time.parallel_status": "并机工作状态",
  "51101.s\\real_time.parallel_cnt": "并机台数",
  "51101.s\\real_time.parallel_ID": "并机台数",
  "51101.s\\real_time.parallel_isMaster": "并机主从机",
  "51101.m\\real_time.all_mod_tot_grid_P": "并机下并网口总功率",
  "51101.m\\real_time.all_mod_tot_PV_P": "并机下PV发电总功率",
  "51101.m\\real_time.batteryPower": "并机下电池侧总功率",
  "51101.m\\real_time.all_mod_tot_EPS_P": "并机下EPS口总功率",
  "51101.m\\real_time.all_mod_tot_batt2Grid_P": "并机下电池流向并网口的馈网总功率",
  "51101.m\\real_time.all_mod_tot_batt2EPS_P": "并机下电池流向EPS负载的总功率",
  "51101.m\\real_time.all_mod_tot_PV2Batt_P": "并机下PV流向电池的总功率",
  "51101.m\\real_time.all_mod_tot_PV2EPS_P": "并机下PV流向EPS负载的总功率",
  "51101.m\\real_time.all_mod_tot_PV2Grid_P": "并机下PV流向并网口的馈网总功率",
  "51101.m\\real_time.all_mod_tot_Grid2Batt_P": "并机下并网口流向电池的总功率",
  "51101.m\\real_time.all_mod_tot_Grid2EPS_P": "并机下并网口流向EPS负载的总功率",
  "51101.m\\real_time.all_mod_tot_inv2Grid_P": "并机下EPS微逆流向并网口的总功率",
  "51101.m\\real_time.all_mod_tot_EPS2Batt_P": "并机下EPS微逆流向电池的总功率",
  "51101.m\\real_time.all_mod_tot_GridElctMeter_P": "网侧入户电表功率",
  "51101.m\\real_time.all_mod_tot_ACElctMeter_P": "AC微逆电表功率",
  "51101.m\\real_time.all_mod_tot_buy_E": "并机下累计买电电量",
  "51101.m\\real_time.all_mod_tot_sell_E": "并机下累计卖电电量",
  "51101.m\\real_time.p_acc_PV_prod_energy": "并机下光伏PV总发电量",
  "51101.m\\real_time.p_acc_EPS_prod_energy": "并机下EPS微逆总发电量",
  "51101.m\\real_time.p_acc_AC_prod_energy": "并机下AC微逆总发电量",
  "51101.m\\real_time.p_acc_load_use_enery": "并机下负载累计用电量",
  "51101.m\\real_time.batteryDischargePower": "并机下电池累计放电电量",
  "51101.m\\real_time.batteryChargerPower": "并机下电池累计充电电量",
  "51101.m\\real_time.p_acc_PV2Bat_E": "并机下光伏PV流向电池的总电量",
  "51101.m\\real_time.p_acc_PV2Load_E": "并机下光伏PV流向负载的总电量",
  "51101.m\\real_time.p_acc_PV2grid_E": "并机下光伏PV流向电网的总电量",
  "51101.m\\real_time.p_acc_EPS_load_E": "并机下ESP负载累计用电量",
  "51101.m\\real_time.p_today_buy_E": "并机下今日买电电量",
  "51101.m\\real_time.p_today_sell_E": "并机下今日卖电电量",
  "51101.m\\real_time.p_today_PV_E": "并机下光伏PV今日累计发电量",
  "51101.m\\real_time.p_today_EPS_E": "并机下EPS微逆今日累计发电量",
  "51101.m\\real_time.p_today_AC_E": "并机下AC微逆今日累计发电量",
  "51101.m\\real_time.p_today_BattDischg_E": "并机下电池今日放电电量",
  "51101.m\\real_time.p_today_Battchg_E": "并机下电池今日充电电量",
  "51101.m\\real_time.p_today_PV2Batt_E": "并机下光伏PV今日流向电池电量",
  "51101.m\\real_time.p_today_PV2Load_E": "并机下光伏PV今日流向负载电量",
  "51101.m\\real_time.p_today_PV2Grid_E": "并机下光伏PV今日流向电网电量",
  "51101.m\\real_time.p_mon_buy_E": "并机下本月买电电量",
  "51101.m\\real_time.p_mon_sell_E": "并机下本月卖电电量",
  "51101.m\\real_time.p_mon_PV_E": "并机下光伏PV本月累计发电量",
  "51101.m\\real_time.p_mon_EPS_E": "并机下EPS微逆本月累计发电量",
  "51101.m\\real_time.p_mon_AC_E": "并机下AC微逆本月累计发电量",
  "51101.m\\real_time.p_mon_BattDischg_E": "并机下电池本月放电电量",
  "51101.m\\real_time.p_mon_Battchg_E": "并机下电池本月充电电量",
  "51101.m\\real_time.p_mon_PV2Batt_E": "并机下光伏PV本月流向电池电量",
  "51101.m\\real_time.p_mon_PV2Load_E": "并机下光伏PV本月流向负载电量",
  "51101.m\\real_time.p_mon_PV2Grid_E": "并机下光伏PV本月流向电网电量",
  "51101.m\\real_time.p_year_buy_E": "并机下年度买电电量",
  "51101.m\\real_time.p_year_sell_E": "并机下年度卖电电量",
  "51101.m\\real_time.p_year_PV_E": "并机下光伏PV年度累计发电量",
  "51101.m\\real_time.p_year_EPS_E": "并机下EPS微逆年度累计发电量",
  "51101.m\\real_time.p_year_AC_E": "并机下AC微逆年度累计发电量",
  "51101.m\\real_time.p_year_BattDischg_E": "并机下电池年度放电电量",
  "51101.m\\real_time.p_year_Battchg_E": "并机下电池年度充电电量",
  "51101.m\\real_time.p_year_PV2Batt_E": "并机下光伏PV年度流向电池电量",
  "51101.m\\real_time.p_year_PV2Load_E": "并机下光伏PV年度流向负载电量",
  "51101.m\\real_time.p_year_PV2Grid_E": "并机下光伏PV年度流向电网电量",
  "51101.s\\real_time.EPS_status": "EPS微逆状态",
  "51101.s\\real_time.EPS_total_power_time": "EPS微逆总发电时长",
  "51101.s\\real_time.EPS_today_power_time": "EPS微逆今日发电时长",
  "51101.s\\real_time.EPS_volt": "EPS微逆电压",
  "51101.s\\real_time.EPS_I": "EPS微逆电流",
  "51101.s\\real_time.EPS_freq": "EPS微逆频率",
  "51101.s\\real_time.EPS_P": "EPS微逆有功功率",
  "51101.s\\real_time.EPS_S": "EPS微逆视在功率",
  "51101.s\\real_time.EPS_Q": "EPS微逆无功功率",
  "51101.s\\real_time.EPS_PF": "EPS微逆功率因数",
  "51101.s\\real_time.PV1_online_status": "PV1在位状态",
  "51101.s\\real_time.PV2_online_status": "PV2在位状态",
  "51101.s\\real_time.PV3_online_status": "PV3在位状态",
  "51101.s\\real_time.PV4_online_status": "PV4在位状态",
  "51101.s\\real_time.PV_total_P": "PV实时总功率",
  "51101.s\\real_time.PV_total_time": "PV总发电时长",
  "51101.s\\real_time.PV_today_time": "PV今日发电时长",
  "51101.s\\real_time.PV1_V": "PV1实时电压",
  "51101.s\\real_time.PV1_I": "PV1实时电流",
  "51101.s\\real_time.PV1_P": "PV1实时功率",
  "51101.s\\real_time.PV2_V": "PV2实时电压",
  "51101.s\\real_time.PV2_I": "PV2实时电流",
  "51101.s\\real_time.PV2_P": "PV2实时功率",
  "51101.s\\real_time.PV3_V": "PV3实时电压",
  "51101.s\\real_time.PV3_I": "PV3实时电流",
  "51101.s\\real_time.PV3_P": "PV3实时功率",
  "51101.s\\real_time.PV4_V": "PV4实时电压",
  "51101.s\\real_time.PV4_I": "PV4实时电流",
  "51101.s\\real_time.PV4_P": "PV4实时功率",
  "51101.s\\real_time.PV1_positive_temp": "PV1+温度",
  "51101.s\\real_time.PV1_negative_temp": "PV1-温度",
  "51101.s\\real_time.PV2_positive_temp": "PV2+温度",
  "51101.s\\real_time.PV2_negative_temp": "PV2-温度",
  "51101.s\\real_time.PV3_positive_temp": "PV3+温度",
  "51101.s\\real_time.PV3_negative_temp": "PV3-温度",
  "51101.s\\real_time.PV4_positive_temp": "PV4+温度",
  "51101.s\\real_time.PV4_negative_temp": "PV4-温度",
  "51101.s_w\\ctl_BMS.env_max_temp_alrm": "环境高温告警",
  "51101.s_w\\ctl_BMS.env_min_temp_alrm": "环境低温告警",
  "51101.s_w\\ctl_BMS.cell_level_1_overtmp_chg": "电芯一级过温告警(充电)",
  "51101.s_w\\ctl_BMS.cell_level_1_lowtmp_chg": "电芯一级低温告警(充电)",
  "51101.s_w\\ctl_BMS.cell_level_1_overtmp_dischg": "电芯一级过温告警(放电)",
  "51101.s_w\\ctl_BMS.cell_level_1_lowtmp_dischg": "电芯一级低温告警(放电)",
  "51101.s_w\\ctl_BMS.cell_level_1_overtmp_protect": "电芯一级过温保护(充电)",
  "51101.s_w\\ctl_BMS.cell_level_2_overtmp_protect": "电芯二级过温保护(充电)",
  "51101.s_w\\ctl_BMS.cell_level_1_lowtmp_protect": "电芯一级低温保护(充电)",
  "51101.s_w\\ctl_BMS.cell_level_2_lowtmp_protect": "电芯二级低温保护(充电)",
  "51101.s_w\\ctl_BMS.cell_level_1_overtmp_protect_dischg": "电芯一级过温保护(放电)",
  "51101.s_w\\ctl_BMS.cell_level_2_overtmp_protect_dischg": "电芯二级过温保护(放电)",
  "51101.s_w\\ctl_BMS.cell_level_1_lowtmp_protect_dischg": "电芯一级低温保护(放电)",
  "51101.s_w\\ctl_BMS.cell_level_2_lowtmp_protect_dischg": "电芯二级低温保护(放电)",
  "51101.s_w\\ctl_BMS.env_overtmp_protect": "环境高温保护",
  "51101.s_w\\ctl_BMS.env_lowtmp_protect": "环境低温保护",
  "51101.s_w\\ctl_BMS.mos_overtmp_alarm": "MOS温度高温告警",
  "51101.s_w\\ctl_BMS.mos_overtmp_protect": "MOS温度高温保护",
  "51101.s_w\\ctl_BMS.batt_avg_volt_high_protect": "电芯组均压高保护",
  "51101.s_w\\ctl_BMS.batt_overvolt_protect": "电芯高压保护",
  "51101.s_w\\ctl_BMS.batt_avg_volt_low_protect": "电芯组均压低保护",
  "51101.s_w\\ctl_BMS.batt_lowvolt_protect": "电芯低压保护",
  "51101.s_w\\ctl_BMS.cell_diffvolt_toohigh_protect": "电芯压差过大保护",
  "51101.s_w\\ctl_BMS.batt_avgvolt_high_alarm": "电芯组均压高告警",
  "51101.s_w\\ctl_BMS.cell_highvolt_alarm": "电芯高压告警",
  "51101.s_w\\ctl_BMS.batt_avgvolt_low_alarm": "电芯组均压低告警",
  "51101.s_w\\ctl_BMS.cell_lowVolt_alarm": "电芯低压告警",
  "51101.s_w\\ctl_BMS.soc_low_alarm": "电量低告警",
  "51101.s_w\\ctl_BMS.cell_unavail": "电芯单体失效",
  "51101.s_w\\ctl_BMS.cell_diffvolt_toohigh_alrm": "电芯温差大告警",
  "51101.s_w\\ctl_BMS.cell_diffvolt_toohigh_fault": "电芯温差大故障",
  "51101.s_w\\ctl_BMS.batt_chg_overcurrent_alarm": "电池充电过流告警",
  "51101.s_w\\ctl_BMS.batt_chg_overcurrent_slow_check_protect": "电池充电过流慢检保护",
  "51101.s_w\\ctl_BMS.batt_chg_overcurrent_fast_check_protect": "电池充电过流快检保护",
  "51101.s_w\\ctl_BMS.batt_chg_overcurrent_fault": "电池充电过流故障",
  "51101.s_w\\ctl_BMS.batt_dischg_overcurrent_alarm": "电池放电过流告警",
  "51101.s_w\\ctl_BMS.batt_dischg_overcurrent_slow_check_protect": "电池放电过流慢检保护",
  "51101.s_w\\ctl_BMS.batt_dischg_overcurrent_fast_check_protect": "电池放电过流快检保护",
  "51101.s_w\\ctl_BMS.batt_dischg_overcurrent_fault": "电池放电过流故障",
  "51101.s_w\\ctl_BMS.cell_too_high_volt_fault": "电芯电压严重高故障",
  "51101.s_w\\ctl_BMS.cell_too_low_volt_fault": "电芯电压严重低故障",
  "51101.s_w\\ctl_BMS.cell_too_low_volt_shutdown": "电芯电压低关机",
  "51101.s_w\\ctl_BMS.cell_term_overTemp_alarm": "极柱温度高告警",
  "51101.s_w\\ctl_BMS.cell_term_overTemp_protect": "极柱温度高保护",
  "51101.s_w\\ctl_BMS.cell_term_overTemp_fault": "极柱温度高故障",
  "51101.s_w\\ctl_BMS.cell_copper_overTemp_alrm": "铜排温度高告警",
  "51101.s_w\\ctl_BMS.cell_copper_overTemp_protect": "铜排温度高保护",
  "51101.s_w\\ctl_BMS.cell_copper_overTemp_fault": "铜排温度高故障",
  "51101.s_w\\ctl_inv.setting_chg_v": "设置充电电压",
  "51101.s_w\\ctl_inv.setting_chg_I": "设置充电电流",
  "51101.s_w\\ctl_inv.setting_trickle_chg_V": "设置涓充充电电压",
  "51101.s_w\\ctl_inv.setting_trickle_chg_I": "设置涓充充电电流",
  "51101.s_w\\ctl_inv.prl_grid_overV_protect": "并网口输入过压保护",
  "51101.s_w\\ctl_inv.prl_grid_overV_recovery": "并网口输入过压恢复",
  "51101.s_w\\ctl_inv.prl_grid_lowV_protect": "并网口输入欠压保护",
  "51101.s_w\\ctl_inv.prl_grid_lowV_recovery": "并网口输入欠压恢复",
  "51101.s_w\\ctl_inv.prl_grid_overFreq_protect": "并网口输入过频保护",
  "51101.s_w\\ctl_inv.prl_grid_overFreq_recovery": "并网口输入过频恢复",
  "51101.s_w\\ctl_inv.prl_grid_lowFreq_protect": "并网口输入欠频保护",
  "51101.s_w\\ctl_inv.prl_grid_lowFreq_recovery": "并网口输入欠频恢复",
  "51101.s_w\\ctl_inv.EPS_overV_protect": "ESP口输入过压保护",
  "51101.s_w\\ctl_inv.EPS_overV_recovery": "EPS口输入过压恢复",
  "51101.s_w\\ctl_inv.EPS_lowV_protect": "EPS口输入欠压保护",
  "51101.s_w\\ctl_inv.EPS__lowV_recovery": "EPS口输入欠压恢复",
  "51101.s_w\\ctl_inv.EPS_overFreq_protect": "EPS口输入过频保护",
  "51101.s_w\\ctl_inv.EPS_overFreq_recovery": "EPS口输入过频恢复",
  "51101.s_w\\ctl_inv.EPS_lowFreq_protect": "EPS口输入欠频保护",
  "51101.s_w\\ctl_inv.EPS_lowFreq_recovery": "EPS口输入欠频恢复",
  "51101.s_w\\ctl_inv.DC_input_overV_protect": "直流输入过压保护",
  "51101.s_w\\ctl_inv.DC_input_overV_recovery": "直流输入过压恢复",
  "51101.s_w\\ctl_inv.DC_input_lowV_protect": "直流输入欠压保护",
  "51101.s_w\\ctl_inv.DC_input_lowV_recovery": "直流输入欠压恢复",
  "51101.s_w\\ctl_inv.PV_input_overV_protect": "PV输入过压保护",
  "51101.s_w\\ctl_inv.PV_input_overV_recovery": "PV输入过压恢复",
  "51101.s_w\\ctl_inv.PV_input_lowV_protect": "PV输入欠压保护",
  "51101.s_w\\ctl_inv.PV_input_lowV_recovery": "PV输入欠压恢复",
  "51101.s_w\\ctl_inv.env_tmp1_over_protect": "环境温度1过温保护",
  "51101.s_w\\ctl_inv.env_tmp1_over_recovery": "环境温度1过温恢复",
  "51101.s_w\\ctl_inv.env_tmp2_over_protect": "环境温度2过温保护",
  "51101.s_w\\ctl_inv.env_tmp2_over_recovery": "环境温度2过温恢复",
  "51101.s_w\\ctl_inv.PFC_overT_protect": "PFC散热器温度过温保护",
  "51101.s_w\\ctl_inv.PFC_overT_recovery": "PFC散热器温度过温恢复",
  "51101.s_w\\ctl_inv.DC_overT_protect": "DC散热器温度1过温保护",
  "51101.s_w\\ctl_inv.DC_overT_recovery": "DC散热器温度1过温恢复",
  "51101.s_w\\ctl_inv.DC_overT2_protect": "DC散热器温度2过温保护",
  "51101.s_w\\ctl_inv.DC_overT2_recovery": "DC散热器温度2过温恢复",
  "51101.s_w\\ctl_inv.PV1_overT_protect": "PV1散热器温度过温保护",
  "51101.s_w\\ctl_inv.PV1_overT_recovery": "PV1散热器温度过温恢复",
  "51101.s_w\\ctl_inv.PV2_overT_protect": "PV2散热器温度过温保护",
  "51101.s_w\\ctl_inv.PV2_overT_recovery": "PV2散热器温度过温恢复",
  "51101.s_w\\ctl_inv.PV3_overT_protect": "PV3散热器温度过温保护",
  "51101.s_w\\ctl_inv.PV3_overT_recovery": "PV3散热器温度过温恢复",
  "51101.s_w\\ctl_inv.PV4_overT_protect": "PV4散热器温度过温保护",
  "51101.s_w\\ctl_inv.PV4_overT_recovery": "PV4散热器温度过温恢复",
  "51101.s_w\\ctl_islandProtection.island_overV": "过压保护阈值",
  "51101.s_w\\ctl_islandProtection.island_lowV": "欠压保护阈值",
  "51101.s_w\\ctl_islandProtection.island_overFreq": "过频保护阈值",
  "51101.s_w\\ctl_islandProtection.island_lowFreq": "欠频保护阈值",
  "51101.s_w\\ctl_reverseFlowProtection.rfp_action_time": "动作保护时间",
  "51101.s_w\\ctl_actpower.actpower_ctl_en": "有功功率控制使能",
  "51101.s_w\\ctl_actpower.max_oP": "最大输出有功功率",
  "51101.s_w\\ctl_actpower.p_ramp_rate": "有功功率爬坡率",
  "51101.s_w\\ctl_reactpower.reactpower_ctl_en": "无功功率控制使能",
  "51101.s_w\\ctl_reactpower.max_oQ": "最大输出无功功率",
  "51101.s_w\\ctl_reactpower.reactpower_ctl_mode": "无功功率控制模式",
  "51101.s_w\\ctl_reactpower.PF_set": "功率因数",
  "51101.s_w\\ctl_reactpower.VreactPCurveVsetValue1": "电压无功功率曲线电压设置值V1",
  "51101.s_w\\ctl_reactpower.VreactPCurveVsetValue2": "电压无功功率曲线电压设置值V2",
  "51101.s_w\\ctl_reactpower.VreactPCurveVsetValue3": "电压无功功率曲线电压设置值V3",
  "51101.s_w\\ctl_reactpower.VreactPCurveQsetValue1": "电压无功功率曲线无功功率设置值Q1",
  "51101.s_w\\ctl_reactpower.VreactPCurveQsetValue2": "电压无功功率曲线无功功率设置值Q2",
  "51101.s_w\\ctl_reactpower.VreactPCurveQsetValue3": "电压无功功率曲线无功功率设置值Q3",
  "51101.s_w\\volt_ride_through.lowVlimit1": "低压限制1",
  "51101.s_w\\volt_ride_through.lowVlimit1Time": "低压限制1时间",
  "51101.s_w\\volt_ride_through.lowVlimit2": "低压限制2",
  "51101.s_w\\volt_ride_through.lowVlimit2Time": "低压限制2时间",
  "51101.s_w\\volt_ride_through.lowVlimit3": "低压限制3",
  "51101.s_w\\volt_ride_through.lowVlimit3Time": "低压限制3时间",
  "51101.s_w\\volt_ride_through.overVlimit1": "过压限制1",
  "51101.s_w\\volt_ride_through.overVlimit1Time": "过压限制1时间",
  "51101.s_w\\volt_ride_through.overVlimit2": "过压限制2",
  "51101.s_w\\volt_ride_through.overVlimit2Time": "过压限制2时间",
  "51101.s_w\\volt_ride_through.overVlimit3": "过压限制3",
  "51101.s_w\\volt_ride_through.overVlimit3Time": "过压限制3时间",
  "51101.s_w\\volt_ride_through.VrecoveryTime": "电压恢复时间",
  "51101.s_w\\volt_ride_through.LVRTThredUplmt": "LVRT阈值上限",
  "51101.s_w\\volt_ride_through.LVRTThredDownlmt": "LVRT阈值下限",
  "51101.s_w\\Freq_ride_through.lowFreqLimit1": "低频限制1",
  "51101.s_w\\Freq_ride_through.lowFreqLimit1Time": "低频限制1时间",
  "51101.s_w\\Freq_ride_through.lowFreqLimit2": "低频限制2",
  "51101.s_w\\Freq_ride_through.lowFreqLimit2Time": "低频限制2时间",
  "51101.s_w\\Freq_ride_through.lowFreqLimit3": "低频限制3",
  "51101.s_w\\Freq_ride_through.lowFreqLimit3Time": "低频限制3时间",
  "51101.s_w\\Freq_ride_through.overFreqLimit1": "过频限制1",
  "51101.s_w\\Freq_ride_through.overFreqLimit1Time": "过频限制1时间",
  "51101.s_w\\Freq_ride_through.overFreqLimit2": "过频限制2",
  "51101.s_w\\Freq_ride_through.overFreqLimit2Time": "过频限制2时间",
  "51101.s_w\\Freq_ride_through.overFreqLimit3": "过频限制3",
  "51101.s_w\\Freq_ride_through.overFreqLimit3Time": "过频限制3时间",
  "51101.s_w\\grid_reconn_args.pareGridReConnTime": "并网重连时间",
  "51101.s_w\\grid_reconn_args.reConnGridVHighLevel": "重连电压高位",
  "51101.s_w\\grid_reconn_args.reConnGridVLowLevel": "重连电压低位",
  "51101.s_w\\grid_reconn_args.reConnGridFHighLevel": "重连频率高位",
  "51101.s_w\\grid_reconn_args.reConnGridFLowLevel": "重连频率低位",
  "51101.m_w\\ctl_EMS.ems_ctrl_work_mode": "工作模式设置",
  "51101.m_w\\ctl_EMS.anti_reverse_curr": "防逆流模式使能",
  "51101.s_w\\ctl_EMS.remote_on_off_ctrl": "远程开关机",
  "51101.s_w\\ctl_EMS.batt_shutdown_ctrl": "电池断电控制",
  "51101.s_w\\ctl_EMS.factory_recovery": "恢复出厂设置",
  "51101.m_w\\ctl_EMS.user_type": "用户类型",
  "51101.m_w\\ctl_EMS.self_consupt_chg_soc": "自发自用模式充电SOC阈值",
  "51101.m_w\\ctl_EMS.self_consupt_dischg_soc": "自发自用模式放电SOC阈值",
  "51101.m_w\\ctl_EMS.self_consupt_max_chg_P": "自发自用模式最大充电功率",
  "51101.m_w\\ctl_EMS.self_consupt_max_feedGrid_P": "自发自用模式最大馈网功率",
  "51101.m_w\\ctl_EMS.feedGrid_chg_soc": "馈网优先模式充电SOC阈值",
  "51101.m_w\\ctl_EMS.feedGrid_dischg_soc": "馈网优先模式放电SOC阈值",
  "51101.m_w\\ctl_EMS.feedGrid_max_chg_P": "馈网优先模式最大充电功率",
  "51101.m_w\\ctl_EMS.feedGrid_max_feedGrid_P": "馈网优先模式最大馈网功率",
  "51101.m_w\\ctl_EMS.bakMode_chg_soc": "备电模式充电SOC阈值",
  "51101.m_w\\ctl_EMS.bakMode_dischg_soc": "备电模式放电SOC阈值",
  "51101.m_w\\ctl_EMS.bakMode_max_chg_P": "备电模式最大充电功率",
  "51101.m_w\\ctl_EMS.bakMode_max_feedGrid_P": "备电模式最大馈网功率",
  "51101.m_w\\ctl_EMS.PSVFMode_chg_soc": "削峰填谷模式充电SOC阈值",
  "51101.m_w\\ctl_EMS.PSVFMode_dischg_soc": "削峰填谷模式放电SOC阈值",
  "51101.m_w\\ctl_EMS.PSVFMode_max_chg_P": "削峰填谷模式最大充电功率",
  "51101.m_w\\ctl_EMS.PSVFMode_max_feedGrid_P": "削峰填谷模式最大馈网功率",
  "51101.m_w\\ctl_EMS.PSVFMode_chgDischg_tm_sect_cnt": "削峰填谷模式充放电时间段数",
  "51101.m_w\\ctl_EMS.s_mon": "开始时间-月",
  "51101.m_w\\ctl_EMS.s_day": "开始时间-日",
  "51101.m_w\\ctl_EMS.e_mon": "结束时间-月",
  "51101.m_w\\ctl_EMS.e_day": "结束时间-日",
  "51101.m_w\\ctl_EMS.s_chg_hour_1": "充电开始时间1-时",
  "51101.m_w\\ctl_EMS.s_chg_min_1": "充电开始时间1-分",
  "51101.m_w\\ctl_EMS.e_chg_hour_1": "充电结束时间1-时",
  "51101.m_w\\ctl_EMS.e_chg_min_1": "充电结束时间1-分",
  "51101.m_w\\ctl_EMS.s_dischg_hour_1": "放电开始时间1-时",
  "51101.m_w\\ctl_EMS.s_dischg_min_1": "放电开始时间1-分",
  "51101.m_w\\ctl_EMS.e_dischg_hour_1": "放电结束时间1-时",
  "51101.m_w\\ctl_EMS.e_dischg_min_1": "放电结束时间1-分",
  "51101.m_w\\ctl_EMS.s_chg_hour_2": "充电开始时间2-时",
  "51101.m_w\\ctl_EMS.s_chg_min_2": "充电开始时间2-分",
  "51101.m_w\\ctl_EMS.e_chg_hour_2": "充电结束时间2-时",
  "51101.m_w\\ctl_EMS.e_chg_min_2": "充电结束时间2-分",
  "51101.m_w\\ctl_EMS.s_dischg_hour_2": "放电开始时间2-时",
  "51101.m_w\\ctl_EMS.s_dischg_min_2": "放电开始时间2-分",
  "51101.m_w\\ctl_EMS.e_dischg_hour_2": "放电结束时间2-时",
  "51101.m_w\\ctl_EMS.e_dischg_min_2": "放电结束时间2-分",
  "51101.m_w\\ctl_EMS.s_chg_hour_3": "充电开始时间3-时",
  "51101.m_w\\ctl_EMS.s_chg_min_3": "充电开始时间3-分",
  "51101.m_w\\ctl_EMS.e_chg_hour_3": "充电结束时间3-时",
  "51101.m_w\\ctl_EMS.e_chg_min_3": "充电结束时间3-分",
  "51101.m_w\\ctl_EMS.s_dischg_hour_3": "放电开始时间3-时",
  "51101.m_w\\ctl_EMS.s_dischg_min_3": "放电开始时间3-分",
  "51101.m_w\\ctl_EMS.e_dischg_hour_3": "放电结束时间3-时",
  "51101.m_w\\ctl_EMS.e_dischg_min_3": "放电结束时间3-分",
  "51101.m_w\\ctl_EMS.s_chg_hour_4": "充电开始时间4-时",
  "51101.m_w\\ctl_EMS.s_chg_min_4": "充电开始时间4-分",
  "51101.m_w\\ctl_EMS.e_chg_hour_4": "充电结束时间4-时",
  "51101.m_w\\ctl_EMS.e_chg_min_4": "充电结束时间4-分",
  "51101.m_w\\ctl_EMS.s_dischg_hour_4": "放电开始时间4-时",
  "51101.m_w\\ctl_EMS.s_dischg_min_4": "放电开始时间4-分",
  "51101.m_w\\ctl_EMS.e_dischg_hour_4": "放电结束时间4-时",
  "51101.m_w\\ctl_EMS.e_dischg_min_4": "放电结束时间4-分",
  "51101.m_w\\ctl_EMS.s_chg_hour_5": "充电开始时间5-时",
  "51101.m_w\\ctl_EMS.s_chg_min_5": "充电开始时间5-分",
  "51101.m_w\\ctl_EMS.e_chg_hour_5": "充电结束时间5-时",
  "51101.m_w\\ctl_EMS.e_chg_min_5": "充电结束时间5-分",
  "51101.m_w\\ctl_EMS.s_dischg_hour_5": "放电开始时间5-时",
  "51101.m_w\\ctl_EMS.s_dischg_min_5": "放电开始时间5-分",
  "51101.m_w\\ctl_EMS.e_dischg_hour_5": "放电结束时间5-时",
  "51101.m_w\\ctl_EMS.e_dischg_min_5": "放电结束时间5-分",
  "51101.m_w\\ctl_EMS.s_chg_hour_6": "充电开始时间6-时",
  "51101.m_w\\ctl_EMS.s_chg_min_6": "充电开始时间6-分",
  "51101.m_w\\ctl_EMS.e_chg_hour_6": "充电结束时间6-时",
  "51101.m_w\\ctl_EMS.e_chg_min_6": "充电结束时间6-分",
  "51101.m_w\\ctl_EMS.s_dischg_hour_6": "放电开始时间6-时",
  "51101.m_w\\ctl_EMS.s_dischg_min_6": "放电开始时间6-分",
  "51101.m_w\\ctl_EMS.e_dischg_hour_6": "放电结束时间6-时",
  "51101.m_w\\ctl_EMS.e_dischg_min_6": "放电结束时间6-分",
  "51101.m_w\\ctl_EMS.gridType": "国家电网标准",
  "51101.m_w\\ctl_EMS.TOU_work_status": "TOU模式工作状态",
  "51101.m_w\\ctl_EMS.TOU_max_chg_P": "TOU模式最大充电功率",
  "51101.m_w\\ctl_EMS.TOU_max_feedGrid_P": "TOU模式最大馈网功率",
  "51101.m_w\\ctl_EMS.TOU_chg_SOC": "TOU模式充电截止SOC",
  "51101.m_w\\ctl_EMS.TOU_dischg_SOC": "TOU模式放电截止SOC",
  "51101.m_w\\ctl_EMS.TOU_time_section_num": "TOU模式充放电时间段数",
  "51101.m_w\\ctl_EMS.TOU_s_chg_hour_1": "TOU充电开始时间1-时",
  "51101.m_w\\ctl_EMS.TOU_s_chg_min_1": "TOU充电开始时间1-分",
  "51101.m_w\\ctl_EMS.TOU_e_chg_hour_1": "TOU充电结束时间1-时",
  "51101.m_w\\ctl_EMS.TOU_e_chg_min_1": "TOU充电结束时间1-分",
  "51101.m_w\\ctl_EMS.TOU_s_dischg_hour_1": "TOU放电开始时间1-时",
  "51101.m_w\\ctl_EMS.TOU_s_dischg_min_1": "TOU放电开始时间1-分",
  "51101.m_w\\ctl_EMS.TOU_e_dischg_hour_1": "TOU放电结束时间1-时",
  "51101.m_w\\ctl_EMS.TOU_e_dischg_min_1": "TOU放电结束时间1-分",
  "51101.m_w\\ctl_EMS.TOU_s_chg_hour_2": "TOU充电开始时间2-时",
  "51101.m_w\\ctl_EMS.TOU_s_chg_min_2": "TOU充电开始时间2-分",
  "51101.m_w\\ctl_EMS.TOU_e_chg_hour_2": "TOU充电结束时间2-时",
  "51101.m_w\\ctl_EMS.TOU_e_chg_min_2": "TOU充电结束时间2-分",
  "51101.m_w\\ctl_EMS.TOU_s_dischg_hour_2": "TOU放电开始时间2-时",
  "51101.m_w\\ctl_EMS.TOU_s_dischg_min_2": "TOU放电开始时间2-分",
  "51101.m_w\\ctl_EMS.TOU_e_dischg_hour_2": "TOU放电结束时间2-时",
  "51101.m_w\\ctl_EMS.TOU_e_dischg_min_2": "TOU放电结束时间2-分",
  "51101.m_w\\ctl_EMS.TOU_s_chg_hour_3": "TOU充电开始时间3-时",
  "51101.m_w\\ctl_EMS.TOU_s_chg_min_3": "TOU充电开始时间3-分",
  "51101.m_w\\ctl_EMS.TOU_e_chg_hour_3": "TOU充电结束时间3-时",
  "51101.m_w\\ctl_EMS.TOU_e_chg_min_3": "TOU充电结束时间3-分",
  "51101.m_w\\ctl_EMS.TOU_s_dischg_hour_3": "TOU放电开始时间3-时",
  "51101.m_w\\ctl_EMS.TOU_s_dischg_min_3": "TOU放电开始时间3-分",
  "51101.m_w\\ctl_EMS.TOU_e_dischg_hour_3": "TOU放电结束时间3-时",
  "51101.m_w\\ctl_EMS.TOU_e_dischg_min_3": "TOU放电结束时间3-分",
  "51101.m_w\\ctl_EMS.TOU_s_chg_hour_4": "TOU充电开始时间4-时",
  "51101.m_w\\ctl_EMS.TOU_s_chg_min_4": "TOU充电开始时间4-分",
  "51101.m_w\\ctl_EMS.TOU_e_chg_hour_4": "TOU充电结束时间4-时",
  "51101.m_w\\ctl_EMS.TOU_e_chg_min_4": "TOU充电结束时间4-分",
  "51101.m_w\\ctl_EMS.TOU_s_dischg_hour_4": "TOU放电开始时间4-时",
  "51101.m_w\\ctl_EMS.TOU_s_dischg_min_4": "TOU放电开始时间4-分",
  "51101.m_w\\ctl_EMS.TOU_e_dischg_hour_4": "TOU放电结束时间4-时",
  "51101.m_w\\ctl_EMS.TOU_e_dischg_min_4": "TOU放电结束时间4-分",
  "51101.m_w\\ctl_EMS.TOU_s_chg_hour_5": "TOU充电开始时间5-时",
  "51101.m_w\\ctl_EMS.TOU_s_chg_min_5": "TOU充电开始时间5-分",
  "51101.m_w\\ctl_EMS.TOU_e_chg_hour_5": "TOU充电结束时间5-时",
  "51101.m_w\\ctl_EMS.TOU_e_chg_min_5": "TOU充电结束时间5-分",
  "51101.m_w\\ctl_EMS.TOU_s_dischg_hour_5": "TOU放电开始时间5-时",
  "51101.m_w\\ctl_EMS.TOU_s_dischg_min_5": "TOU放电开始时间5-分",
  "51101.m_w\\ctl_EMS.TOU_e_dischg_hour_5": "TOU放电结束时间5-时",
  "51101.m_w\\ctl_EMS.TOU_e_dischg_min_5": "TOU放电结束时间5-分",
  "51101.m_w\\ctl_EMS.TOU_s_chg_hour_6": "TOU充电开始时间6-时",
  "51101.m_w\\ctl_EMS.TOU_s_chg_min_6": "TOU充电开始时间6-分",
  "51101.m_w\\ctl_EMS.TOU_e_chg_hour_6": "TOU充电结束时间6-时",
  "51101.m_w\\ctl_EMS.TOU_e_chg_min_6": "TOU充电结束时间6-分",
  "51101.m_w\\ctl_EMS.TOU_s_dischg_hour_6": "TOU放电开始时间6-时",
  "51101.m_w\\ctl_EMS.TOU_s_dischg_min_6": "TOU放电开始时间6-分",
  "51101.m_w\\ctl_EMS.TOU_e_dischg_hour_6": "TOU放电结束时间6-时",
  "51101.m_w\\ctl_EMS.TOU_e_dischg_min_6": "TOU放电结束时间6-分",
  "51101.s\\alarm.alrm_grid_v_low": "电网电压低",
  "51101.s\\alarm.alrm_grid_v_high": "电网电压高",
  "51101.s\\alarm.alrm_grid_f_low": "电网频率低",
  "51101.s\\alarm.alrm_grid_f_high": "电网频率高",
  "51101.s\\alarm.alrm_grid_input_overI": "电网交流输入过流预警",
  "51101.s\\alarm.alrm_PFC_bus_v_low": "整流器预警(母线电压低)",
  "51101.s\\alarm.alrm_U1_bus_v_low": "U1母线预警(电压低)",
  "51101.s\\alarm.alrm_U1_bus_v_high": "U1母线预警(电压高)",
  "51101.s\\alarm.alrm_U2_bus_v_low": "U2母线预警(电压低)",
  "51101.s\\alarm.alrm_U2_bus_v_high": "U2母线预警(电压高)",
  "51101.s\\alarm.alrm_inv_overload": "输出预警(逆变器过载)",
  "51101.s\\alarm.alrm_bypass_overload": "输出预警(旁路过载)",
  "51101.s\\alarm.alrm_inv_v_fault": "整流器预警(逆变电压有效值故障)",
  "51101.s\\alarm.alrm_inv_overV_protect": "整流器预警(逆变交流输出过压保护)",
  "51101.s\\alarm.alrm_inv_lowV_protect": "整流器预警(逆变交流输出欠压保护)",
  "51101.s\\alarm.alrm_inv_overF_protect": "整流器预警(逆变交流输出过频保护)",
  "51101.s\\alarm.alrm_inv_lowF_protect": "整流器预警(逆变交流输出欠频保护)",
  "51101.s\\alarm.alrm_lock_phase_failure": "锁相预警(市电锁相失败)",
  "51101.s\\alarm.alrm_level2_lock_phase_failure": "锁相预警(并机二级锁相失败)",
  "51101.s\\alarm.alrm_T1_tooHigh": "温度预警1(温度过高)",
  "51101.s\\alarm.alrm_T2_tooHigh": "温度预警2(温度过高)",
  "51101.s\\alarm.alrm_bypass_lowV": "旁路预警(电压低)",
  "51101.s\\alarm.alrm_bypass_highV": "旁路预警(电压高)",
  "51101.s\\alarm.alrm_bypass_lowF": "旁路预警(频率低)",
  "51101.s\\alarm.alrm_bypass_highF": "旁路预警(频率高)",
  "51101.s\\alarm.alrm_chg_lowV": "充电器预警(充电器低压)",
  "51101.s\\alarm.alrm_chg_highV": "充电器预警(充电器高压)",
  "51101.s\\alarm.alrm_dischg_lowV": "放电器预警(电池低压故障)",
  "51101.s\\alarm.alrm_dischg_bus_lowV": "放电器预警(母线低压故障)",
  "51101.s\\alarm.alrm_dischg_batt_highV": "放电器预警(电池高压故障)",
  "51101.s\\alarm.alrm_u1_u2_ver_mismatch": "系统预警(U1和U2软件版本不匹配)",
  "51101.s\\alarm.alrm_PV1_DC_lowV": "PV1预警(DC低压故障)",
  "51101.s\\alarm.alrm_PV1_DC_highV": "PV1预警(DC高压故障)",
  "51101.s\\alarm.alrm_PV1_input_lowV": "PV1预警(PV输入欠压)",
  "51101.s\\alarm.alrm_PV1_input_highV": "PV1预警(PV输入过压)",
  "51101.s\\alarm.alrm_PV2_DC_lowV": "PV2预警(DC低压故障)",
  "51101.s\\alarm.alrm_PV2_DC_highV": "PV2预警(DC高压故障)",
  "51101.s\\alarm.alrm_PV2_input_lowV": "PV2预警(PV输入欠压)",
  "51101.s\\alarm.alrm_PV2_input_highV": "PV2预警(PV输入过压)",
  "51101.s\\alarm.alrm_PV3_DC_lowV": "PV3预警(DC低压故障)",
  "51101.s\\alarm.alrm_PV3_DC_highV": "PV3预警(DC高压故障)",
  "51101.s\\alarm.alrm_PV3_input_lowV": "PV3预警(PV输入欠压)",
  "51101.s\\alarm.alrm_PV3_input_highV": "PV3预警(PV输入过压)",
  "51101.s\\alarm.alrm_PV4_DC_lowV": "PV4预警(DC低压故障)",
  "51101.s\\alarm.alrm_PV4_DC_highV": "PV4预警(DC高压故障)",
  "51101.s\\alarm.alrm_PV4_input_lowV": "PV4预警(PV输入欠压)",
  "51101.s\\alarm.alrm_PV4_input_highV": "PV4预警(PV输入过压)",
  "51101.s\\alarm.alrm_parellet_freq_differ": "并机预警1(并机频率体系不一致故障)",
  "51101.s\\alarm.alrm_parellet2_avg_I": "并机预警2(并机均流故障)",
  "51101.s\\alarm.alrm_batt_highV": "电芯预警1(电芯组均压高)",
  "51101.s\\alarm.alrm_batt_cell_highV": "电芯预警1(电芯高压)",
  "51101.s\\alarm.alrm_batt_lowV": "电芯预警1(电芯组均压低)",
  "51101.s\\alarm.alrm_batt_cell_lowV": "电芯预警1(电芯低压)",
  "51101.s\\alarm.alrm_cell_slow_check_overI": "电芯预警2(电芯充电过流慢检)",
  "51101.s\\alarm.alrm_cell_dischg_slow_check_overI": "电芯预警2(电芯放电过流慢检)",
  "51101.s\\alarm.alrm_cell_chg1_overT": "电芯温度预警(电芯一级过温(充电))",
  "51101.s\\alarm.alrm_cell_chg2_overT": "电芯温度预警(电芯二级过温(充电))",
  "51101.s\\alarm.alrm_cell_chg1_lowT": "电芯温度预警(电芯一级低温(充电))",
  "51101.s\\alarm.alrm_cell_chg2_lowT": "电芯温度预警(电芯二级低温(充电))",
  "51101.s\\alarm.alrm_cell_dischg1_overT": "电芯温度预警(电芯一级过温(放电))",
  "51101.s\\alarm.alrm_cell_dischg2_overT": "电芯温度预警(电芯二级过温(放电))",
  "51101.s\\alarm.alrm_cell_dischg1_lowT": "电芯温度预警(电芯一级低温(放电))",
  "51101.s\\alarm.alrm_cell_dischg2_lowT": "电芯温度预警(电芯二级低温(放电))",
  "51101.s\\alarm.alrm_cell_env_overT": "电芯温度预警(环境过温)",
  "51101.s\\alarm.alrm_cell_env_lowT": "电芯温度预警(环境低温)",
  "51101.s\\alarm.alrm_cell_mos_overT": "电芯温度预警(MOS过温)",
  "51101.s\\alarm.alrm_cell_diffT_large": "电芯温度预警(温差过大)",
  "51101.s\\alarm.alrm_eps_lowV": "EPS微逆预警(电压低)",
  "51101.s\\alarm.alrm_eps_highV": "EPS微逆预警(电压高)",
  "51101.s\\alarm.alrm_eps_lowF": "EPS微逆预警(频率低)",
  "51101.s\\alarm.alrm_eps_highF": "EPS微逆预警(频率高)",
  "51101.s\\alarm.alrm_eps_ac_overI": "EPS微逆预警(交流输入过流)",
  "51101.s\\warn.warn_grid_v_low": "电网告警(电网电压低)",
  "51101.s\\warn.warn_grid_v_high": "电网告警(电网电压高)",
  "51101.s\\warn.warn_grid_f_low": "电网告警(电网频率低)",
  "51101.s\\warn.warn_grid_f_high": "电网告警(电网频率高)",
  "51101.s\\warn.warn_grid_I_over": "电网告警(交流输入过流)",
  "51101.s\\warn.warn_PFC_bus_v_low": "整流器告警(母线低压)",
  "51101.s\\warn.warn_U1_bus_v_low": "U1母线告警(电压低)",
  "51101.s\\warn.warn_U1_bus_v_high": "U1母线告警(电压高)",
  "51101.s\\warn.warn_U2_bus_v_low": "U2母线告警(电压低)",
  "51101.s\\warn.warn_U2_bus_v_high": "U2母线告警(电压高)",
  "51101.s\\warn.warn_o_inv_overLoad": "输出告警(逆变过载)",
  "51101.s\\warn.warn_o_byp_overLoad": "输出告警(旁路过载)",
  "51101.s\\warn.warn_PFC_inv_v": "整流器告警(逆变电压有效值故障)",
  "51101.s\\warn.warn_PFC_inv_o_over_v": "整流器告警(逆变交流输出过压保护)",
  "51101.s\\warn.warn_PFC_inv_o_low_v": "整流器告警(逆变交流输出欠压保护)",
  "51101.s\\warn.warn_PFC_inv_o_over_f": "逆变交流输出过频保护告警",
  "51101.s\\warn.warn_PFC_inv_o_low_f": "整流器告警(逆变交流输出欠频保护)",
  "51101.s\\warn.warn_PLL_grid_pll": "锁相告警(市电锁相失败)",
  "51101.s\\warn.warn_PLL_parellet_pll": "锁相告警(并机二级锁相失败)",
  "51101.s\\warn.warn_T1_overT": "温度告警1(温度过高)",
  "51101.s\\warn.warn_T2_overT": "温度告警2(温度过高)",
  "51101.s\\warn.warn_byp_overT": "旁路告警(温度过高)",
  "51101.s\\warn.warn_chg_lowV": "充电器告警(充电器低压)",
  "51101.s\\warn.warn_chg_highV": "充电器告警(充电器高压)",
  "51101.s\\warn.warn_dischg_battV": "放电器告警(电池低压故障)",
  "51101.s\\warn.warn_dischg_busV": "放电器告警(母线低压故障)",
  "51101.s\\warn.warn_dischg_battOverV": "放电器告警(电池高压故障)",
  "51101.s\\warn.warn_PV1_dc_lowV": "PV1告警(DC低压故障)",
  "51101.s\\warn.warn_PV1_dc_highV": "PV1告警(DC高压故障)",
  "51101.s\\warn.warn_PV1_pv_input_lowV": "PV1告警(PV输入欠压)",
  "51101.s\\warn.warn_PV1_pv_input_overV": "PV1告警(PV输入过压)",
  "51101.s\\warn.warn_PV2_dc_lowV": "PV2告警(DC低压故障)",
  "51101.s\\warn.warn_PV2_dc_highV": "PV2告警(DC高压故障)",
  "51101.s\\warn.warn_PV2_pv_input_lowV": "PV2告警(PV输入欠压)",
  "51101.s\\warn.warn_PV2_pv_input_overV": "PV2告警(PV输入过压)",
  "51101.s\\warn.warn_PV3_dc_lowV": "PV3告警(DC低压故障)",
  "51101.s\\warn.warn_PV3_dc_highV": "PV3告警(DC高压故障)",
  "51101.s\\warn.warn_PV3_pv_input_lowV": "PV3告警(PV输入欠压)",
  "51101.s\\warn.warn_PV3_pv_input_overV": "PV3告警(PV输入过压)",
  "51101.s\\warn.warn_PV4_dc_lowV": "PV4告警(DC低压故障)",
  "51101.s\\warn.warn_PV4_dc_highV": "PV4告警(DC高压故障)",
  "51101.s\\warn.warn_PV4_pv_input_lowV": "PV4告警(PV输入欠压)",
  "51101.s\\warn.warn_PV4_pv_input_overV": "PV4告警(PV输入过压)",
  "51101.s\\warn.warn_prllt1_f_mismatch": "并机告警1(并机频率体系不一致)",
  "51101.s\\warn.warn_prllt2_avg_I": "并机告警1(并机均流故障)",
  "51101.s\\warn.warn_cell1_grp_avgV_high": "电芯告警1(电芯组均压高)",
  "51101.s\\warn.warn_cell1_overV": "电芯告警1(电芯高压)",
  "51101.s\\warn.warn_cell1_grp_avgV_low": "电芯告警1(电芯组均压低)",
  "51101.s\\warn.warn_cell1_lowV": "电芯告警1(电芯低压)",
  "51101.s\\warn.warn_cell2_chgOverISlowChck": "电芯告警2(充电过流慢检(电芯))",
  "51101.s\\warn.warn_cell2_dischgOverISlowChck": "电芯告警2(放电过流慢检(电芯))",
  "51101.s\\warn.warn_cellT_L1_overT_chg": "电芯温度告警(电芯一级过温(充电))",
  "51101.s\\warn.warn_cellT_L2_overT_chg": "电芯温度告警(电芯二级过温(充电))",
  "51101.s\\warn.warn_cellT_L1_lowT_chg": "电芯温度告警(电芯一级低温(充电))",
  "51101.s\\warn.warn_cellT_L2_lowT_chg": "电芯温度告警(电芯二级低温(充电))",
  "51101.s\\warn.warn_cellT_L1_overT_dischg": "电芯温度告警(电芯一级过温(放电))",
  "51101.s\\warn.warn_cellT_L2_overT_dischg": "电芯温度告警(电芯二级过温(放电))",
  "51101.s\\warn.warn_cellT_L1_lowT_dischg": "电芯温度告警(电芯一级低温(放电))",
  "51101.s\\warn.warn_cellT_L2_lowT_dischg": "电芯温度告警(电芯二级低温(放电))",
  "51101.s\\warn.warn_cellT_env_overT": "电芯温度告警(环境过温)",
  "51101.s\\warn.warn_cellT_env_lowT": "电芯温度告警(环境低温)",
  "51101.s\\warn.warn_cellT_mos_overT": "电芯温度告警(MOS过温)",
  "51101.s\\warn.warn_cellT_diffT_toolarge": "电芯温度告警(温差过大)",
  "51101.s\\warn.warn_eps_lowV": "EPS微逆告警(电压低)",
  "51101.s\\warn.warn_eps_highV": "EPS微逆告警(电压高)",
  "51101.s\\warn.warn_eps_lowF": "EPS微逆告警(频率低)",
  "51101.s\\warn.warn_eps_highF": "EPS微逆告警(频率高)",
  "51101.s\\warn.warn_eps_i_overI": "EPS微逆告警(交流输入过流)",
  "51101.s\\fault.fault_grid_summary": "电网故障(故障汇总)",
  "51101.s\\fault.fault_grid_Vabnormal": "电网故障(电压异常)",
  "51101.s\\fault.fault_grid_Fabnormal": "电网故障(频率异常)",
  "51101.s\\fault.fault_grid_lowV": "电网故障(电压低)",
  "51101.s\\fault.fault_grid_highV": "电网故障(电压高)",
  "51101.s\\fault.fault_grid_lowF": "电网故障(频率低)",
  "51101.s\\fault.fault_grid_highF": "电网故障(频率高)",
  "51101.s\\fault.fault_grid_gridLost": "电网故障(市电掉电)",
  "51101.s\\fault.fault_grid_gridSurge": "电网故障(市电浪涌)",
  "51101.s\\fault.fault_grid_relayOpen": "电网故障(电网继电器开路)",
  "51101.s\\fault.fault_grid_ac_i_overI": "电网故障(交流输入过流)",
  "51101.s\\fault.fault_PFC_summary": "整流故障(故障汇总)",
  "51101.s\\fault.fault_PFC_hardSoftStrtup": "整流故障(硬件软起故障)",
  "51101.s\\fault.fault_PFC_softSoftStrtup": "整流故障(软件软起故障)",
  "51101.s\\fault.fault_PFC_bus_lowV": "整流故障(母线低压)",
  "51101.s\\fault.fault_PFC_intr_comm_lost": "整流故障(内部通信故障)",
  "51101.s\\fault.fault_PFC_extrnl_comm_lost": "整流故障(对外通信故障)",
  "51101.s\\fault.fault_U1bus_summary": "U1母线故障(故障汇总)",
  "51101.s\\fault.fault_U1bus_lowV_abnormal": "U1母线故障(低压异常)",
  "51101.s\\fault.fault_U1bus_highV_abnormal": "U1母线故障(高压异常)",
  "51101.s\\fault.fault_U1bus_tooLowV": "U1母线故障(电压过低)",
  "51101.s\\fault.fault_U1bus_tooHighV": "U1母线故障(电压过高)",
  "51101.s\\fault.fault_U1bus_VtooHighFastChck": "U1母线故障(电压过高快检)",
  "51101.s\\fault.fault_U2bus_summary": "U2母线故障(故障汇总)",
  "51101.s\\fault.fault_U2bus_lowV_abnormal": "U2母线故障(低压异常)",
  "51101.s\\fault.fault_U2bus_highV_abnormal": "U2母线故障(高压异常)",
  "51101.s\\fault.fault_U2bus_tooLowV": "U2母线故障(电压过低)",
  "51101.s\\fault.fault_U2bus_tooHighV": "U2母线故障(电压过高)",
  "51101.s\\fault.fault_U2bus_VtooHighFastChck": "U2母线故障(电压过高快检)",
  "51101.s\\fault.fault_U2bus_PNbusUnbalance": "U2母线故障(正负母线不平衡)",
  "51101.s\\fault.fault_U2bus_busAvgVlargeV": "U2母线故障(母线均压高)",
  "51101.s\\fault.fault_U2bus_busAvgVlargeI": "U2母线故障(母线均压电流过高)",
  "51101.s\\fault.fault_U2bus_busAvgVlargeIFastChck": "U2母线故障(母线均压电流过高快检)",
  "51101.s\\fault.fault_o_summary": "输出故障(故障汇总)",
  "51101.s\\fault.fault_o_invRalayOpen": "输出故障(逆变继电器开路)",
  "51101.s\\fault.fault_o_invOverLoad": "输出故障(逆变过载延时到故障)",
  "51101.s\\fault.fault_o_bypOverLoad": "输出故障(旁路过载延时到故障)",
  "51101.s\\fault.fault_inv_summary": "逆变故障(故障汇总)",
  "51101.s\\fault.fault_inv_invFastChck": "逆变故障(逆变器快检故障)",
  "51101.s\\fault.fault_inv_invSlowChck": "逆变故障(逆变器慢检故障)",
  "51101.s\\fault.fault_inv_RelayStuck": "逆变故障(继电器连锡故障)",
  "51101.s\\fault.fault_inv_invShortCircuit": "逆变故障(逆变短路故障)",
  "51101.s\\fault.fault_inv_intrCommErr": "逆变故障(内部通信故障)",
  "51101.s\\fault.fault_inv_extCommErr": "逆变故障(对外通信故障)",
  "51101.s\\fault.fault_inv_invVabnormal": "逆变故障(逆变电压有效值故障)",
  "51101.s\\fault.fault_inv_outputOverVProtect": "逆变故障(逆变交流输出过压保护)",
  "51101.s\\fault.fault_inv_outputLowVProtect": "逆变故障(逆变交流输出欠压保护)",
  "51101.s\\fault.fault_inv_outputOverFProtect": "逆变故障(逆变交流输出过频保护)",
  "51101.s\\fault.fault_inv_outputlowFProtect": "逆变故障(逆变交流输出欠频保护)",
  "51101.s\\fault.fault_PLL_summary": "锁相故障(故障汇总)",
  "51101.s\\fault.fault_PLL_acMainPll": "锁相故障(市电锁相失败)",
  "51101.s\\fault.fault_PLL_secondaryPllLocked": "锁相故障(并机二级锁相失败)",
  "51101.s\\fault.fault_T_summary": "温度故障1(故障汇总)",
  "51101.s\\fault.fault_T_TtooHigh": "温度故障1(温度过高)",
  "51101.s\\fault.fault_T_TmpPinDisconn": "温度故障1(温度探头未插)",
  "51101.s\\fault.fault_T2_summary": "温度故障2(故障汇总)",
  "51101.s\\fault.fault_T2_TtooHigh": "温度故障2(温度过高)",
  "51101.s\\fault.fault_T2_TmpPinDisconn": "温度故障2(温度探头未插)",
  "51101.s\\fault.fault_byp_summary": "旁路故障(故障汇总)",
  "51101.s\\fault.fault_byp_Vabnormal": "旁路故障(电压异常)",
  "51101.s\\fault.fault_byp_Fabnormal": "旁路故障(频率异常)",
  "51101.s\\fault.fault_byp_VtooLow": "旁路故障(电压低)",
  "51101.s\\fault.fault_byp_VtooHigh": "旁路故障(电压高)",
  "51101.s\\fault.fault_byp_FtooLow": "旁路故障(频率低)",
  "51101.s\\fault.fault_byp_FtooHigh": "旁路故障(频率高)",
  "51101.s\\fault.fault_byp_bypShtdwn": "旁路故障(旁路掉电)",
  "51101.s\\fault.fault_byp_bypInrush": "旁路故障(旁路浪涌)",
  "51101.s\\fault.fault_byp_intrCommErr": "旁路故障(内部通信故障)",
  "51101.s\\fault.fault_byp_extCommErr": "旁路故障(对外通信故障)",
  "51101.s\\fault.fault_chg_summary": "充电器故障(故障汇总)",
  "51101.s\\fault.fault_chg_lowV": "充电器故障(充电器低压)",
  "51101.s\\fault.fault_chg_HighV": "充电器故障(充电器高压)",
  "51101.s\\fault.fault_chg_OutputShortCircuit": "充电器故障(充电器输出短路)",
  "51101.s\\fault.fault_chg_softStrpup": "充电器故障(充电器软启故障)",
  "51101.s\\fault.fault_chg_busVAbnormal": "充电器故障(母线电压异常)",
  "51101.s\\fault.fault_chg_oVTooLowFastChck": "充电器故障(输出电压过低快检)",
  "51101.s\\fault.fault_chg_oVTooHigh": "充电器故障(输出电压过高)",
  "51101.s\\fault.fault_chg_oVTooHighFastChck": "充电器故障(输出电压过高快检)",
  "51101.s\\fault.fault_chg_acChgUnenough": "充电器故障(AC剩余充电功率不足(PV+AC联合充电))",
  "51101.s\\fault.fault_chg_intrCommErr": "充电器故障(内部通信故障)",
  "51101.s\\fault.fault_chg_outCommErr": "充电器对外通信故障",
  "51101.s\\fault.fault_chg_extCommErr": "充电器故障(剩余充电功率不足(AC边充边放))",
  "51101.s\\fault.fault_chg_bypSundenlyAddLoad": "充电器故障(旁路突加载故障)",
  "51101.s\\fault.fault_dischg_summary": "放电器故障(故障汇总)",
  "51101.s\\fault.fault_dischg_battLowV": "放电器故障(电池低压故障)",
  "51101.s\\fault.fault_dischg_busLowV": "放电器故障(母线低压故障)",
  "51101.s\\fault.fault_dischg_battHighV": "放电器故障(电池高压故障)",
  "51101.s\\fault.fault_dischg_battTooHighV": "放电器故障(电池电压过高故障)",
  "51101.s\\fault.fault_dischg_intrCommLost": "放电器故障(内部通信故障)",
  "51101.s\\fault.fault_dischg_extrCommLost": "放电器故障(对外通信故障)",
  "51101.s\\fault.fault_dischg_battVtooLow": "放电器故障(电池电压过低故障)",
  "51101.s\\fault.fault_dischg_softStrpup": "放电器故障(放电器软启故障)",
  "51101.s\\fault.fault_sys_dismatch": "系统故障(机型不匹配)",
  "51101.s\\fault.fault_sys_intrCommLost": "系统故障(内部通信故障)",
  "51101.s\\fault.fault_sys_extCommLost": "系统故障(对外通信故障)",
  "51101.s\\fault.fault_PV1_summary": "PV1故障(故障汇总)",
  "51101.s\\fault.fault_PV1_DCLowV": "PV1故障(DC低压故障)",
  "51101.s\\fault.fault_PV1_DCHighV": "PV1故障(DC高压故障)",
  "51101.s\\fault.fault_PV1_softStrpUp": "PV1故障(软启故障)",
  "51101.s\\fault.fault_PV1_outpuShrtCircuit": "PV1故障(输出短路故障)",
  "51101.s\\fault.fault_PV1_outpuShrtCircuitStrtup": "PV1故障(输出短路启机故障)",
  "51101.s\\fault.fault_PV1_DCVTooHigh": "PV1故障(DC电压过高)",
  "51101.s\\fault.fault_PV1_DCVTooHighFstChck": "PV1故障(DC电压过高快检)",
  "51101.s\\fault.fault_PV1_Vabnormal": "PV1故障(PV工作电压异常)",
  "51101.s\\fault.fault_PV1_inCommLost": "PV1故障(内部通信故障)",
  "51101.s\\fault.fault_PV1_extCommLost": "PV1故障(对外通信故障)",
  "51101.s\\fault.fault_PV1_inputLowV": "PV1故障(PV输入欠压)",
  "51101.s\\fault.fault_PV1_inputHighV": "PV1故障(PV输入过压)",
  "51101.s\\fault.fault_PV2_summary": "PV2故障(故障汇总)",
  "51101.s\\fault.fault_PV2_DCLowV": "PV2故障(DC低压故障)",
  "51101.s\\fault.fault_PV2_DCHighV": "PV2故障(DC高压故障)",
  "51101.s\\fault.fault_PV2_softStrpUp": "PV2故障(软启故障)",
  "51101.s\\fault.fault_PV2_outpuShrtCircuit": "PV2故障(输出短路故障)",
  "51101.s\\fault.fault_PV2_outpuShrtCircuitStrtup": "PV2故障(输出短路启机故障)",
  "51101.s\\fault.fault_PV2_DCVTooHigh": "PV2故障(DC电压过高)",
  "51101.s\\fault.fault_PV2_DCVTooHighFstChck": "PV2故障(DC电压过高快检)",
  "51101.s\\fault.fault_PV2_Vabnormal": "PV2故障(PV工作电压异常)",
  "51101.s\\fault.fault_PV2_inCommLost": "PV2故障(内部通信故障)",
  "51101.s\\fault.fault_PV2_extCommLost": "PV2故障(对外通信故障)",
  "51101.s\\fault.fault_PV2_inputLowV": "PV2故障(PV输入欠压)",
  "51101.s\\fault.fault_PV2_inputHighV": "PV2故障(PV输入过压)",
  "51101.s\\fault.fault_PV3_summary": "PV3故障(故障汇总)",
  "51101.s\\fault.fault_PV3_DCLowV": "PV3故障(DC低压故障)",
  "51101.s\\fault.fault_PV3_DCHighV": "PV3故障(DC高压故障)",
  "51101.s\\fault.fault_PV3_softStrpUp": "PV3故障(软启故障)",
  "51101.s\\fault.fault_PV3_outpuShrtCircuit": "PV3故障(输出短路故障)",
  "51101.s\\fault.fault_PV3_outpuShrtCircuitStrtup": "PV3故障(输出短路启机故障)",
  "51101.s\\fault.fault_PV3_DCVTooHigh": "PV3故障(DC电压过高)",
  "51101.s\\fault.fault_PV3_DCVTooHighFstChck": "PV3故障(DC电压过高快检)",
  "51101.s\\fault.fault_PV3_Vabnormal": "PV3故障(PV工作电压异常)",
  "51101.s\\fault.fault_PV3_inCommLost": "PV3故障(内部通信故障)",
  "51101.s\\fault.fault_PV3_extCommLost": "PV3故障(对外通信故障)",
  "51101.s\\fault.fault_PV3_inputLowV": "PV3故障(PV输入欠压)",
  "51101.s\\fault.fault_PV3_inputHighV": "PV3故障(PV输入过压)",
  "51101.s\\fault.fault_PV4_summary": "PV4故障(故障汇总)",
  "51101.s\\fault.fault_PV4_DCLowV": "PV4故障(DC低压故障)",
  "51101.s\\fault.fault_PV4_DCHighV": "PV4故障(DC高压故障)",
  "51101.s\\fault.fault_PV4_softStrpUp": "PV4故障(软启故障)",
  "51101.s\\fault.fault_PV4_outpuShrtCircuit": "PV4故障(输出短路故障)",
  "51101.s\\fault.fault_PV4_outpuShrtCircuitStrtup": "PV4故障(输出短路启机故障)",
  "51101.s\\fault.fault_PV4_DCVTooHigh": "PV4故障(DC电压过高)",
  "51101.s\\fault.fault_PV4_DCVTooHighFstChck": "PV4故障(DC电压过高快检)",
  "51101.s\\fault.fault_PV4_Vabnormal": "PV4故障(PV工作电压异常)",
  "51101.s\\fault.fault_PV4_inCommLost": "PV4故障(内部通信故障)",
  "51101.s\\fault.fault_PV4_extCommLost": "PV4故障(对外通信故障)",
  "51101.s\\fault.fault_PV4_inputLowV": "PV4故障(PV输入欠压)",
  "51101.s\\fault.fault_PV4_inputHighV": "PV4故障(PV输入过压)",
  "51101.s\\fault.fault_prllt_summary": "并机故障1(故障汇总)",
  "51101.s\\fault.fault_prllt_idConflict": "并机故障1(并机ID冲突故障)",
  "51101.s\\fault.fault_prllt_commErr": "并机故障1(并机通信故障)",
  "51101.s\\fault.fault_prllt_Fdismatch": "并机故障1(并机频率体系不一致)",
  "51101.s\\fault.fault_prllt_failure": "并机故障1(并机失败故障)",
  "51101.s\\fault.fault_prllt2_summary": "并机故障2(故障汇总)",
  "51101.s\\fault.fault_prllt2_avgI": "并机故障2(并机均流故障)",
  "51101.s\\fault.fault_prllt2_FsyncSig": "并机故障2(并机工频同步信号故障)",
  "51101.s\\fault.fault_cell1_avgVHighProtect": "电芯故障1(电芯组均压高保护)",
  "51101.s\\fault.fault_cell1_HighVProtect": "电芯故障1(电芯高压保护)",
  "51101.s\\fault.fault_cell1_avgVlowProtect": "电芯故障1(电芯组均压低保护)",
  "51101.s\\fault.fault_cell1_lowVProtect": "电芯故障1(电芯低压保护)",
  "51101.s\\fault.fault_cell1_cellCntDismatch": "电芯故障1(电池节数不匹配)",
  "51101.s\\fault.fault_cell1_cellUnavail": "电芯故障1(电芯单体失效)",
  "51101.s\\fault.fault_cell1_cellGrpDiffVtooLarge": "电芯故障1(电芯组压差过大)",
  "51101.s\\fault.fault_cell1_seriousHighVProtect": "电芯故障1(电芯严重高压保护)",
  "51101.s\\fault.fault_cell1_seriousLowVProtect": "电芯故障1(电芯严重低压保护)",
  "51101.s\\fault.fault_cell1_srsLowVPrtctShtdwn": "电芯故障1(电芯严重低压保护关机)",
  "51101.s\\fault.fault_cell1_l1ChgStatus": "电芯故障1(一级强充状态-不控制，只播报)",
  "51101.s\\fault.fault_cell1_l2ChgStatus": "电芯故障1(二级强充状态-不控制，只播报)",
  "51101.s\\fault.fault_cell1_tooOverVProtect": "电芯故障1(电芯严重过压保护)",
  "51101.s\\fault.fault_cell2_chgOverISlwChck": "电芯故障2(充电过流慢检(电芯))",
  "51101.s\\fault.fault_cell2_chgOverIFstChck": "电芯故障2(充电过流快检(电芯))",
  "51101.s\\fault.fault_cell2_dischgOverISlwChck": "电芯故障2(放电过流慢检(电芯))",
  "51101.s\\fault.fault_cell2_dischgOverIFstChck": "电芯故障2(放电过流快检(电芯))",
  "51101.s\\fault.fault_cell2_chgOverI": "电芯故障2(充电过流错误)",
  "51101.s\\fault.fault_cell2_dischgOverI": "电芯故障2(放电过流错误)",
  "51101.s\\fault.fault_cellT_TmpSensorDisconn": "电芯温度故障(电芯采样温度探头未插)",
  "51101.s\\fault.fault_cellT_l1OverTChg": "电芯温度故障(电芯一级过温保护(充电))",
  "51101.s\\fault.fault_cellT_l2OverTChg": "电芯温度故障(电芯二级过温保护(充电))",
  "51101.s\\fault.fault_cellT_l1lowTChg": "电芯温度故障(电芯一级低温保护(充电))",
  "51101.s\\fault.fault_cellT_l2lowTChg": "电芯温度故障(电芯二级低温保护(充电))",
  "51101.s\\fault.fault_cellT_l1OverTdisChg": "电芯温度故障(电芯一级过温保护(放电))",
  "51101.s\\fault.fault_cellT_l2OverTdisChg": "电芯温度故障(电芯二级过温保护(放电))",
  "51101.s\\fault.fault_cellT_l1lowTdisChg": "电芯温度故障(电芯一级低温保护(放电))",
  "51101.s\\fault.fault_cellT_l2lowTdisChg": "电芯温度故障(电芯二级低温保护(放电))",
  "51101.s\\fault.fault_cellT_envOverT": "电芯温度故障(环境过温保护)",
  "51101.s\\fault.fault_cellT_envlowT": "电芯温度故障(环境低温保护)",
  "51101.s\\fault.fault_cellT_mosOverT": "电芯温度故障(MOS过温保护)",
  "51101.s\\fault.fault_cellT_diffTtooHigh": "电芯温度故障(温差过大)",
  "51101.s\\fault.fault_cellT_highVsideMosDisconn": "电芯温度故障(高压侧MOS采样探头未插)",
  "51101.s\\fault.fault_eps_summary": "EPS微逆故障(故障汇总)",
  "51101.s\\fault.fault_eps_Vabnormal": "EPS微逆故障(电压异常)",
  "51101.s\\fault.fault_eps_Fabnormal": "EPS微逆故障(频率异常)",
  "51101.s\\fault.fault_eps_VtooLow": "EPS微逆故障(电压过低)",
  "51101.s\\fault.fault_eps_VLow": "EPS微逆故障(电压低)",
  "51101.s\\fault.fault_eps_VHigh": "EPS微逆故障(电压高)",
  "51101.s\\fault.fault_eps_Flow": "EPS微逆故障(频率低)",
  "51101.s\\fault.fault_eps_FHigh": "EPS微逆故障(频率高)",
  "51101.s\\fault.fault_eps_acMainLost": "EPS微逆故障(输入掉电)",
  "51101.s\\fault.fault_eps_inpuSurge": "EPS微逆故障(输入浪涌)",
  "51101.s\\fault.fault_eps_relayOpenCircuit": "EPS微逆故障(继电器开路)",
  "51101.s\\fault.fault_eps_inputOverI": "EPS微逆故障(输入过流)",
  "51101.s\\elct_meter.elct_meter1_SN": "网侧电表SN",
  "51101.s\\elct_meter.elct_meter1_soft_no": "网侧电表软件编号",
  "51101.s\\elct_meter.elct_meter1_soft_ver": "网侧电表软件版本",
  "51101.s\\elct_meter.elct_meter1_hard_ver": "网侧电表硬件版本号",
  "51101.s\\elct_meter.elct_meter1_phase_no": "逆变器所在相位",
  "51101.s\\elct_meter.elct_meter1_online_status": "网侧电表在线状态",
  "51101.s\\elct_meter.elct_meter1_total_active_energy": "网侧电表总有功电能",
  "51101.s\\elct_meter.gridBuyPower": "网侧电表正向有功电能",
  "51101.s\\elct_meter.gridSellPower": "网侧电表反向有功电能",
  "51101.s\\elct_meter.elct_meter1_total_reactive_energy": "网侧电表总无功电能",
  "51101.s\\elct_meter.elct_meter1_forward_reactive_energy": "网侧电表正向无功电能",
  "51101.s\\elct_meter.elct_meter1_reverse_reactive_energy": "网侧电表反向无功电能",
  "51101.s\\elct_meter.elct_meter1_voltage": "网侧电表电压",
  "51101.s\\elct_meter.elct_meter1_current": "网侧电表电流",
  "51101.s\\elct_meter.gridTotalFrequency": "网侧电表频率",
  "51101.s\\elct_meter.gridPower": "网侧电表有功功率",
  "51101.s\\elct_meter.elct_meter1_reactive_power": "网侧电表无功功率",
  "51101.s\\elct_meter.elct_meter1_apparent_power": "网侧电表视在功率",
  "51101.s\\elct_meter.elct_meter1_power_factor": "网侧电表功率因数",
  "51101.s\\elct_meter.elct_meter2_SN": "AC微逆侧电表SN",
  "51101.s\\elct_meter.elct_meter2_soft_no": "AC微逆侧电表软件编号",
  "51101.s\\elct_meter.elct_meter2_soft_ver": "AC微逆侧电表软件版本",
  "51101.s\\elct_meter.elct_meter2_hard_ver": "AC微逆侧电表硬件版本号",
  "51101.s\\elct_meter.elct_meter2_phase_no": "逆变器所在相位",
  "51101.s\\elct_meter.elct_meter2_online_status": "AC微逆侧电表在线状态",
  "51101.s\\elct_meter.elct_meter2_total_active_energy": "AC微逆侧电表总有功电能",
  "51101.s\\elct_meter.elct_meter2_forward_active_energy": "AC微逆侧电表正向有功电能",
  "51101.s\\elct_meter.elct_meter2_reverse_active_energy": "AC微逆侧电表反向有功电能",
  "51101.s\\elct_meter.elct_meter2_total_reactive_energy": "AC微逆侧电表总无功电能",
  "51101.s\\elct_meter.elct_meter2_forward_reactive_energy": "AC微逆侧电表正向无功电能",
  "51101.s\\elct_meter.elct_meter2_reverse_reactive_energy": "AC微逆侧电表反向无功电能",
  "51101.s\\elct_meter.elct_meter2_voltage": "AC微逆侧电表电压",
  "51101.s\\elct_meter.elct_meter2_current": "AC微逆侧电表电流",
  "51101.s\\elct_meter.elct_meter2_frequency": "AC微逆侧电表频率",
  "51101.s\\elct_meter.elct_meter2_active_power": "AC微逆侧电表有功功率",
  "51101.s\\elct_meter.elct_meter2_reactive_power": "AC微逆侧电表无功功率",
  "51101.s\\elct_meter.elct_meter2_apparent_power": "AC微逆侧电表视在功率",
  "51101.s\\elct_meter.elct_meter2_power_factor": "AC微逆侧电表功率因数",
  "51101.s\\collector.c_datalogger_reboot.12544": "重启",
  "51101.s\\collector.c_datalogger_factory_reset.12544": "恢复出厂设置",
  "51101.s\\collector.c_datalogger_ble_onoff.12288": "关闭",
  "51101.s\\collector.c_datalogger_ble_onoff.12544": "打开",
  "51101.s\\collector.c_eletMeter1_insPlace.0": "未设置",
  "51101.s\\collector.c_eletMeter1_insPlace.1": "电网侧",
  "51101.s\\collector.c_eletMeter1_insPlace.2": "AC微逆侧",
  "51101.s\\collector.c_eletMeter1_commType.0": "未设置",
  "51101.s\\collector.c_eletMeter1_commType.1": "无线",
  "51101.s\\collector.c_eletMeter1_commType.2": "有线",
  "51101.s\\collector.c_eletMeter1_phaseNo.0": "单相",
  "51101.s\\collector.c_eletMeter1_phaseNo.1": "A相",
  "51101.s\\collector.c_eletMeter1_phaseNo.2": "B相",
  "51101.s\\collector.c_eletMeter1_phaseNo.3": "C相",
  "51101.s\\collector.c_eletMeter2_insPlace.0": "未设置",
  "51101.s\\collector.c_eletMeter2_insPlace.1": "电网侧",
  "51101.s\\collector.c_eletMeter2_insPlace.2": "AC微逆侧",
  "51101.s\\collector.c_eletMeter2_commType.0": "未设置",
  "51101.s\\collector.c_eletMeter2_commType.1": "无线",
  "51101.s\\collector.c_eletMeter2_commType.2": "有线",
  "51101.s\\collector.c_eletMeter2_phaseNo.0": "单相",
  "51101.s\\collector.c_eletMeter2_phaseNo.1": "A相",
  "51101.s\\collector.c_eletMeter2_phaseNo.2": "B相",
  "51101.s\\collector.c_eletMeter2_phaseNo.3": "C相",
  "51101.s\\real_time.dev_type.0": "微储",
  "51101.s\\real_time.dev_type.1": "户储",
  "51101.s\\real_time.dev_type.2": "混合逆变器",
  "51101.s\\real_time.bms_status.0": "正常",
  "51101.s\\real_time.bms_status.1": "禁放",
  "51101.s\\real_time.bms_status.2": "禁充",
  "51101.s\\real_time.bms_status.3": "禁充禁放",
  "51101.s\\real_time.bms_status.8": "整机下电",
  "51101.s\\real_time.batt_type.0": "314电芯",
  "51101.s\\real_time.batt_type.1": "其他",
  "51101.s\\real_time.anti_curr_status.0": "未开启",
  "51101.s\\real_time.anti_curr_status.1": "开启",
  "51101.s\\real_time.low_volt_cross_status.0": "未开启",
  "51101.s\\real_time.low_volt_cross_status.1": "开启",
  "51101.s\\real_time.f_cross_status.0": "未开启",
  "51101.s\\real_time.f_cross_status.1": "开启",
  "51101.s\\real_time.reconn_cross_status.0": "未开启",
  "51101.s\\real_time.reconn_cross_status.1": "开启",
  "51101.s\\real_time.inv_profile.0": "220V,50Hz中规",
  "51101.s\\real_time.inv_profile.1": "230V,50Hz欧规/英规/澳规",
  "51101.s\\real_time.inv_profile.2": "120V,50Hz美规",
  "51101.s\\real_time.inv_profile.3": "100V,60Hz日规",
  "51101.s\\real_time.inv_profile.4": "220V,60Hz韩规",
  "51101.s\\real_time.inv_profile.5": "230V,60Hz",
  "51101.s\\real_time.inv_profile.6": "120V,50Hz",
  "51101.s\\real_time.inv_profile.7": "110V,60Hz",
  "51101.s\\real_time.inv_manufac.0": "图为",
  "51101.s\\real_time.deviceStatus.0": "未激活",
  "51101.s\\real_time.deviceStatus.1": "激活",
  "51101.s\\real_time.Wifi_BT_Online.0": "离线",
  "51101.s\\real_time.Wifi_BT_Online.1": "在线",
  "51101.s\\real_time.Wifi_BT_Sleep.0": "不休眠",
  "51101.s\\real_time.workStatus.0": "关机",
  "51101.s\\real_time.workStatus.1": "待机",
  "51101.s\\real_time.workStatus.2": "AC充电",
  "51101.s\\real_time.workStatus.3": "AC边充边放",
  "51101.s\\real_time.workStatus.4": "旁路放电",
  "51101.s\\real_time.workStatus.5": "电池放电",
  "51101.s\\real_time.workStatus.6": "PV充电",
  "51101.s\\real_time.workStatus.7": "PV边充边放",
  "51101.s\\real_time.workStatus.8": "PV+AC联合充电",
  "51101.s\\real_time.workStatus.9": "PV+AC联合充电，旁路放电",
  "51101.s\\real_time.workStatus.10": "微逆充电",
  "51101.s\\real_time.workStatus.11": "微逆馈网",
  "51101.s\\real_time.workStatus.12": "微逆+PV联合充电",
  "51101.s\\real_time.workStatus.13": "故障",
  "51101.s\\real_time.workMode.0": "自发自用模式",
  "51101.s\\real_time.workMode.1": "馈网优先模式",
  "51101.s\\real_time.workMode.2": "削峰填谷模式",
  "51101.s\\real_time.workMode.3": "备电模式",
  "51101.s\\real_time.workMode.4": "TOU模式",
  "51101.s\\real_time.workMode.5": "三方调度",
  "51101.s\\real_time.parelletRunStatue.0": "单机",
  "51101.s\\real_time.parelletRunStatue.1": "并机",
  "51101.s\\real_time.acDischargeMode.0": "未输出",
  "51101.s\\real_time.acDischargeMode.1": "正在输出",
  "51101.s\\real_time.acchargeStatus.0": "未充电",
  "51101.s\\real_time.acchargeStatus.1": "正在充电",
  "51101.s\\real_time.MPPTStatus.0": "未充电",
  "51101.s\\real_time.MPPTStatus.1": "正在充电",
  "51101.s\\real_time.SleepStatus.0": "未休眠",
  "51101.s\\real_time.SleepStatus.1": "休眠",
  "51101.s\\real_time.gridConnStatus.0": "并网",
  "51101.s\\real_time.gridConnStatus.1": "离网",
  "51101.s\\real_time.antiReverseIStatus.0": "未开启",
  "51101.s\\real_time.antiReverseIStatus.1": "开启",
  "51101.s\\real_time.masterOrSlaveStatus.0": "从机",
  "51101.s\\real_time.masterOrSlaveStatus.1": "主机",
  "51101.s\\real_time.EPSConnStatus.0": "负载",
  "51101.s\\real_time.EPSConnStatus.1": "微逆",
  "51101.s\\real_time.remote_onoff_status.0": "无效",
  "51101.s\\real_time.remote_onoff_status.1": "开启",
  "51101.s\\real_time.shunt_trip_status.0": "闭合",
  "51101.s\\real_time.shunt_trip_status.1": "断开",
  "51101.s\\real_time.parallel_status.0": "未开启",
  "51101.s\\real_time.parallel_status.1": "开启",
  "51101.s\\real_time.parallel_isMaster.0": "从机",
  "51101.s\\real_time.parallel_isMaster.1": "主机",
  "51101.s\\real_time.EPS_status.0": "未接入",
  "51101.s\\real_time.EPS_status.1": "已接入",
  "51101.s\\real_time.PV1_online_status.0": "不在位",
  "51101.s\\real_time.PV1_online_status.1": "在位",
  "51101.s\\real_time.PV2_online_status.0": "不在位",
  "51101.s\\real_time.PV2_online_status.1": "在位",
  "51101.s\\real_time.PV3_online_status.0": "不在位",
  "51101.s\\real_time.PV3_online_status.1": "在位",
  "51101.s\\real_time.PV4_online_status.0": "不在位",
  "51101.s\\real_time.PV4_online_status.1": "在位",
  "51101.s_w\\ctl_actpower.actpower_ctl_en.0": "不使能",
  "51101.s_w\\ctl_actpower.actpower_ctl_en.1": "使能",
  "51101.s_w\\ctl_reactpower.reactpower_ctl_en.0": "不使能",
  "51101.s_w\\ctl_reactpower.reactpower_ctl_en.1": "使能",
  "51101.s_w\\ctl_reactpower.reactpower_ctl_mode.0": "功率因数模式",
  "51101.s_w\\ctl_reactpower.reactpower_ctl_mode.1": "电压无功功率曲线模式",
  "51101.m_w\\ctl_EMS.ems_ctrl_work_mode.0": "自发自用模式使能",
  "51101.m_w\\ctl_EMS.ems_ctrl_work_mode.1": "馈网优先模式使能",
  "51101.m_w\\ctl_EMS.ems_ctrl_work_mode.2": "削峰填谷模式使能",
  "51101.m_w\\ctl_EMS.ems_ctrl_work_mode.3": "备电模式使能",
  "51101.m_w\\ctl_EMS.ems_ctrl_work_mode.4": "TOU模式使能",
  "51101.m_w\\ctl_EMS.ems_ctrl_work_mode.5": "第三方调度使能",
  "51101.m_w\\ctl_EMS.anti_reverse_curr.0": "禁用",
  "51101.m_w\\ctl_EMS.anti_reverse_curr.1": "使能",
  "51101.s_w\\ctl_EMS.remote_on_off_ctrl.0": "单台关机",
  "51101.s_w\\ctl_EMS.remote_on_off_ctrl.1": "单台开机",
  "51101.s_w\\ctl_EMS.remote_on_off_ctrl.2": "全部关机",
  "51101.s_w\\ctl_EMS.remote_on_off_ctrl.3": "全部开机",
  "51101.s_w\\ctl_EMS.batt_shutdown_ctrl.0": "禁用",
  "51101.s_w\\ctl_EMS.batt_shutdown_ctrl.1": "使能",
  "51101.s_w\\ctl_EMS.factory_recovery.0": "无操作",
  "51101.s_w\\ctl_EMS.factory_recovery.1": "清除电量信息",
  "51101.s_w\\ctl_EMS.factory_recovery.2": "清除日志信息",
  "51101.s_w\\ctl_EMS.factory_recovery.3": "完全恢复出厂设置",
  "51101.m_w\\ctl_EMS.user_type.0": "普通用户",
  "51101.m_w\\ctl_EMS.gridType.0": "EN50549，欧洲通用",
  "51101.m_w\\ctl_EMS.gridType.2": "AU，澳洲",
  "51101.m_w\\ctl_EMS.gridType.3": "AU-W， 澳洲西",
  "51101.m_w\\ctl_EMS.gridType.4": "NZ，新西兰",
  "51101.m_w\\ctl_EMS.gridType.5": "UK，英国",
  "51101.m_w\\ctl_EMS.gridType.6": "PK，巴基斯坦",
  "51101.m_w\\ctl_EMS.gridType.7": "KR，韩国",
  "51101.m_w\\ctl_EMS.gridType.8": "PHI，菲律宾",
  "51101.m_w\\ctl_EMS.gridType.9": "CN，中国",
  "51101.m_w\\ctl_EMS.gridType.10": "US，美国",
  "51101.m_w\\ctl_EMS.gridType.11": "TAI-PEA，泰国PEA",
  "51101.m_w\\ctl_EMS.gridType.12": "ZA，南非",
  "51101.m_w\\ctl_EMS.gridType.13": "Custom 50Hz，自定义50Hz",
  "51101.m_w\\ctl_EMS.gridType.14": "Custom 60Hz，自定义60Hz",
  "51101.m_w\\ctl_EMS.gridType.15": "POL，波兰",
  "51101.m_w\\ctl_EMS.gridType.16": "ITA，意大利",
  "51101.m_w\\ctl_EMS.gridType.17": "SLO，斯洛文尼亚，采用EN50549",
  "51101.m_w\\ctl_EMS.gridType.18": "CZE，捷克，采用EN50549",
  "51101.m_w\\ctl_EMS.gridType.19": "SWE，瑞典，采用EN50549",
  "51101.m_w\\ctl_EMS.gridType.20": "HU，匈牙利",
  "51101.m_w\\ctl_EMS.gridType.21": "SK，斯洛伐克",
  "51101.m_w\\ctl_EMS.gridType.22": "AT，奥地利",
  "51101.m_w\\ctl_EMS.gridType.23": "BE，比利时",
  "51101.m_w\\ctl_EMS.gridType.24": "JM，牙买加",
  "51101.m_w\\ctl_EMS.gridType.25": "IE，爱尔兰",
  "51101.m_w\\ctl_EMS.gridType.26": "KW，科威特",
  "51101.m_w\\ctl_EMS.gridType.27": "ROU，罗马尼亚",
  "51101.m_w\\ctl_EMS.gridType.28": "FR，法国",
  "51101.m_w\\ctl_EMS.gridType.29": "NL，荷兰",
  "51101.m_w\\ctl_EMS.gridType.30": "CH，瑞士",
  "51101.m_w\\ctl_EMS.gridType.31": "ES，西班牙",
  "51101.m_w\\ctl_EMS.gridType.32": "TAI-MEA，泰国MEA",
  "51101.m_w\\ctl_EMS.TOU_work_status.0": "未开启",
  "51101.m_w\\ctl_EMS.TOU_work_status.1": "开启",
  "51101.s\\alarm.alrm_grid_v_low.0": "正常",
  "51101.s\\alarm.alrm_grid_v_low.1": "预警",
  "51101.s\\alarm.alrm_grid_v_high.0": "正常",
  "51101.s\\alarm.alrm_grid_v_high.1": "预警",
  "51101.s\\alarm.alrm_grid_f_low.0": "正常",
  "51101.s\\alarm.alrm_grid_f_low.1": "预警",
  "51101.s\\alarm.alrm_grid_f_high.0": "正常",
  "51101.s\\alarm.alrm_grid_f_high.1": "预警",
  "51101.s\\alarm.alrm_grid_input_overI.0": "正常",
  "51101.s\\alarm.alrm_grid_input_overI.1": "预警",
  "51101.s\\alarm.alrm_PFC_bus_v_low.0": "正常",
  "51101.s\\alarm.alrm_PFC_bus_v_low.1": "预警",
  "51101.s\\alarm.alrm_U1_bus_v_low.0": "正常",
  "51101.s\\alarm.alrm_U1_bus_v_low.1": "预警",
  "51101.s\\alarm.alrm_U1_bus_v_high.0": "正常",
  "51101.s\\alarm.alrm_U1_bus_v_high.1": "预警",
  "51101.s\\alarm.alrm_U2_bus_v_low.0": "正常",
  "51101.s\\alarm.alrm_U2_bus_v_low.1": "预警",
  "51101.s\\alarm.alrm_U2_bus_v_high.0": "正常",
  "51101.s\\alarm.alrm_U2_bus_v_high.1": "预警",
  "51101.s\\alarm.alrm_inv_overload.0": "正常",
  "51101.s\\alarm.alrm_inv_overload.1": "预警",
  "51101.s\\alarm.alrm_bypass_overload.0": "正常",
  "51101.s\\alarm.alrm_bypass_overload.1": "预警",
  "51101.s\\alarm.alrm_inv_v_fault.0": "正常",
  "51101.s\\alarm.alrm_inv_v_fault.1": "预警",
  "51101.s\\alarm.alrm_inv_overV_protect.0": "正常",
  "51101.s\\alarm.alrm_inv_overV_protect.1": "预警",
  "51101.s\\alarm.alrm_inv_lowV_protect.0": "正常",
  "51101.s\\alarm.alrm_inv_lowV_protect.1": "预警",
  "51101.s\\alarm.alrm_inv_overF_protect.0": "正常",
  "51101.s\\alarm.alrm_inv_overF_protect.1": "预警",
  "51101.s\\alarm.alrm_inv_lowF_protect.0": "正常",
  "51101.s\\alarm.alrm_inv_lowF_protect.1": "预警",
  "51101.s\\alarm.alrm_lock_phase_failure.0": "正常",
  "51101.s\\alarm.alrm_lock_phase_failure.1": "预警",
  "51101.s\\alarm.alrm_level2_lock_phase_failure.0": "正常",
  "51101.s\\alarm.alrm_level2_lock_phase_failure.1": "预警",
  "51101.s\\alarm.alrm_T1_tooHigh.0": "正常",
  "51101.s\\alarm.alrm_T1_tooHigh.1": "预警",
  "51101.s\\alarm.alrm_T2_tooHigh.0": "正常",
  "51101.s\\alarm.alrm_T2_tooHigh.1": "预警",
  "51101.s\\alarm.alrm_bypass_lowV.0": "正常",
  "51101.s\\alarm.alrm_bypass_lowV.1": "预警",
  "51101.s\\alarm.alrm_bypass_highV.0": "正常",
  "51101.s\\alarm.alrm_bypass_highV.1": "预警",
  "51101.s\\alarm.alrm_bypass_lowF.0": "正常",
  "51101.s\\alarm.alrm_bypass_lowF.1": "预警",
  "51101.s\\alarm.alrm_bypass_highF.0": "正常",
  "51101.s\\alarm.alrm_bypass_highF.1": "预警",
  "51101.s\\alarm.alrm_chg_lowV.0": "正常",
  "51101.s\\alarm.alrm_chg_lowV.1": "预警",
  "51101.s\\alarm.alrm_chg_highV.0": "正常",
  "51101.s\\alarm.alrm_chg_highV.1": "预警",
  "51101.s\\alarm.alrm_dischg_lowV.0": "正常",
  "51101.s\\alarm.alrm_dischg_lowV.1": "预警",
  "51101.s\\alarm.alrm_dischg_bus_lowV.0": "正常",
  "51101.s\\alarm.alrm_dischg_bus_lowV.1": "预警",
  "51101.s\\alarm.alrm_dischg_batt_highV.0": "正常",
  "51101.s\\alarm.alrm_dischg_batt_highV.1": "预警",
  "51101.s\\alarm.alrm_u1_u2_ver_mismatch.0": "正常",
  "51101.s\\alarm.alrm_u1_u2_ver_mismatch.1": "预警",
  "51101.s\\alarm.alrm_PV1_DC_lowV.0": "正常",
  "51101.s\\alarm.alrm_PV1_DC_lowV.1": "预警",
  "51101.s\\alarm.alrm_PV1_DC_highV.0": "正常",
  "51101.s\\alarm.alrm_PV1_DC_highV.1": "预警",
  "51101.s\\alarm.alrm_PV1_input_lowV.0": "正常",
  "51101.s\\alarm.alrm_PV1_input_lowV.1": "预警",
  "51101.s\\alarm.alrm_PV1_input_highV.0": "正常",
  "51101.s\\alarm.alrm_PV1_input_highV.1": "预警",
  "51101.s\\alarm.alrm_PV2_DC_lowV.0": "正常",
  "51101.s\\alarm.alrm_PV2_DC_lowV.1": "预警",
  "51101.s\\alarm.alrm_PV2_DC_highV.0": "正常",
  "51101.s\\alarm.alrm_PV2_DC_highV.1": "预警",
  "51101.s\\alarm.alrm_PV2_input_lowV.0": "正常",
  "51101.s\\alarm.alrm_PV2_input_lowV.1": "预警",
  "51101.s\\alarm.alrm_PV2_input_highV.0": "正常",
  "51101.s\\alarm.alrm_PV2_input_highV.1": "预警",
  "51101.s\\alarm.alrm_PV3_DC_lowV.0": "正常",
  "51101.s\\alarm.alrm_PV3_DC_lowV.1": "预警",
  "51101.s\\alarm.alrm_PV3_DC_highV.0": "正常",
  "51101.s\\alarm.alrm_PV3_DC_highV.1": "预警",
  "51101.s\\alarm.alrm_PV3_input_lowV.0": "正常",
  "51101.s\\alarm.alrm_PV3_input_lowV.1": "预警",
  "51101.s\\alarm.alrm_PV3_input_highV.0": "正常",
  "51101.s\\alarm.alrm_PV3_input_highV.1": "预警",
  "51101.s\\alarm.alrm_PV4_DC_lowV.0": "正常",
  "51101.s\\alarm.alrm_PV4_DC_lowV.1": "预警",
  "51101.s\\alarm.alrm_PV4_DC_highV.0": "正常",
  "51101.s\\alarm.alrm_PV4_DC_highV.1": "预警",
  "51101.s\\alarm.alrm_PV4_input_lowV.0": "正常",
  "51101.s\\alarm.alrm_PV4_input_lowV.1": "预警",
  "51101.s\\alarm.alrm_PV4_input_highV.0": "正常",
  "51101.s\\alarm.alrm_PV4_input_highV.1": "预警",
  "51101.s\\alarm.alrm_parellet_freq_differ.0": "正常",
  "51101.s\\alarm.alrm_parellet_freq_differ.1": "预警",
  "51101.s\\alarm.alrm_parellet2_avg_I.0": "正常",
  "51101.s\\alarm.alrm_parellet2_avg_I.1": "预警",
  "51101.s\\alarm.alrm_batt_highV.0": "正常",
  "51101.s\\alarm.alrm_batt_highV.1": "预警",
  "51101.s\\alarm.alrm_batt_cell_highV.0": "正常",
  "51101.s\\alarm.alrm_batt_cell_highV.1": "预警",
  "51101.s\\alarm.alrm_batt_lowV.0": "正常",
  "51101.s\\alarm.alrm_batt_lowV.1": "预警",
  "51101.s\\alarm.alrm_batt_cell_lowV.0": "正常",
  "51101.s\\alarm.alrm_batt_cell_lowV.1": "预警",
  "51101.s\\alarm.alrm_cell_slow_check_overI.0": "正常",
  "51101.s\\alarm.alrm_cell_slow_check_overI.1": "预警",
  "51101.s\\alarm.alrm_cell_dischg_slow_check_overI.0": "正常",
  "51101.s\\alarm.alrm_cell_dischg_slow_check_overI.1": "预警",
  "51101.s\\alarm.alrm_cell_chg1_overT.0": "正常",
  "51101.s\\alarm.alrm_cell_chg1_overT.1": "预警",
  "51101.s\\alarm.alrm_cell_chg2_overT.0": "正常",
  "51101.s\\alarm.alrm_cell_chg2_overT.1": "预警",
  "51101.s\\alarm.alrm_cell_chg1_lowT.0": "正常",
  "51101.s\\alarm.alrm_cell_chg1_lowT.1": "预警",
  "51101.s\\alarm.alrm_cell_chg2_lowT.0": "正常",
  "51101.s\\alarm.alrm_cell_chg2_lowT.1": "预警",
  "51101.s\\alarm.alrm_cell_dischg1_overT.0": "正常",
  "51101.s\\alarm.alrm_cell_dischg1_overT.1": "预警",
  "51101.s\\alarm.alrm_cell_dischg2_overT.0": "正常",
  "51101.s\\alarm.alrm_cell_dischg2_overT.1": "预警",
  "51101.s\\alarm.alrm_cell_dischg1_lowT.0": "正常",
  "51101.s\\alarm.alrm_cell_dischg1_lowT.1": "预警",
  "51101.s\\alarm.alrm_cell_dischg2_lowT.0": "正常",
  "51101.s\\alarm.alrm_cell_dischg2_lowT.1": "预警",
  "51101.s\\alarm.alrm_cell_env_overT.0": "正常",
  "51101.s\\alarm.alrm_cell_env_overT.1": "预警",
  "51101.s\\alarm.alrm_cell_env_lowT.0": "正常",
  "51101.s\\alarm.alrm_cell_env_lowT.1": "预警",
  "51101.s\\alarm.alrm_cell_mos_overT.0": "正常",
  "51101.s\\alarm.alrm_cell_mos_overT.1": "预警",
  "51101.s\\alarm.alrm_cell_diffT_large.0": "正常",
  "51101.s\\alarm.alrm_cell_diffT_large.1": "预警",
  "51101.s\\alarm.alrm_eps_lowV.0": "正常",
  "51101.s\\alarm.alrm_eps_lowV.1": "预警",
  "51101.s\\alarm.alrm_eps_highV.0": "正常",
  "51101.s\\alarm.alrm_eps_highV.1": "预警",
  "51101.s\\alarm.alrm_eps_lowF.0": "正常",
  "51101.s\\alarm.alrm_eps_lowF.1": "预警",
  "51101.s\\alarm.alrm_eps_highF.0": "正常",
  "51101.s\\alarm.alrm_eps_highF.1": "预警",
  "51101.s\\alarm.alrm_eps_ac_overI.0": "正常",
  "51101.s\\alarm.alrm_eps_ac_overI.1": "预警",
  "51101.s\\warn.warn_grid_v_low.0": "正常",
  "51101.s\\warn.warn_grid_v_low.1": "告警",
  "51101.s\\warn.warn_grid_v_high.0": "正常",
  "51101.s\\warn.warn_grid_v_high.1": "告警",
  "51101.s\\warn.warn_grid_f_low.0": "正常",
  "51101.s\\warn.warn_grid_f_low.1": "告警",
  "51101.s\\warn.warn_grid_f_high.0": "正常",
  "51101.s\\warn.warn_grid_f_high.1": "告警",
  "51101.s\\warn.warn_grid_I_over.0": "正常",
  "51101.s\\warn.warn_grid_I_over.1": "告警",
  "51101.s\\warn.warn_PFC_bus_v_low.0": "正常",
  "51101.s\\warn.warn_PFC_bus_v_low.1": "告警",
  "51101.s\\warn.warn_U1_bus_v_low.0": "正常",
  "51101.s\\warn.warn_U1_bus_v_low.1": "告警",
  "51101.s\\warn.warn_U1_bus_v_high.0": "正常",
  "51101.s\\warn.warn_U1_bus_v_high.1": "告警",
  "51101.s\\warn.warn_U2_bus_v_low.0": "正常",
  "51101.s\\warn.warn_U2_bus_v_low.1": "告警",
  "51101.s\\warn.warn_U2_bus_v_high.0": "正常",
  "51101.s\\warn.warn_U2_bus_v_high.1": "告警",
  "51101.s\\warn.warn_o_inv_overLoad.0": "正常",
  "51101.s\\warn.warn_o_inv_overLoad.1": "告警",
  "51101.s\\warn.warn_o_byp_overLoad.0": "正常",
  "51101.s\\warn.warn_o_byp_overLoad.1": "告警",
  "51101.s\\warn.warn_PFC_inv_v.0": "正常",
  "51101.s\\warn.warn_PFC_inv_v.1": "告警",
  "51101.s\\warn.warn_PFC_inv_o_over_v.0": "正常",
  "51101.s\\warn.warn_PFC_inv_o_over_v.1": "告警",
  "51101.s\\warn.warn_PFC_inv_o_low_v.0": "正常",
  "51101.s\\warn.warn_PFC_inv_o_low_v.1": "告警",
  "51101.s\\warn.warn_PFC_inv_o_over_f.0": "正常",
  "51101.s\\warn.warn_PFC_inv_o_over_f.1": "告警",
  "51101.s\\warn.warn_PFC_inv_o_low_f.0": "正常",
  "51101.s\\warn.warn_PFC_inv_o_low_f.1": "告警",
  "51101.s\\warn.warn_PLL_grid_pll.0": "正常",
  "51101.s\\warn.warn_PLL_grid_pll.1": "告警",
  "51101.s\\warn.warn_PLL_parellet_pll.0": "正常",
  "51101.s\\warn.warn_PLL_parellet_pll.1": "告警",
  "51101.s\\warn.warn_T1_overT.0": "正常",
  "51101.s\\warn.warn_T1_overT.1": "告警",
  "51101.s\\warn.warn_T2_overT.0": "正常",
  "51101.s\\warn.warn_T2_overT.1": "告警",
  "51101.s\\warn.warn_byp_overT.0": "正常",
  "51101.s\\warn.warn_byp_overT.1": "告警",
  "51101.s\\warn.warn_chg_lowV.0": "正常",
  "51101.s\\warn.warn_chg_lowV.1": "告警",
  "51101.s\\warn.warn_chg_highV.0": "正常",
  "51101.s\\warn.warn_chg_highV.1": "告警",
  "51101.s\\warn.warn_dischg_battV.0": "正常",
  "51101.s\\warn.warn_dischg_battV.1": "告警",
  "51101.s\\warn.warn_dischg_busV.0": "正常",
  "51101.s\\warn.warn_dischg_busV.1": "告警",
  "51101.s\\warn.warn_dischg_battOverV.0": "正常",
  "51101.s\\warn.warn_dischg_battOverV.1": "告警",
  "51101.s\\warn.warn_PV1_dc_lowV.0": "正常",
  "51101.s\\warn.warn_PV1_dc_lowV.1": "告警",
  "51101.s\\warn.warn_PV1_dc_highV.0": "正常",
  "51101.s\\warn.warn_PV1_dc_highV.1": "告警",
  "51101.s\\warn.warn_PV1_pv_input_lowV.0": "正常",
  "51101.s\\warn.warn_PV1_pv_input_lowV.1": "告警",
  "51101.s\\warn.warn_PV1_pv_input_overV.0": "正常",
  "51101.s\\warn.warn_PV1_pv_input_overV.1": "告警",
  "51101.s\\warn.warn_PV2_dc_lowV.0": "正常",
  "51101.s\\warn.warn_PV2_dc_lowV.1": "告警",
  "51101.s\\warn.warn_PV2_dc_highV.0": "正常",
  "51101.s\\warn.warn_PV2_dc_highV.1": "告警",
  "51101.s\\warn.warn_PV2_pv_input_lowV.0": "正常",
  "51101.s\\warn.warn_PV2_pv_input_lowV.1": "告警",
  "51101.s\\warn.warn_PV2_pv_input_overV.0": "正常",
  "51101.s\\warn.warn_PV2_pv_input_overV.1": "告警",
  "51101.s\\warn.warn_PV3_dc_lowV.0": "正常",
  "51101.s\\warn.warn_PV3_dc_lowV.1": "告警",
  "51101.s\\warn.warn_PV3_dc_highV.0": "正常",
  "51101.s\\warn.warn_PV3_dc_highV.1": "告警",
  "51101.s\\warn.warn_PV3_pv_input_lowV.0": "正常",
  "51101.s\\warn.warn_PV3_pv_input_lowV.1": "告警",
  "51101.s\\warn.warn_PV3_pv_input_overV.0": "正常",
  "51101.s\\warn.warn_PV3_pv_input_overV.1": "告警",
  "51101.s\\warn.warn_PV4_dc_lowV.0": "正常",
  "51101.s\\warn.warn_PV4_dc_lowV.1": "告警",
  "51101.s\\warn.warn_PV4_dc_highV.0": "正常",
  "51101.s\\warn.warn_PV4_dc_highV.1": "告警",
  "51101.s\\warn.warn_PV4_pv_input_lowV.0": "正常",
  "51101.s\\warn.warn_PV4_pv_input_lowV.1": "告警",
  "51101.s\\warn.warn_PV4_pv_input_overV.0": "正常",
  "51101.s\\warn.warn_PV4_pv_input_overV.1": "告警",
  "51101.s\\warn.warn_prllt1_f_mismatch.0": "正常",
  "51101.s\\warn.warn_prllt1_f_mismatch.1": "告警",
  "51101.s\\warn.warn_prllt2_avg_I.0": "正常",
  "51101.s\\warn.warn_prllt2_avg_I.1": "告警",
  "51101.s\\warn.warn_cell1_grp_avgV_high.0": "正常",
  "51101.s\\warn.warn_cell1_grp_avgV_high.1": "告警",
  "51101.s\\warn.warn_cell1_overV.0": "正常",
  "51101.s\\warn.warn_cell1_overV.1": "告警",
  "51101.s\\warn.warn_cell1_grp_avgV_low.0": "正常",
  "51101.s\\warn.warn_cell1_grp_avgV_low.1": "告警",
  "51101.s\\warn.warn_cell1_lowV.0": "正常",
  "51101.s\\warn.warn_cell1_lowV.1": "告警",
  "51101.s\\warn.warn_cell2_chgOverISlowChck.0": "正常",
  "51101.s\\warn.warn_cell2_chgOverISlowChck.1": "告警",
  "51101.s\\warn.warn_cell2_dischgOverISlowChck.0": "正常",
  "51101.s\\warn.warn_cell2_dischgOverISlowChck.1": "告警",
  "51101.s\\warn.warn_cellT_L1_overT_chg.0": "正常",
  "51101.s\\warn.warn_cellT_L1_overT_chg.1": "告警",
  "51101.s\\warn.warn_cellT_L2_overT_chg.0": "正常",
  "51101.s\\warn.warn_cellT_L2_overT_chg.1": "告警",
  "51101.s\\warn.warn_cellT_L1_lowT_chg.0": "正常",
  "51101.s\\warn.warn_cellT_L1_lowT_chg.1": "告警",
  "51101.s\\warn.warn_cellT_L2_lowT_chg.0": "正常",
  "51101.s\\warn.warn_cellT_L2_lowT_chg.1": "告警",
  "51101.s\\warn.warn_cellT_L1_overT_dischg.0": "正常",
  "51101.s\\warn.warn_cellT_L1_overT_dischg.1": "告警",
  "51101.s\\warn.warn_cellT_L2_overT_dischg.0": "正常",
  "51101.s\\warn.warn_cellT_L2_overT_dischg.1": "告警",
  "51101.s\\warn.warn_cellT_L1_lowT_dischg.0": "正常",
  "51101.s\\warn.warn_cellT_L1_lowT_dischg.1": "告警",
  "51101.s\\warn.warn_cellT_L2_lowT_dischg.0": "正常",
  "51101.s\\warn.warn_cellT_L2_lowT_dischg.1": "告警",
  "51101.s\\warn.warn_cellT_env_overT.0": "正常",
  "51101.s\\warn.warn_cellT_env_overT.1": "告警",
  "51101.s\\warn.warn_cellT_env_lowT.0": "正常",
  "51101.s\\warn.warn_cellT_env_lowT.1": "告警",
  "51101.s\\warn.warn_cellT_mos_overT.0": "正常",
  "51101.s\\warn.warn_cellT_mos_overT.1": "告警",
  "51101.s\\warn.warn_cellT_diffT_toolarge.0": "正常",
  "51101.s\\warn.warn_cellT_diffT_toolarge.1": "告警",
  "51101.s\\warn.warn_eps_lowV.0": "正常",
  "51101.s\\warn.warn_eps_lowV.1": "告警",
  "51101.s\\warn.warn_eps_highV.0": "正常",
  "51101.s\\warn.warn_eps_highV.1": "告警",
  "51101.s\\warn.warn_eps_lowF.0": "正常",
  "51101.s\\warn.warn_eps_lowF.1": "告警",
  "51101.s\\warn.warn_eps_highF.0": "正常",
  "51101.s\\warn.warn_eps_highF.1": "告警",
  "51101.s\\warn.warn_eps_i_overI.0": "正常",
  "51101.s\\warn.warn_eps_i_overI.1": "告警",
  "51101.s\\fault.fault_grid_summary.0": "正常",
  "51101.s\\fault.fault_grid_summary.1": "故障",
  "51101.s\\fault.fault_grid_Vabnormal.0": "正常",
  "51101.s\\fault.fault_grid_Vabnormal.1": "故障",
  "51101.s\\fault.fault_grid_Fabnormal.0": "正常",
  "51101.s\\fault.fault_grid_Fabnormal.1": "故障",
  "51101.s\\fault.fault_grid_lowV.0": "正常",
  "51101.s\\fault.fault_grid_lowV.1": "故障",
  "51101.s\\fault.fault_grid_highV.0": "正常",
  "51101.s\\fault.fault_grid_highV.1": "故障",
  "51101.s\\fault.fault_grid_lowF.0": "正常",
  "51101.s\\fault.fault_grid_lowF.1": "故障",
  "51101.s\\fault.fault_grid_highF.0": "正常",
  "51101.s\\fault.fault_grid_highF.1": "故障",
  "51101.s\\fault.fault_grid_gridLost.0": "正常",
  "51101.s\\fault.fault_grid_gridLost.1": "故障",
  "51101.s\\fault.fault_grid_gridSurge.0": "正常",
  "51101.s\\fault.fault_grid_gridSurge.1": "故障",
  "51101.s\\fault.fault_grid_relayOpen.0": "正常",
  "51101.s\\fault.fault_grid_relayOpen.1": "故障",
  "51101.s\\fault.fault_grid_ac_i_overI.0": "正常",
  "51101.s\\fault.fault_grid_ac_i_overI.1": "故障",
  "51101.s\\fault.fault_PFC_summary.0": "正常",
  "51101.s\\fault.fault_PFC_summary.1": "故障",
  "51101.s\\fault.fault_PFC_hardSoftStrtup.0": "正常",
  "51101.s\\fault.fault_PFC_hardSoftStrtup.1": "故障",
  "51101.s\\fault.fault_PFC_softSoftStrtup.0": "正常",
  "51101.s\\fault.fault_PFC_softSoftStrtup.1": "故障",
  "51101.s\\fault.fault_PFC_bus_lowV.0": "正常",
  "51101.s\\fault.fault_PFC_bus_lowV.1": "故障",
  "51101.s\\fault.fault_PFC_intr_comm_lost.0": "正常",
  "51101.s\\fault.fault_PFC_intr_comm_lost.1": "故障",
  "51101.s\\fault.fault_PFC_extrnl_comm_lost.0": "正常",
  "51101.s\\fault.fault_PFC_extrnl_comm_lost.1": "故障",
  "51101.s\\fault.fault_U1bus_summary.0": "正常",
  "51101.s\\fault.fault_U1bus_summary.1": "故障",
  "51101.s\\fault.fault_U1bus_lowV_abnormal.0": "正常",
  "51101.s\\fault.fault_U1bus_lowV_abnormal.1": "故障",
  "51101.s\\fault.fault_U1bus_highV_abnormal.0": "正常",
  "51101.s\\fault.fault_U1bus_highV_abnormal.1": "故障",
  "51101.s\\fault.fault_U1bus_tooLowV.0": "正常",
  "51101.s\\fault.fault_U1bus_tooLowV.1": "故障",
  "51101.s\\fault.fault_U1bus_tooHighV.0": "正常",
  "51101.s\\fault.fault_U1bus_tooHighV.1": "故障",
  "51101.s\\fault.fault_U1bus_VtooHighFastChck.0": "正常",
  "51101.s\\fault.fault_U1bus_VtooHighFastChck.1": "故障",
  "51101.s\\fault.fault_U2bus_summary.0": "正常",
  "51101.s\\fault.fault_U2bus_summary.1": "故障",
  "51101.s\\fault.fault_U2bus_lowV_abnormal.0": "正常",
  "51101.s\\fault.fault_U2bus_lowV_abnormal.1": "故障",
  "51101.s\\fault.fault_U2bus_highV_abnormal.0": "正常",
  "51101.s\\fault.fault_U2bus_highV_abnormal.1": "故障",
  "51101.s\\fault.fault_U2bus_tooLowV.0": "正常",
  "51101.s\\fault.fault_U2bus_tooLowV.1": "故障",
  "51101.s\\fault.fault_U2bus_tooHighV.0": "正常",
  "51101.s\\fault.fault_U2bus_tooHighV.1": "故障",
  "51101.s\\fault.fault_U2bus_VtooHighFastChck.0": "正常",
  "51101.s\\fault.fault_U2bus_VtooHighFastChck.1": "故障",
  "51101.s\\fault.fault_U2bus_PNbusUnbalance.0": "正常",
  "51101.s\\fault.fault_U2bus_PNbusUnbalance.1": "故障",
  "51101.s\\fault.fault_U2bus_busAvgVlargeV.0": "正常",
  "51101.s\\fault.fault_U2bus_busAvgVlargeV.1": "故障",
  "51101.s\\fault.fault_U2bus_busAvgVlargeI.0": "正常",
  "51101.s\\fault.fault_U2bus_busAvgVlargeI.1": "故障",
  "51101.s\\fault.fault_U2bus_busAvgVlargeIFastChck.0": "正常",
  "51101.s\\fault.fault_U2bus_busAvgVlargeIFastChck.1": "故障",
  "51101.s\\fault.fault_o_summary.0": "正常",
  "51101.s\\fault.fault_o_summary.1": "故障",
  "51101.s\\fault.fault_o_invRalayOpen.0": "正常",
  "51101.s\\fault.fault_o_invRalayOpen.1": "故障",
  "51101.s\\fault.fault_o_invOverLoad.0": "正常",
  "51101.s\\fault.fault_o_invOverLoad.1": "故障",
  "51101.s\\fault.fault_o_bypOverLoad.0": "正常",
  "51101.s\\fault.fault_o_bypOverLoad.1": "故障",
  "51101.s\\fault.fault_inv_summary.0": "正常",
  "51101.s\\fault.fault_inv_summary.1": "故障",
  "51101.s\\fault.fault_inv_invFastChck.0": "正常",
  "51101.s\\fault.fault_inv_invFastChck.1": "故障",
  "51101.s\\fault.fault_inv_invSlowChck.0": "正常",
  "51101.s\\fault.fault_inv_invSlowChck.1": "故障",
  "51101.s\\fault.fault_inv_RelayStuck.0": "正常",
  "51101.s\\fault.fault_inv_RelayStuck.1": "故障",
  "51101.s\\fault.fault_inv_invShortCircuit.0": "正常",
  "51101.s\\fault.fault_inv_invShortCircuit.1": "故障",
  "51101.s\\fault.fault_inv_intrCommErr.0": "正常",
  "51101.s\\fault.fault_inv_intrCommErr.1": "故障",
  "51101.s\\fault.fault_inv_extCommErr.0": "正常",
  "51101.s\\fault.fault_inv_extCommErr.1": "故障",
  "51101.s\\fault.fault_inv_invVabnormal.0": "正常",
  "51101.s\\fault.fault_inv_invVabnormal.1": "故障",
  "51101.s\\fault.fault_inv_outputOverVProtect.0": "正常",
  "51101.s\\fault.fault_inv_outputOverVProtect.1": "故障",
  "51101.s\\fault.fault_inv_outputLowVProtect.0": "正常",
  "51101.s\\fault.fault_inv_outputLowVProtect.1": "故障",
  "51101.s\\fault.fault_inv_outputOverFProtect.0": "正常",
  "51101.s\\fault.fault_inv_outputOverFProtect.1": "故障",
  "51101.s\\fault.fault_inv_outputlowFProtect.0": "正常",
  "51101.s\\fault.fault_inv_outputlowFProtect.1": "故障",
  "51101.s\\fault.fault_PLL_summary.0": "正常",
  "51101.s\\fault.fault_PLL_summary.1": "故障",
  "51101.s\\fault.fault_PLL_acMainPll.0": "正常",
  "51101.s\\fault.fault_PLL_acMainPll.1": "故障",
  "51101.s\\fault.fault_PLL_secondaryPllLocked.0": "正常",
  "51101.s\\fault.fault_PLL_secondaryPllLocked.1": "故障",
  "51101.s\\fault.fault_T_summary.0": "正常",
  "51101.s\\fault.fault_T_summary.1": "故障",
  "51101.s\\fault.fault_T_TtooHigh.0": "正常",
  "51101.s\\fault.fault_T_TtooHigh.1": "故障",
  "51101.s\\fault.fault_T_TmpPinDisconn.0": "正常",
  "51101.s\\fault.fault_T_TmpPinDisconn.1": "故障",
  "51101.s\\fault.fault_T2_summary.0": "正常",
  "51101.s\\fault.fault_T2_summary.1": "故障",
  "51101.s\\fault.fault_T2_TtooHigh.0": "正常",
  "51101.s\\fault.fault_T2_TtooHigh.1": "故障",
  "51101.s\\fault.fault_T2_TmpPinDisconn.0": "正常",
  "51101.s\\fault.fault_T2_TmpPinDisconn.1": "故障",
  "51101.s\\fault.fault_byp_summary.0": "正常",
  "51101.s\\fault.fault_byp_summary.1": "故障",
  "51101.s\\fault.fault_byp_Vabnormal.0": "正常",
  "51101.s\\fault.fault_byp_Vabnormal.1": "故障",
  "51101.s\\fault.fault_byp_Fabnormal.0": "正常",
  "51101.s\\fault.fault_byp_Fabnormal.1": "故障",
  "51101.s\\fault.fault_byp_VtooLow.0": "正常",
  "51101.s\\fault.fault_byp_VtooLow.1": "故障",
  "51101.s\\fault.fault_byp_VtooHigh.0": "正常",
  "51101.s\\fault.fault_byp_VtooHigh.1": "故障",
  "51101.s\\fault.fault_byp_FtooLow.0": "正常",
  "51101.s\\fault.fault_byp_FtooLow.1": "故障",
  "51101.s\\fault.fault_byp_FtooHigh.0": "正常",
  "51101.s\\fault.fault_byp_FtooHigh.1": "故障",
  "51101.s\\fault.fault_byp_bypShtdwn.0": "正常",
  "51101.s\\fault.fault_byp_bypShtdwn.1": "故障",
  "51101.s\\fault.fault_byp_bypInrush.0": "正常",
  "51101.s\\fault.fault_byp_bypInrush.1": "故障",
  "51101.s\\fault.fault_byp_intrCommErr.0": "正常",
  "51101.s\\fault.fault_byp_intrCommErr.1": "故障",
  "51101.s\\fault.fault_byp_extCommErr.0": "正常",
  "51101.s\\fault.fault_byp_extCommErr.1": "故障",
  "51101.s\\fault.fault_chg_summary.0": "正常",
  "51101.s\\fault.fault_chg_summary.1": "故障",
  "51101.s\\fault.fault_chg_lowV.0": "正常",
  "51101.s\\fault.fault_chg_lowV.1": "故障",
  "51101.s\\fault.fault_chg_HighV.0": "正常",
  "51101.s\\fault.fault_chg_HighV.1": "故障",
  "51101.s\\fault.fault_chg_OutputShortCircuit.0": "正常",
  "51101.s\\fault.fault_chg_OutputShortCircuit.1": "故障",
  "51101.s\\fault.fault_chg_softStrpup.0": "正常",
  "51101.s\\fault.fault_chg_softStrpup.1": "故障",
  "51101.s\\fault.fault_chg_busVAbnormal.0": "正常",
  "51101.s\\fault.fault_chg_busVAbnormal.1": "故障",
  "51101.s\\fault.fault_chg_oVTooLowFastChck.0": "正常",
  "51101.s\\fault.fault_chg_oVTooLowFastChck.1": "故障",
  "51101.s\\fault.fault_chg_oVTooHigh.0": "正常",
  "51101.s\\fault.fault_chg_oVTooHigh.1": "故障",
  "51101.s\\fault.fault_chg_oVTooHighFastChck.0": "正常",
  "51101.s\\fault.fault_chg_oVTooHighFastChck.1": "故障",
  "51101.s\\fault.fault_chg_acChgUnenough.0": "正常",
  "51101.s\\fault.fault_chg_acChgUnenough.1": "故障",
  "51101.s\\fault.fault_chg_intrCommErr.0": "正常",
  "51101.s\\fault.fault_chg_intrCommErr.1": "故障",
  "51101.s\\fault.fault_chg_outCommErr.0": "正常",
  "51101.s\\fault.fault_chg_outCommErr.1": "故障",
  "51101.s\\fault.fault_chg_extCommErr.0": "正常",
  "51101.s\\fault.fault_chg_extCommErr.1": "故障",
  "51101.s\\fault.fault_chg_bypSundenlyAddLoad.0": "正常",
  "51101.s\\fault.fault_chg_bypSundenlyAddLoad.1": "故障",
  "51101.s\\fault.fault_dischg_summary.0": "正常",
  "51101.s\\fault.fault_dischg_summary.1": "故障",
  "51101.s\\fault.fault_dischg_battLowV.0": "正常",
  "51101.s\\fault.fault_dischg_battLowV.1": "故障",
  "51101.s\\fault.fault_dischg_busLowV.0": "正常",
  "51101.s\\fault.fault_dischg_busLowV.1": "故障",
  "51101.s\\fault.fault_dischg_battHighV.0": "正常",
  "51101.s\\fault.fault_dischg_battHighV.1": "故障",
  "51101.s\\fault.fault_dischg_battTooHighV.0": "正常",
  "51101.s\\fault.fault_dischg_battTooHighV.1": "故障",
  "51101.s\\fault.fault_dischg_intrCommLost.0": "正常",
  "51101.s\\fault.fault_dischg_intrCommLost.1": "故障",
  "51101.s\\fault.fault_dischg_extrCommLost.0": "正常",
  "51101.s\\fault.fault_dischg_extrCommLost.1": "故障",
  "51101.s\\fault.fault_dischg_battVtooLow.0": "正常",
  "51101.s\\fault.fault_dischg_battVtooLow.1": "故障",
  "51101.s\\fault.fault_dischg_softStrpup.0": "正常",
  "51101.s\\fault.fault_dischg_softStrpup.1": "故障",
  "51101.s\\fault.fault_sys_dismatch.0": "正常",
  "51101.s\\fault.fault_sys_dismatch.1": "故障",
  "51101.s\\fault.fault_sys_intrCommLost.0": "正常",
  "51101.s\\fault.fault_sys_intrCommLost.1": "故障",
  "51101.s\\fault.fault_sys_extCommLost.0": "正常",
  "51101.s\\fault.fault_sys_extCommLost.1": "故障",
  "51101.s\\fault.fault_PV1_summary.0": "正常",
  "51101.s\\fault.fault_PV1_summary.1": "故障",
  "51101.s\\fault.fault_PV1_DCLowV.0": "正常",
  "51101.s\\fault.fault_PV1_DCLowV.1": "故障",
  "51101.s\\fault.fault_PV1_DCHighV.0": "正常",
  "51101.s\\fault.fault_PV1_DCHighV.1": "故障",
  "51101.s\\fault.fault_PV1_softStrpUp.0": "正常",
  "51101.s\\fault.fault_PV1_softStrpUp.1": "故障",
  "51101.s\\fault.fault_PV1_outpuShrtCircuit.0": "正常",
  "51101.s\\fault.fault_PV1_outpuShrtCircuit.1": "故障",
  "51101.s\\fault.fault_PV1_outpuShrtCircuitStrtup.0": "正常",
  "51101.s\\fault.fault_PV1_outpuShrtCircuitStrtup.1": "故障",
  "51101.s\\fault.fault_PV1_DCVTooHigh.0": "正常",
  "51101.s\\fault.fault_PV1_DCVTooHigh.1": "故障",
  "51101.s\\fault.fault_PV1_DCVTooHighFstChck.0": "正常",
  "51101.s\\fault.fault_PV1_DCVTooHighFstChck.1": "故障",
  "51101.s\\fault.fault_PV1_Vabnormal.0": "正常",
  "51101.s\\fault.fault_PV1_Vabnormal.1": "故障",
  "51101.s\\fault.fault_PV1_inCommLost.0": "正常",
  "51101.s\\fault.fault_PV1_inCommLost.1": "故障",
  "51101.s\\fault.fault_PV1_extCommLost.0": "正常",
  "51101.s\\fault.fault_PV1_extCommLost.1": "故障",
  "51101.s\\fault.fault_PV1_inputLowV.0": "正常",
  "51101.s\\fault.fault_PV1_inputLowV.1": "故障",
  "51101.s\\fault.fault_PV1_inputHighV.0": "正常",
  "51101.s\\fault.fault_PV1_inputHighV.1": "故障",
  "51101.s\\fault.fault_PV2_summary.0": "正常",
  "51101.s\\fault.fault_PV2_summary.1": "故障",
  "51101.s\\fault.fault_PV2_DCLowV.0": "正常",
  "51101.s\\fault.fault_PV2_DCLowV.1": "故障",
  "51101.s\\fault.fault_PV2_DCHighV.0": "正常",
  "51101.s\\fault.fault_PV2_DCHighV.1": "故障",
  "51101.s\\fault.fault_PV2_softStrpUp.0": "正常",
  "51101.s\\fault.fault_PV2_softStrpUp.1": "故障",
  "51101.s\\fault.fault_PV2_outpuShrtCircuit.0": "正常",
  "51101.s\\fault.fault_PV2_outpuShrtCircuit.1": "故障",
  "51101.s\\fault.fault_PV2_outpuShrtCircuitStrtup.0": "正常",
  "51101.s\\fault.fault_PV2_outpuShrtCircuitStrtup.1": "故障",
  "51101.s\\fault.fault_PV2_DCVTooHigh.0": "正常",
  "51101.s\\fault.fault_PV2_DCVTooHigh.1": "故障",
  "51101.s\\fault.fault_PV2_DCVTooHighFstChck.0": "正常",
  "51101.s\\fault.fault_PV2_DCVTooHighFstChck.1": "故障",
  "51101.s\\fault.fault_PV2_Vabnormal.0": "正常",
  "51101.s\\fault.fault_PV2_Vabnormal.1": "故障",
  "51101.s\\fault.fault_PV2_inCommLost.0": "正常",
  "51101.s\\fault.fault_PV2_inCommLost.1": "故障",
  "51101.s\\fault.fault_PV2_extCommLost.0": "正常",
  "51101.s\\fault.fault_PV2_extCommLost.1": "故障",
  "51101.s\\fault.fault_PV2_inputLowV.0": "正常",
  "51101.s\\fault.fault_PV2_inputLowV.1": "故障",
  "51101.s\\fault.fault_PV2_inputHighV.0": "正常",
  "51101.s\\fault.fault_PV2_inputHighV.1": "故障",
  "51101.s\\fault.fault_PV3_summary.0": "正常",
  "51101.s\\fault.fault_PV3_summary.1": "故障",
  "51101.s\\fault.fault_PV3_DCLowV.0": "正常",
  "51101.s\\fault.fault_PV3_DCLowV.1": "故障",
  "51101.s\\fault.fault_PV3_DCHighV.0": "正常",
  "51101.s\\fault.fault_PV3_DCHighV.1": "故障",
  "51101.s\\fault.fault_PV3_softStrpUp.0": "正常",
  "51101.s\\fault.fault_PV3_softStrpUp.1": "故障",
  "51101.s\\fault.fault_PV3_outpuShrtCircuit.0": "正常",
  "51101.s\\fault.fault_PV3_outpuShrtCircuit.1": "故障",
  "51101.s\\fault.fault_PV3_outpuShrtCircuitStrtup.0": "正常",
  "51101.s\\fault.fault_PV3_outpuShrtCircuitStrtup.1": "故障",
  "51101.s\\fault.fault_PV3_DCVTooHigh.0": "正常",
  "51101.s\\fault.fault_PV3_DCVTooHigh.1": "故障",
  "51101.s\\fault.fault_PV3_DCVTooHighFstChck.0": "正常",
  "51101.s\\fault.fault_PV3_DCVTooHighFstChck.1": "故障",
  "51101.s\\fault.fault_PV3_Vabnormal.0": "正常",
  "51101.s\\fault.fault_PV3_Vabnormal.1": "故障",
  "51101.s\\fault.fault_PV3_inCommLost.0": "正常",
  "51101.s\\fault.fault_PV3_inCommLost.1": "故障",
  "51101.s\\fault.fault_PV3_extCommLost.0": "正常",
  "51101.s\\fault.fault_PV3_extCommLost.1": "故障",
  "51101.s\\fault.fault_PV3_inputLowV.0": "正常",
  "51101.s\\fault.fault_PV3_inputLowV.1": "故障",
  "51101.s\\fault.fault_PV3_inputHighV.0": "正常",
  "51101.s\\fault.fault_PV3_inputHighV.1": "故障",
  "51101.s\\fault.fault_PV4_summary.0": "正常",
  "51101.s\\fault.fault_PV4_summary.1": "故障",
  "51101.s\\fault.fault_PV4_DCLowV.0": "正常",
  "51101.s\\fault.fault_PV4_DCLowV.1": "故障",
  "51101.s\\fault.fault_PV4_DCHighV.0": "正常",
  "51101.s\\fault.fault_PV4_DCHighV.1": "故障",
  "51101.s\\fault.fault_PV4_softStrpUp.0": "正常",
  "51101.s\\fault.fault_PV4_softStrpUp.1": "故障",
  "51101.s\\fault.fault_PV4_outpuShrtCircuit.0": "正常",
  "51101.s\\fault.fault_PV4_outpuShrtCircuit.1": "故障",
  "51101.s\\fault.fault_PV4_outpuShrtCircuitStrtup.0": "正常",
  "51101.s\\fault.fault_PV4_outpuShrtCircuitStrtup.1": "故障",
  "51101.s\\fault.fault_PV4_DCVTooHigh.0": "正常",
  "51101.s\\fault.fault_PV4_DCVTooHigh.1": "故障",
  "51101.s\\fault.fault_PV4_DCVTooHighFstChck.0": "正常",
  "51101.s\\fault.fault_PV4_DCVTooHighFstChck.1": "故障",
  "51101.s\\fault.fault_PV4_Vabnormal.0": "正常",
  "51101.s\\fault.fault_PV4_Vabnormal.1": "故障",
  "51101.s\\fault.fault_PV4_inCommLost.0": "正常",
  "51101.s\\fault.fault_PV4_inCommLost.1": "故障",
  "51101.s\\fault.fault_PV4_extCommLost.0": "正常",
  "51101.s\\fault.fault_PV4_extCommLost.1": "故障",
  "51101.s\\fault.fault_PV4_inputLowV.0": "正常",
  "51101.s\\fault.fault_PV4_inputLowV.1": "故障",
  "51101.s\\fault.fault_PV4_inputHighV.0": "正常",
  "51101.s\\fault.fault_PV4_inputHighV.1": "故障",
  "51101.s\\fault.fault_prllt_summary.0": "正常",
  "51101.s\\fault.fault_prllt_summary.1": "故障",
  "51101.s\\fault.fault_prllt_idConflict.0": "正常",
  "51101.s\\fault.fault_prllt_idConflict.1": "故障",
  "51101.s\\fault.fault_prllt_commErr.0": "正常",
  "51101.s\\fault.fault_prllt_commErr.1": "故障",
  "51101.s\\fault.fault_prllt_Fdismatch.0": "正常",
  "51101.s\\fault.fault_prllt_Fdismatch.1": "故障",
  "51101.s\\fault.fault_prllt_failure.0": "正常",
  "51101.s\\fault.fault_prllt_failure.1": "故障",
  "51101.s\\fault.fault_prllt2_summary.0": "正常",
  "51101.s\\fault.fault_prllt2_summary.1": "故障",
  "51101.s\\fault.fault_prllt2_avgI.0": "正常",
  "51101.s\\fault.fault_prllt2_avgI.1": "故障",
  "51101.s\\fault.fault_prllt2_FsyncSig.0": "正常",
  "51101.s\\fault.fault_prllt2_FsyncSig.1": "故障",
  "51101.s\\fault.fault_cell1_avgVHighProtect.0": "正常",
  "51101.s\\fault.fault_cell1_avgVHighProtect.1": "故障",
  "51101.s\\fault.fault_cell1_HighVProtect.0": "正常",
  "51101.s\\fault.fault_cell1_HighVProtect.1": "故障",
  "51101.s\\fault.fault_cell1_avgVlowProtect.0": "正常",
  "51101.s\\fault.fault_cell1_avgVlowProtect.1": "故障",
  "51101.s\\fault.fault_cell1_lowVProtect.0": "正常",
  "51101.s\\fault.fault_cell1_lowVProtect.1": "故障",
  "51101.s\\fault.fault_cell1_cellCntDismatch.0": "正常",
  "51101.s\\fault.fault_cell1_cellCntDismatch.1": "故障",
  "51101.s\\fault.fault_cell1_cellUnavail.0": "正常",
  "51101.s\\fault.fault_cell1_cellUnavail.1": "故障",
  "51101.s\\fault.fault_cell1_cellGrpDiffVtooLarge.0": "正常",
  "51101.s\\fault.fault_cell1_cellGrpDiffVtooLarge.1": "故障",
  "51101.s\\fault.fault_cell1_seriousHighVProtect.0": "正常",
  "51101.s\\fault.fault_cell1_seriousHighVProtect.1": "故障",
  "51101.s\\fault.fault_cell1_seriousLowVProtect.0": "正常",
  "51101.s\\fault.fault_cell1_seriousLowVProtect.1": "故障",
  "51101.s\\fault.fault_cell1_srsLowVPrtctShtdwn.0": "正常",
  "51101.s\\fault.fault_cell1_srsLowVPrtctShtdwn.1": "故障",
  "51101.s\\fault.fault_cell1_l1ChgStatus.0": "正常",
  "51101.s\\fault.fault_cell1_l1ChgStatus.1": "故障",
  "51101.s\\fault.fault_cell1_l2ChgStatus.0": "正常",
  "51101.s\\fault.fault_cell1_l2ChgStatus.1": "故障",
  "51101.s\\fault.fault_cell1_tooOverVProtect.0": "正常",
  "51101.s\\fault.fault_cell1_tooOverVProtect.1": "故障",
  "51101.s\\fault.fault_cell2_chgOverISlwChck.0": "正常",
  "51101.s\\fault.fault_cell2_chgOverISlwChck.1": "故障",
  "51101.s\\fault.fault_cell2_chgOverIFstChck.0": "正常",
  "51101.s\\fault.fault_cell2_chgOverIFstChck.1": "故障",
  "51101.s\\fault.fault_cell2_dischgOverISlwChck.0": "正常",
  "51101.s\\fault.fault_cell2_dischgOverISlwChck.1": "故障",
  "51101.s\\fault.fault_cell2_dischgOverIFstChck.0": "正常",
  "51101.s\\fault.fault_cell2_dischgOverIFstChck.1": "故障",
  "51101.s\\fault.fault_cell2_chgOverI.0": "正常",
  "51101.s\\fault.fault_cell2_chgOverI.1": "故障",
  "51101.s\\fault.fault_cell2_dischgOverI.0": "正常",
  "51101.s\\fault.fault_cell2_dischgOverI.1": "故障",
  "51101.s\\fault.fault_cellT_TmpSensorDisconn.0": "正常",
  "51101.s\\fault.fault_cellT_TmpSensorDisconn.1": "故障",
  "51101.s\\fault.fault_cellT_l1OverTChg.0": "正常",
  "51101.s\\fault.fault_cellT_l1OverTChg.1": "故障",
  "51101.s\\fault.fault_cellT_l2OverTChg.0": "正常",
  "51101.s\\fault.fault_cellT_l2OverTChg.1": "故障",
  "51101.s\\fault.fault_cellT_l1lowTChg.0": "正常",
  "51101.s\\fault.fault_cellT_l1lowTChg.1": "故障",
  "51101.s\\fault.fault_cellT_l2lowTChg.0": "正常",
  "51101.s\\fault.fault_cellT_l2lowTChg.1": "故障",
  "51101.s\\fault.fault_cellT_l1OverTdisChg.0": "正常",
  "51101.s\\fault.fault_cellT_l1OverTdisChg.1": "故障",
  "51101.s\\fault.fault_cellT_l2OverTdisChg.0": "正常",
  "51101.s\\fault.fault_cellT_l2OverTdisChg.1": "故障",
  "51101.s\\fault.fault_cellT_l1lowTdisChg.0": "正常",
  "51101.s\\fault.fault_cellT_l1lowTdisChg.1": "故障",
  "51101.s\\fault.fault_cellT_l2lowTdisChg.0": "正常",
  "51101.s\\fault.fault_cellT_l2lowTdisChg.1": "故障",
  "51101.s\\fault.fault_cellT_envOverT.0": "正常",
  "51101.s\\fault.fault_cellT_envOverT.1": "故障",
  "51101.s\\fault.fault_cellT_envlowT.0": "正常",
  "51101.s\\fault.fault_cellT_envlowT.1": "故障",
  "51101.s\\fault.fault_cellT_mosOverT.0": "正常",
  "51101.s\\fault.fault_cellT_mosOverT.1": "故障",
  "51101.s\\fault.fault_cellT_diffTtooHigh.0": "正常",
  "51101.s\\fault.fault_cellT_diffTtooHigh.1": "故障",
  "51101.s\\fault.fault_cellT_highVsideMosDisconn.0": "正常",
  "51101.s\\fault.fault_cellT_highVsideMosDisconn.1": "故障",
  "51101.s\\fault.fault_eps_summary.0": "正常",
  "51101.s\\fault.fault_eps_summary.1": "故障",
  "51101.s\\fault.fault_eps_Vabnormal.0": "正常",
  "51101.s\\fault.fault_eps_Vabnormal.1": "故障",
  "51101.s\\fault.fault_eps_Fabnormal.0": "正常",
  "51101.s\\fault.fault_eps_Fabnormal.1": "故障",
  "51101.s\\fault.fault_eps_VtooLow.0": "正常",
  "51101.s\\fault.fault_eps_VtooLow.1": "故障",
  "51101.s\\fault.fault_eps_VLow.0": "正常",
  "51101.s\\fault.fault_eps_VLow.1": "故障",
  "51101.s\\fault.fault_eps_VHigh.0": "正常",
  "51101.s\\fault.fault_eps_VHigh.1": "故障",
  "51101.s\\fault.fault_eps_Flow.0": "正常",
  "51101.s\\fault.fault_eps_Flow.1": "故障",
  "51101.s\\fault.fault_eps_FHigh.0": "正常",
  "51101.s\\fault.fault_eps_FHigh.1": "故障",
  "51101.s\\fault.fault_eps_acMainLost.0": "正常",
  "51101.s\\fault.fault_eps_acMainLost.1": "故障",
  "51101.s\\fault.fault_eps_inpuSurge.0": "正常",
  "51101.s\\fault.fault_eps_inpuSurge.1": "故障",
  "51101.s\\fault.fault_eps_relayOpenCircuit.0": "正常",
  "51101.s\\fault.fault_eps_relayOpenCircuit.1": "故障",
  "51101.s\\fault.fault_eps_inputOverI.0": "正常",
  "51101.s\\fault.fault_eps_inputOverI.1": "故障",
  "51101.s\\elct_meter.elct_meter1_phase_no.0": "未设置",
  "51101.s\\elct_meter.elct_meter1_phase_no.1": "A相",
  "51101.s\\elct_meter.elct_meter1_phase_no.2": "B相",
  "51101.s\\elct_meter.elct_meter1_phase_no.3": "C相",
  "51101.s\\elct_meter.elct_meter1_online_status.0": "不在线",
  "51101.s\\elct_meter.elct_meter1_online_status.1": "在线",
  "51101.s\\elct_meter.elct_meter2_phase_no.0": "未设置",
  "51101.s\\elct_meter.elct_meter2_phase_no.1": "A相",
  "51101.s\\elct_meter.elct_meter2_phase_no.2": "B相",
  "51101.s\\elct_meter.elct_meter2_phase_no.3": "C相",
  "51101.s\\elct_meter.elct_meter2_online_status.0": "不在线",
  "51101.s\\elct_meter.elct_meter2_online_status.1": "在线",
  "51101.s\\collector": "采集器",
  "51101.s_w\\ctl_BMS": "BMS参数",
  "51101.s_w\\grid_reconn_args": "并网重连参数",
  "51101.s\\elct_meter": "电表数据",
  "51101.s_w\\ctl_islandProtection": "防孤岛保护参数",
  "51101.s_w\\ctl_EMS": "EMS参数",
  "51101.s_w\\volt_ride_through": "电压穿越参数",
  "51101.s_w\\Freq_ride_through": "频率穿越参数",
  "51101.m_w\\ctl_EMS": "EMS参数",
  "51101.s_w\\ctl_reverseFlowProtection": "防逆流保护参数",
  "51101.s_w\\ctl_actpower": "有功功率控制",
  "51101.s\\warn": "告警信息",
  "51101.s\\real_time": "实时数据",
  "51101.s\\fault": "故障信息",
  "51101.s_w\\ctl_inv": "逆变器控制参数",
  "51101.m\\real_time": "实时数据",
  "51101.s_w\\ctl_reactpower": "无功功率控制",
  "51101.s\\alarm": "预警信息",
  "not.configured": "未配置",
  "51102.real_time.c_firmwareversion": "采集器软件版本",
  "51102.real_time.c_wifi_rssi": "WIFI信号强度",
  "51102.ctrl_Remote_Reset.c_datalogger_reboot": "采集器重启",
  "51102.ctrl_Remote_Reset.c_datalogger_factory_reset": "采集器恢复出厂设置",
  "51102.real_time.SN": "产品SN",
  "51102.real_time.DSP_softversion": "DSP软件版本",
  "51102.real_time.bms_status": "BMS状态字",
  "51102.real_time.bms_total_v": "电池组总电压",
  "51102.real_time.bms_total_I": "电池组总电流",
  "51102.real_time.bms_total_SOH": "电池组SOH",
  "51102.real_time.chg_full_time": "预计充满时间",
  "51102.real_time.dischg_time": "剩余放电时间",
  "51102.real_time.cell_max_v": "单体最高电压",
  "51102.real_time.cell_min_v": "单体最低电压",
  "51102.real_time.cell_max_v_id": "最高单体电池电压编号",
  "51102.real_time.cell_min_v_id": "最低单体电池电压编号",
  "51102.real_time.cell_min_temp": "单体最低温度",
  "51102.real_time.cell_max_temp_id": "最高单体电池温度编号",
  "51102.real_time.cell_min_temp_id": "最低单体电池温度编号",
  "51102.real_time.batt_SOP": "电池组SOP",
  "51102.real_time.batt_type": "电池类型",
  "51102.real_time.batt_rated_Q": "单体电池额定容量",
  "51102.real_time.batt_DC_port_V": "DC端口电压",
  "51102.real_time.heat_film_I": "加热膜电流",
  "51102.real_time.heat_film_P": "加热膜功率",
  "51102.real_time.cell_1_v": "电芯1电压",
  "51102.real_time.cell_2_v": "电芯2电压",
  "51102.real_time.cell_3_v": "电芯3电压",
  "51102.real_time.cell_4_v": "电芯4电压",
  "51102.real_time.cell_5_v": "电芯5电压",
  "51102.real_time.cell_1_temp": "电芯1温度",
  "51102.real_time.cell_2_temp": "电芯2温度",
  "51102.real_time.cell_3_temp": "电芯3温度",
  "51102.real_time.cell_4_temp": "电芯4温度",
  "51102.real_time.cell_5_temp": "电芯5温度",
  "51102.real_time.batt_term_tmp": "极柱温度",
  "51102.real_time.batt_copper_temp": "铜排温度",
  "51102.real_time.dischg_mos_tmp": "放电MOS温度",
  "51102.real_time.chg_mos_tmp": "充电MOS温度",
  "51102.real_time.palnetif_v": "并网口电压",
  "51102.real_time.palnetif_I": "并网口电流",
  "51102.real_time.palnetif_f": "并网口频率",
  "51102.real_time.palnetif_P": "并网口有功功率",
  "51102.real_time.palnetif_Q": "并网口无功功率",
  "51102.real_time.palnetif_S": "并网口视在功率",
  "51102.real_time.palnetif_PF": "并网口功率因数",
  "51102.real_time.eps_v": "EPS口电压",
  "51102.real_time.eps_I": "EPS口电流",
  "51102.real_time.eps_f": "EPS口频率",
  "51102.real_time.eps_P": "EPS口有功功率",
  "51102.real_time.eps_Q": "EPS口无功功率",
  "51102.real_time.eps_S": "EPS口视在功率",
  "51102.real_time.eps_PF": "EPS口功率因数",
  "51102.real_time.batt_v": "电池电压",
  "51102.real_time.batt_I": "电池电流",
  "51102.real_time.batt_P": "电池功率",
  "51102.real_time.chg_v": "充电电压",
  "51102.real_time.chg_I": "充电电流",
  "51102.real_time.chg_P": "充电功率",
  "51102.real_time.pv1_input_v": "PV1输入电压",
  "51102.real_time.pv1_input_I": "PV1输入电流",
  "51102.real_time.pv1_input_P": "PV1输入功率",
  "51102.real_time.pv1_output_v": "PV1输出电压",
  "51102.real_time.pv1_output_I": "PV1输出电流",
  "51102.real_time.pv1_output_P": "PV1输出功率",
  "51102.real_time.pv2_input_v": "PV2输入电压",
  "51102.real_time.pv2_input_I": "PV2输入电流",
  "51102.real_time.pv2_input_P": "PV2输入功率",
  "51102.real_time.pv2_output_v": "PV2输出电压",
  "51102.real_time.pv2_output_I": "PV2输出电流",
  "51102.real_time.pv2_output_P": "PV2输出功率",
  "51102.real_time.pv3_input_v": "PV3输入电压",
  "51102.real_time.pv3_input_I": "PV3输入电流",
  "51102.real_time.pv3_input_P": "PV3输入功率",
  "51102.real_time.pv3_output_v": "PV3输出电压",
  "51102.real_time.pv3_output_I": "PV3输出电流",
  "51102.real_time.pv3_output_P": "PV3输出功率",
  "51102.real_time.pv4_input_v": "PV4输入电压",
  "51102.real_time.pv4_input_I": "PV4输入电流",
  "51102.real_time.pv4_input_P": "PV4输入功率",
  "51102.real_time.pv4_output_v": "PV4输出电压",
  "51102.real_time.pv4_output_I": "PV4输出电流",
  "51102.real_time.pv4_output_P": "PV4输出功率",
  "51102.real_time.env_temp_1": "环境温度1",
  "51102.real_time.env_temp_2": "环境温度2",
  "51102.real_time.inverterTemp": "PFC散热器温度",
  "51102.real_time.dcdcTemp": "DC散热器温度1",
  "51102.real_time.DC_temp2": "DC散热器温度2",
  "51102.real_time.PV1_temp": "PV1散热器温度",
  "51102.real_time.PV2_temp": "PV2散热器温度",
  "51102.real_time.PV3_temp": "PV3散热器温度",
  "51102.real_time.PV4_temp": "PV4散热器温度",
  "51102.real_time.bus_v": "母线电压",
  "51102.real_time.anti_curr_status": "防逆流功能状态",
  "51102.real_time.low_volt_cross_status": "低电压穿越功能状态",
  "51102.real_time.f_cross_status": "频率穿越功能状态",
  "51102.real_time.reconn_cross_status": "并网重连功能状态",
  "51102.real_time.inv_ver": "逆变器软件版本",
  "51102.real_time.inv_hard_ver": "逆变器硬件版本",
  "51102.real_time.inv_profile": "逆变器国家规格",
  "51102.real_time.deviceStatus": "微储状态",
  "51102.real_time.Wifi_BT_Online": "wifi/蓝牙在线状态",
  "51102.real_time.workStatus": "系统工作状态",
  "51102.real_time.workMode": "工作模式",
  "51102.real_time.parelletRunStatue": "并机状态",
  "51102.real_time.acDischargeMode": "AC放电状态",
  "51102.real_time.acchargeStatus": "AC充电状态",
  "51102.real_time.MPPTStatus": "MPPT状态",
  "51102.real_time.SleepStatus": "系统休眠状态",
  "51102.real_time.gridConnStatus": "并离网状态",
  "51102.real_time.antiReverseIStatus": "防逆流状态",
  "51102.real_time.masterOrSlaveStatus": "主从机状态",
  "51102.real_time.EPSConnStatus": "EPS接入状态",
  "51102.real_time.remote_onoff_status": "远程开关机状态",
  "51102.real_time.shunt_trip_status": "分励脱扣器状态",
  "51102.real_time.AI_LED_status": "AI LED灯状态",
  "51102.real_time.ai_elct_meter_check": "AI智能电表检测状态",
  "51102.real_time.mod_grid_P": "并网口功率",
  "51102.real_time.pvPower": "PV发电功率",
  "51102.real_time.batteryPower": "电池侧功率",
  "51102.real_time.mod_EPS_P": "EPS口功率",
  "51102.real_time.mod_batt2Grid_P": "电池流向并网口的馈网功率",
  "51102.real_time.mod_batt2EPS_P": "电池流向EPS负载的功率",
  "51102.real_time.mod_PV2Batt_P": "PV流向电池的功率",
  "51102.real_time.mod_PV2EPS_P": "PV流向EPS负载的功率",
  "51102.real_time.mod_PV_to_Grid_P": "PV流向并网口的馈网功率",
  "51102.real_time.mod_Grid2Batt_P": "并网口流向电池的功率",
  "51102.real_time.mod_Grid2EPS_P": "并网口流向EPS负载的功率",
  "51102.real_time.mod_inv2Grid_P": "EPS微逆流向并网口的功率",
  "51102.real_time.mod_EPS2Batt_P": "EPS微逆流向电池的功率",
  "51102.real_time.gridPower": "网侧入户电表功率",
  "51102.real_time.mod_ACElctMeter_P": "AC微逆电表功率",
  "51102.real_time.batterySoc": "电池SOC",
  "51102.real_time.acc_buy_energy": "累计买电电量",
  "51102.real_time.acc_sell_energy": "累计卖电电量",
  "51102.real_time.acc_PV_prod_energy": "光伏PV总发电量",
  "51102.real_time.powerGeneration": "总发电量",
  "51102.real_time.acc_EPS_prod_energy": "EPS微逆总发电量",
  "51102.real_time.acc_AC_prod_energy": "AC微逆总发电量",
  "51102.real_time.acc_load_use_enery": "负载累计用电量",
  "51102.real_time.batteryDischargePower": "电池累计放电电量",
  "51102.real_time.batteryChargePower": "电池累计充电电量",
  "51102.real_time.acc_PV2Bat_E": "光伏PV流向电池的总电量",
  "51102.real_time.acc_PV2Load_E": "光伏PV流向负载的总电量",
  "51102.real_time.acc_PV2grid_E": "光伏PV流向电网的总电量",
  "51102.real_time.acc_EPS_load_E": "EPS负载累计用电量",
  "51102.real_time.today_buy_E": "今日买电电量",
  "51102.real_time.today_sell_E": "今日卖电电量",
  "51102.real_time.today_PV_E": "光伏PV今日累计发电量",
  "51102.real_time.today_EPS_E": "EPS微逆今日累计发电量",
  "51102.real_time.today_AC_E": "AC微逆今日累计发电量",
  "51102.real_time.today_BattDischg_E": "电池今日放电电量",
  "51102.real_time.today_Battchg_E": "电池今日充电电量",
  "51102.real_time.today_PV2Batt_E": "光伏PV今日流向电池电量",
  "51102.real_time.today_PV2Load_E": "光伏PV今日流向负载电量",
  "51102.real_time.today_PV2Grid_E": "光伏PV今日流向电网电量",
  "51102.real_time.mon_buy_E": "本月买电电量",
  "51102.real_time.mon_sell_E": "本月卖电电量",
  "51102.real_time.mon_PV_E": "光伏PV本月累计发电量",
  "51102.real_time.mon_EPS_E": "EPS微逆本月累计发电量",
  "51102.real_time.mon_AC_E": "AC微逆本月累计发电量",
  "51102.real_time.mon_BattDischg_E": "电池本月放电电量",
  "51102.real_time.mon_Battchg_E": "电池本月充电电量",
  "51102.real_time.mon_PV2Batt_E": "光伏PV本月流向电池电量",
  "51102.real_time.mon_PV2Load_E": "光伏PV本月流向负载电量",
  "51102.real_time.mon_PV2Grid_E": "光伏PV本月流向电网电量",
  "51102.real_time.year_buy_E": "年度买电电量",
  "51102.real_time.year_sell_E": "年度卖电电量",
  "51102.real_time.year_PV_E": "光伏PV年度累计发电量",
  "51102.real_time.year_EPS_E": "EPS微逆年度累计发电量",
  "51102.real_time.year_AC_E": "AC微逆年度累计发电量",
  "51102.real_time.year_BattDischg_E": "电池年度放电电量",
  "51102.real_time.year_Battchg_E": "电池年度充电电量",
  "51102.real_time.year_PV2Batt_E": "光伏PV年度流向电池电量",
  "51102.real_time.year_PV2Load_E": "光伏PV年度流向负载电量",
  "51102.real_time.year_PV2Grid_E": "光伏PV年度流向电网电量",
  "51102.real_time.eps_load_E_day": "EPS负载今日用电量",
  "51102.real_time.load_E_day": "负载今日用电量",
  "51102.real_time.eps_load_E_month": "EPS负载本月用电量",
  "51102.real_time.load_E_month": "负载本月用电量",
  "51102.real_time.eps_load_E_year": "EPS负载年度用电量",
  "51102.real_time.load_E_year": "负载年度用电量",
  "51102.real_time.parallel_status": "并机工作状态",
  "51102.real_time.parallel_cnt": "并机台数",
  "51102.real_time.parallel_ID": "并机ID",
  "51102.real_time.parallel_isMaster": "并机主从机",
  "51102.real_time.all_mod_tot_grid_P": "并机下并网口总功率",
  "51102.real_time.all_mod_tot_PV_P": "并机下PV发电总功率",
  "51102.real_time.all_mod_tot_BAT_P": "并机下电池侧总功率",
  "51102.real_time.all_mod_tot_EPS_P": "并机下EPS口总功率",
  "51102.real_time.all_mod_tot_batt2Grid_P": "并机下电池流向并网口的馈网总功率",
  "51102.real_time.all_mod_tot_batt2EPS_P": "并机下电池流向EPS负载的总功率",
  "51102.real_time.all_mod_tot_PV2Batt_P": "并机下PV流向电池的总功率",
  "51102.real_time.all_mod_tot_PV2EPS_P": "并机下PV流向EPS负载的总功率",
  "51102.real_time.all_mod_tot_PV2Grid_P": "并机下PV流向并网口的馈网总功率",
  "51102.real_time.all_mod_tot_Grid2Batt_P": "并机下并网口流向电池的总功率",
  "51102.real_time.all_mod_tot_Grid2EPS_P": "并机下并网口流向EPS负载的总功率",
  "51102.real_time.all_mod_tot_inv2Grid_P": "并机下EPS微逆流向并网口的总功率",
  "51102.real_time.all_mod_tot_EPS2Batt_P": "并机下EPS微逆流向电池的总功率",
  "51102.real_time.all_mod_tot_GridElctMeter_P": "网侧入户电表功率",
  "51102.real_time.all_mod_tot_ACElctMeter_P": "AC微逆电表功率",
  "51102.real_time.all_mod_battGrp_soc": "并机下电池SOC",
  "51102.real_time.gridBuyPower": "累计买电电量",
  "51102.real_time.gridSellPower": "累计卖电电量",
  "51102.real_time.p_acc_PV_prod_energy": "并机下光伏PV总发电量",
  "51102.real_time.p_acc_EPS_prod_energy": "并机下EPS微逆总发电量",
  "51102.real_time.p_acc_AC_prod_energy": "并机下AC微逆总发电量",
  "51102.real_time.p_acc_load_use_enery": "并机下负载累计用电量",
  "51102.real_time.tot_batt_acc_dischg_energy": "并机下电池累计放电电量",
  "51102.real_time.tot_batt_acc_chg_energy": "并机下电池累计充电电量",
  "51102.real_time.p_acc_PV2Bat_E": "并机下光伏PV流向电池的总电量",
  "51102.real_time.p_acc_PV2Load_E": "并机下光伏PV流向负载的总电量",
  "51102.real_time.p_acc_PV2grid_E": "并机下光伏PV流向电网的总电量",
  "51102.real_time.p_acc_EPS_load_E": "并机下EPS负载累计用电量",
  "51102.real_time.p_today_buy_E": "并机下今日买电电量",
  "51102.real_time.p_today_sell_E": "并机下今日卖电电量",
  "51102.real_time.p_today_PV_E": "并机下光伏PV今日累计发电量",
  "51102.real_time.p_today_EPS_E": "并机下EPS微逆今日累计发电量",
  "51102.real_time.p_today_AC_E": "并机下AC微逆今日累计发电量",
  "51102.real_time.p_today_BattDischg_E": "并机下电池今日放电电量",
  "51102.real_time.p_today_Battchg_E": "并机下电池今日充电电量",
  "51102.real_time.p_today_PV2Batt_E": "并机下光伏PV今日流向电池电量",
  "51102.real_time.p_today_PV2Load_E": "并机下光伏PV今日流向负载电量",
  "51102.real_time.p_today_PV2Grid_E": "并机下光伏PV今日流向电网电量",
  "51102.real_time.p_mon_buy_E": "并机下本月买电电量",
  "51102.real_time.p_mon_sell_E": "并机下本月卖电电量",
  "51102.real_time.p_mon_PV_E": "并机下光伏PV本月累计发电量",
  "51102.real_time.p_mon_EPS_E": "并机下EPS微逆本月累计发电量",
  "51102.real_time.p_mon_AC_E": "并机下AC微逆本月累计发电量",
  "51102.real_time.p_mon_BattDischg_E": "并机下电池本月放电电量",
  "51102.real_time.p_mon_Battchg_E": "并机下电池本月充电电量",
  "51102.real_time.p_mon_PV2Batt_E": "并机下光伏PV本月流向电池电量",
  "51102.real_time.p_mon_PV2Load_E": "并机下光伏PV本月流向负载电量",
  "51102.real_time.p_mon_PV2Grid_E": "并机下光伏PV本月流向电网电量",
  "51102.real_time.p_year_buy_E": "并机下年度买电电量",
  "51102.real_time.p_year_sell_E": "并机下年度卖电电量",
  "51102.real_time.p_year_PV_E": "并机下光伏PV年度累计发电量",
  "51102.real_time.p_year_EPS_E": "并机下EPS微逆年度累计发电量",
  "51102.real_time.p_year_AC_E": "并机下AC微逆年度累计发电量",
  "51102.real_time.p_year_BattDischg_E": "并机下电池年度放电电量",
  "51102.real_time.p_year_Battchg_E": "并机下电池年度充电电量",
  "51102.real_time.p_year_PV2Batt_E": "并机下光伏PV年度流向电池电量",
  "51102.real_time.p_year_PV2Load_E": "并机下光伏PV年度流向负载电量",
  "51102.real_time.p_year_PV2Grid_E": "并机下光伏PV年度流向电网电量",
  "51102.real_time.tot_eps_load_E_day": "并机下EPS负载今日用电量",
  "51102.real_time.tot_load_E_day": "并机下负载今日用电量",
  "51102.real_time.tot_eps_load_E_month": "并机下EPS负载本月用电量",
  "51102.real_time.tot_load_E_month": "并机下负载本月用电量",
  "51102.real_time.tot_eps_load_E_year": "并机下EPS负载年度用电量",
  "51102.real_time.tot_load_E_year": "并机下负载年度用电量",
  "51102.real_time.EPS_status": "EPS微逆状态",
  "51102.real_time.EPS_total_power_time": "EPS微逆总发电时长",
  "51102.real_time.EPS_today_power_time": "EPS微逆今日发电时长",
  "51102.real_time.EPS_volt": "EPS微逆电压",
  "51102.real_time.EPS_I": "EPS微逆电流",
  "51102.real_time.EPS_freq": "EPS微逆频率",
  "51102.real_time.EPS_P": "EPS微逆有功功率",
  "51102.real_time.EPS_S": "EPS微逆视在功率",
  "51102.real_time.EPS_Q": "EPS微逆无功功率",
  "51102.real_time.EPS_PF": "EPS微逆功率因数",
  "51102.real_time.PV1_online_status": "PV1在位状态",
  "51102.real_time.PV2_online_status": "PV2在位状态",
  "51102.real_time.PV3_online_status": "PV3在位状态",
  "51102.real_time.PV4_online_status": "PV4在位状态",
  "51102.real_time.PV_total_P": "PV实时总功率",
  "51102.real_time.PV_total_time": "PV总发电时长",
  "51102.real_time.PV_today_time": "PV今日发电时长",
  "51102.real_time.PV1_V": "PV1实时电压",
  "51102.real_time.PV1_I": "PV1实时电流",
  "51102.real_time.PV1_P": "PV1实时功率",
  "51102.real_time.PV2_V": "PV2实时电压",
  "51102.real_time.PV2_I": "PV2实时电流",
  "51102.real_time.PV2_P": "PV2实时功率",
  "51102.real_time.PV3_V": "PV3实时电压",
  "51102.real_time.PV3_I": "PV3实时电流",
  "51102.real_time.PV3_P": "PV3实时功率",
  "51102.real_time.PV4_V": "PV4实时电压",
  "51102.real_time.PV4_I": "PV4实时电流",
  "51102.real_time.PV4_P": "PV4实时功率",
  "51102.real_time.PV1_positive_temp": "PV1+温度",
  "51102.real_time.PV1_negative_temp": "PV1-温度",
  "51102.real_time.PV2_positive_temp": "PV2+温度",
  "51102.real_time.PV2_negative_temp": "PV2-温度",
  "51102.real_time.PV3_positive_temp": "PV3+温度",
  "51102.real_time.PV3_negative_temp": "PV3-温度",
  "51102.real_time.PV4_positive_temp": "PV4+温度",
  "51102.real_time.PV4_negative_temp": "PV4-温度",
  "51102.ctrl_Fault Trigger.BMS.env_max_temp_alrm": "环境高温告警",
  "51102.ctrl_Fault Trigger.BMS.env_min_temp_alrm": "环境低温告警",
  "51102.ctrl_Fault Trigger.BMS.cell_level_1_overtmp_chg": "电芯一级过温告警(充电)",
  "51102.ctrl_Fault Trigger.BMS.cell_level_1_lowtmp_chg": "电芯一级低温告警(充电)",
  "51102.ctrl_Fault Trigger.BMS.cell_level_1_overtmp_dischg": "电芯一级过温告警(放电)",
  "51102.ctrl_Fault Trigger.BMS.cell_level_1_lowtmp_dischg": "电芯一级低温告警(放电)",
  "51102.ctrl_Fault Trigger.BMS.cell_level_1_overtmp_protect": "电芯一级过温保护(充电)",
  "51102.ctrl_Fault Trigger.BMS.cell_level_2_overtmp_protect": "电芯二级过温保护(充电)",
  "51102.ctrl_Fault Trigger.BMS.cell_level_1_lowtmp_protect": "电芯一级低温保护(充电)",
  "51102.ctrl_Fault Trigger.BMS.cell_level_2_lowtmp_protect": "电芯二级低温保护(充电)",
  "51102.ctrl_Fault Trigger.BMS.cell_level_1_overtmp_protect_dischg": "电芯一级过温保护(放电)",
  "51102.ctrl_Fault Trigger.BMS.cell_level_2_overtmp_protect_dischg": "电芯二级过温保护(放电)",
  "51102.ctrl_Fault Trigger.BMS.cell_level_1_lowtmp_protect_dischg": "电芯一级低温保护(放电)",
  "51102.ctrl_Fault Trigger.BMS.cell_level_2_lowtmp_protect_dischg": "电芯二级低温保护(放电)",
  "51102.ctrl_Fault Trigger.BMS.env_overtmp_protect": "环境高温保护",
  "51102.ctrl_Fault Trigger.BMS.env_lowtmp_protect": "环境低温保护",
  "51102.ctrl_Fault Trigger.BMS.mos_overtmp_alarm": "MOS温度高温告警",
  "51102.ctrl_Fault Trigger.BMS.mos_overtmp_protect": "MOS温度高温保护",
  "51102.ctrl_Fault Trigger.BMS.batt_avg_volt_high_protect": "电芯组均压高保护",
  "51102.ctrl_Fault Trigger.BMS.batt_overvolt_protect": "电芯高压保护",
  "51102.ctrl_Fault Trigger.BMS.batt_avg_volt_low_protect": "电芯组均压低保护",
  "51102.ctrl_Fault Trigger.BMS.batt_lowvolt_protect": "电芯低压保护",
  "51102.ctrl_Fault Trigger.BMS.cell_diffvolt_toohigh_protect": "电芯压差过大保护",
  "51102.ctrl_Fault Trigger.BMS.batt_avgvolt_high_alarm": "电芯组均压高告警",
  "51102.ctrl_Fault Trigger.BMS.cell_highvolt_alarm": "电芯高压告警",
  "51102.ctrl_Fault Trigger.BMS.batt_avgvolt_low_alarm": "电芯组均压低告警",
  "51102.ctrl_Fault Trigger.BMS.cell_lowVolt_alarm": "电芯低压告警",
  "51102.ctrl_Fault Trigger.BMS.soc_low_alarm": "电量低告警",
  "51102.ctrl_Fault Trigger.BMS.cell_unavail": "电芯单体失效",
  "51102.ctrl_Fault Trigger.BMS.cell_diffvolt_toohigh_alrm": "电芯温差大告警",
  "51102.ctrl_Fault Trigger.BMS.cell_diffvolt_toohigh_fault": "电芯温差大故障",
  "51102.ctrl_Fault Trigger.BMS.batt_chg_overcurrent_alarm": "电池充电过流告警",
  "51102.ctrl_Fault Trigger.BMS.batt_chg_overcurrent_slow_check_protect": "电池充电过流慢检保护",
  "51102.ctrl_Fault Trigger.BMS.batt_chg_overcurrent_fast_check_protect": "电池充电过流快检保护",
  "51102.ctrl_Fault Trigger.BMS.batt_chg_overcurrent_fault": "电池充电过流故障",
  "51102.ctrl_Fault Trigger.BMS.batt_dischg_overcurrent_alarm": "电池放电过流告警",
  "51102.ctrl_Fault Trigger.BMS.batt_dischg_overcurrent_slow_check_protect": "电池放电过流慢检保护",
  "51102.ctrl_Fault Trigger.BMS.batt_dischg_overcurrent_fast_check_protect": "电池放电过流快检保护",
  "51102.ctrl_Fault Trigger.BMS.batt_dischg_overcurrent_fault": "电池放电过流故障",
  "51102.ctrl_Fault Trigger.BMS.cell_too_high_volt_fault": "电芯电压严重高故障",
  "51102.ctrl_Fault Trigger.BMS.cell_too_low_volt_fault": "电芯电压严重低故障",
  "51102.ctrl_Fault Trigger.BMS.cell_too_low_volt_shutdown": "电芯电压低关机",
  "51102.ctrl_Fault Trigger.BMS.cell_term_overTemp_alarm": "极柱温度高告警",
  "51102.ctrl_Fault Trigger.BMS.cell_term_overTemp_protect": "极柱温度高保护",
  "51102.ctrl_Fault Trigger.BMS.cell_term_overTemp_fault": "极柱温度高故障",
  "51102.ctrl_Fault Trigger.BMS.cell_copper_overTemp_alrm": "铜排温度高告警",
  "51102.ctrl_Fault Trigger.BMS.cell_copper_overTemp_protect": "铜排温度高保护",
  "51102.ctrl_Fault Trigger.BMS.cell_copper_overTemp_fault": "铜排温度高故障",
  "51102.ctrl_Fault Trigger.INV.prl_grid_overV_protect": "并网口输入过压保护",
  "51102.ctrl_Fault Trigger.INV.prl_grid_overV_recovery": "并网口输入过压恢复",
  "51102.ctrl_Fault Trigger.INV.prl_grid_lowV_protect": "并网口输入欠压保护",
  "51102.ctrl_Fault Trigger.INV.prl_grid_lowV_recovery": "并网口输入欠压恢复",
  "51102.ctrl_Fault Trigger.INV.prl_grid_overFreq_protect": "并网口输入过频保护",
  "51102.ctrl_Fault Trigger.INV.prl_grid_overFreq_recovery": "并网口输入过频恢复",
  "51102.ctrl_Fault Trigger.INV.prl_grid_lowFreq_protect": "并网口输入欠频保护",
  "51102.ctrl_Fault Trigger.INV.prl_grid_lowFreq_recovery": "并网口输入欠频恢复",
  "51102.ctrl_Fault Trigger.INV.EPS_overV_protect": "EPS口输入过压保护",
  "51102.ctrl_Fault Trigger.INV.EPS_overV_recovery": "EPS口输入过压恢复",
  "51102.ctrl_Fault Trigger.INV.EPS_lowV_protect": "EPS口输入欠压保护",
  "51102.ctrl_Fault Trigger.INV.EPS__lowV_recovery": "EPS口输入欠压恢复",
  "51102.ctrl_Fault Trigger.INV.EPS_overFreq_protect": "EPS口输入过频保护",
  "51102.ctrl_Fault Trigger.INV.EPS_overFreq_recovery": "EPS口输入过频恢复",
  "51102.ctrl_Fault Trigger.INV.EPS_lowFreq_protect": "EPS口输入欠频保护",
  "51102.ctrl_Fault Trigger.INV.EPS_lowFreq_recovery": "EPS口输入欠频恢复",
  "51102.ctrl_Fault Trigger.INV.DC_input_overV_protect": "直流输入过压保护",
  "51102.ctrl_Fault Trigger.INV.DC_input_overV_recovery": "直流输入过压恢复",
  "51102.ctrl_Fault Trigger.INV.DC_input_lowV_protect": "直流输入欠压保护",
  "51102.ctrl_Fault Trigger.INV.DC_input_lowV_recovery": "直流输入欠压恢复",
  "51102.ctrl_Fault Trigger.INV.PV_input_overV_protect": "PV输入过压保护",
  "51102.ctrl_Fault Trigger.INV.PV_input_overV_recovery": "PV输入过压恢复",
  "51102.ctrl_Fault Trigger.INV.PV_input_lowV_protect": "PV输入欠压保护",
  "51102.ctrl_Fault Trigger.INV.PV_input_lowV_recovery": "PV输入欠压恢复",
  "51102.ctrl_Fault Trigger.INV.env_tmp1_over_protect": "环境温度1过温保护",
  "51102.ctrl_Fault Trigger.INV.env_tmp1_over_recovery": "环境温度1过温恢复",
  "51102.ctrl_Fault Trigger.INV.env_tmp2_over_protect": "环境温度2过温保护",
  "51102.ctrl_Fault Trigger.INV.env_tmp2_over_recovery": "环境温度2过温恢复",
  "51102.ctrl_Fault Trigger.INV.PFC_overT_protect": "PFC散热器温度过温保护",
  "51102.ctrl_Fault Trigger.INV.PFC_overT_recovery": "PFC散热器温度过温恢复",
  "51102.ctrl_Fault Trigger.INV.DC_overT_protect": "DC散热器温度1过温保护",
  "51102.ctrl_Fault Trigger.INV.DC_overT_recovery": "DC散热器温度1过温恢复",
  "51102.ctrl_Fault Trigger.INV.DC_overT2_protect": "DC散热器温度2过温保护",
  "51102.ctrl_Fault Trigger.INV.DC_overT2_recovery": "DC散热器温度2过温恢复",
  "51102.ctrl_Fault Trigger.INV.PV1_overT_protect": "PV1散热器温度过温保护",
  "51102.ctrl_Fault Trigger.INV.PV1_overT_recovery": "PV1散热器温度过温恢复",
  "51102.ctrl_Fault Trigger.INV.PV2_overT_protect": "PV2散热器温度过温保护",
  "51102.ctrl_Fault Trigger.INV.PV2_overT_recovery": "PV2散热器温度过温恢复",
  "51102.ctrl_Fault Trigger.INV.PV3_overT_protect": "PV3散热器温度过温保护",
  "51102.ctrl_Fault Trigger.INV.PV3_overT_recovery": "PV3散热器温度过温恢复",
  "51102.ctrl_Fault Trigger.INV.PV4_overT_protect": "PV4散热器温度过温保护",
  "51102.ctrl_Fault Trigger.INV.PV4_overT_recovery": "PV4散热器温度过温恢复",
  "51102.ctrl_Fault Trigger.Anti-Islanding.island_overV": "过压保护阈值",
  "51102.ctrl_Fault Trigger.Anti-Islanding.island_lowV": "欠压保护阈值",
  "51102.ctrl_Fault Trigger.Anti-Islanding.island_overFreq": "过频保护阈值",
  "51102.ctrl_Fault Trigger.Anti-Islanding.island_lowFreq": "欠频保护阈值",
  "51102.ctrl_Fault Trigger.backflow.rfp_action_time": "动作保护时间",
  "51102.ctrl_Inverter-control.Active.max_oP": "最大输出有功功率",
  "51102.ctrl_Inverter-control.Active.p_ramp_rate": "有功功率爬坡率",
  "51102.ctrl_Inverter-control.Reactive.reactpower_ctl_en": "无功功率控制使能",
  "51102.ctrl_Inverter-control.Reactive.max_oQ": "最大输出无功功率",
  "51102.ctrl_Inverter-control.Reactive.reactpower_ctl_mode": "无功功率控制模式",
  "51102.ctrl_Inverter-control.Reactive.PF_set": "功率因数",
  "51102.ctrl_Inverter-control.Reactive.VreactPCurveVsetValue1": "电压无功功率曲线电压设置值V1",
  "51102.ctrl_Inverter-control.Reactive.VreactPCurveVsetValue2": "电压无功功率曲线电压设置值V2",
  "51102.ctrl_Inverter-control.Reactive.VreactPCurveVsetValue3": "电压无功功率曲线电压设置值V3",
  "51102.ctrl_Inverter-control.Reactive.VreactPCurveQsetValue1": "电压无功功率曲线无功功率设置值Q1",
  "51102.ctrl_Inverter-control.Reactive.VreactPCurveQsetValue2": "电压无功功率曲线无功功率设置值Q2",
  "51102.ctrl_Inverter-control.Reactive.VreactPCurveQsetValue3": "电压无功功率曲线无功功率设置值Q3",
  "51102.ctrl_Inverter-control.VRT.lowVlimit1": "低压限制1",
  "51102.ctrl_Inverter-control.VRT.lowVlimit1Time": "低压限制1时间",
  "51102.ctrl_Inverter-control.VRT.lowVlimit2": "低压限制2",
  "51102.ctrl_Inverter-control.VRT.lowVlimit2Time": "低压限制2时间",
  "51102.ctrl_Inverter-control.VRT.lowVlimit3": "低压限制3",
  "51102.ctrl_Inverter-control.VRT.lowVlimit3Time": "低压限制3时间",
  "51102.ctrl_Inverter-control.VRT.overVlimit1": "过压限制1",
  "51102.ctrl_Inverter-control.VRT.overVlimit1Time": "过压限制1时间",
  "51102.ctrl_Inverter-control.VRT.overVlimit2": "过压限制2",
  "51102.ctrl_Inverter-control.VRT.overVlimit2Time": "过压限制2时间",
  "51102.ctrl_Inverter-control.VRT.overVlimit3": "过压限制3",
  "51102.ctrl_Inverter-control.VRT.overVlimit3Time": "过压限制3时间",
  "51102.ctrl_Inverter-control.VRT.VrecoveryTime": "电压恢复时间",
  "51102.ctrl_Inverter-control.VRT.LVRTThredUplmt": "LVRT阈值上限",
  "51102.ctrl_Inverter-control.VRT.LVRTThredDownlmt": "LVRT阈值下限",
  "51102.ctrl_Inverter-control.FRT.lowFreqLimit1": "低频限制1",
  "51102.ctrl_Inverter-control.FRT.lowFreqLimit1Time": "低频限制1时间",
  "51102.ctrl_Inverter-control.FRT.lowFreqLimit2": "低频限制2",
  "51102.ctrl_Inverter-control.FRT.lowFreqLimit2Time": "低频限制2时间",
  "51102.ctrl_Inverter-control.FRT.lowFreqLimit3": "低频限制3",
  "51102.ctrl_Inverter-control.FRT.lowFreqLimit3Time": "低频限制3时间",
  "51102.ctrl_Inverter-control.FRT.overFreqLimit1": "过频限制1",
  "51102.ctrl_Inverter-control.FRT.overFreqLimit1Time": "过频限制1时间",
  "51102.ctrl_Inverter-control.FRT.overFreqLimit2": "过频限制2",
  "51102.ctrl_Inverter-control.FRT.overFreqLimit2Time": "过频限制2时间",
  "51102.ctrl_Inverter-control.FRT.overFreqLimit3": "过频限制3",
  "51102.ctrl_Inverter-control.FRT.overFreqLimit3Time": "过频限制3时间",
  "51102.ctrl_Inverter-control.ReconnGrid.pareGridReConnTime": "并网重连时间",
  "51102.ctrl_Inverter-control.ReconnGrid.reConnGridVHighLevel": "重连电压高位",
  "51102.ctrl_Inverter-control.ReconnGrid.reConnGridVLowLevel": "重连电压低位",
  "51102.ctrl_Inverter-control.ReconnGrid.reConnGridFHighLevel": "重连频率高位",
  "51102.ctrl_Inverter-control.ReconnGrid.reConnGridFLowLevel": "重连频率低位",
  "51102.ctrl_WorkMode.Switch.ems_ctrl_work_mode": "工作模式设置",
  "51102.ctrl_Supersetting.anti_reverse_curr": "防逆流模式使能",
  "51102.ctrl_Supersetting.remote_on_off_ctrl": "远程开关机",
  "51102.ctrl_Supersetting.batt_shutdown_ctrl": "电池断电控制",
  "51102.ctrl_Supersetting.factory_recovery": "恢复出厂设置",
  "51102.ctrl_WorkMode.Selfuse.self_consupt_chg_soc": "自发自用模式充电SOC阈值",
  "51102.ctrl_WorkMode.Selfuse.self_consupt_dischg_soc": "自发自用模式放电SOC阈值",
  "51102.ctrl_WorkMode.Selfuse.self_consupt_max_chg_P": "自发自用模式最大充电功率",
  "51102.ctrl_WorkMode.Selfuse.self_consupt_max_feedGrid_P": "自发自用模式最大馈网功率",
  "51102.ctrl_WorkMode.Feed-in Priority.feedGrid_chg_soc": "馈网优先模式充电SOC阈值",
  "51102.ctrl_WorkMode.Feed-in Priority.feedGrid_dischg_soc": "馈网优先模式放电SOC阈值",
  "51102.ctrl_WorkMode.Feed-in Priority.feedGrid_max_chg_P": "馈网优先模式最大充电功率",
  "51102.ctrl_WorkMode.Feed-in Priority.feedGrid_max_feedGrid_P": "馈网优先模式最大馈网功率",
  "51102.ctrl_WorkMode.BATreserved.bakMode_chg_soc": "备电模式充电SOC阈值",
  "51102.ctrl_WorkMode.BATreserved.bakMode_dischg_soc": "备电模式放电SOC阈值",
  "51102.ctrl_WorkMode.BATreserved.bakMode_max_chg_P": "备电模式最大充电功率",
  "51102.ctrl_WorkMode.BATreserved.bakMode_max_feedGrid_P": "备电模式最大馈网功率",
  "51102.ctrl_WorkMode.Peak shaving.PSVFMode_chg_soc": "削峰填谷模式充电SOC阈值",
  "51102.ctrl_WorkMode.Peak shaving.PSVFMode_dischg_soc": "削峰填谷模式放电SOC阈值",
  "51102.ctrl_WorkMode.Peak shaving.PSVFMode_max_chg_P": "削峰填谷模式最大充电功率",
  "51102.ctrl_WorkMode.Peak shaving.PSVFMode_max_feedGrid_P": "削峰填谷模式最大馈网功率",
  "51102.ctrl_WorkMode.Peak shaving.PSVFMode_date": "削峰填谷模式应用日期",
  "51102.ctrl_WorkMode.Peak shaving.s_chg_time1": "充电时段1",
  "51102.ctrl_WorkMode.Peak shaving.s_dischg_time1": "放电时段1",
  "51102.ctrl_WorkMode.Peak shaving.s_chg_time2": "充电时段2",
  "51102.ctrl_WorkMode.Peak shaving.s_dischg_time2": "放电时段2",
  "51102.ctrl_WorkMode.Peak shaving.s_chg_time3": "充电时段3",
  "51102.ctrl_WorkMode.Peak shaving.s_dischg_time3": "放电时段3",
  "51102.ctrl_WorkMode.Peak shaving.s_chg_time4": "充电时段4",
  "51102.ctrl_WorkMode.Peak shaving.s_dischg_time4": "放电时段4",
  "51102.ctrl_WorkMode.Peak shaving.s_chg_time5": "充电时段5",
  "51102.ctrl_WorkMode.Peak shaving.s_dischg_time5": "放电时段5",
  "51102.ctrl_WorkMode.Peak shaving.s_chg_time6": "充电时段6",
  "51102.ctrl_WorkMode.Peak shaving.s_dischg_time6": "放电时段6",
  "51102.ctrl_Safety Regulations.gridType": "国家电网标准",
  "51102.ctrl_WorkMode.TOU.TOU_work_status": "TOU模式工作状态",
  "51102.ctrl_WorkMode.TOU.TOU_max_chg_P": "TOU模式最大充电功率",
  "51102.ctrl_WorkMode.TOU.TOU_max_feedGrid_P": "TOU模式最大馈网功率",
  "51102.ctrl_WorkMode.TOU.TOU_chg_SOC": "TOU模式充电截止SOC",
  "51102.ctrl_WorkMode.TOU.TOU_dischg_SOC": "TOU模式放电截止SOC",
  "51102.ctrl_WorkMode.TOU.TOU_chg_time1": "TOU充电时段1",
  "51102.ctrl_WorkMode.TOU.TOU_dischg_time1": "TOU放电时段1",
  "51102.ctrl_WorkMode.TOU.TOU_chg_time2": "TOU充电时段2",
  "51102.ctrl_WorkMode.TOU.TOU_dischg_time2": "TOU放电时段2",
  "51102.ctrl_WorkMode.TOU.TOU_chg_time3": "TOU充电时段3",
  "51102.ctrl_WorkMode.TOU.TOU_dischg_time3": "TOU放电时段3",
  "51102.ctrl_WorkMode.TOU.TOU_chg_time4": "TOU充电时段4",
  "51102.ctrl_WorkMode.TOU.TOU_dischg_time4": "TOU放电时段4",
  "51102.ctrl_WorkMode.TOU.TOU_chg_time5": "TOU充电时段5",
  "51102.ctrl_WorkMode.TOU.TOU_dischg_time5": "TOU放电时段5",
  "51102.ctrl_WorkMode.TOU.TOU_chg_time6": "TOU充电时段6",
  "51102.ctrl_WorkMode.TOU.TOU_dischg_time6": "TOU放电时段6",
  "51102.warning.warn_grid_v_low": "电网告警(电网电压低)",
  "51102.warning.warn_grid_v_high": "电网告警(电网电压高)",
  "51102.warning.warn_grid_f_low": "电网告警(电网频率低)",
  "51102.warning.warn_grid_f_high": "电网告警(电网频率高)",
  "51102.warning.warn_grid_I_over": "电网告警(交流输入过流)",
  "51102.warning.warn_PFC_bus_v_low": "AC充电告警(母线低压)",
  "51102.warning.warn_U1_bus_v_low": "AC侧母线告警(电压低)",
  "51102.warning.warn_U1_bus_v_high": "AC侧母线告警(电压高)",
  "51102.warning.warn_U2_bus_v_low": "DC侧母线告警(电压低)",
  "51102.warning.warn_U2_bus_v_high": "DC侧母线告警(电压高)",
  "51102.warning.warn_o_inv_overLoad": "输出告警(逆变过载延时到故障)",
  "51102.warning.warn_o_byp_overLoad": "输出告警(旁路过载延时到故障)",
  "51102.warning.warn_PFC_inv_v": "AC放电告警(逆变电压有效值故障)",
  "51102.warning.warn_PFC_inv_o_over_v": "AC放电告警(逆变交流输出过压保护)",
  "51102.warning.warn_PFC_inv_o_low_v": "AC放电告警(逆变交流输出欠压保护)",
  "51102.warning.warn_PFC_inv_o_over_f": "AC放电告警(逆变交流输出过频保护)",
  "51102.warning.warn_PFC_inv_o_low_f": "AC放电告警(逆变交流输出欠频保护)",
  "51102.warning.warn_PLL_grid_pll": "锁相告警(市电锁相失败)",
  "51102.warning.warn_PLL_parellet_pll": "锁相告警(并机二级锁相失败)",
  "51102.warning.warn_T1_overT": "AC侧温度告警(温度过高)",
  "51102.warning.warn_T2_overT": "DC侧温度告警(温度过高)",
  "51102.warning.warn_byp_overT": "旁路告警(温度过高)",
  "51102.warning.warn_chg_lowV": "DC充电告警(充电器低压)",
  "51102.warning.warn_chg_highV": "DC充电告警(充电器高压)",
  "51102.warning.warn_dischg_battV": "DC放电告警(电池低压故障)",
  "51102.warning.warn_dischg_busV": "DC放电告警(母线低压故障)",
  "51102.warning.warn_dischg_battOverV": "DC放电告警(电池高压故障)",
  "51102.warning.warn_PV1_dc_lowV": "PV1告警(DC低压故障)",
  "51102.warning.warn_PV1_dc_highV": "PV1告警(DC高压故障)",
  "51102.warning.warn_PV1_pv_input_lowV": "PV1告警(PV输入欠压)",
  "51102.warning.warn_PV1_pv_input_overV": "PV1告警(PV输入过压)",
  "51102.warning.warn_PV2_dc_lowV": "PV2告警(DC低压故障)",
  "51102.warning.warn_PV2_dc_highV": "PV2告警(DC高压故障)",
  "51102.warning.warn_PV2_pv_input_lowV": "PV2告警(PV输入欠压)",
  "51102.warning.warn_PV2_pv_input_overV": "PV2告警(PV输入过压)",
  "51102.warning.warn_PV3_dc_lowV": "PV3告警(DC低压故障)",
  "51102.warning.warn_PV3_dc_highV": "PV3告警(DC高压故障)",
  "51102.warning.warn_PV3_pv_input_lowV": "PV3告警(PV输入欠压)",
  "51102.warning.warn_PV3_pv_input_overV": "PV3告警(PV输入过压)",
  "51102.warning.warn_PV4_dc_lowV": "PV4告警(DC低压故障)",
  "51102.warning.warn_PV4_dc_highV": "PV4告警(DC高压故障)",
  "51102.warning.warn_PV4_pv_input_lowV": "PV4告警(PV输入欠压)",
  "51102.warning.warn_PV4_pv_input_overV": "PV4告警(PV输入过压)",
  "51102.warning.warn_prllt1_f_mismatch": "并机告警1(并机频率体系不一致)",
  "51102.warning.warn_prllt2_avg_I": "并机告警2(并机均流故障)",
  "51102.warning.warn_cell1_grp_avgV_high": "电芯告警1(电芯组均压高)",
  "51102.warning.warn_cell1_overV": "电芯告警1(电芯高压)",
  "51102.warning.warn_cell1_grp_avgV_low": "电芯告警1(电芯组均压低)",
  "51102.warning.warn_cell1_lowV": "电芯告警1(电芯低压)",
  "51102.warning.warn_cell2_chgOverISlowChck": "电芯告警2(充电过流慢检(电芯))",
  "51102.warning.warn_cell2_dischgOverISlowChck": "电芯告警2(放电过流慢检(电芯))",
  "51102.warning.warn_cellT_L1_overT_chg": "电芯温度告警(电芯一级过温(充电))",
  "51102.warning.warn_cellT_L2_overT_chg": "电芯温度告警(电芯二级过温(充电))",
  "51102.warning.warn_cellT_L1_lowT_chg": "电芯温度告警(电芯一级低温(充电))",
  "51102.warning.warn_cellT_L2_lowT_chg": "电芯温度告警(电芯二级低温(充电))",
  "51102.warning.warn_cellT_L1_overT_dischg": "电芯温度告警(电芯一级过温(放电))",
  "51102.warning.warn_cellT_L2_overT_dischg": "电芯温度告警(电芯二级过温(放电))",
  "51102.warning.warn_cellT_L1_lowT_dischg": "电芯温度告警(电芯一级低温(放电))",
  "51102.warning.warn_cellT_L2_lowT_dischg": "电芯温度告警(电芯二级低温(放电))",
  "51102.warning.warn_cellT_env_overT": "电芯温度告警(环境过温)",
  "51102.warning.warn_cellT_env_lowT": "电芯温度告警(环境低温)",
  "51102.warning.warn_cellT_mos_overT": "电芯温度告警(MOS过温)",
  "51102.warning.warn_cellT_diffT_toolarge": "电芯温度告警(温差过大)",
  "51102.warning.warn_eps_lowV": "EPS微逆告警(电压低)",
  "51102.warning.warn_eps_highV": "EPS微逆告警(电压高)",
  "51102.warning.warn_eps_lowF": "EPS微逆告警(频率低)",
  "51102.warning.warn_eps_highF": "EPS微逆告警(频率高)",
  "51102.warning.warn_eps_i_overI": "EPS微逆告警(交流输入过流)",
  "51102.fault.fault_grid_summary": "电网故障(故障汇总)",
  "51102.fault.fault_grid_Vabnormal": "电网故障(电压异常)",
  "51102.fault.fault_grid_Fabnormal": "电网故障(频率异常)",
  "51102.fault.fault_grid_lowV": "电网故障(电压低)",
  "51102.fault.fault_grid_highV": "电网故障(电压高)",
  "51102.fault.fault_grid_lowF": "电网故障(频率低)",
  "51102.fault.fault_grid_highF": "电网故障(频率高)",
  "51102.fault.fault_grid_gridLost": "电网故障(市电掉电)",
  "51102.fault.fault_grid_gridSurge": "电网故障(市电浪涌)",
  "51102.fault.fault_grid_relayOpen": "电网故障(电网继电器开路)",
  "51102.fault.fault_grid_ac_i_overI": "电网故障(交流输入过流)",
  "51102.fault.fault_PFC_summary": "AC充电故障(故障汇总)",
  "51102.fault.fault_PFC_hardSoftStrtup": "AC充电故障(硬件软起故障)",
  "51102.fault.fault_PFC_softSoftStrtup": "AC充电故障(软件软起故障)",
  "51102.fault.fault_PFC_bus_lowV": "AC充电故障(母线低压)",
  "51102.fault.fault_PFC_intr_comm_lost": "AC充电故障(内部通信故障)",
  "51102.fault.fault_PFC_extrnl_comm_lost": "AC充电故障(对外通信故障)",
  "51102.fault.fault_U1bus_summary": "AC侧母线故障(故障汇总)",
  "51102.fault.fault_U1bus_lowV_abnormal": "AC侧母线故障(低压异常)",
  "51102.fault.fault_U1bus_highV_abnormal": "AC侧母线故障(高压异常)",
  "51102.fault.fault_U1bus_tooLowV": "AC侧母线故障(电压过低)",
  "51102.fault.fault_U1bus_tooHighV": "AC侧母线故障(电压过高)",
  "51102.fault.fault_U1bus_VtooHighFastChck": "AC侧母线故障(电压过高快检)",
  "51102.fault.fault_U2bus_summary": "DC侧母线故障(故障汇总)",
  "51102.fault.fault_U2bus_lowV_abnormal": "DC侧母线故障(低压异常)",
  "51102.fault.fault_U2bus_highV_abnormal": "DC侧母线故障(高压异常)",
  "51102.fault.fault_U2bus_tooLowV": "DC侧母线故障(电压过低)",
  "51102.fault.fault_U2bus_tooHighV": "DC侧母线故障(电压过高)",
  "51102.fault.fault_U2bus_VtooHighFastChck": "DC侧母线故障(电压过高快检)",
  "51102.fault.fault_o_summary": "输出故障(故障汇总)",
  "51102.fault.fault_o_invRalayOpen": "输出故障(逆变继电器开路)",
  "51102.fault.fault_o_invOverLoad": "输出故障(逆变过载延时到故障)",
  "51102.fault.fault_o_bypOverLoad": "输出故障(旁路过载延时到故障)",
  "51102.fault.fault_inv_summary": "AC放电故障(故障汇总)",
  "51102.fault.fault_inv_invFastChck": "AC放电故障(逆变器快检故障)",
  "51102.fault.fault_inv_invSlowChck": "AC放电故障(逆变器慢检故障)",
  "51102.fault.fault_inv_RelayStuck": "AC放电故障(继电器连锡故障)",
  "51102.fault.fault_inv_invShortCircuit": "AC放电故障(逆变短路故障)",
  "51102.fault.fault_inv_intrCommErr": "AC放电故障(内部通信故障)",
  "51102.fault.fault_inv_extCommErr": "AC放电故障(对外通信故障)",
  "51102.fault.fault_inv_invVabnormal": "AC放电故障(逆变电压有效值故障)",
  "51102.fault.fault_inv_outputOverVProtect": "AC放电故障(逆变交流输出过压保护)",
  "51102.fault.fault_inv_outputLowVProtect": "AC放电故障(逆变交流输出欠压保护)",
  "51102.fault.fault_inv_outputOverFProtect": "AC放电故障(逆变交流输出过频保护)",
  "51102.fault.fault_inv_outputlowFProtect": "AC放电故障(逆变交流输出欠频保护)",
  "51102.fault.fault_PLL_summary": "锁相故障(故障汇总)",
  "51102.fault.fault_PLL_acMainPll": "锁相故障(市电锁相失败)",
  "51102.fault.fault_PLL_secondaryPllLocked": "锁相故障(并机二级锁相失败)",
  "51102.fault.fault_T_summary": "AC侧温度故障(故障汇总)",
  "51102.fault.fault_T_TtooHigh": "AC侧温度故障(温度过高)",
  "51102.fault.fault_T_TmpPinDisconn": "AC侧温度故障(温度探头未插)",
  "51102.fault.fault_T2_summary": "DC侧温度故障(故障汇总)",
  "51102.fault.fault_T2_TtooHigh": "DC侧温度故障(温度过高)",
  "51102.fault.fault_T2_TmpPinDisconn": "DC侧温度故障(温度探头未插)",
  "51102.fault.fault_byp_summary": "旁路故障(故障汇总)",
  "51102.fault.fault_byp_Vabnormal": "旁路故障(电压异常)",
  "51102.fault.fault_byp_Fabnormal": "旁路故障(频率异常)",
  "51102.fault.fault_byp_VtooLow": "旁路故障(电压低)",
  "51102.fault.fault_byp_VtooHigh": "旁路故障(电压高)",
  "51102.fault.fault_byp_FtooLow": "旁路故障(频率低)",
  "51102.fault.fault_byp_FtooHigh": "旁路故障(频率高)",
  "51102.fault.fault_byp_bypShtdwn": "旁路故障(旁路掉电)",
  "51102.fault.fault_byp_bypInrush": "旁路故障(旁路浪涌)",
  "51102.fault.fault_byp_intrCommErr": "旁路故障(内部通信故障)",
  "51102.fault.fault_byp_extCommErr": "旁路故障(对外通信故障)",
  "51102.fault.fault_chg_summary": "DC充电故障(故障汇总)",
  "51102.fault.fault_chg_lowV": "DC充电故障(充电器低压)",
  "51102.fault.fault_chg_HighV": "DC充电故障(充电器高压)",
  "51102.fault.fault_chg_OutputShortCircuit": "DC充电故障(充电器输出短路)",
  "51102.fault.fault_chg_softStrpup": "DC充电故障(充电器软启故障)",
  "51102.fault.fault_chg_busVAbnormal": "DC充电故障(母线电压异常)",
  "51102.fault.fault_chg_oVTooLowFastChck": "DC充电故障(输出电压过低快检)",
  "51102.fault.fault_chg_oVTooHigh": "DC充电故障(输出电压过高)",
  "51102.fault.fault_chg_oVTooHighFastChck": "DC充电故障(输出电压过高快检)",
  "51102.fault.fault_chg_acChgUnenough": "DC充电故障(AC剩余充电功率不足(PV+AC联合充电))",
  "51102.fault.fault_chg_intrCommErr": "DC充电故障(内部通信故障)",
  "51102.fault.fault_chg_outCommErr": "DC充电故障(对外通信故障)",
  "51102.fault.fault_chg_extCommErr": "DC充电故障(剩余充电功率不足(AC边充边放))",
  "51102.fault.fault_chg_bypSundenlyAddLoad": "DC充电故障(旁路突加载故障)",
  "51102.fault.fault_dischg_summary": "DC放电故障(故障汇总)",
  "51102.fault.fault_dischg_battLowV": "DC放电故障(电池低压故障)",
  "51102.fault.fault_dischg_busLowV": "DC放电故障(母线低压故障)",
  "51102.fault.fault_dischg_battHighV": "DC放电故障(电池高压故障)",
  "51102.fault.fault_dischg_battTooHighV": "DC放电故障(电池电压过高故障)",
  "51102.fault.fault_dischg_intrCommLost": "DC放电故障(内部通信故障)",
  "51102.fault.fault_dischg_extrCommLost": "DC放电故障(对外通信故障)",
  "51102.fault.fault_dischg_battVtooLow": "DC放电故障(电池电压过低故障)",
  "51102.fault.fault_dischg_softStrpup": "DC放电故障(放电器软启故障)",
  "51102.fault.fault_sys_dismatch": "系统故障(机型不匹配)",
  "51102.fault.fault_sys_intrCommLost": "系统故障(内部通信故障)",
  "51102.fault.fault_sys_extCommLost": "系统故障(对外通信故障)",
  "51102.fault.fault_pcs_selfTest": "PCS自检故障",
  "51102.fault.fault_elctMeter_selfTest": "电表自检故障",
  "51102.fault.fault_MOS_selfTest": "MOS自检故障",
  "51102.fault.fault_PV1_summary": "PV1故障(故障汇总)",
  "51102.fault.fault_PV1_DCLowV": "PV1故障(DC低压故障)",
  "51102.fault.fault_PV1_DCHighV": "PV1故障(DC高压故障)",
  "51102.fault.fault_PV1_softStrpUp": "PV1故障(软启故障)",
  "51102.fault.fault_PV1_outpuShrtCircuit": "PV1故障(输出短路故障)",
  "51102.fault.fault_PV1_outpuShrtCircuitStrtup": "PV1故障(输出短路启机故障)",
  "51102.fault.fault_PV1_DCVTooHigh": "PV1故障(DC电压过高)",
  "51102.fault.fault_PV1_DCVTooHighFstChck": "PV1故障(DC电压过高快检)",
  "51102.fault.fault_PV1_Vabnormal": "PV1故障(PV工作电压异常)",
  "51102.fault.fault_PV1_inCommLost": "PV1故障(内部通信故障)",
  "51102.fault.fault_PV1_extCommLost": "PV1故障(对外通信故障)",
  "51102.fault.fault_PV1_inputLowV": "PV1故障(PV输入欠压)",
  "51102.fault.fault_PV1_inputHighV": "PV1故障(PV输入过压)",
  "51102.fault.fault_PV2_summary": "PV2故障(故障汇总)",
  "51102.fault.fault_PV2_DCLowV": "PV2故障(DC低压故障)",
  "51102.fault.fault_PV2_DCHighV": "PV2故障(DC高压故障)",
  "51102.fault.fault_PV2_softStrpUp": "PV2故障(软启故障)",
  "51102.fault.fault_PV2_outpuShrtCircuit": "PV2故障(输出短路故障)",
  "51102.fault.fault_PV2_outpuShrtCircuitStrtup": "PV2故障(输出短路启机故障)",
  "51102.fault.fault_PV2_DCVTooHigh": "PV2故障(DC电压过高)",
  "51102.fault.fault_PV2_DCVTooHighFstChck": "PV2故障(DC电压过高快检)",
  "51102.fault.fault_PV2_Vabnormal": "PV2故障(PV工作电压异常)",
  "51102.fault.fault_PV2_inCommLost": "PV2故障(内部通信故障)",
  "51102.fault.fault_PV2_extCommLost": "PV2故障(对外通信故障)",
  "51102.fault.fault_PV2_inputLowV": "PV2故障(PV输入欠压)",
  "51102.fault.fault_PV2_inputHighV": "PV2故障(PV输入过压)",
  "51102.fault.fault_PV3_summary": "PV3故障(故障汇总)",
  "51102.fault.fault_PV3_DCLowV": "PV3故障(DC低压故障)",
  "51102.fault.fault_PV3_DCHighV": "PV3故障(DC高压故障)",
  "51102.fault.fault_PV3_softStrpUp": "PV3故障(软启故障)",
  "51102.fault.fault_PV3_outpuShrtCircuit": "PV3故障(输出短路故障)",
  "51102.fault.fault_PV3_outpuShrtCircuitStrtup": "PV3故障(输出短路启机故障)",
  "51102.fault.fault_PV3_DCVTooHigh": "PV3故障(DC电压过高)",
  "51102.fault.fault_PV3_DCVTooHighFstChck": "PV3故障(DC电压过高快检)",
  "51102.fault.fault_PV3_Vabnormal": "PV3故障(PV工作电压异常)",
  "51102.fault.fault_PV3_inCommLost": "PV3故障(内部通信故障)",
  "51102.fault.fault_PV3_extCommLost": "PV3故障(对外通信故障)",
  "51102.fault.fault_PV3_inputLowV": "PV3故障(PV输入欠压)",
  "51102.fault.fault_PV3_inputHighV": "PV3故障(PV输入过压)",
  "51102.fault.fault_PV4_summary": "PV4故障(故障汇总)",
  "51102.fault.fault_PV4_DCLowV": "PV4故障(DC低压故障)",
  "51102.fault.fault_PV4_DCHighV": "PV4故障(DC高压故障)",
  "51102.fault.fault_PV4_softStrpUp": "PV4故障(软启故障)",
  "51102.fault.fault_PV4_outpuShrtCircuit": "PV4故障(输出短路故障)",
  "51102.fault.fault_PV4_outpuShrtCircuitStrtup": "PV4故障(输出短路启机故障)",
  "51102.fault.fault_PV4_DCVTooHigh": "PV4故障(DC电压过高)",
  "51102.fault.fault_PV4_DCVTooHighFstChck": "PV4故障(DC电压过高快检)",
  "51102.fault.fault_PV4_Vabnormal": "PV4故障(PV工作电压异常)",
  "51102.fault.fault_PV4_inCommLost": "PV4故障(内部通信故障)",
  "51102.fault.fault_PV4_extCommLost": "PV4故障(对外通信故障)",
  "51102.fault.fault_PV4_inputLowV": "PV4故障(PV输入欠压)",
  "51102.fault.fault_PV4_inputHighV": "PV4故障(PV输入过压)",
  "51102.fault.fault_prllt_summary": "并机故障1(故障汇总)",
  "51102.fault.fault_prllt_idConflict": "并机故障1(并机ID冲突故障)",
  "51102.fault.fault_prllt_commErr": "并机故障1(并机通信故障)",
  "51102.fault.fault_prllt_Fdismatch": "并机故障1(并机频率体系不一致)",
  "51102.fault.fault_prllt_failure": "并机故障1(并机失败故障)",
  "51102.fault.fault_prllt2_summary": "并机故障2(故障汇总)",
  "51102.fault.fault_prllt2_avgI": "并机故障2(并机均流故障)",
  "51102.fault.fault_prllt2_FsyncSig": "并机故障2(并机工频同步信号故障)",
  "51102.fault.fault_cell1_avgVHighProtect": "电芯故障1(电芯组均压高保护)",
  "51102.fault.fault_cell1_HighVProtect": "电芯故障1(电芯高压保护)",
  "51102.fault.fault_cell1_avgVlowProtect": "电芯故障1(电芯组均压低保护)",
  "51102.fault.fault_cell1_lowVProtect": "电芯故障1(电芯低压保护)",
  "51102.fault.fault_cell1_cellCntDismatch": "电芯故障1(电池节数不匹配)",
  "51102.fault.fault_cell1_cellUnavail": "电芯故障1(电芯单体失效)",
  "51102.fault.fault_cell1_cellGrpDiffVtooLarge": "电芯故障1(电芯组压差过大)",
  "51102.fault.fault_cell1_seriousHighVProtect": "电芯故障1(电芯严重高压保护)",
  "51102.fault.fault_cell1_seriousLowVProtect": "电芯故障1(电芯严重低压保护)",
  "51102.fault.fault_cell1_srsLowVPrtctShtdwn": "电芯故障1(电芯严重低压保护关机)",
  "51102.fault.fault_cell1_l1ChgStatus": "电芯故障1(一级强充状态-不控制，只播报)",
  "51102.fault.fault_cell1_l2ChgStatus": "电芯故障1(二级强充状态-不控制，只播报)",
  "51102.fault.fault_cell1_tooOverVProtect": "电芯故障1(电芯严重过压保护)",
  "51102.fault.fault_cell2_chgOverISlwChck": "电芯故障2(充电过流慢检(电芯))",
  "51102.fault.fault_cell2_chgOverIFstChck": "电芯故障2(充电过流快检(电芯))",
  "51102.fault.fault_cell2_dischgOverISlwChck": "电芯故障2(放电过流慢检(电芯))",
  "51102.fault.fault_cell2_dischgOverIFstChck": "电芯故障2(放电过流快检(电芯))",
  "51102.fault.fault_cell2_chgOverI": "电芯故障2(充电过流错误)",
  "51102.fault.fault_cell2_dischgOverI": "电芯故障2(放电过流错误)",
  "51102.fault.fault_cellT_TmpSensorDisconn": "电芯温度故障(电芯采样温度探头未插)",
  "51102.fault.fault_cellT_l1OverTChg": "电芯温度故障(电芯一级过温保护(充电))",
  "51102.fault.fault_cellT_l2OverTChg": "电芯温度故障(电芯二级过温保护(充电))",
  "51102.fault.fault_cellT_l1lowTChg": "电芯温度故障(电芯一级低温保护(充电))",
  "51102.fault.fault_cellT_l2lowTChg": "电芯温度故障(电芯二级低温保护(充电))",
  "51102.fault.fault_cellT_l1OverTdisChg": "电芯温度故障(电芯一级过温保护(放电))",
  "51102.fault.fault_cellT_l2OverTdisChg": "电芯温度故障(电芯二级过温保护(放电))",
  "51102.fault.fault_cellT_l1lowTdisChg": "电芯温度故障(电芯一级低温保护(放电))",
  "51102.fault.fault_cellT_l2lowTdisChg": "电芯温度故障(电芯二级低温保护(放电))",
  "51102.fault.fault_cellT_envOverT": "电芯温度故障(环境过温保护)",
  "51102.fault.fault_cellT_envlowT": "电芯温度故障(环境低温保护)",
  "51102.fault.fault_cellT_mosOverT": "电芯温度故障(MOS过温保护)",
  "51102.fault.fault_cellT_diffTtooHigh": "电芯温度故障(温差过大)",
  "51102.fault.fault_cellT_highVsideMosDisconn": "电芯温度故障(高压侧MOS采样探头未插)",
  "51102.fault.fault_eps_summary": "EPS微逆故障(故障汇总)",
  "51102.fault.fault_eps_Vabnormal": "EPS微逆故障(电压异常)",
  "51102.fault.fault_eps_Fabnormal": "EPS微逆故障(频率异常)",
  "51102.fault.fault_eps_VtooLow": "EPS微逆故障(电压过低)",
  "51102.fault.fault_eps_VLow": "EPS微逆故障(电压低)",
  "51102.fault.fault_eps_VHigh": "EPS微逆故障(电压高)",
  "51102.fault.fault_eps_Flow": "EPS微逆故障(频率低)",
  "51102.fault.fault_eps_FHigh": "EPS微逆故障(频率高)",
  "51102.fault.fault_eps_acMainLost": "EPS微逆故障(输入掉电)",
  "51102.fault.fault_eps_inpuSurge": "EPS微逆故障(输入浪涌)",
  "51102.fault.fault_eps_relayOpenCircuit": "EPS微逆故障(继电器开路)",
  "51102.fault.fault_eps_inputOverI": "EPS微逆故障(输入过流)",
  "51102.real_time.elct_meter1_SN": "网侧电表SN",
  "51102.real_time.elct_meter1_soft_ver": "网侧电表软件版本",
  "51102.real_time.elct_meter1_phase_no": "逆变器所在相位",
  "51102.real_time.elct_meter1_online_status": "网侧电表在线状态",
  "51102.real_time.elct_meter1_total_active_energy": "网侧电表总有功电能",
  "51102.real_time.grid_active_energy_forward": "网侧电表正向有功电能",
  "51102.real_time.grid_active_energy_reverse": "网侧电表反向有功电能",
  "51102.real_time.elct_meter1_total_reactive_energy": "网侧电表总无功电能",
  "51102.real_time.elct_meter1_forward_reactive_energy": "网侧电表正向无功电能",
  "51102.real_time.elct_meter1_reverse_reactive_energy": "网侧电表反向无功电能",
  "51102.real_time.elct_meter1_voltage": "网侧电表电压",
  "51102.real_time.elct_meter1_current": "网侧电表电流",
  "51102.real_time.gridTotalFrequency": "网侧电表频率",
  "51102.real_time.gridPower_from_elct_meter": "网侧电表有功功率",
  "51102.real_time.elct_meter1_reactive_power": "网侧电表无功功率",
  "51102.real_time.elct_meter1_apparent_power": "网侧电表视在功率",
  "51102.real_time.elct_meter1_power_factor": "网侧电表功率因数",
  "51102.real_time.elct_meter2_SN": "AC微逆侧电表SN",
  "51102.real_time.elct_meter2_soft_ver": "AC微逆侧电表软件版本",
  "51102.real_time.elct_meter2_phase_no": "逆变器所在相位",
  "51102.real_time.elct_meter2_online_status": "AC微逆侧电表在线状态",
  "51102.real_time.elct_meter2_total_active_energy": "AC微逆侧电表总有功电能",
  "51102.real_time.elct_meter2_forward_active_energy": "AC微逆侧电表正向有功电能",
  "51102.real_time.elct_meter2_reverse_active_energy": "AC微逆侧电表反向有功电能",
  "51102.real_time.elct_meter2_total_reactive_energy": "AC微逆侧电表总无功电能",
  "51102.real_time.elct_meter2_forward_reactive_energy": "AC微逆侧电表正向无功电能",
  "51102.real_time.elct_meter2_reverse_reactive_energy": "AC微逆侧电表反向无功电能",
  "51102.real_time.elct_meter2_voltage": "AC微逆侧电表电压",
  "51102.real_time.elct_meter2_current": "AC微逆侧电表电流",
  "51102.real_time.elct_meter2_frequency": "AC微逆侧电表频率",
  "51102.real_time.elct_meter2_active_power": "AC微逆侧电表有功功率",
  "51102.real_time.elct_meter2_reactive_power": "AC微逆侧电表无功功率",
  "51102.real_time.elct_meter2_apparent_power": "AC微逆侧电表视在功率",
  "51102.real_time.elct_meter2_power_factor": "AC微逆侧电表功率因数",
  "51102.ctrl_Remote_Reset.c_datalogger_reboot.12544": "重启",
  "51102.ctrl_Remote_Reset.c_datalogger_factory_reset.12544": "恢复出厂设置",
  "51102..c_datalogger_ble_onoff.12288": "关闭",
  "51102..c_datalogger_ble_onoff.12544": "打开",
  "51102..c_eletMeter1_insPlace.0": "未设置",
  "51102..c_eletMeter1_insPlace.1": "电网侧",
  "51102..c_eletMeter1_insPlace.2": "AC微逆侧",
  "51102..c_eletMeter1_commType.0": "未设置",
  "51102..c_eletMeter1_commType.1": "无线",
  "51102..c_eletMeter1_commType.2": "有线",
  "51102..c_eletMeter1_phaseNo.0": "单相",
  "51102..c_eletMeter1_phaseNo.1": "A相",
  "51102..c_eletMeter1_phaseNo.2": "B相",
  "51102..c_eletMeter1_phaseNo.3": "C相",
  "51102..c_eletMeter2_insPlace.0": "未设置",
  "51102..c_eletMeter2_insPlace.1": "电网侧",
  "51102..c_eletMeter2_insPlace.2": "AC微逆侧",
  "51102..c_eletMeter2_commType.0": "未设置",
  "51102..c_eletMeter2_commType.1": "无线",
  "51102..c_eletMeter2_commType.2": "有线",
  "51102..c_eletMeter2_phaseNo.0": "单相",
  "51102..c_eletMeter2_phaseNo.1": "A相",
  "51102..c_eletMeter2_phaseNo.2": "B相",
  "51102..c_eletMeter2_phaseNo.3": "C相",
  "51102..c_eletMeter3_insPlace.0": "未设置",
  "51102..c_eletMeter3_insPlace.1": "电网侧",
  "51102..c_eletMeter3_insPlace.2": "AC微逆侧",
  "51102..c_eletMeter3_commType.0": "未设置",
  "51102..c_eletMeter3_commType.1": "无线",
  "51102..c_eletMeter3_commType.2": "有线",
  "51102..c_eletMeter3_phaseNo.0": "单相",
  "51102..c_eletMeter3_phaseNo.1": "A相",
  "51102..c_eletMeter3_phaseNo.2": "B相",
  "51102..c_eletMeter3_phaseNo.3": "C相",
  "51102..dev_type.0": "微储",
  "51102..dev_type.1": "户储",
  "51102..dev_type.2": "混合逆变器",
  "51102.real_time.bms_status.0": "正常",
  "51102.real_time.bms_status.1": "禁放",
  "51102.real_time.bms_status.2": "禁充",
  "51102.real_time.bms_status.3": "禁充禁放",
  "51102.real_time.bms_status.4": "禁充禁放且分励脱扣断开",
  "51102.real_time.bms_status.5": "满充",
  "51102.real_time.bms_status.6": "满放",
  "51102.real_time.bms_status.8": "整机下电",
  "51102.real_time.batt_type.0": "314电芯",
  "51102.real_time.batt_type.1": "其他",
  "51102.real_time.anti_curr_status.0": "未开启",
  "51102.real_time.anti_curr_status.1": "开启",
  "51102.real_time.low_volt_cross_status.0": "未开启",
  "51102.real_time.low_volt_cross_status.1": "开启",
  "51102.real_time.f_cross_status.0": "未开启",
  "51102.real_time.f_cross_status.1": "开启",
  "51102.real_time.reconn_cross_status.0": "未开启",
  "51102.real_time.reconn_cross_status.1": "开启",
  "51102.real_time.inv_profile.22": "奥地利，230V/50Hz",
  "51102.real_time.inv_profile.23": "比利时，230V/50Hz",
  "51102.real_time.inv_profile.24": "牙买加，110/220V 60Hz",
  "51102.real_time.inv_profile.25": "爱尔兰，230V/50Hz",
  "51102.real_time.inv_profile.26": "科威特，230V/50Hz",
  "51102.real_time.inv_profile.27": "罗马尼亚，230V/50Hz",
  "51102.real_time.inv_profile.28": "法国，230V/50Hz",
  "51102.real_time.inv_profile.29": "荷兰，230V/50Hz",
  "51102.real_time.inv_profile.30": "瑞士，230V/50Hz",
  "51102.real_time.inv_profile.31": "西班牙，230V/50Hz",
  "51102.real_time.inv_profile.10": "美国，120V/60Hz",
  "51102.real_time.inv_profile.32": "泰国MEA，220V/50Hz",
  "51102.real_time.inv_profile.11": "泰国PEA，220V/50Hz",
  "51102.real_time.inv_profile.12": "南非，230V/50Hz",
  "51102.real_time.inv_profile.13": "Custom 50Hz，自定义50Hz",
  "51102.real_time.inv_profile.14": "Custom 60Hz，自定义60Hz",
  "51102.real_time.inv_profile.15": "波兰，230V/50Hz",
  "51102.real_time.inv_profile.16": "意大利，230V/50Hz",
  "51102.real_time.inv_profile.17": "斯洛文尼亚，230V/50Hz",
  "51102.real_time.inv_profile.18": "捷克，230V/50Hz",
  "51102.real_time.inv_profile.19": "瑞典，230V/50Hz",
  "51102.real_time.inv_profile.0": "欧洲通用（默认），230V/50Hz",
  "51102.real_time.inv_profile.1": "德国，230V/50Hz",
  "51102.real_time.inv_profile.2": "澳洲，230V/50Hz",
  "51102.real_time.inv_profile.3": "澳洲西，230V/50Hz",
  "51102.real_time.inv_profile.4": "新西兰，230V/50Hz",
  "51102.real_time.inv_profile.5": "英国，230V/50Hz",
  "51102.real_time.inv_profile.6": "巴基斯坦，230V/50Hz",
  "51102.real_time.inv_profile.7": "韩国，220V/60Hz",
  "51102.real_time.inv_profile.8": "菲律宾，220V/60Hz",
  "51102.real_time.inv_profile.9": "中国，220V/50Hz",
  "51102.real_time.inv_profile.20": "匈牙利，230V/50Hz",
  "51102.real_time.inv_profile.21": "斯洛伐克，230V/50Hz",
  "51102..inv_manufac.0": "图为",
  "51102.real_time.deviceStatus.0": "未激活",
  "51102.real_time.deviceStatus.1": "激活",
  "51102.real_time.Wifi_BT_Online.0": "离线",
  "51102.real_time.Wifi_BT_Online.1": "在线",
  "51102..Wifi_BT_Sleep.0": "不休眠",
  "51102.real_time.workStatus.11": "微逆馈网",
  "51102.real_time.workStatus.12": "微逆+PV联合充电",
  "51102.real_time.workStatus.13": "故障",
  "51102.real_time.workStatus.0": "关机",
  "51102.real_time.workStatus.1": "待机",
  "51102.real_time.workStatus.2": "AC充电",
  "51102.real_time.workStatus.3": "AC边充边放",
  "51102.real_time.workStatus.4": "旁路放电",
  "51102.real_time.workStatus.5": "电池放电",
  "51102.real_time.workStatus.6": "PV充电",
  "51102.real_time.workStatus.7": "PV边充边放",
  "51102.real_time.workStatus.8": "PV+AC联合充电",
  "51102.real_time.workStatus.9": "PV+AC联合充电，旁路放电",
  "51102.real_time.workStatus.10": "微逆充电",
  "51102.real_time.workMode.0": "自发自用模式",
  "51102.real_time.workMode.1": "馈网优先模式",
  "51102.real_time.workMode.2": "削峰填谷模式",
  "51102.real_time.workMode.3": "备电模式",
  "51102.real_time.workMode.4": "TOU模式",
  "51102.real_time.workMode.5": "三方调度",
  "51102.real_time.parelletRunStatue.0": "单机",
  "51102.real_time.parelletRunStatue.1": "并机",
  "51102.real_time.acDischargeMode.0": "未输出",
  "51102.real_time.acDischargeMode.1": "正在输出",
  "51102.real_time.acchargeStatus.0": "未充电",
  "51102.real_time.acchargeStatus.1": "正在充电",
  "51102.real_time.MPPTStatus.0": "未充电",
  "51102.real_time.MPPTStatus.1": "正在充电",
  "51102.real_time.SleepStatus.0": "未休眠",
  "51102.real_time.SleepStatus.1": "休眠",
  "51102.real_time.gridConnStatus.0": "并网",
  "51102.real_time.gridConnStatus.1": "离网",
  "51102.real_time.antiReverseIStatus.0": "未开启",
  "51102.real_time.antiReverseIStatus.1": "开启",
  "51102.real_time.masterOrSlaveStatus.0": "从机",
  "51102.real_time.masterOrSlaveStatus.1": "主机",
  "51102.real_time.EPSConnStatus.0": "负载",
  "51102.real_time.EPSConnStatus.1": "微逆",
  "51102.real_time.remote_onoff_status.0": "单台关机",
  "51102.real_time.remote_onoff_status.1": "单台开机",
  "51102.real_time.remote_onoff_status.2": "全部关机",
  "51102.real_time.remote_onoff_status.3": "全部开机",
  "51102.real_time.shunt_trip_status.0": "闭合",
  "51102.real_time.shunt_trip_status.1": "断开",
  "51102.real_time.AI_LED_status.0": "熄灭",
  "51102.real_time.AI_LED_status.1": "点亮",
  "51102.real_time.ai_elct_meter_check.0": "检测完成",
  "51102.real_time.ai_elct_meter_check.1": "检测双电表位置",
  "51102.real_time.ai_elct_meter_check.2": "检测电表相序",
  "51102.real_time.parallel_status.0": "未开启",
  "51102.real_time.parallel_status.1": "开启",
  "51102.real_time.parallel_isMaster.0": "从机",
  "51102.real_time.parallel_isMaster.1": "主机",
  "51102.real_time.EPS_status.0": "未接入",
  "51102.real_time.EPS_status.1": "已接入",
  "51102.real_time.PV1_online_status.0": "不在位",
  "51102.real_time.PV1_online_status.1": "在位",
  "51102.real_time.PV2_online_status.0": "不在位",
  "51102.real_time.PV2_online_status.1": "在位",
  "51102.real_time.PV3_online_status.0": "不在位",
  "51102.real_time.PV3_online_status.1": "在位",
  "51102.real_time.PV4_online_status.0": "不在位",
  "51102.real_time.PV4_online_status.1": "在位",
  "51102..actpower_ctl_en.0": "不使能",
  "51102..actpower_ctl_en.1": "使能",
  "51102.ctrl_Inverter-control.Reactive.reactpower_ctl_en.0": "不使能",
  "51102.ctrl_Inverter-control.Reactive.reactpower_ctl_en.1": "使能",
  "51102.ctrl_Inverter-control.Reactive.reactpower_ctl_mode.0": "功率因数模式",
  "51102.ctrl_Inverter-control.Reactive.reactpower_ctl_mode.1": "电压无功功率曲线模式",
  "51102.ctrl_WorkMode.Switch.ems_ctrl_work_mode.0": "自发自用",
  "51102.ctrl_WorkMode.Switch.ems_ctrl_work_mode.1": "馈网优先",
  "51102.ctrl_WorkMode.Switch.ems_ctrl_work_mode.2": "分时电价",
  "51102.ctrl_WorkMode.Switch.ems_ctrl_work_mode.3": "电池备电",
  "51102.ctrl_WorkMode.Switch.ems_ctrl_work_mode.4": "定时充放",
  "51102.ctrl_Supersetting.anti_reverse_curr.0": "禁用",
  "51102.ctrl_Supersetting.anti_reverse_curr.1": "使能",
  "51102.ctrl_Supersetting.remote_on_off_ctrl.0": "单台关机",
  "51102.ctrl_Supersetting.remote_on_off_ctrl.1": "单台开机",
  "51102.ctrl_Supersetting.remote_on_off_ctrl.2": "全部关机",
  "51102.ctrl_Supersetting.remote_on_off_ctrl.3": "全部开机",
  "51102.ctrl_Supersetting.batt_shutdown_ctrl.0": "禁用",
  "51102.ctrl_Supersetting.batt_shutdown_ctrl.1": "使能",
  "51102.ctrl_Supersetting.factory_recovery.0": "无操作",
  "51102.ctrl_Supersetting.factory_recovery.1": "清除电量信息",
  "51102.ctrl_Supersetting.factory_recovery.2": "清除日志信息",
  "51102.ctrl_Supersetting.factory_recovery.3": "完全恢复出厂设置",
  "51102..ai_tou_enable.0": "禁用",
  "51102..ai_tou_enable.1": "使能",
  "51102..ai_meshing_status.0": "组网完成",
  "51102..ai_meshing_status.1": "智能组网中",
  "51102..user_type.0": "普通用户",
  "51102.ctrl_Safety Regulations.gridType.22": "AT，奥地利",
  "51102.ctrl_Safety Regulations.gridType.23": "BE，比利时",
  "51102.ctrl_Safety Regulations.gridType.24": "JM，牙买加",
  "51102.ctrl_Safety Regulations.gridType.25": "IE，爱尔兰",
  "51102.ctrl_Safety Regulations.gridType.26": "KW，科威特",
  "51102.ctrl_Safety Regulations.gridType.27": "ROU，罗马尼亚",
  "51102.ctrl_Safety Regulations.gridType.28": "FR，法国",
  "51102.ctrl_Safety Regulations.gridType.29": "NL，荷兰",
  "51102.ctrl_Safety Regulations.gridType.30": "CH，瑞士",
  "51102.ctrl_Safety Regulations.gridType.31": "ES，西班牙",
  "51102.ctrl_Safety Regulations.gridType.10": "US，美国",
  "51102.ctrl_Safety Regulations.gridType.32": "TAI-MEA，泰国MEA",
  "51102.ctrl_Safety Regulations.gridType.11": "TAI-PEA，泰国PEA",
  "51102.ctrl_Safety Regulations.gridType.12": "ZA，南非",
  "51102.ctrl_Safety Regulations.gridType.13": "Custom 50Hz，自定义50Hz",
  "51102.ctrl_Safety Regulations.gridType.14": "Custom 60Hz，自定义60Hz",
  "51102.ctrl_Safety Regulations.gridType.15": "POL，波兰",
  "51102.ctrl_Safety Regulations.gridType.16": "ITA，意大利",
  "51102.ctrl_Safety Regulations.gridType.17": "SLO，斯洛文尼亚，采用EN50549",
  "51102.ctrl_Safety Regulations.gridType.18": "CZE，捷克，采用EN50549",
  "51102.ctrl_Safety Regulations.gridType.19": "SWE，瑞典，采用EN50549",
  "51102.ctrl_Safety Regulations.gridType.0": "EN50549，欧洲通用",
  "51102.ctrl_Safety Regulations.gridType.2": "AU，澳洲",
  "51102.ctrl_Safety Regulations.gridType.3": "AU-W， 澳洲西",
  "51102.ctrl_Safety Regulations.gridType.4": "NZ，新西兰",
  "51102.ctrl_Safety Regulations.gridType.5": "UK，英国",
  "51102.ctrl_Safety Regulations.gridType.6": "PK，巴基斯坦",
  "51102.ctrl_Safety Regulations.gridType.7": "KR，韩国",
  "51102.ctrl_Safety Regulations.gridType.8": "PHI，菲律宾",
  "51102.ctrl_Safety Regulations.gridType.9": "CN，中国",
  "51102.ctrl_Safety Regulations.gridType.20": "HU，匈牙利",
  "51102.ctrl_Safety Regulations.gridType.21": "SK，斯洛伐克",
  "51102.ctrl_WorkMode.TOU.TOU_work_status.0": "未开启",
  "51102.ctrl_WorkMode.TOU.TOU_work_status.1": "开启",
  "51102..alrm_grid_v_low.0": "正常",
  "51102..alrm_grid_v_low.1": "预警",
  "51102..alrm_grid_v_high.0": "正常",
  "51102..alrm_grid_v_high.1": "预警",
  "51102..alrm_grid_f_low.0": "正常",
  "51102..alrm_grid_f_low.1": "预警",
  "51102..alrm_grid_f_high.0": "正常",
  "51102..alrm_grid_f_high.1": "预警",
  "51102..alrm_grid_input_overI.0": "正常",
  "51102..alrm_grid_input_overI.1": "预警",
  "51102..alrm_PFC_bus_v_low.0": "正常",
  "51102..alrm_PFC_bus_v_low.1": "预警",
  "51102..alrm_U1_bus_v_low.0": "正常",
  "51102..alrm_U1_bus_v_low.1": "预警",
  "51102..alrm_U1_bus_v_high.0": "正常",
  "51102..alrm_U1_bus_v_high.1": "预警",
  "51102..alrm_U2_bus_v_low.0": "正常",
  "51102..alrm_U2_bus_v_low.1": "预警",
  "51102..alrm_U2_bus_v_high.0": "正常",
  "51102..alrm_U2_bus_v_high.1": "预警",
  "51102..alrm_inv_overload.0": "正常",
  "51102..alrm_inv_overload.1": "预警",
  "51102..alrm_bypass_overload.0": "正常",
  "51102..alrm_bypass_overload.1": "预警",
  "51102..alrm_inv_v_fault.0": "正常",
  "51102..alrm_inv_v_fault.1": "预警",
  "51102..alrm_inv_overV_protect.0": "正常",
  "51102..alrm_inv_overV_protect.1": "预警",
  "51102..alrm_inv_lowV_protect.0": "正常",
  "51102..alrm_inv_lowV_protect.1": "预警",
  "51102..alrm_inv_overF_protect.0": "正常",
  "51102..alrm_inv_overF_protect.1": "预警",
  "51102..alrm_inv_lowF_protect.0": "正常",
  "51102..alrm_inv_lowF_protect.1": "预警",
  "51102..alrm_lock_phase_failure.0": "正常",
  "51102..alrm_lock_phase_failure.1": "预警",
  "51102..alrm_level2_lock_phase_failure.0": "正常",
  "51102..alrm_level2_lock_phase_failure.1": "预警",
  "51102..alrm_T1_tooHigh.0": "正常",
  "51102..alrm_T1_tooHigh.1": "预警",
  "51102..alrm_T2_tooHigh.0": "正常",
  "51102..alrm_T2_tooHigh.1": "预警",
  "51102..alrm_bypass_lowV.0": "正常",
  "51102..alrm_bypass_lowV.1": "预警",
  "51102..alrm_bypass_highV.0": "正常",
  "51102..alrm_bypass_highV.1": "预警",
  "51102..alrm_bypass_lowF.0": "正常",
  "51102..alrm_bypass_lowF.1": "预警",
  "51102..alrm_bypass_highF.0": "正常",
  "51102..alrm_bypass_highF.1": "预警",
  "51102..alrm_chg_lowV.0": "正常",
  "51102..alrm_chg_lowV.1": "预警",
  "51102..alrm_chg_highV.0": "正常",
  "51102..alrm_chg_highV.1": "预警",
  "51102..alrm_dischg_lowV.0": "正常",
  "51102..alrm_dischg_lowV.1": "预警",
  "51102..alrm_dischg_bus_lowV.0": "正常",
  "51102..alrm_dischg_bus_lowV.1": "预警",
  "51102..alrm_dischg_batt_highV.0": "正常",
  "51102..alrm_dischg_batt_highV.1": "预警",
  "51102..alrm_u1_u2_ver_mismatch.0": "正常",
  "51102..alrm_u1_u2_ver_mismatch.1": "预警",
  "51102..alrm_PV1_DC_lowV.0": "正常",
  "51102..alrm_PV1_DC_lowV.1": "预警",
  "51102..alrm_PV1_DC_highV.0": "正常",
  "51102..alrm_PV1_DC_highV.1": "预警",
  "51102..alrm_PV1_input_lowV.0": "正常",
  "51102..alrm_PV1_input_lowV.1": "预警",
  "51102..alrm_PV1_input_highV.0": "正常",
  "51102..alrm_PV1_input_highV.1": "预警",
  "51102..alrm_PV2_DC_lowV.0": "正常",
  "51102..alrm_PV2_DC_lowV.1": "预警",
  "51102..alrm_PV2_DC_highV.0": "正常",
  "51102..alrm_PV2_DC_highV.1": "预警",
  "51102..alrm_PV2_input_lowV.0": "正常",
  "51102..alrm_PV2_input_lowV.1": "预警",
  "51102..alrm_PV2_input_highV.0": "正常",
  "51102..alrm_PV2_input_highV.1": "预警",
  "51102..alrm_PV3_DC_lowV.0": "正常",
  "51102..alrm_PV3_DC_lowV.1": "预警",
  "51102..alrm_PV3_DC_highV.0": "正常",
  "51102..alrm_PV3_DC_highV.1": "预警",
  "51102..alrm_PV3_input_lowV.0": "正常",
  "51102..alrm_PV3_input_lowV.1": "预警",
  "51102..alrm_PV3_input_highV.0": "正常",
  "51102..alrm_PV3_input_highV.1": "预警",
  "51102..alrm_PV4_DC_lowV.0": "正常",
  "51102..alrm_PV4_DC_lowV.1": "预警",
  "51102..alrm_PV4_DC_highV.0": "正常",
  "51102..alrm_PV4_DC_highV.1": "预警",
  "51102..alrm_PV4_input_lowV.0": "正常",
  "51102..alrm_PV4_input_lowV.1": "预警",
  "51102..alrm_PV4_input_highV.0": "正常",
  "51102..alrm_PV4_input_highV.1": "预警",
  "51102..alrm_parellet_freq_differ.0": "正常",
  "51102..alrm_parellet_freq_differ.1": "预警",
  "51102..alrm_parellet2_avg_I.0": "正常",
  "51102..alrm_parellet2_avg_I.1": "预警",
  "51102..alrm_batt_highV.0": "正常",
  "51102..alrm_batt_highV.1": "预警",
  "51102..alrm_batt_cell_highV.0": "正常",
  "51102..alrm_batt_cell_highV.1": "预警",
  "51102..alrm_batt_lowV.0": "正常",
  "51102..alrm_batt_lowV.1": "预警",
  "51102..alrm_batt_cell_lowV.0": "正常",
  "51102..alrm_batt_cell_lowV.1": "预警",
  "51102..alrm_cell_slow_check_overI.0": "正常",
  "51102..alrm_cell_slow_check_overI.1": "预警",
  "51102..alrm_cell_dischg_slow_check_overI.0": "正常",
  "51102..alrm_cell_dischg_slow_check_overI.1": "预警",
  "51102..alrm_cell_chg1_overT.0": "正常",
  "51102..alrm_cell_chg1_overT.1": "预警",
  "51102..alrm_cell_chg2_overT.0": "正常",
  "51102..alrm_cell_chg2_overT.1": "预警",
  "51102..alrm_cell_chg1_lowT.0": "正常",
  "51102..alrm_cell_chg1_lowT.1": "预警",
  "51102..alrm_cell_chg2_lowT.0": "正常",
  "51102..alrm_cell_chg2_lowT.1": "预警",
  "51102..alrm_cell_dischg1_overT.0": "正常",
  "51102..alrm_cell_dischg1_overT.1": "预警",
  "51102..alrm_cell_dischg2_overT.0": "正常",
  "51102..alrm_cell_dischg2_overT.1": "预警",
  "51102..alrm_cell_dischg1_lowT.0": "正常",
  "51102..alrm_cell_dischg1_lowT.1": "预警",
  "51102..alrm_cell_dischg2_lowT.0": "正常",
  "51102..alrm_cell_dischg2_lowT.1": "预警",
  "51102..alrm_cell_env_overT.0": "正常",
  "51102..alrm_cell_env_overT.1": "预警",
  "51102..alrm_cell_env_lowT.0": "正常",
  "51102..alrm_cell_env_lowT.1": "预警",
  "51102..alrm_cell_mos_overT.0": "正常",
  "51102..alrm_cell_mos_overT.1": "预警",
  "51102..alrm_cell_diffT_large.0": "正常",
  "51102..alrm_cell_diffT_large.1": "预警",
  "51102..alrm_eps_lowV.0": "正常",
  "51102..alrm_eps_lowV.1": "预警",
  "51102..alrm_eps_highV.0": "正常",
  "51102..alrm_eps_highV.1": "预警",
  "51102..alrm_eps_lowF.0": "正常",
  "51102..alrm_eps_lowF.1": "预警",
  "51102..alrm_eps_highF.0": "正常",
  "51102..alrm_eps_highF.1": "预警",
  "51102..alrm_eps_ac_overI.0": "正常",
  "51102..alrm_eps_ac_overI.1": "预警",
  "51102.warning.warn_grid_v_low.0": "正常",
  "51102.warning.warn_grid_v_low.1": "告警",
  "51102.warning.warn_grid_v_high.0": "正常",
  "51102.warning.warn_grid_v_high.1": "告警",
  "51102.warning.warn_grid_f_low.0": "正常",
  "51102.warning.warn_grid_f_low.1": "告警",
  "51102.warning.warn_grid_f_high.0": "正常",
  "51102.warning.warn_grid_f_high.1": "告警",
  "51102.warning.warn_grid_I_over.0": "正常",
  "51102.warning.warn_grid_I_over.1": "告警",
  "51102.warning.warn_PFC_bus_v_low.0": "正常",
  "51102.warning.warn_PFC_bus_v_low.1": "告警",
  "51102.warning.warn_U1_bus_v_low.0": "正常",
  "51102.warning.warn_U1_bus_v_low.1": "告警",
  "51102.warning.warn_U1_bus_v_high.0": "正常",
  "51102.warning.warn_U1_bus_v_high.1": "告警",
  "51102.warning.warn_U2_bus_v_low.0": "正常",
  "51102.warning.warn_U2_bus_v_low.1": "告警",
  "51102.warning.warn_U2_bus_v_high.0": "正常",
  "51102.warning.warn_U2_bus_v_high.1": "告警",
  "51102.warning.warn_o_inv_overLoad.0": "正常",
  "51102.warning.warn_o_inv_overLoad.1": "告警",
  "51102.warning.warn_o_byp_overLoad.0": "正常",
  "51102.warning.warn_o_byp_overLoad.1": "告警",
  "51102.warning.warn_PFC_inv_v.0": "正常",
  "51102.warning.warn_PFC_inv_v.1": "告警",
  "51102.warning.warn_PFC_inv_o_over_v.0": "正常",
  "51102.warning.warn_PFC_inv_o_over_v.1": "告警",
  "51102.warning.warn_PFC_inv_o_low_v.0": "正常",
  "51102.warning.warn_PFC_inv_o_low_v.1": "告警",
  "51102.warning.warn_PFC_inv_o_over_f.0": "正常",
  "51102.warning.warn_PFC_inv_o_over_f.1": "告警",
  "51102.warning.warn_PFC_inv_o_low_f.0": "正常",
  "51102.warning.warn_PFC_inv_o_low_f.1": "告警",
  "51102.warning.warn_PLL_grid_pll.0": "正常",
  "51102.warning.warn_PLL_grid_pll.1": "告警",
  "51102.warning.warn_PLL_parellet_pll.0": "正常",
  "51102.warning.warn_PLL_parellet_pll.1": "告警",
  "51102.warning.warn_T1_overT.0": "正常",
  "51102.warning.warn_T1_overT.1": "告警",
  "51102.warning.warn_T2_overT.0": "正常",
  "51102.warning.warn_T2_overT.1": "告警",
  "51102.warning.warn_byp_overT.0": "正常",
  "51102.warning.warn_byp_overT.1": "告警",
  "51102.warning.warn_chg_lowV.0": "正常",
  "51102.warning.warn_chg_lowV.1": "告警",
  "51102.warning.warn_chg_highV.0": "正常",
  "51102.warning.warn_chg_highV.1": "告警",
  "51102.warning.warn_dischg_battV.0": "正常",
  "51102.warning.warn_dischg_battV.1": "告警",
  "51102.warning.warn_dischg_busV.0": "正常",
  "51102.warning.warn_dischg_busV.1": "告警",
  "51102.warning.warn_dischg_battOverV.0": "正常",
  "51102.warning.warn_dischg_battOverV.1": "告警",
  "51102.warning.warn_PV1_dc_lowV.0": "正常",
  "51102.warning.warn_PV1_dc_lowV.1": "告警",
  "51102.warning.warn_PV1_dc_highV.0": "正常",
  "51102.warning.warn_PV1_dc_highV.1": "告警",
  "51102.warning.warn_PV1_pv_input_lowV.0": "正常",
  "51102.warning.warn_PV1_pv_input_lowV.1": "告警",
  "51102.warning.warn_PV1_pv_input_overV.0": "正常",
  "51102.warning.warn_PV1_pv_input_overV.1": "告警",
  "51102.warning.warn_PV2_dc_lowV.0": "正常",
  "51102.warning.warn_PV2_dc_lowV.1": "告警",
  "51102.warning.warn_PV2_dc_highV.0": "正常",
  "51102.warning.warn_PV2_dc_highV.1": "告警",
  "51102.warning.warn_PV2_pv_input_lowV.0": "正常",
  "51102.warning.warn_PV2_pv_input_lowV.1": "告警",
  "51102.warning.warn_PV2_pv_input_overV.0": "正常",
  "51102.warning.warn_PV2_pv_input_overV.1": "告警",
  "51102.warning.warn_PV3_dc_lowV.0": "正常",
  "51102.warning.warn_PV3_dc_lowV.1": "告警",
  "51102.warning.warn_PV3_dc_highV.0": "正常",
  "51102.warning.warn_PV3_dc_highV.1": "告警",
  "51102.warning.warn_PV3_pv_input_lowV.0": "正常",
  "51102.warning.warn_PV3_pv_input_lowV.1": "告警",
  "51102.warning.warn_PV3_pv_input_overV.0": "正常",
  "51102.warning.warn_PV3_pv_input_overV.1": "告警",
  "51102.warning.warn_PV4_dc_lowV.0": "正常",
  "51102.warning.warn_PV4_dc_lowV.1": "告警",
  "51102.warning.warn_PV4_dc_highV.0": "正常",
  "51102.warning.warn_PV4_dc_highV.1": "告警",
  "51102.warning.warn_PV4_pv_input_lowV.0": "正常",
  "51102.warning.warn_PV4_pv_input_lowV.1": "告警",
  "51102.warning.warn_PV4_pv_input_overV.0": "正常",
  "51102.warning.warn_PV4_pv_input_overV.1": "告警",
  "51102.warning.warn_prllt1_f_mismatch.0": "正常",
  "51102.warning.warn_prllt1_f_mismatch.1": "告警",
  "51102.warning.warn_prllt2_avg_I.0": "正常",
  "51102.warning.warn_prllt2_avg_I.1": "告警",
  "51102.warning.warn_cell1_grp_avgV_high.0": "正常",
  "51102.warning.warn_cell1_grp_avgV_high.1": "告警",
  "51102.warning.warn_cell1_overV.0": "正常",
  "51102.warning.warn_cell1_overV.1": "告警",
  "51102.warning.warn_cell1_grp_avgV_low.0": "正常",
  "51102.warning.warn_cell1_grp_avgV_low.1": "告警",
  "51102.warning.warn_cell1_lowV.0": "正常",
  "51102.warning.warn_cell1_lowV.1": "告警",
  "51102.warning.warn_cell2_chgOverISlowChck.0": "正常",
  "51102.warning.warn_cell2_chgOverISlowChck.1": "告警",
  "51102.warning.warn_cell2_dischgOverISlowChck.0": "正常",
  "51102.warning.warn_cell2_dischgOverISlowChck.1": "告警",
  "51102.warning.warn_cellT_L1_overT_chg.0": "正常",
  "51102.warning.warn_cellT_L1_overT_chg.1": "告警",
  "51102.warning.warn_cellT_L2_overT_chg.0": "正常",
  "51102.warning.warn_cellT_L2_overT_chg.1": "告警",
  "51102.warning.warn_cellT_L1_lowT_chg.0": "正常",
  "51102.warning.warn_cellT_L1_lowT_chg.1": "告警",
  "51102.warning.warn_cellT_L2_lowT_chg.0": "正常",
  "51102.warning.warn_cellT_L2_lowT_chg.1": "告警",
  "51102.warning.warn_cellT_L1_overT_dischg.0": "正常",
  "51102.warning.warn_cellT_L1_overT_dischg.1": "告警",
  "51102.warning.warn_cellT_L2_overT_dischg.0": "正常",
  "51102.warning.warn_cellT_L2_overT_dischg.1": "告警",
  "51102.warning.warn_cellT_L1_lowT_dischg.0": "正常",
  "51102.warning.warn_cellT_L1_lowT_dischg.1": "告警",
  "51102.warning.warn_cellT_L2_lowT_dischg.0": "正常",
  "51102.warning.warn_cellT_L2_lowT_dischg.1": "告警",
  "51102.warning.warn_cellT_env_overT.0": "正常",
  "51102.warning.warn_cellT_env_overT.1": "告警",
  "51102.warning.warn_cellT_env_lowT.0": "正常",
  "51102.warning.warn_cellT_env_lowT.1": "告警",
  "51102.warning.warn_cellT_mos_overT.0": "正常",
  "51102.warning.warn_cellT_mos_overT.1": "告警",
  "51102.warning.warn_cellT_diffT_toolarge.0": "正常",
  "51102.warning.warn_cellT_diffT_toolarge.1": "告警",
  "51102.warning.warn_eps_lowV.0": "正常",
  "51102.warning.warn_eps_lowV.1": "告警",
  "51102.warning.warn_eps_highV.0": "正常",
  "51102.warning.warn_eps_highV.1": "告警",
  "51102.warning.warn_eps_lowF.0": "正常",
  "51102.warning.warn_eps_lowF.1": "告警",
  "51102.warning.warn_eps_highF.0": "正常",
  "51102.warning.warn_eps_highF.1": "告警",
  "51102.warning.warn_eps_i_overI.0": "正常",
  "51102.warning.warn_eps_i_overI.1": "告警",
  "51102.fault.fault_grid_summary.0": "正常",
  "51102.fault.fault_grid_summary.1": "故障",
  "51102.fault.fault_grid_Vabnormal.0": "正常",
  "51102.fault.fault_grid_Vabnormal.1": "故障",
  "51102.fault.fault_grid_Fabnormal.0": "正常",
  "51102.fault.fault_grid_Fabnormal.1": "故障",
  "51102.fault.fault_grid_lowV.0": "正常",
  "51102.fault.fault_grid_lowV.1": "故障",
  "51102.fault.fault_grid_highV.0": "正常",
  "51102.fault.fault_grid_highV.1": "故障",
  "51102.fault.fault_grid_lowF.0": "正常",
  "51102.fault.fault_grid_lowF.1": "故障",
  "51102.fault.fault_grid_highF.0": "正常",
  "51102.fault.fault_grid_highF.1": "故障",
  "51102.fault.fault_grid_gridLost.0": "正常",
  "51102.fault.fault_grid_gridLost.1": "故障",
  "51102.fault.fault_grid_gridSurge.0": "正常",
  "51102.fault.fault_grid_gridSurge.1": "故障",
  "51102.fault.fault_grid_relayOpen.0": "正常",
  "51102.fault.fault_grid_relayOpen.1": "故障",
  "51102.fault.fault_grid_ac_i_overI.0": "正常",
  "51102.fault.fault_grid_ac_i_overI.1": "故障",
  "51102.fault.fault_PFC_summary.0": "正常",
  "51102.fault.fault_PFC_summary.1": "故障",
  "51102.fault.fault_PFC_hardSoftStrtup.0": "正常",
  "51102.fault.fault_PFC_hardSoftStrtup.1": "故障",
  "51102.fault.fault_PFC_softSoftStrtup.0": "正常",
  "51102.fault.fault_PFC_softSoftStrtup.1": "故障",
  "51102.fault.fault_PFC_bus_lowV.0": "正常",
  "51102.fault.fault_PFC_bus_lowV.1": "故障",
  "51102.fault.fault_PFC_intr_comm_lost.0": "正常",
  "51102.fault.fault_PFC_intr_comm_lost.1": "故障",
  "51102.fault.fault_PFC_extrnl_comm_lost.0": "正常",
  "51102.fault.fault_PFC_extrnl_comm_lost.1": "故障",
  "51102.fault.fault_U1bus_summary.0": "正常",
  "51102.fault.fault_U1bus_summary.1": "故障",
  "51102.fault.fault_U1bus_lowV_abnormal.0": "正常",
  "51102.fault.fault_U1bus_lowV_abnormal.1": "故障",
  "51102.fault.fault_U1bus_highV_abnormal.0": "正常",
  "51102.fault.fault_U1bus_highV_abnormal.1": "故障",
  "51102.fault.fault_U1bus_tooLowV.0": "正常",
  "51102.fault.fault_U1bus_tooLowV.1": "故障",
  "51102.fault.fault_U1bus_tooHighV.0": "正常",
  "51102.fault.fault_U1bus_tooHighV.1": "故障",
  "51102.fault.fault_U1bus_VtooHighFastChck.0": "正常",
  "51102.fault.fault_U1bus_VtooHighFastChck.1": "故障",
  "51102.fault.fault_U2bus_summary.0": "正常",
  "51102.fault.fault_U2bus_summary.1": "故障",
  "51102.fault.fault_U2bus_lowV_abnormal.0": "正常",
  "51102.fault.fault_U2bus_lowV_abnormal.1": "故障",
  "51102.fault.fault_U2bus_highV_abnormal.0": "正常",
  "51102.fault.fault_U2bus_highV_abnormal.1": "故障",
  "51102.fault.fault_U2bus_tooLowV.0": "正常",
  "51102.fault.fault_U2bus_tooLowV.1": "故障",
  "51102.fault.fault_U2bus_tooHighV.0": "正常",
  "51102.fault.fault_U2bus_tooHighV.1": "故障",
  "51102.fault.fault_U2bus_VtooHighFastChck.0": "正常",
  "51102.fault.fault_U2bus_VtooHighFastChck.1": "故障",
  "51102.fault.fault_o_summary.0": "正常",
  "51102.fault.fault_o_summary.1": "故障",
  "51102.fault.fault_o_invRalayOpen.0": "正常",
  "51102.fault.fault_o_invRalayOpen.1": "故障",
  "51102.fault.fault_o_invOverLoad.0": "正常",
  "51102.fault.fault_o_invOverLoad.1": "故障",
  "51102.fault.fault_o_bypOverLoad.0": "正常",
  "51102.fault.fault_o_bypOverLoad.1": "故障",
  "51102.fault.fault_inv_summary.0": "正常",
  "51102.fault.fault_inv_summary.1": "故障",
  "51102.fault.fault_inv_invFastChck.0": "正常",
  "51102.fault.fault_inv_invFastChck.1": "故障",
  "51102.fault.fault_inv_invSlowChck.0": "正常",
  "51102.fault.fault_inv_invSlowChck.1": "故障",
  "51102.fault.fault_inv_RelayStuck.0": "正常",
  "51102.fault.fault_inv_RelayStuck.1": "故障",
  "51102.fault.fault_inv_invShortCircuit.0": "正常",
  "51102.fault.fault_inv_invShortCircuit.1": "故障",
  "51102.fault.fault_inv_intrCommErr.0": "正常",
  "51102.fault.fault_inv_intrCommErr.1": "故障",
  "51102.fault.fault_inv_extCommErr.0": "正常",
  "51102.fault.fault_inv_extCommErr.1": "故障",
  "51102.fault.fault_inv_invVabnormal.0": "正常",
  "51102.fault.fault_inv_invVabnormal.1": "故障",
  "51102.fault.fault_inv_outputOverVProtect.0": "正常",
  "51102.fault.fault_inv_outputOverVProtect.1": "故障",
  "51102.fault.fault_inv_outputLowVProtect.0": "正常",
  "51102.fault.fault_inv_outputLowVProtect.1": "故障",
  "51102.fault.fault_inv_outputOverFProtect.0": "正常",
  "51102.fault.fault_inv_outputOverFProtect.1": "故障",
  "51102.fault.fault_inv_outputlowFProtect.0": "正常",
  "51102.fault.fault_inv_outputlowFProtect.1": "故障",
  "51102.fault.fault_PLL_summary.0": "正常",
  "51102.fault.fault_PLL_summary.1": "故障",
  "51102.fault.fault_PLL_acMainPll.0": "正常",
  "51102.fault.fault_PLL_acMainPll.1": "故障",
  "51102.fault.fault_PLL_secondaryPllLocked.0": "正常",
  "51102.fault.fault_PLL_secondaryPllLocked.1": "故障",
  "51102.fault.fault_T_summary.0": "正常",
  "51102.fault.fault_T_summary.1": "故障",
  "51102.fault.fault_T_TtooHigh.0": "正常",
  "51102.fault.fault_T_TtooHigh.1": "故障",
  "51102.fault.fault_T_TmpPinDisconn.0": "正常",
  "51102.fault.fault_T_TmpPinDisconn.1": "故障",
  "51102.fault.fault_T2_summary.0": "正常",
  "51102.fault.fault_T2_summary.1": "故障",
  "51102.fault.fault_T2_TtooHigh.0": "正常",
  "51102.fault.fault_T2_TtooHigh.1": "故障",
  "51102.fault.fault_T2_TmpPinDisconn.0": "正常",
  "51102.fault.fault_T2_TmpPinDisconn.1": "故障",
  "51102.fault.fault_byp_summary.0": "正常",
  "51102.fault.fault_byp_summary.1": "故障",
  "51102.fault.fault_byp_Vabnormal.0": "正常",
  "51102.fault.fault_byp_Vabnormal.1": "故障",
  "51102.fault.fault_byp_Fabnormal.0": "正常",
  "51102.fault.fault_byp_Fabnormal.1": "故障",
  "51102.fault.fault_byp_VtooLow.0": "正常",
  "51102.fault.fault_byp_VtooLow.1": "故障",
  "51102.fault.fault_byp_VtooHigh.0": "正常",
  "51102.fault.fault_byp_VtooHigh.1": "故障",
  "51102.fault.fault_byp_FtooLow.0": "正常",
  "51102.fault.fault_byp_FtooLow.1": "故障",
  "51102.fault.fault_byp_FtooHigh.0": "正常",
  "51102.fault.fault_byp_FtooHigh.1": "故障",
  "51102.fault.fault_byp_bypShtdwn.0": "正常",
  "51102.fault.fault_byp_bypShtdwn.1": "故障",
  "51102.fault.fault_byp_bypInrush.0": "正常",
  "51102.fault.fault_byp_bypInrush.1": "故障",
  "51102.fault.fault_byp_intrCommErr.0": "正常",
  "51102.fault.fault_byp_intrCommErr.1": "故障",
  "51102.fault.fault_byp_extCommErr.0": "正常",
  "51102.fault.fault_byp_extCommErr.1": "故障",
  "51102.fault.fault_chg_summary.0": "正常",
  "51102.fault.fault_chg_summary.1": "故障",
  "51102.fault.fault_chg_lowV.0": "正常",
  "51102.fault.fault_chg_lowV.1": "故障",
  "51102.fault.fault_chg_HighV.0": "正常",
  "51102.fault.fault_chg_HighV.1": "故障",
  "51102.fault.fault_chg_OutputShortCircuit.0": "正常",
  "51102.fault.fault_chg_OutputShortCircuit.1": "故障",
  "51102.fault.fault_chg_softStrpup.0": "正常",
  "51102.fault.fault_chg_softStrpup.1": "故障",
  "51102.fault.fault_chg_busVAbnormal.0": "正常",
  "51102.fault.fault_chg_busVAbnormal.1": "故障",
  "51102.fault.fault_chg_oVTooLowFastChck.0": "正常",
  "51102.fault.fault_chg_oVTooLowFastChck.1": "故障",
  "51102.fault.fault_chg_oVTooHigh.0": "正常",
  "51102.fault.fault_chg_oVTooHigh.1": "故障",
  "51102.fault.fault_chg_oVTooHighFastChck.0": "正常",
  "51102.fault.fault_chg_oVTooHighFastChck.1": "故障",
  "51102.fault.fault_chg_acChgUnenough.0": "正常",
  "51102.fault.fault_chg_acChgUnenough.1": "故障",
  "51102.fault.fault_chg_intrCommErr.0": "正常",
  "51102.fault.fault_chg_intrCommErr.1": "故障",
  "51102.fault.fault_chg_outCommErr.0": "正常",
  "51102.fault.fault_chg_outCommErr.1": "故障",
  "51102.fault.fault_chg_extCommErr.0": "正常",
  "51102.fault.fault_chg_extCommErr.1": "故障",
  "51102.fault.fault_chg_bypSundenlyAddLoad.0": "正常",
  "51102.fault.fault_chg_bypSundenlyAddLoad.1": "故障",
  "51102.fault.fault_dischg_summary.0": "正常",
  "51102.fault.fault_dischg_summary.1": "故障",
  "51102.fault.fault_dischg_battLowV.0": "正常",
  "51102.fault.fault_dischg_battLowV.1": "故障",
  "51102.fault.fault_dischg_busLowV.0": "正常",
  "51102.fault.fault_dischg_busLowV.1": "故障",
  "51102.fault.fault_dischg_battHighV.0": "正常",
  "51102.fault.fault_dischg_battHighV.1": "故障",
  "51102.fault.fault_dischg_battTooHighV.0": "正常",
  "51102.fault.fault_dischg_battTooHighV.1": "故障",
  "51102.fault.fault_dischg_intrCommLost.0": "正常",
  "51102.fault.fault_dischg_intrCommLost.1": "故障",
  "51102.fault.fault_dischg_extrCommLost.0": "正常",
  "51102.fault.fault_dischg_extrCommLost.1": "故障",
  "51102.fault.fault_dischg_battVtooLow.0": "正常",
  "51102.fault.fault_dischg_battVtooLow.1": "故障",
  "51102.fault.fault_dischg_softStrpup.0": "正常",
  "51102.fault.fault_dischg_softStrpup.1": "故障",
  "51102.fault.fault_sys_dismatch.0": "正常",
  "51102.fault.fault_sys_dismatch.1": "故障",
  "51102.fault.fault_sys_intrCommLost.0": "正常",
  "51102.fault.fault_sys_intrCommLost.1": "故障",
  "51102.fault.fault_sys_extCommLost.0": "正常",
  "51102.fault.fault_sys_extCommLost.1": "故障",
  "51102.fault.fault_pcs_selfTest.0": "正常",
  "51102.fault.fault_pcs_selfTest.1": "故障",
  "51102.fault.fault_elctMeter_selfTest.0": "正常",
  "51102.fault.fault_elctMeter_selfTest.1": "故障",
  "51102.fault.fault_MOS_selfTest.0": "正常",
  "51102.fault.fault_MOS_selfTest.1": "故障",
  "51102.fault.fault_PV1_summary.0": "正常",
  "51102.fault.fault_PV1_summary.1": "故障",
  "51102.fault.fault_PV1_DCLowV.0": "正常",
  "51102.fault.fault_PV1_DCLowV.1": "故障",
  "51102.fault.fault_PV1_DCHighV.0": "正常",
  "51102.fault.fault_PV1_DCHighV.1": "故障",
  "51102.fault.fault_PV1_softStrpUp.0": "正常",
  "51102.fault.fault_PV1_softStrpUp.1": "故障",
  "51102.fault.fault_PV1_outpuShrtCircuit.0": "正常",
  "51102.fault.fault_PV1_outpuShrtCircuit.1": "故障",
  "51102.fault.fault_PV1_outpuShrtCircuitStrtup.0": "正常",
  "51102.fault.fault_PV1_outpuShrtCircuitStrtup.1": "故障",
  "51102.fault.fault_PV1_DCVTooHigh.0": "正常",
  "51102.fault.fault_PV1_DCVTooHigh.1": "故障",
  "51102.fault.fault_PV1_DCVTooHighFstChck.0": "正常",
  "51102.fault.fault_PV1_DCVTooHighFstChck.1": "故障",
  "51102.fault.fault_PV1_Vabnormal.0": "正常",
  "51102.fault.fault_PV1_Vabnormal.1": "故障",
  "51102.fault.fault_PV1_inCommLost.0": "正常",
  "51102.fault.fault_PV1_inCommLost.1": "故障",
  "51102.fault.fault_PV1_extCommLost.0": "正常",
  "51102.fault.fault_PV1_extCommLost.1": "故障",
  "51102.fault.fault_PV1_inputLowV.0": "正常",
  "51102.fault.fault_PV1_inputLowV.1": "故障",
  "51102.fault.fault_PV1_inputHighV.0": "正常",
  "51102.fault.fault_PV1_inputHighV.1": "故障",
  "51102.fault.fault_PV2_summary.0": "正常",
  "51102.fault.fault_PV2_summary.1": "故障",
  "51102.fault.fault_PV2_DCLowV.0": "正常",
  "51102.fault.fault_PV2_DCLowV.1": "故障",
  "51102.fault.fault_PV2_DCHighV.0": "正常",
  "51102.fault.fault_PV2_DCHighV.1": "故障",
  "51102.fault.fault_PV2_softStrpUp.0": "正常",
  "51102.fault.fault_PV2_softStrpUp.1": "故障",
  "51102.fault.fault_PV2_outpuShrtCircuit.0": "正常",
  "51102.fault.fault_PV2_outpuShrtCircuit.1": "故障",
  "51102.fault.fault_PV2_outpuShrtCircuitStrtup.0": "正常",
  "51102.fault.fault_PV2_outpuShrtCircuitStrtup.1": "故障",
  "51102.fault.fault_PV2_DCVTooHigh.0": "正常",
  "51102.fault.fault_PV2_DCVTooHigh.1": "故障",
  "51102.fault.fault_PV2_DCVTooHighFstChck.0": "正常",
  "51102.fault.fault_PV2_DCVTooHighFstChck.1": "故障",
  "51102.fault.fault_PV2_Vabnormal.0": "正常",
  "51102.fault.fault_PV2_Vabnormal.1": "故障",
  "51102.fault.fault_PV2_inCommLost.0": "正常",
  "51102.fault.fault_PV2_inCommLost.1": "故障",
  "51102.fault.fault_PV2_extCommLost.0": "正常",
  "51102.fault.fault_PV2_extCommLost.1": "故障",
  "51102.fault.fault_PV2_inputLowV.0": "正常",
  "51102.fault.fault_PV2_inputLowV.1": "故障",
  "51102.fault.fault_PV2_inputHighV.0": "正常",
  "51102.fault.fault_PV2_inputHighV.1": "故障",
  "51102.fault.fault_PV3_summary.0": "正常",
  "51102.fault.fault_PV3_summary.1": "故障",
  "51102.fault.fault_PV3_DCLowV.0": "正常",
  "51102.fault.fault_PV3_DCLowV.1": "故障",
  "51102.fault.fault_PV3_DCHighV.0": "正常",
  "51102.fault.fault_PV3_DCHighV.1": "故障",
  "51102.fault.fault_PV3_softStrpUp.0": "正常",
  "51102.fault.fault_PV3_softStrpUp.1": "故障",
  "51102.fault.fault_PV3_outpuShrtCircuit.0": "正常",
  "51102.fault.fault_PV3_outpuShrtCircuit.1": "故障",
  "51102.fault.fault_PV3_outpuShrtCircuitStrtup.0": "正常",
  "51102.fault.fault_PV3_outpuShrtCircuitStrtup.1": "故障",
  "51102.fault.fault_PV3_DCVTooHigh.0": "正常",
  "51102.fault.fault_PV3_DCVTooHigh.1": "故障",
  "51102.fault.fault_PV3_DCVTooHighFstChck.0": "正常",
  "51102.fault.fault_PV3_DCVTooHighFstChck.1": "故障",
  "51102.fault.fault_PV3_Vabnormal.0": "正常",
  "51102.fault.fault_PV3_Vabnormal.1": "故障",
  "51102.fault.fault_PV3_inCommLost.0": "正常",
  "51102.fault.fault_PV3_inCommLost.1": "故障",
  "51102.fault.fault_PV3_extCommLost.0": "正常",
  "51102.fault.fault_PV3_extCommLost.1": "故障",
  "51102.fault.fault_PV3_inputLowV.0": "正常",
  "51102.fault.fault_PV3_inputLowV.1": "故障",
  "51102.fault.fault_PV3_inputHighV.0": "正常",
  "51102.fault.fault_PV3_inputHighV.1": "故障",
  "51102.fault.fault_PV4_summary.0": "正常",
  "51102.fault.fault_PV4_summary.1": "故障",
  "51102.fault.fault_PV4_DCLowV.0": "正常",
  "51102.fault.fault_PV4_DCLowV.1": "故障",
  "51102.fault.fault_PV4_DCHighV.0": "正常",
  "51102.fault.fault_PV4_DCHighV.1": "故障",
  "51102.fault.fault_PV4_softStrpUp.0": "正常",
  "51102.fault.fault_PV4_softStrpUp.1": "故障",
  "51102.fault.fault_PV4_outpuShrtCircuit.0": "正常",
  "51102.fault.fault_PV4_outpuShrtCircuit.1": "故障",
  "51102.fault.fault_PV4_outpuShrtCircuitStrtup.0": "正常",
  "51102.fault.fault_PV4_outpuShrtCircuitStrtup.1": "故障",
  "51102.fault.fault_PV4_DCVTooHigh.0": "正常",
  "51102.fault.fault_PV4_DCVTooHigh.1": "故障",
  "51102.fault.fault_PV4_DCVTooHighFstChck.0": "正常",
  "51102.fault.fault_PV4_DCVTooHighFstChck.1": "故障",
  "51102.fault.fault_PV4_Vabnormal.0": "正常",
  "51102.fault.fault_PV4_Vabnormal.1": "故障",
  "51102.fault.fault_PV4_inCommLost.0": "正常",
  "51102.fault.fault_PV4_inCommLost.1": "故障",
  "51102.fault.fault_PV4_extCommLost.0": "正常",
  "51102.fault.fault_PV4_extCommLost.1": "故障",
  "51102.fault.fault_PV4_inputLowV.0": "正常",
  "51102.fault.fault_PV4_inputLowV.1": "故障",
  "51102.fault.fault_PV4_inputHighV.0": "正常",
  "51102.fault.fault_PV4_inputHighV.1": "故障",
  "51102.fault.fault_prllt_summary.0": "正常",
  "51102.fault.fault_prllt_summary.1": "故障",
  "51102.fault.fault_prllt_idConflict.0": "正常",
  "51102.fault.fault_prllt_idConflict.1": "故障",
  "51102.fault.fault_prllt_commErr.0": "正常",
  "51102.fault.fault_prllt_commErr.1": "故障",
  "51102.fault.fault_prllt_Fdismatch.0": "正常",
  "51102.fault.fault_prllt_Fdismatch.1": "故障",
  "51102.fault.fault_prllt_failure.0": "正常",
  "51102.fault.fault_prllt_failure.1": "故障",
  "51102.fault.fault_prllt2_summary.0": "正常",
  "51102.fault.fault_prllt2_summary.1": "故障",
  "51102.fault.fault_prllt2_avgI.0": "正常",
  "51102.fault.fault_prllt2_avgI.1": "故障",
  "51102.fault.fault_prllt2_FsyncSig.0": "正常",
  "51102.fault.fault_prllt2_FsyncSig.1": "故障",
  "51102.fault.fault_cell1_avgVHighProtect.0": "正常",
  "51102.fault.fault_cell1_avgVHighProtect.1": "故障",
  "51102.fault.fault_cell1_HighVProtect.0": "正常",
  "51102.fault.fault_cell1_HighVProtect.1": "故障",
  "51102.fault.fault_cell1_avgVlowProtect.0": "正常",
  "51102.fault.fault_cell1_avgVlowProtect.1": "故障",
  "51102.fault.fault_cell1_lowVProtect.0": "正常",
  "51102.fault.fault_cell1_lowVProtect.1": "故障",
  "51102.fault.fault_cell1_cellCntDismatch.0": "正常",
  "51102.fault.fault_cell1_cellCntDismatch.1": "故障",
  "51102.fault.fault_cell1_cellUnavail.0": "正常",
  "51102.fault.fault_cell1_cellUnavail.1": "故障",
  "51102.fault.fault_cell1_cellGrpDiffVtooLarge.0": "正常",
  "51102.fault.fault_cell1_cellGrpDiffVtooLarge.1": "故障",
  "51102.fault.fault_cell1_seriousHighVProtect.0": "正常",
  "51102.fault.fault_cell1_seriousHighVProtect.1": "故障",
  "51102.fault.fault_cell1_seriousLowVProtect.0": "正常",
  "51102.fault.fault_cell1_seriousLowVProtect.1": "故障",
  "51102.fault.fault_cell1_srsLowVPrtctShtdwn.0": "正常",
  "51102.fault.fault_cell1_srsLowVPrtctShtdwn.1": "故障",
  "51102.fault.fault_cell1_l1ChgStatus.0": "正常",
  "51102.fault.fault_cell1_l1ChgStatus.1": "故障",
  "51102.fault.fault_cell1_l2ChgStatus.0": "正常",
  "51102.fault.fault_cell1_l2ChgStatus.1": "故障",
  "51102.fault.fault_cell1_tooOverVProtect.0": "正常",
  "51102.fault.fault_cell1_tooOverVProtect.1": "故障",
  "51102.fault.fault_cell2_chgOverISlwChck.0": "正常",
  "51102.fault.fault_cell2_chgOverISlwChck.1": "故障",
  "51102.fault.fault_cell2_chgOverIFstChck.0": "正常",
  "51102.fault.fault_cell2_chgOverIFstChck.1": "故障",
  "51102.fault.fault_cell2_dischgOverISlwChck.0": "正常",
  "51102.fault.fault_cell2_dischgOverISlwChck.1": "故障",
  "51102.fault.fault_cell2_dischgOverIFstChck.0": "正常",
  "51102.fault.fault_cell2_dischgOverIFstChck.1": "故障",
  "51102.fault.fault_cell2_chgOverI.0": "正常",
  "51102.fault.fault_cell2_chgOverI.1": "故障",
  "51102.fault.fault_cell2_dischgOverI.0": "正常",
  "51102.fault.fault_cell2_dischgOverI.1": "故障",
  "51102.fault.fault_cellT_TmpSensorDisconn.0": "正常",
  "51102.fault.fault_cellT_TmpSensorDisconn.1": "故障",
  "51102.fault.fault_cellT_l1OverTChg.0": "正常",
  "51102.fault.fault_cellT_l1OverTChg.1": "故障",
  "51102.fault.fault_cellT_l2OverTChg.0": "正常",
  "51102.fault.fault_cellT_l2OverTChg.1": "故障",
  "51102.fault.fault_cellT_l1lowTChg.0": "正常",
  "51102.fault.fault_cellT_l1lowTChg.1": "故障",
  "51102.fault.fault_cellT_l2lowTChg.0": "正常",
  "51102.fault.fault_cellT_l2lowTChg.1": "故障",
  "51102.fault.fault_cellT_l1OverTdisChg.0": "正常",
  "51102.fault.fault_cellT_l1OverTdisChg.1": "故障",
  "51102.fault.fault_cellT_l2OverTdisChg.0": "正常",
  "51102.fault.fault_cellT_l2OverTdisChg.1": "故障",
  "51102.fault.fault_cellT_l1lowTdisChg.0": "正常",
  "51102.fault.fault_cellT_l1lowTdisChg.1": "故障",
  "51102.fault.fault_cellT_l2lowTdisChg.0": "正常",
  "51102.fault.fault_cellT_l2lowTdisChg.1": "故障",
  "51102.fault.fault_cellT_envOverT.0": "正常",
  "51102.fault.fault_cellT_envOverT.1": "故障",
  "51102.fault.fault_cellT_envlowT.0": "正常",
  "51102.fault.fault_cellT_envlowT.1": "故障",
  "51102.fault.fault_cellT_mosOverT.0": "正常",
  "51102.fault.fault_cellT_mosOverT.1": "故障",
  "51102.fault.fault_cellT_diffTtooHigh.0": "正常",
  "51102.fault.fault_cellT_diffTtooHigh.1": "故障",
  "51102.fault.fault_cellT_highVsideMosDisconn.0": "正常",
  "51102.fault.fault_cellT_highVsideMosDisconn.1": "故障",
  "51102.fault.fault_eps_summary.0": "正常",
  "51102.fault.fault_eps_summary.1": "故障",
  "51102.fault.fault_eps_Vabnormal.0": "正常",
  "51102.fault.fault_eps_Vabnormal.1": "故障",
  "51102.fault.fault_eps_Fabnormal.0": "正常",
  "51102.fault.fault_eps_Fabnormal.1": "故障",
  "51102.fault.fault_eps_VtooLow.0": "正常",
  "51102.fault.fault_eps_VtooLow.1": "故障",
  "51102.fault.fault_eps_VLow.0": "正常",
  "51102.fault.fault_eps_VLow.1": "故障",
  "51102.fault.fault_eps_VHigh.0": "正常",
  "51102.fault.fault_eps_VHigh.1": "故障",
  "51102.fault.fault_eps_Flow.0": "正常",
  "51102.fault.fault_eps_Flow.1": "故障",
  "51102.fault.fault_eps_FHigh.0": "正常",
  "51102.fault.fault_eps_FHigh.1": "故障",
  "51102.fault.fault_eps_acMainLost.0": "正常",
  "51102.fault.fault_eps_acMainLost.1": "故障",
  "51102.fault.fault_eps_inpuSurge.0": "正常",
  "51102.fault.fault_eps_inpuSurge.1": "故障",
  "51102.fault.fault_eps_relayOpenCircuit.0": "正常",
  "51102.fault.fault_eps_relayOpenCircuit.1": "故障",
  "51102.fault.fault_eps_inputOverI.0": "正常",
  "51102.fault.fault_eps_inputOverI.1": "故障",
  "51102.real_time.elct_meter1_phase_no.0": "单相",
  "51102.real_time.elct_meter1_phase_no.1": "A相",
  "51102.real_time.elct_meter1_phase_no.2": "B相",
  "51102.real_time.elct_meter1_phase_no.3": "C相",
  "51102.real_time.elct_meter1_online_status.0": "不在线",
  "51102.real_time.elct_meter1_online_status.1": "在线",
  "51102.real_time.elct_meter2_phase_no.0": "单相",
  "51102.real_time.elct_meter2_phase_no.1": "A相",
  "51102.real_time.elct_meter2_phase_no.2": "B相",
  "51102.real_time.elct_meter2_phase_no.3": "C相",
  "51102.real_time.elct_meter2_online_status.0": "不在线",
  "51102.real_time.elct_meter2_online_status.1": "在线",
  "51102.real_time.PV_total_P.desc": "源,数据分析_光伏",
  "51102.ctrl_WorkMode": "工作模式",
  "51102.Switch": "模式切换",
  "51102.ctrl_Remote_Reset": "远程重启",
  "51102.ctrl_Fault Trigger": "故障触发",
  "51102.Anti-Islanding": "防孤岛保护",
  "51102.ctrl_Inverter-control": "逆变器控制",
  "51102.Active": "有功功率控制",
  "51102.Reactive": "无功功率控制",
  "51102.ctrl_Safety Regulations": "并网标准",
  "51102.INV": "INV",
  "51102.BATreserved": "电池备电",
  "51102.fault": "故障信息",
  "51102.Feed-in Priority": "馈网优先",
  "51102.FRT": "频率穿越参数",
  "51102.TOU": "定时充放",
  "51102.Peak shaving": "分时电价",
  "51102.ReconnGrid": "并网重连参数",
  "51102.backflow": "防孤岛保护",
  "51102.Selfuse": "自发自用",
  "51102.warning": "告警信息",
  "51102.ctrl_Supersetting": "高级设置",
  "51102.VRT": "电压穿越参数",
  "51102.BMS": "BMS",
  "51102.real_time.数据分析_EPS侧负载.tag": "EPS侧负载",
  "51102.real_time.数据分析_电量统计.tag": "电量统计",
  "51102.real_time.数据分析_电网.tag": "电网",
  "51102.real_time.数据分析_EPS侧微逆.tag": "EPS侧微逆",
  "51102.real_time.数据分析_光伏.tag": "光伏",
  "51102.real_time.数据分析_(多机)电量统计.tag": "(多机)电量统计",
  "10001.quickset.note1": "1.自发自用模式：推荐设置为自发自用模式。此模式可最大限度地将光伏发电用于家庭用电或存储在电池中供家庭用电；2.馈网优先模式：在满足负载需求时，此模式可优先将电力输送至电网，适用于有向电网供电补贴的地区；3. Peaking-shaving模式：在设置自发自用或馈网优先模式后，若当地电网公司根据系统峰值用电量计费，客户还可选择电网削峰模式，以避免在电网连接点出现峰值用电功率。4.离网模式：此模式仅用于纯离网，不建议用于标准储能系统。请注意，如果在并网状态下启用此模式，机器的工作逻辑会混乱，并显示“离网”。5.优化收益：如果您需要在自发自用、馈网优先或Peak-shaving模式下手动控制电池的充放电时间，请使用优化收益功能，打开开关和设置时间点。这3种模式中的“允许电网充电”被打开或建议打开（如果关闭，逆变器将不会强制对电池充电，电池可能会进入睡眠状态）。",
  "10001.quickset.note2": "1.自发自用模式：建议设置为自发自用模式。这种模式可以最大限度地将光伏发电用于家庭电力，或将其储存在电池中用于家庭电力；2.馈网优先模式：该模式可以在满足负荷时优先向电网送电，用于有电网补贴的地区；\n3.Peak-shaving模式：在设置自发自用或馈网优先模式后，当当地电网公司根据系统的峰值用电量收取电价时，也可以选择电网调峰。客户可以选择这种调峰方式，以避免电网连接点的峰值功耗；4.离网模式：此模式仅用于纯离网，不建议用于标准存储系统。请注意，如果在并网状态下启用此模式，机器的工作逻辑将被混淆，并显示“离网”；5.优化收益：如果您需要在自发自用、馈网优先或Peak-shaving模式下手动控制电池的充放电时间，请使用优化收益功能，打开开关和设置时间点。这3种模式中的“允许电网充电”被打开或建议打开（如果关闭，逆变器将不会强制对电池充电，电池可能会进入睡眠状态）。",
  "10001.quickset.note3": "1.自发自用模式：建议设置为自发自用模式。这种模式可以最大限度地将光伏发电用于家庭电力，或将其储存在电池中用于家庭电力；2.馈网优先模式：该模式可以在满足负荷时优先向电网送电，用于有电网补贴的地区；3.离网模式：此模式仅用于纯离网，不建议用于标准存储系统。请注意，如果在并网状态下启用此模式，机器的工作逻辑将被混淆，并显示“离网”；4.优化收益：如果您需要在自发自用、馈网优先或Peak-shaving模式下手动控制电池的充放电时间，请使用优化收益功能，打开开关和设置时间点。这3种模式中的“允许电网充电”被打开或建议打开（如果关闭，逆变器将不会强制对电池充电，电池可能会进入睡眠状态）。",
  "chinaAreas.Shandong": "山东省",
  "country.China": "中国",
  "json.50901.workmode.timeSection": "时段",
  "business.role.admin": "工商业管理员",
  "business.role.common": "工商业角色",
  "json.device.dryWorking": "干节点设置",
  "50901.real_time.pvMeterConnectionStatus.0": "离线",
  "50901.real_time.pvMeterConnectionStatus.1": "在线",
  "deptType.business": "工商业",
  "51002.null.数据分析_实时监控_PV.tag": "实时监控_PV",
  "51002.real_time.Energy_PV1.desc": "powerGeneration",
  "51002.real_time.Energy_PV2.desc": "powerGeneration",
  "51002.real_time.Energy_PV3.desc": "powerGeneration",
  "51002.real_time.Energy_PV4.desc": "powerGeneration",
  "51002.real_time.gridTotalFrequency.desc": "gridTotalFrequency",
  "51002.real_time.inverterTemp.desc": "inverterTemp",
  "51002.real_time.pvPower.desc": "pvPower",
  "51002.real_time.stRelayoN.desc": "workStatus",
  "51002.real_time.workStatus.desc": "workStatus",
  "51002.real_time.数据分析_实时监控_GRID.tag": "实时监控_GRID",
  "51002.real_time.数据分析_实时监控_P.tag": "实时监控_P",
  "51002.real_time.数据分析_实时监控_PV.tag": "实时监控_PV",
  "51002.real_time.数据分析_实时监控_TP.tag": "实时监控_TP",
  "51002.warning.stAbnorm_Ris.desc": "workStatus",
  "51002.warning.stErrAccess_EEPROM.desc": "workStatus",
  "51002.warning.stErrOP_Relay.desc": "workStatus",
  "51002.warning.stHW_Fault.desc": "workStatus",
  "51002.warning.stOV_Fgrid.desc": "workStatus",
  "51002.warning.stOV_Temp.desc": "workStatus",
  "51002.warning.stOV_Vgrid.desc": "workStatus",
  "51002.warning.stPV1_OV.desc": "workStatus",
  "51002.warning.stPV1_UV.desc": "workStatus",
  "51002.warning.stPV2_OV.desc": "workStatus",
  "51002.warning.stPV2_UV.desc": "workStatus",
  "51002.warning.stPV3_OV.desc": "workStatus",
  "51002.warning.stPV3_UV.desc": "workStatus",
  "51002.warning.stPV4_OV.desc": "workStatus",
  "51002.warning.stPV4_UV.desc": "workStatus",
  "51002.warning.stUV_Fgrid.desc": "workStatus",
  "51002.warning.stUV_Vgrid.desc": "workStatus",
  "51002..gridtype.desc": "gridtype",
  "51002.ctrl_antireverse.enaPAVE_FEEDINLIMIT.0": "功能关",
  "51002.ctrl_antireverse.enaPAVE_FEEDINLIMIT.1": "功能开",
  "51002.ctrl_inverter.ena10mVs1Prot.0": "功能关",
  "51002.ctrl_inverter.ena10mVs1Prot.1": "功能开",
  "51002.ctrl_inverter.enaAPP_PWSET.0": "功能关",
  "51002.ctrl_inverter.enaAPP_PWSET.1": "功能开",
  "51002.ctrl_inverter.enaFgridShiftPowerAdj.0": "功能关",
  "51002.ctrl_inverter.enaFgridShiftPowerAdj.1": "功能开",
  "51002.ctrl_inverter.enaISORES_ABNORMPROT.0": "功能关",
  "51002.ctrl_inverter.enaISORES_ABNORMPROT.1": "功能开",
  "51002.ctrl_inverter.enaOVs1_powerdownadj.0": "功能关",
  "51002.ctrl_inverter.enaOVs1_powerdownadj.1": "功能开",
  "51002.ctrl_inverter.enaRestoretodefault.0": "功能关",
  "51002.ctrl_inverter.enaRestoretodefault.1": "功能开",
  "51002.ctrl_inverter.enaSysProtIF_selfCheck.0": "功能关",
  "51002.ctrl_inverter.enaSysProtIF_selfCheck.1": "功能开",
  "51002.real_time.stRelayoN.0": "断开",
  "51002.real_time.stRelayoN.1": "闭合",
  "51002.real_time.workStatus.0": "Power OFF",
  "51002.real_time.workStatus.1": "Power ON",
  "51002.warning.stAbnorm_Ris.0": "正常运行",
  "51002.warning.stAbnorm_Ris.1": "触发保护",
  "51002.warning.stErrAccess_EEPROM.0": "正常运行",
  "51002.warning.stErrAccess_EEPROM.1": "触发保护",
  "51002.warning.stErrOP_Relay.0": "正常运行",
  "51002.warning.stErrOP_Relay.1": "触发保护",
  "51002.warning.stHW_Fault.0": "正常运行",
  "51002.warning.stHW_Fault.1": "触发保护",
  "51002.warning.stOV_Fgrid.0": "正常运行",
  "51002.warning.stOV_Fgrid.1": "触发保护",
  "51002.warning.stOV_Temp.0": "正常运行",
  "51002.warning.stOV_Temp.1": "触发保护",
  "51002.warning.stOV_Vgrid.0": "正常运行",
  "51002.warning.stOV_Vgrid.1": "触发保护",
  "51002.warning.stPV1_OV.0": "-",
  "51002.warning.stPV1_OV.1": "触发保护",
  "51002.warning.stPV1_UV.0": "-",
  "51002.warning.stPV1_UV.1": "触发保护",
  "51002.warning.stPV2_OV.0": "-",
  "51002.warning.stPV2_OV.1": "触发保护",
  "51002.warning.stPV2_UV.0": "-",
  "51002.warning.stPV2_UV.1": "触发保护",
  "51002.warning.stPV3_OV.0": "-",
  "51002.warning.stPV3_OV.1": "触发保护",
  "51002.warning.stPV3_UV.0": "-",
  "51002.warning.stPV3_UV.1": "触发保护",
  "51002.warning.stPV4_OV.0": "-",
  "51002.warning.stPV4_OV.1": "触发保护",
  "51002.warning.stPV4_UV.0": "-",
  "51002.warning.stPV4_UV.1": "触发保护",
  "51002.warning.stUV_Fgrid.0": "正常运行",
  "51002.warning.stUV_Fgrid.1": "触发保护",
  "51002.warning.stUV_Vgrid.0": "正常运行",
  "51002.warning.stUV_Vgrid.1": "触发保护",
  "51002.ctrl_inverter.ena10mVs1Prot": "10分钟1级网侧电压均值过压保护使能",
  "51002.ctrl_inverter.enaINVTR.0": "关机",
  "51002.ctrl_inverter.enaINVTR.1": "开机",
  "51002.ctrl_inverter.enaOVTPWDN.0": "功能关",
  "51002.ctrl_inverter.enaOVTPWDN.1": "功能开",
  "51002.ctrl_inverter.enaSysProtIF_selfCheck": "系统保护接口自检功能开关",
  "51002.real_time.gridTotalFrequency": "总频率",
  "51002.real_time.inverterTemp": "逆变器温度",
  "51002.real_time.powerGeneration": "总发电量",
  "51002.real_time.pvPower": "光伏发电功率",
  "51002.real_time.workStatus": "运行状态",
  "51002.ctrl_inverter.enaFgridShiftPowerAdj": "频率偏移功率调节使能",
  "51002.ctrl_inverter.enaISORES_ABNORMPROT": "绝缘阻抗异常保护使能",
  "51002.ctrl_inverter.enaOVs1_powerdownadj": "一级过压降额使能",
  "51002.ctrl_inverter.enaOVTPWDN": "过温降额使能",
  "bw_param_ctrl_option_BackupMode": "备电模式",
  "bw_param_ctrl_option_ Feed-inPriorityMode": "馈网优先",
  "51102.real_time.p_acc_Grid_buy_energy": "并机下累计买电电量",
  "51102.real_time.p_acc_Grid_sell_energy": "并机下累计卖电电量",
  "50657.ctrl_param_config.CTPhaseSequenceSetting": "CT相序设置",
  "50657.ctrl_param_config.CTRatio": "CT变比",
  "50657.ctrl_param_config.CurrentReverseSetting": "电流反向设置",
  "50657.ctrl_param_config.CTPhaseSequenceSetting.16974336": "CT1:L1，CT2:L3，CT3:L2",
  "50657.ctrl_param_config.CTPhaseSequenceSetting.33751296": "CT1:L2，CT2:L3，CT3:L1",
  "50657.ctrl_param_config.CTPhaseSequenceSetting.16909056": "CT1:L1，CT2:L2，CT3:L3",
  "50657.ctrl_param_config.CTPhaseSequenceSetting.50462976": "CT1:L3，CT2:L2，CT3:L1",
  "50657.ctrl_param_config.CTPhaseSequenceSetting.33620736": "CT1:L2，CT2:L1，CT3:L3",
  "50657.ctrl_param_config.CTPhaseSequenceSetting.50397696": "CT1:L3，CT2:L1，CT3:L2",
  "50657.ctrl_param_config.CTPhaseSequenceSetting.0": "CT1:L1，CT2:L2，CT3:L3",
  "50657.ctrl_param_config.CurrentReverseSetting.0": "A正，B正，C正",
  "50657.ctrl_param_config.CurrentReverseSetting.1": "A反，B正，C正",
  "50657.ctrl_param_config.CurrentReverseSetting.2": "A正，B反，C正",
  "50657.ctrl_param_config.CurrentReverseSetting.3": "A反，B反，C正",
  "50657.ctrl_param_config.CurrentReverseSetting.4": "A正，B正，C反",
  "50657.ctrl_param_config.CurrentReverseSetting.5": "A反，B正，C反",
  "50657.ctrl_param_config.CurrentReverseSetting.6": "A正，B反，C反",
  "50657.ctrl_param_config.CurrentReverseSetting.7": "A反，B反，C反",
  "50657.ctrl_param_config": "控制",
  "60451.realtime_inv.ratedPower": "额定功率",
  "60451.realtime_inv.rdOffStatus": "读远程关机",
  "60451.realtime_inv.rdPowerSet": "读功率设置",
  "60451.realtime_inv.workStatus": "逆变器工作状态",
  "60451.realtime_inv.masterAlarmCode": "主告警码",
  "60451.realtime_inv.subAlarmCode": "子告警码",
  "60451.realtime_inv.masterFaultCode": "主故障码",
  "60451.realtime_inv.subFaultCode": "子故障码",
  "60451.realtime_inv.pbusVol": "PBUS电压",
  "60451.realtime_inv.nbusVol": "NBUS电压",
  "60451.realtime_inv.invRTemp": "INV模块R温度",
  "60451.realtime_inv.invSTemp": "INV模块S温度",
  "60451.realtime_inv.invTTemp": "INV模块T温度",
  "60451.realtime_inv.envTemp": "环境温度",
  "60451.realtime_inv.radiatorTemp": "散热器温度",
  "60451.realtime_inv.Edaily": "当天发电量",
  "60451.realtime_inv.powerGeneration": "总发电量",
  "60451.realtime_grid.Uab": "RS电网线电压",
  "60451.realtime_grid.Ubc": "ST电网线电压",
  "60451.realtime_grid.Uca": "TR电网线电压",
  "60451.realtime_grid.Ua": "R电网相电压",
  "60451.realtime_grid.Ub": "S电网相电压",
  "60451.realtime_grid.Uc": "T电网相电压",
  "60451.realtime_grid.Ia": "R相并网电流",
  "60451.realtime_grid.Ib": "S相并网电流",
  "60451.realtime_grid.Ic": "T相并网电流",
  "60451.realtime_grid.Fr": "RS电网频率",
  "60451.realtime_grid.P": "有功功率",
  "60451.realtime_grid.Q": "无功功率",
  "60451.realtime_grid.Pf": "功率因数",
  "60451.realtime_pv.Upv1": "PV1电压",
  "60451.realtime_pv.Ipv1": "PV1电流",
  "60451.realtime_pv.Ppv1": "PV1功率",
  "60451.realtime_pv.Upv2": "PV2电压",
  "60451.realtime_pv.Ipv2": "PV2电流",
  "60451.realtime_pv.Ppv2": "PV2功率",
  "60451.realtime_pv.Upv3": "PV3电压",
  "60451.realtime_pv.Ipv3": "PV3电流",
  "60451.realtime_pv.Ppv3": "PV3功率",
  "60451.realtime_pv.Upv4": "PV4电压",
  "60451.realtime_pv.Ipv4": "PV4电流",
  "60451.realtime_pv.Ppv4": "PV4功率",
  "60451.realtime_pv.Upv5": "PV5电压",
  "60451.realtime_pv.Ipv5": "PV5电流",
  "60451.realtime_pv.Ppv5": "PV5功率",
  "60451.realtime_pv.Upv6": "PV6电压",
  "60451.realtime_pv.Ipv6": "PV6电流",
  "60451.realtime_pv.Ppv6": "PV6功率",
  "60451.realtime_pv.Upv7": "PV7电压",
  "60451.realtime_pv.Ipv7": "PV7电流",
  "60451.realtime_pv.Ppv7": "PV7功率",
  "60451.realtime_pv.Upv8": "PV8电压",
  "60451.realtime_pv.Ipv8": "PV8电流",
  "60451.realtime_pv.Ppv8": "PV8功率",
  "60451.realtime_pv.Upv9": "PV9电压",
  "60451.realtime_pv.Ipv9": "PV9电流",
  "60451.realtime_pv.Ppv9": "PV9功率",
  "60451.realtime_pv.Upv10": "PV10电压",
  "60451.realtime_pv.Ipv10": "PV10电流",
  "60451.realtime_pv.Ppv10": "PV10功率",
  "60451.realtime_pv.Upv11": "PV11电压",
  "60451.realtime_pv.Ipv11": "PV11电流",
  "60451.realtime_pv.Ppv11": "PV11功率",
  "60451.realtime_pv.Upv12": "PV12电压",
  "60451.realtime_pv.Ipv12": "PV12电流",
  "60451.realtime_pv.Ppv12": "PV12功率",
  "60451.realtime_pv.Istr1": "组串1电流",
  "60451.realtime_pv.Istr2": "组串2电流",
  "60451.realtime_pv.Istr3": "组串3电流",
  "60451.realtime_pv.Istr4": "组串4电流",
  "60451.realtime_pv.Istr5": "组串5电流",
  "60451.realtime_pv.Istr6": "组串6电流",
  "60451.realtime_pv.Istr7": "组串7电流",
  "60451.realtime_pv.Istr8": "组串8电流",
  "60451.realtime_pv.Istr9": "组串9电流",
  "60451.realtime_pv.Istr10": "组串10电流",
  "60451.realtime_pv.Istr11": "组串11电流",
  "60451.realtime_pv.Istr12": "组串12电流",
  "60451.realtime_pv.Istr13": "组串13电流",
  "60451.realtime_pv.Istr14": "组串14电流",
  "60451.realtime_pv.Istr15": "组串15电流",
  "60451.realtime_pv.Istr16": "组串16电流",
  "60451.realtime_pv.Istr17": "组串17电流",
  "60451.realtime_pv.Istr18": "组串18电流",
  "60451.realtime_pv.Istr19": "组串19电流",
  "60451.realtime_pv.Istr20": "组串20电流",
  "60451.realtime_pv.Istr21": "组串21电流",
  "60451.realtime_pv.Istr22": "组串22电流",
  "60451.realtime_pv.Istr23": "组串23电流",
  "60451.realtime_pv.Istr24": "组串24电流",
  "60451.realtime_pv.pvPower": "光伏发电功率",
  "60451.realtime_pv.pv1Edaily": "PV1日发电量",
  "60451.realtime_pv.Umppt1": "MPPT1电压",
  "60451.realtime_pv.Imppt1": "MPPT1电流",
  "60451.realtime_pv.Pmppt1": "MPPT1功率",
  "60451.realtime_inv.comStatus": "通讯状态",
  "60451.control.powerSet": "有功功率设置",
  "60451.control.onoffSet": "远程开关机设置",
  "60451.realtime_pv.Umppt2": "MPPT2电压",
  "60451.realtime_pv.Umppt3": "MPPT3电压",
  "60451.realtime_pv.Umppt4": "MPPT4电压",
  "60451.realtime_pv.Umppt5": "MPPT5电压",
  "60451.realtime_pv.Umppt6": "MPPT6电压",
  "60451.realtime_pv.Umppt7": "MPPT7电压",
  "60451.realtime_pv.Umppt8": "MPPT8电压",
  "60451.realtime_pv.Umppt9": "MPPT9电压",
  "60451.realtime_pv.Umppt10": "MPPT10电压",
  "60451.realtime_pv.Umppt11": "MPPT11电压",
  "60451.realtime_pv.Umppt12": "MPPT12电压",
  "60451.realtime_pv.Umppt13": "MPPT13电压",
  "60451.realtime_pv.Umppt14": "MPPT14电压",
  "60451.realtime_pv.Umppt15": "MPPT15电压",
  "60451.realtime_pv.Umppt16": "MPPT16电压",
  "60451.realtime_pv.Umppt17": "MPPT17电压",
  "60451.realtime_pv.Umppt18": "MPPT18电压",
  "60451.realtime_pv.Umppt19": "MPPT19电压",
  "60451.realtime_pv.Umpptt20": "MPPT20电压",
  "60451.realtime_pv.Imppt2": "MPPT2电流",
  "60451.realtime_pv.Imppt3": "MPPT3电流",
  "60451.realtime_pv.Imppt4": "MPPT4电流",
  "60451.realtime_pv.Imppt5": "MPPT5电流",
  "60451.realtime_pv.Imppt6": "MPPT6电流",
  "60451.realtime_pv.Imppt7": "MPPT7电流",
  "60451.realtime_pv.Imppt8": "MPPT8电流",
  "60451.realtime_pv.Imppt9": "MPPT9电流",
  "60451.realtime_pv.Imppt10": "MPPT10电流",
  "60451.realtime_pv.Imppt11": "MPPT11电流",
  "60451.realtime_pv.Imppt12": "MPPT12电流",
  "60451.realtime_pv.Imppt13": "MPPT13电流",
  "60451.realtime_pv.Imppt14": "MPPT14电流",
  "60451.realtime_pv.Imppt15": "MPPT15电流",
  "60451.realtime_pv.Imppt16": "MPPT16电流",
  "60451.realtime_pv.Imppt17": "MPPT17电流",
  "60451.realtime_pv.Imppt18": "MPPT18电流",
  "60451.realtime_pv.Imppt19": "MPPT19电流",
  "60451.realtime_pv.Imppt20": "MPPT20电流",
  "60451.realtime_pv.Istr25": "组串25电流",
  "60451.realtime_pv.Istr26": "组串26电流",
  "60451.realtime_pv.Istr27": "组串27电流",
  "60451.realtime_pv.Istr28": "组串28电流",
  "60451.realtime_pv.Istr29": "组串29电流",
  "60451.realtime_pv.Istr30": "组串30电流",
  "60451.realtime_pv.Istr31": "组串31电流",
  "60451.realtime_pv.Istr32": "组串32电流",
  "60451.realtime_pv.Istr33": "组串33电流",
  "60451.realtime_pv.Istr34": "组串34电流",
  "60451.realtime_pv.Istr35": "组串35电流",
  "60451.realtime_pv.Istr36": "组串36电流",
  "60451.realtime_pv.Istr37": "组串37电流",
  "60451.realtime_pv.Istr38": "组串38电流",
  "60451.realtime_pv.Istr39": "组串39电流",
  "60451.realtime_pv.Istr40": "组串40电流",
  "60451.realtime_pv.Ustr1": "组串1电压",
  "60451.realtime_pv.Ustr2": "组串2电压",
  "60451.realtime_pv.Ustr3": "组串3电压",
  "60451.realtime_pv.Ustr4": "组串4电压",
  "60451.realtime_pv.Ustr5": "组串5电压",
  "60451.realtime_pv.Ustr6": "组串6电压",
  "60451.realtime_pv.Ustr7": "组串7电压",
  "60451.realtime_pv.Ustr8": "组串8电压",
  "60451.realtime_pv.Ustr9": "组串9电压",
  "60451.realtime_pv.Ustr10": "组串10电压",
  "60451.realtime_pv.Ustr11": "组串11电压",
  "60451.realtime_pv.Ustr12": "组串12电压",
  "60451.realtime_pv.Ustr13": "组串13电压",
  "60451.realtime_pv.Ustr14": "组串14电压",
  "60451.realtime_pv.Ustr15": "组串15电压",
  "60451.realtime_pv.Ustr16": "组串16电压",
  "60451.realtime_pv.Ustr17": "组串17电压",
  "60451.realtime_pv.Ustr18": "组串18电压",
  "60451.realtime_pv.Ustr19": "组串19电压",
  "60451.realtime_pv.Ustr20": "组串20电压",
  "60451.realtime_pv.Ustr21": "组串21电压",
  "60451.realtime_pv.Ustr22": "组串22电压",
  "60451.realtime_pv.Ustr23": "组串23电压",
  "60451.realtime_pv.Ustr24": "组串24电压",
  "60451.realtime_pv.Ustr25": "组串25电压",
  "60451.realtime_pv.Ustr26": "组串26电压",
  "60451.realtime_pv.Ustr27": "组串27电压",
  "60451.realtime_pv.Ustr28": "组串28电压",
  "60451.realtime_pv.Ustr29": "组串29电压",
  "60451.realtime_pv.Ustr30": "组串30电压",
  "60451.realtime_pv.Ustr31": "组串31电压",
  "60451.realtime_pv.Ustr32": "组串32电压",
  "60451.realtime_pv.Ustr33": "组串33电压",
  "60451.realtime_pv.Ustr34": "组串34电压",
  "60451.realtime_pv.Ustr35": "组串35电压",
  "60451.realtime_pv.Ustr36": "组串36电压",
  "60451.realtime_pv.Ustr37": "组串37电压",
  "60451.realtime_pv.Ustr38": "组串38电压",
  "60451.realtime_pv.Ustr39": "组串39电压",
  "60451.realtime_pv.Ustr40": "组串40电压",
  "60451.realtime_inv.Emonth": "当月发电量",
  "60451.realtime_inv.Eyear": "当年发电量",
  "60451.realtime_inv.Plimit": "限功率实际值",
  "60451.realtime_inv.Qreg": "无功调节实际值",
  "60451.realtime_grid.Ubus": "母线电压",
  "60451.realtime_inv.rdOffStatus.0": "关机",
  "60451.realtime_inv.rdOffStatus.1": "开机",
  "60451.realtime_inv.workStatus.0": "初始化",
  "60451.realtime_inv.workStatus.1": "运行",
  "60451.realtime_inv.workStatus.2": "停机",
  "60451.realtime_inv.workStatus.3": "检修",
  "60451.realtime_inv.workStatus.4": "待机",
  "60451.realtime_inv.workStatus.5": "离网",
  "60451.realtime_inv.workStatus.6": "旁路",
  "60451.realtime_inv.workStatus.7": "PID修复",
  "60451.realtime_inv.workStatus.8": "PID抑制",
  "60451.realtime_inv.workStatus.9": "除雪模式",
  "60451.realtime_inv.comStatus.0": "断开",
  "60451.realtime_inv.comStatus.1": "连接",
  "60451.realtime_inv": "系统",
  "60451.realtime_grid": "电网侧",
  "60451.realtime_pv": "直流侧",
  "60451.control": "控制",
  "60450.realtime_inv.ratedPower": "额定功率",
  "60450.realtime_inv.rdOffStatus": "读远程关机",
  "60450.realtime_inv.rdPowerSet": "读功率设置",
  "60450.realtime_inv.workStatus": "逆变器工作状态",
  "60450.realtime_inv.masterAlarmCode": "主告警码",
  "60450.realtime_inv.subAlarmCode": "子告警码",
  "60450.realtime_inv.masterFaultCode": "主故障码",
  "60450.realtime_inv.subFaultCode": "子故障码",
  "60450.realtime_inv.pbusVol": "PBUS电压",
  "60450.realtime_inv.nbusVol": "NBUS电压",
  "60450.realtime_inv.invRTemp": "INV模块R温度",
  "60450.realtime_inv.invSTemp": "INV模块S温度",
  "60450.realtime_inv.invTTemp": "INV模块T温度",
  "60450.realtime_inv.envTemp": "环境温度",
  "60450.realtime_inv.radiatorTemp": "散热器温度",
  "60450.realtime_inv.Edaily": "当天发电量",
  "60450.realtime_inv.powerGeneration": "总发电量",
  "60450.realtime_grid.Uab": "RS电网线电压",
  "60450.realtime_grid.Ubc": "ST电网线电压",
  "60450.realtime_grid.Uca": "TR电网线电压",
  "60450.realtime_grid.Ua": "R电网相电压",
  "60450.realtime_grid.Ub": "S电网相电压",
  "60450.realtime_grid.Uc": "T电网相电压",
  "60450.realtime_grid.Ia": "R相并网电流",
  "60450.realtime_grid.Ib": "S相并网电流",
  "60450.realtime_grid.Ic": "T相并网电流",
  "60450.realtime_grid.Fr": "RS电网频率",
  "60450.realtime_grid.P": "有功功率",
  "60450.realtime_grid.Q": "无功功率",
  "60450.realtime_grid.Pf": "功率因数",
  "60450.realtime_pv.Upv1": "PV1电压",
  "60450.realtime_pv.Ipv1": "PV1电流",
  "60450.realtime_pv.Ppv1": "PV1功率",
  "60450.realtime_pv.Upv2": "PV2电压",
  "60450.realtime_pv.Ipv2": "PV2电流",
  "60450.realtime_pv.Ppv2": "PV2功率",
  "60450.realtime_pv.Upv3": "PV3电压",
  "60450.realtime_pv.Ipv3": "PV3电流",
  "60450.realtime_pv.Ppv3": "PV3功率",
  "60450.realtime_pv.Upv4": "PV4电压",
  "60450.realtime_pv.Ipv4": "PV4电流",
  "60450.realtime_pv.Ppv4": "PV4功率",
  "60450.realtime_pv.Upv5": "PV5电压",
  "60450.realtime_pv.Ipv5": "PV5电流",
  "60450.realtime_pv.Ppv5": "PV5功率",
  "60450.realtime_pv.Upv6": "PV6电压",
  "60450.realtime_pv.Ipv6": "PV6电流",
  "60450.realtime_pv.Ppv6": "PV6功率",
  "60450.realtime_pv.Upv7": "PV7电压",
  "60450.realtime_pv.Ipv7": "PV7电流",
  "60450.realtime_pv.Ppv7": "PV7功率",
  "60450.realtime_pv.Upv8": "PV8电压",
  "60450.realtime_pv.Ipv8": "PV8电流",
  "60450.realtime_pv.Ppv8": "PV8功率",
  "60450.realtime_pv.Upv9": "PV9电压",
  "60450.realtime_pv.Ipv9": "PV9电流",
  "60450.realtime_pv.Ppv9": "PV9功率",
  "60450.realtime_pv.Upv10": "PV10电压",
  "60450.realtime_pv.Ipv10": "PV10电流",
  "60450.realtime_pv.Ppv10": "PV10功率",
  "60450.realtime_pv.Upv11": "PV11电压",
  "60450.realtime_pv.Ipv11": "PV11电流",
  "60450.realtime_pv.Ppv11": "PV11功率",
  "60450.realtime_pv.Upv12": "PV12电压",
  "60450.realtime_pv.Ipv12": "PV12电流",
  "60450.realtime_pv.Ppv12": "PV12功率",
  "60450.realtime_pv.Istr1": "组串1电流",
  "60450.realtime_pv.Istr2": "组串2电流",
  "60450.realtime_pv.Istr3": "组串3电流",
  "60450.realtime_pv.Istr4": "组串4电流",
  "60450.realtime_pv.Istr5": "组串5电流",
  "60450.realtime_pv.Istr6": "组串6电流",
  "60450.realtime_pv.Istr7": "组串7电流",
  "60450.realtime_pv.Istr8": "组串8电流",
  "60450.realtime_pv.Istr9": "组串9电流",
  "60450.realtime_pv.Istr10": "组串10电流",
  "60450.realtime_pv.Istr11": "组串11电流",
  "60450.realtime_pv.Istr12": "组串12电流",
  "60450.realtime_pv.Istr13": "组串13电流",
  "60450.realtime_pv.Istr14": "组串14电流",
  "60450.realtime_pv.Istr15": "组串15电流",
  "60450.realtime_pv.Istr16": "组串16电流",
  "60450.realtime_pv.Istr17": "组串17电流",
  "60450.realtime_pv.Istr18": "组串18电流",
  "60450.realtime_pv.Istr19": "组串19电流",
  "60450.realtime_pv.Istr20": "组串20电流",
  "60450.realtime_pv.Istr21": "组串21电流",
  "60450.realtime_pv.Istr22": "组串22电流",
  "60450.realtime_pv.Istr23": "组串23电流",
  "60450.realtime_pv.Istr24": "组串24电流",
  "60450.realtime_pv.pvPower": "光伏发电功率",
  "60450.realtime_pv.pv1Edaily": "PV1日发电量",
  "60450.realtime_pv.Umppt1": "MPPT1电压",
  "60450.realtime_pv.Imppt1": "MPPT1电流",
  "60450.realtime_pv.Pmppt1": "MPPT1功率",
  "60450.realtime_inv.comStatus": "通讯状态",
  "60450.control.powerSet": "有功功率设置",
  "60450.control.onoffSet": "远程开关机设置",
  "60450.realtime_pv.Umppt2": "MPPT2电压",
  "60450.realtime_pv.Umppt3": "MPPT3电压",
  "60450.realtime_pv.Umppt4": "MPPT4电压",
  "60450.realtime_pv.Umppt5": "MPPT5电压",
  "60450.realtime_pv.Umppt6": "MPPT6电压",
  "60450.realtime_pv.Umppt7": "MPPT7电压",
  "60450.realtime_pv.Umppt8": "MPPT8电压",
  "60450.realtime_pv.Umppt9": "MPPT9电压",
  "60450.realtime_pv.Umppt10": "MPPT10电压",
  "60450.realtime_pv.Umppt11": "MPPT11电压",
  "60450.realtime_pv.Umppt12": "MPPT12电压",
  "60450.realtime_pv.Umppt13": "MPPT13电压",
  "60450.realtime_pv.Umppt14": "MPPT14电压",
  "60450.realtime_pv.Umppt15": "MPPT15电压",
  "60450.realtime_pv.Umppt16": "MPPT16电压",
  "60450.realtime_pv.Umppt17": "MPPT17电压",
  "60450.realtime_pv.Umppt18": "MPPT18电压",
  "60450.realtime_pv.Umppt19": "MPPT19电压",
  "60450.realtime_pv.Umpptt20": "MPPT20电压",
  "60450.realtime_pv.Imppt2": "MPPT2电流",
  "60450.realtime_pv.Imppt3": "MPPT3电流",
  "60450.realtime_pv.Imppt4": "MPPT4电流",
  "60450.realtime_pv.Imppt5": "MPPT5电流",
  "60450.realtime_pv.Imppt6": "MPPT6电流",
  "60450.realtime_pv.Imppt7": "MPPT7电流",
  "60450.realtime_pv.Imppt8": "MPPT8电流",
  "60450.realtime_pv.Imppt9": "MPPT9电流",
  "60450.realtime_pv.Imppt10": "MPPT10电流",
  "60450.realtime_pv.Imppt11": "MPPT11电流",
  "60450.realtime_pv.Imppt12": "MPPT12电流",
  "60450.realtime_pv.Imppt13": "MPPT13电流",
  "60450.realtime_pv.Imppt14": "MPPT14电流",
  "60450.realtime_pv.Imppt15": "MPPT15电流",
  "60450.realtime_pv.Imppt16": "MPPT16电流",
  "60450.realtime_pv.Imppt17": "MPPT17电流",
  "60450.realtime_pv.Imppt18": "MPPT18电流",
  "60450.realtime_pv.Imppt19": "MPPT19电流",
  "60450.realtime_pv.Imppt20": "MPPT20电流",
  "60450.realtime_pv.Istr25": "组串25电流",
  "60450.realtime_pv.Istr26": "组串26电流",
  "60450.realtime_pv.Istr27": "组串27电流",
  "60450.realtime_pv.Istr28": "组串28电流",
  "60450.realtime_pv.Istr29": "组串29电流",
  "60450.realtime_pv.Istr30": "组串30电流",
  "60450.realtime_pv.Istr31": "组串31电流",
  "60450.realtime_pv.Istr32": "组串32电流",
  "60450.realtime_pv.Istr33": "组串33电流",
  "60450.realtime_pv.Istr34": "组串34电流",
  "60450.realtime_pv.Istr35": "组串35电流",
  "60450.realtime_pv.Istr36": "组串36电流",
  "60450.realtime_pv.Istr37": "组串37电流",
  "60450.realtime_pv.Istr38": "组串38电流",
  "60450.realtime_pv.Istr39": "组串39电流",
  "60450.realtime_pv.Istr40": "组串40电流",
  "60450.realtime_pv.Ustr1": "组串1电压",
  "60450.realtime_pv.Ustr2": "组串2电压",
  "60450.realtime_pv.Ustr3": "组串3电压",
  "60450.realtime_pv.Ustr4": "组串4电压",
  "60450.realtime_pv.Ustr5": "组串5电压",
  "60450.realtime_pv.Ustr6": "组串6电压",
  "60450.realtime_pv.Ustr7": "组串7电压",
  "60450.realtime_pv.Ustr8": "组串8电压",
  "60450.realtime_pv.Ustr9": "组串9电压",
  "60450.realtime_pv.Ustr10": "组串10电压",
  "60450.realtime_pv.Ustr11": "组串11电压",
  "60450.realtime_pv.Ustr12": "组串12电压",
  "60450.realtime_pv.Ustr13": "组串13电压",
  "60450.realtime_pv.Ustr14": "组串14电压",
  "60450.realtime_pv.Ustr15": "组串15电压",
  "60450.realtime_pv.Ustr16": "组串16电压",
  "60450.realtime_pv.Ustr17": "组串17电压",
  "60450.realtime_pv.Ustr18": "组串18电压",
  "60450.realtime_pv.Ustr19": "组串19电压",
  "60450.realtime_pv.Ustr20": "组串20电压",
  "60450.realtime_pv.Ustr21": "组串21电压",
  "60450.realtime_pv.Ustr22": "组串22电压",
  "60450.realtime_pv.Ustr23": "组串23电压",
  "60450.realtime_pv.Ustr24": "组串24电压",
  "60450.realtime_pv.Ustr25": "组串25电压",
  "60450.realtime_pv.Ustr26": "组串26电压",
  "60450.realtime_pv.Ustr27": "组串27电压",
  "60450.realtime_pv.Ustr28": "组串28电压",
  "60450.realtime_pv.Ustr29": "组串29电压",
  "60450.realtime_pv.Ustr30": "组串30电压",
  "60450.realtime_pv.Ustr31": "组串31电压",
  "60450.realtime_pv.Ustr32": "组串32电压",
  "60450.realtime_pv.Ustr33": "组串33电压",
  "60450.realtime_pv.Ustr34": "组串34电压",
  "60450.realtime_pv.Ustr35": "组串35电压",
  "60450.realtime_pv.Ustr36": "组串36电压",
  "60450.realtime_pv.Ustr37": "组串37电压",
  "60450.realtime_pv.Ustr38": "组串38电压",
  "60450.realtime_pv.Ustr39": "组串39电压",
  "60450.realtime_pv.Ustr40": "组串40电压",
  "60450.realtime_inv.Emonth": "当月发电量",
  "60450.realtime_inv.Eyear": "当年发电量",
  "60450.realtime_inv.Plimit": "限功率实际值",
  "60450.realtime_inv.Qreg": "无功调节实际值",
  "60450.realtime_grid.Ubus": "母线电压",
  "60450.realtime_inv.rdOffStatus.0": "关机",
  "60450.realtime_inv.rdOffStatus.1": "开机",
  "60450.realtime_inv.workStatus.0": "初始化",
  "60450.realtime_inv.workStatus.1": "等待",
  "60450.realtime_inv.workStatus.2": "并网",
  "60450.realtime_inv.workStatus.3": "故障",
  "60450.realtime_inv.workStatus.4": "烧录",
  "60450.realtime_inv.workStatus.5": "离网",
  "60450.realtime_inv.workStatus.6": "旁路",
  "60450.realtime_inv.workStatus.7": "PID修复",
  "60450.realtime_inv.workStatus.8": "PID抑制",
  "60450.realtime_inv.workStatus.9": "除雪模式",
  "60450.realtime_inv.comStatus.0": "断开",
  "60450.realtime_inv.comStatus.1": "连接",
  "60450.realtime_inv": "系统",
  "60450.realtime_grid": "电网侧",
  "60450.realtime_pv": "直流侧",
  "60450.control": "控制",
  "50661.hess.hFTAE": "关口电表正向总有功电能",
  "50661.ems.PT": "电压变比PT",
  "50661.bms.csv": "充电停止单体电压值",
  "50661.bms.ascv": "平均单体电压",
  "50661.bms.lscv": "最低电压",
  "50661.bms.lsct": "最低温度",
  "50661.bms.asct": "平均单体温度",
  "50661.bms.phscvn": "最高单体电压簇号",
  "50661.bms.hpsctd": "最大温度差簇号",
  "50661.ems.Pa": "A相有功总功率",
  "50661.ems.Pb": "B相有功总功率",
  "50661.bms.scc": "电池可充电量",
  "50661.ems.Pc": "C相有功总功率",
  "50661.pcs.apc": "A相电流",
  "50661.bms.mgn": "最高簇总压簇号",
  "50661.ems.Pf": "总功率因数",
  "50661.aac.reftca": "制冷温控回差",
  "50661.bms.discsv": "放电停止单体电压值",
  "50661.bms.bmulscvn": "最低单体电压BMU号",
  "50661.hess.pacd": "需量值上报",
  "50661.ems.workmode": "工作模式",
  "50661.hess.demand": "需量值设置",
  "50661.hess.hsoc": "系统SOC",
  "50661.ems.Qa": "A相无功总功率",
  "50661.ems.Qb": "B相无功总功率",
  "50661.ems.Qc": "C相无功总功率",
  "50661.bms.sdc": "电池可放电量",
  "50661.lcs.wtch": "水温加热点",
  "50661.hess.hdezo": "免调功率",
  "50661.lcs.ehrg": "电加热运行",
  "50661.hess.hpcsstate": "系统运行状态",
  "50661.bms.bmuhsctn": "最高单体温度BMU号",
  "50661.lcs.Icesw": "液冷水泵开关",
  "50661.lcs.wtcp": "水温制冷点",
  "50661.hess.hcrtae": "交流侧系统累计放电量",
  "50661.ems.RAPE": "反向峰有功电能",
  "50661.bms.plscvn": "最低单体电压簇号",
  "50661.hess.htcl": "交流侧系统今日充电量",
  "50661.hess.hRAFE": "关口电表反向平有功电能",
  "50661.ems.scc2": "二充电量",
  "50661.pcs.modpf": "功率因数",
  "50661.pcs.otapp": "输出总视在功率",
  "50661.ems.P": "总有功功率",
  "50661.ems.Q": "总无功功率",
  "50661.bms.bct": "电池单体温度",
  "50661.ems.S": "总视在功率",
  "50661.lcs.lcet": "液冷环境温度",
  "50661.bms.npir": "负极绝缘电阻",
  "50661.hess.hRAVE": "关口电表反向谷有功电能",
  "50661.hess.reconpower": "远程功率",
  "50661.deh.dhstatus1": "除湿状态",
  "50661.ems.FADE": "正向深谷有功电能",
  "50661.bms.mnsbcu": "最低极柱温度SBCU号",
  "50661.fire.h": "氢气",
  "50661.hess.hdsp": "放电阈值",
  "50661.ems.cpuremain": "CPU剩余",
  "50661.fire.co": "一氧化碳",
  "50661.ems.FASE": "正向有功尖电能",
  "50661.ems.Sa": "A相视在功率",
  "50661.ems.Sb": "B相视在功率",
  "50661.ems.Sc": "C相视在功率",
  "50661.ems.CT": "电流变比CT",
  "50661.aac.aircom": "空调运行模式",
  "50661.lcs.lcerstate": "液冷请求运行",
  "50661.pcs.apov": "A相电压",
  "50661.bms.dc": "直流电流",
  "50661.lcs.acc": "冷机通讯",
  "50661.ems.protmode": "保护模式",
  "50661.ems.sccc": "机柜累计已充电量",
  "50661.ems.cinp": "机柜装机功率",
  "50661.hess.hRADE": "关口电表反向深谷有功电能",
  "50661.bms.maxadiscc": "放电最大允许电流",
  "50661.bms.hscvd": "簇最大单体压差值",
  "50661.ems.FAVE": "正向谷有功电能",
  "50661.bms.ccrv": "充电降流单体电压值",
  "50661.bms.dp": "直流功率",
  "50661.aac.heattca": "制热温控回差",
  "50661.bms.hsct": "最高温度",
  "50661.bms.hscv": "最高电压",
  "50661.bms.dv": "直流电压",
  "50661.pcs.modaf": "PCS频率",
  "50661.deh.dhworkmode1": "除湿机工作状态",
  "50661.ems.FAFE": "正向平有功电能",
  "50661.lcs.hrd": "加热回差",
  "50661.pcs.bpov": "B相电压",
  "50661.bms.hscvn": "最高单体电压编号",
  "50661.hess.hotrp": "系统输出总无功功率",
  "50661.aac.exhaustt1": "排气温度",
  "50661.deh.dhalarm1": "除湿机告警状态",
  "50661.hess.htdcldc": "直流侧系统今日放电量",
  "50661.ems.Ua": "A相电压",
  "50661.ems.Ub": "B相电压",
  "50661.hess.htdcl": "交流侧系统今日放电量",
  "50661.ems.Uc": "C相电压",
  "50661.ems.sncode": "设备SN号",
  "50661.bms.mxsbmu": "最高极柱温度SBMU号",
  "50661.hess.sfstatus": "系统故障状态",
  "50661.ems.cinc": "机柜装机容量",
  "50661.ems.emc": "电表通讯",
  "50661.aac.refsett1": "制冷设定温度",
  "50661.bms.hsctd": "簇最大温度差值",
  "50661.hess.hFAVE": "关口电表正向谷有功电能",
  "50661.bms.scvd": "压差",
  "50661.bms.cscv": "电池单体电压",
  "50661.bms.alld": "BMS堆累计放电电量",
  "50661.bms.allc": "BMS堆累计充电量",
  "50661.hess.hotap": "系统输出总有功功率",
  "50661.ems.RADE": "反向深谷有功电能",
  "50661.pcs.otrp": "输出总无功功率",
  "50661.hess.hscdc": "直流侧系统累计放电量",
  "50661.hess.hmpot": "变压器最大功率\n(变压器实际的最大功率)",
  "50661.bms.hsctn": "最高单体温度编号",
  "50661.pcs.otap": "输出总有功功率",
  "50661.ems.RASE": "反向尖有功电能",
  "50661.hess.hP": "关口电表有功功率",
  "50661.hess.hQ": "关口电表无功功率",
  "50661.hess.hS": "关口电表视在功率",
  "50661.ems.Fr": "频率",
  "50661.bms.mxseq": "最高极柱温度序号",
  "50661.lcs.lcett": "设定制冷目标温度",
  "50661.ems.tdcl": "今日放电电量",
  "50661.pcs.pcsgcd": "PCS离并网状态",
  "50661.ems.daily96read": "15分钟抄表数据",
  "50661.bms.sctd": "温差",
  "50661.hess.hRASE": "关口电表反向尖有功电能",
  "50661.hess.hsccc": "直流侧系统累计充电量",
  "50661.hess.hFAFE": "关口电表正向平有功电能",
  "50661.ems.scdc": "机柜累计已放电量",
  "50661.ems.mpot": "变压器最大功率",
  "50661.pcs.aclv": "交流CA线电压",
  "50661.lcs.iwp": "进水压力",
  "50661.pcs.pcsdc": "直流电流",
  "50661.ems.RAFE": "反向平有功电能",
  "50661.ems.Pfa": "A相功率因数",
  "50661.ems.Pfc": "C相功率因数",
  "50661.ems.Pfb": "B相功率因数",
  "50661.ems.lpvn": "本地程序版本号",
  "50661.ems.occ": "一充电量",
  "50661.lcs.lceowt": "液冷出水温度",
  "50661.bms.lsctn": "最低单体温度编号",
  "50661.bms.maxacc": "充电最大允许电流",
  "50661.hess.hRAPE": "关口电表反向峰有功电能",
  "50661.bms.mnsbmu": "最低极柱温度SBMU号",
  "50661.bms.ppir": "正极绝缘电阻",
  "50661.pcs.igbtat": "IGBT-A温度",
  "50661.bms.msgv": "最大簇SOC值",
  "50661.pcs.pcsdv": "直流电压",
  "50661.bms.mnseq": "最低极柱温度序号",
  "50661.hess.hpcsrps": "系统无功功率设置",
  "50661.ems.sdiscc": "二放电量",
  "50661.bms.mcgv": "最高簇总压",
  "50661.ems.Uab": "AB线电压",
  "50661.ems.Ia": "A相电流",
  "50661.ems.RAVE": "反向谷有功电能",
  "50661.ems.Ib": "B相电流",
  "50661.ems.Ic": "C相电流",
  "50661.pcs.cpov": "C相电压",
  "50661.deh.ahdate": "环境湿度值",
  "50661.aac.outsidet": "柜外温度",
  "50661.aac.heatsettl": "制热设定温度",
  "50661.hess.hFADE": "关口电表正向深谷有功电能",
  "50661.ems.lmonoff": "关口电表有无设置",
  "50661.bms.msgn": "最大簇SOC簇号",
  "50661.ems.odiscc": "一放电量",
  "50661.pcs.igbtbt": "IGBT-B温度",
  "50661.pcs.ablv": "交流BC线电压",
  "50661.ems.FTAE": "正向总有功电能",
  "50661.bms.lscvn": "最低单体电压编号",
  "50661.ems.metersn": "柜内表sn",
  "50661.ems.Ubc": "BC线电压",
  "50661.ems.dezo": "免调功率",
  "50661.pcs.igbtct": "IGBT-C温度",
  "50661.hess.hFASE": "关口电表正向尖有功电能",
  "50661.lcs.lcestate": "液冷运行状态",
  "50661.hess.hworkmode": "工作模式",
  "50661.ems.Uca": "CA线电压",
  "50661.pcs.igbtt": "IGBT温度",
  "50661.hess.hotapp": "系统输出总视在功率",
  "50661.ems.lmct": "关口电表变比",
  "50661.ems.comStatus": "通讯状态",
  "50661.bms.plsctn": "最低单体温度簇号",
  "50661.hess.hFAPE": "关口电表正向峰有功电能",
  "50661.pcs.pcssapr": "PCS设置有功功率",
  "50661.deh.environmentt": "环境温度值",
  "50661.ems.soc": "SOC",
  "50661.pcs.aalv": "交流AB线电压",
  "50661.bms.bsccc": "电池累计已充电量",
  "50661.lcs.owp": "出水压力",
  "50661.bms.msn": "最小簇SOC簇号",
  "50661.hess.hcpdae": "交流侧系统累计充电量",
  "50661.ems.soh": "SOH",
  "50661.hess.h96SlotSchedule": "96点策略",
  "50661.bms.mclv": "最低簇总压",
  "50661.aac.cabineth": "柜内湿度",
  "50661.hess.haaotop": "变压器过载保护提前量",
  "50661.pcs.cpc": "C相电流",
  "50661.bms.mcn": "最低簇总压簇号",
  "50661.aac.cabinett": "柜内温度",
  "50661.pcs.pcst": "PCS温度",
  "50661.bms.bscdc": "电池累计已放电量",
  "50661.bms.disccrv": "放电降流单体电压值",
  "50661.hess.hRTAE": "关口电表反向总有功电能",
  "50661.bms.mxval": "最高极柱温度值",
  "50661.lcs.lcerwt": "液冷回水温度",
  "50661.pcs.pcssrpr": "PCS设置无功功率",
  "50661.ems.aaotop": "变压器过载保护提前量",
  "50661.pcs.pcsc": "PCS通讯",
  "50661.hess.htcldc": "直流侧系统今日充电量",
  "50661.hess.shutdown": "储能是否停机",
  "50661.ems.dsp": "放电阈值",
  "50661.ems.RTAE": "反向总有功电能",
  "50661.ems.cstatus": "机柜故障状态",
  "50661.bms.singlec": "BMS堆单次充电电量",
  "50661.bms.bsoh": "bmsSOH",
  "50661.bms.singled": "BMS堆单次放电电量",
  "50661.ems.memremain": "内存剩余",
  "50661.bms.bsoc": "bmsSOC",
  "50661.bms.phsctn": "最高单体温度簇号",
  "50661.ems.FAPE": "正向峰有功电能",
  "50661.pcs.dcp": "直流功率",
  "50661.bms.mnval": "最低极柱温度值",
  "50661.lcs.crd": "制冷回差",
  "50661.pcs.bpc": "B相电流",
  "50661.lcs.crg": "压缩机运行",
  "50661.bms.mvd": "最大总压差",
  "50661.ems.tcl": "今日充电电量",
  "50661.bms.msnv": "最小簇SOC值",
  "50661.bms.hpscvd": "簇最大单体压差簇号",
  "50661.hess.toumeterread": "0点尖峰平⾕抄表",
  "50661.hess.hloadap": "负载有功功率",
  "50661.fire.temp": "温度",
  "50661.hess.hpcsaps": "系统有功功率设置",
  "50661.deh.dehumidifier24": "湿模块手动自动状态",
  "50661.pcs.pcsstate": "PCS运行状态",
  "50661.pcs.pcsws": "PCS警告状态",
  "50661.bms.bmulsctn": "最低单体温度BMU号",
  "50661.pcs.pcsfs": "PCS故障状态",
  "50661.ems.esmct": "储能电表变比",
  "50661.bms.bmsc": "BMS通讯",
  "50661.bms.bmuhscvn": "最高单体电压BMU号",
  "50661.bms.sdcnum": "充放电次数",
  "50661.bms.mxsbcu": "最高极柱温度SBCU号",
  "50661.ems.workmode.0": "计划模式",
  "50661.ems.workmode.1": "手动模式",
  "50661.ems.workmode.2": "远程模式",
  "50661.hess.hpcsstate.1": "待机",
  "50661.hess.hpcsstate.2": "充电",
  "50661.hess.hpcsstate.3": "放电",
  "50661.aac.aircom.0": "待机",
  "50661.aac.aircom.1": "制冷",
  "50661.aac.aircom.2": "制热",
  "50661.aac.aircom.3": "新风",
  "50661.aac.aircom.4": "送风",
  "50661.aac.aircom.5": "除湿",
  "50661.aac.aircom.6": "通风",
  "50661.aac.aircom.7": "自动",
  "50661.aac.aircom.8": "关机",
  "50661.ems.protmode.0": "防逆流防过载启动",
  "50661.ems.protmode.1": "防逆流启动",
  "50661.ems.protmode.2": "防过载启动",
  "50661.ems.protmode.3": "防逆流防过载关闭",
  "50661.hess.sfstatus.0": "正常",
  "50661.hess.sfstatus.1": "故障",
  "50661.pcs.pcsgcd.0": "并网",
  "50661.pcs.pcsgcd.1": "离网",
  "50661.lcs.lcestate.0": "待机",
  "50661.lcs.lcestate.1": "自循环",
  "50661.lcs.lcestate.2": "制冷",
  "50661.lcs.lcestate.3": "制热",
  "50661.lcs.lcestate.4": "自动控制",
  "50661.lcs.lcestate.5": "关机",
  "50661.lcs.lcestate.6": "水泵循环",
  "50661.hess.hworkmode.0": "计划模式",
  "50661.hess.hworkmode.1": "手动模式",
  "50661.hess.hworkmode.2": "远程模式",
  "50661.ems.comStatus.00": "断开",
  "50661.ems.comStatus.01": "连接",
  "50661.hess.shutdown.0": "不停机",
  "50661.hess.shutdown.1": "停机",
  "50661.ems.cstatus.0": "正常",
  "50661.ems.cstatus.1": "故障",
  "50661.deh.dehumidifier24.0": "自动",
  "50661.deh.dehumidifier24.1": "手动",
  "50661.pcs.pcsstate.1": "待机",
  "50661.pcs.pcsstate.2": "充电",
  "50661.pcs.pcsstate.3": "放电",
  "50661.pcs.pcsws.0": "正常",
  "50661.pcs.pcsws.1": "告警",
  "50661.pcs.pcsfs.0": "正常",
  "50661.pcs.pcsfs.1": "故障",
  "50661.pcs": "PCS",
  "50661.aac": "空调",
  "50661.deh": "除湿机",
  "50661.bms": "BMS",
  "50661.fire": "消防",
  "50661.ems": "机柜",
  "50661.hess": "系统",
  "50661.lcs": "液冷",
  "bw_param_ctrl_note_DispatchActivepower": "将此数据设置为正数表示需要放电，而将其设置为负数表示需要充电",
  "bw_param_ctrl_option_Forcedcharginganddischarging": "强制充放电",
  "bw_param_ctrl_option_GridUseCT&PVUseMeter": "电网使用CT、光伏使用电表",
  "bw_param_ctrl_option_GridUseMeter&PVUseCT": "电网使用电表、光伏使用CT",
  "bw_param_ctrl_option_DisableTimePeriodControl": "禁用时间段控制",
  "bw_param_ctrl_option_OnlyEnableChargeTimeperiodcontrol": "只启用充电时间段控制",
  "bw_RTparam_name_TotalApparentPower_Grid": "电表视在功率（总）",
  "bw_param_ctrl_name_FactoryReset ": "   \n初始化系统",
  "bw_param_ctrl_option_FactoryReset ": "重启",
  "bw_param_ctrl_note_DSPReset": "重启DSP：当故障信息与实际情况不一致时，可以通过重新启动DsP来恢复。例如，如果APP遇到接地线丢失的故障，但连接到逆变器的接地线没有断开，可以通过重新启动DSP来恢复。",
  "bw_param_ctrl_note_EMSReset": "重启EMS：当数据采集异常时，请重置EMS以恢复系统。",
  "bw_param_ctrl_note_FactoryReset": "初始化系统：如果要将逆变器的所有参数设置为默认值，可以使用此功能。",
  "bw_param_ctrl_option_Grid&PVuseCT": "电网和光伏使用CT",
  "bw_param_outage_soc_setting": "断电 soc 设置",
  "supplier.type.nky": "能控云",
  "50657.real_time.PhaseACurrent": "A相电流",
  "50657.real_time.PhaseCActivePower": "C相有功功率",
  "50657.real_time.PhaseCCurrent": "C相电流",
  "50657.real_time.PhaseCReverseEnergy": "C相反向电量",
  "50657.real_time.PhaseBCurrent": "B相电流",
  "50657.real_time.PhaseBReverseEnergy": "B相反向电量",
  "50657.real_time.PhaseBTotalEnergy": "B相总电量",
  "50657.real_time.PhaseCPowerFactor": "C相功率因素",
  "50657.real_time.PhaseAReverseEnergy": "A相反向电量",
  "50657.real_time.PhaseAPowerFactor": "A相功率因素",
  "50657.real_time.TotalApparentPower": "总视在功率",
  "50657.real_time.TotalEnergy": "总电量",
  "50657.real_time.TotalActivePower": "总有功功率",
  "50657.real_time.PhaseBActivePower": "B相有功功率",
  "50657.real_time.PhaseAVoltage": "A相电压",
  "50657.real_time.PhaseCTotalEnergy": "C相总电量",
  "50657.real_time.PhaseCApparentPower": "C相视在功率",
  "50657.real_time.TotalReactivePower": "总无功功率",
  "50657.real_time.PhaseAActivePower": "A相有功功率",
  "50657.real_time.PhaseBApparentPower": "B相视在功率",
  "50657.real_time.PhaseBVoltage": "B相电压",
  "50657.real_time.PhaseCVoltage": "C相电压",
  "50657.real_time.TotalForwardEnergy": "总正向电量",
  "50657.real_time.PhaseAReactivePower": "A相无功功率",
  "50657.real_time.TotalReverseEnergy": "总反向电量",
  "50657.real_time.PhaseCForwardEnergy": "C相正向电量",
  "50657.real_time.PhaseCReactivePower": "C相无功功率",
  "50657.real_time.PhaseBReactivePower": "B相无功功率",
  "50657.real_time.PhaseAApparentPower": "A相视在功率",
  "50657.real_time.Frequency": "频率",
  "50657.real_time.PhaseAForwardEnergy": "A相正向电量",
  "50657.real_time.PhaseATotalEnergy": "A相总电量值",
  "50657.real_time.PhaseBForwardEnergy": "B相正向电量",
  "50657.real_time.PhaseBPowerFactor": "B相功率因素",
  "50657.real_time.Version": "电表固件版本号",
  "50657.real_time": "实时监控",
  "51104.smartplug.smartplug_SN": "智能插座SN",
  "51104.smartplug.smartplug_soft_series": "智能插座软件编号",
  "51104.smartplug.smartplug_soft_ver": "智能插座软件版本",
  "51104.smartplug.smartplug_hard_ver": "智能插座硬件版本",
  "51104.smartplug.smartplug_V": "智能插座电压",
  "51104.smartplug.smartplug_I": "智能插座电流",
  "51104.smartplug.smartplug_F": "智能插座频率",
  "51104.smartplug.smartplug_P": "智能插座有功功率",
  "51104.smartplug.smartplug_switch_status": "智能插座开关状态",
  "51104.s\\collector.otaHttpUrl": "升级包url",
  "51104.smartplug.smartplug_switch_status.0": "关闭",
  "51104.smartplug.smartplug_switch_status.1": "开启",
  "51104.s\\collector": "采集器",
  "51104.smartplug": "插座数据",
  "Yes": "是",
  "No": "否",
  "shipment.No": "否",
  "shipment.Yes": "是",
  "the.netherlands": "The Netherlands",
  "netherland.areas": "The Netherlands",
  "60451.realtime_pv.dcPower": "总直流功率",
  "60451.realtime_inv.agciFaultTimes": "AGCI故障次数",
  "60451.realtime_inv.pidRunStatus": "PID工作状态",
  "60451.realtime_inv.pidAlarmCode": "PID告警码",
  "60451.realtime_grid.totalApparentPower": "总视在功率",
  "60451.realtime_inv.inverterEfficiency": "逆变器效率",
  "60451.realtime_inv.totalEnergyHighRes": "总发电量(高精度)",
  "60451.realtime_inv.powerLimitSwitch": "限功率开关",
  "60451.realtime_inv.powerLimitPercent": "限功率百分比",
  "60451.realtime_inv.rdOffStatus.206": "关机",
  "60451.realtime_inv.rdOffStatus.207": "开机",
  "50661.ems.daily96read1": "15分钟抄表数据",
  "50661.ems.scc": "二充电量",
  "50661.bms1.allc1": "BMS堆累计充电量",
  "50661.bms1.plscvn1": "最低单体电压簇号",
  "50661.bms1.alld1": "BMS堆累计放电电量",
  "50661.bms1.hpsctd1": "最大温度差簇号",
  "50661.bms1.bmulscvn1": "最低单体电压BMU号",
  "50661.bms1.singlec1": "BMS堆单次充电电量",
  "50661.bms1.scvd1": "压差",
  "50661.bms1.hscvd1": "簇最大单体压差值",
  "50661.bms1.mnsbcu1": "最低极柱温度SBCU号",
  "50661.bms1.ppir1": "正极绝缘电阻",
  "50661.bms1.bmuhscvn1": "最高单体电压BMU号",
  "50661.bms1.mnseq1": "最低极柱温度序号",
  "50661.bms1.mgn1": "最高簇总压簇号",
  "50661.bms1.singled1": "BMS堆单次放电电量",
  "50661.bms1.mclv1": "最低簇总压",
  "50661.bms1.hscv1": "最高电压",
  "50661.bms1.lsct1": "最低温度",
  "50661.bms1.maxadiscc1": "放电最大允许电流",
  "50661.bms1.bmulsctn1": "最低单体温度BMU号",
  "50661.bms1.bmuhsctn1": "最高单体温度BMU号",
  "50661.bms1.lscv1": "最低电压",
  "50661.bms1.hsct1": "最高温度",
  "50661.bms1.phsctn1": "最高单体温度簇号",
  "50661.bms1.ascv1": "平均单体电压",
  "50661.bms1.dp1": "直流功率",
  "50661.bms1.mxsbmu1": "最高极柱温度SBMU号",
  "50661.bms1.maxacc1": "充电最大允许电流",
  "50661.bms1.npir1": "负极绝缘电阻",
  "50661.bms1.lsctn1": "最低单体温度编号",
  "50661.bms1.phscvn1": "最高单体电压簇号",
  "50661.bms1.mxval1": "最高极柱温度值",
  "50661.bms1.msn1": "最小簇SOC簇号",
  "50661.bms1.bscdc1": "电池累计已放电量",
  "50661.bms1.mcn1": "最低簇总压簇号",
  "50661.bms1.hpscvd1": "簇最大单体压差簇号",
  "50661.bms1.dv1": "直流电压",
  "50661.bms1.mcgv1": "最高簇总压",
  "50661.bms1.bsccc1": "电池累计已充电量",
  "50661.bms1.asct1": "平均单体温度",
  "50661.bms1.mnsbmu1": "最低极柱温度SBMU号",
  "50661.bms1.sctd1": "温差",
  "50661.bms1.lscvn1": "最低单体电压编号",
  "50661.bms1.cscv1": "电池单体电压",
  "50661.bms1.sdc1": "电池可放电量",
  "50661.bms1.bct1": "电池单体温度",
  "50661.bms1.mnval1": "最低极柱温度值",
  "50661.bms1.bsoh1": "bmsSOH",
  "50661.bms1.bmsc1": "BMS通讯",
  "50661.bms1.msnv1": "最小簇SOC值",
  "50661.bms1.scc1": "电池可充电量",
  "50661.bms1.disccrv1": "放电降流单体电压值",
  "50661.bms1.hsctn1": "最高单体温度编号",
  "50661.bms1.csv1": "充电停止单体电压值",
  "50661.bms1.msgn1": "最大簇SOC簇号",
  "50661.bms1.mxseq1": "最高极柱温度序号",
  "50661.bms1.sdcnum1": "充放电次数",
  "50661.bms1.hscvn1": "最高单体电压编号",
  "50661.bms1.bsoc1": "bmsSOC",
  "50661.bms1.mvd1": "最大总压差",
  "50661.bms1.msgv1": "最大簇SOC值",
  "50661.bms1.dc1": "直流电流",
  "50661.bms1.plsctn1": "最低单体温度簇号",
  "50661.bms1.ccrv1": "充电降流单体电压值",
  "50661.bms1.mxsbcu1": "最高极柱温度SBCU号",
  "50661.bms1.discsv1": "放电停止单体电压值",
  "50661.bms1.hsctd1": "簇最大温度差值",
  "50661.bms1.mcstatus1": "电池簇1主回路状态",
  "50661.bms1.chginhibit1": "电池簇1禁止充电",
  "50661.bms1.dischginhibit1": "电池簇1禁止放电",
  "50661.bms1.rlystatus1": "电池簇1继电器状态",
  "50661.bms1.swstatus1": "电池簇1开关量状态",
  "50661.bms1.almstatus1": "电池簇1告警状态",
  "50661.bms1.1bcu1fault1": "电池簇1BCU一级报警故障码1",
  "50661.bms1.1bcu2fault1": "电池簇1BCU二级报警故障码1",
  "50661.bms1.1bcu3fault1": "电池簇1BCU三级报警故障码1",
  "50661.bms1.1bcu1fault2": "电池簇1BCU一级报警故障码2",
  "50661.bms1.1bcu2fault2": "电池簇1BCU二级报警故障码2",
  "50661.bms1.1bcu3fault2": "电池簇1BCU三级报警故障码2",
  "50661.bms1.1bcu1fault3": "电池簇1BCU一级报警故障码3",
  "50661.bms1.1bcu2fault3": "电池簇1BCU二级报警故障码3",
  "50661.bms1.1bcu3fault3": "电池簇1BCU三级报警故障码3",
  "50661.bms1.1bcu1fault4": "电池簇1BCU一级报警故障码4",
  "50661.bms1.1bcu2fault4": "电池簇1BCU二级报警故障码4",
  "50661.bms1.1bcu3fault4": "电池簇1BCU三级报警故障码4",
  "50661.bms2.allc2": "BMS堆累计充电量",
  "50661.bms2.alld2": "BMS堆累计放电电量",
  "50661.bms2.plscvn2": "最低单体电压簇号",
  "50661.bms2.hpsctd2": "最大温度差簇号",
  "50661.bms2.bmulscvn2": "最低单体电压BMU号",
  "50661.bms2.singlec2": "BMS堆单次充电电量",
  "50661.bms2.mnsbcu2": "最低极柱温度SBCU号",
  "50661.bms2.scvd2": "压差",
  "50661.bms2.hscvd2": "簇最大单体压差值",
  "50661.bms2.ppir2": "正极绝缘电阻",
  "50661.bms2.bmuhscvn2": "最高单体电压BMU号",
  "50661.bms2.mnseq2": "最低极柱温度序号",
  "50661.bms2.mgn2": "最高簇总压簇号",
  "50661.bms2.mclv2": "最低簇总压",
  "50661.bms2.singled2": "BMS堆单次放电电量",
  "50661.bms2.hscv2": "最高电压",
  "50661.bms2.bmulsctn2": "最低单体温度BMU号",
  "50661.bms2.lsct2": "最低温度",
  "50661.bms2.maxadiscc2": "放电最大允许电流",
  "50661.bms2.phsctn2": "最高单体温度簇号",
  "50661.bms2.bmuhsctn2": "最高单体温度BMU号",
  "50661.bms2.hsct2": "最高温度",
  "50661.bms2.lscv2": "最低电压",
  "50661.bms2.ascv2": "平均单体电压",
  "50661.bms2.dp2": "直流功率",
  "50661.bms2.mxsbmu2": "最高极柱温度SBMU号",
  "50661.bms2.maxacc2": "充电最大允许电流",
  "50661.bms2.npir2": "负极绝缘电阻",
  "50661.bms2.lsctn2": "最低单体温度编号",
  "50661.bms2.phscvn2": "最高单体电压簇号",
  "50661.bms2.mxval2": "最高极柱温度值",
  "50661.bms2.msn2": "最小簇SOC簇号",
  "50661.bms2.bscdc2": "电池累计已放电量",
  "50661.bms2.mcn2": "最低簇总压簇号",
  "50661.bms2.hpscvd2": "簇最大单体压差簇号",
  "50661.bms2.bsccc2": "电池累计已充电量",
  "50661.bms2.dv2": "直流电压",
  "50661.bms2.mcgv2": "最高簇总压",
  "50661.bms2.asct2": "平均单体温度",
  "50661.bms2.mnsbmu2": "最低极柱温度SBMU号",
  "50661.bms2.lscvn2": "最低单体电压编号",
  "50661.bms2.sctd2": "温差",
  "50661.bms2.disccrv2": "放电降流单体电压值",
  "50661.bms2.cscv2": "电池单体电压",
  "50661.bms2.bct2": "电池单体温度",
  "50661.bms2.bsoh2": "bmsSOH",
  "50661.bms2.mnval2": "最低极柱温度值",
  "50661.bms2.bmsc2": "BMS通讯",
  "50661.bms2.msnv2": "最小簇SOC值",
  "50661.bms2.sdc2": "电池可放电量",
  "50661.bms2.hsctn2": "最高单体温度编号",
  "50661.bms2.csv2": "充电停止单体电压值",
  "50661.bms2.msgn2": "最大簇SOC簇号",
  "50661.bms2.mxseq2": "最高极柱温度序号",
  "50661.bms2.sdcnum2": "充放电次数",
  "50661.bms2.hscvn2": "最高单体电压编号",
  "50661.bms2.bsoc2": "bmsSOC",
  "50661.bms2.mvd2": "最大总压差",
  "50661.bms2.msgv2": "最大簇SOC值",
  "50661.bms2.dc2": "直流电流",
  "50661.bms2.plsctn2": "最低单体温度簇号",
  "50661.bms2.ccrv2": "充电降流单体电压值",
  "50661.bms2.mxsbcu2": "最高极柱温度SBCU号",
  "50661.bms2.discsv2": "放电停止单体电压值",
  "50661.bms2.hsctd2": "簇最大温度差值",
  "50661.bms2.scc2": "电池可充电量",
  "50661.bms2.mcstatus2": "电池簇2主回路状态",
  "50661.bms2.chginhibit2": "电池簇2禁止充电",
  "50661.bms2.dischginhibit2": "电池簇2禁止放电",
  "50661.bms2.rlystatus2": "电池簇2继电器状态",
  "50661.bms2.swstatus2": "电池簇2开关量状态",
  "50661.bms2.almstatus2": "电池簇2告警状态",
  "50661.bms2.2bcu1fault1": "电池簇2BCU一级报警故障码1",
  "50661.bms2.2bcu2fault1": "电池簇2BCU二级报警故障码1",
  "50661.bms2.2bcu3fault1": "电池簇2BCU三级报警故障码1",
  "50661.bms2.2bcu1fault2": "电池簇2BCU一级报警故障码2",
  "50661.bms2.2bcu2fault2": "电池簇2BCU二级报警故障码2",
  "50661.bms2.2bcu3fault2": "电池簇2BCU三级报警故障码2",
  "50661.bms2.2bcu1fault3": "电池簇2BCU一级报警故障码3",
  "50661.bms2.2bcu2fault3": "电池簇2BCU二级报警故障码3",
  "50661.bms2.2bcu3fault3": "电池簇2BCU三级报警故障码3",
  "50661.bms2.2bcu1fault4": "电池簇2BCU一级报警故障码4",
  "50661.bms2.2bcu2fault4": "电池簇2BCU二级报警故障码4",
  "50661.bms2.2bcu3fault4": "电池簇2BCU三级报警故障码4",
  "50661.bms3.allc3": "BMS堆累计充电量",
  "50661.bms3.plscvn3": "最低单体电压簇号",
  "50661.bms3.alld3": "BMS堆累计放电电量",
  "50661.bms3.hpsctd3": "最大温度差簇号",
  "50661.bms3.singlec3": "BMS堆单次充电电量",
  "50661.bms3.bmulscvn3": "最低单体电压BMU号",
  "50661.bms3.mnsbcu3": "最低极柱温度SBCU号",
  "50661.bms3.ppir3": "正极绝缘电阻",
  "50661.bms3.scvd3": "压差",
  "50661.bms3.hscvd3": "簇最大单体压差值",
  "50661.bms3.bmuhscvn3": "最高单体电压BMU号",
  "50661.bms3.mnseq3": "最低极柱温度序号",
  "50661.bms3.mgn3": "最高簇总压簇号",
  "50661.bms3.mclv3": "最低簇总压",
  "50661.bms3.singled3": "BMS堆单次放电电量",
  "50661.bms3.hscv3": "最高电压",
  "50661.bms3.lsct3": "最低温度",
  "50661.bms3.maxadiscc3": "放电最大允许电流",
  "50661.bms3.bmulsctn3": "最低单体温度BMU号",
  "50661.bms3.phsctn3": "最高单体温度簇号",
  "50661.bms3.bmuhsctn3": "最高单体温度BMU号",
  "50661.bms3.hsct3": "最高温度",
  "50661.bms3.lscv3": "最低电压",
  "50661.bms3.ascv3": "平均单体电压",
  "50661.bms3.dp3": "直流功率",
  "50661.bms3.mxsbmu3": "最高极柱温度SBMU号",
  "50661.bms3.maxacc3": "充电最大允许电流",
  "50661.bms3.npir3": "负极绝缘电阻",
  "50661.bms3.lsctn3": "最低单体温度编号",
  "50661.bms3.phscvn3": "最高单体电压簇号",
  "50661.bms3.mxval3": "最高极柱温度值",
  "50661.bms3.msn3": "最小簇SOC簇号",
  "50661.bms3.bscdc3": "电池累计已放电量",
  "50661.bms3.mcn3": "最低簇总压簇号",
  "50661.bms3.hpscvd3": "簇最大单体压差簇号",
  "50661.bms3.bsccc3": "电池累计已充电量",
  "50661.bms3.mcgv3": "最高簇总压",
  "50661.bms3.dv3": "直流电压",
  "50661.bms3.mnsbmu3": "最低极柱温度SBMU号",
  "50661.bms3.sctd3": "温差",
  "50661.bms3.lscvn3": "最低单体电压编号",
  "50661.bms3.asct3": "平均单体温度",
  "50661.bms3.disccrv3": "放电降流单体电压值",
  "50661.bms3.bsoh3": "bmsSOH",
  "50661.bms3.mnval3": "最低极柱温度值",
  "50661.bms3.cscv3": "电池单体电压",
  "50661.bms3.bmsc3": "BMS通讯",
  "50661.bms3.msnv3": "最小簇SOC值",
  "50661.bms3.bct3": "电池单体温度",
  "50661.bms3.sdc3": "电池可放电量",
  "50661.bms3.scc3": "电池可充电量",
  "50661.bms3.hsctn3": "最高单体温度编号",
  "50661.bms3.csv3": "充电停止单体电压值",
  "50661.bms3.msgn3": "最大簇SOC簇号",
  "50661.bms3.mxseq3": "最高极柱温度序号",
  "50661.bms3.sdcnum3": "充放电次数",
  "50661.bms3.hscvn3": "最高单体电压编号",
  "50661.bms3.bsoc3": "bmsSOC",
  "50661.bms3.msgv3": "最大簇SOC值",
  "50661.bms3.mvd3": "最大总压差",
  "50661.bms3.dc3": "直流电流",
  "50661.bms3.plsctn3": "最低单体温度簇号",
  "50661.bms3.ccrv3": "充电降流单体电压值",
  "50661.bms3.mxsbcu3": "最高极柱温度SBCU号",
  "50661.bms3.discsv3": "放电停止单体电压值",
  "50661.bms3.hsctd3": "簇最大温度差值",
  "50661.bms3.mcstatus3": "电池簇3主回路状态",
  "50661.bms3.chginhibit3": "电池簇3禁止充电",
  "50661.bms3.dischginhibit3": "电池簇3禁止放电",
  "50661.bms3.rlystatus3": "电池簇3继电器状态",
  "50661.bms3.swstatus3": "电池簇3开关量状态",
  "50661.bms3.almstatus3": "电池簇3告警状态",
  "50661.bms3.3bcu1fault1": "电池簇3BCU一级报警故障码1",
  "50661.bms3.3bcu2fault1": "电池簇3BCU二级报警故障码1",
  "50661.bms3.3bcu3fault1": "电池簇3BCU三级报警故障码1",
  "50661.bms3.3bcu1fault2": "电池簇3BCU一级报警故障码2",
  "50661.bms3.3bcu2fault2": "电池簇3BCU二级报警故障码2",
  "50661.bms3.3bcu3fault2": "电池簇3BCU三级报警故障码2",
  "50661.bms3.3bcu1fault3": "电池簇3BCU一级报警故障码3",
  "50661.bms3.3bcu2fault3": "电池簇3BCU二级报警故障码3",
  "50661.bms3.3bcu3fault3": "电池簇3BCU三级报警故障码3",
  "50661.bms3.3bcu1fault4": "电池簇3BCU一级报警故障码4",
  "50661.bms3.3bcu2fault4": "电池簇3BCU二级报警故障码4",
  "50661.bms3.3bcu3fault4": "电池簇3BCU三级报警故障码4",
  "50661.bms4.allc4": "BMS堆累计充电量",
  "50661.bms4.alld4": "BMS堆累计放电电量",
  "50661.bms4.plscvn4": "最低单体电压簇号",
  "50661.bms4.hpsctd4": "最大温度差簇号",
  "50661.bms4.bmulscvn4": "最低单体电压BMU号",
  "50661.bms4.singlec4": "BMS堆单次充电电量",
  "50661.bms4.mnsbcu4": "最低极柱温度SBCU号",
  "50661.bms4.scvd4": "压差",
  "50661.bms4.hscvd4": "簇最大单体压差值",
  "50661.bms4.ppir4": "正极绝缘电阻",
  "50661.bms4.bmuhscvn4": "最高单体电压BMU号",
  "50661.bms4.mnseq4": "最低极柱温度序号",
  "50661.bms4.mgn4": "最高簇总压簇号",
  "50661.bms4.singled4": "BMS堆单次放电电量",
  "50661.bms4.mclv4": "最低簇总压",
  "50661.bms4.bmulsctn4": "最低单体温度BMU号",
  "50661.bms4.hscv4": "最高电压",
  "50661.bms4.lsct4": "最低温度",
  "50661.bms4.maxadiscc4": "放电最大允许电流",
  "50661.bms4.phsctn4": "最高单体温度簇号",
  "50661.bms4.bmuhsctn4": "最高单体温度BMU号",
  "50661.bms4.hsct4": "最高温度",
  "50661.bms4.lscv4": "最低电压",
  "50661.bms4.ascv4": "平均单体电压",
  "50661.bms4.dp4": "直流功率",
  "50661.bms4.mxsbmu4": "最高极柱温度SBMU号",
  "50661.bms4.maxacc4": "充电最大允许电流",
  "50661.bms4.npir4": "负极绝缘电阻",
  "50661.bms4.lsctn4": "最低单体温度编号",
  "50661.bms4.phscvn4": "最高单体电压簇号",
  "50661.bms4.mxval4": "最高极柱温度值",
  "50661.bms4.lscvn4": "最低单体电压编号",
  "50661.bms4.bscdc4": "电池累计已放电量",
  "50661.bms4.msn4": "最小簇SOC簇号",
  "50661.bms4.mcn4": "最低簇总压簇号",
  "50661.bms4.hpscvd4": "簇最大单体压差簇号",
  "50661.bms4.bsccc4": "电池累计已充电量",
  "50661.bms4.mcgv4": "最高簇总压",
  "50661.bms4.mnsbmu4": "最低极柱温度SBMU号",
  "50661.bms4.dv4": "直流电压",
  "50661.bms4.sctd4": "温差",
  "50661.bms4.asct4": "平均单体温度",
  "50661.bms4.disccrv4": "放电降流单体电压值",
  "50661.bms4.bsoh4": "bmsSOH",
  "50661.bms4.mnval4": "最低极柱温度值",
  "50661.bms4.cscv4": "电池单体电压",
  "50661.bms4.bmsc4": "BMS通讯",
  "50661.bms4.msnv4": "最小簇SOC值",
  "50661.bms4.bct4": "电池单体温度",
  "50661.bms4.sdc4": "电池可放电量",
  "50661.bms4.scc4": "电池可充电量",
  "50661.bms4.hsctn4": "最高单体温度编号",
  "50661.bms4.csv4": "充电停止单体电压值",
  "50661.bms4.msgn4": "最大簇SOC簇号",
  "50661.bms4.sdcnum4": "充放电次数",
  "50661.bms4.mxseq4": "最高极柱温度序号",
  "50661.bms4.hscvn4": "最高单体电压编号",
  "50661.bms4.bsoc4": "bmsSOC",
  "50661.bms4.msgv4": "最大簇SOC值",
  "50661.bms4.mvd4": "最大总压差",
  "50661.bms4.dc4": "直流电流",
  "50661.bms4.plsctn4": "最低单体温度簇号",
  "50661.bms4.ccrv4": "充电降流单体电压值",
  "50661.bms4.mxsbcu4": "最高极柱温度SBCU号",
  "50661.bms4.discsv4": "放电停止单体电压值",
  "50661.bms4.hsctd4": "簇最大温度差值",
  "50661.bms4.mcstatus4": "电池簇4主回路状态",
  "50661.bms4.chginhibit4": "电池簇4禁止充电",
  "50661.bms4.dischginhibit4": "电池簇4禁止放电",
  "50661.bms4.rlystatus4": "电池簇4继电器状态",
  "50661.bms4.swstatus4": "电池簇4开关量状态",
  "50661.bms4.almstatus4": "电池簇4告警状态",
  "50661.bms4.4bcu1fault1": "电池簇4BCU一级报警故障码1",
  "50661.bms4.4bcu2fault1": "电池簇4BCU二级报警故障码1",
  "50661.bms4.4bcu3fault1": "电池簇4BCU三级报警故障码1",
  "50661.bms4.4bcu1fault2": "电池簇4BCU一级报警故障码2",
  "50661.bms4.4bcu2fault2": "电池簇4BCU二级报警故障码2",
  "50661.bms4.4bcu3fault2": "电池簇4BCU三级报警故障码2",
  "50661.bms4.4bcu1fault3": "电池簇4BCU一级报警故障码3",
  "50661.bms4.4bcu2fault3": "电池簇4BCU二级报警故障码3",
  "50661.bms4.4bcu3fault3": "电池簇4BCU三级报警故障码3",
  "50661.bms4.4bcu1fault4": "电池簇4BCU一级报警故障码4",
  "50661.bms4.4bcu2fault4": "电池簇4BCU二级报警故障码4",
  "50661.bms4.4bcu3fault4": "电池簇4BCU三级报警故障码4",
  "50661.bms5.allc5": "BMS堆累计充电量",
  "50661.bms5.plscvn5": "最低单体电压簇号",
  "50661.bms5.alld5": "BMS堆累计放电电量",
  "50661.bms5.hpsctd5": "最大温度差簇号",
  "50661.bms5.bmulscvn5": "最低单体电压BMU号",
  "50661.bms5.singlec5": "BMS堆单次充电电量",
  "50661.bms5.mnsbcu5": "最低极柱温度SBCU号",
  "50661.bms5.ppir5": "正极绝缘电阻",
  "50661.bms5.scvd5": "压差",
  "50661.bms5.hscvd5": "簇最大单体压差值",
  "50661.bms5.bmuhscvn5": "最高单体电压BMU号",
  "50661.bms5.mgn5": "最高簇总压簇号",
  "50661.bms5.mnseq5": "最低极柱温度序号",
  "50661.bms5.singled5": "BMS堆单次放电电量",
  "50661.bms5.mclv5": "最低簇总压",
  "50661.bms5.bmulsctn5": "最低单体温度BMU号",
  "50661.bms5.hscv5": "最高电压",
  "50661.bms5.lsct5": "最低温度",
  "50661.bms5.maxadiscc5": "放电最大允许电流",
  "50661.bms5.phsctn5": "最高单体温度簇号",
  "50661.bms5.bmuhsctn5": "最高单体温度BMU号",
  "50661.bms5.hsct5": "最高温度",
  "50661.bms5.lscv5": "最低电压",
  "50661.bms5.dp5": "直流功率",
  "50661.bms5.ascv5": "平均单体电压",
  "50661.bms5.mxsbmu5": "最高极柱温度SBMU号",
  "50661.bms5.npir5": "负极绝缘电阻",
  "50661.bms5.maxacc5": "充电最大允许电流",
  "50661.bms5.lsctn5": "最低单体温度编号",
  "50661.bms5.phscvn5": "最高单体电压簇号",
  "50661.bms5.mxval5": "最高极柱温度值",
  "50661.bms5.lscvn5": "最低单体电压编号",
  "50661.bms5.bscdc5": "电池累计已放电量",
  "50661.bms5.msn5": "最小簇SOC簇号",
  "50661.bms5.mcn5": "最低簇总压簇号",
  "50661.bms5.hpscvd5": "簇最大单体压差簇号",
  "50661.bms5.bsccc5": "电池累计已充电量",
  "50661.bms5.mnsbmu5": "最低极柱温度SBMU号",
  "50661.bms5.dv5": "直流电压",
  "50661.bms5.sctd5": "温差",
  "50661.bms5.mcgv5": "最高簇总压",
  "50661.bms5.asct5": "平均单体温度",
  "50661.bms5.disccrv5": "放电降流单体电压值",
  "50661.bms5.mnval5": "最低极柱温度值",
  "50661.bms5.bsoh5": "bmsSOH",
  "50661.bms5.cscv5": "电池单体电压",
  "50661.bms5.bmsc5": "BMS通讯",
  "50661.bms5.msnv5": "最小簇SOC值",
  "50661.bms5.bct5": "电池单体温度",
  "50661.bms5.sdc5": "电池可放电量",
  "50661.bms5.scc5": "电池可充电量",
  "50661.bms5.hsctn5": "最高单体温度编号",
  "50661.bms5.csv5": "充电停止单体电压值",
  "50661.bms5.msgn5": "最大簇SOC簇号",
  "50661.bms5.sdcnum5": "充放电次数",
  "50661.bms5.mxseq5": "最高极柱温度序号",
  "50661.bms5.hscvn5": "最高单体电压编号",
  "50661.bms5.bsoc5": "bmsSOC",
  "50661.bms5.mvd5": "最大总压差",
  "50661.bms5.dc5": "直流电流",
  "50661.bms5.plsctn5": "最低单体温度簇号",
  "50661.bms5.ccrv5": "充电降流单体电压值",
  "50661.bms5.mxsbcu5": "最高极柱温度SBCU号",
  "50661.bms5.discsv5": "放电停止单体电压值",
  "50661.bms5.msgv5": "最大簇SOC值",
  "50661.bms5.hsctd5": "簇最大温度差值",
  "50661.bms5.mcstatus5": "电池簇5主回路状态",
  "50661.bms5.chginhibit5": "电池簇5禁止充电",
  "50661.bms5.dischginhibit5": "电池簇5禁止放电",
  "50661.bms5.rlystatus5": "电池簇5继电器状态",
  "50661.bms5.swstatus5": "电池簇5开关量状态",
  "50661.bms5.almstatus5": "电池簇5告警状态",
  "50661.bms5.5bcu1fault1": "电池簇5BCU一级报警故障码1",
  "50661.bms5.5bcu2fault1": "电池簇5BCU二级报警故障码1",
  "50661.bms5.5bcu3fault1": "电池簇5BCU三级报警故障码1",
  "50661.bms5.5bcu1fault2": "电池簇5BCU一级报警故障码2",
  "50661.bms5.5bcu2fault2": "电池簇5BCU二级报警故障码2",
  "50661.bms5.5bcu3fault2": "电池簇5BCU三级报警故障码2",
  "50661.bms5.5bcu1fault3": "电池簇5BCU一级报警故障码3",
  "50661.bms5.5bcu2fault3": "电池簇5BCU二级报警故障码3",
  "50661.bms5.5bcu3fault3": "电池簇5BCU三级报警故障码3",
  "50661.bms5.5bcu1fault4": "电池簇5BCU一级报警故障码4",
  "50661.bms5.5bcu2fault4": "电池簇5BCU二级报警故障码4",
  "50661.bms5.5bcu3fault4": "电池簇5BCU三级报警故障码4",
  "50661.bms4": "BMS4",
  "50661.bms5": "BMS5",
  "50661.bms2": "BMS2",
  "50661.bms3": "BMS3",
  "50661.bms1": "BMS1",
  "50653.realtime.pt": "电压变比",
  "50653.realtime.ct": "电流变比",
  "50653.fault.comStatus.0": "离线",
  "50653.fault.comStatus.1": "在线",
  "50655.control.demandLimit": "需量限值",
  "50655.control.demandThreshold": "需量保护阈值",
  "50655.realtime.runningStatus.0": "运行正常",
  "50655.realtime.runningStatus.1": "运行异常",
  "50655.realtime.faultCode.0": "无故障",
  "50655.realtime.faultCode.1": "内存不足",
  "50655.realtime.faultCode.2": "网络异常",
  "50655.realtime.faultCode.3": "CPU过载",
  "50655.realtime.net1Status.0": "未连接",
  "50655.realtime.net1Status.1": "已连接",
  "50655.realtime.net2Status.0": "未连接",
  "50655.realtime.net2Status.1": "已连接",
  "50655.realtime.net3Status.0": "未连接",
  "50655.realtime.net3Status.1": "已连接",
  "50655.realtime.net4Status.0": "未连接",
  "50655.realtime.net4Status.1": "已连接",
  "alarm.name.2062822977880346624": "电网冲突",
  "alarm.name.2053758982958759936": "test1",
  "alarm.name.2062823081756479488": "并联通讯告警",
  "alarm.name.2062823162895290368": "MPPT反接",
  "alarm.name.2062821496955490304": "PV反接故障",
  "alarm.name.2062821711699660800": "PV反接告警",
  "alarm.name.2062823300397158400": "升压电容过压告警",
  "alarm.name.2062821918218801152": "PV异常告警",
  "alarm.name.2062823444387614720": "升压电容过压故障",
  "alarm.name.2062823868444332032": "系统故障",
  "alarm.name.2062822154500722688": "系统绝缘阻抗低",
  "alarm.name.2062822348835409920": "环境温度过高",
  "alarm.name.2062823553586319360": "组串电流反灌",
  "alarm.name.2062824024325640192": "系统告警",
  "alarm.name.2062822530817871872": "接地故障",
  "alarm.name.2047142192719585280": "能流图异常-光伏电表离线-场景",
  "alarm.name.2062823677880324096": "PV接地故障",
  "alarm.name.2062824210695344128": "PID阻抗异常",
  "alarm.name.2062824300520558592": "PID功能异常",
  "alarm.name.2046822518626705408": "能流图异常-光伏电表离线",
  "alarm.excDesc.2046822518626705408": "光伏电表离线，能流图不准确，请检查电表",
  "alarm.name.2062822797202313216": "电表/CT反接告警",
  "alarm.name.2062823780925984768": "系统硬件故障",
  "alarm.name.2062824372675170304": "PID过压过流保护",
  "50662.hess.hFTAE": "关口电表正向总有功电能",
  "50662.hess.hsoc": "系统SOC",
  "50662.hess.hRAVE": "关口电表反向谷有功电能",
  "50662.hess.hdsp": "放电阈值",
  "50662.hess.sfstatus": "系统故障状态",
  "50662.hess.hFAVE": "关口电表正向谷有功电能",
  "50662.hess.hotap": "系统输出总有功功率",
  "50662.hess.hP": "关口电表有功功率",
  "50662.hess.hQ": "关口电表无功功率",
  "50662.hess.hS": "关口电表视在功率",
  "50662.hess.hRASE": "关口电表反向尖有功电能",
  "50662.hess.hRAPE": "关口电表反向峰有功电能",
  "50662.hess.hpcsrps": "系统无功功率设置",
  "50662.hess.hFASE": "关口电表正向尖有功电能",
  "50662.hess.hworkmode": "工作模式",
  "50662.hess.hotapp": "系统输出总视在功率",
  "50662.hess.hFAPE": "关口电表正向峰有功电能",
  "50662.hess.haaotop": "变压器过载保护提前量",
  "50662.hess.htcldc": "直流侧系统今日充电量",
  "50662.hess.toumeterread": "0点尖峰平⾕抄表",
  "50662.hess.hloadap": "负载有功功率",
  "50662.hess.hpcsaps": "系统有功功率设置",
  "50662.hess.pacd": "需量值上报",
  "50662.hess.demand": "需量值设置",
  "50662.hess.hdezo": "免调功率",
  "50662.hess.hpcsstate": "系统运行状态",
  "50662.hess.hcrtae": "交流侧系统累计放电量",
  "50662.hess.htcl": "交流侧系统今日充电量",
  "50662.hess.hRAFE": "关口电表反向平有功电能",
  "50662.hess.reconpower": "远程功率",
  "50662.hess.hRADE": "关口电表反向深谷有功电能",
  "50662.hess.hotrp": "系统输出总无功功率",
  "50662.hess.htdcldc": "直流侧系统今日放电量",
  "50662.hess.htdcl": "交流侧系统今日放电量",
  "50662.hess.hscdc": "直流侧系统累计放电量",
  "50662.hess.hmpot": "变压器最大功率\n(变压器实际的最大功率)",
  "50662.hess.hsccc": "直流侧系统累计充电量",
  "50662.hess.hFAFE": "关口电表正向平有功电能",
  "50662.hess.hFADE": "关口电表正向深谷有功电能",
  "50662.hess.hcpdae": "交流侧系统累计充电量",
  "50662.hess.h96SlotSchedule": "96点策略",
  "50662.hess.hRTAE": "关口电表反向总有功电能",
  "50662.hess.shutdown": "储能是否停机",
  "50662.ems.RAPE": "反向峰有功电能",
  "50662.ems.P": "总有功功率",
  "50662.ems.Q": "总无功功率",
  "50662.ems.S": "总视在功率",
  "50662.ems.cpuremain": "CPU剩余",
  "50662.ems.FASE": "正向有功尖电能",
  "50662.ems.CT": "电流变比CT",
  "50662.ems.protmode": "保护模式",
  "50662.ems.cinp": "机柜装机功率",
  "50662.ems.FAVE": "正向谷有功电能",
  "50662.ems.sncode": "设备SN号",
  "50662.ems.cinc": "机柜装机容量",
  "50662.ems.emc": "电表通讯",
  "50662.ems.RASE": "反向尖有功电能",
  "50662.ems.Fr": "频率",
  "50662.ems.Pfa": "A相功率因数",
  "50662.ems.Pfc": "C相功率因数",
  "50662.ems.Pfb": "B相功率因数",
  "50662.ems.occ": "一充电量",
  "50662.ems.sdiscc": "二放电量",
  "50662.ems.Ia": "A相电流",
  "50662.ems.RAVE": "反向谷有功电能",
  "50662.ems.Ib": "B相电流",
  "50662.ems.Ic": "C相电流",
  "50662.ems.odiscc": "一放电量",
  "50662.ems.FTAE": "正向总有功电能",
  "50662.ems.lmct": "关口电表变比",
  "50662.ems.soc": "SOC",
  "50662.ems.soh": "SOH",
  "50662.ems.aaotop": "变压器过载保护提前量",
  "50662.ems.dsp": "放电阈值",
  "50662.ems.RTAE": "反向总有功电能",
  "50662.ems.cstatus": "机柜故障状态",
  "50662.ems.PT": "电压变比PT",
  "50662.ems.Pa": "A相有功总功率",
  "50662.ems.Pb": "B相有功总功率",
  "50662.ems.Pc": "C相有功总功率",
  "50662.ems.Pf": "总功率因数",
  "50662.ems.workmode": "工作模式",
  "50662.ems.Qa": "A相无功总功率",
  "50662.ems.Qb": "B相无功总功率",
  "50662.ems.Qc": "C相无功总功率",
  "50662.ems.FADE": "正向深谷有功电能",
  "50662.ems.Sa": "A相视在功率",
  "50662.ems.Sb": "B相视在功率",
  "50662.ems.Sc": "C相视在功率",
  "50662.ems.sccc": "机柜累计已充电量",
  "50662.ems.FAFE": "正向平有功电能",
  "50662.ems.Ua": "A相电压",
  "50662.ems.Ub": "B相电压",
  "50662.ems.Uc": "C相电压",
  "50662.ems.RADE": "反向深谷有功电能",
  "50662.ems.tdcl": "今日放电电量",
  "50662.ems.scdc": "机柜累计已放电量",
  "50662.ems.mpot": "变压器最大功率",
  "50662.ems.RAFE": "反向平有功电能",
  "50662.ems.lpvn": "本地程序版本号",
  "50662.ems.Uab": "AB线电压",
  "50662.ems.lmonoff": "关口电表有无设置",
  "50662.ems.metersn": "柜内表sn",
  "50662.ems.Ubc": "BC线电压",
  "50662.ems.dezo": "免调功率",
  "50662.ems.Uca": "CA线电压",
  "50662.ems.comStatus": "通讯状态",
  "50662.ems.memremain": "内存剩余",
  "50662.ems.FAPE": "正向峰有功电能",
  "50662.ems.tcl": "今日充电电量",
  "50662.ems.esmct": "储能电表变比",
  "50662.ems.daily96read1": "15分钟抄表数据",
  "50662.ems.scc": "二充电量",
  "50662.pcs.otapp": "输出总视在功率",
  "50662.pcs.modaf": "PCS频率",
  "50662.pcs.otap": "输出总有功功率",
  "50662.pcs.aclv": "交流CA线电压",
  "50662.pcs.ablv": "交流BC线电压",
  "50662.pcs.igbtt": "IGBT温度",
  "50662.pcs.pcssapr": "PCS设置有功功率",
  "50662.pcs.aalv": "交流AB线电压",
  "50662.pcs.cpc": "C相电流",
  "50662.pcs.pcssrpr": "PCS设置无功功率",
  "50662.pcs.bpc": "B相电流",
  "50662.pcs.pcsstate": "PCS运行状态",
  "50662.pcs.pcsws": "PCS警告状态",
  "50662.pcs.apc": "A相电流",
  "50662.pcs.modpf": "功率因数",
  "50662.pcs.apov": "A相电压",
  "50662.pcs.bpov": "B相电压",
  "50662.pcs.otrp": "输出总无功功率",
  "50662.pcs.pcsgcd": "PCS离并网状态",
  "50662.pcs.pcsdc": "直流电流",
  "50662.pcs.igbtat": "IGBT-A温度",
  "50662.pcs.pcsdv": "直流电压",
  "50662.pcs.cpov": "C相电压",
  "50662.pcs.igbtbt": "IGBT-B温度",
  "50662.pcs.igbtct": "IGBT-C温度",
  "50662.pcs.pcst": "PCS温度",
  "50662.pcs.pcsc": "PCS通讯",
  "50662.pcs.dcp": "直流功率",
  "50662.pcs.pcsfs": "PCS故障状态",
  "50662.bms1.allc1": "BMS堆累计充电量",
  "50662.bms1.plscvn1": "最低单体电压簇号",
  "50662.bms1.alld1": "BMS堆累计放电电量",
  "50662.bms1.hpsctd1": "最大温度差簇号",
  "50662.bms1.bmulscvn1": "最低单体电压BMU号",
  "50662.bms1.singlec1": "BMS堆单次充电电量",
  "50662.bms1.scvd1": "压差",
  "50662.bms1.hscvd1": "簇最大单体压差值",
  "50662.bms1.mnsbcu1": "最低极柱温度SBCU号",
  "50662.bms1.ppir1": "正极绝缘电阻",
  "50662.bms1.bmuhscvn1": "最高单体电压BMU号",
  "50662.bms1.mnseq1": "最低极柱温度序号",
  "50662.bms1.mgn1": "最高簇总压簇号",
  "50662.bms1.singled1": "BMS堆单次放电电量",
  "50662.bms1.mclv1": "最低簇总压",
  "50662.bms1.hscv1": "最高电压",
  "50662.bms1.lsct1": "最低温度",
  "50662.bms1.maxadiscc1": "放电最大允许电流",
  "50662.bms1.bmulsctn1": "最低单体温度BMU号",
  "50662.bms1.bmuhsctn1": "最高单体温度BMU号",
  "50662.bms1.lscv1": "最低电压",
  "50662.bms1.hsct1": "最高温度",
  "50662.bms1.phsctn1": "最高单体温度簇号",
  "50662.bms1.ascv1": "平均单体电压",
  "50662.bms1.dp1": "直流功率",
  "50662.bms1.mxsbmu1": "最高极柱温度SBMU号",
  "50662.bms1.maxacc1": "充电最大允许电流",
  "50662.bms1.npir1": "负极绝缘电阻",
  "50662.bms1.lsctn1": "最低单体温度编号",
  "50662.bms1.phscvn1": "最高单体电压簇号",
  "50662.bms1.mxval1": "最高极柱温度值",
  "50662.bms1.msn1": "最小簇SOC簇号",
  "50662.bms1.bscdc1": "电池累计已放电量",
  "50662.bms1.mcn1": "最低簇总压簇号",
  "50662.bms1.hpscvd1": "簇最大单体压差簇号",
  "50662.bms1.dv1": "直流电压",
  "50662.bms1.mcgv1": "最高簇总压",
  "50662.bms1.bsccc1": "电池累计已充电量",
  "50662.bms1.asct1": "平均单体温度",
  "50662.bms1.mnsbmu1": "最低极柱温度SBMU号",
  "50662.bms1.sctd1": "温差",
  "50662.bms1.lscvn1": "最低单体电压编号",
  "50662.bms1.cscv1": "电池单体电压",
  "50662.bms1.sdc1": "电池可放电量",
  "50662.bms1.bct1": "电池单体温度",
  "50662.bms1.mnval1": "最低极柱温度值",
  "50662.bms1.bsoh1": "bmsSOH",
  "50662.bms1.bmsc1": "BMS通讯",
  "50662.bms1.msnv1": "最小簇SOC值",
  "50662.bms1.scc1": "电池可充电量",
  "50662.bms1.disccrv1": "放电降流单体电压值",
  "50662.bms1.hsctn1": "最高单体温度编号",
  "50662.bms1.csv1": "充电停止单体电压值",
  "50662.bms1.msgn1": "最大簇SOC簇号",
  "50662.bms1.mxseq1": "最高极柱温度序号",
  "50662.bms1.sdcnum1": "充放电次数",
  "50662.bms1.hscvn1": "最高单体电压编号",
  "50662.bms1.bsoc1": "bmsSOC",
  "50662.bms1.mvd1": "最大总压差",
  "50662.bms1.msgv1": "最大簇SOC值",
  "50662.bms1.dc1": "直流电流",
  "50662.bms1.plsctn1": "最低单体温度簇号",
  "50662.bms1.ccrv1": "充电降流单体电压值",
  "50662.bms1.mxsbcu1": "最高极柱温度SBCU号",
  "50662.bms1.discsv1": "放电停止单体电压值",
  "50662.bms1.hsctd1": "簇最大温度差值",
  "50662.bms1.mcstatus1": "电池簇1主回路状态",
  "50662.bms1.chginhibit1": "电池簇1禁止充电",
  "50662.bms1.dischginhibit1": "电池簇1禁止放电",
  "50662.bms1.rlystatus1": "电池簇1继电器状态",
  "50662.bms1.swstatus1": "电池簇1开关量状态",
  "50662.bms1.almstatus1": "电池簇1告警状态",
  "50662.bms1.1bcu1fault1": "电池簇1BCU一级报警故障码1",
  "50662.bms1.1bcu2fault1": "电池簇1BCU二级报警故障码1",
  "50662.bms1.1bcu3fault1": "电池簇1BCU三级报警故障码1",
  "50662.bms1.1bcu1fault2": "电池簇1BCU一级报警故障码2",
  "50662.bms1.1bcu2fault2": "电池簇1BCU二级报警故障码2",
  "50662.bms1.1bcu3fault2": "电池簇1BCU三级报警故障码2",
  "50662.bms1.1bcu1fault3": "电池簇1BCU一级报警故障码3",
  "50662.bms1.1bcu2fault3": "电池簇1BCU二级报警故障码3",
  "50662.bms1.1bcu3fault3": "电池簇1BCU三级报警故障码3",
  "50662.bms1.1bcu1fault4": "电池簇1BCU一级报警故障码4",
  "50662.bms1.1bcu2fault4": "电池簇1BCU二级报警故障码4",
  "50662.bms1.1bcu3fault4": "电池簇1BCU三级报警故障码4",
  "50662.lcs.wtch": "水温加热点",
  "50662.lcs.wtcp": "水温制冷点",
  "50662.lcs.lcet": "液冷环境温度",
  "50662.lcs.acc": "冷机通讯",
  "50662.lcs.hrd": "加热回差",
  "50662.lcs.iwp": "进水压力",
  "50662.lcs.lcestate": "液冷运行状态",
  "50662.lcs.crd": "制冷回差",
  "50662.lcs.crg": "压缩机运行",
  "50662.lcs.ehrg": "电加热运行",
  "50662.lcs.Icesw": "液冷水泵开关",
  "50662.lcs.lcerstate": "液冷请求运行",
  "50662.lcs.lcett": "设定制冷目标温度",
  "50662.lcs.lceowt": "液冷出水温度",
  "50662.lcs.owp": "出水压力",
  "50662.lcs.lcerwt": "液冷回水温度",
  "50662.deh.dhstatus1": "除湿状态",
  "50662.deh.dhalarm1": "除湿机告警状态",
  "50662.deh.environmentt": "环境温度值",
  "50662.deh.dhworkmode1": "除湿机工作状态",
  "50662.deh.ahdate": "环境湿度值",
  "50662.deh.dehumidifier24": "湿模块手动自动状态",
  "50662.aac.aircom": "空调运行模式",
  "50662.aac.heattca": "制热温控回差",
  "50662.aac.refsett1": "制冷设定温度",
  "50662.aac.heatsettl": "制热设定温度",
  "50662.aac.cabineth": "柜内湿度",
  "50662.aac.cabinett": "柜内温度",
  "50662.aac.reftca": "制冷温控回差",
  "50662.aac.exhaustt1": "排气温度",
  "50662.aac.outsidet": "柜外温度",
  "50662.fire.h": "氢气",
  "50662.fire.co": "一氧化碳",
  "50662.fire.temp": "温度",
  "50662.hess.sfstatus.0": "正常",
  "50662.hess.sfstatus.1": "故障",
  "50662.hess.hworkmode.0": "计划模式",
  "50662.hess.hworkmode.1": "手动模式",
  "50662.hess.hworkmode.2": "远程模式",
  "50662.hess.hpcsstate.1": "待机",
  "50662.hess.hpcsstate.2": "充电",
  "50662.hess.hpcsstate.3": "放电",
  "50662.hess.shutdown.0": "不停机",
  "50662.hess.shutdown.1": "停机",
  "50662.ems.protmode.0": "防逆流防过载启动",
  "50662.ems.protmode.1": "防逆流启动",
  "50662.ems.protmode.2": "防过载启动",
  "50662.ems.protmode.3": "防逆流防过载关闭",
  "50662.ems.cstatus.0": "正常",
  "50662.ems.cstatus.1": "故障",
  "50662.ems.workmode.0": "计划模式",
  "50662.ems.workmode.1": "手动模式",
  "50662.ems.workmode.2": "远程模式",
  "50662.ems.comStatus.00": "断开",
  "50662.ems.comStatus.01": "连接",
  "50662.pcs.pcsstate.1": "待机",
  "50662.pcs.pcsstate.2": "充电",
  "50662.pcs.pcsstate.3": "放电",
  "50662.pcs.pcsws.0": "正常",
  "50662.pcs.pcsws.1": "告警",
  "50662.pcs.pcsgcd.0": "并网",
  "50662.pcs.pcsgcd.1": "离网",
  "50662.pcs.pcsfs.0": "正常",
  "50662.pcs.pcsfs.1": "故障",
  "50662.lcs.lcestate.0": "待机",
  "50662.lcs.lcestate.1": "自循环",
  "50662.lcs.lcestate.2": "制冷",
  "50662.lcs.lcestate.3": "制热",
  "50662.lcs.lcestate.4": "自动控制",
  "50662.lcs.lcestate.5": "关机",
  "50662.lcs.lcestate.6": "水泵循环",
  "50662.deh.dehumidifier24.0": "自动",
  "50662.deh.dehumidifier24.1": "手动",
  "50662.aac.aircom.0": "待机",
  "50662.aac.aircom.1": "制冷",
  "50662.aac.aircom.2": "制热",
  "50662.aac.aircom.3": "新风",
  "50662.aac.aircom.4": "送风",
  "50662.aac.aircom.5": "除湿",
  "50662.aac.aircom.6": "通风",
  "50662.aac.aircom.7": "自动",
  "50662.aac.aircom.8": "关机",
  "50662.pcs": "PCS",
  "50662.aac": "空调",
  "50662.deh": "除湿机",
  "50662.bms1": "BMS1",
  "50662.fire": "消防",
  "50662.ems": "机柜",
  "50662.hess": "系统",
  "50662.lcs": "液冷",
  "norway.areas": "norwayAreas",
  "device.advanced": "高级功能",
  "device.quickSetup": "快速设置",
  "50661.pcs.acalarm1": "PCS交流端口告警码1",
  "50661.pcs.acalarm1_0": "交流过压",
  "50661.pcs.acalarm1_1": "交流欠压",
  "50661.pcs.acalarm1_10": "直流手动开关未闭合",
  "50661.pcs.acalarm1_11": "高温降频运行",
  "50661.pcs.acalarm1_12": "交流电压不符合离网",
  "50661.pcs.acalarm1_2": "交流过流",
  "50661.pcs.acalarm1_3": "交流过频",
  "50661.pcs.acalarm1_4": "交流欠频",
  "50661.pcs.acalarm1_5": "交流缺相",
  "50661.pcs.acalarm1_6": "交流相序错误",
  "50661.pcs.acalarm1_7": "交流未上电",
  "50661.pcs.acalarm1_8": "电抗器过温",
  "50661.pcs.acalarm1_9": "交流手动开关未闭合",
  "50661.pcs.acfault1": "PCS交流端口故障码1",
  "50661.pcs.acfault1_0": "交流1段过压",
  "50661.pcs.acfault1_1": "交流2段过压",
  "50661.pcs.acfault1_10": "交流硬件过流",
  "50661.pcs.acfault1_11": "断路器故障",
  "50661.pcs.acfault1_12": "接触器故障",
  "50661.pcs.acfault1_13": "熔断器动作",
  "50661.pcs.acfault1_14": "电抗器过温",
  "50661.pcs.acfault1_15": "交流浪涌保护器动作",
  "50661.pcs.acfault1_2": "交流3段过压",
  "50661.pcs.acfault1_3": "交流硬件过压",
  "50661.pcs.acfault1_4": "交流1段欠压",
  "50661.pcs.acfault1_5": "交流2段欠压",
  "50661.pcs.acfault1_6": "交流3段欠压",
  "50661.pcs.acfault1_7": "交流1段过流",
  "50661.pcs.acfault1_8": "交流2段过流",
  "50661.pcs.acfault1_9": "交流3段过流",
  "50661.pcs.acfault2": "PCS交流端口故障码2",
  "50661.pcs.acfault2_0": "交流1段过频",
  "50661.pcs.acfault2_1": "交流2段过频",
  "50661.pcs.acfault2_2": "交流1段欠频",
  "50661.pcs.acfault2_3": "交流2段欠频",
  "50661.pcs.acfault2_4": "交流孤岛保护",
  "50661.pcs.acfault2_5": "低电压穿越失败",
  "50661.pcs.acfault2_6": "高电压穿越失败",
  "50661.pcs.acfault2_7": "交流预充超时",
  "50661.pcs.acfault2_8": "交流漏电保护",
  "50661.pcs.poweralarm1": "PCS功率单元告警码1",
  "50661.pcs.poweralarm1_0": "直流母线过压",
  "50661.pcs.poweralarm1_1": "直流母线欠压",
  "50661.pcs.poweralarm1_10": "A相过流",
  "50661.pcs.poweralarm1_11": "B相过流",
  "50661.pcs.poweralarm1_12": "C相过流",
  "50661.pcs.poweralarm1_13": "充电截止",
  "50661.pcs.poweralarm1_14": "放电截止",
  "50661.pcs.poweralarm1_2": "直流偏压",
  "50661.pcs.poweralarm1_3": "直流过流",
  "50661.pcs.poweralarm1_4": "功率单元过温",
  "50661.pcs.poweralarm1_5": "A相IGBT过温",
  "50661.pcs.poweralarm1_6": "B相IGBT过温",
  "50661.pcs.poweralarm1_7": "C相IGBT过温",
  "50661.pcs.poweralarm1_8": "直流反接",
  "50661.pcs.poweralarm1_9": "硬件连接错误",
  "50661.pcs.powerfault1": "PCS功率单元故障码1",
  "50661.pcs.powerfault1_0": "直流母线1段过压",
  "50661.pcs.powerfault1_1": "直流母线2段过压",
  "50661.pcs.powerfault1_10": "直流母线硬件偏压",
  "50661.pcs.powerfault1_11": "直流1段过流",
  "50661.pcs.powerfault1_12": "直流2段过流",
  "50661.pcs.powerfault1_13": "直流3段过流",
  "50661.pcs.powerfault1_14": "直流母线硬件过流",
  "50661.pcs.powerfault1_15": "直流母线硬件反接",
  "50661.pcs.powerfault1_2": "直流母线3段过压",
  "50661.pcs.powerfault1_3": "直流母线硬件过压",
  "50661.pcs.powerfault1_4": "直流母线1段欠压",
  "50661.pcs.powerfault1_5": "直流母线2段欠压",
  "50661.pcs.powerfault1_6": "直流母线3段欠压",
  "50661.pcs.powerfault1_7": "直流1段偏压",
  "50661.pcs.powerfault1_8": "直流2段偏压",
  "50661.pcs.powerfault1_9": "直流3段偏压",
  "50661.pcs.powerfault2": "PCS功率单元故障码2",
  "50661.pcs.powerfault2_0": "A相软件过流",
  "50661.pcs.powerfault2_1": "B相软件过流",
  "50661.pcs.powerfault2_10": "B相硬件过温",
  "50661.pcs.powerfault2_11": "C相硬件过温",
  "50661.pcs.powerfault2_12": "功率单元对地短路",
  "50661.pcs.powerfault2_13": "直流预充电超时",
  "50661.pcs.powerfault2_14": "正母线绝缘阻抗低",
  "50661.pcs.powerfault2_15": "负母线绝缘阻抗低",
  "50661.pcs.powerfault2_2": "C相软件过流",
  "50661.pcs.powerfault2_3": "A相硬件过流",
  "50661.pcs.powerfault2_4": "B相硬件过流",
  "50661.pcs.powerfault2_5": "C相硬件过流",
  "50661.pcs.powerfault2_6": "A相驱动故障",
  "50661.pcs.powerfault2_7": "B相驱动故障",
  "50661.pcs.powerfault2_8": "C相驱动故障",
  "50661.pcs.powerfault2_9": "A相硬件过温",
  "50661.pcs.powerfault3": "PCS功率单元故障码3",
  "50661.pcs.powerfault3_0": "直流浪涌保护器动作",
  "50661.pcs.powerfault3_1": "直流熔断器动作",
  "50661.pcs.powerfault3_10": "光伏过流/电池过流",
  "50661.pcs.powerfault3_11": "光伏反接/电池反接",
  "50661.pcs.powerfault3_12": "反向放电",
  "50661.pcs.powerfault3_13": "硬件过流",
  "50661.pcs.powerfault3_14": "功率单元通讯故障",
  "50661.pcs.powerfault3_2": "直流断路器动作",
  "50661.pcs.powerfault3_3": "直流接触器故障",
  "50661.pcs.powerfault3_4": "BMS故障",
  "50661.pcs.powerfault3_5": "IGBT过温",
  "50661.pcs.powerfault3_6": "单元风机故障",
  "50661.pcs.powerfault3_7": "散热器过温",
  "50661.pcs.powerfault3_8": "光伏过压/电池过压",
  "50661.pcs.powerfault3_9": "光伏欠压/电池欠压",
  "50661.pcs.sysalarm1": "PCS整机告警码1",
  "50661.pcs.sysalarm1_0": "环温告警",
  "50661.pcs.sysalarm1_1": "需要除霜",
  "50661.pcs.sysalarm1_2": "交流册柜门打开",
  "50661.pcs.sysalarm1_3": "直流侧柜门打开",
  "50661.pcs.sysalarm1_4": "机内空调告警",
  "50661.pcs.sysalarm1_5": "BMS告警",
  "50661.pcs.sysalarm1_6": "BMS降频",
  "50661.pcs.sysalarm1_7": "辅助电源异常",
  "50661.pcs.sysalarm1_8": "EMS通信故障",
  "50661.pcs.sysalarm1_9": "BMS通信故障",
  "50661.pcs.sysfault1": "PCS整机故障码1",
  "50661.pcs.sysfault1_0": "BMS脱扣",
  "50661.pcs.sysfault1_1": "BMS故障",
  "50661.pcs.sysfault1_10": "烟感动作",
  "50661.pcs.sysfault1_11": "模拟量零偏校准异常",
  "50661.pcs.sysfault1_12": "外部急停动作",
  "50661.pcs.sysfault1_13": "机内空调故障",
  "50661.pcs.sysfault1_14": "机内风机故障",
  "50661.pcs.sysfault1_15": "总硬件故障",
  "50661.pcs.sysfault1_2": "BMS通信故障",
  "50661.pcs.sysfault1_3": "整机功率不平衡",
  "50661.pcs.sysfault1_4": "辅助电源故障",
  "50661.pcs.sysfault1_5": "辅助电源变压器过温",
  "50661.pcs.sysfault1_6": "急停动作",
  "50661.pcs.sysfault1_7": "EMS通信故障",
  "50661.pcs.sysfault1_8": "漏电流保护",
  "50661.pcs.sysfault1_9": "环境过温",
  "50661.pcs.sysfault2": "PCS整机故障码2",
  "50661.pcs.sysfault2_0": "通信版存储通信异常",
  "50661.pcs.sysfault2_1": "通信版配置信息存储异常",
  "50661.pcs.sysfault2_10": "并机线异常",
  "50661.pcs.sysfault2_2": "通信版网口1异常",
  "50661.pcs.sysfault2_3": "通信版网口2异常",
  "50661.pcs.sysfault2_4": "通信版HMI异常",
  "50661.pcs.sysfault2_5": "通信版内部通信异常",
  "50661.pcs.sysfault2_6": "主控板内部485异常",
  "50661.pcs.sysfault2_7": "主控板CAN异常",
  "50661.pcs.sysfault2_8": "主控板存储通信异常",
  "50661.pcs.sysfault2_9": "主控板存储数据错误",
  "50661.bms1.1bcu1fault1_0": "总压过压1级",
  "50661.bms1.1bcu1fault1_1": "总压欠压1级",
  "50661.bms1.1bcu1fault1_10": "主从通讯1级",
  "50661.bms1.1bcu1fault1_11": "单体电压排线1级",
  "50661.bms1.1bcu1fault1_12": "单体温感排线1级",
  "50661.bms1.1bcu1fault1_14": "SOC过低1级",
  "50661.bms1.1bcu1fault1_15": "绝缘漏电1级",
  "50661.bms1.1bcu1fault1_2": "单体过压1级",
  "50661.bms1.1bcu1fault1_3": "单体欠压1级",
  "50661.bms1.1bcu1fault1_4": "单体过温1级",
  "50661.bms1.1bcu1fault1_5": "单体低温1级",
  "50661.bms1.1bcu1fault1_6": "压差过大1级",
  "50661.bms1.1bcu1fault1_7": "温差过大1级",
  "50661.bms1.1bcu1fault1_8": "电流过大1级",
  "50661.bms1.1bcu1fault1_9": "高压异常1级",
  "50661.bms1.1bcu1fault2_0": "粘连1级",
  "50661.bms1.1bcu1fault2_1": "预充状态1级",
  "50661.bms1.1bcu1fault2_11": "电流异常1级",
  "50661.bms1.1bcu1fault2_15": "PCS状态1级",
  "50661.bms1.1bcu1fault2_2": "供电过高1级",
  "50661.bms1.1bcu1fault2_3": "供电过低1级",
  "50661.bms1.1bcu1fault2_4": "T1高温1级",
  "50661.bms1.1bcu1fault2_5": "T1低温1级",
  "50661.bms1.1bcu1fault2_6": "T2高温1级",
  "50661.bms1.1bcu1fault2_7": "T2低温1级",
  "50661.bms1.1bcu1fault2_8": "均衡过温1级",
  "50661.bms1.1bcu1fault3_10": "开路故障1级",
  "50661.bms1.1bcu1fault3_11": "急停故障1级",
  "50661.bms1.1bcu1fault3_12": "消防故障1级",
  "50661.bms1.1bcu1fault3_13": "控制指令超时1级",
  "50661.bms1.1bcu1fault3_15": "热失控1级",
  "50661.bms1.1bcu1fault3_2": "模拟前端状态1级",
  "50661.bms1.1bcu1fault3_3": "EEPROM状态1级",
  "50661.bms1.1bcu1fault3_4": "RTC状态1级",
  "50661.bms1.1bcu1fault3_5": "ADC状态1级",
  "50661.bms1.1bcu1fault3_6": "SD卡状态1级",
  "50661.bms1.1bcu1fault3_7": "反馈异常1级",
  "50661.bms1.1bcu1fault3_8": "温升过快1级",
  "50661.bms1.1bcu1fault3_9": "极限故障1级",
  "50661.bms1.1bcu1fault4_0": "电池箱过压1级",
  "50661.bms1.1bcu1fault4_1": "电池箱欠压1级",
  "50661.bms1.1bcu1fault4_10": "交流失电故障1级",
  "50661.bms1.1bcu1fault4_2": "防雷器故障1级",
  "50661.bms1.1bcu1fault4_3": "空调故障1级",
  "50661.bms1.1bcu1fault4_5": "水浸故障1级",
  "50661.bms1.1bcu1fault4_6": "门禁故障1级",
  "50661.bms1.1bcu1fault4_7": "气体传感器故障1级",
  "50661.bms1.1bcu2fault1_0": "总压过压2级",
  "50661.bms1.1bcu2fault1_1": "总压欠压2级",
  "50661.bms1.1bcu2fault1_10": "主从通讯2级",
  "50661.bms1.1bcu2fault1_11": "单体电压排线2级",
  "50661.bms1.1bcu2fault1_12": "单体温感排线2级",
  "50661.bms1.1bcu2fault1_14": "SOC过低2级",
  "50661.bms1.1bcu2fault1_15": "绝缘漏电2级",
  "50661.bms1.1bcu2fault1_2": "单体过压2级",
  "50661.bms1.1bcu2fault1_3": "单体欠压2级",
  "50661.bms1.1bcu2fault1_4": "单体过温2级",
  "50661.bms1.1bcu2fault1_5": "单体低温2级",
  "50661.bms1.1bcu2fault1_6": "压差过大2级",
  "50661.bms1.1bcu2fault1_7": "温差过大2级",
  "50661.bms1.1bcu2fault1_8": "电流过大2级",
  "50661.bms1.1bcu2fault1_9": "高压异常2级",
  "50661.bms1.1bcu2fault2_0": "粘连2级",
  "50661.bms1.1bcu2fault2_1": "预充状态2级",
  "50661.bms1.1bcu2fault2_11": "电流异常2级",
  "50661.bms1.1bcu2fault2_15": "PCS状态2级",
  "50661.bms1.1bcu2fault2_2": "供电过高2级",
  "50661.bms1.1bcu2fault2_3": "供电过低2级",
  "50661.bms1.1bcu2fault2_4": "T1高温2级",
  "50661.bms1.1bcu2fault2_5": "T1低温2级",
  "50661.bms1.1bcu2fault2_6": "T2高温2级",
  "50661.bms1.1bcu2fault2_7": "T2低温2级",
  "50661.bms1.1bcu2fault2_8": "均衡过温2级",
  "50661.bms1.1bcu2fault3_10": "开路故障2级",
  "50661.bms1.1bcu2fault3_11": "急停故障2级",
  "50661.bms1.1bcu2fault3_12": "消防故障2级",
  "50661.bms1.1bcu2fault3_13": "控制指令超时2级",
  "50661.bms1.1bcu2fault3_15": "热失控2级",
  "50661.bms1.1bcu2fault3_2": "模拟前端状态2级",
  "50661.bms1.1bcu2fault3_3": "EEPROM状态2级",
  "50661.bms1.1bcu2fault3_4": "RTC状态2级",
  "50661.bms1.1bcu2fault3_5": "ADC状态2级",
  "50661.bms1.1bcu2fault3_6": "SD卡状态2级",
  "50661.bms1.1bcu2fault3_7": "反馈异常2级",
  "50661.bms1.1bcu2fault3_8": "温升过快2级",
  "50661.bms1.1bcu2fault3_9": "极限故障2级",
  "50661.bms1.1bcu2fault4_0": "电池箱过压2级",
  "50661.bms1.1bcu2fault4_1": "电池箱欠压2级",
  "50661.bms1.1bcu2fault4_10": "交流失电故障2级",
  "50661.bms1.1bcu2fault4_2": "防雷器故障2级",
  "50661.bms1.1bcu2fault4_3": "空调故障2级",
  "50661.bms1.1bcu2fault4_5": "水浸故障2级",
  "50661.bms1.1bcu2fault4_6": "门禁故障2级",
  "50661.bms1.1bcu2fault4_7": "气体传感器故障2级",
  "50661.bms1.1bcu3fault1_0": "总压过压3级",
  "50661.bms1.1bcu3fault1_1": "总压欠压3级",
  "50661.bms1.1bcu3fault1_10": "主从通讯3级",
  "50661.bms1.1bcu3fault1_11": "单体电压排线3级",
  "50661.bms1.1bcu3fault1_12": "单体温感排线3级",
  "50661.bms1.1bcu3fault1_14": "SOC过低3级",
  "50661.bms1.1bcu3fault1_15": "绝缘漏电3级",
  "50661.bms1.1bcu3fault1_2": "单体过压3级",
  "50661.bms1.1bcu3fault1_3": "单体欠压3级",
  "50661.bms1.1bcu3fault1_4": "单体过温3级",
  "50661.bms1.1bcu3fault1_5": "单体低温3级",
  "50661.bms1.1bcu3fault1_6": "压差过大3级",
  "50661.bms1.1bcu3fault1_7": "温差过大3级",
  "50661.bms1.1bcu3fault1_8": "电流过大3级",
  "50661.bms1.1bcu3fault1_9": "高压异常3级",
  "50661.bms1.1bcu3fault2_0": "粘连3级",
  "50661.bms1.1bcu3fault2_1": "预充状态3级",
  "50661.bms1.1bcu3fault2_11": "电流异常3级",
  "50661.bms1.1bcu3fault2_15": "PCS状态3级",
  "50661.bms1.1bcu3fault2_2": "供电过高3级",
  "50661.bms1.1bcu3fault2_3": "供电过低3级",
  "50661.bms1.1bcu3fault2_4": "T1高温3级",
  "50661.bms1.1bcu3fault2_5": "T1低温3级",
  "50661.bms1.1bcu3fault2_6": "T2高温3级",
  "50661.bms1.1bcu3fault2_7": "T2低温3级",
  "50661.bms1.1bcu3fault2_8": "均衡过温3级",
  "50661.bms1.1bcu3fault3_10": "开路故障3级",
  "50661.bms1.1bcu3fault3_11": "急停故障3级",
  "50661.bms1.1bcu3fault3_12": "消防故障3级",
  "50661.bms1.1bcu3fault3_13": "控制指令超时3级",
  "50661.bms1.1bcu3fault3_15": "热失控3级",
  "50661.bms1.1bcu3fault3_2": "模拟前端状态3级",
  "50661.bms1.1bcu3fault3_3": "EEPROM状态3级",
  "50661.bms1.1bcu3fault3_4": "RTC状态3级",
  "50661.bms1.1bcu3fault3_5": "ADC状态3级",
  "50661.bms1.1bcu3fault3_6": "SD卡状态3级",
  "50661.bms1.1bcu3fault3_7": "反馈异常3级",
  "50661.bms1.1bcu3fault3_8": "温升过快3级",
  "50661.bms1.1bcu3fault3_9": "极限故障3级",
  "50661.bms1.1bcu3fault4_0": "电池箱过压3级",
  "50661.bms1.1bcu3fault4_1": "电池箱欠压3级",
  "50661.bms1.1bcu3fault4_10": "交流失电故障3级",
  "50661.bms1.1bcu3fault4_2": "防雷器故障3级",
  "50661.bms1.1bcu3fault4_3": "空调故障3级",
  "50661.bms1.1bcu3fault4_5": "水浸故障3级",
  "50661.bms1.1bcu3fault4_6": "门禁故障3级",
  "50661.bms1.1bcu3fault4_7": "气体传感器故障3级",
  "50661.bms2.2bcu1fault1_0": "总压过压1级",
  "50661.bms2.2bcu1fault1_1": "总压欠压1级",
  "50661.bms2.2bcu1fault1_10": "主从通讯1级",
  "50661.bms2.2bcu1fault1_11": "单体电压排线1级",
  "50661.bms2.2bcu1fault1_12": "单体温感排线1级",
  "50661.bms2.2bcu1fault1_14": "SOC过低1级",
  "50661.bms2.2bcu1fault1_15": "绝缘漏电1级",
  "50661.bms2.2bcu1fault1_2": "单体过压1级",
  "50661.bms2.2bcu1fault1_3": "单体欠压1级",
  "50661.bms2.2bcu1fault1_4": "单体过温1级",
  "50661.bms2.2bcu1fault1_5": "单体低温1级",
  "50661.bms2.2bcu1fault1_6": "压差过大1级",
  "50661.bms2.2bcu1fault1_7": "温差过大1级",
  "50661.bms2.2bcu1fault1_8": "电流过大1级",
  "50661.bms2.2bcu1fault1_9": "高压异常1级",
  "50661.bms2.2bcu1fault2_0": "粘连1级",
  "50661.bms2.2bcu1fault2_1": "预充状态1级",
  "50661.bms2.2bcu1fault2_11": "电流异常1级",
  "50661.bms2.2bcu1fault2_15": "PCS状态1级",
  "50661.bms2.2bcu1fault2_2": "供电过高1级",
  "50661.bms2.2bcu1fault2_3": "供电过低1级",
  "50661.bms2.2bcu1fault2_4": "T1高温1级",
  "50661.bms2.2bcu1fault2_5": "T1低温1级",
  "50661.bms2.2bcu1fault2_6": "T2高温1级",
  "50661.bms2.2bcu1fault2_7": "T2低温1级",
  "50661.bms2.2bcu1fault2_8": "均衡过温1级",
  "50661.bms2.2bcu1fault3_10": "开路故障1级",
  "50661.bms2.2bcu1fault3_11": "急停故障1级",
  "50661.bms2.2bcu1fault3_12": "消防故障1级",
  "50661.bms2.2bcu1fault3_13": "控制指令超时1级",
  "50661.bms2.2bcu1fault3_15": "热失控1级",
  "50661.bms2.2bcu1fault3_2": "模拟前端状态1级",
  "50661.bms2.2bcu1fault3_3": "EEPROM状态1级",
  "50661.bms2.2bcu1fault3_4": "RTC状态1级",
  "50661.bms2.2bcu1fault3_5": "ADC状态1级",
  "50661.bms2.2bcu1fault3_6": "SD卡状态1级",
  "50661.bms2.2bcu1fault3_7": "反馈异常1级",
  "50661.bms2.2bcu1fault3_8": "温升过快1级",
  "50661.bms2.2bcu1fault3_9": "极限故障1级",
  "50661.bms2.2bcu1fault4_0": "电池箱过压1级",
  "50661.bms2.2bcu1fault4_1": "电池箱欠压1级",
  "50661.bms2.2bcu1fault4_10": "交流失电故障1级",
  "50661.bms2.2bcu1fault4_2": "防雷器故障1级",
  "50661.bms2.2bcu1fault4_3": "空调故障1级",
  "50661.bms2.2bcu1fault4_5": "水浸故障1级",
  "50661.bms2.2bcu1fault4_6": "门禁故障1级",
  "50661.bms2.2bcu1fault4_7": "气体传感器故障1级",
  "50661.bms2.2bcu2fault1_0": "总压过压2级",
  "50661.bms2.2bcu2fault1_1": "总压欠压2级",
  "50661.bms2.2bcu2fault1_10": "主从通讯2级",
  "50661.bms2.2bcu2fault1_11": "单体电压排线2级",
  "50661.bms2.2bcu2fault1_12": "单体温感排线2级",
  "50661.bms2.2bcu2fault1_14": "SOC过低2级",
  "50661.bms2.2bcu2fault1_15": "绝缘漏电2级",
  "50661.bms2.2bcu2fault1_2": "单体过压2级",
  "50661.bms2.2bcu2fault1_3": "单体欠压2级",
  "50661.bms2.2bcu2fault1_4": "单体过温2级",
  "50661.bms2.2bcu2fault1_5": "单体低温2级",
  "50661.bms2.2bcu2fault1_6": "压差过大2级",
  "50661.bms2.2bcu2fault1_7": "温差过大2级",
  "50661.bms2.2bcu2fault1_8": "电流过大2级",
  "50661.bms2.2bcu2fault1_9": "高压异常2级",
  "50661.bms2.2bcu2fault2_0": "粘连2级",
  "50661.bms2.2bcu2fault2_1": "预充状态2级",
  "50661.bms2.2bcu2fault2_11": "电流异常2级",
  "50661.bms2.2bcu2fault2_15": "PCS状态2级",
  "50661.bms2.2bcu2fault2_2": "供电过高2级",
  "50661.bms2.2bcu2fault2_3": "供电过低2级",
  "50661.bms2.2bcu2fault2_4": "T1高温2级",
  "50661.bms2.2bcu2fault2_5": "T1低温2级",
  "50661.bms2.2bcu2fault2_6": "T2高温2级",
  "50661.bms2.2bcu2fault2_7": "T2低温2级",
  "50661.bms2.2bcu2fault2_8": "均衡过温2级",
  "50661.bms2.2bcu2fault3_10": "开路故障2级",
  "50661.bms2.2bcu2fault3_11": "急停故障2级",
  "50661.bms2.2bcu2fault3_12": "消防故障2级",
  "50661.bms2.2bcu2fault3_13": "控制指令超时2级",
  "50661.bms2.2bcu2fault3_15": "热失控2级",
  "50661.bms2.2bcu2fault3_2": "模拟前端状态2级",
  "50661.bms2.2bcu2fault3_3": "EEPROM状态2级",
  "50661.bms2.2bcu2fault3_4": "RTC状态2级",
  "50661.bms2.2bcu2fault3_5": "ADC状态2级",
  "50661.bms2.2bcu2fault3_6": "SD卡状态2级",
  "50661.bms2.2bcu2fault3_7": "反馈异常2级",
  "50661.bms2.2bcu2fault3_8": "温升过快2级",
  "50661.bms2.2bcu2fault3_9": "极限故障2级",
  "50661.bms2.2bcu2fault4_0": "电池箱过压2级",
  "50661.bms2.2bcu2fault4_1": "电池箱欠压2级",
  "50661.bms2.2bcu2fault4_10": "交流失电故障2级",
  "50661.bms2.2bcu2fault4_2": "防雷器故障2级",
  "50661.bms2.2bcu2fault4_3": "空调故障2级",
  "50661.bms2.2bcu2fault4_5": "水浸故障2级",
  "50661.bms2.2bcu2fault4_6": "门禁故障2级",
  "50661.bms2.2bcu2fault4_7": "气体传感器故障2级",
  "50661.bms2.2bcu3fault1_0": "总压过压3级",
  "50661.bms2.2bcu3fault1_1": "总压欠压3级",
  "50661.bms2.2bcu3fault1_10": "主从通讯3级",
  "50661.bms2.2bcu3fault1_11": "单体电压排线3级",
  "50661.bms2.2bcu3fault1_12": "单体温感排线3级",
  "50661.bms2.2bcu3fault1_14": "SOC过低3级",
  "50661.bms2.2bcu3fault1_15": "绝缘漏电3级",
  "50661.bms2.2bcu3fault1_2": "单体过压3级",
  "50661.bms2.2bcu3fault1_3": "单体欠压3级",
  "50661.bms2.2bcu3fault1_4": "单体过温3级",
  "50661.bms2.2bcu3fault1_5": "单体低温3级",
  "50661.bms2.2bcu3fault1_6": "压差过大3级",
  "50661.bms2.2bcu3fault1_7": "温差过大3级",
  "50661.bms2.2bcu3fault1_8": "电流过大3级",
  "50661.bms2.2bcu3fault1_9": "高压异常3级",
  "50661.bms2.2bcu3fault2_0": "粘连3级",
  "50661.bms2.2bcu3fault2_1": "预充状态3级",
  "50661.bms2.2bcu3fault2_11": "电流异常3级",
  "50661.bms2.2bcu3fault2_15": "PCS状态3级",
  "50661.bms2.2bcu3fault2_2": "供电过高3级",
  "50661.bms2.2bcu3fault2_3": "供电过低3级",
  "50661.bms2.2bcu3fault2_4": "T1高温3级",
  "50661.bms2.2bcu3fault2_5": "T1低温3级",
  "50661.bms2.2bcu3fault2_6": "T2高温3级",
  "50661.bms2.2bcu3fault2_7": "T2低温3级",
  "50661.bms2.2bcu3fault2_8": "均衡过温3级",
  "50661.bms2.2bcu3fault3_10": "开路故障3级",
  "50661.bms2.2bcu3fault3_11": "急停故障3级",
  "50661.bms2.2bcu3fault3_12": "消防故障3级",
  "50661.bms2.2bcu3fault3_13": "控制指令超时3级",
  "50661.bms2.2bcu3fault3_15": "热失控3级",
  "50661.bms2.2bcu3fault3_2": "模拟前端状态3级",
  "50661.bms2.2bcu3fault3_3": "EEPROM状态3级",
  "50661.bms2.2bcu3fault3_4": "RTC状态3级",
  "50661.bms2.2bcu3fault3_5": "ADC状态3级",
  "50661.bms2.2bcu3fault3_6": "SD卡状态3级",
  "50661.bms2.2bcu3fault3_7": "反馈异常3级",
  "50661.bms2.2bcu3fault3_8": "温升过快3级",
  "50661.bms2.2bcu3fault3_9": "极限故障3级",
  "50661.bms2.2bcu3fault4_0": "电池箱过压3级",
  "50661.bms2.2bcu3fault4_1": "电池箱欠压3级",
  "50661.bms2.2bcu3fault4_10": "交流失电故障3级",
  "50661.bms2.2bcu3fault4_2": "防雷器故障3级",
  "50661.bms2.2bcu3fault4_3": "空调故障3级",
  "50661.bms2.2bcu3fault4_5": "水浸故障3级",
  "50661.bms2.2bcu3fault4_6": "门禁故障3级",
  "50661.bms2.2bcu3fault4_7": "气体传感器故障3级",
  "50661.bms3.3bcu1fault1_0": "总压过压1级",
  "50661.bms3.3bcu1fault1_1": "总压欠压1级",
  "50661.bms3.3bcu1fault1_10": "主从通讯1级",
  "50661.bms3.3bcu1fault1_11": "单体电压排线1级",
  "50661.bms3.3bcu1fault1_12": "单体温感排线1级",
  "50661.bms3.3bcu1fault1_14": "SOC过低1级",
  "50661.bms3.3bcu1fault1_15": "绝缘漏电1级",
  "50661.bms3.3bcu1fault1_2": "单体过压1级",
  "50661.bms3.3bcu1fault1_3": "单体欠压1级",
  "50661.bms3.3bcu1fault1_4": "单体过温1级",
  "50661.bms3.3bcu1fault1_5": "单体低温1级",
  "50661.bms3.3bcu1fault1_6": "压差过大1级",
  "50661.bms3.3bcu1fault1_7": "温差过大1级",
  "50661.bms3.3bcu1fault1_8": "电流过大1级",
  "50661.bms3.3bcu1fault1_9": "高压异常1级",
  "50661.bms3.3bcu1fault2_0": "粘连1级",
  "50661.bms3.3bcu1fault2_1": "预充状态1级",
  "50661.bms3.3bcu1fault2_11": "电流异常1级",
  "50661.bms3.3bcu1fault2_15": "PCS状态1级",
  "50661.bms3.3bcu1fault2_2": "供电过高1级",
  "50661.bms3.3bcu1fault2_3": "供电过低1级",
  "50661.bms3.3bcu1fault2_4": "T1高温1级",
  "50661.bms3.3bcu1fault2_5": "T1低温1级",
  "50661.bms3.3bcu1fault2_6": "T2高温1级",
  "50661.bms3.3bcu1fault2_7": "T2低温1级",
  "50661.bms3.3bcu1fault2_8": "均衡过温1级",
  "50661.bms3.3bcu1fault3_10": "开路故障1级",
  "50661.bms3.3bcu1fault3_11": "急停故障1级",
  "50661.bms3.3bcu1fault3_12": "消防故障1级",
  "50661.bms3.3bcu1fault3_13": "控制指令超时1级",
  "50661.bms3.3bcu1fault3_15": "热失控1级",
  "50661.bms3.3bcu1fault3_2": "模拟前端状态1级",
  "50661.bms3.3bcu1fault3_3": "EEPROM状态1级",
  "50661.bms3.3bcu1fault3_4": "RTC状态1级",
  "50661.bms3.3bcu1fault3_5": "ADC状态1级",
  "50661.bms3.3bcu1fault3_6": "SD卡状态1级",
  "50661.bms3.3bcu1fault3_7": "反馈异常1级",
  "50661.bms3.3bcu1fault3_8": "温升过快1级",
  "50661.bms3.3bcu1fault3_9": "极限故障1级",
  "50661.bms3.3bcu1fault4_0": "电池箱过压1级",
  "50661.bms3.3bcu1fault4_1": "电池箱欠压1级",
  "50661.bms3.3bcu1fault4_10": "交流失电故障1级",
  "50661.bms3.3bcu1fault4_2": "防雷器故障1级",
  "50661.bms3.3bcu1fault4_3": "空调故障1级",
  "50661.bms3.3bcu1fault4_5": "水浸故障1级",
  "50661.bms3.3bcu1fault4_6": "门禁故障1级",
  "50661.bms3.3bcu1fault4_7": "气体传感器故障1级",
  "50661.bms3.3bcu2fault1_0": "总压过压2级",
  "50661.bms3.3bcu2fault1_1": "总压欠压2级",
  "50661.bms3.3bcu2fault1_10": "主从通讯2级",
  "50661.bms3.3bcu2fault1_11": "单体电压排线2级",
  "50661.bms3.3bcu2fault1_12": "单体温感排线2级",
  "50661.bms3.3bcu2fault1_14": "SOC过低2级",
  "50661.bms3.3bcu2fault1_15": "绝缘漏电2级",
  "50661.bms3.3bcu2fault1_2": "单体过压2级",
  "50661.bms3.3bcu2fault1_3": "单体欠压2级",
  "50661.bms3.3bcu2fault1_4": "单体过温2级",
  "50661.bms3.3bcu2fault1_5": "单体低温2级",
  "50661.bms3.3bcu2fault1_6": "压差过大2级",
  "50661.bms3.3bcu2fault1_7": "温差过大2级",
  "50661.bms3.3bcu2fault1_8": "电流过大2级",
  "50661.bms3.3bcu2fault1_9": "高压异常2级",
  "50661.bms3.3bcu2fault2_0": "粘连2级",
  "50661.bms3.3bcu2fault2_1": "预充状态2级",
  "50661.bms3.3bcu2fault2_11": "电流异常2级",
  "50661.bms3.3bcu2fault2_15": "PCS状态2级",
  "50661.bms3.3bcu2fault2_2": "供电过高2级",
  "50661.bms3.3bcu2fault2_3": "供电过低2级",
  "50661.bms3.3bcu2fault2_4": "T1高温2级",
  "50661.bms3.3bcu2fault2_5": "T1低温2级",
  "50661.bms3.3bcu2fault2_6": "T2高温2级",
  "50661.bms3.3bcu2fault2_7": "T2低温2级",
  "50661.bms3.3bcu2fault2_8": "均衡过温2级",
  "50661.bms3.3bcu2fault3_10": "开路故障2级",
  "50661.bms3.3bcu2fault3_11": "急停故障2级",
  "50661.bms3.3bcu2fault3_12": "消防故障2级",
  "50661.bms3.3bcu2fault3_13": "控制指令超时2级",
  "50661.bms3.3bcu2fault3_15": "热失控2级",
  "50661.bms3.3bcu2fault3_2": "模拟前端状态2级",
  "50661.bms3.3bcu2fault3_3": "EEPROM状态2级",
  "50661.bms3.3bcu2fault3_4": "RTC状态2级",
  "50661.bms3.3bcu2fault3_5": "ADC状态2级",
  "50661.bms3.3bcu2fault3_6": "SD卡状态2级",
  "50661.bms3.3bcu2fault3_7": "反馈异常2级",
  "50661.bms3.3bcu2fault3_8": "温升过快2级",
  "50661.bms3.3bcu2fault3_9": "极限故障2级",
  "50661.bms3.3bcu2fault4_0": "电池箱过压2级",
  "50661.bms3.3bcu2fault4_1": "电池箱欠压2级",
  "50661.bms3.3bcu2fault4_10": "交流失电故障2级",
  "50661.bms3.3bcu2fault4_2": "防雷器故障2级",
  "50661.bms3.3bcu2fault4_3": "空调故障2级",
  "50661.bms3.3bcu2fault4_5": "水浸故障2级",
  "50661.bms3.3bcu2fault4_6": "门禁故障2级",
  "50661.bms3.3bcu2fault4_7": "气体传感器故障2级",
  "50661.bms3.3bcu3fault1_0": "总压过压3级",
  "50661.bms3.3bcu3fault1_1": "总压欠压3级",
  "50661.bms3.3bcu3fault1_10": "主从通讯3级",
  "50661.bms3.3bcu3fault1_11": "单体电压排线3级",
  "50661.bms3.3bcu3fault1_12": "单体温感排线3级",
  "50661.bms3.3bcu3fault1_14": "SOC过低3级",
  "50661.bms3.3bcu3fault1_15": "绝缘漏电3级",
  "50661.bms3.3bcu3fault1_2": "单体过压3级",
  "50661.bms3.3bcu3fault1_3": "单体欠压3级",
  "50661.bms3.3bcu3fault1_4": "单体过温3级",
  "50661.bms3.3bcu3fault1_5": "单体低温3级",
  "50661.bms3.3bcu3fault1_6": "压差过大3级",
  "50661.bms3.3bcu3fault1_7": "温差过大3级",
  "50661.bms3.3bcu3fault1_8": "电流过大3级",
  "50661.bms3.3bcu3fault1_9": "高压异常3级",
  "50661.bms3.3bcu3fault2_0": "粘连3级",
  "50661.bms3.3bcu3fault2_1": "预充状态3级",
  "50661.bms3.3bcu3fault2_11": "电流异常3级",
  "50661.bms3.3bcu3fault2_15": "PCS状态3级",
  "50661.bms3.3bcu3fault2_2": "供电过高3级",
  "50661.bms3.3bcu3fault2_3": "供电过低3级",
  "50661.bms3.3bcu3fault2_4": "T1高温3级",
  "50661.bms3.3bcu3fault2_5": "T1低温3级",
  "50661.bms3.3bcu3fault2_6": "T2高温3级",
  "50661.bms3.3bcu3fault2_7": "T2低温3级",
  "50661.bms3.3bcu3fault2_8": "均衡过温3级",
  "50661.bms3.3bcu3fault3_10": "开路故障3级",
  "50661.bms3.3bcu3fault3_11": "急停故障3级",
  "50661.bms3.3bcu3fault3_12": "消防故障3级",
  "50661.bms3.3bcu3fault3_13": "控制指令超时3级",
  "50661.bms3.3bcu3fault3_15": "热失控3级",
  "50661.bms3.3bcu3fault3_2": "模拟前端状态3级",
  "50661.bms3.3bcu3fault3_3": "EEPROM状态3级",
  "50661.bms3.3bcu3fault3_4": "RTC状态3级",
  "50661.bms3.3bcu3fault3_5": "ADC状态3级",
  "50661.bms3.3bcu3fault3_6": "SD卡状态3级",
  "50661.bms3.3bcu3fault3_7": "反馈异常3级",
  "50661.bms3.3bcu3fault3_8": "温升过快3级",
  "50661.bms3.3bcu3fault3_9": "极限故障3级",
  "50661.bms3.3bcu3fault4_0": "电池箱过压3级",
  "50661.bms3.3bcu3fault4_1": "电池箱欠压3级",
  "50661.bms3.3bcu3fault4_10": "交流失电故障3级",
  "50661.bms3.3bcu3fault4_2": "防雷器故障3级",
  "50661.bms3.3bcu3fault4_3": "空调故障3级",
  "50661.bms3.3bcu3fault4_5": "水浸故障3级",
  "50661.bms3.3bcu3fault4_6": "门禁故障3级",
  "50661.bms3.3bcu3fault4_7": "气体传感器故障3级",
  "50661.bms4.4bcu1fault1_0": "总压过压1级",
  "50661.bms4.4bcu1fault1_1": "总压欠压1级",
  "50661.bms4.4bcu1fault1_10": "主从通讯1级",
  "50661.bms4.4bcu1fault1_11": "单体电压排线1级",
  "50661.bms4.4bcu1fault1_12": "单体温感排线1级",
  "50661.bms4.4bcu1fault1_14": "SOC过低1级",
  "50661.bms4.4bcu1fault1_15": "绝缘漏电1级",
  "50661.bms4.4bcu1fault1_2": "单体过压1级",
  "50661.bms4.4bcu1fault1_3": "单体欠压1级",
  "50661.bms4.4bcu1fault1_4": "单体过温1级",
  "50661.bms4.4bcu1fault1_5": "单体低温1级",
  "50661.bms4.4bcu1fault1_6": "压差过大1级",
  "50661.bms4.4bcu1fault1_7": "温差过大1级",
  "50661.bms4.4bcu1fault1_8": "电流过大1级",
  "50661.bms4.4bcu1fault1_9": "高压异常1级",
  "50661.bms4.4bcu1fault2_0": "粘连1级",
  "50661.bms4.4bcu1fault2_1": "预充状态1级",
  "50661.bms4.4bcu1fault2_11": "电流异常1级",
  "50661.bms4.4bcu1fault2_15": "PCS状态1级",
  "50661.bms4.4bcu1fault2_2": "供电过高1级",
  "50661.bms4.4bcu1fault2_3": "供电过低1级",
  "50661.bms4.4bcu1fault2_4": "T1高温1级",
  "50661.bms4.4bcu1fault2_5": "T1低温1级",
  "50661.bms4.4bcu1fault2_6": "T2高温1级",
  "50661.bms4.4bcu1fault2_7": "T2低温1级",
  "50661.bms4.4bcu1fault2_8": "均衡过温1级",
  "50661.bms4.4bcu1fault3_10": "开路故障1级",
  "50661.bms4.4bcu1fault3_11": "急停故障1级",
  "50661.bms4.4bcu1fault3_12": "消防故障1级",
  "50661.bms4.4bcu1fault3_13": "控制指令超时1级",
  "50661.bms4.4bcu1fault3_15": "热失控1级",
  "50661.bms4.4bcu1fault3_2": "模拟前端状态1级",
  "50661.bms4.4bcu1fault3_3": "EEPROM状态1级",
  "50661.bms4.4bcu1fault3_4": "RTC状态1级",
  "50661.bms4.4bcu1fault3_5": "ADC状态1级",
  "50661.bms4.4bcu1fault3_6": "SD卡状态1级",
  "50661.bms4.4bcu1fault3_7": "反馈异常1级",
  "50661.bms4.4bcu1fault3_8": "温升过快1级",
  "50661.bms4.4bcu1fault3_9": "极限故障1级",
  "50661.bms4.4bcu1fault4_0": "电池箱过压1级",
  "50661.bms4.4bcu1fault4_1": "电池箱欠压1级",
  "50661.bms4.4bcu1fault4_10": "交流失电故障1级",
  "50661.bms4.4bcu1fault4_2": "防雷器故障1级",
  "50661.bms4.4bcu1fault4_3": "空调故障1级",
  "50661.bms4.4bcu1fault4_5": "水浸故障1级",
  "50661.bms4.4bcu1fault4_6": "门禁故障1级",
  "50661.bms4.4bcu1fault4_7": "气体传感器故障1级",
  "50661.bms4.4bcu2fault1_0": "总压过压2级",
  "50661.bms4.4bcu2fault1_1": "总压欠压2级",
  "50661.bms4.4bcu2fault1_10": "主从通讯2级",
  "50661.bms4.4bcu2fault1_11": "单体电压排线2级",
  "50661.bms4.4bcu2fault1_12": "单体温感排线2级",
  "50661.bms4.4bcu2fault1_14": "SOC过低2级",
  "50661.bms4.4bcu2fault1_15": "绝缘漏电2级",
  "50661.bms4.4bcu2fault1_2": "单体过压2级",
  "50661.bms4.4bcu2fault1_3": "单体欠压2级",
  "50661.bms4.4bcu2fault1_4": "单体过温2级",
  "50661.bms4.4bcu2fault1_5": "单体低温2级",
  "50661.bms4.4bcu2fault1_6": "压差过大2级",
  "50661.bms4.4bcu2fault1_7": "温差过大2级",
  "50661.bms4.4bcu2fault1_8": "电流过大2级",
  "50661.bms4.4bcu2fault1_9": "高压异常2级",
  "50661.bms4.4bcu2fault2_0": "粘连2级",
  "50661.bms4.4bcu2fault2_1": "预充状态2级",
  "50661.bms4.4bcu2fault2_11": "电流异常2级",
  "50661.bms4.4bcu2fault2_15": "PCS状态2级",
  "50661.bms4.4bcu2fault2_2": "供电过高2级",
  "50661.bms4.4bcu2fault2_3": "供电过低2级",
  "50661.bms4.4bcu2fault2_4": "T1高温2级",
  "50661.bms4.4bcu2fault2_5": "T1低温2级",
  "50661.bms4.4bcu2fault2_6": "T2高温2级",
  "50661.bms4.4bcu2fault2_7": "T2低温2级",
  "50661.bms4.4bcu2fault2_8": "均衡过温2级",
  "50661.bms4.4bcu2fault3_10": "开路故障2级",
  "50661.bms4.4bcu2fault3_11": "急停故障2级",
  "50661.bms4.4bcu2fault3_12": "消防故障2级",
  "50661.bms4.4bcu2fault3_13": "控制指令超时2级",
  "50661.bms4.4bcu2fault3_15": "热失控2级",
  "50661.bms4.4bcu2fault3_2": "模拟前端状态2级",
  "50661.bms4.4bcu2fault3_3": "EEPROM状态2级",
  "50661.bms4.4bcu2fault3_4": "RTC状态2级",
  "50661.bms4.4bcu2fault3_5": "ADC状态2级",
  "50661.bms4.4bcu2fault3_6": "SD卡状态2级",
  "50661.bms4.4bcu2fault3_7": "反馈异常2级",
  "50661.bms4.4bcu2fault3_8": "温升过快2级",
  "50661.bms4.4bcu2fault3_9": "极限故障2级",
  "50661.bms4.4bcu2fault4_0": "电池箱过压2级",
  "50661.bms4.4bcu2fault4_1": "电池箱欠压2级",
  "50661.bms4.4bcu2fault4_10": "交流失电故障2级",
  "50661.bms4.4bcu2fault4_2": "防雷器故障2级",
  "50661.bms4.4bcu2fault4_3": "空调故障2级",
  "50661.bms4.4bcu2fault4_5": "水浸故障2级",
  "50661.bms4.4bcu2fault4_6": "门禁故障2级",
  "50661.bms4.4bcu2fault4_7": "气体传感器故障2级",
  "50661.bms4.4bcu3fault1_0": "总压过压3级",
  "50661.bms4.4bcu3fault1_1": "总压欠压3级",
  "50661.bms4.4bcu3fault1_10": "主从通讯3级",
  "50661.bms4.4bcu3fault1_11": "单体电压排线3级",
  "50661.bms4.4bcu3fault1_12": "单体温感排线3级",
  "50661.bms4.4bcu3fault1_14": "SOC过低3级",
  "50661.bms4.4bcu3fault1_15": "绝缘漏电3级",
  "50661.bms4.4bcu3fault1_2": "单体过压3级",
  "50661.bms4.4bcu3fault1_3": "单体欠压3级",
  "50661.bms4.4bcu3fault1_4": "单体过温3级",
  "50661.bms4.4bcu3fault1_5": "单体低温3级",
  "50661.bms4.4bcu3fault1_6": "压差过大3级",
  "50661.bms4.4bcu3fault1_7": "温差过大3级",
  "50661.bms4.4bcu3fault1_8": "电流过大3级",
  "50661.bms4.4bcu3fault1_9": "高压异常3级",
  "50661.bms4.4bcu3fault2_0": "粘连3级",
  "50661.bms4.4bcu3fault2_1": "预充状态3级",
  "50661.bms4.4bcu3fault2_11": "电流异常3级",
  "50661.bms4.4bcu3fault2_15": "PCS状态3级",
  "50661.bms4.4bcu3fault2_2": "供电过高3级",
  "50661.bms4.4bcu3fault2_3": "供电过低3级",
  "50661.bms4.4bcu3fault2_4": "T1高温3级",
  "50661.bms4.4bcu3fault2_5": "T1低温3级",
  "50661.bms4.4bcu3fault2_6": "T2高温3级",
  "50661.bms4.4bcu3fault2_7": "T2低温3级",
  "50661.bms4.4bcu3fault2_8": "均衡过温3级",
  "50661.bms4.4bcu3fault3_10": "开路故障3级",
  "50661.bms4.4bcu3fault3_11": "急停故障3级",
  "50661.bms4.4bcu3fault3_12": "消防故障3级",
  "50661.bms4.4bcu3fault3_13": "控制指令超时3级",
  "50661.bms4.4bcu3fault3_15": "热失控3级",
  "50661.bms4.4bcu3fault3_2": "模拟前端状态3级",
  "50661.bms4.4bcu3fault3_3": "EEPROM状态3级",
  "50661.bms4.4bcu3fault3_4": "RTC状态3级",
  "50661.bms4.4bcu3fault3_5": "ADC状态3级",
  "50661.bms4.4bcu3fault3_6": "SD卡状态3级",
  "50661.bms4.4bcu3fault3_7": "反馈异常3级",
  "50661.bms4.4bcu3fault3_8": "温升过快3级",
  "50661.bms4.4bcu3fault3_9": "极限故障3级",
  "50661.bms4.4bcu3fault4_0": "电池箱过压3级",
  "50661.bms4.4bcu3fault4_1": "电池箱欠压3级",
  "50661.bms4.4bcu3fault4_10": "交流失电故障3级",
  "50661.bms4.4bcu3fault4_2": "防雷器故障3级",
  "50661.bms4.4bcu3fault4_3": "空调故障3级",
  "50661.bms4.4bcu3fault4_5": "水浸故障3级",
  "50661.bms4.4bcu3fault4_6": "门禁故障3级",
  "50661.bms4.4bcu3fault4_7": "气体传感器故障3级",
  "50661.bms5.5bcu1fault1_0": "总压过压1级",
  "50661.bms5.5bcu1fault1_1": "总压欠压1级",
  "50661.bms5.5bcu1fault1_10": "主从通讯1级",
  "50661.bms5.5bcu1fault1_11": "单体电压排线1级",
  "50661.bms5.5bcu1fault1_12": "单体温感排线1级",
  "50661.bms5.5bcu1fault1_14": "SOC过低1级",
  "50661.bms5.5bcu1fault1_15": "绝缘漏电1级",
  "50661.bms5.5bcu1fault1_2": "单体过压1级",
  "50661.bms5.5bcu1fault1_3": "单体欠压1级",
  "50661.bms5.5bcu1fault1_4": "单体过温1级",
  "50661.bms5.5bcu1fault1_5": "单体低温1级",
  "50661.bms5.5bcu1fault1_6": "压差过大1级",
  "50661.bms5.5bcu1fault1_7": "温差过大1级",
  "50661.bms5.5bcu1fault1_8": "电流过大1级",
  "50661.bms5.5bcu1fault1_9": "高压异常1级",
  "50661.bms5.5bcu1fault2_0": "粘连1级",
  "50661.bms5.5bcu1fault2_1": "预充状态1级",
  "50661.bms5.5bcu1fault2_11": "电流异常1级",
  "50661.bms5.5bcu1fault2_15": "PCS状态1级",
  "50661.bms5.5bcu1fault2_2": "供电过高1级",
  "50661.bms5.5bcu1fault2_3": "供电过低1级",
  "50661.bms5.5bcu1fault2_4": "T1高温1级",
  "50661.bms5.5bcu1fault2_5": "T1低温1级",
  "50661.bms5.5bcu1fault2_6": "T2高温1级",
  "50661.bms5.5bcu1fault2_7": "T2低温1级",
  "50661.bms5.5bcu1fault2_8": "均衡过温1级",
  "50661.bms5.5bcu1fault3_10": "开路故障1级",
  "50661.bms5.5bcu1fault3_11": "急停故障1级",
  "50661.bms5.5bcu1fault3_12": "消防故障1级",
  "50661.bms5.5bcu1fault3_13": "控制指令超时1级",
  "50661.bms5.5bcu1fault3_15": "热失控1级",
  "50661.bms5.5bcu1fault3_2": "模拟前端状态1级",
  "50661.bms5.5bcu1fault3_3": "EEPROM状态1级",
  "50661.bms5.5bcu1fault3_4": "RTC状态1级",
  "50661.bms5.5bcu1fault3_5": "ADC状态1级",
  "50661.bms5.5bcu1fault3_6": "SD卡状态1级",
  "50661.bms5.5bcu1fault3_7": "反馈异常1级",
  "50661.bms5.5bcu1fault3_8": "温升过快1级",
  "50661.bms5.5bcu1fault3_9": "极限故障1级",
  "50661.bms5.5bcu1fault4_0": "电池箱过压1级",
  "50661.bms5.5bcu1fault4_1": "电池箱欠压1级",
  "50661.bms5.5bcu1fault4_10": "交流失电故障1级",
  "50661.bms5.5bcu1fault4_2": "防雷器故障1级",
  "50661.bms5.5bcu1fault4_3": "空调故障1级",
  "50661.bms5.5bcu1fault4_5": "水浸故障1级",
  "50661.bms5.5bcu1fault4_6": "门禁故障1级",
  "50661.bms5.5bcu1fault4_7": "气体传感器故障1级",
  "50661.bms5.5bcu2fault1_0": "总压过压2级",
  "50661.bms5.5bcu2fault1_1": "总压欠压2级",
  "50661.bms5.5bcu2fault1_10": "主从通讯2级",
  "50661.bms5.5bcu2fault1_11": "单体电压排线2级",
  "50661.bms5.5bcu2fault1_12": "单体温感排线2级",
  "50661.bms5.5bcu2fault1_14": "SOC过低2级",
  "50661.bms5.5bcu2fault1_15": "绝缘漏电2级",
  "50661.bms5.5bcu2fault1_2": "单体过压2级",
  "50661.bms5.5bcu2fault1_3": "单体欠压2级",
  "50661.bms5.5bcu2fault1_4": "单体过温2级",
  "50661.bms5.5bcu2fault1_5": "单体低温2级",
  "50661.bms5.5bcu2fault1_6": "压差过大2级",
  "50661.bms5.5bcu2fault1_7": "温差过大2级",
  "50661.bms5.5bcu2fault1_8": "电流过大2级",
  "50661.bms5.5bcu2fault1_9": "高压异常2级",
  "50661.bms5.5bcu2fault2_0": "粘连2级",
  "50661.bms5.5bcu2fault2_1": "预充状态2级",
  "50661.bms5.5bcu2fault2_11": "电流异常2级",
  "50661.bms5.5bcu2fault2_15": "PCS状态2级",
  "50661.bms5.5bcu2fault2_2": "供电过高2级",
  "50661.bms5.5bcu2fault2_3": "供电过低2级",
  "50661.bms5.5bcu2fault2_4": "T1高温2级",
  "50661.bms5.5bcu2fault2_5": "T1低温2级",
  "50661.bms5.5bcu2fault2_6": "T2高温2级",
  "50661.bms5.5bcu2fault2_7": "T2低温2级",
  "50661.bms5.5bcu2fault2_8": "均衡过温2级",
  "50661.bms5.5bcu2fault3_10": "开路故障2级",
  "50661.bms5.5bcu2fault3_11": "急停故障2级",
  "50661.bms5.5bcu2fault3_12": "消防故障2级",
  "50661.bms5.5bcu2fault3_13": "控制指令超时2级",
  "50661.bms5.5bcu2fault3_15": "热失控2级",
  "50661.bms5.5bcu2fault3_2": "模拟前端状态2级",
  "50661.bms5.5bcu2fault3_3": "EEPROM状态2级",
  "50661.bms5.5bcu2fault3_4": "RTC状态2级",
  "50661.bms5.5bcu2fault3_5": "ADC状态2级",
  "50661.bms5.5bcu2fault3_6": "SD卡状态2级",
  "50661.bms5.5bcu2fault3_7": "反馈异常2级",
  "50661.bms5.5bcu2fault3_8": "温升过快2级",
  "50661.bms5.5bcu2fault3_9": "极限故障2级",
  "50661.bms5.5bcu2fault4_0": "电池箱过压2级",
  "50661.bms5.5bcu2fault4_1": "电池箱欠压2级",
  "50661.bms5.5bcu2fault4_10": "交流失电故障2级",
  "50661.bms5.5bcu2fault4_2": "防雷器故障2级",
  "50661.bms5.5bcu2fault4_3": "空调故障2级",
  "50661.bms5.5bcu2fault4_5": "水浸故障2级",
  "50661.bms5.5bcu2fault4_6": "门禁故障2级",
  "50661.bms5.5bcu2fault4_7": "气体传感器故障2级",
  "50661.bms5.5bcu3fault1_0": "总压过压3级",
  "50661.bms5.5bcu3fault1_1": "总压欠压3级",
  "50661.bms5.5bcu3fault1_10": "主从通讯3级",
  "50661.bms5.5bcu3fault1_11": "单体电压排线3级",
  "50661.bms5.5bcu3fault1_12": "单体温感排线3级",
  "50661.bms5.5bcu3fault1_14": "SOC过低3级",
  "50661.bms5.5bcu3fault1_15": "绝缘漏电3级",
  "50661.bms5.5bcu3fault1_2": "单体过压3级",
  "50661.bms5.5bcu3fault1_3": "单体欠压3级",
  "50661.bms5.5bcu3fault1_4": "单体过温3级",
  "50661.bms5.5bcu3fault1_5": "单体低温3级",
  "50661.bms5.5bcu3fault1_6": "压差过大3级",
  "50661.bms5.5bcu3fault1_7": "温差过大3级",
  "50661.bms5.5bcu3fault1_8": "电流过大3级",
  "50661.bms5.5bcu3fault1_9": "高压异常3级",
  "50661.bms5.5bcu3fault2_0": "粘连3级",
  "50661.bms5.5bcu3fault2_1": "预充状态3级",
  "50661.bms5.5bcu3fault2_11": "电流异常3级",
  "50661.bms5.5bcu3fault2_15": "PCS状态3级",
  "50661.bms5.5bcu3fault2_2": "供电过高3级",
  "50661.bms5.5bcu3fault2_3": "供电过低3级",
  "50661.bms5.5bcu3fault2_4": "T1高温3级",
  "50661.bms5.5bcu3fault2_5": "T1低温3级",
  "50661.bms5.5bcu3fault2_6": "T2高温3级",
  "50661.bms5.5bcu3fault2_7": "T2低温3级",
  "50661.bms5.5bcu3fault2_8": "均衡过温3级",
  "50661.bms5.5bcu3fault3_10": "开路故障3级",
  "50661.bms5.5bcu3fault3_11": "急停故障3级",
  "50661.bms5.5bcu3fault3_12": "消防故障3级",
  "50661.bms5.5bcu3fault3_13": "控制指令超时3级",
  "50661.bms5.5bcu3fault3_15": "热失控3级",
  "50661.bms5.5bcu3fault3_2": "模拟前端状态3级",
  "50661.bms5.5bcu3fault3_3": "EEPROM状态3级",
  "50661.bms5.5bcu3fault3_4": "RTC状态3级",
  "50661.bms5.5bcu3fault3_5": "ADC状态3级",
  "50661.bms5.5bcu3fault3_6": "SD卡状态3级",
  "50661.bms5.5bcu3fault3_7": "反馈异常3级",
  "50661.bms5.5bcu3fault3_8": "温升过快3级",
  "50661.bms5.5bcu3fault3_9": "极限故障3级",
  "50661.bms5.5bcu3fault4_0": "电池箱过压3级",
  "50661.bms5.5bcu3fault4_1": "电池箱欠压3级",
  "50661.bms5.5bcu3fault4_10": "交流失电故障3级",
  "50661.bms5.5bcu3fault4_2": "防雷器故障3级",
  "50661.bms5.5bcu3fault4_3": "空调故障3级",
  "50661.bms5.5bcu3fault4_5": "水浸故障3级",
  "50661.bms5.5bcu3fault4_6": "门禁故障3级",
  "50661.bms5.5bcu3fault4_7": "气体传感器故障3级",
  "50661.lcs.dishotlock": "排气温度过高锁定",
  "50661.lcs.invcomfalut": "变频器通讯故障",
  "50661.lcs.invgenlock": "变频器其他故障锁定",
  "50661.lcs.invoclock": "变频器过流锁定",
  "50661.lcs.invotlock": "变频器过温锁定",
  "50661.lcs.invovlock": "变频器过压锁定",
  "50661.lcs.invphlock": "变频器缺相锁定",
  "50661.lcs.invuvlock": "变频器欠压锁定",
  "50661.lcs.iwtsfalut": "回水温感故障",
  "50661.lcs.owhtalarm": "出水高温",
  "50661.lcs.owltalarm": "出水低温",
  "50661.lcs.owopalarm": "出水压力过高告警",
  "50661.lcs.owtsfalut": "出水温感故障",
  "50661.lcs.syshplock": "系统高压锁定",
  "50661.lcs.syslplock": "系统低压锁定",
  "50661.lcs.sysopalarm": "系统压力过高告警",
  "50661.lcs.wateralarm": "补水告警",
  "50661.ems.comStatus.0": "离线",
  "50661.ems.comStatus.1": "在线",
  "50661.pcs.acalarm1_0.0": "正常",
  "50661.pcs.acalarm1_0.1": "告警",
  "50661.pcs.acalarm1_1.0": "正常",
  "50661.pcs.acalarm1_1.1": "告警",
  "50661.pcs.acalarm1_10.0": "正常",
  "50661.pcs.acalarm1_10.1": "告警",
  "50661.pcs.acalarm1_11.0": "正常",
  "50661.pcs.acalarm1_11.1": "告警",
  "50661.pcs.acalarm1_12.0": "正常",
  "50661.pcs.acalarm1_12.1": "告警",
  "50661.pcs.acalarm1_2.0": "正常",
  "50661.pcs.acalarm1_2.1": "告警",
  "50661.pcs.acalarm1_3.0": "正常",
  "50661.pcs.acalarm1_3.1": "告警",
  "50661.pcs.acalarm1_4.0": "正常",
  "50661.pcs.acalarm1_4.1": "告警",
  "50661.pcs.acalarm1_5.0": "正常",
  "50661.pcs.acalarm1_5.1": "告警",
  "50661.pcs.acalarm1_6.0": "正常",
  "50661.pcs.acalarm1_6.1": "告警",
  "50661.pcs.acalarm1_7.0": "正常",
  "50661.pcs.acalarm1_7.1": "告警",
  "50661.pcs.acalarm1_8.0": "正常",
  "50661.pcs.acalarm1_8.1": "告警",
  "50661.pcs.acalarm1_9.0": "正常",
  "50661.pcs.acalarm1_9.1": "告警",
  "50661.pcs.acfault1_0.0": "正常",
  "50661.pcs.acfault1_0.1": "告警",
  "50661.pcs.acfault1_1.0": "正常",
  "50661.pcs.acfault1_1.1": "告警",
  "50661.pcs.acfault1_10.0": "正常",
  "50661.pcs.acfault1_10.1": "告警",
  "50661.pcs.acfault1_11.0": "正常",
  "50661.pcs.acfault1_11.1": "告警",
  "50661.pcs.acfault1_12.0": "正常",
  "50661.pcs.acfault1_12.1": "告警",
  "50661.pcs.acfault1_13.0": "正常",
  "50661.pcs.acfault1_13.1": "告警",
  "50661.pcs.acfault1_14.0": "正常",
  "50661.pcs.acfault1_14.1": "告警",
  "50661.pcs.acfault1_15.0": "正常",
  "50661.pcs.acfault1_15.1": "告警",
  "50661.pcs.acfault1_2.0": "正常",
  "50661.pcs.acfault1_2.1": "告警",
  "50661.pcs.acfault1_3.0": "正常",
  "50661.pcs.acfault1_3.1": "告警",
  "50661.pcs.acfault1_4.0": "正常",
  "50661.pcs.acfault1_4.1": "告警",
  "50661.pcs.acfault1_5.0": "正常",
  "50661.pcs.acfault1_5.1": "告警",
  "50661.pcs.acfault1_6.0": "正常",
  "50661.pcs.acfault1_6.1": "告警",
  "50661.pcs.acfault1_7.0": "正常",
  "50661.pcs.acfault1_7.1": "告警",
  "50661.pcs.acfault1_8.0": "正常",
  "50661.pcs.acfault1_8.1": "告警",
  "50661.pcs.acfault1_9.0": "正常",
  "50661.pcs.acfault1_9.1": "告警",
  "50661.pcs.acfault2_0.0": "正常",
  "50661.pcs.acfault2_0.1": "告警",
  "50661.pcs.acfault2_1.0": "正常",
  "50661.pcs.acfault2_1.1": "告警",
  "50661.pcs.acfault2_2.0": "正常",
  "50661.pcs.acfault2_2.1": "告警",
  "50661.pcs.acfault2_3.0": "正常",
  "50661.pcs.acfault2_3.1": "告警",
  "50661.pcs.acfault2_4.0": "正常",
  "50661.pcs.acfault2_4.1": "告警",
  "50661.pcs.acfault2_5.0": "正常",
  "50661.pcs.acfault2_5.1": "告警",
  "50661.pcs.acfault2_6.0": "正常",
  "50661.pcs.acfault2_6.1": "告警",
  "50661.pcs.acfault2_7.0": "正常",
  "50661.pcs.acfault2_7.1": "告警",
  "50661.pcs.acfault2_8.0": "正常",
  "50661.pcs.acfault2_8.1": "告警",
  "50661.pcs.poweralarm1_0.0": "正常",
  "50661.pcs.poweralarm1_0.1": "告警",
  "50661.pcs.poweralarm1_1.0": "正常",
  "50661.pcs.poweralarm1_1.1": "告警",
  "50661.pcs.poweralarm1_10.0": "正常",
  "50661.pcs.poweralarm1_10.1": "告警",
  "50661.pcs.poweralarm1_11.0": "正常",
  "50661.pcs.poweralarm1_11.1": "告警",
  "50661.pcs.poweralarm1_12.0": "正常",
  "50661.pcs.poweralarm1_12.1": "告警",
  "50661.pcs.poweralarm1_13.0": "正常",
  "50661.pcs.poweralarm1_13.1": "告警",
  "50661.pcs.poweralarm1_14.0": "正常",
  "50661.pcs.poweralarm1_14.1": "告警",
  "50661.pcs.poweralarm1_2.0": "正常",
  "50661.pcs.poweralarm1_2.1": "告警",
  "50661.pcs.poweralarm1_3.0": "正常",
  "50661.pcs.poweralarm1_3.1": "告警",
  "50661.pcs.poweralarm1_4.0": "正常",
  "50661.pcs.poweralarm1_4.1": "告警",
  "50661.pcs.poweralarm1_5.0": "正常",
  "50661.pcs.poweralarm1_5.1": "告警",
  "50661.pcs.poweralarm1_6.0": "正常",
  "50661.pcs.poweralarm1_6.1": "告警",
  "50661.pcs.poweralarm1_7.0": "正常",
  "50661.pcs.poweralarm1_7.1": "告警",
  "50661.pcs.poweralarm1_8.0": "正常",
  "50661.pcs.poweralarm1_8.1": "告警",
  "50661.pcs.poweralarm1_9.0": "正常",
  "50661.pcs.poweralarm1_9.1": "告警",
  "50661.pcs.powerfault1_0.0": "正常",
  "50661.pcs.powerfault1_0.1": "告警",
  "50661.pcs.powerfault1_1.0": "正常",
  "50661.pcs.powerfault1_1.1": "告警",
  "50661.pcs.powerfault1_10.0": "正常",
  "50661.pcs.powerfault1_10.1": "告警",
  "50661.pcs.powerfault1_11.0": "正常",
  "50661.pcs.powerfault1_11.1": "告警",
  "50661.pcs.powerfault1_12.0": "正常",
  "50661.pcs.powerfault1_12.1": "告警",
  "50661.pcs.powerfault1_13.0": "正常",
  "50661.pcs.powerfault1_13.1": "告警",
  "50661.pcs.powerfault1_14.0": "正常",
  "50661.pcs.powerfault1_14.1": "告警",
  "50661.pcs.powerfault1_15.0": "正常",
  "50661.pcs.powerfault1_15.1": "告警",
  "50661.pcs.powerfault1_2.0": "正常",
  "50661.pcs.powerfault1_2.1": "告警",
  "50661.pcs.powerfault1_3.0": "正常",
  "50661.pcs.powerfault1_3.1": "告警",
  "50661.pcs.powerfault1_4.0": "正常",
  "50661.pcs.powerfault1_4.1": "告警",
  "50661.pcs.powerfault1_5.0": "正常",
  "50661.pcs.powerfault1_5.1": "告警",
  "50661.pcs.powerfault1_6.0": "正常",
  "50661.pcs.powerfault1_6.1": "告警",
  "50661.pcs.powerfault1_7.0": "正常",
  "50661.pcs.powerfault1_7.1": "告警",
  "50661.pcs.powerfault1_8.0": "正常",
  "50661.pcs.powerfault1_8.1": "告警",
  "50661.pcs.powerfault1_9.0": "正常",
  "50661.pcs.powerfault1_9.1": "告警",
  "50661.pcs.powerfault2_0.0": "正常",
  "50661.pcs.powerfault2_0.1": "告警",
  "50661.pcs.powerfault2_1.0": "正常",
  "50661.pcs.powerfault2_1.1": "告警",
  "50661.pcs.powerfault2_10.0": "正常",
  "50661.pcs.powerfault2_10.1": "告警",
  "50661.pcs.powerfault2_11.0": "正常",
  "50661.pcs.powerfault2_11.1": "告警",
  "50661.pcs.powerfault2_12.0": "正常",
  "50661.pcs.powerfault2_12.1": "告警",
  "50661.pcs.powerfault2_13.0": "正常",
  "50661.pcs.powerfault2_13.1": "告警",
  "50661.pcs.powerfault2_14.0": "正常",
  "50661.pcs.powerfault2_14.1": "告警",
  "50661.pcs.powerfault2_15.0": "正常",
  "50661.pcs.powerfault2_15.1": "告警",
  "50661.pcs.powerfault2_2.0": "正常",
  "50661.pcs.powerfault2_2.1": "告警",
  "50661.pcs.powerfault2_3.0": "正常",
  "50661.pcs.powerfault2_3.1": "告警",
  "50661.pcs.powerfault2_4.0": "正常",
  "50661.pcs.powerfault2_4.1": "告警",
  "50661.pcs.powerfault2_5.0": "正常",
  "50661.pcs.powerfault2_5.1": "告警",
  "50661.pcs.powerfault2_6.0": "正常",
  "50661.pcs.powerfault2_6.1": "告警",
  "50661.pcs.powerfault2_7.0": "正常",
  "50661.pcs.powerfault2_7.1": "告警",
  "50661.pcs.powerfault2_8.0": "正常",
  "50661.pcs.powerfault2_8.1": "告警",
  "50661.pcs.powerfault2_9.0": "正常",
  "50661.pcs.powerfault2_9.1": "告警",
  "50661.pcs.powerfault3_0.0": "正常",
  "50661.pcs.powerfault3_0.1": "告警",
  "50661.pcs.powerfault3_1.0": "正常",
  "50661.pcs.powerfault3_1.1": "告警",
  "50661.pcs.powerfault3_10.0": "正常",
  "50661.pcs.powerfault3_10.1": "告警",
  "50661.pcs.powerfault3_11.0": "正常",
  "50661.pcs.powerfault3_11.1": "告警",
  "50661.pcs.powerfault3_12.0": "正常",
  "50661.pcs.powerfault3_12.1": "告警",
  "50661.pcs.powerfault3_13.0": "正常",
  "50661.pcs.powerfault3_13.1": "告警",
  "50661.pcs.powerfault3_14.0": "正常",
  "50661.pcs.powerfault3_14.1": "告警",
  "50661.pcs.powerfault3_2.0": "正常",
  "50661.pcs.powerfault3_2.1": "告警",
  "50661.pcs.powerfault3_3.0": "正常",
  "50661.pcs.powerfault3_3.1": "告警",
  "50661.pcs.powerfault3_4.0": "正常",
  "50661.pcs.powerfault3_4.1": "告警",
  "50661.pcs.powerfault3_5.0": "正常",
  "50661.pcs.powerfault3_5.1": "告警",
  "50661.pcs.powerfault3_6.0": "正常",
  "50661.pcs.powerfault3_6.1": "告警",
  "50661.pcs.powerfault3_7.0": "正常",
  "50661.pcs.powerfault3_7.1": "告警",
  "50661.pcs.powerfault3_8.0": "正常",
  "50661.pcs.powerfault3_8.1": "告警",
  "50661.pcs.powerfault3_9.0": "正常",
  "50661.pcs.powerfault3_9.1": "告警",
  "50661.pcs.sysalarm1_0.0": "正常",
  "50661.pcs.sysalarm1_0.1": "告警",
  "50661.pcs.sysalarm1_1.0": "正常",
  "50661.pcs.sysalarm1_1.1": "告警",
  "50661.pcs.sysalarm1_2.0": "正常",
  "50661.pcs.sysalarm1_2.1": "告警",
  "50661.pcs.sysalarm1_3.0": "正常",
  "50661.pcs.sysalarm1_3.1": "告警",
  "50661.pcs.sysalarm1_4.0": "正常",
  "50661.pcs.sysalarm1_4.1": "告警",
  "50661.pcs.sysalarm1_5.0": "正常",
  "50661.pcs.sysalarm1_5.1": "告警",
  "50661.pcs.sysalarm1_6.0": "正常",
  "50661.pcs.sysalarm1_6.1": "告警",
  "50661.pcs.sysalarm1_7.0": "正常",
  "50661.pcs.sysalarm1_7.1": "告警",
  "50661.pcs.sysalarm1_8.0": "正常",
  "50661.pcs.sysalarm1_8.1": "告警",
  "50661.pcs.sysalarm1_9.0": "正常",
  "50661.pcs.sysalarm1_9.1": "告警",
  "50661.pcs.sysfault1_0.0": "正常",
  "50661.pcs.sysfault1_0.1": "告警",
  "50661.pcs.sysfault1_1.0": "正常",
  "50661.pcs.sysfault1_1.1": "告警",
  "50661.pcs.sysfault1_10.0": "正常",
  "50661.pcs.sysfault1_10.1": "告警",
  "50661.pcs.sysfault1_11.0": "正常",
  "50661.pcs.sysfault1_11.1": "告警",
  "50661.pcs.sysfault1_12.0": "正常",
  "50661.pcs.sysfault1_12.1": "告警",
  "50661.pcs.sysfault1_13.0": "正常",
  "50661.pcs.sysfault1_13.1": "告警",
  "50661.pcs.sysfault1_14.0": "正常",
  "50661.pcs.sysfault1_14.1": "告警",
  "50661.pcs.sysfault1_15.0": "正常",
  "50661.pcs.sysfault1_15.1": "告警",
  "50661.pcs.sysfault1_2.0": "正常",
  "50661.pcs.sysfault1_2.1": "告警",
  "50661.pcs.sysfault1_3.0": "正常",
  "50661.pcs.sysfault1_3.1": "告警",
  "50661.pcs.sysfault1_4.0": "正常",
  "50661.pcs.sysfault1_4.1": "告警",
  "50661.pcs.sysfault1_5.0": "正常",
  "50661.pcs.sysfault1_5.1": "告警",
  "50661.pcs.sysfault1_6.0": "正常",
  "50661.pcs.sysfault1_6.1": "告警",
  "50661.pcs.sysfault1_7.0": "正常",
  "50661.pcs.sysfault1_7.1": "告警",
  "50661.pcs.sysfault1_8.0": "正常",
  "50661.pcs.sysfault1_8.1": "告警",
  "50661.pcs.sysfault1_9.0": "正常",
  "50661.pcs.sysfault1_9.1": "告警",
  "50661.pcs.sysfault2_0.0": "正常",
  "50661.pcs.sysfault2_0.1": "告警",
  "50661.pcs.sysfault2_1.0": "正常",
  "50661.pcs.sysfault2_1.1": "告警",
  "50661.pcs.sysfault2_10.0": "正常",
  "50661.pcs.sysfault2_10.1": "告警",
  "50661.pcs.sysfault2_2.0": "正常",
  "50661.pcs.sysfault2_2.1": "告警",
  "50661.pcs.sysfault2_3.0": "正常",
  "50661.pcs.sysfault2_3.1": "告警",
  "50661.pcs.sysfault2_4.0": "正常",
  "50661.pcs.sysfault2_4.1": "告警",
  "50661.pcs.sysfault2_5.0": "正常",
  "50661.pcs.sysfault2_5.1": "告警",
  "50661.pcs.sysfault2_6.0": "正常",
  "50661.pcs.sysfault2_6.1": "告警",
  "50661.pcs.sysfault2_7.0": "正常",
  "50661.pcs.sysfault2_7.1": "告警",
  "50661.pcs.sysfault2_8.0": "正常",
  "50661.pcs.sysfault2_8.1": "告警",
  "50661.pcs.sysfault2_9.0": "正常",
  "50661.pcs.sysfault2_9.1": "告警",
  "50661.bms1.mcstatus1.0": "断开",
  "50661.bms1.mcstatus1.1": "闭合",
  "50661.bms1.1bcu1fault1_0.0": "正常",
  "50661.bms1.1bcu1fault1_0.1": "告警",
  "50661.bms1.1bcu1fault1_1.0": "正常",
  "50661.bms1.1bcu1fault1_1.1": "告警",
  "50661.bms1.1bcu1fault1_10.0": "正常",
  "50661.bms1.1bcu1fault1_10.1": "告警",
  "50661.bms1.1bcu1fault1_11.0": "正常",
  "50661.bms1.1bcu1fault1_11.1": "告警",
  "50661.bms1.1bcu1fault1_12.0": "正常",
  "50661.bms1.1bcu1fault1_12.1": "告警",
  "50661.bms1.1bcu1fault1_14.0": "正常",
  "50661.bms1.1bcu1fault1_14.1": "告警",
  "50661.bms1.1bcu1fault1_15.0": "正常",
  "50661.bms1.1bcu1fault1_15.1": "告警",
  "50661.bms1.1bcu1fault1_2.0": "正常",
  "50661.bms1.1bcu1fault1_2.1": "告警",
  "50661.bms1.1bcu1fault1_3.0": "正常",
  "50661.bms1.1bcu1fault1_3.1": "告警",
  "50661.bms1.1bcu1fault1_4.0": "正常",
  "50661.bms1.1bcu1fault1_4.1": "告警",
  "50661.bms1.1bcu1fault1_5.0": "正常",
  "50661.bms1.1bcu1fault1_5.1": "告警",
  "50661.bms1.1bcu1fault1_6.0": "正常",
  "50661.bms1.1bcu1fault1_6.1": "告警",
  "50661.bms1.1bcu1fault1_7.0": "正常",
  "50661.bms1.1bcu1fault1_7.1": "告警",
  "50661.bms1.1bcu1fault1_8.0": "正常",
  "50661.bms1.1bcu1fault1_8.1": "告警",
  "50661.bms1.1bcu1fault1_9.0": "正常",
  "50661.bms1.1bcu1fault1_9.1": "告警",
  "50661.bms1.1bcu1fault2_0.0": "正常",
  "50661.bms1.1bcu1fault2_0.1": "告警",
  "50661.bms1.1bcu1fault2_1.0": "正常",
  "50661.bms1.1bcu1fault2_1.1": "告警",
  "50661.bms1.1bcu1fault2_11.0": "正常",
  "50661.bms1.1bcu1fault2_11.1": "告警",
  "50661.bms1.1bcu1fault2_15.0": "正常",
  "50661.bms1.1bcu1fault2_15.1": "告警",
  "50661.bms1.1bcu1fault2_2.0": "正常",
  "50661.bms1.1bcu1fault2_2.1": "告警",
  "50661.bms1.1bcu1fault2_3.0": "正常",
  "50661.bms1.1bcu1fault2_3.1": "告警",
  "50661.bms1.1bcu1fault2_4.0": "正常",
  "50661.bms1.1bcu1fault2_4.1": "告警",
  "50661.bms1.1bcu1fault2_5.0": "正常",
  "50661.bms1.1bcu1fault2_5.1": "告警",
  "50661.bms1.1bcu1fault2_6.0": "正常",
  "50661.bms1.1bcu1fault2_6.1": "告警",
  "50661.bms1.1bcu1fault2_7.0": "正常",
  "50661.bms1.1bcu1fault2_7.1": "告警",
  "50661.bms1.1bcu1fault2_8.0": "正常",
  "50661.bms1.1bcu1fault2_8.1": "告警",
  "50661.bms1.1bcu1fault3_10.0": "正常",
  "50661.bms1.1bcu1fault3_10.1": "告警",
  "50661.bms1.1bcu1fault3_11.0": "正常",
  "50661.bms1.1bcu1fault3_11.1": "告警",
  "50661.bms1.1bcu1fault3_12.0": "正常",
  "50661.bms1.1bcu1fault3_12.1": "告警",
  "50661.bms1.1bcu1fault3_13.0": "正常",
  "50661.bms1.1bcu1fault3_13.1": "告警",
  "50661.bms1.1bcu1fault3_15.0": "正常",
  "50661.bms1.1bcu1fault3_15.1": "告警",
  "50661.bms1.1bcu1fault3_2.0": "正常",
  "50661.bms1.1bcu1fault3_2.1": "告警",
  "50661.bms1.1bcu1fault3_3.0": "正常",
  "50661.bms1.1bcu1fault3_3.1": "告警",
  "50661.bms1.1bcu1fault3_4.0": "正常",
  "50661.bms1.1bcu1fault3_4.1": "告警",
  "50661.bms1.1bcu1fault3_5.0": "正常",
  "50661.bms1.1bcu1fault3_5.1": "告警",
  "50661.bms1.1bcu1fault3_6.0": "正常",
  "50661.bms1.1bcu1fault3_6.1": "告警",
  "50661.bms1.1bcu1fault3_7.0": "正常",
  "50661.bms1.1bcu1fault3_7.1": "告警",
  "50661.bms1.1bcu1fault3_8.0": "正常",
  "50661.bms1.1bcu1fault3_8.1": "告警",
  "50661.bms1.1bcu1fault3_9.0": "正常",
  "50661.bms1.1bcu1fault3_9.1": "告警",
  "50661.bms1.1bcu1fault4_0.0": "正常",
  "50661.bms1.1bcu1fault4_0.1": "告警",
  "50661.bms1.1bcu1fault4_1.0": "正常",
  "50661.bms1.1bcu1fault4_1.1": "告警",
  "50661.bms1.1bcu1fault4_10.0": "正常",
  "50661.bms1.1bcu1fault4_10.1": "告警",
  "50661.bms1.1bcu1fault4_2.0": "正常",
  "50661.bms1.1bcu1fault4_2.1": "告警",
  "50661.bms1.1bcu1fault4_3.0": "正常",
  "50661.bms1.1bcu1fault4_3.1": "告警",
  "50661.bms1.1bcu1fault4_5.0": "正常",
  "50661.bms1.1bcu1fault4_5.1": "告警",
  "50661.bms1.1bcu1fault4_6.0": "正常",
  "50661.bms1.1bcu1fault4_6.1": "告警",
  "50661.bms1.1bcu1fault4_7.0": "正常",
  "50661.bms1.1bcu1fault4_7.1": "告警",
  "50661.bms1.1bcu2fault1_0.0": "正常",
  "50661.bms1.1bcu2fault1_0.1": "告警",
  "50661.bms1.1bcu2fault1_1.0": "正常",
  "50661.bms1.1bcu2fault1_1.1": "告警",
  "50661.bms1.1bcu2fault1_10.0": "正常",
  "50661.bms1.1bcu2fault1_10.1": "告警",
  "50661.bms1.1bcu2fault1_11.0": "正常",
  "50661.bms1.1bcu2fault1_11.1": "告警",
  "50661.bms1.1bcu2fault1_12.0": "正常",
  "50661.bms1.1bcu2fault1_12.1": "告警",
  "50661.bms1.1bcu2fault1_14.0": "正常",
  "50661.bms1.1bcu2fault1_14.1": "告警",
  "50661.bms1.1bcu2fault1_15.0": "正常",
  "50661.bms1.1bcu2fault1_15.1": "告警",
  "50661.bms1.1bcu2fault1_2.0": "正常",
  "50661.bms1.1bcu2fault1_2.1": "告警",
  "50661.bms1.1bcu2fault1_3.0": "正常",
  "50661.bms1.1bcu2fault1_3.1": "告警",
  "50661.bms1.1bcu2fault1_4.0": "正常",
  "50661.bms1.1bcu2fault1_4.1": "告警",
  "50661.bms1.1bcu2fault1_5.0": "正常",
  "50661.bms1.1bcu2fault1_5.1": "告警",
  "50661.bms1.1bcu2fault1_6.0": "正常",
  "50661.bms1.1bcu2fault1_6.1": "告警",
  "50661.bms1.1bcu2fault1_7.0": "正常",
  "50661.bms1.1bcu2fault1_7.1": "告警",
  "50661.bms1.1bcu2fault1_8.0": "正常",
  "50661.bms1.1bcu2fault1_8.1": "告警",
  "50661.bms1.1bcu2fault1_9.0": "正常",
  "50661.bms1.1bcu2fault1_9.1": "告警",
  "50661.bms1.1bcu2fault2_0.0": "正常",
  "50661.bms1.1bcu2fault2_0.1": "告警",
  "50661.bms1.1bcu2fault2_1.0": "正常",
  "50661.bms1.1bcu2fault2_1.1": "告警",
  "50661.bms1.1bcu2fault2_11.0": "正常",
  "50661.bms1.1bcu2fault2_11.1": "告警",
  "50661.bms1.1bcu2fault2_15.0": "正常",
  "50661.bms1.1bcu2fault2_15.1": "告警",
  "50661.bms1.1bcu2fault2_2.0": "正常",
  "50661.bms1.1bcu2fault2_2.1": "告警",
  "50661.bms1.1bcu2fault2_3.0": "正常",
  "50661.bms1.1bcu2fault2_3.1": "告警",
  "50661.bms1.1bcu2fault2_4.0": "正常",
  "50661.bms1.1bcu2fault2_4.1": "告警",
  "50661.bms1.1bcu2fault2_5.0": "正常",
  "50661.bms1.1bcu2fault2_5.1": "告警",
  "50661.bms1.1bcu2fault2_6.0": "正常",
  "50661.bms1.1bcu2fault2_6.1": "告警",
  "50661.bms1.1bcu2fault2_7.0": "正常",
  "50661.bms1.1bcu2fault2_7.1": "告警",
  "50661.bms1.1bcu2fault2_8.0": "正常",
  "50661.bms1.1bcu2fault2_8.1": "告警",
  "50661.bms1.1bcu2fault3_10.0": "正常",
  "50661.bms1.1bcu2fault3_10.1": "告警",
  "50661.bms1.1bcu2fault3_11.0": "正常",
  "50661.bms1.1bcu2fault3_11.1": "告警",
  "50661.bms1.1bcu2fault3_12.0": "正常",
  "50661.bms1.1bcu2fault3_12.1": "告警",
  "50661.bms1.1bcu2fault3_13.0": "正常",
  "50661.bms1.1bcu2fault3_13.1": "告警",
  "50661.bms1.1bcu2fault3_15.0": "正常",
  "50661.bms1.1bcu2fault3_15.1": "告警",
  "50661.bms1.1bcu2fault3_2.0": "正常",
  "50661.bms1.1bcu2fault3_2.1": "告警",
  "50661.bms1.1bcu2fault3_3.0": "正常",
  "50661.bms1.1bcu2fault3_3.1": "告警",
  "50661.bms1.1bcu2fault3_4.0": "正常",
  "50661.bms1.1bcu2fault3_4.1": "告警",
  "50661.bms1.1bcu2fault3_5.0": "正常",
  "50661.bms1.1bcu2fault3_5.1": "告警",
  "50661.bms1.1bcu2fault3_6.0": "正常",
  "50661.bms1.1bcu2fault3_6.1": "告警",
  "50661.bms1.1bcu2fault3_7.0": "正常",
  "50661.bms1.1bcu2fault3_7.1": "告警",
  "50661.bms1.1bcu2fault3_8.0": "正常",
  "50661.bms1.1bcu2fault3_8.1": "告警",
  "50661.bms1.1bcu2fault3_9.0": "正常",
  "50661.bms1.1bcu2fault3_9.1": "告警",
  "50661.bms1.1bcu2fault4_0.0": "正常",
  "50661.bms1.1bcu2fault4_0.1": "告警",
  "50661.bms1.1bcu2fault4_1.0": "正常",
  "50661.bms1.1bcu2fault4_1.1": "告警",
  "50661.bms1.1bcu2fault4_10.0": "正常",
  "50661.bms1.1bcu2fault4_10.1": "告警",
  "50661.bms1.1bcu2fault4_2.0": "正常",
  "50661.bms1.1bcu2fault4_2.1": "告警",
  "50661.bms1.1bcu2fault4_3.0": "正常",
  "50661.bms1.1bcu2fault4_3.1": "告警",
  "50661.bms1.1bcu2fault4_5.0": "正常",
  "50661.bms1.1bcu2fault4_5.1": "告警",
  "50661.bms1.1bcu2fault4_6.0": "正常",
  "50661.bms1.1bcu2fault4_6.1": "告警",
  "50661.bms1.1bcu2fault4_7.0": "正常",
  "50661.bms1.1bcu2fault4_7.1": "告警",
  "50661.bms1.1bcu3fault1_0.0": "正常",
  "50661.bms1.1bcu3fault1_0.1": "告警",
  "50661.bms1.1bcu3fault1_1.0": "正常",
  "50661.bms1.1bcu3fault1_1.1": "告警",
  "50661.bms1.1bcu3fault1_10.0": "正常",
  "50661.bms1.1bcu3fault1_10.1": "告警",
  "50661.bms1.1bcu3fault1_11.0": "正常",
  "50661.bms1.1bcu3fault1_11.1": "告警",
  "50661.bms1.1bcu3fault1_12.0": "正常",
  "50661.bms1.1bcu3fault1_12.1": "告警",
  "50661.bms1.1bcu3fault1_14.0": "正常",
  "50661.bms1.1bcu3fault1_14.1": "告警",
  "50661.bms1.1bcu3fault1_15.0": "正常",
  "50661.bms1.1bcu3fault1_15.1": "告警",
  "50661.bms1.1bcu3fault1_2.0": "正常",
  "50661.bms1.1bcu3fault1_2.1": "告警",
  "50661.bms1.1bcu3fault1_3.0": "正常",
  "50661.bms1.1bcu3fault1_3.1": "告警",
  "50661.bms1.1bcu3fault1_4.0": "正常",
  "50661.bms1.1bcu3fault1_4.1": "告警",
  "50661.bms1.1bcu3fault1_5.0": "正常",
  "50661.bms1.1bcu3fault1_5.1": "告警",
  "50661.bms1.1bcu3fault1_6.0": "正常",
  "50661.bms1.1bcu3fault1_6.1": "告警",
  "50661.bms1.1bcu3fault1_7.0": "正常",
  "50661.bms1.1bcu3fault1_7.1": "告警",
  "50661.bms1.1bcu3fault1_8.0": "正常",
  "50661.bms1.1bcu3fault1_8.1": "告警",
  "50661.bms1.1bcu3fault1_9.0": "正常",
  "50661.bms1.1bcu3fault1_9.1": "告警",
  "50661.bms1.1bcu3fault2_0.0": "正常",
  "50661.bms1.1bcu3fault2_0.1": "告警",
  "50661.bms1.1bcu3fault2_1.0": "正常",
  "50661.bms1.1bcu3fault2_1.1": "告警",
  "50661.bms1.1bcu3fault2_11.0": "正常",
  "50661.bms1.1bcu3fault2_11.1": "告警",
  "50661.bms1.1bcu3fault2_15.0": "正常",
  "50661.bms1.1bcu3fault2_15.1": "告警",
  "50661.bms1.1bcu3fault2_2.0": "正常",
  "50661.bms1.1bcu3fault2_2.1": "告警",
  "50661.bms1.1bcu3fault2_3.0": "正常",
  "50661.bms1.1bcu3fault2_3.1": "告警",
  "50661.bms1.1bcu3fault2_4.0": "正常",
  "50661.bms1.1bcu3fault2_4.1": "告警",
  "50661.bms1.1bcu3fault2_5.0": "正常",
  "50661.bms1.1bcu3fault2_5.1": "告警",
  "50661.bms1.1bcu3fault2_6.0": "正常",
  "50661.bms1.1bcu3fault2_6.1": "告警",
  "50661.bms1.1bcu3fault2_7.0": "正常",
  "50661.bms1.1bcu3fault2_7.1": "告警",
  "50661.bms1.1bcu3fault2_8.0": "正常",
  "50661.bms1.1bcu3fault2_8.1": "告警",
  "50661.bms1.1bcu3fault3_10.0": "正常",
  "50661.bms1.1bcu3fault3_10.1": "告警",
  "50661.bms1.1bcu3fault3_11.0": "正常",
  "50661.bms1.1bcu3fault3_11.1": "告警",
  "50661.bms1.1bcu3fault3_12.0": "正常",
  "50661.bms1.1bcu3fault3_12.1": "告警",
  "50661.bms1.1bcu3fault3_13.0": "正常",
  "50661.bms1.1bcu3fault3_13.1": "告警",
  "50661.bms1.1bcu3fault3_15.0": "正常",
  "50661.bms1.1bcu3fault3_15.1": "告警",
  "50661.bms1.1bcu3fault3_2.0": "正常",
  "50661.bms1.1bcu3fault3_2.1": "告警",
  "50661.bms1.1bcu3fault3_3.0": "正常",
  "50661.bms1.1bcu3fault3_3.1": "告警",
  "50661.bms1.1bcu3fault3_4.0": "正常",
  "50661.bms1.1bcu3fault3_4.1": "告警",
  "50661.bms1.1bcu3fault3_5.0": "正常",
  "50661.bms1.1bcu3fault3_5.1": "告警",
  "50661.bms1.1bcu3fault3_6.0": "正常",
  "50661.bms1.1bcu3fault3_6.1": "告警",
  "50661.bms1.1bcu3fault3_7.0": "正常",
  "50661.bms1.1bcu3fault3_7.1": "告警",
  "50661.bms1.1bcu3fault3_8.0": "正常",
  "50661.bms1.1bcu3fault3_8.1": "告警",
  "50661.bms1.1bcu3fault3_9.0": "正常",
  "50661.bms1.1bcu3fault3_9.1": "告警",
  "50661.bms1.1bcu3fault4_0.0": "正常",
  "50661.bms1.1bcu3fault4_0.1": "告警",
  "50661.bms1.1bcu3fault4_1.0": "正常",
  "50661.bms1.1bcu3fault4_1.1": "告警",
  "50661.bms1.1bcu3fault4_10.0": "正常",
  "50661.bms1.1bcu3fault4_10.1": "告警",
  "50661.bms1.1bcu3fault4_2.0": "正常",
  "50661.bms1.1bcu3fault4_2.1": "告警",
  "50661.bms1.1bcu3fault4_3.0": "正常",
  "50661.bms1.1bcu3fault4_3.1": "告警",
  "50661.bms1.1bcu3fault4_5.0": "正常",
  "50661.bms1.1bcu3fault4_5.1": "告警",
  "50661.bms1.1bcu3fault4_6.0": "正常",
  "50661.bms1.1bcu3fault4_6.1": "告警",
  "50661.bms1.1bcu3fault4_7.0": "正常",
  "50661.bms1.1bcu3fault4_7.1": "告警",
  "50661.bms2.mcstatus2.0": "断开",
  "50661.bms2.mcstatus2.1": "闭合",
  "50661.bms2.2bcu1fault1_0.0": "正常",
  "50661.bms2.2bcu1fault1_0.1": "告警",
  "50661.bms2.2bcu1fault1_1.0": "正常",
  "50661.bms2.2bcu1fault1_1.1": "告警",
  "50661.bms2.2bcu1fault1_10.0": "正常",
  "50661.bms2.2bcu1fault1_10.1": "告警",
  "50661.bms2.2bcu1fault1_11.0": "正常",
  "50661.bms2.2bcu1fault1_11.1": "告警",
  "50661.bms2.2bcu1fault1_12.0": "正常",
  "50661.bms2.2bcu1fault1_12.1": "告警",
  "50661.bms2.2bcu1fault1_14.0": "正常",
  "50661.bms2.2bcu1fault1_14.1": "告警",
  "50661.bms2.2bcu1fault1_15.0": "正常",
  "50661.bms2.2bcu1fault1_15.1": "告警",
  "50661.bms2.2bcu1fault1_2.0": "正常",
  "50661.bms2.2bcu1fault1_2.1": "告警",
  "50661.bms2.2bcu1fault1_3.0": "正常",
  "50661.bms2.2bcu1fault1_3.1": "告警",
  "50661.bms2.2bcu1fault1_4.0": "正常",
  "50661.bms2.2bcu1fault1_4.1": "告警",
  "50661.bms2.2bcu1fault1_5.0": "正常",
  "50661.bms2.2bcu1fault1_5.1": "告警",
  "50661.bms2.2bcu1fault1_6.0": "正常",
  "50661.bms2.2bcu1fault1_6.1": "告警",
  "50661.bms2.2bcu1fault1_7.0": "正常",
  "50661.bms2.2bcu1fault1_7.1": "告警",
  "50661.bms2.2bcu1fault1_8.0": "正常",
  "50661.bms2.2bcu1fault1_8.1": "告警",
  "50661.bms2.2bcu1fault1_9.0": "正常",
  "50661.bms2.2bcu1fault1_9.1": "告警",
  "50661.bms2.2bcu1fault2_0.0": "正常",
  "50661.bms2.2bcu1fault2_0.1": "告警",
  "50661.bms2.2bcu1fault2_1.0": "正常",
  "50661.bms2.2bcu1fault2_1.1": "告警",
  "50661.bms2.2bcu1fault2_11.0": "正常",
  "50661.bms2.2bcu1fault2_11.1": "告警",
  "50661.bms2.2bcu1fault2_15.0": "正常",
  "50661.bms2.2bcu1fault2_15.1": "告警",
  "50661.bms2.2bcu1fault2_2.0": "正常",
  "50661.bms2.2bcu1fault2_2.1": "告警",
  "50661.bms2.2bcu1fault2_3.0": "正常",
  "50661.bms2.2bcu1fault2_3.1": "告警",
  "50661.bms2.2bcu1fault2_4.0": "正常",
  "50661.bms2.2bcu1fault2_4.1": "告警",
  "50661.bms2.2bcu1fault2_5.0": "正常",
  "50661.bms2.2bcu1fault2_5.1": "告警",
  "50661.bms2.2bcu1fault2_6.0": "正常",
  "50661.bms2.2bcu1fault2_6.1": "告警",
  "50661.bms2.2bcu1fault2_7.0": "正常",
  "50661.bms2.2bcu1fault2_7.1": "告警",
  "50661.bms2.2bcu1fault2_8.0": "正常",
  "50661.bms2.2bcu1fault2_8.1": "告警",
  "50661.bms2.2bcu1fault3_10.0": "正常",
  "50661.bms2.2bcu1fault3_10.1": "告警",
  "50661.bms2.2bcu1fault3_11.0": "正常",
  "50661.bms2.2bcu1fault3_11.1": "告警",
  "50661.bms2.2bcu1fault3_12.0": "正常",
  "50661.bms2.2bcu1fault3_12.1": "告警",
  "50661.bms2.2bcu1fault3_13.0": "正常",
  "50661.bms2.2bcu1fault3_13.1": "告警",
  "50661.bms2.2bcu1fault3_15.0": "正常",
  "50661.bms2.2bcu1fault3_15.1": "告警",
  "50661.bms2.2bcu1fault3_2.0": "正常",
  "50661.bms2.2bcu1fault3_2.1": "告警",
  "50661.bms2.2bcu1fault3_3.0": "正常",
  "50661.bms2.2bcu1fault3_3.1": "告警",
  "50661.bms2.2bcu1fault3_4.0": "正常",
  "50661.bms2.2bcu1fault3_4.1": "告警",
  "50661.bms2.2bcu1fault3_5.0": "正常",
  "50661.bms2.2bcu1fault3_5.1": "告警",
  "50661.bms2.2bcu1fault3_6.0": "正常",
  "50661.bms2.2bcu1fault3_6.1": "告警",
  "50661.bms2.2bcu1fault3_7.0": "正常",
  "50661.bms2.2bcu1fault3_7.1": "告警",
  "50661.bms2.2bcu1fault3_8.0": "正常",
  "50661.bms2.2bcu1fault3_8.1": "告警",
  "50661.bms2.2bcu1fault3_9.0": "正常",
  "50661.bms2.2bcu1fault3_9.1": "告警",
  "50661.bms2.2bcu1fault4_0.0": "正常",
  "50661.bms2.2bcu1fault4_0.1": "告警",
  "50661.bms2.2bcu1fault4_1.0": "正常",
  "50661.bms2.2bcu1fault4_1.1": "告警",
  "50661.bms2.2bcu1fault4_10.0": "正常",
  "50661.bms2.2bcu1fault4_10.1": "告警",
  "50661.bms2.2bcu1fault4_2.0": "正常",
  "50661.bms2.2bcu1fault4_2.1": "告警",
  "50661.bms2.2bcu1fault4_3.0": "正常",
  "50661.bms2.2bcu1fault4_3.1": "告警",
  "50661.bms2.2bcu1fault4_5.0": "正常",
  "50661.bms2.2bcu1fault4_5.1": "告警",
  "50661.bms2.2bcu1fault4_6.0": "正常",
  "50661.bms2.2bcu1fault4_6.1": "告警",
  "50661.bms2.2bcu1fault4_7.0": "正常",
  "50661.bms2.2bcu1fault4_7.1": "告警",
  "50661.bms2.2bcu2fault1_0.0": "正常",
  "50661.bms2.2bcu2fault1_0.1": "告警",
  "50661.bms2.2bcu2fault1_1.0": "正常",
  "50661.bms2.2bcu2fault1_1.1": "告警",
  "50661.bms2.2bcu2fault1_10.0": "正常",
  "50661.bms2.2bcu2fault1_10.1": "告警",
  "50661.bms2.2bcu2fault1_11.0": "正常",
  "50661.bms2.2bcu2fault1_11.1": "告警",
  "50661.bms2.2bcu2fault1_12.0": "正常",
  "50661.bms2.2bcu2fault1_12.1": "告警",
  "50661.bms2.2bcu2fault1_14.0": "正常",
  "50661.bms2.2bcu2fault1_14.1": "告警",
  "50661.bms2.2bcu2fault1_15.0": "正常",
  "50661.bms2.2bcu2fault1_15.1": "告警",
  "50661.bms2.2bcu2fault1_2.0": "正常",
  "50661.bms2.2bcu2fault1_2.1": "告警",
  "50661.bms2.2bcu2fault1_3.0": "正常",
  "50661.bms2.2bcu2fault1_3.1": "告警",
  "50661.bms2.2bcu2fault1_4.0": "正常",
  "50661.bms2.2bcu2fault1_4.1": "告警",
  "50661.bms2.2bcu2fault1_5.0": "正常",
  "50661.bms2.2bcu2fault1_5.1": "告警",
  "50661.bms2.2bcu2fault1_6.0": "正常",
  "50661.bms2.2bcu2fault1_6.1": "告警",
  "50661.bms2.2bcu2fault1_7.0": "正常",
  "50661.bms2.2bcu2fault1_7.1": "告警",
  "50661.bms2.2bcu2fault1_8.0": "正常",
  "50661.bms2.2bcu2fault1_8.1": "告警",
  "50661.bms2.2bcu2fault1_9.0": "正常",
  "50661.bms2.2bcu2fault1_9.1": "告警",
  "50661.bms2.2bcu2fault2_0.0": "正常",
  "50661.bms2.2bcu2fault2_0.1": "告警",
  "50661.bms2.2bcu2fault2_1.0": "正常",
  "50661.bms2.2bcu2fault2_1.1": "告警",
  "50661.bms2.2bcu2fault2_11.0": "正常",
  "50661.bms2.2bcu2fault2_11.1": "告警",
  "50661.bms2.2bcu2fault2_15.0": "正常",
  "50661.bms2.2bcu2fault2_15.1": "告警",
  "50661.bms2.2bcu2fault2_2.0": "正常",
  "50661.bms2.2bcu2fault2_2.1": "告警",
  "50661.bms2.2bcu2fault2_3.0": "正常",
  "50661.bms2.2bcu2fault2_3.1": "告警",
  "50661.bms2.2bcu2fault2_4.0": "正常",
  "50661.bms2.2bcu2fault2_4.1": "告警",
  "50661.bms2.2bcu2fault2_5.0": "正常",
  "50661.bms2.2bcu2fault2_5.1": "告警",
  "50661.bms2.2bcu2fault2_6.0": "正常",
  "50661.bms2.2bcu2fault2_6.1": "告警",
  "50661.bms2.2bcu2fault2_7.0": "正常",
  "50661.bms2.2bcu2fault2_7.1": "告警",
  "50661.bms2.2bcu2fault2_8.0": "正常",
  "50661.bms2.2bcu2fault2_8.1": "告警",
  "50661.bms2.2bcu2fault3_10.0": "正常",
  "50661.bms2.2bcu2fault3_10.1": "告警",
  "50661.bms2.2bcu2fault3_11.0": "正常",
  "50661.bms2.2bcu2fault3_11.1": "告警",
  "50661.bms2.2bcu2fault3_12.0": "正常",
  "50661.bms2.2bcu2fault3_12.1": "告警",
  "50661.bms2.2bcu2fault3_13.0": "正常",
  "50661.bms2.2bcu2fault3_13.1": "告警",
  "50661.bms2.2bcu2fault3_15.0": "正常",
  "50661.bms2.2bcu2fault3_15.1": "告警",
  "50661.bms2.2bcu2fault3_2.0": "正常",
  "50661.bms2.2bcu2fault3_2.1": "告警",
  "50661.bms2.2bcu2fault3_3.0": "正常",
  "50661.bms2.2bcu2fault3_3.1": "告警",
  "50661.bms2.2bcu2fault3_4.0": "正常",
  "50661.bms2.2bcu2fault3_4.1": "告警",
  "50661.bms2.2bcu2fault3_5.0": "正常",
  "50661.bms2.2bcu2fault3_5.1": "告警",
  "50661.bms2.2bcu2fault3_6.0": "正常",
  "50661.bms2.2bcu2fault3_6.1": "告警",
  "50661.bms2.2bcu2fault3_7.0": "正常",
  "50661.bms2.2bcu2fault3_7.1": "告警",
  "50661.bms2.2bcu2fault3_8.0": "正常",
  "50661.bms2.2bcu2fault3_8.1": "告警",
  "50661.bms2.2bcu2fault3_9.0": "正常",
  "50661.bms2.2bcu2fault3_9.1": "告警",
  "50661.bms2.2bcu2fault4_0.0": "正常",
  "50661.bms2.2bcu2fault4_0.1": "告警",
  "50661.bms2.2bcu2fault4_1.0": "正常",
  "50661.bms2.2bcu2fault4_1.1": "告警",
  "50661.bms2.2bcu2fault4_10.0": "正常",
  "50661.bms2.2bcu2fault4_10.1": "告警",
  "50661.bms2.2bcu2fault4_2.0": "正常",
  "50661.bms2.2bcu2fault4_2.1": "告警",
  "50661.bms2.2bcu2fault4_3.0": "正常",
  "50661.bms2.2bcu2fault4_3.1": "告警",
  "50661.bms2.2bcu2fault4_5.0": "正常",
  "50661.bms2.2bcu2fault4_5.1": "告警",
  "50661.bms2.2bcu2fault4_6.0": "正常",
  "50661.bms2.2bcu2fault4_6.1": "告警",
  "50661.bms2.2bcu2fault4_7.0": "正常",
  "50661.bms2.2bcu2fault4_7.1": "告警",
  "50661.bms2.2bcu3fault1_0.0": "正常",
  "50661.bms2.2bcu3fault1_0.1": "告警",
  "50661.bms2.2bcu3fault1_1.0": "正常",
  "50661.bms2.2bcu3fault1_1.1": "告警",
  "50661.bms2.2bcu3fault1_10.0": "正常",
  "50661.bms2.2bcu3fault1_10.1": "告警",
  "50661.bms2.2bcu3fault1_11.0": "正常",
  "50661.bms2.2bcu3fault1_11.1": "告警",
  "50661.bms2.2bcu3fault1_12.0": "正常",
  "50661.bms2.2bcu3fault1_12.1": "告警",
  "50661.bms2.2bcu3fault1_14.0": "正常",
  "50661.bms2.2bcu3fault1_14.1": "告警",
  "50661.bms2.2bcu3fault1_15.0": "正常",
  "50661.bms2.2bcu3fault1_15.1": "告警",
  "50661.bms2.2bcu3fault1_2.0": "正常",
  "50661.bms2.2bcu3fault1_2.1": "告警",
  "50661.bms2.2bcu3fault1_3.0": "正常",
  "50661.bms2.2bcu3fault1_3.1": "告警",
  "50661.bms2.2bcu3fault1_4.0": "正常",
  "50661.bms2.2bcu3fault1_4.1": "告警",
  "50661.bms2.2bcu3fault1_5.0": "正常",
  "50661.bms2.2bcu3fault1_5.1": "告警",
  "50661.bms2.2bcu3fault1_6.0": "正常",
  "50661.bms2.2bcu3fault1_6.1": "告警",
  "50661.bms2.2bcu3fault1_7.0": "正常",
  "50661.bms2.2bcu3fault1_7.1": "告警",
  "50661.bms2.2bcu3fault1_8.0": "正常",
  "50661.bms2.2bcu3fault1_8.1": "告警",
  "50661.bms2.2bcu3fault1_9.0": "正常",
  "50661.bms2.2bcu3fault1_9.1": "告警",
  "50661.bms2.2bcu3fault2_0.0": "正常",
  "50661.bms2.2bcu3fault2_0.1": "告警",
  "50661.bms2.2bcu3fault2_1.0": "正常",
  "50661.bms2.2bcu3fault2_1.1": "告警",
  "50661.bms2.2bcu3fault2_11.0": "正常",
  "50661.bms2.2bcu3fault2_11.1": "告警",
  "50661.bms2.2bcu3fault2_15.0": "正常",
  "50661.bms2.2bcu3fault2_15.1": "告警",
  "50661.bms2.2bcu3fault2_2.0": "正常",
  "50661.bms2.2bcu3fault2_2.1": "告警",
  "50661.bms2.2bcu3fault2_3.0": "正常",
  "50661.bms2.2bcu3fault2_3.1": "告警",
  "50661.bms2.2bcu3fault2_4.0": "正常",
  "50661.bms2.2bcu3fault2_4.1": "告警",
  "50661.bms2.2bcu3fault2_5.0": "正常",
  "50661.bms2.2bcu3fault2_5.1": "告警",
  "50661.bms2.2bcu3fault2_6.0": "正常",
  "50661.bms2.2bcu3fault2_6.1": "告警",
  "50661.bms2.2bcu3fault2_7.0": "正常",
  "50661.bms2.2bcu3fault2_7.1": "告警",
  "50661.bms2.2bcu3fault2_8.0": "正常",
  "50661.bms2.2bcu3fault2_8.1": "告警",
  "50661.bms2.2bcu3fault3_10.0": "正常",
  "50661.bms2.2bcu3fault3_10.1": "告警",
  "50661.bms2.2bcu3fault3_11.0": "正常",
  "50661.bms2.2bcu3fault3_11.1": "告警",
  "50661.bms2.2bcu3fault3_12.0": "正常",
  "50661.bms2.2bcu3fault3_12.1": "告警",
  "50661.bms2.2bcu3fault3_13.0": "正常",
  "50661.bms2.2bcu3fault3_13.1": "告警",
  "50661.bms2.2bcu3fault3_15.0": "正常",
  "50661.bms2.2bcu3fault3_15.1": "告警",
  "50661.bms2.2bcu3fault3_2.0": "正常",
  "50661.bms2.2bcu3fault3_2.1": "告警",
  "50661.bms2.2bcu3fault3_3.0": "正常",
  "50661.bms2.2bcu3fault3_3.1": "告警",
  "50661.bms2.2bcu3fault3_4.0": "正常",
  "50661.bms2.2bcu3fault3_4.1": "告警",
  "50661.bms2.2bcu3fault3_5.0": "正常",
  "50661.bms2.2bcu3fault3_5.1": "告警",
  "50661.bms2.2bcu3fault3_6.0": "正常",
  "50661.bms2.2bcu3fault3_6.1": "告警",
  "50661.bms2.2bcu3fault3_7.0": "正常",
  "50661.bms2.2bcu3fault3_7.1": "告警",
  "50661.bms2.2bcu3fault3_8.0": "正常",
  "50661.bms2.2bcu3fault3_8.1": "告警",
  "50661.bms2.2bcu3fault3_9.0": "正常",
  "50661.bms2.2bcu3fault3_9.1": "告警",
  "50661.bms2.2bcu3fault4_0.0": "正常",
  "50661.bms2.2bcu3fault4_0.1": "告警",
  "50661.bms2.2bcu3fault4_1.0": "正常",
  "50661.bms2.2bcu3fault4_1.1": "告警",
  "50661.bms2.2bcu3fault4_10.0": "正常",
  "50661.bms2.2bcu3fault4_10.1": "告警",
  "50661.bms2.2bcu3fault4_2.0": "正常",
  "50661.bms2.2bcu3fault4_2.1": "告警",
  "50661.bms2.2bcu3fault4_3.0": "正常",
  "50661.bms2.2bcu3fault4_3.1": "告警",
  "50661.bms2.2bcu3fault4_5.0": "正常",
  "50661.bms2.2bcu3fault4_5.1": "告警",
  "50661.bms2.2bcu3fault4_6.0": "正常",
  "50661.bms2.2bcu3fault4_6.1": "告警",
  "50661.bms2.2bcu3fault4_7.0": "正常",
  "50661.bms2.2bcu3fault4_7.1": "告警",
  "50661.bms3.mcstatus3.0": "断开",
  "50661.bms3.mcstatus3.1": "闭合",
  "50661.bms3.3bcu1fault1_0.0": "正常",
  "50661.bms3.3bcu1fault1_0.1": "告警",
  "50661.bms3.3bcu1fault1_1.0": "正常",
  "50661.bms3.3bcu1fault1_1.1": "告警",
  "50661.bms3.3bcu1fault1_10.0": "正常",
  "50661.bms3.3bcu1fault1_10.1": "告警",
  "50661.bms3.3bcu1fault1_11.0": "正常",
  "50661.bms3.3bcu1fault1_11.1": "告警",
  "50661.bms3.3bcu1fault1_12.0": "正常",
  "50661.bms3.3bcu1fault1_12.1": "告警",
  "50661.bms3.3bcu1fault1_14.0": "正常",
  "50661.bms3.3bcu1fault1_14.1": "告警",
  "50661.bms3.3bcu1fault1_15.0": "正常",
  "50661.bms3.3bcu1fault1_15.1": "告警",
  "50661.bms3.3bcu1fault1_2.0": "正常",
  "50661.bms3.3bcu1fault1_2.1": "告警",
  "50661.bms3.3bcu1fault1_3.0": "正常",
  "50661.bms3.3bcu1fault1_3.1": "告警",
  "50661.bms3.3bcu1fault1_4.0": "正常",
  "50661.bms3.3bcu1fault1_4.1": "告警",
  "50661.bms3.3bcu1fault1_5.0": "正常",
  "50661.bms3.3bcu1fault1_5.1": "告警",
  "50661.bms3.3bcu1fault1_6.0": "正常",
  "50661.bms3.3bcu1fault1_6.1": "告警",
  "50661.bms3.3bcu1fault1_7.0": "正常",
  "50661.bms3.3bcu1fault1_7.1": "告警",
  "50661.bms3.3bcu1fault1_8.0": "正常",
  "50661.bms3.3bcu1fault1_8.1": "告警",
  "50661.bms3.3bcu1fault1_9.0": "正常",
  "50661.bms3.3bcu1fault1_9.1": "告警",
  "50661.bms3.3bcu1fault2_0.0": "正常",
  "50661.bms3.3bcu1fault2_0.1": "告警",
  "50661.bms3.3bcu1fault2_1.0": "正常",
  "50661.bms3.3bcu1fault2_1.1": "告警",
  "50661.bms3.3bcu1fault2_11.0": "正常",
  "50661.bms3.3bcu1fault2_11.1": "告警",
  "50661.bms3.3bcu1fault2_15.0": "正常",
  "50661.bms3.3bcu1fault2_15.1": "告警",
  "50661.bms3.3bcu1fault2_2.0": "正常",
  "50661.bms3.3bcu1fault2_2.1": "告警",
  "50661.bms3.3bcu1fault2_3.0": "正常",
  "50661.bms3.3bcu1fault2_3.1": "告警",
  "50661.bms3.3bcu1fault2_4.0": "正常",
  "50661.bms3.3bcu1fault2_4.1": "告警",
  "50661.bms3.3bcu1fault2_5.0": "正常",
  "50661.bms3.3bcu1fault2_5.1": "告警",
  "50661.bms3.3bcu1fault2_6.0": "正常",
  "50661.bms3.3bcu1fault2_6.1": "告警",
  "50661.bms3.3bcu1fault2_7.0": "正常",
  "50661.bms3.3bcu1fault2_7.1": "告警",
  "50661.bms3.3bcu1fault2_8.0": "正常",
  "50661.bms3.3bcu1fault2_8.1": "告警",
  "50661.bms3.3bcu1fault3_10.0": "正常",
  "50661.bms3.3bcu1fault3_10.1": "告警",
  "50661.bms3.3bcu1fault3_11.0": "正常",
  "50661.bms3.3bcu1fault3_11.1": "告警",
  "50661.bms3.3bcu1fault3_12.0": "正常",
  "50661.bms3.3bcu1fault3_12.1": "告警",
  "50661.bms3.3bcu1fault3_13.0": "正常",
  "50661.bms3.3bcu1fault3_13.1": "告警",
  "50661.bms3.3bcu1fault3_15.0": "正常",
  "50661.bms3.3bcu1fault3_15.1": "告警",
  "50661.bms3.3bcu1fault3_2.0": "正常",
  "50661.bms3.3bcu1fault3_2.1": "告警",
  "50661.bms3.3bcu1fault3_3.0": "正常",
  "50661.bms3.3bcu1fault3_3.1": "告警",
  "50661.bms3.3bcu1fault3_4.0": "正常",
  "50661.bms3.3bcu1fault3_4.1": "告警",
  "50661.bms3.3bcu1fault3_5.0": "正常",
  "50661.bms3.3bcu1fault3_5.1": "告警",
  "50661.bms3.3bcu1fault3_6.0": "正常",
  "50661.bms3.3bcu1fault3_6.1": "告警",
  "50661.bms3.3bcu1fault3_7.0": "正常",
  "50661.bms3.3bcu1fault3_7.1": "告警",
  "50661.bms3.3bcu1fault3_8.0": "正常",
  "50661.bms3.3bcu1fault3_8.1": "告警",
  "50661.bms3.3bcu1fault3_9.0": "正常",
  "50661.bms3.3bcu1fault3_9.1": "告警",
  "50661.bms3.3bcu1fault4_0.0": "正常",
  "50661.bms3.3bcu1fault4_0.1": "告警",
  "50661.bms3.3bcu1fault4_1.0": "正常",
  "50661.bms3.3bcu1fault4_1.1": "告警",
  "50661.bms3.3bcu1fault4_10.0": "正常",
  "50661.bms3.3bcu1fault4_10.1": "告警",
  "50661.bms3.3bcu1fault4_2.0": "正常",
  "50661.bms3.3bcu1fault4_2.1": "告警",
  "50661.bms3.3bcu1fault4_3.0": "正常",
  "50661.bms3.3bcu1fault4_3.1": "告警",
  "50661.bms3.3bcu1fault4_5.0": "正常",
  "50661.bms3.3bcu1fault4_5.1": "告警",
  "50661.bms3.3bcu1fault4_6.0": "正常",
  "50661.bms3.3bcu1fault4_6.1": "告警",
  "50661.bms3.3bcu1fault4_7.0": "正常",
  "50661.bms3.3bcu1fault4_7.1": "告警",
  "50661.bms3.3bcu2fault1_0.0": "正常",
  "50661.bms3.3bcu2fault1_0.1": "告警",
  "50661.bms3.3bcu2fault1_1.0": "正常",
  "50661.bms3.3bcu2fault1_1.1": "告警",
  "50661.bms3.3bcu2fault1_10.0": "正常",
  "50661.bms3.3bcu2fault1_10.1": "告警",
  "50661.bms3.3bcu2fault1_11.0": "正常",
  "50661.bms3.3bcu2fault1_11.1": "告警",
  "50661.bms3.3bcu2fault1_12.0": "正常",
  "50661.bms3.3bcu2fault1_12.1": "告警",
  "50661.bms3.3bcu2fault1_14.0": "正常",
  "50661.bms3.3bcu2fault1_14.1": "告警",
  "50661.bms3.3bcu2fault1_15.0": "正常",
  "50661.bms3.3bcu2fault1_15.1": "告警",
  "50661.bms3.3bcu2fault1_2.0": "正常",
  "50661.bms3.3bcu2fault1_2.1": "告警",
  "50661.bms3.3bcu2fault1_3.0": "正常",
  "50661.bms3.3bcu2fault1_3.1": "告警",
  "50661.bms3.3bcu2fault1_4.0": "正常",
  "50661.bms3.3bcu2fault1_4.1": "告警",
  "50661.bms3.3bcu2fault1_5.0": "正常",
  "50661.bms3.3bcu2fault1_5.1": "告警",
  "50661.bms3.3bcu2fault1_6.0": "正常",
  "50661.bms3.3bcu2fault1_6.1": "告警",
  "50661.bms3.3bcu2fault1_7.0": "正常",
  "50661.bms3.3bcu2fault1_7.1": "告警",
  "50661.bms3.3bcu2fault1_8.0": "正常",
  "50661.bms3.3bcu2fault1_8.1": "告警",
  "50661.bms3.3bcu2fault1_9.0": "正常",
  "50661.bms3.3bcu2fault1_9.1": "告警",
  "50661.bms3.3bcu2fault2_0.0": "正常",
  "50661.bms3.3bcu2fault2_0.1": "告警",
  "50661.bms3.3bcu2fault2_1.0": "正常",
  "50661.bms3.3bcu2fault2_1.1": "告警",
  "50661.bms3.3bcu2fault2_11.0": "正常",
  "50661.bms3.3bcu2fault2_11.1": "告警",
  "50661.bms3.3bcu2fault2_15.0": "正常",
  "50661.bms3.3bcu2fault2_15.1": "告警",
  "50661.bms3.3bcu2fault2_2.0": "正常",
  "50661.bms3.3bcu2fault2_2.1": "告警",
  "50661.bms3.3bcu2fault2_3.0": "正常",
  "50661.bms3.3bcu2fault2_3.1": "告警",
  "50661.bms3.3bcu2fault2_4.0": "正常",
  "50661.bms3.3bcu2fault2_4.1": "告警",
  "50661.bms3.3bcu2fault2_5.0": "正常",
  "50661.bms3.3bcu2fault2_5.1": "告警",
  "50661.bms3.3bcu2fault2_6.0": "正常",
  "50661.bms3.3bcu2fault2_6.1": "告警",
  "50661.bms3.3bcu2fault2_7.0": "正常",
  "50661.bms3.3bcu2fault2_7.1": "告警",
  "50661.bms3.3bcu2fault2_8.0": "正常",
  "50661.bms3.3bcu2fault2_8.1": "告警",
  "50661.bms3.3bcu2fault3_10.0": "正常",
  "50661.bms3.3bcu2fault3_10.1": "告警",
  "50661.bms3.3bcu2fault3_11.0": "正常",
  "50661.bms3.3bcu2fault3_11.1": "告警",
  "50661.bms3.3bcu2fault3_12.0": "正常",
  "50661.bms3.3bcu2fault3_12.1": "告警",
  "50661.bms3.3bcu2fault3_13.0": "正常",
  "50661.bms3.3bcu2fault3_13.1": "告警",
  "50661.bms3.3bcu2fault3_15.0": "正常",
  "50661.bms3.3bcu2fault3_15.1": "告警",
  "50661.bms3.3bcu2fault3_2.0": "正常",
  "50661.bms3.3bcu2fault3_2.1": "告警",
  "50661.bms3.3bcu2fault3_3.0": "正常",
  "50661.bms3.3bcu2fault3_3.1": "告警",
  "50661.bms3.3bcu2fault3_4.0": "正常",
  "50661.bms3.3bcu2fault3_4.1": "告警",
  "50661.bms3.3bcu2fault3_5.0": "正常",
  "50661.bms3.3bcu2fault3_5.1": "告警",
  "50661.bms3.3bcu2fault3_6.0": "正常",
  "50661.bms3.3bcu2fault3_6.1": "告警",
  "50661.bms3.3bcu2fault3_7.0": "正常",
  "50661.bms3.3bcu2fault3_7.1": "告警",
  "50661.bms3.3bcu2fault3_8.0": "正常",
  "50661.bms3.3bcu2fault3_8.1": "告警",
  "50661.bms3.3bcu2fault3_9.0": "正常",
  "50661.bms3.3bcu2fault3_9.1": "告警",
  "50661.bms3.3bcu2fault4_0.0": "正常",
  "50661.bms3.3bcu2fault4_0.1": "告警",
  "50661.bms3.3bcu2fault4_1.0": "正常",
  "50661.bms3.3bcu2fault4_1.1": "告警",
  "50661.bms3.3bcu2fault4_10.0": "正常",
  "50661.bms3.3bcu2fault4_10.1": "告警",
  "50661.bms3.3bcu2fault4_2.0": "正常",
  "50661.bms3.3bcu2fault4_2.1": "告警",
  "50661.bms3.3bcu2fault4_3.0": "正常",
  "50661.bms3.3bcu2fault4_3.1": "告警",
  "50661.bms3.3bcu2fault4_5.0": "正常",
  "50661.bms3.3bcu2fault4_5.1": "告警",
  "50661.bms3.3bcu2fault4_6.0": "正常",
  "50661.bms3.3bcu2fault4_6.1": "告警",
  "50661.bms3.3bcu2fault4_7.0": "正常",
  "50661.bms3.3bcu2fault4_7.1": "告警",
  "50661.bms3.3bcu3fault1_0.0": "正常",
  "50661.bms3.3bcu3fault1_0.1": "告警",
  "50661.bms3.3bcu3fault1_1.0": "正常",
  "50661.bms3.3bcu3fault1_1.1": "告警",
  "50661.bms3.3bcu3fault1_10.0": "正常",
  "50661.bms3.3bcu3fault1_10.1": "告警",
  "50661.bms3.3bcu3fault1_11.0": "正常",
  "50661.bms3.3bcu3fault1_11.1": "告警",
  "50661.bms3.3bcu3fault1_12.0": "正常",
  "50661.bms3.3bcu3fault1_12.1": "告警",
  "50661.bms3.3bcu3fault1_14.0": "正常",
  "50661.bms3.3bcu3fault1_14.1": "告警",
  "50661.bms3.3bcu3fault1_15.0": "正常",
  "50661.bms3.3bcu3fault1_15.1": "告警",
  "50661.bms3.3bcu3fault1_2.0": "正常",
  "50661.bms3.3bcu3fault1_2.1": "告警",
  "50661.bms3.3bcu3fault1_3.0": "正常",
  "50661.bms3.3bcu3fault1_3.1": "告警",
  "50661.bms3.3bcu3fault1_4.0": "正常",
  "50661.bms3.3bcu3fault1_4.1": "告警",
  "50661.bms3.3bcu3fault1_5.0": "正常",
  "50661.bms3.3bcu3fault1_5.1": "告警",
  "50661.bms3.3bcu3fault1_6.0": "正常",
  "50661.bms3.3bcu3fault1_6.1": "告警",
  "50661.bms3.3bcu3fault1_7.0": "正常",
  "50661.bms3.3bcu3fault1_7.1": "告警",
  "50661.bms3.3bcu3fault1_8.0": "正常",
  "50661.bms3.3bcu3fault1_8.1": "告警",
  "50661.bms3.3bcu3fault1_9.0": "正常",
  "50661.bms3.3bcu3fault1_9.1": "告警",
  "50661.bms3.3bcu3fault2_0.0": "正常",
  "50661.bms3.3bcu3fault2_0.1": "告警",
  "50661.bms3.3bcu3fault2_1.0": "正常",
  "50661.bms3.3bcu3fault2_1.1": "告警",
  "50661.bms3.3bcu3fault2_11.0": "正常",
  "50661.bms3.3bcu3fault2_11.1": "告警",
  "50661.bms3.3bcu3fault2_15.0": "正常",
  "50661.bms3.3bcu3fault2_15.1": "告警",
  "50661.bms3.3bcu3fault2_2.0": "正常",
  "50661.bms3.3bcu3fault2_2.1": "告警",
  "50661.bms3.3bcu3fault2_3.0": "正常",
  "50661.bms3.3bcu3fault2_3.1": "告警",
  "50661.bms3.3bcu3fault2_4.0": "正常",
  "50661.bms3.3bcu3fault2_4.1": "告警",
  "50661.bms3.3bcu3fault2_5.0": "正常",
  "50661.bms3.3bcu3fault2_5.1": "告警",
  "50661.bms3.3bcu3fault2_6.0": "正常",
  "50661.bms3.3bcu3fault2_6.1": "告警",
  "50661.bms3.3bcu3fault2_7.0": "正常",
  "50661.bms3.3bcu3fault2_7.1": "告警",
  "50661.bms3.3bcu3fault2_8.0": "正常",
  "50661.bms3.3bcu3fault2_8.1": "告警",
  "50661.bms3.3bcu3fault3_10.0": "正常",
  "50661.bms3.3bcu3fault3_10.1": "告警",
  "50661.bms3.3bcu3fault3_11.0": "正常",
  "50661.bms3.3bcu3fault3_11.1": "告警",
  "50661.bms3.3bcu3fault3_12.0": "正常",
  "50661.bms3.3bcu3fault3_12.1": "告警",
  "50661.bms3.3bcu3fault3_13.0": "正常",
  "50661.bms3.3bcu3fault3_13.1": "告警",
  "50661.bms3.3bcu3fault3_15.0": "正常",
  "50661.bms3.3bcu3fault3_15.1": "告警",
  "50661.bms3.3bcu3fault3_2.0": "正常",
  "50661.bms3.3bcu3fault3_2.1": "告警",
  "50661.bms3.3bcu3fault3_3.0": "正常",
  "50661.bms3.3bcu3fault3_3.1": "告警",
  "50661.bms3.3bcu3fault3_4.0": "正常",
  "50661.bms3.3bcu3fault3_4.1": "告警",
  "50661.bms3.3bcu3fault3_5.0": "正常",
  "50661.bms3.3bcu3fault3_5.1": "告警",
  "50661.bms3.3bcu3fault3_6.0": "正常",
  "50661.bms3.3bcu3fault3_6.1": "告警",
  "50661.bms3.3bcu3fault3_7.0": "正常",
  "50661.bms3.3bcu3fault3_7.1": "告警",
  "50661.bms3.3bcu3fault3_8.0": "正常",
  "50661.bms3.3bcu3fault3_8.1": "告警",
  "50661.bms3.3bcu3fault3_9.0": "正常",
  "50661.bms3.3bcu3fault3_9.1": "告警",
  "50661.bms3.3bcu3fault4_0.0": "正常",
  "50661.bms3.3bcu3fault4_0.1": "告警",
  "50661.bms3.3bcu3fault4_1.0": "正常",
  "50661.bms3.3bcu3fault4_1.1": "告警",
  "50661.bms3.3bcu3fault4_10.0": "正常",
  "50661.bms3.3bcu3fault4_10.1": "告警",
  "50661.bms3.3bcu3fault4_2.0": "正常",
  "50661.bms3.3bcu3fault4_2.1": "告警",
  "50661.bms3.3bcu3fault4_3.0": "正常",
  "50661.bms3.3bcu3fault4_3.1": "告警",
  "50661.bms3.3bcu3fault4_5.0": "正常",
  "50661.bms3.3bcu3fault4_5.1": "告警",
  "50661.bms3.3bcu3fault4_6.0": "正常",
  "50661.bms3.3bcu3fault4_6.1": "告警",
  "50661.bms3.3bcu3fault4_7.0": "正常",
  "50661.bms3.3bcu3fault4_7.1": "告警",
  "50661.bms4.mcstatus4.0": "断开",
  "50661.bms4.mcstatus4.1": "闭合",
  "50661.bms4.4bcu1fault1_0.0": "正常",
  "50661.bms4.4bcu1fault1_0.1": "告警",
  "50661.bms4.4bcu1fault1_1.0": "正常",
  "50661.bms4.4bcu1fault1_1.1": "告警",
  "50661.bms4.4bcu1fault1_10.0": "正常",
  "50661.bms4.4bcu1fault1_10.1": "告警",
  "50661.bms4.4bcu1fault1_11.0": "正常",
  "50661.bms4.4bcu1fault1_11.1": "告警",
  "50661.bms4.4bcu1fault1_12.0": "正常",
  "50661.bms4.4bcu1fault1_12.1": "告警",
  "50661.bms4.4bcu1fault1_14.0": "正常",
  "50661.bms4.4bcu1fault1_14.1": "告警",
  "50661.bms4.4bcu1fault1_15.0": "正常",
  "50661.bms4.4bcu1fault1_15.1": "告警",
  "50661.bms4.4bcu1fault1_2.0": "正常",
  "50661.bms4.4bcu1fault1_2.1": "告警",
  "50661.bms4.4bcu1fault1_3.0": "正常",
  "50661.bms4.4bcu1fault1_3.1": "告警",
  "50661.bms4.4bcu1fault1_4.0": "正常",
  "50661.bms4.4bcu1fault1_4.1": "告警",
  "50661.bms4.4bcu1fault1_5.0": "正常",
  "50661.bms4.4bcu1fault1_5.1": "告警",
  "50661.bms4.4bcu1fault1_6.0": "正常",
  "50661.bms4.4bcu1fault1_6.1": "告警",
  "50661.bms4.4bcu1fault1_7.0": "正常",
  "50661.bms4.4bcu1fault1_7.1": "告警",
  "50661.bms4.4bcu1fault1_8.0": "正常",
  "50661.bms4.4bcu1fault1_8.1": "告警",
  "50661.bms4.4bcu1fault1_9.0": "正常",
  "50661.bms4.4bcu1fault1_9.1": "告警",
  "50661.bms4.4bcu1fault2_0.0": "正常",
  "50661.bms4.4bcu1fault2_0.1": "告警",
  "50661.bms4.4bcu1fault2_1.0": "正常",
  "50661.bms4.4bcu1fault2_1.1": "告警",
  "50661.bms4.4bcu1fault2_11.0": "正常",
  "50661.bms4.4bcu1fault2_11.1": "告警",
  "50661.bms4.4bcu1fault2_15.0": "正常",
  "50661.bms4.4bcu1fault2_15.1": "告警",
  "50661.bms4.4bcu1fault2_2.0": "正常",
  "50661.bms4.4bcu1fault2_2.1": "告警",
  "50661.bms4.4bcu1fault2_3.0": "正常",
  "50661.bms4.4bcu1fault2_3.1": "告警",
  "50661.bms4.4bcu1fault2_4.0": "正常",
  "50661.bms4.4bcu1fault2_4.1": "告警",
  "50661.bms4.4bcu1fault2_5.0": "正常",
  "50661.bms4.4bcu1fault2_5.1": "告警",
  "50661.bms4.4bcu1fault2_6.0": "正常",
  "50661.bms4.4bcu1fault2_6.1": "告警",
  "50661.bms4.4bcu1fault2_7.0": "正常",
  "50661.bms4.4bcu1fault2_7.1": "告警",
  "50661.bms4.4bcu1fault2_8.0": "正常",
  "50661.bms4.4bcu1fault2_8.1": "告警",
  "50661.bms4.4bcu1fault3_10.0": "正常",
  "50661.bms4.4bcu1fault3_10.1": "告警",
  "50661.bms4.4bcu1fault3_11.0": "正常",
  "50661.bms4.4bcu1fault3_11.1": "告警",
  "50661.bms4.4bcu1fault3_12.0": "正常",
  "50661.bms4.4bcu1fault3_12.1": "告警",
  "50661.bms4.4bcu1fault3_13.0": "正常",
  "50661.bms4.4bcu1fault3_13.1": "告警",
  "50661.bms4.4bcu1fault3_15.0": "正常",
  "50661.bms4.4bcu1fault3_15.1": "告警",
  "50661.bms4.4bcu1fault3_2.0": "正常",
  "50661.bms4.4bcu1fault3_2.1": "告警",
  "50661.bms4.4bcu1fault3_3.0": "正常",
  "50661.bms4.4bcu1fault3_3.1": "告警",
  "50661.bms4.4bcu1fault3_4.0": "正常",
  "50661.bms4.4bcu1fault3_4.1": "告警",
  "50661.bms4.4bcu1fault3_5.0": "正常",
  "50661.bms4.4bcu1fault3_5.1": "告警",
  "50661.bms4.4bcu1fault3_6.0": "正常",
  "50661.bms4.4bcu1fault3_6.1": "告警",
  "50661.bms4.4bcu1fault3_7.0": "正常",
  "50661.bms4.4bcu1fault3_7.1": "告警",
  "50661.bms4.4bcu1fault3_8.0": "正常",
  "50661.bms4.4bcu1fault3_8.1": "告警",
  "50661.bms4.4bcu1fault3_9.0": "正常",
  "50661.bms4.4bcu1fault3_9.1": "告警",
  "50661.bms4.4bcu1fault4_0.0": "正常",
  "50661.bms4.4bcu1fault4_0.1": "告警",
  "50661.bms4.4bcu1fault4_1.0": "正常",
  "50661.bms4.4bcu1fault4_1.1": "告警",
  "50661.bms4.4bcu1fault4_10.0": "正常",
  "50661.bms4.4bcu1fault4_10.1": "告警",
  "50661.bms4.4bcu1fault4_2.0": "正常",
  "50661.bms4.4bcu1fault4_2.1": "告警",
  "50661.bms4.4bcu1fault4_3.0": "正常",
  "50661.bms4.4bcu1fault4_3.1": "告警",
  "50661.bms4.4bcu1fault4_5.0": "正常",
  "50661.bms4.4bcu1fault4_5.1": "告警",
  "50661.bms4.4bcu1fault4_6.0": "正常",
  "50661.bms4.4bcu1fault4_6.1": "告警",
  "50661.bms4.4bcu1fault4_7.0": "正常",
  "50661.bms4.4bcu1fault4_7.1": "告警",
  "50661.bms4.4bcu2fault1_0.0": "正常",
  "50661.bms4.4bcu2fault1_0.1": "告警",
  "50661.bms4.4bcu2fault1_1.0": "正常",
  "50661.bms4.4bcu2fault1_1.1": "告警",
  "50661.bms4.4bcu2fault1_10.0": "正常",
  "50661.bms4.4bcu2fault1_10.1": "告警",
  "50661.bms4.4bcu2fault1_11.0": "正常",
  "50661.bms4.4bcu2fault1_11.1": "告警",
  "50661.bms4.4bcu2fault1_12.0": "正常",
  "50661.bms4.4bcu2fault1_12.1": "告警",
  "50661.bms4.4bcu2fault1_14.0": "正常",
  "50661.bms4.4bcu2fault1_14.1": "告警",
  "50661.bms4.4bcu2fault1_15.0": "正常",
  "50661.bms4.4bcu2fault1_15.1": "告警",
  "50661.bms4.4bcu2fault1_2.0": "正常",
  "50661.bms4.4bcu2fault1_2.1": "告警",
  "50661.bms4.4bcu2fault1_3.0": "正常",
  "50661.bms4.4bcu2fault1_3.1": "告警",
  "50661.bms4.4bcu2fault1_4.0": "正常",
  "50661.bms4.4bcu2fault1_4.1": "告警",
  "50661.bms4.4bcu2fault1_5.0": "正常",
  "50661.bms4.4bcu2fault1_5.1": "告警",
  "50661.bms4.4bcu2fault1_6.0": "正常",
  "50661.bms4.4bcu2fault1_6.1": "告警",
  "50661.bms4.4bcu2fault1_7.0": "正常",
  "50661.bms4.4bcu2fault1_7.1": "告警",
  "50661.bms4.4bcu2fault1_8.0": "正常",
  "50661.bms4.4bcu2fault1_8.1": "告警",
  "50661.bms4.4bcu2fault1_9.0": "正常",
  "50661.bms4.4bcu2fault1_9.1": "告警",
  "50661.bms4.4bcu2fault2_0.0": "正常",
  "50661.bms4.4bcu2fault2_0.1": "告警",
  "50661.bms4.4bcu2fault2_1.0": "正常",
  "50661.bms4.4bcu2fault2_1.1": "告警",
  "50661.bms4.4bcu2fault2_11.0": "正常",
  "50661.bms4.4bcu2fault2_11.1": "告警",
  "50661.bms4.4bcu2fault2_15.0": "正常",
  "50661.bms4.4bcu2fault2_15.1": "告警",
  "50661.bms4.4bcu2fault2_2.0": "正常",
  "50661.bms4.4bcu2fault2_2.1": "告警",
  "50661.bms4.4bcu2fault2_3.0": "正常",
  "50661.bms4.4bcu2fault2_3.1": "告警",
  "50661.bms4.4bcu2fault2_4.0": "正常",
  "50661.bms4.4bcu2fault2_4.1": "告警",
  "50661.bms4.4bcu2fault2_5.0": "正常",
  "50661.bms4.4bcu2fault2_5.1": "告警",
  "50661.bms4.4bcu2fault2_6.0": "正常",
  "50661.bms4.4bcu2fault2_6.1": "告警",
  "50661.bms4.4bcu2fault2_7.0": "正常",
  "50661.bms4.4bcu2fault2_7.1": "告警",
  "50661.bms4.4bcu2fault2_8.0": "正常",
  "50661.bms4.4bcu2fault2_8.1": "告警",
  "50661.bms4.4bcu2fault3_10.0": "正常",
  "50661.bms4.4bcu2fault3_10.1": "告警",
  "50661.bms4.4bcu2fault3_11.0": "正常",
  "50661.bms4.4bcu2fault3_11.1": "告警",
  "50661.bms4.4bcu2fault3_12.0": "正常",
  "50661.bms4.4bcu2fault3_12.1": "告警",
  "50661.bms4.4bcu2fault3_13.0": "正常",
  "50661.bms4.4bcu2fault3_13.1": "告警",
  "50661.bms4.4bcu2fault3_15.0": "正常",
  "50661.bms4.4bcu2fault3_15.1": "告警",
  "50661.bms4.4bcu2fault3_2.0": "正常",
  "50661.bms4.4bcu2fault3_2.1": "告警",
  "50661.bms4.4bcu2fault3_3.0": "正常",
  "50661.bms4.4bcu2fault3_3.1": "告警",
  "50661.bms4.4bcu2fault3_4.0": "正常",
  "50661.bms4.4bcu2fault3_4.1": "告警",
  "50661.bms4.4bcu2fault3_5.0": "正常",
  "50661.bms4.4bcu2fault3_5.1": "告警",
  "50661.bms4.4bcu2fault3_6.0": "正常",
  "50661.bms4.4bcu2fault3_6.1": "告警",
  "50661.bms4.4bcu2fault3_7.0": "正常",
  "50661.bms4.4bcu2fault3_7.1": "告警",
  "50661.bms4.4bcu2fault3_8.0": "正常",
  "50661.bms4.4bcu2fault3_8.1": "告警",
  "50661.bms4.4bcu2fault3_9.0": "正常",
  "50661.bms4.4bcu2fault3_9.1": "告警",
  "50661.bms4.4bcu2fault4_0.0": "正常",
  "50661.bms4.4bcu2fault4_0.1": "告警",
  "50661.bms4.4bcu2fault4_1.0": "正常",
  "50661.bms4.4bcu2fault4_1.1": "告警",
  "50661.bms4.4bcu2fault4_10.0": "正常",
  "50661.bms4.4bcu2fault4_10.1": "告警",
  "50661.bms4.4bcu2fault4_2.0": "正常",
  "50661.bms4.4bcu2fault4_2.1": "告警",
  "50661.bms4.4bcu2fault4_3.0": "正常",
  "50661.bms4.4bcu2fault4_3.1": "告警",
  "50661.bms4.4bcu2fault4_5.0": "正常",
  "50661.bms4.4bcu2fault4_5.1": "告警",
  "50661.bms4.4bcu2fault4_6.0": "正常",
  "50661.bms4.4bcu2fault4_6.1": "告警",
  "50661.bms4.4bcu2fault4_7.0": "正常",
  "50661.bms4.4bcu2fault4_7.1": "告警",
  "50661.bms4.4bcu3fault1_0.0": "正常",
  "50661.bms4.4bcu3fault1_0.1": "告警",
  "50661.bms4.4bcu3fault1_1.0": "正常",
  "50661.bms4.4bcu3fault1_1.1": "告警",
  "50661.bms4.4bcu3fault1_10.0": "正常",
  "50661.bms4.4bcu3fault1_10.1": "告警",
  "50661.bms4.4bcu3fault1_11.0": "正常",
  "50661.bms4.4bcu3fault1_11.1": "告警",
  "50661.bms4.4bcu3fault1_12.0": "正常",
  "50661.bms4.4bcu3fault1_12.1": "告警",
  "50661.bms4.4bcu3fault1_14.0": "正常",
  "50661.bms4.4bcu3fault1_14.1": "告警",
  "50661.bms4.4bcu3fault1_15.0": "正常",
  "50661.bms4.4bcu3fault1_15.1": "告警",
  "50661.bms4.4bcu3fault1_2.0": "正常",
  "50661.bms4.4bcu3fault1_2.1": "告警",
  "50661.bms4.4bcu3fault1_3.0": "正常",
  "50661.bms4.4bcu3fault1_3.1": "告警",
  "50661.bms4.4bcu3fault1_4.0": "正常",
  "50661.bms4.4bcu3fault1_4.1": "告警",
  "50661.bms4.4bcu3fault1_5.0": "正常",
  "50661.bms4.4bcu3fault1_5.1": "告警",
  "50661.bms4.4bcu3fault1_6.0": "正常",
  "50661.bms4.4bcu3fault1_6.1": "告警",
  "50661.bms4.4bcu3fault1_7.0": "正常",
  "50661.bms4.4bcu3fault1_7.1": "告警",
  "50661.bms4.4bcu3fault1_8.0": "正常",
  "50661.bms4.4bcu3fault1_8.1": "告警",
  "50661.bms4.4bcu3fault1_9.0": "正常",
  "50661.bms4.4bcu3fault1_9.1": "告警",
  "50661.bms4.4bcu3fault2_0.0": "正常",
  "50661.bms4.4bcu3fault2_0.1": "告警",
  "50661.bms4.4bcu3fault2_1.0": "正常",
  "50661.bms4.4bcu3fault2_1.1": "告警",
  "50661.bms4.4bcu3fault2_11.0": "正常",
  "50661.bms4.4bcu3fault2_11.1": "告警",
  "50661.bms4.4bcu3fault2_15.0": "正常",
  "50661.bms4.4bcu3fault2_15.1": "告警",
  "50661.bms4.4bcu3fault2_2.0": "正常",
  "50661.bms4.4bcu3fault2_2.1": "告警",
  "50661.bms4.4bcu3fault2_3.0": "正常",
  "50661.bms4.4bcu3fault2_3.1": "告警",
  "50661.bms4.4bcu3fault2_4.0": "正常",
  "50661.bms4.4bcu3fault2_4.1": "告警",
  "50661.bms4.4bcu3fault2_5.0": "正常",
  "50661.bms4.4bcu3fault2_5.1": "告警",
  "50661.bms4.4bcu3fault2_6.0": "正常",
  "50661.bms4.4bcu3fault2_6.1": "告警",
  "50661.bms4.4bcu3fault2_7.0": "正常",
  "50661.bms4.4bcu3fault2_7.1": "告警",
  "50661.bms4.4bcu3fault2_8.0": "正常",
  "50661.bms4.4bcu3fault2_8.1": "告警",
  "50661.bms4.4bcu3fault3_10.0": "正常",
  "50661.bms4.4bcu3fault3_10.1": "告警",
  "50661.bms4.4bcu3fault3_11.0": "正常",
  "50661.bms4.4bcu3fault3_11.1": "告警",
  "50661.bms4.4bcu3fault3_12.0": "正常",
  "50661.bms4.4bcu3fault3_12.1": "告警",
  "50661.bms4.4bcu3fault3_13.0": "正常",
  "50661.bms4.4bcu3fault3_13.1": "告警",
  "50661.bms4.4bcu3fault3_15.0": "正常",
  "50661.bms4.4bcu3fault3_15.1": "告警",
  "50661.bms4.4bcu3fault3_2.0": "正常",
  "50661.bms4.4bcu3fault3_2.1": "告警",
  "50661.bms4.4bcu3fault3_3.0": "正常",
  "50661.bms4.4bcu3fault3_3.1": "告警",
  "50661.bms4.4bcu3fault3_4.0": "正常",
  "50661.bms4.4bcu3fault3_4.1": "告警",
  "50661.bms4.4bcu3fault3_5.0": "正常",
  "50661.bms4.4bcu3fault3_5.1": "告警",
  "50661.bms4.4bcu3fault3_6.0": "正常",
  "50661.bms4.4bcu3fault3_6.1": "告警",
  "50661.bms4.4bcu3fault3_7.0": "正常",
  "50661.bms4.4bcu3fault3_7.1": "告警",
  "50661.bms4.4bcu3fault3_8.0": "正常",
  "50661.bms4.4bcu3fault3_8.1": "告警",
  "50661.bms4.4bcu3fault3_9.0": "正常",
  "50661.bms4.4bcu3fault3_9.1": "告警",
  "50661.bms4.4bcu3fault4_0.0": "正常",
  "50661.bms4.4bcu3fault4_0.1": "告警",
  "50661.bms4.4bcu3fault4_1.0": "正常",
  "50661.bms4.4bcu3fault4_1.1": "告警",
  "50661.bms4.4bcu3fault4_10.0": "正常",
  "50661.bms4.4bcu3fault4_10.1": "告警",
  "50661.bms4.4bcu3fault4_2.0": "正常",
  "50661.bms4.4bcu3fault4_2.1": "告警",
  "50661.bms4.4bcu3fault4_3.0": "正常",
  "50661.bms4.4bcu3fault4_3.1": "告警",
  "50661.bms4.4bcu3fault4_5.0": "正常",
  "50661.bms4.4bcu3fault4_5.1": "告警",
  "50661.bms4.4bcu3fault4_6.0": "正常",
  "50661.bms4.4bcu3fault4_6.1": "告警",
  "50661.bms4.4bcu3fault4_7.0": "正常",
  "50661.bms4.4bcu3fault4_7.1": "告警",
  "50661.bms5.mcstatus5.0": "断开",
  "50661.bms5.mcstatus5.1": "闭合",
  "50661.bms5.5bcu1fault1_0.0": "正常",
  "50661.bms5.5bcu1fault1_0.1": "告警",
  "50661.bms5.5bcu1fault1_1.0": "正常",
  "50661.bms5.5bcu1fault1_1.1": "告警",
  "50661.bms5.5bcu1fault1_10.0": "正常",
  "50661.bms5.5bcu1fault1_10.1": "告警",
  "50661.bms5.5bcu1fault1_11.0": "正常",
  "50661.bms5.5bcu1fault1_11.1": "告警",
  "50661.bms5.5bcu1fault1_12.0": "正常",
  "50661.bms5.5bcu1fault1_12.1": "告警",
  "50661.bms5.5bcu1fault1_14.0": "正常",
  "50661.bms5.5bcu1fault1_14.1": "告警",
  "50661.bms5.5bcu1fault1_15.0": "正常",
  "50661.bms5.5bcu1fault1_15.1": "告警",
  "50661.bms5.5bcu1fault1_2.0": "正常",
  "50661.bms5.5bcu1fault1_2.1": "告警",
  "50661.bms5.5bcu1fault1_3.0": "正常",
  "50661.bms5.5bcu1fault1_3.1": "告警",
  "50661.bms5.5bcu1fault1_4.0": "正常",
  "50661.bms5.5bcu1fault1_4.1": "告警",
  "50661.bms5.5bcu1fault1_5.0": "正常",
  "50661.bms5.5bcu1fault1_5.1": "告警",
  "50661.bms5.5bcu1fault1_6.0": "正常",
  "50661.bms5.5bcu1fault1_6.1": "告警",
  "50661.bms5.5bcu1fault1_7.0": "正常",
  "50661.bms5.5bcu1fault1_7.1": "告警",
  "50661.bms5.5bcu1fault1_8.0": "正常",
  "50661.bms5.5bcu1fault1_8.1": "告警",
  "50661.bms5.5bcu1fault1_9.0": "正常",
  "50661.bms5.5bcu1fault1_9.1": "告警",
  "50661.bms5.5bcu1fault2_0.0": "正常",
  "50661.bms5.5bcu1fault2_0.1": "告警",
  "50661.bms5.5bcu1fault2_1.0": "正常",
  "50661.bms5.5bcu1fault2_1.1": "告警",
  "50661.bms5.5bcu1fault2_11.0": "正常",
  "50661.bms5.5bcu1fault2_11.1": "告警",
  "50661.bms5.5bcu1fault2_15.0": "正常",
  "50661.bms5.5bcu1fault2_15.1": "告警",
  "50661.bms5.5bcu1fault2_2.0": "正常",
  "50661.bms5.5bcu1fault2_2.1": "告警",
  "50661.bms5.5bcu1fault2_3.0": "正常",
  "50661.bms5.5bcu1fault2_3.1": "告警",
  "50661.bms5.5bcu1fault2_4.0": "正常",
  "50661.bms5.5bcu1fault2_4.1": "告警",
  "50661.bms5.5bcu1fault2_5.0": "正常",
  "50661.bms5.5bcu1fault2_5.1": "告警",
  "50661.bms5.5bcu1fault2_6.0": "正常",
  "50661.bms5.5bcu1fault2_6.1": "告警",
  "50661.bms5.5bcu1fault2_7.0": "正常",
  "50661.bms5.5bcu1fault2_7.1": "告警",
  "50661.bms5.5bcu1fault2_8.0": "正常",
  "50661.bms5.5bcu1fault2_8.1": "告警",
  "50661.bms5.5bcu1fault3_10.0": "正常",
  "50661.bms5.5bcu1fault3_10.1": "告警",
  "50661.bms5.5bcu1fault3_11.0": "正常",
  "50661.bms5.5bcu1fault3_11.1": "告警",
  "50661.bms5.5bcu1fault3_12.0": "正常",
  "50661.bms5.5bcu1fault3_12.1": "告警",
  "50661.bms5.5bcu1fault3_13.0": "正常",
  "50661.bms5.5bcu1fault3_13.1": "告警",
  "50661.bms5.5bcu1fault3_15.0": "正常",
  "50661.bms5.5bcu1fault3_15.1": "告警",
  "50661.bms5.5bcu1fault3_2.0": "正常",
  "50661.bms5.5bcu1fault3_2.1": "告警",
  "50661.bms5.5bcu1fault3_3.0": "正常",
  "50661.bms5.5bcu1fault3_3.1": "告警",
  "50661.bms5.5bcu1fault3_4.0": "正常",
  "50661.bms5.5bcu1fault3_4.1": "告警",
  "50661.bms5.5bcu1fault3_5.0": "正常",
  "50661.bms5.5bcu1fault3_5.1": "告警",
  "50661.bms5.5bcu1fault3_6.0": "正常",
  "50661.bms5.5bcu1fault3_6.1": "告警",
  "50661.bms5.5bcu1fault3_7.0": "正常",
  "50661.bms5.5bcu1fault3_7.1": "告警",
  "50661.bms5.5bcu1fault3_8.0": "正常",
  "50661.bms5.5bcu1fault3_8.1": "告警",
  "50661.bms5.5bcu1fault3_9.0": "正常",
  "50661.bms5.5bcu1fault3_9.1": "告警",
  "50661.bms5.5bcu1fault4_0.0": "正常",
  "50661.bms5.5bcu1fault4_0.1": "告警",
  "50661.bms5.5bcu1fault4_1.0": "正常",
  "50661.bms5.5bcu1fault4_1.1": "告警",
  "50661.bms5.5bcu1fault4_10.0": "正常",
  "50661.bms5.5bcu1fault4_10.1": "告警",
  "50661.bms5.5bcu1fault4_2.0": "正常",
  "50661.bms5.5bcu1fault4_2.1": "告警",
  "50661.bms5.5bcu1fault4_3.0": "正常",
  "50661.bms5.5bcu1fault4_3.1": "告警",
  "50661.bms5.5bcu1fault4_5.0": "正常",
  "50661.bms5.5bcu1fault4_5.1": "告警",
  "50661.bms5.5bcu1fault4_6.0": "正常",
  "50661.bms5.5bcu1fault4_6.1": "告警",
  "50661.bms5.5bcu1fault4_7.0": "正常",
  "50661.bms5.5bcu1fault4_7.1": "告警",
  "50661.bms5.5bcu2fault1_0.0": "正常",
  "50661.bms5.5bcu2fault1_0.1": "告警",
  "50661.bms5.5bcu2fault1_1.0": "正常",
  "50661.bms5.5bcu2fault1_1.1": "告警",
  "50661.bms5.5bcu2fault1_10.0": "正常",
  "50661.bms5.5bcu2fault1_10.1": "告警",
  "50661.bms5.5bcu2fault1_11.0": "正常",
  "50661.bms5.5bcu2fault1_11.1": "告警",
  "50661.bms5.5bcu2fault1_12.0": "正常",
  "50661.bms5.5bcu2fault1_12.1": "告警",
  "50661.bms5.5bcu2fault1_14.0": "正常",
  "50661.bms5.5bcu2fault1_14.1": "告警",
  "50661.bms5.5bcu2fault1_15.0": "正常",
  "50661.bms5.5bcu2fault1_15.1": "告警",
  "50661.bms5.5bcu2fault1_2.0": "正常",
  "50661.bms5.5bcu2fault1_2.1": "告警",
  "50661.bms5.5bcu2fault1_3.0": "正常",
  "50661.bms5.5bcu2fault1_3.1": "告警",
  "50661.bms5.5bcu2fault1_4.0": "正常",
  "50661.bms5.5bcu2fault1_4.1": "告警",
  "50661.bms5.5bcu2fault1_5.0": "正常",
  "50661.bms5.5bcu2fault1_5.1": "告警",
  "50661.bms5.5bcu2fault1_6.0": "正常",
  "50661.bms5.5bcu2fault1_6.1": "告警",
  "50661.bms5.5bcu2fault1_7.0": "正常",
  "50661.bms5.5bcu2fault1_7.1": "告警",
  "50661.bms5.5bcu2fault1_8.0": "正常",
  "50661.bms5.5bcu2fault1_8.1": "告警",
  "50661.bms5.5bcu2fault1_9.0": "正常",
  "50661.bms5.5bcu2fault1_9.1": "告警",
  "50661.bms5.5bcu2fault2_0.0": "正常",
  "50661.bms5.5bcu2fault2_0.1": "告警",
  "50661.bms5.5bcu2fault2_1.0": "正常",
  "50661.bms5.5bcu2fault2_1.1": "告警",
  "50661.bms5.5bcu2fault2_11.0": "正常",
  "50661.bms5.5bcu2fault2_11.1": "告警",
  "50661.bms5.5bcu2fault2_15.0": "正常",
  "50661.bms5.5bcu2fault2_15.1": "告警",
  "50661.bms5.5bcu2fault2_2.0": "正常",
  "50661.bms5.5bcu2fault2_2.1": "告警",
  "50661.bms5.5bcu2fault2_3.0": "正常",
  "50661.bms5.5bcu2fault2_3.1": "告警",
  "50661.bms5.5bcu2fault2_4.0": "正常",
  "50661.bms5.5bcu2fault2_4.1": "告警",
  "50661.bms5.5bcu2fault2_5.0": "正常",
  "50661.bms5.5bcu2fault2_5.1": "告警",
  "50661.bms5.5bcu2fault2_6.0": "正常",
  "50661.bms5.5bcu2fault2_6.1": "告警",
  "50661.bms5.5bcu2fault2_7.0": "正常",
  "50661.bms5.5bcu2fault2_7.1": "告警",
  "50661.bms5.5bcu2fault2_8.0": "正常",
  "50661.bms5.5bcu2fault2_8.1": "告警",
  "50661.bms5.5bcu2fault3_10.0": "正常",
  "50661.bms5.5bcu2fault3_10.1": "告警",
  "50661.bms5.5bcu2fault3_11.0": "正常",
  "50661.bms5.5bcu2fault3_11.1": "告警",
  "50661.bms5.5bcu2fault3_12.0": "正常",
  "50661.bms5.5bcu2fault3_12.1": "告警",
  "50661.bms5.5bcu2fault3_13.0": "正常",
  "50661.bms5.5bcu2fault3_13.1": "告警",
  "50661.bms5.5bcu2fault3_15.0": "正常",
  "50661.bms5.5bcu2fault3_15.1": "告警",
  "50661.bms5.5bcu2fault3_2.0": "正常",
  "50661.bms5.5bcu2fault3_2.1": "告警",
  "50661.bms5.5bcu2fault3_3.0": "正常",
  "50661.bms5.5bcu2fault3_3.1": "告警",
  "50661.bms5.5bcu2fault3_4.0": "正常",
  "50661.bms5.5bcu2fault3_4.1": "告警",
  "50661.bms5.5bcu2fault3_5.0": "正常",
  "50661.bms5.5bcu2fault3_5.1": "告警",
  "50661.bms5.5bcu2fault3_6.0": "正常",
  "50661.bms5.5bcu2fault3_6.1": "告警",
  "50661.bms5.5bcu2fault3_7.0": "正常",
  "50661.bms5.5bcu2fault3_7.1": "告警",
  "50661.bms5.5bcu2fault3_8.0": "正常",
  "50661.bms5.5bcu2fault3_8.1": "告警",
  "50661.bms5.5bcu2fault3_9.0": "正常",
  "50661.bms5.5bcu2fault3_9.1": "告警",
  "50661.bms5.5bcu2fault4_0.0": "正常",
  "50661.bms5.5bcu2fault4_0.1": "告警",
  "50661.bms5.5bcu2fault4_1.0": "正常",
  "50661.bms5.5bcu2fault4_1.1": "告警",
  "50661.bms5.5bcu2fault4_10.0": "正常",
  "50661.bms5.5bcu2fault4_10.1": "告警",
  "50661.bms5.5bcu2fault4_2.0": "正常",
  "50661.bms5.5bcu2fault4_2.1": "告警",
  "50661.bms5.5bcu2fault4_3.0": "正常",
  "50661.bms5.5bcu2fault4_3.1": "告警",
  "50661.bms5.5bcu2fault4_5.0": "正常",
  "50661.bms5.5bcu2fault4_5.1": "告警",
  "50661.bms5.5bcu2fault4_6.0": "正常",
  "50661.bms5.5bcu2fault4_6.1": "告警",
  "50661.bms5.5bcu2fault4_7.0": "正常",
  "50661.bms5.5bcu2fault4_7.1": "告警",
  "50661.bms5.5bcu3fault1_0.0": "正常",
  "50661.bms5.5bcu3fault1_0.1": "告警",
  "50661.bms5.5bcu3fault1_1.0": "正常",
  "50661.bms5.5bcu3fault1_1.1": "告警",
  "50661.bms5.5bcu3fault1_10.0": "正常",
  "50661.bms5.5bcu3fault1_10.1": "告警",
  "50661.bms5.5bcu3fault1_11.0": "正常",
  "50661.bms5.5bcu3fault1_11.1": "告警",
  "50661.bms5.5bcu3fault1_12.0": "正常",
  "50661.bms5.5bcu3fault1_12.1": "告警",
  "50661.bms5.5bcu3fault1_14.0": "正常",
  "50661.bms5.5bcu3fault1_14.1": "告警",
  "50661.bms5.5bcu3fault1_15.0": "正常",
  "50661.bms5.5bcu3fault1_15.1": "告警",
  "50661.bms5.5bcu3fault1_2.0": "正常",
  "50661.bms5.5bcu3fault1_2.1": "告警",
  "50661.bms5.5bcu3fault1_3.0": "正常",
  "50661.bms5.5bcu3fault1_3.1": "告警",
  "50661.bms5.5bcu3fault1_4.0": "正常",
  "50661.bms5.5bcu3fault1_4.1": "告警",
  "50661.bms5.5bcu3fault1_5.0": "正常",
  "50661.bms5.5bcu3fault1_5.1": "告警",
  "50661.bms5.5bcu3fault1_6.0": "正常",
  "50661.bms5.5bcu3fault1_6.1": "告警",
  "50661.bms5.5bcu3fault1_7.0": "正常",
  "50661.bms5.5bcu3fault1_7.1": "告警",
  "50661.bms5.5bcu3fault1_8.0": "正常",
  "50661.bms5.5bcu3fault1_8.1": "告警",
  "50661.bms5.5bcu3fault1_9.0": "正常",
  "50661.bms5.5bcu3fault1_9.1": "告警",
  "50661.bms5.5bcu3fault2_0.0": "正常",
  "50661.bms5.5bcu3fault2_0.1": "告警",
  "50661.bms5.5bcu3fault2_1.0": "正常",
  "50661.bms5.5bcu3fault2_1.1": "告警",
  "50661.bms5.5bcu3fault2_11.0": "正常",
  "50661.bms5.5bcu3fault2_11.1": "告警",
  "50661.bms5.5bcu3fault2_15.0": "正常",
  "50661.bms5.5bcu3fault2_15.1": "告警",
  "50661.bms5.5bcu3fault2_2.0": "正常",
  "50661.bms5.5bcu3fault2_2.1": "告警",
  "50661.bms5.5bcu3fault2_3.0": "正常",
  "50661.bms5.5bcu3fault2_3.1": "告警",
  "50661.bms5.5bcu3fault2_4.0": "正常",
  "50661.bms5.5bcu3fault2_4.1": "告警",
  "50661.bms5.5bcu3fault2_5.0": "正常",
  "50661.bms5.5bcu3fault2_5.1": "告警",
  "50661.bms5.5bcu3fault2_6.0": "正常",
  "50661.bms5.5bcu3fault2_6.1": "告警",
  "50661.bms5.5bcu3fault2_7.0": "正常",
  "50661.bms5.5bcu3fault2_7.1": "告警",
  "50661.bms5.5bcu3fault2_8.0": "正常",
  "50661.bms5.5bcu3fault2_8.1": "告警",
  "50661.bms5.5bcu3fault3_10.0": "正常",
  "50661.bms5.5bcu3fault3_10.1": "告警",
  "50661.bms5.5bcu3fault3_11.0": "正常",
  "50661.bms5.5bcu3fault3_11.1": "告警",
  "50661.bms5.5bcu3fault3_12.0": "正常",
  "50661.bms5.5bcu3fault3_12.1": "告警",
  "50661.bms5.5bcu3fault3_13.0": "正常",
  "50661.bms5.5bcu3fault3_13.1": "告警",
  "50661.bms5.5bcu3fault3_15.0": "正常",
  "50661.bms5.5bcu3fault3_15.1": "告警",
  "50661.bms5.5bcu3fault3_2.0": "正常",
  "50661.bms5.5bcu3fault3_2.1": "告警",
  "50661.bms5.5bcu3fault3_3.0": "正常",
  "50661.bms5.5bcu3fault3_3.1": "告警",
  "50661.bms5.5bcu3fault3_4.0": "正常",
  "50661.bms5.5bcu3fault3_4.1": "告警",
  "50661.bms5.5bcu3fault3_5.0": "正常",
  "50661.bms5.5bcu3fault3_5.1": "告警",
  "50661.bms5.5bcu3fault3_6.0": "正常",
  "50661.bms5.5bcu3fault3_6.1": "告警",
  "50661.bms5.5bcu3fault3_7.0": "正常",
  "50661.bms5.5bcu3fault3_7.1": "告警",
  "50661.bms5.5bcu3fault3_8.0": "正常",
  "50661.bms5.5bcu3fault3_8.1": "告警",
  "50661.bms5.5bcu3fault3_9.0": "正常",
  "50661.bms5.5bcu3fault3_9.1": "告警",
  "50661.bms5.5bcu3fault4_0.0": "正常",
  "50661.bms5.5bcu3fault4_0.1": "告警",
  "50661.bms5.5bcu3fault4_1.0": "正常",
  "50661.bms5.5bcu3fault4_1.1": "告警",
  "50661.bms5.5bcu3fault4_10.0": "正常",
  "50661.bms5.5bcu3fault4_10.1": "告警",
  "50661.bms5.5bcu3fault4_2.0": "正常",
  "50661.bms5.5bcu3fault4_2.1": "告警",
  "50661.bms5.5bcu3fault4_3.0": "正常",
  "50661.bms5.5bcu3fault4_3.1": "告警",
  "50661.bms5.5bcu3fault4_5.0": "正常",
  "50661.bms5.5bcu3fault4_5.1": "告警",
  "50661.bms5.5bcu3fault4_6.0": "正常",
  "50661.bms5.5bcu3fault4_6.1": "告警",
  "50661.bms5.5bcu3fault4_7.0": "正常",
  "50661.bms5.5bcu3fault4_7.1": "告警",
  "50661.lcs.dishotlock.0": "正常",
  "50661.lcs.dishotlock.1": "告警",
  "50661.lcs.dishotlock.255": "未使能",
  "50661.lcs.invcomfalut.0": "正常",
  "50661.lcs.invcomfalut.1": "告警",
  "50661.lcs.invcomfalut.255": "未使能",
  "50661.lcs.invgenlock.0": "正常",
  "50661.lcs.invgenlock.1": "告警",
  "50661.lcs.invgenlock.255": "未使能",
  "50661.lcs.invoclock.0": "正常",
  "50661.lcs.invoclock.1": "告警",
  "50661.lcs.invoclock.255": "未使能",
  "50661.lcs.invotlock.0": "正常",
  "50661.lcs.invotlock.1": "告警",
  "50661.lcs.invotlock.255": "未使能",
  "50661.lcs.invovlock.0": "正常",
  "50661.lcs.invovlock.1": "告警",
  "50661.lcs.invovlock.255": "未使能",
  "50661.lcs.invphlock.0": "正常",
  "50661.lcs.invphlock.1": "告警",
  "50661.lcs.invphlock.255": "未使能",
  "50661.lcs.invuvlock.0": "正常",
  "50661.lcs.invuvlock.1": "告警",
  "50661.lcs.invuvlock.255": "未使能",
  "50661.lcs.iwtsfalut.0": "正常",
  "50661.lcs.iwtsfalut.1": "告警",
  "50661.lcs.iwtsfalut.255": "未使能",
  "50661.lcs.owhtalarm.0": "正常",
  "50661.lcs.owhtalarm.1": "告警",
  "50661.lcs.owhtalarm.255": "未使能",
  "50661.lcs.owltalarm.0": "正常",
  "50661.lcs.owltalarm.1": "告警",
  "50661.lcs.owltalarm.255": "未使能",
  "50661.lcs.owopalarm.0": "正常",
  "50661.lcs.owopalarm.1": "告警",
  "50661.lcs.owopalarm.255": "未使能",
  "50661.lcs.owtsfalut.0": "正常",
  "50661.lcs.owtsfalut.1": "告警",
  "50661.lcs.owtsfalut.255": "未使能",
  "50661.lcs.syshplock.0": "正常",
  "50661.lcs.syshplock.1": "告警",
  "50661.lcs.syshplock.255": "未使能",
  "50661.lcs.syslplock.0": "正常",
  "50661.lcs.syslplock.1": "告警",
  "50661.lcs.syslplock.255": "未使能",
  "50661.lcs.sysopalarm.0": "正常",
  "50661.lcs.sysopalarm.1": "告警",
  "50661.lcs.sysopalarm.255": "未使能",
  "50661.lcs.wateralarm.0": "正常",
  "50661.lcs.wateralarm.1": "告警",
  "50661.lcs.wateralarm.255": "未使能",
  "paramSet.grouping.safetySetting": "安规设置",
  "alarm.name.2069434251900768256": "配置文件错误",
  "alarm.excDesc.2069434251900768256": "配置文件解析失败",
  "alarm.suggestion.2069434251900768256": "1、平台下发最新配置文件\n2、通过本地导入最新配置文件\n3、联系客服",
  "alarm.name.2033183602525470998": "环温告警",
  "alarm.excDesc.2033183602525470998": "无",
  "alarm.suggestion.2033183602525470998": "无",
  "alarm.desc.2033183602525470998": "无",
  "alarm.name.2069434365868396544": "OTA校验失败",
  "alarm.excDesc.2069434365868396544": "升级包校验不通过",
  "alarm.name.2069434015048421376": "认证校验失败",
  "alarm.excDesc.2069434015048421376": "证书验证或TLS握手失败",
  "alarm.suggestion.2069434015048421376": "1. 检查设备系统时间是否正确。\n2. 联系售后申请新的证书文件并加载。",
  "alarm.name.2069436033402032128": "证书错误",
  "alarm.excDesc.2069436033402032128": "证书文件不存在或验证失败",
  "alarm.suggestion.2069436033402032128": "1.检查设备配置文件中是否包含有效证书。 2. 通过APP或云端重新下发正确证书。 3. 若持续告警，联系售后获取匹配证书。",
  "alarm.name.2069439421393031168": "负荷预测精度差",
  "alarm.excDesc.2069439421393031168": "负荷预测误差连续超阈值",
  "alarm.suggestion.2069439421393031168": "1. 平台重新重新下发最新训练参数",
  "alarm.name.2069439263477485568": "光伏预测精度差",
  "alarm.excDesc.2069439263477485568": "光伏发电预测误差连续超阈值",
  "alarm.suggestion.2069439263477485568": "1. 平台重新重新下发最新训练参数",
  "alarm.name.2069438115173519360": "天气数据获取异常",
  "alarm.excDesc.2069438115173519360": "云端天气接口获取失败",
  "alarm.suggestion.2069438115173519360": "1、检查平台下发电价数据json对象是否满足要求",
  "alarm.name.2069437949204910080": "电价数据异常",
  "alarm.excDesc.2069437949204910080": "云端电价接口获取失败",
  "alarm.suggestion.2069437949204910080": "1、检查平台下发电价数据json对象是否满足要求",
  "alarm.name.2069437260529553408": "存储空间不足",
  "alarm.excDesc.2069437260529553408": "数据分区使用率超过90%",
  "alarm.suggestion.2069437260529553408": "1. 系统会自动清理旧数据。\n2. 若告警持续存在，联系售后。",
  "alarm.name.2069435799934488576": "内存溢出",
  "alarm.excDesc.2069435799934488576": "可用内存不足10%",
  "alarm.suggestion.2069435799934488576": "1. 设备会自动重启释放内存。\n2. 若每周发生超过2次，联系售后升级固件。",
  "alarm.name.2069433840355659776": "云端连接断开",
  "alarm.excDesc.2069433840355659776": "MQTT/HTTP链路中断",
  "alarm.suggestion.2069433840355659776": "1. 尝试重启设备，观察自检是否通过。\n2. 若多次重启后仍告警，判定为硬件故障，联系售后更换设备。",
  "alarm.name.2069429403151126528": "上电自检失败",
  "alarm.excDesc.2069429403151126528": "设备上电硬件自检失败",
  "alarm.suggestion.2069429403151126528": "1. 尝试重启设备，观察自检是否通过。\n2. 若多次重启后仍告警，判定为硬件故障，联系售后更换设备。",
  "alarm.name.2033183602525470721": "需要除霜",
  "alarm.excDesc.2033183602525470721": "无",
  "alarm.suggestion.2033183602525470721": "无",
  "alarm.desc.2033183602525470721": "无",
  "alarm.name.2033183602525470723": "直流侧柜门打开",
  "alarm.excDesc.2033183602525470723": "无",
  "alarm.suggestion.2033183602525470723": "无",
  "alarm.desc.2033183602525470723": "无",
  "alarm.name.2033183602525470725": "BMS告警",
  "alarm.excDesc.2033183602525470725": "无",
  "alarm.suggestion.2033183602525470725": "无",
  "alarm.desc.2033183602525470725": "无",
  "alarm.name.2033183602525470731": "交流欠压",
  "alarm.excDesc.2033183602525470731": "无",
  "alarm.suggestion.2033183602525470731": "无",
  "alarm.desc.2033183602525470731": "无",
  "alarm.name.2033183602525470733": "交流过频",
  "alarm.excDesc.2033183602525470733": "无",
  "alarm.suggestion.2033183602525470733": "无",
  "alarm.desc.2033183602525470733": "无",
  "alarm.name.2033183602525470735": "交流缺相",
  "alarm.excDesc.2033183602525470735": "无",
  "alarm.suggestion.2033183602525470735": "无",
  "alarm.desc.2033183602525470735": "无",
  "alarm.name.2033183602525470737": "交流未上电",
  "alarm.excDesc.2033183602525470737": "无",
  "alarm.suggestion.2033183602525470737": "无",
  "alarm.desc.2033183602525470737": "无",
  "alarm.name.2033183602525470739": "交流手动开关未闭合",
  "alarm.excDesc.2033183602525470739": "无",
  "alarm.suggestion.2033183602525470739": "无",
  "alarm.desc.2033183602525470739": "无",
  "alarm.name.2033183602525470741": "高温降频运行",
  "alarm.excDesc.2033183602525470741": "无",
  "alarm.suggestion.2033183602525470741": "无",
  "alarm.desc.2033183602525470741": "无",
  "alarm.name.2033183602525470743": "直流母线过压",
  "alarm.excDesc.2033183602525470743": "无",
  "alarm.suggestion.2033183602525470743": "无",
  "alarm.desc.2033183602525470743": "无",
  "alarm.name.2033183602525470745": "直流偏压",
  "alarm.excDesc.2033183602525470745": "无",
  "alarm.suggestion.2033183602525470745": "无",
  "alarm.desc.2033183602525470745": "无",
  "alarm.name.2033183602525470747": "功率单元过温",
  "alarm.excDesc.2033183602525470747": "无",
  "alarm.suggestion.2033183602525470747": "无",
  "alarm.desc.2033183602525470747": "无",
  "alarm.name.2033183602525470749": "B相IGBT过温",
  "alarm.excDesc.2033183602525470749": "无",
  "alarm.suggestion.2033183602525470749": "无",
  "alarm.desc.2033183602525470749": "无",
  "alarm.name.2033183602525470751": "直流反接",
  "alarm.excDesc.2033183602525470751": "无",
  "alarm.suggestion.2033183602525470751": "无",
  "alarm.desc.2033183602525470751": "无",
  "alarm.name.2033183602525470753": "A相过流",
  "alarm.excDesc.2033183602525470753": "无",
  "alarm.suggestion.2033183602525470753": "无",
  "alarm.desc.2033183602525470753": "无",
  "alarm.name.2033183602525470755": "C相过流",
  "alarm.excDesc.2033183602525470755": "无",
  "alarm.suggestion.2033183602525470755": "无",
  "alarm.desc.2033183602525470755": "无",
  "alarm.name.2033183602525470757": "放电截止",
  "alarm.excDesc.2033183602525470757": "无",
  "alarm.suggestion.2033183602525470757": "无",
  "alarm.desc.2033183602525470757": "无",
  "alarm.name.2033183602525470761": "整机功率不平衡",
  "alarm.excDesc.2033183602525470761": "无",
  "alarm.suggestion.2033183602525470761": "无",
  "alarm.desc.2033183602525470761": "无",
  "alarm.name.2033183602525470763": "辅助电源变压器过温",
  "alarm.excDesc.2033183602525470763": "无",
  "alarm.suggestion.2033183602525470763": "无",
  "alarm.desc.2033183602525470763": "无",
  "alarm.name.2033183602525470769": "模拟量零偏校准异常",
  "alarm.excDesc.2033183602525470769": "无",
  "alarm.suggestion.2033183602525470769": "无",
  "alarm.desc.2033183602525470769": "无",
  "alarm.name.2033183602525470771": "机内空调故障",
  "alarm.excDesc.2033183602525470771": "无",
  "alarm.suggestion.2033183602525470771": "无",
  "alarm.desc.2033183602525470771": "无",
  "alarm.name.2033183602525470773": "总硬件故障",
  "alarm.excDesc.2033183602525470773": "无",
  "alarm.suggestion.2033183602525470773": "无",
  "alarm.desc.2033183602525470773": "无",
  "alarm.name.2033183602525470775": "通信版配置信息存储异常",
  "alarm.excDesc.2033183602525470775": "无",
  "alarm.suggestion.2033183602525470775": "无",
  "alarm.desc.2033183602525470775": "无",
  "alarm.name.2033183602525470777": "通信版网口2异常",
  "alarm.excDesc.2033183602525470777": "无",
  "alarm.suggestion.2033183602525470777": "无",
  "alarm.desc.2033183602525470777": "无",
  "alarm.name.2033183602525470779": "通信版内部通信异常",
  "alarm.excDesc.2033183602525470779": "无",
  "alarm.suggestion.2033183602525470779": "无",
  "alarm.desc.2033183602525470779": "无",
  "alarm.name.2033183602525470781": "主控板CAN异常",
  "alarm.excDesc.2033183602525470781": "无",
  "alarm.suggestion.2033183602525470781": "无",
  "alarm.desc.2033183602525470781": "无",
  "alarm.name.2033183602525470783": "主控板存储数据错误",
  "alarm.excDesc.2033183602525470783": "无",
  "alarm.suggestion.2033183602525470783": "无",
  "alarm.desc.2033183602525470783": "无",
  "alarm.name.2033183602525470785": "交流1段过压",
  "alarm.excDesc.2033183602525470785": "无",
  "alarm.suggestion.2033183602525470785": "无",
  "alarm.desc.2033183602525470785": "无",
  "alarm.name.2033183602525470787": "交流3段过压",
  "alarm.excDesc.2033183602525470787": "无",
  "alarm.suggestion.2033183602525470787": "无",
  "alarm.desc.2033183602525470787": "无",
  "alarm.name.2033183602525470789": "交流1段欠压",
  "alarm.excDesc.2033183602525470789": "无",
  "alarm.suggestion.2033183602525470789": "无",
  "alarm.desc.2033183602525470789": "无",
  "alarm.name.2033183602525470791": "交流3段欠压",
  "alarm.excDesc.2033183602525470791": "无",
  "alarm.suggestion.2033183602525470791": "无",
  "alarm.desc.2033183602525470791": "无",
  "alarm.name.2033183602525470793": "交流2段过流",
  "alarm.excDesc.2033183602525470793": "无",
  "alarm.suggestion.2033183602525470793": "无",
  "alarm.desc.2033183602525470793": "无",
  "alarm.name.2033183602525470795": "交流硬件过流",
  "alarm.excDesc.2033183602525470795": "无",
  "alarm.suggestion.2033183602525470795": "无",
  "alarm.desc.2033183602525470795": "无",
  "alarm.name.2033183602525470797": "接触器故障",
  "alarm.excDesc.2033183602525470797": "无",
  "alarm.suggestion.2033183602525470797": "无",
  "alarm.desc.2033183602525470797": "无",
  "alarm.name.2033183602525470801": "交流1段过频",
  "alarm.excDesc.2033183602525470801": "无",
  "alarm.suggestion.2033183602525470801": "无",
  "alarm.desc.2033183602525470801": "无",
  "alarm.name.2033183602525470803": "交流1段欠频",
  "alarm.excDesc.2033183602525470803": "无",
  "alarm.suggestion.2033183602525470803": "无",
  "alarm.desc.2033183602525470803": "无",
  "alarm.name.2033183602525470805": "交流孤岛保护",
  "alarm.excDesc.2033183602525470805": "无",
  "alarm.suggestion.2033183602525470805": "无",
  "alarm.desc.2033183602525470805": "无",
  "alarm.name.2033183602525470807": "高电压穿越失败",
  "alarm.excDesc.2033183602525470807": "无",
  "alarm.suggestion.2033183602525470807": "无",
  "alarm.desc.2033183602525470807": "无",
  "alarm.name.2033183602525470809": "交流漏电保护",
  "alarm.excDesc.2033183602525470809": "无",
  "alarm.suggestion.2033183602525470809": "无",
  "alarm.desc.2033183602525470809": "无",
  "alarm.name.2033183602525470722": "交流册柜门打开",
  "alarm.excDesc.2033183602525470722": "无",
  "alarm.suggestion.2033183602525470722": "无",
  "alarm.desc.2033183602525470722": "无",
  "alarm.name.2033183602525470724": "机内空调告警",
  "alarm.excDesc.2033183602525470724": "无",
  "alarm.suggestion.2033183602525470724": "无",
  "alarm.desc.2033183602525470724": "无",
  "alarm.name.2033183602525470726": "BMS降频",
  "alarm.excDesc.2033183602525470726": "无",
  "alarm.suggestion.2033183602525470726": "无",
  "alarm.desc.2033183602525470726": "无",
  "alarm.name.2033183602525470730": "交流过压",
  "alarm.excDesc.2033183602525470730": "无",
  "alarm.suggestion.2033183602525470730": "无",
  "alarm.desc.2033183602525470730": "无",
  "alarm.name.2033183602525470732": "交流过流",
  "alarm.excDesc.2033183602525470732": "无",
  "alarm.suggestion.2033183602525470732": "无",
  "alarm.desc.2033183602525470732": "无",
  "alarm.name.2033183602525470734": "交流欠频",
  "alarm.excDesc.2033183602525470734": "无",
  "alarm.suggestion.2033183602525470734": "无",
  "alarm.desc.2033183602525470734": "无",
  "alarm.name.2033183602525470736": "交流相序错误",
  "alarm.excDesc.2033183602525470736": "无",
  "alarm.suggestion.2033183602525470736": "无",
  "alarm.desc.2033183602525470736": "无",
  "alarm.name.2033183602525470738": "电抗器过温",
  "alarm.excDesc.2033183602525470738": "无",
  "alarm.suggestion.2033183602525470738": "无",
  "alarm.desc.2033183602525470738": "无",
  "alarm.name.2033183602525470740": "直流手动开关未闭合",
  "alarm.excDesc.2033183602525470740": "无",
  "alarm.suggestion.2033183602525470740": "无",
  "alarm.desc.2033183602525470740": "无",
  "alarm.name.2033183602525470742": "交流电压不符合离网",
  "alarm.excDesc.2033183602525470742": "无",
  "alarm.suggestion.2033183602525470742": "无",
  "alarm.desc.2033183602525470742": "无",
  "alarm.name.2033183602525470744": "直流母线欠压",
  "alarm.excDesc.2033183602525470744": "无",
  "alarm.suggestion.2033183602525470744": "无",
  "alarm.desc.2033183602525470744": "无",
  "alarm.name.2033183602525470746": "直流过流",
  "alarm.excDesc.2033183602525470746": "无",
  "alarm.suggestion.2033183602525470746": "无",
  "alarm.desc.2033183602525470746": "无",
  "alarm.name.2033183602525470748": "A相IGBT过温",
  "alarm.excDesc.2033183602525470748": "无",
  "alarm.suggestion.2033183602525470748": "无",
  "alarm.desc.2033183602525470748": "无",
  "alarm.name.2033183602525470750": "C相IGBT过温",
  "alarm.excDesc.2033183602525470750": "无",
  "alarm.suggestion.2033183602525470750": "无",
  "alarm.desc.2033183602525470750": "无",
  "alarm.name.2033183602525470752": "硬件连接错误",
  "alarm.excDesc.2033183602525470752": "无",
  "alarm.suggestion.2033183602525470752": "无",
  "alarm.desc.2033183602525470752": "无",
  "alarm.name.2033183602525470754": "B相过流",
  "alarm.excDesc.2033183602525470754": "无",
  "alarm.suggestion.2033183602525470754": "无",
  "alarm.desc.2033183602525470754": "无",
  "alarm.name.2033183602525470756": "充电截止",
  "alarm.excDesc.2033183602525470756": "无",
  "alarm.suggestion.2033183602525470756": "无",
  "alarm.desc.2033183602525470756": "无",
  "alarm.name.2033183602525470758": "BMS脱扣",
  "alarm.excDesc.2033183602525470758": "无",
  "alarm.suggestion.2033183602525470758": "无",
  "alarm.desc.2033183602525470758": "无",
  "alarm.name.2033183602525470762": "辅助电源故障",
  "alarm.excDesc.2033183602525470762": "无",
  "alarm.suggestion.2033183602525470762": "无",
  "alarm.desc.2033183602525470762": "无",
  "alarm.name.2033183602525470764": "急停动作",
  "alarm.excDesc.2033183602525470764": "无",
  "alarm.suggestion.2033183602525470764": "无",
  "alarm.desc.2033183602525470764": "无",
  "alarm.name.2033183602525470768": "烟感动作",
  "alarm.excDesc.2033183602525470768": "无",
  "alarm.suggestion.2033183602525470768": "无",
  "alarm.desc.2033183602525470768": "无",
  "alarm.name.2033183602525470770": "外部急停动作",
  "alarm.excDesc.2033183602525470770": "无",
  "alarm.suggestion.2033183602525470770": "无",
  "alarm.desc.2033183602525470770": "无",
  "alarm.name.2033183602525470772": "机内风机故障",
  "alarm.excDesc.2033183602525470772": "无",
  "alarm.suggestion.2033183602525470772": "无",
  "alarm.desc.2033183602525470772": "无",
  "alarm.name.2033183602525470774": "通信版存储通信异常",
  "alarm.excDesc.2033183602525470774": "无",
  "alarm.suggestion.2033183602525470774": "无",
  "alarm.desc.2033183602525470774": "无",
  "alarm.name.2033183602525470776": "通信版网口1异常",
  "alarm.excDesc.2033183602525470776": "无",
  "alarm.suggestion.2033183602525470776": "无",
  "alarm.desc.2033183602525470776": "无",
  "alarm.name.2033183602525470778": "通信版HMI异常",
  "alarm.excDesc.2033183602525470778": "无",
  "alarm.suggestion.2033183602525470778": "无",
  "alarm.desc.2033183602525470778": "无",
  "alarm.name.2033183602525470780": "主控板内部485异常",
  "alarm.excDesc.2033183602525470780": "无",
  "alarm.suggestion.2033183602525470780": "无",
  "alarm.desc.2033183602525470780": "无",
  "alarm.name.2033183602525470782": "主控板存储通信异常",
  "alarm.excDesc.2033183602525470782": "无",
  "alarm.suggestion.2033183602525470782": "无",
  "alarm.desc.2033183602525470782": "无",
  "alarm.name.2033183602525470784": "并机线异常",
  "alarm.excDesc.2033183602525470784": "无",
  "alarm.suggestion.2033183602525470784": "无",
  "alarm.desc.2033183602525470784": "无",
  "alarm.name.2033183602525470786": "交流2段过压",
  "alarm.excDesc.2033183602525470786": "无",
  "alarm.suggestion.2033183602525470786": "无",
  "alarm.desc.2033183602525470786": "无",
  "alarm.name.2033183602525470788": "交流硬件过压",
  "alarm.excDesc.2033183602525470788": "无",
  "alarm.suggestion.2033183602525470788": "无",
  "alarm.desc.2033183602525470788": "无",
  "alarm.name.2033183602525470790": "交流2段欠压",
  "alarm.excDesc.2033183602525470790": "无",
  "alarm.suggestion.2033183602525470790": "无",
  "alarm.desc.2033183602525470790": "无",
  "alarm.name.2033183602525470792": "交流1段过流",
  "alarm.excDesc.2033183602525470792": "无",
  "alarm.suggestion.2033183602525470792": "无",
  "alarm.desc.2033183602525470792": "无",
  "alarm.name.2033183602525470794": "交流3段过流",
  "alarm.excDesc.2033183602525470794": "无",
  "alarm.suggestion.2033183602525470794": "无",
  "alarm.desc.2033183602525470794": "无",
  "alarm.name.2033183602525470796": "断路器故障",
  "alarm.excDesc.2033183602525470796": "无",
  "alarm.suggestion.2033183602525470796": "无",
  "alarm.desc.2033183602525470796": "无",
  "alarm.name.2033183602525470798": "熔断器动作",
  "alarm.excDesc.2033183602525470798": "无",
  "alarm.suggestion.2033183602525470798": "无",
  "alarm.desc.2033183602525470798": "无",
  "alarm.name.2033183602525470800": "交流浪涌保护器动作",
  "alarm.excDesc.2033183602525470800": "无",
  "alarm.suggestion.2033183602525470800": "无",
  "alarm.desc.2033183602525470800": "无",
  "alarm.name.2033183602525470802": "交流2段过频",
  "alarm.excDesc.2033183602525470802": "无",
  "alarm.suggestion.2033183602525470802": "无",
  "alarm.desc.2033183602525470802": "无",
  "alarm.name.2033183602525470804": "交流2段欠频",
  "alarm.excDesc.2033183602525470804": "无",
  "alarm.suggestion.2033183602525470804": "无",
  "alarm.desc.2033183602525470804": "无",
  "alarm.name.2033183602525470806": "低电压穿越失败",
  "alarm.excDesc.2033183602525470806": "无",
  "alarm.suggestion.2033183602525470806": "无",
  "alarm.desc.2033183602525470806": "无",
  "alarm.name.2033183602525470808": "交流预充超时",
  "alarm.excDesc.2033183602525470808": "无",
  "alarm.suggestion.2033183602525470808": "无",
  "alarm.desc.2033183602525470808": "无",
  "alarm.name.2033183602525470810": "直流母线1段过压",
  "alarm.excDesc.2033183602525470810": "无",
  "alarm.suggestion.2033183602525470810": "无",
  "alarm.desc.2033183602525470810": "无",
  "alarm.name.2033183602525470812": "直流母线3段过压",
  "alarm.excDesc.2033183602525470812": "无",
  "alarm.suggestion.2033183602525470812": "无",
  "alarm.desc.2033183602525470812": "无",
  "alarm.name.2033183602525470814": "直流母线1段欠压",
  "alarm.excDesc.2033183602525470814": "无",
  "alarm.suggestion.2033183602525470814": "无",
  "alarm.desc.2033183602525470814": "无",
  "alarm.name.2033183602525470816": "直流母线3段欠压",
  "alarm.excDesc.2033183602525470816": "无",
  "alarm.suggestion.2033183602525470816": "无",
  "alarm.desc.2033183602525470816": "无",
  "alarm.name.2033183602525470818": "直流2段偏压",
  "alarm.excDesc.2033183602525470818": "无",
  "alarm.suggestion.2033183602525470818": "无",
  "alarm.desc.2033183602525470818": "无",
  "alarm.name.2033183602525470820": "直流母线硬件偏压",
  "alarm.excDesc.2033183602525470820": "无",
  "alarm.suggestion.2033183602525470820": "无",
  "alarm.desc.2033183602525470820": "无",
  "alarm.name.2033183602525470822": "直流2段过流",
  "alarm.excDesc.2033183602525470822": "无",
  "alarm.suggestion.2033183602525470822": "无",
  "alarm.desc.2033183602525470822": "无",
  "alarm.name.2033183602525470824": "直流母线硬件过流",
  "alarm.excDesc.2033183602525470824": "无",
  "alarm.suggestion.2033183602525470824": "无",
  "alarm.desc.2033183602525470824": "无",
  "alarm.name.2033183602525470826": "A相软件过流",
  "alarm.excDesc.2033183602525470826": "无",
  "alarm.suggestion.2033183602525470826": "无",
  "alarm.desc.2033183602525470826": "无",
  "alarm.name.2033183602525470828": "C相软件过流",
  "alarm.excDesc.2033183602525470828": "无",
  "alarm.suggestion.2033183602525470828": "无",
  "alarm.desc.2033183602525470828": "无",
  "alarm.name.2033183602525470830": "B相硬件过流",
  "alarm.excDesc.2033183602525470830": "无",
  "alarm.suggestion.2033183602525470830": "无",
  "alarm.desc.2033183602525470830": "无",
  "alarm.name.2033183602525470832": "A相驱动故障",
  "alarm.excDesc.2033183602525470832": "无",
  "alarm.suggestion.2033183602525470832": "无",
  "alarm.desc.2033183602525470832": "无",
  "alarm.name.2033183602525470834": "C相驱动故障",
  "alarm.excDesc.2033183602525470834": "无",
  "alarm.suggestion.2033183602525470834": "无",
  "alarm.desc.2033183602525470834": "无",
  "alarm.name.2033183602525470836": "B相硬件过温",
  "alarm.excDesc.2033183602525470836": "无",
  "alarm.suggestion.2033183602525470836": "无",
  "alarm.desc.2033183602525470836": "无",
  "alarm.name.2033183602525470838": "功率单元对地短路",
  "alarm.excDesc.2033183602525470838": "无",
  "alarm.suggestion.2033183602525470838": "无",
  "alarm.desc.2033183602525470838": "无",
  "alarm.name.2033183602525470840": "正母线绝缘阻抗低",
  "alarm.excDesc.2033183602525470840": "无",
  "alarm.suggestion.2033183602525470840": "无",
  "alarm.desc.2033183602525470840": "无",
  "alarm.name.2033183602525470842": "直流浪涌保护器动作",
  "alarm.excDesc.2033183602525470842": "无",
  "alarm.suggestion.2033183602525470842": "无",
  "alarm.desc.2033183602525470842": "无",
  "alarm.name.2033183602525470844": "直流断路器动作",
  "alarm.excDesc.2033183602525470844": "无",
  "alarm.suggestion.2033183602525470844": "无",
  "alarm.desc.2033183602525470844": "无",
  "alarm.name.2033183602525470848": "单元风机故障",
  "alarm.excDesc.2033183602525470848": "无",
  "alarm.suggestion.2033183602525470848": "无",
  "alarm.desc.2033183602525470848": "无",
  "alarm.name.2033183602525470850": "光伏过压/电池过压",
  "alarm.excDesc.2033183602525470850": "无",
  "alarm.suggestion.2033183602525470850": "无",
  "alarm.desc.2033183602525470850": "无",
  "alarm.name.2033183602525470852": "光伏过流/电池过流",
  "alarm.excDesc.2033183602525470852": "无",
  "alarm.suggestion.2033183602525470852": "无",
  "alarm.desc.2033183602525470852": "无",
  "alarm.name.2033183602525470854": "反向放电",
  "alarm.excDesc.2033183602525470854": "无",
  "alarm.suggestion.2033183602525470854": "无",
  "alarm.desc.2033183602525470854": "无",
  "alarm.name.2033183602525470856": "功率单元通讯故障",
  "alarm.excDesc.2033183602525470856": "无",
  "alarm.suggestion.2033183602525470856": "无",
  "alarm.desc.2033183602525470856": "无",
  "alarm.name.2033183602525470858": "总压欠压1级",
  "alarm.excDesc.2033183602525470858": "无",
  "alarm.suggestion.2033183602525470858": "无",
  "alarm.desc.2033183602525470858": "无",
  "alarm.name.2033183602525470860": "单体欠压1级",
  "alarm.excDesc.2033183602525470860": "无",
  "alarm.suggestion.2033183602525470860": "无",
  "alarm.desc.2033183602525470860": "无",
  "alarm.name.2033183602525470862": "单体低温1级",
  "alarm.excDesc.2033183602525470862": "无",
  "alarm.suggestion.2033183602525470862": "无",
  "alarm.desc.2033183602525470862": "无",
  "alarm.name.2033183602525470864": "温差过大1级",
  "alarm.excDesc.2033183602525470864": "无",
  "alarm.suggestion.2033183602525470864": "无",
  "alarm.desc.2033183602525470864": "无",
  "alarm.name.2033183602525470866": "高压异常1级",
  "alarm.excDesc.2033183602525470866": "无",
  "alarm.suggestion.2033183602525470866": "无",
  "alarm.desc.2033183602525470866": "无",
  "alarm.name.2033183602525470868": "单体电压排线1级",
  "alarm.excDesc.2033183602525470868": "无",
  "alarm.suggestion.2033183602525470868": "无",
  "alarm.desc.2033183602525470868": "无",
  "alarm.name.2033183602525470870": "SOC过低1级",
  "alarm.excDesc.2033183602525470870": "无",
  "alarm.suggestion.2033183602525470870": "无",
  "alarm.desc.2033183602525470870": "无",
  "alarm.name.2033183602525470872": "总压过压2级",
  "alarm.excDesc.2033183602525470872": "无",
  "alarm.suggestion.2033183602525470872": "无",
  "alarm.desc.2033183602525470872": "无",
  "alarm.name.2033183602525470874": "单体过压2级",
  "alarm.excDesc.2033183602525470874": "无",
  "alarm.suggestion.2033183602525470874": "无",
  "alarm.desc.2033183602525470874": "无",
  "alarm.name.2033183602525470876": "单体过温2级",
  "alarm.excDesc.2033183602525470876": "无",
  "alarm.suggestion.2033183602525470876": "无",
  "alarm.desc.2033183602525470876": "无",
  "alarm.name.2033183602525470878": "压差过大2级",
  "alarm.excDesc.2033183602525470878": "无",
  "alarm.suggestion.2033183602525470878": "无",
  "alarm.desc.2033183602525470878": "无",
  "alarm.name.2033183602525470880": "电流过大2级",
  "alarm.excDesc.2033183602525470880": "无",
  "alarm.suggestion.2033183602525470880": "无",
  "alarm.desc.2033183602525470880": "无",
  "alarm.name.2033183602525470882": "主从通讯2级",
  "alarm.excDesc.2033183602525470882": "无",
  "alarm.suggestion.2033183602525470882": "无",
  "alarm.desc.2033183602525470882": "无",
  "alarm.name.2033183602525470884": "单体温感排线2级",
  "alarm.excDesc.2033183602525470884": "无",
  "alarm.suggestion.2033183602525470884": "无",
  "alarm.desc.2033183602525470884": "无",
  "alarm.name.2033183602525470886": "绝缘漏电2级",
  "alarm.excDesc.2033183602525470886": "无",
  "alarm.suggestion.2033183602525470886": "无",
  "alarm.desc.2033183602525470886": "无",
  "alarm.name.2033183602525470811": "直流母线2段过压",
  "alarm.excDesc.2033183602525470811": "无",
  "alarm.suggestion.2033183602525470811": "无",
  "alarm.desc.2033183602525470811": "无",
  "alarm.name.2033183602525470813": "直流母线硬件过压",
  "alarm.excDesc.2033183602525470813": "无",
  "alarm.suggestion.2033183602525470813": "无",
  "alarm.desc.2033183602525470813": "无",
  "alarm.name.2033183602525470815": "直流母线2段欠压",
  "alarm.excDesc.2033183602525470815": "无",
  "alarm.suggestion.2033183602525470815": "无",
  "alarm.desc.2033183602525470815": "无",
  "alarm.name.2033183602525470817": "直流1段偏压",
  "alarm.excDesc.2033183602525470817": "无",
  "alarm.suggestion.2033183602525470817": "无",
  "alarm.desc.2033183602525470817": "无",
  "alarm.name.2033183602525470819": "直流3段偏压",
  "alarm.excDesc.2033183602525470819": "无",
  "alarm.suggestion.2033183602525470819": "无",
  "alarm.desc.2033183602525470819": "无",
  "alarm.name.2033183602525470821": "直流1段过流",
  "alarm.excDesc.2033183602525470821": "无",
  "alarm.suggestion.2033183602525470821": "无",
  "alarm.desc.2033183602525470821": "无",
  "alarm.name.2033183602525470823": "直流3段过流",
  "alarm.excDesc.2033183602525470823": "无",
  "alarm.suggestion.2033183602525470823": "无",
  "alarm.desc.2033183602525470823": "无",
  "alarm.name.2033183602525470825": "直流母线硬件反接",
  "alarm.excDesc.2033183602525470825": "无",
  "alarm.suggestion.2033183602525470825": "无",
  "alarm.desc.2033183602525470825": "无",
  "alarm.name.2033183602525470827": "B相软件过流",
  "alarm.excDesc.2033183602525470827": "无",
  "alarm.suggestion.2033183602525470827": "无",
  "alarm.desc.2033183602525470827": "无",
  "alarm.name.2033183602525470829": "A相硬件过流",
  "alarm.excDesc.2033183602525470829": "无",
  "alarm.suggestion.2033183602525470829": "无",
  "alarm.desc.2033183602525470829": "无",
  "alarm.name.2033183602525470831": "C相硬件过流",
  "alarm.excDesc.2033183602525470831": "无",
  "alarm.suggestion.2033183602525470831": "无",
  "alarm.desc.2033183602525470831": "无",
  "alarm.name.2033183602525470833": "B相驱动故障",
  "alarm.excDesc.2033183602525470833": "无",
  "alarm.suggestion.2033183602525470833": "无",
  "alarm.desc.2033183602525470833": "无",
  "alarm.name.2033183602525470835": "A相硬件过温",
  "alarm.excDesc.2033183602525470835": "无",
  "alarm.suggestion.2033183602525470835": "无",
  "alarm.desc.2033183602525470835": "无",
  "alarm.name.2033183602525470837": "C相硬件过温",
  "alarm.excDesc.2033183602525470837": "无",
  "alarm.suggestion.2033183602525470837": "无",
  "alarm.desc.2033183602525470837": "无",
  "alarm.name.2033183602525470839": "直流预充电超时",
  "alarm.excDesc.2033183602525470839": "无",
  "alarm.suggestion.2033183602525470839": "无",
  "alarm.desc.2033183602525470839": "无",
  "alarm.name.2033183602525470841": "负母线绝缘阻抗低",
  "alarm.excDesc.2033183602525470841": "无",
  "alarm.suggestion.2033183602525470841": "无",
  "alarm.desc.2033183602525470841": "无",
  "alarm.name.2033183602525470843": "直流熔断器动作",
  "alarm.excDesc.2033183602525470843": "无",
  "alarm.suggestion.2033183602525470843": "无",
  "alarm.desc.2033183602525470843": "无",
  "alarm.name.2033183602525470845": "直流接触器故障",
  "alarm.excDesc.2033183602525470845": "无",
  "alarm.suggestion.2033183602525470845": "无",
  "alarm.desc.2033183602525470845": "无",
  "alarm.name.2033183602525470847": "IGBT过温",
  "alarm.excDesc.2033183602525470847": "无",
  "alarm.suggestion.2033183602525470847": "无",
  "alarm.desc.2033183602525470847": "无",
  "alarm.name.2033183602525470851": "光伏欠压/电池欠压",
  "alarm.excDesc.2033183602525470851": "无",
  "alarm.suggestion.2033183602525470851": "无",
  "alarm.desc.2033183602525470851": "无",
  "alarm.name.2033183602525470853": "光伏反接/电池反接",
  "alarm.excDesc.2033183602525470853": "无",
  "alarm.suggestion.2033183602525470853": "无",
  "alarm.desc.2033183602525470853": "无",
  "alarm.name.2033183602525470855": "硬件过流",
  "alarm.excDesc.2033183602525470855": "无",
  "alarm.suggestion.2033183602525470855": "无",
  "alarm.desc.2033183602525470855": "无",
  "alarm.name.2033183602525470857": "总压过压1级",
  "alarm.excDesc.2033183602525470857": "无",
  "alarm.suggestion.2033183602525470857": "无",
  "alarm.desc.2033183602525470857": "无",
  "alarm.name.2033183602525470859": "单体过压1级",
  "alarm.excDesc.2033183602525470859": "无",
  "alarm.suggestion.2033183602525470859": "无",
  "alarm.desc.2033183602525470859": "无",
  "alarm.name.2033183602525470861": "单体过温1级",
  "alarm.excDesc.2033183602525470861": "无",
  "alarm.suggestion.2033183602525470861": "无",
  "alarm.desc.2033183602525470861": "无",
  "alarm.name.2033183602525470863": "压差过大1级",
  "alarm.excDesc.2033183602525470863": "无",
  "alarm.suggestion.2033183602525470863": "无",
  "alarm.desc.2033183602525470863": "无",
  "alarm.name.2033183602525470865": "电流过大1级",
  "alarm.excDesc.2033183602525470865": "无",
  "alarm.suggestion.2033183602525470865": "无",
  "alarm.desc.2033183602525470865": "无",
  "alarm.name.2033183602525470867": "主从通讯1级",
  "alarm.excDesc.2033183602525470867": "无",
  "alarm.suggestion.2033183602525470867": "无",
  "alarm.desc.2033183602525470867": "无",
  "alarm.name.2033183602525470869": "单体温感排线1级",
  "alarm.excDesc.2033183602525470869": "无",
  "alarm.suggestion.2033183602525470869": "无",
  "alarm.desc.2033183602525470869": "无",
  "alarm.name.2033183602525470871": "绝缘漏电1级",
  "alarm.excDesc.2033183602525470871": "无",
  "alarm.suggestion.2033183602525470871": "无",
  "alarm.desc.2033183602525470871": "无",
  "alarm.name.2033183602525470873": "总压欠压2级",
  "alarm.excDesc.2033183602525470873": "无",
  "alarm.suggestion.2033183602525470873": "无",
  "alarm.desc.2033183602525470873": "无",
  "alarm.name.2033183602525470875": "单体欠压2级",
  "alarm.excDesc.2033183602525470875": "无",
  "alarm.suggestion.2033183602525470875": "无",
  "alarm.desc.2033183602525470875": "无",
  "alarm.name.2033183602525470877": "单体低温2级",
  "alarm.excDesc.2033183602525470877": "无",
  "alarm.suggestion.2033183602525470877": "无",
  "alarm.desc.2033183602525470877": "无",
  "alarm.name.2033183602525470879": "温差过大2级",
  "alarm.excDesc.2033183602525470879": "无",
  "alarm.suggestion.2033183602525470879": "无",
  "alarm.desc.2033183602525470879": "无",
  "alarm.name.2033183602525470881": "高压异常2级",
  "alarm.excDesc.2033183602525470881": "无",
  "alarm.suggestion.2033183602525470881": "无",
  "alarm.desc.2033183602525470881": "无",
  "alarm.name.2033183602525470883": "单体电压排线2级",
  "alarm.excDesc.2033183602525470883": "无",
  "alarm.suggestion.2033183602525470883": "无",
  "alarm.desc.2033183602525470883": "无",
  "alarm.name.2033183602525470885": "SOC过低2级",
  "alarm.excDesc.2033183602525470885": "无",
  "alarm.suggestion.2033183602525470885": "无",
  "alarm.desc.2033183602525470885": "无",
  "alarm.name.2033183602525470887": "总压过压3级",
  "alarm.excDesc.2033183602525470887": "无",
  "alarm.suggestion.2033183602525470887": "无",
  "alarm.desc.2033183602525470887": "无",
  "alarm.name.2033183602525470889": "单体过压3级",
  "alarm.excDesc.2033183602525470889": "无",
  "alarm.suggestion.2033183602525470889": "无",
  "alarm.desc.2033183602525470889": "无",
  "alarm.name.2033183602525470891": "单体过温3级",
  "alarm.excDesc.2033183602525470891": "无",
  "alarm.suggestion.2033183602525470891": "无",
  "alarm.desc.2033183602525470891": "无",
  "alarm.name.2033183602525470893": "压差过大3级",
  "alarm.excDesc.2033183602525470893": "无",
  "alarm.suggestion.2033183602525470893": "无",
  "alarm.desc.2033183602525470893": "无",
  "alarm.name.2033183602525470888": "总压欠压3级",
  "alarm.excDesc.2033183602525470888": "无",
  "alarm.suggestion.2033183602525470888": "无",
  "alarm.desc.2033183602525470888": "无",
  "alarm.name.2033183602525470890": "单体欠压3级",
  "alarm.excDesc.2033183602525470890": "无",
  "alarm.suggestion.2033183602525470890": "无",
  "alarm.desc.2033183602525470890": "无",
  "alarm.name.2033183602525470892": "单体低温3级",
  "alarm.excDesc.2033183602525470892": "无",
  "alarm.suggestion.2033183602525470892": "无",
  "alarm.desc.2033183602525470892": "无",
  "alarm.name.2033183602525470894": "温差过大3级",
  "alarm.excDesc.2033183602525470894": "无",
  "alarm.suggestion.2033183602525470894": "无",
  "alarm.desc.2033183602525470894": "无",
  "alarm.name.2033183602525470896": "高压异常3级",
  "alarm.excDesc.2033183602525470896": "无",
  "alarm.suggestion.2033183602525470896": "无",
  "alarm.desc.2033183602525470896": "无",
  "alarm.name.2033183602525470898": "单体电压排线3级",
  "alarm.excDesc.2033183602525470898": "无",
  "alarm.suggestion.2033183602525470898": "无",
  "alarm.desc.2033183602525470898": "无",
  "alarm.name.2033183602525470900": "SOC过低3级",
  "alarm.excDesc.2033183602525470900": "无",
  "alarm.suggestion.2033183602525470900": "无",
  "alarm.desc.2033183602525470900": "无",
  "alarm.name.2033183602525470902": "粘连1级",
  "alarm.excDesc.2033183602525470902": "无",
  "alarm.suggestion.2033183602525470902": "无",
  "alarm.desc.2033183602525470902": "无",
  "alarm.name.2033183602525470904": "供电过高1级",
  "alarm.excDesc.2033183602525470904": "无",
  "alarm.suggestion.2033183602525470904": "无",
  "alarm.desc.2033183602525470904": "无",
  "alarm.name.2033183602525470906": "T1高温1级",
  "alarm.excDesc.2033183602525470906": "无",
  "alarm.suggestion.2033183602525470906": "无",
  "alarm.desc.2033183602525470906": "无",
  "alarm.name.2033183602525470908": "T2高温1级",
  "alarm.excDesc.2033183602525470908": "无",
  "alarm.suggestion.2033183602525470908": "无",
  "alarm.desc.2033183602525470908": "无",
  "alarm.name.2033183602525470910": "均衡过温1级",
  "alarm.excDesc.2033183602525470910": "无",
  "alarm.suggestion.2033183602525470910": "无",
  "alarm.desc.2033183602525470910": "无",
  "alarm.name.2033183602525470912": "PCS状态1级",
  "alarm.excDesc.2033183602525470912": "无",
  "alarm.suggestion.2033183602525470912": "无",
  "alarm.desc.2033183602525470912": "无",
  "alarm.name.2033183602525470914": "预充状态2级",
  "alarm.excDesc.2033183602525470914": "无",
  "alarm.suggestion.2033183602525470914": "无",
  "alarm.desc.2033183602525470914": "无",
  "alarm.name.2033183602525470916": "供电过低2级",
  "alarm.excDesc.2033183602525470916": "无",
  "alarm.suggestion.2033183602525470916": "无",
  "alarm.desc.2033183602525470916": "无",
  "alarm.name.2033183602525470918": "T1低温2级",
  "alarm.excDesc.2033183602525470918": "无",
  "alarm.suggestion.2033183602525470918": "无",
  "alarm.desc.2033183602525470918": "无",
  "alarm.name.2033183602525470920": "T2低温2级",
  "alarm.excDesc.2033183602525470920": "无",
  "alarm.suggestion.2033183602525470920": "无",
  "alarm.desc.2033183602525470920": "无",
  "alarm.name.2033183602525470922": "电流异常2级",
  "alarm.excDesc.2033183602525470922": "无",
  "alarm.suggestion.2033183602525470922": "无",
  "alarm.desc.2033183602525470922": "无",
  "alarm.name.2033183602525470924": "粘连3级",
  "alarm.excDesc.2033183602525470924": "无",
  "alarm.suggestion.2033183602525470924": "无",
  "alarm.desc.2033183602525470924": "无",
  "alarm.name.2033183602525470926": "供电过高3级",
  "alarm.excDesc.2033183602525470926": "无",
  "alarm.suggestion.2033183602525470926": "无",
  "alarm.desc.2033183602525470926": "无",
  "alarm.name.2033183602525470928": "T1高温3级",
  "alarm.excDesc.2033183602525470928": "无",
  "alarm.suggestion.2033183602525470928": "无",
  "alarm.desc.2033183602525470928": "无",
  "alarm.name.2033183602525470930": "T2高温3级",
  "alarm.excDesc.2033183602525470930": "无",
  "alarm.suggestion.2033183602525470930": "无",
  "alarm.desc.2033183602525470930": "无",
  "alarm.name.2033183602525470932": "均衡过温3级",
  "alarm.excDesc.2033183602525470932": "无",
  "alarm.suggestion.2033183602525470932": "无",
  "alarm.desc.2033183602525470932": "无",
  "alarm.name.2033183602525470934": "PCS状态3级",
  "alarm.excDesc.2033183602525470934": "无",
  "alarm.suggestion.2033183602525470934": "无",
  "alarm.desc.2033183602525470934": "无",
  "alarm.name.2033183602525470936": "EEPROM状态1级",
  "alarm.excDesc.2033183602525470936": "无",
  "alarm.suggestion.2033183602525470936": "无",
  "alarm.desc.2033183602525470936": "无",
  "alarm.name.2033183602525470938": "ADC状态1级",
  "alarm.excDesc.2033183602525470938": "无",
  "alarm.suggestion.2033183602525470938": "无",
  "alarm.desc.2033183602525470938": "无",
  "alarm.name.2033183602525470940": "反馈异常1级",
  "alarm.excDesc.2033183602525470940": "无",
  "alarm.suggestion.2033183602525470940": "无",
  "alarm.desc.2033183602525470940": "无",
  "alarm.name.2033183602525470942": "极限故障1级",
  "alarm.excDesc.2033183602525470942": "无",
  "alarm.suggestion.2033183602525470942": "无",
  "alarm.desc.2033183602525470942": "无",
  "alarm.name.2033183602525470944": "急停故障1级",
  "alarm.excDesc.2033183602525470944": "无",
  "alarm.suggestion.2033183602525470944": "无",
  "alarm.desc.2033183602525470944": "无",
  "alarm.name.2033183602525470946": "控制指令超时1级",
  "alarm.excDesc.2033183602525470946": "无",
  "alarm.suggestion.2033183602525470946": "无",
  "alarm.desc.2033183602525470946": "无",
  "alarm.name.2033183602525470948": "模拟前端状态2级",
  "alarm.excDesc.2033183602525470948": "无",
  "alarm.suggestion.2033183602525470948": "无",
  "alarm.desc.2033183602525470948": "无",
  "alarm.name.2033183602525470950": "RTC状态2级",
  "alarm.excDesc.2033183602525470950": "无",
  "alarm.suggestion.2033183602525470950": "无",
  "alarm.desc.2033183602525470950": "无",
  "alarm.name.2033183602525470952": "SD卡状态2级",
  "alarm.excDesc.2033183602525470952": "无",
  "alarm.suggestion.2033183602525470952": "无",
  "alarm.desc.2033183602525470952": "无",
  "alarm.name.2033183602525470954": "温升过快2级",
  "alarm.excDesc.2033183602525470954": "无",
  "alarm.suggestion.2033183602525470954": "无",
  "alarm.desc.2033183602525470954": "无",
  "alarm.name.2033183602525470956": "开路故障2级",
  "alarm.excDesc.2033183602525470956": "无",
  "alarm.suggestion.2033183602525470956": "无",
  "alarm.desc.2033183602525470956": "无",
  "alarm.name.2033183602525470958": "消防故障2级",
  "alarm.excDesc.2033183602525470958": "无",
  "alarm.suggestion.2033183602525470958": "无",
  "alarm.desc.2033183602525470958": "无",
  "alarm.name.2033183602525470960": "热失控2级",
  "alarm.excDesc.2033183602525470960": "无",
  "alarm.suggestion.2033183602525470960": "无",
  "alarm.desc.2033183602525470960": "无",
  "alarm.name.2033183602525470962": "EEPROM状态3级",
  "alarm.excDesc.2033183602525470962": "无",
  "alarm.suggestion.2033183602525470962": "无",
  "alarm.desc.2033183602525470962": "无",
  "alarm.name.2033183602525470964": "ADC状态3级",
  "alarm.excDesc.2033183602525470964": "无",
  "alarm.suggestion.2033183602525470964": "无",
  "alarm.desc.2033183602525470964": "无",
  "alarm.name.2033183602525470966": "反馈异常3级",
  "alarm.excDesc.2033183602525470966": "无",
  "alarm.suggestion.2033183602525470966": "无",
  "alarm.desc.2033183602525470966": "无",
  "alarm.name.2033183602525470968": "极限故障3级",
  "alarm.excDesc.2033183602525470968": "无",
  "alarm.suggestion.2033183602525470968": "无",
  "alarm.desc.2033183602525470968": "无",
  "alarm.name.2033183602525470895": "电流过大3级",
  "alarm.excDesc.2033183602525470895": "无",
  "alarm.suggestion.2033183602525470895": "无",
  "alarm.desc.2033183602525470895": "无",
  "alarm.name.2033183602525470897": "主从通讯3级",
  "alarm.excDesc.2033183602525470897": "无",
  "alarm.suggestion.2033183602525470897": "无",
  "alarm.desc.2033183602525470897": "无",
  "alarm.name.2033183602525470899": "单体温感排线3级",
  "alarm.excDesc.2033183602525470899": "无",
  "alarm.suggestion.2033183602525470899": "无",
  "alarm.desc.2033183602525470899": "无",
  "alarm.name.2033183602525470901": "绝缘漏电3级",
  "alarm.excDesc.2033183602525470901": "无",
  "alarm.suggestion.2033183602525470901": "无",
  "alarm.desc.2033183602525470901": "无",
  "alarm.name.2033183602525470903": "预充状态1级",
  "alarm.excDesc.2033183602525470903": "无",
  "alarm.suggestion.2033183602525470903": "无",
  "alarm.desc.2033183602525470903": "无",
  "alarm.name.2033183602525470905": "供电过低1级",
  "alarm.excDesc.2033183602525470905": "无",
  "alarm.suggestion.2033183602525470905": "无",
  "alarm.desc.2033183602525470905": "无",
  "alarm.name.2033183602525470907": "T1低温1级",
  "alarm.excDesc.2033183602525470907": "无",
  "alarm.suggestion.2033183602525470907": "无",
  "alarm.desc.2033183602525470907": "无",
  "alarm.name.2033183602525470909": "T2低温1级",
  "alarm.excDesc.2033183602525470909": "无",
  "alarm.suggestion.2033183602525470909": "无",
  "alarm.desc.2033183602525470909": "无",
  "alarm.name.2033183602525470911": "电流异常1级",
  "alarm.excDesc.2033183602525470911": "无",
  "alarm.suggestion.2033183602525470911": "无",
  "alarm.desc.2033183602525470911": "无",
  "alarm.name.2033183602525470913": "粘连2级",
  "alarm.excDesc.2033183602525470913": "无",
  "alarm.suggestion.2033183602525470913": "无",
  "alarm.desc.2033183602525470913": "无",
  "alarm.name.2033183602525470915": "供电过高2级",
  "alarm.excDesc.2033183602525470915": "无",
  "alarm.suggestion.2033183602525470915": "无",
  "alarm.desc.2033183602525470915": "无",
  "alarm.name.2033183602525470917": "T1高温2级",
  "alarm.excDesc.2033183602525470917": "无",
  "alarm.suggestion.2033183602525470917": "无",
  "alarm.desc.2033183602525470917": "无",
  "alarm.name.2033183602525470919": "T2高温2级",
  "alarm.excDesc.2033183602525470919": "无",
  "alarm.suggestion.2033183602525470919": "无",
  "alarm.desc.2033183602525470919": "无",
  "alarm.name.2033183602525470921": "均衡过温2级",
  "alarm.excDesc.2033183602525470921": "无",
  "alarm.suggestion.2033183602525470921": "无",
  "alarm.desc.2033183602525470921": "无",
  "alarm.name.2033183602525470923": "PCS状态2级",
  "alarm.excDesc.2033183602525470923": "无",
  "alarm.suggestion.2033183602525470923": "无",
  "alarm.desc.2033183602525470923": "无",
  "alarm.name.2033183602525470925": "预充状态3级",
  "alarm.excDesc.2033183602525470925": "无",
  "alarm.suggestion.2033183602525470925": "无",
  "alarm.desc.2033183602525470925": "无",
  "alarm.name.2033183602525470927": "供电过低3级",
  "alarm.excDesc.2033183602525470927": "无",
  "alarm.suggestion.2033183602525470927": "无",
  "alarm.desc.2033183602525470927": "无",
  "alarm.name.2033183602525470929": "T1低温3级",
  "alarm.excDesc.2033183602525470929": "无",
  "alarm.suggestion.2033183602525470929": "无",
  "alarm.desc.2033183602525470929": "无",
  "alarm.name.2033183602525470931": "T2低温3级",
  "alarm.excDesc.2033183602525470931": "无",
  "alarm.suggestion.2033183602525470931": "无",
  "alarm.desc.2033183602525470931": "无",
  "alarm.name.2033183602525470933": "电流异常3级",
  "alarm.excDesc.2033183602525470933": "无",
  "alarm.suggestion.2033183602525470933": "无",
  "alarm.desc.2033183602525470933": "无",
  "alarm.name.2033183602525470935": "模拟前端状态1级",
  "alarm.excDesc.2033183602525470935": "无",
  "alarm.suggestion.2033183602525470935": "无",
  "alarm.desc.2033183602525470935": "无",
  "alarm.name.2033183602525470937": "RTC状态1级",
  "alarm.excDesc.2033183602525470937": "无",
  "alarm.suggestion.2033183602525470937": "无",
  "alarm.desc.2033183602525470937": "无",
  "alarm.name.2033183602525470939": "SD卡状态1级",
  "alarm.excDesc.2033183602525470939": "无",
  "alarm.suggestion.2033183602525470939": "无",
  "alarm.desc.2033183602525470939": "无",
  "alarm.name.2033183602525470941": "温升过快1级",
  "alarm.excDesc.2033183602525470941": "无",
  "alarm.suggestion.2033183602525470941": "无",
  "alarm.desc.2033183602525470941": "无",
  "alarm.name.2033183602525470943": "开路故障1级",
  "alarm.excDesc.2033183602525470943": "无",
  "alarm.suggestion.2033183602525470943": "无",
  "alarm.desc.2033183602525470943": "无",
  "alarm.name.2033183602525470945": "消防故障1级",
  "alarm.excDesc.2033183602525470945": "无",
  "alarm.suggestion.2033183602525470945": "无",
  "alarm.desc.2033183602525470945": "无",
  "alarm.name.2033183602525470947": "热失控1级",
  "alarm.excDesc.2033183602525470947": "无",
  "alarm.suggestion.2033183602525470947": "无",
  "alarm.desc.2033183602525470947": "无",
  "alarm.name.2033183602525470949": "EEPROM状态2级",
  "alarm.excDesc.2033183602525470949": "无",
  "alarm.suggestion.2033183602525470949": "无",
  "alarm.desc.2033183602525470949": "无",
  "alarm.name.2033183602525470951": "ADC状态2级",
  "alarm.excDesc.2033183602525470951": "无",
  "alarm.suggestion.2033183602525470951": "无",
  "alarm.desc.2033183602525470951": "无",
  "alarm.name.2033183602525470953": "反馈异常2级",
  "alarm.excDesc.2033183602525470953": "无",
  "alarm.suggestion.2033183602525470953": "无",
  "alarm.desc.2033183602525470953": "无",
  "alarm.name.2033183602525470955": "极限故障2级",
  "alarm.excDesc.2033183602525470955": "无",
  "alarm.suggestion.2033183602525470955": "无",
  "alarm.desc.2033183602525470955": "无",
  "alarm.name.2033183602525470957": "急停故障2级",
  "alarm.excDesc.2033183602525470957": "无",
  "alarm.suggestion.2033183602525470957": "无",
  "alarm.desc.2033183602525470957": "无",
  "alarm.name.2033183602525470959": "控制指令超时2级",
  "alarm.excDesc.2033183602525470959": "无",
  "alarm.suggestion.2033183602525470959": "无",
  "alarm.desc.2033183602525470959": "无",
  "alarm.name.2033183602525470961": "模拟前端状态3级",
  "alarm.excDesc.2033183602525470961": "无",
  "alarm.suggestion.2033183602525470961": "无",
  "alarm.desc.2033183602525470961": "无",
  "alarm.name.2033183602525470963": "RTC状态3级",
  "alarm.excDesc.2033183602525470963": "无",
  "alarm.suggestion.2033183602525470963": "无",
  "alarm.desc.2033183602525470963": "无",
  "alarm.name.2033183602525470965": "SD卡状态3级",
  "alarm.excDesc.2033183602525470965": "无",
  "alarm.suggestion.2033183602525470965": "无",
  "alarm.desc.2033183602525470965": "无",
  "alarm.name.2033183602525470967": "温升过快3级",
  "alarm.excDesc.2033183602525470967": "无",
  "alarm.suggestion.2033183602525470967": "无",
  "alarm.desc.2033183602525470967": "无",
  "alarm.name.2033183602525470969": "开路故障3级",
  "alarm.excDesc.2033183602525470969": "无",
  "alarm.suggestion.2033183602525470969": "无",
  "alarm.desc.2033183602525470969": "无",
  "alarm.name.2033183602525470971": "消防故障3级",
  "alarm.excDesc.2033183602525470971": "无",
  "alarm.suggestion.2033183602525470971": "无",
  "alarm.desc.2033183602525470971": "无",
  "alarm.name.2033183602525470973": "热失控3级",
  "alarm.excDesc.2033183602525470973": "无",
  "alarm.suggestion.2033183602525470973": "无",
  "alarm.desc.2033183602525470973": "无",
  "alarm.name.2033183602525470975": "电池箱欠压1级",
  "alarm.excDesc.2033183602525470975": "无",
  "alarm.suggestion.2033183602525470975": "无",
  "alarm.desc.2033183602525470975": "无",
  "alarm.name.2033183602525470970": "急停故障3级",
  "alarm.excDesc.2033183602525470970": "无",
  "alarm.suggestion.2033183602525470970": "无",
  "alarm.desc.2033183602525470970": "无",
  "alarm.name.2033183602525470972": "控制指令超时3级",
  "alarm.excDesc.2033183602525470972": "无",
  "alarm.suggestion.2033183602525470972": "无",
  "alarm.desc.2033183602525470972": "无",
  "alarm.name.2033183602525470974": "电池箱过压1级",
  "alarm.excDesc.2033183602525470974": "无",
  "alarm.suggestion.2033183602525470974": "无",
  "alarm.desc.2033183602525470974": "无",
  "alarm.name.2033183602525470976": "防雷器故障1级",
  "alarm.excDesc.2033183602525470976": "无",
  "alarm.suggestion.2033183602525470976": "无",
  "alarm.desc.2033183602525470976": "无",
  "alarm.name.2033183602525470978": "水浸故障1级",
  "alarm.excDesc.2033183602525470978": "无",
  "alarm.suggestion.2033183602525470978": "无",
  "alarm.desc.2033183602525470978": "无",
  "alarm.name.2033183602525470980": "气体传感器故障1级",
  "alarm.excDesc.2033183602525470980": "无",
  "alarm.suggestion.2033183602525470980": "无",
  "alarm.desc.2033183602525470980": "无",
  "alarm.name.2033183602525470982": "电池箱过压2级",
  "alarm.excDesc.2033183602525470982": "无",
  "alarm.suggestion.2033183602525470982": "无",
  "alarm.desc.2033183602525470982": "无",
  "alarm.name.2033183602525470984": "防雷器故障2级",
  "alarm.excDesc.2033183602525470984": "无",
  "alarm.suggestion.2033183602525470984": "无",
  "alarm.desc.2033183602525470984": "无",
  "alarm.name.2033183602525470986": "水浸故障2级",
  "alarm.excDesc.2033183602525470986": "无",
  "alarm.suggestion.2033183602525470986": "无",
  "alarm.desc.2033183602525470986": "无",
  "alarm.name.2033183602525470988": "气体传感器故障2级",
  "alarm.excDesc.2033183602525470988": "无",
  "alarm.suggestion.2033183602525470988": "无",
  "alarm.desc.2033183602525470988": "无",
  "alarm.name.2033183602525470990": "电池箱过压3级",
  "alarm.excDesc.2033183602525470990": "无",
  "alarm.suggestion.2033183602525470990": "无",
  "alarm.desc.2033183602525470990": "无",
  "alarm.name.2033183602525470992": "防雷器故障3级",
  "alarm.excDesc.2033183602525470992": "无",
  "alarm.suggestion.2033183602525470992": "无",
  "alarm.desc.2033183602525470992": "无",
  "alarm.name.2033183602525470994": "水浸故障3级",
  "alarm.excDesc.2033183602525470994": "无",
  "alarm.suggestion.2033183602525470994": "无",
  "alarm.desc.2033183602525470994": "无",
  "alarm.name.2033183602525470996": "气体传感器故障3级",
  "alarm.excDesc.2033183602525470996": "无",
  "alarm.suggestion.2033183602525470996": "无",
  "alarm.desc.2033183602525470996": "无",
  "alarm.name.2033183602525470977": "空调故障1级",
  "alarm.excDesc.2033183602525470977": "无",
  "alarm.suggestion.2033183602525470977": "无",
  "alarm.desc.2033183602525470977": "无",
  "alarm.name.2033183602525470979": "门禁故障1级",
  "alarm.excDesc.2033183602525470979": "无",
  "alarm.suggestion.2033183602525470979": "无",
  "alarm.desc.2033183602525470979": "无",
  "alarm.name.2033183602525470981": "交流失电故障1级",
  "alarm.excDesc.2033183602525470981": "无",
  "alarm.suggestion.2033183602525470981": "无",
  "alarm.desc.2033183602525470981": "无",
  "alarm.name.2033183602525470983": "电池箱欠压2级",
  "alarm.excDesc.2033183602525470983": "无",
  "alarm.suggestion.2033183602525470983": "无",
  "alarm.desc.2033183602525470983": "无",
  "alarm.name.2033183602525470985": "空调故障2级",
  "alarm.excDesc.2033183602525470985": "无",
  "alarm.suggestion.2033183602525470985": "无",
  "alarm.desc.2033183602525470985": "无",
  "alarm.name.2033183602525470987": "门禁故障2级",
  "alarm.excDesc.2033183602525470987": "无",
  "alarm.suggestion.2033183602525470987": "无",
  "alarm.desc.2033183602525470987": "无",
  "alarm.name.2033183602525470989": "交流失电故障2级",
  "alarm.excDesc.2033183602525470989": "无",
  "alarm.suggestion.2033183602525470989": "无",
  "alarm.desc.2033183602525470989": "无",
  "alarm.name.2033183602525470991": "电池箱欠压3级",
  "alarm.excDesc.2033183602525470991": "无",
  "alarm.suggestion.2033183602525470991": "无",
  "alarm.desc.2033183602525470991": "无",
  "alarm.name.2033183602525470993": "空调故障3级",
  "alarm.excDesc.2033183602525470993": "无",
  "alarm.suggestion.2033183602525470993": "无",
  "alarm.desc.2033183602525470993": "无",
  "alarm.name.2033183602525470995": "门禁故障3级",
  "alarm.excDesc.2033183602525470995": "无",
  "alarm.suggestion.2033183602525470995": "无",
  "alarm.desc.2033183602525470995": "无",
  "alarm.name.2033183602525470997": "交流失电故障3级",
  "alarm.excDesc.2033183602525470997": "无",
  "alarm.suggestion.2033183602525470997": "无",
  "alarm.desc.2033183602525470997": "无",
  "alarm.name.2033183602525470729": "BMS通信故障",
  "alarm.excDesc.2033183602525470729": "无",
  "alarm.suggestion.2033183602525470729": "无",
  "alarm.desc.2033183602525470729": "无",
  "alarm.name.2033183602525470728": "EMS通信故障",
  "alarm.excDesc.2033183602525470728": "无",
  "alarm.suggestion.2033183602525470728": "无",
  "alarm.desc.2033183602525470728": "无",
  "deliver.type.hOn": "hOn",
  "networkEnum.code.1": "LAN",
  "networkEnum.code.2": "WiFi",
  "networkEnum.code.3": "2G",
  "networkEnum.code.63": "4G",
  "networkEnum.code.12": "WiFi + BLE",
  "networkEnum.code.23": "WiFi + 4G + BLE",
  "networkEnum.code.62": "LAN",
  "networkEnum.code.64": "WiFi + AP",
  "networkEnum.code.65": "4G + BLE",
  "networkEnum.code.12,62": "WiFi + BLE + LAN",
  "networkEnum.code.62,63": "LAN + 4G",
  "networkEnum.code.23,62": "WiFi + BLE + LAN + 4G",
  "50003.ctrl_bw_param_group_GridMeterSettings.ctrlGridBreake": "电网端用电限值",
  "50003.real_time.bw_RTparam_name_TotalReactivePower_Grid": "电表无功功率（总）",
  "50003.ctrl_bw_param_group_BasicInfo.ctrlProtocolVersion": "协议版本号(高位)",
  "50003.real_time.gridBuyPower": "累计买电量",
  "50003.real_time.bw_RTparam_name_ReactivePOBP_Grid": "电表B无功功率",
  "50003.real_time.bw_RTparam_name_GridPowerL3": "电网有功功率L3",
  "50003.ctrl_bw_param_group_BasicInfo.ctrlDspVersion": "DSP版本号",
  "50003.ctrl_bw_param_group_ParallelSetting.ctrlParallelModeSetting": "并机模式设置",
  "50003.real_time.bw_RTparam_name_GridPowerL2": "电网有功功率L2",
  "50003.real_time.bw_RTparam_name_GridPowerL1": "电网有功功率L1",
  "50003.real_time.bw_RTparam_name_ApparentPOBP_Grid": "电表B视在功率",
  "50003.ctrl_bw_param_group_SpecialSetting.ctrlPhaseOrderResume": "相序自适应使能",
  "50003.ctrl_bw_param_group_BatterySettings.ctrlBatteryMOSControl": "电池MOS控制",
  "50003.real_time.gridPower": "电网总功率（有功功率）",
  "50003.real_time.bw_RTparam_name_BatteryMaxDischargePower": "逆变器允许的最大放电功率",
  "50003.ctrl_bw_param_group_Charge_and_DischargeSettings.ctrlChargeStopTime2Hours": "充电停止时间2(小时)",
  "50003.real_time.bw_RTparam_name_PackIDofMinCellVoltage": "系统最低电池模块电压编号",
  "50003.real_time.pvPower": "总功率",
  "50003.real_time.bw_RTparam_name_BatteryDischargeCurrentLimit": "电池放电限流",
  "50003.ctrl_bw_param_group_GridDispatch.ctrlDispatchTime": "调度时间",
  "50003.real_time.bw_RTparam_name_PV_PowerFactorOfCPhase": "电表C功率因数",
  "50003.real_time.bw_RTparam_name_BackupVoltageT": "Backup T相电压",
  "50003.real_time.bw_RTparam_name_BackupVoltageS": "Backup S相电压",
  "50003.real_time.bw_RTparam_name_BackupVoltageR": "Backup R相电压",
  "50003.ctrl_bw_param_group_BackupBox.ctrlBbSOCLx2": "L2策略执行的最小SOC值",
  "50003.ctrl_bw_param_group_BackupBox.ctrlBbSOCLx3": "L3策略执行的最小SOC值",
  "50003.ctrl_bw_param_group_BackupBox.ctrlBbSOCLx1": "L1策略执行的最小SOC值",
  "50003.ctrl_bw_param_group_Charge_and_DischargeSettings.ctrlDischargeStopTime1Hours": "放电停止时间1(小时)",
  "50003.real_time.bw_RTparam_name_BackupPower": "Backup有功功率",
  "50003.ctrl_bw_param_group_SystemConfig.ctrlPvCapacityOfGridInverter": "储能系统PV装机容量",
  "50003.ctrl_bw_param_group_WorkMode.workMode": "工作模式",
  "50003.real_time.bw_RTparam_name_InvCurrentT": "逆变器L3相电流",
  "50003.real_time.bw_RTparam_name_InvActivePower": "逆变有功功率",
  "50003.ctrl_bw_param_group_Charge_and_DischargeSettings.ctrlEpsReserveSoc": "UPS保留SOC",
  "50003.real_time.bw_RTparam_name_InvCurrentR": "逆变器L1相电流",
  "50003.real_time.bw_RTparam_name_InvCurrentS": "逆变器L2相电流",
  "50003.real_time.bw_RTparam_name_PV_PowerFactorOfAPhase": "电表A功率因数",
  "50003.real_time.bw_RTparam_name_TotalReactivePower_PV": "电表无功功率（总）",
  "50003.real_time.bw_RTparam_name_VoltageOfBPhase_PV": "电表B相电压",
  "50003.ctrl_bw_param_group_Charge_and_DischargeSettings.ctrlDischargeStopTime1Minutes": "放电停止时间1(分钟)",
  "50003.real_time.bw_RTparam_name_ChargeCutSoc": "SOC上限值",
  "50003.real_time.bw_RTparam_name_TotalEnergyInvOutput": "逆变器总输出电量",
  "50003.real_time.bw_RTparam_name_Systemminimumvoltagecellserialnumber": "系统最低电压电芯串号",
  "50003.real_time.bw_RTparam_name_Minimumtemperatureofbattery": "电池最低温度",
  "50003.real_time.bw_RTparam_name_PV1Voltage": "PV1实时电压",
  "50003.ctrl_bw_param_group_Charge_and_DischargeSettings.ctrlDischargeStartTime2Minutes": "放电开始时间2(分钟)",
  "50003.real_time.bw_RTparam_name_TotalConsumption": "累计充电量",
  "50003.real_time.bw_RTparam_name_PV2Power": "PV2实时功率",
  "50003.real_time.bw_RTparam_name_GridFrequencyINV": "逆变并网频率（并网）",
  "50003.ctrl_bw_param_group_RemoteReset.ctrlDspReset": "重启DSP",
  "50003.real_time.gridSellPower": "累计卖电量",
  "50003.real_time.bw_RTparam_name_BatteryRelayStatus": "BMS继电器状态",
  "50003.real_time.bw_RTparam_name_PV3Current": "PV3实时电流",
  "50003.real_time.bw_RTparam_name_Frequent_PV": "电表频率",
  "50003.real_time.bw_RTparam_name_PV_ReactivePowerOfBPhase": "电表B无功功率",
  "50003.real_time.bw_RTparam_name_InvModuleTemperature": "INV模块温度",
  "50003.real_time.bw_RTparam_name_CurrentOfBPhase_PV": "电表B相电流",
  "50003.ctrl_bw_param_group_GridMeterSettings.ctrlGridMeterCTRate": "电网CT倍率",
  "50003.ctrl_bw_param_group_SystemInfo.ctrlRtc": "时钟设置",
  "50003.ctrl_bw_param_group_BatterySettings.ctrlBatteryReady": "电池使能位",
  "50003.ctrl_bw_param_group_GridDispatch.ctrlDispatchStart": "调度（强制充放电）开关",
  "50003.ctrl_bw_param_group_Charge_and_DischargeSettings.ctrlChargeStopTime2Minutes": "充电停止时间2(分钟)",
  "50003.real_time.batteryPower": "电池功率",
  "50003.ctrl_bw_param_group_GridDispatch.ctrlDispatchActivePower": "调度有功功率",
  "50003.real_time.bw_RTparam_name_PV_ReactivePowerOfCPhase": "电表C无功功率",
  "50003.real_time.bw_RTparam_name_ReactivePOCP_Grid": "电表C无功功率",
  "50003.real_time.bw_RTparam_name_BatteryCurrent": "电池电流",
  "50003.ctrl_bw_param_group_BasicInfo.ctrlEmsVersionHigh": "EMS版本号(高位)",
  "50003.real_time.bw_RTparam_name_TotalPowerFactor_PV": "电表功率因数（总）",
  "50003.real_time.bw_RTparam_name_TotalEnergyFeedToGrid_PV": "馈网能量",
  "50003.real_time.pvEnergy": "设备总发电量\n设备总发电量(含光伏电表数据)",
  "50003.real_time.batteryDischargePower": "累计放电量",
  "50003.ctrl_bw_param_group_OnOff.ctrlOnOff": "逆变器开关",
  "50003.ctrl_bw_param_group_GridMeterSettings.ctrlPvMeterNegate": "光伏电表反接标志",
  "50003.ctrl_bw_param_group_GridDispatch.ctrlDispatchReactivePower": "调度无功功率",
  "50003.ctrl_bw_param_group_Charge_and_DischargeSettings.ctrlDischargeTimeSlot2": "强放时间2",
  "50003.real_time.bw_RTparam_name_PackIDofMaxCellVoltage": "系统最高电池模块电压编号",
  "50003.ctrl_bw_param_group_BasicInfo.ctrlEmsVersionLowSuffix": "EMS版本后缀",
  "50003.real_time.bw_RTparam_name_Maximumtemperatureofbattery": "电池最高温度",
  "50003.real_time.bw_RTparam_name_InvPowerFactor": "逆变功率因数",
  "50003.real_time.bw_RTparam_name_DongleRssi": "信号强度",
  "50003.real_time.bw_RTparam_name_DataloggerSN": "通讯棒SN",
  "50003.ctrl_bw_param_group_Charge_and_DischargeSettings.ctrlDischargeStopTime2Minutes": "放电停止时间2(分钟)",
  "50003.real_time.bw_RTparam_name_ReactivePOAP_Grid": "电表A无功功率",
  "50003.real_time.bw_RTparam_name_PV3Voltage": "PV3实时电压",
  "50003.ctrl_bw_param_group_Charge_and_DischargeSettings.ctrlDischargeTimeSlot1": "强放时间1",
  "50003.real_time.bw_RTparam_name_GridFrequency": "电网频率",
  "50003.real_time.bw_RTparam_name_PV1Power": "PV1实时功率",
  "50003.real_time.bw_RTparam_name_PV1Current": "PV1实时电流",
  "50003.real_time.bw_RTparam_name_PV_ApparentPowerOfBPhase": "电表B视在功率",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation": "电网规范",
  "50003.real_time.bw_RTparam_name_PV_ActivePowerOfBPhase": "电表B有功功率",
  "50003.ctrl_bw_param_group_Charge_and_DischargeSettings.ctrlChargeStopTime1Hours": "充电停止时间1(小时)",
  "50003.real_time.bw_RTparam_name_PV_ApparentPowerOfAPhase": "电表A视在功率",
  "50003.real_time.bw_RTparam_name_TotalPower": "总功率",
  "50003.real_time.bw_RTparam_name_Fullchargecapacityofbattery": "满充容量",
  "50003.real_time.bw_RTparam_name_BatteryVoltage": "电池电压",
  "50003.real_time.bw_RTparam_name_Minimumcellvoltage": "最低电芯电压",
  "50003.real_time.bw_RTparam_name_BatterySOH": "电池SOH",
  "50003.real_time.batterySOC": "电池SOC",
  "50003.ctrl_bw_param_group_GridMeterSettings.ctrlPvMeterCTRate": "光伏CT倍率",
  "50003.real_time.bw_RTparam_name_BatteryChargeCut_offVoltage": "系统充电截止电压",
  "50003.real_time.bw_RTparam_name_PV_ActivePowerOfAPhase": "电表A有功功率",
  "50003.real_time.bw_RTparam_name_BatteryNum": "系统电池包数量",
  "50003.real_time.bw_RTparam_name_SoftwareVersion": "通讯棒软件版本",
  "50003.real_time.bw_RTparam_name_PackIDofMinCellTemperature": "系统最低电池模块温度编号",
  "50003.ctrl_bw_param_group_BackupBox.ctrlBackupBoxEnable": "启用Backup-Box",
  "50003.ctrl_bw_param_group_GridMeterSettings.ctrlMeterCTSelect": "电表/CT安装选项",
  "50003.real_time.bw_RTparam_name_TotalPowerFactor_Grid": "电表功率因数（总）",
  "50003.real_time.bw_RTparam_name_VoltageOfAPhase_PV": "电表A相电压",
  "50003.real_time.bw_RTparam_name_BackupFrequency": "逆变EPS频率（离网）",
  "50003.real_time.bw_RTparam_name_BatterySN6": "电池包6 SN",
  "50003.ctrl_bw_param_group_GridMeterSettings.ctrlGridMeterNegate": "电网电表反接标志",
  "50003.real_time.bw_RTparam_name_BatterySN4": "电池包4 SN",
  "50003.real_time.bw_RTparam_name_BatterySN5": "电池包5 SN",
  "50003.real_time.bw_RTparam_name_BatterySN2": "电池包2 SN",
  "50003.real_time.bw_RTparam_name_BatterySN3": "电池包3 SN",
  "50003.ctrl_bw_param_group_Charge_and_DischargeSettings.ctrlChargeCutSoc": "充电截止SOC",
  "50003.real_time.bw_RTparam_name_InvApparentPower": "逆变视在功率",
  "50003.real_time.bw_RTparam_name_InvReactivePower": "逆变无功功率",
  "50003.ctrl_bw_param_group_RemoteReset.ctrlEmsReset": "重启EMS",
  "50003.real_time.bw_RTparam_name_PFOC_Grid": "电表C功率因数",
  "50003.real_time.bw_RTparam_name_HardwareVersion": "通讯棒硬件版本",
  "50003.ctrl_bw_param_group_BasicInfo.ctrlEmsVersionLow": "EMS版本号(低位)",
  "50003.real_time.bw_RTparam_name_BatterySN1": "电池包1 SN",
  "50003.ctrl_bw_param_group_Charge_and_DischargeSettings.ctrlDischargeStopTime2Hours": "放电停止时间2(小时)",
  "50003.real_time.bw_RTparam_name_PV_ActivePowerOfCPhase": "电表C有功功率",
  "50003.real_time.bw_RTparam_name_Systemminimumtemperaturecellserialnumber": "系统最低温度电芯串号",
  "50003.real_time.bw_RTparam_name_BatteryMaxChargePower": "逆变器允许的最大充电功率",
  "50003.real_time.bw_RTparam_name_Maximumcellvoltage": "最高电芯电压",
  "50003.ctrl_bw_param_group_Charge_and_DischargeSettings.ctrlDischargeStartTime1Minutes": "放电开始时间1(分钟)",
  "50003.real_time.bw_RTparam_name_PV_ApparentPowerOfCPhase": "电表C视在功率",
  "50003.real_time.bw_RTparam_name_CurrentOfAPhase_PV": "电表A相电流",
  "50003.real_time.bw_RTparam_name_UPSReserveSoc": "SOC下限值（并网情况）",
  "50003.real_time.bw_RTparam_name_TotalApparentPower_PV": "电表视在功率（总）",
  "50003.real_time.batteryChargePower": "电池来自于电网的电量",
  "50003.real_time.bw_RTparam_name_TotalApparentPower_Grid": "电表视在功率（总）",
  "50003.ctrl_bw_param_group_SystemConfig.ctrlPvCapacityStorage": "光伏逆变器PV装机容量",
  "50003.ctrl_bw_param_group_GridDispatch.ctrlDispatchMode": "调度模式",
  "50003.real_time.bw_RTparam_name_TotalEnergyInvInput": "逆变器总输入电量",
  "50003.real_time.bw_RTparam_name_Systemmaximumtemperaturecellserialnumber": "系统最高温度电芯串号",
  "50003.ctrl_bw_param_group_Charge_and_DischargeSettings.ctrlChargeStartTime1Minutes": "充电开始时间1(分钟)",
  "50003.ctrl_bw_param_group_BasicInfo.ctrlInvSub": "机型类型",
  "50003.ctrl_bw_param_group_Charge_and_DischargeSettings.ctrlChargeTimeSlot1": "强充时间1",
  "50003.real_time.bw_RTparam_name_GridCurrentL3": "电网电流L3",
  "50003.real_time.bw_RTparam_name_TotalEnergyConsumeFormGrid_PV": "取电能量",
  "50003.real_time.bw_RTparam_name_BatteryMode": "BMS模式",
  "50003.real_time.bw_RTparam_name_GridCurrentL1": "电网电流L1",
  "50003.real_time.bw_RTparam_name_GridCurrentL2": "电网电流L2",
  "50003.ctrl_bw_param_group_Charge_and_DischargeSettings.ctrlChargeStopTime1Minutes": "充电停止时间1(分钟)",
  "50003.real_time.bw_RTparam_name_VoltageOfCPhase_PV": "电表C相电压",
  "50003.ctrl_bw_param_group_GridMeterSettings.ctrlPvMeterCTEnable": "光伏CT使能",
  "50003.ctrl_bw_param_group_Charge_and_DischargeSettings.ctrlChargeTimeSlot2": "强充时间2",
  "50003.real_time.bw_RTparam_name_PVConnectState": "PV连接状态",
  "50003.real_time.bw_RTparam_name_PvBoostTemperature": "Boost模块温度",
  "50003.real_time.bw_RTparam_name_PFOA_Grid": "电表A功率因数",
  "50003.ctrl_bw_param_group_Charge_and_DischargeSettings.ctrlEpsReserveEnable": "UPS保留使能",
  "50003.ctrl_bw_param_group_BackupBox.ctrlBbPrioLx2": "L2策略优先级",
  "50003.ctrl_bw_param_group_BackupBox.ctrlBbPrioLx1": "L1策略优先级",
  "50003.ctrl_bw_param_group_BackupBox.ctrlBbPrioLx3": "L3策略优先级",
  "50003.real_time.bw_RTparam_name_PVMeterNegate": "光伏电表反接标志",
  "50003.real_time.bw_RTparam_name_PackIDofMaxCellTemperature": "系统最高电池模块温度编号",
  "50003.real_time.bw_RTparam_name_PV3Power": "PV3实时功率",
  "50003.ctrl_bw_param_group_RemoteReset.ctrlFactoryReset": "表示初始化系统",
  "50003.real_time.bw_param_ctrl_name_InvSub": "机型类型",
  "50003.real_time.bw_RTparam_name_PFOB_Grid": "电表B功率因数",
  "50003.ctrl_bw_param_group_GridMeterSettings.ctrlGridMeterCTEnable": "电网CT使能",
  "50003.real_time.bw_RTparam_name_GridVoltageL3": "电网电压L3",
  "50003.real_time.bw_RTparam_name_GridVoltageL2": "电网电压L2",
  "50003.real_time.bw_RTparam_name_Systemmaximumvoltagecellserialnumber": "系统最高电压电芯串号",
  "50003.ctrl_bw_param_group_Charge_and_DischargeSettings.ctrlChargeStartTime2Minutes": "充电开始时间2(分钟)",
  "50003.real_time.bw_RTparam_name_BatteryDischargeCut_offVoltage": "系统放电截止电压",
  "50003.real_time.bw_RTparam_name_PV2Current": "PV2实时电流",
  "50003.ctrl_bw_param_group_BasicInfo.ctrlEmsVersionMiddle": "EMS版本号(中位)",
  "50003.real_time.bw_RTparam_name_ApparentPOAP_Grid": "电表A视在功率",
  "50003.real_time.bw_RTparam_name_GridVoltageL1": "电网电压L1",
  "50003.real_time.bw_RTparam_name_PowerBoardTemperature": "功率板温度(散热片温度)",
  "50003.real_time.bw_RTparam_name_CurrentOfCPhase_PV": "电表C相电流",
  "50003.real_time.bw_RTparam_name_BatteryChargingCurrentLimit": "电池充电限流",
  "50003.real_time.bw_RTparam_name_ApparentPOCP_Grid": "电表C视在功率",
  "50003.real_time.bw_RTparam_name_vatBmsVersion": "电池包版本号",
  "50003.real_time.bw_RTparam_name_PV2Voltage": "PV2实时电压",
  "50003.ctrl_bw_param_group_GridDispatch.ctrlDispatchSOC": "调度SOC",
  "50003.real_time.bw_RTparam_name_PV_ReactivePowerOfAPhase": "电表A无功功率",
  "50003.ctrl_bw_param_group_SystemInfo.ctrlSystemTimeDayHour": "系统时间(日-时)",
  "50003.real_time.bw_RTparam_name_BackupCurrentR": "Backup R相电流",
  "50003.ctrl_bw_param_group_SystemConfig.ctrlMaxFeedintoGridPercent": "最大馈入电网百分比",
  "50003.real_time.bw_RTparam_name_BackupCurrentT": "Backup T相电流",
  "50003.real_time.bw_RTparam_name_BackupCurrentS": "Backup S相电流",
  "50003.real_time.bw_RTparam_name_PV_PowerFactorOfBPhase": "电表B功率因数",
  "50003.ctrl_bw_param_group_SystemConfig.ctrlSystemMode": "系统模式",
  "50003.ctrl_bw_param_group_SystemInfo.ctrlSystemTimeMinuteSecond": "系统时间(分-秒)",
  "50003.real_time.bw_RTparam_name_WorkOperateStatus": "设备运行状态",
  "50003.real_time.powerGeneration": "累计发电量",
  "50003.ctrl_bw_param_group_GridMeterSettings.ctrlGridBreake.desc": "int类型电网端用电限值的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.bw_RTparam_name_TotalReactivePower_Grid.desc": "int类型电表无功功率（总）的说明。大端字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_BasicInfo.ctrlProtocolVersion.desc": "int类型协议版本号(高位)的说明。大端字序,数据类型可以为空。",
  "50003.real_time.gridBuyPower.desc": "int类型累计买电量的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_ReactivePOBP_Grid.desc": "int类型电表B无功功率的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_GridPowerL3.desc": "int类型电网有功功率L3的说明。小端交换字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_ParallelSetting.ctrlParallelModeSetting.desc": "string类型并机模式设置的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.bw_RTparam_name_GridPowerL2.desc": "int类型电网有功功率L2的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_GridPowerL1.desc": "int类型电网有功功率L1的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_ApparentPOBP_Grid.desc": "int类型电表B视在功率的说明。小端交换字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_SpecialSetting.ctrlPhaseOrderResume.desc": "int类型相序自适应使能的说明。小端交换字序,不支持阈值导入。",
  "50003..ctrlBattery1SN.desc": "int类型电池包1 SN的说明。大端字序,数据类型可以为空。",
  "50003.real_time.gridPower.desc": "int类型电网总功率（有功功率）的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_BatteryMaxDischargePower.desc": "int类型逆变器允许的最大放电功率的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_PackIDofMinCellVoltage.desc": "int类型系统最低电池模块电压编号的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.pvPower.desc": "int类型总功率的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_BatteryDischargeCurrentLimit.desc": "int类型电池放电限流的说明。小端交换字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_GridDispatch.ctrlDispatchTime.desc": "int类型调度时间的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_PV_PowerFactorOfCPhase.desc": "int类型电表C功率因数的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_BackupVoltageT.desc": "int类型Backup T相电压的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_BackupVoltageS.desc": "int类型Backup S相电压的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_BackupVoltageR.desc": "int类型Backup R相电压的说明。大端字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_BackupBox.ctrlBbSOCLx2.desc": "int类型L2策略执行的最小SOC值的说明。大端字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_BackupBox.ctrlBbSOCLx3.desc": "int类型L3策略执行的最小SOC值的说明。大端字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_BackupBox.ctrlBbSOCLx1.desc": "int类型L1策略执行的最小SOC值的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_BackupPower.desc": "int类型Backup有功功率的说明。大端字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_SystemConfig.ctrlPvCapacityOfGridInverter.desc": "int类型储能系统PV装机容量的说明。大端字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_WorkMode.workMode.desc": "int类型工作模式的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.bw_RTparam_name_InvCurrentT.desc": "int类型逆变器L3相电流的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_InvActivePower.desc": "int类型逆变有功功率的说明。大端字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_Charge_and_DischargeSettings.ctrlEpsReserveSoc.desc": "int类型UPS保留SOC的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_InvCurrentR.desc": "int类型逆变器L1相电流的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_InvCurrentS.desc": "int类型逆变器L2相电流的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_PV_PowerFactorOfAPhase.desc": "int类型电表A功率因数的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_TotalReactivePower_PV.desc": "int类型电表无功功率（总）的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_VoltageOfBPhase_PV.desc": "int类型电表B相电压的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_ChargeCutSoc.desc": "int类型SOC上限值的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_TotalEnergyInvOutput.desc": "int类型逆变器总输出电量的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_Systemminimumvoltagecellserialnumber.desc": "int类型系统最低电压电芯串号的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.bw_RTparam_name_Minimumtemperatureofbattery.desc": "int类型电池最低温度的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_PV1Voltage.desc": "int类型PV1实时电压的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_TotalConsumption.desc": "int类型累计充电量的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_PV2Power.desc": "int类型PV2实时功率的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_GridFrequencyINV.desc": "int类型逆变并网频率（并网）的说明。大端字序,数据类型可以为空。",
  "50003..ctrlBattery2SN.desc": "int类型电池包2 SN的说明。大端字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_RemoteReset.ctrlDspReset.desc": "int类型重启DSP的说明。大端字序,数据类型可以为空。",
  "50003.real_time.gridSellPower.desc": "int类型累计卖电量的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_BatteryRelayStatus.desc": "int类型BMS继电器状态的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.bw_RTparam_name_PV3Current.desc": "int类型PV3实时电流的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_Frequent_PV.desc": "int类型电表频率的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_PV_ReactivePowerOfBPhase.desc": "int类型电表B无功功率的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_InvModuleTemperature.desc": "int类型INV模块温度的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_CurrentOfBPhase_PV.desc": "int类型电表B相电流的说明。小端交换字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_SystemInfo.ctrlRtc.desc": "int类型时钟设置的说明。小端交换字序,不支持阈值导入。",
  "50003.ctrl_bw_param_group_BatterySettings.ctrlBatteryReady.desc": "int类型电池使能位的说明。小端交换字序,不支持阈值导入。",
  "50003.ctrl_bw_param_group_GridDispatch.ctrlDispatchStart.desc": "int类型调度（强制充放电）开关的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.batteryPower.desc": "int类型电池功率的说明。小端交换字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_GridDispatch.ctrlDispatchActivePower.desc": "int类型调度有功功率的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_PV_ReactivePowerOfCPhase.desc": "int类型电表C无功功率的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_ReactivePOCP_Grid.desc": "int类型电表C无功功率的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_BatteryCurrent.desc": "int类型电池电流的说明。小端交换字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_BasicInfo.ctrlEmsVersionHigh.desc": "int类型EMS版本号(高位)的说明。大端字序,数据类型可以为空。",
  "50003..ctrlBattery3SN.desc": "int类型电池包3 SN的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_TotalPowerFactor_PV.desc": "int类型电表功率因数（总）的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_TotalEnergyFeedToGrid_PV.desc": "int类型馈网能量的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.pvEnergy.desc": "int类型设备总发电量(含光伏电表数据)的说明。大端字序,数据类型可以为空。",
  "50003.real_time.batteryDischargePower.desc": "int类型累计放电量的说明。小端交换字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_OnOff.ctrlOnOff.desc": "int类型逆变器开关的说明。小端交换字序,不支持阈值导入。",
  "50003.ctrl_bw_param_group_GridMeterSettings.ctrlPvMeterNegate.desc": "int类型光伏电表反接标志的说明。小端交换字序,不支持阈值导入。",
  "50003.ctrl_bw_param_group_GridDispatch.ctrlDispatchReactivePower.desc": "int类型调度无功功率的说明。大端字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_Charge_and_DischargeSettings.ctrlDischargeTimeSlot2.desc": "int类型强放时间2的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.bw_RTparam_name_PackIDofMaxCellVoltage.desc": "int类型系统最高电池模块电压编号的说明。小端交换字序,不支持阈值导入。",
  "50003.ctrl_bw_param_group_BasicInfo.ctrlEmsVersionLowSuffix.desc": "int类型EMS版本后缀的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_Maximumtemperatureofbattery.desc": "int类型电池最高温度的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_InvPowerFactor.desc": "int类型逆变功率因数的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_DongleRssi.desc": "int类型信号强度的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_DataloggerSN.desc": "string类型通讯棒SN的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.bw_RTparam_name_ReactivePOAP_Grid.desc": "int类型电表A无功功率的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_PV3Voltage.desc": "int类型PV3实时电压的说明。小端交换字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_Charge_and_DischargeSettings.ctrlDischargeTimeSlot1.desc": "int类型强放时间1的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.bw_RTparam_name_GridFrequency.desc": "int类型电网频率的说明。小端交换字序,数据类型可以为空。",
  "50003..ctrlBattery4SN.desc": "int类型电池包4 SN的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_PV1Power.desc": "int类型PV1实时功率的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_PV1Current.desc": "int类型PV1实时电流的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_PV_ApparentPowerOfBPhase.desc": "int类型电表B视在功率的说明。大端字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.desc": "int类型电网规范的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.bw_RTparam_name_PV_ActivePowerOfBPhase.desc": "int类型电表B有功功率的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_PV_ApparentPowerOfAPhase.desc": "int类型电表A视在功率的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_TotalPower.desc": "int类型总功率的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_Fullchargecapacityofbattery.desc": "int类型满充容量的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_BatteryVoltage.desc": "int类型电池电压的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_Minimumcellvoltage.desc": "int类型最低电芯电压的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_BatterySOH.desc": "int类型电池SOH的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.batterySOC.desc": "int类型电池SOC的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_BatteryChargeCut_offVoltage.desc": "int类型系统充电截止电压的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_PV_ActivePowerOfAPhase.desc": "int类型电表A有功功率的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_BatteryNum.desc": "int类型系统电池包数量的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_SoftwareVersion.desc": "string类型通讯棒软件版本的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.bw_RTparam_name_PackIDofMinCellTemperature.desc": "int类型系统最低电池模块温度编号的说明。小端交换字序,不支持阈值导入。",
  "50003..ctrlBattery5SN.desc": "int类型电池包5 SN的说明。大端字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_BackupBox.ctrlBackupBoxEnable.desc": "int类型启用Backup-Box的说明。大端字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_GridMeterSettings.ctrlMeterCTSelect.desc": "int类型电表/CT安装选项的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.bw_RTparam_name_TotalPowerFactor_Grid.desc": "int类型电表功率因数（总）的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_VoltageOfAPhase_PV.desc": "int类型电表A相电压的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_BackupFrequency.desc": "int类型Backup频率的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_BatterySN6.desc": "string类型电池包6 SN的说明。小端交换字序,不支持阈值导入。",
  "50003.ctrl_bw_param_group_GridMeterSettings.ctrlGridMeterNegate.desc": "int类型电网电表反接标志的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.bw_RTparam_name_BatterySN4.desc": "string类型电池包4 SN的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.bw_RTparam_name_BatterySN5.desc": "string类型电池包5 SN的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.bw_RTparam_name_BatterySN2.desc": "string类型电池包2 SN的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.bw_RTparam_name_BatterySN3.desc": "string类型电池包3 SN的说明。小端交换字序,不支持阈值导入。",
  "50003.ctrl_bw_param_group_Charge_and_DischargeSettings.ctrlChargeCutSoc.desc": "int类型充电截止SOC的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_InvApparentPower.desc": "int类型逆变视在功率的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_InvReactivePower.desc": "int类型逆变无功功率的说明。大端字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_RemoteReset.ctrlEmsReset.desc": "int类型重启EMS的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_PFOC_Grid.desc": "int类型电表C功率因数的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_HardwareVersion.desc": "string类型通讯棒硬件版本的说明。小端交换字序,不支持阈值导入。",
  "50003.ctrl_bw_param_group_BasicInfo.ctrlEmsVersionLow.desc": "int类型EMS版本号(低位)的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_BatterySN1.desc": "string类型电池包1 SN的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.bw_RTparam_name_PV_ActivePowerOfCPhase.desc": "int类型电表C有功功率的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_Systemminimumtemperaturecellserialnumber.desc": "int类型系统最低温度电芯串号的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.bw_RTparam_name_BatteryMaxChargePower.desc": "int类型逆变器允许的最大充电功率的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_Maximumcellvoltage.desc": "int类型最高电芯电压的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_PV_ApparentPowerOfCPhase.desc": "int类型电表C视在功率的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_CurrentOfAPhase_PV.desc": "int类型电表A相电流的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_UPSReserveSoc.desc": "int类型SOC下限值（并网情况）的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_TotalApparentPower_PV.desc": "int类型电表视在功率（总）的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.batteryChargePower.desc": "int类型电池来自于电网的电量的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_TotalApparentPower_Grid.desc": "int类型电表视在功率（总）的说明。大端字序,数据类型可以为空。",
  "50003..ctrlBattery6SN.desc": "int类型电池包6 SN的说明。大端字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_SystemConfig.ctrlPvCapacityStorage.desc": "int类型光伏逆变器PV装机容量的说明。大端字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_GridDispatch.ctrlDispatchMode.desc": "int类型调度模式的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.bw_RTparam_name_TotalEnergyInvInput.desc": "int类型逆变器总输入电量的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_Systemmaximumtemperaturecellserialnumber.desc": "int类型系统最高温度电芯串号的说明。小端交换字序,不支持阈值导入。",
  "50003.ctrl_bw_param_group_BasicInfo.ctrlInvSub.desc": "int类型机型类型的说明。大端字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_Charge_and_DischargeSettings.ctrlChargeTimeSlot1.desc": "int类型强充时间1的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.bw_RTparam_name_GridCurrentL3.desc": "int类型电网电流L3的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_TotalEnergyConsumeFormGrid_PV.desc": "int类型取电能量的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_BatteryMode.desc": "int类型BMS模式的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.bw_RTparam_name_GridCurrentL1.desc": "int类型电网电流L1的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_GridCurrentL2.desc": "int类型电网电流L2的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_VoltageOfCPhase_PV.desc": "int类型电表C相电压的说明。小端交换字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_Charge_and_DischargeSettings.ctrlChargeTimeSlot2.desc": "int类型强充时间2的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.bw_RTparam_name_PVConnectState.desc": "int类型PV连接状态的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_PvBoostTemperature.desc": "int类型Boost模块温度的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_PFOA_Grid.desc": "int类型电表A功率因数的说明。小端交换字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_Charge_and_DischargeSettings.ctrlEpsReserveEnable.desc": "int类型UPS保留使能的说明。小端交换字序,不支持阈值导入。",
  "50003.ctrl_bw_param_group_BackupBox.ctrlBbPrioLx2.desc": "int类型L2策略优先级的说明。大端字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_BackupBox.ctrlBbPrioLx1.desc": "int类型L1策略优先级的说明。大端字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_BackupBox.ctrlBbPrioLx3.desc": "int类型L3策略优先级的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_PVMeterNegate.desc": "int类型光伏电表反接标志的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.bw_RTparam_name_PackIDofMaxCellTemperature.desc": "int类型系统最高电池模块温度编号的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.bw_RTparam_name_PV3Power.desc": "int类型PV3实时功率的说明。小端交换字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_RemoteReset.ctrlFactoryReset.desc": "int类型表示初始化系统的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_param_ctrl_name_InvSub.desc": "int类型机型类型的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_PFOB_Grid.desc": "int类型电表B功率因数的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_GridVoltageL3.desc": "int类型电网电压L3的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_GridVoltageL2.desc": "int类型电网电压L2的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_Systemmaximumvoltagecellserialnumber.desc": "int类型系统最高电压电芯串号的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.bw_RTparam_name_BatteryDischargeCut_offVoltage.desc": "int类型系统放电截止电压的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_PV2Current.desc": "int类型PV2实时电流的说明。小端交换字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_BasicInfo.ctrlEmsVersionMiddle.desc": "int类型EMS版本号(中位)的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_ApparentPOAP_Grid.desc": "int类型电表A视在功率的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_GridVoltageL1.desc": "int类型电网电压L1的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_PowerBoardTemperature.desc": "int类型功率板温度(散热片温度)的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_CurrentOfCPhase_PV.desc": "int类型电表C相电流的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_BatteryChargingCurrentLimit.desc": "int类型电池充电限流的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_ApparentPOCP_Grid.desc": "int类型电表C视在功率的说明。小端交换字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_vatBmsVersion.desc": "int类型电池包版本号的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.bw_RTparam_name_PV2Voltage.desc": "int类型PV2实时电压的说明。小端交换字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_GridDispatch.ctrlDispatchSOC.desc": "int类型调度SOC的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_PV_ReactivePowerOfAPhase.desc": "int类型电表A无功功率的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_BackupCurrentR.desc": "int类型Backup R相电流的说明。大端字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_SystemConfig.ctrlMaxFeedintoGridPercent.desc": "int类型最大馈入电网百分比的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_BackupCurrentT.desc": "int类型Backup T相电流的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_BackupCurrentS.desc": "int类型Backup S相电流的说明。大端字序,数据类型可以为空。",
  "50003.real_time.bw_RTparam_name_PV_PowerFactorOfBPhase.desc": "int类型电表B功率因数的说明。大端字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_SystemConfig.ctrlSystemMode.desc": "int类型系统模式的说明。小端交换字序,不支持阈值导入。",
  "50003.real_time.bw_RTparam_name_WorkOperateStatus.desc": "int类型设备运行状态的说明。大端字序,数据类型可以为空。",
  "50003.real_time.powerGeneration.desc": "int类型累计发电量的说明。小端交换字序,数据类型可以为空。",
  "50003.ctrl_bw_param_group_OnOff": "ctrl_bw_param_group_OnOff",
  "50003.ctrl_bw_param_group_BasicInfo": "ctrl_bw_param_group_BasicInfo",
  "50003.ctrl_bw_param_group_SpecialSetting": "ctrl_bw_param_group_SpecialSetting",
  "50003.ctrl_bw_param_group_BackupBox": "ctrl_bw_param_group_BackupBox",
  "50003.ctrl_bw_param_group_SystemConfig": "ctrl_bw_param_group_SystemConfig",
  "50003.real_time": "real_time",
  "50003.ctrl_bw_param_group_ParallelSetting": "ctrl_bw_param_group_ParallelSetting",
  "50003.ctrl_bw_param_group_SystemInfo": "ctrl_bw_param_group_SystemInfo",
  "50003.ctrl_bw_param_group_Charge_and_DischargeSettings": "ctrl_bw_param_group_Charge_and_DischargeSettings",
  "50003.ctrl_bw_param_group_GridSafetyConfig": "ctrl_bw_param_group_GridSafetyConfig",
  "50003.ctrl_bw_param_group_GridMeterSettings": "ctrl_bw_param_group_GridMeterSettings",
  "50003.ctrl_bw_param_group_BatterySettings": "ctrl_bw_param_group_BatterySettings",
  "50003.ctrl_bw_param_group_GridDispatch": "ctrl_bw_param_group_GridDispatch",
  "50003.ctrl_bw_param_group_WorkMode": "ctrl_bw_param_group_WorkMode",
  "50003.ctrl_bw_param_group_RemoteReset": "ctrl_bw_param_group_RemoteReset",
  "60003.group_collector.clientUrl": "连接地址",
  "60003.group_collector.rssi": "WiFi信号强度",
  "60003.group_collector.remotePort": "远端网络服务器端口",
  "60003.group_collector.type": "采集器类型",
  "60003.group_collector.resetDevice": "采集棒重置",
  "60003.group_collector.version": "采集器版本号",
  "60003.group_collector.collectorTime": "采集器时间",
  "60003.group_collector.updateInterval": "更新间隔",
  "60003.group_collector.quickReport": "快速上报",
  "60003.group_collector.DataloggerRestart": "采集棒重启",
  "60003.group_collector.httpUrl": "Http下载文件的url",
  "60003.group_collector.datalogSn": "采集器序列号",
  "60003.group_collector.hardwareVersion": "硬件版本",
  "60003.group_collector.protocolVersion": "数服协议版本号",
  "60003.group_collector.remoteDomainName": "远程服务域名",
  "60003.group_collector.bleProtocolVersion": "本地通讯协议版本号",
  "60003.group_collector.inverterSn": "逆变器SN",
  "60003.group_collector.lastUpdateTime": "最后更新时间",
  "60003.group_collector.deviceList": "设备列表",
  "60003.group_collector.ETH_DHCP_ENABLE": "以太网DHCP",
  "60003.group_collector.WIFI_IP": "WiFi连接IP",
  "60003.group_collector.ETH_IP": "以太网IP",
  "60003.group_collector.type.61": "WiFi",
  "60003.group_collector.type.62": "WiFi+Lan",
  "60003.group_collector.resetDevice.1": "1-重置一次",
  "60003.group_collector.quickReport.0": "0-上报一组03额定数据",
  "60003.group_collector.quickReport.1": "1-上报一组04实时数据 ",
  "60003.group_collector.DataloggerRestart.1": "1-重启一次",
  "60003.group_collector.ETH_DHCP_ENABLE.0": "DHCP",
  "60003.group_collector.ETH_DHCP_ENABLE.1": "STATIC",
  "60003.group_collector.rssi.desc": "0~-80(极强)   -80~-90(强)  -90~-100(中等)  -100~-110(弱)   <-110(极弱)",
  "60003.group_collector.resetDevice.desc": "重置通讯棒，蓝牙密码恢复至初始默认密码",
  "60003.group_collector.updateInterval.desc": "逆变器实时数据的更新间隔时间",
  "60003.group_collector.datalogSn.desc": "未授权禁止更改，否则海尔云无法连接到该设备",
  "60003.group_collector.remoteDomainName.desc": "未授权禁止更改，否则无法连接海尔云服务器",
  "60003.group_collector.bleProtocolVersion.desc": "欧洲RED合规认证的协议版本号从9.0开始",
  "60003.group_collector": "采集器分组",
  "60421.ctrl_device.Remote_shutdown_switch_enable": "远程关机开关启用  2",
  "60421.ctrl_device.String_Monitoring_Enable": "字符串监控启用",
  "60421..Battery_State.0": ":睡眠",
  "60421..Battery_State.1": "：充电",
  "60421..Battery_State.2": "：排放",
  "60421..Battery_State.3": "：空闲",
  "60421..Battery_State.4": "：待命",
  "60421..Battery_State.5": "：运行",
  "60421..Battery_State.6": "：故障",
  "60421..Battery_State.7": "：离线",
  "alarm.name.etower202607100002": "Etower2.0 电池欠压告警",
  "alarm.excDesc.etower202607100002": "电池欠压告警",
  "alarm.suggestion.etower202607100002": "检查实际电池电压是否比电池放电截止电压高 10V。",
  "alarm.desc.etower202607100002": "电池欠压告警",
  "alarm.name.etower202607100003": "Etower2.0 过载告警",
  "alarm.excDesc.etower202607100003": "过载告警",
  "alarm.suggestion.etower202607100003": "检查负载是否超过额定功率的 0.95。",
  "alarm.desc.etower202607100003": "过载告警",
  "alarm.name.etower202607100005": "Etower2.0 直流功率告警",
  "alarm.excDesc.etower202607100005": "直流功率告警",
  "alarm.suggestion.etower202607100005": "检查电池正负极连接，PV输入正负极连接是否都正确。并重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100005": "直流功率告警",
  "alarm.name.etower202607100006": "Etower2.0 电池停止运行告警",
  "alarm.excDesc.etower202607100006": "电池停止运行告警",
  "alarm.suggestion.etower202607100006": "检查电池是否处于开机状态，电池输出电压是否正常。可尝试重启电池。",
  "alarm.desc.etower202607100006": "电池停止运行告警",
  "alarm.name.etower202607100007": "Etower2.0 过温告警",
  "alarm.excDesc.etower202607100007": "过温告警",
  "alarm.suggestion.etower202607100007": "停止放电和充电，直到消除此代码并等待温度下降。",
  "alarm.desc.etower202607100007": "过温告警",
  "alarm.name.etower202607100009": "Etower2.0 电池开路",
  "alarm.excDesc.etower202607100009": "电池开路",
  "alarm.suggestion.etower202607100009": "检查逆变器上的电池断路器和电池断路器是否打开。",
  "alarm.desc.etower202607100009": "电池开路",
  "alarm.name.etower202607100010": "Etower2.0 电池反接",
  "alarm.excDesc.etower202607100010": "电池反接",
  "alarm.suggestion.etower202607100010": "检查电池正负极是否接反。",
  "alarm.desc.etower202607100010": "电池反接",
  "alarm.name.etower202607100011": "Etower2.0 bus过压",
  "alarm.excDesc.etower202607100011": "bus过压",
  "alarm.suggestion.etower202607100011": "系统有自恢复功能，告警为正常情况，出现告警机器也会自动消除。",
  "alarm.desc.etower202607100011": "bus过压",
  "alarm.name.etower202607100012": "Etower2.0 电网丢失",
  "alarm.excDesc.etower202607100012": "电网丢失",
  "alarm.suggestion.etower202607100012": "1. 等待电网电力恢复正常。\n2. 如果 Grid 正常，请检查与 Grid 终端的连接。\n3. 重新启动系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100012": "电网丢失",
  "alarm.name.etower202607100015": "Etower2.0 10分钟电网电压异常",
  "alarm.excDesc.etower202607100015": "10分钟电网电压异常",
  "alarm.suggestion.etower202607100015": "10分钟电网电压异常",
  "alarm.desc.etower202607100015": "10分钟电网电压异常",
  "alarm.name.etower202607100016": "Etower2.0 grid volt inst over",
  "alarm.excDesc.etower202607100016": "grid volt inst over",
  "alarm.suggestion.etower202607100016": "1. 确认系统安规是否正确选择。\n2. 等待电网电力恢复正常。（此警告不会影响系统运行）。",
  "alarm.desc.etower202607100016": "grid volt inst over",
  "alarm.name.etower202607100017": "Etower2.0 地线丢失",
  "alarm.excDesc.etower202607100017": "地线丢失",
  "alarm.suggestion.etower202607100017": "1. 检查接地线是否断开。\n2. 重新启动系统（此警告不会影响系统运行）。",
  "alarm.desc.etower202607100017": "地线丢失",
  "alarm.name.etower202607100018": "Etower2.0 零火反接",
  "alarm.excDesc.etower202607100018": "零火反接",
  "alarm.suggestion.etower202607100018": "1. 检查 Grid L/N 电缆是否接反。\n2. 重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100018": "零火反接",
  "alarm.name.etower202607100019": "Etower2.0 低温警告",
  "alarm.excDesc.etower202607100019": "低温警告",
  "alarm.suggestion.etower202607100019": "1. 等待温度恢复正常（-20°C 以上）。\n2. 如果温度正常，请重新启动系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100019": "低温警告",
  "alarm.name.etower202607100129": "Etower2.0 电网过压保护",
  "alarm.excDesc.etower202607100129": "电网过压保护",
  "alarm.suggestion.etower202607100129": "电网过压保护",
  "alarm.desc.etower202607100129": "电网过压保护",
  "alarm.name.etower202607100022": "Etower2.0 DCI",
  "alarm.excDesc.etower202607100022": "DCI",
  "alarm.suggestion.etower202607100022": "重新启动系统以查看故障是否仍然存在。如果仍然存在，请致电服务中心。",
  "alarm.desc.etower202607100022": "DCI",
  "alarm.name.etower202607100024": "Etower2.0 孤岛警告",
  "alarm.excDesc.etower202607100024": "孤岛警告",
  "alarm.suggestion.etower202607100024": "正常保护模式，无需执行任何作。",
  "alarm.desc.etower202607100024": "孤岛警告",
  "alarm.name.etower202607100028": "Etower2.0 CAN通讯异常",
  "alarm.excDesc.etower202607100028": "CAN通讯异常",
  "alarm.suggestion.etower202607100028": "重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100028": "CAN通讯异常",
  "alarm.name.etower202607100030": "Etower2.0 读flash异常",
  "alarm.excDesc.etower202607100030": "读flash异常",
  "alarm.suggestion.etower202607100030": "重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100030": "读flash异常",
  "alarm.name.etower202607100032": "Etower2.0 设备类型异常",
  "alarm.excDesc.etower202607100032": "设备类型异常",
  "alarm.suggestion.etower202607100032": "重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100032": "设备类型异常",
  "alarm.name.etower202607100034": "Etower2.0 软件逆变过流",
  "alarm.excDesc.etower202607100034": "软件逆变过流",
  "alarm.suggestion.etower202607100034": "重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100034": "软件逆变过流",
  "alarm.name.etower202607100036": "Etower2.0 bst软件逆变过流",
  "alarm.excDesc.etower202607100036": "bst软件逆变过流",
  "alarm.suggestion.etower202607100036": "重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100036": "bst软件逆变过流",
  "alarm.name.etower202607100038": "Etower2.0 buckbst软件逆变过流",
  "alarm.excDesc.etower202607100038": "buckbst软件逆变过流",
  "alarm.suggestion.etower202607100038": "重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100038": "buckbst软件逆变过流",
  "alarm.name.etower202607100040": "Etower2.0 bus过低",
  "alarm.excDesc.etower202607100040": "bus过低",
  "alarm.suggestion.etower202607100040": "1. 等待 Grid 电源恢复正常。\n2. 给电池充电并等待电池恢复。",
  "alarm.desc.etower202607100040": "bus过低",
  "alarm.name.etower202607100042": "Etower2.0 输入功率限制",
  "alarm.excDesc.etower202607100042": "输入功率限制",
  "alarm.suggestion.etower202607100042": "正常运行检测信息，无需执行任何作。",
  "alarm.desc.etower202607100042": "输入功率限制",
  "alarm.name.etower202607100044": "Etower2.0 过频降载",
  "alarm.excDesc.etower202607100044": "过频降载",
  "alarm.suggestion.etower202607100044": "等待 Grid 电源恢复正常。",
  "alarm.desc.etower202607100044": "过频降载",
  "alarm.name.etower202607100048": "Etower2.0 低电压穿越",
  "alarm.excDesc.etower202607100048": "低电压穿越",
  "alarm.suggestion.etower202607100048": "等待 Grid 电源恢复正常。",
  "alarm.desc.etower202607100048": "低电压穿越",
  "alarm.name.etower202607100050": "Etower2.0 市电波形异常",
  "alarm.excDesc.etower202607100050": "市电波形异常",
  "alarm.suggestion.etower202607100050": "重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100050": "市电波形异常",
  "alarm.name.etower202607100052": "Etower2.0 并机警告",
  "alarm.excDesc.etower202607100052": "并机警告",
  "alarm.suggestion.etower202607100052": "1. 检查并机通讯线是否连接正常。\n2. 重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100052": "并机警告",
  "alarm.name.etower202607100054": "Etower2.0 平均过载",
  "alarm.excDesc.etower202607100054": "平均过载",
  "alarm.suggestion.etower202607100054": "检查是否使用大负载导致过载，移除负载并重启系统。",
  "alarm.desc.etower202607100054": "平均过载",
  "alarm.name.etower202607100056": "Etower2.0 新机无法加入",
  "alarm.excDesc.etower202607100056": "新机无法加入",
  "alarm.suggestion.etower202607100056": "重启整机并重新设置主从机，如果依然无法设置请致电服务中心。",
  "alarm.desc.etower202607100056": "新机无法加入",
  "alarm.name.etower202607100058": "Etower2.0 输入不一致",
  "alarm.excDesc.etower202607100058": "输入不一致",
  "alarm.suggestion.etower202607100058": "重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100058": "输入不一致",
  "alarm.name.etower202607100060": "Etower2.0 电池数量异常",
  "alarm.excDesc.etower202607100060": "电池数量异常",
  "alarm.suggestion.etower202607100060": "重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100060": "电池数量异常",
  "alarm.name.etower202607100062": "Etower2.0 DCV采样异常",
  "alarm.excDesc.etower202607100062": "DCV采样异常",
  "alarm.suggestion.etower202607100062": "DCV采样异常",
  "alarm.desc.etower202607100062": "DCV采样异常",
  "alarm.name.etower202607100064": "Etower2.0 rtc错误",
  "alarm.excDesc.etower202607100064": "rtc错误",
  "alarm.suggestion.etower202607100064": "rtc错误",
  "alarm.desc.etower202607100064": "rtc错误",
  "alarm.name.etower202607100066": "Etower2.0 backup欠压保护",
  "alarm.excDesc.etower202607100066": "backup欠压保护",
  "alarm.suggestion.etower202607100066": "backup欠压保护",
  "alarm.desc.etower202607100066": "backup欠压保护",
  "alarm.name.etower202607100068": "Etower2.0 load过流保护",
  "alarm.excDesc.etower202607100068": "load过流保护",
  "alarm.suggestion.etower202607100068": "load过流保护",
  "alarm.desc.etower202607100068": "load过流保护",
  "alarm.name.etower202607100070": "Etower2.0 电网波峰比高",
  "alarm.excDesc.etower202607100070": "电网波峰比高",
  "alarm.suggestion.etower202607100070": "电网波峰比高",
  "alarm.desc.etower202607100070": "电网波峰比高",
  "alarm.name.etower202607100072": "Etower2.0 pv反接",
  "alarm.excDesc.etower202607100072": "pv反接",
  "alarm.suggestion.etower202607100072": "pv反接",
  "alarm.desc.etower202607100072": "pv反接",
  "alarm.name.etower202607100074": "Etower2.0 afci警告",
  "alarm.excDesc.etower202607100074": "afci警告",
  "alarm.suggestion.etower202607100074": "afci警告",
  "alarm.desc.etower202607100074": "afci警告",
  "alarm.name.etower202607100130": "Etower2.0 电网欠压保护",
  "alarm.excDesc.etower202607100130": "电网欠压保护",
  "alarm.suggestion.etower202607100130": "电网欠压保护",
  "alarm.desc.etower202607100130": "电网欠压保护",
  "alarm.name.etower202607100132": "Etower2.0 电网欠频保护",
  "alarm.excDesc.etower202607100132": "电网欠频保护",
  "alarm.suggestion.etower202607100132": "电网欠频保护",
  "alarm.desc.etower202607100132": "电网欠频保护",
  "alarm.name.etower202607100023": "Etower2.0 DCV",
  "alarm.excDesc.etower202607100023": "DCV",
  "alarm.suggestion.etower202607100023": "正常保护模式，无需执行任何作。",
  "alarm.desc.etower202607100023": "DCV",
  "alarm.name.etower202607100025": "Etower2.0 风扇异常",
  "alarm.excDesc.etower202607100025": "风扇异常",
  "alarm.suggestion.etower202607100025": "重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100025": "风扇异常",
  "alarm.name.etower202607100027": "Etower2.0 SCI通讯异常",
  "alarm.excDesc.etower202607100027": "SCI通讯异常",
  "alarm.suggestion.etower202607100027": "重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100027": "SCI通讯异常",
  "alarm.name.etower202607100029": "Etower2.0 flashid异常",
  "alarm.excDesc.etower202607100029": "flashid异常",
  "alarm.suggestion.etower202607100029": "重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100029": "flashid异常",
  "alarm.name.etower202607100033": "Etower2.0 逆变电压低",
  "alarm.excDesc.etower202607100033": "逆变电压低",
  "alarm.suggestion.etower202607100033": "1. 检查负载功率是否超过逆变器额定功率。\n2. 重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100033": "逆变电压低",
  "alarm.name.etower202607100035": "Etower2.0 硬件逆变过流",
  "alarm.excDesc.etower202607100035": "硬件逆变过流",
  "alarm.suggestion.etower202607100035": "重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100035": "硬件逆变过流",
  "alarm.name.etower202607100037": "Etower2.0 bst硬件逆变过流",
  "alarm.excDesc.etower202607100037": "bst硬件逆变过流",
  "alarm.suggestion.etower202607100037": "重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100037": "bst硬件逆变过流",
  "alarm.name.etower202607100039": "Etower2.0 buckbst硬件逆变过流",
  "alarm.excDesc.etower202607100039": "buckbst硬件逆变过流",
  "alarm.suggestion.etower202607100039": "重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100039": "buckbst硬件逆变过流",
  "alarm.name.etower202607100041": "Etower2.0 无pv输入",
  "alarm.excDesc.etower202607100041": "无pv输入",
  "alarm.suggestion.etower202607100041": "正常运行检测信息，无需执行任何作。",
  "alarm.desc.etower202607100041": "无pv输入",
  "alarm.name.etower202607100043": "Etower2.0 输出功率限制",
  "alarm.excDesc.etower202607100043": "输出功率限制",
  "alarm.suggestion.etower202607100043": "正常运行检测信息，无需执行任何作。",
  "alarm.desc.etower202607100043": "输出功率限制",
  "alarm.name.etower202607100045": "Etower2.0 过压降载",
  "alarm.excDesc.etower202607100045": "过压降载",
  "alarm.suggestion.etower202607100045": "等待 Grid 电源恢复正常。",
  "alarm.desc.etower202607100045": "过压降载",
  "alarm.name.etower202607100047": "Etower2.0 高电压穿越",
  "alarm.excDesc.etower202607100047": "高电压穿越",
  "alarm.suggestion.etower202607100047": "等待 Grid 电源恢复正常。",
  "alarm.desc.etower202607100047": "高电压穿越",
  "alarm.name.etower202607100049": "Etower2.0 热敏电阻异常",
  "alarm.excDesc.etower202607100049": "热敏电阻异常",
  "alarm.suggestion.etower202607100049": "重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100049": "热敏电阻异常",
  "alarm.name.etower202607100051": "Etower2.0 离网电容衰减",
  "alarm.excDesc.etower202607100051": "离网电容衰减",
  "alarm.suggestion.etower202607100051": "重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100051": "离网电容衰减",
  "alarm.name.etower202607100053": "Etower2.0 并机ID错误",
  "alarm.excDesc.etower202607100053": "并机ID错误",
  "alarm.suggestion.etower202607100053": "1. 检查并机主从机设置是否正确。\n2. 重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100053": "并机ID错误",
  "alarm.name.etower202607100055": "Etower2.0 并机ID重复",
  "alarm.excDesc.etower202607100055": "并机ID重复",
  "alarm.suggestion.etower202607100055": "1. 检查并机主从机设置是否正确。\n2. 重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100055": "并机ID重复",
  "alarm.name.etower202607100057": "Etower2.0 输出不均流",
  "alarm.excDesc.etower202607100057": "输出不均流",
  "alarm.suggestion.etower202607100057": "重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100057": "输出不均流",
  "alarm.name.etower202607100061": "Etower2.0 电网相序不一致",
  "alarm.excDesc.etower202607100061": "电网相序不一致",
  "alarm.suggestion.etower202607100061": "电网相序不一致",
  "alarm.desc.etower202607100061": "电网相序不一致",
  "alarm.name.etower202607100063": "Etower2.0 blackbox_flash错误",
  "alarm.excDesc.etower202607100063": "blackbox_flash错误",
  "alarm.suggestion.etower202607100063": "blackbox_flash错误",
  "alarm.desc.etower202607100063": "blackbox_flash错误",
  "alarm.name.etower202607100065": "Etower2.0 backup过压保护",
  "alarm.excDesc.etower202607100065": "backup过压保护",
  "alarm.suggestion.etower202607100065": "backup过压保护",
  "alarm.desc.etower202607100065": "backup过压保护",
  "alarm.name.etower202607100067": "Etower2.0 backup",
  "alarm.excDesc.etower202607100067": "backup",
  "alarm.suggestion.etower202607100067": "backup",
  "alarm.desc.etower202607100067": "backup",
  "alarm.name.etower202607100069": "Etower2.0 ems和bms丢失",
  "alarm.excDesc.etower202607100069": "ems和bms丢失",
  "alarm.suggestion.etower202607100069": "ems和bms丢失",
  "alarm.desc.etower202607100069": "ems和bms丢失",
  "alarm.name.etower202607100071": "Etower2.0 bus不平衡",
  "alarm.excDesc.etower202607100071": "bus不平衡",
  "alarm.suggestion.etower202607100071": "bus不平衡",
  "alarm.desc.etower202607100071": "bus不平衡",
  "alarm.name.etower202607100073": "Etower2.0 铅酸电池数量设置错误",
  "alarm.excDesc.etower202607100073": "铅酸电池数量设置错误",
  "alarm.suggestion.etower202607100073": "铅酸电池数量设置错误",
  "alarm.desc.etower202607100073": "铅酸电池数量设置错误",
  "alarm.name.etower202607100075": "Etower2.0 Reserve 1",
  "alarm.excDesc.etower202607100075": "Reserve",
  "alarm.suggestion.etower202607100075": "Reserve",
  "alarm.desc.etower202607100075": "Reserve",
  "alarm.name.etower202607100133": "Etower2.0 相位锁定故障",
  "alarm.excDesc.etower202607100133": "相位锁定故障",
  "alarm.suggestion.etower202607100133": "相位锁定故障",
  "alarm.desc.etower202607100133": "相位锁定故障",
  "alarm.name.etower202607100135": "Etower2.0 总线2过压保护",
  "alarm.excDesc.etower202607100135": "总线2过压保护",
  "alarm.suggestion.etower202607100135": "总线2过压保护",
  "alarm.desc.etower202607100135": "总线2过压保护",
  "alarm.name.etower202607100137": "Etower2.0 接地故障断路器故障",
  "alarm.excDesc.etower202607100137": "接地故障断路器故障",
  "alarm.suggestion.etower202607100137": "重启系统，检查是否存在故障。",
  "alarm.desc.etower202607100137": "接地故障断路器故障",
  "alarm.name.etower202607100139": "Etower2.0 gfci继电器故障",
  "alarm.excDesc.etower202607100139": "gfci继电器故障",
  "alarm.suggestion.etower202607100139": "gfci继电器故障",
  "alarm.desc.etower202607100139": "gfci继电器故障",
  "alarm.name.etower202607100141": "Etower2.0 光伏组件极性反接 1",
  "alarm.excDesc.etower202607100141": "光伏组件极性反接",
  "alarm.suggestion.etower202607100141": "光伏组件极性反接",
  "alarm.desc.etower202607100141": "光伏组件极性反接",
  "alarm.name.etower202607100143": "Etower2.0 主从通信故障",
  "alarm.excDesc.etower202607100143": "主从通信故障",
  "alarm.suggestion.etower202607100143": "主从通信故障",
  "alarm.desc.etower202607100143": "主从通信故障",
  "alarm.name.etower202607100145": "Etower2.0 芯片1升级失败",
  "alarm.excDesc.etower202607100145": "芯片1升级失败",
  "alarm.suggestion.etower202607100145": "芯片1升级失败",
  "alarm.desc.etower202607100145": "芯片1升级失败",
  "alarm.name.etower202607100147": "Etower2.0 mppt1软件过流保护",
  "alarm.excDesc.etower202607100147": "mppt1软件过流保护",
  "alarm.suggestion.etower202607100147": "mppt1软件过流保护",
  "alarm.desc.etower202607100147": "mppt1软件过流保护",
  "alarm.name.etower202607100149": "Etower2.0 mppt1过温保护",
  "alarm.excDesc.etower202607100149": "mppt1过温保护",
  "alarm.suggestion.etower202607100149": "mppt1过温保护",
  "alarm.desc.etower202607100149": "mppt1过温保护",
  "alarm.name.etower202607100153": "Etower2.0 mppt2过温保护",
  "alarm.excDesc.etower202607100153": "mppt2过温保护",
  "alarm.suggestion.etower202607100153": "mppt2过温保护",
  "alarm.desc.etower202607100153": "mppt2过温保护",
  "alarm.name.etower202607100155": "Etower2.0 bat欠压保护",
  "alarm.excDesc.etower202607100155": "bat欠压保护",
  "alarm.suggestion.etower202607100155": "检查实际电池电压是否低于电池放电截止电压。",
  "alarm.desc.etower202607100155": "bat欠压保护",
  "alarm.name.etower202607100157": "Etower2.0 电池过温保护",
  "alarm.excDesc.etower202607100157": "电池过温保护",
  "alarm.suggestion.etower202607100157": "电池过温保护",
  "alarm.desc.etower202607100157": "电池过温保护",
  "alarm.name.etower202607100159": "Etower2.0 bat1放电过流保护",
  "alarm.excDesc.etower202607100159": "bat1放电过流保护",
  "alarm.suggestion.etower202607100159": "bat1放电过流保护",
  "alarm.desc.etower202607100159": "bat1放电过流保护",
  "alarm.name.etower202607100161": "Etower2.0 bat2放电过流保护",
  "alarm.excDesc.etower202607100161": "bat2放电过流保护",
  "alarm.suggestion.etower202607100161": "bat2放电过流保护",
  "alarm.desc.etower202607100161": "bat2放电过流保护",
  "alarm.name.etower202607100163": "Etower2.0 bat2硬件过流保护",
  "alarm.excDesc.etower202607100163": "bat2硬件过流保护",
  "alarm.suggestion.etower202607100163": "bat2硬件过流保护",
  "alarm.desc.etower202607100163": "bat2硬件过流保护",
  "alarm.name.etower202607100165": "Etower2.0 逆变过压保护",
  "alarm.excDesc.etower202607100165": "逆变过压保护",
  "alarm.suggestion.etower202607100165": "逆变过压保护",
  "alarm.desc.etower202607100165": "逆变过压保护",
  "alarm.name.etower202607100169": "Etower2.0 逆变硬件过流保护",
  "alarm.excDesc.etower202607100169": "逆变硬件过流保护",
  "alarm.suggestion.etower202607100169": "逆变硬件过流保护",
  "alarm.desc.etower202607100169": "逆变硬件过流保护",
  "alarm.name.etower202607100171": "Etower2.0 输出短路",
  "alarm.excDesc.etower202607100171": "输出短路",
  "alarm.suggestion.etower202607100171": "1. 使用万用表测试离网输出的阻抗。如果很小，请检查接线是否正确。\n2. 重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100171": "输出短路",
  "alarm.name.etower202607100173": "Etower2.0 APU欠压保护",
  "alarm.excDesc.etower202607100173": "APU欠压保护",
  "alarm.suggestion.etower202607100173": "APU欠压保护",
  "alarm.desc.etower202607100173": "APU欠压保护",
  "alarm.name.etower202607100175": "Etower2.0 直流输入扰动",
  "alarm.excDesc.etower202607100175": "直流输入扰动",
  "alarm.suggestion.etower202607100175": "直流输入扰动",
  "alarm.desc.etower202607100175": "直流输入扰动",
  "alarm.name.etower202607100179": "Etower2.0 电网过电流",
  "alarm.excDesc.etower202607100179": "电网过电流",
  "alarm.suggestion.etower202607100179": "电网过电流",
  "alarm.desc.etower202607100179": "电网过电流",
  "alarm.name.etower202607100181": "Etower2.0 负载过压保护",
  "alarm.excDesc.etower202607100181": "负载过压保护",
  "alarm.suggestion.etower202607100181": "负载过压保护",
  "alarm.desc.etower202607100181": "负载过压保护",
  "alarm.name.etower202607100183": "Etower2.0 直流总线低压",
  "alarm.excDesc.etower202607100183": "直流总线低压",
  "alarm.suggestion.etower202607100183": "直流总线低压",
  "alarm.desc.etower202607100183": "直流总线低压",
  "alarm.name.etower202607100185": "Etower2.0 IGBT过流",
  "alarm.excDesc.etower202607100185": "IGBT过流",
  "alarm.suggestion.etower202607100185": "IGBT过流",
  "alarm.desc.etower202607100185": "IGBT过流",
  "alarm.name.etower202607100187": "Etower2.0 afci检查保护",
  "alarm.excDesc.etower202607100187": "afci检查保护",
  "alarm.suggestion.etower202607100187": "afci检查保护",
  "alarm.desc.etower202607100187": "afci检查保护",
  "alarm.name.etower202607100189": "Etower2.0 DSP自检",
  "alarm.excDesc.etower202607100189": "DSP自检",
  "alarm.suggestion.etower202607100189": "DSP自检",
  "alarm.desc.etower202607100189": "DSP自检",
  "alarm.name.etower202607100191": "Etower2.0 电池过压硬件故障",
  "alarm.excDesc.etower202607100191": "电池过压硬件故障",
  "alarm.suggestion.etower202607100191": "电池过压硬件故障",
  "alarm.desc.etower202607100191": "电池过压硬件故障",
  "alarm.name.etower202607100193": "Etower2.0 交流电流互感器检测失败",
  "alarm.excDesc.etower202607100193": "交流电流互感器检测失败",
  "alarm.suggestion.etower202607100193": "交流电流互感器检测失败",
  "alarm.desc.etower202607100193": "交流电流互感器检测失败",
  "alarm.name.etower202607100138": "Etower2.0 gfci测试故障",
  "alarm.excDesc.etower202607100138": "gfci测试故障",
  "alarm.suggestion.etower202607100138": "gfci测试故障",
  "alarm.desc.etower202607100138": "gfci测试故障",
  "alarm.name.etower202607100140": "Etower2.0 过温",
  "alarm.excDesc.etower202607100140": "过温",
  "alarm.suggestion.etower202607100140": "过温",
  "alarm.desc.etower202607100140": "过温",
  "alarm.name.etower202607100146": "Etower2.0 mppt1过压保护",
  "alarm.excDesc.etower202607100146": "mppt1过压保护",
  "alarm.suggestion.etower202607100146": "mppt1过压保护",
  "alarm.desc.etower202607100146": "mppt1过压保护",
  "alarm.name.etower202607100148": "Etower2.0 mppt2硬件过流保护 1",
  "alarm.excDesc.etower202607100148": "mppt2硬件过流保护",
  "alarm.suggestion.etower202607100148": "mppt2硬件过流保护",
  "alarm.desc.etower202607100148": "mppt2硬件过流保护",
  "alarm.name.etower202607100150": "Etower2.0 mppt2过压保护 1",
  "alarm.excDesc.etower202607100150": "mppt2过压保护",
  "alarm.suggestion.etower202607100150": "mppt2过压保护",
  "alarm.desc.etower202607100150": "mppt2过压保护",
  "alarm.name.etower202607100154": "Etower2.0 bat过压保护",
  "alarm.excDesc.etower202607100154": "bat过压保护",
  "alarm.suggestion.etower202607100154": "检查实际电池电压是否超过电池充电截止电压 20V 以上。",
  "alarm.desc.etower202607100154": "bat过压保护",
  "alarm.name.etower202607100156": "Etower2.0 电池缺失",
  "alarm.excDesc.etower202607100156": "电池缺失",
  "alarm.suggestion.etower202607100156": "电池缺失",
  "alarm.desc.etower202607100156": "电池缺失",
  "alarm.name.etower202607100158": "Etower2.0 bat1充电过流保护",
  "alarm.excDesc.etower202607100158": "bat1充电过流保护",
  "alarm.suggestion.etower202607100158": "bat1充电过流保护",
  "alarm.desc.etower202607100158": "bat1充电过流保护",
  "alarm.name.etower202607100160": "Etower2.0 bat2充电过流保护",
  "alarm.excDesc.etower202607100160": "bat2充电过流保护",
  "alarm.suggestion.etower202607100160": "bat2充电过流保护",
  "alarm.desc.etower202607100160": "bat2充电过流保护",
  "alarm.name.etower202607100162": "Etower2.0 bat1硬件过流保护",
  "alarm.excDesc.etower202607100162": "bat1硬件过流保护",
  "alarm.suggestion.etower202607100162": "bat1硬件过流保护",
  "alarm.desc.etower202607100162": "bat1硬件过流保护",
  "alarm.name.etower202607100164": "Etower2.0 逆变过温保护",
  "alarm.excDesc.etower202607100164": "逆变过温保护",
  "alarm.suggestion.etower202607100164": "逆变过温保护",
  "alarm.desc.etower202607100164": "逆变过温保护",
  "alarm.name.etower202607100166": "Etower2.0 逆变欠压保护",
  "alarm.excDesc.etower202607100166": "逆变欠压保护",
  "alarm.suggestion.etower202607100166": "逆变欠压保护",
  "alarm.desc.etower202607100166": "逆变欠压保护",
  "alarm.name.etower202607100168": "Etower2.0 逆变过流保护",
  "alarm.excDesc.etower202607100168": "逆变过流保护",
  "alarm.suggestion.etower202607100168": "逆变过流保护",
  "alarm.desc.etower202607100168": "逆变过流保护",
  "alarm.name.etower202607100170": "Etower2.0 直流输出过压",
  "alarm.excDesc.etower202607100170": "直流输出过压",
  "alarm.suggestion.etower202607100170": "直流输出过压",
  "alarm.desc.etower202607100170": "直流输出过压",
  "alarm.name.etower202607100172": "Etower2.0 输出过载",
  "alarm.excDesc.etower202607100172": "输出过载",
  "alarm.suggestion.etower202607100172": "1. 检查负载是否超过额定功率。\n2. 重新启动系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100172": "输出过载",
  "alarm.name.etower202607100174": "Etower2.0 电池继电器故障",
  "alarm.excDesc.etower202607100174": "电池继电器故障",
  "alarm.suggestion.etower202607100174": "电池继电器故障",
  "alarm.desc.etower202607100174": "电池继电器故障",
  "alarm.name.etower202607100176": "Etower2.0 电网扰动",
  "alarm.excDesc.etower202607100176": "电网扰动",
  "alarm.suggestion.etower202607100176": "电网扰动",
  "alarm.desc.etower202607100176": "电网扰动",
  "alarm.name.etower202607100178": "Etower2.0 频率抖动",
  "alarm.excDesc.etower202607100178": "频率抖动",
  "alarm.suggestion.etower202607100178": "频率抖动",
  "alarm.desc.etower202607100178": "频率抖动",
  "alarm.name.etower202607100180": "Etower2.0 电网电流通路故障",
  "alarm.excDesc.etower202607100180": "电网电流通路故障",
  "alarm.suggestion.etower202607100180": "电网电流通路故障",
  "alarm.desc.etower202607100180": "电网电流通路故障",
  "alarm.name.etower202607100182": "Etower2.0 直流总线电压不平衡",
  "alarm.excDesc.etower202607100182": "直流总线电压不平衡",
  "alarm.suggestion.etower202607100182": "直流总线电压不平衡",
  "alarm.desc.etower202607100182": "直流总线电压不平衡",
  "alarm.name.etower202607100186": "Etower2.0 电网扰动2",
  "alarm.excDesc.etower202607100186": "电网扰动2",
  "alarm.suggestion.etower202607100186": "电网扰动2",
  "alarm.desc.etower202607100186": "电网扰动2",
  "alarm.name.etower202607100188": "Etower2.0 电网电流采样异常",
  "alarm.excDesc.etower202607100188": "电网电流采样异常",
  "alarm.suggestion.etower202607100188": "电网电流采样异常",
  "alarm.desc.etower202607100188": "电网电流采样异常",
  "alarm.name.etower202607100190": "Etower2.0 电网瞬时过流",
  "alarm.excDesc.etower202607100190": "电网瞬时过流",
  "alarm.suggestion.etower202607100190": "电网瞬时过流",
  "alarm.desc.etower202607100190": "电网瞬时过流",
  "alarm.name.etower202607100192": "Etower2.0 零线接地故障",
  "alarm.excDesc.etower202607100192": "零线接地故障",
  "alarm.suggestion.etower202607100192": "零线接地故障",
  "alarm.desc.etower202607100192": "零线接地故障",
  "alarm.name.etower202607100194": "Etower2.0 DCI一致性故障",
  "alarm.excDesc.etower202607100194": "DCI一致性故障",
  "alarm.suggestion.etower202607100194": "DCI一致性故障",
  "alarm.desc.etower202607100194": "DCI一致性故障",
  "alarm.name.etower202607100196": "Etower2.0 继电器设备故障",
  "alarm.excDesc.etower202607100196": "继电器设备故障",
  "alarm.suggestion.etower202607100196": "继电器设备故障",
  "alarm.desc.etower202607100196": "继电器设备故障",
  "alarm.name.etower202607100200": "Etower2.0 相位缺失",
  "alarm.excDesc.etower202607100200": "相位缺失",
  "alarm.suggestion.etower202607100200": "相位缺失",
  "alarm.desc.etower202607100200": "相位缺失",
  "alarm.name.etower202607100202": "Etower2.0 交流频率一致性错误",
  "alarm.excDesc.etower202607100202": "交流频率一致性错误",
  "alarm.suggestion.etower202607100202": "交流频率一致性错误",
  "alarm.desc.etower202607100202": "交流频率一致性错误",
  "alarm.name.etower202607100195": "Etower2.0 接地故障断路器一致性故障",
  "alarm.excDesc.etower202607100195": "接地故障断路器一致性故障",
  "alarm.suggestion.etower202607100195": "接地故障断路器一致性故障",
  "alarm.desc.etower202607100195": "接地故障断路器一致性故障",
  "alarm.name.etower202607100197": "Etower2.0 交流电流互感器故障",
  "alarm.excDesc.etower202607100197": "交流电流互感器故障",
  "alarm.suggestion.etower202607100197": "交流电流互感器故障",
  "alarm.desc.etower202607100197": "交流电流互感器故障",
  "alarm.name.etower202607100199": "Etower2.0 相位错误",
  "alarm.excDesc.etower202607100199": "相位错误",
  "alarm.suggestion.etower202607100199": "相位错误",
  "alarm.desc.etower202607100199": "相位错误",
  "alarm.name.etower202607100203": "Etower2.0 交流电压一致性错误",
  "alarm.excDesc.etower202607100203": "交流电压一致性错误",
  "alarm.suggestion.etower202607100203": "交流电压一致性错误",
  "alarm.desc.etower202607100203": "交流电压一致性错误",
  "alarm.name.etower202607100205": "Etower2.0 DSP通讯错误",
  "alarm.excDesc.etower202607100205": "DSP通讯错误",
  "alarm.suggestion.etower202607100205": "DSP通讯错误",
  "alarm.desc.etower202607100205": "DSP通讯错误",
  "alarm.name.etower202607100207": "Etower2.0 交流电压故障",
  "alarm.excDesc.etower202607100207": "交流电压故障",
  "alarm.suggestion.etower202607100207": "交流电压故障",
  "alarm.desc.etower202607100207": "交流电压故障",
  "alarm.name.etower202607100211": "Etower2.0 bus软起超时",
  "alarm.excDesc.etower202607100211": "bus软起超时",
  "alarm.suggestion.etower202607100211": "bus软起超时",
  "alarm.desc.etower202607100211": "bus软起超时",
  "alarm.name.etower202607100213": "Etower2.0 逆变软起超时",
  "alarm.excDesc.etower202607100213": "逆变软起超时",
  "alarm.suggestion.etower202607100213": "逆变软起超时",
  "alarm.desc.etower202607100213": "逆变软起超时",
  "alarm.name.etower202607100215": "Etower2.0 火线、地线反接",
  "alarm.excDesc.etower202607100215": "火线、地线反接",
  "alarm.suggestion.etower202607100215": "1. 检查 L 线是否连接到接地。\n2. 重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100215": "火线、地线反接",
  "alarm.name.etower202607100217": "Etower2.0 emsCAN通讯错误",
  "alarm.excDesc.etower202607100217": "emsCAN通讯错误",
  "alarm.suggestion.etower202607100217": "emsCAN通讯错误",
  "alarm.desc.etower202607100217": "emsCAN通讯错误",
  "alarm.name.etower202607100219": "Etower2.0 1.5V电源错误",
  "alarm.excDesc.etower202607100219": "1.5V电源错误",
  "alarm.suggestion.etower202607100219": "1.5V电源错误",
  "alarm.desc.etower202607100219": "1.5V电源错误",
  "alarm.name.etower202607100221": "Etower2.0 热敏电阻丢失",
  "alarm.excDesc.etower202607100221": "热敏电阻丢失",
  "alarm.suggestion.etower202607100221": "热敏电阻丢失",
  "alarm.desc.etower202607100221": "热敏电阻丢失",
  "alarm.name.etower202607100223": "Etower2.0 负载CT故障",
  "alarm.excDesc.etower202607100223": "负载CT故障",
  "alarm.suggestion.etower202607100223": "负载CT故障",
  "alarm.desc.etower202607100223": "负载CT故障",
  "alarm.name.etower202607100225": "Etower2.0 PV2CT故障",
  "alarm.excDesc.etower202607100225": "PV2CT故障",
  "alarm.suggestion.etower202607100225": "PV2CT故障",
  "alarm.desc.etower202607100225": "PV2CT故障",
  "alarm.name.etower202607100227": "Etower2.0 bat2CT故障",
  "alarm.excDesc.etower202607100227": "bat2CT故障",
  "alarm.suggestion.etower202607100227": "bat2CT故障",
  "alarm.desc.etower202607100227": "bat2CT故障",
  "alarm.name.etower202607100229": "Etower2.0 负载开关故障",
  "alarm.excDesc.etower202607100229": "负载开关故障",
  "alarm.suggestion.etower202607100229": "负载开关故障",
  "alarm.desc.etower202607100229": "负载开关故障",
  "alarm.name.etower202607100231": "Etower2.0 直流电流分量错误",
  "alarm.excDesc.etower202607100231": "直流电流分量错误",
  "alarm.suggestion.etower202607100231": "直流电流分量错误",
  "alarm.desc.etower202607100231": "直流电流分量错误",
  "alarm.name.etower202607100233": "Etower2.0 逆变开环错误",
  "alarm.excDesc.etower202607100233": "逆变开环错误",
  "alarm.suggestion.etower202607100233": "逆变开环错误",
  "alarm.desc.etower202607100233": "逆变开环错误",
  "alarm.name.etower202607100204": "Etower2.0 相位角错误",
  "alarm.excDesc.etower202607100204": "相位角错误",
  "alarm.suggestion.etower202607100204": "相位角错误",
  "alarm.desc.etower202607100204": "相位角错误",
  "alarm.name.etower202607100206": "Etower2.0 寄存器写入错误",
  "alarm.excDesc.etower202607100206": "寄存器写入错误",
  "alarm.suggestion.etower202607100206": "寄存器写入错误",
  "alarm.desc.etower202607100206": "寄存器写入错误",
  "alarm.name.etower202607100208": "Etower2.0 交流频率故障",
  "alarm.excDesc.etower202607100208": "交流频率故障",
  "alarm.suggestion.etower202607100208": "交流频率故障",
  "alarm.desc.etower202607100208": "交流频率故障",
  "alarm.name.etower202607100210": "Etower2.0 防拉弧设备故障",
  "alarm.excDesc.etower202607100210": "防拉弧设备故障",
  "alarm.suggestion.etower202607100210": "防拉弧设备故障",
  "alarm.desc.etower202607100210": "防拉弧设备故障",
  "alarm.name.etower202607100212": "Etower2.0 bus短路",
  "alarm.excDesc.etower202607100212": "bus短路",
  "alarm.suggestion.etower202607100212": "bus短路",
  "alarm.desc.etower202607100212": "bus短路",
  "alarm.name.etower202607100214": "Etower2.0 backup、grid反接",
  "alarm.excDesc.etower202607100214": "backup、grid反接",
  "alarm.suggestion.etower202607100214": "backup、grid反接",
  "alarm.desc.etower202607100214": "backup、grid反接",
  "alarm.name.etower202607100216": "Etower2.0 ems串口通讯错误",
  "alarm.excDesc.etower202607100216": "ems串口通讯错误",
  "alarm.suggestion.etower202607100216": "ems串口通讯错误",
  "alarm.desc.etower202607100216": "ems串口通讯错误",
  "alarm.name.etower202607100218": "Etower2.0 12V辅助电源参考错误",
  "alarm.excDesc.etower202607100218": "12V辅助电源参考错误",
  "alarm.suggestion.etower202607100218": "12V辅助电源参考错误",
  "alarm.desc.etower202607100218": "12V辅助电源参考错误",
  "alarm.name.etower202607100220": "Etower2.0 0.5V电源错误",
  "alarm.excDesc.etower202607100220": "0.5V电源错误",
  "alarm.suggestion.etower202607100220": "0.5V电源错误",
  "alarm.desc.etower202607100220": "0.5V电源错误",
  "alarm.name.etower202607100222": "Etower2.0 逆变hct错误",
  "alarm.excDesc.etower202607100222": "逆变hct错误",
  "alarm.suggestion.etower202607100222": "逆变hct错误",
  "alarm.desc.etower202607100222": "逆变hct错误",
  "alarm.name.etower202607100224": "Etower2.0 PV1CT故障",
  "alarm.excDesc.etower202607100224": "PV1CT故障",
  "alarm.suggestion.etower202607100224": "PV1CT故障",
  "alarm.desc.etower202607100224": "PV1CT故障",
  "alarm.name.etower202607100226": "Etower2.0 bat1CT故障",
  "alarm.excDesc.etower202607100226": "bat1CT故障",
  "alarm.suggestion.etower202607100226": "bat1CT故障",
  "alarm.desc.etower202607100226": "bat1CT故障",
  "alarm.name.etower202607100230": "Etower2.0 零线对地防雷保护",
  "alarm.excDesc.etower202607100230": "零线对地防雷保护",
  "alarm.suggestion.etower202607100230": "零线对地防雷保护",
  "alarm.desc.etower202607100230": "零线对地防雷保护",
  "alarm.name.etower202607100232": "Etower2.0 定时器故障",
  "alarm.excDesc.etower202607100232": "定时器故障",
  "alarm.suggestion.etower202607100232": "定时器故障",
  "alarm.desc.etower202607100232": "定时器故障",
  "alarm.name.etower202607100234": "Etower2.0 软件一致性错误",
  "alarm.excDesc.etower202607100234": "软件一致性错误",
  "alarm.suggestion.etower202607100234": "请重新进行远程升级，并确保 CPU1 和 CPU2 升级文件的版本一致。",
  "alarm.desc.etower202607100234": "软件一致性错误",
  "alarm.name.etower202607100236": "Etower2.0 初始化故障",
  "alarm.excDesc.etower202607100236": "初始化故障",
  "alarm.suggestion.etower202607100236": "初始化故障",
  "alarm.desc.etower202607100236": "初始化故障",
  "alarm.name.etower202607100237": "Etower2.0 B路DSP芯片故障（本产品不涉及）",
  "alarm.excDesc.etower202607100237": "B路DSP芯片故障（本产品不涉及）",
  "alarm.suggestion.etower202607100237": "B路DSP芯片故障（本产品不涉及）",
  "alarm.desc.etower202607100237": "B路DSP芯片故障（本产品不涉及）",
  "alarm.name.etower202607100241": "Etower2.0 并行通讯错误",
  "alarm.excDesc.etower202607100241": "并行通讯错误",
  "alarm.suggestion.etower202607100241": "并行通讯错误",
  "alarm.desc.etower202607100241": "并行通讯错误",
  "alarm.name.etower202607100242": "Etower2.0 并行系统信号错误",
  "alarm.excDesc.etower202607100242": "并行系统信号错误",
  "alarm.suggestion.etower202607100242": "并行系统信号错误",
  "alarm.desc.etower202607100242": "并行系统信号错误",
  "alarm.name.etower202607100238": "Etower2.0 逆变器线路异常",
  "alarm.excDesc.etower202607100238": "逆变器线路异常",
  "alarm.suggestion.etower202607100238": "逆变器线路异常",
  "alarm.desc.etower202607100238": "逆变器线路异常",
  "alarm.name.etower202607100240": "Etower2.0 数据存储故障",
  "alarm.excDesc.etower202607100240": "数据存储故障",
  "alarm.suggestion.etower202607100240": "数据存储故障",
  "alarm.desc.etower202607100240": "数据存储故障",
  "alarm.name.etower202607100243": "Etower2.0 并机软件版本不一致",
  "alarm.excDesc.etower202607100243": "并机软件版本不一致",
  "alarm.suggestion.etower202607100243": "并机软件版本不一致",
  "alarm.desc.etower202607100243": "并机软件版本不一致",
  "alarm.name.etower202607100244": "Etower2.0 模块模式错误",
  "alarm.excDesc.etower202607100244": "模块模式错误",
  "alarm.suggestion.etower202607100244": "模块模式错误",
  "alarm.desc.etower202607100244": "模块模式错误",
  "alarm.name.etower202607100245": "Etower2.0 负功故障",
  "alarm.excDesc.etower202607100245": "负功故障",
  "alarm.suggestion.etower202607100245": "负功故障",
  "alarm.desc.etower202607100245": "负功故障",
  "alarm.name.etower202607100246": "Etower2.0 并机多主机错误",
  "alarm.excDesc.etower202607100246": "并机多主机错误",
  "alarm.suggestion.etower202607100246": "并机多主机错误",
  "alarm.desc.etower202607100246": "并机多主机错误",
  "alarm.name.etower202607100247": "Etower2.0 开机异常",
  "alarm.excDesc.etower202607100247": "开机异常",
  "alarm.suggestion.etower202607100247": "开机异常",
  "alarm.desc.etower202607100247": "开机异常",
  "alarm.name.etower202607100251": "Etower2.0 逆变器限流保护",
  "alarm.excDesc.etower202607100251": "逆变器限流保护",
  "alarm.suggestion.etower202607100251": "逆变器限流保护",
  "alarm.desc.etower202607100251": "逆变器限流保护",
  "alarm.name.etower202607100253": "Etower2.0 升压电路软件过流保护",
  "alarm.excDesc.etower202607100253": "升压电路软件过流保护",
  "alarm.suggestion.etower202607100253": "升压电路软件过流保护",
  "alarm.desc.etower202607100253": "升压电路软件过流保护",
  "alarm.name.etower202607100255": "Etower2.0 BDC自检故障",
  "alarm.excDesc.etower202607100255": "BDC自检故障",
  "alarm.suggestion.etower202607100255": "BDC自检故障",
  "alarm.desc.etower202607100255": "BDC自检故障",
  "alarm.name.etower202607100257": "Etower2.0 单体电池欠压保护",
  "alarm.excDesc.etower202607100257": "单体电池欠压保护",
  "alarm.suggestion.etower202607100257": "单体电池欠压保护",
  "alarm.desc.etower202607100257": "单体电池欠压保护",
  "alarm.name.etower202607100259": "Etower2.0 放电系统欠压保护",
  "alarm.excDesc.etower202607100259": "放电系统欠压保护",
  "alarm.suggestion.etower202607100259": "放电系统欠压保护",
  "alarm.desc.etower202607100259": "放电系统欠压保护",
  "alarm.name.etower202607100261": "Etower2.0 充电电池低温保护",
  "alarm.excDesc.etower202607100261": "充电电池低温保护",
  "alarm.suggestion.etower202607100261": "充电电池低温保护",
  "alarm.desc.etower202607100261": "充电电池低温保护",
  "alarm.name.etower202607100263": "Etower2.0 放电电池低温保护",
  "alarm.excDesc.etower202607100263": "放电电池低温保护",
  "alarm.suggestion.etower202607100263": "放电电池低温保护",
  "alarm.desc.etower202607100263": "放电电池低温保护",
  "alarm.name.etower202607100265": "Etower2.0 充电过流保护",
  "alarm.excDesc.etower202607100265": "充电过流保护",
  "alarm.suggestion.etower202607100265": "充电过流保护",
  "alarm.desc.etower202607100265": "充电过流保护",
  "alarm.name.etower202607100267": "Etower2.0 模组欠压保护",
  "alarm.excDesc.etower202607100267": "模组欠压保护",
  "alarm.suggestion.etower202607100267": "模组欠压保护",
  "alarm.desc.etower202607100267": "模组欠压保护",
  "alarm.name.etower202607100269": "Etower2.0 单体电池欠压保护2",
  "alarm.excDesc.etower202607100269": "单体电池欠压保护2",
  "alarm.suggestion.etower202607100269": "单体电池欠压保护2",
  "alarm.desc.etower202607100269": "单体电池欠压保护2",
  "alarm.name.etower202607100271": "Etower2.0 电池单体高压告警",
  "alarm.excDesc.etower202607100271": "电池单体高压告警",
  "alarm.suggestion.etower202607100271": "电池单体高压告警",
  "alarm.desc.etower202607100271": "电池单体高压告警",
  "alarm.name.etower202607100273": "Etower2.0 电池组充电高压告警",
  "alarm.excDesc.etower202607100273": "电池组充电高压告警",
  "alarm.suggestion.etower202607100273": "电池组充电高压告警",
  "alarm.desc.etower202607100273": "电池组充电高压告警",
  "alarm.name.etower202607100275": "Etower2.0 充电高温告警",
  "alarm.excDesc.etower202607100275": "充电高温告警",
  "alarm.suggestion.etower202607100275": "充电高温告警",
  "alarm.desc.etower202607100275": "充电高温告警",
  "alarm.name.etower202607100277": "Etower2.0 放电高温告警",
  "alarm.excDesc.etower202607100277": "放电高温告警",
  "alarm.suggestion.etower202607100277": "放电高温告警",
  "alarm.desc.etower202607100277": "放电高温告警",
  "alarm.name.etower202607100279": "Etower2.0 电池组放电过流告警",
  "alarm.excDesc.etower202607100279": "电池组放电过流告警",
  "alarm.suggestion.etower202607100279": "电池组放电过流告警",
  "alarm.desc.etower202607100279": "电池组放电过流告警",
  "alarm.name.etower202607100281": "Etower2.0 电池模块高压告警",
  "alarm.excDesc.etower202607100281": "电池模块高压告警",
  "alarm.suggestion.etower202607100281": "电池模块高压告警",
  "alarm.desc.etower202607100281": "电池模块高压告警",
  "alarm.name.etower202607100283": "Etower2.0 温度传感器故障",
  "alarm.excDesc.etower202607100283": "温度传感器故障",
  "alarm.suggestion.etower202607100283": "温度传感器故障",
  "alarm.desc.etower202607100283": "温度传感器故障",
  "alarm.name.etower202607100285": "Etower2.0 输入过压故障",
  "alarm.excDesc.etower202607100285": "输入过压故障",
  "alarm.suggestion.etower202607100285": "输入过压故障",
  "alarm.desc.etower202607100285": "输入过压故障",
  "alarm.name.etower202607100287": "Etower2.0 / 继电器检测故障",
  "alarm.excDesc.etower202607100287": "/ 继电器检测故障",
  "alarm.suggestion.etower202607100287": "/ 继电器检测故障",
  "alarm.desc.etower202607100287": "/ 继电器检测故障",
  "alarm.name.etower202607100289": "Etower2.0 关机电路异常/",
  "alarm.excDesc.etower202607100289": "关机电路异常/",
  "alarm.suggestion.etower202607100289": "关机电路异常/",
  "alarm.desc.etower202607100289": "关机电路异常/",
  "alarm.name.etower202607100291": "Etower2.0 内部总线异常/",
  "alarm.excDesc.etower202607100291": "内部总线异常/",
  "alarm.suggestion.etower202607100291": "内部总线异常/",
  "alarm.desc.etower202607100291": "内部总线异常/",
  "alarm.name.etower202607100248": "Etower2.0 硬件版本不一致",
  "alarm.excDesc.etower202607100248": "硬件版本不一致",
  "alarm.suggestion.etower202607100248": "硬件版本不一致",
  "alarm.desc.etower202607100248": "硬件版本不一致",
  "alarm.name.etower202607100249": "Etower2.0 总线不平衡",
  "alarm.excDesc.etower202607100249": "总线不平衡",
  "alarm.suggestion.etower202607100249": "总线不平衡",
  "alarm.desc.etower202607100249": "总线不平衡",
  "alarm.name.etower202607100250": "Etower2.0 逆变器输出线路短路",
  "alarm.excDesc.etower202607100250": "逆变器输出线路短路",
  "alarm.suggestion.etower202607100250": "1、检查负载是否短路连接。\n2. 重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100250": "逆变器输出线路短路",
  "alarm.name.etower202607100252": "Etower2.0 整流桥中点过流保护",
  "alarm.excDesc.etower202607100252": "整流桥中点过流保护",
  "alarm.suggestion.etower202607100252": "整流桥中点过流保护",
  "alarm.desc.etower202607100252": "整流桥中点过流保护",
  "alarm.name.etower202607100254": "Etower2.0 BDC提前充电故障",
  "alarm.excDesc.etower202607100254": "BDC提前充电故障",
  "alarm.suggestion.etower202607100254": "BDC提前充电故障",
  "alarm.desc.etower202607100254": "BDC提前充电故障",
  "alarm.name.etower202607100256": "Etower2.0 地线故障",
  "alarm.excDesc.etower202607100256": "地线故障",
  "alarm.suggestion.etower202607100256": "地线故障",
  "alarm.desc.etower202607100256": "地线故障",
  "alarm.name.etower202607100258": "Etower2.0 单体电池过压保护",
  "alarm.excDesc.etower202607100258": "单体电池过压保护",
  "alarm.suggestion.etower202607100258": "单体电池过压保护",
  "alarm.desc.etower202607100258": "单体电池过压保护",
  "alarm.name.etower202607100260": "Etower2.0 充电系统过压保护",
  "alarm.excDesc.etower202607100260": "充电系统过压保护",
  "alarm.suggestion.etower202607100260": "充电系统过压保护",
  "alarm.desc.etower202607100260": "充电系统过压保护",
  "alarm.name.etower202607100262": "Etower2.0 充电电池过温保护",
  "alarm.excDesc.etower202607100262": "充电电池过温保护",
  "alarm.suggestion.etower202607100262": "充电电池过温保护",
  "alarm.desc.etower202607100262": "充电电池过温保护",
  "alarm.name.etower202607100264": "Etower2.0 放电电池过温保护",
  "alarm.excDesc.etower202607100264": "放电电池过温保护",
  "alarm.suggestion.etower202607100264": "放电电池过温保护",
  "alarm.desc.etower202607100264": "放电电池过温保护",
  "alarm.name.etower202607100266": "Etower2.0 放电过流保护",
  "alarm.excDesc.etower202607100266": "放电过流保护",
  "alarm.suggestion.etower202607100266": "放电过流保护",
  "alarm.desc.etower202607100266": "放电过流保护",
  "alarm.name.etower202607100268": "Etower2.0 模组过压保护",
  "alarm.excDesc.etower202607100268": "模组过压保护",
  "alarm.suggestion.etower202607100268": "模组过压保护",
  "alarm.desc.etower202607100268": "模组过压保护",
  "alarm.name.etower202607100270": "Etower2.0 电池单体低压告警",
  "alarm.excDesc.etower202607100270": "电池单体低压告警",
  "alarm.suggestion.etower202607100270": "电池单体低压告警",
  "alarm.desc.etower202607100270": "电池单体低压告警",
  "alarm.name.etower202607100272": "Etower2.0 电池组放电低压告警",
  "alarm.excDesc.etower202607100272": "电池组放电低压告警",
  "alarm.suggestion.etower202607100272": "电池组放电低压告警",
  "alarm.desc.etower202607100272": "电池组放电低压告警",
  "alarm.name.etower202607100274": "Etower2.0 充电低温告警",
  "alarm.excDesc.etower202607100274": "充电低温告警",
  "alarm.suggestion.etower202607100274": "充电低温告警",
  "alarm.desc.etower202607100274": "充电低温告警",
  "alarm.name.etower202607100276": "Etower2.0 放电低温告警",
  "alarm.excDesc.etower202607100276": "放电低温告警",
  "alarm.suggestion.etower202607100276": "放电低温告警",
  "alarm.desc.etower202607100276": "放电低温告警",
  "alarm.name.etower202607100278": "Etower2.0 电池组充电过流告警",
  "alarm.excDesc.etower202607100278": "电池组充电过流告警",
  "alarm.suggestion.etower202607100278": "电池组充电过流告警",
  "alarm.desc.etower202607100278": "电池组充电过流告警",
  "alarm.name.etower202607100280": "Etower2.0 电池模块低压告警",
  "alarm.excDesc.etower202607100280": "电池模块低压告警",
  "alarm.suggestion.etower202607100280": "电池模块低压告警",
  "alarm.desc.etower202607100280": "电池模块低压告警",
  "alarm.name.etower202607100282": "Etower2.0 电压传感器故障",
  "alarm.excDesc.etower202607100282": "电压传感器故障",
  "alarm.suggestion.etower202607100282": "电压传感器故障",
  "alarm.desc.etower202607100282": "电压传感器故障",
  "alarm.name.etower202607100284": "Etower2.0 内部通信故障",
  "alarm.excDesc.etower202607100284": "内部通信故障",
  "alarm.suggestion.etower202607100284": "内部通信故障",
  "alarm.desc.etower202607100284": "内部通信故障",
  "alarm.name.etower202607100286": "Etower2.0 输入反接故障",
  "alarm.excDesc.etower202607100286": "输入反接故障",
  "alarm.suggestion.etower202607100286": "输入反接故障",
  "alarm.desc.etower202607100286": "输入反接故障",
  "alarm.name.etower202607100288": "Etower2.0 电池损坏故障（电池过放等原因导致）/",
  "alarm.excDesc.etower202607100288": "电池损坏故障（电池过放等原因导致）/",
  "alarm.suggestion.etower202607100288": "电池损坏故障（电池过放等原因导致）/",
  "alarm.desc.etower202607100288": "电池损坏故障（电池过放等原因导致）/",
  "alarm.name.etower202607100290": "Etower2.0 BMIC 异常/",
  "alarm.excDesc.etower202607100290": "BMIC 异常/",
  "alarm.suggestion.etower202607100290": "BMIC 异常/",
  "alarm.desc.etower202607100290": "BMIC 异常/",
  "alarm.name.etower202607100292": "Etower2.0 开机自检异常/",
  "alarm.excDesc.etower202607100292": "开机自检异常/",
  "alarm.suggestion.etower202607100292": "开机自检异常/",
  "alarm.desc.etower202607100292": "开机自检异常/",
  "alarm.name.etower202607100294": "Etower2.0 保留 1",
  "alarm.excDesc.etower202607100294": "保留",
  "alarm.suggestion.etower202607100294": "保留",
  "alarm.desc.etower202607100294": "保留",
  "alarm.name.etower202607100298": "Etower2.0 CAN 外部通信故障",
  "alarm.excDesc.etower202607100298": "CAN 外部通信故障",
  "alarm.suggestion.etower202607100298": "CAN 外部通信故障",
  "alarm.desc.etower202607100298": "CAN 外部通信故障",
  "alarm.name.etower202607100302": "Etower2.0 硬件过温",
  "alarm.excDesc.etower202607100302": "硬件过温",
  "alarm.suggestion.etower202607100302": "硬件过温",
  "alarm.desc.etower202607100302": "硬件过温",
  "alarm.name.etower202607100304": "Etower2.0 硬件放电过流",
  "alarm.excDesc.etower202607100304": "硬件放电过流",
  "alarm.suggestion.etower202607100304": "硬件放电过流",
  "alarm.desc.etower202607100304": "硬件放电过流",
  "alarm.name.etower202607100001": "Etower2.0 电池过压告警",
  "alarm.excDesc.etower202607100001": "电池过压告警",
  "alarm.suggestion.etower202607100001": "检查实际电池电压是否比电池充电截止电压高 10V。",
  "alarm.desc.etower202607100001": "电池过压告警",
  "alarm.name.etower202607100004": "Etower2.0 温度传感器异常",
  "alarm.excDesc.etower202607100004": "温度传感器异常",
  "alarm.suggestion.etower202607100004": "重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100004": "温度传感器异常",
  "alarm.name.etower202607100008": "Etower2.0 PV电压高",
  "alarm.excDesc.etower202607100008": "PV电压高",
  "alarm.suggestion.etower202607100008": "1. 检查光伏板的配置电压是否大于 580V（用万用表测量光伏端电压）。\n2. 重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100008": "PV电压高",
  "alarm.name.etower202607100013": "Etower2.0 电网电压异常",
  "alarm.excDesc.etower202607100013": "电网电压异常",
  "alarm.suggestion.etower202607100013": "电网电压异常",
  "alarm.desc.etower202607100013": "电网电压异常",
  "alarm.name.etower202607100014": "Etower2.0 电网频率异常",
  "alarm.excDesc.etower202607100014": "电网频率异常",
  "alarm.suggestion.etower202607100014": "电网频率异常",
  "alarm.desc.etower202607100014": "电网频率异常",
  "alarm.name.etower202607100020": "Etower2.0 GFCI",
  "alarm.excDesc.etower202607100020": "GFCI",
  "alarm.suggestion.etower202607100020": "1. 检查系统线缆是否有漏电流。\n2. 如果没有异常连接，但仍然经常出错，请致电服务中心。",
  "alarm.desc.etower202607100020": "GFCI",
  "alarm.name.etower202607100021": "Etower2.0 ISO",
  "alarm.excDesc.etower202607100021": "ISO",
  "alarm.suggestion.etower202607100021": "1. 检查系统线缆是否有漏电流。\n2. 如果没有异常连接，但仍然经常出错，请致电服务中心。",
  "alarm.desc.etower202607100021": "ISO",
  "alarm.name.etower202607100026": "Etower2.0 零线丢失",
  "alarm.excDesc.etower202607100026": "零线丢失",
  "alarm.suggestion.etower202607100026": "1. 检查 Grid N 电缆是否断开。\n2. 重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100026": "零线丢失",
  "alarm.name.etower202607100031": "Etower2.0 写flash异常",
  "alarm.excDesc.etower202607100031": "写flash异常",
  "alarm.suggestion.etower202607100031": "重启系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100031": "写flash异常",
  "alarm.name.etower202607100046": "Etower2.0 过温降载",
  "alarm.excDesc.etower202607100046": "过温降载",
  "alarm.suggestion.etower202607100046": "等待逆变器温度恢复正常。",
  "alarm.desc.etower202607100046": "过温降载",
  "alarm.name.etower202607100059": "Etower2.0 grid backup n lost（n-n短接）",
  "alarm.excDesc.etower202607100059": "grid backup n lost（n-n短接）",
  "alarm.suggestion.etower202607100059": "1. 安装在澳大利亚的系统需要检查 N-N 是否短路。\n2. 如果不在澳大利亚，请正确设定安全标准。\n3. 重新启动系统，如果仍然存在错误，请致电服务中心。",
  "alarm.desc.etower202607100059": "grid backup n lost（n-n短接）",
  "alarm.name.etower202607100076": "Etower2.0 Reserve 2",
  "alarm.excDesc.etower202607100076": "Reserve",
  "alarm.suggestion.etower202607100076": "Reserve",
  "alarm.desc.etower202607100076": "Reserve",
  "alarm.name.etower202607100077": "Etower2.0 Reserve 3",
  "alarm.excDesc.etower202607100077": "Reserve",
  "alarm.suggestion.etower202607100077": "Reserve",
  "alarm.desc.etower202607100077": "Reserve",
  "alarm.name.etower202607100078": "Etower2.0 Reserve 4",
  "alarm.excDesc.etower202607100078": "Reserve",
  "alarm.suggestion.etower202607100078": "Reserve",
  "alarm.desc.etower202607100078": "Reserve",
  "alarm.name.etower202607100079": "Etower2.0 Reserve 5",
  "alarm.excDesc.etower202607100079": "Reserve",
  "alarm.suggestion.etower202607100079": "Reserve",
  "alarm.desc.etower202607100079": "Reserve",
  "alarm.name.etower202607100080": "Etower2.0 Reserve 6",
  "alarm.excDesc.etower202607100080": "Reserve",
  "alarm.suggestion.etower202607100080": "Reserve",
  "alarm.desc.etower202607100080": "Reserve",
  "alarm.name.etower202607100081": "Etower2.0 Reserve 7",
  "alarm.excDesc.etower202607100081": "Reserve",
  "alarm.suggestion.etower202607100081": "Reserve",
  "alarm.desc.etower202607100081": "Reserve",
  "alarm.name.etower202607100082": "Etower2.0 Reserve 8",
  "alarm.excDesc.etower202607100082": "Reserve",
  "alarm.suggestion.etower202607100082": "Reserve",
  "alarm.desc.etower202607100082": "Reserve",
  "alarm.name.etower202607100083": "Etower2.0 Reserve 9",
  "alarm.excDesc.etower202607100083": "Reserve",
  "alarm.suggestion.etower202607100083": "Reserve",
  "alarm.desc.etower202607100083": "Reserve",
  "alarm.name.etower202607100084": "Etower2.0 Reserve 10",
  "alarm.excDesc.etower202607100084": "Reserve",
  "alarm.suggestion.etower202607100084": "Reserve",
  "alarm.desc.etower202607100084": "Reserve",
  "alarm.name.etower202607100085": "Etower2.0 Reserve 11",
  "alarm.excDesc.etower202607100085": "Reserve",
  "alarm.suggestion.etower202607100085": "Reserve",
  "alarm.desc.etower202607100085": "Reserve",
  "alarm.name.etower202607100086": "Etower2.0 Reserve 12",
  "alarm.excDesc.etower202607100086": "Reserve",
  "alarm.suggestion.etower202607100086": "Reserve",
  "alarm.desc.etower202607100086": "Reserve",
  "alarm.name.etower202607100087": "Etower2.0 Reserve 13",
  "alarm.excDesc.etower202607100087": "Reserve",
  "alarm.suggestion.etower202607100087": "Reserve",
  "alarm.desc.etower202607100087": "Reserve",
  "alarm.name.etower202607100088": "Etower2.0 Reserve 14",
  "alarm.excDesc.etower202607100088": "Reserve",
  "alarm.suggestion.etower202607100088": "Reserve",
  "alarm.desc.etower202607100088": "Reserve",
  "alarm.name.etower202607100089": "Etower2.0 Reserve 15",
  "alarm.excDesc.etower202607100089": "Reserve",
  "alarm.suggestion.etower202607100089": "Reserve",
  "alarm.desc.etower202607100089": "Reserve",
  "alarm.name.etower202607100090": "Etower2.0 Reserve 16",
  "alarm.excDesc.etower202607100090": "Reserve",
  "alarm.suggestion.etower202607100090": "Reserve",
  "alarm.desc.etower202607100090": "Reserve",
  "alarm.name.etower202607100091": "Etower2.0 Reserve 17",
  "alarm.excDesc.etower202607100091": "Reserve",
  "alarm.suggestion.etower202607100091": "Reserve",
  "alarm.desc.etower202607100091": "Reserve",
  "alarm.name.etower202607100301": "Etower2.0 硬件过压",
  "alarm.excDesc.etower202607100301": "硬件过压",
  "alarm.suggestion.etower202607100301": "硬件过压",
  "alarm.desc.etower202607100301": "硬件过压",
  "alarm.name.etower202607100303": "Etower2.0 硬件充电过流",
  "alarm.excDesc.etower202607100303": "硬件充电过流",
  "alarm.suggestion.etower202607100303": "硬件充电过流",
  "alarm.desc.etower202607100303": "硬件充电过流",
  "alarm.name.etower202607100305": "Etower2.0 PCBA 过温故障",
  "alarm.excDesc.etower202607100305": "PCBA 过温故障",
  "alarm.suggestion.etower202607100305": "PCBA 过温故障",
  "alarm.desc.etower202607100305": "PCBA 过温故障",
  "alarm.name.etower202607100092": "Etower2.0 Reserve 18",
  "alarm.excDesc.etower202607100092": "Reserve",
  "alarm.suggestion.etower202607100092": "Reserve",
  "alarm.desc.etower202607100092": "Reserve",
  "alarm.name.etower202607100094": "Etower2.0 Reserve 20",
  "alarm.excDesc.etower202607100094": "Reserve",
  "alarm.suggestion.etower202607100094": "Reserve",
  "alarm.desc.etower202607100094": "Reserve",
  "alarm.name.etower202607100096": "Etower2.0 Reserve 22",
  "alarm.excDesc.etower202607100096": "Reserve",
  "alarm.suggestion.etower202607100096": "Reserve",
  "alarm.desc.etower202607100096": "Reserve",
  "alarm.name.etower202607100098": "Etower2.0 Reserve 24",
  "alarm.excDesc.etower202607100098": "Reserve",
  "alarm.suggestion.etower202607100098": "Reserve",
  "alarm.desc.etower202607100098": "Reserve",
  "alarm.name.etower202607100100": "Etower2.0 Reserve 26",
  "alarm.excDesc.etower202607100100": "Reserve",
  "alarm.suggestion.etower202607100100": "Reserve",
  "alarm.desc.etower202607100100": "Reserve",
  "alarm.name.etower202607100102": "Etower2.0 Reserve 28",
  "alarm.excDesc.etower202607100102": "Reserve",
  "alarm.suggestion.etower202607100102": "Reserve",
  "alarm.desc.etower202607100102": "Reserve",
  "alarm.name.etower202607100104": "Etower2.0 Reserve 30",
  "alarm.excDesc.etower202607100104": "Reserve",
  "alarm.suggestion.etower202607100104": "Reserve",
  "alarm.desc.etower202607100104": "Reserve",
  "alarm.name.etower202607100106": "Etower2.0 Reserve 32",
  "alarm.excDesc.etower202607100106": "Reserve",
  "alarm.suggestion.etower202607100106": "Reserve",
  "alarm.desc.etower202607100106": "Reserve",
  "alarm.name.etower202607100108": "Etower2.0 Reserve 34",
  "alarm.excDesc.etower202607100108": "Reserve",
  "alarm.suggestion.etower202607100108": "Reserve",
  "alarm.desc.etower202607100108": "Reserve",
  "alarm.name.etower202607100110": "Etower2.0 Reserve 36",
  "alarm.excDesc.etower202607100110": "Reserve",
  "alarm.suggestion.etower202607100110": "Reserve",
  "alarm.desc.etower202607100110": "Reserve",
  "alarm.name.etower202607100112": "Etower2.0 Reserve 38",
  "alarm.excDesc.etower202607100112": "Reserve",
  "alarm.suggestion.etower202607100112": "Reserve",
  "alarm.desc.etower202607100112": "Reserve",
  "alarm.name.etower202607100114": "Etower2.0 Reserve 40",
  "alarm.excDesc.etower202607100114": "Reserve",
  "alarm.suggestion.etower202607100114": "Reserve",
  "alarm.desc.etower202607100114": "Reserve",
  "alarm.name.etower202607100116": "Etower2.0 Reserve 42",
  "alarm.excDesc.etower202607100116": "Reserve",
  "alarm.suggestion.etower202607100116": "Reserve",
  "alarm.desc.etower202607100116": "Reserve",
  "alarm.name.etower202607100118": "Etower2.0 Reserve 44",
  "alarm.excDesc.etower202607100118": "Reserve",
  "alarm.suggestion.etower202607100118": "Reserve",
  "alarm.desc.etower202607100118": "Reserve",
  "alarm.name.etower202607100120": "Etower2.0 Reserve 46",
  "alarm.excDesc.etower202607100120": "Reserve",
  "alarm.suggestion.etower202607100120": "Reserve",
  "alarm.desc.etower202607100120": "Reserve",
  "alarm.name.etower202607100122": "Etower2.0 Reserve 48",
  "alarm.excDesc.etower202607100122": "Reserve",
  "alarm.suggestion.etower202607100122": "Reserve",
  "alarm.desc.etower202607100122": "Reserve",
  "alarm.name.etower202607100124": "Etower2.0 Reserve 50",
  "alarm.excDesc.etower202607100124": "Reserve",
  "alarm.suggestion.etower202607100124": "Reserve",
  "alarm.desc.etower202607100124": "Reserve",
  "alarm.name.etower202607100126": "Etower2.0 Reserve 52",
  "alarm.excDesc.etower202607100126": "Reserve",
  "alarm.suggestion.etower202607100126": "Reserve",
  "alarm.desc.etower202607100126": "Reserve",
  "alarm.name.etower202607100128": "Etower2.0 Reserve 54",
  "alarm.excDesc.etower202607100128": "Reserve",
  "alarm.suggestion.etower202607100128": "Reserve",
  "alarm.desc.etower202607100128": "Reserve",
  "alarm.name.etower202607100134": "Etower2.0 总线1过压保护",
  "alarm.excDesc.etower202607100134": "总线1过压保护",
  "alarm.suggestion.etower202607100134": "总线1过压保护",
  "alarm.desc.etower202607100134": "总线1过压保护",
  "alarm.name.etower202607100136": "Etower2.0 绝缘故障 1",
  "alarm.excDesc.etower202607100136": "绝缘故障",
  "alarm.suggestion.etower202607100136": "1. 检查光伏电缆连接是否可靠。\n2. 检查光伏电缆是否损坏。",
  "alarm.desc.etower202607100136": "绝缘故障",
  "alarm.name.etower202607100142": "Etower2.0 光伏组件极性反接 2",
  "alarm.excDesc.etower202607100142": "光伏组件极性反接",
  "alarm.suggestion.etower202607100142": "光伏组件极性反接",
  "alarm.desc.etower202607100142": "光伏组件极性反接",
  "alarm.name.etower202607100144": "Etower2.0 显示器通道故障",
  "alarm.excDesc.etower202607100144": "显示器通道故障",
  "alarm.suggestion.etower202607100144": "显示器通道故障",
  "alarm.desc.etower202607100144": "显示器通道故障",
  "alarm.name.etower202607100152": "Etower2.0 mppt2硬件过流保护 2",
  "alarm.excDesc.etower202607100152": "mppt2硬件过流保护",
  "alarm.suggestion.etower202607100152": "mppt2硬件过流保护",
  "alarm.desc.etower202607100152": "mppt2硬件过流保护",
  "alarm.name.etower202607100184": "Etower2.0 直流总线2电压不平衡",
  "alarm.excDesc.etower202607100184": "直流总线2电压不平衡",
  "alarm.suggestion.etower202607100184": "直流总线2电压不平衡",
  "alarm.desc.etower202607100184": "直流总线2电压不平衡",
  "alarm.name.etower202607100198": "Etower2.0 接地故障",
  "alarm.excDesc.etower202607100198": "接地故障",
  "alarm.suggestion.etower202607100198": "接地故障",
  "alarm.desc.etower202607100198": "接地故障",
  "alarm.name.etower202607100228": "Etower2.0 旁路继电器故障",
  "alarm.excDesc.etower202607100228": "旁路继电器故障",
  "alarm.suggestion.etower202607100228": "旁路继电器故障",
  "alarm.desc.etower202607100228": "旁路继电器故障",
  "alarm.name.etower202607100296": "Etower2.0 保留 3",
  "alarm.excDesc.etower202607100296": "保留",
  "alarm.suggestion.etower202607100296": "保留",
  "alarm.desc.etower202607100296": "保留",
  "alarm.name.etower202607100300": "Etower2.0 预充故障",
  "alarm.excDesc.etower202607100300": "预充故障",
  "alarm.suggestion.etower202607100300": "预充故障",
  "alarm.desc.etower202607100300": "预充故障",
  "alarm.name.etower202607100093": "Etower2.0 Reserve 19",
  "alarm.excDesc.etower202607100093": "Reserve",
  "alarm.suggestion.etower202607100093": "Reserve",
  "alarm.desc.etower202607100093": "Reserve",
  "alarm.name.etower202607100095": "Etower2.0 Reserve 21",
  "alarm.excDesc.etower202607100095": "Reserve",
  "alarm.suggestion.etower202607100095": "Reserve",
  "alarm.desc.etower202607100095": "Reserve",
  "alarm.name.etower202607100097": "Etower2.0 Reserve 23",
  "alarm.excDesc.etower202607100097": "Reserve",
  "alarm.suggestion.etower202607100097": "Reserve",
  "alarm.desc.etower202607100097": "Reserve",
  "alarm.name.etower202607100099": "Etower2.0 Reserve 25",
  "alarm.excDesc.etower202607100099": "Reserve",
  "alarm.suggestion.etower202607100099": "Reserve",
  "alarm.desc.etower202607100099": "Reserve",
  "alarm.name.etower202607100101": "Etower2.0 Reserve 27",
  "alarm.excDesc.etower202607100101": "Reserve",
  "alarm.suggestion.etower202607100101": "Reserve",
  "alarm.desc.etower202607100101": "Reserve",
  "alarm.name.etower202607100103": "Etower2.0 Reserve 29",
  "alarm.excDesc.etower202607100103": "Reserve",
  "alarm.suggestion.etower202607100103": "Reserve",
  "alarm.desc.etower202607100103": "Reserve",
  "alarm.name.etower202607100105": "Etower2.0 Reserve 31",
  "alarm.excDesc.etower202607100105": "Reserve",
  "alarm.suggestion.etower202607100105": "Reserve",
  "alarm.desc.etower202607100105": "Reserve",
  "alarm.name.etower202607100107": "Etower2.0 Reserve 33",
  "alarm.excDesc.etower202607100107": "Reserve",
  "alarm.suggestion.etower202607100107": "Reserve",
  "alarm.desc.etower202607100107": "Reserve",
  "alarm.name.etower202607100109": "Etower2.0 Reserve 35",
  "alarm.excDesc.etower202607100109": "Reserve",
  "alarm.suggestion.etower202607100109": "Reserve",
  "alarm.desc.etower202607100109": "Reserve",
  "alarm.name.etower202607100111": "Etower2.0 Reserve 37",
  "alarm.excDesc.etower202607100111": "Reserve",
  "alarm.suggestion.etower202607100111": "Reserve",
  "alarm.desc.etower202607100111": "Reserve",
  "alarm.name.etower202607100113": "Etower2.0 Reserve 39",
  "alarm.excDesc.etower202607100113": "Reserve",
  "alarm.suggestion.etower202607100113": "Reserve",
  "alarm.desc.etower202607100113": "Reserve",
  "alarm.name.etower202607100115": "Etower2.0 Reserve 41",
  "alarm.excDesc.etower202607100115": "Reserve",
  "alarm.suggestion.etower202607100115": "Reserve",
  "alarm.desc.etower202607100115": "Reserve",
  "alarm.name.etower202607100117": "Etower2.0 Reserve 43",
  "alarm.excDesc.etower202607100117": "Reserve",
  "alarm.suggestion.etower202607100117": "Reserve",
  "alarm.desc.etower202607100117": "Reserve",
  "alarm.name.etower202607100119": "Etower2.0 Reserve 45",
  "alarm.excDesc.etower202607100119": "Reserve",
  "alarm.suggestion.etower202607100119": "Reserve",
  "alarm.desc.etower202607100119": "Reserve",
  "alarm.name.etower202607100121": "Etower2.0 Reserve 47",
  "alarm.excDesc.etower202607100121": "Reserve",
  "alarm.suggestion.etower202607100121": "Reserve",
  "alarm.desc.etower202607100121": "Reserve",
  "alarm.name.etower202607100123": "Etower2.0 Reserve 49",
  "alarm.excDesc.etower202607100123": "Reserve",
  "alarm.suggestion.etower202607100123": "Reserve",
  "alarm.desc.etower202607100123": "Reserve",
  "alarm.name.etower202607100125": "Etower2.0 Reserve 51",
  "alarm.excDesc.etower202607100125": "Reserve",
  "alarm.suggestion.etower202607100125": "Reserve",
  "alarm.desc.etower202607100125": "Reserve",
  "alarm.name.etower202607100127": "Etower2.0 Reserve 53",
  "alarm.excDesc.etower202607100127": "Reserve",
  "alarm.suggestion.etower202607100127": "Reserve",
  "alarm.desc.etower202607100127": "Reserve",
  "alarm.name.etower202607100131": "Etower2.0 电网过频保护",
  "alarm.excDesc.etower202607100131": "电网过频保护",
  "alarm.suggestion.etower202607100131": "电网过频保护",
  "alarm.desc.etower202607100131": "电网过频保护",
  "alarm.name.etower202607100151": "Etower2.0 mppt2过压保护 2",
  "alarm.excDesc.etower202607100151": "mppt2过压保护",
  "alarm.suggestion.etower202607100151": "mppt2过压保护",
  "alarm.desc.etower202607100151": "mppt2过压保护",
  "alarm.name.etower202607100167": "Etower2.0 直流输出过流",
  "alarm.excDesc.etower202607100167": "直流输出过流",
  "alarm.suggestion.etower202607100167": "直流输出过流",
  "alarm.desc.etower202607100167": "直流输出过流",
  "alarm.name.etower202607100177": "Etower2.0 电网不平衡",
  "alarm.excDesc.etower202607100177": "电网不平衡",
  "alarm.suggestion.etower202607100177": "电网不平衡",
  "alarm.desc.etower202607100177": "电网不平衡",
  "alarm.name.etower202607100201": "Etower2.0 内部风扇故障",
  "alarm.excDesc.etower202607100201": "内部风扇故障",
  "alarm.suggestion.etower202607100201": "内部风扇故障",
  "alarm.desc.etower202607100201": "内部风扇故障",
  "alarm.name.etower202607100209": "Etower2.0 外部风扇故障",
  "alarm.excDesc.etower202607100209": "外部风扇故障",
  "alarm.suggestion.etower202607100209": "外部风扇故障",
  "alarm.desc.etower202607100209": "外部风扇故障",
  "alarm.name.etower202607100235": "Etower2.0 中线反接或丢失",
  "alarm.excDesc.etower202607100235": "中线反接或丢失",
  "alarm.suggestion.etower202607100235": "中线反接或丢失",
  "alarm.desc.etower202607100235": "中线反接或丢失",
  "alarm.name.etower202607100239": "Etower2.0 BOOST 线路异常(直流软起异常)",
  "alarm.excDesc.etower202607100239": "BOOST 线路异常(直流软起异常)",
  "alarm.suggestion.etower202607100239": "BOOST 线路异常(直流软起异常)",
  "alarm.desc.etower202607100239": "BOOST 线路异常(直流软起异常)",
  "alarm.name.etower202607100293": "Etower2.0 安全功能异常/",
  "alarm.excDesc.etower202607100293": "安全功能异常/",
  "alarm.suggestion.etower202607100293": "安全功能异常/",
  "alarm.desc.etower202607100293": "安全功能异常/",
  "alarm.name.etower202607100295": "Etower2.0 保留 2",
  "alarm.excDesc.etower202607100295": "保留",
  "alarm.suggestion.etower202607100295": "保留",
  "alarm.desc.etower202607100295": "保留",
  "alarm.name.etower202607100297": "Etower2.0 保留 4",
  "alarm.excDesc.etower202607100297": "保留",
  "alarm.suggestion.etower202607100297": "保留",
  "alarm.desc.etower202607100297": "保留",
  "alarm.name.etower202607100299": "Etower2.0 绝缘故障 2",
  "alarm.excDesc.etower202607100299": "绝缘故障",
  "alarm.suggestion.etower202607100299": "绝缘故障",
  "alarm.desc.etower202607100299": "绝缘故障",
  "alarm.name.2075507186554019840": "jxtest",
  "50003.real_time.bw_RTparam_name_BatterySOC": "电池SOC",
  "50003.real_time.bw_RTparam_name_TheSystemTotalPVEnergy": "设备总发电量\n设备总发电量(含光伏电表数据)",
  "50003.real_time.bw_RTparam_name_BatteryType": "电池类型",
  "50003.real_time.bw_RTparam_name_BatWarningPack": "电池具体报错位置",
  "50003.real_time.bw_RTparam_name_BmsChargeTotalEnergy": "BMS充电输入总电量",
  "50003.real_time.bw_RTparam_name_BmsDischargeTotalEnergy": "BMS放电输入总电量",
  "50003.real_time.bw_RTparam_name_DeviceTotalRuntime": "设备总运行时间",
  "50003.real_time.bw_RTparam_name_BatBuckBoostTemperature": "电池模块温度",
  "50003.real_time.bw_RTparam_name_BusVoltage": "母线电压",
  "50003.real_time.bw_RTparam_name_BatteryFrontVoltage": "电池前电压（端口电压）",
  "50003.real_time.bw_RTparam_name_BuckBoost1Current": "电池前电流",
  "50003.real_time.bw_RTparam_name_BatteryBackVoltage": "电池后电压（预充继电器之后的电压）",
  "50003.real_time.bw_RTparam_name_BuckBoost2Current": "电池后电流",
  "50003.real_time.bw_RTparam_name_TotalBatCurrent": "电池总电流",
  "50003.real_time.bw_RTparam_name_BmsPowerRegister": "BMS功率寄存器",
  "50003.real_time.bw_RTparam_name_GridVoltageR": "电网R相电压",
  "50003.real_time.bw_RTparam_name_GridVoltageS": "电网S相电压",
  "50003.real_time.bw_RTparam_name_GridVoltageT": "电网T相电压",
  "50003.real_time.bw_RTparam_name_SystemFault": "系统故障",
  "50003.real_time.bw_RTparam_name_NetworkType": "联网类型",
  "50003.real_time.bw_RTparam_name_BbVersion": "BB版本号",
  "50003.ctrl_bw_param_group_SpecialSetting.ctrlAfciEnable": "AFCI使能",
  "50003.ctrl_bw_param_group_SpecialSetting.ctrlAfciFaultEnable": "AFCI报错使能",
  "50003.real_time.inverterTemp": "逆变器温度",
  "50003.warning.batteryOvervoltageAlarm": "电池过压告警",
  "50003.warning.batteryUndervoltageAlarm": "电池欠压告警",
  "50003.warning.overloadAlarm": "过载告警",
  "50003.warning.abnormalTemperatureSensor": "温度传感器异常",
  "50003.warning.dcPowerAlarm": "直流功率告警",
  "50003.warning.batteryStopRunningAlarm": "电池停止运行告警",
  "50003.warning.overTemperatureAlarm": "过温告警",
  "50003.warning.pvVoltageHigh": "PV电压高",
  "50003.warning.batteryOpenCircuit": "电池开路",
  "50003.warning.reverseBatteryConnection": "电池反接",
  "50003.warning.busOvervoltage": "bus过压",
  "50003.warning.gridDisconnect": "电网丢失",
  "50003.warning.abnormalGridVoltage": "电网电压异常",
  "50003.warning.abnormalGridFrequency": "电网频率异常",
  "50003.warning.n10MinutesOfAbnormalGridVoltage": "10分钟电网电压异常",
  "50003.warning.gridVoltInstOver": "grid volt inst over",
  "50003.warning.groundingLost": "地线丢失",
  "50003.warning.nLReverseConnection": "零火反接",
  "50003.warning.lowTemperatureWarning": "低温警告",
  "50003.warning.gfci": "GFCI",
  "50003.warning.iso": "ISO",
  "50003.warning.dci": "DCI",
  "50003.warning.dcv": "DCV",
  "50003.warning.islandWarning": "孤岛警告",
  "50003.warning.fanMalfunction": "风扇异常",
  "50003.warning.nLineLost": "零线丢失",
  "50003.warning.abnormalSciCommunication": "SCI通讯异常",
  "50003.warning.abnormalCanCommunication": "CAN通讯异常",
  "50003.warning.flashidException": "flashid异常",
  "50003.warning.flashReadingException": "读flash异常",
  "50003.warning.writeFlashException": "写flash异常",
  "50003.warning.abnormalDeviceType": "设备类型异常",
  "50003.warning.lowInverterVoltage": "逆变电压低",
  "50003.warning.softwareInverterOvercurrent": "软件逆变过流",
  "50003.warning.hardwareInverterOvercurrent": "硬件逆变过流",
  "50003.warning.boostSoftwareInverterOvercurrent": "bst软件逆变过流",
  "50003.warning.boostHardwareInverterOvercurrent": "bst硬件逆变过流",
  "50003.warning.buckBoostSoftwareInverterOvercurrent": "buckbst软件逆变过流",
  "50003.warning.buckBoostHardwareInverterOvercurrent": "buckbst硬件逆变过流",
  "50003.warning.busTooLow": "bus过低",
  "50003.warning.noPvInput": "无pv输入",
  "50003.warning.inputPowerConstraint": "输入功率限制",
  "50003.warning.outputPowerLimit": "输出功率限制",
  "50003.warning.overFrequencyLoadShedding": "过频降载",
  "50003.warning.overvoltageAndLoadReduction": "过压降载",
  "50003.warning.overTemperatureAndLoadReduction": "过温降载",
  "50003.warning.highVoltageRideThrough": "高电压穿越",
  "50003.warning.lowVoltageRideThrough": "低电压穿越",
  "50003.warning.thermistorAbnormality": "热敏电阻异常",
  "50003.warning.abnormalWaveformOfUrbanRadioWaves": "市电波形异常",
  "50003.warning.offGridCapacitorAttenuation": "离网电容衰减",
  "50003.warning.parallelWarning": "并机警告",
  "50003.warning.parallelIdError": "并机ID错误",
  "50003.warning.averageOverload": "平均过载",
  "50003.warning.duplicateParallelId": "并机ID重复",
  "50003.warning.newMachineCannotBeAdded": "新机无法加入",
  "50003.warning.unevenOutputCurrent": "输出不均流",
  "50003.warning.inconsistentInput": "输入不一致",
  "50003.warning.gridBackupNLossNNShortCircuit": "grid backup n lost（n-n短接）",
  "50003.warning.abnormalBatteryQuantity": "电池数量异常",
  "50003.warning.reserved055eBit12": "预留 0x055E bit12",
  "50003.warning.reserved055eBit13": "预留 0x055E bit13",
  "50003.warning.reserved055eBit14": "预留 0x055E bit14",
  "50003.warning.reserved055eBit15": "预留 0x055E bit15",
  "50003.warning.reserved0583Bit0": "预留 0x0583 bit0",
  "50003.warning.reserved0583Bit1": "预留 0x0583 bit1",
  "50003.warning.reserved0583Bit2": "预留 0x0583 bit2",
  "50003.warning.reserved0583Bit3": "预留 0x0583 bit3",
  "50003.warning.reserved0583Bit4": "预留 0x0583 bit4",
  "50003.warning.reserved0583Bit5": "预留 0x0583 bit5",
  "50003.warning.reserved0583Bit6": "预留 0x0583 bit6",
  "50003.warning.reserved0583Bit7": "预留 0x0583 bit7",
  "50003.warning.reserved0583Bit8": "预留 0x0583 bit8",
  "50003.warning.reserved0583Bit9": "预留 0x0583 bit9",
  "50003.warning.reserved0583Bit10": "预留 0x0583 bit10",
  "50003.warning.reserved0583Bit11": "预留 0x0583 bit11",
  "50003.warning.reserved0583Bit12": "预留 0x0583 bit12",
  "50003.warning.reserved0583Bit13": "预留 0x0583 bit13",
  "50003.warning.reserved0583Bit14": "预留 0x0583 bit14",
  "50003.warning.reserved0583Bit15": "预留 0x0583 bit15",
  "50003.warning.reserved0582Bit0": "预留 0x0582 bit0",
  "50003.warning.reserved0582Bit1": "预留 0x0582 bit1",
  "50003.warning.reserved0582Bit2": "预留 0x0582 bit2",
  "50003.warning.reserved0582Bit3": "预留 0x0582 bit3",
  "50003.warning.reserved0582Bit4": "预留 0x0582 bit4",
  "50003.warning.reserved0582Bit5": "预留 0x0582 bit5",
  "50003.warning.reserved0582Bit6": "预留 0x0582 bit6",
  "50003.warning.reserved0582Bit7": "预留 0x0582 bit7",
  "50003.warning.reserved0582Bit8": "预留 0x0582 bit8",
  "50003.warning.reserved0582Bit9": "预留 0x0582 bit9",
  "50003.warning.reserved0582Bit10": "预留 0x0582 bit10",
  "50003.warning.reserved0582Bit11": "预留 0x0582 bit11",
  "50003.warning.reserved0582Bit12": "预留 0x0582 bit12",
  "50003.warning.reserved0582Bit13": "预留 0x0582 bit13",
  "50003.warning.reserved0582Bit14": "预留 0x0582 bit14",
  "50003.warning.reserved0582Bit15": "预留 0x0582 bit15",
  "50003.warning.reserved0581Bit0": "预留 0x0581 bit0",
  "50003.warning.reserved0581Bit1": "预留 0x0581 bit1",
  "50003.warning.reserved0581Bit2": "预留 0x0581 bit2",
  "50003.warning.reserved0581Bit3": "预留 0x0581 bit3",
  "50003.warning.reserved0581Bit4": "预留 0x0581 bit4",
  "50003.warning.reserved0581Bit5": "预留 0x0581 bit5",
  "50003.warning.reserved0581Bit6": "预留 0x0581 bit6",
  "50003.warning.reserved0581Bit7": "预留 0x0581 bit7",
  "50003.warning.reserved0581Bit8": "预留 0x0581 bit8",
  "50003.warning.reserved0581Bit9": "预留 0x0581 bit9",
  "50003.warning.reserved0581Bit10": "预留 0x0581 bit10",
  "50003.warning.reserved0581Bit11": "预留 0x0581 bit11",
  "50003.warning.reserved0581Bit12": "预留 0x0581 bit12",
  "50003.warning.reserved0581Bit13": "预留 0x0581 bit13",
  "50003.warning.reserved0581Bit14": "预留 0x0581 bit14",
  "50003.warning.reserved0581Bit15": "预留 0x0581 bit15",
  "50003.warning.reserved0580Bit0": "预留 0x0580 bit0",
  "50003.warning.reserved0580Bit1": "预留 0x0580 bit1",
  "50003.warning.reserved0580Bit2": "预留 0x0580 bit2",
  "50003.warning.reserved0580Bit3": "预留 0x0580 bit3",
  "50003.warning.reserved0580Bit4": "预留 0x0580 bit4",
  "50003.warning.reserved0580Bit5": "预留 0x0580 bit5",
  "50003.warning.reserved0580Bit6": "预留 0x0580 bit6",
  "50003.warning.reserved0580Bit7": "预留 0x0580 bit7",
  "50003.warning.reserved0580Bit8": "预留 0x0580 bit8",
  "50003.warning.reserved0580Bit9": "预留 0x0580 bit9",
  "50003.warning.reserved0580Bit10": "预留 0x0580 bit10",
  "50003.warning.reserved0580Bit11": "预留 0x0580 bit11",
  "50003.warning.reserved0580Bit12": "预留 0x0580 bit12",
  "50003.warning.reserved0580Bit13": "预留 0x0580 bit13",
  "50003.warning.reserved0580Bit14": "预留 0x0580 bit14",
  "50003.warning.reserved0580Bit15": "预留 0x0580 bit15",
  "50003.fault.gridOvervoltageProtection": "电网过压保护",
  "50003.fault.gridUndervoltageProtection": "电网欠压保护",
  "50003.fault.gridOverfrequencyProtection": "电网过频保护",
  "50003.fault.gridUnderfrequencyProtection": "电网欠频保护",
  "50003.fault.phaseLockedFault": "相位锁定故障",
  "50003.fault.bus1OvervoltageProtection": "总线1过压保护",
  "50003.fault.bus2OvervoltageProtection": "总线2过压保护",
  "50003.fault.insulationFault": "绝缘故障",
  "50003.fault.gcfiFault": "接地故障断路器故障",
  "50003.fault.gfciTestFault": "gfci测试故障",
  "50003.fault.gfciRelayFault": "gfci继电器故障",
  "50003.fault.overtemperature": "过温",
  "50003.fault.pvModulesReverseBit12": "光伏组件极性反接",
  "50003.fault.pvModulesReverseBit13": "光伏组件极性反接",
  "50003.fault.masterSlaveCommunicationFault": "主从通信故障",
  "50003.fault.displayChannelsFault": "显示器通道故障",
  "50003.fault.chip1UpgradeFault": "芯片1升级失败",
  "50003.fault.mppt1OvervoltageProtection": "mppt1过压保护",
  "50003.fault.mppt1SoftwareOvercurrentProtection": "mppt1软件过流保护",
  "50003.fault.mppt2HardwareOvercurrentProtectionBit3": "mppt2硬件过流保护",
  "50003.fault.mppt1OverTemperatureProtection": "mppt1过温保护",
  "50003.fault.mppt2OvervoltageProtectionBit5": "mppt2过压保护",
  "50003.fault.mppt2OvervoltageProtectionBit6": "mppt2过压保护",
  "50003.fault.mppt2HardwareOvercurrentProtectionBit7": "mppt2硬件过流保护",
  "50003.fault.mppt2OverTemperatureProtection": "mppt2过温保护",
  "50003.fault.batOvervoltageProtection": "bat过压保护",
  "50003.fault.batUndervoltageProtection": "bat欠压保护",
  "50003.fault.batLost": "电池缺失",
  "50003.fault.batOverTemperatureProtection": "电池过温保护",
  "50003.fault.bat1ChargingOvercurrentProtection": "bat1充电过流保护",
  "50003.fault.bat1DischargeOvercurrentProtection": "bat1放电过流保护",
  "50003.fault.bat2ChargingOvercurrentProtection": "bat2充电过流保护",
  "50003.fault.bat2DischargeOvercurrentProtection": "bat2放电过流保护",
  "50003.fault.bat1HardwareOvercurrentProtection": "bat1硬件过流保护",
  "50003.fault.bat2HardwareOvercurrentProtection": "bat2硬件过流保护",
  "50003.fault.inverterOverTemperatureProtection": "逆变过温保护",
  "50003.fault.inverterOvervoltageProtection": "逆变过压保护",
  "50003.fault.inverterUndervoltageProtection": "逆变欠压保护",
  "50003.fault.dcOutputOvercurrent": "直流输出过流",
  "50003.fault.inverterOvercurrentProtection": "逆变过流保护",
  "50003.fault.inverterHardwareOvercurrentProtection": "逆变硬件过流保护",
  "50003.fault.dcOutputOvervoltage": "直流输出过压",
  "50003.fault.outputShortCircuit": "输出短路",
  "50003.fault.outputOverload": "输出过载",
  "50003.fault.apuUndervoltageProtection": "APU欠压保护",
  "50003.fault.batRelayFault": "电池继电器故障",
  "50003.fault.dcInputDisturbance": "直流输入扰动",
  "50003.fault.gridDisturbance": "电网扰动",
  "50003.fault.gridUnbalance": "电网不平衡",
  "50003.fault.frequencyJitter": "频率抖动",
  "50003.fault.gridOvercurrent": "电网过电流",
  "50003.fault.gridCurrentTrackFault": "电网电流通路故障",
  "50003.fault.backupOvervoltageProtection": "负载过压保护",
  "50003.fault.dcBusVoltageUnbalance": "直流总线电压不平衡",
  "50003.fault.dcBusLowVoltage": "直流总线低压",
  "50003.fault.dcBus2VoltageUnbalance": "直流总线2电压不平衡",
  "50003.fault.igbtOvercurrent": "IGBT过流",
  "50003.fault.gridDisturbance2": "电网扰动2",
  "50003.fault.afciCheckProtection": "afci检查保护",
  "50003.real_time.batterySoc": "电池SOC",
  "50003.real_time.bw_RTparam_name_TotalactivePower_PV": "电表有功功率（总）",
  "50003.fault.abnormalGridCurrentSampling": "电网电流采样异常",
  "50003.fault.dspCheck": "DSP自检",
  "50003.fault.gridShortTimeOverCurrent": "电网瞬时过流",
  "50003.fault.batteryOvervoltageHardwareFault": "电池过压硬件故障",
  "50003.fault.neutralGroundFault": "零线接地故障",
  "50003.fault.acCurrentTransformerCheckFault": "交流电流互感器检测失败",
  "50003.fault.dciConsistencyFailure": "DCI一致性故障",
  "50003.fault.groundFaultCircuitBreakerConsistencyFault": "接地故障断路器一致性故障",
  "50003.fault.failureOfRelayEquipment": "继电器设备故障",
  "50003.fault.acCurrentTransformerFault": "交流电流互感器故障",
  "50003.fault.groundFault": "接地故障",
  "50003.fault.phaseError": "相位错误",
  "50003.fault.phaseMiss": "相位缺失",
  "50003.fault.internalFanFailure": "内部风扇故障",
  "50003.fault.acFrequencyConsistencyFault": "交流频率一致性错误",
  "50003.fault.acVoltageConsistencyFault": "交流电压一致性错误",
  "50003.fault.phaseAngleFault": "相位角错误",
  "50003.fault.dspCommunicationFault": "DSP通讯错误",
  "50003.fault.eepromWriteFault": "寄存器写入错误",
  "50003.fault.acVoltageFault": "交流电压故障",
  "50003.fault.acFrequencyFault": "交流频率故障",
  "50003.fault.externalFanFault": "外部风扇故障",
  "50003.fault.acfiDeviceFault": "防拉弧设备故障",
  "50003.fault.busSoftStartTimeout": "bus软起超时",
  "50003.fault.busShortCircuit": "bus短路",
  "50003.fault.inverterSoftStartTimeout": "逆变软起超时",
  "50003.fault.backupGridReverseConnect": "backup、grid反接",
  "50003.fault.firelineAndGroundReverseConnect": "火线、地线反接",
  "50003.fault.emsSerialPortCommunicationError": "ems串口通讯错误",
  "50003.fault.emsCanCommunicationError": "emsCAN通讯错误",
  "50003.fault.n12vAuxiliaryPowerSupplyError": "12V辅助电源参考错误",
  "50003.fault.n15vPowerError": "1.5V电源错误",
  "50003.fault.n05vPowerError": "0.5V电源错误",
  "50003.fault.thermistorLost": "热敏电阻丢失",
  "50003.fault.inverterHctFault": "逆变hct错误",
  "50003.fault.loadCtFault": "负载CT故障",
  "50003.fault.pv1CtFault": "PV1CT故障",
  "50003.fault.pv2CtFault": "PV2CT故障",
  "50003.fault.bat1CtFault": "bat1CT故障",
  "50003.fault.bat2CtFault": "bat2CT故障",
  "50003.fault.bypassRelayFault": "旁路继电器故障",
  "50003.fault.loadSwitchFault": "负载开关故障",
  "50003.fault.neutralLineToGroundLightningProtection": "零线对地防雷保护",
  "50003.fault.dcCurrentComponentError": "直流电流分量错误",
  "50003.fault.timerFault": "定时器故障",
  "50003.fault.inverterIncorrect": "逆变开环错误",
  "50003.fault.softwareConsistencyError": "软件一致性错误",
  "50003.fault.midlineReverseOrMiss": "中线反接或丢失",
  "50003.fault.initializFault": "初始化故障",
  "50003.fault.abnormalInverterLine": "逆变器线路异常",
  "50003.fault.abnormalBoostLineAbnormalDcSoftStart": "BOOST 线路异常(直流软起异常)",
  "50003.fault.dataStorageFault": "数据存储故障",
  "50003.fault.canParallelCommunicationError": "并行通讯错误",
  "50003.fault.systemSignalParallelError": "并行系统信号错误",
  "50003.fault.parallelSoftwareVersionInconsistent": "并机软件版本不一致",
  "50003.fault.moduleModeError": "模块模式错误",
  "50003.fault.negativeWorkFault": "负功故障",
  "50003.fault.parallelMultiHostError": "并机多主机错误",
  "50003.fault.abnormalStartup": "开机异常",
  "50003.fault.hardwareVersionInconsistent": "硬件版本不一致",
  "50003.fault.busUnbalance": "总线不平衡",
  "50003.fault.inverterOutputLineShortCircuit": "逆变器输出线路短路",
  "50003.fault.inverterCurrentLimitProtection": "逆变器限流保护",
  "50003.fault.rectifierBridgeMidpointOvercurrentProtection": "整流桥中点过流保护",
  "50003.fault.boostCircuitSoftwareOvercurrentProtection": "升压电路软件过流保护",
  "50003.fault.bdcPreChargeFailure": "BDC提前充电故障",
  "50003.fault.bdcSelfTestFault": "BDC自检故障",
  "50003.fault.groundWireFault": "地线故障",
  "50003.fault.reserved011cBit0": "预留 0x011C bit0",
  "50003.fault.reserved011cBit1": "预留 0x011C bit1",
  "50003.fault.reserved011cBit2": "预留 0x011C bit2",
  "50003.fault.reserved011cBit3": "预留 0x011C bit3",
  "50003.fault.reserved011cBit4": "预留 0x011C bit4",
  "50003.fault.reserved011cBit5": "预留 0x011C bit5",
  "50003.fault.reserved011cBit6": "预留 0x011C bit6",
  "50003.fault.reserved011cBit7": "预留 0x011C bit7",
  "50003.fault.reserved011cBit8": "预留 0x011C bit8",
  "50003.fault.reserved011cBit9": "预留 0x011C bit9",
  "50003.fault.reserved011cBit10": "预留 0x011C bit10",
  "50003.fault.reserved011cBit11": "预留 0x011C bit11",
  "50003.fault.reserved011cBit12": "预留 0x011C bit12",
  "50003.fault.reserved011dBit0": "预留 0x011D bit0",
  "50003.fault.reserved011dBit1": "预留 0x011D bit1",
  "50003.fault.reserved011dBit2": "预留 0x011D bit2",
  "50003.fault.reserved011dBit3": "预留 0x011D bit3",
  "50003.fault.reserved011dBit4": "预留 0x011D bit4",
  "50003.fault.reserved011dBit5": "预留 0x011D bit5",
  "50003.fault.reserved011dBit6": "预留 0x011D bit6",
  "50003.fault.reserved011dBit7": "预留 0x011D bit7",
  "50003.fault.reserved011dBit8": "预留 0x011D bit8",
  "50003.fault.reserved011dBit9": "预留 0x011D bit9",
  "50003.fault.reserved011dBit10": "预留 0x011D bit10",
  "50003.fault.reserved011dBit11": "预留 0x011D bit11",
  "50003.fault.reserved011fBit0": "预留 0x011F bit0",
  "50003.fault.reserved011fBit1": "预留 0x011F bit1",
  "50003.fault.reserved011fBit2": "预留 0x011F bit2",
  "50003.fault.reserved011fBit3": "预留 0x011F bit3",
  "50003.fault.reserved011fBit4": "预留 0x011F bit4",
  "50003.fault.reserved011fBit5": "预留 0x011F bit5",
  "50003.fault.reserved011fBit6": "预留 0x011F bit6",
  "50003.fault.reserved011fBit7": "预留 0x011F bit7",
  "50003.fault.reserved011fBit8": "预留 0x011F bit8",
  "50003.fault.reserved011fBit9": "预留 0x011F bit9",
  "50003.fault.reserved011fBit10": "预留 0x011F bit10",
  "50003.fault.reserved011fBit11": "预留 0x011F bit11",
  "50003.fault.reserved011fBit12": "预留 0x011F bit12",
  "50003.fault.reserved011fBit13": "预留 0x011F bit13",
  "50003.fault.reserved011fBit14": "预留 0x011F bit14",
  "50003.fault.reserved011fBit15": "预留 0x011F bit15",
  "50003.fault.reserved011eBit0": "预留 0x011E bit0",
  "50003.fault.reserved011eBit1": "预留 0x011E bit1",
  "50003.fault.reserved011eBit2": "预留 0x011E bit2",
  "50003.fault.reserved011eBit3": "预留 0x011E bit3",
  "50003.fault.reserved011eBit4": "预留 0x011E bit4",
  "50003.fault.reserved011eBit5": "预留 0x011E bit5",
  "50003.fault.reserved011eBit6": "预留 0x011E bit6",
  "50003.fault.reserved011eBit7": "预留 0x011E bit7",
  "50003.ctrl_bw_param_group_SystemConfig.ctrlSystemMode.0": "自发自用",
  "50003.ctrl_bw_param_group_SystemConfig.ctrlSystemMode.1": "TOU",
  "50003.ctrl_bw_param_group_SystemConfig.ctrlSystemMode.2.0": "TOU",
  "50003.ctrl_bw_param_group_WorkMode.workMode.0": "自发自用",
  "50003.ctrl_bw_param_group_WorkMode.workMode.1": "TOU",
  "50003.ctrl_bw_param_group_WorkMode.workMode.2": "TOU",
  "50003.ctrl_bw_param_group_WorkMode.workMode.3": "TOU",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.22": "PEA",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.23": "MEA",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.24": "BISI",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.25": "JET-GR Series",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.26": "NA",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.27": "NA",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.28": "50Hz Default",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.29": "60Hz Default",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.30": "WAREHOUSE",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.31": "AS4777.2-NZ",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.10": "NRS097-2-1",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.32": "Korea",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.11": "EN50549-GR",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.33": "G98/G99-IE",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.12": "UTE_C15_712",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.34": "NCRfg",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.13": "IEC61727",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.35": "UL1741",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.14": "G59_3",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.36": "UL1741-Rule21",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.15": "RD1699",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.37": "UL1741-Hawaiian",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.16": "G99",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.38": "EN50549",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.17": "NA",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.18": "VDE0126-60Hz",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.19": "AS4777.2-SA",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.0": "VDE0126-50Hz",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.1": "VDE4105/11.18",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.2": "AS4777.2",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.3": "G83_2",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.4": "C10/C11",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.5": "TOR Erzeuger",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.6": "EN50549-NL",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.7": "EN50549-DK",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.8": "CEB",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.9": "CEI-021",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.20": "G98",
  "50003.ctrl_bw_param_group_GridSafetyConfig.ctrlGridRegulation.21": "EN50549-CZ",
  "50003.real_time.batterySoc.desc": "int类型电池SOC的说明。小端交换字序,数据类型可以为空。",
  "isShowService.show": "show",
  "faultType.all": "全部",
  "faultType.happen": "发生中",
  "faultType.restored": "已恢复",
  "transfer.operation.success": "成功",
  "transfer.operation.fail": "失败",
  "transfer.operation.unbind": "解绑",
  "transfer.operation.withdraw": "撤回",
  "login.passLength": "密码长度必须在 8 到 20 位之间",
  "login.passType": "密码必须包含数字、大写字母、小写字母和英文符号中的至少三种",
  "login.correctEmail": "请输入正确的邮箱地址",
  "unc.65323.runStatus": "运行状态",
  "unc.65323.faultStatus1": "故障状态1",
  "unc.65323.faultStatus2": "故障状态2",
  "unc.65323.warningStatus": "告警状态",
  "unc.65323.relayStatus": "继电器状态",
  "unc.65323.inverterTemperature": "逆变器温度(℃)",
  "unc.65323.dcTemperature": "DC温度(℃)",
  "unc.65323.drmStatus": "DRM状态",
  "unc.65323.mpptTemperature": "MPPT温度(℃)",
  "unc.65323.gridVoltageAB": "电网电压AB",
  "unc.65323.gridVoltageBC": "电网电压BC",
  "unc.65323.gridVoltageCA": "电网电压CA",
  "unc.65323.gridCurrentA": "电网电流A",
  "unc.65323.gridCurrentB": "电网电流B",
  "unc.65323.gridCurrentC": "电网电流C",
  "unc.65323.gridFrequencyA": "电网频率A",
  "unc.65323.gridFrequencyB": "电网频率B",
  "unc.65323.gridFrequencyC": "电网频率C",
  "unc.65323.gridActivePower": "电网有功功率",
  "unc.65323.gridAPhaseActivePower": "电网A相有功功率",
  "unc.65323.gridBPhaseActivePower": "电网B相有功功率",
  "unc.65323.gridCPhaseActivePower": "电网C相有功功率",
  "unc.65323.gridReactivePower": "电网无功功率",
  "unc.65323.gridApparentPower": "电网视在功率",
  "unc.65323.powerFactor": "功率因数",
  "unc.65323.dcComponentA": "直流分量A",
  "unc.65323.dcComponentB": "直流分量B",
  "unc.65323.dcComponentC": "直流分量C",
  "unc.65323.phaseOrder": "相序",
  "unc.65323.leakageCurrent": "漏电流",
  "unc.65323.clsStatus": "CLS状态",
  "unc.65323.clsLockNum": "CLS锁定次数",
  "unc.65323.clsLockTime": "CLS锁定时间",
  "unc.65323.returnFlowPortVoltageA": "回流端口电压A",
  "unc.65323.returnFlowPortVoltageB": "回流端口电压B",
  "unc.65323.returnFlowPortVoltageC": "回流端口电压C",
  "unc.65323.returnFlowPortCurrentA": "回流端口电流A",
  "unc.65323.returnFlowPortCurrentB": "回流端口电流B",
  "unc.65323.returnFlowPortCurrentC": "回流端口电流C",
  "unc.65323.returnFlowPortTotalActivePower": "回流端口总有功功率",
  "unc.65323.returnFlowPortAPhaseActivePower": "回流端口A相有功功率",
  "unc.65323.returnFlowPortBPhaseActivePower": "回流端口B相有功功率",
  "unc.65323.returnFlowPortCPhaseActivePower": "回流端口C相有功功率",
  "unc.65323.returnFlowPortReactivePower": "回流端口无功功率",
  "unc.65323.returnFlowPortApparentPower": "回流端口视在功率",
  "unc.65323.returnFlowPortFrequency": "回流端口频率",
  "unc.65323.returnFlowPortPowerFactor": "回流端口功率因数",
  "unc.65323.todayFeedInGridEnergy": "当日馈网电量",
  "unc.65323.todayConsumeEnergy": "今日用电量",
  "unc.65323.totalFeedInGridEnergy": "累计馈网电量",
  "unc.65323.totalConsumeEnergy": "累计用电量",
  "unc.65323.ctStatus": "电表状态",
  "unc.65323.ctVoltageA": "电表电压A",
  "unc.65323.ctVoltageB": "电表电压B",
  "unc.65323.ctVoltageC": "电表电压C",
  "unc.65323.ctCurrentA": "电表电流A",
  "unc.65323.ctCurrentB": "电表电流B",
  "unc.65323.ctCurrentC": "电表电流C",
  "unc.65323.ctTotalActivePower": "电表总有功功率",
  "unc.65323.ctAPhaseActivePower": "电表A相有功功率",
  "unc.65323.ctBPhaseActivePower": "电表B相有功功率",
  "unc.65323.ctCPhaseActivePower": "电表C相有功功率",
  "unc.65323.ctReactivePower": "电表无功功率",
  "unc.65323.ctApparentPower": "电表视在功率",
  "unc.65323.ctFrequency": "电表频率",
  "unc.65323.ctPowerFactor": "电表功率因数",
  "unc.65323.loadVoltageA": "负载电压A",
  "unc.65323.loadVoltageB": "负载电压B",
  "unc.65323.loadVoltageC": "负载电压C",
  "unc.65323.loadCurrentA": "负载电流A",
  "unc.65323.loadCurrentB": "负载电流B",
  "unc.65323.loadCurrentC": "负载电流C",
  "unc.65323.loadFrequency": "负载频率",
  "unc.65323.loadActivePower": "负载有功功率",
  "unc.65323.loadAPhaseActivePower": "负载A相有功功率",
  "unc.65323.loadBPhaseActivePower": "负载B相有功功率",
  "unc.65323.loadCPhaseActivePower": "负载C相有功功率",
  "unc.65323.loadReactivePower": "负载无功功率",
  "unc.65323.loadTodayConsumeEnergy": "负载当日用电量",
  "unc.65323.loadTotalConsumeEnergy": "负载累计用电量",
  "unc.65323.pv1Voltage": "光伏1电压",
  "unc.65323.pv2Voltage": "光伏2电压",
  "unc.65323.pv3Voltage": "光伏3电压",
  "unc.65323.pv4Voltage": "光伏4电压",
  "unc.65323.pv5Voltage": "光伏5电压",
  "unc.65323.pv6Voltage": "光伏6电压",
  "unc.65323.pv1Current": "光伏1电流",
  "unc.65323.pv2Current": "光伏2电流",
  "unc.65323.pv3Current": "光伏3电流",
  "unc.65323.pv4Current": "光伏4电流",
  "unc.65323.pv5Current": "光伏5电流",
  "unc.65323.pv6Current": "光伏6电流",
  "unc.65323.pv1Power": "光伏1功率",
  "unc.65323.pv2Power": "光伏2功率",
  "unc.65323.pv3Power": "光伏3功率",
  "unc.65323.pv4Power": "光伏4功率",
  "unc.65323.pv5Power": "光伏5功率",
  "unc.65323.pv6Power": "光伏6功率",
  "unc.65323.pvTotalPower": "光伏总功率",
  "unc.65323.busVoltage": "母线电压",
  "unc.65323.pvTodayEnergy": "光伏当日发电量",
  "unc.65323.pvMonthlyEnergy": "光伏当月发电量",
  "unc.65323.pvAnnualEnergy": "光伏当年发电量",
  "unc.65323.pvTotalEnergy": "光伏总发电量",
  "unc.65323.negativeElectrodeInsulationImpedance": "负极绝缘阻抗",
  "unc.65323.positiveElectrodeInsulationImpedance1": "正极绝缘阻抗1",
  "unc.65323.positiveElectrodeInsulationImpedance2": "正极绝缘阻抗2",
  "unc.65323.positiveElectrodeInsulationImpedance3": "正极绝缘阻抗3",
  "unc.65323.positiveElectrodeInsulationImpedance4": "正极绝缘阻抗4",
  "unc.65323.positiveElectrodeInsulationImpedance5": "正极绝缘阻抗5",
  "unc.65323.positiveElectrodeInsulationImpedance6": "正极绝缘阻抗6",
  "unc.65323.batteryVoltage": "电池电压",
  "unc.65323.batteryCurrent": "电池电流",
  "unc.65323.batteryPower": "电池功率",
  "unc.65323.batterySOC": "电池SOC",
  "unc.65323.batterySOH": "电池SOH",
  "unc.65323.batteryStatus": "电池状态",
  "unc.65323.batChargeVoltage": "充电电压",
  "unc.65323.bmsBatteryVoltage": "BMS电池电压",
  "unc.65323.bmsBatteryCurrent": "BMS电池电流",
  "unc.65323.bmsTemperature": "BMS温度(℃)",
  "unc.65323.bmsChargeCurrentLimit": "BMS充电限流",
  "unc.65323.bmsDischargeCurrentLimit": "BMS放电限流",
  "unc.65323.batTodayChargeEnergy": "今日充电量",
  "unc.65323.batTodayDischargeEnergy": "电池当日放电量",
  "unc.65323.batTotalChargeEnergy": "累计充电量",
  "unc.65323.batTotalDischargeEnergy": "电池累计放电量",
  "unc.65323.bmsMaxVoltage": "BMS最大电压",
  "unc.65323.bmsMinVoltage": "BMS最小电压",
  "unc.65323.batFaultFlag": "电池故障标志",
  "unc.65323.batAlarmFlag": "电池告警标志",
  "unc.65323.bmsRequestFlag": "BMS请求标志",
  "unc.65323.generatorRelayStatus": "发电机继电器状态",
  "unc.65323.load2GeneratorVoltageA": "负载2/发电机电压A",
  "unc.65323.load2GeneratorVoltageB": "负载2/发电机电压B",
  "unc.65323.load2GeneratorVoltageC": "负载2/发电机电压C",
  "unc.65323.load2GeneratorCurrentA": "负载2/发电机电流A",
  "unc.65323.load2GeneratorCurrentB": "负载2/发电机电流B",
  "unc.65323.load2GeneratorCurrentC": "负载2/发电机电流C",
  "unc.65323.load2GeneratorFrequency": "负载2/发电机频率",
  "unc.65323.load2GeneratorActivePower": "负载2/发电机有功功率",
  "unc.65323.load2GeneratorAPhaseActivePower": "负载2/发电机A相有功功率",
  "unc.65323.load2GeneratorBPhaseActivePower": "负载2/发电机B相有功功率",
  "unc.65323.load2GeneratorCPhaseActivePower": "负载2/发电机C相有功功率",
  "unc.65323.load2GeneratorReactivePower": "负载2/发电机无功功率",
  "unc.65323.load2GeneratorTodayConsumeEnergy": "负载2/发电机当日用电量",
  "unc.65323.load2GeneratorTotalConsumeEnergy": "负载2/发电机累计用电量",
  "unc.65323.load2GeneratorTodayGenerateEnergy": "负载2/发电机当日发电量",
  "unc.65323.load2GeneratorTotalGenerateEnergy": "负载2/发电机累计发电量",
  "unc.65323.spiAutoTestResult": "SPI自动测试结果",
  "unc.65323.spiAutoTestEndFlag": "SPI自动测试结束标志",
  "unc.65323.spiAutoTestThresholdAPhaseU1": "SPI自动测试阈值A相U>>",
  "unc.65323.spiAutoTestThresholdAPhaseU2": "SPI自动测试阈值A相U>10min",
  "unc.65323.spiAutoTestThresholdAPhaseU3": "SPI自动测试阈值A相U<",
  "unc.65323.spiAutoTestThresholdAPhaseU4": "SPI自动测试阈值A相U<<",
  "unc.65323.spiAutoTestThresholdBPhaseU1": "SPI自动测试阈值B相U>>",
  "unc.65323.spiAutoTestThresholdBPhaseU2": "SPI自动测试阈值B相U>10min",
  "unc.65323.spiAutoTestThresholdBPhaseU3": "SPI自动测试阈值B相U<",
  "unc.65323.spiAutoTestThresholdBPhaseU4": "SPI自动测试阈值B相U<<",
  "unc.65323.spiAutoTestThresholdCPhaseU1": "SPI自动测试阈值C相U>>",
  "unc.65323.spiAutoTestThresholdCPhaseU2": "SPI自动测试阈值C相U>10min",
  "unc.65323.spiAutoTestThresholdCPhaseU3": "SPI自动测试阈值C相U<",
  "unc.65323.spiAutoTestThresholdCPhaseU4": "SPI自动测试阈值C相U<<",
  "unc.65323.spiAutoTestThresholdF1": "SPI自动测试阈值F>>",
  "unc.65323.spiAutoTestThresholdF2": "SPI自动测试阈值F>",
  "unc.65323.spiAutoTestThresholdF3": "SPI自动测试阈值F<",
  "unc.65323.spiAutoTestThresholdF4": "SPI自动测试阈值F<<",
  "unc.65323.spiAutoTestTimeAPhaseU1": "SPI自动测试时间A相U>>",
  "unc.65323.spiAutoTestTimeAPhaseU2": "SPI自动测试时间A相U>10min",
  "unc.65323.spiAutoTestTimeAPhaseU3": "SPI自动测试时间A相U<",
  "unc.65323.spiAutoTestTimeAPhaseU4": "SPI自动测试时间A相U<<",
  "unc.65323.spiAutoTestTimeBPhaseU1": "SPI自动测试时间B相U>>",
  "unc.65323.spiAutoTestTimeBPhaseU2": "SPI自动测试时间B相U>10min",
  "unc.65323.spiAutoTestTimeBPhaseU3": "SPI自动测试时间B相U<",
  "unc.65323.spiAutoTestTimeBPhaseU4": "SPI自动测试时间B相U<<",
  "unc.65323.spiAutoTestTimeCPhaseU1": "SPI自动测试时间C相U>>",
  "unc.65323.spiAutoTestTimeCPhaseU2": "SPI自动测试时间C相U>10min",
  "unc.65323.spiAutoTestTimeCPhaseU3": "SPI自动测试时间C相U<",
  "unc.65323.spiAutoTestTimeCPhaseU4": "SPI自动测试时间C相U<<",
  "unc.65323.spiAutoTestTimeF1": "SPI自动测试时间F1",
  "unc.65323.spiAutoTestTimeF2": "SPI自动测试时间F2",
  "unc.65323.spiAutoTestTimeF3": "SPI自动测试时间F3",
  "unc.65323.spiAutoTestTimeF4": "SPI自动测试时间F4",
  "login.password.not.blank": "登录密码不能为空",
  "token.invalid": "token失效，请重新登录",
  "token.empty": "token不能为空",
  "user.not.exist": "用户不存在",
  "user.mail.password.not.correct": "用户邮箱或密码不正确",
  "user.email.exist": "邮箱已被注册！",
  "dept.suspend": "部门停用，不允许新增",
  "dept.not.exist": "部门信息不存在",
  "email.code.valid": "验证码不正确",
  "service.not.found": "服务未找到",
  "service.internal.error": "服务器内部错误",
  "login.email.length.error": "邮箱长度不能超过50个字符。",
  "login.password.length.error": "密码长度必须在8-20个字符之间",
  "menu.edit.exist": "修改菜单'%s'失败，菜单名称已存在",
  "menu.add.exist": "添加菜单'%s'失败，菜单名称已存在",
  "menu.edit.parent": "修改菜单'%s'失败，上级菜单不能选择自己",
  "menu.add.parent": "添加菜单'%s'失败，上级菜单不能选择自己",
  "menu.child.exist": "存在子菜单,不允许删除",
  "menu.assign.error": "菜单已分配,不允许删除",
  "password.reset.success": "密码重置成功",
  "user.register.success": "注册成功",
  "dept.add.exist": "新增部门'%s'失败，部门名称已存在",
  "dept.edit.exist": "修改部门'%s'失败，部门名称已存在",
  "menu.show.status": "显示",
  "menu.hide.status": "隐藏",
  "menu.category.name": "目录",
  "menu.menu.name": "菜单",
  "menu.button.name": "按钮",
  "menu.is.external": "是",
  "menu.not.external": "否",
  "dev.type.oem": "OEM",
  "dev.type.odm": "ODM",
  "dev.type.self": "自研",
  "supplier.type.hr": "海尔",
  "supplier.type.jl": "锦浪",
  "supplier.type.nt": "纳通",
  "device.category.inverter": "逆变器",
  "device.category.pv": "光伏",
  "device.category.battery": "电池",
  "device.category.switch": "开关",
  "device.category.charging.pile": "充电桩",
  "product.not.exist": "产品不存在",
  "product.binding.error": "产品已绑定，不允许删除",
  "ship.import.empty": "导入数据不能为空",
  "mdn.exist": "mdn物料号已存在，不要重复添加",
  "ship.mdn.not.empty": "mdn不能为空",
  "ship.category.not.empty": "品类不能为空",
  "ship.hrSn.not.empty": "海尔序列号不能为空",
  "ship.devType.not.empty": "研发类型不能为空",
  "ship.supplierSn.not.empty": "供应商序列号不能为空",
  "ship.mdn.not.exist": "产品mdn不存在",
  "ship.add.data.error": "出货管理新增数据异常，请联系管理员",
  "device.empty": "设备不存在",
  "deviceType.empty": "设备类型不支持",
  "collector.params.error": "读取非采集器参数异常",
  "can.not.empty": "不能为空",
  "solis.10001.eToday": "日发电量",
  "solis.10001.eMonth": "月发电量",
  "solis.10001.eYear": "年发电量",
  "solis.10001.eTotal": "总发电量",
  "solis.10001.fAc": "电网频率",
  "solis.10001.pac": "实时功率",
  "solis.10001.pacPec": "功率百分比",
  "solis.10001.fullHour": "全功率小时数",
  "solis.10001.power": "装机容量",
  "solis.10001.iAc1": "交流侧电流-R",
  "solis.10001.iAc2": "交流侧电流-S",
  "solis.10001.iAc3": "交流侧电流-T",
  "solis.10001.uAc1": "交流侧电压-R",
  "solis.10001.uAc2": "交流侧电压-S",
  "solis.10001.uAc3": "交流侧电压-T",
  "solis.10001.iPv1": "PV电流-1",
  "solis.10001.iPv2": "PV电流-2",
  "solis.10001.iPv3": "PV电流-3",
  "solis.10001.iPv4": "PV电流-4",
  "solis.10001.iPv5": "PV电流-5",
  "solis.10001.iPv6": "PV电流-6",
  "solis.10001.iPv7": "PV电流-7",
  "solis.10001.iPv8": "PV电流-8",
  "solis.10001.iPv9": "PV电流-9",
  "solis.10001.iPv10": "PV电流-10",
  "solis.10001.iPv11": "PV电流-11",
  "solis.10001.iPv12": "PV电流-12",
  "solis.10001.iPv13": "PV电流-13",
  "solis.10001.iPv14": "PV电流-14",
  "solis.10001.iPv15": "PV电流-15",
  "solis.10001.iPv16": "PV电流-16",
  "solis.10001.iPv17": "PV电流-17",
  "solis.10001.iPv18": "PV电流-18",
  "solis.10001.iPv19": "PV电流-19",
  "solis.10001.iPv20": "PV电流-20",
  "solis.10001.iPv21": "PV电流-21",
  "solis.10001.iPv22": "PV电流-22",
  "solis.10001.iPv23": "PV电流-23",
  "solis.10001.iPv24": "PV电流-24",
  "solis.10001.iPv25": "PV电流-25",
  "solis.10001.iPv26": "PV电流-26",
  "solis.10001.iPv27": "PV电流-27",
  "solis.10001.iPv28": "PV电流-28",
  "solis.10001.iPv29": "PV电流-29",
  "solis.10001.iPv30": "PV电流-30",
  "solis.10001.iPv31": "PV电流-31",
  "solis.10001.iPv32": "PV电流-32",
  "solis.10001.uPv1": "PV电压-1",
  "solis.10001.uPv2": "PV电压-2",
  "solis.10001.uPv3": "PV电压-3",
  "solis.10001.uPv4": "PV电压-4",
  "solis.10001.uPv5": "PV电压-5",
  "solis.10001.uPv6": "PV电压-6",
  "solis.10001.uPv7": "PV电压-7",
  "solis.10001.uPv8": "PV电压-8",
  "solis.10001.uPv9": "PV电压-9",
  "solis.10001.uPv10": "PV电压-10",
  "solis.10001.uPv11": "PV电压-11",
  "solis.10001.uPv12": "PV电压-12",
  "solis.10001.uPv13": "PV电压-13",
  "solis.10001.uPv14": "PV电压-14",
  "solis.10001.uPv15": "PV电压-15",
  "solis.10001.uPv16": "PV电压-16",
  "solis.10001.uPv17": "PV电压-17",
  "solis.10001.uPv18": "PV电压-18",
  "solis.10001.uPv19": "PV电压-19",
  "solis.10001.uPv20": "PV电压-20",
  "solis.10001.uPv21": "PV电压-21",
  "solis.10001.uPv22": "PV电压-22",
  "solis.10001.uPv23": "PV电压-23",
  "solis.10001.uPv24": "PV电压-24",
  "solis.10001.uPv25": "PV电压-25",
  "solis.10001.uPv26": "PV电压-26",
  "solis.10001.uPv27": "PV电压-27",
  "solis.10001.uPv28": "PV电压-28",
  "solis.10001.uPv29": "PV电压-29",
  "solis.10001.uPv30": "PV电压-30",
  "solis.10001.uPv31": "PV电压-31",
  "solis.10001.uPv32": "PV电压-32",
  "solis.10001.pow1": "PV功率-1",
  "solis.10001.pow2": "PV功率-2",
  "solis.10001.pow3": "PV功率-3",
  "solis.10001.pow4": "PV功率-4",
  "solis.10001.pow5": "PV功率-5",
  "solis.10001.pow6": "PV功率-6",
  "solis.10001.pow7": "PV功率-7",
  "solis.10001.pow8": "PV功率-8",
  "solis.10001.pow9": "PV功率-9",
  "solis.10001.pow10": "PV功率-10",
  "solis.10001.pow11": "PV功率-11",
  "solis.10001.pow12": "PV功率-12",
  "solis.10001.pow13": "PV功率-13",
  "solis.10001.pow14": "PV功率-14",
  "solis.10001.pow15": "PV功率-15",
  "solis.10001.pow16": "PV功率-16",
  "solis.10001.pow17": "PV功率-17",
  "solis.10001.pow18": "PV功率-18",
  "solis.10001.pow19": "PV功率-19",
  "solis.10001.pow20": "PV功率-20",
  "solis.10001.pow21": "PV功率-21",
  "solis.10001.pow22": "PV功率-22",
  "solis.10001.pow23": "PV功率-23",
  "solis.10001.pow24": "PV功率-24",
  "solis.10001.pow25": "PV功率-25",
  "solis.10001.pow26": "PV功率-26",
  "solis.10001.pow27": "PV功率-27",
  "solis.10001.pow28": "PV功率-28",
  "solis.10001.pow29": "PV功率-29",
  "solis.10001.pow30": "PV功率-30",
  "solis.10001.pow31": "PV功率-31",
  "solis.10001.pow32": "PV功率-32",
  "solis.10001.inverterTemperature": "逆变器温度(℃)",
  "solis.10001.acOutputType": "交流输出等级",
  "solis.10001.dcInputType": "直流输入通道数",
  "solis.10001.powerFactor": "功率因数",
  "solis.10001.batteryPower": "电池功率",
  "solis.10001.batteryPowerPec": "电池功率百分比",
  "solis.10001.batteryCapacitySoc": "电池 SOC",
  "solis.10001.batteryHealthSoh": "电池 SOH",
  "solis.10001.socDischargeSet": "SOC 过度放电",
  "solis.10001.socChargingSet": "强大的充电 SOC",
  "solis.10001.batteryType": "电池型号",
  "solis.10001.batteryVoltage": "电池电压",
  "solis.10001.batteryCurrent": "电池电流",
  "solis.10001.batteryTodayChargeEnergy": "日充电量",
  "solis.10001.batteryMonthChargeEnergy": "月充电量",
  "solis.10001.batteryYearChargeEnergy": "年充电量",
  "solis.10001.batteryTotalChargeEnergy": "累计充电量",
  "solis.10001.batteryTodayDischargeEnergy": "电池日放电量",
  "solis.10001.batteryMonthDischargeEnergy": "电池月放电量",
  "solis.10001.batteryYearDischargeEnergy": "电池年放电量",
  "solis.10001.batteryTotalDischargeEnergy": "电池累计放电量",
  "solis.10001.gridPurchasedTodayEnergy": "电网日买电量",
  "solis.10001.gridPurchasedMonthEnergy": "电网月买电量",
  "solis.10001.gridPurchasedYearEnergy": "电网年买电量",
  "solis.10001.gridPurchasedTotalEnergy": "电网累计买电量",
  "solis.10001.gridSellTodayEnergy": "电网日卖电量",
  "solis.10001.gridSellMonthEnergy": "电网月卖电量",
  "solis.10001.gridSellYearEnergy": "电网年卖电量",
  "solis.10001.gridSellTotalEnergy": "电网总卖电量",
  "solis.10001.familyLoadPower": "家庭负载功率",
  "solis.10001.bypassLoadPower": "旁路负载功率",
  "solis.10001.pSum": "电网总有功功率",
  "solis.10001.psumPec": "电网总有功功率的百分比",
  "solis.10001.homeLoadTodayEnergy": "负载日消耗量",
  "solis.10001.homeLoadTotalEnergy": "负载总消耗量",
  "solis.10001.model": "逆变器型号",
  "solis.10001.type": "逆变器类型",
  "solis.10001.stateExceptionFlag": "逆变器脱机状态",
  "solis.10001.productModel": "产品型号",
  "solis.10001.nationalStandards": "国家电网标准",
  "solis.10001.version": "逆变器软件版本",
  "solis.10001.reactivePower": "逆变器无功功率",
  "solis.10001.apparentPower": "逆变器视在功率",
  "solis.10001.dcPac": "总直流输入功率",
  "solis.10001.updateShelfEndTime": "保修结束时间",
  "solis.10001.iA": "电表A电流",
  "solis.10001.uA": "电表A电压",
  "solis.10001.pA": "电表A功率",
  "solis.10001.aLookedPower": "电表A视在功率",
  "solis.10001.aReactivePower": "电表A无功功率",
  "solis.10001.aphasePowerFactor": "电表A有功功率",
  "solis.10001.averagePowerFactor": "电表A功率因数",
  "solis.10001.iB": "电表B电流",
  "solis.10001.uB": "电表B电压",
  "solis.10001.pB": "电表B功率",
  "solis.10001.bLookedPower": "电表B视在功率",
  "solis.10001.bReactivePower": "电表B无功功率",
  "solis.10001.bphasePowerFactor": "电表B有功功率",
  "solis.10001.bveragePowerFactor": "电表B功率因数",
  "solis.10001.iC": "电表C电流",
  "solis.10001.uC": "电表C电压",
  "solis.10001.pC": "电表C功率",
  "solis.10001.cLookedPower": "电表C视在功率",
  "solis.10001.cReactivePower": "电表C无功功率",
  "solis.10001.cphasePowerFactor": "电表C有功功率",
  "solis.10001.cveragePowerFactor": "电表C功率因数",
  "jl_param_ctrl_name_Self-UseModeSwitch": "自发自用开关",
  "jl_param_ctrl_name_AllowGridCharging": "允许从市电充电",
  "jl_param_ctrl_name_BatteryReserveSwitch": "电池保留功能开关",
  "jl_param_ctrl_name_ReservedSOC": "保留SOC",
  "jl_param_ctrl_name_GridChargingPowerLimit": "电网充电功率限制",
  "jl_param_ctrl_name_FeedinPriorityModeSwitch": "馈网优先开关",
  "jl_param_ctrl_name_Peak-shavingSwitch": "Peak-shaving开关",
  "jl_param_ctrl_name_Max.usableGridPower": "最大允许电表处取电功率",
  "jl_param_ctrl_name_BaselineSOC": "基准SOC",
  "jl_param_ctrl_name_Off-gridModeSwitch": "离网模式开关",
  "jl_param_ctrl_name_Off-GridOverdischargeSOC": "离网过放SOC",
  "jl_param_ctrl_name_TimeofUseSwitch": "优化收益开关",
  "jl_param_ctrl_name_TimeofUseChargeCurrentSet": "优化收益充电电流设置",
  "jl_param_ctrl_name_TimeofUseDischargeCurrentSet": "优化收益放电电流设置",
  "jl_param_ctrl_name_ChargeTimeSlot1": "充电时段1",
  "jl_param_ctrl_name_DischargeTimeSlot1": "放电时段1",
  "jl_param_ctrl_name_ChargeTimeSlot2": "充电时段2",
  "jl_param_ctrl_name_DischargeTimeSlot2": "放电时段2",
  "jl_param_ctrl_name_ChargeTimeSlot3": "充电时段3",
  "jl_param_ctrl_name_DischargeTimeSlot3": "放电时段3",
  "jl_param_ctrl_name_ChargeTimeSlot4": "充电时段4",
  "jl_param_ctrl_name_DischargeTimeSlot4": "放电时段4",
  "jl_param_ctrl_name_ChargeTimeSlot5": "充电时段5",
  "jl_param_ctrl_name_DischargeTimeSlot5": "放电时段5",
  "jl_param_ctrl_name_ChargeTimeSlot6": "充电时段6",
  "jl_param_ctrl_name_DischargeTimeSlot6": "放电时段6",
  "jl_param_ctrl_name_TimeSetting": "时间设置",
  "jl_param_ctrl_name_FeedinPowerLimitSwitch": "馈网功率限制开关",
  "jl_param_ctrl_name_FeedinPowerLimitValue": "馈网功率限制值",
  "jl_param_ctrl_name_UnblanceOutput": "不平衡输出",
  "jl_param_ctrl_name_FeedinCurrentLimitSwtich": "馈网电流限制开关",
  "jl_param_ctrl_name_FeedinCurrentLimitValue": "馈网电流限制值",
  "jl_param_ctrl_name_FailSafeSwitch": "FailSafe开关",
  "jl_param_ctrl_name_BatteryType": "电池类型",
  "jl_param_ctrl_name_BatteryModel": "电池型号",
  "jl_param_ctrl_name_MaxChargingCurrent": "最大充电电流",
  "jl_param_ctrl_name_MaxDischargingCurrent": "最大放电电流",
  "jl_param_ctrl_name_OverdischargeSOC": "过放SOC",
  "jl_param_ctrl_name_OverdischargeHysteresisSOC": "过放滞回SOC",
  "jl_param_ctrl_name_ForcechargeSOC": "强充SOC",
  "jl_param_ctrl_name_BatteryHealingSwitch": "电池治疗功能开关",
  "jl_param_ctrl_name_BatteryHealingSOC": "电池治疗SOC",
  "jl_param_ctrl_name_BatteryCapacity": "电池容量",
  "jl_param_ctrl_name_Peak-shavingSetting": "市电取电动态调节",
  "jl_param_ctrl_name_Max.gridpowerwhenForcecharging": "强充限功率设置",
  "jl_param_ctrl_name_ECOFunction": "夜间节能模式",
  "jl_param_ctrl_name_BatteryWakeupSwitch": "手动电池唤醒开关",
  "jl_param_ctrl_name_BatteryWakeupVoltageSetting": "手动电池唤醒电压",
  "jl_param_ctrl_name_BatteryWakeupTimeSetting": "手动电池唤醒时间",
  "jl_param_ctrl_name_AutoBatAwaken": "自动电池唤醒开关",
  "jl_param_ctrl_name_AutoBatWakeupVoltageSetting": "自动电池唤醒电压",
  "jl_param_ctrl_name_AutoBatAwakenTimeSetting": "自动电池唤醒时间",
  "jl_param_ctrl_name_GridStandardPrecision": "电网标准保护参数精度",
  "jl_param_ctrl_name_GridCode": "电网标准",
  "jl_param_ctrl_name_OV-G-V01": "OV-G-V 01",
  "jl_param_ctrl_name_OV-G-V-T01": "OV-G-V-T 01",
  "jl_param_ctrl_name_OV-G-V02": "OV-G-V 02",
  "jl_param_ctrl_name_OV-G-V-T02": "OV-G-V-T 02",
  "jl_param_ctrl_name_UN-G-V01": "UN-G-V 01",
  "jl_param_ctrl_name_UN-G-V-T01": "UN-G-V-T 01",
  "jl_param_ctrl_name_UN-G-V02": "UN-G-V 02",
  "jl_param_ctrl_name_UN-G-V-T02": "UN-G-V-T 02",
  "jl_param_ctrl_name_OV-G-F01": "OV-G-F 01",
  "jl_param_ctrl_name_OV-G-F-T01": "OV-G-F-T 01",
  "jl_param_ctrl_name_OV-G-F02": "OV-G-F 02",
  "jl_param_ctrl_name_OV-G-F-T02": "OV-G-F-T 02",
  "jl_param_ctrl_name_UN-G-F01": "UN-G-F 01",
  "jl_param_ctrl_name_UN-G-F-T01": "UN-G-F-T 01",
  "jl_param_ctrl_name_UN-G-F02": "UN-G-F 02",
  "jl_param_ctrl_name_UN-G-F-T02": "UN-G-F-T 02",
  "jl_param_ctrl_name_59.S1": "59.S1",
  "jl_param_ctrl_name_59.S2": "59.S2",
  "jl_param_ctrl_name_59.S2Time": "59.S2 Time",
  "jl_param_ctrl_name_27.S1": "27.S1",
  "jl_param_ctrl_name_27.S1Time": "27.S1 Time",
  "jl_param_ctrl_name_27.S2": "27.S2",
  "jl_param_ctrl_name_27.S2Time": "27.S2 Time",
  "jl_param_ctrl_name_81>S1": "81>S1",
  "jl_param_ctrl_name_81>S1-Time": "81>S1-Time",
  "jl_param_ctrl_name_81<S1": "81<S1",
  "jl_param_ctrl_name_81<S1-Time": "81<S1-Time",
  "jl_param_ctrl_name_81>S2F": "81>S2F",
  "jl_param_ctrl_name_81>S2F-Time": "81>S2F-Time",
  "jl_param_ctrl_name_81<S2F": "81<S2F",
  "jl_param_ctrl_name_81<S2F-Time": "81<S2F-Time",
  "jl_param_ctrl_name_81>S2S": "81>S2S",
  "jl_param_ctrl_name_81>S2S-Time": "81>S2S-Time",
  "jl_param_ctrl_name_81<S2S": "81<S2S",
  "jl_param_ctrl_name_81<S2S-Time": "81<S2S-Time",
  "jl_param_ctrl_name_Startup-VH": "Startup-VH",
  "jl_param_ctrl_name_Startup-VL": "Startup-VL",
  "jl_param_ctrl_name_Recover-VH": "Recover-VH",
  "jl_param_ctrl_name_Recover-VL": "Recover-VL",
  "jl_param_ctrl_name_Startup-FH": "Startup-FH",
  "jl_param_ctrl_name_Startup-FL": "Startup-FL",
  "jl_param_ctrl_name_Recover-FH": "Recover-FH",
  "jl_param_ctrl_name_Recover-FL": "Recover-FL",
  "jl_param_ctrl_name_Startup-T": "Startup-T",
  "jl_param_ctrl_name_Restore-T": "Restore-T",
  "jl_param_ctrl_name_GridCodeWorkMode": "国家标准工作模式\r\nID 378",
  "jl_param_ctrl_name_GradientLimitforPowerChange": "功率变化斜率限制",
  "jl_param_ctrl_name_Ramp-up-US": "Ramp-up-US",
  "jl_param_ctrl_name_Reconnect-US": "Reconnect-US",
  "jl_param_ctrl_name_EN50549GradientLimitforPower-onChange": "EN50549上电变化斜率限制",
  "jl_param_ctrl_name_EN50549PowerChangeGradientafterFaultTripRestart": "EN50549故障Trip重启后功率变化斜率",
  "jl_param_ctrl_name_FrequencyDeratingMode": "过频减载控制模式",
  "jl_param_ctrl_name_01-FrequencyDeratingFstop": "01-减载过频点",
  "jl_param_ctrl_name_0C-FrequencyDeratingFstart": "0C-减载起始频率点",
  "jl_param_ctrl_name_0A-FrequencyDeratingFstart": "0A-减载起始频率点",
  "jl_param_ctrl_name_03&11H&12H-FrequencyDeratingFstart": "03&11H&12H-减载起始频率点",
  "jl_param_ctrl_name_13H-FrequencyDeratingFstart": "13H-减载起始频率点",
  "jl_param_ctrl_name_04-FrequencyDeratingFstart": "04-减载起始频率点",
  "jl_param_ctrl_name_08-FrequencyDeratingFstart": "08-减载起始频率点",
  "jl_param_ctrl_name_0D-FrequencyDeratingSlope(Fdroop)": "0D-减载斜率",
  "jl_param_ctrl_name_0E-FrequencyDeratingF1": "0E-减载起始频率点",
  "jl_param_ctrl_name_01-Under-FreqDerateFstart": "01-欠频减载起始频率点",
  "jl_param_ctrl_name_0C&0A-FrequencyDeratingSlope(Fdroop)": "0C&0A-减载斜率",
  "jl_param_ctrl_name_03&11H&12H-FrequencyDeratingSlope(Fdroop)": "03&11H&12H-减载斜率",
  "jl_param_ctrl_name_13H-FrequencyDeratingSlope(Fdroop)": "13H-减载斜率",
  "jl_param_ctrl_name_04-FrequencyDeratingFstop": "04-减载终点频率",
  "jl_param_ctrl_name_08-FrequencyDeratingSlope(Wgra)": "08-减载斜率",
  "jl_param_ctrl_name_0E-FrequencyDeratingHysteresis": "0E-减载滞回使能开关",
  "jl_param_ctrl_name_01-FrequencyDeratingFstart": "01-减载起始频率",
  "jl_param_ctrl_name_08-FrequencyDeratingFstop": "08-减载终点频率",
  "jl_param_ctrl_name_0E-FrequencyDeratingFstop": "0E-减载滞回频率",
  "jl_param_ctrl_name_13H-FrequencyDeratingResponseTime": "13H-减载响应时间",
  "jl_param_ctrl_name_01-FrequencyDeratingFtransition": "01-过频减载Ftransition",
  "jl_param_ctrl_name_08-FrequencyDeratingHysteresisEnableSwitch(HystEna)": "08-减载滞回使能开关",
  "jl_param_ctrl_name_0E-FrequencyDeratinghysteresisresponsetime(Tstop)": "0E-减载滞回响应时间",
  "jl_param_ctrl_name_0E-FrequencyDeratingSlope(Fdroop)": "0E-减载斜率",
  "jl_param_ctrl_name_0E-FrequencyDeratingResponseDelay(Tintendelay)": "0E-减载响应延时",
  "jl_param_ctrl_name_01-UnderfrequencyRampingFdstart": "01-欠频增载Fdstart",
  "jl_param_ctrl_name_03&0E-UnderfrequencyRampingFdstart": "03&0E-升载起始频率点",
  "jl_param_ctrl_name_13H-UnderfrequencyRampingFdstart": "13H-升载起始频率点",
  "jl_param_ctrl_name_01-UnderfrequencyRampingFpmax": "01-欠频增载的停止频率点（Fpmax）",
  "jl_param_ctrl_name_03&0E-UnderfrequencyRampingFD_Droop": "03&0E-升载斜率",
  "jl_param_ctrl_name_13H-UnderfrequencyRampingFD_Droop": "13H-升载斜率",
  "jl_param_ctrl_name_01-Powerderatechangeslopelimit（Wgra-）": "01-功率下降变化斜率限制（Wgra-）",
  "jl_param_ctrl_name_BatteryPsmaxPercentageSetting(onlyforCEI0-21)": "电池Psmax百分比设定（仅限意大利）",
  "jl_param_ctrl_name_BatteryPcmaxPercentageSetting(onlyforCEI0-21)": "电池Pcmax百分比设定（仅限意大利）",
  "jl_param_ctrl_name_10minOvervoltageSetting": "滑窗电压设置",
  "jl_param_ctrl_name_3Tau(Q)Setting": "3Tau(Q)设置",
  "jl_param_ctrl_name_3Tau(P)Setting": "3Tau(P)设置",
  "jl_param_ctrl_name_OverVoltAutoPLmt": "过压有功自动限制",
  "jl_param_ctrl_name_WorkModeDefault": "工作模式恢复默认设置",
  "jl_param_ctrl_name_PowerLimitDefault": "功率斜率恢复默认设置",
  "jl_param_ctrl_name_FrequencyDeratingDefault": "频率减载恢复默认设置",
  "jl_param_ctrl_name_10minOvervoltageDefault": "滑窗电压恢复默认设置",
  "jl_param_ctrl_name_DRMSwitch": "DRM开关",
  "jl_param_ctrl_name_BackupPortEnablingSetting": "Backup口使能设置",
  "jl_param_ctrl_name_BackupPortReferenceVoltageSetting": "Backup负载供电电压",
  "jl_param_ctrl_name_VoltageDroopSetting": "旁路过载降压",
  "jl_param_ctrl_name_Min.DroopVoltage": "过载降压最低电压",
  "jl_param_ctrl_name_ACCouplingSwitch": "AC Coupling 开关",
  "jl_param_ctrl_name_Position": "连接位置",
  "jl_param_ctrl_name_ACCoupling_OFF_SOC": "AC Coupling关闭SOC",
  "jl_param_ctrl_name_ACCoulplingMax.fre": "最大降载频率",
  "jl_param_ctrl_name_DryContact": "干接点功能",
  "jl_param_ctrl_name_GridPortPoweredBy": "电网口能量来源",
  "jl_param_ctrl_name_GeneratorCharge": "发电机充电开关",
  "jl_param_ctrl_name_GenChargePower": "发电机充电功率",
  "jl_param_ctrl_name_StartChargingSOC": "电池充电SOC",
  "jl_param_ctrl_name_StopChargingSOC": "电池停止充电SOC",
  "jl_param_ctrl_name_Meter.CTSetting": "电表/CT设置",
  "jl_param_ctrl_name_MeterTypeandInstallationLocation": "电表类型及安装位置",
  "jl_param_ctrl_name_CTDirection": "CT方向",
  "jl_param_ctrl_name_InverterMaxOutputPowerSetting": "逆变器最大输出功率设置值",
  "jl_param_ctrl_name_LimitedReactivePowerValue": "逆变器无功功率值",
  "jl_param_ctrl_name_InverterMaxOutputPowerSettingPowerDownStorage": "逆变器最大输出功率设置掉电保存",
  "jl_param_ctrl_name_PowerFactorSettingValue": "功率因数设置值",
  "jl_param_ctrl_name_PowerFactorSettingPowerDownStorage": "功率因数设置掉电保存",
  "jl_param_ctrl_name_MPPTMulti-peakScanningSwitch": "双波峰扫描开关",
  "jl_param_ctrl_name_MPPTMulti-peakScanInterval": "双波峰扫描时间间隔",
  "jl_param_ctrl_name_DailyPV-ISODetection": "每日PV绝缘检测",
  "jl_param_ctrl_name_FactoryReset": "恢复出厂设置",
  "jl_param_ctrl_name_OnlyPVPowerLoad": "仅PV带载",
  "jl_param_ctrl_name_PVOnlyOverloadReset": "仅PV带载复位",
  "jl_param_ctrl_name_IgFollow": "电网电流跟随使能",
  "jl_param_ctrl_name_AFCIProtect": "AFCI保护",
  "jl_param_ctrl_name_AFCIlevel": "AFCI保护灵敏度设置",
  "jl_param_ctrl_name_G100Switch": "G100开关",
  "jl_param_ctrl_name_G100BackflowCurrent": "G100电流输出限制设置",
  "jl_param_ctrl_name_G100ManualFaultClearing": "G100标准故障清除",
  "jl_param_ctrl_name_EPSSwitchingTime": "EPS切换时间",
  "jl_param_ctrl_name_EPSDOD": "EPS放电截止SOC",
  "jl_param_ctrl_name_PassiveModeSwitc": "被动模式开关",
  "jl_param_ctrl_name_FCASDroopSwitch": "FCAS Droop Switch",
  "jl_param_ctrl_name_LSB": "LSB参数",
  "jl_param_ctrl_name_HSB": "HSB参数",
  "jl_param_ctrl_name_LDB": "LDB参数",
  "jl_param_ctrl_name_HDB": "HDB参数",
  "jl_param_ctrl_name_Pcharge": "Pcharge",
  "jl_param_ctrl_name_Pdischarge": "Pdischarge",
  "jl_param_ctrl_name_ParallelMode": "单机/并机设置",
  "jl_param_ctrl_name_PhysicalAddressID": "物理地址ID",
  "jl_param_ctrl_name_ManualSetMaster.Slave": "手动设定主/从机",
  "jl_param_ctrl_name_TotalNumberOfHybridInvertersConnected": "并机接入的储能逆变器总台数",
  "jl_param_ctrl_name_ParallelSync": "并机同步锁定",
  "jl_param_ctrl_group_WorkMode-Self-UseMode": "工作模式-自发自用",
  "jl_param_ctrl_group_WorkMode-FeedinPriorityMode": "工作模式-馈网优先",
  "jl_param_ctrl_group_WorkMode-Peak-shavingMode": "工作模式-Peak-shaving 模式",
  "jl_param_ctrl_group_WorkMode-Off-GridMode": "工作模式-离网模式",
  "jl_param_ctrl_group_TimeOfUse": "优化收益",
  "jl_param_ctrl_group_TimeSetting": "时间设置",
  "jl_param_ctrl_group_GridFeedinPowerLimit": "馈网功率限制",
  "jl_param_ctrl_group_BatterySetting": "电池设置",
  "jl_param_ctrl_group_GridCodeSetting-GridCodeParameters": "电网标准设置-电网标准参数",
  "jl_param_ctrl_group_GridCodeSetting-CERTModeSetting": "电网标准设置-认证选择",
  "jl_param_ctrl_group_GridCodeSetting-PowerLimit": "电网标准设置-功率限制",
  "jl_param_ctrl_group_GridCodeSetting-FrequencyDeratingSetting": "电网标准设置-频率减载设置",
  "jl_param_ctrl_group_GridCodeSetting-SpecialSetting": "电网标准设置-特殊设置",
  "jl_param_ctrl_group_GridCodeSetting-\nInitialSetting": "电网标准设置-恢复默认设置",
  "jl_param_ctrl_group_GridCodeSetting-GridCodeSetting-SpecialSetting": "电网标准设置-DRM设置",
  "jl_param_ctrl_group_BackupSetting": "Backup设置",
  "jl_param_ctrl_group_SmartPort-ACCouplingSetting": "智能端口-AC Coupling 设置",
  "jl_param_ctrl_group_SmartPort-GENSetting": "智能端口-发电机设置",
  "jl_param_ctrl_group_AdvancedSetting-Meter.CTSetting": "高级设置-电表/CT设置",
  "jl_param_ctrl_group_AdvancedSetting-InverterOutputPowerSetting": "高级设置-逆变器输出功率设置",
  "jl_param_ctrl_group_AdvancedSetting-PowerFactorSetting": "高级设置-功率因数设置",
  "jl_param_ctrl_group_AdvancedSetting-MPPTMulti-peakScanningSet": "高级设置-双波峰扫描设置",
  "jl_param_ctrl_group_AdvancedSetting-DailyPV-ISODetection": "高级设置-每日PV绝缘检测",
  "jl_param_ctrl_group_AdvancedSetting-OtherSetting": "高级设置-其他设置",
  "jl_param_ctrl_group_AdvancedSetting-SpecialFunctionSetting": "高级设置-特殊功能设置",
  "jl_param_ctrl_group_AdvancedSetting-EPSMode(OnlyForItaly)": "高级设置-EPS模式(仅对意大利)",
  "jl_param_ctrl_group_AdvancedSetting-PassiveMode": "高级设置-被动模式",
  "jl_param_ctrl_group_ParallelSetting": "并机设置",
  "jl_param_ctrl_note_OnOff": "开启或关闭逆变器",
  "jl_param_ctrl_note_Self-UseModeSwitch": "此开关用于开启/关闭自发自用模式。\r\n自发自用模式、馈网优先模式、Peak-shavig模式和离网模式不能同时关闭。打开其他模式后，自发自用模式将自动关闭。",
  "jl_param_ctrl_note_AllowGridCharging": "设置是否允许系统从市电取电给电池充电",
  "jl_param_ctrl_note_BatteryReserveSwitch": "设置系统是否需要在正常运行中保留一定的电池SOC，预留的电能仅在离网时使用，以长时间支持负载",
  "jl_param_ctrl_note_ReservedSOC": "保留SOC。该参数仅当启用电池保留功能开关时有效。\r\n范围：过放SOC~100%",
  "jl_param_ctrl_note_GridChargingPowerLimit": "电网的最大功率限制可以用来保留电池的SOC等级。仅当启用电池保留功能开关时有效",
  "jl_param_ctrl_note_FeedinPriorityModeSwitch": "此开关用于开启/关闭馈网优先模式",
  "jl_param_ctrl_note_Peak-shavingSwitch": "此开关用于开启/关闭 Peakshaving 模式",
  "jl_param_ctrl_note_Max.usableGridPower": "对于Peakshaving模式，在电网连接点设置允许的峰值输入功率限制",
  "jl_param_ctrl_note_BaselineSOC": "设置当未达到最大可用电网功率限制时需要保持的电池SOC等级。\r\n范围：过放SOC-100%",
  "jl_param_ctrl_note_Off-gridModeSwitch": "此开关用于开启/关闭离网模式",
  "jl_param_ctrl_note_Off-GridOverdischargeSOC": "在离网状态下设置电池过放SOC",
  "jl_param_ctrl_note_TimeofUseSwitch": "此开关用于开启/关闭使用时间设置，允许用户去设置自定义的充电/放电模式",
  "jl_param_ctrl_note_ChargeTimeSlot1": "与其他强充和强放时间段不能有重叠",
  "jl_param_ctrl_note_DischargeTimeSlot1": "与其他强充和强放时间段不能有重叠",
  "jl_param_ctrl_note_ChargeTimeSlot2": "与其他强充和强放时间段不能有重叠",
  "jl_param_ctrl_note_DischargeTimeSlot2": "与其他强充和强放时间段不能有重叠",
  "jl_param_ctrl_note_ChargeTimeSlot3": "与其他强充和强放时间段不能有重叠",
  "jl_param_ctrl_note_DischargeTimeSlot3": "与其他强充和强放时间段不能有重叠",
  "jl_param_ctrl_note_ChargeTimeSlot4": "与其他强充和强放时间段不能有重叠",
  "jl_param_ctrl_note_DischargeTimeSlot4": "与其他强充和强放时间段不能有重叠",
  "jl_param_ctrl_note_ChargeTimeSlot5": "与其他强充和强放时间段不能有重叠",
  "jl_param_ctrl_note_DischargeTimeSlot5": "与其他强充和强放时间段不能有重叠",
  "jl_param_ctrl_note_ChargeTimeSlot6": "与其他强充和强放时间段不能有重叠",
  "jl_param_ctrl_note_DischargeTimeSlot6": "与其他强充和强放时间段不能有重叠",
  "jl_param_ctrl_note_FeedinPowerLimitSwitch": "此开关用于开启/关闭系统馈网控制功能",
  "jl_param_ctrl_note_FeedinPowerLimitValue": "设置并网点的允许最大馈网功率限制",
  "jl_param_ctrl_note_UnblanceOutput": "该开关用于启用/禁用逆变器的不平衡输出能力。\r\n提示：若未接入线，无法开启此模式",
  "jl_param_ctrl_note_FeedinCurrentLimitSwtich": "此开关用来开启/关闭系统馈网电流控制功能",
  "jl_param_ctrl_note_FeedinCurrentLimitValue": "并网点设置的最大馈网电流限制值",
  "jl_param_ctrl_note_FailSafeSwitch": "此开关用于开启/关闭失效安全功能，如果电表通讯丢失，逆变器将会报告",
  "jl_param_ctrl_note_BatteryModel": "设置当前与逆变器连接的电池型号",
  "jl_param_ctrl_note_MaxChargingCurrent": "设置最大允许充电电流",
  "jl_param_ctrl_note_MaxDischargingCurrent": "设置最大允许放电电流",
  "jl_param_ctrl_note_OverdischargeSOC": "当电池电量达到过放SOC，逆变器将会停止给电池放电",
  "jl_param_ctrl_note_ForcechargeSOC": "由于电池自放电现象，电池SOC也许会低于过放SOC值。当达到强制充电SOC值时，逆变器将会自动给电池充电从而避免电池进入休眠状态",
  "jl_param_ctrl_note_BatteryHealingSwitch": "此开关用于开启/关闭电池治疗功能。在光伏发电能力不足期间，电池可能长期保持在低SOC.电池治疗功能将会给电池充电到目标SOC.",
  "jl_param_ctrl_note_BatteryHealingSOC": "电池治疗功能的目标SOC值",
  "jl_param_ctrl_note_Peak-shavingSetting": "此开关用于在强制充电阶段开启/关闭市电取电动态调节功能。当开关开启时，逆变器将对电池进行动态强制充电，同时在并网点保持 \"强制充电时的最大电网功率 \"不被突破。",
  "jl_param_ctrl_note_Max.gridpowerwhenForcecharging": "给电池强制充电的电网最大允许功率",
  "jl_param_ctrl_note_ECOFunction": "此开关用于开启/关闭节能功能。当晚上电池SOC达到过放SOC时，逆变器将会关闭电池电路避免电池功率消耗",
  "jl_param_ctrl_note_BatteryWakeupSwitch": "手动唤醒功能，逆变器将以唤醒电压水平给电池口充电，然后保护一段时间将电池从休眠模式唤醒",
  "jl_param_ctrl_note_BatteryWakeupVoltageSetting": "手动唤醒电压设置",
  "jl_param_ctrl_note_BatteryWakeupTimeSetting": "手动唤醒时间设置",
  "jl_param_ctrl_note_AutoBatAwaken": "电池自动唤醒功能。逆变器通电时将启动电池唤醒功能",
  "jl_param_ctrl_note_AutoBatAwakenTimeSetting": "唤醒时间设置",
  "jl_param_ctrl_note_GridCode": "电网代码设置：请选择相关的电网代码来符合当地的需求",
  "jl_param_ctrl_note_GradientLimitforPowerChange": "改变最大输出功率时的斜率限制",
  "jl_param_ctrl_note_EN50549GradientLimitforPower-onChange": "EN50549电网代码的初始上电功率的斜率限制",
  "jl_param_ctrl_note_EN50549PowerChangeGradientafterFaultTripRestart": "EN50549电网代码的重连功率斜率限制",
  "jl_param_ctrl_note_10minOvervoltageSetting": "电网代码相关的特殊设置。除非本地网络运营商允许，否则请勿修改设置",
  "jl_param_ctrl_note_WorkModeDefault": "重置电网代码相关工作模式",
  "jl_param_ctrl_note_PowerLimitDefault": "重置电网代码相关功率限制",
  "jl_param_ctrl_note_FrequencyDeratingDefault": "重置电网代码相关频率响应",
  "jl_param_ctrl_note_10minOvervoltageDefault": "重置电网代码相关的10分钟过压保护",
  "jl_param_ctrl_note_DRMSwitch": "开启/关闭 DRM/逻辑接口功能",
  "jl_param_ctrl_note_BackupPortReferenceVoltageSetting": "逆变器在离网状态下backup端口参考电压设置",
  "jl_param_ctrl_note_VoltageDroopSetting": "当backup端口过载时电压下降功能",
  "jl_param_ctrl_note_Min.DroopVoltage": "过载降压功能里允许的最低电压",
  "jl_param_ctrl_note_ACCouplingSwitch": "此开关用于开启/关闭 AC coupling功能，通过频率调节控制光伏逆变器发电",
  "jl_param_ctrl_note_Position": "设置与光伏逆变器的连接位置",
  "jl_param_ctrl_note_ACCoupling_OFF_SOC": "当频率达到AC coupling 的最大频率时，设置AC coupling关闭的SOC值，",
  "jl_param_ctrl_note_ACCoulplingMax.fre": "系统允许控制光伏逆变器发电的最大频率",
  "jl_param_ctrl_note_StartChargingSOC": "设置发电机进入工作的电池SOC",
  "jl_param_ctrl_note_StopChargingSOC": "设置发电机停止工作的电池SOC",
  "jl_param_ctrl_note_MeterTypeandInstallationLocation": "设置系统中使用的智能电表类型",
  "jl_param_ctrl_note_CTDirection": "改变CT 的有效方向",
  "jl_param_ctrl_note_InverterMaxOutputPowerSetting": "设置逆变器输出的最大功率限制值",
  "jl_param_ctrl_note_LimitedReactivePowerValue": "设置逆变器的无功功率限制值",
  "jl_param_ctrl_note_PowerFactorSettingValue": "设置逆变器的功率因素",
  "jl_param_ctrl_note_MPPTMulti-peakScanningSwitch": "在阴影条件下使用。启用全局最大功率点扫描。由于IV扫描操作可能会影响发电",
  "jl_param_ctrl_note_MPPTMulti-peakScanInterval": "在IV扫描过程中设置时间间隔，由于IV扫描操作可能会影响发电",
  "jl_param_ctrl_note_DailyPV-ISODetection": "混合逆变器每天早上进行光伏绝缘监测",
  "jl_param_ctrl_note_AFCIProtect": "开启/关闭 AFCI保护",
  "jl_param_ctrl_note_AFCIlevel": "AFCI 保护等级，未经专业工程师指导，请勿自行调整",
  "jl_param_ctrl_note_EPSSwitchingTime": "0表示EPS参数无效、且EPS模式关闭",
  "jl_param_ctrl_note_ParallelMode": "设置逆变器运行在单机模式或者并机模式",
  "jl_param_ctrl_note_PhysicalAddressID": "在并机操作中设置物理地址",
  "jl_param_ctrl_note_ManualSetMaster.Slave": "在并机操作中设置逆变器是主机还是从机",
  "jl_param_ctrl_option_OFF": "关闭",
  "jl_param_ctrl_option_ON": "开启",
  "jl_param_ctrl_option_NotAllowed": "不允许",
  "jl_param_ctrl_option_Allow": "允许",
  "jl_param_ctrl_option_Lithiumbattery": "锂电池",
  "jl_param_ctrl_option_Lead-aci_Battery": "铅酸蓄电池",
  "jl_param_ctrl_option_48VLithiumBattery_WithoutCOMM": "48V锂电池（无COMM）",
  "jl_param_ctrl_option_51.2VLithium_Battery_Without_COMM": "51.2V锂电池（无COM）",
  "jl_param_ctrl_option_No_Battery": "无电池",
  "jl_param_ctrl_option_HaierHV": "Haier HV",
  "jl_param_ctrl_option_NoBattery": "No Battery",
  "jl_param_ctrl_option_UserDefine": "User define",
  "jl_param_ctrl_option_PYLON_HV": "PYLON_HV",
  "jl_param_ctrl_option_B_BOX_HV_BYD": "B_BOX_HV BYD",
  "jl_param_ctrl_option_LG_10H": "LG 10H",
  "jl_param_ctrl_option_SOLUNA_HV": "SOLUNA_HV",
  "jl_param_ctrl_option_DynessHV": "Dyness HV",
  "jl_param_ctrl_option_AoboetHV": "Aoboet HV",
  "jl_param_ctrl_option_WECO_HV_": "WECO HV",
  "jl_param_ctrl_option_AlphaHV": "Alpha HV",
  "jl_param_ctrl_option_GS_Energy": "GS Energy",
  "jl_param_ctrl_option_BYD_HVL": "BYD HVL",
  "jl_param_ctrl_option_Jinko": "Jinko",
  "jl_param_ctrl_option_FOX": "FOX",
  "jl_param_ctrl_option_LG_16H": "LG_16H",
  "jl_param_ctrl_option_PureDrive": "PureDrive",
  "jl_param_ctrl_option_UZ_ENERGY": "UZ ENERGY",
  "jl_param_ctrl_option_J-PACK-HV": "J-PACK-HV",
  "jl_param_ctrl_option_SUNWODA_HV": "SUNWODA HV",
  "jl_param_ctrl_option_WTS_Energy_CORE_Power_CORE": "WTS Energy CORE/Power CORE",
  "jl_param_ctrl_option_AMPACE_HV": "AMPACE_HV",
  "jl_param_ctrl_option_DuraHV": "DuraHV",
  "jl_param_ctrl_option_DMEGC": "DMEGC",
  "jl_param_ctrl_option_AlpSolarrHV": "AlpSolarr HV",
  "jl_param_ctrl_option_CNTE_HV": "CNTE_HV",
  "jl_param_ctrl_option_Ucanpower": "UcanPower",
  "jl_param_ctrl_option_ZNTECH": "ZNTECH",
  "jl_param_ctrl_option_Tower_US": "Tower US",
  "jl_param_ctrl_option_PYTESH": "PYTESH",
  "jl_param_ctrl_option_GS-HV": "GS-HV",
  "jl_param_ctrl_option_Lithium_battery": "Lithium battery",
  "jl_param_ctrl_option_JA-H": "JA-H",
  "jl_param_ctrl_option_BMZ_HV": "BMZ_HV",
  "jl_param_ctrl_option_Voltage0.1V_Time0.01s_Frequency0.01Hz": "电压0.1V，时间0.01s，频率0.01Hz",
  "jl_param_ctrl_option_Voltage1V_Time0.1s_Frequency0.1Hz": "电压1V，时间0.1s，频率0.1Hz",
  "AS4777_NA": "Australia_AS4777_NA",
  "AS4777_SA": "Australia_AS4777_SA",
  "AS4777-02": "Australia_AS4777-02",
  "AS4777-15": "Australia_AS4777-15",
  "AS4777-NW": "Australia_AS4777-NW",
  "AS4777-WA": "Australia_AS4777-WA",
  "ASNZ4777-A": "Australia_ASNZ4777-A",
  "ASNZ4777-B": "Australia_ASNZ4777-B",
  "ASNZ4777-C": "Australia_ASNZ4777-C",
  "AUS-Q-0.8": "Australia_AUS-Q-0.8",
  "AUS-Q-0.9": "Australia_AUS-Q-0.9",
  "Barbados": "Barbados_Barbados",
  "BDEW": "BDEW",
  "BRA-N": "Brazil_BRA-N",
  "BRAZIL": "Brazil_BRAZIL",
  "Brazil-H": "Brazil_Brazil-H",
  "C10/11": "Belgium_C10/11",
  "CEI_0-16": "Italy_CEI 0-16",
  "CEI_0-21": "Italy_CEI 0-21",
  "Chile": "Chile_Chile",
  "CQC3310": "CQC3310",
  "CQC-B": "China_CQC-B",
  "CQC-DZ": "CQC-DZ",
  "Czech_2023_A1/A": "Czech_2023 A1/A",
  "DK": "Denmark_DK",
  "DK1": "Denmark_DK1",
  "DK2": "Denmark_DK2",
  "Dubai-A": "Dubai-A",
  "Dubai-B": "Dubai-B",
  "Egypt": "Egypt",
  "EIFS-SW": "Sweden_EIFS-SW",
  "EN50438_L": "Cyprus,Finland,Czech,Slovenia,Jamaica_EN50438 L",
  "EN50438IE": "Ireland_EN50438IE",
  "EN50549": "EU--EN50549",
  "EN50549-2": "Other_EN50549-2",
  "EN50549ES": "Estonia_EN50549ES",
  "EN50549FI": "Finland_EN50549FI",
  "EN50549IE": "Ireland_EN50549IE",
  "EN50549NL": "Netherlands_EN50549NL",
  "EN50549PO": "Poland_EN50549P0",
  "EN50549TR": "Turkey_EN50549TR",
  "ESB-Micro": "Ireland_ESB-Micro",
  "ESB-Mini": "Ireland_ESB-Mini",
  "ESB-MV": "Ireland_ESB-MV",
  "ESB-SC": "Ireland_ESB-SC",
  "ES-L-N": "Spain_ES-L-N",
  "France": "France_France",
  "G59/3": "UK_G59/3",
  "G59/3-A": "UK_G59/3-A",
  "G83/1": "UK_G83/1",
  "G98": "UK--G98",
  "G98-NI": "UK_G98-NI",
  "G99": "UK--G99",
  "G99-B": "UK_G99-B",
  "G99N": "UK_G99N",
  "G99-NI": "UK_G99-NI",
  "GN-DZL": "China_GN-DZL",
  "GNHN-A": "China_GNHN-A",
  "GNHN-B": "China_GNHN-B",
  "GN-L": "China_GN-L",
  "GNL-A": "China_GNL-A",
  "GNSD-A": "China_GNSD-A",
  "GNSD-B": "China_GNSD-B",
  "GREECE": "Greece_GREECE",
  "HK": "China_HK",
  "Hungary": "Hungary",
  "IEC61727": "IEC61727",
  "IEC61727L": "Pakistan,India_IEC61727L",
  "IEEE1547-13": "IEEE1547-13",
  "Indon": "Indonesia_Indon",
  "Iran": "Iran_Iran",
  "Israel": "Israel_Israel",
  "KS1": "Korea_KS1",
  "KS2": "KS2",
  "KS3": "KS3",
  "KS3-LVRT": "KS3-LVRT",
  "KSC8565-D": "KSC8565-D",
  "KSC8565-T": "KSC8565-T",
  "LTU-1": "Lithuania_LTU-1",
  "LTU-2": "LTU-2",
  "Mala-LV": "Malaysia_Mala-LV",
  "MEA": "Thailand--MEA",
  "MEX-CFE": "Aruba,El Salvador,Nicaragua,Honduras,Guatemala,Panama,Dominica,Mexico_MEX-CFE",
  "MEX-CFE-SP": "Mexico_MEX-CFE-SP",
  "N4105-BEL": "Belgium_N4105-BEL",
  "NewZeal": "Australia_NewZeal",
  "NRS097": "South Africa_NRS097",
  "NTS631": "Spain_NTS631",
  "PEA": "Thailand--PEA",
  "Philippin": "Philippines_Philippin",
  "PH-L": "Philippines_PH-L",
  "PN-50549": "Poland_PN-50549",
  "RD1699": "Spain--RD1699",
  "RENBLAD": "Norway_RENBLAD",
  "SG": "Singapore_SG",
  "SI-1": "SI-1",
  "SI-2": "SI-2",
  "Sri_Lanka": "Sri Lanka",
  "TOR": "Austria_TOR",
  "TR-2": "TR-2",
  "TW": "China_TW",
  "UL-A": "UL-A",
  "User_defined50": "User defined50",
  "User-define": "User defined_User-define",
  "User-define_60": "User-define 60",
  "VDE0126": "Germany_VDE0126",
  "VDE4105": "Germany_VDE4105",
  "VDE4110": "VDE4110",
  "VIETNAM": "Vietnam_VIETNAM",
  "jl_param_ctrl_option_NoResponseMode": "无响应模式",
  "jl_param_ctrl_option_P_Mode-Volt-vatt": "P模式电压值",
  "jl_param_ctrl_option_Q_Mode-Volt-var": "Q模式电压无功",
  "jl_param_ctrl_option_FixPF_": "固定PF",
  "jl_param_ctrl_option_FixReactive": "固定无功",
  "jl_param_ctrl_option_P-Factor": "P系数",
  "jl_param_ctrl_option_Power-Q": "功率-Q",
  "jl_param_ctrl_option_00-NO": "00-无要求",
  "jl_param_ctrl_option_01-Australia": "01-澳大利亚",
  "jl_param_ctrl_option_03-VDE&EN50438": "03-VDE&EN50438",
  "jl_param_ctrl_option_04-US_Rule21": "04-美国Rule21",
  "jl_param_ctrl_option_05-Brazil": "05-巴巴西",
  "jl_param_ctrl_option_06-South_Africa": "06-南非",
  "jl_param_ctrl_option_07-US_Rule21Phase1": "07-美国Rule21Phase1",
  "jl_param_ctrl_option_08-US_Rule21Phase3": "08-美国Rule21Phase3",
  "jl_param_ctrl_option_09-Dubai": "09-迪拜",
  "jl_param_ctrl_option_0A-UK_G98&G99": "0A-英国G98&G99",
  "jl_param_ctrl_option_0B-Germany_BDEW": "0B-德国BDEW",
  "jl_param_ctrl_option_0C-Denmark": "0C-丹麦",
  "jl_param_ctrl_option_0D-China_2018_New_Standard": "0D-中国2018新标准",
  "jl_param_ctrl_option_0E-EN50549": "0E-EN50549",
  "jl_param_ctrl_option_0F-CEI_0-21": "0F-CEI 0-21",
  "jl_param_ctrl_option_10H-South_Africa_levelise": "10H-南非levelise",
  "jl_param_ctrl_option_11H-France": "11H-法国",
  "jl_param_ctrl_option_12H-Austria": "12H-奥地利",
  "jl_param_ctrl_option_13H-Hawaii": "13H-夏威夷",
  "jl_param_ctrl_option_14H-AU_FCAS": "14H-澳洲FCAS",
  "Reset_the_grid_code_related_working_mod": "标准工作模式恢复默认",
  "Reset_the_grid_code_related_power_limit": "功率变化斜率恢复默认",
  "Reset_the_grid_code_related_frequency_response": "频率减载恢复默认",
  "Reset_the_grid_code_related_10min_overvoltage_protection": "滑窗保护恢复默认",
  "jl_param_ctrl_option_GeneratorPort": "发电机端口",
  "jl_param_ctrl_option_BackupPort": "Backup端口",
  "jl_param_ctrl_option_GeneratorControl": "发电机控制",
  "jl_param_ctrl_option_InverterOnAndOffGridSignal": "并离网同步信号",
  "jl_param_ctrl_option_Grid": "电网",
  "jl_param_ctrl_option_Generator": "发电机",
  "jl_param_ctrl_option_Meter": "电表",
  "jl_param_ctrl_option_CT": "CT",
  "Meter_in_Grid_Acrel_1P_Meter": "电网侧Acrel单相",
  "Meter_in_Grid_Acrel_3P_Meter": "电网侧Acrel三相",
  "Meter_in_Grid_Eastron_Standard_1P_Meter": "电网侧Eastron标准单相",
  "Meter_in_Grid_Eastron_Standard_3P_Meter": "电网侧Eastron标准三相",
  "Meter_in_Load_Acrel_1P_Meter": "负载侧Acrel单相",
  "Meter_in_Load_Acrel_3P_Meter": "负载侧Acrel三相",
  "Meter_in_Load_Eastron_Standard_1P_Meter": "负载侧Eastron标准单相",
  "Meter_in_Load_Eastron_Standard_3P_Meter": "负载侧Eastron标准三相",
  "Meter_in_Grid+Grid+PV_Inverter_Acrel_1P_Meter_Only_applicable_for_Eastron_Meter": "电网侧+并联逆变器输出侧(双电表)Acrel单相仅对东鸿电表生效",
  "Meter_in_Grid+Grid+PV_Inverter_Acrel_3P_Meter_Only_applicable_for_Eastron_Meter": "电网侧+并联逆变器输出侧(双电表)Acrel三相仅对东鸿电表生效",
  "Meter_in_Grid+Grid+PV_Inverter_Eastron_Standard_1P_Meter_Only_applicable_for_Eastron_Meter": "电网侧+并联逆变器输出侧(双电表)Eastron标准单相仅对东鸿电表生效",
  "Meter_in_Grid+Grid+PV_Inverter_Eastron_Standard_3P_Meter_Only_applicable_for_Eastron_Meter": "电网侧+并联逆变器输出侧(双电表)Eastron标准三相仅对东鸿电表生效",
  "NO_Meter": "无电表模式",
  "jl_param_ctrl_option_forward": "正向设置",
  "jl_param_ctrl_option_backward": "反向设置",
  "jl_param_ctrl_option_Disable": "不使能",
  "jl_param_ctrl_option_Enable": "使能",
  "jl_param_ctrl_option_Factory_Reset": "恢复出厂设置",
  "Overload_Fault_Clearing": "负载过载故障清除",
  "jl_param_ctrl_option_0": "0",
  "jl_param_ctrl_option_1": "1",
  "jl_param_ctrl_option_2": "2",
  "jl_param_ctrl_option_3": "3",
  "jl_param_ctrl_option_4": "4",
  "jl_param_ctrl_option_5": "5",
  "jl_param_ctrl_option_6": "6",
  "jl_param_ctrl_option_7": "7",
  "jl_param_ctrl_option_NO": "否",
  "jl_param_ctrl_option_YES": "是",
  "jl_param_ctrl_option_Single": "单机",
  "jl_param_ctrl_option_Parallel": "并机",
  "jl_param_ctrl_option_Slave": "Slave",
  "jl_param_ctrl_option_Master": "Master",
  "jl_param_ctrl_option_Unlock": "未锁定",
  "jl_param_ctrl_option_Lock": "锁定",
  "solis.10001.batteryChargingCurrent": "电池充电限流",
  "solis.10001.batteryDischargeLimiting": "电池放电限流",
  "solis.10001.gridVoltageA": "电网电压L1",
  "solis.10001.gridVoltageB": "电网电压L2",
  "solis.10001.gridVoltageC": "电网电压L3",
  "solis.10001.gridCurrentA": "电网电流L1",
  "solis.10001.gridCurrentB": "电网电流L2",
  "solis.10001.gridCurrentC": "电网电流L3",
  "solis.10001.gridPower": "电网总功率",
  "solis.10001.gridFac": "电网频率",
  "solis.10001.totalLoadPower": "用电总功率",
  "solis.10001.homeGridTodayEnergy": "当日用电量",
  "solis.10001.homeGridTotalEnergy": "累计电网负载用电量",
  "jl_param_ctrl_name_ChargeTimeSlot1Switch": "充电时段1开关",
  "jl_param_ctrl_name_SOC1": "SOC1",
  "jl_param_ctrl_name_ChargeCurrent1": "充电电流1",
  "jl_param_ctrl_name_ChargeTimeSlot2Switch": "充电时段2开关",
  "jl_param_ctrl_name_SOC2": "SOC2",
  "jl_param_ctrl_name_ChargeCurrent2": "充电电流2",
  "jl_param_ctrl_name_ChargeTimeSlot3Switch": "充电时段3开关",
  "jl_param_ctrl_name_SOC3": "SOC3",
  "jl_param_ctrl_name_ChargeCurrent3": "充电电流3",
  "jl_param_ctrl_name_ChargeTimeSlot4Switch": "充电时段4开关",
  "jl_param_ctrl_name_SOC4": "SOC4",
  "jl_param_ctrl_name_ChargeCurrent4": "充电电流4",
  "jl_param_ctrl_name_ChargeTimeSlot5Switch": "充电时段5开关",
  "jl_param_ctrl_name_SOC5": "SOC5",
  "jl_param_ctrl_name_ChargeCurrent5": "充电电流5",
  "jl_param_ctrl_name_ChargeTimeSlot6Switch": "充电时段6开关",
  "jl_param_ctrl_name_SOC6": "SOC6",
  "jl_param_ctrl_name_ChargeCurrent6": "充电电流6",
  "jl_param_ctrl_name_DischargeTimeSlot1Switch": "放电时段1开关",
  "jl_param_ctrl_name_DischargeCurrent1": "放电电流1",
  "jl_param_ctrl_name_DischargeTimeSlot2Switch": "放电时段2开关",
  "jl_param_ctrl_name_DischargeCurrent2": "放电电流2",
  "jl_param_ctrl_name_DischargeTimeSlot3Switch": "放电时段3开关",
  "jl_param_ctrl_name_DischargeCurrent3": "放电电流3",
  "jl_param_ctrl_name_DischargeTimeSlot4Switch": "放电时段4开关",
  "jl_param_ctrl_name_DischargeCurrent4": "放电电流4",
  "jl_param_ctrl_name_DischargeTimeSlot5Switch": "放电时段5开关",
  "jl_param_ctrl_name_DischargeCurrent5": "放电电流5",
  "jl_param_ctrl_name_DischargeTimeSlot6Switch": "放电时段6开关",
  "jl_param_ctrl_name_DischargeCurrent6": "放电电流6",
  "jl_param_ctrl_note_SOC1": "范围：过放SOC~ 100%",
  "jl_param_ctrl_note_SOC2": "范围：过放SOC~ 100%",
  "jl_param_ctrl_note_SOC3": "范围：过放SOC~ 100%",
  "jl_param_ctrl_note_SOC4": "范围：过放SOC~ 100%",
  "jl_param_ctrl_note_SOC5": "范围：过放SOC~ 100%",
  "jl_param_ctrl_note_SOC6": "范围：过放SOC~ 100%",
  "jl_RTparam_name_BatteryVersion": "电池版本号",
  "jl_RTparam_name_vatBmsVersion": "电池包版本号",
  "jl_RTparam_name_batDcdcVersion": "电池DCDC版本号",
  "supplier.type.sh": "首航",
  "supplier.type.nep": "NEP",
  "supplier.type.ywt": "英威腾",
  "supplier.type.unc": "攸能创",
  "supplier.type.sk": "三科",
  "supplier.type.yx": "岩芯",
  "supplier.type.styr": "生态引入",
  "device.category.collecting.box": "汇流箱",
  "device.category.energy.storage": "储能控制器一体机",
  "setting.type22.reactiveControlSet": "被动控制",
  "setting.type22.inputModeSet": "输入模式",
  "ywt.65323.runStatus": "运行状态",
  "ywt.65323.faultStatus1": "故障状态1",
  "ywt.65323.faultStatus2": "故障状态2",
  "ywt.65323.warningStatus": "告警状态",
  "ywt.65323.relayStatus": "继电器状态",
  "ywt.65323.inverterTemperature": "逆变温度(℃)",
  "ywt.65323.dcTemperature": "DC温度(℃)",
  "ywt.65323.drmStatus": "DRM状态",
  "ywt.65323.mpptTemperature": "MPPT温度(℃)",
  "ywt.65323.gridVoltageAB": "电网电压AB",
  "ywt.65323.gridVoltageBC": "电网电压BC",
  "ywt.65323.gridVoltageCA": "电网电压CA",
  "ywt.65323.gridCurrentA": "电网电流A",
  "ywt.65323.gridCurrentB": "电网电流B",
  "ywt.65323.gridCurrentC": "电网电流C",
  "ywt.65323.gridFrequencyA": "电网频率A",
  "ywt.65323.gridFrequencyB": "电网频率B",
  "ywt.65323.gridFrequencyC": "电网频率C",
  "ywt.65323.gridActivePower": "电网有功功率",
  "ywt.65323.gridAPhaseActivePower": "电网A相有功功率",
  "ywt.65323.gridBPhaseActivePower": "电网B相有功功率",
  "ywt.65323.gridCPhaseActivePower": "电网C相有功功率",
  "ywt.65323.gridReactivePower": "电网无功功率",
  "ywt.65323.gridApparentPower": "电网视在功率",
  "ywt.65323.powerFactor": "功率因数",
  "ywt.65323.dcComponentA": "直流分量A",
  "ywt.65323.dcComponentB": "直流分量B",
  "ywt.65323.dcComponentC": "直流分量C",
  "ywt.65323.phaseOrder": "相序",
  "ywt.65323.leakageCurrent": "漏电流",
  "ywt.65323.clsStatus": "CLS状态",
  "ywt.65323.clsLockNum": "CLS锁定次数",
  "ywt.65323.clsLockTime": "CLS锁定时间",
  "ywt.65323.returnFlowPortVoltageA": "回流端口电压A",
  "ywt.65323.returnFlowPortVoltageB": "回流端口电压B",
  "ywt.65323.returnFlowPortVoltageC": "回流端口电压C",
  "ywt.65323.returnFlowPortCurrentA": "回流端口电流A",
  "ywt.65323.returnFlowPortCurrentB": "回流端口电流B",
  "ywt.65323.returnFlowPortCurrentC": "回流端口电流C",
  "ywt.65323.returnFlowPortTotalActivePower": "回流端口总有功功率",
  "ywt.65323.returnFlowPortAPhaseActivePower": "回流端口A相有功功率",
  "ywt.65323.returnFlowPortBPhaseActivePower": "回流端口B相有功功率",
  "ywt.65323.returnFlowPortCPhaseActivePower": "回流端口C相有功功率",
  "ywt.65323.returnFlowPortReactivePower": "回流端口无功功率",
  "ywt.65323.returnFlowPortApparentPower": "回流端口视在功率",
  "ywt.65323.returnFlowPortFrequency": "回流端口频率",
  "ywt.65323.returnFlowPortPowerFactor": "回流端口功率因数",
  "ywt.65323.todayFeedInGridEnergy": "当日馈网电量",
  "ywt.65323.todayConsumeEnergy": "今日用电量",
  "ywt.65323.totalFeedInGridEnergy": "累计馈网电量",
  "ywt.65323.totalConsumeEnergy": "累计用电量",
  "ywt.65323.ctStatus": "电表状态",
  "ywt.65323.ctVoltageA": "电表电压A",
  "ywt.65323.ctVoltageB": "电表电压B",
  "ywt.65323.ctVoltageC": "电表电压C",
  "ywt.65323.ctCurrentA": "电表电流A",
  "ywt.65323.ctCurrentB": "电表电流B",
  "ywt.65323.ctCurrentC": "电表电流C",
  "ywt.65323.ctTotalActivePower": "电表总有功功率",
  "ywt.65323.ctAPhaseActivePower": "电表A相有功功率",
  "ywt.65323.ctBPhaseActivePower": "电表B相有功功率",
  "ywt.65323.ctCPhaseActivePower": "电表C相有功功率",
  "ywt.65323.ctReactivePower": "电表无功功率",
  "ywt.65323.ctApparentPower": "电表视在功率",
  "ywt.65323.ctFrequency": "电表频率",
  "ywt.65323.ctPowerFactor": "电表功率因数",
  "ywt.65323.loadVoltageA": "负载电压A",
  "ywt.65323.loadVoltageB": "负载电压B",
  "ywt.65323.loadVoltageC": "负载电压C",
  "ywt.65323.loadCurrentA": "负载电流A",
  "ywt.65323.loadCurrentB": "负载电流B",
  "ywt.65323.loadCurrentC": "负载电流C",
  "ywt.65323.loadFrequency": "负载频率",
  "ywt.65323.loadActivePower": "负载有功功率",
  "ywt.65323.loadAPhaseActivePower": "负载A相有功功率",
  "ywt.65323.loadBPhaseActivePower": "负载B相有功功率",
  "ywt.65323.loadCPhaseActivePower": "负载C相有功功率",
  "ywt.65323.loadReactivePower": "负载无功功率",
  "ywt.65323.loadTodayConsumeEnergy": "负载当日用电量",
  "ywt.65323.loadTotalConsumeEnergy": "负载累计用电量",
  "ywt.65323.pv1Voltage": "光伏1电压",
  "ywt.65323.pv2Voltage": "光伏2电压",
  "ywt.65323.pv3Voltage": "光伏3电压",
  "ywt.65323.pv4Voltage": "光伏4电压",
  "ywt.65323.pv5Voltage": "光伏5电压",
  "ywt.65323.pv6Voltage": "光伏6电压",
  "ywt.65323.pv1Current": "光伏1电流",
  "ywt.65323.pv2Current": "光伏2电流",
  "ywt.65323.pv3Current": "光伏3电流",
  "ywt.65323.pv4Current": "光伏4电流",
  "ywt.65323.pv5Current": "光伏5电流",
  "ywt.65323.pv6Current": "光伏6电流",
  "ywt.65323.pv1Power": "光伏1功率",
  "ywt.65323.pv2Power": "光伏2功率",
  "ywt.65323.pv3Power": "光伏3功率",
  "ywt.65323.pv4Power": "光伏4功率",
  "ywt.65323.pv5Power": "光伏5功率",
  "ywt.65323.pv6Power": "光伏6功率",
  "ywt.65323.pvTotalPower": "光伏总功率",
  "ywt.65323.busVoltage": "母线电压",
  "ywt.65323.pvTodayEnergy": "光伏当日发电量",
  "ywt.65323.pvMonthlyEnergy": "光伏当月发电量",
  "ywt.65323.pvAnnualEnergy": "光伏当年发电量",
  "ywt.65323.pvTotalEnergy": "光伏总发电量",
  "ywt.65323.negativeElectrodeInsulationImpedance": "负极绝缘阻抗",
  "ywt.65323.positiveElectrodeInsulationImpedance1": "正极绝缘阻抗1",
  "ywt.65323.positiveElectrodeInsulationImpedance2": "正极绝缘阻抗2",
  "ywt.65323.positiveElectrodeInsulationImpedance3": "正极绝缘阻抗3",
  "ywt.65323.positiveElectrodeInsulationImpedance4": "正极绝缘阻抗4",
  "ywt.65323.positiveElectrodeInsulationImpedance5": "正极绝缘阻抗5",
  "ywt.65323.positiveElectrodeInsulationImpedance6": "正极绝缘阻抗6",
  "ywt.65323.batteryVoltage": "电池电压",
  "ywt.65323.batteryCurrent": "电池电流",
  "ywt.65323.batteryPower": "电池功率",
  "ywt.65323.batterySOC": "电池SOC",
  "ywt.65323.batterySOH": "电池SOH",
  "ywt.65323.batteryStatus": "电池状态",
  "ywt.65323.batChargeVoltage": "充电电压",
  "ywt.65323.bmsBatteryVoltage": "BMS电池电压",
  "ywt.65323.bmsBatteryCurrent": "BMS电池电流",
  "ywt.65323.bmsTemperature": "BMS温度(℃)",
  "ywt.65323.bmsChargeCurrentLimit": "BMS充电限流",
  "ywt.65323.bmsDischargeCurrentLimit": "BMS放电限流",
  "ywt.65323.batTodayChargeEnergy": "今日充电量",
  "ywt.65323.batTodayDischargeEnergy": "电池当日放电量",
  "ywt.65323.batTotalChargeEnergy": "累计充电量",
  "ywt.65323.batTotalDischargeEnergy": "电池累计放电量",
  "ywt.65323.bmsMaxVoltage": "BMS最大电压",
  "ywt.65323.bmsMinVoltage": "BMS最小电压",
  "ywt.65323.batFaultFlag": "电池故障标志",
  "ywt.65323.batAlarmFlag": "电池告警标志",
  "ywt.65323.bmsRequestFlag": "BMS请求标志",
  "ywt.65323.generatorRelayStatus": "发电机继电器状态",
  "ywt.65323.load2GeneratorVoltageA": "负载2/发电机电压A",
  "ywt.65323.load2GeneratorVoltageB": "负载2/发电机电压B",
  "ywt.65323.load2GeneratorVoltageC": "负载2/发电机电压C",
  "ywt.65323.load2GeneratorCurrentA": "负载2/发电机电流A",
  "ywt.65323.load2GeneratorCurrentB": "负载2/发电机电流B",
  "ywt.65323.load2GeneratorCurrentC": "负载2/发电机电流C",
  "ywt.65323.load2GeneratorFrequency": "负载2/发电机频率",
  "ywt.65323.load2GeneratorActivePower": "负载2/发电机有功功率",
  "ywt.65323.load2GeneratorAPhaseActivePower": "负载2/发电机A相有功功率",
  "ywt.65323.load2GeneratorBPhaseActivePower": "负载2/发电机B相有功功率",
  "ywt.65323.load2GeneratorCPhaseActivePower": "负载2/发电机C相有功功率",
  "ywt.65323.load2GeneratorReactivePower": "负载2/发电机无功功率",
  "ywt.65323.load2GeneratorTodayConsumeEnergy": "负载2/发电机当日用电量",
  "ywt.65323.load2GeneratorTotalConsumeEnergy": "负载2/发电机累计用电量",
  "ywt.65323.load2GeneratorTodayGenerateEnergy": "负载2/发电机当日发电量",
  "ywt.65323.load2GeneratorTotalGenerateEnergy": "负载2/发电机累计发电量",
  "ywt.65323.spiAutoTestResult": "SPI自动测试结果",
  "ywt.65323.spiAutoTestEndFlag": "SPI自动测试结束标志",
  "ywt.65323.spiAutoTestThresholdAPhaseU1": "SPI自动测试阈值A相U>>",
  "ywt.65323.spiAutoTestThresholdAPhaseU2": "SPI自动测试阈值A相U>10min",
  "ywt.65323.spiAutoTestThresholdAPhaseU3": "SPI自动测试阈值A相U<",
  "ywt.65323.spiAutoTestThresholdAPhaseU4": "SPI自动测试阈值A相U<<",
  "ywt.65323.spiAutoTestThresholdBPhaseU1": "SPI自动测试阈值B相U>>",
  "ywt.65323.spiAutoTestThresholdBPhaseU2": "SPI自动测试阈值B相U>10min",
  "ywt.65323.spiAutoTestThresholdBPhaseU3": "SPI自动测试阈值B相U<",
  "ywt.65323.spiAutoTestThresholdBPhaseU4": "SPI自动测试阈值B相U<<",
  "ywt.65323.spiAutoTestThresholdCPhaseU1": "SPI自动测试阈值C相U>>",
  "ywt.65323.spiAutoTestThresholdCPhaseU2": "SPI自动测试阈值C相U>10min",
  "ywt.65323.spiAutoTestThresholdCPhaseU3": "SPI自动测试阈值C相U<",
  "ywt.65323.spiAutoTestThresholdCPhaseU4": "SPI自动测试阈值C相U<<",
  "ywt.65323.spiAutoTestThresholdF1": "SPI自动测试阈值F>>",
  "ywt.65323.spiAutoTestThresholdF2": "SPI自动测试阈值F>",
  "ywt.65323.spiAutoTestThresholdF3": "SPI自动测试阈值F<",
  "ywt.65323.spiAutoTestThresholdF4": "SPI自动测试阈值F<<",
  "ywt.65323.spiAutoTestTimeAPhaseU1": "SPI自动测试时间A相U>>",
  "ywt.65323.spiAutoTestTimeAPhaseU2": "SPI自动测试时间A相U>10min",
  "ywt.65323.spiAutoTestTimeAPhaseU3": "SPI自动测试时间A相U<",
  "ywt.65323.spiAutoTestTimeAPhaseU4": "SPI自动测试时间A相U<<",
  "ywt.65323.spiAutoTestTimeBPhaseU1": "SPI自动测试时间B相U>>",
  "ywt.65323.spiAutoTestTimeBPhaseU2": "SPI自动测试时间B相U>10min",
  "ywt.65323.spiAutoTestTimeBPhaseU3": "SPI自动测试时间B相U<",
  "ywt.65323.spiAutoTestTimeBPhaseU4": "SPI自动测试时间B相U<<",
  "ywt.65323.spiAutoTestTimeCPhaseU1": "SPI自动测试时间C相U>>",
  "ywt.65323.spiAutoTestTimeCPhaseU2": "SPI自动测试时间C相U>10min",
  "ywt.65323.spiAutoTestTimeCPhaseU3": "SPI自动测试时间C相U<",
  "ywt.65323.spiAutoTestTimeCPhaseU4": "SPI自动测试时间C相U<<",
  "ywt.65323.spiAutoTestTimeF1": "SPI自动测试时间F>>",
  "ywt.65323.spiAutoTestTimeF2": "SPI自动测试时间F>",
  "ywt.65323.spiAutoTestTimeF3": "SPI自动测试时间F<",
  "ywt.65323.spiAutoTestTimeF4": "SPI自动测试时间F<<",
  "mini.65290.stOV_Vgrid": "网侧电压过压保护",
  "mini.65290.stUV_Vgrid": "网侧电压欠压保护",
  "mini.65290.stOV_Fgrid": "网侧电压过频保护",
  "mini.65290.stUV_Fgrid": "网侧电压欠频保护",
  "mini.65290.stOV_Temp": "逆变器过温保护",
  "mini.65290.stHW_Fault": "逆变器硬件保护",
  "mini.65290.stErrOP_Relay": "网侧继电器异常保护",
  "mini.65290.stErrAccess_EEPROM": "EEPROM 存取异常",
  "mini.65290.stAbnorm_Ris": "绝缘阻抗异常",
  "mini.65290.Vacrms": "网侧电压有效值",
  "mini.65290.Iacrms": "网侧电流有效值",
  "mini.65290.Fgrid": "网侧频率",
  "mini.65290.Temperature": "逆变器工作温度(℃)",
  "mini.65290.stPV1_UV": "PV 输入 1 欠压",
  "mini.65290.stPV1_OV": "PV 输入 1 过压",
  "mini.65290.stRes1": "保留状态1",
  "mini.65290.Vpv1": "PV1 输入电压",
  "mini.65290.Ipv1": "PV1 输入电流",
  "mini.65290.Energy_PV1": "PV1 累计发电量",
  "mini.65290.stPV2_UV": "PV 输入 2 欠压",
  "mini.65290.stPV2_OV": "PV 输入 2 过压",
  "mini.65290.stRes2": "保留状态2",
  "mini.65290.Vpv2": "PV2 输入电压",
  "mini.65290.Ipv2": "PV2 输入电流",
  "mini.65290.Energy_PV2": "PV2 累计发电量",
  "mini.65290.stPV3_UV": "PV 输入 3 欠压",
  "mini.65290.stPV3_OV": "PV 输入 3 过压",
  "mini.65290.stRes3": "保留状态3",
  "mini.65290.Vpv3": "PV3 输入电压",
  "mini.65290.Ipv3": "PV3 输入电流",
  "mini.65290.Energy_PV3": "PV3 累计发电量",
  "mini.65290.stPV4_UV": "PV 输入 4 欠压",
  "mini.65290.stPV4_OV": "PV 输入 4 过压",
  "mini.65290.stRes4": "保留状态4",
  "mini.65290.Vpv4": "PV4 输入电压",
  "mini.65290.Ipv4": "PV4 输入电流",
  "mini.65290.Energy_PV4": "PV4 累计发电量",
  "mini.65290.stPV5_UV": "PV 输入 5 欠压",
  "mini.65290.stPV5_OV": "PV 输入 5 过压",
  "mini.65290.stRes5": "保留状态5",
  "mini.65290.Vpv5": "PV5 输入电压",
  "mini.65290.Ipv5": "PV5 输入电流",
  "mini.65290.Energy_PV5": "PV5 累计发电量",
  "mini.65290.stPV6_UV": "PV 输入 6 欠压",
  "mini.65290.stPV6_OV": "PV 输入 6 过压",
  "mini.65290.stRes6": "保留状态6",
  "mini.65290.Vpv6": "PV6 输入电压",
  "mini.65290.Ipv6": "PV6 输入电流",
  "mini.65290.Energy_PV6": "PV6 累计发电量",
  "mini.65290.StINVTPOWERON": "逆变器运行状态",
  "mini.65290.stRelayoN": "继电器接通状态",
  "mini.65290.activePower": "有功功率",
  "mini.65290.Res10": "保留10",
  "mini.65290.Res11": "保留11",
  "mini.65290.Res12": "保留12",
  "mini.65290.Res13": "保留13",
  "mini.65290.Res14": "保留14",
  "mini.65290.Res15": "保留15",
  "mini.65290.Res16": "保留16",
  "mini.65290.Res17": "保留17",
  "mini.65290.Res18": "保留18",
  "mini.65290.Res19": "保留19",
  "mini.65290.Res20": "保留20",
  "mini.65290.Un": "并网电网额定电压有效值",
  "mini.65290.Fn": "并网电网额定频率",
  "mini.65290.Pn": "最大并网有功功率",
  "mini.65290.Irmsmax": "最大并网电流有效值",
  "mini.65290.Vmpptmin": "最小 mppt 电压",
  "mini.65290.Vmpptmax": "最大 mppt 电压",
  "mini.65290.Powpvmax": "最大输入 PV 功率",
  "mini.65290.Ipvmax": "最大输入 PV 电流",
  "mini.65290.Tempmax": "最大工作温度(℃)",
  "mini.65290.Firmware_ver1": "固件版本 1",
  "mini.65290.Firmware_ver2": "固件版本 2",
  "mini.65290.Firmware_ver3": "固件版本 3",
  "mini.65290.UpdateProgress": "升级进度",
  "mini.65290.DeviceID": "设备序列号",
  "storage.v2.65284.pvInputVoltage": "光伏输入电压",
  "storage.v2.65284.pvGenerartion": "光伏当前发电功率",
  "storage.v2.65284.pvEnergyDay": "光伏当日发电量",
  "storage.v2.65284.pvEnergyTotal": "光伏累计发电量",
  "storage.v2.65284.batteryVoltage": "电池电压",
  "storage.v2.65284.batteryCurrent": "电池充放电电流",
  "storage.v2.65284.dcOutputCurrent": "直流输出电流",
  "storage.v2.65284.dcOutputPower": "直流输出功率",
  "storage.v2.65284.ratedCapacity": "电池额定容量",
  "storage.v2.65284.batterySOC": "电池剩余容量 SOC",
  "storage.v2.65284.cycleNumber": "充放电循环次数",
  "storage.v2.65284.internalTemp": "系统内部温度(℃)",
  "storage.v2.65284.heatsinkTemp": "散热器温度(℃)",
  "storage.v2.65284.batteryTemp1": "电池包温度 1(℃)",
  "storage.v2.65284.batteryTemp2": "电池包温度 2(℃)",
  "storage.v2.65284.BMSTemp": "BMS 温度(℃)",
  "storage.v2.65284.cellVoltage1": "电芯1电压",
  "storage.v2.65284.cellVoltage2": "电芯2电压",
  "storage.v2.65284.cellVoltage3": "电芯3电压",
  "storage.v2.65284.cellVoltage4": "电芯4电压",
  "storage.v2.65284.cellVoltage5": "电芯5电压",
  "storage.v2.65284.cellVoltage6": "电芯6电压",
  "storage.v2.65284.cellVoltage7": "电芯7电压",
  "storage.v2.65284.cellVoltage8": "电芯8电压",
  "storage.v2.65284.cellVoltage9": "电芯9电压",
  "storage.v2.65284.cellVoltage10": "电芯10电压",
  "storage.v2.65284.cellVoltage11": "电芯11电压",
  "storage.v2.65284.cellVoltage12": "电芯12电压",
  "storage.v2.65284.cellVoltage13": "电芯13电压",
  "storage.v2.65284.cellVoltage14": "电芯14电压",
  "storage.v2.65284.cellVoltage15": "电芯15电压",
  "storage.v2.65284.cellVoltage16": "电芯16电压",
  "storage.v2.65284.BMSWorkingStatus": "BMS 工作状态",
  "storage.v2.65284.runningStatus": "设备的运行状态",
  "storage.v2.65284.time": "设备时间",
  "storage.v2.65284.invPower": "微逆功率",
  "mini.65290.tmp": "逆变器温度(℃)",
  "mini.65290.onGridPower": "有功功率",
  "mini.65290.invPvPower": "PV功率",
  "storage.s3.65292.batVoltage": "电池电压",
  "storage.s3.65292.batCurrent": "电池电流",
  "storage.s3.65292.batChargePower": "电池充电功率",
  "storage.s3.65292.mainsChargeCurrent": "市电充电电流",
  "storage.s3.65292.pvChargeCurrent": "PV充电电流",
  "storage.s3.65292.pv1Voltage": "第1路光伏板电压",
  "storage.s3.65292.pv1Current": "第1路光伏板电流",
  "storage.s3.65292.pv1Power": "第1路光伏板输出功率",
  "storage.s3.65292.pv2Voltage": "第2路光伏板电压",
  "storage.s3.65292.pv2Current": "第2路光伏板电流",
  "storage.s3.65292.pv2Power": "第2路光伏板输出功率",
  "storage.s3.65292.aPhaseVoltage": "A相输出电压",
  "storage.s3.65292.aPhaseCurrent": "A相输出电流",
  "storage.s3.65292.aPhaseActivePower": "A相输出有功功率",
  "storage.s3.65292.aPhaseApparentPower": "A相输出视在功率",
  "storage.s3.65292.bPhaseVoltage": "B相输出电压",
  "storage.s3.65292.bPhaseCurrent": "B相输出电流",
  "storage.s3.65292.bPhaseActivePower": "B相输出有功功率",
  "storage.s3.65292.bPhaseApparentPower": "B相输出视在功率",
  "storage.s3.65292.cPhaseVoltage": "C相输出电压",
  "storage.s3.65292.cPhaseCurrent": "C相输出电流",
  "storage.s3.65292.cPhaseActivePower": "C相输出有功功率",
  "storage.s3.65292.cPhaseApparentPower": "C相输出视在功率",
  "storage.s3.65292.allActivePower": "整机输出有功功率",
  "storage.s3.65292.allApparentPower": "整机输出视在功率",
  "storage.s3.65292.aChargeActivePower": "A相发电有功功率",
  "storage.s3.65292.bChargeActivePower": "B相发电有功功率",
  "storage.s3.65292.cChargeActivePower": "C相发电有功功率",
  "storage.s3.65292.mainsApVoltage": "市电A相电压",
  "storage.s3.65292.mainsApCurrent": "市电A相电流",
  "storage.s3.65292.mainsBpVoltage": "市电B相电压",
  "storage.s3.65292.mainsBpCurrent": "市电B相电流",
  "storage.s3.65292.mainsCpVoltage": "市电C相电压",
  "storage.s3.65292.mainsCpCurrent": "市电C相电流",
  "storage.s3.65292.mainsApPower": "市电A相功率",
  "storage.s3.65292.mainsBpPower": "市电B相功率",
  "storage.s3.65292.mainsCpPower": "市电C相功率",
  "storage.s3.65292.onGridActivePower": "并网有功功率",
  "storage.s3.65292.homeLoadPower": "家庭负载功率",
  "storage.s3.65292.afterLoadPower": "后端负载功率",
  "storage.s3.65292.totalLoadPower": "总负载",
  "storage.s3.65292.batPower": "电池功率",
  "storage.s3.65292.girdDisplayPower": "电网侧显示功率",
  "storage.s3.65292.invPower": "逆变器功率",
  "storage.s3.65292.beforeLoadMarker": "前端负载能流标志",
  "storage.s3.65292.gridMarker": "电网能流标志",
  "storage.s3.65292.mainsMarker": "市电能流标志",
  "storage.s3.65292.machineOnStatus": "开机状态",
  "storage.s3.65292.chargeStatus": "充电状态",
  "storage.s3.65292.outputStatus": "输出状态",
  "storage.s3.65292.acTodayEnergy": "今日交流发电量",
  "storage.s3.65292.batTodayChargeEnergy": "今日充电量",
  "storage.s3.65292.batTodayDischargeEnergy": "今日电池放电量",
  "storage.s3.65292.pvTodayEnergy": "今日光伏发电量",
  "storage.s3.65292.loadTodayEnergy": "今日负载用电量",
  "storage.s3.65292.mainsTodayChargeEnergy": "市电当天充电电量",
  "storage.s3.65292.loadTodayUseMainsEnergy": "今日负载从电网消耗电量",
  "storage.s3.65292.batTotalChargeEnergy": "累计充电量",
  "storage.s3.65292.batTotalDischargeEnergy": "电池累计放电量",
  "storage.s3.65292.pvTotalEnergy": "光伏累计发电量",
  "storage.s3.65292.loadTotalEnergy": "负载累计用电量",
  "storage.s3.65292.mainsTotalChargeEnergy": "累计通过市电获取的充电量",
  "storage.s3.65292.loadTotalUseMainsEnergy": "累计负载从电网消耗电量",
  "storage.s3.65292.acTotalEnergy": "累计交流发电电量",
  "storage.s3.65292.mainsChargeTimerSet": "定时市电充电使能",
  "storage.s3.65292.batChargeTimerSet": "定时电池放电使能",
  "storage.s3.65292.softWareVersion3": "软件版本号3",
  "storage.s3.65292.aPhaseOnGridPower": "A相电网侧有功率",
  "storage.s3.65292.bPhaseOnGridPower": "B相电网侧有功率",
  "storage.s3.65292.cPhaseOnGridPower": "C相电网侧有功率",
  "storage.s3.65292.aPhaseOnGridCurrent": "A相电网侧电流",
  "storage.s3.65292.bPhaseOnGridCurrent": "B相电网侧电流",
  "storage.s3.65292.cPhaseOnGridCurrent": "C相电网侧电流",
  "storage.s3.65292.batTemp": "电池温度(℃)",
  "storage.s3.65292.softWareVersion1": "逆变版本号",
  "storage.s3.65292.softWareVersion2": "BMS版本号",
  "storage.s3.65292.softWareVersion4": "主控板版本号",
  "storage.s3.65292.batChargeCur": "电池请求充电电流",
  "storage.s3.65292.batSurplusCapacity": "电池剩余容量",
  "storage.s3.65292.batRatedCapacity": "电池额定容量",
  "storage.s3.65292.batMaxPressure": "单体电池最大压差",
  "storage.s3.65292.batSoh": "SOH",
  "storage.s3.65292.batChargeLimitVol": "电池充电限压值",
  "storage.s3.65292.bat1CellVol": "电芯电压1",
  "storage.s3.65292.bat2CellVol": "电芯电压2",
  "storage.s3.65292.bat3CellVol": "电芯电压3",
  "storage.s3.65292.bat4CellVol": "电芯电压4",
  "storage.s3.65292.bat5CellVol": "电芯电压5",
  "storage.s3.65292.bat6CellVol": "电芯电压6",
  "storage.s3.65292.bat7CellVol": "电芯电压7",
  "storage.s3.65292.bat8CellVol": "电芯电压8",
  "storage.s3.65292.bat9CellVol": "电芯电压9",
  "storage.s3.65292.bat10CellVol": "电芯电压10",
  "storage.s3.65292.bat11CellVol": "电芯电压11",
  "storage.s3.65292.bat12CellVol": "电芯电压12",
  "storage.s3.65292.bat13CellVol": "电芯电压13",
  "storage.s3.65292.bat14CellVol": "电芯电压14",
  "storage.s3.65292.bat15CellVol": "电芯电压15",
  "storage.s3.65292.bat16CellVol": "电芯电压16",
  "storage.s3.65292.batStatus": "电池状态",
  "storage.s3.65292.pvVoltageLevel": "光伏电压等级",
  "storage.s3.65292.pvRadiatorTemp": "PV散热器温度(℃)",
  "storage.s3.65292.invTemp": "逆变温度(℃)",
  "storage.s3.65292.transformerTemp": "变压器温度(℃)",
  "storage.s3.65292.cellTemp1": "电芯温度1(℃)",
  "storage.s3.65292.cellTemp2": "电芯温度2(℃)",
  "storage.s3.65292.cellTemp3": "电芯温度3(℃)",
  "storage.s3.65292.cellTemp4": "电芯温度4(℃)",
  "storage.s3.65292.mosTemp": "MOS温度(℃)",
  "storage.s3.65292.mcuTemp": "MCU温度(℃)",
  "storage.s3.65292.msAvgTemp": "主从机平均温度(℃)",
  "storage.s3.65292.batSOC": "电池剩余电量SOC",
  "storage.s3.65292.invSubBoardVersion": "逆变子版本号",
  "storage.s3.65292.batDischargeCur": "电池请求放电电流",
  "storage.s3.65292.batWorkStatus": "电池开关状态",
  "storage.s3.65292.ctWorkStatus": "无线CT开关状态",
  "storage.s3.65292.socketPower1": "插座功率1",
  "storage.s3.65292.socketPower2": "插座功率2",
  "storage.s3.65292.socketPower3": "插座功率3",
  "storage.s3.65292.socketPower4": "插座功率4",
  "storage.s3.65292.socketPower5": "插座功率5",
  "storage.s3.65292.socketPower6": "插座功率6",
  "storage.s3.65292.socketPower7": "插座功率7",
  "storage.s3.65292.socketPower8": "插座功率8",
  "storage.s3.65292.socketPower9": "插座功率9",
  "storage.s3.65292.socketPower10": "插座功率10",
  "storage.s3.65292.socketPower11": "插座功率11",
  "storage.s3.65292.socketPower12": "插座功率12",
  "storage.s3.65292.socketPower13": "插座功率13",
  "storage.s3.65292.socketPower14": "插座功率14",
  "storage.s3.65292.socketPower15": "插座功率15",
  "storage.s3.65292.socketPower16": "插座功率16",
  "storage.s3.65292.outPutFreq": "输出频率",
  "storage.s3.65292.mainsFreq": "市电频率",
  "storage.s3.65292.socketWorkStatus": "插座数量",
  "storage.s3.65292.time": "设备时间",
  "storage.s3.65292.deviceSn": "设备序列号",
  "datalog.sn": "采集器序列号",
  "storage.s3.65292.offlineAlarm": "光伏电压等级",
  "storage.s3.65292.pvPower": "光伏功率",
  "hipment.devType": "研发方式",
  "device.voltageV": "设备电压V",
  "device.electric.currentA": "设备电流A",
  "device.return.port": "回流端口",
  "device.a.phase": "A相",
  "device.b.phase": "B相",
  "device.c.phase": "C相",
  "device.electic.meter.data": "电表数据",
  "device.voltage": "电压",
  "device.electric.current": "电流",
  "jl_param_ctrl_group_GridCodeSetting-InitialSetting": "电网标准设置-恢复默认设置",
  "jl_param_ctrl_name_Metercompensation": "电表补偿",
  "the.latest.version.was.not.found": "未找到最新版本",
  "jl_param_ctrl_option_HaierLV": "Haier LV",
  "jl_paran_ctrl_name_InverterConnectedPhaseSetting": "逆变器连接相设定",
  "jl_param_ctrl_name_ClearOverload(OffGrid)Fault": "离网过载故障清除",
  "jl_param_ctrl_option_NAHUILV": "NAHUI LV",
  "jl_param_ctrl_option_LeadAcid": "Lead Acid",
  "jl_param_ctrl_option_48VLithiumbatteryLV": "48V Lithium battery LV",
  "jl_param_ctrl_option_51.2VLithiumbatteryLV": "51.2V Lithium battery LV",
  "jl_param_ctrl_option_PYLON_LV": "PYLON_LV",
  "jl_param_ctrl_option_B_BOX_LVBYD": "B_BOX_LV BYD",
  "jl_param_ctrl_option_DynessLV": "Dyness LV",
  "jl_param_ctrl_option_LGChemLV": "LG Chem LV",
  "jl_param_ctrl_option_AoBo": "AoBo",
  "jl_param_ctrl_option_JiaWei": "JiaWei",
  "jl_param_ctrl_option_WECO": "WECO",
  "jl_param_ctrl_option_FreedomWon": "FreedomWon",
  "jl_param_ctrl_option_Soluna": "Soluna",
  "jl_param_ctrl_option_GSL": "GSL",
  "jl_param_ctrl_option_RiSheng": "RiSheng",
  "jl_param_ctrl_option_UZ(Catl)": "UZ(Catl)",
  "jl_param_ctrl_option_Zeta": "Zeta",
  "jl_param_ctrl_option_Highstar": "Highstar",
  "jl_param_ctrl_option_KODAK": "KODAK",
  "jl_param_ctrl_option_EXIDE": "EXIDE",
  "jl_param_ctrl_option_HDEnergy": "HD Energy",
  "jl_param_ctrl_option_GLG": "GLG",
  "jl_param_ctrl_option_PAND": "PAND",
  "jl_param_ctrl_option_Dowell": "Dowell",
  "jl_param_ctrl_option_ROSENESS": "ROSEN ESS",
  "jl_param_ctrl_option_AlpSolarrLV": "AlpSolarr LV",
  "jl_param_ctrl_option_YOSHOPOLV": "YOSHOPO LV",
  "jl_param_ctrl_option_SUNWODALV": "SUNWODA LV",
  "jl_param_ctrl_option_J-Pack-LV": "J-Pack-LV",
  "jl_param_ctrl_option_CFELV": "CFE LV",
  "jl_param_ctrl_option_UpowerUE-H": "UPower UE-H",
  "jl_param_ctrl_option_UpowerUE-I": "UPower UE-I",
  "jl_param_ctrl_option_Duracell": "Duracell",
  "jl_param_ctrl_option_STELTECLV": "STELTEC LV",
  "jl_param_ctrl_option_LithiumBatteryLV(RS485)": "Lithium Battery LV(RS485)",
  "jl_param_ctrl_option_JA-L": "JA-L",
  "jl_param_ctrl_name_PercentagesettingofthereactivepowerunderDRM3mode": "DRM3模式下的无功百分比设置",
  "jl_param_ctrl_name_PercentagesettingofthereactivepowerunderDRM7mode": "DRM7模式下的无功百分比设置",
  "jl_param_ctrl_name_StartFrequency": "启动频率",
  "jl_param_ctrl_name_ACCoupling_OFF_Bat_Volt": "AC Coupling关闭电池电压",
  "jl_param_ctrl_name_WithGenerator": "连接发电机",
  "jl_param_ctrl_name_GENPortLoadON": "发电机口负载开启",
  "jl_param_ctrl_name_CTRatio": "CT变比",
  "jl_param_ctrl_name_InverterConnectedPhaseSetting": "逆变器连接相设定",
  "jl_param_ctrl_name_FCASFMMode": "FCAS调频模式",
  "jl_param_ctrl_option_step mode": "step模式",
  "jl_param_ctrl_option_droop mode": "droop模式",
  "jl_param_ctrl_option_None": "未连接",
  "jl_param_ctrl_option_SinglePhase": "单相",
  "jl_param_ctrl_option_PhaseA(3P)": "A相（三相）",
  "jl_param_ctrl_option_PhaseB(3P)": "B相（三相）",
  "jl_param_ctrl_option_PhaseC(3P)": "C相（三相）",
  "bw_RTparam_group_Inverter": "逆变器",
  "bw_RTparam_group_Grid": "电网",
  "bw_RTparam_group_Battery": "电池",
  "bw_RTparam_group_Load": "负载",
  "bw_RTparam_group_PVMeter": "光伏侧电表",
  "50300_E-G3-0-1": "电网过压保护",
  "supplier.type.yw": "英维",
  "common.50100.pv1Voltage": "PV1实时电压",
  "common.50100.pv1Current": "PV1实时电流",
  "common.50100.pv1Power": "PV1实时功率",
  "common.50100.pv2Voltage": "PV2实时电压",
  "common.50100.pv2Current": "PV2实时电流",
  "common.50100.pv2Power": "PV2实时功率",
  "common.50100.pv3Voltage": "PV3实时电压",
  "common.50100.pv3Current": "PV3实时电流",
  "common.50100.pv3Power": "PV3实时功率",
  "common.50100.pv4Voltage": "PV4实时电压",
  "common.50100.pv4Current": "PV4实时电流",
  "common.50100.pv4Power": "PV4实时功率",
  "common.50100.temperature": "逆变器温度(℃)",
  "common.50100.outputGridVoltage": "输出电网电压",
  "common.50100.outputGridCurrent": "输出电网频率",
  "common.50100.outputGridPower": "输出电网功率",
  "common.50100.pv1CumulativePowerGeneration": "PV1累计发电量",
  "common.50100.pv2CumulativePowerGeneration": "PV2累计发电量",
  "common.50100.pv3CumulativePowerGeneration": "PV3累计发电量",
  "common.50100.pv4CumulativePowerGeneration": "PV4累计发电量",
  "common.50100.totalPowerGeneration": "设备累计发电量",
  "common.50100.wnSn": "通讯棒SN",
  "common.50100.wnWifiVersion": "通讯棒wifi版本",
  "common.50100.wnHardwareVersion": "通讯棒硬件版本",
  "common.50100.wnSoftwareVersion": "通讯棒软件版本",
  "ltwn_RTparam_group_Inverter": "逆变器",
  "bw_param_ctrl_option_withoutBattery": "未接入电池",
  "\nbw_param_ctrl_option_OnlyEnableDischargeTimePeriodControl": "\n只启用放电时间段控制",
  "plant.already.deliver": "电站已移交",
  "50300_E-G3-0-0": "电网断电",
  "supplier.type.gd": "固德威",
  "common.50100.totalPvEnergy": "总发电量",
  "ltcg_RTparam_name_name": "设备名称",
  "ltcg_RTparam_name_out_pac": "发电功率(千瓦)",
  "ltcg_RTparam_name_eday": "今日发电量（度）",
  "ltcg_RTparam_name_etotal": "累计发电量（度）",
  "ltcg_RTparam_name_status": "状态",
  "ltcg_RTparam_name_turnon_time": "接入时间",
  "ltcg_RTparam_name_type": "设备类型",
  "ltcg_RTparam_name_capacity": "容量 kw",
  "ltcg_RTparam_name_tempperature": "温度",
  "ltcg_RTparam_name_creationDate": "数据最新时间",
  "ltcg_RTparam_name_pac": "发电功率",
  "ltcg_RTparam_name_hTotal": "累计发电小时",
  "ltcg_RTparam_name_vpv1": "直流电压 1",
  "ltcg_RTparam_name_vpv2": "直流电压 2",
  "ltcg_RTparam_name_vpv3": "直流电压 3",
  "ltcg_RTparam_name_vpv4": "直流电压 4",
  "ltcg_RTparam_name_vpv5": "直流电压 5",
  "ltcg_RTparam_name_vpv6": "直流电压 6",
  "ltcg_RTparam_name_vpv7": "直流电压 7",
  "ltcg_RTparam_name_vpv8": "直流电压 8",
  "ltcg_RTparam_name_vpv9": "直流电压 9",
  "ltcg_RTparam_name_vpv10": "直流电压 10",
  "ltcg_RTparam_name_vpv11": "直流电压 11",
  "ltcg_RTparam_name_vpv12": "直流电压 12",
  "ltcg_RTparam_name_ipv1": "直流电流 1",
  "ltcg_RTparam_name_ipv2": "直流电流 2",
  "ltcg_RTparam_name_ipv3": "直流电流 3",
  "ltcg_RTparam_name_ipv4": "直流电流 4",
  "ltcg_RTparam_name_ipv5": "直流电流 5",
  "ltcg_RTparam_name_ipv6": "直流电流 6",
  "ltcg_RTparam_name_ipv7": "直流电流 7",
  "ltcg_RTparam_name_ipv8": "直流电流 8",
  "ltcg_RTparam_name_ipv9": "直流电流 9",
  "ltcg_RTparam_name_ipv10": "直流电流 10",
  "ltcg_RTparam_name_ipv11": "直流电流 11",
  "ltcg_RTparam_name_ipv12": "直流电流 12",
  "ltcg_RTparam_name_vac1": "交流电压 1",
  "ltcg_RTparam_name_vac2": "交流电压 2",
  "ltcg_RTparam_name_vac3": "交流电压 3",
  "ltcg_RTparam_name_iac1": "交流电流 1",
  "ltcg_RTparam_name_iac2": "交流电流 2",
  "ltcg_RTparam_name_iac3": "交流电流 3",
  "ltcg_RTparam_name_fac1": "交流频率 1",
  "ltcg_RTparam_name_fac2": "交流频率 2",
  "ltcg_RTparam_name_fac3": "交流频率 3",
  "ltcg_RTparam_name_istr1": "组串电流 1",
  "ltcg_RTparam_name_istr2": "组串电流 2",
  "ltcg_RTparam_name_istr3": "组串电流 3",
  "ltcg_RTparam_name_istr4": "组串电流 4",
  "ltcg_RTparam_name_istr5": "组串电流 5",
  "ltcg_RTparam_name_istr6": "组串电流 6",
  "ltcg_RTparam_name_istr7": "组串电流 7",
  "ltcg_RTparam_name_istr8": "组串电流 8",
  "ltcg_RTparam_name_istr9": "组串电流 9",
  "ltcg_RTparam_name_istr10": "组串电流 10",
  "ltcg_RTparam_name_istr11": "组串电流 11",
  "ltcg_RTparam_name_istr12": "组串电流 12",
  "ltcg_RTparam_name_istr13": "组串电流 13",
  "ltcg_RTparam_name_istr14": "组串电流 14",
  "ltcg_RTparam_name_istr15": "组串电流 15",
  "ltcg_RTparam_name_istr16": "组串电流 16",
  "ltcg_RTparam_name_istr17": "组串电流 17",
  "ltcg_RTparam_name_istr18": "组串电流 18",
  "ltcg_RTparam_name_istr19": "组串电流 19",
  "ltcg_RTparam_name_istr20": "组串电流 20",
  "ltcg_RTparam_name_istr21": "组串电流 21",
  "ltcg_RTparam_name_istr22": "组串电流 22",
  "ltcg_RTparam_name_istr23": "组串电流 23",
  "ltcg_RTparam_name_istr24": "组串电流 24",
  "ltcg_RTparam_group_Inverter": "逆变器",
  "city.not.exist": "城市不存在",
  "supplier.type.tb": "特变",
  "common.50300.sn": "设备序列号",
  "common.50300.name": "设备名称",
  "common.50300.out_pac": "发电功率(千瓦)",
  "common.50300.eday": "今日发电量（度）",
  "common.50300.etotal": "累计发电量（度）",
  "common.50300.status": "状态",
  "common.50300.turnon_time": "接入时间",
  "common.50300.type": "设备类型",
  "common.50300.capacity": "视在功率（Kw）",
  "common.50300.tempperature": "温度",
  "common.50300.creationDate": "数据最新时间",
  "common.50300.pac": "发电功率",
  "common.50300.hTotal": "累计发电小时",
  "common.50300.vpv1": "直流电压 1",
  "common.50300.vpv2": "直流电压 2",
  "common.50300.vpv3": "直流电压 3",
  "common.50300.vpv4": "直流电压 4",
  "common.50300.vpv5": "直流电压 5",
  "common.50300.vpv6": "直流电压 6",
  "common.50300.vpv7": "直流电压 7",
  "common.50300.vpv8": "直流电压 8",
  "common.50300.vpv9": "直流电压 9",
  "common.50300.vpv10": "直流电压 10",
  "common.50300.vpv11": "直流电压 11",
  "common.50300.vpv12": "直流电压 12",
  "common.50300.ipv1": "直流电流 1",
  "common.50300.ipv2": "直流电流 2",
  "common.50300.ipv3": "直流电流 3",
  "common.50300.ipv4": "直流电流 4",
  "common.50300.ipv5": "直流电流 5",
  "common.50300.ipv6": "直流电流 6",
  "common.50300.ipv7": "直流电流 7",
  "common.50300.ipv8": "直流电流 8",
  "common.50300.ipv9": "直流电流 9",
  "common.50300.ipv10": "直流电流 10",
  "common.50300.ipv11": "直流电流 11",
  "common.50300.ipv12": "直流电流 12",
  "common.50300.vac1": "交流电压 1",
  "common.50300.vac2": "交流电压 2",
  "common.50300.vac3": "交流电压 3",
  "common.50300.iac1": "交流电流 1",
  "common.50300.iac2": "交流电流 2",
  "common.50300.iac3": "交流电流 3",
  "common.50300.fac1": "交流频率 1",
  "common.50300.fac2": "交流频率 2",
  "common.50300.fac3": "交流频率 3",
  "common.50300.istr1": "组串电流 1",
  "common.50300.istr2": "组串电流 2",
  "common.50300.istr3": "组串电流 3",
  "common.50300.istr4": "组串电流 4",
  "common.50300.istr5": "组串电流 5",
  "common.50300.istr6": "组串电流 6",
  "common.50300.istr7": "组串电流 7",
  "common.50300.istr8": "组串电流 8",
  "common.50300.istr9": "组串电流 9",
  "common.50300.istr10": "组串电流 10",
  "common.50300.istr11": "组串电流 11",
  "common.50300.istr12": "组串电流 12",
  "common.50300.istr13": "组串电流 13",
  "common.50300.istr14": "组串电流 14",
  "common.50300.istr15": "组串电流 15",
  "common.50300.istr16": "组串电流 16",
  "common.50300.istr17": "组串电流 17",
  "common.50300.istr18": "组串电流 18",
  "common.50300.istr19": "组串电流 19",
  "common.50300.istr20": "组串电流 20",
  "common.50300.istr21": "组串电流 21",
  "common.50300.istr22": "组串电流 22",
  "common.50300.istr23": "组串电流 23",
  "common.50300.istr24": "组串电流 24",
  "common.50402.sn": "逆变器SN",
  "common.50402.ID": "逆变器ID",
  "common.50402.STATION_ID": "电站ID",
  "common.50402.INV_EG_DAY": "日发电量",
  "common.50402.INV_EG_TOTAL": "逆变器累计发电量",
  "common.50402.INV_I_AC": "逆变器电流",
  "common.50402.INV_U_AC": "逆变器电压",
  "common.50402.PV1_I": "PV1电流",
  "common.50402.PV2_I": "PV2电流",
  "common.50402.PV3_I": "PV3电流",
  "common.50402.PV4_I": "PV4电流",
  "common.50402.PV5_I": "PV5电流",
  "common.50402.PV6_I": "PV6电流",
  "common.50402.PV7_I": "PV7电流",
  "common.50402.PV8_I": "PV8电流",
  "common.50402.PV9_I": "PV9电流",
  "common.50402.PV10_I": "PV10电流",
  "common.50402.PV11_I": "PV11电流",
  "common.50402.PV12_I": "PV12电流",
  "common.50402.PV13_I": "PV13电流",
  "common.50402.PV14_I": "PV14电流",
  "common.50402.PV15_I": "PV15电流",
  "common.50402.PV16_I": "PV16电流",
  "common.50402.PV17_I": "PV17电流",
  "common.50402.PV18_I": "PV18电流",
  "common.50402.PV19_I": "PV19电流",
  "common.50402.PV20_I": "PV20电流",
  "common.50402.PV21_I": "PV21电流",
  "common.50402.PV22_I": "PV22电流",
  "common.50402.PV23_I": "PV23电流",
  "common.50402.PV24_I": "PV24电流",
  "common.50402.PV25_I": "PV25电流",
  "common.50402.PV26_I": "PV26电流",
  "common.50402.PV27_I": "PV27电流",
  "common.50402.PV28_I": "PV28电流",
  "common.50402.PV29_I": "PV29电流",
  "common.50402.PV30_I": "PV30电流",
  "common.50402.PV1_V": "PV1电压",
  "common.50402.PV2_V": "PV2电压",
  "common.50402.PV3_V": "PV3电压",
  "common.50402.PV4_V": "PV4电压",
  "common.50402.PV5_V": "PV5电压",
  "common.50402.PV6_V": "PV6电压",
  "common.50402.PV7_V": "PV7电压",
  "common.50402.PV8_V": "PV8电压",
  "common.50402.PV9_V": "PV9电压",
  "common.50402.PV10_V": "PV10电压",
  "common.50402.PV11_V": "PV11电压",
  "common.50402.PV12_V": "PV12电压",
  "common.50402.PV13_V": "PV13电压",
  "common.50402.PV14_V": "PV14电压",
  "common.50402.PV15_V": "PV15电压",
  "common.50402.PV16_V": "PV16电压",
  "common.50402.PV17_V": "PV17电压",
  "common.50402.PV18_V": "PV18电压",
  "common.50402.PV19_V": "PV19电压",
  "common.50402.PV20_V": "PV20电压",
  "common.50402.PV21_V": "PV21电压",
  "common.50402.PV22_V": "PV22电压",
  "common.50402.PV23_V": "PV23电压",
  "common.50402.PV24_V": "PV24电压",
  "common.50402.PV25_V": "PV25电压",
  "common.50402.PV26_V": "PV26电压",
  "common.50402.PV27_V": "PV27电压",
  "common.50402.PV28_V": "PV28电压",
  "common.50402.PV29_V": "PV29电压",
  "common.50402.PV30_V": "PV30电压",
  "common.50402.INV_P_AC": "逆变器有功功率",
  "common.50402.CAPACITY": "装机容量",
  "common.50402.INV_RUN_STATE": "逆变器运行状态",
  "common.50402.DATA_TIME": "数据时间",
  "common.50402.name": "设备名称",
  "common.50402.out_pac": "发电功率(千瓦)",
  "common.50402.eday": "今日发电量（度）",
  "common.50402.etotal": "累计发电量（度）",
  "common.50402.status": "状态",
  "common.50402.turnon_time": "接入时间",
  "common.50402.type": "设备类型",
  "common.50402.tempperature": "温度(℃)",
  "common.50402.creationDate": "数据最新时间",
  "common.50402.pac": "发电功率",
  "common.50402.hTotal": "累计发电小时",
  "common.50402.vpv1": "直流电压 1",
  "common.50402.vpv2": "直流电压 2",
  "common.50402.vpv3": "直流电压 3",
  "common.50402.vpv4": "直流电压 4",
  "common.50402.vpv5": "直流电压 5",
  "common.50402.vpv6": "直流电压 6",
  "common.50402.vpv7": "直流电压 7",
  "common.50402.vpv8": "直流电压 8",
  "common.50402.vpv9": "直流电压 9",
  "common.50402.vpv10": "直流电压 10",
  "common.50402.vpv11": "直流电压 11",
  "common.50402.vpv12": "直流电压 12",
  "common.50402.ipv1": "直流电流 1",
  "common.50402.ipv2": "直流电流 2",
  "common.50402.ipv3": "直流电流 3",
  "common.50402.ipv4": "直流电流 4",
  "common.50402.ipv5": "直流电流 5",
  "common.50402.ipv6": "直流电流 6",
  "common.50402.ipv7": "直流电流 7",
  "common.50402.ipv8": "直流电流 8",
  "common.50402.ipv9": "直流电流 9",
  "common.50402.ipv10": "直流电流 10",
  "common.50402.ipv11": "直流电流 11",
  "common.50402.ipv12": "直流电流 12",
  "common.50402.vac1": "交流电压 1",
  "common.50402.vac2": "交流电压 2",
  "common.50402.vac3": "交流电压 3",
  "common.50402.iac1": "交流电流 1",
  "common.50402.iac2": "交流电流 2",
  "common.50402.iac3": "交流电流 3",
  "common.50402.fac1": "交流频率 1",
  "common.50402.fac2": "交流频率 2",
  "common.50402.fac3": "交流频率 3",
  "common.50402.istr1": "组串电流 1",
  "common.50402.istr2": "组串电流 2",
  "common.50402.istr3": "组串电流 3",
  "common.50402.istr4": "组串电流 4",
  "common.50402.istr5": "组串电流 5",
  "common.50402.istr6": "组串电流 6",
  "common.50402.istr7": "组串电流 7",
  "common.50402.istr8": "组串电流 8",
  "common.50402.istr9": "组串电流 9",
  "common.50402.istr10": "组串电流 10",
  "common.50402.istr11": "组串电流 11",
  "common.50402.istr12": "组串电流 12",
  "common.50402.istr13": "组串电流 13",
  "common.50402.istr14": "组串电流 14",
  "common.50402.istr15": "组串电流 15",
  "common.50402.istr16": "组串电流 16",
  "common.50402.istr17": "组串电流 17",
  "common.50402.istr18": "组串电流 18",
  "common.50402.istr19": "组串电流 19",
  "common.50402.istr20": "组串电流 20",
  "common.50402.istr21": "组串电流 21",
  "common.50402.istr22": "组串电流 22",
  "common.50402.istr23": "组串电流 23",
  "common.50402.istr24": "组串电流 24",
  "bw_RTparam_group_ Dongle": "通讯棒",
  "bw_RTparam_group_Dongle": "通讯棒",
  "common.50500.xnl_RTparam_name_FV_P": "功率因数值",
  "common.50500.xnl_RTparam_name_GVL": "并网电压等级",
  "common.50500.xnl_RTparam_name_RS_D": "运行状态(默认)",
  "common.50500.xnl_RTparam_name_Etdy_ge1": "当日发电量（有功）",
  "common.50500.xnl_RTparam_name_A_R_P_D": "当日AC无功电量",
  "common.50500.xnl_RTparam_name_GEN_P_D": "发电机日发量",
  "common.50500.xnl_RTparam_name_Et_ge0": "累计发电量（有功）",
  "common.50500.xnl_RTparam_name_Emon1": "当月发电量（有功）",
  "common.50500.xnl_RTparam_name_Etdy_use2": "当月用电量",
  "common.50500.xnl_RTparam_name_t_gc_tdy2": "当月并网量",
  "common.50500.xnl_RTparam_name_Eyr1": "当年发电量（有功）",
  "common.50500.xnl_RTparam_name_Etdy_cg1": "今日充电量",
  "common.50500.xnl_RTparam_name_Etdy_dcg1": "今日放电量",
  "common.50500.xnl_RTparam_name_t_cg_n1": "累计充电量",
  "common.50500.xnl_RTparam_name_t_dcg_n1": "累计放电量",
  "common.50500.xnl_RTparam_name_E_B_D": "当日购电量",
  "common.50500.xnl_RTparam_name_GRID_C_D": "电网当天并网量",
  "common.50500.xnl_RTparam_name_E_B_TO": "总购电量",
  "common.50500.xnl_RTparam_name_PG_F1": "电网频率",
  "common.50500.xnl_RTparam_name_t_gc1": "累计并网量",
  "common.50500.xnl_RTparam_name_GDOH": "发电机日工作时间",
  "common.50500.xnl_RTparam_name_Etdy_use1": "今日用电量",
  "common.50500.xnl_RTparam_name_Et_use1": "累计用电量",
  "common.50500.xnl_RTparam_name_Etdy_use3": "当年用电量",
  "common.50500.xnl_RTparam_name_T_TFM1": "变压器温度",
  "common.50500.xnl_RTparam_name_T_RDT1": "散热器温度",
  "common.50500.xnl_RTparam_name_EG_t_ge1": "发电机总发电量",
  "common.50500.xnl_RTparam_name_E_PVhis_ge1": "历史PV发电量",
  "common.50500.xnl_RTparam_name_t_gc_tdy3": "当年并网量",
  "common.50500.xnl_RTparam_name_LCD": "LCD测试标志位",
  "common.50500.xnl_RTparam_name_CBAC": "电池校正后的容量",
  "common.50500.xnl_RTparam_name_PVDE": "当日PV发电量",
  "common.50500.xnl_RTparam_name_DV1": "直流电压PV1",
  "common.50500.xnl_RTparam_name_DC1": "直流电流PV1",
  "common.50500.xnl_RTparam_name_DV2": "直流电压PV2",
  "common.50500.xnl_RTparam_name_DC2": "直流电流PV2",
  "common.50500.xnl_RTparam_name_DV3": "直流电压PV3",
  "common.50500.xnl_RTparam_name_DC3": "直流电流PV3",
  "common.50500.xnl_RTparam_name_DV4": "直流电压PV4",
  "common.50500.xnl_RTparam_name_DC4": "直流电流PV4",
  "common.50500.xnl_RTparam_name_INV_DSP_D_1": "INV DSP调试信息1",
  "common.50500.xnl_RTparam_name_INV_DSP_D_2": "INV DSP调试信息2",
  "common.50500.xnl_RTparam_name_INV_DSP_D_3": "INV DSP调试信息3",
  "common.50500.xnl_RTparam_name_INV_DSP_D_4": "INV DSP调试信息4",
  "common.50500.xnl_RTparam_name_INV_DSP_D_5": "INV DSP调试信息5",
  "common.50500.xnl_RTparam_name_INV_DSP_D_6": "INV DSP调试信息6",
  "common.50500.xnl_RTparam_name_INV_DSP_D_7": "INV DSP调试信息7",
  "common.50500.xnl_RTparam_name_INV_DSP_D_8": "INV DSP调试信息8",
  "common.50500.xnl_RTparam_name_INV_DSP_D_9": "INV DSP调试信息9",
  "common.50500.xnl_RTparam_name_INV_DSP_D_10": "INV DSP调试信息10",
  "common.50500.xnl_RTparam_name_INV_DSP_D_11": "INV DSP调试信息11",
  "common.50500.xnl_RTparam_name_INV_DSP_D_12": "INV DSP调试信息12",
  "common.50500.xnl_RTparam_name_INV_DSP_D_13": "INV DSP调试信息13",
  "common.50500.xnl_RTparam_name_INV_DSP_D_14": "INV DSP调试信息14",
  "common.50500.xnl_RTparam_name_INV_DSP_D_15": "INV DSP调试信息15",
  "common.50500.xnl_RTparam_name_INV_DSP_D_16": "INV DSP调试信息16",
  "common.50500.xnl_RTparam_name_INV_DSP_D_17": "INV DSP调试信息17",
  "common.50500.xnl_RTparam_name_INV_DSP_D_18": "INV DSP调试信息18",
  "common.50500.xnl_RTparam_name_INV_DSP_D_19": "INV DSP调试信息19",
  "common.50500.xnl_RTparam_name_INV_DSP_D_20": "INV DSP调试信息20",
  "common.50500.xnl_RTparam_name_INV_DSP_D_21": "INV DSP调试信息21",
  "common.50500.xnl_RTparam_name_INV_DSP_D_22": "INV DSP调试信息22",
  "common.50500.xnl_RTparam_name_INV_DSP_D_23": "INV DSP调试信息23",
  "common.50500.xnl_RTparam_name_INV_DSP_D_24": "INV DSP调试信息24",
  "common.50500.xnl_RTparam_name_INV_DSP_D_25": "INV DSP调试信息25",
  "common.50500.xnl_RTparam_name_INV_DSP_D_26": "INV DSP调试信息26",
  "common.50500.xnl_RTparam_name_INV_DSP_D_27": "INV DSP调试信息27",
  "common.50500.xnl_RTparam_name_INV_DSP_D_28": "INV DSP调试信息28",
  "common.50500.xnl_RTparam_name_G_V_L1_N": "电网侧电压L1-N",
  "common.50500.xnl_RTparam_name_G_V_L2_N": "电网侧电压L2-N",
  "common.50500.xnl_RTparam_name_G_V_L1_L2": "电网侧电压L1-L2",
  "common.50500.xnl_RTparam_name_R_I_V_L1_L2": "继电器中间侧电压L1-L2",
  "common.50500.xnl_RTparam_name_AV1": "交流电压R/U/A",
  "common.50500.xnl_RTparam_name_AV2": "交流电压S/V/B",
  "common.50500.xnl_RTparam_name_INV_O_P_L1_L2": "逆变器输出电压L1-L2 ",
  "common.50500.xnl_RTparam_name_C_V_L1": "负载电压 L1",
  "common.50500.xnl_RTparam_name_C_V_L2": "负载电压 L2",
  "common.50500.xnl_RTparam_name_I_O_F2": "逆变器输出频率L2",
  "common.50500.xnl_RTparam_name_G_C_L1": "电网电流 L1",
  "common.50500.xnl_RTparam_name_G_C_L2": "电网电流 L2",
  "common.50500.xnl_RTparam_name_G_C_A": "电网电流 A",
  "common.50500.xnl_RTparam_name_G_C_B": "电网电流 B",
  "common.50500.xnl_RTparam_name_AC1": "交流电流R/U/A",
  "common.50500.xnl_RTparam_name_AC2": "交流电流S/V/B",
  "common.50500.xnl_RTparam_name_GEN_P_T": "发电机总功率",
  "common.50500.xnl_RTparam_name_G_P_L1": "电网功率 L1",
  "common.50500.xnl_RTparam_name_G_P_L2": "电网功率 L2",
  "common.50500.xnl_RTparam_name_PG_Pt1": "电网总功率",
  "common.50500.xnl_RTparam_name_E_CT_P1": "外置 CT1功率",
  "common.50500.xnl_RTparam_name_E_CT_P2": "外置 CT2功率",
  "common.50500.xnl_RTparam_name_CT_P_T": "电网CT总功率",
  "common.50500.xnl_RTparam_name_INV_O_P_L1": "逆变器输出功率 L1 ",
  "common.50500.xnl_RTparam_name_INV_O_P_L2": "逆变器输出功率 L2 ",
  "common.50500.xnl_RTparam_name_I_O_P_LN": "逆变器输出功率 L/N",
  "common.50500.xnl_RTparam_name_C_P_L1": "负载功率 L1",
  "common.50500.xnl_RTparam_name_C_P_L2": "负载功率 L2",
  "common.50500.xnl_RTparam_name_E_Puse_t1": "用电总功率",
  "common.50500.xnl_RTparam_name_E_Cuse1": "用电电流R/U/A",
  "common.50500.xnl_RTparam_name_E_Cuse2": "用电电流S/V/B",
  "common.50500.xnl_RTparam_name_PVGP_A": "Gen端口的相电压A",
  "common.50500.xnl_RTparam_name_B_T1": "电池温度",
  "common.50500.xnl_RTparam_name_B_V1": "电池电压",
  "common.50500.xnl_RTparam_name_B_R_C": "电池剩余电量",
  "common.50500.xnl_RTparam_name_LF2": "负载频率L2",
  "common.50500.xnl_RTparam_name_DP1": "直流功率PV1",
  "common.50500.xnl_RTparam_name_DP2": "直流功率PV2",
  "common.50500.xnl_RTparam_name_DP3": "直流功率PV3",
  "common.50500.xnl_RTparam_name_DP4": "直流功率PV4",
  "common.50500.xnl_RTparam_name_B_Pdcg1": "电池放电功率",
  "common.50500.xnl_RTparam_name_B_C1": "电池电流",
  "common.50500.xnl_RTparam_name_LF1": "负载频率L1",
  "common.50500.xnl_RTparam_name_I_O_F1": "逆变器输出频率L1",
  "common.50500.xnl_RTparam_name_GRID_RELAY_ST1": "电网继电器状态",
  "common.50500.xnl_RTparam_name_ST_EG_RELAY1": "发电机侧继电器状态",
  "common.50500.xnl_RTparam_name_EG_F1": "发电机频率",
  "common.50500.xnl_RTparam_name_BUS_VOL": "母线电压",
  "common.50500.xnl_RTparam_name_H_B_V": "半母线电压",
  "common.50500.xnl_RTparam_name_B_B_C": "平衡桥电流",
  "common.50500.xnl_RTparam_name_I_EARipa1": "并联对地阻抗",
  "common.50500.xnl_RTparam_name_LBVN": "锂电版本号",
  "common.50500.xnl_RTparam_name_M_P": "电表总功率",
  "common.50500.xnl_RTparam_name_M_P_A": "电表功率A",
  "common.50500.xnl_RTparam_name_M_P_B": "电表功率B",
  "common.50500.xnl_RTparam_name_M_P_C": "电表功率C",
  "common.50500.xnl_RTparam_name_t_gc_tdy1": "今日并网量",
  "common.50500.xnl_RTparam_name_Etdy_pu1": "今日购电量",
  "common.50500.xnl_RTparam_name_Et_pu1": "累计购电量",
  "common.50500.xnl_RTparam_name_Vtr1_BAP1": "电池组1总电压",
  "common.50500.xnl_RTparam_name_Cr1_BAP1": "电池组1电流",
  "common.50500.xnl_RTparam_name_T_BAP1": "电池组1温度",
  "common.50500.xnl_RTparam_name_SOC_BAP1": "电池组1SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP1": "电池组1剩余容量",
  "common.50500.xnl_RTparam_name_T_cap_BAP1": "电池组1总容量",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg1": "电池组1充电请求电压",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg1": "电池组1充电请求电流",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg1": "电池组1放电请求电流",
  "common.50500.xnl_RTparam_name_Max_V_BAP1": "电池组1电池最大电压",
  "common.50500.xnl_RTparam_name_MIN_V_BAP1": "电池组1电池最小电压",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP1": "电池组1循环次数",
  "common.50500.xnl_RTparam_name_Warn_BAP1": "电池组1告警",
  "common.50500.xnl_RTparam_name_Fault_BAP1": "电池组1故障",
  "common.50500.xnl_RTparam_name_Vtr_BAP2": "电池组2总电压",
  "common.50500.xnl_RTparam_name_Cr_BAP2": "电池组2电流",
  "common.50500.xnl_RTparam_name_T_BAP2": "电池组2温度",
  "common.50500.xnl_RTparam_name_SOC_BAP2": "电池组2SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP2": "电池组2剩余容量",
  "common.50500.xnl_RTparam_name_T_cap_BAP2": "电池组2总容量",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg2": "电池组2充电请求电压",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg2": "电池组2充电请求电流",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg2": "电池组2放电请求电流",
  "common.50500.xnl_RTparam_name_Max_V_BAP2": "电池组2电池最大电压",
  "common.50500.xnl_RTparam_name_MIN_V_BAP2": "电池组2电池最小电压",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP2": "电池组2循环次数",
  "common.50500.xnl_RTparam_name_Warn_BAP2": "电池组2告警",
  "common.50500.xnl_RTparam_name_Fault_BAP2": "电池组2故障",
  "common.50500.xnl_RTparam_name_Vtr_BAP3": "电池组3总电压",
  "common.50500.xnl_RTparam_name_Cr_BAP3": "电池组3电流",
  "common.50500.xnl_RTparam_name_T_BAP3": "电池组3温度",
  "common.50500.xnl_RTparam_name_SOC_BAP3": "电池组3 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP3": "电池组3剩余容量",
  "common.50500.xnl_RTparam_name_T_cap_BAP3": "电池组3总容量",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg3": "电池组3充电请求电压",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg3": "电池组3充电请求电流",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg3": "电池组3放电请求电流",
  "common.50500.xnl_RTparam_name_Max_V_BAP3": "电池组3电池最大电压",
  "common.50500.xnl_RTparam_name_MIN_V_BAP3": "电池组3电池最小电压",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP3": "电池组3循环次数",
  "common.50500.xnl_RTparam_name_Warn_BAP3": "电池组3告警",
  "common.50500.xnl_RTparam_name_Fault_BAP3": "电池组3故障",
  "common.50500.xnl_RTparam_name_Vtr_BAP4": "电池组4总电压",
  "common.50500.xnl_RTparam_name_Cr_BAP4": "电池组4电流",
  "common.50500.xnl_RTparam_name_T_BAP4": "电池组4温度",
  "common.50500.xnl_RTparam_name_SOC_BAP4": "电池组4 SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP4": "电池组4剩余容量",
  "common.50500.xnl_RTparam_name_T_cap_BAP4": "电池组4总容量",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg4": "电池组4充电请求电压",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg4": "电池组4充电请求电流",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg4": "电池组4放电请求电流",
  "common.50500.xnl_RTparam_name_Max_V_BAP4": "电池组4电池最大电压",
  "common.50500.xnl_RTparam_name_MIN_V_BAP4": "电池组4电池最小电压",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP4": "电池组4循环次数",
  "common.50500.xnl_RTparam_name_Warn_BAP4": "电池组4告警",
  "common.50500.xnl_RTparam_name_Fault_BAP4": "电池组4故障",
  "common.50500.xnl_RTparam_name_Vtr5_BAP5": "电池组5总电压",
  "common.50500.xnl_RTparam_name_Cr5_BAP5": "电池组5电流",
  "common.50500.xnl_RTparam_name_T_BAP5": "电池组5温度",
  "common.50500.xnl_RTparam_name_SOC_BAP5": "电池组5SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP5": "电池组5剩余容量",
  "common.50500.xnl_RTparam_name_T_cap_BAP5": "电池组5总容量",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg5": "电池组5充电请求电压",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg5": "电池组5充电请求电流",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg5": "电池组5放电请求电流",
  "common.50500.xnl_RTparam_name_Max_V_BAP5": "电池组5电池最大电压",
  "common.50500.xnl_RTparam_name_MIN_V_BAP5": "电池组5电池最小电压",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP5": "电池组5循环次数",
  "common.50500.xnl_RTparam_name_Warn_BAP5": "电池组5告警",
  "common.50500.xnl_RTparam_name_Fault_BAP5": "电池组5故障",
  "common.50500.xnl_RTparam_name_Vtr6_BAP6": "电池组6总电压",
  "common.50500.xnl_RTparam_name_Cr6_BAP6": "电池组6电流",
  "common.50500.xnl_RTparam_name_T_BAP6": "电池组6温度",
  "common.50500.xnl_RTparam_name_SOC_BAP6": "电池组6SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP6": "电池组6剩余容量",
  "common.50500.xnl_RTparam_name_T_cap_BAP6": "电池组6总容量",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg6": "电池组6充电请求电压",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg6": "电池组6充电请求电流",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg6": "电池组6放电请求电流",
  "common.50500.xnl_RTparam_name_Max_V_BAP6": "电池组6电池最大电压",
  "common.50500.xnl_RTparam_name_MIN_V_BAP6": "电池组6电池最小电压",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP6": "电池组6循环次数",
  "common.50500.xnl_RTparam_name_Warn_BAP6": "电池组6告警",
  "common.50500.xnl_RTparam_name_Fault_BAP6": "电池组6故障",
  "common.50500.xnl_RTparam_name_Vtr7_BAP7": "电池组7总电压",
  "common.50500.xnl_RTparam_name_Cr7_BAP7": "电池组7电流",
  "common.50500.xnl_RTparam_name_T_BAP7": "电池组7温度",
  "common.50500.xnl_RTparam_name_SOC_BAP7": "电池组7SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP7": "电池组7剩余容量",
  "common.50500.xnl_RTparam_name_T_cap_BAP7": "电池组7总容量",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg7": "电池组7充电请求电压",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg7": "电池组7充电请求电流",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg7": "电池组7放电请求电流",
  "common.50500.xnl_RTparam_name_Max_V_BAP7": "电池组7电池最大电压",
  "common.50500.xnl_RTparam_name_MIN_V_BAP7": "电池组7电池最小电压",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP7": "电池组7循环次数",
  "common.50500.xnl_RTparam_name_Warn_BAP7": "电池组7告警",
  "common.50500.xnl_RTparam_name_Fault_BAP7": "电池组7故障",
  "common.50500.xnl_RTparam_name_Vtr8_BAP8": "电池组8总电压",
  "common.50500.xnl_RTparam_name_Cr8_BAP8": "电池组8电流",
  "common.50500.xnl_RTparam_name_T_BAP8": "电池组8温度",
  "common.50500.xnl_RTparam_name_SOC_BAP8": "电池组8SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP8": "电池组8剩余容量",
  "common.50500.xnl_RTparam_name_T_cap_BAP8": "电池组8总容量",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg8": "电池组8充电请求电压",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg8": "电池组8充电请求电流",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg8": "电池组8放电请求电流",
  "common.50500.xnl_RTparam_name_Max_V_BAP8": "电池组8电池最大电压",
  "common.50500.xnl_RTparam_name_MIN_V_BAP8": "电池组8电池最小电压",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP8": "电池组8循环次数",
  "common.50500.xnl_RTparam_name_Warn_BAP8": "电池组8告警",
  "common.50500.xnl_RTparam_name_Fault_BAP8": "电池组8故障",
  "common.50500.xnl_RTparam_name_Vtr9_BAP9": "电池组9总电压",
  "common.50500.xnl_RTparam_name_Cr9_BAP9": "电池组9电流",
  "common.50500.xnl_RTparam_name_T_BAP9": "电池组9温度",
  "common.50500.xnl_RTparam_name_SOC_BAP9": "电池组9SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP9": "电池组9剩余容量",
  "common.50500.xnl_RTparam_name_T_cap_BAP9": "电池组9总容量",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg9": "电池组9充电请求电压",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg9": "电池组9充电请求电流",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg9": "电池组9放电请求电流",
  "common.50500.xnl_RTparam_name_Max_V_BAP9": "电池组9电池最大电压",
  "common.50500.xnl_RTparam_name_MIN_V_BAP9": "电池组9电池最小电压",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP9": "电池组9循环次数",
  "common.50500.xnl_RTparam_name_Warn_BAP9": "电池组9告警",
  "common.50500.xnl_RTparam_name_Fault_BAP9": "电池组9故障",
  "common.50500.xnl_RTparam_name_Vtr10_BAP10": "电池组10总电压",
  "common.50500.xnl_RTparam_name_Cr10_BAP10": "电池组10电流",
  "common.50500.xnl_RTparam_name_T_BAP10": "电池组10温度",
  "common.50500.xnl_RTparam_name_SOC_BAP10": "电池组10SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP10": "电池组10剩余容量",
  "common.50500.xnl_RTparam_name_T_cap_BAP10": "电池组10总容量",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg10": "电池组10充电请求电压",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg10": "电池组10充电请求电流",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg10": "电池组10放电请求电流",
  "common.50500.xnl_RTparam_name_Max_V_BAP10": "电池组10电池最大电压",
  "common.50500.xnl_RTparam_name_MIN_V_BAP10": "电池组10电池最小电压",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP10": "电池组10循环次数",
  "common.50500.xnl_RTparam_name_Warn_BAP10": "电池组10告警",
  "common.50500.xnl_RTparam_name_Fault_BAP10": "电池组10故障",
  "common.50500.xnl_RTparam_name_Vtr11_BAP11": "电池组11总电压",
  "common.50500.xnl_RTparam_name_Cr11_BAP11": "电池组11电流",
  "common.50500.xnl_RTparam_name_T_BAP11": "电池组11温度",
  "common.50500.xnl_RTparam_name_SOC_BAP11": "电池组11SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP11": "电池组11剩余容量",
  "common.50500.xnl_RTparam_name_T_cap_BAP11": "电池组11总容量",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg11": "电池组11充电请求电压",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg11": "电池组11充电请求电流",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg11": "电池组11放电请求电流",
  "common.50500.xnl_RTparam_name_Max_V_BAP11": "电池组11电池最大电压",
  "common.50500.xnl_RTparam_name_MIN_V_BAP11": "电池组11电池最小电压",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP11": "电池组11循环次数",
  "common.50500.xnl_RTparam_name_Warn_BAP11": "电池组11告警",
  "common.50500.xnl_RTparam_name_Fault_BAP11": "电池组11故障",
  "common.50500.xnl_RTparam_name_Vtr12_BAP12": "电池组12总电压",
  "common.50500.xnl_RTparam_name_Cr12_BAP12": "电池组12电流",
  "common.50500.xnl_RTparam_name_T_BAP12": "电池组12温度",
  "common.50500.xnl_RTparam_name_SOC_BAP12": "电池组12SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP12": "电池组12剩余容量",
  "common.50500.xnl_RTparam_name_T_cap_BAP12": "电池组12总容量",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg12": "电池组12充电请求电压",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg12": "电池组12充电请求电流",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg12": "电池组12放电请求电流",
  "common.50500.xnl_RTparam_name_Max_V_BAP12": "电池组12电池最大电压",
  "common.50500.xnl_RTparam_name_MIN_V_BAP12": "电池组12电池最小电压",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP12": "电池组12循环次数",
  "common.50500.xnl_RTparam_name_Warn_BAP12": "电池组12告警",
  "common.50500.xnl_RTparam_name_Fault_BAP12": "电池组12故障",
  "common.50500.xnl_RTparam_name_Vtr13_BAP13": "电池组13总电压",
  "common.50500.xnl_RTparam_name_Cr13_BAP13": "电池组13电流",
  "common.50500.xnl_RTparam_name_T_BAP13": "电池组13温度",
  "common.50500.xnl_RTparam_name_SOC_BAP13": "电池组13SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP13": "电池组13剩余容量",
  "common.50500.xnl_RTparam_name_T_cap_BAP13": "电池组13总容量",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg13": "电池组13充电请求电压",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg13": "电池组13充电请求电流",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg13": "电池组13放电请求电流",
  "common.50500.xnl_RTparam_name_Max_V_BAP13": "电池组13电池最大电压",
  "common.50500.xnl_RTparam_name_MIN_V_BAP13": "电池组13电池最小电压",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP13": "电池组13循环次数",
  "common.50500.xnl_RTparam_name_Warn_BAP13": "电池组13告警",
  "common.50500.xnl_RTparam_name_Fault_BAP13": "电池组13故障",
  "common.50500.xnl_RTparam_name_Vtr14_BAP14": "电池组14总电压",
  "common.50500.xnl_RTparam_name_Cr14_BAP14": "电池组14电流",
  "common.50500.xnl_RTparam_name_T_BAP14": "电池组14温度",
  "common.50500.xnl_RTparam_name_SOC_BAP14": "电池组14SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP14": "电池组14剩余容量",
  "common.50500.xnl_RTparam_name_T_cap_BAP14": "电池组14总容量",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg14": "电池组14充电请求电压",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg14": "电池组14充电请求电流",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg14": "电池组14放电请求电流",
  "common.50500.xnl_RTparam_name_Max_V_BAP14": "电池组14电池最大电压",
  "common.50500.xnl_RTparam_name_MIN_V_BAP14": "电池组14电池最小电压",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP14": "电池组14循环次数",
  "common.50500.xnl_RTparam_name_Warn_BAP14": "电池组14告警",
  "common.50500.xnl_RTparam_name_Fault_BAP14": "电池组14故障",
  "common.50500.xnl_RTparam_name_Vtr15_BAP15": "电池组15总电压",
  "common.50500.xnl_RTparam_name_Cr15_BAP15": "电池组15电流",
  "common.50500.xnl_RTparam_name_T_BAP15": "电池组15温度",
  "common.50500.xnl_RTparam_name_SOC_BAP15": "电池组15SoC",
  "common.50500.xnl_RTparam_name_Re_cap_BAP15": "电池组15剩余容量",
  "common.50500.xnl_RTparam_name_T_cap_BAP15": "电池组15总容量",
  "common.50500.xnl_RTparam_name_BAP_r_Vcg15": "电池组15充电请求电压",
  "common.50500.xnl_RTparam_name_BAP_r_Ccg15": "电池组15充电请求电流",
  "common.50500.xnl_RTparam_name_BAP_r_Cdcg15": "电池组15放电请求电流",
  "common.50500.xnl_RTparam_name_Max_V_BAP15": "电池组15电池最大电压",
  "common.50500.xnl_RTparam_name_MIN_V_BAP15": "电池组15电池最小电压",
  "common.50500.xnl_RTparam_name_Cycle_t_BAP15": "电池组15循环次数",
  "common.50500.xnl_RTparam_name_Warn_BAP15": "电池组15告警",
  "common.50500.xnl_RTparam_name_Fault_BAP15": "电池组15故障",
  "common.50500.xnl_RTparam_name_yr1": "年",
  "common.50500.xnl_RTparam_name_mon1": "月",
  "common.50500.xnl_RTparam_name_tdy1": "日",
  "common.50500.xnl_RTparam_name_hou1": "时",
  "common.50500.xnl_RTparam_name_min1": "分",
  "common.50500.xnl_RTparam_name_sec1": "秒",
  "common.50500.xnl_RTparam_name_BMS_D_V": "BMS放电电压",
  "common.50500.xnl_RTparam_name_BMS_B_Ccg_thd1": "BMS电池充电限流",
  "common.50500.xnl_RTparam_name_BMS_B_Cdcg_thd1": "BMS电池放电限流",
  "common.50500.xnl_RTparam_name_B_R_P": "BMS剩余电量",
  "common.50500.xnl_RTparam_name_BMS_B_V1": "BMS电池电压",
  "common.50500.xnl_RTparam_name_BMS_B_C1": "BMS电池电流",
  "common.50500.xnl_RTparam_name_BMST": "BMS温度",
  "common.50500.xnl_RTparam_name_BCT": "电池类型",
  "common.50500.xnl_RTparam_name_HF_1": "历史故障1",
  "common.50500.xnl_RTparam_name_HF_2": "历史故障2",
  "common.50500.xnl_RTparam_name_HF_3": "历史故障3",
  "common.50500.xnl_RTparam_name_HF_4": "历史故障4",
  "common.50500.xnl_RTparam_name_HF_5": "历史故障5",
  "common.50500.xnl_RTparam_name_HF_6": "历史故障6",
  "common.50500.xnl_RTparam_name_HF_7": "历史故障7",
  "common.50500.xnl_RTparam_name_HF_8": "历史故障8",
  "common.50500.xnl_RTparam_name_HF_9": "历史故障9",
  "common.50500.xnl_RTparam_name_HF_10": "历史故障10",
  "common.50500.xnl_RTparam_name_HF_11": "历史故障11",
  "common.50500.xnl_RTparam_name_HF_12": "历史故障12",
  "common.50500.xnl_RTparam_name_HF_13": "历史故障13",
  "common.50500.xnl_RTparam_name_G_V_L3": "电网电压 L3",
  "common.50500.xnl_RTparam_name_G_V_L1_L3": "电网侧电压L1-L3",
  "common.50500.xnl_RTparam_name_G_V_L2_L3": "电网侧电压L2-L3",
  "common.50500.xnl_RTparam_name_AV3": "交流电压T/W/C",
  "common.50500.xnl_RTparam_name_INV_O_P_L1_L3": "逆变器输出电压L1-L3",
  "common.50500.xnl_RTparam_name_INV_O_P_L2_L3": "逆变器输出电压L2-L3",
  "common.50500.xnl_RTparam_name_C_V_L3": "负载电压 L3",
  "common.50500.xnl_RTparam_name_NA": "NA",
  "common.50500.xnl_RTparam_name_I_O_F3": "逆变器输出频率L3",
  "common.50500.xnl_RTparam_name_G_C_L3": "电网电流 L3",
  "common.50500.xnl_RTparam_name_G_C_C": "电网电流 C",
  "common.50500.xnl_RTparam_name_AC3": "交流电流T/W/C",
  "common.50500.xnl_RTparam_name_G_P_L3": "电网功率 L3",
  "common.50500.xnl_RTparam_name_CT3_P_E": "外置功率 CT3",
  "common.50500.xnl_RTparam_name_INV_O_P_L3": "逆变器输出功率 L3 ",
  "common.50500.xnl_RTparam_name_C_P_L3": "负载功率L3",
  "common.50500.xnl_RTparam_name_C_C_L3": "负载电流 L3",
  "common.50500.xnl_RTparam_name_BMS_C_V": "BMS充电电压",
  "common.50500.xnl_RTparam_name_INV_ADDR": "逆变器地址",
  "50300_E-G3-15-1": "离网SOC低保护",
  "50300_E-G3-15-2": "Back-up端口电压丢失",
  "50300_E-G3-15-3": "CPLD保护",
  "50300_E-G3-15-4": "rsvd",
  "50300_E-G3-15-5": "AC重追故障",
  "50300_E-G3-15-6": "模块故障（副CPU）",
  "50300_E-G3-15-7": "rsvd",
  "50300_E-G3-15-8": "微网故障",
  "50300_E-G3-15-9": "rsvd",
  "50300_E-G3-5-7-0": "PV HCT故障",
  "50300_E-G3-5-7-1": "PV HCT故障",
  "50300_E-G3-5-7-4": "PV HCT故障",
  "50300_E-G3-5-7-5": "PV HCT故障",
  "50300_E-G3-5-7-2": "PV HCT故障",
  "50300_E-G3-5-7-3": "PV HCT故障",
  "50300_E-G3-8-2-10": "组串丢失(组串33~48)",
  "50300_E-G3-8-2-15": "组串丢失(组串33~48)",
  "50300_E-G3-8-2-14": "组串丢失(组串33~48)",
  "50300_E-G3-8-2-13": "组串丢失(组串33~48)",
  "50300_E-G3-8-2-12": "组串丢失(组串33~48)",
  "50300_E-G3-15-0": "Back-up端口欠压故障",
  "50300_E-G3-8-2-11": "组串丢失(组串33~48)",
  "50300_E-G3-13-4-3": "PV单次硬件过流",
  "50300_E-G3-13-4-2": "PV单次硬件过流",
  "50300_E-G3-16-8-15": "历史PV反接警告(组串17~32)",
  "50300_E-G3-13-4-1": "PV单次硬件过流",
  "50300_E-G3-16-8-14": "历史PV反接警告(组串17~32)",
  "50300_E-G3-13-4-0": "PV单次硬件过流",
  "50300_E-G3-13-4-9": "PV单次硬件过流",
  "50300_E-G3-13-4-8": "PV单次硬件过流",
  "50300_E-G3-16-8-13": "历史PV反接警告(组串17~32)",
  "50300_E-G3-13-4-7": "PV单次硬件过流",
  "50300_E-G3-16-8-12": "历史PV反接警告(组串17~32)",
  "50300_E-G3-13-4-6": "PV单次硬件过流",
  "50300_E-G3-16-8-11": "历史PV反接警告(组串17~32)",
  "50300_E-G3-13-4-5": "PV单次硬件过流",
  "50300_E-G3-16-8-10": "历史PV反接警告(组串17~32)",
  "50300_E-G3-13-4-4": "PV单次硬件过流",
  "50300_E-G3-0-2-0704": "电网欠压保护",
  "50300_E-G3-0-2-0703": "电网欠压保护",
  "50300_E-G3-0-2-0702": "电网欠压保护",
  "50300_E-G3-0-2-0701": "电网欠压保护",
  "50300_E-G3-0-2-0707": "电网欠压保护",
  "50300_E-G3-0-2-0706": "电网欠压保护",
  "50300_E-G3-0-2-0705": "电网欠压保护",
  "50300_E-G3-7-0-11": "PV输入过压",
  "50300_E-G3-7-0-10": "PV输入过压",
  "50300_E-G3-7-0-13": "PV输入过压",
  "50300_E-G3-7-0-12": "PV输入过压",
  "50300_E-G3-7-0-15": "PV输入过压",
  "50300_E-G3-7-0-14": "PV输入过压",
  "50300_E-G3-5-7-8": "PV HCT故障",
  "50300_E-G3-5-7-9": "PV HCT故障",
  "50300_E-G3-5-7-6": "PV HCT故障",
  "50300_E-G3-5-7-7": "PV HCT故障",
  "50300_E-G3-7-10-1": "组串过流(组串1~16)",
  "50300_E-G3-7-10-0": "组串过流(组串1~16)",
  "50300_E-G3-7-10-3": "组串过流(组串1~16)",
  "50300_E-G3-7-10-2": "组串过流(组串1~16)",
  "50300_E-G3-7-10-5": "组串过流(组串1~16)",
  "50300_E-G3-7-10-4": "组串过流(组串1~16)",
  "50300_E-G3-7-10-7": "组串过流(组串1~16)",
  "50300_E-G3-7-10-6": "组串过流(组串1~16)",
  "50300_E-G3-7-10-9": "组串过流(组串1~16)",
  "50300_E-G3-7-10-8": "组串过流(组串1~16)",
  "50300_E-G3-16-2-0": "内部风扇异常",
  "50300_E-G3-16-2-2": "内部风扇异常",
  "50300_E-G3-16-2-1": "内部风扇异常",
  "50300_E-G3-16-2-3": "内部风扇异常",
  "50300_E-G3-0-10-0102": "电压穿越欠压故障",
  "50300_E-G3-13-12-1": "PID/SVG升压模块故障",
  "50300_E-G3-0-10-0103": "电压穿越欠压故障",
  "50300_E-G3-0-10-0104": "电压穿越欠压故障",
  "50300_E-G3-0-10-0101": "电压穿越欠压故障",
  "50300_E-G3-13-12-0": "PID/SVG升压模块故障",
  "50300_E-G3-1-6": "rsvd",
  "50300_E-G3-1-7": "rsvd",
  "50300_E-G3-1-4": "rsvd",
  "50300_E-G3-1-5": "rsvd",
  "50300_E-G3-1-8": "rsvd",
  "50300_E-G3-1-9": "rsvd",
  "50300_E-G3-5-7-15": "PV HCT故障",
  "50300_E-G3-5-7-13": "PV HCT故障",
  "50300_E-G3-5-7-14": "PV HCT故障",
  "50300_E-G3-5-7-11": "PV HCT故障",
  "50300_E-G3-1-2": "EMS强制离网",
  "50300_E-G3-5-7-12": "PV HCT故障",
  "50300_E-G3-1-3": "rsvd",
  "50300_E-G3-1-0": "电网断电快速保护",
  "50300_E-G3-5-7-10": "PV HCT故障",
  "50300_E-G3-1-1": "电网零线丢失（Split电网）",
  "50300_E-G3-2-15-1": "外部通讯断链",
  "50300_E-G3-2-15-0": "外部通讯断链",
  "50300_E-G3-2-15-3": "外部通讯断链",
  "50300_E-G3-2-15-2": "外部通讯断链",
  "50300_E-G3-2-15-5": "外部通讯断链",
  "50300_E-G3-2-15-4": "外部通讯断链",
  "50300_E-G3-2-15-7": "外部通讯断链",
  "50300_E-G3-2-15-6": "外部通讯断链",
  "50300_E-G3-2-15-9": "外部通讯断链",
  "50300_E-G3-2-15-8": "外部通讯断链",
  "50300_E-G3-4-4-0601": "继电器自检异常",
  "50300_E-G3-13-5-11": "PV单次软件过流",
  "50300_E-G3-13-5-10": "PV单次软件过流",
  "50300_E-G3-13-5-15": "PV单次软件过流",
  "50300_E-G3-13-5-14": "PV单次软件过流",
  "50300_E-G3-13-5-13": "PV单次软件过流",
  "50300_E-G3-13-5-12": "PV单次软件过流",
  "50300_E-G3-1-10": "rsvd",
  "50300_E-G3-1-11": "rsvd",
  "50300_E-G3-1-12": "rsvd",
  "50300_E-G3-1-13": "rsvd",
  "50300_E-G3-1-14": "rsvd",
  "50300_E-G3-1-15": "rsvd",
  "50300_E-G3-9-2": "电池1接入过压",
  "50300_E-G3-9-3": "电池2预充故障",
  "50300_E-G3-9-0": "电池1预充故障",
  "50300_E-G3-9-1": "电池1继电器故障",
  "50300_E-G3-9-6": "电池1反接故障",
  "50300_E-G3-9-7": "电池2反接故障",
  "50300_E-G3-9-4": "电池2继电器故障",
  "50300_E-G3-9-5": "电池2接入过压",
  "50300_E-G3-9-8": "电池异常接入",
  "50300_E-G3-9-9": "rsvd",
  "50300_E-G3-4-13-10": "INV模块过高",
  "50300_E-G3-16-12-3": "组串失配",
  "50300_E-G3-16-12-2": "组串失配",
  "50300_E-G3-16-12-1": "组串失配",
  "50300_E-G3-16-12-0": "组串失配",
  "50300_E-G3-16-12-9": "组串失配",
  "50300_E-G3-16-12-8": "组串失配",
  "50300_E-G3-16-12-7": "组串失配",
  "50300_E-G3-16-12-6": "组串失配",
  "50300_E-G3-16-12-5": "组串失配",
  "50300_E-G3-16-12-4": "组串失配",
  "50300_E-G3-0-11-0302": "电压穿越过压故障",
  "50300_E-G3-0-11-0301": "电压穿越过压故障",
  "50300_E-G3-0-11-0304": "电压穿越过压故障",
  "50300_E-G3-0-11-0303": "电压穿越过压故障",
  "50300_E-G3-16-0": "AC侧SPD故障",
  "50300_E-G3-16-1": "DC侧SPD故障",
  "50300_E-G3-16-2": "内部风扇异常",
  "50300_E-G3-16-3": "外部风扇异常",
  "50300_E-G3-16-4": "PID诊断异常",
  "50300_E-G3-16-5": "脱扣开关跳脱警告",
  "50300_E-G3-16-6": "历史PV IGBT 短路警告",
  "50300_E-G3-16-7": "历史PV反接警告(组串1~16)",
  "50300_E-G3-16-8": "历史PV反接警告(组串17~32)",
  "50300_E-G3-16-9": "Flash读写错误警告",
  "50300_E-G3-15-14": "rsvd",
  "50300_E-G3-15-15": "rsvd",
  "50300_E-G3-15-12": "rsvd",
  "50300_E-G3-15-13": "rsvd",
  "50300_E-G3-15-10": "发电机端口过载",
  "50300_E-G3-15-11": "rsvd",
  "50300_E-G3-13-5-2": "PV单次软件过流",
  "50300_E-G3-13-5-1": "PV单次软件过流",
  "50300_E-G3-13-5-0": "PV单次软件过流",
  "50300_E-G3-13-5-9": "PV单次软件过流",
  "50300_E-G3-13-5-8": "PV单次软件过流",
  "50300_E-G3-13-5-7": "PV单次软件过流",
  "50300_E-G3-13-5-6": "PV单次软件过流",
  "50300_E-G3-13-5-5": "PV单次软件过流",
  "50300_E-G3-13-5-4": "PV单次软件过流",
  "50300_E-G3-13-5-3": "PV单次软件过流",
  "50300_E-G3-7-2-8": "PV持续软件过流",
  "50300_E-G3-7-2-7": "PV持续软件过流",
  "50300_E-G3-7-2-6": "PV持续软件过流",
  "50300_E-G3-7-2-5": "PV持续软件过流",
  "50300_E-G3-7-2-4": "PV持续软件过流",
  "50300_E-G3-7-2-3": "PV持续软件过流",
  "50300_E-G3-7-2-2": "PV持续软件过流",
  "50300_E-G3-7-2-1": "PV持续软件过流",
  "50300_E-G3-7-2-0": "PV持续软件过流",
  "50300_E-G3-14-2": "电池1电压低关机保护(离网模式)",
  "50300_E-G3-14-3": "电池1异常接入",
  "50300_E-G3-14-4": "电池1异常断开",
  "50300_E-G3-14-5": "电池2硬件过流",
  "50300_E-G3-14-6": "电池2软件过流",
  "50300_E-G3-14-7": "电池2电压低关机保护(离网模式)",
  "50300_E-G3-14-8": "电池2异常接入",
  "50300_E-G3-14-9": "电池2异常断开",
  "50300_E-G3-14-0": "电池1硬件过流",
  "50300_E-G3-14-1": "电池1软件过流",
  "50300_E-G3-0-11-0201": "电压穿越过压故障",
  "50300_E-G3-0-11-0203": "电压穿越过压故障",
  "50300_E-G3-0-11-0202": "电压穿越过压故障",
  "50300_E-G3-0-11-0204": "电压穿越过压故障",
  "50300_E-G3-200-5": "并机通信超时停机",
  "50300_E-G3-7-12": "组串反接(组串1~16)",
  "50300_E-G3-7-11": "组串过流(组串17~32)",
  "50300_E-G3-7-10": "组串过流(组串1~16)",
  "50300_E-G3-7-2-9": "PV持续软件过流",
  "50300_E-G3-7-15": "组串丢失(组串17~32)",
  "50300_E-G3-7-14": "组串丢失(组串1~16)",
  "50300_E-G3-7-13": "组串反接(组串17~32)",
  "50300_E-G3-2-5": "DCI二级保护",
  "50300_E-G3-2-6": "绝缘阻抗低",
  "50300_E-G3-2-3": "Gfci缓变保护",
  "50300_E-G3-2-4": "DCI一级保护",
  "50300_E-G3-2-9": "DCV一级保护",
  "50300_E-G3-2-7": "系统接地异常",
  "50300_E-G3-2-8": "火线对地短路",
  "50300_E-G3-2-1": "60mAGfci保护",
  "50300_E-G3-2-2": "150mAGfci保护",
  "50300_E-G3-2-0": "30mAGfci保护",
  "50300_E-G3-7-8-12": "飞跨电容预充失败",
  "50300_E-G3-7-8-13": "飞跨电容预充失败",
  "50300_E-G3-7-8-14": "飞跨电容预充失败",
  "50300_E-G3-7-8-15": "飞跨电容预充失败",
  "50300_E-G3-16-3-1": "外部风扇异常",
  "50300_E-G3-7-8-10": "飞跨电容预充失败",
  "50300_E-G3-16-3-0": "外部风扇异常",
  "50300_E-G3-7-8-11": "飞跨电容预充失败",
  "50300_E-G3-16-3-3": "外部风扇异常",
  "50300_E-G3-16-3-2": "外部风扇异常",
  "50300_E-G3-16-3-5": "外部风扇异常",
  "50300_E-G3-16-3-4": "外部风扇异常",
  "50300_E-G3-16-3-7": "外部风扇异常",
  "50300_E-G3-16-3-6": "外部风扇异常",
  "50300_E-G3-16-3-9": "外部风扇异常",
  "50300_E-G3-16-3-8": "外部风扇异常",
  "50300_E-G3-7-11-0": "组串过流(组串17~32)",
  "50300_E-G3-7-11-2": "组串过流(组串17~32)",
  "50300_E-G3-7-11-1": "组串过流(组串17~32)",
  "50300_E-G3-7-11-4": "组串过流(组串17~32)",
  "50300_E-G3-7-11-3": "组串过流(组串17~32)",
  "50300_E-G3-7-11-6": "组串过流(组串17~32)",
  "50300_E-G3-7-11-5": "组串过流(组串17~32)",
  "50300_E-G3-7-11-8": "组串过流(组串17~32)",
  "50300_E-G3-7-11-7": "组串过流(组串17~32)",
  "50300_E-G3-7-11-9": "组串过流(组串17~32)",
  "50300_E-G3-10-15": "rsvd",
  "50300_E-G3-10-14": "rsvd",
  "50300_E-G3-10-13": "rsvd",
  "50300_E-G3-10-12": "rsvd",
  "50300_E-G3-10-11": "rsvd",
  "50300_E-G3-10-10": "rsvd",
  "50300_E-G3-11-1-0": "基准电压异常",
  "50300_E-G3-0-10-0003": "电压穿越欠压故障",
  "50300_E-G3-0-10-0004": "电压穿越欠压故障",
  "50300_E-G3-0-10-0001": "电压穿越欠压故障",
  "50300_E-G3-0-10-0002": "电压穿越欠压故障",
  "50300_E-G3-4-4-0701": "继电器自检异常",
  "50300_E-G3-0-2-0003": "电网欠压保护",
  "50300_E-G3-0-2-0002": "电网欠压保护",
  "50300_E-G3-0-2-0001": "电网欠压保护",
  "50300_E-G3-0-2-0004": "电网欠压保护",
  "50300_E-G3-5-1-15": "PV IGBT 短路故障",
  "50300_E-G3-5-1-10": "PV IGBT 短路故障",
  "50300_E-G3-5-1-11": "PV IGBT 短路故障",
  "50300_E-G3-5-1-12": "PV IGBT 短路故障",
  "50300_E-G3-5-1-13": "PV IGBT 短路故障",
  "50300_E-G3-5-1-14": "PV IGBT 短路故障",
  "50300_E-G3-7-12-11": "组串反接(组串1~16)",
  "50300_E-G3-7-12-12": "组串反接(组串1~16)",
  "50300_E-G3-7-12-10": "组串反接(组串1~16)",
  "50300_E-G3-7-12-15": "组串反接(组串1~16)",
  "50300_E-G3-7-12-13": "组串反接(组串1~16)",
  "50300_E-G3-7-12-14": "组串反接(组串1~16)",
  "50300_E-G3-2-12-13": "内部通讯断链",
  "50300_E-G3-2-12-12": "内部通讯断链",
  "50300_E-G3-2-12-11": "内部通讯断链",
  "50300_E-G3-2-12-10": "内部通讯断链",
  "50300_E-G3-2-12-15": "内部通讯断链",
  "50300_E-G3-2-12-14": "内部通讯断链",
  "50300_E-G3-4-11": "交流端子温度过高",
  "50300_E-G3-4-10": "直流拉弧自检故障",
  "50300_E-G3-4-13": "INV模块过高",
  "50300_E-G3-4-12": "腔体温度过高",
  "50300_E-G3-4-15": "输出滤波电容过温",
  "50300_E-G3-4-14": "Boost模块温度过高",
  "50300_E-G3-0-1-0302": "电网过压保护",
  "50300_E-G3-0-1-0303": "电网过压保护",
  "50300_E-G3-0-1-0301": "电网过压保护",
  "50300_E-G3-0-1-0304": "电网过压保护",
  "50300_E-G3-6-10": "NBUS过压(CPLD)",
  "50300_E-G3-6-11": "MOS持续过压",
  "50300_E-G3-6-14": "DC侧采样异常",
  "50300_E-G3-6-12": "BUS短路故障",
  "50300_E-G3-6-13": "BUS采样异常",
  "50300_E-G3-13-13": "单路飞跨电容无法预充",
  "50300_E-G3-13-12": "PID/SVG升压模块故障",
  "50300_E-G3-13-15": "SVG预充失败",
  "50300_E-G3-13-14": "Mos单次硬件过压",
  "50300_E-G3-13-11": "SPS欠压",
  "50300_E-G3-13-10": "T相逆变软件过流",
  "50300_E-G3-7-9-14": "飞跨电容无法预充",
  "50300_E-G3-7-9-13": "飞跨电容无法预充",
  "50300_E-G3-7-9-15": "飞跨电容无法预充",
  "50300_E-G3-7-9-10": "飞跨电容无法预充",
  "50300_E-G3-7-9-12": "飞跨电容无法预充",
  "50300_E-G3-7-9-11": "飞跨电容无法预充",
  "50300_E-G3-13-6-1": "PV能量低",
  "50300_E-G3-13-6-0": "PV能量低",
  "50300_E-G3-13-6-9": "PV能量低",
  "50300_E-G3-0-1-0706": "电网过压保护",
  "50300_E-G3-13-6-8": "PV能量低",
  "50300_E-G3-0-1-0707": "电网过压保护",
  "50300_E-G3-13-6-7": "PV能量低",
  "50300_E-G3-0-1-0704": "电网过压保护",
  "50300_E-G3-13-6-6": "PV能量低",
  "50300_E-G3-0-1-0705": "电网过压保护",
  "50300_E-G3-13-6-5": "PV能量低",
  "50300_E-G3-0-1-0702": "电网过压保护",
  "50300_E-G3-13-6-4": "PV能量低",
  "50300_E-G3-0-1-0703": "电网过压保护",
  "50300_E-G3-13-6-3": "PV能量低",
  "50300_E-G3-13-6-2": "PV能量低",
  "50300_E-G3-0-1-0701": "电网过压保护",
  "50300_E-G3-3-4": "发电机故障",
  "50300_E-G3-3-5": "外接STS故障",
  "50300_E-G3-3-2": "并网中同步超时故障",
  "50300_E-G3-3-3": "外接Box故障",
  "50300_E-G3-3-8": "Bypass过载",
  "50300_E-G3-2-15-13": "外部通讯断链",
  "50300_E-G3-3-9": "黑启动故障",
  "50300_E-G3-2-15-14": "外部通讯断链",
  "50300_E-G3-3-6": "CT丢失故障",
  "50300_E-G3-2-15-15": "外部通讯断链",
  "50300_E-G3-3-7": "防逆流故障",
  "50300_E-G3-2-15-10": "外部通讯断链",
  "50300_E-G3-2-15-11": "外部通讯断链",
  "50300_E-G3-2-15-12": "外部通讯断链",
  "50300_E-G3-7-1-9": "PV持续硬件过流",
  "50300_E-G3-7-1-8": "PV持续硬件过流",
  "50300_E-G3-7-1-7": "PV持续硬件过流",
  "50300_E-G3-7-1-6": "PV持续硬件过流",
  "50300_E-G3-7-1-5": "PV持续硬件过流",
  "50300_E-G3-7-1-4": "PV持续硬件过流",
  "50300_E-G3-7-1-3": "PV持续硬件过流",
  "50300_E-G3-7-1-2": "PV持续硬件过流",
  "50300_E-G3-7-1-1": "PV持续硬件过流",
  "50300_E-G3-7-1-0": "PV持续硬件过流",
  "50300_E-G3-3-0": "Back-up端口过载故障",
  "50300_E-G3-3-1": "Back-up端口过压故障",
  "50300_E-G3-5-12-4": "机型识别故障",
  "50300_E-G3-5-12-5": "机型识别故障",
  "50300_E-G3-5-12-6": "机型识别故障",
  "50300_E-G3-5-12-7": "机型识别故障",
  "50300_E-G3-5-12-8": "机型识别故障",
  "50300_E-G3-5-12-9": "机型识别故障",
  "50300_E-G3-5-12-0": "机型识别故障",
  "50300_E-G3-5-12-1": "机型识别故障",
  "50300_E-G3-5-12-2": "机型识别故障",
  "50300_E-G3-5-12-3": "机型识别故障",
  "50300_E-G3-16-4-0": "PID诊断异常",
  "50300_E-G3-16-4-2": "PID诊断异常",
  "50300_E-G3-16-4-1": "PID诊断异常",
  "50300_E-G3-16-4-4": "PID诊断异常",
  "50300_E-G3-16-4-3": "PID诊断异常",
  "50300_E-G3-0-10-0301": "电压穿越欠压故障",
  "50300_E-G3-0-10-0302": "电压穿越欠压故障",
  "50300_E-G3-0-10-0303": "电压穿越欠压故障",
  "50300_E-G3-4-4-0403": "继电器自检异常",
  "50300_E-G3-4-4-0402": "继电器自检异常",
  "50300_E-G3-0-10-0304": "电压穿越欠压故障",
  "50300_E-G3-4-4-0401": "继电器自检异常",
  "50300_E-G3-16-3-10": "外部风扇异常",
  "50300_E-G3-16-3-11": "外部风扇异常",
  "50300_E-G3-7-9-9": "飞跨电容无法预充",
  "50300_E-G3-7-9-8": "飞跨电容无法预充",
  "50300_E-G3-7-9-7": "飞跨电容无法预充",
  "50300_E-G3-7-9-6": "飞跨电容无法预充",
  "50300_E-G3-7-9-5": "飞跨电容无法预充",
  "50300_E-G3-7-9-4": "飞跨电容无法预充",
  "50300_E-G3-7-9-3": "飞跨电容无法预充",
  "50300_E-G3-7-9-2": "飞跨电容无法预充",
  "50300_E-G3-13-14-0": "Mos单次硬件过压",
  "50300_E-G3-13-14-2": "Mos单次硬件过压",
  "50300_E-G3-13-14-1": "Mos单次硬件过压",
  "50300_E-G3-13-14-3": "Mos单次硬件过压",
  "50300_E-G3-7-9-1": "飞跨电容无法预充",
  "50300_E-G3-7-9-0": "飞跨电容无法预充",
  "50300_E-G3-4-13-1": "INV模块过高",
  "50300_E-G3-4-13-0": "INV模块过高",
  "50300_E-G3-4-13-5": "INV模块过高",
  "50300_E-G3-4-13-4": "INV模块过高",
  "50300_E-G3-4-13-3": "INV模块过高",
  "50300_E-G3-4-13-2": "INV模块过高",
  "50300_E-G3-4-13-9": "INV模块过高",
  "50300_E-G3-4-13-8": "INV模块过高",
  "50300_E-G3-4-13-7": "INV模块过高",
  "50300_E-G3-4-13-6": "INV模块过高",
  "50300_E-G3-0-1-0607": "电网过压保护",
  "50300_E-G3-0-1-0605": "电网过压保护",
  "50300_E-G3-0-1-0606": "电网过压保护",
  "50300_E-G3-0-1-0603": "电网过压保护",
  "50300_E-G3-0-1-0604": "电网过压保护",
  "50300_E-G3-0-1-0601": "电网过压保护",
  "50300_E-G3-0-1-0602": "电网过压保护",
  "50300_E-G3-7-11-11": "组串过流(组串17~32)",
  "50300_E-G3-7-11-10": "组串过流(组串17~32)",
  "50300_E-G3-7-11-13": "组串过流(组串17~32)",
  "50300_E-G3-7-11-12": "组串过流(组串17~32)",
  "50300_E-G3-7-11-15": "组串过流(组串17~32)",
  "50300_E-G3-7-11-14": "组串过流(组串17~32)",
  "50300_E-G3-3-10": "并机IO自检异常",
  "50300_E-G3-5-2-10": "PV IGBT开路故障",
  "50300_E-G3-3-12": "并机电网接反",
  "50300_E-G3-5-2-11": "PV IGBT开路故障",
  "50300_E-G3-3-11": "并机CAN通讯异常",
  "50300_E-G3-5-2-12": "PV IGBT开路故障",
  "50300_E-G3-3-14": "逆变软启动失败",
  "50300_E-G3-5-2-13": "PV IGBT开路故障",
  "50300_E-G3-3-13": "并机Back-up接反",
  "50300_E-G3-5-2-14": "PV IGBT开路故障",
  "50300_E-G3-5-2-15": "PV IGBT开路故障",
  "50300_E-G3-3-15": "离网输出瞬时过压故障",
  "50300_E-G3-14-10-10": "PCS充放电电压电流保护",
  "50300_E-G3-14-10-11": "PCS充放电电压电流保护",
  "50300_E-G3-14-10-12": "PCS充放电电压电流保护",
  "50300_E-G3-14-10-13": "PCS充放电电压电流保护",
  "50300_E-G3-14-10-14": "PCS充放电电压电流保护",
  "50300_E-G3-14-10-15": "PCS充放电电压电流保护",
  "50300_E-G3-8-3-8": "组串过流(组串33~48)",
  "50300_E-G3-8-3-7": "组串过流(组串33~48)",
  "50300_E-G3-8-3-9": "组串过流(组串33~48)",
  "50300_E-G3-7-1-10": "PV持续硬件过流",
  "50300_E-G3-7-1-12": "PV持续硬件过流",
  "50300_E-G3-7-1-11": "PV持续硬件过流",
  "50300_E-G3-7-1-14": "PV持续硬件过流",
  "50300_E-G3-7-1-13": "PV持续硬件过流",
  "50300_E-G3-7-1-15": "PV持续硬件过流",
  "50300_E-G3-8-3-4": "组串过流(组串33~48)",
  "50300_E-G3-8-3-3": "组串过流(组串33~48)",
  "50300_E-G3-8-3-6": "组串过流(组串33~48)",
  "50300_E-G3-8-3-5": "组串过流(组串33~48)",
  "50300_E-G3-8-3-0": "组串过流(组串33~48)",
  "50300_E-G3-8-3-2": "组串过流(组串33~48)",
  "50300_E-G3-8-3-1": "组串过流(组串33~48)",
  "50300_E-G3-7-14-10": "组串丢失(组串1~16)",
  "50300_E-G3-7-14-14": "组串丢失(组串1~16)",
  "50300_E-G3-7-14-13": "组串丢失(组串1~16)",
  "50300_E-G3-7-14-12": "组串丢失(组串1~16)",
  "50300_E-G3-7-14-11": "组串丢失(组串1~16)",
  "50300_E-G3-3-10-8": "并机IO自检异常",
  "50300_E-G3-3-10-9": "并机IO自检异常",
  "50300_E-G3-3-10-6": "并机IO自检异常",
  "50300_E-G3-3-10-7": "并机IO自检异常",
  "50300_E-G3-3-10-4": "并机IO自检异常",
  "50300_E-G3-3-10-5": "并机IO自检异常",
  "50300_E-G3-3-10-2": "并机IO自检异常",
  "50300_E-G3-3-10-3": "并机IO自检异常",
  "50300_E-G3-3-10-0": "并机IO自检异常",
  "50300_E-G3-7-14-15": "组串丢失(组串1~16)",
  "50300_E-G3-3-10-1": "并机IO自检异常",
  "50300_E-G3-0-2-0605": "电网欠压保护",
  "50300_E-G3-0-2-0604": "电网欠压保护",
  "50300_E-G3-0-2-0603": "电网欠压保护",
  "50300_E-G3-0-2-0602": "电网欠压保护",
  "50300_E-G3-0-2-0607": "电网欠压保护",
  "50300_E-G3-0-2-0606": "电网欠压保护",
  "50300_E-G3-0-2-0601": "电网欠压保护",
  "50300_E-G3-8-2-9": "组串丢失(组串33~48)",
  "50300_E-G3-8-2-8": "组串丢失(组串33~48)",
  "50300_E-G3-4-3": "漏电流传感器故障",
  "50300_E-G3-4-4": "继电器自检异常",
  "50300_E-G3-4-1": "交流传感器故障",
  "50300_E-G3-4-2": "漏电流传感器自检异常",
  "50300_E-G3-4-7": "直流拉弧故障（组串33~48）",
  "50300_E-G3-4-8": "Flash读写错误",
  "50300_E-G3-4-5": "继电器故障",
  "50300_E-G3-4-6": "直流拉弧故障（组串17~32）",
  "50300_E-G3-4-9": "直流拉弧故障（组串1~16）",
  "50300_E-G3-7-0-9": "PV输入过压",
  "50300_E-G3-7-0-8": "PV输入过压",
  "50300_E-G3-7-0-7": "PV输入过压",
  "50300_E-G3-7-0-6": "PV输入过压",
  "50300_E-G3-7-0-5": "PV输入过压",
  "50300_E-G3-7-0-4": "PV输入过压",
  "50300_E-G3-7-0-3": "PV输入过压",
  "50300_E-G3-7-0-2": "PV输入过压",
  "50300_E-G3-7-0-1": "PV输入过压",
  "50300_E-G3-7-0-0": "PV输入过压",
  "50300_E-G3-4-0": "交流传感器自检异常",
  "50300_E-G3-8-3-11": "组串过流(组串33~48)",
  "50300_E-G3-8-3-10": "组串过流(组串33~48)",
  "50300_E-G3-8-3-15": "组串过流(组串33~48)",
  "50300_E-G3-8-3-14": "组串过流(组串33~48)",
  "50300_E-G3-8-3-13": "组串过流(组串33~48)",
  "50300_E-G3-8-3-12": "组串过流(组串33~48)",
  "50300_E-G3-0-10-0201": "电压穿越欠压故障",
  "50300_E-G3-0-10-0202": "电压穿越欠压故障",
  "50300_E-G3-0-10-0203": "电压穿越欠压故障",
  "50300_E-G3-0-10-0204": "电压穿越欠压故障",
  "50300_E-G3-9-10": "rsvd",
  "50300_E-G3-9-14": "rsvd",
  "50300_E-G3-9-13": "rsvd",
  "50300_E-G3-9-12": "rsvd",
  "50300_E-G3-9-11": "rsvd",
  "50300_E-G3-9-15": "rsvd",
  "50300_E-G3-7-6-10": "飞跨电容硬件过压",
  "50300_E-G3-7-6-11": "飞跨电容硬件过压",
  "50300_E-G3-7-6-12": "飞跨电容硬件过压",
  "50300_E-G3-7-6-13": "飞跨电容硬件过压",
  "50300_E-G3-7-6-14": "飞跨电容硬件过压",
  "50300_E-G3-7-6-15": "飞跨电容硬件过压",
  "50300_E-G3-4-2-0": "漏电流传感器自检异常",
  "50300_E-G3-4-2-1": "漏电流传感器自检异常",
  "50300_E-G3-4-2-2": "漏电流传感器自检异常",
  "50300_E-G3-4-2-3": "漏电流传感器自检异常",
  "50300_E-G3-4-2-4": "漏电流传感器自检异常",
  "50300_E-G3-4-2-5": "漏电流传感器自检异常",
  "50300_E-G3-4-2-6": "漏电流传感器自检异常",
  "50300_E-G3-4-2-7": "漏电流传感器自检异常",
  "50300_E-G3-16-5-1": "脱扣开关跳脱警告",
  "50300_E-G3-16-5-0": "脱扣开关跳脱警告",
  "50300_E-G3-16-5-3": "脱扣开关跳脱警告",
  "50300_E-G3-16-5-2": "脱扣开关跳脱警告",
  "50300_E-G3-16-5-5": "脱扣开关跳脱警告",
  "50300_E-G3-16-5-4": "脱扣开关跳脱警告",
  "50300_E-G3-16-5-7": "脱扣开关跳脱警告",
  "50300_E-G3-16-5-6": "脱扣开关跳脱警告",
  "50300_E-G3-13-15-1": "SVG预充失败",
  "50300_E-G3-13-15-0": "SVG预充失败",
  "50300_E-G3-13-15-3": "SVG预充失败",
  "50300_E-G3-13-15-2": "SVG预充失败",
  "50300_E-G3-13-15-4": "SVG预充失败",
  "50300_E-G3-4-4-0501": "继电器自检异常",
  "50300_E-G3-16-6-0": "历史PV IGBT 短路警告",
  "50300_E-G3-16-6-2": "历史PV IGBT 短路警告",
  "50300_E-G3-16-6-1": "历史PV IGBT 短路警告",
  "50300_E-G3-16-6-4": "历史PV IGBT 短路警告",
  "50300_E-G3-16-6-3": "历史PV IGBT 短路警告",
  "50300_E-G3-16-6-6": "历史PV IGBT 短路警告",
  "50300_E-G3-16-6-5": "历史PV IGBT 短路警告",
  "50300_E-G3-7-8-2": "飞跨电容预充失败",
  "50300_E-G3-7-8-1": "飞跨电容预充失败",
  "50300_E-G3-7-8-0": "飞跨电容预充失败",
  "50300_E-G3-7-8-9": "飞跨电容预充失败",
  "50300_E-G3-7-8-8": "飞跨电容预充失败",
  "50300_E-G3-7-8-7": "飞跨电容预充失败",
  "50300_E-G3-7-8-6": "飞跨电容预充失败",
  "50300_E-G3-7-8-5": "飞跨电容预充失败",
  "50300_E-G3-7-8-4": "飞跨电容预充失败",
  "50300_E-G3-7-8-3": "飞跨电容预充失败",
  "50300_E-G3-16-15": "地线缺失警告",
  "50300_E-G3-16-13": "CT未接",
  "50300_E-G3-16-14": "CT反接",
  "50300_E-G3-16-11": "PV面板类型识别失败",
  "50300_E-G3-16-12": "组串失配",
  "50300_E-G3-17-0": "组串端子温度高(组串1~8)",
  "50300_E-G3-16-10": "电表通信异常告警",
  "50300_E-G3-17-1": "组串端子温度高(组串9~16)",
  "50300_E-G3-17-2": "组串端子温度高(组串17~20)",
  "50300_E-G3-17-3": "历史PV反接警告(组串33~48)",
  "50300_E-G3-17-4": "电池1电压低",
  "50300_E-G3-17-5": "电池2电压低",
  "50300_E-G3-17-6": "电池电源电压低",
  "50300_E-G3-13-4-10": "PV单次硬件过流",
  "50300_E-G3-13-4-13": "PV单次硬件过流",
  "50300_E-G3-13-4-14": "PV单次硬件过流",
  "50300_E-G3-13-4-11": "PV单次硬件过流",
  "50300_E-G3-13-4-12": "PV单次硬件过流",
  "50300_E-G3-8-2-5": "组串丢失(组串33~48)",
  "50300_E-G3-8-2-4": "组串丢失(组串33~48)",
  "50300_E-G3-8-2-7": "组串丢失(组串33~48)",
  "50300_E-G3-8-2-6": "组串丢失(组串33~48)",
  "50300_E-G3-8-2-1": "组串丢失(组串33~48)",
  "50300_E-G3-8-2-0": "组串丢失(组串33~48)",
  "50300_E-G3-8-2-3": "组串丢失(组串33~48)",
  "50300_E-G3-8-2-2": "组串丢失(组串33~48)",
  "50300_E-G3-13-4-15": "PV单次硬件过流",
  "50300_E-G3-4-9-1": "直流拉弧故障（组串1~16）",
  "50300_E-G3-4-9-2": "直流拉弧故障（组串1~16）",
  "50300_E-G3-4-9-3": "直流拉弧故障（组串1~16）",
  "50300_E-G3-4-9-4": "直流拉弧故障（组串1~16）",
  "50300_E-G3-8-1-9": "组串反接(组串33~48)",
  "50300_E-G3-4-9-0": "直流拉弧故障（组串1~16）",
  "50300_E-G3-8-1-6": "组串反接(组串33~48)",
  "50300_E-G3-5-2": "PV IGBT开路故障",
  "50300_E-G3-4-9-9": "直流拉弧故障（组串1~16）",
  "50300_E-G3-8-1-5": "组串反接(组串33~48)",
  "50300_E-G3-5-3": "NTC异常",
  "50300_E-G3-8-1-8": "组串反接(组串33~48)",
  "50300_E-G3-5-0": "继电器故障2",
  "50300_E-G3-8-1-7": "组串反接(组串33~48)",
  "50300_E-G3-5-1": "PV IGBT 短路故障",
  "50300_E-G3-8-1-2": "组串反接(组串33~48)",
  "50300_E-G3-5-6": "微电子故障",
  "50300_E-G3-4-9-5": "直流拉弧故障（组串1~16）",
  "50300_E-G3-8-1-1": "组串反接(组串33~48)",
  "50300_E-G3-5-7": "PV HCT故障",
  "50300_E-G3-4-9-6": "直流拉弧故障（组串1~16）",
  "50300_E-G3-8-1-4": "组串反接(组串33~48)",
  "50300_E-G3-5-4": "发波异常故障",
  "50300_E-G3-4-9-7": "直流拉弧故障（组串1~16）",
  "50300_E-G3-8-1-3": "组串反接(组串33~48)",
  "50300_E-G3-5-5": "CPU中断异常",
  "50300_E-G3-4-9-8": "直流拉弧故障（组串1~16）",
  "50300_E-G3-8-1-0": "组串反接(组串33~48)",
  "50300_E-G3-5-8": "1.5V基准异常",
  "50300_E-G3-5-9": "0.3V基准异常",
  "50300_E-G3-17-3-15": "历史PV反接警告(组串33~48)",
  "50300_E-G3-17-3-14": "历史PV反接警告(组串33~48)",
  "50300_E-G3-17-3-11": "历史PV反接警告(组串33~48)",
  "50300_E-G3-7-13-12": "组串反接(组串17~32)",
  "50300_E-G3-17-3-10": "历史PV反接警告(组串33~48)",
  "50300_E-G3-7-13-13": "组串反接(组串17~32)",
  "50300_E-G3-17-3-13": "历史PV反接警告(组串33~48)",
  "50300_E-G3-7-13-10": "组串反接(组串17~32)",
  "50300_E-G3-17-3-12": "历史PV反接警告(组串33~48)",
  "50300_E-G3-7-13-11": "组串反接(组串17~32)",
  "50300_E-G3-7-13-14": "组串反接(组串17~32)",
  "50300_E-G3-7-13-15": "组串反接(组串17~32)",
  "50300_E-G3-11-5": "rsvd",
  "50300_E-G3-7-7-11": "飞跨电容欠压",
  "50300_E-G3-11-6": "rsvd",
  "50300_E-G3-7-7-12": "飞跨电容欠压",
  "50300_E-G3-11-7": "rsvd",
  "50300_E-G3-7-7-13": "飞跨电容欠压",
  "50300_E-G3-11-8": "rsvd",
  "50300_E-G3-7-7-14": "飞跨电容欠压",
  "50300_E-G3-11-9": "rsvd",
  "50300_E-G3-7-7-10": "飞跨电容欠压",
  "50300_E-G3-8-13": "rsvd",
  "50300_E-G3-7-7-15": "飞跨电容欠压",
  "50300_E-G3-8-12": "rsvd",
  "50300_E-G3-8-11": "rsvd",
  "50300_E-G3-8-10": "rsvd",
  "50300_E-G3-11-0": "电池散热器温度过高",
  "50300_E-G3-11-1": "基准电压异常",
  "50300_E-G3-11-2": "rsvd",
  "50300_E-G3-11-3": "rsvd",
  "50300_E-G3-11-4": "rsvd",
  "50300_E-G3-8-15": "rsvd",
  "50300_E-G3-8-14": "rsvd",
  "50300_E-G3-11-14": "rsvd",
  "50300_E-G3-11-15": "rsvd",
  "50300_E-G3-11-10": "rsvd",
  "50300_E-G3-11-11": "rsvd",
  "50300_E-G3-11-12": "rsvd",
  "50300_E-G3-11-13": "rsvd",
  "50300_E-G3-0-2-0304": "电网欠压保护",
  "50300_E-G3-0-2-0303": "电网欠压保护",
  "50300_E-G3-0-2-0302": "电网欠压保护",
  "50300_E-G3-0-2-0301": "电网欠压保护",
  "50300_E-G3-4-4-0201": "继电器自检异常",
  "50300_E-G3-4-4-0203": "继电器自检异常",
  "50300_E-G3-4-4-0202": "继电器自检异常",
  "50300_E-G3-7-14-1": "组串丢失(组串1~16)",
  "50300_E-G3-7-14-0": "组串丢失(组串1~16)",
  "50300_E-G3-7-14-3": "组串丢失(组串1~16)",
  "50300_E-G3-7-14-2": "组串丢失(组串1~16)",
  "50300_E-G3-7-14-5": "组串丢失(组串1~16)",
  "50300_E-G3-7-14-4": "组串丢失(组串1~16)",
  "50300_E-G3-7-14-7": "组串丢失(组串1~16)",
  "50300_E-G3-7-14-6": "组串丢失(组串1~16)",
  "50300_E-G3-7-14-9": "组串丢失(组串1~16)",
  "50300_E-G3-7-14-8": "组串丢失(组串1~16)",
  "50300_E-G3-16-6-8": "历史PV IGBT 短路警告",
  "50300_E-G3-16-6-7": "历史PV IGBT 短路警告",
  "50300_E-G3-16-6-9": "历史PV IGBT 短路警告",
  "50300_E-G3-16-7-7": "历史PV反接警告(组串1~16)",
  "50300_E-G3-16-7-6": "历史PV反接警告(组串1~16)",
  "50300_E-G3-16-7-9": "历史PV反接警告(组串1~16)",
  "50300_E-G3-16-7-8": "历史PV反接警告(组串1~16)",
  "50300_E-G3-4-0-2": "交流传感器自检异常",
  "50300_E-G3-4-0-3": "交流传感器自检异常",
  "50300_E-G3-4-0-4": "交流传感器自检异常",
  "50300_E-G3-4-0-5": "交流传感器自检异常",
  "50300_E-G3-4-0-0": "交流传感器自检异常",
  "50300_E-G3-4-0-1": "交流传感器自检异常",
  "50300_E-G3-4-0-6": "交流传感器自检异常",
  "50300_E-G3-4-0-7": "交流传感器自检异常",
  "50300_E-G3-16-7-1": "历史PV反接警告(组串1~16)",
  "50300_E-G3-16-7-0": "历史PV反接警告(组串1~16)",
  "50300_E-G3-16-7-3": "历史PV反接警告(组串1~16)",
  "50300_E-G3-16-7-2": "历史PV反接警告(组串1~16)",
  "50300_E-G3-16-7-5": "历史PV反接警告(组串1~16)",
  "50300_E-G3-16-7-4": "历史PV反接警告(组串1~16)",
  "50300_E-G3-0-1-0003": "电网过压保护",
  "50300_E-G3-0-1-0004": "电网过压保护",
  "50300_E-G3-0-1-0001": "电网过压保护",
  "50300_E-G3-0-1-0002": "电网过压保护",
  "50300_E-G3-5-0-13": "继电器故障2",
  "50300_E-G3-5-0-12": "继电器故障2",
  "50300_E-G3-5-0-11": "继电器故障2",
  "50300_E-G3-5-0-10": "继电器故障2",
  "50300_E-G3-0-11-0702": "电压穿越过压故障",
  "50300_E-G3-0-11-0701": "电压穿越过压故障",
  "50300_E-G3-0-11-0704": "电压穿越过压故障",
  "50300_E-G3-0-11-0703": "电压穿越过压故障",
  "50300_E-G3-0-11-0706": "电压穿越过压故障",
  "50300_E-G3-0-11-0705": "电压穿越过压故障",
  "50300_E-G3-0-11-0707": "电压穿越过压故障",
  "50300_E-G3-5-0-15": "继电器故障2",
  "50300_E-G3-5-0-14": "继电器故障2",
  "50300_E-G3-7-7-9": "飞跨电容欠压",
  "50300_E-G3-7-7-8": "飞跨电容欠压",
  "50300_E-G3-7-7-7": "飞跨电容欠压",
  "50300_E-G3-7-7-6": "飞跨电容欠压",
  "50300_E-G3-7-7-5": "飞跨电容欠压",
  "50300_E-G3-7-7-4": "飞跨电容欠压",
  "50300_E-G3-7-7-3": "飞跨电容欠压",
  "50300_E-G3-7-7-2": "飞跨电容欠压",
  "50300_E-G3-7-7-1": "飞跨电容欠压",
  "50300_E-G3-7-7-0": "飞跨电容欠压",
  "50300_E-G3-5-10": "CPLD版本识别错误",
  "50300_E-G3-6-1": "上半母线过压",
  "50300_E-G3-6-2": "下半母线过压",
  "50300_E-G3-6-0": "母线过压",
  "50300_E-G3-6-5": "NBUS过压(副CPU1)",
  "50300_E-G3-6-6": "NBUS过压(副CPU2)",
  "50300_E-G3-6-3": "BUS过压(副CPU1)",
  "50300_E-G3-6-4": "PBUS过压(副CPU1)",
  "50300_E-G3-6-9": "PBUS过压(CPLD)",
  "50300_E-G3-6-7": "PBUS过压(副CPU2)",
  "50300_E-G3-6-8": "NBUS过压(副CPU2)",
  "50300_E-G3-14-14": "DAB高压侧硬件过流",
  "50300_E-G3-14-13": "DAB的关断电流超标",
  "50300_E-G3-14-15": "DAB驱动电源欠压",
  "50300_E-G3-14-10": "PCS充放电电压电流保护",
  "50300_E-G3-14-12": "DAB电流过载保护",
  "50300_E-G3-14-11": "逆变多次过流",
  "50300_E-G3-200-13": "一键关断停机",
  "50300_E-G3-16-12-15": "组串失配",
  "50300_E-G3-16-12-12": "组串失配",
  "50300_E-G3-16-12-11": "组串失配",
  "50300_E-G3-16-12-14": "组串失配",
  "50300_E-G3-16-12-13": "组串失配",
  "50300_E-G3-16-12-10": "组串失配",
  "50300_E-G3-2-12-2": "内部通讯断链",
  "50300_E-G3-2-12-1": "内部通讯断链",
  "50300_E-G3-2-12-4": "内部通讯断链",
  "50300_E-G3-2-12-3": "内部通讯断链",
  "50300_E-G3-2-12-6": "内部通讯断链",
  "50300_E-G3-2-12-5": "内部通讯断链",
  "50300_E-G3-2-12-8": "内部通讯断链",
  "50300_E-G3-2-12-7": "内部通讯断链",
  "50300_E-G3-2-12-0": "内部通讯断链",
  "50300_E-G3-2-12-9": "内部通讯断链",
  "50300_E-G3-10-6": "rsvd",
  "50300_E-G3-10-7": "rsvd",
  "50300_E-G3-10-8": "rsvd",
  "50300_E-G3-10-9": "rsvd",
  "50300_E-G3-5-2-1": "PV IGBT开路故障",
  "50300_E-G3-5-2-2": "PV IGBT开路故障",
  "50300_E-G3-5-2-0": "PV IGBT开路故障",
  "50300_E-G3-5-2-5": "PV IGBT开路故障",
  "50300_E-G3-5-2-6": "PV IGBT开路故障",
  "50300_E-G3-5-2-3": "PV IGBT开路故障",
  "50300_E-G3-5-2-4": "PV IGBT开路故障",
  "50300_E-G3-5-2-9": "PV IGBT开路故障",
  "50300_E-G3-5-2-7": "PV IGBT开路故障",
  "50300_E-G3-5-2-8": "PV IGBT开路故障",
  "50300_E-G3-10-0": "rsvd",
  "50300_E-G3-10-1": "rsvd",
  "50300_E-G3-10-2": "rsvd",
  "50300_E-G3-10-3": "rsvd",
  "50300_E-G3-10-4": "rsvd",
  "50300_E-G3-10-5": "rsvd",
  "50300_E-G3-8-1-14": "组串反接(组串33~48)",
  "50300_E-G3-8-1-15": "组串反接(组串33~48)",
  "50300_E-G3-8-1-12": "组串反接(组串33~48)",
  "50300_E-G3-8-1-13": "组串反接(组串33~48)",
  "50300_E-G3-8-1-10": "组串反接(组串33~48)",
  "50300_E-G3-8-1-11": "组串反接(组串33~48)",
  "50300_E-G3-0-5-0101": "电网过频保护",
  "50300_E-G3-4-4-0301": "继电器自检异常",
  "50300_E-G3-0-5-0103": "电网过频保护",
  "50300_E-G3-0-5-0102": "电网过频保护",
  "50300_E-G3-0-5-0104": "电网过频保护",
  "50300_E-G3-0-5-0002": "电网过频保护",
  "50300_E-G3-0-5-0001": "电网过频保护",
  "50300_E-G3-0-15": "电网相序故障",
  "50300_E-G3-0-14": "电网电压不平衡",
  "50300_E-G3-0-13": "电网缺相保护",
  "50300_E-G3-0-5-0004": "电网过频保护",
  "50300_E-G3-0-12": "电压波形检测异常",
  "50300_E-G3-0-5-0003": "电网过频保护",
  "50300_E-G3-0-11": "电压穿越过压故障",
  "50300_E-G3-0-10": "电压穿越欠压故障",
  "50300_E-G3-4-14-0": "Boost模块温度过高",
  "50300_E-G3-4-14-4": "Boost模块温度过高",
  "50300_E-G3-4-14-3": "Boost模块温度过高",
  "50300_E-G3-4-14-2": "Boost模块温度过高",
  "50300_E-G3-4-14-1": "Boost模块温度过高",
  "50300_E-G3-4-14-8": "Boost模块温度过高",
  "50300_E-G3-4-14-7": "Boost模块温度过高",
  "50300_E-G3-4-14-6": "Boost模块温度过高",
  "50300_E-G3-4-14-5": "Boost模块温度过高",
  "50300_E-G3-16-8-6": "历史PV反接警告(组串17~32)",
  "50300_E-G3-16-8-5": "历史PV反接警告(组串17~32)",
  "50300_E-G3-16-8-8": "历史PV反接警告(组串17~32)",
  "50300_E-G3-16-8-7": "历史PV反接警告(组串17~32)",
  "50300_E-G3-16-8-9": "历史PV反接警告(组串17~32)",
  "50300_E-G3-7-15-0": "组串丢失(组串17~32)",
  "50300_E-G3-7-15-2": "组串丢失(组串17~32)",
  "50300_E-G3-7-15-1": "组串丢失(组串17~32)",
  "50300_E-G3-7-15-4": "组串丢失(组串17~32)",
  "50300_E-G3-7-15-3": "组串丢失(组串17~32)",
  "50300_E-G3-7-15-6": "组串丢失(组串17~32)",
  "50300_E-G3-7-15-5": "组串丢失(组串17~32)",
  "50300_E-G3-7-15-8": "组串丢失(组串17~32)",
  "50300_E-G3-7-15-7": "组串丢失(组串17~32)",
  "50300_E-G3-7-15-9": "组串丢失(组串17~32)",
  "50300_E-G3-16-8-0": "历史PV反接警告(组串17~32)",
  "50300_E-G3-16-8-2": "历史PV反接警告(组串17~32)",
  "50300_E-G3-16-8-1": "历史PV反接警告(组串17~32)",
  "50300_E-G3-16-8-4": "历史PV反接警告(组串17~32)",
  "50300_E-G3-16-8-3": "历史PV反接警告(组串17~32)",
  "50300_E-G3-4-7-10": "直流拉弧故障（组串33~48）",
  "50300_E-G3-4-7-11": "直流拉弧故障（组串33~48）",
  "50300_E-G3-4-7-14": "直流拉弧故障（组串33~48）",
  "50300_E-G3-4-7-15": "直流拉弧故障（组串33~48）",
  "50300_E-G3-4-7-12": "直流拉弧故障（组串33~48）",
  "50300_E-G3-4-7-13": "直流拉弧故障（组串33~48）",
  "50300_E-G3-13-6-12": "PV能量低",
  "50300_E-G3-13-6-11": "PV能量低",
  "50300_E-G3-13-6-10": "PV能量低",
  "50300_E-G3-13-6-15": "PV能量低",
  "50300_E-G3-13-6-14": "PV能量低",
  "50300_E-G3-13-6-13": "PV能量低",
  "50300_E-G3-16-6-14": "历史PV IGBT 短路警告",
  "50300_E-G3-16-6-15": "历史PV IGBT 短路警告",
  "50300_E-G3-16-6-12": "历史PV IGBT 短路警告",
  "50300_E-G3-16-6-13": "历史PV IGBT 短路警告",
  "50300_E-G3-16-6-10": "历史PV IGBT 短路警告",
  "50300_E-G3-16-6-11": "历史PV IGBT 短路警告",
  "50300_E-G3-7-6-4": "飞跨电容硬件过压",
  "50300_E-G3-7-6-3": "飞跨电容硬件过压",
  "50300_E-G3-7-6-2": "飞跨电容硬件过压",
  "50300_E-G3-7-6-1": "飞跨电容硬件过压",
  "50300_E-G3-7-6-0": "飞跨电容硬件过压",
  "50300_E-G3-0-11-0601": "电压穿越过压故障",
  "50300_E-G3-0-11-0603": "电压穿越过压故障",
  "50300_E-G3-0-11-0602": "电压穿越过压故障",
  "50300_E-G3-0-11-0605": "电压穿越过压故障",
  "50300_E-G3-0-11-0604": "电压穿越过压故障",
  "50300_E-G3-0-11-0607": "电压穿越过压故障",
  "50300_E-G3-0-11-0606": "电压穿越过压故障",
  "50300_E-G3-5-12-15": "机型识别故障",
  "50300_E-G3-5-12-12": "机型识别故障",
  "50300_E-G3-5-12-11": "机型识别故障",
  "50300_E-G3-5-12-14": "机型识别故障",
  "50300_E-G3-5-12-13": "机型识别故障",
  "50300_E-G3-5-12-10": "机型识别故障",
  "50300_E-G3-7-6-9": "飞跨电容硬件过压",
  "50300_E-G3-7-6-8": "飞跨电容硬件过压",
  "50300_E-G3-7-6-7": "飞跨电容硬件过压",
  "50300_E-G3-7-6-6": "飞跨电容硬件过压",
  "50300_E-G3-7-6-5": "飞跨电容硬件过压",
  "50300_E-G3-14-10-8": "PCS充放电电压电流保护",
  "50300_E-G3-14-10-9": "PCS充放电电压电流保护",
  "50300_E-G3-14-10-6": "PCS充放电电压电流保护",
  "50300_E-G3-14-10-7": "PCS充放电电压电流保护",
  "50300_E-G3-14-10-4": "PCS充放电电压电流保护",
  "50300_E-G3-14-10-5": "PCS充放电电压电流保护",
  "50300_E-G3-14-10-2": "PCS充放电电压电流保护",
  "50300_E-G3-14-10-3": "PCS充放电电压电流保护",
  "50300_E-G3-14-10-0": "PCS充放电电压电流保护",
  "50300_E-G3-14-10-1": "PCS充放电电压电流保护",
  "common.50100.Inverter": "逆变器",
  "50300_E-G3-0-11-0102": "电压穿越过压故障",
  "50300_E-G3-0-11-0101": "电压穿越过压故障",
  "50300_E-G3-0-11-0104": "电压穿越过压故障",
  "50300_E-G3-0-11-0103": "电压穿越过压故障",
  "50300_E-G3-13-3": "T相逆变硬件过流",
  "50300_E-G3-13-4": "PV单次硬件过流",
  "50300_E-G3-13-5": "PV单次软件过流",
  "50300_E-G3-13-6": "PV能量低",
  "50300_E-G3-13-7": "单次发波异常",
  "50300_E-G3-13-8": "R相逆变软件过流",
  "50300_E-G3-13-9": "S相逆变软件过流",
  "50300_E-G3-4-7-3": "直流拉弧故障（组串33~48）",
  "50300_E-G3-4-7-4": "直流拉弧故障（组串33~48）",
  "50300_E-G3-4-7-5": "直流拉弧故障（组串33~48）",
  "50300_E-G3-4-7-6": "直流拉弧故障（组串33~48）",
  "50300_E-G3-13-0": "逆变软件过流",
  "50300_E-G3-4-7-0": "直流拉弧故障（组串33~48）",
  "50300_E-G3-13-1": "R相逆变硬件过流",
  "50300_E-G3-4-7-1": "直流拉弧故障（组串33~48）",
  "50300_E-G3-13-2": "S相逆变硬件过流",
  "50300_E-G3-4-7-2": "直流拉弧故障（组串33~48）",
  "50300_E-G3-0-10-0704": "电压穿越欠压故障",
  "50300_E-G3-0-10-0705": "电压穿越欠压故障",
  "50300_E-G3-0-10-0706": "电压穿越欠压故障",
  "50300_E-G3-0-10-0707": "电压穿越欠压故障",
  "50300_E-G3-0-10-0701": "电压穿越欠压故障",
  "50300_E-G3-0-10-0702": "电压穿越欠压故障",
  "50300_E-G3-0-10-0703": "电压穿越欠压故障",
  "50300_E-G3-4-7-7": "直流拉弧故障（组串33~48）",
  "50300_E-G3-4-7-8": "直流拉弧故障（组串33~48）",
  "50300_E-G3-4-7-9": "直流拉弧故障（组串33~48）",
  "50300_E-G3-4-4-0A01": "继电器自检异常",
  "50300_E-G3-4-4-0001": "继电器自检异常",
  "50300_E-G3-4-4-0003": "继电器自检异常",
  "50300_E-G3-4-4-0002": "继电器自检异常",
  "50300_E-G3-7-12-1": "组串反接(组串1~16)",
  "50300_E-G3-7-12-0": "组串反接(组串1~16)",
  "50300_E-G3-7-12-3": "组串反接(组串1~16)",
  "50300_E-G3-7-12-2": "组串反接(组串1~16)",
  "50300_E-G3-7-12-5": "组串反接(组串1~16)",
  "50300_E-G3-7-12-4": "组串反接(组串1~16)",
  "50300_E-G3-7-12-7": "组串反接(组串1~16)",
  "50300_E-G3-7-12-6": "组串反接(组串1~16)",
  "50300_E-G3-7-12-9": "组串反接(组串1~16)",
  "50300_E-G3-7-12-8": "组串反接(组串1~16)",
  "50300_E-G3-5-1-2": "PV IGBT 短路故障",
  "50300_E-G3-5-1-3": "PV IGBT 短路故障",
  "50300_E-G3-5-1-0": "PV IGBT 短路故障",
  "50300_E-G3-5-1-1": "PV IGBT 短路故障",
  "50300_E-G3-5-1-6": "PV IGBT 短路故障",
  "50300_E-G3-5-1-7": "PV IGBT 短路故障",
  "50300_E-G3-5-1-4": "PV IGBT 短路故障",
  "50300_E-G3-5-1-5": "PV IGBT 短路故障",
  "50300_E-G3-5-1-8": "PV IGBT 短路故障",
  "50300_E-G3-5-1-9": "PV IGBT 短路故障",
  "50300_E-G3-7-15-11": "组串丢失(组串17~32)",
  "50300_E-G3-7-15-10": "组串丢失(组串17~32)",
  "50300_E-G3-7-15-15": "组串丢失(组串17~32)",
  "50300_E-G3-7-15-14": "组串丢失(组串17~32)",
  "50300_E-G3-7-15-13": "组串丢失(组串17~32)",
  "50300_E-G3-7-15-12": "组串丢失(组串17~32)",
  "50300_E-G3-0-1-0203": "电网过压保护",
  "50300_E-G3-0-1-0204": "电网过压保护",
  "50300_E-G3-0-1-0201": "电网过压保护",
  "50300_E-G3-0-1-0202": "电网过压保护",
  "50300_E-G3-4-6-10": "直流拉弧故障（组串17~43）",
  "50300_E-G3-4-6-15": "直流拉弧故障（组串17~48）",
  "50300_E-G3-4-6-12": "直流拉弧故障（组串17~45）",
  "50300_E-G3-4-6-11": "直流拉弧故障（组串17~44）",
  "50300_E-G3-4-6-14": "直流拉弧故障（组串17~47）",
  "50300_E-G3-4-6-13": "直流拉弧故障（组串17~46）",
  "50300_E-G3-7-5-12": "飞跨电容软件过压",
  "50300_E-G3-7-5-11": "飞跨电容软件过压",
  "50300_E-G3-7-5-10": "飞跨电容软件过压",
  "50300_E-G3-7-5-15": "飞跨电容软件过压",
  "50300_E-G3-7-5-14": "飞跨电容软件过压",
  "50300_E-G3-7-5-13": "飞跨电容软件过压",
  "50300_E-G3-16-9-5": "Flash读写错误警告",
  "50300_E-G3-16-9-4": "Flash读写错误警告",
  "50300_E-G3-4-4-0801": "继电器自检异常",
  "50300_E-G3-0-2-0102": "电网欠压保护",
  "50300_E-G3-0-2-0101": "电网欠压保护",
  "50300_E-G3-16-9-1": "Flash读写错误警告",
  "50300_E-G3-16-9-0": "Flash读写错误警告",
  "50300_E-G3-16-9-3": "Flash读写错误警告",
  "50300_E-G3-0-2-0104": "电网欠压保护",
  "50300_E-G3-16-9-2": "Flash读写错误警告",
  "50300_E-G3-0-2-0103": "电网欠压保护",
  "50300_E-G3-0-6-0103": "电网欠频保护",
  "50300_E-G3-0-6-0104": "电网欠频保护",
  "50300_E-G3-7-5-9": "飞跨电容软件过压",
  "50300_E-G3-7-5-8": "飞跨电容软件过压",
  "50300_E-G3-7-5-7": "飞跨电容软件过压",
  "50300_E-G3-7-5-6": "飞跨电容软件过压",
  "50300_E-G3-16-7-15": "历史PV反接警告(组串1~16)",
  "50300_E-G3-16-7-13": "历史PV反接警告(组串1~16)",
  "50300_E-G3-16-7-14": "历史PV反接警告(组串1~16)",
  "50300_E-G3-16-7-11": "历史PV反接警告(组串1~16)",
  "50300_E-G3-16-7-12": "历史PV反接警告(组串1~16)",
  "50300_E-G3-16-7-10": "历史PV反接警告(组串1~16)",
  "50300_E-G3-0-6-0101": "电网欠频保护",
  "50300_E-G3-0-6-0102": "电网欠频保护",
  "50300_E-G3-7-0": "PV输入过压",
  "50300_E-G3-7-1": "PV持续硬件过流",
  "50300_E-G3-7-4": "rsvd",
  "50300_E-G3-7-5": "飞跨电容软件过压",
  "50300_E-G3-7-2": "PV持续软件过流",
  "50300_E-G3-7-3": "rsvd",
  "50300_E-G3-7-8": "飞跨电容预充失败",
  "50300_E-G3-7-9": "飞跨电容无法预充",
  "50300_E-G3-7-6": "飞跨电容硬件过压",
  "50300_E-G3-7-7": "飞跨电容欠压",
  "50300_E-G3-7-5-5": "飞跨电容软件过压",
  "50300_E-G3-7-5-4": "飞跨电容软件过压",
  "50300_E-G3-7-5-3": "飞跨电容软件过压",
  "50300_E-G3-7-5-2": "飞跨电容软件过压",
  "50300_E-G3-7-5-1": "飞跨电容软件过压",
  "50300_E-G3-7-5-0": "飞跨电容软件过压",
  "50300_E-G3-202-0": "湿度检测异常",
  "50300_E-G3-5-13": "SVG预充失效",
  "50300_E-G3-5-14": "夜间SVG PID预防故障",
  "50300_E-G3-5-11": "CPLD通信故障",
  "50300_E-G3-5-12": "机型识别故障",
  "50300_E-G3-5-15": "DSP版本识别错误",
  "50300_E-G3-0-10-0605": "电压穿越欠压故障",
  "50300_E-G3-0-10-0606": "电压穿越欠压故障",
  "50300_E-G3-0-10-0607": "电压穿越欠压故障",
  "50300_E-G3-0-10-0601": "电压穿越欠压故障",
  "50300_E-G3-0-10-0602": "电压穿越欠压故障",
  "50300_E-G3-0-10-0603": "电压穿越欠压故障",
  "50300_E-G3-0-10-0604": "电压穿越欠压故障",
  "50300_E-G3-12-4": "电网锁相失败",
  "50300_E-G3-12-5": "逆变持续过流",
  "50300_E-G3-12-6": "输出电流不平衡",
  "50300_E-G3-12-7": "绝缘阻抗低",
  "50300_E-G3-12-8": "30mAGfci保护",
  "50300_E-G3-12-9": "60mAGfci保护",
  "50300_E-G3-4-6-4": "直流拉弧故障（组串17~37）",
  "50300_E-G3-4-6-5": "直流拉弧故障（组串17~38）",
  "50300_E-G3-4-6-6": "直流拉弧故障（组串17~39）",
  "50300_E-G3-4-6-7": "直流拉弧故障（组串17~40）",
  "50300_E-G3-12-0": "PV电压低",
  "50300_E-G3-4-6-0": "直流拉弧故障（组串17~33）",
  "50300_E-G3-12-1": "BUS电压低",
  "50300_E-G3-4-6-1": "直流拉弧故障（组串17~34）",
  "50300_E-G3-12-2": "BUS软启失败",
  "50300_E-G3-4-6-2": "直流拉弧故障（组串17~35）",
  "50300_E-G3-12-3": "BUS电压不平衡",
  "50300_E-G3-4-6-3": "直流拉弧故障（组串17~36）",
  "50300_E-G3-0-11-0001": "电压穿越过压故障",
  "50300_E-G3-0-11-0003": "电压穿越过压故障",
  "50300_E-G3-0-11-0002": "电压穿越过压故障",
  "50300_E-G3-0-11-0004": "电压穿越过压故障",
  "50300_E-G3-12-15": "BUS持续过压",
  "50300_E-G3-12-11": "缓变Gfci保护",
  "50300_E-G3-12-12": "并机IO自检失败",
  "50300_E-G3-12-13": "电池BUS软起失败",
  "50300_E-G3-12-14": "电池侧电压低",
  "50300_E-G3-12-10": "150mAGfci保护",
  "50300_E-G3-4-6-8": "直流拉弧故障（组串17~41）",
  "50300_E-G3-4-6-9": "直流拉弧故障（组串17~42）",
  "50300_E-G3-0-2-0201": "电网欠压保护",
  "50300_E-G3-0-2-0204": "电网欠压保护",
  "50300_E-G3-0-2-0203": "电网欠压保护",
  "50300_E-G3-0-2-0202": "电网欠压保护",
  "50300_E-G3-4-4-0B01": "继电器自检异常",
  "50300_E-G3-4-4-0102": "继电器自检异常",
  "50300_E-G3-4-4-0101": "继电器自检异常",
  "50300_E-G3-4-4-0103": "继电器自检异常",
  "50300_E-G3-17-3-9": "历史PV反接警告(组串33~48)",
  "50300_E-G3-0-7": "电网频移保护",
  "50300_E-G3-0-8": "电网相移保护",
  "50300_E-G3-0-5": "电网过频保护",
  "50300_E-G3-0-6": "电网欠频保护",
  "50300_E-G3-0-9": "孤岛保护",
  "50300_E-G3-0-3": "电网过压快速保护",
  "50300_E-G3-0-4": "10min过压保护",
  "50300_E-G3-0-2": "电网欠压保护",
  "50300_E-G3-5-0-0": "继电器故障2",
  "50300_E-G3-5-0-3": "继电器故障2",
  "50300_E-G3-5-0-4": "继电器故障2",
  "50300_E-G3-5-0-1": "继电器故障2",
  "50300_E-G3-5-0-2": "继电器故障2",
  "50300_E-G3-5-0-7": "继电器故障2",
  "50300_E-G3-5-0-8": "继电器故障2",
  "50300_E-G3-5-0-5": "继电器故障2",
  "50300_E-G3-5-0-6": "继电器故障2",
  "50300_E-G3-5-0-9": "继电器故障2",
  "50300_E-G3-17-3-8": "历史PV反接警告(组串33~48)",
  "50300_E-G3-3-4-1": "发电机故障",
  "50300_E-G3-17-3-7": "历史PV反接警告(组串33~48)",
  "50300_E-G3-3-4-2": "发电机故障",
  "50300_E-G3-17-3-6": "历史PV反接警告(组串33~48)",
  "50300_E-G3-17-3-5": "历史PV反接警告(组串33~48)",
  "50300_E-G3-3-4-0": "发电机故障",
  "50300_E-G3-17-3-4": "历史PV反接警告(组串33~48)",
  "50300_E-G3-17-3-3": "历史PV反接警告(组串33~48)",
  "50300_E-G3-17-3-2": "历史PV反接警告(组串33~48)",
  "50300_E-G3-17-3-1": "历史PV反接警告(组串33~48)",
  "50300_E-G3-17-3-0": "历史PV反接警告(组串33~48)",
  "50300_E-G3-3-4-9": "发电机故障",
  "50300_E-G3-3-4-7": "发电机故障",
  "50300_E-G3-3-4-8": "发电机故障",
  "50300_E-G3-3-4-5": "发电机故障",
  "50300_E-G3-3-4-6": "发电机故障",
  "50300_E-G3-3-4-3": "发电机故障",
  "50300_E-G3-3-4-4": "发电机故障",
  "50300_E-G3-7-13-0": "组串反接(组串17~32)",
  "50300_E-G3-7-13-2": "组串反接(组串17~32)",
  "50300_E-G3-7-13-1": "组串反接(组串17~32)",
  "50300_E-G3-7-13-4": "组串反接(组串17~32)",
  "50300_E-G3-7-13-3": "组串反接(组串17~32)",
  "50300_E-G3-7-13-6": "组串反接(组串17~32)",
  "50300_E-G3-7-13-5": "组串反接(组串17~32)",
  "50300_E-G3-7-13-8": "组串反接(组串17~32)",
  "50300_E-G3-7-13-7": "组串反接(组串17~32)",
  "50300_E-G3-7-13-9": "组串反接(组串17~32)",
  "50300_E-G3-3-4-15": "发电机故障",
  "50300_E-G3-3-4-14": "发电机故障",
  "50300_E-G3-3-4-13": "发电机故障",
  "50300_E-G3-3-4-12": "发电机故障",
  "50300_E-G3-3-4-11": "发电机故障",
  "50300_E-G3-3-4-10": "发电机故障",
  "50300_E-G3-0-1-0104": "电网过压保护",
  "50300_E-G3-0-1-0102": "电网过压保护",
  "50300_E-G3-0-1-0103": "电网过压保护",
  "50300_E-G3-0-1-0101": "电网过压保护",
  "50300_E-G3-2-10": "DCV二级保护",
  "50300_E-G3-2-11": "硬件防逆流保护",
  "50300_E-G3-2-12": "内部通讯断链",
  "50300_E-G3-2-13": "漏电流(GFCI)多次故障停机",
  "50300_E-G3-2-14": "直流拉弧(AFCI)多次故障停机",
  "50300_E-G3-2-15": "外部通讯断链",
  "50300_E-G3-4-9-12": "直流拉弧故障（组串1~16）",
  "50300_E-G3-0-6-0002": "电网欠频保护",
  "50300_E-G3-4-9-13": "直流拉弧故障（组串1~16）",
  "50300_E-G3-0-6-0003": "电网欠频保护",
  "50300_E-G3-4-9-10": "直流拉弧故障（组串1~16）",
  "50300_E-G3-4-9-11": "直流拉弧故障（组串1~16）",
  "50300_E-G3-0-6-0001": "电网欠频保护",
  "50300_E-G3-4-9-14": "直流拉弧故障（组串1~16）",
  "50300_E-G3-4-9-15": "直流拉弧故障（组串1~16）",
  "50300_E-G3-4-4-0901": "继电器自检异常",
  "50300_E-G3-3-10-15": "并机IO自检异常",
  "50300_E-G3-7-2-12": "PV持续软件过流",
  "50300_E-G3-7-2-13": "PV持续软件过流",
  "50300_E-G3-7-2-10": "PV持续软件过流",
  "50300_E-G3-7-2-11": "PV持续软件过流",
  "50300_E-G3-7-2-14": "PV持续软件过流",
  "50300_E-G3-7-2-15": "PV持续软件过流",
  "50300_E-G3-3-10-10": "并机IO自检异常",
  "50300_E-G3-3-10-11": "并机IO自检异常",
  "50300_E-G3-3-10-12": "并机IO自检异常",
  "50300_E-G3-3-10-13": "并机IO自检异常",
  "50300_E-G3-3-10-14": "并机IO自检异常",
  "50300_E-G3-0-6-0004": "电网欠频保护",
  "50300_E-G3-7-10-10": "组串过流(组串1~16)",
  "50300_E-G3-7-10-12": "组串过流(组串1~16)",
  "50300_E-G3-6-11-3": "MOS持续过压",
  "50300_E-G3-7-10-11": "组串过流(组串1~16)",
  "50300_E-G3-6-11-2": "MOS持续过压",
  "50300_E-G3-7-10-14": "组串过流(组串1~16)",
  "50300_E-G3-7-10-13": "组串过流(组串1~16)",
  "50300_E-G3-7-10-15": "组串过流(组串1~16)",
  "50300_E-G3-6-11-1": "MOS持续过压",
  "50300_E-G3-6-11-0": "MOS持续过压",
  "50300_E-G3-8-0": "PV接入模式设置错误",
  "50300_E-G3-8-3": "组串过流(组串33~48)",
  "50300_E-G3-8-4": "多路PV错相识别故障",
  "50300_E-G3-8-1": "组串反接(组串33~48)",
  "50300_E-G3-8-2": "组串丢失(组串33~48)",
  "50300_E-G3-8-7": "rsvd",
  "50300_E-G3-8-8": "rsvd",
  "50300_E-G3-8-5": "rsvd",
  "50300_E-G3-8-6": "rsvd",
  "50300_E-G3-8-9": "rsvd",
  "supplier.type.tuobang": "拓邦",
  "validate.email.sendVerificationCodeEmailAddress": "发送验证码",
  "validate.email.getVerificationCode": "获取验证码",
  "login.agreement.and": "和",
  "switchover.switchover.Installers": "我是安装商",
  "login.agreement.readAndAgree": "阅读并同意",
  "jl_param_ctrl_group_GridCodeSetting-\r\nInitialSetting": "电网标准设置-恢复默认设置",
  "retrieve.lable.newPassword": "新密码",
  "switchover.tipsProvisionServices": "让我们为您提供更好的服务",
  "Ajouterbar.plant": "创建电站",
  "register.lable.Email": "邮箱",
  "login.forgotPassword": "忘记密码",
  "validate.tips.PleaseEnterPassword": "请输入密码",
  "validate.email.reacquireCode": "重新获取",
  "validate.email.verificationCodeHasBeenSent": "验证码已发送",
  "register.guidance.toLogin": "已有帐号去登录",
  "register.lable.password": "密码",
  "register.title.WelcomeRegister": "欢迎注册",
  "login.agreement.checkAgreeAgreement": "请先勾选我同意用户协议和隐私协议",
  "register.lable.VerificationCode": "验证码",
  "retrieve.tips.sendVerificationCodeEmailAddress": "验证码已发送到您的{scope}邮箱",
  "switchover.SelectIdentity": "请选择您的身份",
  "register.lable.register": "注册",
  "validate.retrieve.passwordEnteredTwiceInconsistent": "两次输入密码不一致",
  "button.SendVerificationCode": "发送验证码",
  "login.donTHaveAccount": "还没有账号？",
  "validate.tips.passwordRule": "请输入8-10位密码",
  "form.networkCall11": "是否执行配网回调",
  "xnl_runningstatus_name_sleep_mode": "待机",
  "xnl_runningstatus_name_self_check_mode": "自检",
  "xnl_runningstatus_name_normal_mode": "正常",
  "xnl_runningstatus_name_fault_mode": "故障",
  "ASNZ4777-N": "Australia_ASNZ4777-N",
  "CEI 0-21": "Italy_CEI 0-21",
  "custom50": "User defined_Custom50",
  "custom60": "User defined_Custom60",
  "EN50438L": "Cyprus,Finland,Czech,Slovenia,Jamaica_EN50438 L",
  "G83/1-A": "UK_G83/1-A",
  "G83/3": "UK_G83/3",
  "General50": "User defined_General 50",
  "General60": "User defined_General 60",
  "GN300V": "China_GN300V",
  "GNB": "China_GNB",
  "GNC": "China_GNC",
  "ISONE208": "USA_ISONE208",
  "ISONE208A": "USA_ISONE208A",
  "ISONE240": "USA_ISONE240",
  "ISONE240A": "USA_ISONE240A",
  "JAM-230": "Jamaica_JAM-230",
  "MEX": "China_MEX",
  "MEX-A": "Mexico_MEX-A",
  "MEX-N": "MEX-N_MEX-N",
  "NA-EEA-A": "Switzerland_NA-EEA-A",
  "R14-208": "USA_R14-208",
  "R14-208A": "USA_R14-208A",
  "R14-240": "USA_R14-240",
  "R14-240A": "USA_R14-240A",
  "R14H-208": "USA_R14H-208",
  "R14H-240": "USA_R14H-240",
  "R21-208": "USA_R21-208",
  "R21-240": "USA_R21-240",
  "R21P3-208": "USA_R21P3-208",
  "R21P3-20A": "USA_R21P3-20A",
  "R21P3-240": "USA_R21P3-240",
  "R21P3-24A": "USA_R21P3-24A",
  "UL-208V-13": "USA_UL-208V-13",
  "UL-208V-18": "USA_UL-208V-18",
  "UL-208V-A": "USA_UL-208V-A",
  "UL240-13": "USA_UL240-13",
  "UL-240V-18": "USA_UL-240V-18",
  "common.50402.Derating": "降额",
  "common.50402.dispatch": "调度",
  "common.50402.fault": "故障",
  "common.50402.outages": "限电停运",
  "common.50402.generation": "并网发电",
  "common.50402.Standby": "待机",
  "common.50402.Planned": "计划停运",
  "common.50300.offline": "离线",
  "common.50300.Standby": "待机",
  "common.50300.online": "在线",
  "common.50300.fault": "故障",
  "device.category.fox": "Fox",
  "xparam_set.xnl_inverter_Factoryresetenable_disable": "否",
  "param_set.xnl_inverter_Factoryresetenable_enable": "是",
  "param_set.xnl_inverter_GridMode0": "General standard",
  "param_set.xnl_inverter_GridMode1": "UL1741&IEE1547",
  "param_set.xnl_inverter_GridMode2": "CPUC RULE21",
  "param_set.xnl_inverter_GridMode3": "SRD-UL1741",
  "param_set.xnl_inverter_GridMode4": "CEI 0-21",
  "param_set.xnl_inverter_GridType0": "单相240V/230V/220V",
  "param_set.xnl_inverter_GridType1": "两相120V/240V",
  "param_set.xnl_inverter_GridType2": "三相系统208V/120V",
  "param_set.xnl_inverter_GridFrequency0": "否",
  "param_set.xnl_inverter_GridFrequency1": "是",
  "param_set.xnl_inverter_Q(V)0": "否",
  "param_set.xnl_inverter_Q(V)1": "是",
  "param_set.xnl_inverter_SolarArcFaultON0": "关闭",
  "param_set.xnl_inverter_SolarArcFaultON1": "开启",
  "param_set.xnl_inverter_SolarArcFaultON2": "拉弧故障清零",
  "CEI0-21": "Italy_CEI 0-21",
  "common.50700.xnl_RTparam_group_Load": "负载",
  "common.50700.xnl_RTparam_group_Inverter": "逆变器",
  "common.50700.xnl_RTparam_group_Grid": "电网",
  "common.50700.170": "非法",
  "common.50700.169": "工厂测试",
  "common.50700.168": "升级中",
  "common.50700.167": "待机",
  "common.50700.166": "永久性故障",
  "common.50700.165": "故障",
  "common.50700.164": "离网",
  "common.50700.163": "并网",
  "common.50700.162": "检查中",
  "common.50700.161": "等待",
  "common.50700.160": "自检",
  "common.50700.TFreq": "T相频率",
  "common.50700.TCurrent": "T相电流",
  "common.50700.SVolt": "S相电压",
  "common.50700.SPower": "S相功率",
  "common.50700.SOH": "SOH",
  "common.50700.SoC": "SOC",
  "common.50700.SFreq": "S相频率",
  "common.50700.SCurrent": "S相电流",
  "common.50700.RVolt": "R相电压",
  "common.50700.runningState": "运行状态",
  "common.50700.RPower": "R相功率",
  "common.50700.RFreq": "R相频率",
  "common.50700.ResidualEnergy": "电池剩余电量",
  "common.50700.ReactivePower": "无功功率",
  "common.50700.RCurrent": "R相电流",
  "common.50700.pvPower": "PV功率",
  "common.50700.pv9Volt": "PV9电压",
  "common.50700.pv9Power": "PV9功率",
  "common.50700.pv9Current": "PV9电流",
  "common.50700.pv8Volt": "PV8电压",
  "common.50700.pv8Power": "PV8功率",
  "common.50700.pv8Current": "PV8电流",
  "common.50700.pv7Volt": "PV7电压",
  "common.50700.pv7Power": "PV7功率",
  "common.50700.pv7Current": "PV7电流",
  "common.50700.pv6Volt": "PV6电压",
  "common.50700.pv6Power": "PV6功率",
  "common.50700.pv6Current": "PV6电流",
  "common.50700.pv5Volt": "PV5电压",
  "common.50700.pv5Power": "PV5功率",
  "common.50700.pv5Current": "PV5电流",
  "common.50700.pv4Volt": "PV4电压",
  "common.50700.pv4Power": "PV4功率",
  "common.50700.pv4Current": "PV4电流",
  "common.50700.pv3Volt": "PV3电压",
  "common.50700.pv3Power": "PV3功率",
  "common.50700.pv3Current": "PV3电流",
  "common.50700.pv2Volt": "PV2电压",
  "common.50700.pv2Power": "PV2功率",
  "common.50700.pv2Current": "PV2电流",
  "common.50700.pv1Volt": "PV1电压",
  "common.50700.pv1Power": "PV1功率",
  "common.50700.pv1Current": "PV1电流",
  "common.50700.pv18Volt": "PV18电压",
  "common.50700.pv18Power": "PV18功率",
  "common.50700.pv18Current": "PV18电流",
  "common.50700.pv17Volt": "PV17电压",
  "common.50700.pv17Power": "PV17功率",
  "common.50700.pv17Current": "PV17电流",
  "common.50700.pv16Volt": "PV16电压",
  "common.50700.pv16Power": "PV16功率",
  "common.50700.pv16Current": "PV16电流",
  "common.50700.pv15Volt": "PV15电压",
  "common.50700.pv15Power": "PV15功率",
  "common.50700.pv15Current": "PV15电流",
  "common.50700.pv14Volt": "PV14电压",
  "common.50700.pv14Power": "PV14功率",
  "common.50700.pv14Current": "PV14电流",
  "common.50700.pv13Volt": "PV13电压",
  "common.50700.pv13Power": "PV13功率",
  "common.50700.pv13Current": "PV13电流",
  "common.50700.pv12Volt": "PV12电压",
  "common.50700.pv12Power": "PV12功率",
  "common.50700.pv12Current": "PV12电流",
  "common.50700.pv11Volt": "PV11电压",
  "common.50700.pv11Power": "PV11功率",
  "common.50700.pv11Current": "PV11电流",
  "common.50700.pv10Volt": "PV10电压",
  "common.50700.pv10Power": "PV10功率",
  "common.50700.pv10Current": "PV10电流",
  "common.50700.PowerFactor": "功率因数",
  "common.50700.meterPowerT": "电表功率T",
  "common.50700.meterPowerS": "电表功率S",
  "common.50700.meterPowerR": "电表功率R",
  "common.50700.meterPower2": "电表2功率",
  "common.50700.meterPower": "电表功率",
  "common.50700.loadsPowerT": "负载T相功率",
  "common.50700.loadsPowerS": "负载S相功率",
  "common.50700.loadsPowerR": "负载R相功率",
  "common.50700.loadsPower": "负载功率",
  "common.50700.loads": "负载用电量",
  "common.50700.invTemperation": "逆变器温度",
  "common.50700.invBatVolt": "逆变侧电池电压",
  "common.50700.invBatPower": "逆变侧电池功率",
  "common.50700.invBatCurrent": "逆变侧电池电流",
  "common.50700.gridConsumptionPower": "电网损耗功率",
  "common.50700.gridConsumption": "总电网用电量",
  "common.50700.generationPower": "发电功率",
  "common.50700.generation": "累计发电量",
  "common.50700.feedinPower": "并网功率",
  "common.50700.feedin": "馈网总电量",
  "common.50700.epsVoltT": "EPS-T相电压",
  "common.50700.epsVoltS": "EPS-S相电压",
  "common.50700.epsVoltR": "EPS-R相电压",
  "common.50700.epsPowerT": "EPS-T相功率",
  "common.50700.epsPowerS": "EPS-S相功率",
  "common.50700.epsPowerR": "EPS-R相功率",
  "common.50700.epsPower": "EPS功率",
  "common.50700.epsCurrentT": "EPS-T相电流",
  "common.50700.epsCurrentS": "EPS-S相电流",
  "common.50700.epsCurrentR": "EPS-R相电流",
  "common.50700.energyThroughput": "电池吞吐量",
  "common.50700.dspTemperature": "DSP温度",
  "common.50700.dischargeEnergyToTal": "总放电量",
  "common.50700.chargeTemperature": "充电温度",
  "common.50700.chargeEnergyToTal": "总充电量",
  "common.50700.boostTemperation": "充电器温度",
  "common.50700.batVolt": "电池电压",
  "common.50700.batTemperature": "电池温度",
  "common.50700.batStatusV2": "电池状态",
  "common.50700.batStatus": "电池状态",
  "common.50700.batDischargePower": "电池放电功率",
  "common.50700.batCurrent": "电池电流",
  "common.50700.batChargePower": "电池充电功率",
  "common.50700.ambientTemperation": "环境温度",
  "common.50700.xnl_RTparam_group_Battery": "电池",
  "common.50702.xnl_RTparam_group_Battery": "电池",
  "common.50698.TVolt": "T相电压",
  "common.50700.TPower": "T相功率",
  "common.50700.TVolt": "T相电压",
  "param_set.xnl_inverter_Factoryresetenable": "恢复出厂设置",
  "param_set.xnl_inverter_GridMode": "并网标准",
  "param_set.xnl_inverter_GridType": "电网类型设置",
  "param_set.xnl_inverter_GridFrequency": "电网频率设置",
  "param_set.xnl_inverter_Restoreconnectiontime": "恢复并网时间",
  "param_set.xnl_inverter_PF": "输出PF值设定",
  "param_set.xnl_inverter_GridFrequencyOver": "电网频率高保护点",
  "param_set.xnl_inverter_GridFrequencyUnder": "电网频率低保护点",
  "param_set.xnl_inverter_GridVoltageOver": "电网过压保护点",
  "param_set.xnl_inverter_GridVoltageUnder": "电网低压保护点",
  "param_set.xnl_inverter_Q(V)": "加州CA_QV使能",
  "param_set.xnl_inverter_V1": "CA_QV_V1",
  "param_set.xnl_inverter_V2": "CA_QV_V2",
  "param_set.xnl_inverter_V3": "CA_QV_V3",
  "param_set.xnl_inverter_V4": "CA_QV_V4",
  "param_set.xnl_inverter_Q1": "CA_QV_Q1",
  "param_set.xnl_inverter_Q2": "CA_QV_Q2",
  "param_set.xnl_inverter_Q3": "CA_QV_Q3",
  "param_set.xnl_inverter_Q4": "CA_QV_Q4",
  "param_set.xnl_inverter_FW": "加州CA_FW使能",
  "param_set.xnl_inverter_Fstart": "CA_Fstart",
  "param_set.xnl_inverter_Fstop": "CA_Fstop",
  "param_set.xnl_inverter_VW": "加州CA_VW使能",
  "param_set.xnl_inverter_Vstart": "CA_Vstart",
  "param_set.xnl_inverter_Vstop": "CA_Vstop",
  "param_set.xnl_inverter_Normalupwardslope": "正常上升斜率",
  "param_set.xnl_inverter_Softstartriserate": "软启动上升速率",
  "param_set.xnl_inverter_LHVRT": "加州低压高压穿越使能",
  "param_set.xnl_inverter_HV2": "CA_HV2",
  "param_set.xnl_inverter_HV1": "CA_HV1",
  "param_set.xnl_inverter_LV1": "CA_LV1",
  "param_set.xnl_inverter_LV2": "CA_LV2",
  "param_set.xnl_inverter_LV3": "CA_LV3",
  "param_set.xnl_inverter_CA_HV2_Time": "CA_HV2_Time",
  "param_set.xnl_inverter_CA_HV1_Time": "CA_HV1_Time",
  "param_set.xnl_inverter_CA_LV1_Time": "CA_LV1_Time",
  "param_set.xnl_inverter_CA_LV2_Time": "CA_LV2_Time",
  "param_set.xnl_inverter_CA_LV3_Time": "CA_LV3_Time",
  "param_set.xnl_inverter_CA_LHFRT": "加州低频高频穿越CA_LHFRT使能",
  "param_set.xnl_inverter_CA_HF2": "CA_HF2",
  "param_set.xnl_inverter_CA_HF1": "CA_HF1",
  "param_set.xnl_inverter_CA_LF1": "CA_LF1",
  "param_set.xnl_inverter_CA_LF2": "CA_LF2",
  "param_set.xnl_inverter_CA_HF2_Time": "CA_HF2_Time",
  "param_set.xnl_inverter_CA_HF1_Time": "CA_HF1_Time",
  "param_set.xnl_inverter_CA_LF1_Time": "CA_LF1_Time",
  "param_set.xnl_inverter_CA_LF2_Time": "CA_LF2_Time",
  "param_set.xnl_inverter_GeneratorInputRatedPower": "发电机额定输入功率",
  "param_set.xnl_inverter_GENConnectToGridInput": "发电机连接到电网",
  "param_set.xnl_inverter_SmartLoadOutput": "带载功率",
  "param_set.xnl_inverter_OnGridAlwayson00": "开启电网条件",
  "param_set.xnl_inverter_OFF1": "SmartLoad OFF电池电压",
  "param_set.xnl_inverter_ON1": "SmartLoad ON电池电压",
  "param_set.xnl_inverter_OFF2": "SmartLoad OFF电池电量",
  "param_set.xnl_inverter_ON2": "SmartLoad ON电池电量",
  "param_set.xnl_inverter_Battery_Type": "电池类型",
  "param_set.xnl_inverter_Battery_Mode": "电池模式",
  "param_set.xnl_inverter_Activate Battery": "锂电池唤醒标志位",
  "param_set.xnl_inverter_Batt Capacity": "电池容量",
  "param_set.xnl_inverter_MaxACharge": "电池最大充电电流",
  "param_set.xnl_inverter_MaxAdischarge": "电池最大放电电流",
  "param_set.xnl_inverter_GenCharge1": "发电机充电使能",
  "param_set.xnl_inverter_GenSignal1": "Gen信号",
  "param_set.xnl_inverter_GenStartingCapacityPoint2": "发电机充电启动容量点",
  "param_set.xnl_inverter_GenMainsPowerBattery2": "发电机对电池充电电流",
  "param_set.xnl_inverter_MaxRunTime": "发电机最大运行时间",
  "param_set.xnl_inverter_CoolingTime": "发电机冷却时间",
  "param_set.xnl_inverter_GridCharge": "市电充电使能",
  "param_set.xnl_inverter_GridSignal": "Grid信号",
  "param_set.xnl_inverter_StartVoltageMainsPowerCharge1": "市电充电启动容量点",
  "param_set.xnl_inverter_ChargeCurrentBatteryMains1": "市电对电池充电电流",
  "param_set.xnl_inverter_Lithium Protocol": "锂电池通讯选择",
  "param_set.xnl_inverter_ShutDown": "电池关断",
  "param_set.xnl_inverter_Restart": "电池重启",
  "param_set.xnl_inverter_LowBatt": "电池低压",
  "param_set.xnl_inverter_GenSignal ": "市电信号",
  "param_set.xnl_inverter_GenStartVoltageMainsPowerCharge": "发电机充电启动电压点",
  "param_set.xnl_inverter_StartVoltageMainsPowerCharge": "市电充电启动电压点",
  "param_set.xnl_inverter_FloatVoltage": "浮充电压",
  "param_set.xnl_inverter_AbsorptionVoltage": "吸收电压",
  "param_set.xnl_inverter_EqualizationVoltage": "均充电压",
  "param_set.xnl_inverter_EqualizationdayS": "均衡充几天执行一次",
  "param_set.xnl_inverter_TEMPCO": "温度补偿值",
  "param_set.xnl_inverter_Equalizationhours": "均衡充执行时间",
  "param_set.xnl_inverter_batteryresistancevalue": "电池内阻值",
  "param_set.xnl_inverter_GenStartingCapacityPoint": "发电机充电启动容量点",
  "param_set.xnl_inverter_SellingFirst": "卖电优先",
  "param_set.xnl_inverter_Solarsell": "光伏卖电功率",
  "param_set.xnl_inverter_MaxSolarPower": "最大光伏功率",
  "param_set.xnl_inverter_MaxSellPower": "并网最大功率",
  "param_set.xnl_inverter_Zero-Exportpower": "最小起作用功率",
  "param_set.xnl_inverter_EnergyPattern": "能量管理模式",
  "param_set.xnl_inverter_GridPeakShavingPower": "电网调峰",
  "param_set.xnl_inverter_GridGen10": "电网充电使能1",
  "param_set.xnl_inverter_GridGen20": "电网充电使能2",
  "param_set.xnl_inverter_GridGen30": "电网充电使能3",
  "param_set.xnl_inverter_GridGen40": "电网充电使能4",
  "param_set.xnl_inverter_GridGen50": "电网充电使能5",
  "param_set.xnl_inverter_GridGen60": "电网充电使能6",
  "param_set.xnl_inverter_Time1": "时间段1",
  "param_set.xnl_inverter_Time2": "时间段2",
  "param_set.xnl_inverter_Time3": "时间段3",
  "param_set.xnl_inverter_Time4": "时间段4",
  "param_set.xnl_inverter_Time5": "时间段5",
  "param_set.xnl_inverter_Time6": "时间段6",
  "param_set.xnl_inverter_Power1": "功率",
  "param_set.xnl_inverter_Power2": "功率2",
  "param_set.xnl_inverter_Power3": "功率3",
  "param_set.xnl_inverter_Power4": "功率4",
  "param_set.xnl_inverter_Power5": "功率5",
  "param_set.xnl_inverter_Power6": "功率6",
  "param_set.xnl_inverter_BattV1": "电池电压1 ",
  "param_set.xnl_inverter_BattV2": "电池电压2 ",
  "param_set.xnl_inverter_BattV3": "电池电压3 ",
  "param_set.xnl_inverter_BattV4": "电池电压4 ",
  "param_set.xnl_inverter_BattV5": "电池电压5 ",
  "param_set.xnl_inverter_BattV6": "电池电压6 ",
  "param_set.xnl_inverter_Batt1": "电量1",
  "param_set.xnl_inverter_Batt2": "电量2",
  "param_set.xnl_inverter_Batt3": "电量3",
  "param_set.xnl_inverter_Batt4": "电量4",
  "param_set.xnl_inverter_Batt5": "电量5",
  "param_set.xnl_inverter_Batt6": "电量6",
  "param_set.xnl_inverter_SolarArcFaultON": "Arc Fault模式",
  "param_set.xnl_inverter_CTRatio": "CT变比",
  "param_set.xnl_inverter_BackupDelay": "Ups_time",
  "param_set.xnl_inverter_Parallel1": "Parallel",
  "param_set.xnl_inverter_3P1": "三相并机-使能Meter CT",
  "param_set.xnl_inverter_GenCharge": "发电机充电使能",
  "param_set.xnl_inverter_GenChargeCurrentBatterMains": "发电机对电池充电电流",
  "param_set.xnl_inverter_Down Time": "发电机冷却时间",
  "param_set.xnl_inverter_Grid Charge": "市电充电使能",
  "param_set.xnl_inverter_ChargeCurrentBatterMains": "市电对电池充电电流",
  "param_set.xnl_inverter_GenMainsPowerBattery": "发电机对电池充电电流",
  "param_set.xnl_inverter_DownTime": "发电机冷却时间",
  "param_set.xnl_inverter_StartingCapacityPoint": "市电充电启动容量点",
  "param_set.xnl_inverter_MainsPowerBattery": "市电对电池充电电流",
  "param_set.xnl_inverter_Equalizationtime": "均衡充执行时间",
  "param_set.xnl_inverter_Parallel2": "Master",
  "param_set.xnl_inverter_Parallel3": "Phase",
  "param_set.xnl_inverter_Parallel4": "Modbus SN",
  "param_set.xnl_inverter_3P2": "三相并机-A相使能",
  "param_set.xnl_inverter_3P3": "三相并机-B相使能",
  "param_set.xnl_inverter_3P4": "三相并机-C相使能",
  "param_set.xnl_inverter_GridGen11": "柴发/充电使能1",
  "param_set.xnl_inverter_GridGen21": "柴发充电使能2",
  "param_set.xnl_inverter_GridGen31": "柴发充电使能3",
  "param_set.xnl_inverter_GridGen41": "柴发充电使能4",
  "param_set.xnl_inverter_GridGen51": "柴发充电使能5",
  "param_set.xnl_inverter_GridGen61": "柴发充电使能6",
  "param_set.xnl_inverter_OnGridAlwayson04": "开启电网条件-发电机调峰",
  "param_set.xnl_inverter_OnGridAlwayson08": "开启电网条件-电网调峰",
  "param_set.xnl_inverter_OnGridAlwayson12": "开启电网条件- On Grid always on",
  "param_set.xnl_inverter_OnGridAlwayson13": "开启电网条件-external relay",
  "param_set.xnl_inverter_OnGridAlwayson14": "开启电网条件-锂电池丢失报故障使能位",
  "param_set.xnl_inverter_OnGridAlwayson15": "开启电网条件- DRM使能位",
  "param_set.xnl_inverterGroup_BasicSettings": "基础设置",
  "param_set.xnl_inverterGroup_GridSettings": "电网设置",
  "param_set.xnl_inverterGroup_GeneratorSettings": "发电机设置",
  "param_set.xnl_inverterGroup_BatterySettings": "电池设置",
  "param_set.xnl_inverterGroup_SystemOperatingMode": "系统工作模式",
  "param_set.xnl_inverterGroup_AdvancedSettings": "高级设置",
  "supplier.type.ankerui": "安科瑞",
  "subtype.collector.4g.meters": "4G电表",
  "param_set.xnl_inverter_GenSignal_fdj": "发电机信号",
  "param_set.xnl_inverter_GenSignal_charge": "市电信号",
  "param_set.xnl_inverter_GenSignal_fdj_1": "发电机信号1",
  "param_set.xnl_inverter_GenSignal_charge_1": "市电信号1",
  "param_set.xnl_inverter_GenSignal_fdj_2": "发电机信号2",
  "param_set.xnl_inverter_GenSignal_charge_2": "市电信号2",
  "param_set.xnl_inverter_TimeOfUse": "Time of Use",
  "param_set.xnl_inverter_GenPortUsedFor": "发电端口用于",
  "common.50300.todayFeedInGridEnergy": "当日馈网电量",
  "common.50300.totalConsumeEnergy": "累计消耗电量",
  "common.50300.todayConsumeEnergy": "当日消耗电量",
  "common.50300.totalFeedInGridEnergy": "累计馈网电量",
  "common.50300.Ua": "电表电压A",
  "common.50300.Ub": "电表电压B",
  "common.50300.Uc": "电表电压C",
  "common.50300.Ia": "A相电流",
  "common.50300.Pa": "A相有功功率",
  "common.50300.Ib": "B相电流",
  "common.50300.Pb": "B相有功功率",
  "common.50300.Ic": "C相电流",
  "common.50300.Pc": "C相有功功率",
  "common.50300.ctTotalActivePower": "总有功功率",
  "bw_value_ChargeDischargeRelaysAreDisconnected": "充放电继电器断开",
  "bw_value_OnlyDischargeRelayIsClosed": "只有放电继电器闭合",
  "bw_value_OnlyChargeRelayIsClosed": "只有充电继电器闭合",
  "bw_value_ChargeAndDischargeRelaysAreClosed": "充电和放电继电器闭合",
  "bw_value_Single-Phase5KwModel": "单相5KW机型",
  "bw_value_SinglePhaseEnergyStorage5KwModel": "单相储能5KW机型",
  "bw_value_Single-PhaseEnergyStorage3KwModel": "单相储能3KW机型",
  "bw_value_Single-PhaseEnergyStorage6KwModel": "单相储能6KW机型",
  "bw_value_SinglePhaseEnergyStorage8KwModel": "单相储能8KW机型",
  "bw_value_Three-Phase4KwModel": "三相4KW机型",
  "bw_value_Three-Phase5KwModel": "三相5KW机型",
  "bw_value_Three-Phase6KwModel": "三相6KW机型",
  "bw_value_Three-Phase8KwModel": "三相8KW机型",
  "bw_value_ThreePhase10KwModel": "三相10KW机型",
  "common.device.check.tab.collector": "通讯棒",
  "common.device.check.tab.grid": "电网",
  "common.device.check.tab.meterselect": "电表选择",
  "common.device.check.tab.gridmeter": "电网侧电表",
  "common.device.check.tab.pvmeter": "光伏侧电表",
  "common.device.check.tab.battery": "电池",
  "common.check.field.collectorSn": "通讯棒SN",
  "common.check.field.dongleRSSI": "信号强度",
  "common.check.field.inverterHardwareVersion": "通讯棒硬件版本",
  "common.check.field.dongleSoftwareVersion": "通讯棒软件版本 ",
  "common.check.field.gridVoltageR": "电网R相电压",
  "common.check.field.gridVoltageS": "电网S相电压",
  "common.check.field.gridVoltageT": "电网T相电压",
  "common.check.field.meterCTSelect": "电表是否连接",
  "common.check.field.gridVoltageOfAPhase": "电表A相电压",
  "common.check.field.gridCurrentOfAPhaseV2": "电表A相电流",
  "common.check.field.gridVoltageOfBPhase": "电表B相电压",
  "common.check.field.gridCurrentOfBPhaseV2": "电表B相电流",
  "common.check.field.gridVoltageOfCPhase": "电表C相电压",
  "common.check.field.gridCurrentOfCPhaseV2": "电表C相电流",
  "common.check.field.gridFrequent": "电表频率",
  "common.check.field.pvVoltageOfAPhase": "电表A相电压",
  "common.check.field.pvCurrentOfAPhase": "电表A相电流",
  "common.check.field.pvVoltageOfBPhase": "电表B相电压",
  "common.check.field.pvCurrentOfBPhase": "电表B相电流",
  "common.check.field.pvVoltageOfCPhase": "电表C相电压",
  "common.check.field.pvCurrentOfCPhase": "电表C相电流",
  "common.check.field.pvFrequent": "电表频率",
  "common.check.field.pvTotalApparentPower": "电表视在功率（总）",
  "common.check.field.pvMeterTotalActivePower": "电表有功功率（总）",
  "common.check.field.pvTotalReactivePower": "电表无功功率（总）",
  "common.check.field.pvTotalPowerFactor": "电表功率因数（总）",
  "common.check.field.batteryOnlineStatus": "电池是否有效连接",
  "device.category.heatpump": "热泵",
  "device.category.collector": "通讯棒",
  "jl_RTparam_name_powerAmmeter2": "电表2功率",
  "jl_RTparam_name_dayEnergyAmmeter2": "电表2当日电量",
  "jl_RTparam_name_monthEnergyAmmeter2": "电表2当月电量",
  "jl_RTparam_name_yearEnergyAmmeter2": "电表2当年电量",
  "jl_RTparam_name_totalEnergyAmmeter2": "电表2累计电量",
  "jl_RTparam_group_Ammeter": "电表",
  "ai.robot.manage.family": "你好，AI机器人正在管理您的家庭用电。",
  "ai.robot.predicted.price": "已获取今日电价，预测今日发电量为{###}kWh。",
  "ai.robot.regulating.heat.pump": "将在适当情况下调节热泵工作。",
  "bw_RTparam_Option_NoPV": "无PV",
  "bw_RTparam_Option_HasPV": "有PV",
  "bw_RTparam_Option_PVMeterNormal": "光伏电表正常",
  "bw_RTparam_Option_PVMeterReversed": "光伏电表反接",
  "common.device.check.tab.meterYes": "电表连接状态",
  "common.check.field.batteryCommunicationStatus": "工作状态",
  "device.category.module": "组件",
  "50000_0X561-M-12": "电网相序不一致",
  "50000_0X561-M-13": "DCV采样异常",
  "50000_0X561-M-14": "blackbox_flash错误",
  "50000_0X561-M-15": "RTC错误",
  "bw.content.alarm.0X55E-M-60": "电网相序不一致",
  "bw.content.alarm.0X55E-M-61": "DCV采样异常",
  "bw.content.alarm.0X55E-M-62": "blackbox_flash错误",
  "bw.content.alarm.0X55E-M-63": "RTC错误",
  "plant.deliver.type.zj": "海尔智家",
  "deliver.type.energy": "Haier Energy",
  "deliver.type.smart": "海尔智家",
  "dddddddddddd": "33",
  "VDE0126-50Hz": "France--VDE0126-50Hz",
  "VDE4105/11.18": "Germany--VDE4105/11.18",
  "AS4777.2": "Australia--AS4777.2",
  "G83_2": "G83_2",
  "C10/C11": "Belgium--C10/C11",
  "TOR Erzeuger": "Austria--TOR Erzeuger",
  "EN50549-NL": "Netherlands--EN50549-NL",
  "EN50549-DK": "EN50549-DK",
  "CEB": "CEB",
  "CEI-021": "Italy--CEI-021",
  "NRS097-2-1": "South Africa--NRS097-2-1",
  "EN50549-GR": "EN50549-GR",
  "UTE_C15_712": "UTE_C15_712",
  "G59_3": "G59_3",
  "NA": "NA",
  "VDE0126-60Hz": "VDE0126-60Hz",
  "AS4777.2-SA": "Australia--AS4777.2-SA",
  "EN50549-CZ": "EN50549-CZ",
  "BISI": "BISI",
  "JET-GR Series": "JET-GR Series",
  "50Hz Default": "50Hz Default",
  "60Hz Default": "60Hz Default",
  "WAREHOUSE": "WAREHOUSE",
  "AS4777.2-NZ": "Australia--AS4777.2-NZ",
  "Korea": "Korea",
  "G98/G99-IE": "UK--G98/G99-IE",
  "NCRfg": "NCRfg",
  "UL1741": "UL1741",
  "UL1741-Rule21": "UL1741-Rule21",
  "UL1741-Hawaiian": "UL1741-Hawaiian",
  "common.50800.defrosting": "除霜",
  "common.50800.antiFreezing": "防冻",
  "common.50800.sterilization": "杀菌",
  "common.50800.antiRust": "防锈",
  "common.50800.auto": "自动",
  "common.50800.cool": "制冷",
  "common.50800.heat": "制热",
  "common.50800.dhw": "热水",
  "common.50800.pool": "泳池",
  "common.50800.heat+pool": "制热+泳池",
  "common.50800.auto+dhw": "自动+热水",
  "common.50800.cool+dhw": "制冷+热水",
  "common.50800.heat+dhw": "制热+热水",
  "supplier.type.lg": "力高",
  "plant.not.delivered": "电站未交付",
  "plant.not.exist": "电站不存在",
  "device.agent.admin.can.operate": "抱歉,您没有权限撤回交付。仅平台超级管理员、安装商管理员可以撤回交付",
  "setting.type22.singleReverseFlowEnable": "单机防逆流使能",
  "setting.type22.multiReverseFlowEnable": "多机防逆流使能",
  "setting.type22.meterSelect": "电表选择",
  "setting.type22.allowCounterCurrentPower": "允许逆流功率",
  "setting.type22.restrictCounterCurrent": "限制逆流方式",
  "setting.type22.reverseFlowSetting": "防逆流设置",
  "plant.pure.light": "零碳适家-纯光",
  "ywt.60419.loadPower\n": "负载功率",
  "param_set.lg_inverterGroup_LithiumBattery": "锂电池",
  "param_set.lg_inverterGroup_AdvancedSettings": "高级设置",
  "param_set.lg_inverterGroup_SystemOperationMode": "系统工作模式",
  "param_set.lg_inverterGroup_GeneratorSettings": "发电机设置",
  "param_set.lg_inverterGroup_ParallelOperationSettings": "并机设置",
  "param_set.lg_inverterGroup_PeakShavingandValleyFillingSettings": "削峰填谷设置",
  "param_set.lg_inverterGroup_GeneratorInputEnable": "发电机输入使能",
  "param_set.lg_inverterGroup_SmartLoadEnable": "智能负载使能",
  "param_set.lg_inverterGroup_MicroinverterEnable": "微逆使能",
  "param_set.lg_inverterGroup_Battery(Shared)": "电池（共用）",
  "param_set.lg_inverterGroup_Lead-AcidBattery": "铅酸电池",
  "param_set.lg_inverter_SystemOn": "系统开关机",
  "param_set.lg_inverter_ClearFault": "清除故障",
  "param_set.lg_inverter_ManualActivation": "手动激活",
  "param_set.lg_inverter_InverterRated（%）": "逆变功率百分比设置",
  "param_set.lg_inverter_PVActivePowerSetting": "PV有功设定(%)",
  "param_set.lg_inverter_PVConnectorMode": "PV连接设置",
  "param_set.lg_inverter_PVStarupEnable": "单PV开机使能",
  "param_set.lg_inverter_ZeroGroundVoltFaultDetectionEnable": "零地电压故障检测使能",
  "param_set.lg_inverter_GFCIEnable": "漏电流检测使能",
  "param_set.lg_inverter_AllowGridCharging": "允许电网充电",
  "param_set.lg_inverter_PVISOEnable": "PV绝缘检测使能",
  "param_set.lg_inverter_CT/MeterOptional": "CT电表使能位",
  "param_set.lg_inverter_PhaseType": "相序类型",
  "param_set.lg_inverter_CTRatio": "CT比例",
  "param_set.lg_inverter_PVOperationMode": "PV运行模式",
  "param_set.lg_inverter_CVT1CurrentLimit": "CVT1电流限制",
  "param_set.lg_inverter_CVT2CurrentLimit": "CVT2电流限制",
  "param_set.lg_inverter_ChargingCurrent": "充电电流",
  "param_set.lg_inverter_DischargingCurrent": "放电电流",
  "param_set.lg_inverter_FloatChargingVoltage": "浮充电压",
  "param_set.lg_inverter_EqualChargingVoltage": "均充电压",
  "param_set.lg_inverter_CT/MeterAccessDirection": "CT/电表接入方向",
  "param_set.lg_inverter_HomeloadUnbalancedCurrentEnable": "家庭负载不均流使能",
  "param_set.lg_inverter_BMSClearFault": "BMS故障清除",
  "param_set.lg_inverter_AFCIReset": "AFCI重置",
  "param_set.lg_inverter_HMIBrightness": "HMI亮度",
  "param_set.lg_inverter_HMIRestTime": "HMI息屏时间",
  "param_set.lg_inverter_StatisticClear": "清除统计",
  "param_set.lg_inverter_EnergyPattern": "能量管理模式",
  "param_set.lg_inverter_SyncTimeEnable": "时间同步使能",
  "param_set.lg_inverter_RSDEnable": "RSD使能",
  "param_set.lg_inverter_Startuptimesetbytheinstaller": "安装商设定开机时间",
  "param_set.lg_inverter_DynamicPassword": "动态密码",
  "param_set.lg_inverter_ACType": "交流类型",
  "param_set.lg_inverter_ChargingPriorityMode": "充电优先模式",
  "param_set.lg_inverter_SellPowerLimit": "限制并网最大功率输出",
  "param_set.lg_inverter_BuzzerEnable": "蜂鸣器",
  "param_set.lg_inverter_MeterType": "电表类型",
  "param_set.lg_inverter_Specialfeatures": "特殊功能",
  "param_set.lg_inverter_NLineNotGrounded": "N线没有接地",
  "param_set.lg_inverter_AFCIEnable": "拉弧检测使能",
  "param_set.lg_inverter_FactoryReset": "恢复出厂设置",
  "param_set.lg_inverter_AsymmetricPhaseFeeding": "不对称相位馈电",
  "param_set.lg_inverter_ParamsChangeLock": "参数修改锁",
  "param_set.lg_inverter_SystemWorkMode": "系统工作模式",
  "param_set.lg_inverter_SolarSell": "光伏卖电",
  "param_set.lg_inverter_SignalIslandMode": "离网信号输入",
  "param_set.lg_inverter_GridTOUEnable": "电网削峰时间段使能",
  "param_set.lg_inverter_AutoRunEnable": "自动运行使能",
  "param_set.lg_inverter_DRMEnable": "DRM使能",
  "param_set.lg_inverter_Password": "默认密码",
  "param_set.lg_inverter_PasswordValidityTime": "密码有效时间",
  "param_set.lg_inverter_GeneratorStartMode": "发电机启动模式",
  "param_set.lg_inverter_GeneratorManualStartMode": "发电机手动启动",
  "param_set.lg_inverter_Generatorpriority": "发电机优先",
  "param_set.lg_inverter_GeneratorInputPort": "发电机输入端口",
  "param_set.lg_inverter_GeneratorPower": "发电机功率",
  "param_set.lg_inverter_GeneratorStartupVoltage": "发电机开机电压",
  "param_set.lg_inverter_GeneratorShutdownVoltage": "发电机关机电压",
  "param_set.lg_inverter_GeneratorStartupSOC": "发电机启动SOC",
  "param_set.lg_inverter_GeneratorShutdownSOC": "发电机结束SOC（自动启动模式）",
  "param_set.lg_inverter_GeneratorStartSignal": "发电机启动信号",
  "param_set.lg_inverter_GeneratorChargeCurrent": "发电机充电电流",
  "param_set.lg_inverter_GeneratorOperatingTimeLimit": "发电机最大运行时间",
  "param_set.lg_inverter_GeneratorCutOffTime": "发电机截止时间",
  "param_set.lg_inverter_GeneratorTOUEnable": "发电机削峰使能",
  "param_set.lg_inverter_ParallelEnable": "并机使能",
  "param_set.lg_inverter_ParallelAddress": "并机地址",
  "param_set.lg_inverter_ParallelNumber": "并机个数",
  "param_set.lg_inverter_ParallelBatterySharingEnable": "并机电池共享使能",
  "param_set.lg_inverter_ParallelPhase": "并机相序",
  "param_set.lg_inverter_ParallelMode": "并机模式",
  "param_set.lg_inverter_Year/Month": "年/月",
  "param_set.lg_inverter_Day/Reserve": "日/保留",
  "param_set.lg_inverter_Hour/Minute": "时/分",
  "param_set.lg_inverter_Second/Week": "秒/星期",
  "param_set.lg_inverter_TOUStartTime1": "削峰填谷充放电开启时间1",
  "param_set.lg_inverter_TOUEndTime1": "削峰填谷充放电结束时间1",
  "param_set.lg_inverter_Time1TOUPower": "时间1电网充放电功率",
  "param_set.lg_inverter_TOUStartTime2": "削峰填谷充放电开启时间2",
  "param_set.lg_inverter_TOUEndTime2": "削峰填谷充放电结束时间2",
  "param_set.lg_inverter_Time2TOUPower": "时间2电网充放电功率",
  "param_set.lg_inverter_TOUStartTime3": "削峰填谷充放电开启时间3",
  "param_set.lg_inverter_TOUEndTime3": "削峰填谷充放电结束时间3",
  "param_set.lg_inverter_Time3TOUPower": "时间3电网充放电功率",
  "param_set.lg_inverter_TOUStartTime4": "削峰填谷充放电开启时间4",
  "param_set.lg_inverter_TOUEndTime4": "削峰填谷充放电结束时间4",
  "param_set.lg_inverter_Time4TOUPower": "时间4电网充放电功率",
  "param_set.lg_inverter_TOUStartTime5": "削峰填谷充放电开启时间5",
  "param_set.lg_inverter_TOUEndTime5": "削峰填谷充放电结束时间5",
  "param_set.lg_inverter_Time5TOUPower": "时间5电网充放电功率",
  "param_set.lg_inverter_TOUStartTime6": "削峰填谷充放电开启时间6",
  "param_set.lg_inverter_TOUEndTime6": "削峰填谷充放电结束时间6",
  "param_set.lg_inverter_Time6TOUPower": "时间5电网充放电功率",
  "param_set.lg_inverter_Time1TOUSOC": "时间1削峰电池SOC",
  "param_set.lg_inverter_Time2TOUSOC": "时间2削峰电池SOC",
  "param_set.lg_inverter_Time3TOUSOC": "时间3削峰电池SOC",
  "param_set.lg_inverter_Time4TOUSOC": "时间4削峰电池SOC",
  "param_set.lg_inverter_Time5TOUSOC": "时间5削峰电池SOC",
  "param_set.lg_inverter_Time6TOUSOC": "时间6削峰电池SOC",
  "param_set.lg_inverter_Time1TOUVoltage": "时间1削峰电压",
  "param_set.lg_inverter_Time2TOUVoltage": "时间2削峰电压",
  "param_set.lg_inverter_Time3TOUVoltage": "时间3削峰电压",
  "param_set.lg_inverter_Time4TOUVoltage": "时间4削峰电压",
  "param_set.lg_inverter_Time5TOUVoltage": "时间5削峰电压",
  "param_set.lg_inverter_Time6TOUVoltage": "时间6削峰电压",
  "param_set.lg_inverter_TOUWeek": "削峰周参数",
  "param_set.lg_inverter_GENTOUEnable": "发电机削峰时间段使能",
  "param_set.lg_inverter_SmartLoadSetting": "SmartLoad设置",
  "param_set.lg_inverter_SmartLoadStopVoltage": "智能负载关闭电压",
  "param_set.lg_inverter_GeneratorLinktoInput": "发电机连接到电网输入端",
  "param_set.lg_inverter_MicroINVLinkLoad": "微逆连接到负载侧",
  "param_set.lg_inverter_MicroINVLinkGrid": "微逆连接到电网侧",
  "param_set.lg_inverter_SolarPower": "Solar功率",
  "param_set.lg_inverter_GridAlwaysOn": "电网始终打开",
  "param_set.lg_inverter_OffGridDisconnection": "离网立即断开",
  "param_set.lg_inverter_SmartLoadONSOC": "智能负载启动SOC",
  "param_set.lg_inverter_SmartLoadOFFSOC": "智能负载关闭SOC",
  "param_set.lg_inverter_ACCoupleFreqUpperLimit": "AC Couple频率上限设置",
  "param_set.lg_inverter_MicroINVOutputtoGrid": "微逆输出到电网切断",
  "param_set.lg_inverter_MicroINVOFFSOC": "微逆关闭SOC",
  "param_set.lg_inverter_MicroINVONSOC": "微逆启动SOC",
  "param_set.lg_inverter_SmartLoadStartVoltage": "智能负载开启电压",
  "param_set.lg_inverter_SmartLoadDuration": "智能负载持续时间",
  "param_set.lg_inverter_SmartLoadStartTime": "智能负载开启时间",
  "param_set.lg_inverter_SmartLoadEndTime": "智能负载结束时间",
  "param_set.lg_inverter_BatteryType": "电池类型",
  "param_set.lg_inverter_BatteryInputMode": "电池接入模式",
  "param_set.lg_inverter_BatteryFailureShutdown": "电池通信故障停机",
  "param_set.lg_inverter_GridChargeEnable": "电网使能充电",
  "param_set.lg_inverter_GridSignal": "电网信号",
  "param_set.lg_inverter_GridChargeCurrent": "电网充电电流",
  "param_set.lg_inverter_GridStartupSOC": "电网启动SOC",
  "param_set.lg_inverter_BatteryLowCostMode": "电池低功耗模式",
  "param_set.lg_inverter_LowNoiseMode": "电池低噪声模式",
  "param_set.lg_inverter_StrongchargeSOC": "强充SOC点",
  "param_set.lg_inverter_StrongchargeStopSOC": "强充截止SOC点",
  "param_set.lg_inverter_StrongchargeSOCEN": "强充soc使能",
  "param_set.lg_inverter_LithiumBatteryManufacturers": "锂电池厂家",
  "param_set.lg_inverter_ChargingVoltage": "充电电压",
  "param_set.lg_inverter_ChargingCurrentLimit": "最大充电电流",
  "param_set.lg_inverter_DischargingCurrentLimit": "最大放电电流",
  "param_set.lg_inverter_DischargingShutdownVoltage": "电池放电电压截止点",
  "param_set.lg_inverter_BatteryLowVoltage": "电池放电电压低点",
  "param_set.lg_inverter_DischargingShutdownSOC": "电池放电截止SOC",
  "param_set.lg_inverter_ChargingEndSOC": "电池充电截止SOC",
  "param_set.lg_inverter_BatteryLowSOC": "电池低电量SOC",
  "param_set.lg_inverter_BatteryRestartSOC": "电池重启SOC",
  "param_set.lg_inverter_AutoForced-chargeEnable": "自动强充使能",
  "param_set.lg_inverter_AutoActivationEnable": "电池自动激活使能",
  "param_set.lg_inverter_BatteryTriggerVoltage": "电池激活电压",
  "param_set.lg_inverter_BatteryTriggerTime": "电池激活时长",
  "param_set.lg_inverter_DisableFloatCharge": "失能浮充",
  "param_set.lg_inverter_CV-CCChargingTime": "恒压转恒流时间",
  "param_set.lg_inverter_CC-CVChargingTime": "恒流转恒压时间",
  "param_set.lg_inverter_CC-FCChargingTime": "均充转浮充时间",
  "param_set.lg_inverter_LeadAcidOvervolt": "铅酸过压点",
  "param_set.lg_inverter_LeadAcidBatteryType": "铅酸电池类型",
  "param_set.lg_inverter_BatteryRatedCapacity": "电池额定容量",
  "param_set.lg_inverter_BatteryOverTempVoltage": "电池过温保护点",
  "param_set.lg_inverter_TempCompensationFactor": "电池温补系数",
  "param_set.lg_inverter_BatteryRestartVoltage": "电池恢复电压点",
  "param_set.lg_inverter_EC-FCChargeCurrent": "均充转浮充充电电流",
  "param_set.lg_inverter_FC-ECChargeCurrent": "浮充转均充电流",
  "param_set.lg_inverter_CCChargingTimeLimit": "恒流均充最长时间",
  "param_set.lg_inverter_CVChargingTimeLimit": "恒压均充最长时间",
  "status.enable": "启用",
  "status.disable": "停用",
  "end.app": "APP端",
  "end.backend": "后端",
  "module.product_management": "产品管理",
  "module.plant_management": "电站管理",
  "module.shipment_management": "出货管理",
  "module.device_management": "设备管理",
  "module.device_detail": "设备详情",
  "module.org_management": "组织管理",
  "module.login_register": "登录注册",
  "module.user_management": "用户管理",
  "module.family_management": "家庭管理",
  "module.physical_model": "物模型",
  "module.dictionary_value": "字典值",
  "param.name.dongle.reset.returnTip": "通讯棒已重置，请重新连接",
  "test.code": "test.code",
  "test.code1": "test.code1",
  "test.code3": "3",
  "test.code.222": "test.code.222",
  "dict.sttaus.not.normal": "^不^正^常",
  "dict.not.normal": "不正常",
  "dict.status.normal": "正常",
  "rr": "2e",
  "dict..status.not.normal": "不正常",
  "dict.status.not.normal": "不正常",
  "test": "test",
  "role.status.abnormal": "异常",
  "role.status.normal1": "正常",
  "role.status.normal": "正常",
  "filter.all.blank.null": "全部语言翻译为空",
  "fallback.i18n.code": "兜底词条",
  "plant.smart.investment": "零碳智投",
  "oehrt1": "其他1",
  "module.oversea": "工单管理",
  "开发中": "开发中",
  "developing": "开发中",
  "published": "已发布",
  "supplier.type.ts": "腾圣",
  "income.unit.cny.pkr": "PKR",
  "device.robotChannel": "机器人",
  "device.communicationChannel": "通讯棒",
  "device.channelType": "通讯通道",
  "device.switchChannelFailed": "切换通讯通道失败",
  "else": "其他",
  "All": "全部",
  "multilangue.tag.dic": "字典值",
  "manual_import": "手动导入",
  "c": "dong",
  "filter.nl_nl.blank.null": "荷兰语翻译为空",
  "filter.th_th.blank.null": "泰语翻译为空",
  "test.chuneng": "chuneng",
  "filter.adsf": "泰语翻译为空",
  "filter.tyu": "泰语翻译为空",
  "Manual": "人工",
  "System": "系统",
  "Photovoltaic": "光伏",
  "Processed": "已处理",
  "shandong": "山东1",
  "Critical": "超紧急",
  "Urgent": "紧急",
  "Severe": "严重",
  "General": "一般",
  "Reminder": "提醒",
  "c1": "缓存测试1",
  "plant.light.storage1": "零碳适家",
  "plant.light.storage": "零碳适家",
  "plant.e-station1": "零碳E站",
  "plant.others1": "其他",
  "end.shared": "通用",
  "welcome": "欢迎回来",
  "device.operatingDataInfoTip": "说明：若此项为空，请联系IOT平台管理员配置",
  "dynamic.price.not.exist": "未获取到动态电价",
  "product.pleaseUploadAtLeastOneImage": "请至少上传一张图片",
  "iot.device.register.failed": "iot设备注册失败",
  "expired": "已过期",
  "due.today": "今日到期",
  "sidebar.bulletinBoard": "安装看板",
  "sidebar.dataQuery": "数据查询",
  "Setting.timeSet": "时段配置",
  "org.authCompanyName": "认证公司名称",
  "org.serviceAddress": "服务地址",
  "org.servicePhone": "服务电话",
  "org.serviceEmail": "服务邮箱",
  "org.companyLogo": "企业logo",
  "org.websiteUrl": "网址",
  "org.partnerId": "伙伴ID",
  "org.serviceAgreement": "服务协议书",
  "org.serviceCertificate": "证书",
  "report.dataQuery.maxDevicesWarning": "最多可选择10台设备",
  "report.dataQuery.maxParamsWarning": "最多可选择10个参数",
  "report.dataQuery.selectDeviceAndParamsFirst": "请先选择设备与参数",
  "report.dataQuery.chartTitle": "多数据运行趋势对比",
  "report.dataQuery.selectDevice": "选择设备",
  "report.dataQuery.placeholderSelectDevice": "请选择设备",
  "report.dataQuery.tabByModel": "按型号",
  "report.dataQuery.tabByStation": "按电站",
  "report.dataQuery.modelGroupName": "型号名称",
  "report.dataQuery.noMore": "没有更多了",
  "report.dataQuery.selectedDevicesFooter": "已选 {current} / 10 台设备",
  "report.dataQuery.selectedDevicesShort": "已选设备",
  "report.dataQuery.clear": "清空",
  "report.dataQuery.noDeviceSelectedYet": "暂无选择设备",
  "report.dataQuery.selectParamsTitle": "选择参数（最多可选10个）",
  "report.dataQuery.maxParamsHint": "最多同时选择10个参数",
  "report.dataQuery.searchParamsPlaceholder": "搜索参数",
  "report.dataQuery.noMatchingParams": "无匹配参数",
  "report.dataQuery.selectDeviceFirst": "请先选择设备",
  "report.dataQuery.placeholderDeviceSn": "输入设备序列号",
  "report.dataQuery.placeholderModelName": "输入型号名称",
  "report.dataQuery.placeholderStationName": "输入电站名称",
  "report.dataQuery.selectedDevicesSummary": "已选 {count} 台设备",
  "report.dataQuery.startAnalysis": "开始分析",
  "report.dataQuery.emptyGuide": "点击左上角「选择设备」按钮，选择需要分析的设备（最多10台），然后选择参数和时间范围即可开始分析",
  "report.dataQuery.noDataHint": "当前查询条件下暂无可展示的数据，请调整设备、参数或时间范围后重试",
  "report.dataQuery.tableTitle": "多设备运行数据对比",
  "report.dataQuery.peakLabel": "峰值：",
  "report.dataQuery.peakColor": "红色",
  "report.dataQuery.valleyLabel": "谷值：",
  "report.dataQuery.valleyColor": "蓝色",
  "report.dataQuery.timeByDay": "按天",
  "report.dataQuery.timeByWeek": "按周",
  "report.dataQuery.timeByMonth": "按月",
  "report.dataQuery.timeByCustom": "自定义",
  "report.dataQuery.highlightNone": "无高亮",
  "report.dataQuery.highlightCol": "列差异高亮",
  "report.dataQuery.highlightRow": "行差异高亮",
  "report.dataQuery.weekdayMon": "周一",
  "report.dataQuery.weekdayTue": "周二",
  "report.dataQuery.weekdayWed": "周三",
  "report.dataQuery.weekdayThu": "周四",
  "report.dataQuery.weekdayFri": "周五",
  "report.dataQuery.weekdaySat": "周六",
  "report.dataQuery.weekdaySun": "周日",
  "report.dataQuery.axisMonthDay": "{n}日",
  "report.dataQuery.maxCurvesWarning": "当前查询参数超出10条曲线",
  "report.dataQuery.maxCurvesLimitHint": "最多可选10条曲线",
  "report.dataQuery.selectParamsHeading": "选择参数",
  "device.button.cancel": "返回",
  "org.accountNumber": "用户户号",
  "org.accountName": "用户户名",
  "org.description": "电力用户描述",
  "org.creditCode": "社会信用代码",
  "plant.deptName": "组织名称",
  "plant.businessScope": "工商业",
  "plant.withdrawBusinessDeliveryTip": "撤回交付后，{scope}用户将无法继续管理本电站。请谨慎操作。",
  "mapScreen.RevenueInfo": "收益信息",
  "mapScreen.MonthlyRevenue": "电站当月收益",
  "mapScreen.YearlyRevenue": "当年收益",
  "mapScreen.CumulativeRevenue": "累计收益",
  "mapScreen.CarbonIndicator": "碳指标",
  "mapScreen.StorageInfo": "储能信息",
  "mapScreen.MonthlyChargeDischarge": "当月总充/放电量",
  "mapScreen.YearlyChargeDischarge": "当年总充/放电量",
  "mapScreen.TotalPlants": "电站总数",
  "mapScreen.PvInstalledCapacity": "光伏装机容量",
  "mapScreen.StorageInstalledCapacity": "储能装机容量",
  "mapScreen.ChargingPileCapacity": "充电桩装机容量",
  "mapScreen.Residential": "户用",
  "mapScreen.Commercial": "工商业",
  "mapScreen.PlantCount": "共 {count} 个电站",
  "mapScreen.NewEnergyPower": "新能源发电功率",
  "mapScreen.GenerationInfo": "发电信息",
  "mapScreen.MonthlyGeneration": "当月发电量",
  "mapScreen.YearlyGeneration": "当年发电量",
  "mapScreen.ChargingPileInfo": "充电桩信息",
  "mapScreen.MonthlyConsumption": "当月用电量",
  "mapScreen.YearlyConsumption": "当年用电量",
  "mapScreen.GridConnectionInfo": "并网信息",
  "mapScreen.MonthlyPurchaseFeedin": "当月购电/上网电量",
  "mapScreen.YearlyPurchaseFeedin": "当年购电/上网电量",
  "mapScreen.CO2Reduction": "CO2减排总量",
  "mapScreen.SaveCoal": "节约标准煤",
  "mapScreen.TreePlanting": "种树量",
  "mapScreen.SelectCountry": "选择国家",
  "mapScreen.BackToPrev": "返回上一级",
  "mapScreen.Revenue": "收益",
  "mapScreen.ChargeAmount": "充电量",
  "mapScreen.DischargeAmount": "放电量",
  "mapScreen.GenerationAmount": "发电量",
  "mapScreen.ConsumptionAmount": "用电量",
  "mapScreen.PowerGeneration": "发电功率",
  "mapScreen.PurchaseAmount": "购电量",
  "mapScreen.GridSellAmount": "上网电量",
  "mapScreen.title": "海尔新能源全景能源监控",
  "mapScreen.PlantMonthlyRevenue": "电站当月收益",
  "mapScreen.PlantYearlyRevenue": "电站当年收益",
  "mapScreen.PlantCumulativeRevenue": "电站累计收益",
  "physicalModels.tagGroup": "标签组",
  "device.expandAll": "全部展开",
  "device.collapseAll": "全部收起",
  "common.deleteSuccess": "删除成功",
  "common.unloginOrExpired": "未登录或登录已过期",
  "common.serverError": "服务端异常，请稍后重试",
  "common.requestFailed": "请求失败",
  "common.backendError": "后端接口连接异常",
  "common.timeout": "系统接口请求超时",
  "common.systemInterface": "系统接口",
  "common.contains": "包含",
  "common.columnSetting": "列设置",
  "product.skipShipmentCheck": "跳过出货检查",
  "system.mapScreen": "全景大屏",
  "settingDrawer.title": "布局设置",
  "settingDrawer.themeMode": "主题模式",
  "settingDrawer.darkTheme": "暗色主题",
  "settingDrawer.lightTheme": "亮色主题",
  "settingDrawer.themeColor": "主题色",
  "settingDrawer.navMode": "导航模式",
  "settingDrawer.sideMenu": "侧边菜单布局",
  "settingDrawer.topMenu": "顶部菜单布局",
  "settingDrawer.mixMenu": "混合布局",
  "settingDrawer.columnMenu": "分栏布局",
  "settingDrawer.drawerMenu": "抽屉布局",
  "settingDrawer.layoutSetting": "布局设置",
  "settingDrawer.contentWidth": "内容区域宽度",
  "settingDrawer.contentWidthFixed": "固定",
  "settingDrawer.contentWidthFluid": "流式",
  "settingDrawer.fixedHeader": "固定 Header",
  "settingDrawer.fixedSidebar": "固定侧边菜单",
  "settingDrawer.hideFooter": "隐藏 Footer",
  "settingDrawer.multiTab": "多页签模式",
  "settingDrawer.sidebarColorfulIcon": "侧边栏彩色图标",
  "settingDrawer.searchMode": "搜索组件形态",
  "settingDrawer.searchModeHeader": "新版",
  "settingDrawer.searchModeForm": "老版",
  "settingDrawer.systemConfig": "系统配置",
  "settingDrawer.systemTitle": "系统标题",
  "settingDrawer.systemCopyright": "版权信息",
  "settingDrawer.systemVersion": "系统版本",
  "settingDrawer.systemVersionPlaceholder": "版本号",
  "settingDrawer.tableStyle": "表格通用样式",
  "settingDrawer.tableSize": "表格大小",
  "settingDrawer.tableSizeDefault": "默认",
  "settingDrawer.tableSizeMiddle": "中等",
  "settingDrawer.tableSizeSmall": "紧凑",
  "settingDrawer.tableBordered": "显示边框",
  "settingDrawer.tableFixHeader": "固定表头",
  "settingDrawer.tableHeaderBold": "表头加粗",
  "settingDrawer.tableResizable": "允许调整列宽",
  "settingDrawer.tableRowSelection": "允许行选择",
  "settingDrawer.tableHeaderBgColor": "表头背景色",
  "settingDrawer.tableHeight": "表格高度",
  "settingDrawer.pageSize": "分页大小",
  "settingDrawer.pageSizeUnit": "条/页",
  "settingDrawer.showTotal": "显示数据总数",
  "settingDrawer.showSizeChanger": "显示分页选择器",
  "settingDrawer.showQuickJumper": "显示快速跳转",
  "settingDrawer.tableStripe": "斑马条纹",
  "settingDrawer.tableShowHeader": "显示表头",
  "settingDrawer.saveTableConfig": "保存表格配置",
  "settingDrawer.reset": "重置",
  "settingDrawer.configManagement": "配置管理",
  "settingDrawer.saveAll": "保存所有配置",
  "settingDrawer.exportConfig": "导出配置",
  "settingDrawer.importConfig": "导入配置",
  "settingDrawer.resetAll": "重置所有配置",
  "settingDrawer.msg.initFail": "系统初始化失败，请刷新页面重试",
  "settingDrawer.msg.configInitFail": "配置初始化失败",
  "settingDrawer.msg.themeChangeFail": "主题切换失败",
  "settingDrawer.msg.colorChangeFail": "主题色切换失败",
  "settingDrawer.msg.searchModeSwitched": "已切换到{mode}搜索",
  "settingDrawer.msg.searchModeSwitchFail": "搜索组件切换失败",
  "settingDrawer.msg.navModeSwitched": "已切换到{mode}模式",
  "settingDrawer.msg.navSide": "侧边栏",
  "settingDrawer.msg.navTop": "顶部菜单",
  "settingDrawer.msg.navMix": "混合",
  "settingDrawer.msg.navModeSwitchFail": "导航模式切换失败",
  "settingDrawer.msg.layoutSwitchFail": "布局切换失败",
  "settingDrawer.msg.settingUpdateFail": "设置更新失败",
  "settingDrawer.msg.tableStoreNotInit": "表格配置存储未初始化",
  "settingDrawer.msg.tableConfigSaved": "表格配置已保存",
  "settingDrawer.msg.tableConfigSaveFail": "表格配置保存失败",
  "settingDrawer.msg.tableConfigReset": "表格配置已重置",
  "settingDrawer.msg.tableConfigResetFail": "表格配置重置失败",
  "settingDrawer.msg.systemConfigUpdated": "系统配置已更新",
  "settingDrawer.msg.systemConfigUpdateFailStore": "系统配置更新失败：Store 未初始化",
  "settingDrawer.msg.systemConfigUpdateFail": "系统配置更新失败",
  "settingDrawer.msg.allConfigSaved": "所有配置已保存",
  "settingDrawer.msg.configSaveFail": "配置保存失败",
  "settingDrawer.msg.configExported": "配置已导出",
  "settingDrawer.msg.configExportFail": "配置导出失败",
  "settingDrawer.msg.configImportConfirmTitle": "确认导入配置",
  "settingDrawer.msg.configImportConfirmContent": "导入配置将覆盖当前所有设置，是否继续？",
  "settingDrawer.msg.confirm": "确认",
  "settingDrawer.msg.cancel": "取消",
  "settingDrawer.msg.configImported": "配置导入成功",
  "settingDrawer.msg.configFileInvalid": "配置文件格式错误",
  "settingDrawer.msg.resetConfirmTitle": "确认重置",
  "settingDrawer.msg.resetConfirmContent": "重置将清除所有自定义配置，恢复到默认状态，是否继续？",
  "settingDrawer.msg.allConfigReset": "所有配置已重置"
}
